(function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return a(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module '"+o+"'");throw f.code="MODULE_NOT_FOUND",f}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(require,module,exports){
window.debugMode = env === "development"
window.socket = null

const SocketUtil = require("./util/socket_util")
const Protocol = require("./../../common/util/protocol")
const Config = require("junon-common/config")
const Game = require("./entities/game")
const GameExplorer = require("./components/game_explorer")
const PvPExplorer = require("./components/pvp_explorer")
const SettingsMenu = require("./components/settings_menu")
const MiniGameDetailsMenu = require("./components/minigame_details_menu")
const BanManager = require("./components/ban_manager")
const GameConnection = require("./components/game_connection")
const ExceptionReporter = require("./util/exception_reporter")
const ClientHelper = require("./util/client_helper")
const isMobile = require('ismobilejs')
const Cookies = require("js-cookie")
const uuidv4 = require('uuid/v4')
const FirebaseClientHelper = require('./util/firebase_client_helper')
const Polyglot = require('node-polyglot')
const japaneseTranslationMap = require("../../common/translations/ja")
const englishTranslationMap = require("../../common/translations/en")
const russianTranslationMap = require("../../common/translations/ru")
const ObjectPool = require("../../common/entities/object_pool")
const TeamEntry = require("./components/team_entry")
const Lighting = require("./entities/lighting")
const Particles = require("./entities/particles/index")
const BitmapText = require("./util/bitmap_text")
const Projectiles = require("./entities/projectiles/index")
const Helper = require("../../common/helper")
const SpritePoolInstance = require("./entities/sprite_pool_instance")

require('url-search-params-polyfill')

require("./util/polyfills")

class Main {
  constructor() {
    this.friends = {}
    this.onlinePlayers = {}
    this.sentFriendRequests = {}
    this.receivedFriendRequests = {}
  }

  isWebGLSupported() {
    if (typeof this.webGlSupported !== 'undefined') return this.webGlSupported

    var contextOptions = { stencil: true };

    try {
        if (!window.WebGLRenderingContext) {
            this.webGlSupported = false
        }

        var canvas = document.createElement('canvas');
        var gl = canvas.getContext('webgl', contextOptions) || canvas.getContext('experimental-webgl', contextOptions);

        var success = !!(gl && gl.getContextAttributes().stencil);

        if (gl) {
            var loseContext = gl.getExtension('WEBGL_lose_context');

            if (loseContext) {
                loseContext.loseContext();
            }
        }

        gl = null;

        this.webGlSupported = success;
    } catch (e) {
        this.webGlSupported = false;
    }

    return this.webGlSupported
  }

  checkLocalStorageSupport() {
    let result = true

    try {
      window.localStorage
    } catch(e) {
      result = false
    }

    return result
  }

  hideUchu() {
    if (document.referrer.length > 0) {
      // being embeded in iframe from another site

      document.querySelector(".other_game_ad_square").style.display = 'none'
      document.querySelector(".junon_ad_square_2").classList.add("middle")
    }
  }

  checkWebGLSupport() {
    if (!this.isWebGLSupported()) {
      document.querySelector("#connecting_message").style.display = 'none'
      document.querySelector("#home_error_message").innerText = "Your browser doesn't have proper WebGL support"
      return false
    }

    return true
  }

  initPools() {
    this.poolManager = ObjectPool

    ObjectPool.create("Lighting", Lighting)
    ObjectPool.create("Trail", Particles.Trail)
    ObjectPool.create("Meteor", Particles.Meteor)
    ObjectPool.create("BitmapText", BitmapText)
    ObjectPool.create("Smoke", Particles.Smoke)
    ObjectPool.create("Sprite", SpritePoolInstance)
  }

  initTranslation() {
    window.language = window.location.pathname.split("/")[1]
    if (window.language.length === 0) {
      let savedLanguage = Cookies.get("language")
      if (savedLanguage && savedLanguage !== 'en') {
        this.navigateToLanguage(savedLanguage)
      } else {
        window.language = 'en'
      }
    }

    document.getElementById("language_select").value = window.language
    document.querySelector(".minigame_chat_language_select").value = window.language

    window.isForeignLanguage = language !== 'en'

    const url = this.getBrowserHref()
    let phrases = englishTranslationMap

    if (language.length > 0) {
      if (language === "ja") {
        phrases = Object.assign({}, phrases, japaneseTranslationMap)
      } else if (language === "ru") {
        phrases = Object.assign({}, phrases, russianTranslationMap)
      }
    }

    let i18n = new Polyglot({
      phrases: phrases,
      allowMissing: true
    })
    window.i18n = i18n
  }

  getVersion() {
    let el = document.querySelector(".game_version")
    if (!el) return "0.0.0"

    let versionString = el.innerText
    return versionString.replace('.alpha','')
  }

  getRevisionUrl() {
    if (env === "staging") {
      return "https://staging.junon.io/revision"
    } else if (env === "production") {
      return "https://junon.io/revision"
    } else {
      return "/revision"
    }
  }

  isClientUpToDate(cb) {
    ClientHelper.httpRequest(this.getRevisionUrl(), {
      success: (result) => {
        if (result !== window.revision) {
          // old version
          cb(false)
        } else {
          cb(true)
        }
      },
      error: () => {
        cb(true)
      }
    })
  }

  redirectToHttps() {
    if (env === 'staging' && location.protocol !== 'https:') {
      location.replace(`https:${location.href.substring(location.protocol.length)}`);
    }
  }

  chromeWebsocketBugWorkaround() {
    // https://bugs.chromium.org/p/chromium/issues/detail?id=1108112
    // window._requestAnimationFrame = window.requestAnimationFrame;
    // window.requestAnimationFrame = function (callback) {
    //         setTimeout (function () { window._requestAnimationFrame (callback) }, 0);
    // }
  }

  isBrowserSupported() {
    if(navigator.userAgent.match(/Windows Phone/i)){
      return false
    }

    return true
  }

  navigateViaUrlParam() {
    if (this.inviteToken) {
      this.renderGameInvite()
      return
    }

    let miniGame = this.getUrlParam().get("minigame")
    if (miniGame) {
      let miniGameId = miniGame.split("-")[1]
      if (this.gameExplorer.getMiniGame(miniGameId)) {
        this.hideMenus()
        this.showBackMainBtn()

        this.miniGameDetailsMenu.open({ gameId: miniGameId })
        return
      }
    }

    let game = this.getUrlParam().get("game")
    let isImposterMode = this.isImposterMode()
    if (isImposterMode) {
      this.hideMenus()
      let miniGameId = debugMode ? "eWC1CfZymRExY" : "Ap9OYBkw3dQvJ"

      this.miniGameDetailsMenu.open({ gameId: miniGameId })
      return
    }

    if (game) {
      let miniGameId = game.split("-")[1]
      if (this.gameExplorer.getMiniGame(miniGameId)) {
        this.hideMenus()
        document.querySelector(".main_menu_navigator").style.marginTop = '10px'
        document.querySelector("#changelogs").style.display = 'none'
        // document.querySelector("#more_io_games").style.display = 'block'

        this.miniGameDetailsMenu.open({ gameId: miniGameId })
        return
      }
    }

    let nav = this.getUrlParam().get("nav")
    if (nav) {
      let tab = document.querySelector(".colony_filter_tab[data-tab='" + nav + "']")
      if (tab) {
        this.gameExplorer.selectColonyFilterTab(tab)
      }
    }

  }

  run() {
    this.redirectToHttps()
    this.chromeWebsocketBugWorkaround()

    const isWebGLSupported = this.checkWebGLSupport()
    if (!isWebGLSupported) return

    if (!this.isBrowserSupported()) {
      document.querySelector("#connecting_message").style.display = 'none'
      document.querySelector("#home_error_message").innerText = "Your browser is not supported"
      return
    }

    const hasLocalStorage = this.checkLocalStorageSupport()
    if (!hasLocalStorage) {
      document.querySelector("#login_cookies").style.display = 'block'
    }

    console.log("initializing..")
    window.initializeTime = (new Date()).getTime()

    if (env === "production" || env === "staging") {
      this.initAnalytics()
      this.initErrorReporting()
    }

    this.initPools()
    this.initTranslation()
    this.initGameUI()
    this.hideStagingMenu()
    this.logGameClientInfo()
    this.initSessionId()
    this.initGameExplorer()
    this.mobileDetect()
    this.initAuthentication()
    this.initRegionTabContent()
    this.initServerAnnouncement()
    this.renderImposterMode()
    this.hideUchu()

    this.parseInviteLink()
    this.initListeners()

    this.initFingerPrint(() => {
      this.determineRegion(() => {
        this.gameExplorer.init(() => {
          this.initGame()
          this.initMiniGameMenu()
          this.initSettingsMenu()
          this.initBanManagerMenu()

          this.updateItchChangelogUrl()
          this.updateItchPrivacyUrl()
          // this.displayHomePageAd()
          this.initVideoAd()

          this.isClientUpToDate((isUpToDate) => {
            if (!isUpToDate) {
              document.querySelector("#home_error_message").innerText = i18n.t('OutdatedGameClient')
              document.querySelector("#connecting_message").style.display = 'none'
            }
          })
        })
      })
    })
  }

  renderImposterMode() {
    if (this.isImposterMode()) {
      document.querySelector("body").classList.add("imposter_mode")
      document.querySelector("#authentication_container").style.display = 'none'
      document.querySelector("#changelogs").style.display = 'none'
      document.querySelector("#total_online_count").style.display = 'none'
      document.querySelector("#privacy_link").style.display = 'none'
      document.querySelector("#rules_link").style.display = 'none'

      if (this.getUrlParam().get("impy")) {
        this.impy = true
        document.querySelector(".minigame_poster").src = "/assets/images/background/imposter_bg_2.jpg"
      } else {
        document.querySelector(".minigame_poster").src = "/assets/images/background/imposter_bg.jpg"
      }
    }
  }

  initGameUI() {
    let timeLabel = "<div id='day_label_container'>" + i18n.t('DayCount', { day: "<span id='day_label'></span>" }) + "</div>" +
                    "<div id='hour_label_container'>" + i18n.t('HourCount', { hour: "<span id='hour_label'></span>"}) + "</div>"
    time_label.innerHTML = timeLabel

    let countdownTimer = i18n.t('RestartIn', { number: "<span id='restart_countdown_number'></span>" })
    restart_countdown.innerHTML = countdownTimer
  }

  async initServerAnnouncement() {
    let announcement = await FirebaseClientHelper.getServerAnnouncement()
    if (announcement) {
      document.querySelector("#server_announcement_message").innerText = announcement
      document.querySelector("#server_announcement_bar").style.display = 'block'
    }
  }

  hideStagingMenu() {
    if (env === 'staging') {
      document.querySelector("#region_selector").style.display = 'none'
    }
  }

  clearHomeErrorMessage() {
    document.querySelector("#home_error_message").innerText = ""
  }

  initSessionId() {
    this.sessionId = uuidv4()
  }

  initFingerPrint(cb) {
    FingerprintJS.load().then(fp => {
      fp.get().then(result => {
        const visitorId = result.visitorId
        this.fingerprint = visitorId
        cb()
      })
    })
  }

  logGameClientInfo() {
    console.log("revision: " + window.revision)
  }

  displayHomePageAd() {
    if (debugMode) return
    let threeMinutes = 1000 * 60 * 3
    let shouldRefreshAd = !this.lastHomepageAdDisplay ||
                          (this.lastHomepageAdDisplay && ((Date.now() - this.lastHomepageAdDisplay) > threeMinutes))
    if (shouldRefreshAd) {
      aiptag.cmd.display.push(() => {
        aipDisplayTag.display('junon-io_300x250');
      })

      aiptag.cmd.display.push(() => {
        aipDisplayTag.display('junon-io_300x250_2');
      })
      this.lastHomepageAdDisplay = Date.now()
    }
  }

  initVideoAd() {
    let padding = 100
    let playerWidth = window.innerWidth - padding
    let playerHeight = window.innerHeight - padding
    playerWidth = Math.min(800, playerWidth)
    playerHeight = Math.min(450, playerHeight)

    document.querySelector("#preroll_container").style.width  = playerWidth  + "px"
    document.querySelector("#preroll_container").style.height = playerHeight + "px"
    document.querySelector("#preroll_container").style.marginLeft = -(playerWidth/2) + "px"
    document.querySelector("#preroll_container").style.marginTop  = -(playerHeight/2) + "px"

    aiptag.cmd.player.push(() => {
      window.adplayer = new aipPlayer({
        AD_WIDTH: playerWidth,
        AD_HEIGHT: playerHeight,
        AD_FULLSCREEN: false,
        AD_CENTERPLAYER: false,
        LOADING_TEXT: 'loading advertisement',
        PREROLL_ELEM: () => {
          return document.getElementById('preroll')
        },
        AIP_COMPLETE: () => {
          document.querySelector("#preroll_container").style.display = 'none'
          if (this.videoAdCompleteCallback) {
            this.videoAdCompleteCallback()
          }
        },
        AIP_REMOVE: () => {
          document.querySelector("#preroll_container").style.display = 'none'
        }
      });
    });
  }

  recordColonyVisit() {
    if (!Cookies.get("colonyVisit")) {
      let day  = (new Date()).getDay()
      let time = Date.now()
      let colonyVisit = [day, time].join(":")
      Cookies.set("colonyVisit", colonyVisit)
    }
  }

  shouldShowVideoAd() {
    if (debugMode) return false

    let colonyVisit = Cookies.get("colonyVisit")
    if (!colonyVisit) return false

    let day  = parseInt(colonyVisit.split(":")[0])
    let time = parseInt(colonyVisit.split(":")[1])

    let timeNow = Date.now()
    let dateNow = new Date()

    if (day !== dateNow.getDay()) {
      Cookies.remove("colonyVisit")
      return false
    }

    let durationSinceColonyVisit = timeNow - time
    let threshold = env === 'staging' ? (1000 * 60 * 5) : (1000 * 60 * 60)
    let awayThreshold = (1000 * 60 * 60 * 3)
    if (durationSinceColonyVisit >= threshold) {
      Cookies.remove("colonyVisit")
      if (durationSinceColonyVisit >= awayThreshold) {
        return false
      } else {
        return true
      }
    }

    return false
  }

  displayVideoAd() {
    if (typeof adplayer !== 'undefined') {
      aiptag.cmd.player.push(() => {
        document.querySelector("#preroll_container").style.display = 'block'
        adplayer.startPreRoll()
      })
    } else {
      //Adlib didnt load this could be due to an adblocker, timeout etc.
      if (this.videoAdCompleteCallback) {
        this.videoAdCompleteCallback()
      }
    }
  }

  initRegionTabContent() {
    if (debugMode) {
      this.regions = [
        { id: 'localhost', name: "localhost"},
        { id: 'test', name: "test"}
      ]
    } else {
      this.regions = [
        { id: 'nyc1', name: "USA" },
        { id: 'fra1', name: "Europe"}
      ]
    }

    let selectOptions = ""

    let tabPanes = ""
    this.regions.forEach((region) => {
        selectOptions += "<option value='" + region.id + "'>" + region.name + "</option>"
    })

    tabPanes += "<div class='tab-pane'>" +
        "<div class='game_browser_container'>" +
            "<div class='search_colony_list colony_list' cellspacing='0' cellpadding='0'>" +
            "</div>" +
            "<div class='main_colony_list colony_list' cellspacing='0' cellpadding='0'>" +
            "</div>" +
        "</div>" +
    "</div>"

    document.querySelector("#region_select").innerHTML = selectOptions
    document.querySelector("#region_tab_content").innerHTML = tabPanes
  }

  mobileDetect() {
    this.isMobile = isMobile.any

    if (this.isMobile) {
      document.querySelector("body").classList.add("mobile")
    }
  }

  updateItchChangelogUrl() {
    if (this.isItchPage()) {
      let changelogUrl = window.location.href.replace("index.html", "changelogs.html")
      document.getElementById("changelog_link").href = changelogUrl
    }
  }

  updateItchPrivacyUrl() {
    if (this.isItchPage()) {
      let privacyUrl = window.location.href.replace("index.html", "privacy.html")
      document.getElementById("privacy_link").href = privacyUrl
    }
  }

  isItchPage() {
    return window.location.href.match("hwcdn.net")
  }

  isLoggedIn() {
    let hasLocalStorage = this.checkLocalStorageSupport()
    if (!hasLocalStorage) {
      return false
    }

    return FirebaseClientHelper.isLoggedIn()
  }

  async bootSector(sectorId) {
    let data = {
      sectorId: sectorId,
      env: this.getEnvToSendToMatchmaker(),
      region: this.region,
      sessionId: this.sessionId
    }

    if (this.isLoggedIn()) {
      let idToken = await this.getFirebaseIdToken()
      data["idToken"] = idToken
      data["username"] = this.userData.username
      data["uid"] = this.uid
    }

    if (this.getTargetHost()) {
      data["targetHost"] = this.getTargetHost()
    }

    if (this.isStress()) {
      data["stress"] = true
    }

    this.sendToMatchmaker({ event: "BootSector", data: data })
  }

  getBrowserHost() {
    return window.location.origin
  }

  getBrowserHref() {
    return document.location.href
  }

  getUrlParam() {
    const url = this.getBrowserHref()
    return new URLSearchParams(url.split("?")[1])
  }

  parseInviteLink() {
    const inviteParam = this.getUrlParam().get("e")
    if (inviteParam) {
      this.inviteToken = inviteParam
    }
  }

  getTargetHost() {
    const targetParam = this.getUrlParam().get("target")
    if (targetParam) {
      return targetParam
    }
  }

  renderGameInvite() {
    if (!this.inviteToken) return

    this.gameExplorer.fetchSectorData(this.inviteToken, (sector) => {
      if (sector) {
        let teamEntry = new TeamEntry(this.gameExplorer, sector)
        this.gameExplorer.selectGameEntry(teamEntry)
        this.showGameInviteMenu(teamEntry)

        this.teamInviteEntryFound = true
        this.hideHomeMenu()
      }
    })
  }

  showGameInviteMenu(teamEntry) {
    this.showBackMainBtn()

    let container = document.querySelector(".game_invite_container")
    if (teamEntry.getScreenshot()) {
      let src = this.getScreenshotThumbnailPath(teamEntry.getScreenshot())
      container.querySelector(".game_invite_screenshot").src = src
    }

    let miniGameMatch = teamEntry.data.sectorId.match(/mini-(.*)-/)
    if (miniGameMatch) {
      let gameId = miniGameMatch[1]
      let miniGameData = this.gameExplorer.miniGames[gameId]
      if (miniGameData) {
        container.querySelector(".game_invite_name").innerText = miniGameData.name
        container.querySelector(".game_invite_container .game_invite_day_count").style.display = 'none'
      }
    } else {
      container.querySelector(".game_invite_name").innerText = teamEntry.getName()
      container.querySelector(".game_invite_container .team_days_alive").innerText = teamEntry.getDayCount()
      container.querySelector(".game_invite_container .game_invite_day_count").style.display = 'block'
    }

    container.querySelector(".game_invite_container .team_member_count").innerText = teamEntry.getMemberCount() + " / 10"

    container.style.display = 'block'
  }

  hideGameInviteMenu() {
    document.querySelector(".game_invite_container").style.display = 'none'
  }

  onGameInitialized() {
    this.isGameInitialized = true
    this.postInitSetup()
  }

  onRegionAssigned() {
    this.isRegionSelected = true
  }

  getRegionName() {
    if (!this.region) return ""

    let regionData = this.regions.find((regionData) => {
      return regionData.id === this.region
    })

    return regionData.name
  }

  getObjectPool() {
    return ObjectPool
  }

  preallocateObjectPools() {
    let sprites = []
    for (var i = 0; i < 5000; i++) {
      sprites.push(SpritePoolInstance.create({texture: null}))
    }

    sprites.forEach((sprite) => {
      sprite.remove()
    })
  }

  postInitSetup() {
    if (this.initSetupFinished) return

    // two conditions need to be met:
    // game initialized + matchmaker returned sector/team list
    if (!this.isSectorListPopulated) return
    if (!this.isGameInitialized) return

    let projectileKlasses = Projectiles.getList()
    projectileKlasses.forEach((klass) => {
      let projectileName = Helper.getProjectileNameById(klass.getType())
      ObjectPool.create(projectileName, klass)
    })


    this.navigateViaUrlParam()

    // this.preallocateObjectPools()

    document.querySelector("#connecting_message").style.display = 'none'

    this.initSetupFinished = true

    if (!this.teamInviteEntryFound &&
        !this.getUrlParam().get("nav") &&
        !this.getUrlParam().get("game") &&
        !this.getUrlParam().get("minigame")) {
      this.showHomeMenu()
    }

  }

  isImposterMode() {
    return this.getUrlParam().get("game") &&
           (this.getUrlParam().get("game") === 'FindtheImposter-Ap9OYBkw3dQvJ' ||
            this.getUrlParam().get("game") === 'FindtheImposter-eWC1CfZymRExY' )
  }

  getSubdomain() {
    return window.location.host.split('.')[0]
  }

  requestGame(url, options = {}) {
    if (!url) return

    this.connectGame(url, () => {
      this.game.requestGame(options)
    })
  }

  enableJoin() {
    this.isJoinInProgress = false
    this.newColonySectorId = null
    this.resetButtonStates()
  }

  resetButtonStates() {
    document.getElementById("play_btn").querySelector("span").innerText = i18n.t("Play")
    document.querySelector(".play_spinner").style.display = 'none'

    document.querySelector(".new_colony_menu_btn span").innerText = i18n.t("New Colony")
    document.querySelector(".new_colony_menu_btn .play_spinner").style.display = 'none'

    document.querySelector(".tutorial_menu_btn span").innerText = i18n.t("Tutorial")
    document.querySelector(".tutorial_menu_btn .play_spinner").style.display = 'none'

    document.querySelector(".continue_game_btn span").innerText = i18n.t("Start Game")
    document.querySelector(".continue_game_btn .play_spinner").style.display = 'none'
  }

  hideChangeLog() {
    document.querySelector("#changelogs").style.display = 'none'
  }

  connectGame(url, cb) {
    if (this.gameExplorer.isInGame()) {
      SocketUtil.emit("LeaveGame", {})
    }

    if (url === 'wss://') return

    if (this.gameConnection) {
      let isAlreadyConnected = this.gameConnection.url === url && this.gameConnection.isConnected()
      if (isAlreadyConnected) {
        return cb()
      }

      this.gameConnection.close()
    }

    this.gameConnection = new GameConnection(url)
    this.gameConnection.init({
      success: (gameConnection) => {
        this.game.setGameConnection(this.gameConnection)

        if (cb) cb()
      },
      error: (wasNeverConnected) => {
        if (wasNeverConnected) {
          this.onPlayerCantJoin({ message: "Cant connect to server " + url })
        } else {
          this.enableJoin()
        }
      }
    })
  }

  initGame() {
    window.game = this.game = new Game(this)

    if (!Cookies.get("list_mode") || Cookies.get("list_mode") === 'false') {
      // default
    } else if (Cookies.get("list_mode") === 'true') {
      document.querySelector(".main_colony_list").classList.add("list_mode")
      document.querySelector(".search_colony_list").classList.add("list_mode")
    }
  }

  getScreenshotThumbnailPath(key) {
    if (debugMode) {
      return `http://localhost:8001/assets/screenshots/${key}_thumb.jpg`
    } else {
      return `https://junon.nyc3.cdn.digitaloceanspaces.com/screenshots/${key}_thumb.jpg`
    }
  }

  onPlayerCantJoin(data) {
    document.querySelector("#connecting_message").style.display = 'none'
    document.querySelector(".loading_modal").style.display = 'none'
    console.log(data.message)

    setTimeout(() => {
      this.enableJoin()
      let message = data.message || "Servers are currently full"
      document.getElementById("home_error_message").innerText = message

      if (this.isMobile) {
        setTimeout(() => {
          this.clearHomeErrorMessage()
        }, 2000)
      }
    }, 1000)
  }

  getExceptionReporter() {
    return ExceptionReporter
  }

  initGameExplorer() {
    this.gameExplorer = new GameExplorer(this)
    this.pvpExplorer = new PvPExplorer(this)
  }

  initSettingsMenu() {
    this.settingsMenu = new SettingsMenu(this)
  }

  initMiniGameMenu() {
    this.miniGameDetailsMenu = new MiniGameDetailsMenu(this)
  }

  initBanManagerMenu() {
    this.banManager = new BanManager(this)
  }

  getCookieInstance() {
    return Cookies
  }

  getMatchmakerServersUrl() {
    let baseUrl = Config[env].matchmakerUrl + "servers"

    let envToSend = this.getEnvToSendToMatchmaker()
    let url = baseUrl + "?environment=" + envToSend
    return url
  }

  getEnvToSendToMatchmaker() {
    return window.test_vm ? 'vm' : env
  }

  renderRegionSelectPlayerCount(onlineCountByRegion) {
    if (this.isMobile) return

    for (let regionName in onlineCountByRegion) {
      let option = document.querySelector("#region_select option[value='" + regionName + "']")
      let onlineCount = onlineCountByRegion[regionName]

      let region = this.regions.find((regionData) => { return regionData.id === regionName })
      if (region) {
        let friendlyRegionName = region.name
        option.innerText = `${friendlyRegionName} - ${onlineCount} players`
      }
    }
  }

  determineRegion(cb) {
    let matchmakerServersUrl = this.getMatchmakerServersUrl()

    ClientHelper.httpRequest(matchmakerServersUrl, {
      success: (result) => {
        let data = JSON.parse(result)
        if (data.error) {
          this.onPlayerCantJoin({ message: data.error })
          return
        }

        this.renderRegionSelectPlayerCount(data.onlineCountByRegion)
        document.querySelector("#total_online_count").innerText = data.totalOnlineCount + " " + i18n.t("PlayersOnline")
        this.serversByRegion = data.serversByRegion
        this.gameExplorer.setMiniGames(data.miniGames)

        this.findBestRegion(this.serversByRegion, (region) => {
          if (!region) {
            region = this.regions[0].id // choose a default one
          }

          this.setRegion(region)
          this.onRegionAssigned()
          cb()
        })
      },
      error: () => {
        this.onPlayerCantJoin({ message: i18n.t("MatchmakerUnavailable") })
      }
    })
  }

  onSectorEntryAdded(sectorEntry) {
    if (this.gameExplorer) {
      this.gameExplorer.onSectorEntryAdded(sectorEntry)
    }
  }

  connectNewColonyGame(host, sectorId) {
    let url  = this.getServerWebsocketUrl(host)
    this.requestGame(url, { sectorId: sectorId })
  }

  onSectorEntryRemoved(sectorEntry) {
  }

  setRegion(region) {
    this.region = region
    document.querySelector('#region_select').value = region
  }

  findBestRegion(serversByRegion, cb) {
    let pings = {}
    let requests = []
    let counter = Object.keys(serversByRegion).length

    for (let region in serversByRegion) {
      let servers = serversByRegion[region]
      let serverIp = Object.keys(servers)[0]
      if (serverIp) {
        let url = this.getServerHTTPUrl(serverIp)
        pings[region] = Date.now()

        let request = ClientHelper.httpRequest(url + "/ping", {
          success: (result) => {
            pings[region] = Date.now() - pings[region]

            counter -= 1
            let isAllServerPinged = counter === 0
            if (isAllServerPinged) {
              // check lowest ping server
              this.isBestRegionFound = true
              let bestRegion = this.getLowestPingRegion(pings)
              console.log("all pings finished. best region - " + bestRegion)
              cb(bestRegion)
            }
          },
          error: () => {
          }
        })

        requests.push(request)
      }
    }

    // 1 second limit
    setTimeout(() => {
      if (!this.isBestRegionFound) {
        console.log("1 second reached. aborting pings..")
        requests.forEach((xhttp) => {
          let done = 4
          if (xhttp.readyState !== done) {
            xhttp.abort()
          }
        })

        let bestRegion = this.getLowestPingRegion(pings)
        bestRegion = bestRegion || Object.keys(pings)[0]
        console.log("best region - " + bestRegion)
        cb(bestRegion)
      }
    }, 1000)
  }

  getLowestPingRegion(pings) {
    let lowest = 10000
    let targetRegion

    for (let region in pings) {
      let ping = pings[region]
      console.log("ping: " + region + " - " + ping + " ms")
      if (ping < lowest) {
        targetRegion = region
        lowest = ping
      }
    }

    return targetRegion
  }

  initAdditionalLibraries() {
    let libs = ["cytoscape.min.js"]
      // libs.push(["jquery-3.3.1.min.js", "d3.v357.min.js", "epoch.min.js"])
    this.installLib(libs)
  }

  installLib(libs) {
    if (libs.length === 0) return
    let lib = libs.shift()

    const script = document.createElement('script')
    script.setAttribute('src','/' + lib)
    script.onload = this.installLib.bind(this, libs)
    document.head.appendChild(script)
  }

  initErrorReporting() {
    ExceptionReporter.init()
  }

  initAnalytics() {
    // google analytics
    const trackingId = Config[env].googleAnalyticsId

    document.write('<script async src="https://www.googletagmanager.com/gtag/js?id=' + trackingId + '"></script>')
    window.dataLayer = window.dataLayer || []
    function gtag(){dataLayer.push(arguments)}
    window.gtag = gtag
    gtag('js', new Date())
    gtag('config', trackingId)
  }

  onNameInputKeyup(e) {
    // if (e.which === 13) { // enter
    //   this.onPlayBtnClick()
    // }
  }

  onPlayBtnClick() {

    // if (this.isJoinInProgress) return
    // this.lockJoin()

    // document.getElementById("play_btn").querySelector("span").innerText = ""
    // document.querySelector("#play_btn .play_spinner").style.display = 'inline-block'
    // this.clearHomeErrorMessage()

    // this.gameExplorer.joinRandomSectorEntry()
  }

  onLoginBtnClick(e) {
    const socialLoginContainer = document.querySelector("#social_login_container")
    if (socialLoginContainer.style.display === 'block') {
      socialLoginContainer.style.display = 'none'
    } else {
      socialLoginContainer.style.display = 'block'
    }

    if (e.target.classList.contains("mobile_login_btn")) {
      // position right below mobile_login_btn
      let margin = 10
      let positionY = e.target.offsetTop + e.target.offsetHeight + margin
      socialLoginContainer.style.top = positionY + "px"
    }
  }

  onLogoutBtnClick() {
    this.user = null
    this.uid = null

    FirebaseClientHelper.signOut(() => {
      this.showAuthContainer()
      this.hideUsernameContainer()
    })

    document.getElementById("logout_btn").style.display = 'none'
    document.getElementById("firebaseui-auth-container").style.display = 'none'
    this.onBackMainMenuBtnClick()

    document.querySelector(".mobile_username_container").classList.remove("logged_in")
    document.querySelector(".mobile_login_btn").style.display = 'block'
    document.querySelector(".mobile_logout_btn").style.display = 'none'

    document.querySelector("#social_login_container").style.display = 'none'
    document.querySelector("#username_form_container").style.display = 'none'
  }

  onSectorListPopulated() {
    this.isSectorListPopulated = true
    this.postInitSetup()
  }

  async isUsernameBadWord(username) {
    let matchmakerUrl = Config[env].matchmakerUrl

    return new Promise((resolve, reject) => {
      ClientHelper.httpRequest(matchmakerUrl + `checkname?username=${username}`, {
        success: (result) => {
          if (result === "invalid") {
            resolve(true)
          } else {
            resolve(false)
          }
        },
        error: (e) => {
          reject(e)
        }
      })
    })
  }

  onSearchWorldInputKeyup(e) {
    let keyCode = ClientHelper.getKeycode(e)
    if (keyCode === 13) { // enter
      this.onSearchWorldBtnClick()
    }
  }

  onUsernameInputKeyup(e) {
    let keyCode = ClientHelper.getKeycode(e)
    if (keyCode === 13) { // enter
      this.onSetUsernameBtnClick()
    }
  }

  onNewColonyNameInputKeyup(e) {
    let keyCode = ClientHelper.getKeycode(e)
    if (keyCode === 13) { // enter
      this.onNewColonyMenuBtnClick()
    }
  }

  isValidUsername(username) {
    return !username.match(/[^a-zA-Z0-9_]/)
  }

  onSearchWorldBtnClick() {
    let search = document.querySelector(".search_world_input").value
    if (search.length === 0) {
      document.querySelector(".search_colony_list").style.display = 'none'
      document.querySelector(".main_colony_list").style.display = 'block'
      return
    }

    if (this.searchLock) return
    this.searchLock = true

    let matchmakerUrl = Config[env].matchmakerUrl
    ClientHelper.httpRequest(matchmakerUrl + "search?q=" + search, {
      success: (result) => {
        try {
          this.gameExplorer.resetSearch()
          let sectors = JSON.parse(result)
          for (var i = 0; i < sectors.length; i++) {
            let colonyData = sectors[i]
            this.gameExplorer.renderSearchColony(colonyData)
          }

          let selectedFilterTab = document.querySelector(".colony_filter_tab.selected")
          if (selectedFilterTab.classList.contains("mine_colonies_tab")) {
            document.querySelector(".search_colony_list").style.display = 'none'
            document.querySelector(".main_colony_list").style.display = 'block'
          } else {
            document.querySelector(".search_colony_list").style.display = 'block'
            document.querySelector(".main_colony_list").style.display = 'none'
          }
          this.searchLock = false
        } catch(e) {
          console.log("search parse error")
          this.searchLock = false
        }
      },
      error: () => {
        console.log("search error")
        this.searchLock = false
      }
    })
  }

  async onSetUsernameBtnClick() {
    let username = document.getElementById("username_input").value
    if (username.length === 0) {
      document.getElementById("username_errors").innerText = "Username cant be blank"
      return
    } else if (username.length > 16) {
      document.getElementById("username_errors").innerText = "Username cant be longer than 16 characters"
      return
    }

    if (this.isUsernameSetInProgress) return
    this.isUsernameSetInProgress = true
    let uid = this.uid

    try {
      let isBadWord = await this.isUsernameBadWord(username)
      if (isBadWord) {
        this.isUsernameSetInProgress = false
        document.getElementById("username_errors").innerText = "Username not appropriate"
        return
      }
    } catch(e) {
      this.isUsernameSetInProgress = false
      document.getElementById("username_errors").innerText = "Service unavailable. Unable to create username"
      return
    }

    if (!uid) {
      this.isUsernameSetInProgress = false
      document.getElementById("username_errors").innerText = "Must log in to create username"
      return
    }

    let idToken = await this.getFirebaseIdToken()
    let matchmakerUrl = Config[env].matchmakerUrl
    let data = {
      idToken: idToken,
      uid: uid,
      username: username,
      email: this.user.email
    }

    ClientHelper.httpPost(matchmakerUrl + "create_user", data, {
      success: (result) => {
        this.isUsernameSetInProgress = false
        try {
          let data = JSON.parse(result)
          if (data.error) {
            document.getElementById("username_errors").innerText = data.error
          } else {
            // success
            this.renderLoggedInUser(username)
            this.hideUsernameInputForm()
          }
        } catch(e) {
          document.getElementById("username_errors").innerText = "Unable to create user"
        }
      },
      error: () => {
        this.isUsernameSetInProgress = false
        document.getElementById("username_errors").innerText = "Unable to create user"
      }
    })
  }

  onFriendRequestSent(request) {
    this.sentFriendRequests[request.friendUid] = request
    this.game.friendsMenu.onFriendRequestSent(request)
  }

  onFriendRequestReceived(request) {
    this.receivedFriendRequests[request.userUid] = request
    this.game.onFriendRequestReceived(request)
  }

  onFriendAccepted(request) {
    this.friends[request.friendUid] = request
    let name = request.receiver.username
    this.game.displayError("You are now friends with " + name, { success: true })
  }

  onRemoveFriendSuccessful(data) {
    delete this.friends[data.friendUid]
    this.game.friendsMenu.onRemoveFriendSuccessful()
  }

  onOnlineList(data) {
    if (!data.online) return

    data.online.forEach((uid) => {
      this.onlinePlayers[uid] = true
    })
  }

  async removeFriend(friendUid) {
    if (this.isFriendRequestInProgress) return
    this.isFriendRequestInProgress = true

    let idToken = await this.getFirebaseIdToken()
    let matchmakerUrl = Config[env].matchmakerUrl
    let data = { idToken: idToken, friendUid: friendUid, uid: this.uid }

    ClientHelper.httpPost(matchmakerUrl + "unfriend", data, {
      success: (result) => {
        this.isFriendRequestInProgress = false

        try {
          let data = JSON.parse(result)
          if (data.error) {
            this.game.displayError(data.error, { warning: true })
          } else {
            // success
            this.onRemoveFriendSuccessful(data)
          }
        } catch(e) {
          ExceptionReporter.captureException(e)
          this.game.displayError("Remove friend failed", { warning: true })
        }
      },
      error: () => {
        this.isFriendRequestInProgress = false
        this.game.displayError("Remove friend failed", { warning: true })
      }
    })

  }

  async addFriend(friendUid) {
    if (this.isFriendRequestInProgress) return
    this.isFriendRequestInProgress = true

    this.sentFriendRequests[friendUid] = true

    let idToken = await this.getFirebaseIdToken()
    let matchmakerUrl = Config[env].matchmakerUrl
    let data = { idToken: idToken, friendUid: friendUid, uid: this.uid }

    ClientHelper.httpPost(matchmakerUrl + "friend_request", data, {
      success: (result) => {
        this.isFriendRequestInProgress = false

        try {
          let data = JSON.parse(result)
          if (data.error) {
            this.game.displayError(data.error, { warning: true })
          } else {
            // success
            this.onFriendRequestSent(data)
          }
        } catch(e) {
          ExceptionReporter.captureException(e)
          this.game.displayError("Friend request failed", { warning: true })
        }
      },
      error: () => {
        this.isFriendRequestInProgress = false
        this.game.displayError("Friend request failed", { warning: true })
      }
    })
  }

  getPendingReceivedFriendRequestsCount() {
    let count = 0

    for (let uid in this.receivedFriendRequests) {
      let request = this.receivedFriendRequests[uid]
      if (request.status !== 'ignored') {
        count += 1
      }
    }

    return count
  }

  onFriendRequestAccepted(requestId) {
    for (let uid in this.receivedFriendRequests) {
      let request = this.receivedFriendRequests[uid]
      if (request.id === requestId) {
        delete this.receivedFriendRequests[uid]
        this.friends[request.userUid] = request
        break
      }
    }

    this.game.friendsMenu.onFriendRequestAccepted(requestId)
    this.game.friendRequestMenu.onFriendRequestAccepted(requestId)
  }

  onFriendRequestIgnored(requestId) {
    for (let uid in this.receivedFriendRequests) {
      let request = this.receivedFriendRequests[uid]
      if (request.id === requestId) {
        delete this.receivedFriendRequests[uid]
        break
      }
    }

    this.game.friendsMenu.onFriendRequestIgnored(requestId)
    this.game.friendRequestMenu.onFriendRequestIgnored(requestId)
  }

  async acceptFriendRequest(requestId) {
    if (this.isFriendRequestInProgress) return
    this.isFriendRequestInProgress = true

    let idToken = await this.getFirebaseIdToken()
    let matchmakerUrl = Config[env].matchmakerUrl
    let data = { idToken: idToken, requestId: requestId, uid: this.uid }

    ClientHelper.httpPost(matchmakerUrl + "accept_friend_request", data, {
      success: (result) => {
        this.isFriendRequestInProgress = false

        try {
          let data = JSON.parse(result)
          if (data.error) {
            this.game.displayError(data.error, { warning: true })
          } else {
            // success
            this.onFriendRequestAccepted(data.requestId)
          }
        } catch(e) {
          ExceptionReporter.captureException(e)
          this.game.displayError("Accepting Friend request failed", { warning: true })
        }
      },
      error: () => {
        this.isFriendRequestInProgress = false
        this.game.displayError("Accepting Friend request failed", { warning: true })
      }
    })
  }

  async ignoreFriendRequest(requestId) {
    if (this.isFriendRequestInProgress) return
    this.isFriendRequestInProgress = true

    let idToken = await this.getFirebaseIdToken()
    let matchmakerUrl = Config[env].matchmakerUrl
    let data = { idToken: idToken, requestId: requestId, uid: this.uid }

    ClientHelper.httpPost(matchmakerUrl + "ignore_friend_request", data, {
      success: (result) => {
        this.isFriendRequestInProgress = false

        try {
          let data = JSON.parse(result)
          if (data.error) {
            this.game.displayError(data.error, { warning: true })
          } else {
            // success
            this.onFriendRequestIgnored(data.requestId)
          }
        } catch(e) {
          ExceptionReporter.captureException(e)
          this.game.displayError("Ignore Friend request failed", { warning: true })
        }
      },
      error: () => {
        this.isFriendRequestInProgress = false
        this.game.displayError("Ignore Friend request failed", { warning: true })
      }
    })
  }

  hideMainPlayButtons() {
    document.querySelector("#play_btn").style.display = 'none'
  }

  getServerHTTPUrl(ip) {
    let protocol = this.isHttps() ? "https://" : "http://"

    return protocol + ip
  }

  getServerWebsocketUrl(ip) {
    let protocol = this.isHttps() ? "wss://" : "ws://"

    if (!ip) return null

    return protocol + ip
  }

  isHttps() {
    if (window.test_vm) return true
    if (env === "staging" || env === "production") return true
    return window.location.protocol === "https:"
  }

  initListeners() {
    document.getElementById("username_input").addEventListener("keyup", this.onUsernameInputKeyup.bind(this), true)
    document.querySelector(".search_world_btn").addEventListener("click", this.onSearchWorldBtnClick.bind(this), true)
    document.querySelector(".search_world_input").addEventListener("keyup", this.onSearchWorldInputKeyup.bind(this), true)
    document.getElementById("set_username_btn").addEventListener("click", this.onSetUsernameBtnClick.bind(this), true)
    document.getElementById("login_btn").addEventListener("click", this.onLoginBtnClick.bind(this), true)
    document.querySelector(".mobile_login_btn").addEventListener("click", this.onLoginBtnClick.bind(this), true)
    document.getElementById("logout_btn").addEventListener("click", this.onLogoutBtnClick.bind(this), true)
    document.querySelector(".mobile_logout_btn").addEventListener("click", this.onLogoutBtnClick.bind(this), true)
    document.querySelector(".new_colony_name_input").addEventListener("keyup", this.onNewColonyNameInputKeyup.bind(this), true)
    document.querySelector(".new_colony_menu_btn").addEventListener("click", this.onNewColonyMenuBtnClick.bind(this), true)
    document.querySelector(".tutorial_menu_btn").addEventListener("click", this.onTutorialMenuBtnClick.bind(this), true)
    document.querySelector(".default_play_btn").addEventListener("click", this.onDefaultPlayBtnClick.bind(this), true)
    document.querySelector(".tower_defense_game_mode_entry").addEventListener("click", this.onTowerDefenseGameModeClick.bind(this), true)
    document.querySelector(".bed_wars_game_mode_entry").addEventListener("click", this.onBedWarsGameModeClick.bind(this), true)
    document.querySelector(".domination_game_mode_entry").addEventListener("click", this.onDominationGameModeClick.bind(this), true)
    document.querySelector(".home_user_action_container .settings_menu_btn").addEventListener("click", this.onSettingsMenuBtnClick.bind(this), true)
    document.querySelector(".main_menu .settings_menu_btn").addEventListener("click", this.onSettingsMenuBtnClick.bind(this), true)
    document.querySelector(".resume_menu_btn").addEventListener("click", this.onResumeMenuBtnClick.bind(this), true)
    document.querySelector(".exit_game_menu_btn").addEventListener("click", this.onExitGameMenuBtnClick.bind(this), true)
    document.querySelector(".back_main_menu_btn").addEventListener("click", this.onBackMainMenuBtnClick.bind(this), true)
    document.querySelector(".continue_game_btn").addEventListener("click", this.onContinueGameBtnClick.bind(this), true)
    document.querySelector(".visibility_select").addEventListener("change", this.onGameVisibilitySelectChange.bind(this), true)
    document.querySelector("#language_select").addEventListener("change", this.onLanguageSelectChange.bind(this), true)
    document.querySelector(".rules_accept_btn").addEventListener("click", this.onRulesAcceptBtnClick.bind(this), true)
    document.querySelector(".imposter_game_mode_entry").addEventListener("click", this.onImposterGameModeClick.bind(this), true)
    document.querySelector(".invite_link_copy_btn").addEventListener("click", this.onCopyInviteLinkBtnCLick.bind(this), true)
    document.querySelector(".open_ban_list_btn").addEventListener("click", this.onOpenBanListClick.bind(this), true)

    // disable right click because it causes some keyup event listener not firing bug (that causes player to move indefinitely)
    document.addEventListener("contextmenu", function(e){
        e.preventDefault()
    }, false)
  }

  hideMainMenu() {
    document.querySelector(".main_menu").style.display = 'none'
  }

  showMainMenu() {
    document.querySelector(".main_menu").style.display = 'block'
    this.settingsMenu.hide()
    this.hideBackMainBtn()
    this.hideNewGameMenu()
    this.hideGameInviteMenu()
    this.miniGameDetailsMenu.hide()
    this.hideLoadGameSettings()
  }

  hideBackMainBtn() {
    document.querySelector(".back_main_menu_btn").style.display = 'none'
  }

  showBackMainBtn() {
    document.querySelector(".back_main_menu_btn").style.display = 'block'
  }

  onBackMainMenuBtnClick() {
    window.history.replaceState(null, null, "?")

    if (this.lastMenu) {
      this.lastMenu.show()
      this.lastMenu = null
      this.hideLoadGameSettings()
    } else {
      if (document.querySelector("#welcome_container").classList.contains("in_game")) {
        this.showMainMenu()
      } else {
        this.showHomeMenu()
      }
    }
  }

  onContinueGameBtnClick() {
    document.querySelector(".continue_game_btn span").innerText = i18n.t("Starting")
      // document.querySelector(".continue_game_btn .play_spinner").style.display = 'inline-block'
    this.gameExplorer.onJoinGameBtnClick()
  }

  onOpenBanListClick() {
    this.banManager.open()
  }

  onCopyInviteLinkBtnCLick() {
    let input = document.querySelector(".invite_link_input")

    input.select()
    input.setSelectionRange(0, 99999) /*For mobile devices*/

    /* Copy the text inside the text field */
    document.execCommand("copy")
  }

  onImposterGameModeClick() {
    let id
    if (env === 'development') {
      id = "eWC1CfZymRExY"
    } else if (env === 'production' || env === 'staging') {
      id = "Ap9OYBkw3dQvJ"
    }

    this.hideMenus()
    this.showBackMainBtn()

    this.miniGameDetailsMenu.open({ gameId: id })
  }

  onTowerDefenseGameModeClick() {
    let id
    if (env === 'development') {
      id = "vbj91eofmFCiu"
    } else {
      id = 'YcdqgbswlAqRi'
    }

    this.hideMenus()
    this.showBackMainBtn()

    this.miniGameDetailsMenu.open({ gameId: id })
  }

  onBedWarsGameModeClick() {
    let id
    if (env === 'development') {
      id = "l8v7ezWMvnGeC"
    } else if (env === 'production' || env === 'staging') {
      id = "uLHpXWb2koXYe"
    }

    this.hideMenus()
    this.showBackMainBtn()

    this.miniGameDetailsMenu.open({ gameId: id })
  }

  onDominationGameModeClick() {
    let id
    if (env === 'development') {
      id = "BPF0uFha5QLUr"
    } else if (env === 'production' || env === 'staging') {
      id = "PnGkJd5xZsb0v"
    }

    this.hideMenus()
    this.showBackMainBtn()

    this.miniGameDetailsMenu.open({ gameId: id })
  }

  onRulesAcceptBtnClick() {
    document.querySelector("#rules_menu").style.display = 'none'
    SocketUtil.emit("ClientChat", { message: "/accept_rules" })
  }

  onGameVisibilitySelectChange(e) {
  }

  onLanguageSelectChange(e) {
    let selectedLanguage = e.target.value
    if (selectedLanguage !== window.language) {
      Cookies.set("language", selectedLanguage)
      this.navigateToLanguage(selectedLanguage)
    }
  }

  navigateToLanguage(language) {
    window.location.href = "/" + language + "/" + window.location.search
  }

  showLoadGameSettings(teamEntry) {
    this.hideHomeMenu()
    this.showBackMainBtn()
    document.querySelector(".load_game_settings_container").style.display = 'block'
    document.querySelector('.visibility_select').value = teamEntry.isPrivate ? 'private' : 'public'

    document.querySelector('.load_game_save_name').innerText = teamEntry.getName()
  }

  hideLoadGameSettings() {
    document.querySelector(".load_game_settings_container").style.display = 'none'
  }

  showHomeMenu() {
    this.clearHomeErrorMessage()

    document.body.style.overflowY = 'scroll'
    document.querySelector(".left_sidebar_contents").style.display = 'block'
    document.querySelector("#error_menu_content").innerText = ""
    document.querySelector("#home_background").classList.remove('security_camera')
    document.querySelector(".other_game_ad_square").style.display = 'block'

    this.gameExplorer.show()

    if (this.settingsMenu) {
      this.settingsMenu.hide()
      this.miniGameDetailsMenu.hide()
    }

    this.hideBackMainBtn()
    this.hideLoadGameSettings()
    this.hideGameInviteMenu()
    this.hideNewGameMenu()

    document.querySelector(".middle_container").style.display = 'block'
    if (this.gameExplorer && this.gameExplorer.isAttachedToBody) {
      this.gameExplorer.attachToMiddleContainer()
    }
  }

  hideHomeMenu() {
    document.querySelector(".middle_container").style.display = 'none'
  }

  lockJoin() {
    this.isJoinInProgress = true
    setTimeout(() => {
      this.isJoinInProgress = false
    }, 10000)
  }

  onNewColonyLaunchBtnClick() {
    this.hideMenus()

    this.showBackMainBtn()
    document.querySelector(".new_game_container").style.display = 'block'
  }

  hideNewGameMenu() {
    document.querySelector(".new_game_container").style.display = 'none'
  }

  async onNewColonyMenuBtnClick(e) {
    if (this.isJoinInProgress) return
    if (!this.isMatchmakerReady()) {
      this.onPlayerCantJoin({ message: i18n.t("MatchmakerUnavailable") })
      return
    }

    if (!Cookies.get('tutorial_done')) {
      this.game.confirmMenu.open({
        message: i18n.t('AskTutorialMessage'),
        proceedCallback: this.onTutorialMenuBtnClick.bind(this),
        cancelCallback: this.createNewColony.bind(this)
      })
      return
    } else {
      this.createNewColony()
    }
  }

  createNewColony() {
    this.lockJoin()
    this.clearHomeErrorMessage()

    Cookies.set('tutorial_done', true)

    document.querySelector(".new_colony_menu_btn span").innerText = i18n.t("Starting")
    document.querySelector(".new_colony_menu_btn .play_spinner").style.display = 'inline-block'

    this.requestNewColonyFromMatchmaker()
  }

  onDefaultPlayBtnClick(e) {
    this.onNewColonyLaunchBtnClick()
  }

  hasZeroGames() {
    return Object.keys(this.gameExplorer.sectorEntries).length === 0
  }

  joinDominationMiniGame() {
    if (debugMode) {
      this.gameExplorer.joinMiniGame("BPF0uFha5QLUr")
    } else {
      this.gameExplorer.joinMiniGame("PnGkJd5xZsb0v")
    }
  }

  async onTutorialMenuBtnClick(e) {
    if (this.isJoinInProgress) return
    if (!this.isMatchmakerReady()) {
      this.onPlayerCantJoin({ message: i18n.t("MatchmakerUnavailable") })
      return
    }

    this.lockJoin()
    this.clearHomeErrorMessage()

    Cookies.set('tutorial_done', true)

    document.querySelector(".tutorial_menu_btn span").innerText = i18n.t("Starting")
    document.querySelector(".tutorial_menu_btn .play_spinner").style.display = 'inline-block'

    let isTutorial = true
    this.requestNewColonyFromMatchmaker(isTutorial)
  }

  async onPlayerCreateSectorStatus(data) {
    if (data.error) {
      this.onPlayerCantJoin({ message: data.error })
      this.enableJoin()
    } else {
      if (data.profile) {
        console.log("== NewColony Timing ")
        console.log(data.profile)
      }
      if (data.isGameReady) {
        this.connectNewColonyGame(data.host, data.sectorId)
      }
    }
  }

  async joinMiniGame(miniGameId, options) {
    let data = {
      env: this.getEnvToSendToMatchmaker(),
      region: this.region,
      sessionId: this.sessionId,
      miniGameId: miniGameId
    }

    let chatSelect = document.querySelector(".minigame_chat_language_select")
    data.language = chatSelect.value

    if (this.isLoggedIn()) {
      let idToken = await this.getFirebaseIdToken()
      data["idToken"] = idToken
    }

    if (options.prevMiniGameId) {
      data.prevMiniGameId = options.prevMiniGameId
    }

    if (options.targetMiniGameId) {
      data.targetMiniGameId = options.targetMiniGameId
    }

    if (options.isPrivate) {
      data.isPrivate = true
    }

    if (options.hostPrivateGame) {
      data.hostPrivateGame = true
    }

    this.sendToMatchmaker({ event: "JoinMiniGame", data: data })
  }

  async requestNewColonyFromMatchmaker(isTutorial = false) {
    let data = {
      env: this.getEnvToSendToMatchmaker(),
      region: this.region,
      sessionId: this.sessionId
    }

    if (this.isLoggedIn()) {
      let idToken = await this.getFirebaseIdToken()
      data["idToken"] = idToken
      data["username"] = this.userData.username
      data["uid"] = this.uid
    }

    if (isTutorial) {
      data["isTutorial"] = true
    }

    let colonyName = document.querySelector(".new_colony_name_input").value
    if (colonyName.length > 0) {
      data["name"] = colonyName
    }

    if (this.isStress()) {
      data["stress"] = true
    }

    if (this.getUrlParam().get("row")) {
      data["rowCount"] = this.getUrlParam().get("row")
    }

    if (this.getUrlParam().get("col")) {
      data["colCount"] = this.getUrlParam().get("col")
    }

    this.sendToMatchmaker({ event: "NewColony", data: data })
  }

  isStress() {
    const url = this.getBrowserHref()
    return url.match(new RegExp(".*?stress="))
  }

  getParentUrl() {
    return (window.location != window.parent.location)
            ? document.referrer
            : document.location.href
  }

  sendToMatchmaker(json) {
    let matchmakerSocket = this.getMatchmakerSocket()
    if (matchmakerSocket.readyState !== WebSocket.OPEN) return

    matchmakerSocket.send(JSON.stringify(json))
  }

  isMatchmakerReady() {
    let matchmakerSocket = this.getMatchmakerSocket()
    return matchmakerSocket && matchmakerSocket.readyState === WebSocket.OPEN
  }

  getMatchmakerSocket() {
    return this.gameExplorer.socket
  }


  reserveGameSpot(host) {
    return new Promise((resolve, reject) => {
      ClientHelper.httpRequest(this.getServerHTTPUrl(host) + "/join", {
        success: (result) => {
          let join = JSON.parse(result)
          if (join.success) {
            console.log("reserved spot in " + host)
            resolve(true)
          } else {
            resolve(false)
          }
        },
        error: () => {
          resolve(false)
        }
      })
    })
  }

  hideMenus() {
    this.hideMainMenu()
    this.hideHomeMenu()
    this.gameExplorer.hide()
    this.pvpExplorer.hide()
    this.hideGameInviteMenu()
  }

  onPvPModeMenuBtnClick(e) {
    this.hideMenus()

    this.showBackMainBtn()
    this.pvpExplorer.show()
  }

  onLoadGameMenuBtnClick(e) {
    this.hideMenus()

    this.showBackMainBtn()
  }


  onSettingsMenuBtnClick(e) {
    this.hideMenus()

    this.showBackMainBtn()
    this.settingsMenu.show()
  }

  onResumeMenuBtnClick(e) {
    this.game.closeInGameMenu()
  }

  onExitGameMenuBtnClick(e) {
    SocketUtil.emit("LeaveGame", {})

    if (this.gameConnection) {
      this.gameConnection.close()
    }

    if (this.isLoggedIn() && this.game.isCreatedByPlayer()) {
      setTimeout(() => {
        this.exitGame()
      }, 1000)
    } else {
      this.exitGame()
    }
  }

  exitGame() {
    this.game.stopAllBackgroundMusic()
    this.game.closeInGameMenu()
    // this.game.gameConnection.close()
    window.history.replaceState(null, null, "?")

    this.game.displayHomePage()
    if (this.impy) {
      this.hideMenus()
      let miniGameId = debugMode ? "eWC1CfZymRExY" : "Ap9OYBkw3dQvJ"

      this.miniGameDetailsMenu.open({ gameId: miniGameId })
    }
  }

  onGoogleLoginBtnClick() {
    FirebaseClientHelper.signIn("google")
  }

  onFacebookLoginBtnClick() {
    FirebaseClientHelper.signIn("facebook")
  }

  initAuthentication() {
    document.querySelector(".google_login_btn").addEventListener("click", this.onGoogleLoginBtnClick.bind(this), true)
    document.querySelector(".facebook_login_btn").addEventListener("click", this.onFacebookLoginBtnClick.bind(this), true)

    let hasLocalStorage = this.checkLocalStorageSupport()
    // when iframed in incognito, localStorage is not available if (cookies are blocked)
    // firebase would throw error, and cant even play game.
    // dont init firebase, show warning that cookies must be enable to login (for google sign in to work using their sdk)
    if (hasLocalStorage) {
      FirebaseClientHelper.initFirebase(this.onFirebaseAuth.bind(this))
    }
  }

  getFirebaseHelper() {
    return FirebaseClientHelper
  }

  getFirebaseInstance() {
    return FirebaseClientHelper.getFirebaseInstance()
  }

  showAuthProgress() {
    document.querySelector("#auth_in_progress").style.display = 'block'
  }

  hideAuthProgress() {
    document.querySelector("#auth_in_progress").style.display = 'none'
  }

  updateFriends(friends) {
    if (!friends) return
    friends.forEach((data) => {
      let isPending = data.status === "requested"
      let isIgnored = data.status === "ignored"
      let isAccepted = data.status === "accepted"
      let isRequestSentByMe = data.userUid === this.uid

      if (isAccepted) {
        if (isRequestSentByMe) {
          this.friends[data.friendUid] = data
        } else {
          this.friends[data.userUid] = data
        }
      } else {
        if (isRequestSentByMe) {
          this.sentFriendRequests[data.friendUid] = data
        } else {
          this.receivedFriendRequests[data.userUid] = data
        }
      }

    })
  }

  isMyFriend(uid) {
    return this.friends[uid]
  }

  isFriendRequestPending(uid) {
    return this.sentFriendRequests[uid] ||
           this.receivedFriendRequests[uid]
  }

  async onFirebaseAuth(user) {
    if (user) {
      this.user = user
      this.uid = user.uid

      this.showAuthProgress()
      document.getElementById("logout_btn").style.display = 'inline-block'
      document.querySelector("#social_login_container").style.display = 'none'

      let result = await this.getUserRecord(this.uid)
      this.userData = result
      this.updateFriends(result.friends)

      this.hideAuthProgress()

      if (result.error) {
        if (result.error === 'User not found') {
          this.showUsernameInputForm(user)
        }
      } else {
        this.renderLoggedInUser(this.userData.username)
        let saveEntries = this.userData.saves
        let favorites   = this.userData.favorites
        this.gameExplorer.addMyColonies(saveEntries)
        this.gameExplorer.addFavoriteColonies(favorites)

        if (this.isModerator()) {
          document.body.classList.add("moderator")
        }
      }

      this.onUserAuthenticated()
    } else {
      // No user is signed in.
      this.showAuthContainer()
      this.hideUsernameContainer()
    }
  }

  onPlayerOnline(data) {
    this.onlinePlayers[data.uid] = data
  }

  onPlayerOffline(data) {
    delete this.onlinePlayers[data.uid]
  }

  onFriendRequest(data) {
    this.receivedFriendRequests[data.uid] = data
  }

  isModerator() {
    if (!this.userData) return false
    let mods = ["kuroro", "BigTforLife", "superaaron"]
    return mods.indexOf(this.userData.username) !== -1
  }

  async onUserAuthenticated() {
    let isMod = this.isModerator()

    if (isMod) {
      document.querySelector(".open_ban_list_btn").style.display = 'block'
    }

    this.isUserAuthenticated = true
    if (this.isReadyToPresence()) {
      let idToken = await this.getFirebaseIdToken()
      this.sendToMatchmaker({ event: "Online", data: { idToken: idToken, uid: this.uid } })
    }
  }

  async onMatchmakerConnectSuccess() {
    this.isConnectedToMatchmaker = true

    if (this.isReadyToPresence()) {
      let idToken = await this.getFirebaseIdToken()
      this.sendToMatchmaker({ event: "Online", data: { idToken: idToken, uid: this.uid } })
    }
  }

  isReadyToPresence() {
    return this.isUserAuthenticated && this.isConnectedToMatchmaker
  }

  getUserRecord(uid) {
    let matchmakerUrl = Config[env].matchmakerUrl
    return new Promise((resolve, reject) => {
      ClientHelper.httpRequest(matchmakerUrl + "get_user?uid=" + uid, {
        success: (result) => {
          try {
            let user = JSON.parse(result)
            if (user.error) {
              resolve({ error: user.error })
            } else {
              resolve(user)
            }
          } catch(e) {
            resolve({ error: "Something went wrong" })
          }
        },
        error: () => {
          resolve({ error: "Something went wrong" })
        }
      })
    })
  }

  getFirebaseIdToken() {
    return new Promise((resolve, reject) => {
      if (this.idToken) {
        let isAlmostExpiring = (Date.now() - this.idTokenCreatedAt) > 45 * 60 * 1000 // 45 min
        if (isAlmostExpiring) {
          FirebaseClientHelper.fetchFirebaseIdToken((token) => {
            this.idToken = token
            this.idTokenCreatedAt = Date.now()
            resolve(token)
          })
        } else {
          resolve(this.idToken)
        }
      } else {
        FirebaseClientHelper.fetchFirebaseIdToken((token) => {
          this.idToken = token
          this.idTokenCreatedAt = Date.now()
          resolve(token)
        })
      }
    })
  }

  hideAuthContainer() {
    document.getElementById("authentication_container").style.display = 'none'
  }

  showAuthContainer() {
    document.getElementById("authentication_container").style.display = 'inline-block'
  }

  renderLoggedInUser(username) {
    this.username = username
    this.hideAuthContainer()
    document.getElementById("name_input").style.display = 'none'
    document.getElementById("username_container").style.display = 'block'
    document.getElementById("username").innerText = username

    document.querySelector("#social_login_container").style.display = 'none'

    document.querySelector(".mobile_login_btn").style.display = 'none'
    document.querySelector(".mobile_logout_btn").style.display = 'block'
    document.querySelector(".mobile_username_container").classList.add("logged_in")
    document.querySelector(".mobile_username_container .username").innerText = username
  }

  hideUsernameContainer() {
    document.getElementById("username_container").style.display = 'none'
  }

  showUsernameInputForm() {
    this.hideAuthContainer()
    document.getElementById("username_form_container").style.display = "block"
  }

  hideUsernameInputForm() {
    document.getElementById("username_form_container").style.display = "none"
  }


}

window.main = new Main()
main.run()

},{"../../common/entities/object_pool":660,"../../common/helper":664,"../../common/translations/en":682,"../../common/translations/ja":683,"../../common/translations/ru":684,"./../../common/util/protocol":686,"./components/ban_manager":178,"./components/game_connection":179,"./components/game_explorer":180,"./components/minigame_details_menu":182,"./components/pvp_explorer":184,"./components/settings_menu":187,"./components/team_entry":188,"./entities/game":440,"./entities/lighting":448,"./entities/particles/index":506,"./entities/projectiles/index":526,"./entities/sprite_pool_instance":547,"./util/bitmap_text":648,"./util/client_helper":649,"./util/exception_reporter":650,"./util/firebase_client_helper":651,"./util/polyfills":653,"./util/socket_util":654,"ismobilejs":57,"js-cookie":58,"junon-common/config":59,"node-polyglot":157,"url-search-params-polyfill":173,"uuid/v4":176}],2:[function(require,module,exports){
(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("Draggable", [], factory);
	else if(typeof exports === 'object')
		exports["Draggable"] = factory();
	else
		root["Draggable"] = factory();
})(window, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 66);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _AbstractEvent = __webpack_require__(64);

var _AbstractEvent2 = _interopRequireDefault(_AbstractEvent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _AbstractEvent2.default;

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _AbstractPlugin = __webpack_require__(60);

var _AbstractPlugin2 = _interopRequireDefault(_AbstractPlugin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _AbstractPlugin2.default;

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _closest = __webpack_require__(51);

Object.defineProperty(exports, 'closest', {
  enumerable: true,
  get: function () {
    return _interopRequireDefault(_closest).default;
  }
});

var _requestNextAnimationFrame = __webpack_require__(49);

Object.defineProperty(exports, 'requestNextAnimationFrame', {
  enumerable: true,
  get: function () {
    return _interopRequireDefault(_requestNextAnimationFrame).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _SensorEvent = __webpack_require__(44);

Object.keys(_SensorEvent).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _SensorEvent[key];
    }
  });
});

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Sensor = __webpack_require__(47);

var _Sensor2 = _interopRequireDefault(_Sensor);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Sensor2.default;

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _DragEvent = __webpack_require__(14);

Object.keys(_DragEvent).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _DragEvent[key];
    }
  });
});

var _DraggableEvent = __webpack_require__(13);

Object.keys(_DraggableEvent).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _DraggableEvent[key];
    }
  });
});

var _Plugins = __webpack_require__(12);

Object.keys(_Plugins).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _Plugins[key];
    }
  });
});

var _Sensors = __webpack_require__(6);

Object.keys(_Sensors).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _Sensors[key];
    }
  });
});

var _Draggable = __webpack_require__(37);

var _Draggable2 = _interopRequireDefault(_Draggable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Draggable2.default;

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Sensor = __webpack_require__(4);

Object.defineProperty(exports, 'Sensor', {
  enumerable: true,
  get: function () {
    return _interopRequireDefault(_Sensor).default;
  }
});

var _MouseSensor = __webpack_require__(46);

Object.defineProperty(exports, 'MouseSensor', {
  enumerable: true,
  get: function () {
    return _interopRequireDefault(_MouseSensor).default;
  }
});

var _TouchSensor = __webpack_require__(43);

Object.defineProperty(exports, 'TouchSensor', {
  enumerable: true,
  get: function () {
    return _interopRequireDefault(_TouchSensor).default;
  }
});

var _DragSensor = __webpack_require__(41);

Object.defineProperty(exports, 'DragSensor', {
  enumerable: true,
  get: function () {
    return _interopRequireDefault(_DragSensor).default;
  }
});

var _ForceTouchSensor = __webpack_require__(39);

Object.defineProperty(exports, 'ForceTouchSensor', {
  enumerable: true,
  get: function () {
    return _interopRequireDefault(_ForceTouchSensor).default;
  }
});

var _SensorEvent = __webpack_require__(3);

Object.keys(_SensorEvent).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _SensorEvent[key];
    }
  });
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _SnappableEvent = __webpack_require__(18);

Object.keys(_SnappableEvent).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _SnappableEvent[key];
    }
  });
});

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _CollidableEvent = __webpack_require__(23);

Object.keys(_CollidableEvent).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _CollidableEvent[key];
    }
  });
});

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _SortableEvent = __webpack_require__(27);

Object.keys(_SortableEvent).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _SortableEvent[key];
    }
  });
});

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _SwappableEvent = __webpack_require__(30);

Object.keys(_SwappableEvent).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _SwappableEvent[key];
    }
  });
});

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _DroppableEvent = __webpack_require__(33);

Object.keys(_DroppableEvent).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _DroppableEvent[key];
    }
  });
});

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Announcement = __webpack_require__(62);

Object.defineProperty(exports, 'Announcement', {
  enumerable: true,
  get: function () {
    return _interopRequireDefault(_Announcement).default;
  }
});
Object.defineProperty(exports, 'defaultAnnouncementOptions', {
  enumerable: true,
  get: function () {
    return _Announcement.defaultOptions;
  }
});

var _Focusable = __webpack_require__(59);

Object.defineProperty(exports, 'Focusable', {
  enumerable: true,
  get: function () {
    return _interopRequireDefault(_Focusable).default;
  }
});

var _Mirror = __webpack_require__(57);

Object.defineProperty(exports, 'Mirror', {
  enumerable: true,
  get: function () {
    return _interopRequireDefault(_Mirror).default;
  }
});
Object.defineProperty(exports, 'defaultMirrorOptions', {
  enumerable: true,
  get: function () {
    return _Mirror.defaultOptions;
  }
});

var _Scrollable = __webpack_require__(53);

Object.defineProperty(exports, 'Scrollable', {
  enumerable: true,
  get: function () {
    return _interopRequireDefault(_Scrollable).default;
  }
});
Object.defineProperty(exports, 'defaultScrollableOptions', {
  enumerable: true,
  get: function () {
    return _Scrollable.defaultOptions;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _DraggableEvent = __webpack_require__(63);

Object.keys(_DraggableEvent).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _DraggableEvent[key];
    }
  });
});

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _DragEvent = __webpack_require__(65);

Object.keys(_DragEvent).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _DragEvent[key];
    }
  });
});

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultOptions = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _AbstractPlugin = __webpack_require__(1);

var _AbstractPlugin2 = _interopRequireDefault(_AbstractPlugin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const onSortableSorted = Symbol('onSortableSorted');

/**
 * SwapAnimation default options
 * @property {Object} defaultOptions
 * @property {Number} defaultOptions.duration
 * @property {String} defaultOptions.easingFunction
 * @property {Boolean} defaultOptions.horizontal
 * @type {Object}
 */
const defaultOptions = exports.defaultOptions = {
  duration: 150,
  easingFunction: 'ease-in-out',
  horizontal: false
};

/**
 * SwapAnimation plugin adds swap animations for sortable
 * @class SwapAnimation
 * @module SwapAnimation
 * @extends AbstractPlugin
 */
class SwapAnimation extends _AbstractPlugin2.default {
  /**
   * SwapAnimation constructor.
   * @constructs SwapAnimation
   * @param {Draggable} draggable - Draggable instance
   */
  constructor(draggable) {
    super(draggable);

    /**
     * SwapAnimation options
     * @property {Object} options
     * @property {Number} defaultOptions.duration
     * @property {String} defaultOptions.easingFunction
     * @type {Object}
     */
    this.options = _extends({}, defaultOptions, this.getOptions());

    /**
     * Last animation frame
     * @property {Number} lastAnimationFrame
     * @type {Number}
     */
    this.lastAnimationFrame = null;

    this[onSortableSorted] = this[onSortableSorted].bind(this);
  }

  /**
   * Attaches plugins event listeners
   */
  attach() {
    this.draggable.on('sortable:sorted', this[onSortableSorted]);
  }

  /**
   * Detaches plugins event listeners
   */
  detach() {
    this.draggable.off('sortable:sorted', this[onSortableSorted]);
  }

  /**
   * Returns options passed through draggable
   * @return {Object}
   */
  getOptions() {
    return this.draggable.options.swapAnimation || {};
  }

  /**
   * Sortable sorted handler
   * @param {SortableSortedEvent} sortableEvent
   * @private
   */
  [onSortableSorted]({ oldIndex, newIndex, dragEvent }) {
    const { source, over } = dragEvent;

    cancelAnimationFrame(this.lastAnimationFrame);

    // Can be done in a separate frame
    this.lastAnimationFrame = requestAnimationFrame(() => {
      if (oldIndex >= newIndex) {
        animate(source, over, this.options);
      } else {
        animate(over, source, this.options);
      }
    });
  }
}

exports.default = SwapAnimation; /**
                                  * Animates two elements
                                  * @param {HTMLElement} from
                                  * @param {HTMLElement} to
                                  * @param {Object} options
                                  * @param {Number} options.duration
                                  * @param {String} options.easingFunction
                                  * @param {String} options.horizontal
                                  * @private
                                  */

function animate(from, to, { duration, easingFunction, horizontal }) {
  for (const element of [from, to]) {
    element.style.pointerEvents = 'none';
  }

  if (horizontal) {
    const width = from.offsetWidth;
    from.style.transform = `translate3d(${width}px, 0, 0)`;
    to.style.transform = `translate3d(-${width}px, 0, 0)`;
  } else {
    const height = from.offsetHeight;
    from.style.transform = `translate3d(0, ${height}px, 0)`;
    to.style.transform = `translate3d(0, -${height}px, 0)`;
  }

  requestAnimationFrame(() => {
    for (const element of [from, to]) {
      element.addEventListener('transitionend', resetElementOnTransitionEnd);
      element.style.transition = `transform ${duration}ms ${easingFunction}`;
      element.style.transform = '';
    }
  });
}

/**
 * Resets animation style properties after animation has completed
 * @param {Event} event
 * @private
 */
function resetElementOnTransitionEnd(event) {
  event.target.style.transition = '';
  event.target.style.pointerEvents = '';
  event.target.removeEventListener('transitionend', resetElementOnTransitionEnd);
}

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultOptions = undefined;

var _SwapAnimation = __webpack_require__(15);

var _SwapAnimation2 = _interopRequireDefault(_SwapAnimation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _SwapAnimation2.default;
exports.defaultOptions = _SwapAnimation.defaultOptions;

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _AbstractPlugin = __webpack_require__(1);

var _AbstractPlugin2 = _interopRequireDefault(_AbstractPlugin);

var _SnappableEvent = __webpack_require__(7);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const onDragStart = Symbol('onDragStart');
const onDragStop = Symbol('onDragStop');
const onDragOver = Symbol('onDragOver');
const onDragOut = Symbol('onDragOut');
const onMirrorCreated = Symbol('onMirrorCreated');
const onMirrorDestroy = Symbol('onMirrorDestroy');

/**
 * Snappable plugin which snaps draggable elements into place
 * @class Snappable
 * @module Snappable
 * @extends AbstractPlugin
 */
class Snappable extends _AbstractPlugin2.default {
  /**
   * Snappable constructor.
   * @constructs Snappable
   * @param {Draggable} draggable - Draggable instance
   */
  constructor(draggable) {
    super(draggable);

    /**
     * Keeps track of the first source element
     * @property {HTMLElement|null} firstSource
     */
    this.firstSource = null;

    /**
     * Keeps track of the mirror element
     * @property {HTMLElement} mirror
     */
    this.mirror = null;

    this[onDragStart] = this[onDragStart].bind(this);
    this[onDragStop] = this[onDragStop].bind(this);
    this[onDragOver] = this[onDragOver].bind(this);
    this[onDragOut] = this[onDragOut].bind(this);
    this[onMirrorCreated] = this[onMirrorCreated].bind(this);
    this[onMirrorDestroy] = this[onMirrorDestroy].bind(this);
  }

  /**
   * Attaches plugins event listeners
   */
  attach() {
    this.draggable.on('drag:start', this[onDragStart]).on('drag:stop', this[onDragStop]).on('drag:over', this[onDragOver]).on('drag:out', this[onDragOut]).on('droppable:over', this[onDragOver]).on('droppable:out', this[onDragOut]).on('mirror:created', this[onMirrorCreated]).on('mirror:destroy', this[onMirrorDestroy]);
  }

  /**
   * Detaches plugins event listeners
   */
  detach() {
    this.draggable.off('drag:start', this[onDragStart]).off('drag:stop', this[onDragStop]).off('drag:over', this[onDragOver]).off('drag:out', this[onDragOut]).off('droppable:over', this[onDragOver]).off('droppable:out', this[onDragOut]).off('mirror:created', this[onMirrorCreated]).off('mirror:destroy', this[onMirrorDestroy]);
  }

  /**
   * Drag start handler
   * @private
   * @param {DragStartEvent} event - Drag start event
   */
  [onDragStart](event) {
    if (event.canceled()) {
      return;
    }

    this.firstSource = event.source;
  }

  /**
   * Drag stop handler
   * @private
   * @param {DragStopEvent} event - Drag stop event
   */
  [onDragStop]() {
    this.firstSource = null;
  }

  /**
   * Drag over handler
   * @private
   * @param {DragOverEvent|DroppableOverEvent} event - Drag over event
   */
  [onDragOver](event) {
    if (event.canceled()) {
      return;
    }

    const source = event.source || event.dragEvent.source;

    if (source === this.firstSource) {
      this.firstSource = null;
      return;
    }

    const snapInEvent = new _SnappableEvent.SnapInEvent({
      dragEvent: event,
      snappable: event.over || event.droppable
    });

    this.draggable.trigger(snapInEvent);

    if (snapInEvent.canceled()) {
      return;
    }

    if (this.mirror) {
      this.mirror.style.display = 'none';
    }

    source.classList.remove(this.draggable.getClassNameFor('source:dragging'));
    source.classList.add(this.draggable.getClassNameFor('source:placed'));

    // Need to cancel this in drag out
    setTimeout(() => {
      source.classList.remove(this.draggable.getClassNameFor('source:placed'));
    }, this.draggable.options.placedTimeout);
  }

  /**
   * Drag out handler
   * @private
   * @param {DragOutEvent|DroppableOutEvent} event - Drag out event
   */
  [onDragOut](event) {
    if (event.canceled()) {
      return;
    }

    const source = event.source || event.dragEvent.source;

    const snapOutEvent = new _SnappableEvent.SnapOutEvent({
      dragEvent: event,
      snappable: event.over || event.droppable
    });

    this.draggable.trigger(snapOutEvent);

    if (snapOutEvent.canceled()) {
      return;
    }

    if (this.mirror) {
      this.mirror.style.display = '';
    }

    source.classList.add(this.draggable.getClassNameFor('source:dragging'));
  }

  /**
   * Mirror created handler
   * @param {MirrorCreatedEvent} mirrorEvent
   * @private
   */
  [onMirrorCreated]({ mirror }) {
    this.mirror = mirror;
  }

  /**
   * Mirror destroy handler
   * @param {MirrorDestroyEvent} mirrorEvent
   * @private
   */
  [onMirrorDestroy]() {
    this.mirror = null;
  }
}
exports.default = Snappable;

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SnapOutEvent = exports.SnapInEvent = exports.SnapEvent = undefined;

var _AbstractEvent = __webpack_require__(0);

var _AbstractEvent2 = _interopRequireDefault(_AbstractEvent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Base snap event
 * @class SnapEvent
 * @module SnapEvent
 * @extends AbstractEvent
 */
class SnapEvent extends _AbstractEvent2.default {

  /**
   * Drag event that triggered this snap event
   * @property dragEvent
   * @type {DragEvent}
   * @readonly
   */
  get dragEvent() {
    return this.data.dragEvent;
  }

  /**
   * Snappable element
   * @property snappable
   * @type {HTMLElement}
   * @readonly
   */
  get snappable() {
    return this.data.snappable;
  }
}

exports.SnapEvent = SnapEvent; /**
                                * Snap in event
                                * @class SnapInEvent
                                * @module SnapInEvent
                                * @extends SnapEvent
                                */

SnapEvent.type = 'snap';
class SnapInEvent extends SnapEvent {}

exports.SnapInEvent = SnapInEvent; /**
                                    * Snap out event
                                    * @class SnapOutEvent
                                    * @module SnapOutEvent
                                    * @extends SnapEvent
                                    */

SnapInEvent.type = 'snap:in';
SnapInEvent.cancelable = true;
class SnapOutEvent extends SnapEvent {}
exports.SnapOutEvent = SnapOutEvent;
SnapOutEvent.type = 'snap:out';
SnapOutEvent.cancelable = true;

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _SnappableEvent = __webpack_require__(7);

Object.keys(_SnappableEvent).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _SnappableEvent[key];
    }
  });
});

var _Snappable = __webpack_require__(17);

var _Snappable2 = _interopRequireDefault(_Snappable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Snappable2.default;

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultOptions = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _AbstractPlugin = __webpack_require__(1);

var _AbstractPlugin2 = _interopRequireDefault(_AbstractPlugin);

var _utils = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const onMirrorCreated = Symbol('onMirrorCreated');
const onMirrorDestroy = Symbol('onMirrorDestroy');
const onDragOver = Symbol('onDragOver');
const resize = Symbol('resize');

/**
 * ResizeMirror default options
 * @property {Object} defaultOptions
 * @type {Object}
 */
const defaultOptions = exports.defaultOptions = {};

/**
 * The ResizeMirror plugin resizes the mirror element to the dimensions of the draggable element that the mirror is hovering over
 * @class ResizeMirror
 * @module ResizeMirror
 * @extends AbstractPlugin
 */
class ResizeMirror extends _AbstractPlugin2.default {
  /**
   * ResizeMirror constructor.
   * @constructs ResizeMirror
   * @param {Draggable} draggable - Draggable instance
   */
  constructor(draggable) {
    super(draggable);

    /**
     * ResizeMirror options
     * @property {Object} options
     * @type {Object}
     */
    this.options = _extends({}, defaultOptions, this.getOptions());

    /**
     * ResizeMirror remembers the last width when resizing the mirror
     * to avoid additional writes to the DOM
     * @property {number} lastWidth
     */
    this.lastWidth = 0;

    /**
     * ResizeMirror remembers the last height when resizing the mirror
     * to avoid additional writes to the DOM
     * @property {number} lastHeight
     */
    this.lastHeight = 0;

    /**
     * Keeps track of the mirror element
     * @property {HTMLElement} mirror
     */
    this.mirror = null;

    this[onMirrorCreated] = this[onMirrorCreated].bind(this);
    this[onMirrorDestroy] = this[onMirrorDestroy].bind(this);
    this[onDragOver] = this[onDragOver].bind(this);
  }

  /**
   * Attaches plugins event listeners
   */
  attach() {
    this.draggable.on('mirror:created', this[onMirrorCreated]).on('drag:over', this[onDragOver]).on('drag:over:container', this[onDragOver]);
  }

  /**
   * Detaches plugins event listeners
   */
  detach() {
    this.draggable.off('mirror:created', this[onMirrorCreated]).off('mirror:destroy', this[onMirrorDestroy]).off('drag:over', this[onDragOver]).off('drag:over:container', this[onDragOver]);
  }

  /**
   * Returns options passed through draggable
   * @return {Object}
   */
  getOptions() {
    return this.draggable.options.resizeMirror || {};
  }

  /**
   * Mirror created handler
   * @param {MirrorCreatedEvent} mirrorEvent
   * @private
   */
  [onMirrorCreated]({ mirror }) {
    this.mirror = mirror;
  }

  /**
   * Mirror destroy handler
   * @param {MirrorDestroyEvent} mirrorEvent
   * @private
   */
  [onMirrorDestroy]() {
    this.mirror = null;
  }

  /**
   * Drag over handler
   * @param {DragOverEvent | DragOverContainer} dragEvent
   * @private
   */
  [onDragOver](dragEvent) {
    this[resize](dragEvent);
  }

  /**
   * Resize function for
   * @param {DragOverEvent | DragOverContainer} dragEvent
   * @private
   */
  [resize]({ overContainer, over }) {
    requestAnimationFrame(() => {
      if (this.mirror.parentNode !== overContainer) {
        overContainer.appendChild(this.mirror);
      }

      const overElement = over || this.draggable.getDraggableElementsForContainer(overContainer)[0];

      if (!overElement) {
        return;
      }

      (0, _utils.requestNextAnimationFrame)(() => {
        const overRect = overElement.getBoundingClientRect();

        if (this.lastHeight === overRect.height && this.lastWidth === overRect.width) {
          return;
        }

        this.mirror.style.width = `${overRect.width}px`;
        this.mirror.style.height = `${overRect.height}px`;

        this.lastWidth = overRect.width;
        this.lastHeight = overRect.height;
      });
    });
  }
}
exports.default = ResizeMirror;

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultOptions = undefined;

var _ResizeMirror = __webpack_require__(20);

var _ResizeMirror2 = _interopRequireDefault(_ResizeMirror);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _ResizeMirror2.default;
exports.defaultOptions = _ResizeMirror.defaultOptions;

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _AbstractPlugin = __webpack_require__(1);

var _AbstractPlugin2 = _interopRequireDefault(_AbstractPlugin);

var _utils = __webpack_require__(2);

var _CollidableEvent = __webpack_require__(8);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const onDragMove = Symbol('onDragMove');
const onDragStop = Symbol('onDragStop');
const onRequestAnimationFrame = Symbol('onRequestAnimationFrame');

/**
 * Collidable plugin which detects colliding elements while dragging
 * @class Collidable
 * @module Collidable
 * @extends AbstractPlugin
 */
class Collidable extends _AbstractPlugin2.default {
  /**
   * Collidable constructor.
   * @constructs Collidable
   * @param {Draggable} draggable - Draggable instance
   */
  constructor(draggable) {
    super(draggable);

    /**
     * Keeps track of currently colliding elements
     * @property {HTMLElement|null} currentlyCollidingElement
     * @type {HTMLElement|null}
     */
    this.currentlyCollidingElement = null;

    /**
     * Keeps track of currently colliding elements
     * @property {HTMLElement|null} lastCollidingElement
     * @type {HTMLElement|null}
     */
    this.lastCollidingElement = null;

    /**
     * Animation frame for finding colliding elements
     * @property {Number|null} currentAnimationFrame
     * @type {Number|null}
     */
    this.currentAnimationFrame = null;

    this[onDragMove] = this[onDragMove].bind(this);
    this[onDragStop] = this[onDragStop].bind(this);
    this[onRequestAnimationFrame] = this[onRequestAnimationFrame].bind(this);
  }

  /**
   * Attaches plugins event listeners
   */
  attach() {
    this.draggable.on('drag:move', this[onDragMove]).on('drag:stop', this[onDragStop]);
  }

  /**
   * Detaches plugins event listeners
   */
  detach() {
    this.draggable.off('drag:move', this[onDragMove]).off('drag:stop', this[onDragStop]);
  }

  /**
   * Returns current collidables based on `collidables` option
   * @return {HTMLElement[]}
   */
  getCollidables() {
    const collidables = this.draggable.options.collidables;

    if (typeof collidables === 'string') {
      return Array.prototype.slice.call(document.querySelectorAll(collidables));
    } else if (collidables instanceof NodeList || collidables instanceof Array) {
      return Array.prototype.slice.call(collidables);
    } else if (collidables instanceof HTMLElement) {
      return [collidables];
    } else if (typeof collidables === 'function') {
      return collidables();
    } else {
      return [];
    }
  }

  /**
   * Drag move handler
   * @private
   * @param {DragMoveEvent} event - Drag move event
   */
  [onDragMove](event) {
    const target = event.sensorEvent.target;

    this.currentAnimationFrame = requestAnimationFrame(this[onRequestAnimationFrame](target));

    if (this.currentlyCollidingElement) {
      event.cancel();
    }

    const collidableInEvent = new _CollidableEvent.CollidableInEvent({
      dragEvent: event,
      collidingElement: this.currentlyCollidingElement
    });

    const collidableOutEvent = new _CollidableEvent.CollidableOutEvent({
      dragEvent: event,
      collidingElement: this.lastCollidingElement
    });

    const enteringCollidable = Boolean(this.currentlyCollidingElement && this.lastCollidingElement !== this.currentlyCollidingElement);
    const leavingCollidable = Boolean(!this.currentlyCollidingElement && this.lastCollidingElement);

    if (enteringCollidable) {
      if (this.lastCollidingElement) {
        this.draggable.trigger(collidableOutEvent);
      }

      this.draggable.trigger(collidableInEvent);
    } else if (leavingCollidable) {
      this.draggable.trigger(collidableOutEvent);
    }

    this.lastCollidingElement = this.currentlyCollidingElement;
  }

  /**
   * Drag stop handler
   * @private
   * @param {DragStopEvent} event - Drag stop event
   */
  [onDragStop](event) {
    const lastCollidingElement = this.currentlyCollidingElement || this.lastCollidingElement;
    const collidableOutEvent = new _CollidableEvent.CollidableOutEvent({
      dragEvent: event,
      collidingElement: lastCollidingElement
    });

    if (lastCollidingElement) {
      this.draggable.trigger(collidableOutEvent);
    }

    this.lastCollidingElement = null;
    this.currentlyCollidingElement = null;
  }

  /**
   * Animation frame function
   * @private
   * @param {HTMLElement} target - Current move target
   * @return {Function}
   */
  [onRequestAnimationFrame](target) {
    return () => {
      const collidables = this.getCollidables();
      this.currentlyCollidingElement = (0, _utils.closest)(target, element => collidables.includes(element));
    };
  }
}
exports.default = Collidable;

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CollidableOutEvent = exports.CollidableInEvent = exports.CollidableEvent = undefined;

var _AbstractEvent = __webpack_require__(0);

var _AbstractEvent2 = _interopRequireDefault(_AbstractEvent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Base collidable event
 * @class CollidableEvent
 * @module CollidableEvent
 * @extends AbstractEvent
 */
class CollidableEvent extends _AbstractEvent2.default {

  /**
   * Drag event that triggered this colliable event
   * @property dragEvent
   * @type {DragEvent}
   * @readonly
   */
  get dragEvent() {
    return this.data.dragEvent;
  }
}

exports.CollidableEvent = CollidableEvent; /**
                                            * Collidable in event
                                            * @class CollidableInEvent
                                            * @module CollidableInEvent
                                            * @extends CollidableEvent
                                            */

CollidableEvent.type = 'collidable';
class CollidableInEvent extends CollidableEvent {

  /**
   * Element you are currently colliding with
   * @property collidingElement
   * @type {HTMLElement}
   * @readonly
   */
  get collidingElement() {
    return this.data.collidingElement;
  }
}

exports.CollidableInEvent = CollidableInEvent; /**
                                                * Collidable out event
                                                * @class CollidableOutEvent
                                                * @module CollidableOutEvent
                                                * @extends CollidableEvent
                                                */

CollidableInEvent.type = 'collidable:in';
class CollidableOutEvent extends CollidableEvent {

  /**
   * Element you were previously colliding with
   * @property collidingElement
   * @type {HTMLElement}
   * @readonly
   */
  get collidingElement() {
    return this.data.collidingElement;
  }
}
exports.CollidableOutEvent = CollidableOutEvent;
CollidableOutEvent.type = 'collidable:out';

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _CollidableEvent = __webpack_require__(8);

Object.keys(_CollidableEvent).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _CollidableEvent[key];
    }
  });
});

var _Collidable = __webpack_require__(22);

var _Collidable2 = _interopRequireDefault(_Collidable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Collidable2.default;

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Collidable = __webpack_require__(24);

Object.defineProperty(exports, 'Collidable', {
  enumerable: true,
  get: function () {
    return _interopRequireDefault(_Collidable).default;
  }
});

var _ResizeMirror = __webpack_require__(21);

Object.defineProperty(exports, 'ResizeMirror', {
  enumerable: true,
  get: function () {
    return _interopRequireDefault(_ResizeMirror).default;
  }
});
Object.defineProperty(exports, 'defaultResizeMirrorOptions', {
  enumerable: true,
  get: function () {
    return _ResizeMirror.defaultOptions;
  }
});

var _Snappable = __webpack_require__(19);

Object.defineProperty(exports, 'Snappable', {
  enumerable: true,
  get: function () {
    return _interopRequireDefault(_Snappable).default;
  }
});

var _SwapAnimation = __webpack_require__(16);

Object.defineProperty(exports, 'SwapAnimation', {
  enumerable: true,
  get: function () {
    return _interopRequireDefault(_SwapAnimation).default;
  }
});
Object.defineProperty(exports, 'defaultSwapAnimationOptions', {
  enumerable: true,
  get: function () {
    return _SwapAnimation.defaultOptions;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _Draggable = __webpack_require__(5);

var _Draggable2 = _interopRequireDefault(_Draggable);

var _SortableEvent = __webpack_require__(9);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const onDragStart = Symbol('onDragStart');
const onDragOverContainer = Symbol('onDragOverContainer');
const onDragOver = Symbol('onDragOver');
const onDragStop = Symbol('onDragStop');

/**
 * Returns announcement message when a Draggable element has been sorted with another Draggable element
 * or moved into a new container
 * @param {SortableSortedEvent} sortableEvent
 * @return {String}
 */
function onSortableSortedDefaultAnnouncement({ dragEvent }) {
  const sourceText = dragEvent.source.textContent.trim() || dragEvent.source.id || 'sortable element';

  if (dragEvent.over) {
    const overText = dragEvent.over.textContent.trim() || dragEvent.over.id || 'sortable element';
    const isFollowing = dragEvent.source.compareDocumentPosition(dragEvent.over) & Node.DOCUMENT_POSITION_FOLLOWING;

    if (isFollowing) {
      return `Placed ${sourceText} after ${overText}`;
    } else {
      return `Placed ${sourceText} before ${overText}`;
    }
  } else {
    // need to figure out how to compute container name
    return `Placed ${sourceText} into a different container`;
  }
}

/**
 * @const {Object} defaultAnnouncements
 * @const {Function} defaultAnnouncements['sortable:sorted']
 */
const defaultAnnouncements = {
  'sortable:sorted': onSortableSortedDefaultAnnouncement
};

/**
 * Sortable is built on top of Draggable and allows sorting of draggable elements. Sortable will keep
 * track of the original index and emits the new index as you drag over draggable elements.
 * @class Sortable
 * @module Sortable
 * @extends Draggable
 */
class Sortable extends _Draggable2.default {
  /**
   * Sortable constructor.
   * @constructs Sortable
   * @param {HTMLElement[]|NodeList|HTMLElement} containers - Sortable containers
   * @param {Object} options - Options for Sortable
   */
  constructor(containers = [], options = {}) {
    super(containers, _extends({}, options, {
      announcements: _extends({}, defaultAnnouncements, options.announcements || {})
    }));

    /**
     * start index of source on drag start
     * @property startIndex
     * @type {Number}
     */
    this.startIndex = null;

    /**
     * start container on drag start
     * @property startContainer
     * @type {HTMLElement}
     * @default null
     */
    this.startContainer = null;

    this[onDragStart] = this[onDragStart].bind(this);
    this[onDragOverContainer] = this[onDragOverContainer].bind(this);
    this[onDragOver] = this[onDragOver].bind(this);
    this[onDragStop] = this[onDragStop].bind(this);

    this.on('drag:start', this[onDragStart]).on('drag:over:container', this[onDragOverContainer]).on('drag:over', this[onDragOver]).on('drag:stop', this[onDragStop]);
  }

  /**
   * Destroys Sortable instance.
   */
  destroy() {
    super.destroy();

    this.off('drag:start', this[onDragStart]).off('drag:over:container', this[onDragOverContainer]).off('drag:over', this[onDragOver]).off('drag:stop', this[onDragStop]);
  }

  /**
   * Returns true index of element within its container during drag operation, i.e. excluding mirror and original source
   * @param {HTMLElement} element - An element
   * @return {Number}
   */
  index(element) {
    return this.getDraggableElementsForContainer(element.parentNode).indexOf(element);
  }

  /**
   * Drag start handler
   * @private
   * @param {DragStartEvent} event - Drag start event
   */
  [onDragStart](event) {
    this.startContainer = event.source.parentNode;
    this.startIndex = this.index(event.source);

    const sortableStartEvent = new _SortableEvent.SortableStartEvent({
      dragEvent: event,
      startIndex: this.startIndex,
      startContainer: this.startContainer
    });

    this.trigger(sortableStartEvent);

    if (sortableStartEvent.canceled()) {
      event.cancel();
    }
  }

  /**
   * Drag over container handler
   * @private
   * @param {DragOverContainerEvent} event - Drag over container event
   */
  [onDragOverContainer](event) {
    if (event.canceled()) {
      return;
    }

    const { source, over, overContainer } = event;
    const oldIndex = this.index(source);

    const sortableSortEvent = new _SortableEvent.SortableSortEvent({
      dragEvent: event,
      currentIndex: oldIndex,
      source,
      over
    });

    this.trigger(sortableSortEvent);

    if (sortableSortEvent.canceled()) {
      return;
    }

    const children = this.getDraggableElementsForContainer(overContainer);
    const moves = move({ source, over, overContainer, children });

    if (!moves) {
      return;
    }

    const { oldContainer, newContainer } = moves;
    const newIndex = this.index(event.source);

    const sortableSortedEvent = new _SortableEvent.SortableSortedEvent({
      dragEvent: event,
      oldIndex,
      newIndex,
      oldContainer,
      newContainer
    });

    this.trigger(sortableSortedEvent);
  }

  /**
   * Drag over handler
   * @private
   * @param {DragOverEvent} event - Drag over event
   */
  [onDragOver](event) {
    if (event.over === event.originalSource || event.over === event.source) {
      return;
    }

    const { source, over, overContainer } = event;
    const oldIndex = this.index(source);

    const sortableSortEvent = new _SortableEvent.SortableSortEvent({
      dragEvent: event,
      currentIndex: oldIndex,
      source,
      over
    });

    this.trigger(sortableSortEvent);

    if (sortableSortEvent.canceled()) {
      return;
    }

    const children = this.getDraggableElementsForContainer(overContainer);
    const moves = move({ source, over, overContainer, children });

    if (!moves) {
      return;
    }

    const { oldContainer, newContainer } = moves;
    const newIndex = this.index(source);

    const sortableSortedEvent = new _SortableEvent.SortableSortedEvent({
      dragEvent: event,
      oldIndex,
      newIndex,
      oldContainer,
      newContainer
    });

    this.trigger(sortableSortedEvent);
  }

  /**
   * Drag stop handler
   * @private
   * @param {DragStopEvent} event - Drag stop event
   */
  [onDragStop](event) {
    const sortableStopEvent = new _SortableEvent.SortableStopEvent({
      dragEvent: event,
      oldIndex: this.startIndex,
      newIndex: this.index(event.source),
      oldContainer: this.startContainer,
      newContainer: event.source.parentNode
    });

    this.trigger(sortableStopEvent);

    this.startIndex = null;
    this.startContainer = null;
  }
}

exports.default = Sortable;
function index(element) {
  return Array.prototype.indexOf.call(element.parentNode.children, element);
}

function move({ source, over, overContainer, children }) {
  const emptyOverContainer = !children.length;
  const differentContainer = source.parentNode !== overContainer;
  const sameContainer = over && !differentContainer;

  if (emptyOverContainer) {
    return moveInsideEmptyContainer(source, overContainer);
  } else if (sameContainer) {
    return moveWithinContainer(source, over);
  } else if (differentContainer) {
    return moveOutsideContainer(source, over, overContainer);
  } else {
    return null;
  }
}

function moveInsideEmptyContainer(source, overContainer) {
  const oldContainer = source.parentNode;

  overContainer.appendChild(source);

  return { oldContainer, newContainer: overContainer };
}

function moveWithinContainer(source, over) {
  const oldIndex = index(source);
  const newIndex = index(over);

  if (oldIndex < newIndex) {
    source.parentNode.insertBefore(source, over.nextElementSibling);
  } else {
    source.parentNode.insertBefore(source, over);
  }

  return { oldContainer: source.parentNode, newContainer: source.parentNode };
}

function moveOutsideContainer(source, over, overContainer) {
  const oldContainer = source.parentNode;

  if (over) {
    over.parentNode.insertBefore(source, over);
  } else {
    // need to figure out proper position
    overContainer.appendChild(source);
  }

  return { oldContainer, newContainer: source.parentNode };
}

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SortableStopEvent = exports.SortableSortedEvent = exports.SortableSortEvent = exports.SortableStartEvent = exports.SortableEvent = undefined;

var _AbstractEvent = __webpack_require__(0);

var _AbstractEvent2 = _interopRequireDefault(_AbstractEvent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Base sortable event
 * @class SortableEvent
 * @module SortableEvent
 * @extends AbstractEvent
 */
class SortableEvent extends _AbstractEvent2.default {

  /**
   * Original drag event that triggered this sortable event
   * @property dragEvent
   * @type {DragEvent}
   * @readonly
   */
  get dragEvent() {
    return this.data.dragEvent;
  }
}

exports.SortableEvent = SortableEvent; /**
                                        * Sortable start event
                                        * @class SortableStartEvent
                                        * @module SortableStartEvent
                                        * @extends SortableEvent
                                        */

SortableEvent.type = 'sortable';
class SortableStartEvent extends SortableEvent {

  /**
   * Start index of source on sortable start
   * @property startIndex
   * @type {Number}
   * @readonly
   */
  get startIndex() {
    return this.data.startIndex;
  }

  /**
   * Start container on sortable start
   * @property startContainer
   * @type {HTMLElement}
   * @readonly
   */
  get startContainer() {
    return this.data.startContainer;
  }
}

exports.SortableStartEvent = SortableStartEvent; /**
                                                  * Sortable sort event
                                                  * @class SortableSortEvent
                                                  * @module SortableSortEvent
                                                  * @extends SortableEvent
                                                  */

SortableStartEvent.type = 'sortable:start';
SortableStartEvent.cancelable = true;
class SortableSortEvent extends SortableEvent {

  /**
   * Index of current draggable element
   * @property currentIndex
   * @type {Number}
   * @readonly
   */
  get currentIndex() {
    return this.data.currentIndex;
  }

  /**
   * Draggable element you are hovering over
   * @property over
   * @type {HTMLElement}
   * @readonly
   */
  get over() {
    return this.data.oldIndex;
  }

  /**
   * Draggable container element you are hovering over
   * @property overContainer
   * @type {HTMLElement}
   * @readonly
   */
  get overContainer() {
    return this.data.newIndex;
  }
}

exports.SortableSortEvent = SortableSortEvent; /**
                                                * Sortable sorted event
                                                * @class SortableSortedEvent
                                                * @module SortableSortedEvent
                                                * @extends SortableEvent
                                                */

SortableSortEvent.type = 'sortable:sort';
SortableSortEvent.cancelable = true;
class SortableSortedEvent extends SortableEvent {

  /**
   * Index of last sorted event
   * @property oldIndex
   * @type {Number}
   * @readonly
   */
  get oldIndex() {
    return this.data.oldIndex;
  }

  /**
   * New index of this sorted event
   * @property newIndex
   * @type {Number}
   * @readonly
   */
  get newIndex() {
    return this.data.newIndex;
  }

  /**
   * Old container of draggable element
   * @property oldContainer
   * @type {HTMLElement}
   * @readonly
   */
  get oldContainer() {
    return this.data.oldContainer;
  }

  /**
   * New container of draggable element
   * @property newContainer
   * @type {HTMLElement}
   * @readonly
   */
  get newContainer() {
    return this.data.newContainer;
  }
}

exports.SortableSortedEvent = SortableSortedEvent; /**
                                                    * Sortable stop event
                                                    * @class SortableStopEvent
                                                    * @module SortableStopEvent
                                                    * @extends SortableEvent
                                                    */

SortableSortedEvent.type = 'sortable:sorted';
class SortableStopEvent extends SortableEvent {

  /**
   * Original index on sortable start
   * @property oldIndex
   * @type {Number}
   * @readonly
   */
  get oldIndex() {
    return this.data.oldIndex;
  }

  /**
   * New index of draggable element
   * @property newIndex
   * @type {Number}
   * @readonly
   */
  get newIndex() {
    return this.data.newIndex;
  }

  /**
   * Original container of draggable element
   * @property oldContainer
   * @type {HTMLElement}
   * @readonly
   */
  get oldContainer() {
    return this.data.oldContainer;
  }

  /**
   * New container of draggable element
   * @property newContainer
   * @type {HTMLElement}
   * @readonly
   */
  get newContainer() {
    return this.data.newContainer;
  }
}
exports.SortableStopEvent = SortableStopEvent;
SortableStopEvent.type = 'sortable:stop';

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _SortableEvent = __webpack_require__(9);

Object.keys(_SortableEvent).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _SortableEvent[key];
    }
  });
});

var _Sortable = __webpack_require__(26);

var _Sortable2 = _interopRequireDefault(_Sortable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Sortable2.default;

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _Draggable = __webpack_require__(5);

var _Draggable2 = _interopRequireDefault(_Draggable);

var _SwappableEvent = __webpack_require__(10);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const onDragStart = Symbol('onDragStart');
const onDragOver = Symbol('onDragOver');
const onDragStop = Symbol('onDragStop');

/**
 * Returns an announcement message when the Draggable element is swapped with another draggable element
 * @param {SwappableSwappedEvent} swappableEvent
 * @return {String}
 */
function onSwappableSwappedDefaultAnnouncement({ dragEvent, swappedElement }) {
  const sourceText = dragEvent.source.textContent.trim() || dragEvent.source.id || 'swappable element';
  const overText = swappedElement.textContent.trim() || swappedElement.id || 'swappable element';

  return `Swapped ${sourceText} with ${overText}`;
}

/**
 * @const {Object} defaultAnnouncements
 * @const {Function} defaultAnnouncements['swappabled:swapped']
 */
const defaultAnnouncements = {
  'swappabled:swapped': onSwappableSwappedDefaultAnnouncement
};

/**
 * Swappable is built on top of Draggable and allows swapping of draggable elements.
 * Order is irrelevant to Swappable.
 * @class Swappable
 * @module Swappable
 * @extends Draggable
 */
class Swappable extends _Draggable2.default {
  /**
   * Swappable constructor.
   * @constructs Swappable
   * @param {HTMLElement[]|NodeList|HTMLElement} containers - Swappable containers
   * @param {Object} options - Options for Swappable
   */
  constructor(containers = [], options = {}) {
    super(containers, _extends({}, options, {
      announcements: _extends({}, defaultAnnouncements, options.announcements || {})
    }));

    /**
     * Last draggable element that was dragged over
     * @property lastOver
     * @type {HTMLElement}
     */
    this.lastOver = null;

    this[onDragStart] = this[onDragStart].bind(this);
    this[onDragOver] = this[onDragOver].bind(this);
    this[onDragStop] = this[onDragStop].bind(this);

    this.on('drag:start', this[onDragStart]).on('drag:over', this[onDragOver]).on('drag:stop', this[onDragStop]);
  }

  /**
   * Destroys Swappable instance.
   */
  destroy() {
    super.destroy();

    this.off('drag:start', this._onDragStart).off('drag:over', this._onDragOver).off('drag:stop', this._onDragStop);
  }

  /**
   * Drag start handler
   * @private
   * @param {DragStartEvent} event - Drag start event
   */
  [onDragStart](event) {
    const swappableStartEvent = new _SwappableEvent.SwappableStartEvent({
      dragEvent: event
    });

    this.trigger(swappableStartEvent);

    if (swappableStartEvent.canceled()) {
      event.cancel();
    }
  }

  /**
   * Drag over handler
   * @private
   * @param {DragOverEvent} event - Drag over event
   */
  [onDragOver](event) {
    if (event.over === event.originalSource || event.over === event.source || event.canceled()) {
      return;
    }

    const swappableSwapEvent = new _SwappableEvent.SwappableSwapEvent({
      dragEvent: event,
      over: event.over,
      overContainer: event.overContainer
    });

    this.trigger(swappableSwapEvent);

    if (swappableSwapEvent.canceled()) {
      return;
    }

    // swap originally swapped element back
    if (this.lastOver && this.lastOver !== event.over) {
      swap(this.lastOver, event.source);
    }

    if (this.lastOver === event.over) {
      this.lastOver = null;
    } else {
      this.lastOver = event.over;
    }

    swap(event.source, event.over);

    const swappableSwappedEvent = new _SwappableEvent.SwappableSwappedEvent({
      dragEvent: event,
      swappedElement: event.over
    });

    this.trigger(swappableSwappedEvent);
  }

  /**
   * Drag stop handler
   * @private
   * @param {DragStopEvent} event - Drag stop event
   */
  [onDragStop](event) {
    const swappableStopEvent = new _SwappableEvent.SwappableStopEvent({
      dragEvent: event
    });

    this.trigger(swappableStopEvent);
    this.lastOver = null;
  }
}

exports.default = Swappable;
function withTempElement(callback) {
  const tmpElement = document.createElement('div');
  callback(tmpElement);
  tmpElement.parentNode.removeChild(tmpElement);
}

function swap(source, over) {
  const overParent = over.parentNode;
  const sourceParent = source.parentNode;

  withTempElement(tmpElement => {
    sourceParent.insertBefore(tmpElement, source);
    overParent.insertBefore(source, over);
    sourceParent.insertBefore(over, tmpElement);
  });
}

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SwappableStopEvent = exports.SwappableSwappedEvent = exports.SwappableSwapEvent = exports.SwappableStartEvent = exports.SwappableEvent = undefined;

var _AbstractEvent = __webpack_require__(0);

var _AbstractEvent2 = _interopRequireDefault(_AbstractEvent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Base swappable event
 * @class SwappableEvent
 * @module SwappableEvent
 * @extends AbstractEvent
 */
class SwappableEvent extends _AbstractEvent2.default {

  /**
   * Original drag event that triggered this swappable event
   * @property dragEvent
   * @type {DragEvent}
   * @readonly
   */
  get dragEvent() {
    return this.data.dragEvent;
  }
}

exports.SwappableEvent = SwappableEvent; /**
                                          * Swappable start event
                                          * @class SwappableStartEvent
                                          * @module SwappableStartEvent
                                          * @extends SwappableEvent
                                          */

SwappableEvent.type = 'swappable';
class SwappableStartEvent extends SwappableEvent {}

exports.SwappableStartEvent = SwappableStartEvent; /**
                                                    * Swappable swap event
                                                    * @class SwappableSwapEvent
                                                    * @module SwappableSwapEvent
                                                    * @extends SwappableEvent
                                                    */

SwappableStartEvent.type = 'swappable:start';
SwappableStartEvent.cancelable = true;
class SwappableSwapEvent extends SwappableEvent {

  /**
   * Draggable element you are over
   * @property over
   * @type {HTMLElement}
   * @readonly
   */
  get over() {
    return this.data.over;
  }

  /**
   * Draggable container you are over
   * @property overContainer
   * @type {HTMLElement}
   * @readonly
   */
  get overContainer() {
    return this.data.overContainer;
  }
}

exports.SwappableSwapEvent = SwappableSwapEvent; /**
                                                  * Swappable swapped event
                                                  * @class SwappableSwappedEvent
                                                  * @module SwappableSwappedEvent
                                                  * @extends SwappableEvent
                                                  */

SwappableSwapEvent.type = 'swappable:swap';
SwappableSwapEvent.cancelable = true;
class SwappableSwappedEvent extends SwappableEvent {

  /**
   * The draggable element that you swapped with
   * @property swappedElement
   * @type {HTMLElement}
   * @readonly
   */
  get swappedElement() {
    return this.data.swappedElement;
  }
}

exports.SwappableSwappedEvent = SwappableSwappedEvent; /**
                                                        * Swappable stop event
                                                        * @class SwappableStopEvent
                                                        * @module SwappableStopEvent
                                                        * @extends SwappableEvent
                                                        */

SwappableSwappedEvent.type = 'swappable:swapped';
class SwappableStopEvent extends SwappableEvent {}
exports.SwappableStopEvent = SwappableStopEvent;
SwappableStopEvent.type = 'swappable:stop';

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _SwappableEvent = __webpack_require__(10);

Object.keys(_SwappableEvent).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _SwappableEvent[key];
    }
  });
});

var _Swappable = __webpack_require__(29);

var _Swappable2 = _interopRequireDefault(_Swappable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Swappable2.default;

/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _utils = __webpack_require__(2);

var _Draggable = __webpack_require__(5);

var _Draggable2 = _interopRequireDefault(_Draggable);

var _DroppableEvent = __webpack_require__(11);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const onDragStart = Symbol('onDragStart');
const onDragMove = Symbol('onDragMove');
const onDragStop = Symbol('onDragStop');
const dropInDropzone = Symbol('dropInDropZone');
const returnToOriginalDropzone = Symbol('returnToOriginalDropzone');
const closestDropzone = Symbol('closestDropzone');
const getDropzones = Symbol('getDropzones');

/**
 * Returns an announcement message when the Draggable element is dropped into a dropzone element
 * @param {DroppableDroppedEvent} droppableEvent
 * @return {String}
 */
function onDroppableDroppedDefaultAnnouncement({ dragEvent, dropzone }) {
  const sourceText = dragEvent.source.textContent.trim() || dragEvent.source.id || 'draggable element';
  const dropzoneText = dropzone.textContent.trim() || dropzone.id || 'droppable element';

  return `Dropped ${sourceText} into ${dropzoneText}`;
}

/**
 * Returns an announcement message when the Draggable element has returned to its original dropzone element
 * @param {DroppableReturnedEvent} droppableEvent
 * @return {String}
 */
function onDroppableReturnedDefaultAnnouncement({ dragEvent, dropzone }) {
  const sourceText = dragEvent.source.textContent.trim() || dragEvent.source.id || 'draggable element';
  const dropzoneText = dropzone.textContent.trim() || dropzone.id || 'droppable element';

  return `Returned ${sourceText} from ${dropzoneText}`;
}

/**
 * @const {Object} defaultAnnouncements
 * @const {Function} defaultAnnouncements['droppable:dropped']
 * @const {Function} defaultAnnouncements['droppable:returned']
 */
const defaultAnnouncements = {
  'droppable:dropped': onDroppableDroppedDefaultAnnouncement,
  'droppable:returned': onDroppableReturnedDefaultAnnouncement
};

const defaultClasses = {
  'droppable:active': 'draggable-dropzone--active',
  'droppable:occupied': 'draggable-dropzone--occupied'
};

const defaultOptions = {
  dropzone: '.draggable-droppable'
};

/**
 * Droppable is built on top of Draggable and allows dropping draggable elements
 * into dropzone element
 * @class Droppable
 * @module Droppable
 * @extends Draggable
 */
class Droppable extends _Draggable2.default {
  /**
   * Droppable constructor.
   * @constructs Droppable
   * @param {HTMLElement[]|NodeList|HTMLElement} containers - Droppable containers
   * @param {Object} options - Options for Droppable
   */
  constructor(containers = [], options = {}) {
    super(containers, _extends({}, defaultOptions, options, {
      classes: _extends({}, defaultClasses, options.classes || {}),
      announcements: _extends({}, defaultAnnouncements, options.announcements || {})
    }));

    /**
     * All dropzone elements on drag start
     * @property dropzones
     * @type {HTMLElement[]}
     */
    this.dropzones = null;

    /**
     * Last dropzone element that the source was dropped into
     * @property lastDropzone
     * @type {HTMLElement}
     */
    this.lastDropzone = null;

    /**
     * Initial dropzone element that the source was drag from
     * @property initialDropzone
     * @type {HTMLElement}
     */
    this.initialDropzone = null;

    this[onDragStart] = this[onDragStart].bind(this);
    this[onDragMove] = this[onDragMove].bind(this);
    this[onDragStop] = this[onDragStop].bind(this);

    this.on('drag:start', this[onDragStart]).on('drag:move', this[onDragMove]).on('drag:stop', this[onDragStop]);
  }

  /**
   * Destroys Droppable instance.
   */
  destroy() {
    super.destroy();

    this.off('drag:start', this[onDragStart]).off('drag:move', this[onDragMove]).off('drag:stop', this[onDragStop]);
  }

  /**
   * Drag start handler
   * @private
   * @param {DragStartEvent} event - Drag start event
   */
  [onDragStart](event) {
    if (event.canceled()) {
      return;
    }

    this.dropzones = [...this[getDropzones]()];
    const dropzone = (0, _utils.closest)(event.sensorEvent.target, this.options.dropzone);

    if (!dropzone) {
      event.cancel();
      return;
    }

    const droppableStartEvent = new _DroppableEvent.DroppableStartEvent({
      dragEvent: event,
      dropzone
    });

    this.trigger(droppableStartEvent);

    if (droppableStartEvent.canceled()) {
      event.cancel();
      return;
    }

    this.initialDropzone = dropzone;

    for (const dropzoneElement of this.dropzones) {
      if (dropzoneElement.classList.contains(this.getClassNameFor('droppable:occupied'))) {
        continue;
      }

      dropzoneElement.classList.add(this.getClassNameFor('droppable:active'));
    }
  }

  /**
   * Drag move handler
   * @private
   * @param {DragMoveEvent} event - Drag move event
   */
  [onDragMove](event) {
    if (event.canceled()) {
      return;
    }

    const dropzone = this[closestDropzone](event.sensorEvent.target);
    const overEmptyDropzone = dropzone && !dropzone.classList.contains(this.getClassNameFor('droppable:occupied'));

    if (overEmptyDropzone && this[dropInDropzone](event, dropzone)) {
      this.lastDropzone = dropzone;
    } else if ((!dropzone || dropzone === this.initialDropzone) && this.lastDropzone) {
      this[returnToOriginalDropzone](event);
      this.lastDropzone = null;
    }
  }

  /**
   * Drag stop handler
   * @private
   * @param {DragStopEvent} event - Drag stop event
   */
  [onDragStop](event) {
    const droppableStopEvent = new _DroppableEvent.DroppableStopEvent({
      dragEvent: event,
      dropzone: this.lastDropzone || this.initialDropzone
    });

    this.trigger(droppableStopEvent);

    const occupiedClass = this.getClassNameFor('droppable:occupied');

    for (const dropzone of this.dropzones) {
      dropzone.classList.remove(this.getClassNameFor('droppable:active'));
    }

    if (this.lastDropzone && this.lastDropzone !== this.initialDropzone) {
      this.initialDropzone.classList.remove(occupiedClass);
    }

    this.dropzones = null;
    this.lastDropzone = null;
    this.initialDropzone = null;
  }

  /**
   * Drops a draggable element into a dropzone element
   * @private
   * @param {DragMoveEvent} event - Drag move event
   * @param {HTMLElement} dropzone - Dropzone element to drop draggable into
   */
  [dropInDropzone](event, dropzone) {
    const droppableDroppedEvent = new _DroppableEvent.DroppableDroppedEvent({
      dragEvent: event,
      dropzone
    });

    this.trigger(droppableDroppedEvent);

    if (droppableDroppedEvent.canceled()) {
      return false;
    }

    const occupiedClass = this.getClassNameFor('droppable:occupied');

    if (this.lastDropzone) {
      this.lastDropzone.classList.remove(occupiedClass);
    }

    dropzone.appendChild(event.source);
    dropzone.classList.add(occupiedClass);

    return true;
  }

  /**
   * Moves the previously dropped element back into its original dropzone
   * @private
   * @param {DragMoveEvent} event - Drag move event
   */
  [returnToOriginalDropzone](event) {
    const droppableReturnedEvent = new _DroppableEvent.DroppableReturnedEvent({
      dragEvent: event,
      dropzone: this.lastDropzone
    });

    this.trigger(droppableReturnedEvent);

    if (droppableReturnedEvent.canceled()) {
      return;
    }

    this.initialDropzone.appendChild(event.source);
    this.lastDropzone.classList.remove(this.getClassNameFor('droppable:occupied'));
  }

  /**
   * Returns closest dropzone element for even target
   * @private
   * @param {HTMLElement} target - Event target
   * @return {HTMLElement|null}
   */
  [closestDropzone](target) {
    if (!this.dropzones) {
      return null;
    }

    return (0, _utils.closest)(target, this.dropzones);
  }

  /**
   * Returns all current dropzone elements for this draggable instance
   * @private
   * @return {NodeList|HTMLElement[]|Array}
   */
  [getDropzones]() {
    const dropzone = this.options.dropzone;

    if (typeof dropzone === 'string') {
      return document.querySelectorAll(dropzone);
    } else if (dropzone instanceof NodeList || dropzone instanceof Array) {
      return dropzone;
    } else if (typeof dropzone === 'function') {
      return dropzone();
    } else {
      return [];
    }
  }
}
exports.default = Droppable;

/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DroppableStopEvent = exports.DroppableReturnedEvent = exports.DroppableDroppedEvent = exports.DroppableStartEvent = exports.DroppableEvent = undefined;

var _AbstractEvent = __webpack_require__(0);

var _AbstractEvent2 = _interopRequireDefault(_AbstractEvent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Base droppable event
 * @class DroppableEvent
 * @module DroppableEvent
 * @extends AbstractEvent
 */
class DroppableEvent extends _AbstractEvent2.default {

  /**
   * Original drag event that triggered this droppable event
   * @property dragEvent
   * @type {DragEvent}
   * @readonly
   */
  get dragEvent() {
    return this.data.dragEvent;
  }
}

exports.DroppableEvent = DroppableEvent; /**
                                          * Droppable start event
                                          * @class DroppableStartEvent
                                          * @module DroppableStartEvent
                                          * @extends DroppableEvent
                                          */

DroppableEvent.type = 'droppable';
class DroppableStartEvent extends DroppableEvent {

  /**
   * The initial dropzone element of the currently dragging draggable element
   * @property dropzone
   * @type {HTMLElement}
   * @readonly
   */
  get dropzone() {
    return this.data.dropzone;
  }
}

exports.DroppableStartEvent = DroppableStartEvent; /**
                                                    * Droppable dropped event
                                                    * @class DroppableDroppedEvent
                                                    * @module DroppableDroppedEvent
                                                    * @extends DroppableEvent
                                                    */

DroppableStartEvent.type = 'droppable:start';
DroppableStartEvent.cancelable = true;
class DroppableDroppedEvent extends DroppableEvent {

  /**
   * The dropzone element you dropped the draggable element into
   * @property dropzone
   * @type {HTMLElement}
   * @readonly
   */
  get dropzone() {
    return this.data.dropzone;
  }
}

exports.DroppableDroppedEvent = DroppableDroppedEvent; /**
                                                        * Droppable returned event
                                                        * @class DroppableReturnedEvent
                                                        * @module DroppableReturnedEvent
                                                        * @extends DroppableEvent
                                                        */

DroppableDroppedEvent.type = 'droppable:dropped';
DroppableDroppedEvent.cancelable = true;
class DroppableReturnedEvent extends DroppableEvent {

  /**
   * The dropzone element you dragged away from
   * @property dropzone
   * @type {HTMLElement}
   * @readonly
   */
  get dropzone() {
    return this.data.dropzone;
  }
}

exports.DroppableReturnedEvent = DroppableReturnedEvent; /**
                                                          * Droppable stop event
                                                          * @class DroppableStopEvent
                                                          * @module DroppableStopEvent
                                                          * @extends DroppableEvent
                                                          */

DroppableReturnedEvent.type = 'droppable:returned';
DroppableReturnedEvent.cancelable = true;
class DroppableStopEvent extends DroppableEvent {

  /**
   * The final dropzone element of the draggable element
   * @property dropzone
   * @type {HTMLElement}
   * @readonly
   */
  get dropzone() {
    return this.data.dropzone;
  }
}
exports.DroppableStopEvent = DroppableStopEvent;
DroppableStopEvent.type = 'droppable:stop';
DroppableStopEvent.cancelable = true;

/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _DroppableEvent = __webpack_require__(11);

Object.keys(_DroppableEvent).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _DroppableEvent[key];
    }
  });
});

var _Droppable = __webpack_require__(32);

var _Droppable2 = _interopRequireDefault(_Droppable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Droppable2.default;

/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * The Emitter is a simple emitter class that provides you with `on()`, `off()` and `trigger()` methods
 * @class Emitter
 * @module Emitter
 */
class Emitter {
  constructor() {
    this.callbacks = {};
  }

  /**
   * Registers callbacks by event name
   * @param {String} type
   * @param {...Function} callbacks
   */
  on(type, ...callbacks) {
    if (!this.callbacks[type]) {
      this.callbacks[type] = [];
    }

    this.callbacks[type].push(...callbacks);

    return this;
  }

  /**
   * Unregisters callbacks by event name
   * @param {String} type
   * @param {Function} callback
   */
  off(type, callback) {
    if (!this.callbacks[type]) {
      return null;
    }

    const copy = this.callbacks[type].slice(0);

    for (let i = 0; i < copy.length; i++) {
      if (callback === copy[i]) {
        this.callbacks[type].splice(i, 1);
      }
    }

    return this;
  }

  /**
   * Triggers event callbacks by event object
   * @param {AbstractEvent} event
   */
  trigger(event) {
    if (!this.callbacks[event.type]) {
      return null;
    }

    const callbacks = [...this.callbacks[event.type]];
    const caughtErrors = [];

    for (let i = callbacks.length - 1; i >= 0; i--) {
      const callback = callbacks[i];

      try {
        callback(event);
      } catch (error) {
        caughtErrors.push(error);
      }
    }

    if (caughtErrors.length) {
      /* eslint-disable no-console */
      console.error(`Draggable caught errors while triggering '${event.type}'`, caughtErrors);
      /* eslint-disable no-console */
    }

    return this;
  }
}
exports.default = Emitter;

/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Emitter = __webpack_require__(35);

var _Emitter2 = _interopRequireDefault(_Emitter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Emitter2.default;

/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultOptions = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _utils = __webpack_require__(2);

var _Plugins = __webpack_require__(12);

var _Emitter = __webpack_require__(36);

var _Emitter2 = _interopRequireDefault(_Emitter);

var _Sensors = __webpack_require__(6);

var _DraggableEvent = __webpack_require__(13);

var _DragEvent = __webpack_require__(14);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const onDragStart = Symbol('onDragStart');
const onDragMove = Symbol('onDragMove');
const onDragStop = Symbol('onDragStop');
const onDragPressure = Symbol('onDragPressure');

/**
 * @const {Object} defaultAnnouncements
 * @const {Function} defaultAnnouncements['drag:start']
 * @const {Function} defaultAnnouncements['drag:stop']
 */
const defaultAnnouncements = {
  'drag:start': event => `Picked up ${event.source.textContent.trim() || event.source.id || 'draggable element'}`,
  'drag:stop': event => `Released ${event.source.textContent.trim() || event.source.id || 'draggable element'}`
};

const defaultClasses = {
  'container:dragging': 'draggable-container--is-dragging',
  'source:dragging': 'draggable-source--is-dragging',
  'source:placed': 'draggable-source--placed',
  'container:placed': 'draggable-container--placed',
  'body:dragging': 'draggable--is-dragging',
  'draggable:over': 'draggable--over',
  'container:over': 'draggable-container--over',
  'source:original': 'draggable--original',
  mirror: 'draggable-mirror'
};

const defaultOptions = exports.defaultOptions = {
  draggable: '.draggable-source',
  handle: null,
  delay: 100,
  placedTimeout: 800,
  plugins: [],
  sensors: []
};

/**
 * This is the core draggable library that does the heavy lifting
 * @class Draggable
 * @module Draggable
 */
class Draggable {

  /**
   * Draggable constructor.
   * @constructs Draggable
   * @param {HTMLElement[]|NodeList|HTMLElement} containers - Draggable containers
   * @param {Object} options - Options for draggable
   */
  constructor(containers = [document.body], options = {}) {
    /**
     * Draggable containers
     * @property containers
     * @type {HTMLElement[]}
     */
    if (containers instanceof NodeList || containers instanceof Array) {
      this.containers = [...containers];
    } else if (containers instanceof HTMLElement) {
      this.containers = [containers];
    } else {
      throw new Error('Draggable containers are expected to be of type `NodeList`, `HTMLElement[]` or `HTMLElement`');
    }

    this.options = _extends({}, defaultOptions, options, {
      classes: _extends({}, defaultClasses, options.classes || {}),
      announcements: _extends({}, defaultAnnouncements, options.announcements || {})
    });

    /**
     * Draggables event emitter
     * @property emitter
     * @type {Emitter}
     */
    this.emitter = new _Emitter2.default();

    /**
     * Current drag state
     * @property dragging
     * @type {Boolean}
     */
    this.dragging = false;

    /**
     * Active plugins
     * @property plugins
     * @type {Plugin[]}
     */
    this.plugins = [];

    /**
     * Active sensors
     * @property sensors
     * @type {Sensor[]}
     */
    this.sensors = [];

    this[onDragStart] = this[onDragStart].bind(this);
    this[onDragMove] = this[onDragMove].bind(this);
    this[onDragStop] = this[onDragStop].bind(this);
    this[onDragPressure] = this[onDragPressure].bind(this);

    document.addEventListener('drag:start', this[onDragStart], true);
    document.addEventListener('drag:move', this[onDragMove], true);
    document.addEventListener('drag:stop', this[onDragStop], true);
    document.addEventListener('drag:pressure', this[onDragPressure], true);

    const defaultPlugins = Object.values(Draggable.Plugins).map(Plugin => Plugin);
    const defaultSensors = [_Sensors.MouseSensor, _Sensors.TouchSensor];

    this.addPlugin(...[...defaultPlugins, ...this.options.plugins]);
    this.addSensor(...[...defaultSensors, ...this.options.sensors]);

    const draggableInitializedEvent = new _DraggableEvent.DraggableInitializedEvent({
      draggable: this
    });

    this.on('mirror:created', ({ mirror }) => this.mirror = mirror);
    this.on('mirror:destroy', () => this.mirror = null);

    this.trigger(draggableInitializedEvent);
  }

  /**
   * Destroys Draggable instance. This removes all internal event listeners and
   * deactivates sensors and plugins
   */

  /**
   * Default plugins draggable uses
   * @static
   * @property {Object} Plugins
   * @property {Announcement} Plugins.Announcement
   * @property {Focusable} Plugins.Focusable
   * @property {Mirror} Plugins.Mirror
   * @property {Scrollable} Plugins.Scrollable
   * @type {Object}
   */
  destroy() {
    document.removeEventListener('drag:start', this[onDragStart], true);
    document.removeEventListener('drag:move', this[onDragMove], true);
    document.removeEventListener('drag:stop', this[onDragStop], true);
    document.removeEventListener('drag:pressure', this[onDragPressure], true);

    const draggableDestroyEvent = new _DraggableEvent.DraggableDestroyEvent({
      draggable: this
    });

    this.trigger(draggableDestroyEvent);

    this.removePlugin(...this.plugins.map(plugin => plugin.constructor));
    this.removeSensor(...this.sensors.map(sensor => sensor.constructor));
  }

  /**
   * Adds plugin to this draggable instance. This will end up calling the attach method of the plugin
   * @param {...typeof Plugin} plugins - Plugins that you want attached to draggable
   * @return {Draggable}
   * @example draggable.addPlugin(CustomA11yPlugin, CustomMirrorPlugin)
   */
  addPlugin(...plugins) {
    const activePlugins = plugins.map(Plugin => new Plugin(this));

    activePlugins.forEach(plugin => plugin.attach());
    this.plugins = [...this.plugins, ...activePlugins];

    return this;
  }

  /**
   * Removes plugins that are already attached to this draggable instance. This will end up calling
   * the detach method of the plugin
   * @param {...typeof Plugin} plugins - Plugins that you want detached from draggable
   * @return {Draggable}
   * @example draggable.removePlugin(MirrorPlugin, CustomMirrorPlugin)
   */
  removePlugin(...plugins) {
    const removedPlugins = this.plugins.filter(plugin => plugins.includes(plugin.constructor));

    removedPlugins.forEach(plugin => plugin.detach());
    this.plugins = this.plugins.filter(plugin => !plugins.includes(plugin.constructor));

    return this;
  }

  /**
   * Adds sensors to this draggable instance. This will end up calling the attach method of the sensor
   * @param {...typeof Sensor} sensors - Sensors that you want attached to draggable
   * @return {Draggable}
   * @example draggable.addSensor(ForceTouchSensor, CustomSensor)
   */
  addSensor(...sensors) {
    const activeSensors = sensors.map(Sensor => new Sensor(this.containers, this.options));

    activeSensors.forEach(sensor => sensor.attach());
    this.sensors = [...this.sensors, ...activeSensors];

    return this;
  }

  /**
   * Removes sensors that are already attached to this draggable instance. This will end up calling
   * the detach method of the sensor
   * @param {...typeof Sensor} sensors - Sensors that you want attached to draggable
   * @return {Draggable}
   * @example draggable.removeSensor(TouchSensor, DragSensor)
   */
  removeSensor(...sensors) {
    const removedSensors = this.sensors.filter(sensor => sensors.includes(sensor.constructor));

    removedSensors.forEach(sensor => sensor.detach());
    this.sensors = this.sensors.filter(sensor => !sensors.includes(sensor.constructor));

    return this;
  }

  /**
   * Adds container to this draggable instance
   * @param {...HTMLElement} containers - Containers you want to add to draggable
   * @return {Draggable}
   * @example draggable.addContainer(document.body)
   */
  addContainer(...containers) {
    this.containers = [...this.containers, ...containers];
    this.sensors.forEach(sensor => sensor.addContainer(...containers));
    return this;
  }

  /**
   * Removes container from this draggable instance
   * @param {...HTMLElement} containers - Containers you want to remove from draggable
   * @return {Draggable}
   * @example draggable.removeContainer(document.body)
   */
  removeContainer(...containers) {
    this.containers = this.containers.filter(container => !containers.includes(container));
    this.sensors.forEach(sensor => sensor.removeContainer(...containers));
    return this;
  }

  /**
   * Adds listener for draggable events
   * @param {String} type - Event name
   * @param {...Function} callbacks - Event callbacks
   * @return {Draggable}
   * @example draggable.on('drag:start', (dragEvent) => dragEvent.cancel());
   */
  on(type, ...callbacks) {
    this.emitter.on(type, ...callbacks);
    return this;
  }

  /**
   * Removes listener from draggable
   * @param {String} type - Event name
   * @param {Function} callback - Event callback
   * @return {Draggable}
   * @example draggable.off('drag:start', handlerFunction);
   */
  off(type, callback) {
    this.emitter.off(type, callback);
    return this;
  }

  /**
   * Triggers draggable event
   * @param {AbstractEvent} event - Event instance
   * @return {Draggable}
   * @example draggable.trigger(event);
   */
  trigger(event) {
    this.emitter.trigger(event);
    return this;
  }

  /**
   * Returns class name for class identifier
   * @param {String} name - Name of class identifier
   * @return {String|null}
   */
  getClassNameFor(name) {
    return this.options.classes[name];
  }

  /**
   * Returns true if this draggable instance is currently dragging
   * @return {Boolean}
   */
  isDragging() {
    return Boolean(this.dragging);
  }

  /**
   * Returns all draggable elements
   * @return {HTMLElement[]}
   */
  getDraggableElements() {
    return this.containers.reduce((current, container) => {
      return [...current, ...this.getDraggableElementsForContainer(container)];
    }, []);
  }

  /**
   * Returns draggable elements for a given container, excluding the mirror and
   * original source element if present
   * @param {HTMLElement} container
   * @return {HTMLElement[]}
   */
  getDraggableElementsForContainer(container) {
    const allDraggableElements = container.querySelectorAll(this.options.draggable);

    return [...allDraggableElements].filter(childElement => {
      return childElement !== this.originalSource && childElement !== this.mirror;
    });
  }

  /**
   * Drag start handler
   * @private
   * @param {Event} event - DOM Drag event
   */
  [onDragStart](event) {
    const sensorEvent = getSensorEvent(event);
    const { target, container } = sensorEvent;

    if (!this.containers.includes(container)) {
      return;
    }

    if (this.options.handle && target && !(0, _utils.closest)(target, this.options.handle)) {
      sensorEvent.cancel();
      return;
    }

    // Find draggable source element
    this.originalSource = (0, _utils.closest)(target, this.options.draggable);
    this.sourceContainer = container;

    if (!this.originalSource) {
      sensorEvent.cancel();
      return;
    }

    if (this.lastPlacedSource && this.lastPlacedContainer) {
      clearTimeout(this.placedTimeoutID);
      this.lastPlacedSource.classList.remove(this.getClassNameFor('source:placed'));
      this.lastPlacedContainer.classList.remove(this.getClassNameFor('container:placed'));
    }

    this.source = this.originalSource.cloneNode(true);
    this.originalSource.parentNode.insertBefore(this.source, this.originalSource);
    this.originalSource.style.display = 'none';

    const dragEvent = new _DragEvent.DragStartEvent({
      source: this.source,
      originalSource: this.originalSource,
      sourceContainer: container,
      sensorEvent
    });

    this.trigger(dragEvent);

    this.dragging = !dragEvent.canceled();

    if (dragEvent.canceled()) {
      this.source.parentNode.removeChild(this.source);
      this.originalSource.style.display = null;
      return;
    }

    this.originalSource.classList.add(this.getClassNameFor('source:original'));
    this.source.classList.add(this.getClassNameFor('source:dragging'));
    this.sourceContainer.classList.add(this.getClassNameFor('container:dragging'));
    document.body.classList.add(this.getClassNameFor('body:dragging'));
    applyUserSelect(document.body, 'none');

    requestAnimationFrame(() => {
      const oldSensorEvent = getSensorEvent(event);
      const newSensorEvent = oldSensorEvent.clone({ target: this.source });

      this[onDragMove](_extends({}, event, {
        detail: newSensorEvent
      }));
    });
  }

  /**
   * Drag move handler
   * @private
   * @param {Event} event - DOM Drag event
   */
  [onDragMove](event) {
    if (!this.dragging) {
      return;
    }

    const sensorEvent = getSensorEvent(event);
    const { container } = sensorEvent;
    let target = sensorEvent.target;

    const dragMoveEvent = new _DragEvent.DragMoveEvent({
      source: this.source,
      originalSource: this.originalSource,
      sourceContainer: container,
      sensorEvent
    });

    this.trigger(dragMoveEvent);

    if (dragMoveEvent.canceled()) {
      sensorEvent.cancel();
    }

    target = (0, _utils.closest)(target, this.options.draggable);
    const withinCorrectContainer = (0, _utils.closest)(sensorEvent.target, this.containers);
    const overContainer = sensorEvent.overContainer || withinCorrectContainer;
    const isLeavingContainer = this.currentOverContainer && overContainer !== this.currentOverContainer;
    const isLeavingDraggable = this.currentOver && target !== this.currentOver;
    const isOverContainer = overContainer && this.currentOverContainer !== overContainer;
    const isOverDraggable = withinCorrectContainer && target && this.currentOver !== target;

    if (isLeavingDraggable) {
      const dragOutEvent = new _DragEvent.DragOutEvent({
        source: this.source,
        originalSource: this.originalSource,
        sourceContainer: container,
        sensorEvent,
        over: this.currentOver
      });

      this.currentOver.classList.remove(this.getClassNameFor('draggable:over'));
      this.currentOver = null;

      this.trigger(dragOutEvent);
    }

    if (isLeavingContainer) {
      const dragOutContainerEvent = new _DragEvent.DragOutContainerEvent({
        source: this.source,
        originalSource: this.originalSource,
        sourceContainer: container,
        sensorEvent,
        overContainer: this.currentOverContainer
      });

      this.currentOverContainer.classList.remove(this.getClassNameFor('container:over'));
      this.currentOverContainer = null;

      this.trigger(dragOutContainerEvent);
    }

    if (isOverContainer) {
      overContainer.classList.add(this.getClassNameFor('container:over'));

      const dragOverContainerEvent = new _DragEvent.DragOverContainerEvent({
        source: this.source,
        originalSource: this.originalSource,
        sourceContainer: container,
        sensorEvent,
        overContainer
      });

      this.currentOverContainer = overContainer;

      this.trigger(dragOverContainerEvent);
    }

    if (isOverDraggable) {
      target.classList.add(this.getClassNameFor('draggable:over'));

      const dragOverEvent = new _DragEvent.DragOverEvent({
        source: this.source,
        originalSource: this.originalSource,
        sourceContainer: container,
        sensorEvent,
        overContainer,
        over: target
      });

      this.currentOver = target;

      this.trigger(dragOverEvent);
    }
  }

  /**
   * Drag stop handler
   * @private
   * @param {Event} event - DOM Drag event
   */
  [onDragStop](event) {
    if (!this.dragging) {
      return;
    }

    this.dragging = false;

    const dragStopEvent = new _DragEvent.DragStopEvent({
      source: this.source,
      originalSource: this.originalSource,
      sensorEvent: event.sensorEvent,
      sourceContainer: this.sourceContainer
    });

    this.trigger(dragStopEvent);

    this.source.parentNode.insertBefore(this.originalSource, this.source);
    this.source.parentNode.removeChild(this.source);
    this.originalSource.style.display = '';

    this.source.classList.remove(this.getClassNameFor('source:dragging'));
    this.originalSource.classList.remove(this.getClassNameFor('source:original'));
    this.originalSource.classList.add(this.getClassNameFor('source:placed'));
    this.sourceContainer.classList.add(this.getClassNameFor('container:placed'));
    this.sourceContainer.classList.remove(this.getClassNameFor('container:dragging'));
    document.body.classList.remove(this.getClassNameFor('body:dragging'));
    applyUserSelect(document.body, '');

    if (this.currentOver) {
      this.currentOver.classList.remove(this.getClassNameFor('draggable:over'));
    }

    if (this.currentOverContainer) {
      this.currentOverContainer.classList.remove(this.getClassNameFor('container:over'));
    }

    this.lastPlacedSource = this.originalSource;
    this.lastPlacedContainer = this.sourceContainer;

    this.placedTimeoutID = setTimeout(() => {
      if (this.lastPlacedSource) {
        this.lastPlacedSource.classList.remove(this.getClassNameFor('source:placed'));
      }

      if (this.lastPlacedContainer) {
        this.lastPlacedContainer.classList.remove(this.getClassNameFor('container:placed'));
      }

      this.lastPlacedSource = null;
      this.lastPlacedContainer = null;
    }, this.options.placedTimeout);

    this.source = null;
    this.originalSource = null;
    this.currentOverContainer = null;
    this.currentOver = null;
    this.sourceContainer = null;
  }

  /**
   * Drag pressure handler
   * @private
   * @param {Event} event - DOM Drag event
   */
  [onDragPressure](event) {
    if (!this.dragging) {
      return;
    }

    const sensorEvent = getSensorEvent(event);
    const source = this.source || (0, _utils.closest)(sensorEvent.originalEvent.target, this.options.draggable);

    const dragPressureEvent = new _DragEvent.DragPressureEvent({
      sensorEvent,
      source,
      pressure: sensorEvent.pressure
    });

    this.trigger(dragPressureEvent);
  }
}

exports.default = Draggable;
Draggable.Plugins = { Announcement: _Plugins.Announcement, Focusable: _Plugins.Focusable, Mirror: _Plugins.Mirror, Scrollable: _Plugins.Scrollable };
function getSensorEvent(event) {
  return event.detail;
}

function applyUserSelect(element, value) {
  element.style.webkitUserSelect = value;
  element.style.mozUserSelect = value;
  element.style.msUserSelect = value;
  element.style.oUserSelect = value;
  element.style.userSelect = value;
}

/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Sensor = __webpack_require__(4);

var _Sensor2 = _interopRequireDefault(_Sensor);

var _SensorEvent = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const onMouseForceWillBegin = Symbol('onMouseForceWillBegin');
const onMouseForceDown = Symbol('onMouseForceDown');
const onMouseDown = Symbol('onMouseDown');
const onMouseForceChange = Symbol('onMouseForceChange');
const onMouseMove = Symbol('onMouseMove');
const onMouseUp = Symbol('onMouseUp');
const onMouseForceGlobalChange = Symbol('onMouseForceGlobalChange');

/**
 * This sensor picks up native force touch events and dictates drag operations
 * @class ForceTouchSensor
 * @module ForceTouchSensor
 * @extends Sensor
 */
class ForceTouchSensor extends _Sensor2.default {
  /**
   * ForceTouchSensor constructor.
   * @constructs ForceTouchSensor
   * @param {HTMLElement[]|NodeList|HTMLElement} containers - Containers
   * @param {Object} options - Options
   */
  constructor(containers = [], options = {}) {
    super(containers, options);

    /**
     * Draggable element needs to be remembered to unset the draggable attribute after drag operation has completed
     * @property mightDrag
     * @type {Boolean}
     */
    this.mightDrag = false;

    this[onMouseForceWillBegin] = this[onMouseForceWillBegin].bind(this);
    this[onMouseForceDown] = this[onMouseForceDown].bind(this);
    this[onMouseDown] = this[onMouseDown].bind(this);
    this[onMouseForceChange] = this[onMouseForceChange].bind(this);
    this[onMouseMove] = this[onMouseMove].bind(this);
    this[onMouseUp] = this[onMouseUp].bind(this);
  }

  /**
   * Attaches sensors event listeners to the DOM
   */
  attach() {
    for (const container of this.containers) {
      container.addEventListener('webkitmouseforcewillbegin', this[onMouseForceWillBegin], false);
      container.addEventListener('webkitmouseforcedown', this[onMouseForceDown], false);
      container.addEventListener('mousedown', this[onMouseDown], true);
      container.addEventListener('webkitmouseforcechanged', this[onMouseForceChange], false);
    }

    document.addEventListener('mousemove', this[onMouseMove]);
    document.addEventListener('mouseup', this[onMouseUp]);
  }

  /**
   * Detaches sensors event listeners to the DOM
   */
  detach() {
    for (const container of this.containers) {
      container.removeEventListener('webkitmouseforcewillbegin', this[onMouseForceWillBegin], false);
      container.removeEventListener('webkitmouseforcedown', this[onMouseForceDown], false);
      container.removeEventListener('mousedown', this[onMouseDown], true);
      container.removeEventListener('webkitmouseforcechanged', this[onMouseForceChange], false);
    }

    document.removeEventListener('mousemove', this[onMouseMove]);
    document.removeEventListener('mouseup', this[onMouseUp]);
  }

  /**
   * Mouse force will begin handler
   * @private
   * @param {Event} event - Mouse force will begin event
   */
  [onMouseForceWillBegin](event) {
    event.preventDefault();
    this.mightDrag = true;
  }

  /**
   * Mouse force down handler
   * @private
   * @param {Event} event - Mouse force down event
   */
  [onMouseForceDown](event) {
    if (this.dragging) {
      return;
    }

    const target = document.elementFromPoint(event.clientX, event.clientY);
    const container = event.currentTarget;

    const dragStartEvent = new _SensorEvent.DragStartSensorEvent({
      clientX: event.clientX,
      clientY: event.clientY,
      target,
      container,
      originalEvent: event
    });

    this.trigger(container, dragStartEvent);

    this.currentContainer = container;
    this.dragging = !dragStartEvent.canceled();
    this.mightDrag = false;
  }

  /**
   * Mouse up handler
   * @private
   * @param {Event} event - Mouse up event
   */
  [onMouseUp](event) {
    if (!this.dragging) {
      return;
    }

    const dragStopEvent = new _SensorEvent.DragStopSensorEvent({
      clientX: event.clientX,
      clientY: event.clientY,
      target: null,
      container: this.currentContainer,
      originalEvent: event
    });

    this.trigger(this.currentContainer, dragStopEvent);

    this.currentContainer = null;
    this.dragging = false;
    this.mightDrag = false;
  }

  /**
   * Mouse down handler
   * @private
   * @param {Event} event - Mouse down event
   */
  [onMouseDown](event) {
    if (!this.mightDrag) {
      return;
    }

    // Need workaround for real click
    // Cancel potential drag events
    event.stopPropagation();
    event.stopImmediatePropagation();
    event.preventDefault();
  }

  /**
   * Mouse move handler
   * @private
   * @param {Event} event - Mouse force will begin event
   */
  [onMouseMove](event) {
    if (!this.dragging) {
      return;
    }

    const target = document.elementFromPoint(event.clientX, event.clientY);

    const dragMoveEvent = new _SensorEvent.DragMoveSensorEvent({
      clientX: event.clientX,
      clientY: event.clientY,
      target,
      container: this.currentContainer,
      originalEvent: event
    });

    this.trigger(this.currentContainer, dragMoveEvent);
  }

  /**
   * Mouse force change handler
   * @private
   * @param {Event} event - Mouse force change event
   */
  [onMouseForceChange](event) {
    if (this.dragging) {
      return;
    }

    const target = event.target;
    const container = event.currentTarget;

    const dragPressureEvent = new _SensorEvent.DragPressureSensorEvent({
      pressure: event.webkitForce,
      clientX: event.clientX,
      clientY: event.clientY,
      target,
      container,
      originalEvent: event
    });

    this.trigger(container, dragPressureEvent);
  }

  /**
   * Mouse force global change handler
   * @private
   * @param {Event} event - Mouse force global change event
   */
  [onMouseForceGlobalChange](event) {
    if (!this.dragging) {
      return;
    }

    const target = event.target;

    const dragPressureEvent = new _SensorEvent.DragPressureSensorEvent({
      pressure: event.webkitForce,
      clientX: event.clientX,
      clientY: event.clientY,
      target,
      container: this.currentContainer,
      originalEvent: event
    });

    this.trigger(this.currentContainer, dragPressureEvent);
  }
}
exports.default = ForceTouchSensor;

/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ForceTouchSensor = __webpack_require__(38);

var _ForceTouchSensor2 = _interopRequireDefault(_ForceTouchSensor);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _ForceTouchSensor2.default;

/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _utils = __webpack_require__(2);

var _Sensor = __webpack_require__(4);

var _Sensor2 = _interopRequireDefault(_Sensor);

var _SensorEvent = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const onMouseDown = Symbol('onMouseDown');
const onMouseUp = Symbol('onMouseUp');
const onDragStart = Symbol('onDragStart');
const onDragOver = Symbol('onDragOver');
const onDragEnd = Symbol('onDragEnd');
const onDrop = Symbol('onDrop');
const reset = Symbol('reset');

/**
 * This sensor picks up native browser drag events and dictates drag operations
 * @class DragSensor
 * @module DragSensor
 * @extends Sensor
 */
class DragSensor extends _Sensor2.default {
  /**
   * DragSensor constructor.
   * @constructs DragSensor
   * @param {HTMLElement[]|NodeList|HTMLElement} containers - Containers
   * @param {Object} options - Options
   */
  constructor(containers = [], options = {}) {
    super(containers, options);

    /**
     * Mouse down timer which will end up setting the draggable attribute, unless canceled
     * @property mouseDownTimeout
     * @type {Number}
     */
    this.mouseDownTimeout = null;

    /**
     * Draggable element needs to be remembered to unset the draggable attribute after drag operation has completed
     * @property draggableElement
     * @type {HTMLElement}
     */
    this.draggableElement = null;

    /**
     * Native draggable element could be links or images, their draggable state will be disabled during drag operation
     * @property nativeDraggableElement
     * @type {HTMLElement}
     */
    this.nativeDraggableElement = null;

    this[onMouseDown] = this[onMouseDown].bind(this);
    this[onMouseUp] = this[onMouseUp].bind(this);
    this[onDragStart] = this[onDragStart].bind(this);
    this[onDragOver] = this[onDragOver].bind(this);
    this[onDragEnd] = this[onDragEnd].bind(this);
    this[onDrop] = this[onDrop].bind(this);
  }

  /**
   * Attaches sensors event listeners to the DOM
   */
  attach() {
    document.addEventListener('mousedown', this[onMouseDown], true);
  }

  /**
   * Detaches sensors event listeners to the DOM
   */
  detach() {
    document.removeEventListener('mousedown', this[onMouseDown], true);
  }

  /**
   * Drag start handler
   * @private
   * @param {Event} event - Drag start event
   */
  [onDragStart](event) {
    // Need for firefox. "text" key is needed for IE
    event.dataTransfer.setData('text', '');
    event.dataTransfer.effectAllowed = this.options.type;

    const target = document.elementFromPoint(event.clientX, event.clientY);
    this.currentContainer = (0, _utils.closest)(event.target, this.containers);

    if (!this.currentContainer) {
      return;
    }

    const dragStartEvent = new _SensorEvent.DragStartSensorEvent({
      clientX: event.clientX,
      clientY: event.clientY,
      target,
      container: this.currentContainer,
      originalEvent: event
    });

    // Workaround
    setTimeout(() => {
      this.trigger(this.currentContainer, dragStartEvent);

      if (dragStartEvent.canceled()) {
        this.dragging = false;
      } else {
        this.dragging = true;
      }
    }, 0);
  }

  /**
   * Drag over handler
   * @private
   * @param {Event} event - Drag over event
   */
  [onDragOver](event) {
    if (!this.dragging) {
      return;
    }

    const target = document.elementFromPoint(event.clientX, event.clientY);
    const container = this.currentContainer;

    const dragMoveEvent = new _SensorEvent.DragMoveSensorEvent({
      clientX: event.clientX,
      clientY: event.clientY,
      target,
      container,
      originalEvent: event
    });

    this.trigger(container, dragMoveEvent);

    if (!dragMoveEvent.canceled()) {
      event.preventDefault();
      event.dataTransfer.dropEffect = this.options.type;
    }
  }

  /**
   * Drag end handler
   * @private
   * @param {Event} event - Drag end event
   */
  [onDragEnd](event) {
    if (!this.dragging) {
      return;
    }

    document.removeEventListener('mouseup', this[onMouseUp], true);

    const target = document.elementFromPoint(event.clientX, event.clientY);
    const container = this.currentContainer;

    const dragStopEvent = new _SensorEvent.DragStopSensorEvent({
      clientX: event.clientX,
      clientY: event.clientY,
      target,
      container,
      originalEvent: event
    });

    this.trigger(container, dragStopEvent);

    this.dragging = false;

    this[reset]();
  }

  /**
   * Drop handler
   * @private
   * @param {Event} event - Drop event
   */
  [onDrop](event) {
    // eslint-disable-line class-methods-use-this
    event.preventDefault();
  }

  /**
   * Mouse down handler
   * @private
   * @param {Event} event - Mouse down event
   */
  [onMouseDown](event) {
    // Firefox bug for inputs within draggables https://bugzilla.mozilla.org/show_bug.cgi?id=739071
    if (event.target && (event.target.form || event.target.contenteditable)) {
      return;
    }

    const nativeDraggableElement = (0, _utils.closest)(event.target, element => element.draggable);

    if (nativeDraggableElement) {
      nativeDraggableElement.draggable = false;
      this.nativeDraggableElement = nativeDraggableElement;
    }

    document.addEventListener('mouseup', this[onMouseUp], true);
    document.addEventListener('dragstart', this[onDragStart], false);
    document.addEventListener('dragover', this[onDragOver], false);
    document.addEventListener('dragend', this[onDragEnd], false);
    document.addEventListener('drop', this[onDrop], false);

    const target = (0, _utils.closest)(event.target, this.options.draggable);

    if (!target) {
      return;
    }

    this.mouseDownTimeout = setTimeout(() => {
      target.draggable = true;
      this.draggableElement = target;
    }, this.options.delay);
  }

  /**
   * Mouse up handler
   * @private
   * @param {Event} event - Mouse up event
   */
  [onMouseUp]() {
    this[reset]();
  }

  /**
   * Mouse up handler
   * @private
   * @param {Event} event - Mouse up event
   */
  [reset]() {
    clearTimeout(this.mouseDownTimeout);

    document.removeEventListener('mouseup', this[onMouseUp], true);
    document.removeEventListener('dragstart', this[onDragStart], false);
    document.removeEventListener('dragover', this[onDragOver], false);
    document.removeEventListener('dragend', this[onDragEnd], false);
    document.removeEventListener('drop', this[onDrop], false);

    if (this.nativeDraggableElement) {
      this.nativeDraggableElement.draggable = true;
      this.nativeDraggableElement = null;
    }

    if (this.draggableElement) {
      this.draggableElement.draggable = false;
      this.draggableElement = null;
    }
  }
}
exports.default = DragSensor;

/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _DragSensor = __webpack_require__(40);

var _DragSensor2 = _interopRequireDefault(_DragSensor);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _DragSensor2.default;

/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _utils = __webpack_require__(2);

var _Sensor = __webpack_require__(4);

var _Sensor2 = _interopRequireDefault(_Sensor);

var _SensorEvent = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const onTouchStart = Symbol('onTouchStart');
const onTouchHold = Symbol('onTouchHold');
const onTouchEnd = Symbol('onTouchEnd');
const onTouchMove = Symbol('onTouchMove');

/**
 * Prevents scrolling when set to true
 * @var {Boolean} preventScrolling
 */
let preventScrolling = false;

// WebKit requires cancelable `touchmove` events to be added as early as possible
window.addEventListener('touchmove', event => {
  if (!preventScrolling) {
    return;
  }

  // Prevent scrolling
  event.preventDefault();
}, { passive: false });

/**
 * This sensor picks up native browser touch events and dictates drag operations
 * @class TouchSensor
 * @module TouchSensor
 * @extends Sensor
 */
class TouchSensor extends _Sensor2.default {
  /**
   * TouchSensor constructor.
   * @constructs TouchSensor
   * @param {HTMLElement[]|NodeList|HTMLElement} containers - Containers
   * @param {Object} options - Options
   */
  constructor(containers = [], options = {}) {
    super(containers, options);

    /**
     * Closest scrollable container so accidental scroll can cancel long touch
     * @property currentScrollableParent
     * @type {HTMLElement}
     */
    this.currentScrollableParent = null;

    /**
     * TimeoutID for long touch
     * @property tapTimeout
     * @type {Number}
     */
    this.tapTimeout = null;

    /**
     * touchMoved indicates if touch has moved during tapTimeout
     * @property touchMoved
     * @type {Boolean}
     */
    this.touchMoved = false;

    this[onTouchStart] = this[onTouchStart].bind(this);
    this[onTouchHold] = this[onTouchHold].bind(this);
    this[onTouchEnd] = this[onTouchEnd].bind(this);
    this[onTouchMove] = this[onTouchMove].bind(this);
  }

  /**
   * Attaches sensors event listeners to the DOM
   */
  attach() {
    document.addEventListener('touchstart', this[onTouchStart]);
  }

  /**
   * Detaches sensors event listeners to the DOM
   */
  detach() {
    document.removeEventListener('touchstart', this[onTouchStart]);
  }

  /**
   * Touch start handler
   * @private
   * @param {Event} event - Touch start event
   */
  [onTouchStart](event) {
    const container = (0, _utils.closest)(event.target, this.containers);

    if (!container) {
      return;
    }

    document.addEventListener('touchmove', this[onTouchMove]);
    document.addEventListener('touchend', this[onTouchEnd]);
    document.addEventListener('touchcancel', this[onTouchEnd]);
    container.addEventListener('contextmenu', onContextMenu);

    this.currentContainer = container;
    this.tapTimeout = setTimeout(this[onTouchHold](event, container), this.options.delay);
  }

  /**
   * Touch hold handler
   * @private
   * @param {Event} event - Touch start event
   * @param {HTMLElement} container - Container element
   */
  [onTouchHold](event, container) {
    return () => {
      if (this.touchMoved) {
        return;
      }

      const touch = event.touches[0] || event.changedTouches[0];
      const target = event.target;

      const dragStartEvent = new _SensorEvent.DragStartSensorEvent({
        clientX: touch.pageX,
        clientY: touch.pageY,
        target,
        container,
        originalEvent: event
      });

      this.trigger(container, dragStartEvent);

      this.dragging = !dragStartEvent.canceled();
      preventScrolling = this.dragging;
    };
  }

  /**
   * Touch move handler
   * @private
   * @param {Event} event - Touch move event
   */
  [onTouchMove](event) {
    this.touchMoved = true;

    if (!this.dragging) {
      return;
    }

    const touch = event.touches[0] || event.changedTouches[0];
    const target = document.elementFromPoint(touch.pageX - window.scrollX, touch.pageY - window.scrollY);

    const dragMoveEvent = new _SensorEvent.DragMoveSensorEvent({
      clientX: touch.pageX,
      clientY: touch.pageY,
      target,
      container: this.currentContainer,
      originalEvent: event
    });

    this.trigger(this.currentContainer, dragMoveEvent);
  }

  /**
   * Touch end handler
   * @private
   * @param {Event} event - Touch end event
   */
  [onTouchEnd](event) {
    this.touchMoved = false;
    preventScrolling = false;

    document.removeEventListener('touchend', this[onTouchEnd]);
    document.removeEventListener('touchcancel', this[onTouchEnd]);
    document.removeEventListener('touchmove', this[onTouchMove]);

    if (this.currentContainer) {
      this.currentContainer.removeEventListener('contextmenu', onContextMenu);
    }

    clearTimeout(this.tapTimeout);

    if (!this.dragging) {
      return;
    }

    const touch = event.touches[0] || event.changedTouches[0];
    const target = document.elementFromPoint(touch.pageX - window.scrollX, touch.pageY - window.scrollY);

    event.preventDefault();

    const dragStopEvent = new _SensorEvent.DragStopSensorEvent({
      clientX: touch.pageX,
      clientY: touch.pageY,
      target,
      container: this.currentContainer,
      originalEvent: event
    });

    this.trigger(this.currentContainer, dragStopEvent);

    this.currentContainer = null;
    this.dragging = false;
  }
}

exports.default = TouchSensor;
function onContextMenu(event) {
  event.preventDefault();
  event.stopPropagation();
}

/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _TouchSensor = __webpack_require__(42);

var _TouchSensor2 = _interopRequireDefault(_TouchSensor);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _TouchSensor2.default;

/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DragPressureSensorEvent = exports.DragStopSensorEvent = exports.DragMoveSensorEvent = exports.DragStartSensorEvent = exports.SensorEvent = undefined;

var _AbstractEvent = __webpack_require__(0);

var _AbstractEvent2 = _interopRequireDefault(_AbstractEvent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Base sensor event
 * @class SensorEvent
 * @module SensorEvent
 * @extends AbstractEvent
 */
class SensorEvent extends _AbstractEvent2.default {
  /**
   * Original browser event that triggered a sensor
   * @property originalEvent
   * @type {Event}
   * @readonly
   */
  get originalEvent() {
    return this.data.originalEvent;
  }

  /**
   * Normalized clientX for both touch and mouse events
   * @property clientX
   * @type {Number}
   * @readonly
   */
  get clientX() {
    return this.data.clientX;
  }

  /**
   * Normalized clientY for both touch and mouse events
   * @property clientY
   * @type {Number}
   * @readonly
   */
  get clientY() {
    return this.data.clientY;
  }

  /**
   * Normalized target for both touch and mouse events
   * Returns the element that is behind cursor or touch pointer
   * @property target
   * @type {HTMLElement}
   * @readonly
   */
  get target() {
    return this.data.target;
  }

  /**
   * Container that initiated the sensor
   * @property container
   * @type {HTMLElement}
   * @readonly
   */
  get container() {
    return this.data.container;
  }

  /**
   * Trackpad pressure
   * @property pressure
   * @type {Number}
   * @readonly
   */
  get pressure() {
    return this.data.pressure;
  }
}

exports.SensorEvent = SensorEvent; /**
                                    * Drag start sensor event
                                    * @class DragStartSensorEvent
                                    * @module DragStartSensorEvent
                                    * @extends SensorEvent
                                    */

class DragStartSensorEvent extends SensorEvent {}

exports.DragStartSensorEvent = DragStartSensorEvent; /**
                                                      * Drag move sensor event
                                                      * @class DragMoveSensorEvent
                                                      * @module DragMoveSensorEvent
                                                      * @extends SensorEvent
                                                      */

DragStartSensorEvent.type = 'drag:start';
class DragMoveSensorEvent extends SensorEvent {}

exports.DragMoveSensorEvent = DragMoveSensorEvent; /**
                                                    * Drag stop sensor event
                                                    * @class DragStopSensorEvent
                                                    * @module DragStopSensorEvent
                                                    * @extends SensorEvent
                                                    */

DragMoveSensorEvent.type = 'drag:move';
class DragStopSensorEvent extends SensorEvent {}

exports.DragStopSensorEvent = DragStopSensorEvent; /**
                                                    * Drag pressure sensor event
                                                    * @class DragPressureSensorEvent
                                                    * @module DragPressureSensorEvent
                                                    * @extends SensorEvent
                                                    */

DragStopSensorEvent.type = 'drag:stop';
class DragPressureSensorEvent extends SensorEvent {}
exports.DragPressureSensorEvent = DragPressureSensorEvent;
DragPressureSensorEvent.type = 'drag:pressure';

/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _utils = __webpack_require__(2);

var _Sensor = __webpack_require__(4);

var _Sensor2 = _interopRequireDefault(_Sensor);

var _SensorEvent = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const onContextMenuWhileDragging = Symbol('onContextMenuWhileDragging');
const onMouseDown = Symbol('onMouseDown');
const onMouseMove = Symbol('onMouseMove');
const onMouseUp = Symbol('onMouseUp');

/**
 * This sensor picks up native browser mouse events and dictates drag operations
 * @class MouseSensor
 * @module MouseSensor
 * @extends Sensor
 */
class MouseSensor extends _Sensor2.default {
  /**
   * MouseSensor constructor.
   * @constructs MouseSensor
   * @param {HTMLElement[]|NodeList|HTMLElement} containers - Containers
   * @param {Object} options - Options
   */
  constructor(containers = [], options = {}) {
    super(containers, options);

    /**
     * Indicates if mouse button is still down
     * @property mouseDown
     * @type {Boolean}
     */
    this.mouseDown = false;

    /**
     * Mouse down timer which will end up triggering the drag start operation
     * @property mouseDownTimeout
     * @type {Number}
     */
    this.mouseDownTimeout = null;

    /**
     * Indicates if context menu has been opened during drag operation
     * @property openedContextMenu
     * @type {Boolean}
     */
    this.openedContextMenu = false;

    this[onContextMenuWhileDragging] = this[onContextMenuWhileDragging].bind(this);
    this[onMouseDown] = this[onMouseDown].bind(this);
    this[onMouseMove] = this[onMouseMove].bind(this);
    this[onMouseUp] = this[onMouseUp].bind(this);
  }

  /**
   * Attaches sensors event listeners to the DOM
   */
  attach() {
    document.addEventListener('mousedown', this[onMouseDown], true);
  }

  /**
   * Detaches sensors event listeners to the DOM
   */
  detach() {
    document.removeEventListener('mousedown', this[onMouseDown], true);
  }

  /**
   * Mouse down handler
   * @private
   * @param {Event} event - Mouse down event
   */
  [onMouseDown](event) {
    if (event.button !== 0 || event.ctrlKey || event.metaKey) {
      return;
    }

    document.addEventListener('mouseup', this[onMouseUp]);

    const target = document.elementFromPoint(event.clientX, event.clientY);
    const container = (0, _utils.closest)(target, this.containers);

    if (!container) {
      return;
    }

    document.addEventListener('dragstart', preventNativeDragStart);

    this.mouseDown = true;

    clearTimeout(this.mouseDownTimeout);
    this.mouseDownTimeout = setTimeout(() => {
      if (!this.mouseDown) {
        return;
      }

      const dragStartEvent = new _SensorEvent.DragStartSensorEvent({
        clientX: event.clientX,
        clientY: event.clientY,
        target,
        container,
        originalEvent: event
      });

      this.trigger(container, dragStartEvent);

      this.currentContainer = container;
      this.dragging = !dragStartEvent.canceled();

      if (this.dragging) {
        document.addEventListener('contextmenu', this[onContextMenuWhileDragging]);
        document.addEventListener('mousemove', this[onMouseMove]);
      }
    }, this.options.delay);
  }

  /**
   * Mouse move handler
   * @private
   * @param {Event} event - Mouse move event
   */
  [onMouseMove](event) {
    if (!this.dragging) {
      return;
    }

    const target = document.elementFromPoint(event.clientX, event.clientY);

    const dragMoveEvent = new _SensorEvent.DragMoveSensorEvent({
      clientX: event.clientX,
      clientY: event.clientY,
      target,
      container: this.currentContainer,
      originalEvent: event
    });

    this.trigger(this.currentContainer, dragMoveEvent);
  }

  /**
   * Mouse up handler
   * @private
   * @param {Event} event - Mouse up event
   */
  [onMouseUp](event) {
    this.mouseDown = Boolean(this.openedContextMenu);

    if (this.openedContextMenu) {
      this.openedContextMenu = false;
      return;
    }

    document.removeEventListener('mouseup', this[onMouseUp]);
    document.removeEventListener('dragstart', preventNativeDragStart);

    if (!this.dragging) {
      return;
    }

    const target = document.elementFromPoint(event.clientX, event.clientY);

    const dragStopEvent = new _SensorEvent.DragStopSensorEvent({
      clientX: event.clientX,
      clientY: event.clientY,
      target,
      container: this.currentContainer,
      originalEvent: event
    });

    this.trigger(this.currentContainer, dragStopEvent);

    document.removeEventListener('contextmenu', this[onContextMenuWhileDragging]);
    document.removeEventListener('mousemove', this[onMouseMove]);

    this.currentContainer = null;
    this.dragging = false;
  }

  /**
   * Context menu handler
   * @private
   * @param {Event} event - Context menu event
   */
  [onContextMenuWhileDragging](event) {
    event.preventDefault();
    this.openedContextMenu = true;
  }
}

exports.default = MouseSensor;
function preventNativeDragStart(event) {
  event.preventDefault();
}

/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _MouseSensor = __webpack_require__(45);

var _MouseSensor2 = _interopRequireDefault(_MouseSensor);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _MouseSensor2.default;

/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Base sensor class. Extend from this class to create a new or custom sensor
 * @class Sensor
 * @module Sensor
 */
class Sensor {
  /**
   * Sensor constructor.
   * @constructs Sensor
   * @param {HTMLElement[]|NodeList|HTMLElement} containers - Containers
   * @param {Object} options - Options
   */
  constructor(containers = [], options = {}) {
    /**
     * Current containers
     * @property containers
     * @type {HTMLElement[]}
     */
    this.containers = [...containers];

    /**
     * Current options
     * @property options
     * @type {Object}
     */
    this.options = _extends({}, options);

    /**
     * Current drag state
     * @property dragging
     * @type {Boolean}
     */
    this.dragging = false;

    /**
     * Current container
     * @property currentContainer
     * @type {HTMLElement}
     */
    this.currentContainer = null;
  }

  /**
   * Attaches sensors event listeners to the DOM
   * @return {Sensor}
   */
  attach() {
    return this;
  }

  /**
   * Detaches sensors event listeners to the DOM
   * @return {Sensor}
   */
  detach() {
    return this;
  }

  /**
   * Adds container to this sensor instance
   * @param {...HTMLElement} containers - Containers you want to add to this sensor
   * @example draggable.addContainer(document.body)
   */
  addContainer(...containers) {
    this.containers = [...this.containers, ...containers];
  }

  /**
   * Removes container from this sensor instance
   * @param {...HTMLElement} containers - Containers you want to remove from this sensor
   * @example draggable.removeContainer(document.body)
   */
  removeContainer(...containers) {
    this.containers = this.containers.filter(container => !containers.includes(container));
  }

  /**
   * Triggers event on target element
   * @param {HTMLElement} element - Element to trigger event on
   * @param {SensorEvent} sensorEvent - Sensor event to trigger
   */
  trigger(element, sensorEvent) {
    const event = document.createEvent('Event');
    event.detail = sensorEvent;
    event.initEvent(sensorEvent.type, true, true);
    element.dispatchEvent(event);
    this.lastEvent = sensorEvent;

    return sensorEvent;
  }
}
exports.default = Sensor;

/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = requestNextAnimationFrame;
function requestNextAnimationFrame(callback) {
  return requestAnimationFrame(() => {
    requestAnimationFrame(callback);
  });
}

/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _requestNextAnimationFrame = __webpack_require__(48);

var _requestNextAnimationFrame2 = _interopRequireDefault(_requestNextAnimationFrame);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _requestNextAnimationFrame2.default;

/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = closest;
const matchFunction = Element.prototype.matches || Element.prototype.webkitMatchesSelector || Element.prototype.mozMatchesSelector || Element.prototype.msMatchesSelector;

/**
 * Get the closest parent element of a given element that matches the given
 * selector string or matching function
 *
 * @param {Element} element The child element to find a parent of
 * @param {String|Function} selector The string or function to use to match
 *     the parent element
 * @return {Element|null}
 */
function closest(element, value) {
  if (!element) {
    return null;
  }

  const selector = value;
  const callback = value;
  const nodeList = value;
  const singleElement = value;

  const isSelector = Boolean(typeof value === 'string');
  const isFunction = Boolean(typeof value === 'function');
  const isNodeList = Boolean(value instanceof NodeList || value instanceof Array);
  const isElement = Boolean(value instanceof HTMLElement);

  function conditionFn(currentElement) {
    if (!currentElement) {
      return currentElement;
    } else if (isSelector) {
      return matchFunction.call(currentElement, selector);
    } else if (isNodeList) {
      return [...nodeList].includes(currentElement);
    } else if (isElement) {
      return singleElement === currentElement;
    } else if (isFunction) {
      return callback(currentElement);
    } else {
      return null;
    }
  }

  let current = element;

  do {
    current = current.correspondingUseElement || current.correspondingElement || current;

    if (conditionFn(current)) {
      return current;
    }

    current = current.parentNode;
  } while (current && current !== document.body && current !== document);

  return null;
}

/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _closest = __webpack_require__(50);

var _closest2 = _interopRequireDefault(_closest);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _closest2.default;

/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultOptions = exports.scroll = exports.onDragStop = exports.onDragMove = exports.onDragStart = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _AbstractPlugin = __webpack_require__(1);

var _AbstractPlugin2 = _interopRequireDefault(_AbstractPlugin);

var _utils = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const onDragStart = exports.onDragStart = Symbol('onDragStart');
const onDragMove = exports.onDragMove = Symbol('onDragMove');
const onDragStop = exports.onDragStop = Symbol('onDragStop');
const scroll = exports.scroll = Symbol('scroll');

/**
 * Scrollable default options
 * @property {Object} defaultOptions
 * @property {Number} defaultOptions.speed
 * @property {Number} defaultOptions.sensitivity
 * @property {HTMLElement[]} defaultOptions.scrollableElements
 * @type {Object}
 */
const defaultOptions = exports.defaultOptions = {
  speed: 6,
  sensitivity: 50,
  scrollableElements: []
};

/**
 * Scrollable plugin which scrolls the closest scrollable parent
 * @class Scrollable
 * @module Scrollable
 * @extends AbstractPlugin
 */
class Scrollable extends _AbstractPlugin2.default {
  /**
   * Scrollable constructor.
   * @constructs Scrollable
   * @param {Draggable} draggable - Draggable instance
   */
  constructor(draggable) {
    super(draggable);

    /**
     * Scrollable options
     * @property {Object} options
     * @property {Number} options.speed
     * @property {Number} options.sensitivity
     * @property {HTMLElement[]} options.scrollableElements
     * @type {Object}
     */
    this.options = _extends({}, defaultOptions, this.getOptions());

    /**
     * Keeps current mouse position
     * @property {Object} currentMousePosition
     * @property {Number} currentMousePosition.clientX
     * @property {Number} currentMousePosition.clientY
     * @type {Object|null}
     */
    this.currentMousePosition = null;

    /**
     * Scroll animation frame
     * @property scrollAnimationFrame
     * @type {Number|null}
     */
    this.scrollAnimationFrame = null;

    /**
     * Closest scrollable element
     * @property scrollableElement
     * @type {HTMLElement|null}
     */
    this.scrollableElement = null;

    /**
     * Animation frame looking for the closest scrollable element
     * @property findScrollableElementFrame
     * @type {Number|null}
     */
    this.findScrollableElementFrame = null;

    this[onDragStart] = this[onDragStart].bind(this);
    this[onDragMove] = this[onDragMove].bind(this);
    this[onDragStop] = this[onDragStop].bind(this);
    this[scroll] = this[scroll].bind(this);
  }

  /**
   * Attaches plugins event listeners
   */
  attach() {
    this.draggable.on('drag:start', this[onDragStart]).on('drag:move', this[onDragMove]).on('drag:stop', this[onDragStop]);
  }

  /**
   * Detaches plugins event listeners
   */
  detach() {
    this.draggable.off('drag:start', this[onDragStart]).off('drag:move', this[onDragMove]).off('drag:stop', this[onDragStop]);
  }

  /**
   * Returns options passed through draggable
   * @return {Object}
   */
  getOptions() {
    return this.draggable.options.scrollable || {};
  }

  /**
   * Returns closest scrollable elements by element
   * @param {HTMLElement} target
   * @return {HTMLElement}
   */
  getScrollableElement(target) {
    if (this.hasDefinedScrollableElements()) {
      return (0, _utils.closest)(target, this.options.scrollableElements) || document.documentElement;
    } else {
      return closestScrollableElement(target);
    }
  }

  /**
   * Returns true if at least one scrollable element have been defined via options
   * @param {HTMLElement} target
   * @return {Boolean}
   */
  hasDefinedScrollableElements() {
    return Boolean(this.options.scrollableElements.length !== 0);
  }

  /**
   * Drag start handler. Finds closest scrollable parent in separate frame
   * @param {DragStartEvent} dragEvent
   * @private
   */
  [onDragStart](dragEvent) {
    this.findScrollableElementFrame = requestAnimationFrame(() => {
      this.scrollableElement = this.getScrollableElement(dragEvent.source);
    });
  }

  /**
   * Drag move handler. Remembers mouse position and initiates scrolling
   * @param {DragMoveEvent} dragEvent
   * @private
   */
  [onDragMove](dragEvent) {
    this.findScrollableElementFrame = requestAnimationFrame(() => {
      this.scrollableElement = this.getScrollableElement(dragEvent.sensorEvent.target);
    });

    if (!this.scrollableElement) {
      return;
    }

    const sensorEvent = dragEvent.sensorEvent;
    const scrollOffset = { x: 0, y: 0 };

    if ('ontouchstart' in window) {
      scrollOffset.y = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
      scrollOffset.x = window.pageXOffset || document.documentElement.scrollLeft || document.body.scrollLeft || 0;
    }

    this.currentMousePosition = {
      clientX: sensorEvent.clientX - scrollOffset.x,
      clientY: sensorEvent.clientY - scrollOffset.y
    };

    this.scrollAnimationFrame = requestAnimationFrame(this[scroll]);
  }

  /**
   * Drag stop handler. Cancels scroll animations and resets state
   * @private
   */
  [onDragStop]() {
    cancelAnimationFrame(this.scrollAnimationFrame);
    cancelAnimationFrame(this.findScrollableElementFrame);

    this.scrollableElement = null;
    this.scrollAnimationFrame = null;
    this.findScrollableElementFrame = null;
    this.currentMousePosition = null;
  }

  /**
   * Scroll function that does the heavylifting
   * @private
   */
  [scroll]() {
    if (!this.scrollableElement || !this.currentMousePosition) {
      return;
    }

    cancelAnimationFrame(this.scrollAnimationFrame);

    const { speed, sensitivity } = this.options;

    const rect = this.scrollableElement.getBoundingClientRect();
    const bottomCutOff = rect.bottom > window.innerHeight;
    const topCutOff = rect.top < 0;
    const cutOff = topCutOff || bottomCutOff;

    const documentScrollingElement = getDocumentScrollingElement();
    const scrollableElement = this.scrollableElement;
    const clientX = this.currentMousePosition.clientX;
    const clientY = this.currentMousePosition.clientY;

    if (scrollableElement !== document.body && scrollableElement !== document.documentElement && !cutOff) {
      const { offsetHeight, offsetWidth } = scrollableElement;

      if (rect.top + offsetHeight - clientY < sensitivity) {
        scrollableElement.scrollTop += speed;
      } else if (clientY - rect.top < sensitivity) {
        scrollableElement.scrollTop -= speed;
      }

      if (rect.left + offsetWidth - clientX < sensitivity) {
        scrollableElement.scrollLeft += speed;
      } else if (clientX - rect.left < sensitivity) {
        scrollableElement.scrollLeft -= speed;
      }
    } else {
      const { innerHeight, innerWidth } = window;

      if (clientY < sensitivity) {
        documentScrollingElement.scrollTop -= speed;
      } else if (innerHeight - clientY < sensitivity) {
        documentScrollingElement.scrollTop += speed;
      }

      if (clientX < sensitivity) {
        documentScrollingElement.scrollLeft -= speed;
      } else if (innerWidth - clientX < sensitivity) {
        documentScrollingElement.scrollLeft += speed;
      }
    }

    this.scrollAnimationFrame = requestAnimationFrame(this[scroll]);
  }
}

exports.default = Scrollable; /**
                               * Returns true if the passed element has overflow
                               * @param {HTMLElement} element
                               * @return {Boolean}
                               * @private
                               */

function hasOverflow(element) {
  const overflowRegex = /(auto|scroll)/;
  const computedStyles = getComputedStyle(element, null);

  const overflow = computedStyles.getPropertyValue('overflow') + computedStyles.getPropertyValue('overflow-y') + computedStyles.getPropertyValue('overflow-x');

  return overflowRegex.test(overflow);
}

/**
 * Returns true if the passed element is statically positioned
 * @param {HTMLElement} element
 * @return {Boolean}
 * @private
 */
function isStaticallyPositioned(element) {
  const position = getComputedStyle(element).getPropertyValue('position');
  return position === 'static';
}

/**
 * Finds closest scrollable element
 * @param {HTMLElement} element
 * @return {HTMLElement}
 * @private
 */
function closestScrollableElement(element) {
  if (!element) {
    return getDocumentScrollingElement();
  }

  const position = getComputedStyle(element).getPropertyValue('position');
  const excludeStaticParents = position === 'absolute';

  const scrollableElement = (0, _utils.closest)(element, parent => {
    if (excludeStaticParents && isStaticallyPositioned(parent)) {
      return false;
    }
    return hasOverflow(parent);
  });

  if (position === 'fixed' || !scrollableElement) {
    return getDocumentScrollingElement();
  } else {
    return scrollableElement;
  }
}

/**
 * Returns element that scrolls document
 * @return {HTMLElement}
 * @private
 */
function getDocumentScrollingElement() {
  return document.scrollingElement || document.documentElement;
}

/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultOptions = undefined;

var _Scrollable = __webpack_require__(52);

var _Scrollable2 = _interopRequireDefault(_Scrollable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Scrollable2.default;
exports.defaultOptions = _Scrollable.defaultOptions;

/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MirrorDestroyEvent = exports.MirrorMoveEvent = exports.MirrorAttachedEvent = exports.MirrorCreatedEvent = exports.MirrorCreateEvent = exports.MirrorEvent = undefined;

var _AbstractEvent = __webpack_require__(0);

var _AbstractEvent2 = _interopRequireDefault(_AbstractEvent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Base mirror event
 * @class MirrorEvent
 * @module MirrorEvent
 * @extends AbstractEvent
 */
class MirrorEvent extends _AbstractEvent2.default {
  /**
   * Draggables source element
   * @property source
   * @type {HTMLElement}
   * @readonly
   */
  get source() {
    return this.data.source;
  }

  /**
   * Draggables original source element
   * @property originalSource
   * @type {HTMLElement}
   * @readonly
   */
  get originalSource() {
    return this.data.originalSource;
  }

  /**
   * Draggables source container element
   * @property sourceContainer
   * @type {HTMLElement}
   * @readonly
   */
  get sourceContainer() {
    return this.data.sourceContainer;
  }

  /**
   * Sensor event
   * @property sensorEvent
   * @type {SensorEvent}
   * @readonly
   */
  get sensorEvent() {
    return this.data.sensorEvent;
  }

  /**
   * Drag event
   * @property dragEvent
   * @type {DragEvent}
   * @readonly
   */
  get dragEvent() {
    return this.data.dragEvent;
  }

  /**
   * Original event that triggered sensor event
   * @property originalEvent
   * @type {Event}
   * @readonly
   */
  get originalEvent() {
    if (this.sensorEvent) {
      return this.sensorEvent.originalEvent;
    }

    return null;
  }
}

exports.MirrorEvent = MirrorEvent; /**
                                    * Mirror create event
                                    * @class MirrorCreateEvent
                                    * @module MirrorCreateEvent
                                    * @extends MirrorEvent
                                    */

class MirrorCreateEvent extends MirrorEvent {}

exports.MirrorCreateEvent = MirrorCreateEvent; /**
                                                * Mirror created event
                                                * @class MirrorCreatedEvent
                                                * @module MirrorCreatedEvent
                                                * @extends MirrorEvent
                                                */

MirrorCreateEvent.type = 'mirror:create';
class MirrorCreatedEvent extends MirrorEvent {

  /**
   * Draggables mirror element
   * @property mirror
   * @type {HTMLElement}
   * @readonly
   */
  get mirror() {
    return this.data.mirror;
  }
}

exports.MirrorCreatedEvent = MirrorCreatedEvent; /**
                                                  * Mirror attached event
                                                  * @class MirrorAttachedEvent
                                                  * @module MirrorAttachedEvent
                                                  * @extends MirrorEvent
                                                  */

MirrorCreatedEvent.type = 'mirror:created';
class MirrorAttachedEvent extends MirrorEvent {

  /**
   * Draggables mirror element
   * @property mirror
   * @type {HTMLElement}
   * @readonly
   */
  get mirror() {
    return this.data.mirror;
  }
}

exports.MirrorAttachedEvent = MirrorAttachedEvent; /**
                                                    * Mirror move event
                                                    * @class MirrorMoveEvent
                                                    * @module MirrorMoveEvent
                                                    * @extends MirrorEvent
                                                    */

MirrorAttachedEvent.type = 'mirror:attached';
class MirrorMoveEvent extends MirrorEvent {

  /**
   * Draggables mirror element
   * @property mirror
   * @type {HTMLElement}
   * @readonly
   */
  get mirror() {
    return this.data.mirror;
  }
}

exports.MirrorMoveEvent = MirrorMoveEvent; /**
                                            * Mirror destroy event
                                            * @class MirrorDestroyEvent
                                            * @module MirrorDestroyEvent
                                            * @extends MirrorEvent
                                            */

MirrorMoveEvent.type = 'mirror:move';
MirrorMoveEvent.cancelable = true;
class MirrorDestroyEvent extends MirrorEvent {

  /**
   * Draggables mirror element
   * @property mirror
   * @type {HTMLElement}
   * @readonly
   */
  get mirror() {
    return this.data.mirror;
  }
}
exports.MirrorDestroyEvent = MirrorDestroyEvent;
MirrorDestroyEvent.type = 'mirror:destroy';
MirrorDestroyEvent.cancelable = true;

/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _MirrorEvent = __webpack_require__(54);

Object.keys(_MirrorEvent).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _MirrorEvent[key];
    }
  });
});

/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultOptions = exports.getAppendableContainer = exports.onScroll = exports.onMirrorMove = exports.onMirrorCreated = exports.onDragStop = exports.onDragMove = exports.onDragStart = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _AbstractPlugin = __webpack_require__(1);

var _AbstractPlugin2 = _interopRequireDefault(_AbstractPlugin);

var _MirrorEvent = __webpack_require__(55);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

const onDragStart = exports.onDragStart = Symbol('onDragStart');
const onDragMove = exports.onDragMove = Symbol('onDragMove');
const onDragStop = exports.onDragStop = Symbol('onDragStop');
const onMirrorCreated = exports.onMirrorCreated = Symbol('onMirrorCreated');
const onMirrorMove = exports.onMirrorMove = Symbol('onMirrorMove');
const onScroll = exports.onScroll = Symbol('onScroll');
const getAppendableContainer = exports.getAppendableContainer = Symbol('getAppendableContainer');

/**
 * Mirror default options
 * @property {Object} defaultOptions
 * @property {Boolean} defaultOptions.constrainDimensions
 * @property {Boolean} defaultOptions.xAxis
 * @property {Boolean} defaultOptions.yAxis
 * @property {null} defaultOptions.cursorOffsetX
 * @property {null} defaultOptions.cursorOffsetY
 * @type {Object}
 */
const defaultOptions = exports.defaultOptions = {
  constrainDimensions: false,
  xAxis: true,
  yAxis: true,
  cursorOffsetX: null,
  cursorOffsetY: null
};

/**
 * Mirror plugin which controls the mirror positioning while dragging
 * @class Mirror
 * @module Mirror
 * @extends AbstractPlugin
 */
class Mirror extends _AbstractPlugin2.default {
  /**
   * Mirror constructor.
   * @constructs Mirror
   * @param {Draggable} draggable - Draggable instance
   */
  constructor(draggable) {
    super(draggable);

    /**
     * Mirror options
     * @property {Object} options
     * @property {Boolean} options.constrainDimensions
     * @property {Boolean} options.xAxis
     * @property {Boolean} options.yAxis
     * @property {Number|null} options.cursorOffsetX
     * @property {Number|null} options.cursorOffsetY
     * @property {String|HTMLElement|Function} options.appendTo
     * @type {Object}
     */
    this.options = _extends({}, defaultOptions, this.getOptions());

    /**
     * Scroll offset for touch devices because the mirror is positioned fixed
     * @property {Object} scrollOffset
     * @property {Number} scrollOffset.x
     * @property {Number} scrollOffset.y
     */
    this.scrollOffset = { x: 0, y: 0 };

    /**
     * Initial scroll offset for touch devices because the mirror is positioned fixed
     * @property {Object} scrollOffset
     * @property {Number} scrollOffset.x
     * @property {Number} scrollOffset.y
     */
    this.initialScrollOffset = {
      x: window.scrollX,
      y: window.scrollY
    };

    this[onDragStart] = this[onDragStart].bind(this);
    this[onDragMove] = this[onDragMove].bind(this);
    this[onDragStop] = this[onDragStop].bind(this);
    this[onMirrorCreated] = this[onMirrorCreated].bind(this);
    this[onMirrorMove] = this[onMirrorMove].bind(this);
    this[onScroll] = this[onScroll].bind(this);
  }

  /**
   * Attaches plugins event listeners
   */
  attach() {
    this.draggable.on('drag:start', this[onDragStart]).on('drag:move', this[onDragMove]).on('drag:stop', this[onDragStop]).on('mirror:created', this[onMirrorCreated]).on('mirror:move', this[onMirrorMove]);
  }

  /**
   * Detaches plugins event listeners
   */
  detach() {
    this.draggable.off('drag:start', this[onDragStart]).off('drag:move', this[onDragMove]).off('drag:stop', this[onDragStop]).off('mirror:created', this[onMirrorCreated]).off('mirror:move', this[onMirrorMove]);
  }

  /**
   * Returns options passed through draggable
   * @return {Object}
   */
  getOptions() {
    return this.draggable.options.mirror || {};
  }

  [onDragStart](dragEvent) {
    if (dragEvent.canceled()) {
      return;
    }

    if ('ontouchstart' in window) {
      document.addEventListener('scroll', this[onScroll], true);
    }

    this.initialScrollOffset = {
      x: window.scrollX,
      y: window.scrollY
    };

    const { source, originalSource, sourceContainer, sensorEvent } = dragEvent;

    const mirrorCreateEvent = new _MirrorEvent.MirrorCreateEvent({
      source,
      originalSource,
      sourceContainer,
      sensorEvent,
      dragEvent
    });

    this.draggable.trigger(mirrorCreateEvent);

    if (isNativeDragEvent(sensorEvent) || mirrorCreateEvent.canceled()) {
      return;
    }

    const appendableContainer = this[getAppendableContainer](source) || sourceContainer;
    this.mirror = source.cloneNode(true);

    const mirrorCreatedEvent = new _MirrorEvent.MirrorCreatedEvent({
      source,
      originalSource,
      sourceContainer,
      sensorEvent,
      dragEvent,
      mirror: this.mirror
    });

    const mirrorAttachedEvent = new _MirrorEvent.MirrorAttachedEvent({
      source,
      originalSource,
      sourceContainer,
      sensorEvent,
      dragEvent,
      mirror: this.mirror
    });

    this.draggable.trigger(mirrorCreatedEvent);
    appendableContainer.appendChild(this.mirror);
    this.draggable.trigger(mirrorAttachedEvent);
  }

  [onDragMove](dragEvent) {
    if (!this.mirror || dragEvent.canceled()) {
      return;
    }

    const { source, originalSource, sourceContainer, sensorEvent } = dragEvent;

    const mirrorMoveEvent = new _MirrorEvent.MirrorMoveEvent({
      source,
      originalSource,
      sourceContainer,
      sensorEvent,
      dragEvent,
      mirror: this.mirror
    });

    this.draggable.trigger(mirrorMoveEvent);
  }

  [onDragStop](dragEvent) {
    if ('ontouchstart' in window) {
      document.removeEventListener('scroll', this[onScroll], true);
    }

    this.initialScrollOffset = { x: 0, y: 0 };
    this.scrollOffset = { x: 0, y: 0 };

    if (!this.mirror) {
      return;
    }

    const { source, sourceContainer, sensorEvent } = dragEvent;

    const mirrorDestroyEvent = new _MirrorEvent.MirrorDestroyEvent({
      source,
      mirror: this.mirror,
      sourceContainer,
      sensorEvent,
      dragEvent
    });

    this.draggable.trigger(mirrorDestroyEvent);

    if (!mirrorDestroyEvent.canceled()) {
      this.mirror.parentNode.removeChild(this.mirror);
    }
  }

  [onScroll]() {
    this.scrollOffset = {
      x: window.scrollX - this.initialScrollOffset.x,
      y: window.scrollY - this.initialScrollOffset.y
    };
  }

  /**
   * Mirror created handler
   * @param {MirrorCreatedEvent} mirrorEvent
   * @return {Promise}
   * @private
   */
  [onMirrorCreated]({ mirror, source, sensorEvent }) {
    const mirrorClass = this.draggable.getClassNameFor('mirror');

    const setState = (_ref) => {
      let { mirrorOffset, initialX, initialY } = _ref,
          args = _objectWithoutProperties(_ref, ['mirrorOffset', 'initialX', 'initialY']);

      this.mirrorOffset = mirrorOffset;
      this.initialX = initialX;
      this.initialY = initialY;
      return _extends({ mirrorOffset, initialX, initialY }, args);
    };

    const initialState = {
      mirror,
      source,
      sensorEvent,
      mirrorClass,
      scrollOffset: this.scrollOffset,
      options: this.options
    };

    return Promise.resolve(initialState)
    // Fix reflow here
    .then(computeMirrorDimensions).then(calculateMirrorOffset).then(resetMirror).then(addMirrorClasses).then(positionMirror({ initial: true })).then(removeMirrorID).then(setState);
  }

  /**
   * Mirror move handler
   * @param {MirrorMoveEvent} mirrorEvent
   * @return {Promise|null}
   * @private
   */
  [onMirrorMove](mirrorEvent) {
    if (mirrorEvent.canceled()) {
      return null;
    }

    const initialState = {
      mirror: mirrorEvent.mirror,
      sensorEvent: mirrorEvent.sensorEvent,
      mirrorOffset: this.mirrorOffset,
      options: this.options,
      initialX: this.initialX,
      initialY: this.initialY,
      scrollOffset: this.scrollOffset
    };

    return Promise.resolve(initialState).then(positionMirror({ raf: true }));
  }

  /**
   * Returns appendable container for mirror based on the appendTo option
   * @private
   * @param {Object} options
   * @param {HTMLElement} options.source - Current source
   * @return {HTMLElement}
   */
  [getAppendableContainer](source) {
    const appendTo = this.options.appendTo;

    if (typeof appendTo === 'string') {
      return document.querySelector(appendTo);
    } else if (appendTo instanceof HTMLElement) {
      return appendTo;
    } else if (typeof appendTo === 'function') {
      return appendTo(source);
    } else {
      return source.parentNode;
    }
  }
}

exports.default = Mirror; /**
                           * Computes mirror dimensions based on the source element
                           * Adds sourceRect to state
                           * @param {Object} state
                           * @param {HTMLElement} state.source
                           * @return {Promise}
                           * @private
                           */

function computeMirrorDimensions(_ref2) {
  let { source } = _ref2,
      args = _objectWithoutProperties(_ref2, ['source']);

  return withPromise(resolve => {
    const sourceRect = source.getBoundingClientRect();
    resolve(_extends({ source, sourceRect }, args));
  });
}

/**
 * Calculates mirror offset
 * Adds mirrorOffset to state
 * @param {Object} state
 * @param {SensorEvent} state.sensorEvent
 * @param {DOMRect} state.sourceRect
 * @return {Promise}
 * @private
 */
function calculateMirrorOffset(_ref3) {
  let { sensorEvent, sourceRect, options } = _ref3,
      args = _objectWithoutProperties(_ref3, ['sensorEvent', 'sourceRect', 'options']);

  return withPromise(resolve => {
    const top = options.cursorOffsetY === null ? sensorEvent.clientY - sourceRect.top : options.cursorOffsetY;
    const left = options.cursorOffsetX === null ? sensorEvent.clientX - sourceRect.left : options.cursorOffsetX;

    const mirrorOffset = { top, left };

    resolve(_extends({ sensorEvent, sourceRect, mirrorOffset, options }, args));
  });
}

/**
 * Applys mirror styles
 * @param {Object} state
 * @param {HTMLElement} state.mirror
 * @param {HTMLElement} state.source
 * @param {Object} state.options
 * @return {Promise}
 * @private
 */
function resetMirror(_ref4) {
  let { mirror, source, options } = _ref4,
      args = _objectWithoutProperties(_ref4, ['mirror', 'source', 'options']);

  return withPromise(resolve => {
    let offsetHeight;
    let offsetWidth;

    if (options.constrainDimensions) {
      const computedSourceStyles = getComputedStyle(source);
      offsetHeight = computedSourceStyles.getPropertyValue('height');
      offsetWidth = computedSourceStyles.getPropertyValue('width');
    }

    mirror.style.position = 'fixed';
    mirror.style.pointerEvents = 'none';
    mirror.style.top = 0;
    mirror.style.left = 0;
    mirror.style.margin = 0;

    if (options.constrainDimensions) {
      mirror.style.height = offsetHeight;
      mirror.style.width = offsetWidth;
    }

    resolve(_extends({ mirror, source, options }, args));
  });
}

/**
 * Applys mirror class on mirror element
 * @param {Object} state
 * @param {HTMLElement} state.mirror
 * @param {String} state.mirrorClass
 * @return {Promise}
 * @private
 */
function addMirrorClasses(_ref5) {
  let { mirror, mirrorClass } = _ref5,
      args = _objectWithoutProperties(_ref5, ['mirror', 'mirrorClass']);

  return withPromise(resolve => {
    mirror.classList.add(mirrorClass);
    resolve(_extends({ mirror, mirrorClass }, args));
  });
}

/**
 * Removes source ID from cloned mirror element
 * @param {Object} state
 * @param {HTMLElement} state.mirror
 * @return {Promise}
 * @private
 */
function removeMirrorID(_ref6) {
  let { mirror } = _ref6,
      args = _objectWithoutProperties(_ref6, ['mirror']);

  return withPromise(resolve => {
    mirror.removeAttribute('id');
    delete mirror.id;
    resolve(_extends({ mirror }, args));
  });
}

/**
 * Positions mirror with translate3d
 * @param {Object} state
 * @param {HTMLElement} state.mirror
 * @param {SensorEvent} state.sensorEvent
 * @param {Object} state.mirrorOffset
 * @param {Number} state.initialY
 * @param {Number} state.initialX
 * @param {Object} state.options
 * @return {Promise}
 * @private
 */
function positionMirror({ withFrame = false, initial = false } = {}) {
  return (_ref7) => {
    let { mirror, sensorEvent, mirrorOffset, initialY, initialX, scrollOffset, options } = _ref7,
        args = _objectWithoutProperties(_ref7, ['mirror', 'sensorEvent', 'mirrorOffset', 'initialY', 'initialX', 'scrollOffset', 'options']);

    return withPromise(resolve => {
      const result = _extends({
        mirror,
        sensorEvent,
        mirrorOffset,
        options
      }, args);

      if (mirrorOffset) {
        const x = sensorEvent.clientX - mirrorOffset.left - scrollOffset.x;
        const y = sensorEvent.clientY - mirrorOffset.top - scrollOffset.y;

        if (options.xAxis && options.yAxis || initial) {
          mirror.style.transform = `translate3d(${x}px, ${y}px, 0)`;
        } else if (options.xAxis && !options.yAxis) {
          mirror.style.transform = `translate3d(${x}px, ${initialY}px, 0)`;
        } else if (options.yAxis && !options.xAxis) {
          mirror.style.transform = `translate3d(${initialX}px, ${y}px, 0)`;
        }

        if (initial) {
          result.initialX = x;
          result.initialY = y;
        }
      }

      resolve(result);
    }, { frame: withFrame });
  };
}

/**
 * Wraps functions in promise with potential animation frame option
 * @param {Function} callback
 * @param {Object} options
 * @param {Boolean} options.raf
 * @return {Promise}
 * @private
 */
function withPromise(callback, { raf = false } = {}) {
  return new Promise((resolve, reject) => {
    if (raf) {
      requestAnimationFrame(() => {
        callback(resolve, reject);
      });
    } else {
      callback(resolve, reject);
    }
  });
}

/**
 * Returns true if the sensor event was triggered by a native browser drag event
 * @param {SensorEvent} sensorEvent
 */
function isNativeDragEvent(sensorEvent) {
  return (/^drag/.test(sensorEvent.originalEvent.type)
  );
}

/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultOptions = undefined;

var _Mirror = __webpack_require__(56);

var _Mirror2 = _interopRequireDefault(_Mirror);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Mirror2.default;
exports.defaultOptions = _Mirror.defaultOptions;

/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _AbstractPlugin = __webpack_require__(1);

var _AbstractPlugin2 = _interopRequireDefault(_AbstractPlugin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const onInitialize = Symbol('onInitialize');
const onDestroy = Symbol('onDestroy');

/**
 * Focusable default options
 * @property {Object} defaultOptions
 * @type {Object}
 */
const defaultOptions = {};

/**
 * Focusable plugin
 * @class Focusable
 * @module Focusable
 * @extends AbstractPlugin
 */
class Focusable extends _AbstractPlugin2.default {
  /**
   * Focusable constructor.
   * @constructs Focusable
   * @param {Draggable} draggable - Draggable instance
   */
  constructor(draggable) {
    super(draggable);

    /**
     * Focusable options
     * @property {Object} options
     * @type {Object}
     */
    this.options = _extends({}, defaultOptions, this.getOptions());

    this[onInitialize] = this[onInitialize].bind(this);
    this[onDestroy] = this[onDestroy].bind(this);
  }

  /**
   * Attaches listeners to draggable
   */
  attach() {
    this.draggable.on('draggable:initialize', this[onInitialize]).on('draggable:destroy', this[onDestroy]);
  }

  /**
   * Detaches listeners from draggable
   */
  detach() {
    this.draggable.off('draggable:initialize', this[onInitialize]).off('draggable:destroy', this[onDestroy]);
  }

  /**
   * Returns options passed through draggable
   * @return {Object}
   */
  getOptions() {
    return this.draggable.options.focusable || {};
  }

  /**
   * Returns draggable containers and elements
   * @return {HTMLElement[]}
   */
  getElements() {
    return [...this.draggable.containers, ...this.draggable.getDraggableElements()];
  }

  /**
   * Intialize handler
   * @private
   */
  [onInitialize]() {
    // Can wait until the next best frame is available
    requestAnimationFrame(() => {
      this.getElements().forEach(element => decorateElement(element));
    });
  }

  /**
   * Destroy handler
   * @private
   */
  [onDestroy]() {
    // Can wait until the next best frame is available
    requestAnimationFrame(() => {
      this.getElements().forEach(element => stripElement(element));
    });
  }
}

exports.default = Focusable; /**
                              * Keeps track of all the elements that are missing tabindex attributes
                              * so they can be reset when draggable gets destroyed
                              * @const {HTMLElement[]} elementsWithMissingTabIndex
                              */

const elementsWithMissingTabIndex = [];

/**
 * Decorates element with tabindex attributes
 * @param {HTMLElement} element
 * @return {Object}
 * @private
 */
function decorateElement(element) {
  const hasMissingTabIndex = Boolean(!element.getAttribute('tabindex') && element.tabIndex === -1);

  if (hasMissingTabIndex) {
    elementsWithMissingTabIndex.push(element);
    element.tabIndex = 0;
  }
}

/**
 * Removes elements tabindex attributes
 * @param {HTMLElement} element
 * @private
 */
function stripElement(element) {
  const tabIndexElementPosition = elementsWithMissingTabIndex.indexOf(element);

  if (tabIndexElementPosition !== -1) {
    element.tabIndex = -1;
    elementsWithMissingTabIndex.splice(tabIndexElementPosition, 1);
  }
}

/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Focusable = __webpack_require__(58);

var _Focusable2 = _interopRequireDefault(_Focusable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Focusable2.default;

/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * All draggable plugins inherit from this class.
 * @abstract
 * @class AbstractPlugin
 * @module AbstractPlugin
 */
class AbstractPlugin {
  /**
   * AbstractPlugin constructor.
   * @constructs AbstractPlugin
   * @param {Draggable} draggable - Draggable instance
   */
  constructor(draggable) {
    /**
     * Draggable instance
     * @property draggable
     * @type {Draggable}
     */
    this.draggable = draggable;
  }

  /**
   * Override to add listeners
   * @abstract
   */
  attach() {
    throw new Error('Not Implemented');
  }

  /**
   * Override to remove listeners
   * @abstract
   */
  detach() {
    throw new Error('Not Implemented');
  }
}
exports.default = AbstractPlugin;

/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultOptions = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _AbstractPlugin = __webpack_require__(1);

var _AbstractPlugin2 = _interopRequireDefault(_AbstractPlugin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const onInitialize = Symbol('onInitialize');
const onDestroy = Symbol('onDestroy');
const announceEvent = Symbol('announceEvent');
const announceMessage = Symbol('announceMessage');

const ARIA_RELEVANT = 'aria-relevant';
const ARIA_ATOMIC = 'aria-atomic';
const ARIA_LIVE = 'aria-live';
const ROLE = 'role';

/**
 * Announcement default options
 * @property {Object} defaultOptions
 * @property {Number} defaultOptions.expire
 * @type {Object}
 */
const defaultOptions = exports.defaultOptions = {
  expire: 7000
};

/**
 * Announcement plugin
 * @class Announcement
 * @module Announcement
 * @extends AbstractPlugin
 */
class Announcement extends _AbstractPlugin2.default {
  /**
   * Announcement constructor.
   * @constructs Announcement
   * @param {Draggable} draggable - Draggable instance
   */
  constructor(draggable) {
    super(draggable);

    /**
     * Plugin options
     * @property options
     * @type {Object}
     */
    this.options = _extends({}, defaultOptions, this.getOptions());

    /**
     * Original draggable trigger method. Hack until we have onAll or on('all')
     * @property originalTriggerMethod
     * @type {Function}
     */
    this.originalTriggerMethod = this.draggable.trigger;

    this[onInitialize] = this[onInitialize].bind(this);
    this[onDestroy] = this[onDestroy].bind(this);
  }

  /**
   * Attaches listeners to draggable
   */
  attach() {
    this.draggable.on('draggable:initialize', this[onInitialize]);
  }

  /**
   * Detaches listeners from draggable
   */
  detach() {
    this.draggable.off('draggable:destroy', this[onDestroy]);
  }

  /**
   * Returns passed in options
   */
  getOptions() {
    return this.draggable.options.announcements || {};
  }

  /**
   * Announces event
   * @private
   * @param {AbstractEvent} event
   */
  [announceEvent](event) {
    const message = this.options[event.type];

    if (message && typeof message === 'string') {
      this[announceMessage](message);
    }

    if (message && typeof message === 'function') {
      this[announceMessage](message(event));
    }
  }

  /**
   * Announces message to screen reader
   * @private
   * @param {String} message
   */
  [announceMessage](message) {
    announce(message, { expire: this.options.expire });
  }

  /**
   * Initialize hander
   * @private
   */
  [onInitialize]() {
    // Hack until there is an api for listening for all events
    this.draggable.trigger = event => {
      try {
        this[announceEvent](event);
      } finally {
        // Ensure that original trigger is called
        this.originalTriggerMethod.call(this.draggable, event);
      }
    };
  }

  /**
   * Destroy hander
   * @private
   */
  [onDestroy]() {
    this.draggable.trigger = this.originalTriggerMethod;
  }
}

exports.default = Announcement; /**
                                 * @const {HTMLElement} liveRegion
                                 */

const liveRegion = createRegion();

/**
 * Announces message via live region
 * @param {String} message
 * @param {Object} options
 * @param {Number} options.expire
 */
function announce(message, { expire }) {
  const element = document.createElement('div');

  element.textContent = message;
  liveRegion.appendChild(element);

  return setTimeout(() => {
    liveRegion.removeChild(element);
  }, expire);
}

/**
 * Creates region element
 * @return {HTMLElement}
 */
function createRegion() {
  const element = document.createElement('div');

  element.setAttribute('id', 'draggable-live-region');
  element.setAttribute(ARIA_RELEVANT, 'additions');
  element.setAttribute(ARIA_ATOMIC, 'true');
  element.setAttribute(ARIA_LIVE, 'assertive');
  element.setAttribute(ROLE, 'log');

  element.style.position = 'fixed';
  element.style.width = '1px';
  element.style.height = '1px';
  element.style.top = '-1px';
  element.style.overflow = 'hidden';

  return element;
}

// Append live region element as early as possible
document.addEventListener('DOMContentLoaded', () => {
  document.body.appendChild(liveRegion);
});

/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultOptions = undefined;

var _Announcement = __webpack_require__(61);

var _Announcement2 = _interopRequireDefault(_Announcement);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Announcement2.default;
exports.defaultOptions = _Announcement.defaultOptions;

/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DraggableDestroyEvent = exports.DraggableInitializedEvent = exports.DraggableEvent = undefined;

var _AbstractEvent = __webpack_require__(0);

var _AbstractEvent2 = _interopRequireDefault(_AbstractEvent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Base draggable event
 * @class DraggableEvent
 * @module DraggableEvent
 * @extends AbstractEvent
 */
class DraggableEvent extends _AbstractEvent2.default {

  /**
   * Draggable instance
   * @property draggable
   * @type {Draggable}
   * @readonly
   */
  get draggable() {
    return this.data.draggable;
  }
}

exports.DraggableEvent = DraggableEvent; /**
                                          * Draggable initialized event
                                          * @class DraggableInitializedEvent
                                          * @module DraggableInitializedEvent
                                          * @extends DraggableEvent
                                          */

DraggableEvent.type = 'draggable';
class DraggableInitializedEvent extends DraggableEvent {}

exports.DraggableInitializedEvent = DraggableInitializedEvent; /**
                                                                * Draggable destory event
                                                                * @class DraggableInitializedEvent
                                                                * @module DraggableDestroyEvent
                                                                * @extends DraggableDestroyEvent
                                                                */

DraggableInitializedEvent.type = 'draggable:initialize';
class DraggableDestroyEvent extends DraggableEvent {}
exports.DraggableDestroyEvent = DraggableDestroyEvent;
DraggableDestroyEvent.type = 'draggable:destroy';

/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

const canceled = Symbol('canceled');

/**
 * All events fired by draggable inherit this class. You can call `cancel()` to
 * cancel a specific event or you can check if an event has been canceled by
 * calling `canceled()`.
 * @abstract
 * @class AbstractEvent
 * @module AbstractEvent
 */
class AbstractEvent {

  /**
   * AbstractEvent constructor.
   * @constructs AbstractEvent
   * @param {object} data - Event data
   */

  /**
   * Event type
   * @static
   * @abstract
   * @property type
   * @type {String}
   */
  constructor(data) {
    this[canceled] = false;
    this.data = data;
  }

  /**
   * Read-only type
   * @abstract
   * @return {String}
   */


  /**
   * Event cancelable
   * @static
   * @abstract
   * @property cancelable
   * @type {Boolean}
   */
  get type() {
    return this.constructor.type;
  }

  /**
   * Read-only cancelable
   * @abstract
   * @return {Boolean}
   */
  get cancelable() {
    return this.constructor.cancelable;
  }

  /**
   * Cancels the event instance
   * @abstract
   */
  cancel() {
    this[canceled] = true;
  }

  /**
   * Check if event has been canceled
   * @abstract
   * @return {Boolean}
   */
  canceled() {
    return Boolean(this[canceled]);
  }

  /**
   * Returns new event instance with existing event data.
   * This method allows for overriding of event data.
   * @param {Object} data
   * @return {AbstractEvent}
   */
  clone(data) {
    return new this.constructor(_extends({}, this.data, data));
  }
}
exports.default = AbstractEvent;
AbstractEvent.type = 'event';
AbstractEvent.cancelable = false;

/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DragStopEvent = exports.DragPressureEvent = exports.DragOutContainerEvent = exports.DragOverContainerEvent = exports.DragOutEvent = exports.DragOverEvent = exports.DragMoveEvent = exports.DragStartEvent = exports.DragEvent = undefined;

var _AbstractEvent = __webpack_require__(0);

var _AbstractEvent2 = _interopRequireDefault(_AbstractEvent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Base drag event
 * @class DragEvent
 * @module DragEvent
 * @extends AbstractEvent
 */
class DragEvent extends _AbstractEvent2.default {

  /**
   * Draggables source element
   * @property source
   * @type {HTMLElement}
   * @readonly
   */
  get source() {
    return this.data.source;
  }

  /**
   * Draggables original source element
   * @property originalSource
   * @type {HTMLElement}
   * @readonly
   */
  get originalSource() {
    return this.data.originalSource;
  }

  /**
   * Draggables mirror element
   * @property mirror
   * @type {HTMLElement}
   * @readonly
   */
  get mirror() {
    return this.data.mirror;
  }

  /**
   * Draggables source container element
   * @property sourceContainer
   * @type {HTMLElement}
   * @readonly
   */
  get sourceContainer() {
    return this.data.sourceContainer;
  }

  /**
   * Sensor event
   * @property sensorEvent
   * @type {SensorEvent}
   * @readonly
   */
  get sensorEvent() {
    return this.data.sensorEvent;
  }

  /**
   * Original event that triggered sensor event
   * @property originalEvent
   * @type {Event}
   * @readonly
   */
  get originalEvent() {
    if (this.sensorEvent) {
      return this.sensorEvent.originalEvent;
    }

    return null;
  }
}

exports.DragEvent = DragEvent; /**
                                * Drag start event
                                * @class DragStartEvent
                                * @module DragStartEvent
                                * @extends DragEvent
                                */

DragEvent.type = 'drag';
class DragStartEvent extends DragEvent {}

exports.DragStartEvent = DragStartEvent; /**
                                          * Drag move event
                                          * @class DragMoveEvent
                                          * @module DragMoveEvent
                                          * @extends DragEvent
                                          */

DragStartEvent.type = 'drag:start';
DragStartEvent.cancelable = true;
class DragMoveEvent extends DragEvent {}

exports.DragMoveEvent = DragMoveEvent; /**
                                        * Drag over event
                                        * @class DragOverEvent
                                        * @module DragOverEvent
                                        * @extends DragEvent
                                        */

DragMoveEvent.type = 'drag:move';
class DragOverEvent extends DragEvent {

  /**
   * Draggable container you are over
   * @property overContainer
   * @type {HTMLElement}
   * @readonly
   */
  get overContainer() {
    return this.data.overContainer;
  }

  /**
   * Draggable element you are over
   * @property over
   * @type {HTMLElement}
   * @readonly
   */
  get over() {
    return this.data.over;
  }
}

exports.DragOverEvent = DragOverEvent; /**
                                        * Drag out event
                                        * @class DragOutEvent
                                        * @module DragOutEvent
                                        * @extends DragEvent
                                        */

DragOverEvent.type = 'drag:over';
DragOverEvent.cancelable = true;
class DragOutEvent extends DragEvent {

  /**
   * Draggable container you are over
   * @property overContainer
   * @type {HTMLElement}
   * @readonly
   */
  get overContainer() {
    return this.data.overContainer;
  }

  /**
   * Draggable element you left
   * @property over
   * @type {HTMLElement}
   * @readonly
   */
  get over() {
    return this.data.over;
  }
}

exports.DragOutEvent = DragOutEvent; /**
                                      * Drag over container event
                                      * @class DragOverContainerEvent
                                      * @module DragOverContainerEvent
                                      * @extends DragEvent
                                      */

DragOutEvent.type = 'drag:out';
class DragOverContainerEvent extends DragEvent {

  /**
   * Draggable container you are over
   * @property overContainer
   * @type {HTMLElement}
   * @readonly
   */
  get overContainer() {
    return this.data.overContainer;
  }
}

exports.DragOverContainerEvent = DragOverContainerEvent; /**
                                                          * Drag out container event
                                                          * @class DragOutContainerEvent
                                                          * @module DragOutContainerEvent
                                                          * @extends DragEvent
                                                          */

DragOverContainerEvent.type = 'drag:over:container';
class DragOutContainerEvent extends DragEvent {

  /**
   * Draggable container you left
   * @property overContainer
   * @type {HTMLElement}
   * @readonly
   */
  get overContainer() {
    return this.data.overContainer;
  }
}

exports.DragOutContainerEvent = DragOutContainerEvent; /**
                                                        * Drag pressure event
                                                        * @class DragPressureEvent
                                                        * @module DragPressureEvent
                                                        * @extends DragEvent
                                                        */

DragOutContainerEvent.type = 'drag:out:container';
class DragPressureEvent extends DragEvent {

  /**
   * Pressure applied on draggable element
   * @property pressure
   * @type {Number}
   * @readonly
   */
  get pressure() {
    return this.data.pressure;
  }
}

exports.DragPressureEvent = DragPressureEvent; /**
                                                * Drag stop event
                                                * @class DragStopEvent
                                                * @module DragStopEvent
                                                * @extends DragEvent
                                                */

DragPressureEvent.type = 'drag:pressure';
class DragStopEvent extends DragEvent {}
exports.DragStopEvent = DragStopEvent;
DragStopEvent.type = 'drag:stop';

/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Plugins = exports.Sensors = exports.Sortable = exports.Swappable = exports.Droppable = exports.Draggable = exports.BasePlugin = exports.BaseEvent = undefined;

var _Draggable = __webpack_require__(5);

Object.defineProperty(exports, 'Draggable', {
  enumerable: true,
  get: function () {
    return _interopRequireDefault(_Draggable).default;
  }
});

var _Droppable = __webpack_require__(34);

Object.defineProperty(exports, 'Droppable', {
  enumerable: true,
  get: function () {
    return _interopRequireDefault(_Droppable).default;
  }
});

var _Swappable = __webpack_require__(31);

Object.defineProperty(exports, 'Swappable', {
  enumerable: true,
  get: function () {
    return _interopRequireDefault(_Swappable).default;
  }
});

var _Sortable = __webpack_require__(28);

Object.defineProperty(exports, 'Sortable', {
  enumerable: true,
  get: function () {
    return _interopRequireDefault(_Sortable).default;
  }
});

var _AbstractEvent = __webpack_require__(0);

var _AbstractEvent2 = _interopRequireDefault(_AbstractEvent);

var _AbstractPlugin = __webpack_require__(1);

var _AbstractPlugin2 = _interopRequireDefault(_AbstractPlugin);

var _Sensors = __webpack_require__(6);

var Sensors = _interopRequireWildcard(_Sensors);

var _Plugins = __webpack_require__(25);

var Plugins = _interopRequireWildcard(_Plugins);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.BaseEvent = _AbstractEvent2.default;
exports.BasePlugin = _AbstractPlugin2.default;
exports.Sensors = Sensors;
exports.Plugins = Plugins;

/***/ })
/******/ ]);
});
},{}],3:[function(require,module,exports){
'use strict';

var GetIntrinsic = require('get-intrinsic');
var callBound = require('call-bind/callBound');
var $TypeError = GetIntrinsic('%TypeError%');

var Call = require('es-abstract/2021/Call');
var Get = require('es-abstract/2021/Get');
var HasProperty = require('es-abstract/2021/HasProperty');
var IsCallable = require('es-abstract/2021/IsCallable');
var LengthOfArrayLike = require('es-abstract/2021/LengthOfArrayLike');
var ToObject = require('es-abstract/2021/ToObject');
var ToString = require('es-abstract/2021/ToString');

var isString = require('is-string');

var $split = callBound('String.prototype.split');

// Check failure of by-index access of string characters (IE < 9) and failure of `0 in boxedString` (Rhino)
var boxedString = Object('a');
var splitString = boxedString[0] !== 'a' || !(0 in boxedString);

module.exports = function forEach(callbackfn) {
	var thisO = ToObject(this);
	var O = splitString && isString(this) ? $split(this, '') : thisO;

	var len = LengthOfArrayLike(O);

	if (!IsCallable(callbackfn)) {
		throw new $TypeError('Array.prototype.forEach callback must be a function');
	}

	var thisArg;
	if (arguments.length > 1) {
		thisArg = arguments[1];
	}

	var k = 0;
	while (k < len) {
		var Pk = ToString(k);
		var kPresent = HasProperty(O, Pk);
		if (kPresent) {
			var kValue = Get(O, Pk);
			Call(callbackfn, thisArg, [kValue, k, O]);
		}
		k += 1;
	}

	return void undefined;
};

},{"call-bind/callBound":10,"es-abstract/2021/Call":14,"es-abstract/2021/Get":15,"es-abstract/2021/HasProperty":16,"es-abstract/2021/IsCallable":18,"es-abstract/2021/LengthOfArrayLike":20,"es-abstract/2021/ToObject":25,"es-abstract/2021/ToString":27,"get-intrinsic":47,"is-string":55}],4:[function(require,module,exports){
'use strict';

var define = require('define-properties');
var callBind = require('call-bind');
var callBound = require('call-bind/callBound');
var RequireObjectCoercible = require('es-abstract/2021/RequireObjectCoercible');

var implementation = require('./implementation');
var getPolyfill = require('./polyfill');
var polyfill = getPolyfill();
var shim = require('./shim');

var $slice = callBound('Array.prototype.slice');

var bound = callBind.apply(polyfill);
// eslint-disable-next-line no-unused-vars
var boundCoercible = function forEach(array, callbackfn) {
	RequireObjectCoercible(array);
	return bound(array, $slice(arguments, 1));
};

define(boundCoercible, {
	getPolyfill: getPolyfill,
	implementation: implementation,
	shim: shim
});

module.exports = boundCoercible;

},{"./implementation":3,"./polyfill":5,"./shim":6,"call-bind":11,"call-bind/callBound":10,"define-properties":12,"es-abstract/2021/RequireObjectCoercible":21}],5:[function(require,module,exports){
'use strict';

var arrayMethodBoxesProperly = require('es-array-method-boxes-properly');

var implementation = require('./implementation');

module.exports = function getPolyfill() {
	var method = Array.prototype.forEach;
	return arrayMethodBoxesProperly(method) ? method : implementation;
};

},{"./implementation":3,"es-array-method-boxes-properly":40}],6:[function(require,module,exports){
'use strict';

var define = require('define-properties');
var getPolyfill = require('./polyfill');

module.exports = function shimForEach() {
	var polyfill = getPolyfill();
	define(
		Array.prototype,
		{ forEach: polyfill },
		{ forEach: function () { return Array.prototype.forEach !== polyfill; } }
	);
	return polyfill;
};

},{"./polyfill":5,"define-properties":12}],7:[function(require,module,exports){
!function(e,t){"object"==typeof exports&&"object"==typeof module?module.exports=t():"function"==typeof define&&define.amd?define([],t):"object"==typeof exports?exports.bowser=t():e.bowser=t()}(this,(function(){return function(e){var t={};function r(n){if(t[n])return t[n].exports;var i=t[n]={i:n,l:!1,exports:{}};return e[n].call(i.exports,i,i.exports,r),i.l=!0,i.exports}return r.m=e,r.c=t,r.d=function(e,t,n){r.o(e,t)||Object.defineProperty(e,t,{enumerable:!0,get:n})},r.r=function(e){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(e,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(e,"__esModule",{value:!0})},r.t=function(e,t){if(1&t&&(e=r(e)),8&t)return e;if(4&t&&"object"==typeof e&&e&&e.__esModule)return e;var n=Object.create(null);if(r.r(n),Object.defineProperty(n,"default",{enumerable:!0,value:e}),2&t&&"string"!=typeof e)for(var i in e)r.d(n,i,function(t){return e[t]}.bind(null,i));return n},r.n=function(e){var t=e&&e.__esModule?function(){return e.default}:function(){return e};return r.d(t,"a",t),t},r.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},r.p="",r(r.s=90)}({17:function(e,t,r){"use strict";t.__esModule=!0,t.default=void 0;var n=r(18),i=function(){function e(){}return e.getFirstMatch=function(e,t){var r=t.match(e);return r&&r.length>0&&r[1]||""},e.getSecondMatch=function(e,t){var r=t.match(e);return r&&r.length>1&&r[2]||""},e.matchAndReturnConst=function(e,t,r){if(e.test(t))return r},e.getWindowsVersionName=function(e){switch(e){case"NT":return"NT";case"XP":return"XP";case"NT 5.0":return"2000";case"NT 5.1":return"XP";case"NT 5.2":return"2003";case"NT 6.0":return"Vista";case"NT 6.1":return"7";case"NT 6.2":return"8";case"NT 6.3":return"8.1";case"NT 10.0":return"10";default:return}},e.getMacOSVersionName=function(e){var t=e.split(".").splice(0,2).map((function(e){return parseInt(e,10)||0}));if(t.push(0),10===t[0])switch(t[1]){case 5:return"Leopard";case 6:return"Snow Leopard";case 7:return"Lion";case 8:return"Mountain Lion";case 9:return"Mavericks";case 10:return"Yosemite";case 11:return"El Capitan";case 12:return"Sierra";case 13:return"High Sierra";case 14:return"Mojave";case 15:return"Catalina";default:return}},e.getAndroidVersionName=function(e){var t=e.split(".").splice(0,2).map((function(e){return parseInt(e,10)||0}));if(t.push(0),!(1===t[0]&&t[1]<5))return 1===t[0]&&t[1]<6?"Cupcake":1===t[0]&&t[1]>=6?"Donut":2===t[0]&&t[1]<2?"Eclair":2===t[0]&&2===t[1]?"Froyo":2===t[0]&&t[1]>2?"Gingerbread":3===t[0]?"Honeycomb":4===t[0]&&t[1]<1?"Ice Cream Sandwich":4===t[0]&&t[1]<4?"Jelly Bean":4===t[0]&&t[1]>=4?"KitKat":5===t[0]?"Lollipop":6===t[0]?"Marshmallow":7===t[0]?"Nougat":8===t[0]?"Oreo":9===t[0]?"Pie":void 0},e.getVersionPrecision=function(e){return e.split(".").length},e.compareVersions=function(t,r,n){void 0===n&&(n=!1);var i=e.getVersionPrecision(t),s=e.getVersionPrecision(r),a=Math.max(i,s),o=0,u=e.map([t,r],(function(t){var r=a-e.getVersionPrecision(t),n=t+new Array(r+1).join(".0");return e.map(n.split("."),(function(e){return new Array(20-e.length).join("0")+e})).reverse()}));for(n&&(o=a-Math.min(i,s)),a-=1;a>=o;){if(u[0][a]>u[1][a])return 1;if(u[0][a]===u[1][a]){if(a===o)return 0;a-=1}else if(u[0][a]<u[1][a])return-1}},e.map=function(e,t){var r,n=[];if(Array.prototype.map)return Array.prototype.map.call(e,t);for(r=0;r<e.length;r+=1)n.push(t(e[r]));return n},e.find=function(e,t){var r,n;if(Array.prototype.find)return Array.prototype.find.call(e,t);for(r=0,n=e.length;r<n;r+=1){var i=e[r];if(t(i,r))return i}},e.assign=function(e){for(var t,r,n=e,i=arguments.length,s=new Array(i>1?i-1:0),a=1;a<i;a++)s[a-1]=arguments[a];if(Object.assign)return Object.assign.apply(Object,[e].concat(s));var o=function(){var e=s[t];"object"==typeof e&&null!==e&&Object.keys(e).forEach((function(t){n[t]=e[t]}))};for(t=0,r=s.length;t<r;t+=1)o();return e},e.getBrowserAlias=function(e){return n.BROWSER_ALIASES_MAP[e]},e.getBrowserTypeByAlias=function(e){return n.BROWSER_MAP[e]||""},e}();t.default=i,e.exports=t.default},18:function(e,t,r){"use strict";t.__esModule=!0,t.ENGINE_MAP=t.OS_MAP=t.PLATFORMS_MAP=t.BROWSER_MAP=t.BROWSER_ALIASES_MAP=void 0;t.BROWSER_ALIASES_MAP={"Amazon Silk":"amazon_silk","Android Browser":"android",Bada:"bada",BlackBerry:"blackberry",Chrome:"chrome",Chromium:"chromium",Electron:"electron",Epiphany:"epiphany",Firefox:"firefox",Focus:"focus",Generic:"generic","Google Search":"google_search",Googlebot:"googlebot","Internet Explorer":"ie","K-Meleon":"k_meleon",Maxthon:"maxthon","Microsoft Edge":"edge","MZ Browser":"mz","NAVER Whale Browser":"naver",Opera:"opera","Opera Coast":"opera_coast",PhantomJS:"phantomjs",Puffin:"puffin",QupZilla:"qupzilla",QQ:"qq",QQLite:"qqlite",Safari:"safari",Sailfish:"sailfish","Samsung Internet for Android":"samsung_internet",SeaMonkey:"seamonkey",Sleipnir:"sleipnir",Swing:"swing",Tizen:"tizen","UC Browser":"uc",Vivaldi:"vivaldi","WebOS Browser":"webos",WeChat:"wechat","Yandex Browser":"yandex",Roku:"roku"};t.BROWSER_MAP={amazon_silk:"Amazon Silk",android:"Android Browser",bada:"Bada",blackberry:"BlackBerry",chrome:"Chrome",chromium:"Chromium",electron:"Electron",epiphany:"Epiphany",firefox:"Firefox",focus:"Focus",generic:"Generic",googlebot:"Googlebot",google_search:"Google Search",ie:"Internet Explorer",k_meleon:"K-Meleon",maxthon:"Maxthon",edge:"Microsoft Edge",mz:"MZ Browser",naver:"NAVER Whale Browser",opera:"Opera",opera_coast:"Opera Coast",phantomjs:"PhantomJS",puffin:"Puffin",qupzilla:"QupZilla",qq:"QQ Browser",qqlite:"QQ Browser Lite",safari:"Safari",sailfish:"Sailfish",samsung_internet:"Samsung Internet for Android",seamonkey:"SeaMonkey",sleipnir:"Sleipnir",swing:"Swing",tizen:"Tizen",uc:"UC Browser",vivaldi:"Vivaldi",webos:"WebOS Browser",wechat:"WeChat",yandex:"Yandex Browser"};t.PLATFORMS_MAP={tablet:"tablet",mobile:"mobile",desktop:"desktop",tv:"tv"};t.OS_MAP={WindowsPhone:"Windows Phone",Windows:"Windows",MacOS:"macOS",iOS:"iOS",Android:"Android",WebOS:"WebOS",BlackBerry:"BlackBerry",Bada:"Bada",Tizen:"Tizen",Linux:"Linux",ChromeOS:"Chrome OS",PlayStation4:"PlayStation 4",Roku:"Roku"};t.ENGINE_MAP={EdgeHTML:"EdgeHTML",Blink:"Blink",Trident:"Trident",Presto:"Presto",Gecko:"Gecko",WebKit:"WebKit"}},90:function(e,t,r){"use strict";t.__esModule=!0,t.default=void 0;var n,i=(n=r(91))&&n.__esModule?n:{default:n},s=r(18);function a(e,t){for(var r=0;r<t.length;r++){var n=t[r];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(e,n.key,n)}}var o=function(){function e(){}var t,r,n;return e.getParser=function(e,t){if(void 0===t&&(t=!1),"string"!=typeof e)throw new Error("UserAgent should be a string");return new i.default(e,t)},e.parse=function(e){return new i.default(e).getResult()},t=e,n=[{key:"BROWSER_MAP",get:function(){return s.BROWSER_MAP}},{key:"ENGINE_MAP",get:function(){return s.ENGINE_MAP}},{key:"OS_MAP",get:function(){return s.OS_MAP}},{key:"PLATFORMS_MAP",get:function(){return s.PLATFORMS_MAP}}],(r=null)&&a(t.prototype,r),n&&a(t,n),e}();t.default=o,e.exports=t.default},91:function(e,t,r){"use strict";t.__esModule=!0,t.default=void 0;var n=u(r(92)),i=u(r(93)),s=u(r(94)),a=u(r(95)),o=u(r(17));function u(e){return e&&e.__esModule?e:{default:e}}var d=function(){function e(e,t){if(void 0===t&&(t=!1),null==e||""===e)throw new Error("UserAgent parameter can't be empty");this._ua=e,this.parsedResult={},!0!==t&&this.parse()}var t=e.prototype;return t.getUA=function(){return this._ua},t.test=function(e){return e.test(this._ua)},t.parseBrowser=function(){var e=this;this.parsedResult.browser={};var t=o.default.find(n.default,(function(t){if("function"==typeof t.test)return t.test(e);if(t.test instanceof Array)return t.test.some((function(t){return e.test(t)}));throw new Error("Browser's test function is not valid")}));return t&&(this.parsedResult.browser=t.describe(this.getUA())),this.parsedResult.browser},t.getBrowser=function(){return this.parsedResult.browser?this.parsedResult.browser:this.parseBrowser()},t.getBrowserName=function(e){return e?String(this.getBrowser().name).toLowerCase()||"":this.getBrowser().name||""},t.getBrowserVersion=function(){return this.getBrowser().version},t.getOS=function(){return this.parsedResult.os?this.parsedResult.os:this.parseOS()},t.parseOS=function(){var e=this;this.parsedResult.os={};var t=o.default.find(i.default,(function(t){if("function"==typeof t.test)return t.test(e);if(t.test instanceof Array)return t.test.some((function(t){return e.test(t)}));throw new Error("Browser's test function is not valid")}));return t&&(this.parsedResult.os=t.describe(this.getUA())),this.parsedResult.os},t.getOSName=function(e){var t=this.getOS().name;return e?String(t).toLowerCase()||"":t||""},t.getOSVersion=function(){return this.getOS().version},t.getPlatform=function(){return this.parsedResult.platform?this.parsedResult.platform:this.parsePlatform()},t.getPlatformType=function(e){void 0===e&&(e=!1);var t=this.getPlatform().type;return e?String(t).toLowerCase()||"":t||""},t.parsePlatform=function(){var e=this;this.parsedResult.platform={};var t=o.default.find(s.default,(function(t){if("function"==typeof t.test)return t.test(e);if(t.test instanceof Array)return t.test.some((function(t){return e.test(t)}));throw new Error("Browser's test function is not valid")}));return t&&(this.parsedResult.platform=t.describe(this.getUA())),this.parsedResult.platform},t.getEngine=function(){return this.parsedResult.engine?this.parsedResult.engine:this.parseEngine()},t.getEngineName=function(e){return e?String(this.getEngine().name).toLowerCase()||"":this.getEngine().name||""},t.parseEngine=function(){var e=this;this.parsedResult.engine={};var t=o.default.find(a.default,(function(t){if("function"==typeof t.test)return t.test(e);if(t.test instanceof Array)return t.test.some((function(t){return e.test(t)}));throw new Error("Browser's test function is not valid")}));return t&&(this.parsedResult.engine=t.describe(this.getUA())),this.parsedResult.engine},t.parse=function(){return this.parseBrowser(),this.parseOS(),this.parsePlatform(),this.parseEngine(),this},t.getResult=function(){return o.default.assign({},this.parsedResult)},t.satisfies=function(e){var t=this,r={},n=0,i={},s=0;if(Object.keys(e).forEach((function(t){var a=e[t];"string"==typeof a?(i[t]=a,s+=1):"object"==typeof a&&(r[t]=a,n+=1)})),n>0){var a=Object.keys(r),u=o.default.find(a,(function(e){return t.isOS(e)}));if(u){var d=this.satisfies(r[u]);if(void 0!==d)return d}var c=o.default.find(a,(function(e){return t.isPlatform(e)}));if(c){var f=this.satisfies(r[c]);if(void 0!==f)return f}}if(s>0){var l=Object.keys(i),h=o.default.find(l,(function(e){return t.isBrowser(e,!0)}));if(void 0!==h)return this.compareVersion(i[h])}},t.isBrowser=function(e,t){void 0===t&&(t=!1);var r=this.getBrowserName().toLowerCase(),n=e.toLowerCase(),i=o.default.getBrowserTypeByAlias(n);return t&&i&&(n=i.toLowerCase()),n===r},t.compareVersion=function(e){var t=[0],r=e,n=!1,i=this.getBrowserVersion();if("string"==typeof i)return">"===e[0]||"<"===e[0]?(r=e.substr(1),"="===e[1]?(n=!0,r=e.substr(2)):t=[],">"===e[0]?t.push(1):t.push(-1)):"="===e[0]?r=e.substr(1):"~"===e[0]&&(n=!0,r=e.substr(1)),t.indexOf(o.default.compareVersions(i,r,n))>-1},t.isOS=function(e){return this.getOSName(!0)===String(e).toLowerCase()},t.isPlatform=function(e){return this.getPlatformType(!0)===String(e).toLowerCase()},t.isEngine=function(e){return this.getEngineName(!0)===String(e).toLowerCase()},t.is=function(e,t){return void 0===t&&(t=!1),this.isBrowser(e,t)||this.isOS(e)||this.isPlatform(e)},t.some=function(e){var t=this;return void 0===e&&(e=[]),e.some((function(e){return t.is(e)}))},e}();t.default=d,e.exports=t.default},92:function(e,t,r){"use strict";t.__esModule=!0,t.default=void 0;var n,i=(n=r(17))&&n.__esModule?n:{default:n};var s=/version\/(\d+(\.?_?\d+)+)/i,a=[{test:[/googlebot/i],describe:function(e){var t={name:"Googlebot"},r=i.default.getFirstMatch(/googlebot\/(\d+(\.\d+))/i,e)||i.default.getFirstMatch(s,e);return r&&(t.version=r),t}},{test:[/opera/i],describe:function(e){var t={name:"Opera"},r=i.default.getFirstMatch(s,e)||i.default.getFirstMatch(/(?:opera)[\s/](\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/opr\/|opios/i],describe:function(e){var t={name:"Opera"},r=i.default.getFirstMatch(/(?:opr|opios)[\s/](\S+)/i,e)||i.default.getFirstMatch(s,e);return r&&(t.version=r),t}},{test:[/SamsungBrowser/i],describe:function(e){var t={name:"Samsung Internet for Android"},r=i.default.getFirstMatch(s,e)||i.default.getFirstMatch(/(?:SamsungBrowser)[\s/](\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/Whale/i],describe:function(e){var t={name:"NAVER Whale Browser"},r=i.default.getFirstMatch(s,e)||i.default.getFirstMatch(/(?:whale)[\s/](\d+(?:\.\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/MZBrowser/i],describe:function(e){var t={name:"MZ Browser"},r=i.default.getFirstMatch(/(?:MZBrowser)[\s/](\d+(?:\.\d+)+)/i,e)||i.default.getFirstMatch(s,e);return r&&(t.version=r),t}},{test:[/focus/i],describe:function(e){var t={name:"Focus"},r=i.default.getFirstMatch(/(?:focus)[\s/](\d+(?:\.\d+)+)/i,e)||i.default.getFirstMatch(s,e);return r&&(t.version=r),t}},{test:[/swing/i],describe:function(e){var t={name:"Swing"},r=i.default.getFirstMatch(/(?:swing)[\s/](\d+(?:\.\d+)+)/i,e)||i.default.getFirstMatch(s,e);return r&&(t.version=r),t}},{test:[/coast/i],describe:function(e){var t={name:"Opera Coast"},r=i.default.getFirstMatch(s,e)||i.default.getFirstMatch(/(?:coast)[\s/](\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/opt\/\d+(?:.?_?\d+)+/i],describe:function(e){var t={name:"Opera Touch"},r=i.default.getFirstMatch(/(?:opt)[\s/](\d+(\.?_?\d+)+)/i,e)||i.default.getFirstMatch(s,e);return r&&(t.version=r),t}},{test:[/yabrowser/i],describe:function(e){var t={name:"Yandex Browser"},r=i.default.getFirstMatch(/(?:yabrowser)[\s/](\d+(\.?_?\d+)+)/i,e)||i.default.getFirstMatch(s,e);return r&&(t.version=r),t}},{test:[/ucbrowser/i],describe:function(e){var t={name:"UC Browser"},r=i.default.getFirstMatch(s,e)||i.default.getFirstMatch(/(?:ucbrowser)[\s/](\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/Maxthon|mxios/i],describe:function(e){var t={name:"Maxthon"},r=i.default.getFirstMatch(s,e)||i.default.getFirstMatch(/(?:Maxthon|mxios)[\s/](\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/epiphany/i],describe:function(e){var t={name:"Epiphany"},r=i.default.getFirstMatch(s,e)||i.default.getFirstMatch(/(?:epiphany)[\s/](\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/puffin/i],describe:function(e){var t={name:"Puffin"},r=i.default.getFirstMatch(s,e)||i.default.getFirstMatch(/(?:puffin)[\s/](\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/sleipnir/i],describe:function(e){var t={name:"Sleipnir"},r=i.default.getFirstMatch(s,e)||i.default.getFirstMatch(/(?:sleipnir)[\s/](\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/k-meleon/i],describe:function(e){var t={name:"K-Meleon"},r=i.default.getFirstMatch(s,e)||i.default.getFirstMatch(/(?:k-meleon)[\s/](\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/micromessenger/i],describe:function(e){var t={name:"WeChat"},r=i.default.getFirstMatch(/(?:micromessenger)[\s/](\d+(\.?_?\d+)+)/i,e)||i.default.getFirstMatch(s,e);return r&&(t.version=r),t}},{test:[/qqbrowser/i],describe:function(e){var t={name:/qqbrowserlite/i.test(e)?"QQ Browser Lite":"QQ Browser"},r=i.default.getFirstMatch(/(?:qqbrowserlite|qqbrowser)[/](\d+(\.?_?\d+)+)/i,e)||i.default.getFirstMatch(s,e);return r&&(t.version=r),t}},{test:[/msie|trident/i],describe:function(e){var t={name:"Internet Explorer"},r=i.default.getFirstMatch(/(?:msie |rv:)(\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/\sedg\//i],describe:function(e){var t={name:"Microsoft Edge"},r=i.default.getFirstMatch(/\sedg\/(\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/edg([ea]|ios)/i],describe:function(e){var t={name:"Microsoft Edge"},r=i.default.getSecondMatch(/edg([ea]|ios)\/(\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/vivaldi/i],describe:function(e){var t={name:"Vivaldi"},r=i.default.getFirstMatch(/vivaldi\/(\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/seamonkey/i],describe:function(e){var t={name:"SeaMonkey"},r=i.default.getFirstMatch(/seamonkey\/(\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/sailfish/i],describe:function(e){var t={name:"Sailfish"},r=i.default.getFirstMatch(/sailfish\s?browser\/(\d+(\.\d+)?)/i,e);return r&&(t.version=r),t}},{test:[/silk/i],describe:function(e){var t={name:"Amazon Silk"},r=i.default.getFirstMatch(/silk\/(\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/phantom/i],describe:function(e){var t={name:"PhantomJS"},r=i.default.getFirstMatch(/phantomjs\/(\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/slimerjs/i],describe:function(e){var t={name:"SlimerJS"},r=i.default.getFirstMatch(/slimerjs\/(\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/blackberry|\bbb\d+/i,/rim\stablet/i],describe:function(e){var t={name:"BlackBerry"},r=i.default.getFirstMatch(s,e)||i.default.getFirstMatch(/blackberry[\d]+\/(\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/(web|hpw)[o0]s/i],describe:function(e){var t={name:"WebOS Browser"},r=i.default.getFirstMatch(s,e)||i.default.getFirstMatch(/w(?:eb)?[o0]sbrowser\/(\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/bada/i],describe:function(e){var t={name:"Bada"},r=i.default.getFirstMatch(/dolfin\/(\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/tizen/i],describe:function(e){var t={name:"Tizen"},r=i.default.getFirstMatch(/(?:tizen\s?)?browser\/(\d+(\.?_?\d+)+)/i,e)||i.default.getFirstMatch(s,e);return r&&(t.version=r),t}},{test:[/qupzilla/i],describe:function(e){var t={name:"QupZilla"},r=i.default.getFirstMatch(/(?:qupzilla)[\s/](\d+(\.?_?\d+)+)/i,e)||i.default.getFirstMatch(s,e);return r&&(t.version=r),t}},{test:[/firefox|iceweasel|fxios/i],describe:function(e){var t={name:"Firefox"},r=i.default.getFirstMatch(/(?:firefox|iceweasel|fxios)[\s/](\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/electron/i],describe:function(e){var t={name:"Electron"},r=i.default.getFirstMatch(/(?:electron)\/(\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/MiuiBrowser/i],describe:function(e){var t={name:"Miui"},r=i.default.getFirstMatch(/(?:MiuiBrowser)[\s/](\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/chromium/i],describe:function(e){var t={name:"Chromium"},r=i.default.getFirstMatch(/(?:chromium)[\s/](\d+(\.?_?\d+)+)/i,e)||i.default.getFirstMatch(s,e);return r&&(t.version=r),t}},{test:[/chrome|crios|crmo/i],describe:function(e){var t={name:"Chrome"},r=i.default.getFirstMatch(/(?:chrome|crios|crmo)\/(\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/GSA/i],describe:function(e){var t={name:"Google Search"},r=i.default.getFirstMatch(/(?:GSA)\/(\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:function(e){var t=!e.test(/like android/i),r=e.test(/android/i);return t&&r},describe:function(e){var t={name:"Android Browser"},r=i.default.getFirstMatch(s,e);return r&&(t.version=r),t}},{test:[/playstation 4/i],describe:function(e){var t={name:"PlayStation 4"},r=i.default.getFirstMatch(s,e);return r&&(t.version=r),t}},{test:[/safari|applewebkit/i],describe:function(e){var t={name:"Safari"},r=i.default.getFirstMatch(s,e);return r&&(t.version=r),t}},{test:[/.*/i],describe:function(e){var t=-1!==e.search("\\(")?/^(.*)\/(.*)[ \t]\((.*)/:/^(.*)\/(.*) /;return{name:i.default.getFirstMatch(t,e),version:i.default.getSecondMatch(t,e)}}}];t.default=a,e.exports=t.default},93:function(e,t,r){"use strict";t.__esModule=!0,t.default=void 0;var n,i=(n=r(17))&&n.__esModule?n:{default:n},s=r(18);var a=[{test:[/Roku\/DVP/],describe:function(e){var t=i.default.getFirstMatch(/Roku\/DVP-(\d+\.\d+)/i,e);return{name:s.OS_MAP.Roku,version:t}}},{test:[/windows phone/i],describe:function(e){var t=i.default.getFirstMatch(/windows phone (?:os)?\s?(\d+(\.\d+)*)/i,e);return{name:s.OS_MAP.WindowsPhone,version:t}}},{test:[/windows /i],describe:function(e){var t=i.default.getFirstMatch(/Windows ((NT|XP)( \d\d?.\d)?)/i,e),r=i.default.getWindowsVersionName(t);return{name:s.OS_MAP.Windows,version:t,versionName:r}}},{test:[/Macintosh(.*?) FxiOS(.*?)\//],describe:function(e){var t={name:s.OS_MAP.iOS},r=i.default.getSecondMatch(/(Version\/)(\d[\d.]+)/,e);return r&&(t.version=r),t}},{test:[/macintosh/i],describe:function(e){var t=i.default.getFirstMatch(/mac os x (\d+(\.?_?\d+)+)/i,e).replace(/[_\s]/g,"."),r=i.default.getMacOSVersionName(t),n={name:s.OS_MAP.MacOS,version:t};return r&&(n.versionName=r),n}},{test:[/(ipod|iphone|ipad)/i],describe:function(e){var t=i.default.getFirstMatch(/os (\d+([_\s]\d+)*) like mac os x/i,e).replace(/[_\s]/g,".");return{name:s.OS_MAP.iOS,version:t}}},{test:function(e){var t=!e.test(/like android/i),r=e.test(/android/i);return t&&r},describe:function(e){var t=i.default.getFirstMatch(/android[\s/-](\d+(\.\d+)*)/i,e),r=i.default.getAndroidVersionName(t),n={name:s.OS_MAP.Android,version:t};return r&&(n.versionName=r),n}},{test:[/(web|hpw)[o0]s/i],describe:function(e){var t=i.default.getFirstMatch(/(?:web|hpw)[o0]s\/(\d+(\.\d+)*)/i,e),r={name:s.OS_MAP.WebOS};return t&&t.length&&(r.version=t),r}},{test:[/blackberry|\bbb\d+/i,/rim\stablet/i],describe:function(e){var t=i.default.getFirstMatch(/rim\stablet\sos\s(\d+(\.\d+)*)/i,e)||i.default.getFirstMatch(/blackberry\d+\/(\d+([_\s]\d+)*)/i,e)||i.default.getFirstMatch(/\bbb(\d+)/i,e);return{name:s.OS_MAP.BlackBerry,version:t}}},{test:[/bada/i],describe:function(e){var t=i.default.getFirstMatch(/bada\/(\d+(\.\d+)*)/i,e);return{name:s.OS_MAP.Bada,version:t}}},{test:[/tizen/i],describe:function(e){var t=i.default.getFirstMatch(/tizen[/\s](\d+(\.\d+)*)/i,e);return{name:s.OS_MAP.Tizen,version:t}}},{test:[/linux/i],describe:function(){return{name:s.OS_MAP.Linux}}},{test:[/CrOS/],describe:function(){return{name:s.OS_MAP.ChromeOS}}},{test:[/PlayStation 4/],describe:function(e){var t=i.default.getFirstMatch(/PlayStation 4[/\s](\d+(\.\d+)*)/i,e);return{name:s.OS_MAP.PlayStation4,version:t}}}];t.default=a,e.exports=t.default},94:function(e,t,r){"use strict";t.__esModule=!0,t.default=void 0;var n,i=(n=r(17))&&n.__esModule?n:{default:n},s=r(18);var a=[{test:[/googlebot/i],describe:function(){return{type:"bot",vendor:"Google"}}},{test:[/huawei/i],describe:function(e){var t=i.default.getFirstMatch(/(can-l01)/i,e)&&"Nova",r={type:s.PLATFORMS_MAP.mobile,vendor:"Huawei"};return t&&(r.model=t),r}},{test:[/nexus\s*(?:7|8|9|10).*/i],describe:function(){return{type:s.PLATFORMS_MAP.tablet,vendor:"Nexus"}}},{test:[/ipad/i],describe:function(){return{type:s.PLATFORMS_MAP.tablet,vendor:"Apple",model:"iPad"}}},{test:[/Macintosh(.*?) FxiOS(.*?)\//],describe:function(){return{type:s.PLATFORMS_MAP.tablet,vendor:"Apple",model:"iPad"}}},{test:[/kftt build/i],describe:function(){return{type:s.PLATFORMS_MAP.tablet,vendor:"Amazon",model:"Kindle Fire HD 7"}}},{test:[/silk/i],describe:function(){return{type:s.PLATFORMS_MAP.tablet,vendor:"Amazon"}}},{test:[/tablet(?! pc)/i],describe:function(){return{type:s.PLATFORMS_MAP.tablet}}},{test:function(e){var t=e.test(/ipod|iphone/i),r=e.test(/like (ipod|iphone)/i);return t&&!r},describe:function(e){var t=i.default.getFirstMatch(/(ipod|iphone)/i,e);return{type:s.PLATFORMS_MAP.mobile,vendor:"Apple",model:t}}},{test:[/nexus\s*[0-6].*/i,/galaxy nexus/i],describe:function(){return{type:s.PLATFORMS_MAP.mobile,vendor:"Nexus"}}},{test:[/[^-]mobi/i],describe:function(){return{type:s.PLATFORMS_MAP.mobile}}},{test:function(e){return"blackberry"===e.getBrowserName(!0)},describe:function(){return{type:s.PLATFORMS_MAP.mobile,vendor:"BlackBerry"}}},{test:function(e){return"bada"===e.getBrowserName(!0)},describe:function(){return{type:s.PLATFORMS_MAP.mobile}}},{test:function(e){return"windows phone"===e.getBrowserName()},describe:function(){return{type:s.PLATFORMS_MAP.mobile,vendor:"Microsoft"}}},{test:function(e){var t=Number(String(e.getOSVersion()).split(".")[0]);return"android"===e.getOSName(!0)&&t>=3},describe:function(){return{type:s.PLATFORMS_MAP.tablet}}},{test:function(e){return"android"===e.getOSName(!0)},describe:function(){return{type:s.PLATFORMS_MAP.mobile}}},{test:function(e){return"macos"===e.getOSName(!0)},describe:function(){return{type:s.PLATFORMS_MAP.desktop,vendor:"Apple"}}},{test:function(e){return"windows"===e.getOSName(!0)},describe:function(){return{type:s.PLATFORMS_MAP.desktop}}},{test:function(e){return"linux"===e.getOSName(!0)},describe:function(){return{type:s.PLATFORMS_MAP.desktop}}},{test:function(e){return"playstation 4"===e.getOSName(!0)},describe:function(){return{type:s.PLATFORMS_MAP.tv}}},{test:function(e){return"roku"===e.getOSName(!0)},describe:function(){return{type:s.PLATFORMS_MAP.tv}}}];t.default=a,e.exports=t.default},95:function(e,t,r){"use strict";t.__esModule=!0,t.default=void 0;var n,i=(n=r(17))&&n.__esModule?n:{default:n},s=r(18);var a=[{test:function(e){return"microsoft edge"===e.getBrowserName(!0)},describe:function(e){if(/\sedg\//i.test(e))return{name:s.ENGINE_MAP.Blink};var t=i.default.getFirstMatch(/edge\/(\d+(\.?_?\d+)+)/i,e);return{name:s.ENGINE_MAP.EdgeHTML,version:t}}},{test:[/trident/i],describe:function(e){var t={name:s.ENGINE_MAP.Trident},r=i.default.getFirstMatch(/trident\/(\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:function(e){return e.test(/presto/i)},describe:function(e){var t={name:s.ENGINE_MAP.Presto},r=i.default.getFirstMatch(/presto\/(\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:function(e){var t=e.test(/gecko/i),r=e.test(/like gecko/i);return t&&!r},describe:function(e){var t={name:s.ENGINE_MAP.Gecko},r=i.default.getFirstMatch(/gecko\/(\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/(apple)?webkit\/537\.36/i],describe:function(){return{name:s.ENGINE_MAP.Blink}}},{test:[/(apple)?webkit/i],describe:function(e){var t={name:s.ENGINE_MAP.WebKit},r=i.default.getFirstMatch(/webkit\/(\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}}];t.default=a,e.exports=t.default}})}));
},{}],8:[function(require,module,exports){

},{}],9:[function(require,module,exports){
arguments[4][8][0].apply(exports,arguments)
},{"dup":8}],10:[function(require,module,exports){
'use strict';

var GetIntrinsic = require('get-intrinsic');

var callBind = require('./');

var $indexOf = callBind(GetIntrinsic('String.prototype.indexOf'));

module.exports = function callBoundIntrinsic(name, allowMissing) {
	var intrinsic = GetIntrinsic(name, !!allowMissing);
	if (typeof intrinsic === 'function' && $indexOf(name, '.prototype.') > -1) {
		return callBind(intrinsic);
	}
	return intrinsic;
};

},{"./":11,"get-intrinsic":47}],11:[function(require,module,exports){
'use strict';

var bind = require('function-bind');
var GetIntrinsic = require('get-intrinsic');

var $apply = GetIntrinsic('%Function.prototype.apply%');
var $call = GetIntrinsic('%Function.prototype.call%');
var $reflectApply = GetIntrinsic('%Reflect.apply%', true) || bind.call($call, $apply);

var $gOPD = GetIntrinsic('%Object.getOwnPropertyDescriptor%', true);
var $defineProperty = GetIntrinsic('%Object.defineProperty%', true);
var $max = GetIntrinsic('%Math.max%');

if ($defineProperty) {
	try {
		$defineProperty({}, 'a', { value: 1 });
	} catch (e) {
		// IE 8 has a broken defineProperty
		$defineProperty = null;
	}
}

module.exports = function callBind(originalFunction) {
	var func = $reflectApply(bind, $call, arguments);
	if ($gOPD && $defineProperty) {
		var desc = $gOPD(func, 'length');
		if (desc.configurable) {
			// original length, plus the receiver, minus any additional arguments (after the receiver)
			$defineProperty(
				func,
				'length',
				{ value: 1 + $max(0, originalFunction.length - (arguments.length - 1)) }
			);
		}
	}
	return func;
};

var applyBind = function applyBind() {
	return $reflectApply(bind, $apply, arguments);
};

if ($defineProperty) {
	$defineProperty(module.exports, 'apply', { value: applyBind });
} else {
	module.exports.apply = applyBind;
}

},{"function-bind":45,"get-intrinsic":47}],12:[function(require,module,exports){
'use strict';

var keys = require('object-keys');
var hasSymbols = typeof Symbol === 'function' && typeof Symbol('foo') === 'symbol';

var toStr = Object.prototype.toString;
var concat = Array.prototype.concat;
var origDefineProperty = Object.defineProperty;

var isFunction = function (fn) {
	return typeof fn === 'function' && toStr.call(fn) === '[object Function]';
};

var hasPropertyDescriptors = require('has-property-descriptors')();

var supportsDescriptors = origDefineProperty && hasPropertyDescriptors;

var defineProperty = function (object, name, value, predicate) {
	if (name in object && (!isFunction(predicate) || !predicate())) {
		return;
	}
	if (supportsDescriptors) {
		origDefineProperty(object, name, {
			configurable: true,
			enumerable: false,
			value: value,
			writable: true
		});
	} else {
		object[name] = value; // eslint-disable-line no-param-reassign
	}
};

var defineProperties = function (object, map) {
	var predicates = arguments.length > 2 ? arguments[2] : {};
	var props = keys(map);
	if (hasSymbols) {
		props = concat.call(props, Object.getOwnPropertySymbols(map));
	}
	for (var i = 0; i < props.length; i += 1) {
		defineProperty(object, props[i], map[props[i]], predicates[props[i]]);
	}
};

defineProperties.supportsDescriptors = !!supportsDescriptors;

module.exports = defineProperties;

},{"has-property-descriptors":48,"object-keys":160}],13:[function(require,module,exports){
function polyfill(window) {
  var ElementPrototype = window.Element.prototype;

  if (typeof ElementPrototype.matches !== 'function') {
    ElementPrototype.matches = ElementPrototype.msMatchesSelector || ElementPrototype.mozMatchesSelector || ElementPrototype.webkitMatchesSelector || function matches(selector) {
      var element = this;
      var elements = (element.document || element.ownerDocument).querySelectorAll(selector);
      var index = 0;

      while (elements[index] && elements[index] !== element) {
        ++index;
      }

      return Boolean(elements[index]);
    };
  }

  if (typeof ElementPrototype.closest !== 'function') {
    ElementPrototype.closest = function closest(selector) {
      var element = this;

      while (element && element.nodeType === 1) {
        if (element.matches(selector)) {
          return element;
        }

        element = element.parentNode;
      }

      return null;
    };
  }
}

module.exports = polyfill;
//# sourceMappingURL=index.js.map

},{}],14:[function(require,module,exports){
'use strict';

var GetIntrinsic = require('get-intrinsic');
var callBound = require('call-bind/callBound');

var $TypeError = GetIntrinsic('%TypeError%');

var IsArray = require('./IsArray');

var $apply = GetIntrinsic('%Reflect.apply%', true) || callBound('%Function.prototype.apply%');

// https://ecma-international.org/ecma-262/6.0/#sec-call

module.exports = function Call(F, V) {
	var argumentsList = arguments.length > 2 ? arguments[2] : [];
	if (!IsArray(argumentsList)) {
		throw new $TypeError('Assertion failed: optional `argumentsList`, if provided, must be a List');
	}
	return $apply(F, V, argumentsList);
};

},{"./IsArray":17,"call-bind/callBound":10,"get-intrinsic":47}],15:[function(require,module,exports){
'use strict';

var GetIntrinsic = require('get-intrinsic');

var $TypeError = GetIntrinsic('%TypeError%');

var inspect = require('object-inspect');

var IsPropertyKey = require('./IsPropertyKey');
var Type = require('./Type');

// https://ecma-international.org/ecma-262/6.0/#sec-get-o-p

module.exports = function Get(O, P) {
	// 7.3.1.1
	if (Type(O) !== 'Object') {
		throw new $TypeError('Assertion failed: Type(O) is not Object');
	}
	// 7.3.1.2
	if (!IsPropertyKey(P)) {
		throw new $TypeError('Assertion failed: IsPropertyKey(P) is not true, got ' + inspect(P));
	}
	// 7.3.1.3
	return O[P];
};

},{"./IsPropertyKey":19,"./Type":28,"get-intrinsic":47,"object-inspect":158}],16:[function(require,module,exports){
'use strict';

var GetIntrinsic = require('get-intrinsic');

var $TypeError = GetIntrinsic('%TypeError%');

var IsPropertyKey = require('./IsPropertyKey');
var Type = require('./Type');

// https://ecma-international.org/ecma-262/6.0/#sec-hasproperty

module.exports = function HasProperty(O, P) {
	if (Type(O) !== 'Object') {
		throw new $TypeError('Assertion failed: `O` must be an Object');
	}
	if (!IsPropertyKey(P)) {
		throw new $TypeError('Assertion failed: `P` must be a Property Key');
	}
	return P in O;
};

},{"./IsPropertyKey":19,"./Type":28,"get-intrinsic":47}],17:[function(require,module,exports){
'use strict';

// https://ecma-international.org/ecma-262/6.0/#sec-isarray
module.exports = require('../helpers/IsArray');

},{"../helpers/IsArray":33}],18:[function(require,module,exports){
'use strict';

// http://262.ecma-international.org/5.1/#sec-9.11

module.exports = require('is-callable');

},{"is-callable":53}],19:[function(require,module,exports){
'use strict';

// https://ecma-international.org/ecma-262/6.0/#sec-ispropertykey

module.exports = function IsPropertyKey(argument) {
	return typeof argument === 'string' || typeof argument === 'symbol';
};

},{}],20:[function(require,module,exports){
'use strict';

var GetIntrinsic = require('get-intrinsic');

var $TypeError = GetIntrinsic('%TypeError%');

var Get = require('./Get');
var ToLength = require('./ToLength');
var Type = require('./Type');

// https://262.ecma-international.org/11.0/#sec-lengthofarraylike

module.exports = function LengthOfArrayLike(obj) {
	if (Type(obj) !== 'Object') {
		throw new $TypeError('Assertion failed: `obj` must be an Object');
	}
	return ToLength(Get(obj, 'length'));
};

// TODO: use this all over

},{"./Get":15,"./ToLength":23,"./Type":28,"get-intrinsic":47}],21:[function(require,module,exports){
'use strict';

module.exports = require('../5/CheckObjectCoercible');

},{"../5/CheckObjectCoercible":31}],22:[function(require,module,exports){
'use strict';

var abs = require('./abs');
var floor = require('./floor');
var ToNumber = require('./ToNumber');

var $isNaN = require('../helpers/isNaN');
var $isFinite = require('../helpers/isFinite');
var $sign = require('../helpers/sign');

// https://262.ecma-international.org/12.0/#sec-tointegerorinfinity

module.exports = function ToIntegerOrInfinity(value) {
	var number = ToNumber(value);
	if ($isNaN(number) || number === 0) { return 0; }
	if (!$isFinite(number)) { return number; }
	return $sign(number) * floor(abs(number));
};

},{"../helpers/isFinite":34,"../helpers/isNaN":35,"../helpers/sign":39,"./ToNumber":24,"./abs":29,"./floor":30}],23:[function(require,module,exports){
'use strict';

var MAX_SAFE_INTEGER = require('../helpers/maxSafeInteger');

var ToIntegerOrInfinity = require('./ToIntegerOrInfinity');

module.exports = function ToLength(argument) {
	var len = ToIntegerOrInfinity(argument);
	if (len <= 0) { return 0; } // includes converting -0 to +0
	if (len > MAX_SAFE_INTEGER) { return MAX_SAFE_INTEGER; }
	return len;
};

},{"../helpers/maxSafeInteger":37,"./ToIntegerOrInfinity":22}],24:[function(require,module,exports){
'use strict';

var GetIntrinsic = require('get-intrinsic');

var $TypeError = GetIntrinsic('%TypeError%');
var $Number = GetIntrinsic('%Number%');
var $RegExp = GetIntrinsic('%RegExp%');
var $parseInteger = GetIntrinsic('%parseInt%');

var callBound = require('call-bind/callBound');
var regexTester = require('../helpers/regexTester');
var isPrimitive = require('../helpers/isPrimitive');

var $strSlice = callBound('String.prototype.slice');
var isBinary = regexTester(/^0b[01]+$/i);
var isOctal = regexTester(/^0o[0-7]+$/i);
var isInvalidHexLiteral = regexTester(/^[-+]0x[0-9a-f]+$/i);
var nonWS = ['\u0085', '\u200b', '\ufffe'].join('');
var nonWSregex = new $RegExp('[' + nonWS + ']', 'g');
var hasNonWS = regexTester(nonWSregex);

// whitespace from: https://es5.github.io/#x15.5.4.20
// implementation from https://github.com/es-shims/es5-shim/blob/v3.4.0/es5-shim.js#L1304-L1324
var ws = [
	'\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003',
	'\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028',
	'\u2029\uFEFF'
].join('');
var trimRegex = new RegExp('(^[' + ws + ']+)|([' + ws + ']+$)', 'g');
var $replace = callBound('String.prototype.replace');
var $trim = function (value) {
	return $replace(value, trimRegex, '');
};

var ToPrimitive = require('./ToPrimitive');

// https://ecma-international.org/ecma-262/6.0/#sec-tonumber

module.exports = function ToNumber(argument) {
	var value = isPrimitive(argument) ? argument : ToPrimitive(argument, $Number);
	if (typeof value === 'symbol') {
		throw new $TypeError('Cannot convert a Symbol value to a number');
	}
	if (typeof value === 'bigint') {
		throw new $TypeError('Conversion from \'BigInt\' to \'number\' is not allowed.');
	}
	if (typeof value === 'string') {
		if (isBinary(value)) {
			return ToNumber($parseInteger($strSlice(value, 2), 2));
		} else if (isOctal(value)) {
			return ToNumber($parseInteger($strSlice(value, 2), 8));
		} else if (hasNonWS(value) || isInvalidHexLiteral(value)) {
			return NaN;
		}
		var trimmed = $trim(value);
		if (trimmed !== value) {
			return ToNumber(trimmed);
		}

	}
	return $Number(value);
};

},{"../helpers/isPrimitive":36,"../helpers/regexTester":38,"./ToPrimitive":26,"call-bind/callBound":10,"get-intrinsic":47}],25:[function(require,module,exports){
'use strict';

var GetIntrinsic = require('get-intrinsic');

var $Object = GetIntrinsic('%Object%');

var RequireObjectCoercible = require('./RequireObjectCoercible');

// https://ecma-international.org/ecma-262/6.0/#sec-toobject

module.exports = function ToObject(value) {
	RequireObjectCoercible(value);
	return $Object(value);
};

},{"./RequireObjectCoercible":21,"get-intrinsic":47}],26:[function(require,module,exports){
'use strict';

var toPrimitive = require('es-to-primitive/es2015');

// https://ecma-international.org/ecma-262/6.0/#sec-toprimitive

module.exports = function ToPrimitive(input) {
	if (arguments.length > 1) {
		return toPrimitive(input, arguments[1]);
	}
	return toPrimitive(input);
};

},{"es-to-primitive/es2015":41}],27:[function(require,module,exports){
'use strict';

var GetIntrinsic = require('get-intrinsic');

var $String = GetIntrinsic('%String%');
var $TypeError = GetIntrinsic('%TypeError%');

// https://ecma-international.org/ecma-262/6.0/#sec-tostring

module.exports = function ToString(argument) {
	if (typeof argument === 'symbol') {
		throw new $TypeError('Cannot convert a Symbol value to a string');
	}
	return $String(argument);
};

},{"get-intrinsic":47}],28:[function(require,module,exports){
'use strict';

var ES5Type = require('../5/Type');

// https://262.ecma-international.org/11.0/#sec-ecmascript-data-types-and-values

module.exports = function Type(x) {
	if (typeof x === 'symbol') {
		return 'Symbol';
	}
	if (typeof x === 'bigint') {
		return 'BigInt';
	}
	return ES5Type(x);
};

},{"../5/Type":32}],29:[function(require,module,exports){
'use strict';

var GetIntrinsic = require('get-intrinsic');

var $abs = GetIntrinsic('%Math.abs%');

// http://262.ecma-international.org/5.1/#sec-5.2

module.exports = function abs(x) {
	return $abs(x);
};

},{"get-intrinsic":47}],30:[function(require,module,exports){
'use strict';

// var modulo = require('./modulo');
var $floor = Math.floor;

// http://262.ecma-international.org/5.1/#sec-5.2

module.exports = function floor(x) {
	// return x - modulo(x, 1);
	return $floor(x);
};

},{}],31:[function(require,module,exports){
'use strict';

var GetIntrinsic = require('get-intrinsic');

var $TypeError = GetIntrinsic('%TypeError%');

// http://262.ecma-international.org/5.1/#sec-9.10

module.exports = function CheckObjectCoercible(value, optMessage) {
	if (value == null) {
		throw new $TypeError(optMessage || ('Cannot call method on ' + value));
	}
	return value;
};

},{"get-intrinsic":47}],32:[function(require,module,exports){
'use strict';

// https://262.ecma-international.org/5.1/#sec-8

module.exports = function Type(x) {
	if (x === null) {
		return 'Null';
	}
	if (typeof x === 'undefined') {
		return 'Undefined';
	}
	if (typeof x === 'function' || typeof x === 'object') {
		return 'Object';
	}
	if (typeof x === 'number') {
		return 'Number';
	}
	if (typeof x === 'boolean') {
		return 'Boolean';
	}
	if (typeof x === 'string') {
		return 'String';
	}
};

},{}],33:[function(require,module,exports){
'use strict';

var GetIntrinsic = require('get-intrinsic');

var $Array = GetIntrinsic('%Array%');

// eslint-disable-next-line global-require
var toStr = !$Array.isArray && require('call-bind/callBound')('Object.prototype.toString');

module.exports = $Array.isArray || function IsArray(argument) {
	return toStr(argument) === '[object Array]';
};

},{"call-bind/callBound":10,"get-intrinsic":47}],34:[function(require,module,exports){
'use strict';

var $isNaN = Number.isNaN || function (a) { return a !== a; };

module.exports = Number.isFinite || function (x) { return typeof x === 'number' && !$isNaN(x) && x !== Infinity && x !== -Infinity; };

},{}],35:[function(require,module,exports){
'use strict';

module.exports = Number.isNaN || function isNaN(a) {
	return a !== a;
};

},{}],36:[function(require,module,exports){
'use strict';

module.exports = function isPrimitive(value) {
	return value === null || (typeof value !== 'function' && typeof value !== 'object');
};

},{}],37:[function(require,module,exports){
'use strict';

var GetIntrinsic = require('get-intrinsic');

var $Math = GetIntrinsic('%Math%');
var $Number = GetIntrinsic('%Number%');

module.exports = $Number.MAX_SAFE_INTEGER || $Math.pow(2, 53) - 1;

},{"get-intrinsic":47}],38:[function(require,module,exports){
'use strict';

var callBound = require('call-bind/callBound');

var $exec = callBound('RegExp.prototype.exec');

module.exports = function regexTester(regex) {
	return function test(s) { return $exec(regex, s) !== null; };
};

},{"call-bind/callBound":10}],39:[function(require,module,exports){
'use strict';

module.exports = function sign(number) {
	return number >= 0 ? 1 : -1;
};

},{}],40:[function(require,module,exports){
module.exports = function properlyBoxed(method) {
	// Check node 0.6.21 bug where third parameter is not boxed
	var properlyBoxesNonStrict = true;
	var properlyBoxesStrict = true;
	var threwException = false;
	if (typeof method === 'function') {
		try {
			// eslint-disable-next-line max-params
			method.call('f', function (_, __, O) {
				if (typeof O !== 'object') {
					properlyBoxesNonStrict = false;
				}
			});

			method.call(
				[null],
				function () {
					'use strict';

					properlyBoxesStrict = typeof this === 'string'; // eslint-disable-line no-invalid-this
				},
				'x'
			);
		} catch (e) {
			threwException = true;
		}
		return !threwException && properlyBoxesNonStrict && properlyBoxesStrict;
	}
	return false;
};

},{}],41:[function(require,module,exports){
'use strict';

var hasSymbols = typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol';

var isPrimitive = require('./helpers/isPrimitive');
var isCallable = require('is-callable');
var isDate = require('is-date-object');
var isSymbol = require('is-symbol');

var ordinaryToPrimitive = function OrdinaryToPrimitive(O, hint) {
	if (typeof O === 'undefined' || O === null) {
		throw new TypeError('Cannot call method on ' + O);
	}
	if (typeof hint !== 'string' || (hint !== 'number' && hint !== 'string')) {
		throw new TypeError('hint must be "string" or "number"');
	}
	var methodNames = hint === 'string' ? ['toString', 'valueOf'] : ['valueOf', 'toString'];
	var method, result, i;
	for (i = 0; i < methodNames.length; ++i) {
		method = O[methodNames[i]];
		if (isCallable(method)) {
			result = method.call(O);
			if (isPrimitive(result)) {
				return result;
			}
		}
	}
	throw new TypeError('No default value');
};

var GetMethod = function GetMethod(O, P) {
	var func = O[P];
	if (func !== null && typeof func !== 'undefined') {
		if (!isCallable(func)) {
			throw new TypeError(func + ' returned for property ' + P + ' of object ' + O + ' is not a function');
		}
		return func;
	}
	return void 0;
};

// http://www.ecma-international.org/ecma-262/6.0/#sec-toprimitive
module.exports = function ToPrimitive(input) {
	if (isPrimitive(input)) {
		return input;
	}
	var hint = 'default';
	if (arguments.length > 1) {
		if (arguments[1] === String) {
			hint = 'string';
		} else if (arguments[1] === Number) {
			hint = 'number';
		}
	}

	var exoticToPrim;
	if (hasSymbols) {
		if (Symbol.toPrimitive) {
			exoticToPrim = GetMethod(input, Symbol.toPrimitive);
		} else if (isSymbol(input)) {
			exoticToPrim = Symbol.prototype.valueOf;
		}
	}
	if (typeof exoticToPrim !== 'undefined') {
		var result = exoticToPrim.call(input, hint);
		if (isPrimitive(result)) {
			return result;
		}
		throw new TypeError('unable to convert exotic object to primitive');
	}
	if (hint === 'default' && (isDate(input) || isSymbol(input))) {
		hint = 'string';
	}
	return ordinaryToPrimitive(input, hint === 'default' ? 'number' : hint);
};

},{"./helpers/isPrimitive":42,"is-callable":53,"is-date-object":54,"is-symbol":56}],42:[function(require,module,exports){
arguments[4][36][0].apply(exports,arguments)
},{"dup":36}],43:[function(require,module,exports){
(function(root,factory){if(typeof exports==="object"&&typeof module==="object")module.exports=factory();else if(typeof define==="function"&&define.amd)define("EventBus",[],factory);else if(typeof exports==="object")exports["EventBus"]=factory();else root["EventBus"]=factory()})(this,function(){var EventBusClass={};EventBusClass=function(){this.listeners={}};EventBusClass.prototype={addEventListener:function(type,callback,scope){var args=[];var numOfArgs=arguments.length;for(var i=0;i<numOfArgs;i++){args.push(arguments[i])}args=args.length>3?args.splice(3,args.length-1):[];if(typeof this.listeners[type]!="undefined"){this.listeners[type].push({scope:scope,callback:callback,args:args})}else{this.listeners[type]=[{scope:scope,callback:callback,args:args}]}},removeEventListener:function(type,callback,scope){if(typeof this.listeners[type]!="undefined"){var numOfCallbacks=this.listeners[type].length;var newArray=[];for(var i=0;i<numOfCallbacks;i++){var listener=this.listeners[type][i];if(listener.scope==scope&&listener.callback==callback){}else{newArray.push(listener)}}this.listeners[type]=newArray}},hasEventListener:function(type,callback,scope){if(typeof this.listeners[type]!="undefined"){var numOfCallbacks=this.listeners[type].length;if(callback===undefined&&scope===undefined){return numOfCallbacks>0}for(var i=0;i<numOfCallbacks;i++){var listener=this.listeners[type][i];if((scope?listener.scope==scope:true)&&listener.callback==callback){return true}}}return false},dispatch:function(type,target){var event={type:type,target:target};var args=[];var numOfArgs=arguments.length;for(var i=0;i<numOfArgs;i++){args.push(arguments[i])}args=args.length>2?args.splice(2,args.length-1):[];args=[event].concat(args);if(typeof this.listeners[type]!="undefined"){var listeners=this.listeners[type].slice();var numOfCallbacks=listeners.length;for(var i=0;i<numOfCallbacks;i++){var listener=listeners[i];if(listener&&listener.callback){var concatArgs=args.concat(listener.args);listener.callback.apply(listener.scope,concatArgs)}}}},getEvents:function(){var str="";for(var type in this.listeners){var numOfCallbacks=this.listeners[type].length;for(var i=0;i<numOfCallbacks;i++){var listener=this.listeners[type][i];str+=listener.scope&&listener.scope.className?listener.scope.className:"anonymous";str+=" listen for '"+type+"'\n"}}return str}};var EventBus=new EventBusClass;return EventBus});
},{}],44:[function(require,module,exports){
'use strict';

/* eslint no-invalid-this: 1 */

var ERROR_MESSAGE = 'Function.prototype.bind called on incompatible ';
var slice = Array.prototype.slice;
var toStr = Object.prototype.toString;
var funcType = '[object Function]';

module.exports = function bind(that) {
    var target = this;
    if (typeof target !== 'function' || toStr.call(target) !== funcType) {
        throw new TypeError(ERROR_MESSAGE + target);
    }
    var args = slice.call(arguments, 1);

    var bound;
    var binder = function () {
        if (this instanceof bound) {
            var result = target.apply(
                this,
                args.concat(slice.call(arguments))
            );
            if (Object(result) === result) {
                return result;
            }
            return this;
        } else {
            return target.apply(
                that,
                args.concat(slice.call(arguments))
            );
        }
    };

    var boundLength = Math.max(0, target.length - args.length);
    var boundArgs = [];
    for (var i = 0; i < boundLength; i++) {
        boundArgs.push('$' + i);
    }

    bound = Function('binder', 'return function (' + boundArgs.join(',') + '){ return binder.apply(this,arguments); }')(binder);

    if (target.prototype) {
        var Empty = function Empty() {};
        Empty.prototype = target.prototype;
        bound.prototype = new Empty();
        Empty.prototype = null;
    }

    return bound;
};

},{}],45:[function(require,module,exports){
'use strict';

var implementation = require('./implementation');

module.exports = Function.prototype.bind || implementation;

},{"./implementation":44}],46:[function(require,module,exports){
/**
 * gemini-scrollbar
 * @version 1.5.3
 * @link http://noeldelgado.github.io/gemini-scrollbar/
 * @license MIT
 */
(function() {
  var SCROLLBAR_WIDTH, DONT_CREATE_GEMINI, CLASSNAMES;

  CLASSNAMES = {
    element: 'gm-scrollbar-container',
    verticalScrollbar: 'gm-scrollbar -vertical',
    horizontalScrollbar: 'gm-scrollbar -horizontal',
    thumb: 'thumb',
    view: 'gm-scroll-view',
    autoshow: 'gm-autoshow',
    disable: 'gm-scrollbar-disable-selection',
    prevented: 'gm-prevented',
    resizeTrigger: 'gm-resize-trigger',
  };

  function getScrollbarWidth() {
    var e = document.createElement('div'), sw;
    e.style.position = 'absolute';
    e.style.top = '-9999px';
    e.style.width = '100px';
    e.style.height = '100px';
    e.style.overflow = 'scroll';
    e.style.msOverflowStyle = 'scrollbar';
    document.body.appendChild(e);
    sw = (e.offsetWidth - e.clientWidth);
    document.body.removeChild(e);
    return sw;
  }

  function addClass(el, classNames) {
    if (el.classList) {
      return classNames.forEach(function(cl) {
        el.classList.add(cl);
      });
    }
    el.className += ' ' + classNames.join(' ');
  }

  function removeClass(el, classNames) {
    if (el.classList) {
      return classNames.forEach(function(cl) {
        el.classList.remove(cl);
      });
    }
    el.className = el.className.replace(new RegExp('(^|\\b)' + classNames.join('|') + '(\\b|$)', 'gi'), ' ');
  }

  /* Copyright (c) 2015 Lucas Wiener
   * https://github.com/wnr/element-resize-detector
   */
  function isIE() {
    var agent = navigator.userAgent.toLowerCase();
    return agent.indexOf("msie") !== -1 || agent.indexOf("trident") !== -1 || agent.indexOf(" edge/") !== -1;
  }

  function GeminiScrollbar(config) {
    this.element = null;
    this.autoshow = false;
    this.createElements = true;
    this.forceGemini = false;
    this.onResize = null;
    this.minThumbSize = 20;

    Object.keys(config || {}).forEach(function (propertyName) {
      this[propertyName] = config[propertyName];
    }, this);

    SCROLLBAR_WIDTH = getScrollbarWidth();
    DONT_CREATE_GEMINI = ((SCROLLBAR_WIDTH === 0) && (this.forceGemini === false));

    this._cache = {events: {}};
    this._created = false;
    this._cursorDown = false;
    this._prevPageX = 0;
    this._prevPageY = 0;

    this._document = null;
    this._viewElement = this.element;
    this._scrollbarVerticalElement = null;
    this._thumbVerticalElement = null;
    this._scrollbarHorizontalElement = null;
    this._scrollbarHorizontalElement = null;
  }

  GeminiScrollbar.prototype.create = function create() {
    if (DONT_CREATE_GEMINI) {
      addClass(this.element, [CLASSNAMES.prevented]);

      if (this.onResize) {
        // still need a resize trigger if we have an onResize callback, which
        // also means we need a separate _viewElement to do the scrolling.
        if (this.createElements === true) {
          this._viewElement = document.createElement('div');
          while(this.element.childNodes.length > 0) {
            this._viewElement.appendChild(this.element.childNodes[0]);
          }
          this.element.appendChild(this._viewElement);
        } else {
          this._viewElement = this.element.querySelector('.' + CLASSNAMES.view);
        }
        addClass(this.element, [CLASSNAMES.element]);
        addClass(this._viewElement, [CLASSNAMES.view]);
        this._createResizeTrigger();
      }

      return this;
    }

    if (this._created === true) {
      console.warn('calling on a already-created object');
      return this;
    }

    if (this.autoshow) {
      addClass(this.element, [CLASSNAMES.autoshow]);
    }

    this._document = document;

    if (this.createElements === true) {
      this._viewElement = document.createElement('div');
      this._scrollbarVerticalElement = document.createElement('div');
      this._thumbVerticalElement = document.createElement('div');
      this._scrollbarHorizontalElement = document.createElement('div');
      this._thumbHorizontalElement = document.createElement('div');
      while(this.element.childNodes.length > 0) {
        this._viewElement.appendChild(this.element.childNodes[0]);
      }

      this._scrollbarVerticalElement.appendChild(this._thumbVerticalElement);
      this._scrollbarHorizontalElement.appendChild(this._thumbHorizontalElement);
      this.element.appendChild(this._scrollbarVerticalElement);
      this.element.appendChild(this._scrollbarHorizontalElement);
      this.element.appendChild(this._viewElement);
    } else {
      this._viewElement = this.element.querySelector('.' + CLASSNAMES.view);
      this._scrollbarVerticalElement = this.element.querySelector('.' + CLASSNAMES.verticalScrollbar.split(' ').join('.'));
      this._thumbVerticalElement = this._scrollbarVerticalElement.querySelector('.' + CLASSNAMES.thumb);
      this._scrollbarHorizontalElement = this.element.querySelector('.' + CLASSNAMES.horizontalScrollbar.split(' ').join('.'));
      this._thumbHorizontalElement = this._scrollbarHorizontalElement.querySelector('.' + CLASSNAMES.thumb);
    }

    addClass(this.element, [CLASSNAMES.element]);
    addClass(this._viewElement, [CLASSNAMES.view]);
    addClass(this._scrollbarVerticalElement, CLASSNAMES.verticalScrollbar.split(/\s/));
    addClass(this._scrollbarHorizontalElement, CLASSNAMES.horizontalScrollbar.split(/\s/));
    addClass(this._thumbVerticalElement, [CLASSNAMES.thumb]);
    addClass(this._thumbHorizontalElement, [CLASSNAMES.thumb]);

    this._scrollbarVerticalElement.style.display = '';
    this._scrollbarHorizontalElement.style.display = '';

    this._createResizeTrigger();

    this._created = true;

    return this._bindEvents().update();
  };

  GeminiScrollbar.prototype._createResizeTrigger = function createResizeTrigger() {
    // We need to arrange for self.scrollbar.update to be called whenever
    // the DOM is changed resulting in a size-change for our div. To make
    // this happen, we use a technique described here:
    // http://www.backalleycoder.com/2013/03/18/cross-browser-event-based-element-resize-detection/.
    //
    // The idea is that we create an <object> element in our div, which we
    // arrange to have the same size as that div. The <object> element
    // contains a Window object, to which we can attach an onresize
    // handler.
    //
    // (React appears to get very confused by the object (we end up with
    // Chrome windows which only show half of the text they are supposed
    // to), so we always do this manually.)

    var obj = document.createElement('object');
    addClass(obj, [CLASSNAMES.resizeTrigger]);
    obj.type = 'text/html';
    obj.setAttribute('tabindex', '-1');
    var resizeHandler = this._resizeHandler.bind(this);
    obj.onload = function () {
      var win = obj.contentDocument.defaultView;
      win.addEventListener('resize', resizeHandler);
    };

    //IE: Does not like that this happens before, even if it is also added after.
    if (!isIE()) {
      obj.data = 'about:blank';
    }

    this.element.appendChild(obj);

    //IE: This must occur after adding the object to the DOM.
    if (isIE()) {
      obj.data = 'about:blank';
    }

    this._resizeTriggerElement = obj;
  };

  GeminiScrollbar.prototype.update = function update() {
    if (DONT_CREATE_GEMINI) {
      return this;
    }

    if (this._created === false) {
      console.warn('calling on a not-yet-created object');
      return this;
    }

    this._viewElement.style.width = ((this.element.offsetWidth + SCROLLBAR_WIDTH).toString() + 'px');
    this._viewElement.style.height = ((this.element.offsetHeight + SCROLLBAR_WIDTH).toString() + 'px');

    this._naturalThumbSizeX = this._scrollbarHorizontalElement.clientWidth / this._viewElement.scrollWidth * this._scrollbarHorizontalElement.clientWidth;
    this._naturalThumbSizeY = this._scrollbarVerticalElement.clientHeight / this._viewElement.scrollHeight * this._scrollbarVerticalElement.clientHeight;

    this._scrollTopMax = this._viewElement.scrollHeight - this._viewElement.clientHeight;
    this._scrollLeftMax = this._viewElement.scrollWidth - this._viewElement.clientWidth;

    if (this._naturalThumbSizeY < this.minThumbSize) {
      this._thumbVerticalElement.style.height = this.minThumbSize + 'px';
    } else if (this._scrollTopMax) {
      this._thumbVerticalElement.style.height = this._naturalThumbSizeY + 'px';
    } else {
      this._thumbVerticalElement.style.height = '0px';
    }

    if (this._naturalThumbSizeX < this.minThumbSize) {
      this._thumbHorizontalElement.style.width = this.minThumbSize + 'px';
    } else if (this._scrollLeftMax) {
      this._thumbHorizontalElement.style.width = this._naturalThumbSizeX + 'px';
    } else {
      this._thumbHorizontalElement.style.width = '0px';
    }

    this._thumbSizeY = this._thumbVerticalElement.clientHeight;
    this._thumbSizeX = this._thumbHorizontalElement.clientWidth;

    this._trackTopMax = this._scrollbarVerticalElement.clientHeight - this._thumbSizeY;
    this._trackLeftMax = this._scrollbarHorizontalElement.clientWidth - this._thumbSizeX;

    this._scrollHandler();

    return this;
  };

  GeminiScrollbar.prototype.destroy = function destroy() {
    if (this._resizeTriggerElement) {
      this.element.removeChild(this._resizeTriggerElement);
      this._resizeTriggerElement = null;
    }

    if (DONT_CREATE_GEMINI) {
      return this;
    }

    if (this._created === false) {
      console.warn('calling on a not-yet-created object');
      return this;
    }

    this._unbinEvents();

    removeClass(this.element, [CLASSNAMES.element, CLASSNAMES.autoshow]);

    if (this.createElements === true) {
      this.element.removeChild(this._scrollbarVerticalElement);
      this.element.removeChild(this._scrollbarHorizontalElement);
      while(this._viewElement.childNodes.length > 0) {
        this.element.appendChild(this._viewElement.childNodes[0]);
      }
      this.element.removeChild(this._viewElement);
    } else {
      this._viewElement.style.width = '';
      this._viewElement.style.height = '';
      this._scrollbarVerticalElement.style.display = 'none';
      this._scrollbarHorizontalElement.style.display = 'none';
    }

    this._created = false;
    this._document = null;

    return null;
  };

  GeminiScrollbar.prototype.getViewElement = function getViewElement() {
    return this._viewElement;
  };

  GeminiScrollbar.prototype._bindEvents = function _bindEvents() {
    this._cache.events.scrollHandler = this._scrollHandler.bind(this);
    this._cache.events.clickVerticalTrackHandler = this._clickVerticalTrackHandler.bind(this);
    this._cache.events.clickHorizontalTrackHandler = this._clickHorizontalTrackHandler.bind(this);
    this._cache.events.clickVerticalThumbHandler = this._clickVerticalThumbHandler.bind(this);
    this._cache.events.clickHorizontalThumbHandler = this._clickHorizontalThumbHandler.bind(this);
    this._cache.events.mouseUpDocumentHandler = this._mouseUpDocumentHandler.bind(this);
    this._cache.events.mouseMoveDocumentHandler = this._mouseMoveDocumentHandler.bind(this);

    this._viewElement.addEventListener('scroll', this._cache.events.scrollHandler);
    this._scrollbarVerticalElement.addEventListener('mousedown', this._cache.events.clickVerticalTrackHandler);
    this._scrollbarHorizontalElement.addEventListener('mousedown', this._cache.events.clickHorizontalTrackHandler);
    this._thumbVerticalElement.addEventListener('mousedown', this._cache.events.clickVerticalThumbHandler);
    this._thumbHorizontalElement.addEventListener('mousedown', this._cache.events.clickHorizontalThumbHandler);
    this._document.addEventListener('mouseup', this._cache.events.mouseUpDocumentHandler);

    return this;
  };

  GeminiScrollbar.prototype._unbinEvents = function _unbinEvents() {
    this._viewElement.removeEventListener('scroll', this._cache.events.scrollHandler);
    this._scrollbarVerticalElement.removeEventListener('mousedown', this._cache.events.clickVerticalTrackHandler);
    this._scrollbarHorizontalElement.removeEventListener('mousedown', this._cache.events.clickHorizontalTrackHandler);
    this._thumbVerticalElement.removeEventListener('mousedown', this._cache.events.clickVerticalThumbHandler);
    this._thumbHorizontalElement.removeEventListener('mousedown', this._cache.events.clickHorizontalThumbHandler);
    this._document.removeEventListener('mouseup', this._cache.events.mouseUpDocumentHandler);
    this._document.removeEventListener('mousemove', this._cache.events.mouseMoveDocumentHandler);

    return this;
  };

  GeminiScrollbar.prototype._scrollHandler = function _scrollHandler() {
    var x = (this._viewElement.scrollLeft * this._trackLeftMax / this._scrollLeftMax) || 0;
    var y = (this._viewElement.scrollTop * this._trackTopMax / this._scrollTopMax) || 0;

    this._thumbHorizontalElement.style.msTransform = 'translateX(' + x + 'px)';
    this._thumbHorizontalElement.style.webkitTransform = 'translate3d(' + x + 'px, 0, 0)';
    this._thumbHorizontalElement.style.transform = 'translate3d(' + x + 'px, 0, 0)';

    this._thumbVerticalElement.style.msTransform = 'translateY(' + y + 'px)';
    this._thumbVerticalElement.style.webkitTransform = 'translate3d(0, ' + y + 'px, 0)';
    this._thumbVerticalElement.style.transform = 'translate3d(0, ' + y + 'px, 0)';
  };

  GeminiScrollbar.prototype._resizeHandler = function _resizeHandler() {
    this.update();
    if (this.onResize) {
      this.onResize();
    }
  };

  GeminiScrollbar.prototype._clickVerticalTrackHandler = function _clickVerticalTrackHandler(e) {
    if(e.target !== e.currentTarget) {
      return;
    }
    var offset = e.offsetY - this._naturalThumbSizeY * .5
      , thumbPositionPercentage = offset * 100 / this._scrollbarVerticalElement.clientHeight;

    this._viewElement.scrollTop = thumbPositionPercentage * this._viewElement.scrollHeight / 100;
  };

  GeminiScrollbar.prototype._clickHorizontalTrackHandler = function _clickHorizontalTrackHandler(e) {
    if(e.target !== e.currentTarget) {
      return;
    }
    var offset = e.offsetX - this._naturalThumbSizeX * .5
      , thumbPositionPercentage = offset * 100 / this._scrollbarHorizontalElement.clientWidth;

    this._viewElement.scrollLeft = thumbPositionPercentage * this._viewElement.scrollWidth / 100;
  };

  GeminiScrollbar.prototype._clickVerticalThumbHandler = function _clickVerticalThumbHandler(e) {
    this._startDrag(e);
    this._prevPageY = this._thumbSizeY - e.offsetY;
  };

  GeminiScrollbar.prototype._clickHorizontalThumbHandler = function _clickHorizontalThumbHandler(e) {
    this._startDrag(e);
    this._prevPageX = this._thumbSizeX - e.offsetX;
  };

  GeminiScrollbar.prototype._startDrag = function _startDrag(e) {
    this._cursorDown = true;
    addClass(document.body, [CLASSNAMES.disable]);
    this._document.addEventListener('mousemove', this._cache.events.mouseMoveDocumentHandler);
    this._document.onselectstart = function() {return false;};
  };

  GeminiScrollbar.prototype._mouseUpDocumentHandler = function _mouseUpDocumentHandler() {
    this._cursorDown = false;
    this._prevPageX = this._prevPageY = 0;
    removeClass(document.body, [CLASSNAMES.disable]);
    this._document.removeEventListener('mousemove', this._cache.events.mouseMoveDocumentHandler);
    this._document.onselectstart = null;
  };

  GeminiScrollbar.prototype._mouseMoveDocumentHandler = function _mouseMoveDocumentHandler(e) {
    if (this._cursorDown === false) {return;}

    var offset, thumbClickPosition;

    if (this._prevPageY) {
      offset = e.clientY - this._scrollbarVerticalElement.getBoundingClientRect().top;
      thumbClickPosition = this._thumbSizeY - this._prevPageY;

      this._viewElement.scrollTop = this._scrollTopMax * (offset - thumbClickPosition) / this._trackTopMax;

      return void 0;
    }

    if (this._prevPageX) {
      offset = e.clientX - this._scrollbarHorizontalElement.getBoundingClientRect().left;
      thumbClickPosition = this._thumbSizeX - this._prevPageX;

      this._viewElement.scrollLeft = this._scrollLeftMax * (offset - thumbClickPosition) / this._trackLeftMax;
    }
  };

  if (typeof exports === 'object') {
    module.exports = GeminiScrollbar;
  } else {
    window.GeminiScrollbar = GeminiScrollbar;
  }
})();

},{}],47:[function(require,module,exports){
'use strict';

var undefined;

var $SyntaxError = SyntaxError;
var $Function = Function;
var $TypeError = TypeError;

// eslint-disable-next-line consistent-return
var getEvalledConstructor = function (expressionSyntax) {
	try {
		return $Function('"use strict"; return (' + expressionSyntax + ').constructor;')();
	} catch (e) {}
};

var $gOPD = Object.getOwnPropertyDescriptor;
if ($gOPD) {
	try {
		$gOPD({}, '');
	} catch (e) {
		$gOPD = null; // this is IE 8, which has a broken gOPD
	}
}

var throwTypeError = function () {
	throw new $TypeError();
};
var ThrowTypeError = $gOPD
	? (function () {
		try {
			// eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
			arguments.callee; // IE 8 does not throw here
			return throwTypeError;
		} catch (calleeThrows) {
			try {
				// IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
				return $gOPD(arguments, 'callee').get;
			} catch (gOPDthrows) {
				return throwTypeError;
			}
		}
	}())
	: throwTypeError;

var hasSymbols = require('has-symbols')();

var getProto = Object.getPrototypeOf || function (x) { return x.__proto__; }; // eslint-disable-line no-proto

var needsEval = {};

var TypedArray = typeof Uint8Array === 'undefined' ? undefined : getProto(Uint8Array);

var INTRINSICS = {
	'%AggregateError%': typeof AggregateError === 'undefined' ? undefined : AggregateError,
	'%Array%': Array,
	'%ArrayBuffer%': typeof ArrayBuffer === 'undefined' ? undefined : ArrayBuffer,
	'%ArrayIteratorPrototype%': hasSymbols ? getProto([][Symbol.iterator]()) : undefined,
	'%AsyncFromSyncIteratorPrototype%': undefined,
	'%AsyncFunction%': needsEval,
	'%AsyncGenerator%': needsEval,
	'%AsyncGeneratorFunction%': needsEval,
	'%AsyncIteratorPrototype%': needsEval,
	'%Atomics%': typeof Atomics === 'undefined' ? undefined : Atomics,
	'%BigInt%': typeof BigInt === 'undefined' ? undefined : BigInt,
	'%Boolean%': Boolean,
	'%DataView%': typeof DataView === 'undefined' ? undefined : DataView,
	'%Date%': Date,
	'%decodeURI%': decodeURI,
	'%decodeURIComponent%': decodeURIComponent,
	'%encodeURI%': encodeURI,
	'%encodeURIComponent%': encodeURIComponent,
	'%Error%': Error,
	'%eval%': eval, // eslint-disable-line no-eval
	'%EvalError%': EvalError,
	'%Float32Array%': typeof Float32Array === 'undefined' ? undefined : Float32Array,
	'%Float64Array%': typeof Float64Array === 'undefined' ? undefined : Float64Array,
	'%FinalizationRegistry%': typeof FinalizationRegistry === 'undefined' ? undefined : FinalizationRegistry,
	'%Function%': $Function,
	'%GeneratorFunction%': needsEval,
	'%Int8Array%': typeof Int8Array === 'undefined' ? undefined : Int8Array,
	'%Int16Array%': typeof Int16Array === 'undefined' ? undefined : Int16Array,
	'%Int32Array%': typeof Int32Array === 'undefined' ? undefined : Int32Array,
	'%isFinite%': isFinite,
	'%isNaN%': isNaN,
	'%IteratorPrototype%': hasSymbols ? getProto(getProto([][Symbol.iterator]())) : undefined,
	'%JSON%': typeof JSON === 'object' ? JSON : undefined,
	'%Map%': typeof Map === 'undefined' ? undefined : Map,
	'%MapIteratorPrototype%': typeof Map === 'undefined' || !hasSymbols ? undefined : getProto(new Map()[Symbol.iterator]()),
	'%Math%': Math,
	'%Number%': Number,
	'%Object%': Object,
	'%parseFloat%': parseFloat,
	'%parseInt%': parseInt,
	'%Promise%': typeof Promise === 'undefined' ? undefined : Promise,
	'%Proxy%': typeof Proxy === 'undefined' ? undefined : Proxy,
	'%RangeError%': RangeError,
	'%ReferenceError%': ReferenceError,
	'%Reflect%': typeof Reflect === 'undefined' ? undefined : Reflect,
	'%RegExp%': RegExp,
	'%Set%': typeof Set === 'undefined' ? undefined : Set,
	'%SetIteratorPrototype%': typeof Set === 'undefined' || !hasSymbols ? undefined : getProto(new Set()[Symbol.iterator]()),
	'%SharedArrayBuffer%': typeof SharedArrayBuffer === 'undefined' ? undefined : SharedArrayBuffer,
	'%String%': String,
	'%StringIteratorPrototype%': hasSymbols ? getProto(''[Symbol.iterator]()) : undefined,
	'%Symbol%': hasSymbols ? Symbol : undefined,
	'%SyntaxError%': $SyntaxError,
	'%ThrowTypeError%': ThrowTypeError,
	'%TypedArray%': TypedArray,
	'%TypeError%': $TypeError,
	'%Uint8Array%': typeof Uint8Array === 'undefined' ? undefined : Uint8Array,
	'%Uint8ClampedArray%': typeof Uint8ClampedArray === 'undefined' ? undefined : Uint8ClampedArray,
	'%Uint16Array%': typeof Uint16Array === 'undefined' ? undefined : Uint16Array,
	'%Uint32Array%': typeof Uint32Array === 'undefined' ? undefined : Uint32Array,
	'%URIError%': URIError,
	'%WeakMap%': typeof WeakMap === 'undefined' ? undefined : WeakMap,
	'%WeakRef%': typeof WeakRef === 'undefined' ? undefined : WeakRef,
	'%WeakSet%': typeof WeakSet === 'undefined' ? undefined : WeakSet
};

var doEval = function doEval(name) {
	var value;
	if (name === '%AsyncFunction%') {
		value = getEvalledConstructor('async function () {}');
	} else if (name === '%GeneratorFunction%') {
		value = getEvalledConstructor('function* () {}');
	} else if (name === '%AsyncGeneratorFunction%') {
		value = getEvalledConstructor('async function* () {}');
	} else if (name === '%AsyncGenerator%') {
		var fn = doEval('%AsyncGeneratorFunction%');
		if (fn) {
			value = fn.prototype;
		}
	} else if (name === '%AsyncIteratorPrototype%') {
		var gen = doEval('%AsyncGenerator%');
		if (gen) {
			value = getProto(gen.prototype);
		}
	}

	INTRINSICS[name] = value;

	return value;
};

var LEGACY_ALIASES = {
	'%ArrayBufferPrototype%': ['ArrayBuffer', 'prototype'],
	'%ArrayPrototype%': ['Array', 'prototype'],
	'%ArrayProto_entries%': ['Array', 'prototype', 'entries'],
	'%ArrayProto_forEach%': ['Array', 'prototype', 'forEach'],
	'%ArrayProto_keys%': ['Array', 'prototype', 'keys'],
	'%ArrayProto_values%': ['Array', 'prototype', 'values'],
	'%AsyncFunctionPrototype%': ['AsyncFunction', 'prototype'],
	'%AsyncGenerator%': ['AsyncGeneratorFunction', 'prototype'],
	'%AsyncGeneratorPrototype%': ['AsyncGeneratorFunction', 'prototype', 'prototype'],
	'%BooleanPrototype%': ['Boolean', 'prototype'],
	'%DataViewPrototype%': ['DataView', 'prototype'],
	'%DatePrototype%': ['Date', 'prototype'],
	'%ErrorPrototype%': ['Error', 'prototype'],
	'%EvalErrorPrototype%': ['EvalError', 'prototype'],
	'%Float32ArrayPrototype%': ['Float32Array', 'prototype'],
	'%Float64ArrayPrototype%': ['Float64Array', 'prototype'],
	'%FunctionPrototype%': ['Function', 'prototype'],
	'%Generator%': ['GeneratorFunction', 'prototype'],
	'%GeneratorPrototype%': ['GeneratorFunction', 'prototype', 'prototype'],
	'%Int8ArrayPrototype%': ['Int8Array', 'prototype'],
	'%Int16ArrayPrototype%': ['Int16Array', 'prototype'],
	'%Int32ArrayPrototype%': ['Int32Array', 'prototype'],
	'%JSONParse%': ['JSON', 'parse'],
	'%JSONStringify%': ['JSON', 'stringify'],
	'%MapPrototype%': ['Map', 'prototype'],
	'%NumberPrototype%': ['Number', 'prototype'],
	'%ObjectPrototype%': ['Object', 'prototype'],
	'%ObjProto_toString%': ['Object', 'prototype', 'toString'],
	'%ObjProto_valueOf%': ['Object', 'prototype', 'valueOf'],
	'%PromisePrototype%': ['Promise', 'prototype'],
	'%PromiseProto_then%': ['Promise', 'prototype', 'then'],
	'%Promise_all%': ['Promise', 'all'],
	'%Promise_reject%': ['Promise', 'reject'],
	'%Promise_resolve%': ['Promise', 'resolve'],
	'%RangeErrorPrototype%': ['RangeError', 'prototype'],
	'%ReferenceErrorPrototype%': ['ReferenceError', 'prototype'],
	'%RegExpPrototype%': ['RegExp', 'prototype'],
	'%SetPrototype%': ['Set', 'prototype'],
	'%SharedArrayBufferPrototype%': ['SharedArrayBuffer', 'prototype'],
	'%StringPrototype%': ['String', 'prototype'],
	'%SymbolPrototype%': ['Symbol', 'prototype'],
	'%SyntaxErrorPrototype%': ['SyntaxError', 'prototype'],
	'%TypedArrayPrototype%': ['TypedArray', 'prototype'],
	'%TypeErrorPrototype%': ['TypeError', 'prototype'],
	'%Uint8ArrayPrototype%': ['Uint8Array', 'prototype'],
	'%Uint8ClampedArrayPrototype%': ['Uint8ClampedArray', 'prototype'],
	'%Uint16ArrayPrototype%': ['Uint16Array', 'prototype'],
	'%Uint32ArrayPrototype%': ['Uint32Array', 'prototype'],
	'%URIErrorPrototype%': ['URIError', 'prototype'],
	'%WeakMapPrototype%': ['WeakMap', 'prototype'],
	'%WeakSetPrototype%': ['WeakSet', 'prototype']
};

var bind = require('function-bind');
var hasOwn = require('has');
var $concat = bind.call(Function.call, Array.prototype.concat);
var $spliceApply = bind.call(Function.apply, Array.prototype.splice);
var $replace = bind.call(Function.call, String.prototype.replace);
var $strSlice = bind.call(Function.call, String.prototype.slice);
var $exec = bind.call(Function.call, RegExp.prototype.exec);

/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */
var rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
var reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */
var stringToPath = function stringToPath(string) {
	var first = $strSlice(string, 0, 1);
	var last = $strSlice(string, -1);
	if (first === '%' && last !== '%') {
		throw new $SyntaxError('invalid intrinsic syntax, expected closing `%`');
	} else if (last === '%' && first !== '%') {
		throw new $SyntaxError('invalid intrinsic syntax, expected opening `%`');
	}
	var result = [];
	$replace(string, rePropName, function (match, number, quote, subString) {
		result[result.length] = quote ? $replace(subString, reEscapeChar, '$1') : number || match;
	});
	return result;
};
/* end adaptation */

var getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
	var intrinsicName = name;
	var alias;
	if (hasOwn(LEGACY_ALIASES, intrinsicName)) {
		alias = LEGACY_ALIASES[intrinsicName];
		intrinsicName = '%' + alias[0] + '%';
	}

	if (hasOwn(INTRINSICS, intrinsicName)) {
		var value = INTRINSICS[intrinsicName];
		if (value === needsEval) {
			value = doEval(intrinsicName);
		}
		if (typeof value === 'undefined' && !allowMissing) {
			throw new $TypeError('intrinsic ' + name + ' exists, but is not available. Please file an issue!');
		}

		return {
			alias: alias,
			name: intrinsicName,
			value: value
		};
	}

	throw new $SyntaxError('intrinsic ' + name + ' does not exist!');
};

module.exports = function GetIntrinsic(name, allowMissing) {
	if (typeof name !== 'string' || name.length === 0) {
		throw new $TypeError('intrinsic name must be a non-empty string');
	}
	if (arguments.length > 1 && typeof allowMissing !== 'boolean') {
		throw new $TypeError('"allowMissing" argument must be a boolean');
	}

	if ($exec(/^%?[^%]*%?$/g, name) === null) {
		throw new $SyntaxError('`%` may not be present anywhere but at the beginning and end of the intrinsic name');
	}
	var parts = stringToPath(name);
	var intrinsicBaseName = parts.length > 0 ? parts[0] : '';

	var intrinsic = getBaseIntrinsic('%' + intrinsicBaseName + '%', allowMissing);
	var intrinsicRealName = intrinsic.name;
	var value = intrinsic.value;
	var skipFurtherCaching = false;

	var alias = intrinsic.alias;
	if (alias) {
		intrinsicBaseName = alias[0];
		$spliceApply(parts, $concat([0, 1], alias));
	}

	for (var i = 1, isOwn = true; i < parts.length; i += 1) {
		var part = parts[i];
		var first = $strSlice(part, 0, 1);
		var last = $strSlice(part, -1);
		if (
			(
				(first === '"' || first === "'" || first === '`')
				|| (last === '"' || last === "'" || last === '`')
			)
			&& first !== last
		) {
			throw new $SyntaxError('property names with quotes must have matching quotes');
		}
		if (part === 'constructor' || !isOwn) {
			skipFurtherCaching = true;
		}

		intrinsicBaseName += '.' + part;
		intrinsicRealName = '%' + intrinsicBaseName + '%';

		if (hasOwn(INTRINSICS, intrinsicRealName)) {
			value = INTRINSICS[intrinsicRealName];
		} else if (value != null) {
			if (!(part in value)) {
				if (!allowMissing) {
					throw new $TypeError('base intrinsic for ' + name + ' exists, but the property is not available.');
				}
				return void undefined;
			}
			if ($gOPD && (i + 1) >= parts.length) {
				var desc = $gOPD(value, part);
				isOwn = !!desc;

				// By convention, when a data property is converted to an accessor
				// property to emulate a data property that does not suffer from
				// the override mistake, that accessor's getter is marked with
				// an `originalValue` property. Here, when we detect this, we
				// uphold the illusion by pretending to see that original data
				// property, i.e., returning the value rather than the getter
				// itself.
				if (isOwn && 'get' in desc && !('originalValue' in desc.get)) {
					value = desc.get;
				} else {
					value = value[part];
				}
			} else {
				isOwn = hasOwn(value, part);
				value = value[part];
			}

			if (isOwn && !skipFurtherCaching) {
				INTRINSICS[intrinsicRealName] = value;
			}
		}
	}
	return value;
};

},{"function-bind":45,"has":52,"has-symbols":49}],48:[function(require,module,exports){
'use strict';

var GetIntrinsic = require('get-intrinsic');

var $defineProperty = GetIntrinsic('%Object.defineProperty%', true);

var hasPropertyDescriptors = function hasPropertyDescriptors() {
	if ($defineProperty) {
		try {
			$defineProperty({}, 'a', { value: 1 });
			return true;
		} catch (e) {
			// IE 8 has a broken defineProperty
			return false;
		}
	}
	return false;
};

hasPropertyDescriptors.hasArrayLengthDefineBug = function hasArrayLengthDefineBug() {
	// node v0.6 has a bug where array lengths can be Set but not Defined
	if (!hasPropertyDescriptors()) {
		return null;
	}
	try {
		return $defineProperty([], 'length', { value: 1 }).length !== 1;
	} catch (e) {
		// In Firefox 4-22, defining length on an array throws an exception.
		return true;
	}
};

module.exports = hasPropertyDescriptors;

},{"get-intrinsic":47}],49:[function(require,module,exports){
'use strict';

var origSymbol = typeof Symbol !== 'undefined' && Symbol;
var hasSymbolSham = require('./shams');

module.exports = function hasNativeSymbols() {
	if (typeof origSymbol !== 'function') { return false; }
	if (typeof Symbol !== 'function') { return false; }
	if (typeof origSymbol('foo') !== 'symbol') { return false; }
	if (typeof Symbol('bar') !== 'symbol') { return false; }

	return hasSymbolSham();
};

},{"./shams":50}],50:[function(require,module,exports){
'use strict';

/* eslint complexity: [2, 18], max-statements: [2, 33] */
module.exports = function hasSymbols() {
	if (typeof Symbol !== 'function' || typeof Object.getOwnPropertySymbols !== 'function') { return false; }
	if (typeof Symbol.iterator === 'symbol') { return true; }

	var obj = {};
	var sym = Symbol('test');
	var symObj = Object(sym);
	if (typeof sym === 'string') { return false; }

	if (Object.prototype.toString.call(sym) !== '[object Symbol]') { return false; }
	if (Object.prototype.toString.call(symObj) !== '[object Symbol]') { return false; }

	// temp disabled per https://github.com/ljharb/object.assign/issues/17
	// if (sym instanceof Symbol) { return false; }
	// temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
	// if (!(symObj instanceof Symbol)) { return false; }

	// if (typeof Symbol.prototype.toString !== 'function') { return false; }
	// if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }

	var symVal = 42;
	obj[sym] = symVal;
	for (sym in obj) { return false; } // eslint-disable-line no-restricted-syntax, no-unreachable-loop
	if (typeof Object.keys === 'function' && Object.keys(obj).length !== 0) { return false; }

	if (typeof Object.getOwnPropertyNames === 'function' && Object.getOwnPropertyNames(obj).length !== 0) { return false; }

	var syms = Object.getOwnPropertySymbols(obj);
	if (syms.length !== 1 || syms[0] !== sym) { return false; }

	if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) { return false; }

	if (typeof Object.getOwnPropertyDescriptor === 'function') {
		var descriptor = Object.getOwnPropertyDescriptor(obj, sym);
		if (descriptor.value !== symVal || descriptor.enumerable !== true) { return false; }
	}

	return true;
};

},{}],51:[function(require,module,exports){
'use strict';

var hasSymbols = require('has-symbols/shams');

module.exports = function hasToStringTagShams() {
	return hasSymbols() && !!Symbol.toStringTag;
};

},{"has-symbols/shams":50}],52:[function(require,module,exports){
'use strict';

var bind = require('function-bind');

module.exports = bind.call(Function.call, Object.prototype.hasOwnProperty);

},{"function-bind":45}],53:[function(require,module,exports){
'use strict';

var fnToStr = Function.prototype.toString;
var reflectApply = typeof Reflect === 'object' && Reflect !== null && Reflect.apply;
var badArrayLike;
var isCallableMarker;
if (typeof reflectApply === 'function' && typeof Object.defineProperty === 'function') {
	try {
		badArrayLike = Object.defineProperty({}, 'length', {
			get: function () {
				throw isCallableMarker;
			}
		});
		isCallableMarker = {};
		// eslint-disable-next-line no-throw-literal
		reflectApply(function () { throw 42; }, null, badArrayLike);
	} catch (_) {
		if (_ !== isCallableMarker) {
			reflectApply = null;
		}
	}
} else {
	reflectApply = null;
}

var constructorRegex = /^\s*class\b/;
var isES6ClassFn = function isES6ClassFunction(value) {
	try {
		var fnStr = fnToStr.call(value);
		return constructorRegex.test(fnStr);
	} catch (e) {
		return false; // not a function
	}
};

var tryFunctionObject = function tryFunctionToStr(value) {
	try {
		if (isES6ClassFn(value)) { return false; }
		fnToStr.call(value);
		return true;
	} catch (e) {
		return false;
	}
};
var toStr = Object.prototype.toString;
var fnClass = '[object Function]';
var genClass = '[object GeneratorFunction]';
var hasToStringTag = typeof Symbol === 'function' && !!Symbol.toStringTag; // better: use `has-tostringtag`
/* globals document: false */
var documentDotAll = typeof document === 'object' && typeof document.all === 'undefined' && document.all !== undefined ? document.all : {};

module.exports = reflectApply
	? function isCallable(value) {
		if (value === documentDotAll) { return true; }
		if (!value) { return false; }
		if (typeof value !== 'function' && typeof value !== 'object') { return false; }
		if (typeof value === 'function' && !value.prototype) { return true; }
		try {
			reflectApply(value, null, badArrayLike);
		} catch (e) {
			if (e !== isCallableMarker) { return false; }
		}
		return !isES6ClassFn(value);
	}
	: function isCallable(value) {
		if (value === documentDotAll) { return true; }
		if (!value) { return false; }
		if (typeof value !== 'function' && typeof value !== 'object') { return false; }
		if (typeof value === 'function' && !value.prototype) { return true; }
		if (hasToStringTag) { return tryFunctionObject(value); }
		if (isES6ClassFn(value)) { return false; }
		var strClass = toStr.call(value);
		return strClass === fnClass || strClass === genClass;
	};

},{}],54:[function(require,module,exports){
'use strict';

var getDay = Date.prototype.getDay;
var tryDateObject = function tryDateGetDayCall(value) {
	try {
		getDay.call(value);
		return true;
	} catch (e) {
		return false;
	}
};

var toStr = Object.prototype.toString;
var dateClass = '[object Date]';
var hasToStringTag = require('has-tostringtag/shams')();

module.exports = function isDateObject(value) {
	if (typeof value !== 'object' || value === null) {
		return false;
	}
	return hasToStringTag ? tryDateObject(value) : toStr.call(value) === dateClass;
};

},{"has-tostringtag/shams":51}],55:[function(require,module,exports){
'use strict';

var strValue = String.prototype.valueOf;
var tryStringObject = function tryStringObject(value) {
	try {
		strValue.call(value);
		return true;
	} catch (e) {
		return false;
	}
};
var toStr = Object.prototype.toString;
var strClass = '[object String]';
var hasToStringTag = require('has-tostringtag/shams')();

module.exports = function isString(value) {
	if (typeof value === 'string') {
		return true;
	}
	if (typeof value !== 'object') {
		return false;
	}
	return hasToStringTag ? tryStringObject(value) : toStr.call(value) === strClass;
};

},{"has-tostringtag/shams":51}],56:[function(require,module,exports){
'use strict';

var toStr = Object.prototype.toString;
var hasSymbols = require('has-symbols')();

if (hasSymbols) {
	var symToStr = Symbol.prototype.toString;
	var symStringRegex = /^Symbol\(.*\)$/;
	var isSymbolObject = function isRealSymbolObject(value) {
		if (typeof value.valueOf() !== 'symbol') {
			return false;
		}
		return symStringRegex.test(symToStr.call(value));
	};

	module.exports = function isSymbol(value) {
		if (typeof value === 'symbol') {
			return true;
		}
		if (toStr.call(value) !== '[object Symbol]') {
			return false;
		}
		try {
			return isSymbolObject(value);
		} catch (e) {
			return false;
		}
	};
} else {

	module.exports = function isSymbol(value) {
		// this environment does not support Symbols.
		return false && value;
	};
}

},{"has-symbols":49}],57:[function(require,module,exports){
!function(e){var n=/iPhone/i,t=/iPod/i,r=/iPad/i,a=/\bAndroid(?:.+)Mobile\b/i,p=/Android/i,b=/\bAndroid(?:.+)SD4930UR\b/i,l=/\bAndroid(?:.+)(?:KF[A-Z]{2,4})\b/i,f=/Windows Phone/i,s=/\bWindows(?:.+)ARM\b/i,u=/BlackBerry/i,c=/BB10/i,h=/Opera Mini/i,v=/\b(CriOS|Chrome)(?:.+)Mobile/i,w=/Mobile(?:.+)Firefox\b/i;function m(e,i){return e.test(i)}function i(e){var i=e||("undefined"!=typeof navigator?navigator.userAgent:""),o=i.split("[FBAN");void 0!==o[1]&&(i=o[0]),void 0!==(o=i.split("Twitter"))[1]&&(i=o[0]);var d={apple:{phone:m(n,i)&&!m(f,i),ipod:m(t,i),tablet:!m(n,i)&&m(r,i)&&!m(f,i),device:(m(n,i)||m(t,i)||m(r,i))&&!m(f,i)},amazon:{phone:m(b,i),tablet:!m(b,i)&&m(l,i),device:m(b,i)||m(l,i)},android:{phone:!m(f,i)&&m(b,i)||!m(f,i)&&m(a,i),tablet:!m(f,i)&&!m(b,i)&&!m(a,i)&&(m(l,i)||m(p,i)),device:!m(f,i)&&(m(b,i)||m(l,i)||m(a,i)||m(p,i))||m(/\bokhttp\b/i,i)},windows:{phone:m(f,i),tablet:m(s,i),device:m(f,i)||m(s,i)},other:{blackberry:m(u,i),blackberry10:m(c,i),opera:m(h,i),firefox:m(w,i),chrome:m(v,i),device:m(u,i)||m(c,i)||m(h,i)||m(w,i)||m(v,i)}};return d.any=d.apple.device||d.android.device||d.windows.device||d.other.device,d.phone=d.apple.phone||d.android.phone||d.windows.phone,d.tablet=d.apple.tablet||d.android.tablet||d.windows.tablet,d}"undefined"!=typeof module&&module.exports&&"undefined"==typeof window?module.exports=i:"undefined"!=typeof module&&module.exports&&"undefined"!=typeof window?(module.exports=i(),module.exports.isMobile=i):"function"==typeof define&&define.amd?define([],e.isMobile=i()):e.isMobile=i()}(this);
},{}],58:[function(require,module,exports){
/*!
 * JavaScript Cookie v2.2.1
 * https://github.com/js-cookie/js-cookie
 *
 * Copyright 2006, 2015 Klaus Hartl & Fagner Brack
 * Released under the MIT license
 */
;(function (factory) {
	var registeredInModuleLoader;
	if (typeof define === 'function' && define.amd) {
		define(factory);
		registeredInModuleLoader = true;
	}
	if (typeof exports === 'object') {
		module.exports = factory();
		registeredInModuleLoader = true;
	}
	if (!registeredInModuleLoader) {
		var OldCookies = window.Cookies;
		var api = window.Cookies = factory();
		api.noConflict = function () {
			window.Cookies = OldCookies;
			return api;
		};
	}
}(function () {
	function extend () {
		var i = 0;
		var result = {};
		for (; i < arguments.length; i++) {
			var attributes = arguments[ i ];
			for (var key in attributes) {
				result[key] = attributes[key];
			}
		}
		return result;
	}

	function decode (s) {
		return s.replace(/(%[0-9A-Z]{2})+/g, decodeURIComponent);
	}

	function init (converter) {
		function api() {}

		function set (key, value, attributes) {
			if (typeof document === 'undefined') {
				return;
			}

			attributes = extend({
				path: '/'
			}, api.defaults, attributes);

			if (typeof attributes.expires === 'number') {
				attributes.expires = new Date(new Date() * 1 + attributes.expires * 864e+5);
			}

			// We're using "expires" because "max-age" is not supported by IE
			attributes.expires = attributes.expires ? attributes.expires.toUTCString() : '';

			try {
				var result = JSON.stringify(value);
				if (/^[\{\[]/.test(result)) {
					value = result;
				}
			} catch (e) {}

			value = converter.write ?
				converter.write(value, key) :
				encodeURIComponent(String(value))
					.replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent);

			key = encodeURIComponent(String(key))
				.replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent)
				.replace(/[\(\)]/g, escape);

			var stringifiedAttributes = '';
			for (var attributeName in attributes) {
				if (!attributes[attributeName]) {
					continue;
				}
				stringifiedAttributes += '; ' + attributeName;
				if (attributes[attributeName] === true) {
					continue;
				}

				// Considers RFC 6265 section 5.2:
				// ...
				// 3.  If the remaining unparsed-attributes contains a %x3B (";")
				//     character:
				// Consume the characters of the unparsed-attributes up to,
				// not including, the first %x3B (";") character.
				// ...
				stringifiedAttributes += '=' + attributes[attributeName].split(';')[0];
			}

			return (document.cookie = key + '=' + value + stringifiedAttributes);
		}

		function get (key, json) {
			if (typeof document === 'undefined') {
				return;
			}

			var jar = {};
			// To prevent the for loop in the first place assign an empty array
			// in case there are no cookies at all.
			var cookies = document.cookie ? document.cookie.split('; ') : [];
			var i = 0;

			for (; i < cookies.length; i++) {
				var parts = cookies[i].split('=');
				var cookie = parts.slice(1).join('=');

				if (!json && cookie.charAt(0) === '"') {
					cookie = cookie.slice(1, -1);
				}

				try {
					var name = decode(parts[0]);
					cookie = (converter.read || converter)(cookie, name) ||
						decode(cookie);

					if (json) {
						try {
							cookie = JSON.parse(cookie);
						} catch (e) {}
					}

					jar[name] = cookie;

					if (key === name) {
						break;
					}
				} catch (e) {}
			}

			return key ? jar[key] : jar;
		}

		api.set = set;
		api.get = function (key) {
			return get(key, false /* read as raw */);
		};
		api.getJSON = function (key) {
			return get(key, true /* read as json */);
		};
		api.remove = function (key, attributes) {
			set(key, '', extend(attributes, {
				expires: -1
			}));
		};

		api.defaults = {};

		api.withConverter = init;

		return api;
	}

	return init(function () {});
}));

},{}],59:[function(require,module,exports){
module.exports={
  "saveFormatVersion": 36,
  "development": {
    "googleAnalyticsId": "",
    "matchmakerUrl": "http://localhost:3000/",
    "matchmakerWebsocketUrl": "ws://localhost:3000/",
    "matchmakerGameServerWebsocketUrl": "ws://localhost:2095/",
    "firebase": {
      "apiKey": "AIzaSyDj8y3h2TCaWdAJ_6bjskf-7V0-y2Z1I1U",
      "authDomain": "junon-dfd53.firebaseapp.com",
      "databaseURL": "https://junon-dfd53.firebaseio.com",
      "projectId": "junon-dfd53",
      "storageBucket": "",
      "messagingSenderId": "497331755585",
      "appId": "1:497331755585:web:241453fe17be5b31"
    }
  },
  "production": {
    "googleAnalyticsId": "UA-53143804-3",
    "matchmakerUrl": "https://matchmaker.junon.io/",
    "matchmakerWebsocketUrl": "wss://matchmaker.junon.io/",
    "matchmakerGameServerWebsocketUrl": "ws://matchmaker.junon.io:2095/",
    "firebase": {
      "apiKey": "AIzaSyAbpgpktZ9s42LxAlsSsXvRXtQnLLFH1Eo",
      "authDomain": "junon-io.firebaseapp.com",
      "databaseURL": "https://junon-io.firebaseio.com",
      "projectId": "junon-io",
      "storageBucket": "junon-io.appspot.com",
      "messagingSenderId": "753451258380",
      "appId": "1:753451258380:web:6534c35fb40a95a3"
    }
  }
}

},{}],60:[function(require,module,exports){
var hashClear = require('./_hashClear'),
    hashDelete = require('./_hashDelete'),
    hashGet = require('./_hashGet'),
    hashHas = require('./_hashHas'),
    hashSet = require('./_hashSet');

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

module.exports = Hash;

},{"./_hashClear":101,"./_hashDelete":102,"./_hashGet":103,"./_hashHas":104,"./_hashSet":105}],61:[function(require,module,exports){
var listCacheClear = require('./_listCacheClear'),
    listCacheDelete = require('./_listCacheDelete'),
    listCacheGet = require('./_listCacheGet'),
    listCacheHas = require('./_listCacheHas'),
    listCacheSet = require('./_listCacheSet');

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

module.exports = ListCache;

},{"./_listCacheClear":112,"./_listCacheDelete":113,"./_listCacheGet":114,"./_listCacheHas":115,"./_listCacheSet":116}],62:[function(require,module,exports){
var getNative = require('./_getNative'),
    root = require('./_root');

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map');

module.exports = Map;

},{"./_getNative":97,"./_root":128}],63:[function(require,module,exports){
var mapCacheClear = require('./_mapCacheClear'),
    mapCacheDelete = require('./_mapCacheDelete'),
    mapCacheGet = require('./_mapCacheGet'),
    mapCacheHas = require('./_mapCacheHas'),
    mapCacheSet = require('./_mapCacheSet');

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

module.exports = MapCache;

},{"./_mapCacheClear":117,"./_mapCacheDelete":118,"./_mapCacheGet":119,"./_mapCacheHas":120,"./_mapCacheSet":121}],64:[function(require,module,exports){
var ListCache = require('./_ListCache'),
    stackClear = require('./_stackClear'),
    stackDelete = require('./_stackDelete'),
    stackGet = require('./_stackGet'),
    stackHas = require('./_stackHas'),
    stackSet = require('./_stackSet');

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

module.exports = Stack;

},{"./_ListCache":61,"./_stackClear":132,"./_stackDelete":133,"./_stackGet":134,"./_stackHas":135,"./_stackSet":136}],65:[function(require,module,exports){
var root = require('./_root');

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;

},{"./_root":128}],66:[function(require,module,exports){
var root = require('./_root');

/** Built-in value references. */
var Uint8Array = root.Uint8Array;

module.exports = Uint8Array;

},{"./_root":128}],67:[function(require,module,exports){
/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0: return func.call(thisArg);
    case 1: return func.call(thisArg, args[0]);
    case 2: return func.call(thisArg, args[0], args[1]);
    case 3: return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

module.exports = apply;

},{}],68:[function(require,module,exports){
var baseTimes = require('./_baseTimes'),
    isArguments = require('./isArguments'),
    isArray = require('./isArray'),
    isBuffer = require('./isBuffer'),
    isIndex = require('./_isIndex'),
    isTypedArray = require('./isTypedArray');

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray(value),
      isArg = !isArr && isArguments(value),
      isBuff = !isArr && !isArg && isBuffer(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           isIndex(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = arrayLikeKeys;

},{"./_baseTimes":84,"./_isIndex":107,"./isArguments":141,"./isArray":142,"./isBuffer":145,"./isTypedArray":151}],69:[function(require,module,exports){
var baseAssignValue = require('./_baseAssignValue'),
    eq = require('./eq');

/**
 * This function is like `assignValue` except that it doesn't assign
 * `undefined` values.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignMergeValue(object, key, value) {
  if ((value !== undefined && !eq(object[key], value)) ||
      (value === undefined && !(key in object))) {
    baseAssignValue(object, key, value);
  }
}

module.exports = assignMergeValue;

},{"./_baseAssignValue":72,"./eq":139}],70:[function(require,module,exports){
var baseAssignValue = require('./_baseAssignValue'),
    eq = require('./eq');

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
      (value === undefined && !(key in object))) {
    baseAssignValue(object, key, value);
  }
}

module.exports = assignValue;

},{"./_baseAssignValue":72,"./eq":139}],71:[function(require,module,exports){
var eq = require('./eq');

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

module.exports = assocIndexOf;

},{"./eq":139}],72:[function(require,module,exports){
var defineProperty = require('./_defineProperty');

/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function baseAssignValue(object, key, value) {
  if (key == '__proto__' && defineProperty) {
    defineProperty(object, key, {
      'configurable': true,
      'enumerable': true,
      'value': value,
      'writable': true
    });
  } else {
    object[key] = value;
  }
}

module.exports = baseAssignValue;

},{"./_defineProperty":94}],73:[function(require,module,exports){
var isObject = require('./isObject');

/** Built-in value references. */
var objectCreate = Object.create;

/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */
var baseCreate = (function() {
  function object() {}
  return function(proto) {
    if (!isObject(proto)) {
      return {};
    }
    if (objectCreate) {
      return objectCreate(proto);
    }
    object.prototype = proto;
    var result = new object;
    object.prototype = undefined;
    return result;
  };
}());

module.exports = baseCreate;

},{"./isObject":148}],74:[function(require,module,exports){
var createBaseFor = require('./_createBaseFor');

/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */
var baseFor = createBaseFor();

module.exports = baseFor;

},{"./_createBaseFor":93}],75:[function(require,module,exports){
var Symbol = require('./_Symbol'),
    getRawTag = require('./_getRawTag'),
    objectToString = require('./_objectToString');

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

module.exports = baseGetTag;

},{"./_Symbol":65,"./_getRawTag":99,"./_objectToString":125}],76:[function(require,module,exports){
var baseGetTag = require('./_baseGetTag'),
    isObjectLike = require('./isObjectLike');

/** `Object#toString` result references. */
var argsTag = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag;
}

module.exports = baseIsArguments;

},{"./_baseGetTag":75,"./isObjectLike":149}],77:[function(require,module,exports){
var isFunction = require('./isFunction'),
    isMasked = require('./_isMasked'),
    isObject = require('./isObject'),
    toSource = require('./_toSource');

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

module.exports = baseIsNative;

},{"./_isMasked":110,"./_toSource":137,"./isFunction":146,"./isObject":148}],78:[function(require,module,exports){
var baseGetTag = require('./_baseGetTag'),
    isLength = require('./isLength'),
    isObjectLike = require('./isObjectLike');

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike(value) &&
    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}

module.exports = baseIsTypedArray;

},{"./_baseGetTag":75,"./isLength":147,"./isObjectLike":149}],79:[function(require,module,exports){
var isObject = require('./isObject'),
    isPrototype = require('./_isPrototype'),
    nativeKeysIn = require('./_nativeKeysIn');

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeysIn(object) {
  if (!isObject(object)) {
    return nativeKeysIn(object);
  }
  var isProto = isPrototype(object),
      result = [];

  for (var key in object) {
    if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeysIn;

},{"./_isPrototype":111,"./_nativeKeysIn":123,"./isObject":148}],80:[function(require,module,exports){
var Stack = require('./_Stack'),
    assignMergeValue = require('./_assignMergeValue'),
    baseFor = require('./_baseFor'),
    baseMergeDeep = require('./_baseMergeDeep'),
    isObject = require('./isObject'),
    keysIn = require('./keysIn'),
    safeGet = require('./_safeGet');

/**
 * The base implementation of `_.merge` without support for multiple sources.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} [customizer] The function to customize merged values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */
function baseMerge(object, source, srcIndex, customizer, stack) {
  if (object === source) {
    return;
  }
  baseFor(source, function(srcValue, key) {
    stack || (stack = new Stack);
    if (isObject(srcValue)) {
      baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
    }
    else {
      var newValue = customizer
        ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
        : undefined;

      if (newValue === undefined) {
        newValue = srcValue;
      }
      assignMergeValue(object, key, newValue);
    }
  }, keysIn);
}

module.exports = baseMerge;

},{"./_Stack":64,"./_assignMergeValue":69,"./_baseFor":74,"./_baseMergeDeep":81,"./_safeGet":129,"./isObject":148,"./keysIn":152}],81:[function(require,module,exports){
var assignMergeValue = require('./_assignMergeValue'),
    cloneBuffer = require('./_cloneBuffer'),
    cloneTypedArray = require('./_cloneTypedArray'),
    copyArray = require('./_copyArray'),
    initCloneObject = require('./_initCloneObject'),
    isArguments = require('./isArguments'),
    isArray = require('./isArray'),
    isArrayLikeObject = require('./isArrayLikeObject'),
    isBuffer = require('./isBuffer'),
    isFunction = require('./isFunction'),
    isObject = require('./isObject'),
    isPlainObject = require('./isPlainObject'),
    isTypedArray = require('./isTypedArray'),
    safeGet = require('./_safeGet'),
    toPlainObject = require('./toPlainObject');

/**
 * A specialized version of `baseMerge` for arrays and objects which performs
 * deep merges and tracks traversed objects enabling objects with circular
 * references to be merged.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {string} key The key of the value to merge.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} mergeFunc The function to merge values.
 * @param {Function} [customizer] The function to customize assigned values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */
function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
  var objValue = safeGet(object, key),
      srcValue = safeGet(source, key),
      stacked = stack.get(srcValue);

  if (stacked) {
    assignMergeValue(object, key, stacked);
    return;
  }
  var newValue = customizer
    ? customizer(objValue, srcValue, (key + ''), object, source, stack)
    : undefined;

  var isCommon = newValue === undefined;

  if (isCommon) {
    var isArr = isArray(srcValue),
        isBuff = !isArr && isBuffer(srcValue),
        isTyped = !isArr && !isBuff && isTypedArray(srcValue);

    newValue = srcValue;
    if (isArr || isBuff || isTyped) {
      if (isArray(objValue)) {
        newValue = objValue;
      }
      else if (isArrayLikeObject(objValue)) {
        newValue = copyArray(objValue);
      }
      else if (isBuff) {
        isCommon = false;
        newValue = cloneBuffer(srcValue, true);
      }
      else if (isTyped) {
        isCommon = false;
        newValue = cloneTypedArray(srcValue, true);
      }
      else {
        newValue = [];
      }
    }
    else if (isPlainObject(srcValue) || isArguments(srcValue)) {
      newValue = objValue;
      if (isArguments(objValue)) {
        newValue = toPlainObject(objValue);
      }
      else if (!isObject(objValue) || isFunction(objValue)) {
        newValue = initCloneObject(srcValue);
      }
    }
    else {
      isCommon = false;
    }
  }
  if (isCommon) {
    // Recursively merge objects and arrays (susceptible to call stack limits).
    stack.set(srcValue, newValue);
    mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
    stack['delete'](srcValue);
  }
  assignMergeValue(object, key, newValue);
}

module.exports = baseMergeDeep;

},{"./_assignMergeValue":69,"./_cloneBuffer":87,"./_cloneTypedArray":88,"./_copyArray":89,"./_initCloneObject":106,"./_safeGet":129,"./isArguments":141,"./isArray":142,"./isArrayLikeObject":144,"./isBuffer":145,"./isFunction":146,"./isObject":148,"./isPlainObject":150,"./isTypedArray":151,"./toPlainObject":155}],82:[function(require,module,exports){
var identity = require('./identity'),
    overRest = require('./_overRest'),
    setToString = require('./_setToString');

/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */
function baseRest(func, start) {
  return setToString(overRest(func, start, identity), func + '');
}

module.exports = baseRest;

},{"./_overRest":127,"./_setToString":130,"./identity":140}],83:[function(require,module,exports){
var constant = require('./constant'),
    defineProperty = require('./_defineProperty'),
    identity = require('./identity');

/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var baseSetToString = !defineProperty ? identity : function(func, string) {
  return defineProperty(func, 'toString', {
    'configurable': true,
    'enumerable': false,
    'value': constant(string),
    'writable': true
  });
};

module.exports = baseSetToString;

},{"./_defineProperty":94,"./constant":138,"./identity":140}],84:[function(require,module,exports){
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

module.exports = baseTimes;

},{}],85:[function(require,module,exports){
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

module.exports = baseUnary;

},{}],86:[function(require,module,exports){
var Uint8Array = require('./_Uint8Array');

/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */
function cloneArrayBuffer(arrayBuffer) {
  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
  new Uint8Array(result).set(new Uint8Array(arrayBuffer));
  return result;
}

module.exports = cloneArrayBuffer;

},{"./_Uint8Array":66}],87:[function(require,module,exports){
var root = require('./_root');

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined,
    allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;

/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */
function cloneBuffer(buffer, isDeep) {
  if (isDeep) {
    return buffer.slice();
  }
  var length = buffer.length,
      result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

  buffer.copy(result);
  return result;
}

module.exports = cloneBuffer;

},{"./_root":128}],88:[function(require,module,exports){
var cloneArrayBuffer = require('./_cloneArrayBuffer');

/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */
function cloneTypedArray(typedArray, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}

module.exports = cloneTypedArray;

},{"./_cloneArrayBuffer":86}],89:[function(require,module,exports){
/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */
function copyArray(source, array) {
  var index = -1,
      length = source.length;

  array || (array = Array(length));
  while (++index < length) {
    array[index] = source[index];
  }
  return array;
}

module.exports = copyArray;

},{}],90:[function(require,module,exports){
var assignValue = require('./_assignValue'),
    baseAssignValue = require('./_baseAssignValue');

/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
  var isNew = !object;
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];

    var newValue = customizer
      ? customizer(object[key], source[key], key, object, source)
      : undefined;

    if (newValue === undefined) {
      newValue = source[key];
    }
    if (isNew) {
      baseAssignValue(object, key, newValue);
    } else {
      assignValue(object, key, newValue);
    }
  }
  return object;
}

module.exports = copyObject;

},{"./_assignValue":70,"./_baseAssignValue":72}],91:[function(require,module,exports){
var root = require('./_root');

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

module.exports = coreJsData;

},{"./_root":128}],92:[function(require,module,exports){
var baseRest = require('./_baseRest'),
    isIterateeCall = require('./_isIterateeCall');

/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */
function createAssigner(assigner) {
  return baseRest(function(object, sources) {
    var index = -1,
        length = sources.length,
        customizer = length > 1 ? sources[length - 1] : undefined,
        guard = length > 2 ? sources[2] : undefined;

    customizer = (assigner.length > 3 && typeof customizer == 'function')
      ? (length--, customizer)
      : undefined;

    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
      customizer = length < 3 ? undefined : customizer;
      length = 1;
    }
    object = Object(object);
    while (++index < length) {
      var source = sources[index];
      if (source) {
        assigner(object, source, index, customizer);
      }
    }
    return object;
  });
}

module.exports = createAssigner;

},{"./_baseRest":82,"./_isIterateeCall":108}],93:[function(require,module,exports){
/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseFor(fromRight) {
  return function(object, iteratee, keysFunc) {
    var index = -1,
        iterable = Object(object),
        props = keysFunc(object),
        length = props.length;

    while (length--) {
      var key = props[fromRight ? length : ++index];
      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }
    return object;
  };
}

module.exports = createBaseFor;

},{}],94:[function(require,module,exports){
var getNative = require('./_getNative');

var defineProperty = (function() {
  try {
    var func = getNative(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}());

module.exports = defineProperty;

},{"./_getNative":97}],95:[function(require,module,exports){
(function (global){
/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

module.exports = freeGlobal;

}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{}],96:[function(require,module,exports){
var isKeyable = require('./_isKeyable');

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

module.exports = getMapData;

},{"./_isKeyable":109}],97:[function(require,module,exports){
var baseIsNative = require('./_baseIsNative'),
    getValue = require('./_getValue');

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

module.exports = getNative;

},{"./_baseIsNative":77,"./_getValue":100}],98:[function(require,module,exports){
var overArg = require('./_overArg');

/** Built-in value references. */
var getPrototype = overArg(Object.getPrototypeOf, Object);

module.exports = getPrototype;

},{"./_overArg":126}],99:[function(require,module,exports){
var Symbol = require('./_Symbol');

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

module.exports = getRawTag;

},{"./_Symbol":65}],100:[function(require,module,exports){
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

module.exports = getValue;

},{}],101:[function(require,module,exports){
var nativeCreate = require('./_nativeCreate');

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
  this.size = 0;
}

module.exports = hashClear;

},{"./_nativeCreate":122}],102:[function(require,module,exports){
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = hashDelete;

},{}],103:[function(require,module,exports){
var nativeCreate = require('./_nativeCreate');

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

module.exports = hashGet;

},{"./_nativeCreate":122}],104:[function(require,module,exports){
var nativeCreate = require('./_nativeCreate');

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
}

module.exports = hashHas;

},{"./_nativeCreate":122}],105:[function(require,module,exports){
var nativeCreate = require('./_nativeCreate');

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

module.exports = hashSet;

},{"./_nativeCreate":122}],106:[function(require,module,exports){
var baseCreate = require('./_baseCreate'),
    getPrototype = require('./_getPrototype'),
    isPrototype = require('./_isPrototype');

/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneObject(object) {
  return (typeof object.constructor == 'function' && !isPrototype(object))
    ? baseCreate(getPrototype(object))
    : {};
}

module.exports = initCloneObject;

},{"./_baseCreate":73,"./_getPrototype":98,"./_isPrototype":111}],107:[function(require,module,exports){
/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER : length;

  return !!length &&
    (type == 'number' ||
      (type != 'symbol' && reIsUint.test(value))) &&
        (value > -1 && value % 1 == 0 && value < length);
}

module.exports = isIndex;

},{}],108:[function(require,module,exports){
var eq = require('./eq'),
    isArrayLike = require('./isArrayLike'),
    isIndex = require('./_isIndex'),
    isObject = require('./isObject');

/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */
function isIterateeCall(value, index, object) {
  if (!isObject(object)) {
    return false;
  }
  var type = typeof index;
  if (type == 'number'
        ? (isArrayLike(object) && isIndex(index, object.length))
        : (type == 'string' && index in object)
      ) {
    return eq(object[index], value);
  }
  return false;
}

module.exports = isIterateeCall;

},{"./_isIndex":107,"./eq":139,"./isArrayLike":143,"./isObject":148}],109:[function(require,module,exports){
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

module.exports = isKeyable;

},{}],110:[function(require,module,exports){
var coreJsData = require('./_coreJsData');

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

module.exports = isMasked;

},{"./_coreJsData":91}],111:[function(require,module,exports){
/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

module.exports = isPrototype;

},{}],112:[function(require,module,exports){
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

module.exports = listCacheClear;

},{}],113:[function(require,module,exports){
var assocIndexOf = require('./_assocIndexOf');

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

module.exports = listCacheDelete;

},{"./_assocIndexOf":71}],114:[function(require,module,exports){
var assocIndexOf = require('./_assocIndexOf');

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

module.exports = listCacheGet;

},{"./_assocIndexOf":71}],115:[function(require,module,exports){
var assocIndexOf = require('./_assocIndexOf');

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

module.exports = listCacheHas;

},{"./_assocIndexOf":71}],116:[function(require,module,exports){
var assocIndexOf = require('./_assocIndexOf');

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

module.exports = listCacheSet;

},{"./_assocIndexOf":71}],117:[function(require,module,exports){
var Hash = require('./_Hash'),
    ListCache = require('./_ListCache'),
    Map = require('./_Map');

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

module.exports = mapCacheClear;

},{"./_Hash":60,"./_ListCache":61,"./_Map":62}],118:[function(require,module,exports){
var getMapData = require('./_getMapData');

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = mapCacheDelete;

},{"./_getMapData":96}],119:[function(require,module,exports){
var getMapData = require('./_getMapData');

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

module.exports = mapCacheGet;

},{"./_getMapData":96}],120:[function(require,module,exports){
var getMapData = require('./_getMapData');

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

module.exports = mapCacheHas;

},{"./_getMapData":96}],121:[function(require,module,exports){
var getMapData = require('./_getMapData');

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

module.exports = mapCacheSet;

},{"./_getMapData":96}],122:[function(require,module,exports){
var getNative = require('./_getNative');

/* Built-in method references that are verified to be native. */
var nativeCreate = getNative(Object, 'create');

module.exports = nativeCreate;

},{"./_getNative":97}],123:[function(require,module,exports){
/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function nativeKeysIn(object) {
  var result = [];
  if (object != null) {
    for (var key in Object(object)) {
      result.push(key);
    }
  }
  return result;
}

module.exports = nativeKeysIn;

},{}],124:[function(require,module,exports){
var freeGlobal = require('./_freeGlobal');

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    // Use `util.types` for Node.js 10+.
    var types = freeModule && freeModule.require && freeModule.require('util').types;

    if (types) {
      return types;
    }

    // Legacy `process.binding('util')` for Node.js < 10.
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

module.exports = nodeUtil;

},{"./_freeGlobal":95}],125:[function(require,module,exports){
/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

module.exports = objectToString;

},{}],126:[function(require,module,exports){
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

module.exports = overArg;

},{}],127:[function(require,module,exports){
var apply = require('./_apply');

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */
function overRest(func, start, transform) {
  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
  return function() {
    var args = arguments,
        index = -1,
        length = nativeMax(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = transform(array);
    return apply(func, this, otherArgs);
  };
}

module.exports = overRest;

},{"./_apply":67}],128:[function(require,module,exports){
var freeGlobal = require('./_freeGlobal');

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

module.exports = root;

},{"./_freeGlobal":95}],129:[function(require,module,exports){
/**
 * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function safeGet(object, key) {
  if (key === 'constructor' && typeof object[key] === 'function') {
    return;
  }

  if (key == '__proto__') {
    return;
  }

  return object[key];
}

module.exports = safeGet;

},{}],130:[function(require,module,exports){
var baseSetToString = require('./_baseSetToString'),
    shortOut = require('./_shortOut');

/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var setToString = shortOut(baseSetToString);

module.exports = setToString;

},{"./_baseSetToString":83,"./_shortOut":131}],131:[function(require,module,exports){
/** Used to detect hot functions by number of calls within a span of milliseconds. */
var HOT_COUNT = 800,
    HOT_SPAN = 16;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeNow = Date.now;

/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */
function shortOut(func) {
  var count = 0,
      lastCalled = 0;

  return function() {
    var stamp = nativeNow(),
        remaining = HOT_SPAN - (stamp - lastCalled);

    lastCalled = stamp;
    if (remaining > 0) {
      if (++count >= HOT_COUNT) {
        return arguments[0];
      }
    } else {
      count = 0;
    }
    return func.apply(undefined, arguments);
  };
}

module.exports = shortOut;

},{}],132:[function(require,module,exports){
var ListCache = require('./_ListCache');

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache;
  this.size = 0;
}

module.exports = stackClear;

},{"./_ListCache":61}],133:[function(require,module,exports){
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

module.exports = stackDelete;

},{}],134:[function(require,module,exports){
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

module.exports = stackGet;

},{}],135:[function(require,module,exports){
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

module.exports = stackHas;

},{}],136:[function(require,module,exports){
var ListCache = require('./_ListCache'),
    Map = require('./_Map'),
    MapCache = require('./_MapCache');

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache) {
    var pairs = data.__data__;
    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

module.exports = stackSet;

},{"./_ListCache":61,"./_Map":62,"./_MapCache":63}],137:[function(require,module,exports){
/** Used for built-in method references. */
var funcProto = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

module.exports = toSource;

},{}],138:[function(require,module,exports){
/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */
function constant(value) {
  return function() {
    return value;
  };
}

module.exports = constant;

},{}],139:[function(require,module,exports){
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

module.exports = eq;

},{}],140:[function(require,module,exports){
/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

module.exports = identity;

},{}],141:[function(require,module,exports){
var baseIsArguments = require('./_baseIsArguments'),
    isObjectLike = require('./isObjectLike');

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

module.exports = isArguments;

},{"./_baseIsArguments":76,"./isObjectLike":149}],142:[function(require,module,exports){
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

module.exports = isArray;

},{}],143:[function(require,module,exports){
var isFunction = require('./isFunction'),
    isLength = require('./isLength');

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

module.exports = isArrayLike;

},{"./isFunction":146,"./isLength":147}],144:[function(require,module,exports){
var isArrayLike = require('./isArrayLike'),
    isObjectLike = require('./isObjectLike');

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

module.exports = isArrayLikeObject;

},{"./isArrayLike":143,"./isObjectLike":149}],145:[function(require,module,exports){
var root = require('./_root'),
    stubFalse = require('./stubFalse');

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

module.exports = isBuffer;

},{"./_root":128,"./stubFalse":154}],146:[function(require,module,exports){
var baseGetTag = require('./_baseGetTag'),
    isObject = require('./isObject');

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

module.exports = isFunction;

},{"./_baseGetTag":75,"./isObject":148}],147:[function(require,module,exports){
/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

module.exports = isLength;

},{}],148:[function(require,module,exports){
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

module.exports = isObject;

},{}],149:[function(require,module,exports){
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

module.exports = isObjectLike;

},{}],150:[function(require,module,exports){
var baseGetTag = require('./_baseGetTag'),
    getPrototype = require('./_getPrototype'),
    isObjectLike = require('./isObjectLike');

/** `Object#toString` result references. */
var objectTag = '[object Object]';

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
    return false;
  }
  var proto = getPrototype(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
    funcToString.call(Ctor) == objectCtorString;
}

module.exports = isPlainObject;

},{"./_baseGetTag":75,"./_getPrototype":98,"./isObjectLike":149}],151:[function(require,module,exports){
var baseIsTypedArray = require('./_baseIsTypedArray'),
    baseUnary = require('./_baseUnary'),
    nodeUtil = require('./_nodeUtil');

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

module.exports = isTypedArray;

},{"./_baseIsTypedArray":78,"./_baseUnary":85,"./_nodeUtil":124}],152:[function(require,module,exports){
var arrayLikeKeys = require('./_arrayLikeKeys'),
    baseKeysIn = require('./_baseKeysIn'),
    isArrayLike = require('./isArrayLike');

/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */
function keysIn(object) {
  return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
}

module.exports = keysIn;

},{"./_arrayLikeKeys":68,"./_baseKeysIn":79,"./isArrayLike":143}],153:[function(require,module,exports){
var baseMerge = require('./_baseMerge'),
    createAssigner = require('./_createAssigner');

/**
 * This method is like `_.merge` except that it accepts `customizer` which
 * is invoked to produce the merged values of the destination and source
 * properties. If `customizer` returns `undefined`, merging is handled by the
 * method instead. The `customizer` is invoked with six arguments:
 * (objValue, srcValue, key, object, source, stack).
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} sources The source objects.
 * @param {Function} customizer The function to customize assigned values.
 * @returns {Object} Returns `object`.
 * @example
 *
 * function customizer(objValue, srcValue) {
 *   if (_.isArray(objValue)) {
 *     return objValue.concat(srcValue);
 *   }
 * }
 *
 * var object = { 'a': [1], 'b': [2] };
 * var other = { 'a': [3], 'b': [4] };
 *
 * _.mergeWith(object, other, customizer);
 * // => { 'a': [1, 3], 'b': [2, 4] }
 */
var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
  baseMerge(object, source, srcIndex, customizer);
});

module.exports = mergeWith;

},{"./_baseMerge":80,"./_createAssigner":92}],154:[function(require,module,exports){
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = stubFalse;

},{}],155:[function(require,module,exports){
var copyObject = require('./_copyObject'),
    keysIn = require('./keysIn');

/**
 * Converts `value` to a plain object flattening inherited enumerable string
 * keyed properties of `value` to own properties of the plain object.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {Object} Returns the converted plain object.
 * @example
 *
 * function Foo() {
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.assign({ 'a': 1 }, new Foo);
 * // => { 'a': 1, 'b': 2 }
 *
 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
 * // => { 'a': 1, 'b': 2, 'c': 3 }
 */
function toPlainObject(value) {
  return copyObject(value, keysIn(value));
}

module.exports = toPlainObject;

},{"./_copyObject":90,"./keysIn":152}],156:[function(require,module,exports){
!function(t,i){"object"==typeof exports&&"object"==typeof module?module.exports=i():"function"==typeof define&&define.amd?define("nipplejs",[],i):"object"==typeof exports?exports.nipplejs=i():t.nipplejs=i()}(window,function(){return function(t){var i={};function e(o){if(i[o])return i[o].exports;var n=i[o]={i:o,l:!1,exports:{}};return t[o].call(n.exports,n,n.exports,e),n.l=!0,n.exports}return e.m=t,e.c=i,e.d=function(t,i,o){e.o(t,i)||Object.defineProperty(t,i,{enumerable:!0,get:o})},e.r=function(t){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(t,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(t,"__esModule",{value:!0})},e.t=function(t,i){if(1&i&&(t=e(t)),8&i)return t;if(4&i&&"object"==typeof t&&t&&t.__esModule)return t;var o=Object.create(null);if(e.r(o),Object.defineProperty(o,"default",{enumerable:!0,value:t}),2&i&&"string"!=typeof t)for(var n in t)e.d(o,n,function(i){return t[i]}.bind(null,n));return o},e.n=function(t){var i=t&&t.__esModule?function(){return t.default}:function(){return t};return e.d(i,"a",i),i},e.o=function(t,i){return Object.prototype.hasOwnProperty.call(t,i)},e.p="",e(e.s=0)}([function(t,i,e){"use strict";e.r(i);var o,n=function(t,i){var e=i.x-t.x,o=i.y-t.y;return Math.sqrt(e*e+o*o)},s=function(t){return t*(Math.PI/180)},r=function(t){return t*(180/Math.PI)},d=function(t,i,e){for(var o,n=i.split(/[ ,]+/g),s=0;s<n.length;s+=1)o=n[s],t.addEventListener?t.addEventListener(o,e,!1):t.attachEvent&&t.attachEvent(o,e)},p=function(t,i,e){for(var o,n=i.split(/[ ,]+/g),s=0;s<n.length;s+=1)o=n[s],t.removeEventListener?t.removeEventListener(o,e):t.detachEvent&&t.detachEvent(o,e)},a=function(t){return t.preventDefault(),t.type.match(/^touch/)?t.changedTouches:t},c=function(){return{x:void 0!==window.pageXOffset?window.pageXOffset:(document.documentElement||document.body.parentNode||document.body).scrollLeft,y:void 0!==window.pageYOffset?window.pageYOffset:(document.documentElement||document.body.parentNode||document.body).scrollTop}},h=function(t,i){i.top||i.right||i.bottom||i.left?(t.style.top=i.top,t.style.right=i.right,t.style.bottom=i.bottom,t.style.left=i.left):(t.style.left=i.x+"px",t.style.top=i.y+"px")},l=function(t,i,e){var o=u(t);for(var n in o)if(o.hasOwnProperty(n))if("string"==typeof i)o[n]=i+" "+e;else{for(var s="",r=0,d=i.length;r<d;r+=1)s+=i[r]+" "+e+", ";o[n]=s.slice(0,-2)}return o},u=function(t){var i={};i[t]="";return["webkit","Moz","o"].forEach(function(e){i[e+t.charAt(0).toUpperCase()+t.slice(1)]=""}),i},f=function(t,i){for(var e in i)i.hasOwnProperty(e)&&(t[e]=i[e]);return t},y=function(t,i){if(t.length)for(var e=0,o=t.length;e<o;e+=1)i(t[e]);else i(t)},m=!!("ontouchstart"in window),v=!!window.PointerEvent,g=!!window.MSPointerEvent,b={start:"mousedown",move:"mousemove",end:"mouseup"},x={};function O(){}v?o={start:"pointerdown",move:"pointermove",end:"pointerup, pointercancel"}:g?o={start:"MSPointerDown",move:"MSPointerMove",end:"MSPointerUp"}:m?(o={start:"touchstart",move:"touchmove",end:"touchend, touchcancel"},x=b):o=b,O.prototype.on=function(t,i){var e,o=t.split(/[ ,]+/g);this._handlers_=this._handlers_||{};for(var n=0;n<o.length;n+=1)e=o[n],this._handlers_[e]=this._handlers_[e]||[],this._handlers_[e].push(i);return this},O.prototype.off=function(t,i){return this._handlers_=this._handlers_||{},void 0===t?this._handlers_={}:void 0===i?this._handlers_[t]=null:this._handlers_[t]&&this._handlers_[t].indexOf(i)>=0&&this._handlers_[t].splice(this._handlers_[t].indexOf(i),1),this},O.prototype.trigger=function(t,i){var e,o=this,n=t.split(/[ ,]+/g);o._handlers_=o._handlers_||{};for(var s=0;s<n.length;s+=1)e=n[s],o._handlers_[e]&&o._handlers_[e].length&&o._handlers_[e].forEach(function(t){t.call(o,{type:e,target:o},i)})},O.prototype.config=function(t){this.options=this.defaults||{},t&&(this.options=function(t,i){var e={};for(var o in t)t.hasOwnProperty(o)&&i.hasOwnProperty(o)?e[o]=i[o]:t.hasOwnProperty(o)&&(e[o]=t[o]);return e}(this.options,t))},O.prototype.bindEvt=function(t,i){var e=this;return e._domHandlers_=e._domHandlers_||{},e._domHandlers_[i]=function(){"function"==typeof e["on"+i]?e["on"+i].apply(e,arguments):console.warn('[WARNING] : Missing "on'+i+'" handler.')},d(t,o[i],e._domHandlers_[i]),x[i]&&d(t,x[i],e._domHandlers_[i]),e},O.prototype.unbindEvt=function(t,i){return this._domHandlers_=this._domHandlers_||{},p(t,o[i],this._domHandlers_[i]),x[i]&&p(t,x[i],this._domHandlers_[i]),delete this._domHandlers_[i],this};var _=O;function w(t,i){return this.identifier=i.identifier,this.position=i.position,this.frontPosition=i.frontPosition,this.collection=t,this.defaults={size:100,threshold:.1,color:"white",fadeTime:250,dataOnly:!1,restJoystick:!0,restOpacity:.5,mode:"dynamic",zone:document.body,lockX:!1,lockY:!1},this.config(i),"dynamic"===this.options.mode&&(this.options.restOpacity=0),this.id=w.id,w.id+=1,this.buildEl().stylize(),this.instance={el:this.ui.el,on:this.on.bind(this),off:this.off.bind(this),show:this.show.bind(this),hide:this.hide.bind(this),add:this.addToDom.bind(this),remove:this.removeFromDom.bind(this),destroy:this.destroy.bind(this),resetDirection:this.resetDirection.bind(this),computeDirection:this.computeDirection.bind(this),trigger:this.trigger.bind(this),position:this.position,frontPosition:this.frontPosition,ui:this.ui,identifier:this.identifier,id:this.id,options:this.options},this.instance}w.prototype=new _,w.constructor=w,w.id=0,w.prototype.buildEl=function(t){return this.ui={},this.options.dataOnly?this:(this.ui.el=document.createElement("div"),this.ui.back=document.createElement("div"),this.ui.front=document.createElement("div"),this.ui.el.className="nipple collection_"+this.collection.id,this.ui.back.className="back",this.ui.front.className="front",this.ui.el.setAttribute("id","nipple_"+this.collection.id+"_"+this.id),this.ui.el.appendChild(this.ui.back),this.ui.el.appendChild(this.ui.front),this)},w.prototype.stylize=function(){if(this.options.dataOnly)return this;var t=this.options.fadeTime+"ms",i=function(t,i){var e=u(t);for(var o in e)e.hasOwnProperty(o)&&(e[o]=i);return e}("borderRadius","50%"),e=l("transition","opacity",t),o={};return o.el={position:"absolute",opacity:this.options.restOpacity,display:"block",zIndex:999},o.back={position:"absolute",display:"block",width:this.options.size+"px",height:this.options.size+"px",marginLeft:-this.options.size/2+"px",marginTop:-this.options.size/2+"px",background:this.options.color,opacity:".5"},o.front={width:this.options.size/2+"px",height:this.options.size/2+"px",position:"absolute",display:"block",marginLeft:-this.options.size/4+"px",marginTop:-this.options.size/4+"px",background:this.options.color,opacity:".5"},f(o.el,e),f(o.back,i),f(o.front,i),this.applyStyles(o),this},w.prototype.applyStyles=function(t){for(var i in this.ui)if(this.ui.hasOwnProperty(i))for(var e in t[i])this.ui[i].style[e]=t[i][e];return this},w.prototype.addToDom=function(){return this.options.dataOnly||document.body.contains(this.ui.el)?this:(this.options.zone.appendChild(this.ui.el),this)},w.prototype.removeFromDom=function(){return this.options.dataOnly||!document.body.contains(this.ui.el)?this:(this.options.zone.removeChild(this.ui.el),this)},w.prototype.destroy=function(){clearTimeout(this.removeTimeout),clearTimeout(this.showTimeout),clearTimeout(this.restTimeout),this.trigger("destroyed",this.instance),this.removeFromDom(),this.off()},w.prototype.show=function(t){var i=this;return i.options.dataOnly?i:(clearTimeout(i.removeTimeout),clearTimeout(i.showTimeout),clearTimeout(i.restTimeout),i.addToDom(),i.restCallback(),setTimeout(function(){i.ui.el.style.opacity=1},0),i.showTimeout=setTimeout(function(){i.trigger("shown",i.instance),"function"==typeof t&&t.call(this)},i.options.fadeTime),i)},w.prototype.hide=function(t){var i=this;return i.options.dataOnly?i:(i.ui.el.style.opacity=i.options.restOpacity,clearTimeout(i.removeTimeout),clearTimeout(i.showTimeout),clearTimeout(i.restTimeout),i.removeTimeout=setTimeout(function(){var e="dynamic"===i.options.mode?"none":"block";i.ui.el.style.display=e,"function"==typeof t&&t.call(i),i.trigger("hidden",i.instance)},i.options.fadeTime),i.options.restJoystick&&i.restPosition(),i)},w.prototype.restPosition=function(t){var i=this;i.frontPosition={x:0,y:0};var e=i.options.fadeTime+"ms",o={};o.front=l("transition",["top","left"],e);var n={front:{}};n.front={left:i.frontPosition.x+"px",top:i.frontPosition.y+"px"},i.applyStyles(o),i.applyStyles(n),i.restTimeout=setTimeout(function(){"function"==typeof t&&t.call(i),i.restCallback()},i.options.fadeTime)},w.prototype.restCallback=function(){var t={};t.front=l("transition","none",""),this.applyStyles(t),this.trigger("rested",this.instance)},w.prototype.resetDirection=function(){this.direction={x:!1,y:!1,angle:!1}},w.prototype.computeDirection=function(t){var i,e,o,n=t.angle.radian,s=Math.PI/4,r=Math.PI/2;if(n>s&&n<3*s&&!t.lockX?i="up":n>-s&&n<=s&&!t.lockY?i="left":n>3*-s&&n<=-s&&!t.lockX?i="down":t.lockY||(i="right"),t.lockY||(e=n>-r&&n<r?"left":"right"),t.lockX||(o=n>0?"up":"down"),t.force>this.options.threshold){var d,p={};for(d in this.direction)this.direction.hasOwnProperty(d)&&(p[d]=this.direction[d]);var a={};for(d in this.direction={x:e,y:o,angle:i},t.direction=this.direction,p)p[d]===this.direction[d]&&(a[d]=!0);if(a.x&&a.y&&a.angle)return t;a.x&&a.y||this.trigger("plain",t),a.x||this.trigger("plain:"+e,t),a.y||this.trigger("plain:"+o,t),a.angle||this.trigger("dir dir:"+i,t)}else this.resetDirection();return t};var T=w;function k(t,i){return this.nipples=[],this.idles=[],this.actives=[],this.ids=[],this.pressureIntervals={},this.manager=t,this.id=k.id,k.id+=1,this.defaults={zone:document.body,multitouch:!1,maxNumberOfNipples:10,mode:"dynamic",position:{top:0,left:0},catchDistance:200,size:100,threshold:.1,color:"white",fadeTime:250,dataOnly:!1,restJoystick:!0,restOpacity:.5,lockX:!1,lockY:!1,dynamicPage:!1},this.config(i),"static"!==this.options.mode&&"semi"!==this.options.mode||(this.options.multitouch=!1),this.options.multitouch||(this.options.maxNumberOfNipples=1),this.updateBox(),this.prepareNipples(),this.bindings(),this.begin(),this.nipples}k.prototype=new _,k.constructor=k,k.id=0,k.prototype.prepareNipples=function(){var t=this.nipples;t.on=this.on.bind(this),t.off=this.off.bind(this),t.options=this.options,t.destroy=this.destroy.bind(this),t.ids=this.ids,t.id=this.id,t.processOnMove=this.processOnMove.bind(this),t.processOnEnd=this.processOnEnd.bind(this),t.get=function(i){if(void 0===i)return t[0];for(var e=0,o=t.length;e<o;e+=1)if(t[e].identifier===i)return t[e];return!1}},k.prototype.bindings=function(){this.bindEvt(this.options.zone,"start"),this.options.zone.style.touchAction="none",this.options.zone.style.msTouchAction="none"},k.prototype.begin=function(){var t=this.options;if("static"===t.mode){var i=this.createNipple(t.position,this.manager.getIdentifier());i.add(),this.idles.push(i)}},k.prototype.createNipple=function(t,i){var e=c(),o={},n=this.options;if(t.x&&t.y)o={x:t.x-(e.x+this.box.left),y:t.y-(e.y+this.box.top)};else if(t.top||t.right||t.bottom||t.left){var s=document.createElement("DIV");s.style.display="hidden",s.style.top=t.top,s.style.right=t.right,s.style.bottom=t.bottom,s.style.left=t.left,s.style.position="absolute",n.zone.appendChild(s);var r=s.getBoundingClientRect();n.zone.removeChild(s),o=t,t={x:r.left+e.x,y:r.top+e.y}}var d=new T(this,{color:n.color,size:n.size,threshold:n.threshold,fadeTime:n.fadeTime,dataOnly:n.dataOnly,restJoystick:n.restJoystick,restOpacity:n.restOpacity,mode:n.mode,identifier:i,position:t,zone:n.zone,frontPosition:{x:0,y:0}});return n.dataOnly||(h(d.ui.el,o),h(d.ui.front,d.frontPosition)),this.nipples.push(d),this.trigger("added "+d.identifier+":added",d),this.manager.trigger("added "+d.identifier+":added",d),this.bindNipple(d),d},k.prototype.updateBox=function(){this.box=this.options.zone.getBoundingClientRect()},k.prototype.bindNipple=function(t){var i,e=this,o=function(t,o){i=t.type+" "+o.id+":"+t.type,e.trigger(i,o)};t.on("destroyed",e.onDestroyed.bind(e)),t.on("shown hidden rested dir plain",o),t.on("dir:up dir:right dir:down dir:left",o),t.on("plain:up plain:right plain:down plain:left",o)},k.prototype.pressureFn=function(t,i,e){var o=this,n=0;clearInterval(o.pressureIntervals[e]),o.pressureIntervals[e]=setInterval(function(){var e=t.force||t.pressure||t.webkitForce||0;e!==n&&(i.trigger("pressure",e),o.trigger("pressure "+i.identifier+":pressure",e),n=e)}.bind(o),100)},k.prototype.onstart=function(t){var i=this,e=i.options,o=t;t=a(t),i.updateBox();return y(t,function(n){i.actives.length<e.maxNumberOfNipples?i.processOnStart(n):o.type.match(/^touch/)&&(Object.keys(i.manager.ids).forEach(function(e){if(Object.values(o.touches).findIndex(function(t){return t.identifier===e})<0){var n=[t[0]];n.identifier=e,i.processOnEnd(n)}}),i.actives.length<e.maxNumberOfNipples&&i.processOnStart(n))}),i.manager.bindDocument(),!1},k.prototype.processOnStart=function(t){var i,e=this,o=e.options,s=e.manager.getIdentifier(t),r=t.force||t.pressure||t.webkitForce||0,d={x:t.pageX,y:t.pageY},p=e.getOrCreate(s,d);p.identifier!==s&&e.manager.removeIdentifier(p.identifier),p.identifier=s;var a=function(i){i.trigger("start",i),e.trigger("start "+i.id+":start",i),i.show(),r>0&&e.pressureFn(t,i,i.identifier),e.processOnMove(t)};if((i=e.idles.indexOf(p))>=0&&e.idles.splice(i,1),e.actives.push(p),e.ids.push(p.identifier),"semi"!==o.mode)a(p);else{if(!(n(d,p.position)<=o.catchDistance))return p.destroy(),void e.processOnStart(t);a(p)}return p},k.prototype.getOrCreate=function(t,i){var e,o=this.options;return/(semi|static)/.test(o.mode)?(e=this.idles[0])?(this.idles.splice(0,1),e):"semi"===o.mode?this.createNipple(i,t):(console.warn("Coudln't find the needed nipple."),!1):e=this.createNipple(i,t)},k.prototype.processOnMove=function(t){var i=this.options,e=this.manager.getIdentifier(t),o=this.nipples.get(e);if(function(t){return"pointerdown"===t.type||"pointermove"===t.type||(isNaN(t.buttons)?0!==t.pressure:0!==t.buttons)}(t)){if(!o)return console.error("Found zombie joystick with ID "+e),void this.manager.removeIdentifier(e);if(i.dynamicPage){var d=c();a=o.el.getBoundingClientRect(),o.position={x:d.x+a.left,y:d.y+a.top}}o.identifier=e;var p=o.options.size/2,a={x:t.pageX,y:t.pageY};i.lockX&&(a.y=o.position.y),i.lockY&&(a.x=o.position.x);var l,u,f,y,m,v,g,b,x=n(a,o.position),O=(l=a,u=o.position,f=u.x-l.x,y=u.y-l.y,r(Math.atan2(y,f))),_=s(O),w=x/p,T={distance:x,position:a};x>p&&(x=p,m=o.position,v=x,b={x:0,y:0},g=s(g=O),b.x=m.x-v*Math.cos(g),b.y=m.y-v*Math.sin(g),a=b);var k=a.x-o.position.x,E=a.y-o.position.y;o.frontPosition={x:k,y:E},i.dataOnly||h(o.ui.front,o.frontPosition);var P={identifier:o.identifier,position:a,force:w,pressure:t.force||t.pressure||t.webkitForce||0,distance:x,angle:{radian:_,degree:O},vector:{x:k/p,y:-E/p},raw:T,instance:o,lockX:i.lockX,lockY:i.lockY};(P=o.computeDirection(P)).angle={radian:s(180-O),degree:180-O},o.trigger("move",P),this.trigger("move "+o.id+":move",P)}else this.processOnEnd(t)},k.prototype.processOnEnd=function(t){var i=this,e=i.options,o=i.manager.getIdentifier(t),n=i.nipples.get(o),s=i.manager.removeIdentifier(n.identifier);n&&(e.dataOnly||n.hide(function(){"dynamic"===e.mode&&(n.trigger("removed",n),i.trigger("removed "+n.id+":removed",n),i.manager.trigger("removed "+n.id+":removed",n),n.destroy())}),clearInterval(i.pressureIntervals[n.identifier]),n.resetDirection(),n.trigger("end",n),i.trigger("end "+n.id+":end",n),i.ids.indexOf(n.identifier)>=0&&i.ids.splice(i.ids.indexOf(n.identifier),1),i.actives.indexOf(n)>=0&&i.actives.splice(i.actives.indexOf(n),1),/(semi|static)/.test(e.mode)?i.idles.push(n):i.nipples.indexOf(n)>=0&&i.nipples.splice(i.nipples.indexOf(n),1),i.manager.unbindDocument(),/(semi|static)/.test(e.mode)&&(i.manager.ids[s.id]=s.identifier))},k.prototype.onDestroyed=function(t,i){this.nipples.indexOf(i)>=0&&this.nipples.splice(this.nipples.indexOf(i),1),this.actives.indexOf(i)>=0&&this.actives.splice(this.actives.indexOf(i),1),this.idles.indexOf(i)>=0&&this.idles.splice(this.idles.indexOf(i),1),this.ids.indexOf(i.identifier)>=0&&this.ids.splice(this.ids.indexOf(i.identifier),1),this.manager.removeIdentifier(i.identifier),this.manager.unbindDocument()},k.prototype.destroy=function(){for(var t in this.unbindEvt(this.options.zone,"start"),this.nipples.forEach(function(t){t.destroy()}),this.pressureIntervals)this.pressureIntervals.hasOwnProperty(t)&&clearInterval(this.pressureIntervals[t]);this.trigger("destroyed",this.nipples),this.manager.unbindDocument(),this.off()};var E=k;function P(t){var i,e=this;return e.ids={},e.index=0,e.collections=[],e.config(t),e.prepareCollections(),d(window,"resize",function(t){clearTimeout(i),i=setTimeout(function(){var t,i=c();e.collections.forEach(function(e){e.forEach(function(e){t=e.el.getBoundingClientRect(),e.position={x:i.x+t.left,y:i.y+t.top}})})},100)}),e.collections}P.prototype=new _,P.constructor=P,P.prototype.prepareCollections=function(){var t=this;t.collections.create=t.create.bind(t),t.collections.on=t.on.bind(t),t.collections.off=t.off.bind(t),t.collections.destroy=t.destroy.bind(t),t.collections.get=function(i){var e;return t.collections.every(function(t){return!(e=t.get(i))}),e}},P.prototype.create=function(t){return this.createCollection(t)},P.prototype.createCollection=function(t){var i=new E(this,t);return this.bindCollection(i),this.collections.push(i),i},P.prototype.bindCollection=function(t){var i,e=this,o=function(t,o){i=t.type+" "+o.id+":"+t.type,e.trigger(i,o)};t.on("destroyed",e.onDestroyed.bind(e)),t.on("shown hidden rested dir plain",o),t.on("dir:up dir:right dir:down dir:left",o),t.on("plain:up plain:right plain:down plain:left",o)},P.prototype.bindDocument=function(){this.binded||(this.bindEvt(document,"move").bindEvt(document,"end"),this.binded=!0)},P.prototype.unbindDocument=function(t){Object.keys(this.ids).length&&!0!==t||(this.unbindEvt(document,"move").unbindEvt(document,"end"),this.binded=!1)},P.prototype.getIdentifier=function(t){var i;return t?void 0===(i=void 0===t.identifier?t.pointerId:t.identifier)&&(i=this.latest||0):i=this.index,void 0===this.ids[i]&&(this.ids[i]=this.index,this.index+=1),this.latest=i,this.ids[i]},P.prototype.removeIdentifier=function(t){var i={};for(var e in this.ids)if(this.ids[e]===t){i.id=e,i.identifier=this.ids[e],delete this.ids[e];break}return i},P.prototype.onmove=function(t){return this.onAny("move",t),!1},P.prototype.onend=function(t){return this.onAny("end",t),!1},P.prototype.oncancel=function(t){return this.onAny("end",t),!1},P.prototype.onAny=function(t,i){var e,o=this,n="processOn"+t.charAt(0).toUpperCase()+t.slice(1);i=a(i);return y(i,function(t){e=o.getIdentifier(t),y(o.collections,function(t,i,e){e.ids.indexOf(i)>=0&&(e[n](t),t._found_=!0)}.bind(null,t,e)),t._found_||o.removeIdentifier(e)}),!1},P.prototype.destroy=function(){this.unbindDocument(!0),this.ids={},this.index=0,this.collections.forEach(function(t){t.destroy()}),this.off()},P.prototype.onDestroyed=function(t,i){if(this.collections.indexOf(i)<0)return!1;this.collections.splice(this.collections.indexOf(i),1)};var I=new P;i.default={create:function(t){return I.create(t)},factory:I}}]).default});
},{}],157:[function(require,module,exports){
//     (c) 2012-2018 Airbnb, Inc.
//
//     polyglot.js may be freely distributed under the terms of the BSD
//     license. For all licensing information, details, and documentation:
//     http://airbnb.github.com/polyglot.js
//
//
// Polyglot.js is an I18n helper library written in JavaScript, made to
// work both in the browser and in Node. It provides a simple solution for
// interpolation and pluralization, based off of Airbnb's
// experience adding I18n functionality to its Backbone.js and Node apps.
//
// Polylglot is agnostic to your translation backend. It doesn't perform any
// translation; it simply gives you a way to manage translated phrases from
// your client- or server-side JavaScript application.
//

'use strict';

var forEach = require('array.prototype.foreach');
var entries = require('object.entries');
var warning = require('warning');
var has = require('has');
var trim = require('string.prototype.trim');

var warn = function warn(message) {
  warning(false, message);
};

var replace = String.prototype.replace;
var split = String.prototype.split;

// #### Pluralization methods
// The string that separates the different phrase possibilities.
var delimiter = '||||';

var russianPluralGroups = function (n) {
  var lastTwo = n % 100;
  var end = lastTwo % 10;
  if (lastTwo !== 11 && end === 1) {
    return 0;
  }
  if (2 <= end && end <= 4 && !(lastTwo >= 12 && lastTwo <= 14)) {
    return 1;
  }
  return 2;
};

var defaultPluralRules = {
  // Mapping from pluralization group plural logic.
  pluralTypes: {
    arabic: function (n) {
      // http://www.arabeyes.org/Plural_Forms
      if (n < 3) { return n; }
      var lastTwo = n % 100;
      if (lastTwo >= 3 && lastTwo <= 10) return 3;
      return lastTwo >= 11 ? 4 : 5;
    },
    bosnian_serbian: russianPluralGroups,
    chinese: function () { return 0; },
    croatian: russianPluralGroups,
    french: function (n) { return n >= 2 ? 1 : 0; },
    german: function (n) { return n !== 1 ? 1 : 0; },
    russian: russianPluralGroups,
    lithuanian: function (n) {
      if (n % 10 === 1 && n % 100 !== 11) { return 0; }
      return n % 10 >= 2 && n % 10 <= 9 && (n % 100 < 11 || n % 100 > 19) ? 1 : 2;
    },
    czech: function (n) {
      if (n === 1) { return 0; }
      return (n >= 2 && n <= 4) ? 1 : 2;
    },
    polish: function (n) {
      if (n === 1) { return 0; }
      var end = n % 10;
      return 2 <= end && end <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2;
    },
    icelandic: function (n) { return (n % 10 !== 1 || n % 100 === 11) ? 1 : 0; },
    slovenian: function (n) {
      var lastTwo = n % 100;
      if (lastTwo === 1) {
        return 0;
      }
      if (lastTwo === 2) {
        return 1;
      }
      if (lastTwo === 3 || lastTwo === 4) {
        return 2;
      }
      return 3;
    }
  },

  // Mapping from pluralization group to individual language codes/locales.
  // Will look up based on exact match, if not found and it's a locale will parse the locale
  // for language code, and if that does not exist will default to 'en'
  pluralTypeToLanguages: {
    arabic: ['ar'],
    bosnian_serbian: ['bs-Latn-BA', 'bs-Cyrl-BA', 'srl-RS', 'sr-RS'],
    chinese: ['id', 'id-ID', 'ja', 'ko', 'ko-KR', 'lo', 'ms', 'th', 'th-TH', 'zh'],
    croatian: ['hr', 'hr-HR'],
    german: ['fa', 'da', 'de', 'en', 'es', 'fi', 'el', 'he', 'hi-IN', 'hu', 'hu-HU', 'it', 'nl', 'no', 'pt', 'sv', 'tr'],
    french: ['fr', 'tl', 'pt-br'],
    russian: ['ru', 'ru-RU'],
    lithuanian: ['lt'],
    czech: ['cs', 'cs-CZ', 'sk'],
    polish: ['pl'],
    icelandic: ['is'],
    slovenian: ['sl-SL']
  }
};

function langToTypeMap(mapping) {
  var ret = {};
  forEach(entries(mapping), function (entry) {
    var type = entry[0];
    var langs = entry[1];
    forEach(langs, function (lang) {
      ret[lang] = type;
    });
  });
  return ret;
}

function pluralTypeName(pluralRules, locale) {
  var langToPluralType = langToTypeMap(pluralRules.pluralTypeToLanguages);
  return langToPluralType[locale]
    || langToPluralType[split.call(locale, /-/, 1)[0]]
    || langToPluralType.en;
}

function pluralTypeIndex(pluralRules, pluralType, count) {
  return pluralRules.pluralTypes[pluralType](count);
}

function createMemoizedPluralTypeNameSelector() {
  var localePluralTypeStorage = {};

  return function (pluralRules, locale) {
    var pluralType = localePluralTypeStorage[locale];

    if (pluralType && !pluralRules.pluralTypes[pluralType]) {
      pluralType = null;
      localePluralTypeStorage[locale] = pluralType;
    }

    if (!pluralType) {
      pluralType = pluralTypeName(pluralRules, locale);

      if (pluralType) {
        localePluralTypeStorage[locale] = pluralType;
      }
    }

    return pluralType;
  };
}

function escape(token) {
  return token.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}

function constructTokenRegex(opts) {
  var prefix = (opts && opts.prefix) || '%{';
  var suffix = (opts && opts.suffix) || '}';

  if (prefix === delimiter || suffix === delimiter) {
    throw new RangeError('"' + delimiter + '" token is reserved for pluralization');
  }

  return new RegExp(escape(prefix) + '(.*?)' + escape(suffix), 'g');
}

var memoizedPluralTypeName = createMemoizedPluralTypeNameSelector();

var defaultTokenRegex = /%\{(.*?)\}/g;

// ### transformPhrase(phrase, substitutions, locale)
//
// Takes a phrase string and transforms it by choosing the correct
// plural form and interpolating it.
//
//     transformPhrase('Hello, %{name}!', {name: 'Spike'});
//     // "Hello, Spike!"
//
// The correct plural form is selected if substitutions.smart_count
// is set. You can pass in a number instead of an Object as `substitutions`
// as a shortcut for `smart_count`.
//
//     transformPhrase('%{smart_count} new messages |||| 1 new message', {smart_count: 1}, 'en');
//     // "1 new message"
//
//     transformPhrase('%{smart_count} new messages |||| 1 new message', {smart_count: 2}, 'en');
//     // "2 new messages"
//
//     transformPhrase('%{smart_count} new messages |||| 1 new message', 5, 'en');
//     // "5 new messages"
//
// You should pass in a third argument, the locale, to specify the correct plural type.
// It defaults to `'en'` with 2 plural forms.
function transformPhrase(phrase, substitutions, locale, tokenRegex, pluralRules) {
  if (typeof phrase !== 'string') {
    throw new TypeError('Polyglot.transformPhrase expects argument #1 to be string');
  }

  if (substitutions == null) {
    return phrase;
  }

  var result = phrase;
  var interpolationRegex = tokenRegex || defaultTokenRegex;

  // allow number as a pluralization shortcut
  var options = typeof substitutions === 'number' ? { smart_count: substitutions } : substitutions;

  // Select plural form: based on a phrase text that contains `n`
  // plural forms separated by `delimiter`, a `locale`, and a `substitutions.smart_count`,
  // choose the correct plural form. This is only done if `count` is set.
  if (options.smart_count != null && phrase) {
    var pluralRulesOrDefault = pluralRules || defaultPluralRules;
    var texts = split.call(phrase, delimiter);
    var bestLocale = locale || 'en';
    var pluralType = memoizedPluralTypeName(pluralRulesOrDefault, bestLocale);
    var pluralTypeWithCount = pluralTypeIndex(
      pluralRulesOrDefault,
      pluralType,
      options.smart_count
    );

    result = trim(texts[pluralTypeWithCount] || texts[0]);
  }

  // Interpolate: Creates a `RegExp` object for each interpolation placeholder.
  result = replace.call(result, interpolationRegex, function (expression, argument) {
    if (!has(options, argument) || options[argument] == null) { return expression; }
    return options[argument];
  });

  return result;
}

// ### Polyglot class constructor
function Polyglot(options) {
  var opts = options || {};
  this.phrases = {};
  this.extend(opts.phrases || {});
  this.currentLocale = opts.locale || 'en';
  var allowMissing = opts.allowMissing ? transformPhrase : null;
  this.onMissingKey = typeof opts.onMissingKey === 'function' ? opts.onMissingKey : allowMissing;
  this.warn = opts.warn || warn;
  this.tokenRegex = constructTokenRegex(opts.interpolation);
  this.pluralRules = opts.pluralRules || defaultPluralRules;
}

// ### polyglot.locale([locale])
//
// Get or set locale. Internally, Polyglot only uses locale for pluralization.
Polyglot.prototype.locale = function (newLocale) {
  if (newLocale) this.currentLocale = newLocale;
  return this.currentLocale;
};

// ### polyglot.extend(phrases)
//
// Use `extend` to tell Polyglot how to translate a given key.
//
//     polyglot.extend({
//       "hello": "Hello",
//       "hello_name": "Hello, %{name}"
//     });
//
// The key can be any string.  Feel free to call `extend` multiple times;
// it will override any phrases with the same key, but leave existing phrases
// untouched.
//
// It is also possible to pass nested phrase objects, which get flattened
// into an object with the nested keys concatenated using dot notation.
//
//     polyglot.extend({
//       "nav": {
//         "hello": "Hello",
//         "hello_name": "Hello, %{name}",
//         "sidebar": {
//           "welcome": "Welcome"
//         }
//       }
//     });
//
//     console.log(polyglot.phrases);
//     // {
//     //   'nav.hello': 'Hello',
//     //   'nav.hello_name': 'Hello, %{name}',
//     //   'nav.sidebar.welcome': 'Welcome'
//     // }
//
// `extend` accepts an optional second argument, `prefix`, which can be used
// to prefix every key in the phrases object with some string, using dot
// notation.
//
//     polyglot.extend({
//       "hello": "Hello",
//       "hello_name": "Hello, %{name}"
//     }, "nav");
//
//     console.log(polyglot.phrases);
//     // {
//     //   'nav.hello': 'Hello',
//     //   'nav.hello_name': 'Hello, %{name}'
//     // }
//
// This feature is used internally to support nested phrase objects.
Polyglot.prototype.extend = function (morePhrases, prefix) {
  forEach(entries(morePhrases || {}), function (entry) {
    var key = entry[0];
    var phrase = entry[1];
    var prefixedKey = prefix ? prefix + '.' + key : key;
    if (typeof phrase === 'object') {
      this.extend(phrase, prefixedKey);
    } else {
      this.phrases[prefixedKey] = phrase;
    }
  }, this);
};

// ### polyglot.unset(phrases)
// Use `unset` to selectively remove keys from a polyglot instance.
//
//     polyglot.unset("some_key");
//     polyglot.unset({
//       "hello": "Hello",
//       "hello_name": "Hello, %{name}"
//     });
//
// The unset method can take either a string (for the key), or an object hash with
// the keys that you would like to unset.
Polyglot.prototype.unset = function (morePhrases, prefix) {
  if (typeof morePhrases === 'string') {
    delete this.phrases[morePhrases];
  } else {
    forEach(entries(morePhrases || {}), function (entry) {
      var key = entry[0];
      var phrase = entry[1];
      var prefixedKey = prefix ? prefix + '.' + key : key;
      if (typeof phrase === 'object') {
        this.unset(phrase, prefixedKey);
      } else {
        delete this.phrases[prefixedKey];
      }
    }, this);
  }
};

// ### polyglot.clear()
//
// Clears all phrases. Useful for special cases, such as freeing
// up memory if you have lots of phrases but no longer need to
// perform any translation. Also used internally by `replace`.
Polyglot.prototype.clear = function () {
  this.phrases = {};
};

// ### polyglot.replace(phrases)
//
// Completely replace the existing phrases with a new set of phrases.
// Normally, just use `extend` to add more phrases, but under certain
// circumstances, you may want to make sure no old phrases are lying around.
Polyglot.prototype.replace = function (newPhrases) {
  this.clear();
  this.extend(newPhrases);
};

// ### polyglot.t(key, options)
//
// The most-used method. Provide a key, and `t` will return the
// phrase.
//
//     polyglot.t("hello");
//     => "Hello"
//
// The phrase value is provided first by a call to `polyglot.extend()` or
// `polyglot.replace()`.
//
// Pass in an object as the second argument to perform interpolation.
//
//     polyglot.t("hello_name", {name: "Spike"});
//     => "Hello, Spike"
//
// If you like, you can provide a default value in case the phrase is missing.
// Use the special option key "_" to specify a default.
//
//     polyglot.t("i_like_to_write_in_language", {
//       _: "I like to write in %{language}.",
//       language: "JavaScript"
//     });
//     => "I like to write in JavaScript."
//
Polyglot.prototype.t = function (key, options) {
  var phrase, result;
  var opts = options == null ? {} : options;
  if (typeof this.phrases[key] === 'string') {
    phrase = this.phrases[key];
  } else if (typeof opts._ === 'string') {
    phrase = opts._;
  } else if (this.onMissingKey) {
    var onMissingKey = this.onMissingKey;
    result = onMissingKey(key, opts, this.currentLocale, this.tokenRegex, this.pluralRules);
  } else {
    this.warn('Missing translation for key: "' + key + '"');
    result = key;
  }
  if (typeof phrase === 'string') {
    result = transformPhrase(phrase, opts, this.currentLocale, this.tokenRegex, this.pluralRules);
  }
  return result;
};

// ### polyglot.has(key)
//
// Check if polyglot has a translation for given key
Polyglot.prototype.has = function (key) {
  return has(this.phrases, key);
};

// export transformPhrase
Polyglot.transformPhrase = function transform(phrase, substitutions, locale) {
  return transformPhrase(phrase, substitutions, locale);
};

module.exports = Polyglot;

},{"array.prototype.foreach":4,"has":52,"object.entries":163,"string.prototype.trim":169,"warning":177}],158:[function(require,module,exports){
var hasMap = typeof Map === 'function' && Map.prototype;
var mapSizeDescriptor = Object.getOwnPropertyDescriptor && hasMap ? Object.getOwnPropertyDescriptor(Map.prototype, 'size') : null;
var mapSize = hasMap && mapSizeDescriptor && typeof mapSizeDescriptor.get === 'function' ? mapSizeDescriptor.get : null;
var mapForEach = hasMap && Map.prototype.forEach;
var hasSet = typeof Set === 'function' && Set.prototype;
var setSizeDescriptor = Object.getOwnPropertyDescriptor && hasSet ? Object.getOwnPropertyDescriptor(Set.prototype, 'size') : null;
var setSize = hasSet && setSizeDescriptor && typeof setSizeDescriptor.get === 'function' ? setSizeDescriptor.get : null;
var setForEach = hasSet && Set.prototype.forEach;
var hasWeakMap = typeof WeakMap === 'function' && WeakMap.prototype;
var weakMapHas = hasWeakMap ? WeakMap.prototype.has : null;
var hasWeakSet = typeof WeakSet === 'function' && WeakSet.prototype;
var weakSetHas = hasWeakSet ? WeakSet.prototype.has : null;
var hasWeakRef = typeof WeakRef === 'function' && WeakRef.prototype;
var weakRefDeref = hasWeakRef ? WeakRef.prototype.deref : null;
var booleanValueOf = Boolean.prototype.valueOf;
var objectToString = Object.prototype.toString;
var functionToString = Function.prototype.toString;
var $match = String.prototype.match;
var $slice = String.prototype.slice;
var $replace = String.prototype.replace;
var $toUpperCase = String.prototype.toUpperCase;
var $toLowerCase = String.prototype.toLowerCase;
var $test = RegExp.prototype.test;
var $concat = Array.prototype.concat;
var $join = Array.prototype.join;
var $arrSlice = Array.prototype.slice;
var $floor = Math.floor;
var bigIntValueOf = typeof BigInt === 'function' ? BigInt.prototype.valueOf : null;
var gOPS = Object.getOwnPropertySymbols;
var symToString = typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol' ? Symbol.prototype.toString : null;
var hasShammedSymbols = typeof Symbol === 'function' && typeof Symbol.iterator === 'object';
// ie, `has-tostringtag/shams
var toStringTag = typeof Symbol === 'function' && Symbol.toStringTag && (typeof Symbol.toStringTag === hasShammedSymbols ? 'object' : 'symbol')
    ? Symbol.toStringTag
    : null;
var isEnumerable = Object.prototype.propertyIsEnumerable;

var gPO = (typeof Reflect === 'function' ? Reflect.getPrototypeOf : Object.getPrototypeOf) || (
    [].__proto__ === Array.prototype // eslint-disable-line no-proto
        ? function (O) {
            return O.__proto__; // eslint-disable-line no-proto
        }
        : null
);

function addNumericSeparator(num, str) {
    if (
        num === Infinity
        || num === -Infinity
        || num !== num
        || (num && num > -1000 && num < 1000)
        || $test.call(/e/, str)
    ) {
        return str;
    }
    var sepRegex = /[0-9](?=(?:[0-9]{3})+(?![0-9]))/g;
    if (typeof num === 'number') {
        var int = num < 0 ? -$floor(-num) : $floor(num); // trunc(num)
        if (int !== num) {
            var intStr = String(int);
            var dec = $slice.call(str, intStr.length + 1);
            return $replace.call(intStr, sepRegex, '$&_') + '.' + $replace.call($replace.call(dec, /([0-9]{3})/g, '$&_'), /_$/, '');
        }
    }
    return $replace.call(str, sepRegex, '$&_');
}

var utilInspect = require('./util.inspect');
var inspectCustom = utilInspect.custom;
var inspectSymbol = isSymbol(inspectCustom) ? inspectCustom : null;

module.exports = function inspect_(obj, options, depth, seen) {
    var opts = options || {};

    if (has(opts, 'quoteStyle') && (opts.quoteStyle !== 'single' && opts.quoteStyle !== 'double')) {
        throw new TypeError('option "quoteStyle" must be "single" or "double"');
    }
    if (
        has(opts, 'maxStringLength') && (typeof opts.maxStringLength === 'number'
            ? opts.maxStringLength < 0 && opts.maxStringLength !== Infinity
            : opts.maxStringLength !== null
        )
    ) {
        throw new TypeError('option "maxStringLength", if provided, must be a positive integer, Infinity, or `null`');
    }
    var customInspect = has(opts, 'customInspect') ? opts.customInspect : true;
    if (typeof customInspect !== 'boolean' && customInspect !== 'symbol') {
        throw new TypeError('option "customInspect", if provided, must be `true`, `false`, or `\'symbol\'`');
    }

    if (
        has(opts, 'indent')
        && opts.indent !== null
        && opts.indent !== '\t'
        && !(parseInt(opts.indent, 10) === opts.indent && opts.indent > 0)
    ) {
        throw new TypeError('option "indent" must be "\\t", an integer > 0, or `null`');
    }
    if (has(opts, 'numericSeparator') && typeof opts.numericSeparator !== 'boolean') {
        throw new TypeError('option "numericSeparator", if provided, must be `true` or `false`');
    }
    var numericSeparator = opts.numericSeparator;

    if (typeof obj === 'undefined') {
        return 'undefined';
    }
    if (obj === null) {
        return 'null';
    }
    if (typeof obj === 'boolean') {
        return obj ? 'true' : 'false';
    }

    if (typeof obj === 'string') {
        return inspectString(obj, opts);
    }
    if (typeof obj === 'number') {
        if (obj === 0) {
            return Infinity / obj > 0 ? '0' : '-0';
        }
        var str = String(obj);
        return numericSeparator ? addNumericSeparator(obj, str) : str;
    }
    if (typeof obj === 'bigint') {
        var bigIntStr = String(obj) + 'n';
        return numericSeparator ? addNumericSeparator(obj, bigIntStr) : bigIntStr;
    }

    var maxDepth = typeof opts.depth === 'undefined' ? 5 : opts.depth;
    if (typeof depth === 'undefined') { depth = 0; }
    if (depth >= maxDepth && maxDepth > 0 && typeof obj === 'object') {
        return isArray(obj) ? '[Array]' : '[Object]';
    }

    var indent = getIndent(opts, depth);

    if (typeof seen === 'undefined') {
        seen = [];
    } else if (indexOf(seen, obj) >= 0) {
        return '[Circular]';
    }

    function inspect(value, from, noIndent) {
        if (from) {
            seen = $arrSlice.call(seen);
            seen.push(from);
        }
        if (noIndent) {
            var newOpts = {
                depth: opts.depth
            };
            if (has(opts, 'quoteStyle')) {
                newOpts.quoteStyle = opts.quoteStyle;
            }
            return inspect_(value, newOpts, depth + 1, seen);
        }
        return inspect_(value, opts, depth + 1, seen);
    }

    if (typeof obj === 'function' && !isRegExp(obj)) { // in older engines, regexes are callable
        var name = nameOf(obj);
        var keys = arrObjKeys(obj, inspect);
        return '[Function' + (name ? ': ' + name : ' (anonymous)') + ']' + (keys.length > 0 ? ' { ' + $join.call(keys, ', ') + ' }' : '');
    }
    if (isSymbol(obj)) {
        var symString = hasShammedSymbols ? $replace.call(String(obj), /^(Symbol\(.*\))_[^)]*$/, '$1') : symToString.call(obj);
        return typeof obj === 'object' && !hasShammedSymbols ? markBoxed(symString) : symString;
    }
    if (isElement(obj)) {
        var s = '<' + $toLowerCase.call(String(obj.nodeName));
        var attrs = obj.attributes || [];
        for (var i = 0; i < attrs.length; i++) {
            s += ' ' + attrs[i].name + '=' + wrapQuotes(quote(attrs[i].value), 'double', opts);
        }
        s += '>';
        if (obj.childNodes && obj.childNodes.length) { s += '...'; }
        s += '</' + $toLowerCase.call(String(obj.nodeName)) + '>';
        return s;
    }
    if (isArray(obj)) {
        if (obj.length === 0) { return '[]'; }
        var xs = arrObjKeys(obj, inspect);
        if (indent && !singleLineValues(xs)) {
            return '[' + indentedJoin(xs, indent) + ']';
        }
        return '[ ' + $join.call(xs, ', ') + ' ]';
    }
    if (isError(obj)) {
        var parts = arrObjKeys(obj, inspect);
        if (!('cause' in Error.prototype) && 'cause' in obj && !isEnumerable.call(obj, 'cause')) {
            return '{ [' + String(obj) + '] ' + $join.call($concat.call('[cause]: ' + inspect(obj.cause), parts), ', ') + ' }';
        }
        if (parts.length === 0) { return '[' + String(obj) + ']'; }
        return '{ [' + String(obj) + '] ' + $join.call(parts, ', ') + ' }';
    }
    if (typeof obj === 'object' && customInspect) {
        if (inspectSymbol && typeof obj[inspectSymbol] === 'function' && utilInspect) {
            return utilInspect(obj, { depth: maxDepth - depth });
        } else if (customInspect !== 'symbol' && typeof obj.inspect === 'function') {
            return obj.inspect();
        }
    }
    if (isMap(obj)) {
        var mapParts = [];
        mapForEach.call(obj, function (value, key) {
            mapParts.push(inspect(key, obj, true) + ' => ' + inspect(value, obj));
        });
        return collectionOf('Map', mapSize.call(obj), mapParts, indent);
    }
    if (isSet(obj)) {
        var setParts = [];
        setForEach.call(obj, function (value) {
            setParts.push(inspect(value, obj));
        });
        return collectionOf('Set', setSize.call(obj), setParts, indent);
    }
    if (isWeakMap(obj)) {
        return weakCollectionOf('WeakMap');
    }
    if (isWeakSet(obj)) {
        return weakCollectionOf('WeakSet');
    }
    if (isWeakRef(obj)) {
        return weakCollectionOf('WeakRef');
    }
    if (isNumber(obj)) {
        return markBoxed(inspect(Number(obj)));
    }
    if (isBigInt(obj)) {
        return markBoxed(inspect(bigIntValueOf.call(obj)));
    }
    if (isBoolean(obj)) {
        return markBoxed(booleanValueOf.call(obj));
    }
    if (isString(obj)) {
        return markBoxed(inspect(String(obj)));
    }
    if (!isDate(obj) && !isRegExp(obj)) {
        var ys = arrObjKeys(obj, inspect);
        var isPlainObject = gPO ? gPO(obj) === Object.prototype : obj instanceof Object || obj.constructor === Object;
        var protoTag = obj instanceof Object ? '' : 'null prototype';
        var stringTag = !isPlainObject && toStringTag && Object(obj) === obj && toStringTag in obj ? $slice.call(toStr(obj), 8, -1) : protoTag ? 'Object' : '';
        var constructorTag = isPlainObject || typeof obj.constructor !== 'function' ? '' : obj.constructor.name ? obj.constructor.name + ' ' : '';
        var tag = constructorTag + (stringTag || protoTag ? '[' + $join.call($concat.call([], stringTag || [], protoTag || []), ': ') + '] ' : '');
        if (ys.length === 0) { return tag + '{}'; }
        if (indent) {
            return tag + '{' + indentedJoin(ys, indent) + '}';
        }
        return tag + '{ ' + $join.call(ys, ', ') + ' }';
    }
    return String(obj);
};

function wrapQuotes(s, defaultStyle, opts) {
    var quoteChar = (opts.quoteStyle || defaultStyle) === 'double' ? '"' : "'";
    return quoteChar + s + quoteChar;
}

function quote(s) {
    return $replace.call(String(s), /"/g, '&quot;');
}

function isArray(obj) { return toStr(obj) === '[object Array]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isDate(obj) { return toStr(obj) === '[object Date]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isRegExp(obj) { return toStr(obj) === '[object RegExp]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isError(obj) { return toStr(obj) === '[object Error]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isString(obj) { return toStr(obj) === '[object String]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isNumber(obj) { return toStr(obj) === '[object Number]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isBoolean(obj) { return toStr(obj) === '[object Boolean]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }

// Symbol and BigInt do have Symbol.toStringTag by spec, so that can't be used to eliminate false positives
function isSymbol(obj) {
    if (hasShammedSymbols) {
        return obj && typeof obj === 'object' && obj instanceof Symbol;
    }
    if (typeof obj === 'symbol') {
        return true;
    }
    if (!obj || typeof obj !== 'object' || !symToString) {
        return false;
    }
    try {
        symToString.call(obj);
        return true;
    } catch (e) {}
    return false;
}

function isBigInt(obj) {
    if (!obj || typeof obj !== 'object' || !bigIntValueOf) {
        return false;
    }
    try {
        bigIntValueOf.call(obj);
        return true;
    } catch (e) {}
    return false;
}

var hasOwn = Object.prototype.hasOwnProperty || function (key) { return key in this; };
function has(obj, key) {
    return hasOwn.call(obj, key);
}

function toStr(obj) {
    return objectToString.call(obj);
}

function nameOf(f) {
    if (f.name) { return f.name; }
    var m = $match.call(functionToString.call(f), /^function\s*([\w$]+)/);
    if (m) { return m[1]; }
    return null;
}

function indexOf(xs, x) {
    if (xs.indexOf) { return xs.indexOf(x); }
    for (var i = 0, l = xs.length; i < l; i++) {
        if (xs[i] === x) { return i; }
    }
    return -1;
}

function isMap(x) {
    if (!mapSize || !x || typeof x !== 'object') {
        return false;
    }
    try {
        mapSize.call(x);
        try {
            setSize.call(x);
        } catch (s) {
            return true;
        }
        return x instanceof Map; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}

function isWeakMap(x) {
    if (!weakMapHas || !x || typeof x !== 'object') {
        return false;
    }
    try {
        weakMapHas.call(x, weakMapHas);
        try {
            weakSetHas.call(x, weakSetHas);
        } catch (s) {
            return true;
        }
        return x instanceof WeakMap; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}

function isWeakRef(x) {
    if (!weakRefDeref || !x || typeof x !== 'object') {
        return false;
    }
    try {
        weakRefDeref.call(x);
        return true;
    } catch (e) {}
    return false;
}

function isSet(x) {
    if (!setSize || !x || typeof x !== 'object') {
        return false;
    }
    try {
        setSize.call(x);
        try {
            mapSize.call(x);
        } catch (m) {
            return true;
        }
        return x instanceof Set; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}

function isWeakSet(x) {
    if (!weakSetHas || !x || typeof x !== 'object') {
        return false;
    }
    try {
        weakSetHas.call(x, weakSetHas);
        try {
            weakMapHas.call(x, weakMapHas);
        } catch (s) {
            return true;
        }
        return x instanceof WeakSet; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}

function isElement(x) {
    if (!x || typeof x !== 'object') { return false; }
    if (typeof HTMLElement !== 'undefined' && x instanceof HTMLElement) {
        return true;
    }
    return typeof x.nodeName === 'string' && typeof x.getAttribute === 'function';
}

function inspectString(str, opts) {
    if (str.length > opts.maxStringLength) {
        var remaining = str.length - opts.maxStringLength;
        var trailer = '... ' + remaining + ' more character' + (remaining > 1 ? 's' : '');
        return inspectString($slice.call(str, 0, opts.maxStringLength), opts) + trailer;
    }
    // eslint-disable-next-line no-control-regex
    var s = $replace.call($replace.call(str, /(['\\])/g, '\\$1'), /[\x00-\x1f]/g, lowbyte);
    return wrapQuotes(s, 'single', opts);
}

function lowbyte(c) {
    var n = c.charCodeAt(0);
    var x = {
        8: 'b',
        9: 't',
        10: 'n',
        12: 'f',
        13: 'r'
    }[n];
    if (x) { return '\\' + x; }
    return '\\x' + (n < 0x10 ? '0' : '') + $toUpperCase.call(n.toString(16));
}

function markBoxed(str) {
    return 'Object(' + str + ')';
}

function weakCollectionOf(type) {
    return type + ' { ? }';
}

function collectionOf(type, size, entries, indent) {
    var joinedEntries = indent ? indentedJoin(entries, indent) : $join.call(entries, ', ');
    return type + ' (' + size + ') {' + joinedEntries + '}';
}

function singleLineValues(xs) {
    for (var i = 0; i < xs.length; i++) {
        if (indexOf(xs[i], '\n') >= 0) {
            return false;
        }
    }
    return true;
}

function getIndent(opts, depth) {
    var baseIndent;
    if (opts.indent === '\t') {
        baseIndent = '\t';
    } else if (typeof opts.indent === 'number' && opts.indent > 0) {
        baseIndent = $join.call(Array(opts.indent + 1), ' ');
    } else {
        return null;
    }
    return {
        base: baseIndent,
        prev: $join.call(Array(depth + 1), baseIndent)
    };
}

function indentedJoin(xs, indent) {
    if (xs.length === 0) { return ''; }
    var lineJoiner = '\n' + indent.prev + indent.base;
    return lineJoiner + $join.call(xs, ',' + lineJoiner) + '\n' + indent.prev;
}

function arrObjKeys(obj, inspect) {
    var isArr = isArray(obj);
    var xs = [];
    if (isArr) {
        xs.length = obj.length;
        for (var i = 0; i < obj.length; i++) {
            xs[i] = has(obj, i) ? inspect(obj[i], obj) : '';
        }
    }
    var syms = typeof gOPS === 'function' ? gOPS(obj) : [];
    var symMap;
    if (hasShammedSymbols) {
        symMap = {};
        for (var k = 0; k < syms.length; k++) {
            symMap['$' + syms[k]] = syms[k];
        }
    }

    for (var key in obj) { // eslint-disable-line no-restricted-syntax
        if (!has(obj, key)) { continue; } // eslint-disable-line no-restricted-syntax, no-continue
        if (isArr && String(Number(key)) === key && key < obj.length) { continue; } // eslint-disable-line no-restricted-syntax, no-continue
        if (hasShammedSymbols && symMap['$' + key] instanceof Symbol) {
            // this is to prevent shammed Symbols, which are stored as strings, from being included in the string key section
            continue; // eslint-disable-line no-restricted-syntax, no-continue
        } else if ($test.call(/[^\w$]/, key)) {
            xs.push(inspect(key, obj) + ': ' + inspect(obj[key], obj));
        } else {
            xs.push(key + ': ' + inspect(obj[key], obj));
        }
    }
    if (typeof gOPS === 'function') {
        for (var j = 0; j < syms.length; j++) {
            if (isEnumerable.call(obj, syms[j])) {
                xs.push('[' + inspect(syms[j]) + ']: ' + inspect(obj[syms[j]], obj));
            }
        }
    }
    return xs;
}

},{"./util.inspect":8}],159:[function(require,module,exports){
'use strict';

var keysShim;
if (!Object.keys) {
	// modified from https://github.com/es-shims/es5-shim
	var has = Object.prototype.hasOwnProperty;
	var toStr = Object.prototype.toString;
	var isArgs = require('./isArguments'); // eslint-disable-line global-require
	var isEnumerable = Object.prototype.propertyIsEnumerable;
	var hasDontEnumBug = !isEnumerable.call({ toString: null }, 'toString');
	var hasProtoEnumBug = isEnumerable.call(function () {}, 'prototype');
	var dontEnums = [
		'toString',
		'toLocaleString',
		'valueOf',
		'hasOwnProperty',
		'isPrototypeOf',
		'propertyIsEnumerable',
		'constructor'
	];
	var equalsConstructorPrototype = function (o) {
		var ctor = o.constructor;
		return ctor && ctor.prototype === o;
	};
	var excludedKeys = {
		$applicationCache: true,
		$console: true,
		$external: true,
		$frame: true,
		$frameElement: true,
		$frames: true,
		$innerHeight: true,
		$innerWidth: true,
		$onmozfullscreenchange: true,
		$onmozfullscreenerror: true,
		$outerHeight: true,
		$outerWidth: true,
		$pageXOffset: true,
		$pageYOffset: true,
		$parent: true,
		$scrollLeft: true,
		$scrollTop: true,
		$scrollX: true,
		$scrollY: true,
		$self: true,
		$webkitIndexedDB: true,
		$webkitStorageInfo: true,
		$window: true
	};
	var hasAutomationEqualityBug = (function () {
		/* global window */
		if (typeof window === 'undefined') { return false; }
		for (var k in window) {
			try {
				if (!excludedKeys['$' + k] && has.call(window, k) && window[k] !== null && typeof window[k] === 'object') {
					try {
						equalsConstructorPrototype(window[k]);
					} catch (e) {
						return true;
					}
				}
			} catch (e) {
				return true;
			}
		}
		return false;
	}());
	var equalsConstructorPrototypeIfNotBuggy = function (o) {
		/* global window */
		if (typeof window === 'undefined' || !hasAutomationEqualityBug) {
			return equalsConstructorPrototype(o);
		}
		try {
			return equalsConstructorPrototype(o);
		} catch (e) {
			return false;
		}
	};

	keysShim = function keys(object) {
		var isObject = object !== null && typeof object === 'object';
		var isFunction = toStr.call(object) === '[object Function]';
		var isArguments = isArgs(object);
		var isString = isObject && toStr.call(object) === '[object String]';
		var theKeys = [];

		if (!isObject && !isFunction && !isArguments) {
			throw new TypeError('Object.keys called on a non-object');
		}

		var skipProto = hasProtoEnumBug && isFunction;
		if (isString && object.length > 0 && !has.call(object, 0)) {
			for (var i = 0; i < object.length; ++i) {
				theKeys.push(String(i));
			}
		}

		if (isArguments && object.length > 0) {
			for (var j = 0; j < object.length; ++j) {
				theKeys.push(String(j));
			}
		} else {
			for (var name in object) {
				if (!(skipProto && name === 'prototype') && has.call(object, name)) {
					theKeys.push(String(name));
				}
			}
		}

		if (hasDontEnumBug) {
			var skipConstructor = equalsConstructorPrototypeIfNotBuggy(object);

			for (var k = 0; k < dontEnums.length; ++k) {
				if (!(skipConstructor && dontEnums[k] === 'constructor') && has.call(object, dontEnums[k])) {
					theKeys.push(dontEnums[k]);
				}
			}
		}
		return theKeys;
	};
}
module.exports = keysShim;

},{"./isArguments":161}],160:[function(require,module,exports){
'use strict';

var slice = Array.prototype.slice;
var isArgs = require('./isArguments');

var origKeys = Object.keys;
var keysShim = origKeys ? function keys(o) { return origKeys(o); } : require('./implementation');

var originalKeys = Object.keys;

keysShim.shim = function shimObjectKeys() {
	if (Object.keys) {
		var keysWorksWithArguments = (function () {
			// Safari 5.0 bug
			var args = Object.keys(arguments);
			return args && args.length === arguments.length;
		}(1, 2));
		if (!keysWorksWithArguments) {
			Object.keys = function keys(object) { // eslint-disable-line func-name-matching
				if (isArgs(object)) {
					return originalKeys(slice.call(object));
				}
				return originalKeys(object);
			};
		}
	} else {
		Object.keys = keysShim;
	}
	return Object.keys || keysShim;
};

module.exports = keysShim;

},{"./implementation":159,"./isArguments":161}],161:[function(require,module,exports){
'use strict';

var toStr = Object.prototype.toString;

module.exports = function isArguments(value) {
	var str = toStr.call(value);
	var isArgs = str === '[object Arguments]';
	if (!isArgs) {
		isArgs = str !== '[object Array]' &&
			value !== null &&
			typeof value === 'object' &&
			typeof value.length === 'number' &&
			value.length >= 0 &&
			toStr.call(value.callee) === '[object Function]';
	}
	return isArgs;
};

},{}],162:[function(require,module,exports){
'use strict';

var RequireObjectCoercible = require('es-abstract/2021/RequireObjectCoercible');
var callBound = require('call-bind/callBound');
var $isEnumerable = callBound('Object.prototype.propertyIsEnumerable');
var $push = callBound('Array.prototype.push');

module.exports = function entries(O) {
	var obj = RequireObjectCoercible(O);
	var entrys = [];
	for (var key in obj) {
		if ($isEnumerable(obj, key)) { // checks own-ness as well
			$push(entrys, [key, obj[key]]);
		}
	}
	return entrys;
};

},{"call-bind/callBound":10,"es-abstract/2021/RequireObjectCoercible":21}],163:[function(require,module,exports){
'use strict';

var define = require('define-properties');
var callBind = require('call-bind');

var implementation = require('./implementation');
var getPolyfill = require('./polyfill');
var shim = require('./shim');

var polyfill = callBind(getPolyfill(), Object);

define(polyfill, {
	getPolyfill: getPolyfill,
	implementation: implementation,
	shim: shim
});

module.exports = polyfill;

},{"./implementation":162,"./polyfill":164,"./shim":165,"call-bind":11,"define-properties":12}],164:[function(require,module,exports){
'use strict';

var implementation = require('./implementation');

module.exports = function getPolyfill() {
	return typeof Object.entries === 'function' ? Object.entries : implementation;
};

},{"./implementation":162}],165:[function(require,module,exports){
'use strict';

var getPolyfill = require('./polyfill');
var define = require('define-properties');

module.exports = function shimEntries() {
	var polyfill = getPolyfill();
	define(Object, { entries: polyfill }, {
		entries: function testEntries() {
			return Object.entries !== polyfill;
		}
	});
	return polyfill;
};

},{"./polyfill":164,"define-properties":12}],166:[function(require,module,exports){
(function (global, factory) {
	typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory() :
	typeof define === 'function' && define.amd ? define(factory) :
	(global.quickselect = factory());
}(this, (function () { 'use strict';

function quickselect(arr, k, left, right, compare) {
    quickselectStep(arr, k, left || 0, right || (arr.length - 1), compare || defaultCompare);
}

function quickselectStep(arr, k, left, right, compare) {

    while (right > left) {
        if (right - left > 600) {
            var n = right - left + 1;
            var m = k - left + 1;
            var z = Math.log(n);
            var s = 0.5 * Math.exp(2 * z / 3);
            var sd = 0.5 * Math.sqrt(z * s * (n - s) / n) * (m - n / 2 < 0 ? -1 : 1);
            var newLeft = Math.max(left, Math.floor(k - m * s / n + sd));
            var newRight = Math.min(right, Math.floor(k + (n - m) * s / n + sd));
            quickselectStep(arr, k, newLeft, newRight, compare);
        }

        var t = arr[k];
        var i = left;
        var j = right;

        swap(arr, left, k);
        if (compare(arr[right], t) > 0) swap(arr, left, right);

        while (i < j) {
            swap(arr, i, j);
            i++;
            j--;
            while (compare(arr[i], t) < 0) i++;
            while (compare(arr[j], t) > 0) j--;
        }

        if (compare(arr[left], t) === 0) swap(arr, left, j);
        else {
            j++;
            swap(arr, j, right);
        }

        if (j <= k) left = j + 1;
        if (k <= j) right = j - 1;
    }
}

function swap(arr, i, j) {
    var tmp = arr[i];
    arr[i] = arr[j];
    arr[j] = tmp;
}

function defaultCompare(a, b) {
    return a < b ? -1 : a > b ? 1 : 0;
}

return quickselect;

})));

},{}],167:[function(require,module,exports){
'use strict';

module.exports = rbush;
module.exports.default = rbush;

var quickselect = require('quickselect');

function rbush(maxEntries, format) {
    if (!(this instanceof rbush)) return new rbush(maxEntries, format);

    // max entries in a node is 9 by default; min node fill is 40% for best performance
    this._maxEntries = Math.max(4, maxEntries || 9);
    this._minEntries = Math.max(2, Math.ceil(this._maxEntries * 0.4));

    if (format) {
        this._initFormat(format);
    }

    this.clear();
}

rbush.prototype = {

    all: function () {
        return this._all(this.data, []);
    },

    search: function (bbox) {

        var node = this.data,
            result = [],
            toBBox = this.toBBox;

        if (!intersects(bbox, node)) return result;

        var nodesToSearch = [],
            i, len, child, childBBox;

        while (node) {
            for (i = 0, len = node.children.length; i < len; i++) {

                child = node.children[i];
                childBBox = node.leaf ? toBBox(child) : child;

                if (intersects(bbox, childBBox)) {
                    if (node.leaf) result.push(child);
                    else if (contains(bbox, childBBox)) this._all(child, result);
                    else nodesToSearch.push(child);
                }
            }
            node = nodesToSearch.pop();
        }

        return result;
    },

    collides: function (bbox) {

        var node = this.data,
            toBBox = this.toBBox;

        if (!intersects(bbox, node)) return false;

        var nodesToSearch = [],
            i, len, child, childBBox;

        while (node) {
            for (i = 0, len = node.children.length; i < len; i++) {

                child = node.children[i];
                childBBox = node.leaf ? toBBox(child) : child;

                if (intersects(bbox, childBBox)) {
                    if (node.leaf || contains(bbox, childBBox)) return true;
                    nodesToSearch.push(child);
                }
            }
            node = nodesToSearch.pop();
        }

        return false;
    },

    load: function (data) {
        if (!(data && data.length)) return this;

        if (data.length < this._minEntries) {
            for (var i = 0, len = data.length; i < len; i++) {
                this.insert(data[i]);
            }
            return this;
        }

        // recursively build the tree with the given data from scratch using OMT algorithm
        var node = this._build(data.slice(), 0, data.length - 1, 0);

        if (!this.data.children.length) {
            // save as is if tree is empty
            this.data = node;

        } else if (this.data.height === node.height) {
            // split root if trees have the same height
            this._splitRoot(this.data, node);

        } else {
            if (this.data.height < node.height) {
                // swap trees if inserted one is bigger
                var tmpNode = this.data;
                this.data = node;
                node = tmpNode;
            }

            // insert the small tree into the large tree at appropriate level
            this._insert(node, this.data.height - node.height - 1, true);
        }

        return this;
    },

    insert: function (item) {
        if (item) this._insert(item, this.data.height - 1);
        return this;
    },

    clear: function () {
        this.data = createNode([]);
        return this;
    },

    remove: function (item, equalsFn) {
        if (!item) return this;

        var node = this.data,
            bbox = this.toBBox(item),
            path = [],
            indexes = [],
            i, parent, index, goingUp;

        // depth-first iterative tree traversal
        while (node || path.length) {

            if (!node) { // go up
                node = path.pop();
                parent = path[path.length - 1];
                i = indexes.pop();
                goingUp = true;
            }

            if (node.leaf) { // check current node
                index = findItem(item, node.children, equalsFn);

                if (index !== -1) {
                    // item found, remove the item and condense tree upwards
                    node.children.splice(index, 1);
                    path.push(node);
                    this._condense(path);
                    return this;
                }
            }

            if (!goingUp && !node.leaf && contains(node, bbox)) { // go down
                path.push(node);
                indexes.push(i);
                i = 0;
                parent = node;
                node = node.children[0];

            } else if (parent) { // go right
                i++;
                node = parent.children[i];
                goingUp = false;

            } else node = null; // nothing found
        }

        return this;
    },

    toBBox: function (item) { return item; },

    compareMinX: compareNodeMinX,
    compareMinY: compareNodeMinY,

    toJSON: function () { return this.data; },

    fromJSON: function (data) {
        this.data = data;
        return this;
    },

    _all: function (node, result) {
        var nodesToSearch = [];
        while (node) {
            if (node.leaf) result.push.apply(result, node.children);
            else nodesToSearch.push.apply(nodesToSearch, node.children);

            node = nodesToSearch.pop();
        }
        return result;
    },

    _build: function (items, left, right, height) {

        var N = right - left + 1,
            M = this._maxEntries,
            node;

        if (N <= M) {
            // reached leaf level; return leaf
            node = createNode(items.slice(left, right + 1));
            calcBBox(node, this.toBBox);
            return node;
        }

        if (!height) {
            // target height of the bulk-loaded tree
            height = Math.ceil(Math.log(N) / Math.log(M));

            // target number of root entries to maximize storage utilization
            M = Math.ceil(N / Math.pow(M, height - 1));
        }

        node = createNode([]);
        node.leaf = false;
        node.height = height;

        // split the items into M mostly square tiles

        var N2 = Math.ceil(N / M),
            N1 = N2 * Math.ceil(Math.sqrt(M)),
            i, j, right2, right3;

        multiSelect(items, left, right, N1, this.compareMinX);

        for (i = left; i <= right; i += N1) {

            right2 = Math.min(i + N1 - 1, right);

            multiSelect(items, i, right2, N2, this.compareMinY);

            for (j = i; j <= right2; j += N2) {

                right3 = Math.min(j + N2 - 1, right2);

                // pack each entry recursively
                node.children.push(this._build(items, j, right3, height - 1));
            }
        }

        calcBBox(node, this.toBBox);

        return node;
    },

    _chooseSubtree: function (bbox, node, level, path) {

        var i, len, child, targetNode, area, enlargement, minArea, minEnlargement;

        while (true) {
            path.push(node);

            if (node.leaf || path.length - 1 === level) break;

            minArea = minEnlargement = Infinity;

            for (i = 0, len = node.children.length; i < len; i++) {
                child = node.children[i];
                area = bboxArea(child);
                enlargement = enlargedArea(bbox, child) - area;

                // choose entry with the least area enlargement
                if (enlargement < minEnlargement) {
                    minEnlargement = enlargement;
                    minArea = area < minArea ? area : minArea;
                    targetNode = child;

                } else if (enlargement === minEnlargement) {
                    // otherwise choose one with the smallest area
                    if (area < minArea) {
                        minArea = area;
                        targetNode = child;
                    }
                }
            }

            node = targetNode || node.children[0];
        }

        return node;
    },

    _insert: function (item, level, isNode) {

        var toBBox = this.toBBox,
            bbox = isNode ? item : toBBox(item),
            insertPath = [];

        // find the best node for accommodating the item, saving all nodes along the path too
        var node = this._chooseSubtree(bbox, this.data, level, insertPath);

        // put the item into the node
        node.children.push(item);
        extend(node, bbox);

        // split on node overflow; propagate upwards if necessary
        while (level >= 0) {
            if (insertPath[level].children.length > this._maxEntries) {
                this._split(insertPath, level);
                level--;
            } else break;
        }

        // adjust bboxes along the insertion path
        this._adjustParentBBoxes(bbox, insertPath, level);
    },

    // split overflowed node into two
    _split: function (insertPath, level) {

        var node = insertPath[level],
            M = node.children.length,
            m = this._minEntries;

        this._chooseSplitAxis(node, m, M);

        var splitIndex = this._chooseSplitIndex(node, m, M);

        var newNode = createNode(node.children.splice(splitIndex, node.children.length - splitIndex));
        newNode.height = node.height;
        newNode.leaf = node.leaf;

        calcBBox(node, this.toBBox);
        calcBBox(newNode, this.toBBox);

        if (level) insertPath[level - 1].children.push(newNode);
        else this._splitRoot(node, newNode);
    },

    _splitRoot: function (node, newNode) {
        // split root node
        this.data = createNode([node, newNode]);
        this.data.height = node.height + 1;
        this.data.leaf = false;
        calcBBox(this.data, this.toBBox);
    },

    _chooseSplitIndex: function (node, m, M) {

        var i, bbox1, bbox2, overlap, area, minOverlap, minArea, index;

        minOverlap = minArea = Infinity;

        for (i = m; i <= M - m; i++) {
            bbox1 = distBBox(node, 0, i, this.toBBox);
            bbox2 = distBBox(node, i, M, this.toBBox);

            overlap = intersectionArea(bbox1, bbox2);
            area = bboxArea(bbox1) + bboxArea(bbox2);

            // choose distribution with minimum overlap
            if (overlap < minOverlap) {
                minOverlap = overlap;
                index = i;

                minArea = area < minArea ? area : minArea;

            } else if (overlap === minOverlap) {
                // otherwise choose distribution with minimum area
                if (area < minArea) {
                    minArea = area;
                    index = i;
                }
            }
        }

        return index;
    },

    // sorts node children by the best axis for split
    _chooseSplitAxis: function (node, m, M) {

        var compareMinX = node.leaf ? this.compareMinX : compareNodeMinX,
            compareMinY = node.leaf ? this.compareMinY : compareNodeMinY,
            xMargin = this._allDistMargin(node, m, M, compareMinX),
            yMargin = this._allDistMargin(node, m, M, compareMinY);

        // if total distributions margin value is minimal for x, sort by minX,
        // otherwise it's already sorted by minY
        if (xMargin < yMargin) node.children.sort(compareMinX);
    },

    // total margin of all possible split distributions where each node is at least m full
    _allDistMargin: function (node, m, M, compare) {

        node.children.sort(compare);

        var toBBox = this.toBBox,
            leftBBox = distBBox(node, 0, m, toBBox),
            rightBBox = distBBox(node, M - m, M, toBBox),
            margin = bboxMargin(leftBBox) + bboxMargin(rightBBox),
            i, child;

        for (i = m; i < M - m; i++) {
            child = node.children[i];
            extend(leftBBox, node.leaf ? toBBox(child) : child);
            margin += bboxMargin(leftBBox);
        }

        for (i = M - m - 1; i >= m; i--) {
            child = node.children[i];
            extend(rightBBox, node.leaf ? toBBox(child) : child);
            margin += bboxMargin(rightBBox);
        }

        return margin;
    },

    _adjustParentBBoxes: function (bbox, path, level) {
        // adjust bboxes along the given tree path
        for (var i = level; i >= 0; i--) {
            extend(path[i], bbox);
        }
    },

    _condense: function (path) {
        // go through the path, removing empty nodes and updating bboxes
        for (var i = path.length - 1, siblings; i >= 0; i--) {
            if (path[i].children.length === 0) {
                if (i > 0) {
                    siblings = path[i - 1].children;
                    siblings.splice(siblings.indexOf(path[i]), 1);

                } else this.clear();

            } else calcBBox(path[i], this.toBBox);
        }
    },

    _initFormat: function (format) {
        // data format (minX, minY, maxX, maxY accessors)

        // uses eval-type function compilation instead of just accepting a toBBox function
        // because the algorithms are very sensitive to sorting functions performance,
        // so they should be dead simple and without inner calls

        var compareArr = ['return a', ' - b', ';'];

        this.compareMinX = new Function('a', 'b', compareArr.join(format[0]));
        this.compareMinY = new Function('a', 'b', compareArr.join(format[1]));

        this.toBBox = new Function('a',
            'return {minX: a' + format[0] +
            ', minY: a' + format[1] +
            ', maxX: a' + format[2] +
            ', maxY: a' + format[3] + '};');
    }
};

function findItem(item, items, equalsFn) {
    if (!equalsFn) return items.indexOf(item);

    for (var i = 0; i < items.length; i++) {
        if (equalsFn(item, items[i])) return i;
    }
    return -1;
}

// calculate node's bbox from bboxes of its children
function calcBBox(node, toBBox) {
    distBBox(node, 0, node.children.length, toBBox, node);
}

// min bounding rectangle of node children from k to p-1
function distBBox(node, k, p, toBBox, destNode) {
    if (!destNode) destNode = createNode(null);
    destNode.minX = Infinity;
    destNode.minY = Infinity;
    destNode.maxX = -Infinity;
    destNode.maxY = -Infinity;

    for (var i = k, child; i < p; i++) {
        child = node.children[i];
        extend(destNode, node.leaf ? toBBox(child) : child);
    }

    return destNode;
}

function extend(a, b) {
    a.minX = Math.min(a.minX, b.minX);
    a.minY = Math.min(a.minY, b.minY);
    a.maxX = Math.max(a.maxX, b.maxX);
    a.maxY = Math.max(a.maxY, b.maxY);
    return a;
}

function compareNodeMinX(a, b) { return a.minX - b.minX; }
function compareNodeMinY(a, b) { return a.minY - b.minY; }

function bboxArea(a)   { return (a.maxX - a.minX) * (a.maxY - a.minY); }
function bboxMargin(a) { return (a.maxX - a.minX) + (a.maxY - a.minY); }

function enlargedArea(a, b) {
    return (Math.max(b.maxX, a.maxX) - Math.min(b.minX, a.minX)) *
           (Math.max(b.maxY, a.maxY) - Math.min(b.minY, a.minY));
}

function intersectionArea(a, b) {
    var minX = Math.max(a.minX, b.minX),
        minY = Math.max(a.minY, b.minY),
        maxX = Math.min(a.maxX, b.maxX),
        maxY = Math.min(a.maxY, b.maxY);

    return Math.max(0, maxX - minX) *
           Math.max(0, maxY - minY);
}

function contains(a, b) {
    return a.minX <= b.minX &&
           a.minY <= b.minY &&
           b.maxX <= a.maxX &&
           b.maxY <= a.maxY;
}

function intersects(a, b) {
    return b.minX <= a.maxX &&
           b.minY <= a.maxY &&
           b.maxX >= a.minX &&
           b.maxY >= a.minY;
}

function createNode(children) {
    return {
        children: children,
        height: 1,
        leaf: true,
        minX: Infinity,
        minY: Infinity,
        maxX: -Infinity,
        maxY: -Infinity
    };
}

// sort an array so that items come in groups of n unsorted items, with groups sorted between each other;
// combines selection algorithm with binary divide & conquer approach

function multiSelect(arr, left, right, n, compare) {
    var stack = [left, right],
        mid;

    while (stack.length) {
        right = stack.pop();
        left = stack.pop();

        if (right - left <= n) continue;

        mid = left + Math.ceil((right - left) / n / 2) * n;
        quickselect(arr, mid, left, right, compare);

        stack.push(left, mid, mid, right);
    }
}

},{"quickselect":166}],168:[function(require,module,exports){
'use strict';

var RequireObjectCoercible = require('es-abstract/2021/RequireObjectCoercible');
var ToString = require('es-abstract/2021/ToString');
var callBound = require('call-bind/callBound');
var $replace = callBound('String.prototype.replace');

var mvsIsWS = (/^\s$/).test('\u180E');
/* eslint-disable no-control-regex */
var leftWhitespace = mvsIsWS
	? /^[\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF]+/
	: /^[\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF]+/;
var rightWhitespace = mvsIsWS
	? /[\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF]+$/
	: /[\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF]+$/;
/* eslint-enable no-control-regex */

module.exports = function trim() {
	var S = ToString(RequireObjectCoercible(this));
	return $replace($replace(S, leftWhitespace, ''), rightWhitespace, '');
};

},{"call-bind/callBound":10,"es-abstract/2021/RequireObjectCoercible":21,"es-abstract/2021/ToString":27}],169:[function(require,module,exports){
'use strict';

var callBind = require('call-bind');
var define = require('define-properties');
var RequireObjectCoercible = require('es-abstract/2021/RequireObjectCoercible');

var implementation = require('./implementation');
var getPolyfill = require('./polyfill');
var shim = require('./shim');

var bound = callBind(getPolyfill());
var boundMethod = function trim(receiver) {
	RequireObjectCoercible(receiver);
	return bound(receiver);
};

define(boundMethod, {
	getPolyfill: getPolyfill,
	implementation: implementation,
	shim: shim
});

module.exports = boundMethod;

},{"./implementation":168,"./polyfill":170,"./shim":171,"call-bind":11,"define-properties":12,"es-abstract/2021/RequireObjectCoercible":21}],170:[function(require,module,exports){
'use strict';

var implementation = require('./implementation');

var zeroWidthSpace = '\u200b';
var mongolianVowelSeparator = '\u180E';

module.exports = function getPolyfill() {
	if (
		String.prototype.trim
		&& zeroWidthSpace.trim() === zeroWidthSpace
		&& mongolianVowelSeparator.trim() === mongolianVowelSeparator
		&& ('_' + mongolianVowelSeparator).trim() === ('_' + mongolianVowelSeparator)
		&& (mongolianVowelSeparator + '_').trim() === (mongolianVowelSeparator + '_')
	) {
		return String.prototype.trim;
	}
	return implementation;
};

},{"./implementation":168}],171:[function(require,module,exports){
'use strict';

var define = require('define-properties');
var getPolyfill = require('./polyfill');

module.exports = function shimStringTrim() {
	var polyfill = getPolyfill();
	define(String.prototype, { trim: polyfill }, {
		trim: function testTrim() {
			return String.prototype.trim !== polyfill;
		}
	});
	return polyfill;
};

},{"./polyfill":170,"define-properties":12}],172:[function(require,module,exports){
// TinyColor v1.4.2
// https://github.com/bgrins/TinyColor
// Brian Grinstead, MIT License

(function(Math) {

var trimLeft = /^\s+/,
    trimRight = /\s+$/,
    tinyCounter = 0,
    mathRound = Math.round,
    mathMin = Math.min,
    mathMax = Math.max,
    mathRandom = Math.random;

function tinycolor (color, opts) {

    color = (color) ? color : '';
    opts = opts || { };

    // If input is already a tinycolor, return itself
    if (color instanceof tinycolor) {
       return color;
    }
    // If we are called as a function, call using new instead
    if (!(this instanceof tinycolor)) {
        return new tinycolor(color, opts);
    }

    var rgb = inputToRGB(color);
    this._originalInput = color,
    this._r = rgb.r,
    this._g = rgb.g,
    this._b = rgb.b,
    this._a = rgb.a,
    this._roundA = mathRound(100*this._a) / 100,
    this._format = opts.format || rgb.format;
    this._gradientType = opts.gradientType;

    // Don't let the range of [0,255] come back in [0,1].
    // Potentially lose a little bit of precision here, but will fix issues where
    // .5 gets interpreted as half of the total, instead of half of 1
    // If it was supposed to be 128, this was already taken care of by `inputToRgb`
    if (this._r < 1) { this._r = mathRound(this._r); }
    if (this._g < 1) { this._g = mathRound(this._g); }
    if (this._b < 1) { this._b = mathRound(this._b); }

    this._ok = rgb.ok;
    this._tc_id = tinyCounter++;
}

tinycolor.prototype = {
    isDark: function() {
        return this.getBrightness() < 128;
    },
    isLight: function() {
        return !this.isDark();
    },
    isValid: function() {
        return this._ok;
    },
    getOriginalInput: function() {
      return this._originalInput;
    },
    getFormat: function() {
        return this._format;
    },
    getAlpha: function() {
        return this._a;
    },
    getBrightness: function() {
        //http://www.w3.org/TR/AERT#color-contrast
        var rgb = this.toRgb();
        return (rgb.r * 299 + rgb.g * 587 + rgb.b * 114) / 1000;
    },
    getLuminance: function() {
        //http://www.w3.org/TR/2008/REC-WCAG20-20081211/#relativeluminancedef
        var rgb = this.toRgb();
        var RsRGB, GsRGB, BsRGB, R, G, B;
        RsRGB = rgb.r/255;
        GsRGB = rgb.g/255;
        BsRGB = rgb.b/255;

        if (RsRGB <= 0.03928) {R = RsRGB / 12.92;} else {R = Math.pow(((RsRGB + 0.055) / 1.055), 2.4);}
        if (GsRGB <= 0.03928) {G = GsRGB / 12.92;} else {G = Math.pow(((GsRGB + 0.055) / 1.055), 2.4);}
        if (BsRGB <= 0.03928) {B = BsRGB / 12.92;} else {B = Math.pow(((BsRGB + 0.055) / 1.055), 2.4);}
        return (0.2126 * R) + (0.7152 * G) + (0.0722 * B);
    },
    setAlpha: function(value) {
        this._a = boundAlpha(value);
        this._roundA = mathRound(100*this._a) / 100;
        return this;
    },
    toHsv: function() {
        var hsv = rgbToHsv(this._r, this._g, this._b);
        return { h: hsv.h * 360, s: hsv.s, v: hsv.v, a: this._a };
    },
    toHsvString: function() {
        var hsv = rgbToHsv(this._r, this._g, this._b);
        var h = mathRound(hsv.h * 360), s = mathRound(hsv.s * 100), v = mathRound(hsv.v * 100);
        return (this._a == 1) ?
          "hsv("  + h + ", " + s + "%, " + v + "%)" :
          "hsva(" + h + ", " + s + "%, " + v + "%, "+ this._roundA + ")";
    },
    toHsl: function() {
        var hsl = rgbToHsl(this._r, this._g, this._b);
        return { h: hsl.h * 360, s: hsl.s, l: hsl.l, a: this._a };
    },
    toHslString: function() {
        var hsl = rgbToHsl(this._r, this._g, this._b);
        var h = mathRound(hsl.h * 360), s = mathRound(hsl.s * 100), l = mathRound(hsl.l * 100);
        return (this._a == 1) ?
          "hsl("  + h + ", " + s + "%, " + l + "%)" :
          "hsla(" + h + ", " + s + "%, " + l + "%, "+ this._roundA + ")";
    },
    toHex: function(allow3Char) {
        return rgbToHex(this._r, this._g, this._b, allow3Char);
    },
    toHexString: function(allow3Char) {
        return '#' + this.toHex(allow3Char);
    },
    toHex8: function(allow4Char) {
        return rgbaToHex(this._r, this._g, this._b, this._a, allow4Char);
    },
    toHex8String: function(allow4Char) {
        return '#' + this.toHex8(allow4Char);
    },
    toRgb: function() {
        return { r: mathRound(this._r), g: mathRound(this._g), b: mathRound(this._b), a: this._a };
    },
    toRgbString: function() {
        return (this._a == 1) ?
          "rgb("  + mathRound(this._r) + ", " + mathRound(this._g) + ", " + mathRound(this._b) + ")" :
          "rgba(" + mathRound(this._r) + ", " + mathRound(this._g) + ", " + mathRound(this._b) + ", " + this._roundA + ")";
    },
    toPercentageRgb: function() {
        return { r: mathRound(bound01(this._r, 255) * 100) + "%", g: mathRound(bound01(this._g, 255) * 100) + "%", b: mathRound(bound01(this._b, 255) * 100) + "%", a: this._a };
    },
    toPercentageRgbString: function() {
        return (this._a == 1) ?
          "rgb("  + mathRound(bound01(this._r, 255) * 100) + "%, " + mathRound(bound01(this._g, 255) * 100) + "%, " + mathRound(bound01(this._b, 255) * 100) + "%)" :
          "rgba(" + mathRound(bound01(this._r, 255) * 100) + "%, " + mathRound(bound01(this._g, 255) * 100) + "%, " + mathRound(bound01(this._b, 255) * 100) + "%, " + this._roundA + ")";
    },
    toName: function() {
        if (this._a === 0) {
            return "transparent";
        }

        if (this._a < 1) {
            return false;
        }

        return hexNames[rgbToHex(this._r, this._g, this._b, true)] || false;
    },
    toFilter: function(secondColor) {
        var hex8String = '#' + rgbaToArgbHex(this._r, this._g, this._b, this._a);
        var secondHex8String = hex8String;
        var gradientType = this._gradientType ? "GradientType = 1, " : "";

        if (secondColor) {
            var s = tinycolor(secondColor);
            secondHex8String = '#' + rgbaToArgbHex(s._r, s._g, s._b, s._a);
        }

        return "progid:DXImageTransform.Microsoft.gradient("+gradientType+"startColorstr="+hex8String+",endColorstr="+secondHex8String+")";
    },
    toString: function(format) {
        var formatSet = !!format;
        format = format || this._format;

        var formattedString = false;
        var hasAlpha = this._a < 1 && this._a >= 0;
        var needsAlphaFormat = !formatSet && hasAlpha && (format === "hex" || format === "hex6" || format === "hex3" || format === "hex4" || format === "hex8" || format === "name");

        if (needsAlphaFormat) {
            // Special case for "transparent", all other non-alpha formats
            // will return rgba when there is transparency.
            if (format === "name" && this._a === 0) {
                return this.toName();
            }
            return this.toRgbString();
        }
        if (format === "rgb") {
            formattedString = this.toRgbString();
        }
        if (format === "prgb") {
            formattedString = this.toPercentageRgbString();
        }
        if (format === "hex" || format === "hex6") {
            formattedString = this.toHexString();
        }
        if (format === "hex3") {
            formattedString = this.toHexString(true);
        }
        if (format === "hex4") {
            formattedString = this.toHex8String(true);
        }
        if (format === "hex8") {
            formattedString = this.toHex8String();
        }
        if (format === "name") {
            formattedString = this.toName();
        }
        if (format === "hsl") {
            formattedString = this.toHslString();
        }
        if (format === "hsv") {
            formattedString = this.toHsvString();
        }

        return formattedString || this.toHexString();
    },
    clone: function() {
        return tinycolor(this.toString());
    },

    _applyModification: function(fn, args) {
        var color = fn.apply(null, [this].concat([].slice.call(args)));
        this._r = color._r;
        this._g = color._g;
        this._b = color._b;
        this.setAlpha(color._a);
        return this;
    },
    lighten: function() {
        return this._applyModification(lighten, arguments);
    },
    brighten: function() {
        return this._applyModification(brighten, arguments);
    },
    darken: function() {
        return this._applyModification(darken, arguments);
    },
    desaturate: function() {
        return this._applyModification(desaturate, arguments);
    },
    saturate: function() {
        return this._applyModification(saturate, arguments);
    },
    greyscale: function() {
        return this._applyModification(greyscale, arguments);
    },
    spin: function() {
        return this._applyModification(spin, arguments);
    },

    _applyCombination: function(fn, args) {
        return fn.apply(null, [this].concat([].slice.call(args)));
    },
    analogous: function() {
        return this._applyCombination(analogous, arguments);
    },
    complement: function() {
        return this._applyCombination(complement, arguments);
    },
    monochromatic: function() {
        return this._applyCombination(monochromatic, arguments);
    },
    splitcomplement: function() {
        return this._applyCombination(splitcomplement, arguments);
    },
    triad: function() {
        return this._applyCombination(triad, arguments);
    },
    tetrad: function() {
        return this._applyCombination(tetrad, arguments);
    }
};

// If input is an object, force 1 into "1.0" to handle ratios properly
// String input requires "1.0" as input, so 1 will be treated as 1
tinycolor.fromRatio = function(color, opts) {
    if (typeof color == "object") {
        var newColor = {};
        for (var i in color) {
            if (color.hasOwnProperty(i)) {
                if (i === "a") {
                    newColor[i] = color[i];
                }
                else {
                    newColor[i] = convertToPercentage(color[i]);
                }
            }
        }
        color = newColor;
    }

    return tinycolor(color, opts);
};

// Given a string or object, convert that input to RGB
// Possible string inputs:
//
//     "red"
//     "#f00" or "f00"
//     "#ff0000" or "ff0000"
//     "#ff000000" or "ff000000"
//     "rgb 255 0 0" or "rgb (255, 0, 0)"
//     "rgb 1.0 0 0" or "rgb (1, 0, 0)"
//     "rgba (255, 0, 0, 1)" or "rgba 255, 0, 0, 1"
//     "rgba (1.0, 0, 0, 1)" or "rgba 1.0, 0, 0, 1"
//     "hsl(0, 100%, 50%)" or "hsl 0 100% 50%"
//     "hsla(0, 100%, 50%, 1)" or "hsla 0 100% 50%, 1"
//     "hsv(0, 100%, 100%)" or "hsv 0 100% 100%"
//
function inputToRGB(color) {

    var rgb = { r: 0, g: 0, b: 0 };
    var a = 1;
    var s = null;
    var v = null;
    var l = null;
    var ok = false;
    var format = false;

    if (typeof color == "string") {
        color = stringInputToObject(color);
    }

    if (typeof color == "object") {
        if (isValidCSSUnit(color.r) && isValidCSSUnit(color.g) && isValidCSSUnit(color.b)) {
            rgb = rgbToRgb(color.r, color.g, color.b);
            ok = true;
            format = String(color.r).substr(-1) === "%" ? "prgb" : "rgb";
        }
        else if (isValidCSSUnit(color.h) && isValidCSSUnit(color.s) && isValidCSSUnit(color.v)) {
            s = convertToPercentage(color.s);
            v = convertToPercentage(color.v);
            rgb = hsvToRgb(color.h, s, v);
            ok = true;
            format = "hsv";
        }
        else if (isValidCSSUnit(color.h) && isValidCSSUnit(color.s) && isValidCSSUnit(color.l)) {
            s = convertToPercentage(color.s);
            l = convertToPercentage(color.l);
            rgb = hslToRgb(color.h, s, l);
            ok = true;
            format = "hsl";
        }

        if (color.hasOwnProperty("a")) {
            a = color.a;
        }
    }

    a = boundAlpha(a);

    return {
        ok: ok,
        format: color.format || format,
        r: mathMin(255, mathMax(rgb.r, 0)),
        g: mathMin(255, mathMax(rgb.g, 0)),
        b: mathMin(255, mathMax(rgb.b, 0)),
        a: a
    };
}


// Conversion Functions
// --------------------

// `rgbToHsl`, `rgbToHsv`, `hslToRgb`, `hsvToRgb` modified from:
// <http://mjijackson.com/2008/02/rgb-to-hsl-and-rgb-to-hsv-color-model-conversion-algorithms-in-javascript>

// `rgbToRgb`
// Handle bounds / percentage checking to conform to CSS color spec
// <http://www.w3.org/TR/css3-color/>
// *Assumes:* r, g, b in [0, 255] or [0, 1]
// *Returns:* { r, g, b } in [0, 255]
function rgbToRgb(r, g, b){
    return {
        r: bound01(r, 255) * 255,
        g: bound01(g, 255) * 255,
        b: bound01(b, 255) * 255
    };
}

// `rgbToHsl`
// Converts an RGB color value to HSL.
// *Assumes:* r, g, and b are contained in [0, 255] or [0, 1]
// *Returns:* { h, s, l } in [0,1]
function rgbToHsl(r, g, b) {

    r = bound01(r, 255);
    g = bound01(g, 255);
    b = bound01(b, 255);

    var max = mathMax(r, g, b), min = mathMin(r, g, b);
    var h, s, l = (max + min) / 2;

    if(max == min) {
        h = s = 0; // achromatic
    }
    else {
        var d = max - min;
        s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
        switch(max) {
            case r: h = (g - b) / d + (g < b ? 6 : 0); break;
            case g: h = (b - r) / d + 2; break;
            case b: h = (r - g) / d + 4; break;
        }

        h /= 6;
    }

    return { h: h, s: s, l: l };
}

// `hslToRgb`
// Converts an HSL color value to RGB.
// *Assumes:* h is contained in [0, 1] or [0, 360] and s and l are contained [0, 1] or [0, 100]
// *Returns:* { r, g, b } in the set [0, 255]
function hslToRgb(h, s, l) {
    var r, g, b;

    h = bound01(h, 360);
    s = bound01(s, 100);
    l = bound01(l, 100);

    function hue2rgb(p, q, t) {
        if(t < 0) t += 1;
        if(t > 1) t -= 1;
        if(t < 1/6) return p + (q - p) * 6 * t;
        if(t < 1/2) return q;
        if(t < 2/3) return p + (q - p) * (2/3 - t) * 6;
        return p;
    }

    if(s === 0) {
        r = g = b = l; // achromatic
    }
    else {
        var q = l < 0.5 ? l * (1 + s) : l + s - l * s;
        var p = 2 * l - q;
        r = hue2rgb(p, q, h + 1/3);
        g = hue2rgb(p, q, h);
        b = hue2rgb(p, q, h - 1/3);
    }

    return { r: r * 255, g: g * 255, b: b * 255 };
}

// `rgbToHsv`
// Converts an RGB color value to HSV
// *Assumes:* r, g, and b are contained in the set [0, 255] or [0, 1]
// *Returns:* { h, s, v } in [0,1]
function rgbToHsv(r, g, b) {

    r = bound01(r, 255);
    g = bound01(g, 255);
    b = bound01(b, 255);

    var max = mathMax(r, g, b), min = mathMin(r, g, b);
    var h, s, v = max;

    var d = max - min;
    s = max === 0 ? 0 : d / max;

    if(max == min) {
        h = 0; // achromatic
    }
    else {
        switch(max) {
            case r: h = (g - b) / d + (g < b ? 6 : 0); break;
            case g: h = (b - r) / d + 2; break;
            case b: h = (r - g) / d + 4; break;
        }
        h /= 6;
    }
    return { h: h, s: s, v: v };
}

// `hsvToRgb`
// Converts an HSV color value to RGB.
// *Assumes:* h is contained in [0, 1] or [0, 360] and s and v are contained in [0, 1] or [0, 100]
// *Returns:* { r, g, b } in the set [0, 255]
 function hsvToRgb(h, s, v) {

    h = bound01(h, 360) * 6;
    s = bound01(s, 100);
    v = bound01(v, 100);

    var i = Math.floor(h),
        f = h - i,
        p = v * (1 - s),
        q = v * (1 - f * s),
        t = v * (1 - (1 - f) * s),
        mod = i % 6,
        r = [v, q, p, p, t, v][mod],
        g = [t, v, v, q, p, p][mod],
        b = [p, p, t, v, v, q][mod];

    return { r: r * 255, g: g * 255, b: b * 255 };
}

// `rgbToHex`
// Converts an RGB color to hex
// Assumes r, g, and b are contained in the set [0, 255]
// Returns a 3 or 6 character hex
function rgbToHex(r, g, b, allow3Char) {

    var hex = [
        pad2(mathRound(r).toString(16)),
        pad2(mathRound(g).toString(16)),
        pad2(mathRound(b).toString(16))
    ];

    // Return a 3 character hex if possible
    if (allow3Char && hex[0].charAt(0) == hex[0].charAt(1) && hex[1].charAt(0) == hex[1].charAt(1) && hex[2].charAt(0) == hex[2].charAt(1)) {
        return hex[0].charAt(0) + hex[1].charAt(0) + hex[2].charAt(0);
    }

    return hex.join("");
}

// `rgbaToHex`
// Converts an RGBA color plus alpha transparency to hex
// Assumes r, g, b are contained in the set [0, 255] and
// a in [0, 1]. Returns a 4 or 8 character rgba hex
function rgbaToHex(r, g, b, a, allow4Char) {

    var hex = [
        pad2(mathRound(r).toString(16)),
        pad2(mathRound(g).toString(16)),
        pad2(mathRound(b).toString(16)),
        pad2(convertDecimalToHex(a))
    ];

    // Return a 4 character hex if possible
    if (allow4Char && hex[0].charAt(0) == hex[0].charAt(1) && hex[1].charAt(0) == hex[1].charAt(1) && hex[2].charAt(0) == hex[2].charAt(1) && hex[3].charAt(0) == hex[3].charAt(1)) {
        return hex[0].charAt(0) + hex[1].charAt(0) + hex[2].charAt(0) + hex[3].charAt(0);
    }

    return hex.join("");
}

// `rgbaToArgbHex`
// Converts an RGBA color to an ARGB Hex8 string
// Rarely used, but required for "toFilter()"
function rgbaToArgbHex(r, g, b, a) {

    var hex = [
        pad2(convertDecimalToHex(a)),
        pad2(mathRound(r).toString(16)),
        pad2(mathRound(g).toString(16)),
        pad2(mathRound(b).toString(16))
    ];

    return hex.join("");
}

// `equals`
// Can be called with any tinycolor input
tinycolor.equals = function (color1, color2) {
    if (!color1 || !color2) { return false; }
    return tinycolor(color1).toRgbString() == tinycolor(color2).toRgbString();
};

tinycolor.random = function() {
    return tinycolor.fromRatio({
        r: mathRandom(),
        g: mathRandom(),
        b: mathRandom()
    });
};


// Modification Functions
// ----------------------
// Thanks to less.js for some of the basics here
// <https://github.com/cloudhead/less.js/blob/master/lib/less/functions.js>

function desaturate(color, amount) {
    amount = (amount === 0) ? 0 : (amount || 10);
    var hsl = tinycolor(color).toHsl();
    hsl.s -= amount / 100;
    hsl.s = clamp01(hsl.s);
    return tinycolor(hsl);
}

function saturate(color, amount) {
    amount = (amount === 0) ? 0 : (amount || 10);
    var hsl = tinycolor(color).toHsl();
    hsl.s += amount / 100;
    hsl.s = clamp01(hsl.s);
    return tinycolor(hsl);
}

function greyscale(color) {
    return tinycolor(color).desaturate(100);
}

function lighten (color, amount) {
    amount = (amount === 0) ? 0 : (amount || 10);
    var hsl = tinycolor(color).toHsl();
    hsl.l += amount / 100;
    hsl.l = clamp01(hsl.l);
    return tinycolor(hsl);
}

function brighten(color, amount) {
    amount = (amount === 0) ? 0 : (amount || 10);
    var rgb = tinycolor(color).toRgb();
    rgb.r = mathMax(0, mathMin(255, rgb.r - mathRound(255 * - (amount / 100))));
    rgb.g = mathMax(0, mathMin(255, rgb.g - mathRound(255 * - (amount / 100))));
    rgb.b = mathMax(0, mathMin(255, rgb.b - mathRound(255 * - (amount / 100))));
    return tinycolor(rgb);
}

function darken (color, amount) {
    amount = (amount === 0) ? 0 : (amount || 10);
    var hsl = tinycolor(color).toHsl();
    hsl.l -= amount / 100;
    hsl.l = clamp01(hsl.l);
    return tinycolor(hsl);
}

// Spin takes a positive or negative amount within [-360, 360] indicating the change of hue.
// Values outside of this range will be wrapped into this range.
function spin(color, amount) {
    var hsl = tinycolor(color).toHsl();
    var hue = (hsl.h + amount) % 360;
    hsl.h = hue < 0 ? 360 + hue : hue;
    return tinycolor(hsl);
}

// Combination Functions
// ---------------------
// Thanks to jQuery xColor for some of the ideas behind these
// <https://github.com/infusion/jQuery-xcolor/blob/master/jquery.xcolor.js>

function complement(color) {
    var hsl = tinycolor(color).toHsl();
    hsl.h = (hsl.h + 180) % 360;
    return tinycolor(hsl);
}

function triad(color) {
    var hsl = tinycolor(color).toHsl();
    var h = hsl.h;
    return [
        tinycolor(color),
        tinycolor({ h: (h + 120) % 360, s: hsl.s, l: hsl.l }),
        tinycolor({ h: (h + 240) % 360, s: hsl.s, l: hsl.l })
    ];
}

function tetrad(color) {
    var hsl = tinycolor(color).toHsl();
    var h = hsl.h;
    return [
        tinycolor(color),
        tinycolor({ h: (h + 90) % 360, s: hsl.s, l: hsl.l }),
        tinycolor({ h: (h + 180) % 360, s: hsl.s, l: hsl.l }),
        tinycolor({ h: (h + 270) % 360, s: hsl.s, l: hsl.l })
    ];
}

function splitcomplement(color) {
    var hsl = tinycolor(color).toHsl();
    var h = hsl.h;
    return [
        tinycolor(color),
        tinycolor({ h: (h + 72) % 360, s: hsl.s, l: hsl.l}),
        tinycolor({ h: (h + 216) % 360, s: hsl.s, l: hsl.l})
    ];
}

function analogous(color, results, slices) {
    results = results || 6;
    slices = slices || 30;

    var hsl = tinycolor(color).toHsl();
    var part = 360 / slices;
    var ret = [tinycolor(color)];

    for (hsl.h = ((hsl.h - (part * results >> 1)) + 720) % 360; --results; ) {
        hsl.h = (hsl.h + part) % 360;
        ret.push(tinycolor(hsl));
    }
    return ret;
}

function monochromatic(color, results) {
    results = results || 6;
    var hsv = tinycolor(color).toHsv();
    var h = hsv.h, s = hsv.s, v = hsv.v;
    var ret = [];
    var modification = 1 / results;

    while (results--) {
        ret.push(tinycolor({ h: h, s: s, v: v}));
        v = (v + modification) % 1;
    }

    return ret;
}

// Utility Functions
// ---------------------

tinycolor.mix = function(color1, color2, amount) {
    amount = (amount === 0) ? 0 : (amount || 50);

    var rgb1 = tinycolor(color1).toRgb();
    var rgb2 = tinycolor(color2).toRgb();

    var p = amount / 100;

    var rgba = {
        r: ((rgb2.r - rgb1.r) * p) + rgb1.r,
        g: ((rgb2.g - rgb1.g) * p) + rgb1.g,
        b: ((rgb2.b - rgb1.b) * p) + rgb1.b,
        a: ((rgb2.a - rgb1.a) * p) + rgb1.a
    };

    return tinycolor(rgba);
};


// Readability Functions
// ---------------------
// <http://www.w3.org/TR/2008/REC-WCAG20-20081211/#contrast-ratiodef (WCAG Version 2)

// `contrast`
// Analyze the 2 colors and returns the color contrast defined by (WCAG Version 2)
tinycolor.readability = function(color1, color2) {
    var c1 = tinycolor(color1);
    var c2 = tinycolor(color2);
    return (Math.max(c1.getLuminance(),c2.getLuminance())+0.05) / (Math.min(c1.getLuminance(),c2.getLuminance())+0.05);
};

// `isReadable`
// Ensure that foreground and background color combinations meet WCAG2 guidelines.
// The third argument is an optional Object.
//      the 'level' property states 'AA' or 'AAA' - if missing or invalid, it defaults to 'AA';
//      the 'size' property states 'large' or 'small' - if missing or invalid, it defaults to 'small'.
// If the entire object is absent, isReadable defaults to {level:"AA",size:"small"}.

// *Example*
//    tinycolor.isReadable("#000", "#111") => false
//    tinycolor.isReadable("#000", "#111",{level:"AA",size:"large"}) => false
tinycolor.isReadable = function(color1, color2, wcag2) {
    var readability = tinycolor.readability(color1, color2);
    var wcag2Parms, out;

    out = false;

    wcag2Parms = validateWCAG2Parms(wcag2);
    switch (wcag2Parms.level + wcag2Parms.size) {
        case "AAsmall":
        case "AAAlarge":
            out = readability >= 4.5;
            break;
        case "AAlarge":
            out = readability >= 3;
            break;
        case "AAAsmall":
            out = readability >= 7;
            break;
    }
    return out;

};

// `mostReadable`
// Given a base color and a list of possible foreground or background
// colors for that base, returns the most readable color.
// Optionally returns Black or White if the most readable color is unreadable.
// *Example*
//    tinycolor.mostReadable(tinycolor.mostReadable("#123", ["#124", "#125"],{includeFallbackColors:false}).toHexString(); // "#112255"
//    tinycolor.mostReadable(tinycolor.mostReadable("#123", ["#124", "#125"],{includeFallbackColors:true}).toHexString();  // "#ffffff"
//    tinycolor.mostReadable("#a8015a", ["#faf3f3"],{includeFallbackColors:true,level:"AAA",size:"large"}).toHexString(); // "#faf3f3"
//    tinycolor.mostReadable("#a8015a", ["#faf3f3"],{includeFallbackColors:true,level:"AAA",size:"small"}).toHexString(); // "#ffffff"
tinycolor.mostReadable = function(baseColor, colorList, args) {
    var bestColor = null;
    var bestScore = 0;
    var readability;
    var includeFallbackColors, level, size ;
    args = args || {};
    includeFallbackColors = args.includeFallbackColors ;
    level = args.level;
    size = args.size;

    for (var i= 0; i < colorList.length ; i++) {
        readability = tinycolor.readability(baseColor, colorList[i]);
        if (readability > bestScore) {
            bestScore = readability;
            bestColor = tinycolor(colorList[i]);
        }
    }

    if (tinycolor.isReadable(baseColor, bestColor, {"level":level,"size":size}) || !includeFallbackColors) {
        return bestColor;
    }
    else {
        args.includeFallbackColors=false;
        return tinycolor.mostReadable(baseColor,["#fff", "#000"],args);
    }
};


// Big List of Colors
// ------------------
// <http://www.w3.org/TR/css3-color/#svg-color>
var names = tinycolor.names = {
    aliceblue: "f0f8ff",
    antiquewhite: "faebd7",
    aqua: "0ff",
    aquamarine: "7fffd4",
    azure: "f0ffff",
    beige: "f5f5dc",
    bisque: "ffe4c4",
    black: "000",
    blanchedalmond: "ffebcd",
    blue: "00f",
    blueviolet: "8a2be2",
    brown: "a52a2a",
    burlywood: "deb887",
    burntsienna: "ea7e5d",
    cadetblue: "5f9ea0",
    chartreuse: "7fff00",
    chocolate: "d2691e",
    coral: "ff7f50",
    cornflowerblue: "6495ed",
    cornsilk: "fff8dc",
    crimson: "dc143c",
    cyan: "0ff",
    darkblue: "00008b",
    darkcyan: "008b8b",
    darkgoldenrod: "b8860b",
    darkgray: "a9a9a9",
    darkgreen: "006400",
    darkgrey: "a9a9a9",
    darkkhaki: "bdb76b",
    darkmagenta: "8b008b",
    darkolivegreen: "556b2f",
    darkorange: "ff8c00",
    darkorchid: "9932cc",
    darkred: "8b0000",
    darksalmon: "e9967a",
    darkseagreen: "8fbc8f",
    darkslateblue: "483d8b",
    darkslategray: "2f4f4f",
    darkslategrey: "2f4f4f",
    darkturquoise: "00ced1",
    darkviolet: "9400d3",
    deeppink: "ff1493",
    deepskyblue: "00bfff",
    dimgray: "696969",
    dimgrey: "696969",
    dodgerblue: "1e90ff",
    firebrick: "b22222",
    floralwhite: "fffaf0",
    forestgreen: "228b22",
    fuchsia: "f0f",
    gainsboro: "dcdcdc",
    ghostwhite: "f8f8ff",
    gold: "ffd700",
    goldenrod: "daa520",
    gray: "808080",
    green: "008000",
    greenyellow: "adff2f",
    grey: "808080",
    honeydew: "f0fff0",
    hotpink: "ff69b4",
    indianred: "cd5c5c",
    indigo: "4b0082",
    ivory: "fffff0",
    khaki: "f0e68c",
    lavender: "e6e6fa",
    lavenderblush: "fff0f5",
    lawngreen: "7cfc00",
    lemonchiffon: "fffacd",
    lightblue: "add8e6",
    lightcoral: "f08080",
    lightcyan: "e0ffff",
    lightgoldenrodyellow: "fafad2",
    lightgray: "d3d3d3",
    lightgreen: "90ee90",
    lightgrey: "d3d3d3",
    lightpink: "ffb6c1",
    lightsalmon: "ffa07a",
    lightseagreen: "20b2aa",
    lightskyblue: "87cefa",
    lightslategray: "789",
    lightslategrey: "789",
    lightsteelblue: "b0c4de",
    lightyellow: "ffffe0",
    lime: "0f0",
    limegreen: "32cd32",
    linen: "faf0e6",
    magenta: "f0f",
    maroon: "800000",
    mediumaquamarine: "66cdaa",
    mediumblue: "0000cd",
    mediumorchid: "ba55d3",
    mediumpurple: "9370db",
    mediumseagreen: "3cb371",
    mediumslateblue: "7b68ee",
    mediumspringgreen: "00fa9a",
    mediumturquoise: "48d1cc",
    mediumvioletred: "c71585",
    midnightblue: "191970",
    mintcream: "f5fffa",
    mistyrose: "ffe4e1",
    moccasin: "ffe4b5",
    navajowhite: "ffdead",
    navy: "000080",
    oldlace: "fdf5e6",
    olive: "808000",
    olivedrab: "6b8e23",
    orange: "ffa500",
    orangered: "ff4500",
    orchid: "da70d6",
    palegoldenrod: "eee8aa",
    palegreen: "98fb98",
    paleturquoise: "afeeee",
    palevioletred: "db7093",
    papayawhip: "ffefd5",
    peachpuff: "ffdab9",
    peru: "cd853f",
    pink: "ffc0cb",
    plum: "dda0dd",
    powderblue: "b0e0e6",
    purple: "800080",
    rebeccapurple: "663399",
    red: "f00",
    rosybrown: "bc8f8f",
    royalblue: "4169e1",
    saddlebrown: "8b4513",
    salmon: "fa8072",
    sandybrown: "f4a460",
    seagreen: "2e8b57",
    seashell: "fff5ee",
    sienna: "a0522d",
    silver: "c0c0c0",
    skyblue: "87ceeb",
    slateblue: "6a5acd",
    slategray: "708090",
    slategrey: "708090",
    snow: "fffafa",
    springgreen: "00ff7f",
    steelblue: "4682b4",
    tan: "d2b48c",
    teal: "008080",
    thistle: "d8bfd8",
    tomato: "ff6347",
    turquoise: "40e0d0",
    violet: "ee82ee",
    wheat: "f5deb3",
    white: "fff",
    whitesmoke: "f5f5f5",
    yellow: "ff0",
    yellowgreen: "9acd32"
};

// Make it easy to access colors via `hexNames[hex]`
var hexNames = tinycolor.hexNames = flip(names);


// Utilities
// ---------

// `{ 'name1': 'val1' }` becomes `{ 'val1': 'name1' }`
function flip(o) {
    var flipped = { };
    for (var i in o) {
        if (o.hasOwnProperty(i)) {
            flipped[o[i]] = i;
        }
    }
    return flipped;
}

// Return a valid alpha value [0,1] with all invalid values being set to 1
function boundAlpha(a) {
    a = parseFloat(a);

    if (isNaN(a) || a < 0 || a > 1) {
        a = 1;
    }

    return a;
}

// Take input from [0, n] and return it as [0, 1]
function bound01(n, max) {
    if (isOnePointZero(n)) { n = "100%"; }

    var processPercent = isPercentage(n);
    n = mathMin(max, mathMax(0, parseFloat(n)));

    // Automatically convert percentage into number
    if (processPercent) {
        n = parseInt(n * max, 10) / 100;
    }

    // Handle floating point rounding errors
    if ((Math.abs(n - max) < 0.000001)) {
        return 1;
    }

    // Convert into [0, 1] range if it isn't already
    return (n % max) / parseFloat(max);
}

// Force a number between 0 and 1
function clamp01(val) {
    return mathMin(1, mathMax(0, val));
}

// Parse a base-16 hex value into a base-10 integer
function parseIntFromHex(val) {
    return parseInt(val, 16);
}

// Need to handle 1.0 as 100%, since once it is a number, there is no difference between it and 1
// <http://stackoverflow.com/questions/7422072/javascript-how-to-detect-number-as-a-decimal-including-1-0>
function isOnePointZero(n) {
    return typeof n == "string" && n.indexOf('.') != -1 && parseFloat(n) === 1;
}

// Check to see if string passed in is a percentage
function isPercentage(n) {
    return typeof n === "string" && n.indexOf('%') != -1;
}

// Force a hex value to have 2 characters
function pad2(c) {
    return c.length == 1 ? '0' + c : '' + c;
}

// Replace a decimal with it's percentage value
function convertToPercentage(n) {
    if (n <= 1) {
        n = (n * 100) + "%";
    }

    return n;
}

// Converts a decimal to a hex value
function convertDecimalToHex(d) {
    return Math.round(parseFloat(d) * 255).toString(16);
}
// Converts a hex value to a decimal
function convertHexToDecimal(h) {
    return (parseIntFromHex(h) / 255);
}

var matchers = (function() {

    // <http://www.w3.org/TR/css3-values/#integers>
    var CSS_INTEGER = "[-\\+]?\\d+%?";

    // <http://www.w3.org/TR/css3-values/#number-value>
    var CSS_NUMBER = "[-\\+]?\\d*\\.\\d+%?";

    // Allow positive/negative integer/number.  Don't capture the either/or, just the entire outcome.
    var CSS_UNIT = "(?:" + CSS_NUMBER + ")|(?:" + CSS_INTEGER + ")";

    // Actual matching.
    // Parentheses and commas are optional, but not required.
    // Whitespace can take the place of commas or opening paren
    var PERMISSIVE_MATCH3 = "[\\s|\\(]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")\\s*\\)?";
    var PERMISSIVE_MATCH4 = "[\\s|\\(]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")\\s*\\)?";

    return {
        CSS_UNIT: new RegExp(CSS_UNIT),
        rgb: new RegExp("rgb" + PERMISSIVE_MATCH3),
        rgba: new RegExp("rgba" + PERMISSIVE_MATCH4),
        hsl: new RegExp("hsl" + PERMISSIVE_MATCH3),
        hsla: new RegExp("hsla" + PERMISSIVE_MATCH4),
        hsv: new RegExp("hsv" + PERMISSIVE_MATCH3),
        hsva: new RegExp("hsva" + PERMISSIVE_MATCH4),
        hex3: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
        hex6: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/,
        hex4: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
        hex8: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/
    };
})();

// `isValidCSSUnit`
// Take in a single string / number and check to see if it looks like a CSS unit
// (see `matchers` above for definition).
function isValidCSSUnit(color) {
    return !!matchers.CSS_UNIT.exec(color);
}

// `stringInputToObject`
// Permissive string parsing.  Take in a number of formats, and output an object
// based on detected format.  Returns `{ r, g, b }` or `{ h, s, l }` or `{ h, s, v}`
function stringInputToObject(color) {

    color = color.replace(trimLeft,'').replace(trimRight, '').toLowerCase();
    var named = false;
    if (names[color]) {
        color = names[color];
        named = true;
    }
    else if (color == 'transparent') {
        return { r: 0, g: 0, b: 0, a: 0, format: "name" };
    }

    // Try to match string input using regular expressions.
    // Keep most of the number bounding out of this function - don't worry about [0,1] or [0,100] or [0,360]
    // Just return an object and let the conversion functions handle that.
    // This way the result will be the same whether the tinycolor is initialized with string or object.
    var match;
    if ((match = matchers.rgb.exec(color))) {
        return { r: match[1], g: match[2], b: match[3] };
    }
    if ((match = matchers.rgba.exec(color))) {
        return { r: match[1], g: match[2], b: match[3], a: match[4] };
    }
    if ((match = matchers.hsl.exec(color))) {
        return { h: match[1], s: match[2], l: match[3] };
    }
    if ((match = matchers.hsla.exec(color))) {
        return { h: match[1], s: match[2], l: match[3], a: match[4] };
    }
    if ((match = matchers.hsv.exec(color))) {
        return { h: match[1], s: match[2], v: match[3] };
    }
    if ((match = matchers.hsva.exec(color))) {
        return { h: match[1], s: match[2], v: match[3], a: match[4] };
    }
    if ((match = matchers.hex8.exec(color))) {
        return {
            r: parseIntFromHex(match[1]),
            g: parseIntFromHex(match[2]),
            b: parseIntFromHex(match[3]),
            a: convertHexToDecimal(match[4]),
            format: named ? "name" : "hex8"
        };
    }
    if ((match = matchers.hex6.exec(color))) {
        return {
            r: parseIntFromHex(match[1]),
            g: parseIntFromHex(match[2]),
            b: parseIntFromHex(match[3]),
            format: named ? "name" : "hex"
        };
    }
    if ((match = matchers.hex4.exec(color))) {
        return {
            r: parseIntFromHex(match[1] + '' + match[1]),
            g: parseIntFromHex(match[2] + '' + match[2]),
            b: parseIntFromHex(match[3] + '' + match[3]),
            a: convertHexToDecimal(match[4] + '' + match[4]),
            format: named ? "name" : "hex8"
        };
    }
    if ((match = matchers.hex3.exec(color))) {
        return {
            r: parseIntFromHex(match[1] + '' + match[1]),
            g: parseIntFromHex(match[2] + '' + match[2]),
            b: parseIntFromHex(match[3] + '' + match[3]),
            format: named ? "name" : "hex"
        };
    }

    return false;
}

function validateWCAG2Parms(parms) {
    // return valid WCAG2 parms for isReadable.
    // If input parms are invalid, return {"level":"AA", "size":"small"}
    var level, size;
    parms = parms || {"level":"AA", "size":"small"};
    level = (parms.level || "AA").toUpperCase();
    size = (parms.size || "small").toLowerCase();
    if (level !== "AA" && level !== "AAA") {
        level = "AA";
    }
    if (size !== "small" && size !== "large") {
        size = "small";
    }
    return {"level":level, "size":size};
}

// Node: Export function
if (typeof module !== "undefined" && module.exports) {
    module.exports = tinycolor;
}
// AMD/requirejs: Define the module
else if (typeof define === 'function' && define.amd) {
    define(function () {return tinycolor;});
}
// Browser: Expose to window
else {
    window.tinycolor = tinycolor;
}

})(Math);

},{}],173:[function(require,module,exports){
(function (global){
/**
 *
 *
 * @author Jerry Bendy <jerry@icewingcc.com>
 * @licence MIT
 *
 */

(function(self) {
    'use strict';

    var nativeURLSearchParams = (function() {
            // #41 Fix issue in RN
            try {
                if (self.URLSearchParams && (new self.URLSearchParams('foo=bar')).get('foo') === 'bar') {
                    return self.URLSearchParams;
                }
            } catch (e) {}
            return null;
        })(),
        isSupportObjectConstructor = nativeURLSearchParams && (new nativeURLSearchParams({a: 1})).toString() === 'a=1',
        // There is a bug in safari 10.1 (and earlier) that incorrectly decodes `%2B` as an empty space and not a plus.
        decodesPlusesCorrectly = nativeURLSearchParams && (new nativeURLSearchParams('s=%2B').get('s') === '+'),
        __URLSearchParams__ = "__URLSearchParams__",
        // Fix bug in Edge which cannot encode ' &' correctly
        encodesAmpersandsCorrectly = nativeURLSearchParams ? (function() {
            var ampersandTest = new nativeURLSearchParams();
            ampersandTest.append('s', ' &');
            return ampersandTest.toString() === 's=+%26';
        })() : true,
        prototype = URLSearchParamsPolyfill.prototype,
        iterable = !!(self.Symbol && self.Symbol.iterator);

    if (nativeURLSearchParams && isSupportObjectConstructor && decodesPlusesCorrectly && encodesAmpersandsCorrectly) {
        return;
    }


    /**
     * Make a URLSearchParams instance
     *
     * @param {object|string|URLSearchParams} search
     * @constructor
     */
    function URLSearchParamsPolyfill(search) {
        search = search || "";

        // support construct object with another URLSearchParams instance
        if (search instanceof URLSearchParams || search instanceof URLSearchParamsPolyfill) {
            search = search.toString();
        }
        this [__URLSearchParams__] = parseToDict(search);
    }


    /**
     * Appends a specified key/value pair as a new search parameter.
     *
     * @param {string} name
     * @param {string} value
     */
    prototype.append = function(name, value) {
        appendTo(this [__URLSearchParams__], name, value);
    };

    /**
     * Deletes the given search parameter, and its associated value,
     * from the list of all search parameters.
     *
     * @param {string} name
     */
    prototype['delete'] = function(name) {
        delete this [__URLSearchParams__] [name];
    };

    /**
     * Returns the first value associated to the given search parameter.
     *
     * @param {string} name
     * @returns {string|null}
     */
    prototype.get = function(name) {
        var dict = this [__URLSearchParams__];
        return this.has(name) ? dict[name][0] : null;
    };

    /**
     * Returns all the values association with a given search parameter.
     *
     * @param {string} name
     * @returns {Array}
     */
    prototype.getAll = function(name) {
        var dict = this [__URLSearchParams__];
        return this.has(name) ? dict [name].slice(0) : [];
    };

    /**
     * Returns a Boolean indicating if such a search parameter exists.
     *
     * @param {string} name
     * @returns {boolean}
     */
    prototype.has = function(name) {
        return hasOwnProperty(this [__URLSearchParams__], name);
    };

    /**
     * Sets the value associated to a given search parameter to
     * the given value. If there were several values, delete the
     * others.
     *
     * @param {string} name
     * @param {string} value
     */
    prototype.set = function set(name, value) {
        this [__URLSearchParams__][name] = ['' + value];
    };

    /**
     * Returns a string containg a query string suitable for use in a URL.
     *
     * @returns {string}
     */
    prototype.toString = function() {
        var dict = this[__URLSearchParams__], query = [], i, key, name, value;
        for (key in dict) {
            name = encode(key);
            for (i = 0, value = dict[key]; i < value.length; i++) {
                query.push(name + '=' + encode(value[i]));
            }
        }
        return query.join('&');
    };

    // There is a bug in Safari 10.1 and `Proxy`ing it is not enough.
    var forSureUsePolyfill = !decodesPlusesCorrectly;
    var useProxy = (!forSureUsePolyfill && nativeURLSearchParams && !isSupportObjectConstructor && self.Proxy);
    var propValue; 
    if (useProxy) {
        // Safari 10.0 doesn't support Proxy, so it won't extend URLSearchParams on safari 10.0
        propValue = new Proxy(nativeURLSearchParams, {
            construct: function (target, args) {
                return new target((new URLSearchParamsPolyfill(args[0]).toString()));
            }
        })
        // Chrome <=60 .toString() on a function proxy got error "Function.prototype.toString is not generic"
        propValue.toString = Function.prototype.toString.bind(URLSearchParamsPolyfill);
    } else {
        propValue = URLSearchParamsPolyfill;
    }
    /*
     * Apply polifill to global object and append other prototype into it
     */
    Object.defineProperty(self, 'URLSearchParams', {
        value: propValue
    });

    var USPProto = self.URLSearchParams.prototype;

    USPProto.polyfill = true;

    /**
     *
     * @param {function} callback
     * @param {object} thisArg
     */
    USPProto.forEach = USPProto.forEach || function(callback, thisArg) {
        var dict = parseToDict(this.toString());
        Object.getOwnPropertyNames(dict).forEach(function(name) {
            dict[name].forEach(function(value) {
                callback.call(thisArg, value, name, this);
            }, this);
        }, this);
    };

    /**
     * Sort all name-value pairs
     */
    USPProto.sort = USPProto.sort || function() {
        var dict = parseToDict(this.toString()), keys = [], k, i, j;
        for (k in dict) {
            keys.push(k);
        }
        keys.sort();

        for (i = 0; i < keys.length; i++) {
            this['delete'](keys[i]);
        }
        for (i = 0; i < keys.length; i++) {
            var key = keys[i], values = dict[key];
            for (j = 0; j < values.length; j++) {
                this.append(key, values[j]);
            }
        }
    };

    /**
     * Returns an iterator allowing to go through all keys of
     * the key/value pairs contained in this object.
     *
     * @returns {function}
     */
    USPProto.keys = USPProto.keys || function() {
        var items = [];
        this.forEach(function(item, name) {
            items.push(name);
        });
        return makeIterator(items);
    };

    /**
     * Returns an iterator allowing to go through all values of
     * the key/value pairs contained in this object.
     *
     * @returns {function}
     */
    USPProto.values = USPProto.values || function() {
        var items = [];
        this.forEach(function(item) {
            items.push(item);
        });
        return makeIterator(items);
    };

    /**
     * Returns an iterator allowing to go through all key/value
     * pairs contained in this object.
     *
     * @returns {function}
     */
    USPProto.entries = USPProto.entries || function() {
        var items = [];
        this.forEach(function(item, name) {
            items.push([name, item]);
        });
        return makeIterator(items);
    };


    if (iterable) {
        USPProto[self.Symbol.iterator] = USPProto[self.Symbol.iterator] || USPProto.entries;
    }


    function encode(str) {
        var replace = {
            '!': '%21',
            "'": '%27',
            '(': '%28',
            ')': '%29',
            '~': '%7E',
            '%20': '+',
            '%00': '\x00'
        };
        return encodeURIComponent(str).replace(/[!'\(\)~]|%20|%00/g, function(match) {
            return replace[match];
        });
    }

    function decode(str) {
        return str
            .replace(/[ +]/g, '%20')
            .replace(/(%[a-f0-9]{2})+/ig, function(match) {
                return decodeURIComponent(match);
            });
    }

    function makeIterator(arr) {
        var iterator = {
            next: function() {
                var value = arr.shift();
                return {done: value === undefined, value: value};
            }
        };

        if (iterable) {
            iterator[self.Symbol.iterator] = function() {
                return iterator;
            };
        }

        return iterator;
    }

    function parseToDict(search) {
        var dict = {};

        if (typeof search === "object") {
            // if `search` is an array, treat it as a sequence
            if (isArray(search)) {
                for (var i = 0; i < search.length; i++) {
                    var item = search[i];
                    if (isArray(item) && item.length === 2) {
                        appendTo(dict, item[0], item[1]);
                    } else {
                        throw new TypeError("Failed to construct 'URLSearchParams': Sequence initializer must only contain pair elements");
                    }
                }

            } else {
                for (var key in search) {
                    if (search.hasOwnProperty(key)) {
                        appendTo(dict, key, search[key]);
                    }
                }
            }

        } else {
            // remove first '?'
            if (search.indexOf("?") === 0) {
                search = search.slice(1);
            }

            var pairs = search.split("&");
            for (var j = 0; j < pairs.length; j++) {
                var value = pairs [j],
                    index = value.indexOf('=');

                if (-1 < index) {
                    appendTo(dict, decode(value.slice(0, index)), decode(value.slice(index + 1)));

                } else {
                    if (value) {
                        appendTo(dict, decode(value), '');
                    }
                }
            }
        }

        return dict;
    }

    function appendTo(dict, name, value) {
        var val = typeof value === 'string' ? value : (
            value !== null && value !== undefined && typeof value.toString === 'function' ? value.toString() : JSON.stringify(value)
        );

        // #47 Prevent using `hasOwnProperty` as a property name
        if (hasOwnProperty(dict, name)) {
            dict[name].push(val);
        } else {
            dict[name] = [val];
        }
    }

    function isArray(val) {
        return !!val && '[object Array]' === Object.prototype.toString.call(val);
    }

    function hasOwnProperty(obj, prop) {
        return Object.prototype.hasOwnProperty.call(obj, prop);
    }

})(typeof global !== 'undefined' ? global : (typeof window !== 'undefined' ? window : this));

}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{}],174:[function(require,module,exports){
/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */
var byteToHex = [];
for (var i = 0; i < 256; ++i) {
  byteToHex[i] = (i + 0x100).toString(16).substr(1);
}

function bytesToUuid(buf, offset) {
  var i = offset || 0;
  var bth = byteToHex;
  // join used to fix memory issue caused by concatenation: https://bugs.chromium.org/p/v8/issues/detail?id=3175#c4
  return ([
    bth[buf[i++]], bth[buf[i++]],
    bth[buf[i++]], bth[buf[i++]], '-',
    bth[buf[i++]], bth[buf[i++]], '-',
    bth[buf[i++]], bth[buf[i++]], '-',
    bth[buf[i++]], bth[buf[i++]], '-',
    bth[buf[i++]], bth[buf[i++]],
    bth[buf[i++]], bth[buf[i++]],
    bth[buf[i++]], bth[buf[i++]]
  ]).join('');
}

module.exports = bytesToUuid;

},{}],175:[function(require,module,exports){
// Unique ID creation requires a high quality random # generator.  In the
// browser this is a little complicated due to unknown quality of Math.random()
// and inconsistent support for the `crypto` API.  We do the best we can via
// feature-detection

// getRandomValues needs to be invoked in a context where "this" is a Crypto
// implementation. Also, find the complete implementation of crypto on IE11.
var getRandomValues = (typeof(crypto) != 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto)) ||
                      (typeof(msCrypto) != 'undefined' && typeof window.msCrypto.getRandomValues == 'function' && msCrypto.getRandomValues.bind(msCrypto));

if (getRandomValues) {
  // WHATWG crypto RNG - http://wiki.whatwg.org/wiki/Crypto
  var rnds8 = new Uint8Array(16); // eslint-disable-line no-undef

  module.exports = function whatwgRNG() {
    getRandomValues(rnds8);
    return rnds8;
  };
} else {
  // Math.random()-based (RNG)
  //
  // If all else fails, use Math.random().  It's fast, but is of unspecified
  // quality.
  var rnds = new Array(16);

  module.exports = function mathRNG() {
    for (var i = 0, r; i < 16; i++) {
      if ((i & 0x03) === 0) r = Math.random() * 0x100000000;
      rnds[i] = r >>> ((i & 0x03) << 3) & 0xff;
    }

    return rnds;
  };
}

},{}],176:[function(require,module,exports){
var rng = require('./lib/rng');
var bytesToUuid = require('./lib/bytesToUuid');

function v4(options, buf, offset) {
  var i = buf && offset || 0;

  if (typeof(options) == 'string') {
    buf = options === 'binary' ? new Array(16) : null;
    options = null;
  }
  options = options || {};

  var rnds = options.random || (options.rng || rng)();

  // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
  rnds[6] = (rnds[6] & 0x0f) | 0x40;
  rnds[8] = (rnds[8] & 0x3f) | 0x80;

  // Copy bytes to buffer, if provided
  if (buf) {
    for (var ii = 0; ii < 16; ++ii) {
      buf[i + ii] = rnds[ii];
    }
  }

  return buf || bytesToUuid(rnds);
}

module.exports = v4;

},{"./lib/bytesToUuid":174,"./lib/rng":175}],177:[function(require,module,exports){
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

'use strict';

/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var __DEV__ = "production" !== 'production';

var warning = function() {};

if (__DEV__) {
  var printWarning = function printWarning(format, args) {
    var len = arguments.length;
    args = new Array(len > 1 ? len - 1 : 0);
    for (var key = 1; key < len; key++) {
      args[key - 1] = arguments[key];
    }
    var argIndex = 0;
    var message = 'Warning: ' +
      format.replace(/%s/g, function() {
        return args[argIndex++];
      });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  }

  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
          '`warning(condition, format, ...args)` requires a warning ' +
          'message argument'
      );
    }
    if (!condition) {
      printWarning.apply(null, [format].concat(args));
    }
  };
}

module.exports = warning;

},{}],178:[function(require,module,exports){
const ClientHelper = require("../util/client_helper")
const KeyboardMap = require("../entities/keyboard_map")
const Cookies = require("js-cookie")
const Constants = require("./../../../common/constants.json")
const Helper = require("./../../../common/helper")
const Config = require("junon-common/config")

class BanManager {
  constructor(main) {
    this.main = main
    this.game = main.game

    this.initListeners()
  }

  initListeners() {
    document.querySelector(".global_ban_btn").addEventListener("click", this.onGlobalBanBtnClick.bind(this))
    document.querySelector("#ban_manager_container .cancel_btn").addEventListener("click", this.onCancelClick.bind(this))
  }

  async banWorld(host, sectorUid, creatorUid) {
    let url = Config[env].matchmakerUrl + "create_ban" 
    let idToken = await this.main.getFirebaseIdToken()

    const data = {
      idToken: idToken,
      host: host,
      sectorUid: sectorUid,
      creatorUid: creatorUid,
    }

    ClientHelper.httpPost(url, data, {
      success: (result) => {
        try {
          let data = JSON.parse(result)
          if (data.error) {
            alert("Ban world failed: " + data.error) 
            return
          }
          if (data.success) {
            alert("Ban successful") 
          }
        } catch(e) {
          alert("Ban world failed" ) 
        }
      },
      error: () => {
        alert("Ban world failed" ) 
      }
    })
  }

  async onGlobalBanBtnClick(e) {
    let username = document.querySelector(".ban_user_form .ban_username input").value
    let dayCount = document.querySelector(".ban_user_form .ban_duration input").value
    let reason   = document.querySelector(".ban_user_form .ban_reason input").value
    let idToken = await this.main.getFirebaseIdToken()

    let data = {
      idToken: idToken,
      username: username,
      dayCount: dayCount,
      reason: reason
    }

    let url = Config[env].matchmakerUrl + "create_ban" 

    ClientHelper.httpPost(url, data, {
      success: (result) => {
        try {
          let data = JSON.parse(result)
          if (data.error) {
            document.querySelector(".ban_status_message").innerText = data.error
            return
          }
          if (data.success) {
            document.querySelector(".ban_status_message").innerText = data.success
          }
        } catch(e) {
          document.querySelector(".ban_status_message").innerText = "Ban error"
        }
      },
      error: () => {
        document.querySelector(".ban_status_message").innerText = "Ban error"
      }
    })

  }

  async open(options = {}) {
    if (!this.main.isLoggedIn()) return

    this.show()

    let idToken = await this.main.getFirebaseIdToken()

    let url = Config[env].matchmakerUrl + "bans?idToken=" + idToken + "&uid=" + this.main.uid

    ClientHelper.httpRequest(url, {
      success: (data) => {
        try {
          let result = JSON.parse(data)
          this.renderBans(result)
        } catch(e) {
          alert("Error fetching bans")
        }
      },
      error: (data) => {
        alert("Error fetching bans")
      }
    })

  }

  renderBans(result) {
    if (result.error) {
      document.querySelector(".ban_status_message").innerText = "Unauthorized"
      return
    }

    document.querySelector(".ban_status_message").innerText = ""

    if (result.success) {
      let ipBanList = result.success
      let el = ""

      for (var i = 0; i < ipBanList.length; i++) {
        let ipBan = ipBanList[i]
        el += this.createIpBanEl(ipBan)
      }

      document.querySelector(".global_ban_list_body").innerHTML = el
    }
  }

  createIpBanEl(ipBan) {
    let date = new Date(ipBan.createdAt)
    let formattedDate = (date.getMonth() + 1) + "/" + date.getDate() + "/" + date.getFullYear()
    if (ipBan.createdAt === null) {
      formattedDate = ""
    }

    return "<div class='ip_ban_row' data-ip='" + ipBan.ip + "''>" + 
      "<div class='ip_ban_col ip_ban_username'>" + (ipBan.username || ipBan.ip) + "</div>" +
      "<div class='ip_ban_col ip_ban_daycount'>" + (ipBan.dayCount || "") + "</div>" +
      "<div class='ip_ban_col ip_ban_reason'>" + (ipBan.reason || "") + "</div>" +
      "<div class='ip_ban_col ip_ban_date'>" + formattedDate + "</div>" +
    "</div>"
  }

  show() {
    document.querySelector("#ban_manager_container").style.display = 'block'
  }

  hide() {
    document.querySelector("#ban_manager_container").style.display = 'none'
  }

  onCancelClick() {
    this.hide()
  }

}

module.exports = BanManager

},{"../entities/keyboard_map":444,"../util/client_helper":649,"./../../../common/constants.json":656,"./../../../common/helper":664,"js-cookie":58,"junon-common/config":59}],179:[function(require,module,exports){
const Cookies = require("js-cookie")
const SocketUtil = require("../util/socket_util")
const ClientHelper = require("../util/client_helper")

class GameConnection {

  constructor(url) {
    this.url = url

    this.reconnectAttemptCount = 0
    this.isFirstSocketSetup = true
    this.reconnectDelay = 5
  }

  init(options) {
    this.initWebsocket(options)
  }

  close() {
    this.isTerminated = true
    if (this.socket) {
      this.socket.close()
    }
    
  }

  setGame(game) {
    this.game = game
  }

  getSector() {
    return this.game.sector
  }

  initWebsocket(options) {
    this.websocketSetupTime = (new Date()).getTime()

    this.setupSocket(options)
  }

  setupSocket(callback) {
    this.socket = new WebSocket(this.url)
    this.socket.binaryType = "arraybuffer"

    this.socket.onopen = () => {
      if (this.isFirstSocketSetup) {
        this.isFirstSocketSetup = false
        let selfTime = (new Date()).getTime() - this.websocketSetupTime
        console.log("connected to: " + this.url + " took " + (selfTime / 1000).toFixed(1) + " seconds")
      }

      if (callback.success) callback.success(this.socket)
    }

    this.socket.onerror = () => {
      let wasNeverConnected = this.isFirstSocketSetup
      if (callback.error) callback.error(wasNeverConnected)
    }

    this.socket.onclose = this.onSocketDisconnect.bind(this)
  }

  onSocketDisconnect(event) {
    if (this.isFirstSocketSetup) return
    if (this.isTerminated) return

    this.game.stopAllBackgroundMusic()

    if (this.game.isAFK) {
      this.displayDisconnected()
      return
    }

    let serverIp = this.getServerIp()

    const inFiveMinutes = new Date(new Date().getTime() + 5 * 60 * 1000)
    Cookies.set("server_ip", serverIp, { expires: inFiveMinutes })

    const delay = (this.reconnectAttemptCount + 1) * this.reconnectDelay
    if (this.reconnectAttemptCount > 4) {
      this.displayDisconnected()
    } else if (this.game.isServerShutdownInProgress) {
      this.displayDisconnected()
    } else {
      this.attemptReconnect(delay)
    }
  }

  getServerIp() {
    return this.url.replace(/ws.*\//,"")
  }

  waitForSectorRestart() {
    let sectorsOnline = this.main.gameExplorer.sectorEntries
    if (sectorsOnline[this.game.sector.uid]) {
      clearInterval(this.sectorWaitInterval)
      this.displayServerUp()
    }  
  }

  displayServerUp() {
    const message    = document.querySelector(".disconnected_msg")
    message.style.display = 'block'
    message.innerText = "Server ready.. Please reload game"
  }

  getDots(reloadIncrement) {
    let progress = (reloadIncrement % 3) + 1

    let dots = ""
    for (var i = 0; i < progress; i++) {
      dots += "."
    }

    return dots
  }

  displayReload() {
    this.reloadIncrement = this.reloadIncrement || 0
    let dots = this.getDots(this.reloadIncrement)

    const message    = document.querySelector(".disconnected_msg")
    message.style.display = 'block'
    message.innerText = "Server restart in progress" + dots
    this.reloadIncrement += 1
  }

  displayDisconnected() {
    const message    = document.querySelector(".disconnected_msg")
    message.style.display = 'block'
    message.innerText = "Disconnected from server. Reload to reconnect"
  }

  displayRemoved() {
    const message    = document.querySelector(".disconnected_msg")
    message.style.display = 'block'
    message.innerText = "Removed from game as you have a new connection active"
  }

  isConnected() {
    if (!this.socket) return false
    return this.socket.readyState === WebSocket.OPEN        
  }

  attemptReconnect(delay) {
    const message    = document.querySelector(".disconnected_msg")
    message.style.display = 'block'

    let countdown = delay

    clearInterval(this.reconnectCountdownInterval)
    this.reconnectCountdownInterval = setInterval(() => {
      const countdownEl = document.querySelector(".reconnect_countdown")
      if (!countdownEl) {
        clearInterval(this.reconnectCountdownInterval)
        return
      }

      countdownEl.innerText = countdown
      countdown -= 1
      if (countdown <= 0) {
        clearInterval(this.reconnectCountdownInterval)
      }
    }, 1000)

    let reconnect = this.reconnectWebsocket.bind(this, { success: this.resumeGame.bind(this) })
    setTimeout(reconnect, delay * 1000)
  }

  resumeGame(sectorId, teamId) {
    this.reconnectAttemptCount = 0

    this.game.resumeGame()
  }

  onSessionResume() {
    console.log("session resumed..")
    document.querySelector(".disconnected_msg").style.display = 'none'
  }

  reconnectWebsocket(callback) {
    console.log("Reconnecting...")

    this.reconnectAttemptCount += 1
    this.setupSocket(callback)
    this.game.reinitConnection()
  }

}

module.exports = GameConnection
},{"../util/client_helper":649,"../util/socket_util":654,"js-cookie":58}],180:[function(require,module,exports){
const Config = require("junon-common/config")
const TeamEntry = require("./team_entry")
const SectorEntry = require("./sector_entry")
const ClientHelper = require("./../util/client_helper")
const ExceptionReporter = require("./../util/exception_reporter")
const Cookies = require("js-cookie")

class GameExplorer {

  constructor(main) {
    this.main = main

    this.el = document.querySelector(".browse_games_container")

    this.MATCHMAKER_WEBSOCKET_URL = this.getMatchmakerWebsocketUrl()
    this.isFirstSocketSetup = true
    this.reconnectDelay = 5
    this.reconnectAttemptCount = 0

    this.sectorEntries = {}
    this.teamEntries = { }
    this.topColonyEntries = {}
    this.searchColonyEntries = {}
    this.mineColonyEntries = {}
    this.favoriteColonyEntries = {}
    this.privateSectors = {}

    document.querySelector(".game_list_container").addEventListener("click", this.onGameListContainerClick.bind(this))
    document.querySelector("#join_game_btn").addEventListener("click", this.onGameInviteJoinGameClick.bind(this))
    document.querySelector("#region_select").addEventListener("change", this.onRegionChanged.bind(this), true)
    document.querySelector(".game_list_container").addEventListener("mouseover", this.onColonyListMouseover.bind(this), true)
    document.querySelector(".game_list_container").addEventListener("mouseleave", this.onColonyListMouseleave.bind(this), true)
    document.querySelector("#minigames_tab_content").addEventListener("click", this.onMiniGamesClick.bind(this), true)
    document.querySelector(".list_mode_btn").addEventListener("click", this.onListModeClick.bind(this), true)
    document.querySelector(".gallery_mode_btn").addEventListener("click", this.onGalleryModeClick.bind(this), true)
    document.querySelector(".main_game_mode_selector").addEventListener("mouseover", this.onGameModeSelectorMouseOver.bind(this), true)
    document.querySelector(".minigame_details_container").addEventListener("mousemove", this.onMiniGameDetailsMouseMove.bind(this), true)
    document.querySelector("#import_sector_menu .cancel_btn").addEventListener("click", this.onImportSectorCancelClick.bind(this), true)
    document.querySelector("#import_sector_menu .import_sector_btn").addEventListener("click", this.onImportSectorSubmitClick.bind(this), true)

    let colony_filter_tabs = document.querySelectorAll(".colony_filter_tab")
    for (var i = 0; i < colony_filter_tabs.length; i++) {
      let colony_filter_tab = colony_filter_tabs[i]
      colony_filter_tab.addEventListener("click", this.onColonyFilterTabClick.bind(this), true)
    }

    this.listTopColonies() 
  }

  setMiniGames(miniGames) {
    this.miniGames = miniGames
    this.renderMiniGames()
  }

  onListModeClick() {
    this.el.querySelector(".main_colony_list").classList.add("list_mode")
    this.el.querySelector(".search_colony_list").classList.add("list_mode")
    Cookies.set("list_mode", true)
  }

  onGameInviteJoinGameClick(e) {
    document.querySelector("#join_game_btn").innerText = "Loading.."
    setTimeout(() => {
      document.querySelector("#join_game_btn").innerText = "Join Game"
    }, 5000)
    this.onJoinGameBtnClick(e)
  }

  onGalleryModeClick() {
    this.el.querySelector(".main_colony_list").classList.remove("list_mode")
    this.el.querySelector(".search_colony_list").classList.remove("list_mode")
    Cookies.set("list_mode", false)
  }

  getMiniGame(miniGameId) {
    if (this.miniGames[miniGameId]) {
      return this.miniGames[miniGameId]
    }

    if (miniGameId === 'vbj91eofmFCiu' || miniGameId === 'YcdqgbswlAqRi') {
      return {
        "name": "Tower Defense",
        "playerCount": 0,
        "screenshot": "9f2495eb19ba4bc4868966567222b1e9",
        "creator": "Starmancer"
      }
    }
  }

  renderMiniGames() {
    let el = ""
    for (let id in this.miniGames) {
      let miniGame = this.miniGames[id]
      miniGame.playerCount
      let gameModeEntry = document.querySelector(".main_game_mode_entry[data-id='" + id + "']")
      if (gameModeEntry) {
        gameModeEntry.querySelector(".minigame_player_count").innerText = miniGame.playerCount + " players"
      }
    }
  }

  createMiniGameEntry(id, miniGame) {
    let screenshotPath = this.main.getScreenshotThumbnailPath(miniGame.screenshot)
    return "<div class='minigame_entry' data-id='" + id + "'>" + 
      "<img class='minigame_thumbnail' src='" + screenshotPath + "' />" +
      "<div class='minigame_name'>" + miniGame.name +  "</div>" +
      "<div class='minigame_creator'>" + miniGame.creator +  "</div>" +
      "<div class='minigame_player_count'>" + miniGame.playerCount + " " + i18n.t('players') + "</div>" +
    "</div>"
  }

  onMiniGamesClick(e) {
    let miniGameEntry = e.target.closest(".minigame_entry")
    if (!miniGameEntry) return

    this.joinMiniGame(miniGameEntry.dataset.id)
  }

  joinMiniGame(miniGameId, options = {}) {
    if (this.main.isJoinInProgress) return
    this.main.lockJoin()

    document.querySelector(".loading_modal").style.display = 'block'

    this.main.joinMiniGame(miniGameId, options)
  }

  getOnlineTeamCount() {
    return Object.keys(this.teamEntries).length
  }

  onMenuInteract(cmd) {
    switch(cmd) {
      case "ShiftTab":
        this.onShiftTab()
        break
      case "Tab":
        this.onTab()
        break
    }
  }

  onShiftTab() {
    this.onTabDirection(-1)
  }

  onTab() {
    this.onTabDirection(1)
  }

  onTabDirection(direction) {
    let tabs = Array.from(this.el.querySelectorAll(".colony_filter_tab"))
    if (tabs.length <= 1) return

    let tabIndex = Array.prototype.indexOf.call(tabs, this.lastActiveTab)
    
    if (direction > 0) {
      // next
      let isLastTab = tabIndex === tabs.length - 1
      if (isLastTab) {
        this.selectColonyFilterTab(tabs[0])
      } else {
        this.selectColonyFilterTab(tabs[tabIndex + 1])
      }
    } else {
      // prev
      let isFirstTab = tabIndex === 0
      if (isFirstTab) {
        this.selectColonyFilterTab(tabs[tabs.length - 1])
      } else {
        this.selectColonyFilterTab(tabs[tabIndex - 1])
      }
    }
  }

  selectVisitColonyFilter() {
    if (this.main.inviteToken) {
      this.selectColonyFilterTabByName("online")
      return
    }
    
    if (this.getOnlineTeamCount() === 0) {
      this.selectColonyFilterTabByName("mine")
    } else {
      this.selectColonyFilterTabByName("online")
    }
  }

  onSectorListFetchedFromMatchmaker() {
    this.hasFetchedSectorsFromMatchmaker = true
    this.renderTopColonies()
  }

  onColonyFilterTabClick(e) {
    this.selectColonyFilterTab(e.target)
  }

  selectColonyFilterTab(tab) {
    let selectedColonyFilterTab = document.querySelector(".colony_filter_tab.selected")
    if (selectedColonyFilterTab) {
      selectedColonyFilterTab.classList.remove("selected")
    }

    selectedColonyFilterTab = tab
    selectedColonyFilterTab.classList.add("selected")

    // document.querySelector(".new_colony_launch_btn").style.display = 'none'
    document.querySelector("#minigames_tab_content").style.display = 'none'
    document.querySelector("#region_tab_content").style.display = 'inline-block'

    if (selectedColonyFilterTab.classList.contains("online_colonies_tab")) {
      this.filterColonyList("online")
    } else if (selectedColonyFilterTab.classList.contains("new_colonies_tab")) {
      this.filterColonyList("new")
    } else if (selectedColonyFilterTab.classList.contains("top_colonies_tab")) {
      this.filterColonyList("top")
    } else if (selectedColonyFilterTab.classList.contains("mine_colonies_tab")) {
      this.filterColonyList("mine")
      // document.querySelector(".new_colony_launch_btn").style.display = 'inline-block'
    } else if (selectedColonyFilterTab.classList.contains("favorite_colonies_tab")) {
      this.filterColonyList("favorite")
    } else if (selectedColonyFilterTab.classList.contains("minigames_tab")) {
      document.querySelector("#minigames_tab_content").style.display = 'block'
      document.querySelector("#region_tab_content").style.display = 'none'
    }

    this.lastActiveTab = selectedColonyFilterTab
  }

  filterColonyList(filterType) {
    if (filterType === "mine") {
      document.querySelector(".search_colony_list").style.display = 'none'
      document.querySelector(".main_colony_list").style.display = 'block'
    } else {
      if (this.hasSearchResults() && !this.el.classList.contains("in_game_middle_menu")) {
        document.querySelector(".search_colony_list").style.display = 'block'
        document.querySelector(".main_colony_list").style.display = 'none'
      } else {
        document.querySelector(".search_colony_list").style.display = 'none'
        document.querySelector(".main_colony_list").style.display = 'block'
      }
    }

    this.el.querySelector(".main_colony_list").dataset.filter = filterType
  }

  hasSearchResults() {
    return document.querySelector(".search_world_input").value !== ""
  }

  sortNewColonies(colonies) {
    let newColonies = Object.values(colonies).filter((colonyData) => {
      return colonyData.week
    }).map((colonyData) => {
      let data = Object.assign({}, colonyData)
      data.sectorId = data.uid
      delete data['top']
      return data
    })

    return newColonies.sort((sectorData, otherSectorData) => {
      // give priority to weekly ranked sector
      let otherDaysAlive = otherSectorData.daysAlive || 0
      let daysAlive = sectorData.daysAlive || 0
      return otherDaysAlive - daysAlive
    })
  }

  sortTopColonies(colonies) {
    let topColonies = Object.values(colonies).filter((colonyData) => {
      return colonyData.top
    }).map((colonyData) => {
      let data = Object.assign({}, colonyData)
      data.sectorId = data.uid
      delete data['new']
      return data
    })

    return topColonies.sort((sectorData, otherSectorData) => {
      // give priority to weekly ranked sector
      let otherFavoriteCount = otherSectorData.favoriteCount || 0
      let favoriteCount = sectorData.favoriteCount || 0
      return otherFavoriteCount - favoriteCount
    })
  }

  parseAndSortTopColonies(topColonies) {
    // stored sectorId in dictionary value for later use in TeamEntry
    let validColonies = {}

    for (let sectorId in topColonies) {
      if (topColonies[sectorId].daysAlive) {
        validColonies[sectorId] = topColonies[sectorId]
        validColonies[sectorId].sectorId = sectorId
      }
    }

    let result = Object.values(validColonies)
    result.sort((sectorData, otherSectorData) => {
      // give priority to weekly ranked sector
      let otherDaysAlive = otherSectorData.daysAlive || 0
      let daysAlive = sectorData.daysAlive || 0
      return otherDaysAlive - daysAlive
    })

    return result
  }

  renderTopColonies() {
    if (this.topColonies && this.hasFetchedSectorsFromMatchmaker && !this.hasRenderedTopColonies) {

      let sorted = this.sortNewColonies(this.topColonies)

      sorted.forEach((colonyData) => {
        this.renderTopColony(colonyData)
      })

      sorted = this.sortTopColonies(this.topColonies)
      sorted.forEach((colonyData) => {
        this.renderTopColony(colonyData)
      })

      this.hasRenderedTopColonies = true
    }
  }

  addMyColonies(saveEntries) {
    saveEntries.forEach((entry) => {
      let colonyData = entry
      colonyData.mine = true
      colonyData.sectorId = colonyData.uid


      if (!this.hasMineColonyEntry(colonyData.sectorId)) {
        let isTopColony = true
        let teamEntry = new TeamEntry(this, colonyData, isTopColony)
        this.mineColonyEntries[colonyData.sectorId] = teamEntry

        this.el.querySelector(".main_colony_list").appendChild(teamEntry.el)
      }
    })
  }

  addFavoriteColonies(entries) {
    entries.forEach((entry) => {
      let colonyData = entry
      colonyData.favorite = true
      colonyData.sectorId = colonyData.uid

      if (!this.hasFavoriteColonyEntry(colonyData.sectorId)) {
        let isTopColony = true
        let teamEntry = new TeamEntry(this, colonyData, isTopColony)
        this.favoriteColonyEntries[colonyData.sectorId] = teamEntry

        this.el.querySelector(".main_colony_list").appendChild(teamEntry.el)
      }
    })
  }

  removeFavoriteColonies(entries) {
    entries.forEach((entry) => {
      let colonyData = entry
      colonyData.sectorId = colonyData.uid

      let teamEntry = this.favoriteColonyEntries[colonyData.sectorId]
      if (teamEntry) {
        teamEntry.remove()
        delete this.favoriteColonyEntries[colonyData.sectorId]
      }

    })
  }

  hasMineColonyEntry(sectorId) {
    return this.mineColonyEntries[sectorId]
  }

  hasFavoriteColonyEntry(sectorId) {
    return this.favoriteColonyEntries[sectorId]
  }

  listTopColonies() {
    let matchmakerUrl = Config[env].matchmakerUrl
    ClientHelper.httpRequest(matchmakerUrl + "top_colonies", {
      success: (result) => {
        try {
          this.topColonies = JSON.parse(result)
        } catch (e) {
          ExceptionReporter.captureException(e)
          this.topColonies = {}
        }
        this.renderTopColonies()
      },
      error: () => {
      }
    })

  }

  open() {
    if (this.main.game.shouldDenyMenuOpen) return

    this.closeAllMenus()
    this.show()

    if (this.isInGame()) {
      document.querySelector("#game_list_action_container").style.display = 'none'
    } else {
      document.querySelector("#game_list_action_container").style.display = 'block'
    }

    let isNotOpen = this.main.game.openMenus.indexOf(this) === -1
    if (isNotOpen) {
      this.main.game.openMenus.push(this)
    }
  }

  isModal() {
    return true
  }

  closeAllMenus() {
    this.main.game.closeAllMenus()
  }

  show() {
    this.selectVisitColonyFilter()
  }

  isInGame() {
    if (!this.main.game) return false
    return this.main.game.player
  }
  
  isClose() {
    return this.el.style.display === 'none'
  }

  attachToBody() {
    this.isAttachedToBody = true
    document.querySelector(".wrapper").appendChild(this.el)
    this.el.classList.add("in_game_middle_menu")
  }

  attachToMiddleContainer() {
    this.isAttachedToBody = false
    document.querySelector(".middle_container").appendChild(this.el)
    this.el.classList.remove("in_game_middle_menu")
  }

  toggle() {
    if (!this.isInGame()) return

    if (this.isAttachedToBody) {
      this.attachToMiddleContainer()
    } else {
      this.attachToBody()
    }
  }

  close() {

  }

  hide() {
  }

  renderTopColony(colonyData) {
    let isTopColony = true


    let teamEntry = new TeamEntry(this, colonyData, isTopColony)
    this.topColonyEntries[colonyData.sectorId] = teamEntry

    this.el.querySelector(".main_colony_list").appendChild(teamEntry.el)
  }

  resetSearch() {
    this.searchColonyEntries = {}
    this.el.querySelector(".search_colony_list").innerHTML = ""
  }

  renderSearchColony(colonyData) {
    let isTopColony = true
    let teamEntry = new TeamEntry(this, colonyData, isTopColony)
    this.searchColonyEntries[colonyData.sectorId] = teamEntry
    this.el.querySelector(".search_colony_list").appendChild(teamEntry.el)
  }

  findTeamEntry(sectorId) {
    return this.teamEntries[sectorId]
  }

  onColonyListMouseover(e) {
    if (!this.el.querySelector(".main_colony_list").classList.contains("list_mode")) {
      return
    }

    const screenshotEl = e.target.closest('.screenshot')
    const teamEntryRow = e.target.closest('.team_entry_row')
    if (screenshotEl && teamEntryRow) {
      let teamEntry = this.getEntry(teamEntryRow.dataset.key)
      let screenshot = teamEntry && teamEntry.getScreenshot()

      if (screenshot) {
        this.showPopupTimeout = setTimeout(() => {
          this.renderScreenshotsPopup(screenshot, teamEntryRow)
          this.showPopupTimeout = null
        }, 500)
      } else {
        this.hideScreenshotsPopup()
      }
    }
  }

  onGameModeSelectorMouseOver() {
    this.hideScreenshotsPopup()
  }

  onMiniGameDetailsMouseMove() {
    this.hideScreenshotsPopup()
  }

  onColonyListMouseleave(e) {
    const newElement = e.toElement || e.relatedTarget
    const teamEntryRow = newElement && newElement.closest('.team_entry_row')
    if (teamEntryRow) {
      // still referencing team entry. 
      return
    }

    this.hideScreenshotsPopup()
  }

  hideScreenshotsPopup() {
    if (this.showPopupTimeout) {
      clearTimeout(this.showPopupTimeout)
    }

    document.querySelector(".colony_preview_popup").style.display = 'none'
  }

  renderScreenshotsPopup(screenshot, teamEntryRow) {
    if (!screenshot) return
    if (this.isClose()) return

    let screenshotPopup = document.querySelector(".colony_preview_popup")
    screenshotPopup.style.display = 'block'
    screenshotPopup.innerHTML = ""

    let thumbnailPath = this.main.getScreenshotThumbnailPath(screenshot)
    let el = "<img src='" + thumbnailPath + "' />"
    screenshotPopup.innerHTML += el

    this.repositionScreenshotPopup(teamEntryRow)
  }

  repositionScreenshotPopup(teamEntryRow) {
    let boundingRect = teamEntryRow.getBoundingClientRect()
    let screenshotPopup = document.querySelector(".colony_preview_popup")

    const bottomMargin = 10
    const margin = 50
    let left = boundingRect.x - screenshotPopup.offsetWidth  / 2 + teamEntryRow.offsetWidth / 2
    let top  = teamEntryRow.offsetTop - margin

    left = Math.max(margin, left) // cant be lower than margin
    left = Math.min(window.innerWidth - screenshotPopup.offsetWidth - margin, left) // cant be more than than margin

    // if (top < margin) {
    //   // show at bottom instead
    //   top = boundingRect.bottom + (bottomMargin * 2)
    // }
    // top = Math.max(margin, top) // cant be lower than margin
    // top = Math.min(window.innerHeight - screenshotPopup.offsetHeight - margin, top) // cant be more than than margin

    screenshotPopup.style.left = left + "px"
    screenshotPopup.style.top  = top  + "px"
  }

  getEntry(teamKey) {
    let topColonyEntry = this.topColonyEntries[teamKey]
    if (topColonyEntry) return topColonyEntry

    let searchColonyEntry = this.searchColonyEntries[teamKey]
    if (searchColonyEntry) return searchColonyEntry

    let mineColonyEntry = this.mineColonyEntries[teamKey]
    if (mineColonyEntry) return mineColonyEntry

    let favoriteColonyEntry = this.favoriteColonyEntries[teamKey]
    if (favoriteColonyEntry) return favoriteColonyEntry

    let colonyEntry = this.teamEntries[teamKey]
    if (colonyEntry) return colonyEntry
  }

  onGameListContainerClick(event) {
    const sectorEntryRow = event.target.closest('.sector_entry_row')
    if (sectorEntryRow) {
      this.hideScreenshotsPopup()

      const prevSelectedRow = sectorEntryRow.closest('.sector_list').querySelector('.selected')
      if (prevSelectedRow) {
        prevSelectedRow.classList.remove("selected")
      }
      sectorEntryRow.classList.add("selected")
      let sectorId = sectorEntryRow.dataset.id
      let sectorEntry = this.sectorEntries[sectorId]
      this.selectGameEntry(sectorEntry)
      this.onJoinGameBtnClick()
      return
    }

    const teamEntryRow = event.target.closest('.team_entry_row')
    if (teamEntryRow) {
      this.hideScreenshotsPopup()

      if (event.target.closest(".team_delete_btn")) {
        this.confirmSaveDelete(teamEntryRow)
        return  
      }

      if (event.target.closest(".ban_world_btn")) {
        let teamEntry = this.teamEntries[teamEntryRow.dataset.key]
        this.banWorld(teamEntry.data.host, teamEntry.data.sectorId, teamEntry.data.creatorUid)
        return  
      }

      if (event.target.closest(".export_world_btn")) {
        this.exportWorld(teamEntryRow)
        return  
      }

      if (event.target.closest(".import_world_btn")) {
        this.importWorld(teamEntryRow)
        return  
      }

      if (this.isInGame() && 
          this.main.game.isAnonymousGame() &&
          this.main.game.isCreatedByPlayer()) {
        this.main.game.confirmMenu.open({
          message: i18n.t('ColonyLeaveConfirmMessage'),
          proceedCallback: this.visitTeamEntry.bind(this, teamEntryRow)
        })
      } else {
        this.visitTeamEntry(teamEntryRow)
      }
    }
  }

  async banWorld(host, sectorUid, creatorUid) {
    this.main.banManager.banWorld(host, sectorUid, creatorUid)
  }

  async exportWorld(teamEntryRow) {
    let idToken = await this.main.getFirebaseIdToken()
    if (!idToken) return

    let matchmakerUrl = Config[env].matchmakerUrl

    let teamKey = teamEntryRow.dataset.key
    let teamEntry = this.mineColonyEntries[teamKey]

    let path = `export_sector?idToken=${idToken}` + 
               `&sectorUid=${teamEntry.getSectorId()}` + 
               `&uid=${this.main.uid}`

    document.location.href = matchmakerUrl + path
  }

  importWorld(teamEntryRow) {
    document.querySelector("#import_sector_menu input[type='file']").value = null
    document.querySelector("#import_sector_menu").style.display = 'block'
    document.querySelector("#import_sector_menu").style.top = window.scrollY + window.innerHeight/4 + "px"

    document.querySelector(".import_sector_btn").classList.remove("disabled")
    document.querySelector(".import_sector_btn").innerText = "Upload"

    let teamKey = teamEntryRow.dataset.key
    let teamEntry = this.mineColonyEntries[teamKey]

    this.importSectorUid = teamKey

    document.querySelector("#import_sector_menu .sector_name").innerText = teamEntry.name
    document.querySelector("#import_sector_menu .sector_thumbnail").src = teamEntry.getThumbnailPath()
  }

  onImportSectorCancelClick() {
    document.querySelector("#import_sector_menu").style.display = 'none'
  }

  // https://developer.mozilla.org/en-US/docs/Web/API/File/Using_files_from_web_applications#handling_the_upload_process_for_a_file
  async onImportSectorSubmitClick() {

    if (document.querySelector(".import_sector_btn").classList.contains("disabled")) {
      return
    }

    document.querySelector(".import_sector_btn").classList.remove("disabled")

    let idToken = await this.main.getFirebaseIdToken()
    if (!idToken) return

    if (!this.importSectorUid) return

    let file = document.querySelector("#import_sector_menu input[type='file']")
                       .files[0]

    if (!file) {
      alert("Save File required")
      return 
    }

    let matchmakerUrl = Config[env].matchmakerUrl
    let url = matchmakerUrl + "import_sector"

    fetch(url, {
      method : 'POST',
      headers: { 
        "Content-Type": "multipart/form-data;",
        'Token': idToken,
        'Sector': this.importSectorUid,
        'Uid': this.main.uid
      },
      body: file
    }).then((response) => {
      return response.json().then((data) => {
        if (data.error) {
          alert(data.error);
        } else {
          console.log(data);
          // success
          document.querySelector(".import_sector_btn").innerText = "Success"
          document.querySelector(".import_sector_btn").classList.add("disabled")
        }
      });
    }).catch(() => {
      alert("Upload server error ");
    })

//     const xhr = new XMLHttpRequest();
//     xhr.upload.addEventListener("progress", function(e) {
//       if (e.lengthComputable) {
//         const percentage = Math.round((e.loaded * 100) / e.total);
//         console.log("upload percent :" + percentage);
//       }
//     }, false);
// 
// 
//     xhr.upload.addEventListener("load", function(e){
//       debugger
//       console.log("upload complete..")
//     }, false);
// 
//     xhr.open("POST", url, true)
//     xhr.setRequestHeader('Token', idToken);
//     xhr.setRequestHeader('Sector', this.importSectorUid);
//     xhr.setRequestHeader('Content-Type', 'multipart/form-data');
// 
//     xhr.send(file)
  }

  confirmSaveDelete(teamEntryRow) {
    let yes = confirm("Are you sure you want to delete this save file?")
    if (yes) {
      let teamKey = teamEntryRow.dataset.key
      let teamEntry = this.mineColonyEntries[teamKey]
      this.deleteSaveEntry(teamEntry)
    }
  }

  async deleteSaveEntry(teamEntry) {
    if (!teamEntry) return

    let idToken = await this.main.getFirebaseIdToken()
    if (!idToken) return

    let matchmakerUrl = Config[env].matchmakerUrl
    let data = {
      idToken: idToken,
      region: this.main.region,
      sectorId: teamEntry.getSectorId(),
      uid: this.main.uid
    }

    ClientHelper.httpPost(matchmakerUrl + "delete_save", data, {
      success: (result) => {
        try {
          let data = JSON.parse(result)
          if (data.error) {
            this.main.onPlayerCantJoin({ message: data.error })
          } else {
            // success
            this.removeSaveTeamEntry(teamEntry.getSectorId())
          }
        } catch(e) {
          this.main.onPlayerCantJoin({ message: i18n.t("Unable to delete save") })
        }
      },
      error: () => {
        this.main.onPlayerCantJoin({ message: i18n.t("Unable to delete save") })
      }
    })

  }

  removeSaveTeamEntry(sectorUid) {
    let teamEntry = this.mineColonyEntries[sectorUid]
    if (teamEntry) {
      teamEntry.remove()
      delete this.mineColonyEntries[sectorUid]
    }
  }


  visitTeamEntry(teamEntryRow) {
    const prevSelectedRow = teamEntryRow.closest('.colony_list').querySelector('.selected')
    if (prevSelectedRow) {
      prevSelectedRow.classList.remove("selected")
    }
    teamEntryRow.classList.add("selected")
    let teamKey = teamEntryRow.dataset.key

    let mineColonyEntry = this.mineColonyEntries[teamKey]
    if (mineColonyEntry) {
      this.selectGameEntry(mineColonyEntry)

      if (this.selectedEntry.isOffline() && !this.isInGame()) {
        this.showLoadGameSettings()
      } else {
        this.onJoinGameBtnClick()
      }
      return  
    }

    let favoriteColonyEntry = this.favoriteColonyEntries[teamKey]
    if (favoriteColonyEntry) {
      this.selectGameEntry(favoriteColonyEntry)
      this.onJoinGameBtnClick()
      return  
    }

    // find from topColonyEntries
    let topColonyEntry = this.topColonyEntries[teamKey]
    if (topColonyEntry) {
      this.selectGameEntry(topColonyEntry)
      this.onJoinGameBtnClick()
      return  
    }

    let searchColonyEntry = this.searchColonyEntries[teamKey]
    if (searchColonyEntry) {
      this.selectGameEntry(searchColonyEntry)
      this.onJoinGameBtnClick()
      return  
    }

    // find from teamEntries
    let teamEntry = this.teamEntries[teamKey]
    this.selectGameEntry(teamEntry)
    this.onJoinGameBtnClick()
    return
  }

  selectGameEntry(sectorEntry) {
    this.selectedEntry = sectorEntry
    document.querySelector("#join_game_btn").dataset.disabled = ''
  }

  isAlreadyInsideSector(sectorId) {
    return this.main.game.isActive && 
           this.main.game.sector && 
           this.main.game.sector.uid === sectorId 
  }

  onJoinGameBtnClick(event) {
    if (this.main.isJoinInProgress) return
    this.main.lockJoin()

    if (this.selectedEntry) {
      if (this.isAlreadyInsideSector(this.selectedEntry.getSectorId())) {
        return
      }

      let isOwnedByMe = this.main.user && this.main.user.uid === this.selectedEntry.data.creatorUid 
      if (!isOwnedByMe && this.selectedEntry.isPrivate) {
        let isDirectLinkMatch = this.main.getUrlParam().get("e") === this.selectedEntry.getSectorId()
        if (!isDirectLinkMatch) {
          this.main.onPlayerCantJoin({ message: "Colony is Private" })
          return
        }
      }


      if (this.selectedEntry.isOffline()) {
        // boot sector
        this.selectedEntry.startBoot()
      } else {
        this.selectedEntry.join()
      }
    } else {
      this.joinRandomSectorEntry()
    }
  }

  showLoadGameSettings() {
    this.main.showLoadGameSettings(this.selectedEntry)
    this.hide()
  }

  continueAction() {
    this.onJoinGameBtnClick()
  }



  visitSector(data) {
    let isTopColony = true
    let teamEntry = new TeamEntry(this, data, isTopColony)
    this.selectedEntry = teamEntry

    if (this.isInGame() && 
        this.main.game.isAnonymousGame() &&
        this.main.game.isCreatedByPlayer()) {
      this.main.game.confirmMenu.open({
        message: i18n.t('ColonyLeaveConfirmMessage'),
        proceedCallback: this.onJoinGameBtnClick.bind(this)
      })
    } else {
      this.onJoinGameBtnClick()
    }

  }

  isSectorOnline(sectorUid) {
    let sectorEntry = this.getSectorEntry(sectorUid)
    return !!sectorEntry
  }

  getSectorEntry(sectorUid) {
    return this.sectorEntries[sectorUid]
  }

  onSectorEntryAdded(sectorEntry) {
  }

  selectColonyFilterTabByName(filterType) {
    let tab = document.querySelector(`.colony_filter_tab.${filterType}_colonies_tab`)
    this.selectColonyFilterTab(tab)
  }

  joinRandomSectorEntry() {
    let sectorList = Object.values(this.sectorEntries)
    let joinableSectorList = sectorList.filter((sectorEntry) => {
      return sectorEntry.getPlayerCount() < 20
    })

    let currentVersionSectorList = joinableSectorList.filter((sectorEntry) => {
      return sectorEntry.getVersion() === this.main.getVersion()
    })

    let oldVersionSectorList = joinableSectorList.filter((sectorEntry) => {
      return sectorEntry.getVersion() !== this.main.getVersion()
    })

    let randomIndex
    let randomSectorEntry

    if (currentVersionSectorList.length > 0) {
      randomIndex = Math.floor(Math.random() * currentVersionSectorList.length)
      randomSectorEntry = currentVersionSectorList[randomIndex]
    }

    if (!randomSectorEntry && oldVersionSectorList.length > 0) {
      randomIndex = Math.floor(Math.random() * oldVersionSectorList.length)
      randomSectorEntry = oldVersionSectorList[randomIndex]
    }

    if (!randomSectorEntry) {
      this.main.onPlayerCantJoin({ message: "Unable to join any servers" })
      return
    }

    randomSectorEntry.join()
  }

  isSectorsTabSelected() {
    return document.querySelector(".sectors_tab").classList.contains("selected")
  }

  getRegion() {
    return this.main.region
  }

  onRegionChanged(event) {
    let region = event.target.value
    let oldRegion = this.getRegion()
    this.main.setRegion(region)
  }

  getMatchmakerWebsocketUrl() {
    return Config[env].matchmakerWebsocketUrl
  }

  requestGame(ip, options = {}) {
    this.main.requestGame(this.main.getServerWebsocketUrl(ip), options)
  }

  onInventoryChanged() {

  }

  init(cb) {
    this.websocketSetupTime = (new Date()).getTime()

    this.setupMatchmakerSocket({
      success: this.onMatchmakerConnectSuccess.bind(this, cb)
    })
  }

  setupMatchmakerSocket(callback) {
    this.socket = new WebSocket(this.MATCHMAKER_WEBSOCKET_URL)

    this.socket.onopen = () => {
      if (this.isFirstSocketSetup) {
        this.isFirstSocketSetup = false
        let selfTime = (new Date()).getTime() - this.websocketSetupTime
        let time = (new Date()).getTime() - window.initializeTime

        console.log("connected to: " + this.MATCHMAKER_WEBSOCKET_URL)
        console.log("matchmaker websocket established - " + [(selfTime / 1000).toFixed(1), (time / 1000).toFixed(1)].join("/") + " seconds")
      }

      if (callback.success) callback.success()
    }

    this.socket.onmessage = this.onMatchmakerMessage.bind(this)

    this.socket.onerror = () => {
      if (callback.error) callback.error()
    }

    this.socket.onclose = this.onSocketDisconnect.bind(this)
  }

  closeConnection() {
    this.isForceClosed = true

    if (this.socket.readyState === WebSocket.OPEN) {
      this.socket.close()
    }
  }

  onSocketDisconnect(event) {
    if (this.isForceClosed) return

    const delay = (this.reconnectAttemptCount + 1) * this.reconnectDelay
    if (this.reconnectAttemptCount > 4) {

    } else {
      this.attemptReconnect(delay)
    }
  }

  attemptReconnect(delay) {
    let reconnect = this.reconnectWebsocket.bind(this, { success: this.onMatchmakerConnectSuccess.bind(this) })
    setTimeout(reconnect, delay * 1000)
  }

  onMatchmakerConnectSuccess(cb) {
    this.requestRegionGames()
    this.keepAlivePingInterval()
    this.main.onMatchmakerConnectSuccess()
    if (cb) cb()
  }

  keepAlivePingInterval() {
    clearInterval(this.keepAlivePingInterval)

    let twoMinutes = 1000 * 60 * 2
    setInterval(() => {
      this.sendToMatchmaker({ event: "1" })
    }, twoMinutes)
  }

  requestRegionGames() {
    let envToSend = window.test_vm ? 'vm' : env

    let data = { env: envToSend }

    this.sendToMatchmaker({ event: "MatchFilter", data: data })
    this.sendToMatchmaker({ event: "RequestSectorList" })
  }

  sendToMatchmaker(json) {
    let data = JSON.stringify(json)

    if (this.socket.readyState !== WebSocket.OPEN) return
      
    this.socket.send(data)
  }

  reconnectWebsocket(callback) {
    if (debugMode) {
      console.log("Reconnecting matchmaker socket...")
    }

    this.reconnectAttemptCount += 1
    this.setupMatchmakerSocket(callback)
  }

  onMatchmakerMessage(event) {
    let message = JSON.parse(event.data)

    switch(message.event) {
      // ping back from matchamerk
      case "1":
        this.onPong(message.data)
        break
      case "JoinMiniGameStatus":
        this.onJoinMiniGameStatus(message.data)
        break
      case "PlayerBootSectorStatus":
        this.onPlayerBootSectorStatus(message.data)
        break
      case "PlayerCreateSectorStatus":
        this.onPlayerCreateSectorStatus(message.data)
        break
      case "SectorList":
        this.renderSectorList(message.data)
        break
      case "RemoveSector":
        this.removeSectorFromMatchmaker(message.data)
        break
      case "ServerChat":
        this.onServerChat(message.data)
        break
      case "ChatHistory":
        this.onChatHistory(message.data)
        break
      case "Team":
        break
      case "SectorUpdated":
        this.renderTeam(message.data)
        break
      case "SectorInfo":
        this.onSectorInfo(message.data)
        break
      case "PlayerOnline":
        this.onPlayerOnline(message.data)
        break
      case "PlayerOffline":
        this.onPlayerOffline(message.data)
        break
      case "FriendRequest":
        this.onFriendRequest(message.data)
        break
      case "FriendAccepted":
        this.onFriendAccepted(message.data)
        break
      case "OnlineList":
        this.onOnlineList(message.data)
        break
    }
  }

  onPong(data) {
  }

  fetchSectorData(sectorId, cb){
    this.sendToMatchmaker({ event: "GetSector", data: { sectorId: sectorId } })
    this.onSectorFetched = cb
  }

  onSectorInfo(data) {
    this.onSectorFetched(data.sector)
  }

  onPlayerOnline(data) {
    this.main.onPlayerOnline(data)
  }

  onPlayerOffline(data) {
    this.main.onPlayerOffline(data)
  }

  onFriendRequest(data) {
    this.main.onFriendRequestReceived(data)
  }

  onFriendAccepted(data) {
    this.main.onFriendAccepted(data)
  }

  onOnlineList(data) {
    this.main.onOnlineList(data)
  }

  onServerChat(data) {
    if (!this.main.game) return
    if (!this.main.game.chatMenu) return

    this.main.game.chatMenu.onGlobalServerChat(data)
  }

  onChatHistory(data) {
    if (!this.main.game) return

    this.main.game.chatMenu.onChatHistory(data)
  }

  onJoinMiniGameStatus(data) {
    if (data.error) {
      document.querySelector(".loading_modal").style.display = 'none'
      this.main.onPlayerCantJoin({ message: data.error })
      this.main.enableJoin()
    } else {
      this.requestGame(data.host, { sectorId: data.sectorId })
    }
  }

  onPlayerBootSectorStatus(data) {
    if (!this.selectedEntry) return
    if (data.profile) console.log(data.profile)

    if (data.error) {
      this.main.onPlayerCantJoin({ message: data.error })
      this.selectedEntry.cancelBoot()
    } else {
      if (data.sector) {
        this.renderSector(data.sector)        
      }

      if (data.isGameReady) {
        this.selectedEntry.finishBoot()
      }
    }
  }

  onPlayerCreateSectorStatus(data) {
    this.main.onPlayerCreateSectorStatus(data)
  }

  renderSectorList(data) {
    this.main.onSectorListPopulated()
    this.main.pvpExplorer.renderSectorList(data)

    let sectors = data.sectors

    for (let id in this.sectorEntries) {
      let currentSectorEntry = this.sectorEntries[id]
      let isSectorNoLongerPresent = !sectors[id]
      if (isSectorNoLongerPresent) {
        this.removeSector({ region: data.region, id: id })
      }
    }
    
    for (let sectorId in sectors) {
      let sector = sectors[sectorId]

      this.renderSector(sector)
      this.renderTeam(sector)
    }

    this.onSectorListFetchedFromMatchmaker()
  }

  createTeamEntry(team) {
    team.online = true
    let teamEntry = new TeamEntry(this, team)

    let teamKey = this.getTeamKey(team)
    this.teamEntries[teamKey] = teamEntry

    let colonyListBody = this.el.querySelector(".main_colony_list")

    // determine insert position
    // if its daysAlive is less than mine, then insert it before there

    let teamEntryElements = colonyListBody.querySelectorAll(".team_entry_row.online")
    if (teamEntryElements.length === 0) {
      colonyListBody.insertBefore(teamEntry.el, colonyListBody.firstElementChild)
    } else {
      let insertBeforeEl = this.getTeamEntryElToInsertBefore(teamEntryElements, team)
      colonyListBody.insertBefore(teamEntry.el, insertBeforeEl)
    }
    
  }

  getTeamEntryElToInsertBefore(teamEntryElements, team) {
    let targetTeamEntryEl
    let teamEntryEl

    for (var i = 0; i < teamEntryElements.length; i++) {
      teamEntryEl = teamEntryElements[i]
      let teamEntryDaysAlive = teamEntryEl.dataset.days
      if (team.daysAlive >= teamEntryDaysAlive) {
        targetTeamEntryEl = teamEntryEl
        break
      }
    }

    if (!targetTeamEntryEl) {
      return teamEntryEl.nextSibling
    } else {
      return targetTeamEntryEl
    }
  }

  createSectorEntry(sector) {
    let sectorEntry = new SectorEntry(this, sector)

    this.sectorEntries[sector.id] = sectorEntry
    this.main.onSectorEntryAdded(sectorEntry)
  }

  removeSectorFromMatchmaker(sector) {
    this.main.pvpExplorer.removeSector(sector)
    this.removeSector(sector)
  }

  removeSector(sector) {
    let sectorEntry = this.sectorEntries[sector.id]
    if (sectorEntry) {
      sectorEntry.remove()
      this.main.onSectorEntryRemoved(sectorEntry)

      for (let teamName in sector.teams) {
        let team = sector.teams[teamName]
        this.removeTeam(team)
      }
    }

    // if pass in func parameter without teams data, we need to go through 
    // teamEntries as well and delete any that matches sector id
    for (let id in this.teamEntries) {
      let teamEntry = this.teamEntries[id]
      if (teamEntry.getSectorId() === sector.id) {
        teamEntry.remove()        
      }
    }
  }

  removeTeam(team) {
    let teamKey = this.getTeamKey(team)
    let teamEntry = this.teamEntries[teamKey]
    if (teamEntry) {
      teamEntry.remove()
    }
  }

  renderSector(sector) {
    this.main.pvpExplorer.renderSector(sector)

    if (sector.gameMode === 'pvp') return

    let sectorEntry = this.sectorEntries[sector.id]

    if (!sectorEntry) {
      this.createSectorEntry(sector)  
    } else {
      sectorEntry.update(sector)
    }
  }

  getTeamKey(team) {
    return team.sectorId
  }

  getTopColonyKey(team) {
    return team.sectorId
  }

  renderTeam(team) {
    let isMiniGame = team.id.match(/mini-(.*)-/)
    if (isMiniGame) return

    if (team.name === "Tutorial Lobby") return

    let teamKey = this.getTeamKey(team) 
    let teamEntry = this.teamEntries[teamKey]

    if (!teamEntry && team.playerCount > 0) {
      this.createTeamEntry(team)
      if (team.isPrivate) {
        this.privateSectors[team.sectorId] = true
      }
    } else if (team.playerCount === 0) {
      this.removeTeam(team)
    } else {
      teamEntry.update(team)
    }

    this.updateColonyEntries(team)
  }

  updateColonyEntries(team) {
    // make sure top colony entries are hidden if game is set to private
    let colonyKey = this.getTopColonyKey(team)


    let topColonyEntry = this.topColonyEntries[colonyKey]
    if (topColonyEntry) topColonyEntry.update(team)

    let searchColonyEntry = this.searchColonyEntries[colonyKey]
    if (searchColonyEntry) searchColonyEntry.update(team)

    let mineColonyEntry = this.mineColonyEntries[colonyKey]
    if (mineColonyEntry) mineColonyEntry.update(team)

    let favoriteColonyEntry = this.favoriteColonyEntries[colonyKey]
    if (favoriteColonyEntry) favoriteColonyEntry.update(team)
  }


}

module.exports = GameExplorer

},{"./../util/client_helper":649,"./../util/exception_reporter":650,"./sector_entry":186,"./team_entry":188,"js-cookie":58,"junon-common/config":59}],181:[function(require,module,exports){
const BitmapText = require("../util/bitmap_text")

class HealthBar {
  constructor(entity, options = {}) {
    this.width = 50
    this.height = 6
    this.border = 2
    this.margin = 10

    this.entity = entity
    this.sprite = this.getSprite(options)
    this.sprite.alpha = 0

    if (options.attribute) {
      this.attribute = options.attribute
      this.maxAttribute = options.maxAttribute
    }

    if (options.isFixedPosition) {
      this.entity.game.sector.effectsContainer.addChild(this.sprite)
      this.sprite.position.x += this.entity.getX()
      this.sprite.position.y += this.entity.getY()
    } else {
      this.entity.sprite.addChild(this.sprite)
    }

    this.entity.sector.registerBar(this)
  }

  getSprite(options) {
    const sprite = new PIXI.Sprite(PIXI.utils.TextureCache["health_bar_background.png"])
    sprite.name = this.getMeterAttribute() + "_bar"

    if (options.displayOnTop) {
      sprite.position.y = -((this.entity.getHeight() / 2) + this.margin)
    } else {
      sprite.position.y = (this.entity.getHeight() / 2) + this.margin
    }
    
    sprite.position.x = -this.width / 2

    this.barFill = new PIXI.Sprite(this.getBarFillTexture())
    this.barFill.name = this.getMeterAttribute() + "_bar_fill"

    sprite.addChild(this.barFill)

    return sprite
  }

  getMeterAttribute() {
    return this.attribute || "health"
  }

  getMeterMaxAttribute() {
    return this.maxAttribute || "getMaxHealth"
  }

  getBarFillTexture() {
    return PIXI.utils.TextureCache["health_bar_fill.png"]
  }

  drawMeter() {
    const width = this.width * (this.entity[this.getMeterAttribute()] / this.entity[this.getMeterMaxAttribute()]())
    this.barFill.width = width
  }


  draw() {
    this.drawMeter()
    this.display()
  }

  // dynamically create bar and remove after 
  // use for tiles where bar display is rare
  static draw(entity, options = {}) {
    let bar = entity.sector.getBar(entity)
    if (!bar) {
      bar = new this(entity, options)
    }

    bar.drawAndRemove()
  }

  drawAndRemove() {
    this.drawMeter()
    clearTimeout(this.removeTimeout)

    this.sprite.alpha = 1

    this.removeTimeout = setTimeout(() => {
      this.remove()
    }, 3000)
  }

  remove() {
    this.entity.sector.unregisterBar(this)

    this.sprite.removeChild(this.barFill)    
    if (this.sprite.parent) {
      this.sprite.parent.removeChild(this.sprite)
    }
  }

  hide() {
    this.sprite.alpha = 0
  }

  display() {
    clearTimeout(this.hideTimeout)

    this.sprite.alpha = 1

    this.hideTimeout = setTimeout(() => {
      this.sprite.alpha = 0
    }, 3000)
  }

  showHealthIncreased(amount) {
    const duration = 500
    const yLength  = 50

    const healthText = BitmapText.create({
      label: "Health",
      text: amount,
      size: 40,
      spriteContainer: this.entity.game.sector.effectsContainer
    })

    healthText.sprite.tint = 0x16d016

    let dimensions = {
      x: this.entity.getX(),
      y: this.entity.getY() - this.entity.getHeight(),
      size: 64
    }

    healthText.sprite.position.set(dimensions.x, dimensions.y)

    new TWEEN.Tween(dimensions) 
        .to({ x: dimensions.x, y: dimensions.y - yLength, size: 32 }, duration) 
        .easing(TWEEN.Easing.Quadratic.Out) 
        .onUpdate(() => { 
          healthText.sprite.position.y = dimensions.y
        })
        .onComplete(() => {
          healthText.remove()
        }) 
        .start()
 
  }

  showDamageTaken(amount) {
    this.constructor.showDamageTaken(this.entity, amount)
  }

  static showDamageTaken(entity, amount) {
    const duration = 500
    const yLength  = 50

    const healthText = BitmapText.create({
      label: "Health",
      text: amount,
      size: 40,
      spriteContainer: entity.game.sector.effectsContainer
    })

    healthText.sprite.tint = 0xff0000

    let dimensions = {
      x: entity.getX(),
      y: entity.getY() - entity.getHeight(),
      size: 64
    }

    healthText.sprite.position.set(dimensions.x, dimensions.y)

    new TWEEN.Tween(dimensions) 
        .to({ x: dimensions.x, y: dimensions.y - yLength, size: 32 }, duration) 
        .easing(TWEEN.Easing.Quadratic.Out) 
        .onUpdate(() => { 
          healthText.sprite.position.y = dimensions.y
          // sprite.width  = dimensions.size + 20
          // sprite.height = dimensions.size
        })
        .onComplete(() => {
          healthText.remove()
        }) 
        .start()

  }


}

module.exports = HealthBar
},{"../util/bitmap_text":648}],182:[function(require,module,exports){
const ClientHelper = require("../util/client_helper")
const KeyboardMap = require("../entities/keyboard_map")
const Cookies = require("js-cookie")
const Constants = require("./../../../common/constants.json")
const Helper = require("./../../../common/helper")

class MiniGameDetailsMenu {
  constructor(main) {
    this.main = main
    this.game = main.game

    this.initListeners()
  }

  open(options = {}) {
    let isInsideGame = this.game.player
    if (isInsideGame) {
      this.main.gameExplorer.joinMiniGame(options.gameId)
      return
    }

    this.gameId = options.gameId

    let minigameData = this.main.gameExplorer.getMiniGame(this.gameId)
    let minigameName = minigameData.name.replace(/[^\w]+/g,"")
    let value = minigameName + "-" + this.gameId

    if (!this.main.getUrlParam().get("game")) {
      let newSearchParam = ClientHelper.replaceQueryParam('minigame', value, window.location.search)
      history.replaceState('','', newSearchParam)
    }

    this.renderDetails(minigameData)
    this.show()
  }

  renderDetails(minigameData) {
    // render player count
    let languageOptions = document.querySelectorAll(".minigame_chat_language_select option")
    for (var i = 0; i < languageOptions.length; i++) {
      let languageOption = languageOptions[i]
      let language = languageOption.value
      let count = 0  
      if (minigameData.playerCountByLanguage && minigameData.playerCountByLanguage[language]) {
        count = minigameData.playerCountByLanguage[language]
      }
      
      let languageMap = {
        "en": "English",
        "ru": "Русский",
        "ja": "日本語",
      } 

      languageOption.innerText = languageMap[language] + " - " + count + " players"
    }

    let imageBasePath = "/assets/images/background/"
    if (this.gameId === "l8v7ezWMvnGeC" || this.gameId === "uLHpXWb2koXYe") {
      document.querySelector(".minigame_details_container .minigame_title").innerText = "Bed Wars"
      document.querySelector(".minigame_details_container .minigame_description").innerText = "Defend your bed and destroy other teams bed"
      document.querySelector(".minigame_thumbnail_1").href = imageBasePath + "bedwars_1.jpg"
      document.querySelector(".minigame_thumbnail_1 img").src = imageBasePath + "bedwars_1.jpg"
      document.querySelector(".minigame_thumbnail_2").href = imageBasePath + "bedwars_2.jpg"
      document.querySelector(".minigame_thumbnail_2 img").src = imageBasePath + "bedwars_2.jpg"
    } else if (this.gameId === "BPF0uFha5QLUr" || this.gameId === "PnGkJd5xZsb0v") {
      document.querySelector(".minigame_details_container .minigame_title").innerText = i18n.t("Domination.Title")
      document.querySelector(".minigame_details_container .minigame_description").innerText = i18n.t("Domination.Description")
      document.querySelector(".minigame_thumbnail_1").href = imageBasePath + "pvp_1.jpg"
      document.querySelector(".minigame_thumbnail_1 img").src = imageBasePath + "pvp_1.jpg"
      document.querySelector(".minigame_thumbnail_2").href = imageBasePath + "pvp_2.jpg"
      document.querySelector(".minigame_thumbnail_2 img").src = imageBasePath + "pvp_2.jpg"
    } else if (this.gameId === "vbj91eofmFCiu" || this.gameId === "YcdqgbswlAqRi") {
      document.querySelector(".minigame_details_container .minigame_title").innerText = "Tower Defense"
      document.querySelector(".minigame_details_container .minigame_description").innerText = "Protect your core from incoming enemy waves"
      document.querySelector(".minigame_thumbnail_1").href = imageBasePath + "td_1.jpg"
      document.querySelector(".minigame_thumbnail_1 img").src = imageBasePath + "td_1.jpg"
      document.querySelector(".minigame_thumbnail_2").href = imageBasePath + "td_2.jpg"
      document.querySelector(".minigame_thumbnail_2 img").src = imageBasePath + "td_2.jpg"
    } else {
      document.querySelector(".minigame_details_container .minigame_title").innerText = i18n.t("FindTheImposter.Title")
      document.querySelector(".minigame_details_container .minigame_description").innerText = i18n.t("FindTheImposter.Description")
      document.querySelector(".minigame_thumbnail_1").href = imageBasePath + "role_crew.jpg"
      document.querySelector(".minigame_thumbnail_1 img").src = imageBasePath + "role_crew.jpg"
      document.querySelector(".minigame_thumbnail_2").href = imageBasePath + "meeting.jpg"
      document.querySelector(".minigame_thumbnail_2 img").src = imageBasePath + "meeting.jpg"
    }
  }

  initListeners() {
    document.querySelector(".join_minigame_btn").addEventListener("click", this.onJoinMiniGameBtnClick.bind(this), true)
    document.querySelector(".host_minigame_btn").addEventListener("click", this.onHostMiniGameBtnClick.bind(this), true)
  }

  onJoinMiniGameBtnClick() {
    this.main.gameExplorer.joinMiniGame(this.gameId) 
  }

  onHostMiniGameBtnClick() {
    this.main.gameExplorer.joinMiniGame(this.gameId, { hostPrivateGame: true }) 
  }

  show() {
    document.querySelector(".minigame_details_container").style.display = 'block'
  }

  hide() {
    document.querySelector(".minigame_details_container").style.display = 'none'
  }


}

module.exports = MiniGameDetailsMenu
},{"../entities/keyboard_map":444,"../util/client_helper":649,"./../../../common/constants.json":656,"./../../../common/helper":664,"js-cookie":58}],183:[function(require,module,exports){
const HealthBar = require("./health_bar")

class ProgressBar extends HealthBar {
  constructor(entity, options = {}) {
    super(entity, options)
  }

  display() {
    this.sprite.alpha = 1
  }

  getBarFillTexture() {
    return PIXI.utils.TextureCache["progress_bar_fill.png"]
  }


}

module.exports = ProgressBar
},{"./health_bar":181}],184:[function(require,module,exports){
const Config = require("junon-common/config")
const TeamEntry = require("./team_entry")
const PvPSectorEntry = require("./pvp_sector_entry")
const ClientHelper = require("./../util/client_helper")
const ExceptionReporter = require("./../util/exception_reporter")
const Cookies = require("js-cookie")

class PvPExplorer {
  constructor(main) {
    this.main = main
    this.el = document.querySelector(".pvp_games_container")
    this.sectorEntries = {}

    this.el.querySelector(".pvp_colony_list").addEventListener("click", this.onColonyListClick.bind(this), true)
  }

  show() {
    this.el.style.display = 'block'
    let highlightedEntry = this.el.querySelector(".sector_entry_row.highlighted")
    if (highlightedEntry) {
      highlightedEntry.classList.remove("highlighted")
    }

    let pvpSectorUid = Cookies.get("pvpSectorUid")
    if (pvpSectorUid) {
      let sectorRow = this.el.querySelector(`.sector_entry_row[data-id='${pvpSectorUid}']`)
      if (sectorRow) {
        sectorRow.classList.add("highlighted")
      }
    }
  }

  hide() {
    this.el.style.display = 'none'
  }

  onColonyListClick(e) {
    let sectorEntryRow = e.target.closest(".sector_entry_row")
    if (!sectorEntryRow) return

    let sectorEntry = this.sectorEntries[sectorEntryRow.dataset.id]
    if (sectorEntry) {
      this.lastSectorEntry = sectorEntry
      sectorEntry.join()
    }

  }

  renderSectorList(data) {
    let sectors = data.sectors

    // since sectors come from different regions, we cant compare presence
    // unless we track this.sectorEntries by region as well. skip delete for now

    // for (let id in this.sectorEntries) {
    //   let isSectorNoLongerPresent = !sectors[id]
    //   if (isSectorNoLongerPresent) {
    //     this.removeSector({ id: id })
    //   }
    // }

    for (let sectorId in sectors) {
      let sector = sectors[sectorId]
        this.renderSector(sector)
    }
  }

  renderSector(sector) {
    if (!sector.gameMode) return
    if (sector.gameMode !== 'pvp') return

    let sectorEntry = this.sectorEntries[sector.id]

    if (!sectorEntry) {
      this.createSectorEntry(sector)  
    } else {
      sectorEntry.update(sector)
    }
  }

  createSectorEntry(sector) {
    let sectorEntry = new PvPSectorEntry(this, sector)
    this.sectorEntries[sector.id] = sectorEntry

    this.el.querySelector(".pvp_colony_list tbody").appendChild(sectorEntry.el)
  }

  removeSector(data) {
    let sectorEntry = this.sectorEntries[data.id]
    if (sectorEntry) {
      sectorEntry.remove()
    }
  }
}

module.exports = PvPExplorer

},{"./../util/client_helper":649,"./../util/exception_reporter":650,"./pvp_sector_entry":185,"./team_entry":188,"js-cookie":58,"junon-common/config":59}],185:[function(require,module,exports){
const SectorEntry = require("./sector_entry")

class PvPSectorEntry extends SectorEntry {
  constructor(pvpExplorer, sector) {
    super(pvpExplorer.main.gameExplorer, sector)
    this.pvpExplorer = pvpExplorer
  }

  update(sector) {
    this.data = sector

    this.setIp(sector.ip)
    let regionData = main.regions.find((region) => { 
      return region.id === sector.region 
    })
    let regionName = regionData ? regionData.name : sector.region
    this.setName(sector.name)
    this.setOccupancy(sector.daysAlive)
    this.setPlayerCount(sector.playerCount)

    this.setVisibility(sector)
  }

  remove() {
    if (this.el.parentElement) {
      this.el.parentElement.removeChild(this.el)
    }

    delete this.pvpExplorer.sectorEntries[this.getId()]
  }
}

module.exports = PvPSectorEntry
},{"./sector_entry":186}],186:[function(require,module,exports){
const Cookies = require("js-cookie")

class SectorEntry {
  constructor(gameExplorer, sector) {
    this.gameExplorer = gameExplorer
    this.el = document.createElement("tr")
    this.el.className = "sector_entry_row"

    this.el.innerHTML += "<td class='info_name'></td>"
    this.el.innerHTML += "<td class='sector_occupancy'></td>"
    this.el.innerHTML += "<td class='sector_player_count'></td>"

    this.setId(sector.sectorId)
    this.update(sector)
  }

  join(options = {}) {
    let ip = this.getIp()

    options['sectorId'] = this.getId()

    if (!Cookies.get('tutorial_done')) {
      this.gameExplorer.main.game.confirmMenu.open({
        message: i18n.t('AskTutorialMessage'),
        proceedCallback: this.gameExplorer.main.onTutorialMenuBtnClick.bind(this.gameExplorer.main),
        cancelCallback: this.onSkipTutorial.bind(this, ip, options)
      })
      return
    } else {
      this.gameExplorer.requestGame(ip, options)
    }
  }

  onSkipTutorial(ip, options) {
    Cookies.set('tutorial_done', true)  
    this.gameExplorer.requestGame(ip, options)
  }

  getHost() {
    return this.data.host
  }

  getScreenshot() {
    if (!this.data.screenshots) return null
    return Object.keys(this.data.screenshots)[0]
  }

  select() {
    this.el.classList.add("selected")
  }

  getRegion() {
    return this.gameExplorer.getRegion()
  }

  getVersion() {
    return this.data.version
  }

  getName() {
    return this.data.name
  }

  getId() {
    return this.data.sectorId
  }

  getIp() {
    return this.data.ip
  }

  setIp(ip) {
    this.el.dataset.ip = ip
  }

  setId(id) {
    this.el.dataset.id = id
  }

  setName(name) {
    this.el.querySelector(".info_name").innerText = name
  }

  setPlayerCount(count) {
    this.el.querySelector(".sector_player_count").innerText = `${count} / 50` 
  }

  setOccupancy(occupancy) {
    this.el.querySelector(".sector_occupancy").innerText = `${occupancy}` 
  }

  getPlayerCount() {
    return this.data.playerCount
  }

  update(sector) {
    this.data = sector

    this.setIp(sector.ip)
    this.setName(sector.name)
    this.setOccupancy(sector.daysAlive)
    this.setPlayerCount(sector.playerCount)

    this.setVisibility(sector)
  }

  setVisibility(sector) {
//     if (sector.hidden) {
//       this.el.dataset.hidden = true
//     }
// 
//     if (this.isOlderVersion()) {
//       this.el.dataset.hidden = true
//     }
  }

  isOlderVersion() {
    let clientVersionValue = this.getVersionValue(main.getVersion())
    let serverVersionValue = this.getVersionValue(this.getVersion())
    return serverVersionValue < clientVersionValue
  }

  getVersionValue(versionString) {
    versionString = versionString.replace(/^v/,'') // remove leading v character
    let tokens = versionString.split(".")
    let numTokens = tokens.map((el, index) => { 
      return parseInt(el) * (tokens.length - index) 
    })

    return numTokens.reduce((sum, el) => { return sum + el }, 0)
  }

  remove() {
    if (this.el.parentElement) {
      this.el.parentElement.removeChild(this.el)
    }

    if (this.gameExplorer.selectedEntry === this) {
      this.gameExplorer.selectedEntry = null
    }

    delete this.gameExplorer.sectorEntries[this.getId()]
  }

}

module.exports = SectorEntry
},{"js-cookie":58}],187:[function(require,module,exports){
const ClientHelper = require("../util/client_helper")
const KeyboardMap = require("../entities/keyboard_map")
const Cookies = require("js-cookie")
const Constants = require("./../../../common/constants.json")
const Helper = require("./../../../common/helper")

class SettingsMenu {
  constructor(main) {
    this.main = main
    this.game = main.game

    this.displayVolume()
    this.displayKeybindings()

    this.loadKeyBindingsFromStorage()

    this.initListeners()
  }

  initListeners() {
    document.querySelector(".key_bindings_container").addEventListener("click", this.onKeyBindingsContainerClick.bind(this), true)
    document.querySelector(".key_bindings_container").addEventListener("keyup", this.onKeyBindingsContainerKeyup.bind(this), true)

    document.querySelector(".effects_volume_slider").addEventListener("change", this.onEffectsVolumeSliderChange.bind(this))
    document.querySelector(".effects_volume_slider").addEventListener("input", this.onEffectsVolumeSliderChange.bind(this))

    document.querySelector(".background_volume_slider").addEventListener("change", this.onBackgroundVolumeSliderChange.bind(this))
    document.querySelector(".background_volume_slider").addEventListener("input", this.onBackgroundVolumeSliderChange.bind(this))
  }

  displayVolume() {
    const volume = Cookies.get("effects_volume") || Constants.defaultVolume

    document.querySelector(".effects_volume_value").innerText = volume
    document.querySelector(".effects_volume_slider").value = volume * 10

    const backgroundVolume = Cookies.get("background_volume") || Constants.defaultBackgroundVolume

    document.querySelector(".background_volume_value").innerText = backgroundVolume
    document.querySelector(".background_volume_slider").value = backgroundVolume * 10
  }

  onEffectsVolumeSliderChange(e) {
    let volume = parseInt(e.target.value) / 10
    Cookies.set("effects_volume", volume)
    document.querySelector(".effects_volume_value").innerText = volume
    
    this.game.setEffectsVolume(volume)
  }

  onBackgroundVolumeSliderChange(e) {
    let volume = parseInt(e.target.value) / 10
    Cookies.set("background_volume", volume)
    document.querySelector(".background_volume_value").innerText = volume
    
    this.game.setBackgroundVolume(volume)
  }

  onKeyBindingsContainerKeyup(e) {
    let keyCode = ClientHelper.getKeycode(e)
    if (keyCode === 27) {
      // escape - user is trying to leave settings menu
      return
    }

    if (!this.currentKeyBindingRow) return
    
    let keyBindingLabel = this.currentKeyBindingRow.dataset.label
    Cookies.set(keyBindingLabel, keyCode)
    this.setNewKeyBinding(keyBindingLabel, keyCode)
  }

  setNewKeyBinding(keyBindingLabel, keyBinding) {
    this.game.keyBindings[keyBindingLabel] = keyBinding
    let selector = ".key_bindings_row[data-label='" + keyBindingLabel + "'] .key_binding_value"
    document.querySelector(selector).innerText = KeyboardMap[keyBinding]

    this.onKeyBindingChanged(keyBindingLabel, keyBinding)
  }

  onKeyBindingChanged(keyBindingLabel, keyBinding) {
    if (keyBindingLabel === "interact") {
      document.querySelector("#player_action_tooltip #shortcut_btn").innerText = KeyboardMap[keyBinding]
    }
  }

  onKeyBindingsContainerClick(e) {
    // let currentKeyBindingRow 
    // if (this.currentKeyBinding) {
    //   currentKeyBindingRow = document.querySelector(".key_bindings_row[data-key-binding='" + this.currentKeyBinding +"']")
    //   currentKeyBindingRow.querySelector(".key_binding_value")
    // }

    if (this.currentKeyBindingRow) {
      // reset edit mode
      let keyBindingLabel = this.currentKeyBindingRow.dataset.label
      let keyBinding = this.game.keyBindings[keyBindingLabel]
      this.currentKeyBindingRow.querySelector(".key_binding_value").innerText = KeyboardMap[keyBinding]
      this.currentKeyBindingRow = null
    }
    
    if (e.target.className === 'key_binding_value') {
      e.target.innerText = "Press any Key"
      let keyBindingRow = e.target.closest(".key_bindings_row")
      this.currentKeyBindingRow = keyBindingRow
    } else {

    }
  }

  displayKeybindings() {
    for (let command in this.game.keyBindings) {
      let keyBinding = this.game.keyBindings[command]
      let translatedCommand = i18n.t(Helper.capitalizeWords(command))
      let el = document.createElement("div")
      el.className = "key_bindings_row"
      el.dataset.label = command
      el.innerHTML += "<div class='key_binding_label'>" + translatedCommand + "</div>"
      el.innerHTML += "<div class='key_binding_value' tabindex='0'>" + KeyboardMap[keyBinding] + "</div>"

      document.querySelector(".key_bindings_container").appendChild(el)
    }
  }

  loadKeyBindingsFromStorage() {
    for (let keyBindingLabel in this.game.keyBindings) {
      let savedKeybinding = Cookies.get(keyBindingLabel)
      if (savedKeybinding) {
        this.setNewKeyBinding(keyBindingLabel, parseInt(savedKeybinding))
      }
    }
  }

  show() {
    document.querySelector(".settings_container").style.display = 'block'
  }

  hide() {
    document.querySelector(".settings_container").style.display = 'none'
  }


}

module.exports = SettingsMenu
},{"../entities/keyboard_map":444,"../util/client_helper":649,"./../../../common/constants.json":656,"./../../../common/helper":664,"js-cookie":58}],188:[function(require,module,exports){
class TeamEntry {
  constructor(gameExplorer, team, isTopColony) {
    this.gameExplorer = gameExplorer
    this.main = gameExplorer.main
    this.isTopColony = isTopColony

    this.el = document.createElement("div")
    this.el.className = "team_entry_row"

    if (team.week) {
      this.el.classList.add('new')
    } 
    if (team.top) {
      this.el.classList.add('top')
    }
    if (team.mine) {
      this.el.classList.add('mine')
      this.isMine = true
    } 
    if (team.favorite) {
      this.el.classList.add('favorite')
    } 
    if (team.online) {
      this.el.classList.add('online')
    }

    this.data = team
    
    if (!this.data.sectorId) {
      this.data.sectorId = this.data.uid
    }

    this.el.innerHTML += "<img class='screenshot' src='" + this.getThumbnailPath() + "' />"
    this.el.innerHTML += "<div class='info_name'></div>"
    
    if (team.online) {
      this.el.innerHTML += "<div class='ban_world_btn'>Ban</div>"
    }

    if (this.isMine) {
      this.el.innerHTML += "<img class='team_delete_btn' src='/assets/images/trash_icon.png' />"
      this.el.innerHTML += "<img class='export_world_btn' src='/assets/images/download_icon.png' />"
      this.el.innerHTML += "<img class='import_world_btn' src='/assets/images/upload_icon.png' />"
    }

    this.el.innerHTML += "<div class='team_member_count'></div>"
    this.el.innerHTML += "<div class='team_days_alive'></div>"

    this.update(team)
  }

  getThumbnailPath() {
    let screenshot = this.getScreenshot()
    let thumbnailPath
    if (!screenshot) {
      thumbnailPath = "/assets/images/background/default_junon_thumb.png"
    } else {
      thumbnailPath = this.main.getScreenshotThumbnailPath(screenshot)
    }

    return thumbnailPath
  }

  getScreenshot() {
    if (this.data.screenshot) return this.data.screenshot
    if (!this.data.screenshots) return null
    return Object.keys(this.data.screenshots)[0]
  }

  select() {
    this.el.classList.add("selected")
  }

  join() {
    if (this.isFull() && this.gameExplorer.isInGame()) {
      this.main.game.displayError("Max Players Reached. Unable to Join.", { warning: true })
      return
    }

    if (this.main.shouldShowVideoAd()) {
      this.main.videoAdCompleteCallback = this.joinColony.bind(this)
      this.main.displayVideoAd()
    } else {
      this.joinColony()
    }
  }

  joinColony() {
    this.main.recordColonyVisit()
    let ip = this.getIp()
    this.gameExplorer.requestGame(ip, { sectorId: this.getSectorId(), teamId: this.data.id })
  }

  startBoot() {
    if (this.main.shouldShowVideoAd()) {
      this.main.videoAdCompleteCallback = this.performBoot.bind(this)
      this.main.displayVideoAd()
    } else {
      this.performBoot()
    }
  }

  performBoot() {
    this.isBooting = true
    this.showBootStatus()
    this.main.bootSector(this.getSectorId())
  }

  showBootStatus() {
    document.querySelector(".loading_modal").style.display = 'block'
  }

  hideBootStatus() {
    document.querySelector(".loading_modal").style.display = 'none'
  }

  cancelBoot() {
    this.isBooting = false
    this.hideBootStatus()
  }

  finishBoot() {
    if (!this.isBooting) return
      
    this.isBooting = false
    this.hideBootStatus()

    let sectorEntry = this.getSectorEntry()
    if (sectorEntry) {
      this.main.recordColonyVisit()
      let ip = sectorEntry.getIp()
      this.gameExplorer.requestGame(ip, { sectorId: this.getSectorId() })
    }
  }

  isOffline() {
    return this.getMemberCount() === 0
  }

  getId() {
    return this.data.id
  }

  getSectorId() {
    return this.data.sectorId || this.data.uid
  }

  getName() {
    return this.data.name
  }

  isFull() {
    return this.getMemberCount() >= 20
  }

  getMemberCount() {
    if (this.data.hasOwnProperty("playerCount")) {
      return this.data.playerCount
    }
    
    if (this.isTopColony) {
      let teamEntry = this.gameExplorer.findTeamEntry(this.getSectorId())
      if (teamEntry) {
        return teamEntry.getMemberCount()
      } else {
        return 0
      }
    } else {
      return this.data.members.length
    }
  }

  getIp() {
    if (this.data.ip) return this.data.ip

    let sectorEntry = this.getSectorEntry()
    if (sectorEntry) return sectorEntry.getIp()
  }

  setIp(ip) {
    this.el.dataset.ip = ip
  }

  setName(name, gameMode) {
    name = name || ""
    let maxLength = 40
    let displayName = ""
    if (gameMode && gameMode !== 'pvp') {
      displayName += this.getGameModeEmoji(gameMode)
    }
    displayName += name.slice(0, maxLength)
    this.el.querySelector(".info_name").innerText = displayName
    this.name = name
  }

  getGameModeEmoji(gameMode) {
    // if (gameMode === 'peaceful') return "🏠"
    // if (gameMode === 'survival') return "🌎"
    // if (gameMode === 'hardcore') return "👾"
    return ""
  }

  setDayCount(dayCount) {
    this.el.dataset.days = dayCount
    this.el.querySelector(".team_days_alive").innerText = "Day " + dayCount
    this.dayCount = dayCount
  }

  getDayCount() {
    return this.dayCount
  }

  setColonyName(name, gameMode) {
    name = name || ""
    let maxLength = 40
    let displayName = ""
    if (gameMode && gameMode !== 'pvp') {
      displayName += this.getGameModeEmoji(gameMode)
    }
    displayName += name.slice(0, maxLength)
    this.el.querySelector(".info_name").innerText = displayName
    this.name = name
  }

  setDaysAlive(daysAlive) {
    this.el.dataset.days = daysAlive
    this.el.querySelector(".team_days_alive").innerText = "Day " + daysAlive
  }

  setMemberCount(count) {
    this.el.querySelector(".team_member_count").innerHTML = "<span class='player_count_value'>" + count + "</span><img class='person_icon' src='/assets/images/person_icon.png' />"

    this.onMemberCountChanged()
  }

  onMemberCountChanged() {
    if (this.isTopColony) {
      if (this.getMemberCount() > 0) {
        this.el.classList.add("ranked_online")
      } else {
        this.el.classList.remove("ranked_online")
      }
    }
  }

  setPrivacy(isPrivate) {
    this.isPrivate = isPrivate

    this.el.dataset.private = isPrivate
  }

  onTeamInviteFound() {

  }

  getRegion() {
    return this.data.region
  }

  getSectorEntry() {
    return this.gameExplorer.sectorEntries[this.getSectorId()]
  }

  setSectorNameById(sectorId) {
    let sectorEntry = this.getSectorEntry()
    if (sectorEntry) {
      // this.el.querySelector(".team_sector_name").innerText = sectorEntry.getName()
    }
  }

  update(team) {
    this.data = team

    this.setKey()

    if (this.isTopColony) {
      this.setColonyName(team.name, team.gameMode)
      this.setDaysAlive(team.daysAlive)
      this.setMemberCount(this.getMemberCount())
      this.setPrivacy(team.isPrivate)
    } else {
      this.setName(team.name, team.gameMode)
      this.setDayCount(team.daysAlive)
      this.setMemberCount(this.getMemberCount())
      this.setSectorNameById(team.sectorId)
      this.setPrivacy(team.isPrivate)
      this.setIp(team.ip)
      this.setTags()
    }

  }

  setOwner(team) {
    if (team.creatorUid) {
      this.ownerName = team.owners[team.creatorUid]
      this.el.querySelector(".team_owner_name").innerText = this.ownerName
    }
  }
  
  setTags() {
    let name = this.getName()

    if (this.isOlderVersion()) {
      name = "[" + this.getVersion() + "] " + name
    }

    if (this.isAnonymousGame()) {
      name = "[temp] " + name
    }

    this.setName(name, this.data.gameMode)
  }

  isAnonymousGame() {
    let uuidv4Regex = new RegExp(/^[0-9A-F]{8}-[0-9A-F]{4}-4[0-9A-F]{3}-[89AB][0-9A-F]{3}-[0-9A-F]{12}$/i)
    return uuidv4Regex.test(this.data.creatorUid)
  }

  isOlderVersion() {
    let clientVersionValue = this.getVersionValue(main.getVersion())
    let serverVersionValue = this.getVersionValue(this.getVersion())
    return serverVersionValue < clientVersionValue
  }

  getVersionValue(versionString) {
    versionString = versionString.replace(/^v/,'') // remove leading v character
    let tokens = versionString.split(".")
    let numTokens = tokens.map((el, index) => { 
      return parseInt(el) * (tokens.length - index) 
    })

    return numTokens.reduce((sum, el) => { return sum + el }, 0)
  }

  getVersion() {
    let sectorEntry = this.getSectorEntry()
    if (sectorEntry) {
      return sectorEntry.getVersion()
    } else {
      return main.getVersion() // last resort fallback
    }
  }


  setKey() {
    this.el.dataset.key = this.getTeamKey()
  }

  getTeamKey() {
    return this.getSectorId()
  }

  remove() {
    if (this.el.parentElement) {
      this.el.parentElement.removeChild(this.el)
    }

    if (this.gameExplorer.selectedEntry === this) {
      this.gameExplorer.selectedEntry = null
    }

    let teamKey = this.getTeamKey()
    let teamEntries = this.gameExplorer.teamEntries
    if (teamEntries) {
      delete teamEntries[teamKey]
    }
    
  }

}

module.exports = TeamEntry
},{}],189:[function(require,module,exports){
const BaseEntity  = require("./../base_entity")
const Constants = require("./../../../../common/constants.json")
const Protocol = require("./../../../../common/util/protocol")
const Helper = require("./../../../../common/helper")

class BaseAmmo extends BaseEntity {
  constructor(game, data) {
    super(game, data)

    this.repositionSprite()
  }

  getSprite() {
    const sprite = new PIXI.Sprite(PIXI.utils.TextureCache[this.getSpritePath()])
    return sprite
  }

  repositionSprite() {
    this.sprite.anchor.set(0)
    this.sprite.position.x = 50
    this.sprite.position.y = 0
    this.sprite.rotation = Math.PI/2
  }

  getSpriteContainer() {
    if (this.data.user.isBuildingType()) {
      return this.data.user.buildingSprite
    } else {
      return this.data.user.characterSprite
    }
  }

  onPostEquip() {

  }

  syncWithServer() {
    
  }

  static getSellGroup() {
    return "Ammos"
  }

  static build(game, data) {
    return new this(game, data)
  }

  getType() {
    throw new Error("must implement BaseAmmo.getType")
  }

}

module.exports = BaseAmmo


},{"./../../../../common/constants.json":656,"./../../../../common/helper":664,"./../../../../common/util/protocol":686,"./../base_entity":206}],190:[function(require,module,exports){
const BaseAmmo = require("./base_ammo")
const Constants = require("./../../../../common/constants.json")
const Protocol = require("./../../../../common/util/protocol")

class BulletAmmo extends BaseAmmo {

  getSpritePath() {
    return 'bullet_ammo.png'
  }

  getType() {
    return Protocol.definition().BuildingType.BulletAmmo
  }

  getConstantsTable() {
    return "Ammos.BulletAmmo"
  }

}

module.exports = BulletAmmo

},{"./../../../../common/constants.json":656,"./../../../../common/util/protocol":686,"./base_ammo":189}],191:[function(require,module,exports){
const Helper = require("./../../../../common/helper")

const Ammos = {}
Ammos.BulletAmmo = require("./bullet_ammo")
Ammos.RifleAmmo = require("./rifle_ammo")
Ammos.ShotgunShell = require("./shotgun_shell")
Ammos.Missile = require("./missile")
Ammos.PlasmaCell = require("./plasma_cell")


Ammos.forType = (type) => {
  const klassName = Helper.getTypeNameById(type)
  return Ammos[klassName]
}

Ammos.getList = () => {
  return [Ammos.BulletAmmo, Ammos.ShotgunShell, Ammos.RifleAmmo, Ammos.Missile, Ammos.PlasmaCell]
}


module.exports = Ammos

},{"./../../../../common/helper":664,"./bullet_ammo":190,"./missile":192,"./plasma_cell":193,"./rifle_ammo":194,"./shotgun_shell":195}],192:[function(require,module,exports){
const BaseAmmo = require("./base_ammo")
const Constants = require("./../../../../common/constants.json")
const Protocol = require("./../../../../common/util/protocol")

class Missile extends BaseAmmo {

  getSpritePath() {
    return 'missile_ammo.png'
  }

  getType() {
    return Protocol.definition().BuildingType.Missile
  }

  getConstantsTable() {
    return "Ammos.Missile"
  }

}

module.exports = Missile

},{"./../../../../common/constants.json":656,"./../../../../common/util/protocol":686,"./base_ammo":189}],193:[function(require,module,exports){
const BaseAmmo = require("./base_ammo")
const Constants = require("./../../../../common/constants.json")
const Protocol = require("./../../../../common/util/protocol")

class PlasmaCell extends BaseAmmo {

  getSpritePath() {
    return 'plasma_cell.png'
  }

  getType() {
    return Protocol.definition().BuildingType.PlasmaCell
  }

  getConstantsTable() {
    return "Ammos.PlasmaCell"
  }

}

module.exports = PlasmaCell

},{"./../../../../common/constants.json":656,"./../../../../common/util/protocol":686,"./base_ammo":189}],194:[function(require,module,exports){
const BaseAmmo = require("./base_ammo")
const Constants = require("./../../../../common/constants.json")
const Protocol = require("./../../../../common/util/protocol")

class RifleAmmo extends BaseAmmo {

  getSpritePath() {
    return 'rifle_ammo.png'
  }

  getType() {
    return Protocol.definition().BuildingType.RifleAmmo
  }

  getConstantsTable() {
    return "Ammos.RifleAmmo"
  }

}

module.exports = RifleAmmo

},{"./../../../../common/constants.json":656,"./../../../../common/util/protocol":686,"./base_ammo":189}],195:[function(require,module,exports){
const BaseAmmo = require("./base_ammo")
const Constants = require("./../../../../common/constants.json")
const Protocol = require("./../../../../common/util/protocol")

class ShotgunShell extends BaseAmmo {

  getSpritePath() {
    return 'shotgun_shell.png'
  }

  getType() {
    return Protocol.definition().BuildingType.ShotgunShell
  }

  getConstantsTable() {
    return "Ammos.ShotgunShell"
  }

}

module.exports = ShotgunShell

},{"./../../../../common/constants.json":656,"./../../../../common/util/protocol":686,"./base_ammo":189}],196:[function(require,module,exports){
const Protocol = require("./../../../../common/util/protocol")

const Backgrounds = {}

Backgrounds.Planet = require("./planet")
Backgrounds.Star = require("./star")
Backgrounds.Ring = require("./ring")

Backgrounds.forType = (type) => {
  let targetKlass = ""
  const nameToTypeMap = Protocol.definition().BackgroundType

  for (let name in nameToTypeMap) {
    if (nameToTypeMap[name] === type) {
      targetKlass = name
    }
  }

  return Backgrounds[targetKlass]
}


module.exports = Backgrounds
},{"./../../../../common/util/protocol":686,"./planet":197,"./ring":198,"./star":199}],197:[function(require,module,exports){
const BaseEntity = require("./../base_entity")
const Constants = require("./../../../../common/constants.json")

class Planet extends BaseEntity {

  static build(game, data) {
    return new this(game, data)
  }

  constructor(game, data) {
    super(game, data)
  }

  getSpriteContainer() {
    return this.game.sector.backgroundSpriteContainer
  }

  getSprite() {
    let circle = new PIXI.Graphics()
    circle.beginFill(0xffd170)
    circle.drawCircle(0, 0, this.w)
    circle.endFill()
    circle.beginFill(0xe5a217)
    circle.drawCircle(0, 0, this.w - 20)
    circle.endFill()
    circle.position.x = this.x
    circle.position.y = this.y
    const sprite = circle

    // let texture = PIXI.utils.TextureCache["yellow_planet_circle.png"]
    // const sprite = new PIXI.Sprite(texture)
    // sprite.position.x = this.x
    // sprite.position.y = this.y
    // sprite.width = this.w
    // sprite.height = this.h

    return sprite
  }

}

module.exports = Planet

},{"./../../../../common/constants.json":656,"./../base_entity":206}],198:[function(require,module,exports){
const BaseEntity = require("./../base_entity")
const Constants = require("./../../../../common/constants.json")

class Ring extends BaseEntity {

  static build(game, data) {
    return new this(game, data)
  }

  constructor(game, data) {
    super(game, data)
  }

  getSpriteContainer() {
    return this.game.backgroundSpriteContainer
  }

  getSprite() {
    let circle = new PIXI.Graphics()
    circle.lineStyle(10, 0x777777, 0.2)
    circle.drawCircle(0, 0, this.w)
    circle.endFill()
    circle.position.x = this.x
    circle.position.y = this.y
    const sprite = circle

    // let texture = PIXI.utils.TextureCache["yellow_planet_circle.png"]
    // const sprite = new PIXI.Sprite(texture)
    // sprite.position.x = this.x
    // sprite.position.y = this.y
    // sprite.width = this.w
    // sprite.height = this.h

    return sprite
  }

}

module.exports = Ring

},{"./../../../../common/constants.json":656,"./../base_entity":206}],199:[function(require,module,exports){
const BaseEntity = require("./../base_entity")
const Constants = require("./../../../../common/constants.json")

class Star extends BaseEntity {

  static build(game, data) {
    return new this(game, data)
  }

  constructor(game, data) {
    super(game, data)
  }

  getSpriteContainer() {
    return this.game.sector.backgroundSpriteContainer
  }

  getConstants() {
    return {}  
  }

  getSprite() {
    let texture = PIXI.utils.TextureCache["star.png"]
    const sprite = new PIXI.Sprite(texture)
    sprite.position.x = this.x
    sprite.position.y = this.y
    sprite.width = this.w
    sprite.height = this.h
    sprite.name = "Star"

    return sprite
  }

}

module.exports = Star

},{"./../../../../common/constants.json":656,"./../base_entity":206}],200:[function(require,module,exports){
const BaseEntity  = require("./../base_entity")
const Constants = require("./../../../../common/constants.json")
const Protocol = require("./../../../../common/util/protocol")
const Helper = require("./../../../../common/helper")

class BaseBar extends BaseEntity {
  constructor(options) {
    const data = { x: 0, y: 0, player: options.player }

    super(options.player.game, data)
  }

  getSprite() {
    const sprite = new PIXI.Sprite(PIXI.utils.TextureCache[this.getSpritePath()])
    sprite.width = this.getWidth()
    sprite.height = this.getHeight()
    return sprite
  }

  static getSellGroup() {
    return "Bars"
  }

  getSpriteContainer() {
    return this.data.player.characterSprite
  }

  static build(game, data) {
    return new this(game, data)
  }

  getType() {
    throw new Error("must implement BaseBar.getType")
  }

}

module.exports = BaseBar

},{"./../../../../common/constants.json":656,"./../../../../common/helper":664,"./../../../../common/util/protocol":686,"./../base_entity":206}],201:[function(require,module,exports){
const BaseBar = require("./base_bar")
const Constants = require("./../../../../common/constants.json")
const Protocol = require("./../../../../common/util/protocol")

class CircuitBoard extends BaseBar {

  getSpritePath() {
    return 'circuit_board.png'
  }

  getType() {
    return Protocol.definition().BuildingType.CircuitBoard
  }

  getConstantsTable() {
    return "Bars.CircuitBoard"
  }

}

module.exports = CircuitBoard

},{"./../../../../common/constants.json":656,"./../../../../common/util/protocol":686,"./base_bar":200}],202:[function(require,module,exports){
const BaseBar = require("./base_bar")
const Constants = require("./../../../../common/constants.json")
const Protocol = require("./../../../../common/util/protocol")

class CopperBar extends BaseBar {

  getSpritePath() {
    return 'copper_bar.png'
  }

  getType() {
    return Protocol.definition().BuildingType.CopperBar
  }

  getConstantsTable() {
    return "Bars.CopperBar"
  }

}

module.exports = CopperBar

},{"./../../../../common/constants.json":656,"./../../../../common/util/protocol":686,"./base_bar":200}],203:[function(require,module,exports){
const BaseBar = require("./base_bar")
const Constants = require("./../../../../common/constants.json")
const Protocol = require("./../../../../common/util/protocol")

class Glass extends BaseBar {

  getSpritePath() {
    return 'glass.png'
  }

  getType() {
    return Protocol.definition().BuildingType.Glass
  }

  getConstantsTable() {
    return "Bars.Glass"
  }

}

module.exports = Glass

},{"./../../../../common/constants.json":656,"./../../../../common/util/protocol":686,"./base_bar":200}],204:[function(require,module,exports){
const Helper = require("./../../../../common/helper")

const Bars = {}
Bars.CopperBar = require("./copper_bar")
Bars.IronBar = require("./iron_bar")
Bars.Glass = require("./glass")
Bars.CircuitBoard = require("./circuit_board")
Bars.Cloth = require("../ores/cloth")

Bars.forType = (type) => {
  const klassName = Helper.getTypeNameById(type)
  return Bars[klassName]
}

module.exports = Bars


},{"../ores/cloth":488,"./../../../../common/helper":664,"./circuit_board":201,"./copper_bar":202,"./glass":203,"./iron_bar":205}],205:[function(require,module,exports){
const BaseBar = require("./base_bar")
const Constants = require("./../../../../common/constants.json")
const Protocol = require("./../../../../common/util/protocol")

class IronBar extends BaseBar {

  getSpritePath() {
    return 'iron_bar.png'
  }

  getType() {
    return Protocol.definition().BuildingType.IronBar
  }

  getConstantsTable() {
    return "Bars.IronBar"
  }

}

module.exports = IronBar

},{"./../../../../common/constants.json":656,"./../../../../common/util/protocol":686,"./base_bar":200}],206:[function(require,module,exports){
const Interpolator = require("./../util/interpolator")
const Constants = require("./../../../common/constants.json")
const Protocol = require("./../../../common/util/protocol")
const Helper = require("./../../../common/helper")
const ClientHelper = require("./../util/client_helper")
const Taintable = require("./../../../common/interfaces/taintable")
const Definable = require("./../../../common/interfaces/definable")
const Categorizable = require("./../../../common/interfaces/categorizable")
const Effects = require("./effects/index")
const BitmapText = require("../util/bitmap_text")
const ChatBubble = require("./chat_bubble")

class BaseEntity {
  constructor(game, data) {
    this.setEntityAttributes(game, data)
    this.initSprite(data.x, data.y)
  }

  setEntityAttributes(game, data) {
    this.id = data.id

    this.data = data
    this.container = data.container
    this.game = game
    this.sector = game.sector
    this.stage = game.app.stage

    this.w = data.w || this.getDisplayWidth()
    this.h = data.h || this.getDisplayHeight()

    if (this.sprite) {
      this.sprite.position.set(data.x, data.y)
    }

    this.initTaintable({shouldPopulate: false})
    this.effects = {}
    this.effectInstances = {}

    this.registerEntity()
  }

  isHiddenFromView() {
    return false
  }

  registerEntity() {
    if (this.id) {
      this.sector.registerGlobalEntity(this)
    }
  }

  canMenuBeOpened() {
    return true
  }

  shouldSendInteractTargetToServer() {
    return !this.getConstants().shouldLimitInteractToMenuOnly
  }

  getCoord() {
    return [this.getRow(), this.getCol()].join(",")
  }

  getAngle() {
    return this.angle
  }

  getRadAngle() {
    return this.angle * (Math.PI / 180)
  }

  getEntityMenuName() {
    return i18n.t(this.getTypeName())
  }

  onHighlighted() {

  }

  belongToOwner(player) {
    if (!this.owner) return false
    if (!player) return false
      
    let isOwnedByPlayer = this.owner.id === player.id
    let isOwnedByPlayerTeam = this.owner.id === player.teamId
    return isOwnedByPlayer || isOwnedByPlayerTeam
  }

  unregisterEntity() {
    if (this.id) {
      this.sector.unregisterGlobalEntity(this)
    }
  }

  shouldShowCooldown() {
    return this.getConstants().shouldShowCooldown
  }

  isLightOn() {
    return this.isLightPersistent() || this.isOpen
  }

  isLightPersistent() {
    return this.getConstants().isLightPersistent
  }

  onNPCServerMessage(data) {

  }
  
  createChatBubble(text, options = {}) {
    let shouldRecreateChatBubble = (this.chatBubble && this.chatBubble.textSprite.text !== text) ||
                                   !this.chatBubble
    if (shouldRecreateChatBubble) {
      options.text = text
      options.entity = this

      this.chatBubble = new ChatBubble(options)
    }

    this.chatBubble.delayedRemove(5000)
    return this.chatBubble
  }


  isProducer() {
    return this.hasCategory("producer")
  }

  static isTerrain() {
    return false
  }

  isTerrain() {
    return this.constructor.isTerrain()
  }

  getTypeName(content) {
    let label = this.getConstants().label
    if (label) return label

    let type = this.getType()
    return Helper.getTypeNameById(type).replace(/([A-Z])/g, ' $1').trim() // space before capital letters
  }

  static getCraftTypeName(content) {
    let type = this.getType()
    return Helper.getTypeNameById(type).replace(/([A-Z])/g, ' $1').trim() // space before capital letters
  }

  getTypeNameCamelCase(content) {
    let typeName = this.getTypeName(content)
    return typeName.replace(/\s+/g, '')
  }

  static getTypeName(content) {
    return this.prototype.getTypeName(content)
  }

  static getType() {
    return this.prototype.getType()
  }

  getDescription() {
    let description = this.getConstants().description
    if (description === this.name) return ""

    let translationKey = this.getTypeNameCamelCase() + ".Description" 

    if (i18n.has(translationKey)) {
      return i18n.t(translationKey)
    } else {
      return description || ""
    }
  }

  onClick() {
  }

  static getDescription() {
    return this.prototype.getDescription()
  }

  static getConstants() {
    return this.prototype.getConstants()
  }

  dontShowHealth() {
    return this.getConstants().dontShowHealth
  }

  isUsable() {
    return false
  }

  hasMenu() {
    return !!this.getConstants().hasMenu
  }

  shouldShowInteractTooltip() {
    return !!this.getConstants().showInteractTooltip
  }

  isInteractable() {
    return !!this.getConstants().isInteractable
  }

  closeHands() {
    this.hands.texture = PIXI.utils.TextureCache["player_hands_closed.png"]
  }

  openHands() {
    this.hands.texture = PIXI.utils.TextureCache["player_hands.png"]
  }

  getOwnershipStat(options = {}) {
    let ownerName
    if (this.unowned || !this.owner) {
      ownerName = "None"
    } else if (this.owner) {
      let team = this.game.teams[this.owner.id]
      if (team) {
        // make sure to use update team name if changed
        ownerName = team.name
      } else {
        ownerName = this.owner.name 
      }
    }

    let el = "<div class='entity_stats_entry ownership_stat_entry'>" +
                    "<div class='stats_type'>" + i18n.t("Owner") + ":</div>" +
                    "<div class='stats_value'>" + ownerName.replace(/</g, "&lt;").replace(/>/g, "&gt;") + "</div>" +
                "</div>"
    return el
  }


  showLighting(container, entityMenu) {
    let brightness   = container.lightManager.getTotalBrightness(this.getRow(), this.getCol())
    let color        = container.lightManager.computeLightValue(this.getRow(), this.getCol())

    let colorString = [color.r, color.g, color.b].join(",")

    // entityMenu.querySelector(".entity_light_brightness").innerText = "brightness:  " + brightness
    // entityMenu.querySelector(".entity_light_color").innerText = "color:  " + colorString
  }

  static getCost() {
    let requirements = this.prototype.getConstants().requirements

    let requirementsCost = 0
    for (let klassName in requirements) {
      let count = requirements[klassName]
      let klass = game.getItemKlassByName(klassName)
      let cost = klass.getCost() * count
      requirementsCost += cost
    }

    if (requirementsCost && !this.prototype.getConstants().isCostIndependent) {
      return requirementsCost
    } else {
      let cost = this.prototype.getConstants().cost
      return cost ? cost.gold : 2
    }
  }

  addEffectInstance(name, effectInstance) {
    this.effectInstances[name] = effectInstance
  }

  removeEffectInstance(name) {
    delete this.effectInstances[name]
  }

  removeSelfAndChildrens(sprite) {
    ClientHelper.removeSelfAndChildrens(sprite)
  }

  setEffects(effects) {
    // effects to remove
    for (let prevEffect in this.effects) {
      if (!effects[prevEffect]) {
        delete this.effects[prevEffect]
        this.onEffectRemoved(prevEffect)
      }
    }

    // effects to add
    for (let effect in effects) {
      let value = effects[effect]
      this.setEffectLevel(effect, value)
    }
  }

  handleDoubleClick(callback) {
    let currClickTime = (new Date()).getTime()
    let doubleClickThreshold = 500 // ms
    let isDblClick = this.lastClickTime && ((currClickTime - this.lastClickTime) < doubleClickThreshold)

    if (isDblClick) {
      callback()
    }

    this.lastClickTime = (new Date()).getTime()
  }

  renderInvalidArea() {
    const areaInvalidSprite = this.game.sector.invalidAreaSprite

    let isPositionValid = this.constructor.isPositionValid(this.container,
                                                           this.getRelativeX(),
                                                           this.getRelativeY(),
                                                           this.getRotatedWidth(),
                                                           this.getRotatedHeight(),
                                                           this.getAngle(),
                                                           this.game.player,
                                                           this.getType(),
                                                           this)

    if (isPositionValid) {
      let regionBuildPermission = this.game.sector.getRegionBuildPermission(this.getRelativeX(), this.getRelativeY(), this.getRotatedWidth(), this.getRotatedHeight())
      if (regionBuildPermission ) {
        if (!this.game.player.canBuildInRegion(regionBuildPermission)) {
          isPositionValid = false
        }
      } else {
        if (player.getRole() && !player.getRole().permissions.Build) {
          isPositionValid = false
        }
      }
    }

    if (!isPositionValid) {
      areaInvalidSprite.width = this.getAreaInvalidWidth()
      areaInvalidSprite.height = this.getAreaInvalidHeight()
      areaInvalidSprite.position.x = this.getX()
      areaInvalidSprite.position.y = this.getY()
      areaInvalidSprite.rotation = this.getRadAngle()

      areaInvalidSprite.alpha = 0.6
      this.onPositionBecomeInvalid()
    } else {
      areaInvalidSprite.alpha = 0
      this.onPositionBecomeValid()
    }
  }

  renderAtMousePosition(clientX, clientY) {
    const cameraPositionX = -this.game.cameraDisplacement.x
    const cameraPositionY = -this.game.cameraDisplacement.y
    const x = (cameraPositionX + clientX) / this.game.resolution
    const y = (cameraPositionY + clientY) / this.game.resolution

    const oldX = this.sprite.x
    const oldY = this.sprite.y
    const oldRow = Math.floor(oldY / Constants.tileSize)
    const oldCol = Math.floor(oldX / Constants.tileSize)

    this.sprite.x = this.container.getSnappedPosX(x, this.getRotatedWidth())
    this.sprite.y = this.container.getSnappedPosY(y, this.getRotatedHeight())

    const row = Math.floor(this.sprite.y / Constants.tileSize)
    const col = Math.floor(this.sprite.x / Constants.tileSize)

    if (oldX !== this.sprite.x || oldY !== this.sprite.y) {
      this.onPositionChanged()

      if (oldRow !== row || oldCol !== col) {
        this.onGridPositionChanged()
      }
    }
  }


  getAreaInvalidWidth() {
    return this.getWidth()
  }

  getAreaInvalidHeight() {
    return this.getHeight()
  }


  onPositionBecomeInvalid() {

  }

  onPositionBecomeValid() {

  }


  isBuildingType() {
    return false
  }

  isLightBlocker() {
    return this.getConstants().isLightBlocker
  }

  isLightSource() {
    if (!this.cachedLightSource) {
      this.cachedLightSource = this.getConstants().isLightSource
    }

    return this.cachedLightSource
  }

  isLightDiffuser() {
    return this.isForegroundTile()
  }

  isForegroundTile() {
    return false
  }

  getStats(level) {
    return this.getConstants().stats || {}
  }

  createRoleSelect(entityMenu) {
    let el = "<div>" +
               "<div class='player_permissions_label'>" + i18n.t('Role') + "</div>" +
               "<select class='player_permissions_select ui_select' data-member-id='" + this.id + "'>"

    for (let roleId in this.game.roles) {
      let role = this.game.roles[roleId]
      let option = "<option value='" + roleId + "'>" + i18n.t(role.name) + "</option>" 
      el += option
    }

    el += "</select></div>" 

    return el
  }

  getStandingPlatform() {
    let entity = this.getContainer().platformMap.get(this.getRow(), this.getCol())
    if (entity) return entity

    entity = this.getContainer().groundMap.get(this.getRow(), this.getCol())
    if (entity) return entity

    entity = this.getContainer().undergroundMap.get(this.getRow(), this.getCol())
    if (entity) return entity

    return null
  }

  initSprite(x, y) {
    this.sprite = this.getSprite()
    let baseSprite = this.getLightableSprites()
    // baseSprite.blendMode = PIXI.BLEND_MODES.MULTIPLY // for blending against lightmap

    if (this.sprite.anchor) this.sprite.anchor.set(0.5)
    this.sprite.position.set(x, y)

    this.applyConstantsDefinition()

    let spriteContainer = this.getSpriteContainer()
    if (spriteContainer) {
      let childIndex = this.getChildIndex()
      if (childIndex === null) {
        spriteContainer.addChild(this.sprite)
      } else {
        spriteContainer.addChildAt(this.sprite, childIndex)
      }
      
      if (this.isInterpolatable()) {
        this.interpolator = Interpolator.mixin(this.getInterpolatableSprite())
      }
      
    } else {
      this.remove()
    }
  }

  isInterpolatable() {
    return this.sector.movableGroupSet.has(this.getGroup())
  }

  getGroup() {
    return null
  }

  getChildIndex() {
    return null
  }

  getId() {
    return this.id
  }

  applyConstantsDefinition() {
    let constantTable = this.getConstants().sprite
    if (constantTable) {
      if (constantTable.position) {
        this.sprite.position.x = constantTable.position.x
        this.sprite.position.y = constantTable.position.y
      }

      if (typeof constantTable.anchor !== "undefined") {
        this.sprite.anchor.set(constantTable.anchor)
      }

      if (typeof constantTable.rotation !== "undefined") {
        this.sprite.rotation = constantTable.rotation * PIXI.DEG_TO_RAD
      }

      if (typeof constantTable.tint !== "undefined") {
        this.sprite.tint = ClientHelper.hexToInt(constantTable.tint)
      }

      if (typeof constantTable.width !== "undefined") {
        this.sprite.width = constantTable.width
      }

      if (typeof constantTable.height !== "undefined") {
        this.sprite.height = constantTable.height
      }
    }
  }

  getInterpolatableSprite() {
    return this.sprite
  }

  getLightableSprites() {
    return [this.sprite] // default
  }

  unselect() {
    if (this.selectionSprite) {
      let parent = this.selectionSprite.parent
      if (parent) {
        this.selectionSprite.parent.removeChild(this.selectionSprite)
      }
      this.selectionSprite.destroy()
      this.selectionSprite = null
    }
  }

  renderEntityMenu(entityMenu) {
    // nothing by default
  }

  getSelectionRect() {
    return null
  }

  onMouseOver() {
    this.isMouseOver = true
  }

  onMouseOut() {
    this.isMouseOver = false
  }

  hasMouseOver() {
    return this.isMouseOver
  }

  isControlledByPlayer() {
    return this.game.player.getCameraFocusTarget() === this
  }

  getRelativeBox() {
    if (!this.ship) {
      return this.getBox(this.getX(), this.getY(), this.getWidth(), this.getHeight())
    } else {
      return this.getBox(this.getRelativeX(), this.getRelativeY(), this.getWidth(), this.getHeight())
    }
  }


  getPaddedRelativeBox(padding = Constants.tileSize) {
    let box = this.getRelativeBox()

    return {
      pos: {
        x: box.pos.x - padding,
        y: box.pos.y - padding
      },
      w: box.w + padding * 2,
      h: box.h + padding * 2
    }
  }


  getSelectionSpriteParent() {
    return this.sprite
  }

  registerToChunk() {
    let chunk = this.getChunk()

    if (this.chunk !== chunk) {
      if (this.chunk) {
        this.chunk.unregister(this.getGroup(), this)
      }

      this.chunk = chunk
      if (this.chunk) {
        this.chunk.register(this.getGroup(), this)
      }
    }
  }

  getChunk() {
    return this.sector.getChunk(this.getChunkRow(), this.getChunkCol())
  }

  getChunkRow() {
    const chunkSize = Constants.chunkRowCount * Constants.tileSize
    return Math.floor(this.getY() / chunkSize)
  }

  getChunkCol() {
    const chunkSize = Constants.chunkRowCount * Constants.tileSize
    return Math.floor(this.getX() / chunkSize)
  }

  getUpperLeftRow() {
    let box = this.getRelativeBox()
    return Math.floor(box.pos.y / Constants.tileSize)
  }

  getUpperLeftCol() {
    let box = this.getRelativeBox()
    return Math.floor(box.pos.x / Constants.tileSize)
  }

  getRow() {
    let box = this.getRelativeBox()
    return Math.floor((box.pos.y + box.h / 2) / Constants.tileSize)
  }

  getCol() {
    let box = this.getRelativeBox()
    return Math.floor((box.pos.x + box.w / 2) / Constants.tileSize)
  }


  getRotatedWidth() {
    return this.getWidth()
  }

  getRotatedHeight() {
    return this.getHeight()
  }

  getSelectionWidth() {
    return this.getWidth()
  }

  getSelectionHeight() {
    return this.getHeight()
  }

  getSelectionLineStyle() {
    return {
      lineWidth: 4,
      color: 0xeeeeee,
      alpha: 0.7
    }
  }

  static isUsable() {
    return false
  }

  isMob() {
    return false
  }

  isMovable() {
    return false
  }

  isHangar() {
    return false
  }

  isAnimatable() {
    return this.getConstants().isAnimatable
  }

  redrawSprite() {
    // do nothing by default
  }

  getBrightness() {
    return this.getConstants().brightness || 0
  }

  static getBox(x, y, w, h) {
    return {
      pos: {
        x: x - w/2,
        y: y - h/2,
      },
      w: w,
      h: h
    }
  }

  getBox(x = this.getX(), y = this.getY(), w = this.w, h = this.h) {
    return {
      pos: {
        x: x - w/2,
        y: y - h/2,
      },
      w: w,
      h: h
    }
  }

  getSprite() {
    let texture = PIXI.utils.TextureCache[this.getSpritePath()]
    let sprite = this.createSprite(texture)
    if (!this.shouldUseOriginalWidth()) {
      sprite.width  = this.w
      sprite.height = this.h
    }
    sprite.name = this.constructor.name

    return sprite
  }

  createSprite(texture) {
    return new PIXI.Sprite(texture)
  }

  shouldUseOriginalWidth() {
    return this.getConstants().useOriginalSize || false
  }

  setAlpha(alpha) {
    this.sprite.alpha = alpha
  }

  setScaleX(scale) {
    this.sprite.scale.x = scale
  }

  setLevel(level) {
    const prevLevel = this.level
    this.level = level

    if (this.level !== prevLevel && this.level !== 0) {
      this.onLevelIncreased()
    }
  }

  onLevelIncreased() {

  }

  instructToMove(x, y) {
    this.sprite.instructToMove(x, y)
  }

  instructToRotate(rotation) {
    this.getRotatableSprite().instructToRotate(rotation)
  }

  getRotatableSprite() {
    return this.sprite
  }

  getMeleeTarget() {
    const xp = this.getRange() * Math.cos(this.getRadAngle())
    const yp = this.getRange() * Math.sin(this.getRadAngle())

    return { x: this.getX() + xp, y: this.getY() + yp }
  }


  instructToExpand(width) {
    this.sprite.instructToExpand(width)
  }

  interpolate(lastFrameTime) {
    this.sprite.interpolate(lastFrameTime)

    if (typeof this.angle !== "undefined") {
      this.interpolateRotation(lastFrameTime)
    }
  }

  interpolateRotation(lastFrameTime) {
    this.getRotatableSprite().interpolateRotation(lastFrameTime)
  }

  getDefaultSpriteColor() {
    return 0xffffff
  }

  animateDamage() {
    if (this.hasCategory("custom_colors")) return
    if (this.spriteRestoreTimeout) return

    this.setTint(this.getTintableSprite(), 0xff6d6d) // 0x555555

    this.spriteRestoreTimeout = setTimeout(() => {
      this.setTint(this.getTintableSprite(), this.getDefaultSpriteColor())
      this.spriteRestoreTimeout = null
      // this.shieldSprite.alpha = 1
    }, 100)

  }

  getActionTooltipMessage() {
    return null
  }

  repositionOnUnitMap() {
    this.removeFromUnitMap()
    this.getContainer().unitMap.registerToCollection(this.getRelativeBox(), this)
    this.prevRelativeBox = this.getRelativeBox()
  }

  repositionOnCorpseMap() {
    this.removeFromCorpseMap()
    this.getContainer().corpseMap.registerToCollection(this.getRelativeBox(), this)
    this.prevRelativeBox = this.getRelativeBox()
  }

  getContainer() {
    return this.sector
  }

  removeFromUnitMap() {
    if (this.prevRelativeBox) {
      this.getContainer().unitMap.unregisterFromCollection(this.prevRelativeBox, this)
    }
  }

  removeFromCorpseMap() {
    if (this.prevRelativeBox) {
      this.getContainer().corpseMap.unregisterFromCollection(this.prevRelativeBox, this)
    }
  }

  setTint(spriteOrContainer, tint) {
    const isContainer = typeof spriteOrContainer.calculateVertices !== "function"
    if (isContainer) {
      spriteOrContainer.children.forEach((child) => {
        this.setTint(child, tint)
      })
    } else {
      // is sprite
      spriteOrContainer.tint = tint
    }
  }

  lightenColor(color, percent) {
    var num = parseInt(color,16),
    amt = Math.round(2.55 * percent),
    R = (num >> 16) + amt,
    B = (num >> 8 & 0x00FF) + amt,
    G = (num & 0x0000FF) + amt;

    return (0x1000000 + (R<255?R<1?0:R:255)*0x10000 + (B<255?B<1?0:B:255)*0x100 + (G<255?G<1?0:G:255)).toString(16).slice(1)
  }

  getTintableSprite() {
    return this.sprite
  }

  getSpriteContainer() {
    return this.stage
  }

  getRequirements() {
    return Object.assign({}, this.getConstants().requirements)
  }

  setAngle(angle) {
    this.angle = angle
    this.sprite.rotation = this.getRadAngle()
  }

  remove() {
    this.unregisterEntity()

    if (this.sprite) {
      this.removeSelfAndChildrens(this.sprite)
    }

    for (let effect in this.effectInstances) {
      let effectInstance = this.effectInstances[effect]
      effectInstance.remove()
    }
  }

  getTintableSprites() {
    return [this.sprite]
  }

  removeChildrens(sprite) {
    while(sprite.children[0]) {
      sprite.removeChild(sprite.children[0])
    }
  }

  isCorpse() {
    return false
  }

  isPlayer() {
    return false
  }

  getCollisionGroup() {
    return null
  }

  addDizzyEyes(targetSprite) {
    if (!this.dizzySprite) {
      this.dizzySprite = new PIXI.Sprite(PIXI.utils.TextureCache["dizzy_eyes.png"])
      this.dizzySprite.width  = 30
      this.dizzySprite.height = 12
      this.dizzySprite.anchor.set(0.5)
      targetSprite.addChild(this.dizzySprite)
    }
  }

  removeDizzyEyes() {
    if (this.dizzySprite) {
      this.dizzySprite.parent.removeChild(this.dizzySprite)
      this.dizzySprite = null
    }
  }

  resurrectBody() {
    this.removeDizzyEyes()
  }

  getTiles() {
    return [{ row: this.getRow(), col: this.getCol() }]
  }

  getSleepTween() {
    const firstSleepText = BitmapText.create({
      label: "SleepText",
      text: "Z", 
      align: 'center',
      spriteContainer: this.sleepStatusContainer
    })

    firstSleepText.sprite.alpha = 0

    const secondSleepText = BitmapText.create({
      label: "SleepText",
      text: "Z", 
      align: 'center',
      spriteContainer: this.sleepStatusContainer
    })

    secondSleepText.sprite.alpha = 0

    let launcher = new TWEEN.Tween({}).to({}, 0).onUpdate(() => {})
    launcher.onStop(() => {
      firstSleepText.remove()
      secondSleepText.remove()
    })

    let delay = 1000
    const firstSleepPositionTween = this.getPositionTween(firstSleepText.sprite, 0, Constants.tileSize, delay)
    const secondSleepPositionTween = this.getPositionTween(secondSleepText.sprite, 0, Constants.tileSize)
    firstSleepPositionTween.chain(launcher)

    launcher.chain(firstSleepPositionTween, secondSleepPositionTween)

    return launcher
  }

  getPositionTween(sprite, start, end, delay = 0) {
    let offset = { offset: start }

    return new TWEEN.Tween(offset)
        .to({ offset: end }, 3000)
        .onStart(() => {
          sprite.alpha = 0.8
        })
        .onUpdate(() => {
          sprite.position.x = offset.offset
          sprite.position.y = -(offset.offset*2)
          sprite.width = Math.max(12, Math.min(25, offset.offset))
          sprite.height = Math.max(12, Math.min(25, offset.offset))
        })
        .onComplete(() => {
          offset.offset = start
          sprite.alpha = 0
        })
        .delay(delay)
  }

  showSleepAnimation() {
    if (!this.sleepTween) {
      this.sleepTween = this.getSleepTween()
    }

    this.sleepTween.start()
  }

  hideSleepAnimation() {
    if (this.sleepTween) {
      this.sleepTween.stop()
      this.sleepTween = null
    }

    this.sleepStatusContainer.removeChildren()
  }


  getDisplayWidth() {
    let constantTable = this.getConstants().sprite
    if (constantTable && constantTable.width) {
      return constantTable.width
    } else {
      return this.getWidth()
    }
  }

  getDisplayHeight() {
    let constantTable = this.getConstants().sprite
    if (constantTable && constantTable.height) {
      return constantTable.height
    } else {
      return this.getHeight()
    }
  }

  animateHungerDecreased(delta) {
    const duration = 1500
    const yLength  = 50

    const message = '- ' + delta + ' hunger'

    const hungerText = BitmapText.create({
      label: "HungerText",
      text: message,
      size: 21,
      spriteContainer: this.game.sector.effectsContainer
    })

    hungerText.sprite.tint = 0xeeeeee

    let dimensions = {
      x: this.getX(),
      y: this.getY() - this.getHeight(),
      size: 64
    }

    hungerText.sprite.position.set(dimensions.x, dimensions.y)

    new TWEEN.Tween(dimensions) 
        .to({ x: dimensions.x, y: dimensions.y - yLength, size: 32 }, duration) 
        .easing(TWEEN.Easing.Quadratic.Out) 
        .onUpdate(() => { 
          hungerText.sprite.position.y = dimensions.y
          // sprite.width  = dimensions.size + 20
          // sprite.height = dimensions.size
        })
        .onComplete(() => {
          hungerText.remove()
        }) 
        .start()
  }


  isMovingEntity() {
    return this.isPlayer() || this.isMob()
  }

  getWidth() {
    return this.getConstants().width
  }

  getHeight() {
    return this.getConstants().height
  }


  static getConstantsTable() {
    return this.prototype.getConstantsTable()
  }

  getSpritePath() {
    let table = this.getConstants()
    if (table.sprite && table.sprite.path) {
      return table.sprite.path + ".png"
    }

    throw this.getTypeName() + " must implement getSpritePath"
  }

  getYScale() {
    return 1
  }

  getXScale() {
    return 1
  }

  getX() {
    return this.sprite.x
  }

  getY() {
    return this.sprite.y
  }

  getEffectInstance(name) {
    return this.effectInstances[name]
  }

}

Object.assign(BaseEntity.prototype, Definable.prototype, {
})

Object.assign(BaseEntity.prototype, Categorizable.prototype, {
})

Object.assign(BaseEntity.prototype, Taintable.prototype, {
  onEffectAdded(effect) {
    let klass = Effects.forName(effect)
    if (klass) {
      new klass(this)
    }
  },
  onEffectRemoved(effect) {
    const effectInstance = this.getEffectInstance(effect)
    if (effectInstance) {
      effectInstance.remove()
    }
  },
  onEffectLevelChanged(effect, level) {
    const effectInstance = this.getEffectInstance(effect)
    if (effectInstance) {
      effectInstance.onLevelChanged(level)
    }
  }
})


module.exports = BaseEntity

},{"../util/bitmap_text":648,"./../../../common/constants.json":656,"./../../../common/helper":664,"./../../../common/interfaces/categorizable":666,"./../../../common/interfaces/definable":669,"./../../../common/interfaces/taintable":679,"./../../../common/util/protocol":686,"./../util/client_helper":649,"./../util/interpolator":652,"./chat_bubble":330,"./effects/index":349}],207:[function(require,module,exports){
const BaseBuilding = require("./base_building")
const Constants = require("./../../../../common/constants.json")
const Protocol = require("./../../../../common/util/protocol")

class AirAlarm extends BaseBuilding {

  constructor(game, data, isEquipDisplay) {
    super(game, data, isEquipDisplay)
  }

  getType() {
    return Protocol.definition().BuildingType.AirAlarm
  }

  getSpritePath() {
    return "air_alarm.png"
  }

  getConstantsTable() {
    return "Buildings.AirAlarm"
  }

  getBuildingSprite() {
    let sprite = new PIXI.Container()

    this.baseSprite = new PIXI.Sprite(PIXI.utils.TextureCache["air_alarm_base.png"])
    this.baseSprite.name = "AirAlarmBase"
    this.baseSprite.anchor.set(0.5)

    this.lcdSprite = new PIXI.Sprite(PIXI.utils.TextureCache["air_alarm_lcd.png"])
    this.lcdSprite.name = "AirAlarmLED"
    this.lcdSprite.anchor.set(0.5)
    this.lcdSprite.position.y = -5

    sprite.addChild(this.baseSprite)
    sprite.addChild(this.lcdSprite)

    return sprite
  }


  onOpenChanged() {
    super.onOpenChanged()
    
    if (this.isOpen) {
      this.assignLighting()
      this.lcdSprite.tint = 0xeb2215 // red
    } else {
      this.unassignLighting()
      this.lcdSprite.tint = 0x07b24c // green
    }
  }

}

module.exports = AirAlarm

},{"./../../../../common/constants.json":656,"./../../../../common/util/protocol":686,"./base_building":211}],208:[function(require,module,exports){
const BaseBuilding = require("./base_building")
const Constants = require("./../../../../common/constants.json")
const Protocol = require("./../../../../common/util/protocol")
const SocketUtil = require("./../../util/socket_util")
const Wire = require("./wire")

class Airlock extends BaseBuilding {

  onBuildingConstructed() {
    super.onBuildingConstructed()

    this.isFirstLoad = true
  }

  isLightBlocker() {
    return !this.isOpen //  only if closed
  }

  static isPositionValid(container, x, y, w, h, angle, player) {
    let relativeBox = this.getBox(x, y, w, h)
    let structureSides = this.getSideTiles(container.structureMap, relativeBox)
    // let wallSides      = this.getSideTiles(container.armorMap, relativeBox)

    // let noAirtightWallBeside = wallSides.every((hit) => { return !hit.entity || (hit.entity && !hit.entity.isAirtight()) })
    // let noAirtightStructureBeside = structureSides.every((hit) => { return !hit.entity || (hit.entity && !hit.entity.isAirtight()) })

    let armorHits = container.armorMap.hitTestTile(relativeBox)
    const isEnemyArmor = armorHits.find((hit) => { return hit.entity && !hit.entity.isOwnedBy(player) })
    if (isEnemyArmor) return false

    return  this.isOnValidPlatform(container, x, y, w, h, angle, player) &&
                         // noAirtightStructureBeside &&
                         this.isWithinInteractDistance(x, y, player) &&
                         !this.isOnHangar(container, x, y, w, h) &&
                         !this.hasRailNeighbor(container, x, y, w, h) &&
                         !container.unitMap.isOccupied(x, y, w, h) &&
                         !container.railMap.isOccupied(x, y, w, h) &&
                         !container.structureMap.isOccupied(x, y, w, h)
  }


  onOpenChanged() {
    super.onOpenChanged()
    
    if (this.tween) this.tween.stop()

    if (this.isOpen) {
      this.open()
    } else {
      this.close()
    }

    if (this.isFirstLoad) {
      this.isFirstLoad = false
    } else {
      this.recalculateNearbyFov()
      // this.game.playSound("airlock", { minInterval: 5000, shouldDelete: false })
    }

    this.container.lightManager.invalidateLightSources(this.getRow(), this.getCol())
  }

  recalculateNearbyFov() {
    if (this.game.player && this.sector.isFovMode()) {
      let hits = this.constructor.getNeighborTiles(this.sector.structureMap, this.getRelativeBox())    
      this.game.player.recalculateFovIfHitPresent(hits)
    }
    
  }

  open() {
    this.tween = this.getOpenTween(Constants.tileSize * 2)
    this.tween.start()
  }

  close() {
    this.tween = this.getOpenTween(0)
    this.tween.start()
  }

  getUpgradeCost() {
    return 500
  }

  getMaxHealth() {
    let maxHealth = super.getMaxHealth()
    if (this.level === 1) return maxHealth * 2
    return maxHealth
  }

  getOpenTween(toPosition) {
    const fromPosition = this.upperDoorSprite.position.x
    let position = { position: fromPosition }

    return new TWEEN.Tween(position)
        .to({ position: toPosition }, 250)
        .onUpdate(() => {
          this.upperDoorSprite.position.x = position.position
          this.lowerDoorSprite.position.x = -position.position
        })
        .onComplete(() => {
        })
  }

  getType() {
    return Protocol.definition().BuildingType.Airlock
  }

  getBuildingSprite() {
    let sprite = new PIXI.Container()

    let texture = PIXI.utils.TextureCache[this.getSpritePath()]
    let baseSprite = new PIXI.Sprite(texture)
    baseSprite.name = "Hinge"
    baseSprite.anchor.set(0.5)

    texture = PIXI.utils.TextureCache["upper_door.png"]
    this.upperDoorSprite = new PIXI.Sprite(texture)
    this.upperDoorSprite.anchor.set(0.5)
    this.upperDoorSprite.name = "UpperDoor"

    texture = PIXI.utils.TextureCache["lower_door.png"]
    this.lowerDoorSprite = new PIXI.Sprite(texture)
    this.lowerDoorSprite.anchor.set(0.5)
    this.lowerDoorSprite.name = "LowerDoor"

    sprite.addChild(this.lowerDoorSprite)
    sprite.addChild(this.upperDoorSprite)
    sprite.addChild(baseSprite)

    return sprite
  }


  getSpritePath() {
    return "airlock_hinge.png"
  }

  getConstantsTable() {
    return "Buildings.Airlock"
  }

}

module.exports = Airlock

},{"./../../../../common/constants.json":656,"./../../../../common/util/protocol":686,"./../../util/socket_util":654,"./base_building":211,"./wire":325}],209:[function(require,module,exports){
const Ammos = require("./../ammos/index")
const Equipments = require("./../equipments/index")
const BaseBuilding = require("./base_building")
const Constants = require("./../../../../common/constants.json")
const Protocol = require("./../../../../common/util/protocol")

class AmmoPrinter extends BaseBuilding {

  constructor(game, data, isEquipDisplay) {
    super(game, data, isEquipDisplay)
  }

  openMenu() {
    const templateList = Ammos.getList()
    templateList.push(Equipments.Grenade)
    templateList.push(Equipments.PoisonGrenade)
    templateList.push(Equipments.Dynamite)
    templateList.push(this.sector.getTimerBombKlass())

    let options = {}
    if (!this.isPowered) {
      options["disabled"] = "Insufficient Power"
    }
    this.game.craftMenu.open("Ammo Printer", "Craft", this.id, templateList, options)
  }

  getType() {
    return Protocol.definition().BuildingType.AmmoPrinter
  }

  getSpritePath() {
    return "ammo_printer.png"
  }

  getConstantsTable() {
    return "Buildings.AmmoPrinter"
  }

}

module.exports = AmmoPrinter

},{"./../../../../common/constants.json":656,"./../../../../common/util/protocol":686,"./../ammos/index":191,"./../equipments/index":407,"./base_building":211}],210:[function(require,module,exports){
const Constants = require("./../../../../common/constants.json")
const Protocol = require("./../../../../common/util/protocol")
const BaseBuilding = require("./base_building")

class Atm extends BaseBuilding {

  getSpritePath() {
    return "atm.png"
  }

  openMenu() {
    this.game.atmMenu.open({ entity: this })
  }

  getType() {
    return Protocol.definition().BuildingType.Atm
  }

  getConstantsTable() {
    return "Buildings.Atm"
  }

}

module.exports = Atm

},{"./../../../../common/constants.json":656,"./../../../../common/util/protocol":686,"./base_building":211}],211:[function(require,module,exports){
const BaseEntity  = require("./../base_entity")
const Destroyable  = require("./../../../../common/interfaces/destroyable")
const Powerable  = require("./../../../../common/interfaces/powerable")
const Upgradable = require("./../../../../common/interfaces/upgradable")
const ShipMountable = require("./../../../../common/interfaces/ship_mountable")
const Resource = require("./../../../../common/interfaces/resource")
const Conductor = require("./../../../../common/interfaces/conductor")
const Drainable = require("./../../../../common/interfaces/drainable")
// const Tileable  = require("./../../../../common/interfaces/tileable")
const Constants = require("./../../../../common/constants.json")
const HealthBar = require("./../../components/health_bar")
const ProgressBar = require("./../../components/progress_bar")
const Protocol = require("./../../../../common/util/protocol")
const Helper = require("./../../../../common/helper")
const SocketUtil = require("../../util/socket_util")
const ClientHelper = require("./../../util/client_helper")
const SpriteEventHandler = require("./../../util/sprite_event_handler")
const BaseBuildingCommon = require("./../../../../common/entities/base_building_common")
const NetworkSprite = require("./../network_sprite")
const BitmapText = require("../../util/bitmap_text")

let attributeHandlers = {}

class BaseBuilding extends BaseEntity {
  static build(game, data) {
    return new this(game, data)
  }

  static numOfTilesMultiplier() {
    return this.getConstants().width / Constants.tileSize
  }

  static getGroup() {
    return "structures"
  }

  static initAttributeHandlers() {
    for (let attribute in Protocol.definition().Building.fields) {
      attributeHandlers[attribute] = "set" + Helper.capitalize(attribute)
    }
  }

  getSelectionSprite() {
  }

  getTiles() {
    let hits = this.container.groundMap.hitTestTile(this.getRelativeBox())
    return hits.map((hit) => {
      return { row: hit.row, col: hit.col }
    })
  }

  static getSellGroup() {
    return "Buildings"
  }

  constructor(game, data) {
    super(game, data)

    this.collider = data.collider
    this.isLaunched = data.isLaunched
    this.isEquipDisplay = data.isEquipDisplay
    this.fireLevel = data.fireLevel
    this.owner = data.owner
    this.level = data.level || 0
    this.isStatic = true
    this.lightings = []
    this.lighting  = null
    this.networks = {}
    this.networkSprites = {}
    this.chunks = {}
    this.localeContents = {}

    this.row = this.getRow()
    this.col = this.getCol()

    if (this.isEquipDisplay) {
      this.buildingSprite.alpha = 0.7
      this.setBaseRotation(this.getDefaultRotation())
      this.setAngle(this.getDefaultRotation())
      this.postBuildingEquipDisplayed()
    } else if (!this.isEquipment()) {
      this.setBaseRotation(data.origAngle)
      this.setAngle(data.angle)
      this.initDestroyable()
      this.getChunk().register("buildings", this)
      this.onBuildingConstructed() // subclasses might override

      if (data.hasOwnProperty('buildProgress')) {
        this.setBuildProgress(data.buildProgress)
      }

      this.assignLighting()
      this.updateChunkSprite()

      this.postBuildingConstructed()
    }

    this.health = data.health
    // this.initColliderDebug()
    this.drawColliderDebug()
  }

  postBuildingEquipDisplayed() {
    if (this.game.isMobile()) {
      // this.game.buildActionMenu.position.x =
    }
  }

  onShadowRendered() {

  }

  isEquipment() {
    return false
  }

  getStorageCount() {
    return this.getConstants().storageCount
  }

  getTintableSprite() {
    return this.buildingSprite
  }

  isNotForSale() {
    return false
  }

  isMaxUpgradeReached() {
    return Object.keys(this.getUpgradeProgress()).length === 0
  }

  isUsable() {
    return this.shouldShowInteractTooltip() || this.hasMenu()
  }

  setIsOpen(isOpen) {
    if (this.isOpen !== isOpen) {
      this.isOpen = isOpen
      this.onOpenChanged()
    }
  }

  setTargets(targets) {
    let prevTargets = this.targets
    this.targets = targets

    if (this.targets !== prevTargets) {
      if (this.game.entityMenu.isOpen(this)) {
        this.game.entityMenu.update(this)
      }
    }
  }

  getEffectableSprite() {
    return this.buildingSprite
  }

  onOpenChanged() {
    this.sector.onSelectionChanged(this.sector.selection.selectedEntity)
  }

  break(breakProgress) {
    this.isBreaking = true

    this.setEffectLevel("break", breakProgress)
  }

  initColliderDebug() {
    if (!this.collider) return
    this.colliderSprite = new PIXI.Graphics()
    this.colliderSprite.name = "collider"
    this.getSpriteContainer().addChild(this.colliderSprite)
  }

  getMenuDescription() {
    return this.getConstants().menuDescription
  }

  drawColliderDebug() {
    return
    if (!this.collider) return

    let points = this.collider.map((point) => { return [point.x, point.y] })
    points = [].concat.apply([], points)
    this.colliderSprite.clear()
    this.colliderSprite.lineStyle(5, 0xff0000, 0.7)
    this.colliderSprite.drawPolygon(points)
    this.colliderSprite.endFill()
  }

  setCollider(collider) {
    this.collider = collider
    this.drawColliderDebug()
  }

  isShipCore() {
    return false
  }

  getDefaultRotation() {
    return -90
  }

  static getMaxCountFor(ship) {
    return this.prototype.getStats(ship.level).count
  }

  onClick(options) {
    if (this.isEquipDisplay) return

    if (this.game.isChunkDisplayEnabled) {
      this.handleDoubleClick(() => {
        this.game.showChunkRegionPathForEntity(this)
      })
    }

    if (!Helper.isTargetWithinRange(this.game.player, this)) {
      return
    }

    let shouldProceedClick = this.clickBuilding(options)
    if (!shouldProceedClick) return

    if (this.hasCategory("power_consumer") ) {
      if (this.isPowered) {
        this.onPostClick()
      }
    } else {
      this.onPostClick()
    }
  }

  onPostClick() {

  }

  clickBuilding(options) {
    if (this.game.player.isControllingGhost()) return

    this.game.selectEntity(this)
    this.game.showEntityMenu(this, { dontCloseMenus: true, selectedEntity: this, replaceSelected: true })

    if (options.isRightClick) {
      this.game.interact(this)
    }

    return true
  }

  hasRangeDisplay() {
    return false
  }

  onMouseOver() {
    super.onMouseOver()

    if (this.isEquipDisplay) return

    let distance = Helper.distance(this.game.player.getX(), this.game.player.getY(), this.getX(), this.getY())
    if (!Helper.isTargetWithinRange(this.game.player, this)) {
      return
    }

    if (this.hasRangeDisplay()) {
      this.drawRange()
    }

    this.game.player.setActTarget(this)

    if (this.shouldShowEntityMenu()) {
      this.game.showEntityMenu(this, { dontCloseMenus: true })
    }

    if (this.isInteractable() && !this.game.player.isControllingGhost()) {
      this.game.highlight(this)
      this.game.player.setMouseTarget(this)
    }
  }

  shouldShowInteractTooltip() {
    if (this.isConstructionInProgress()) return false

    return super.shouldShowInteractTooltip()
  }

  shouldShowEntityMenu() {
    return true
  }

  onMouseOut() {
    super.onMouseOut()

    if (this.isEquipDisplay) return

    this.isMouseOver = false
    this.game.player.setMouseTarget(null)

    if (this.hasRangeDisplay()) {
      this.hideRange()
    }

    if (this.game.player.getActTarget() === this) {
      this.game.player.setActTarget(null)
    }

    if (this.shouldShowEntityMenu()) {
      this.game.hideEntityMenu()
    }

    if (this.isInteractable()) {
      this.game.unhighlight(this)
    }
  }

  belongsToPlayer(player) {
    return this.owner && this.owner.id === player.getBuildOwnerId()
  }

  static getUpgradeProgress() {
    return this.prototype.getUpgradeProgress()
  }

  getUpgradeType() {
    return "buildings"
  }

  animateDestruction() {
    const smokeCount = 4
    for (var i = 0; i < smokeCount; i++) {
      ClientHelper.addSmoke(this.getX(), this.getY())
    }
  }

  isTower() {
    return false
  }

  rotateEquip() {
    let currentRotation = this.angle
    currentRotation += 90
    if (currentRotation === 270) {
      currentRotation = -90
    }
    this.setAngle(currentRotation)
    this.setBaseRotation(currentRotation)

    let lastClientX = this.game.inputController.lastClientX
    let lastClientY = this.game.inputController.lastClientY

    this.renderAtMousePosition(lastClientX, lastClientY)

    this.renderInvalidArea()
  }

  setBaseRotation(angle) {
    if (this.baseRotation !== angle) {
      this.origAngle = this.baseRotation = angle
    }
  }

  setAngle(deg) {
    if (deg === this.angle) return // no change in rotation

    // override, we want to rotate buildingSprite, not the container
    this.angle = deg
    this.buildingSprite.rotation = this.getRadAngle()

    // if (this.isEquipDisplay) {
    //   const position = this.game.app.renderer.plugins.interaction.mouse.global
    //   this.renderAtMousePosition(position.x, position.y)
    // }
  }

  setLocaleContents(localeContents) {
    this.localeContents = localeContents
  }

  renderEntityMenu(entityMenu) {
    this.showLighting(this.container, entityMenu)
    this.showStats(entityMenu)
    this.showAction(entityMenu)
    this.showLogs(entityMenu)
    this.showTargets(entityMenu)
    this.showPermissions(entityMenu)
  }

  hasTargets() {
    return this.hasCategory("editable_targets")
  }

  hasPermissions() {
    return this.hasCategory("editable_permissions")
  }

  getName() {
    return this.getTypeName() + " " + this.id
  }

  showTargets(entityMenu) {
    if (!this.hasTargets()) return

    let targetNames = Object.keys(Protocol.definition().AttackTargetType)
    for (let i = 0; i < targetNames.length; i++) {
      let targetName = targetNames[i]
      let targetId = Protocol.definition().AttackTargetType[targetName]
      let bitValue = (this.targets >> targetId) % 2
      let isEnabled = bitValue === 1
      let checkbox = entityMenu.querySelector(`.attack_target[data-target-id='${targetId}'] input`)

      if (isEnabled) {
        checkbox.checked = true
      } else {
        checkbox.checked = false
      }
    }
  }

  shouldShowCustomAccessSelect() {
    return true
  }

  showPermissions(entityMenu) {
    if (!this.hasPermissions()) return

    if (this.isCustomAccess) {
      entityMenu.querySelector(".entity_permission_roles").style.display = 'block'
      entityMenu.querySelector(".custom_access_select").value = 'custom'
    } else {
      entityMenu.querySelector(".entity_permission_roles").style.display = 'none'
      entityMenu.querySelector(".custom_access_select").value = 'default'
    }

    if (this.shouldShowCustomAccessSelect()) {
      entityMenu.querySelector(".custom_access_select").style.display = 'block'
    } else {
      entityMenu.querySelector(".custom_access_select").style.display = 'none'
    }


    // slave role
    let slaveRoleId = 3
    this.renderPermissionCheckbox(entityMenu, slaveRoleId)

    for (let id in this.game.roles) {
      let role = this.game.roles[id]
      this.renderPermissionCheckbox(entityMenu, role.id)
    }
  }

  renderPermissionCheckbox(entityMenu, roleId) {
    let bitValue = (this.accessType >> roleId) % 2
    let isEnabled = bitValue === 1
    let checkbox = entityMenu.querySelector(`.permission_role[data-role-id='${roleId}'] input`)
    if (!checkbox) return

    if (isEnabled) {
      checkbox.checked = true
    } else {
      checkbox.checked = false
    }
  }


  showLogs(entityMenu) {
    entityMenu.querySelector(".entity_logs").innerHTML = ""
  }

  showAction(entityMenu) {
    let html = this.getActions()
    if (html) {
      entityMenu.querySelector(".entity_action").innerHTML = html
    }
  }

  getActions() {
    let buttons = this.sector.getButtonsFor(this.getTypeNameCamelCase())
    let html = ""

    buttons.forEach((button) => {
      html += button.buildHTML(this)
    })

    return html
  }

  initPermissionSelectListener(entityMenu) {
    entityMenu.querySelector(".allow_access_select").addEventListener("change", this.onAllowAccessSelectChanged.bind(this))
  }

  onAllowAccessSelectChanged(e) {
    e.preventDefault()
    let value = e.target.value
    SocketUtil.emit("EditBuilding", { id: this.id, accessType: value })
  }

  setAllowAccessSelectDefault(entityMenu) {
    if (typeof this.accessType !== 'undefined') {
      entityMenu.querySelector(".allow_access_select").value = this.accessType
    } else {
      entityMenu.querySelector(".allow_access_select").value = -1
    }
  }

  showStats(entityMenu) {
    entityMenu.querySelector(".entity_stats").innerHTML = this.getEntityMenuStats()
  }

  getEntityMenuStats() {
    let el = ""

    if (this.decayStartTimestamp) {
      let decayEndTimestamp = this.decayStartTimestamp + Constants.physicsTimeStep * Constants.decayThresholdInSeconds
      let seconds = (decayEndTimestamp - game.timestamp) / Constants.physicsTimeStep
      let minute = Math.ceil(seconds / 60)
      if (minute < 0) minute = 0
      el += "<div class='entity_decay_timer'>Decay in " + minute + " min</div>"
    }

    if (!this.dontShowHealth()) {
      el += this.getHealthStat()
    }

    el += this.getOwnershipStat({ showMissingOwnership: true })

    let resources = ["power", "oxygen", "liquid", "fuel"]
    let types = ["consumer", "producer", "storage"]

    let primaryResource = this.getPrimaryResource()
    if (primaryResource) {
      resources = [primaryResource]
    }

    resources.forEach((resource) => {
      types.forEach((type) => {
        let category = [resource, type].join("_")
        if (this.hasCategory(category)) {
          el += this.getResourceStat(resource, type)
        }
      })

    })


    if (this.hasCategory("editable_permissions")) {
      let canManagePermissions = this.belongToOwner(this.game.player) &&
                                 this.game.player.isAdmin()

      if (!canManagePermissions) {
        el += this.getPermissionStat()
      }
    }

    if (this.hasCategory("spawnpoint") && this.content) {
      let canManageSpawn = this.belongToOwner(this.game.player) && this.game.player.isAdmin()
      if (!canManageSpawn) {
        el += this.getSpawnPointStat()
      }
    }


    return el
  }

  getPrimaryResource() {
    return this.getConstants().primaryResource
  }

  getUnitForResource(resource) {
    if (resource === "power") {
      return "W"
    } else if (resource === "oxygen") {
      return "%"
    } else if (resource === "liquid") {
      return "L"
    } else if (resource === "fuel") {
      return "L"
    }
  }

  getResourceStat(resource, type) {
    let el = ""
    let unit = this.getUnitForResource(resource)

    if (type === "producer") {
      el += this.getProducerStat(resource, unit)
    }

    if (type === "consumer") {
      el += this.getConsumerStat(resource, unit)
    }

    if (type === "storage") {
      el += this.getStorageStat(resource, unit)
    }

    return el
  }

  getFillBarMaxWidth() {
    return 36
  }

  redrawEntityUsage() {
    let shouldRedraw = this.hasCategory("power_storage") ||
                       this.hasCategory("oxygen_storage") ||
                       this.hasCategory("fuel_storage") ||
                       this.hasCategory("liquid_storage")

    if (shouldRedraw) {
      const usageRate = this.getUsage() / this.getUsageCapacity()

      if (this.hasFillBar()) {
        this.fillBar.height = usageRate * this.getFillBarMaxWidth()
      }

      if (this.game.entityMenu.isOpen(this)) {
        this.game.entityMenu.update(this)
      }
    }
  }

  hasFillBar() {
    return this.getConstants().hasFillBar
  }

  getResourceStored(name) {
    return this.usage
  }

  canMenuBeOpened() {
    return this.isConstructionFinished()
  }

  getStorageStat(name, unit = "") {
    let capacity = this.getResourceCapacity(name)
    let usage = this.usage

    if (!usage) return ""

    const el = "<div class='entity_stats_entry'>" +
                      "<div class='stats_type'>" + i18n.t('Stored') + ":</div>" +
                      "<div class='stats_value'>" + usage + "/" + capacity + " " + unit + "</div>" +
                  "</div>"
    return el
  }

  getConsumerStat(name, unit = "") {
    if (name !== "power") return ""

    let consumption = this.getResourceConsumption(name)

    let resourceNeedLabel  = Helper.capitalize(name) + " Needed"

    const el = "<div class='entity_stats_entry'>" +
                  "<div class='stats_type'>" + i18n.t(resourceNeedLabel)  + ": </div>" +
                  "<div class='stats_value'>" + consumption + " " + unit + "</div>" +
              "</div>"

    return el
  }

  getHealthStat() {
    let el = "<div class='entity_stats_entry'>" +
                    "<div class='stats_type'>" + i18n.t('Entity.Health') + ":</div>" +
                    "<div class='stats_value'>" + this.health + "/" + this.getMaxHealth() + "</div>" +
                "</div>"
    return el
  }

  getPositionStat() {
    let el = "<div class='entity_stats_entry'>" +
                    "<div class='stats_type'>Row, Col:</div>" +
                    "<div class='stats_value'>(" + [this.getRow(), this.getCol()].join(",") + ")</div>" +
                "</div>"
    return el
  }

  getProducerStat(name, unit = "") {
    if (name === "oxygen") return ""

    let production = this.getResourceProduction(name)

    let el = "<div class='entity_stats_entry'>" +
                    "<div class='stats_type'>" + i18n.t('Production') + ":</div>" +
                    "<div class='stats_value'>" + production + " " + unit + "</div>" +
                "</div>"

    return el
  }

  setContent(content) {
    if (this.content !== content) {
      this.content = content
      this.onContentChanged()
    }
  }

  getGold() {
    return this.content || 0
  }

  onContentChanged() {

  }

  getSelectionWidth() {
    return this.getRotatedWidth()
  }

  getSelectionHeight() {
    return this.getRotatedHeight()
  }

  getRotatedWidth() {
    return Math.round(Math.abs(Math.cos(this.getRadOrigAngle())) * this.getWidth() + Math.abs(Math.sin(this.getRadOrigAngle())) * this.getHeight())
  }

  getRadOrigAngle() {
    return this.origAngle * (Math.PI / 180)
  }

  getRotatedHeight() {
    return Math.round(Math.abs(Math.cos(this.getRadOrigAngle())) * this.getHeight() + Math.abs(Math.sin(this.getRadOrigAngle())) * this.getWidth())
  }

  /*
    1x1,1x2,2x1
  */
  createInProgressBorderSprite() {
    let graphics = new PIXI.Graphics()
    graphics.name = "building_in_progress_border"

    const lineStyle = {
      lineWidth: 4,
      color: 0xeeeeee,
      alpha: 0.7
    }

    padding = 2

    graphics.lineStyle(lineStyle.lineWidth, lineStyle.color)
    graphics.drawRect(-this.getRotatedWidth()/2 + padding, -this.getRotatedHeight()/2 + padding, this.getRotatedWidth() - (padding * 2), this.getRotatedHeight() - (padding * 2))
    graphics.endFill()
  }

  getSprite() {
    const sprite = new PIXI.Container()
    sprite.name = this.constructor.name

    // building sprite
    this.buildingSprite = this.getBuildingSprite()
    this.buildingSprite.name = "Building"

    if (this.hasFillBar()) {
      this.buildingSprite.addChild(this.createFillBar())
    }

    sprite.addChild(this.buildingSprite)

    return sprite
  }

  createFillBar() {
    this.fillBarContainer = new PIXI.Sprite(PIXI.utils.TextureCache["gas_fill_bar_container.png"])
    this.fillBarContainer.name = "FillBarContainer"
    this.fillBarContainer.anchor.set(0.5)
    this.fillBarContainer.position.x = -36
    this.fillBarContainer.height = 32

    this.fillBar = new PIXI.Sprite(PIXI.utils.TextureCache["gas_fill_bar.png"])
    this.fillBar.name = "FillBar"
    this.fillBar.anchor.x = 0.5
    this.fillBar.anchor.y = 0
    this.fillBar.width = 6
    this.fillBar.height = 0
    this.fillBar.position.y = -18

    this.fillBarContainer.addChild(this.fillBar)

    return this.fillBarContainer
  }

  getSpriteContainer() {
    const isOnCeiling = this.getConstants().isOnCeiling
    let group = isOnCeiling ? "ceilings" : this.getSpriteLayerGroup()

    if (this.isEquipment()) {
      return this.data.user.handEquipContainer
    } else if (this.data.isEquipDisplay) {
      return this.container.spriteLayers[group]
    } else {
      return this.container.getSpriteLayerForChunk(group, this.getChunkRow(), this.getChunkCol())
    }
  }

  isChunkable() {
    if (this.data.isEquipDisplay) return false

    if (this.getContainer().isMovable()) return false

    let chunkableGroups = ["platforms", "distributions", "armors"]
    return !this.isEquipment() && chunkableGroups.indexOf(this.getGroup()) !== -1
  }

  updateChunkSprite() {
    if (!this.isChunkable()) return

    this.getChunk().updateSprite(this)
  }

  getGroup() {
    return "structures"
  }

  getSpriteLayerGroup() {
    return this.getGroup()
  }

  onPositionChanged() {

  }

  onGridPositionChanged() {
    this.renderInvalidArea()
  }

  getRelativeBox() {
    if (!this.container.isMovable()) {
      return this.getBox(this.getX(), this.getY(), this.getRotatedWidth(), this.getRotatedHeight())
    } else {
      return this.getBox(this.getRelativeX(), this.getRelativeY(), this.getRotatedWidth(), this.getRotatedHeight())
    }
  }

  isAirtight() {
    return false
  }

  static getPaddedRelativeBox(box) {
    return {
      pos: {
        x: box.pos.x - Constants.tileSize,
        y: box.pos.y - Constants.tileSize
      },
      w: box.w + Constants.tileSize * 2,
      h: box.h + Constants.tileSize * 2
    }
  }

  getPaddedBox() {
    const box = this.getBox()

    box.pos.x -= Constants.tileSize
    box.pos.y -= Constants.tileSize
    box.w += (Constants.tileSize * 2)
    box.h += (Constants.tileSize * 2)

    return box
  }

  calculateInvalidBox(tileCollisionMap) {
    let lowerBound = { row: null, col: null }
    let upperBound = { row: null, col: null }

    let containsInvalid = false

    for (let mapType in tileCollisionMap) {
      let collisionTiles = tileCollisionMap[mapType]

      collidedTiles.forEach((hit) => {
        if (hit.entity !== 0) {
          containsInvalid = true

          lowerBound.row = lowerBound.row !== null ? Math.min(lowerBound.row, hit.row) : hit.row // must use null comparison instead of 0, because 0 will be interpreted as falsy
          lowerBound.col = lowerBound.col !== null ? Math.min(lowerBound.col, hit.col) : hit.col

          upperBound.row = upperBound.row !== null ? Math.max(upperBound.row, hit.row) : hit.row
          upperBound.col = upperBound.col !== null ? Math.max(upperBound.col, hit.col) : hit.col
        }
      })
    }


    return {
      lowerBound: lowerBound,
      upperBound: upperBound
    }
  }

  onBuildStart() {
    if (this.hasDistributionRole()) {
      this.game.sector.spriteLayers["armors"].alpha = 0.5
      this.game.sector.spriteLayers["structures"].alpha = 0.5
    }
  }

  onBuildStop() {
    if (this.hasDistributionRole()) {
      this.game.sector.spriteLayers["armors"].alpha = 1
      this.game.sector.spriteLayers["structures"].alpha = 1
    }
  }

  animateWalk(entity) {

  }

  getBuildingSprite() {
    let texture = PIXI.utils.TextureCache[this.getSpritePath()]
    let sprite = this.createSprite(texture)
    sprite.name = [this.constructor.name, "building"].join("_")

    sprite.anchor.set(0.5)
    sprite.scale.y = this.getYScale()
    sprite.scale.x = this.getXScale()

    if (!this.shouldUseOriginalWidth()) {
      sprite.width = this.getDisplayWidth()
      sprite.height = this.getDisplayHeight()
    }

    return sprite
  }

  getRotatedAngle() {
    return this.container.getRadAngle() + this.getRadAngle()
  }

  setAttribute(attribute) {

  }

  setResourceStorages(resourceStorages) {
    for (let resource in resourceStorages) {
      let resourceStorage = resourceStorages[resource]
      let clientResource = this.getStats().clientResource

      // building could have multiple resource usages (i.e liquid + oxygen)
      // only setUsage for the clientResource
      if (clientResource === resource) {
        this.setUsage(resourceStorage.usage)
      }
    }
  }

  setColorIndex(colorIndex) {
    this.colorIndex = colorIndex
  }

  setTextureIndex(textureIndex) {
    this.textureIndex = textureIndex
  }

  setIsHarvestable(isHarvestable) {

  }

  setIsPowered(powerStatus) {
    this.setPowerStatus(powerStatus)
  }

  setIsProcessing(isProcessing) {
    if (this.isProcessing !== isProcessing) {
      this.isProcessing = isProcessing
      this.onIsProcessingChanged()
    }
  }

  setAccessType(accessType) {
    if (this.accessType !== accessType) {
      this.accessType = accessType
      this.onAccessTypeChanged()
    }
  }

  setIsCustomAccess(isCustomAccess) {
    if (this.isCustomAccess !== isCustomAccess) {
      this.isCustomAccess = isCustomAccess
      this.onIsCustomAccessChanged()
    }
  }

  onIsCustomAccessChanged() {
    if (this.game.entityMenu.isOpen(this)) {
      this.game.entityMenu.update(this)
    }
  }

  onAccessTypeChanged() {
    if (this.game.entityMenu.isOpen(this)) {
      this.game.entityMenu.update(this)
    }
  }

  getPermissionStat(accessType) {
    let allowedRoles = []

    if (this.isRoleAllowed(3)) {
      allowedRoles.push(i18n.t("Slave"))
    }

    for (let id in this.game.roles) {
      let role = this.game.roles[id]
      if (this.isRoleAllowed(role.id)) {
        allowedRoles.push(i18n.t(role.name))
      }
    }

    let roles = this.isCustomAccess ? allowedRoles.join(", ") : "Default"

    let el = "<div class='entity_stats_entry'>" +
                  "<div class='stats_type'>" + i18n.t('Permission') + ":</div>" +
                  "<div class='stats_value access_role_stats_value'>" + roles + "</div>" +
              "</div>"
    return el
  }

  getSpawnPointStat() {
    let label = ""
    let group = "For"

    if (this.content === 'everyone') {
      label = "Everyone"
    } else {
      group = this.content.split("-")[0]
      let value = this.content.split("-")[1]
      if (group === 'role') {
        let role = this.game.roles[value]
        if (role) {
          label = role.name
        }
      } else if (group === 'team') {
        let team = this.game.teams[value]
        if (team) {
          label = team.name
        }
      }
    }

    let el = "<div class='entity_stats_entry'>" +
                  "<div class='stats_type'>" + i18n.t(Helper.capitalize(group)) + ":</div>" +
                  "<div class='stats_value spawn_point_filter_stats_value'>" + label + "</div>" +
              "</div>"
    return el
  }

  isRoleAllowed(roleId) {
    let bitValue = (this.accessType >> roleId) % 2
    let isEnabled = bitValue === 1
    return isEnabled
  }

  onIsProcessingChanged() {

  }

  setIsWatered(isWatered) {
    if (this.isWatered !== isWatered) {
      this.isWatered = isWatered
      this.onIsWateredChanged()
    }
  }

  setBuildProgress(buildProgress) {
    if (this.buildProgress !== buildProgress) {
      this.buildProgress = buildProgress
      this.onBuildProgressChanged()
    }
  }

  getMaxBuildProgress() {
    return 100
  }

  onBuildProgressChanged() {
    let percentProgress = this.buildProgress / this.getMaxBuildProgress()
    if (this.isConstructionFinished()) {
      this.buildingSprite.alpha = 1

      if (this.progressBar) {
        this.progressBar.remove()
        this.progressBar = null
      }

      this.updateChunkSprite()
    } else if (this.buildProgress > 0) {
      this.buildingSprite.alpha = 0.3 + (0.7 * percentProgress)

      this.initProgressBar()
      this.progressBar.draw()
    } else if (this.buildProgress === 0) {
      this.buildingSprite.alpha = 0.3
    }
  }

  isConstructionInProgress() {
    return !this.isConstructionFinished()
  }

  isConstructionFinished() {
    if (this.buildProgress === null || typeof this.buildProgress === 'undefined') {
      return true
    }

    return this.buildProgress >= this.getMaxBuildProgress()
  }

  initProgressBar() {
    if (this.progressBar) return

    this.progressBar = new ProgressBar(this, {
      attribute: "buildProgress",
      maxAttribute: "getMaxBuildProgress",
      isFixedPosition: true
    })
  }

  removeProgressBar() {
    if (this.progressBar) {
      this.progressBar.remove()
    }
  }


  onIsWateredChanged() {

  }

  syncWithServer(data) {
    for (let attribute in data) {
      let value = data[attribute]
      if (Helper.isProtobufAttributeSet(data, attribute)) {
        let handler = this[attributeHandlers[attribute]]
        if (handler) {
          handler.call(this, data[attribute])
        }
      }
    }

  }

  setOwner(owner) {
    this.owner = owner
  }

  setUnowned(unowned) {
    this.unowned = unowned
  }

  setNeighbors(neighbors) {
    if (this.neighbors !== neighbors) {
      this.neighbors = neighbors
      this.onNeighborChanged()
    }
  }

  setName(name) {
    this.name = name
    this.onNameChanged()
  }

  onNameChanged() {
    this.createNameSpriteIfNotPresent()
    this.nameText.sprite.text = this.name
  }

  createNameSpriteIfNotPresent() {
    if (!this.nameSprite) {
      const margin = this.getRotatedHeight() - this.getRotatedHeight()/4

      this.nameSprite = new PIXI.Container()
      this.nameSprite.position.x = this.getX() 
      this.nameSprite.position.y = this.getY() + margin
      this.nameSprite.name = "NameContainer"

      this.nameText = BitmapText.create({ 
        label: "NameText",
        text: this.name, 
        align: 'center',
        spriteContainer: this.nameSprite
      })

      this.sector.effectsContainer.addChild(this.nameSprite)
    }
  }

  onNeighborChanged() {
    this.redrawSprite()
  }

  isOwnedBy(player) {
    if (!this.owner) return false
    return this.owner.id === player.getBuildOwnerId()
  }

  setPowerNetwork(network) {
    this.removeAndReplaceNetwork("power", network)
  }

  setFuelNetwork(network) {
    this.removeAndReplaceNetwork("fuel", network)
  }

  setOxygenNetwork(network) {
    this.removeAndReplaceNetwork("fuel", network)
  }

  setLiquidNetwork(network) {
    this.removeAndReplaceNetwork("fuel", network)
  }

  setRailNetwork(network) {
    this.removeAndReplaceNetwork("rail", network)
  }

  setSoilNetwork(network) {
    this.removeAndReplaceNetwork("soil", network)
  }

  removeAndReplaceNetwork(type, network) {
    this.removeNetwork(type)

    if (network.id !== 0) {
      this.setNetwork(type, network.id)
    }
  }

  removeNetworks() {
    Object.keys(this.networks).forEach((networkType) => {
      this.removeNetwork(networkType)
    })
  }

  setNetwork(type, id) {
    let prevNetwork = this.networks[type]
    this.networks[type] = id

    if (prevNetwork !== this.networks[type]) {
      this.onNetworkChanged(type, id)
    }
  }

  isBuildingType() {
    return true
  }

  isItemStorage() {
    return this.getStorageCount() > 1
  }

  removeNetwork(type) {
    delete this.networks[type]

    if (this.networkSprites[type]) {
      this.networkSprites[type].remove()
    }

    delete this.networkSprites[type]
  }

  onNetworkChanged(type, id) {
    this.updateNetworkSprite(type, id)
  }

  updateNetworkSprite(type, id) {
    return
    if (this.networkSprites[type]) {
      this.networkSprites[type].remove()
    }

    this.networkSprites[type] = new NetworkSprite(this.game, {
      container: this.container,
      type: type,
      id: id,
      x: this.getX(),
      y: this.getY()
    })
  }

  showPowerOff() {
    this.powerOffSprite = new PIXI.Sprite(PIXI.utils.TextureCache["power_off.png"])
    this.powerOffSprite.anchor.set(0.5)
    this.powerOffSprite.width  = Constants.tileSize * 3/4
    this.powerOffSprite.height = Constants.tileSize * 3/4

    this.buildingSprite.addChild(this.powerOffSprite)

    this.powerTween = this.getPowerTween()
    this.powerTween.start()
  }

  getSpawnTween() {
    let alpha = { alpha: 0.4 }

    var tween = new TWEEN.Tween(alpha)
        .to({ alpha: 0 }, 500)
        .onUpdate(() => {
          this.buildingSprite.alpha = alpha.alpha
        })
        .yoyo(true)
        .repeat(Infinity)

    return tween
  }

  getPowerTween() {
    let alpha = { alpha: 1 }

    var tween = new TWEEN.Tween(alpha)
        .to({ alpha: 0.3 }, 500)
        .onUpdate(() => {
          this.powerOffSprite.alpha = alpha.alpha
        })
        .yoyo(true)
        .repeat(Infinity)

    return tween
  }

  removePowerOff() {
    if (this.powerOffSprite) {
      if (this.powerOffSprite.parent) {
        this.powerOffSprite.parent.removeChild(this.powerOffSprite)
      }
      this.powerTween.stop()
    }
  }

  setIsLaunched(isLaunched) {
    if (this.isLaunched !== isLaunched) {
      this.isLaunched = isLaunched
      this.onLaunchedChanged()
    }
  }

  setIsUnderConstruction(isUnderConstruction) {
    if (this.isUnderConstruction !== isUnderConstruction) {
      this.isUnderConstruction = isUnderConstruction
      this.onIsUnderConstructionChanged()
    }
  }

  setDecayStartTimestamp(decayStartTimestamp) {
    this.decayStartTimestamp = decayStartTimestamp
    this.onDecayStartTimestampChanged()
  }

  onDecayStartTimestampChanged() {
  }

  onIsUnderConstructionChanged() {
    if (!this.isUnderConstruction) {
      this.setBuildProgress(100)
    }
  }

  onLaunchedChanged() {

  }

  setLevel(level) {
    const prevLevel = this.level

    this.level = level

    if (this.level !== prevLevel && this.level !== 0) {
      this.onLevelIncreased()
    }
  }

  onLevelIncreased() {
    if (this.game.isEntityMenuOpenFor(this)) {
      this.game.showEntityMenu(this)
    }
  }

  getXYPosition() {
    return {
      x: this.getX(),
      y: this.getY()
    }
  }

  getCollisionGroup() {
    return "collisionGroup.Building"
  }

  getType() {
    throw new Error("must implement BaseBuilding.getType")
  }

  getGroupType() {
    return "building"
  }

  toJson() {
    return {
      type: this.getType(),
      x: this.getX(),
      y: this.getY()
    }
  }

  getDamage() {
    return 0
  }

  getRange() {
    return 0
  }

  static isOnHangar(container, x, y, w, h) {
    const hits = container.platformMap.hitTestTile(this.getBox(x, y, w, h))
    return hits.find((hit) => { return hit.entity && hit.entity.isHangar() })
  }

  static hasRailNeighbor(container, x, y, w, h) {
    let paddedBox = this.getPaddedRelativeBox(this.getBox(x,y,w,h))
    return container.railMap.hitTestTile(paddedBox).find((hit) => {
      return hit.entity
    })
  }

  static isPositionValid(container, x, y, w, h, angle, player) {
    const hits = container.platformMap.hitTestTile(this.getBox(x, y, w, h))
    const hasSoil = hits.find((hit) => { return hit.entity && hit.entity.hasCategory("soil") })

    return this.isOnValidPlatform(container, x, y, w, h, angle, player) &&
           this.isWithinInteractDistance(x, y, player) &&
           !this.isOnHangar(container, x, y, w, h) &&
           !this.hasRailNeighbor(container, x, y, w, h) &&
           !hasSoil &&
           !container.railMap.isOccupied(x, y, w, h) &&
           !container.unitMap.isOccupied(x, y, w, h) &&
           !container.armorMap.isOccupied(x, y, w, h) &&
           !container.structureMap.isOccupied(x, y, w, h)
  }

  static isWithinInteractDistance(x, y, player) {
    let distance = Helper.distance(player.getX(), player.getY(), x, y)
    return distance <= Helper.ENTITY_INTERACT_RANGE
  }

  static isOnValidPlatform(container, x, y, w, h, angle, player) {
    if (this.isPlacingOnSomeoneElsePlatform(container, x, y, w, h, angle, player)) return false

    let box = this.getBox(x, y, w, h)
    let checkFull = false
    let excludeOutOfBounds = false
    let groundHits = container.groundMap.hitTestTile(box, checkFull, excludeOutOfBounds)

    let isAllPlatform = groundHits.every((hit) => {
      if (!hit.entity) {
        return container.platformMap.get(hit.row, hit.col)
      }

      if (!hit.entity.isGroundTile()) {
        return container.platformMap.get(hit.row, hit.col)
      }

      return true
    })

    return isAllPlatform
  }

  static isPlacingOnSomeoneElsePlatform(container, x, y, w, h, angle, player) {
    return false
  }

  postBuildingConstructed() {
    this.assignStructureOnMap()
  }

  assignStructureOnMap() {
    this.game.mapMenu.assignStructure(this)
  }

  getMinimapColor() {
    return this.getConstants().minimapColor
  }

  onBuildingConstructed() {
    this.register()

  }

  hasOwner() {
    return !!this.owner
  }

  hasRailOnTop() {
    let row = this.getRow()
    let col = this.getCol()
    return this.container.railMap.get(row, col)
  }

  hasStructureOnTop() {
    let row = this.getRow()
    let col = this.getCol()
    return this.container.structureMap.get(row, col)
  }

  hasWallOnTop() {
    let row = this.getRow()
    let col = this.getCol()
    return this.container.armorMap.get(row, col)
  }

  assignLighting() {
    if (this.hasCategory("platform")) {
      this.assignShadow()
    } else if (this.isLightBlocker()) {
      this.container.lightManager.invalidateLightSources(this.getRow(), this.getCol())
    } else if (this.isLightSource() && this.isLightOn()) {
      this.container.lightManager.queueLightSource({ action: 'register', entity: this })
    }
  }

  assignShadow() {
    this.container.lightManager.assignShadowFor(this, this.getShadowColor())
  }

  getLightColor() {
    return this.getConstants().lightColor
  }

  getLightRadius() {
    return this.getConstants().lightRadius
  }

  unassignLighting() {
    if (this.hasCategory("platform") ) {
      this.unassignShadow()
    } else if (this.isLightBlocker()) {
      this.container.lightManager.invalidateLightSources(this.getRow(), this.getCol())
    } else if (this.isLightSource()) {
      this.container.lightManager.queueLightSource({ action: 'unregister', entity: this })
    }
  }

  unassignShadow() {
    this.container.lightManager.unassignShadowFor(this, this.getGroundShadowColor())
  }

  getShadowColor() {
    return "#292929"
  }

  getGroundShadowColor() {
    let platform = this.getStandingPlatform()
    if (platform) {
      return platform.getShadowColor()
    } else {
      return "#ffffff"
    }
  }

  getBrightness() {
    return 0
  }

  getTopLeftRow() {
    let box = this.getRelativeBox()
    return Math.floor((box.pos.y) / Constants.tileSize)
  }

  getTopLeftCol() {
    let box = this.getRelativeBox()
    return Math.floor((box.pos.x) / Constants.tileSize)
  }

  static getNeighborTiles(tilemap, relativeBox) {
    const paddedRelativeBox = this.getPaddedRelativeBox(relativeBox)
    let   coreHits = tilemap.hitTestTile(relativeBox)
    let   paddedHits = tilemap.hitTestTile(paddedRelativeBox)

    return paddedHits.filter((hit) => {
      const isPartOfCore = coreHits.find((coreHit) => {
        return coreHit.row === hit.row && coreHit.col === hit.col
      })
      return !isPartOfCore
    })
  }

  static isSameHit(hit, otherHit) {
    return hit.row === otherHit.row && hit.col === otherHit.col
  }

  static getSideTiles(tilemap, relativeBox) {
    const paddedRelativeBox = this.getPaddedRelativeBox(relativeBox)
    let checkFull = false
    let excludeOutOfBounds = false

    let   coreHits = tilemap.hitTestTile(relativeBox, checkFull, excludeOutOfBounds)
    let   paddedHits = tilemap.hitTestTile(paddedRelativeBox, checkFull, excludeOutOfBounds)
    const coreEdges = tilemap.getDiagonalEdges(paddedRelativeBox, checkFull, excludeOutOfBounds)

    return paddedHits.filter((hit) => {
      const isPartOfCoreOrDiagonal = coreHits.find((coreHit) => {
        return this.isSameHit(coreHit, hit) ||
               this.isSameHit(coreEdges.upperLeft, hit) ||
               this.isSameHit(coreEdges.upperRight, hit) ||
               this.isSameHit(coreEdges.lowerLeft, hit) ||
               this.isSameHit(coreEdges.lowerRight, hit)
      })
      return !isPartOfCoreOrDiagonal
    })
  }

  getSideTiles(tilemap) {
    let relativeBox = this.getRelativeBox()
    return this.constructor.getSideTiles(tilemap, relativeBox)
  }

  getSideHitTileMaps() {
    let tileMaps = [this.getMap()]

    if (this.hasPowerRole())  tileMaps.push(this.container.distributionMap)
    if (this.hasLiquidRole()) tileMaps.push(this.container.liquidDistributionMap)
    if (this.hasOxygenRole()) tileMaps.push(this.container.gasDistributionMap)
    if (this.hasFuelRole())   tileMaps.push(this.container.fuelDistributionMap)

    return tileMaps
  }

  getSideHits() {
    let tileMaps = this.getSideHitTileMaps()
    if (tileMaps.length === 1) {
      return this.getSideHitsFor(tileMaps[0])
    } else {
      return this.getSideHitsMulti(tileMaps)
    }
  }

  getSideHitsMulti(tileMaps) {
    let firstSideHits    = this.getSideHitsFor(tileMaps[0])
    let secondSideHits   = this.getSideHitsFor(tileMaps[1])
    let hits = {}

    for (let direction in firstSideHits) {
      let directionHits = firstSideHits[direction]
      let hit = directionHits[0] // it'll only have one entry only
      if (!hit) continue

      let firstHitDetected = hit.entity
      if (firstHitDetected) {
        hits[direction] = firstSideHits[direction]
      } else {
        hits[direction] = secondSideHits[direction]
      }
    }

    return hits
  }

  onEffectAdded(effect) {
    super.onEffectAdded(effect)
    this.updateChunkSprite()
  }

  onEffectRemoved(effect) {
    super.onEffectRemoved(effect)
    this.updateChunkSprite()
  }

  onEffectLevelChanged(effect, level) {
    super.onEffectLevelChanged(effect, level)
    this.updateChunkSprite()
  }

  getRowColSideHitsFor(tilemap, row, col) {
    return {
      left:  tilemap.rowColHitTest(row    , col - 1), // left
      up:    tilemap.rowColHitTest(row - 1, col    ), // top
      right: tilemap.rowColHitTest(row    , col + 1), // right
      down:  tilemap.rowColHitTest(row + 1, col    ), // down
    }
  }

  getCoreHits() {
    return this.getMap().hitTestTile(this.getRelativeBox())
  }

  getSideHitsFor(tilemap) {
    const result = { left: [], up: [], right: [], down: [] }

    let   coreHits = tilemap.hitTestTile(this.getRelativeBox())
    const sideTiles = this.getSideTiles(tilemap)

    for (var i = 0; i < sideTiles.length; i++) {
      let hit = sideTiles[i]
      if (tilemap.isLeft(hit, coreHits)) {
        result["left"].push(hit)
      } else if (tilemap.isUp(hit, coreHits)) {
        result["up"].push(hit)
      } else if (tilemap.isRight(hit, coreHits)) {
        result["right"].push(hit)
      } else if (tilemap.isDown(hit, coreHits)) {
        result["down"].push(hit)
      }

    }

    return result
  }

  removeStructureFromMinimap() {
    // to prevent cases where other platforms has already this current one thats being deleted
    // and erasing the minimap rendering of that platform
    // let isRegisteredOnMap = this.getMap().get(this.getRow(), this.getCol()) === this
    // if (isRegisteredOnMap) {
    //   this.game.mapMenu.removeStructure(this)
    // }

    let shouldIgnoreDynamic = true
    let entity = this.sector.pick(this.getRow(), this.getCol(), null, shouldIgnoreDynamic)
    if (entity && entity.isBuildingType()) {
    } else {
      this.game.mapMenu.unassignStructure(this)
    }
  }

  getUpgradeCost() {
    return 0
  }

  remove() {
    super.remove()

    this.removeNetworks()
    this.removeProgressBar()

    this.updateChunkSprite()

    if (this.nameText) {
      this.nameText.remove()
    }

    if (this.nameSprite) {
      this.nameSprite.parent.removeChild(this.nameSprite)
    }

    if (!this.isEquipDisplay && !this.isEquipment()) {
      this.getContainer().unregisterEntity("buildings", this)
      this.getChunk().unregister("buildings", this)
      this.unregister()
      this.unassignLighting()

      this.removeStructureFromMinimap()
    }

    this.cleanupTween()

    if (this.game.sector.persistentSelection.selectedEntity === this) {
      this.game.resetEntitySelection()
    }
  }

  cleanupTween() {
    if (this.fireTween) {
      this.fireTween.stop()
    }

    if (this.powerTween) {
      this.powerTween.stop()
    }
  }

  redrawSprite() {
    this.updateChunkSprite()
  }

  convertNeighborsToSideHits() {
    let neighbors = this.neighbors
    return {
      "left":  !!((neighbors >> 3) & 1),
      "up":    !!((neighbors >> 2) & 1),
      "right": !!((neighbors >> 1) & 1),
      "down":  !!((neighbors >> 0) & 1)
    }
  }

  getMap() {
    return this.container.structureMap
  }

  getMapRegisterBox() {
    return this.getRelativeBox()
  }

  register() {
    this.container[this.getGroup()][this.id] = this
    this.getMap().register(this.getMapRegisterBox(), this)
  }

  unregister() {
    this.getContainer().unregisterEntity(this.getGroup(), this)
    this.getMap().unregister(this.getMapRegisterBox(), this)
  }

  getX() {
    if (this.container.isMovable()) {
      return this.getAbsoluteXOnContainer()
    }

    return super.getX()
  }

  getContainer() {
    return this.container
  }

  getY() {
    if (this.container.isMovable()) {
      return this.getAbsoluteYOnContainer()
    }

    return super.getY()
  }

  forceShowDamage() {
    return false
  }

  getRow() {
    return Math.floor(this.getRelativeY() / Constants.tileSize)
  }

  getCol() {
    return Math.floor(this.getRelativeX() / Constants.tileSize)
  }

}

Object.assign(BaseBuilding.prototype, Upgradable.prototype, {
})

Object.assign(BaseBuilding.prototype, ShipMountable.prototype, {
  getRelativeX() {
    return this.sprite.position.x
  },
  getRelativeY() {
    return this.sprite.position.y
  }
})

/* Implement Destroyable */

Object.assign(BaseBuilding.prototype, Destroyable.prototype, {
  onHealthZero() {
    this.animateDestruction()
  },
  getMaxHealth() {
    if (this.game.sector.entityCustomStats[this.id]) {
      return this.game.sector.entityCustomStats[this.id].health
    }

    if (this.game.sector.buildingCustomStats[this.getType()]) {
      return this.game.sector.buildingCustomStats[this.getType()].health
    }

    return this.getStats(this.level).health
  },
  onPostSetHealth() {
    if (!this.dontShowHealth()) {
      HealthBar.draw(this, { isFixedPosition: true })
    }


    if (this.game.entityMenu.isOpen(this)) {
      this.game.entityMenu.update(this)
    }

  },
  onHealthReduced(delta) {
    if (this.forceShowDamage()) {
      HealthBar.draw(this, { isFixedPosition: true })
    }

    if (!this.dontShowHealth() || this.forceShowDamage()) {
      HealthBar.showDamageTaken(this, delta)
      this.animateDamage()
    }
  }
})

Object.assign(BaseBuilding.prototype, BaseBuildingCommon.prototype, {
})

Object.assign(BaseBuilding.prototype, Resource.prototype, {
})

Object.assign(BaseBuilding.prototype, Powerable.prototype, {
  onPowerChanged() {
    if (this.isPowered) {
      this.removePowerOff()
    } else {
      this.showPowerOff()
    }
  }
})

Object.assign(BaseBuilding.prototype, Drainable.prototype, {
  getUsageCapacity() {
    let clientResource = this.getStats().clientResource
    if (clientResource) {
      return this.getResourceCapacity(clientResource)
    } else {
      return 100
    }
  },
  onUsageChanged() {
    let clientResource = this.getStats().clientResource
    if (clientResource) {
      this.redrawEntityUsage()
    }
  }
})

Object.assign(BaseBuilding.prototype, Conductor.prototype, {
  getConduitMap() {
    if (this.hasPowerRole()) {
      return this.container.distributionMap
    }

    if (this.hasLiquidRole()) {
      return this.container.liquidDistributionMap
    }

    if (this.hasOxygenRole()) {
      return this.container.gasDistributionMap
    }

    if (this.hasFuelRole()) {
      return this.container.fuelDistributionMap
    }
  },
  canConduct(hit) {
    if (!hit.entity) return false

    if (this.hasPowerRole()) {
      return hit.entity.hasCategory("power_conduit")
    }

    if (this.hasLiquidRole()) {
      return hit.entity.hasCategory("liquid_conduit")
    }

    if (this.hasOxygenRole()) {
      return hit.entity.hasCategory("oxygen_conduit")
    }

    if (this.hasFuelRole()) {
      return hit.entity.hasCategory("fuel_conduit")
    }
  },
  getTextures() {
    if (this.hasPowerRole()) {
      return this.sector.getConduitTexturesForRole("power")
    }

    if (this.hasLiquidRole()) {
      return this.sector.getConduitTexturesForRole("liquid")
    }

    if (this.hasOxygenRole()) {
      return this.sector.getConduitTexturesForRole("oxygen")
    }

    if (this.hasFuelRole()) {
      return this.sector.getConduitTexturesForRole("fuel")
    }
  },
  getTileSprite() {
    return this.buildingSprite
  }
})


module.exports = BaseBuilding

},{"../../util/bitmap_text":648,"../../util/socket_util":654,"./../../../../common/constants.json":656,"./../../../../common/entities/base_building_common":657,"./../../../../common/helper":664,"./../../../../common/interfaces/conductor":667,"./../../../../common/interfaces/destroyable":670,"./../../../../common/interfaces/drainable":671,"./../../../../common/interfaces/powerable":676,"./../../../../common/interfaces/resource":677,"./../../../../common/interfaces/ship_mountable":678,"./../../../../common/interfaces/upgradable":681,"./../../../../common/util/protocol":686,"./../../components/health_bar":181,"./../../components/progress_bar":183,"./../../util/client_helper":649,"./../../util/sprite_event_handler":655,"./../base_entity":206,"./../network_sprite":486}],212:[function(require,module,exports){
const BaseBuilding = require("./base_building")
const Constants = require("../../../../common/constants.json")

class BaseDistribution extends BaseBuilding {

  static isPositionValid(container, x, y, w, h, angle, player) {
    return this.isOnValidPlatform(container, x, y, w, h, angle, player) &&
           this.isWithinInteractDistance(x, y, player) &&
           !this.isOnHangar(container, x, y, w, h) &&
           !container.structureMap.isOccupied(x, y, w, h) &&
           !container.distributionMap.isOccupied(x, y, w, h)
  }

  getDisplayWidth() {
    return Constants.tileSize
  }

  getDisplayHeight() {
    return Constants.tileSize
  }

  getRotatedWidth() {
    return Constants.tileSize
  }

  getRotatedHeight() {
    return Constants.tileSize
  }

  getGroup() {
    return "distributions"
  }

  getMap() {
    return this.container.distributionMap
  }

}

module.exports = BaseDistribution

},{"../../../../common/constants.json":656,"./base_building":211}],213:[function(require,module,exports){
const BaseBuilding = require("./base_building")
const Constants = require("./../../../../common/constants.json")
const Protocol = require("./../../../../common/util/protocol")

class BaseStarter extends BaseBuilding {

  constructor(game, data, isEquipDisplay) {
    super(game, data, isEquipDisplay)

    this.sprite.rotation = Math.PI/2
  }

  getType() {
    return Protocol.definition().BuildingType.BaseStarter
  }

  getSpritePath() {
    return "base_starter.png"
  }

  getConstantsTable() {
    return "Buildings.BaseStarter"
  }

}

module.exports = BaseStarter

},{"./../../../../common/constants.json":656,"./../../../../common/util/protocol":686,"./base_building":211}],214:[function(require,module,exports){
const BaseBuilding = require("./base_building")
const Constants = require("./../../../../common/constants.json")
const Protocol = require("./../../../../common/util/protocol")
const BaseFloor = require("./platforms/base_floor")
const SocketUtil = require("./../../util/socket_util")
const Tilable = require("./../../../../common/interfaces/tilable")
const ClientHelper = require("../../util/client_helper")

class BaseWall extends BaseFloor {

  static isPositionValid(container, x, y, w, h, angle, player) {
    const hits = container.platformMap.hitTestTile(this.getBox(x, y, w, h))
    const isOnSoil = hits.every((hit) => { return hit.entity && hit.entity.hasCategory("soil") })

    return this.isOnValidPlatform(container, x, y, w, h, angle, player) &&
           this.isWithinInteractDistance(x, y, player) &&
           !this.isOnHangar(container, x, y, w, h) &&
           !this.hasRailNeighbor(container, x, y, w, h) &&
           !isOnSoil &&
           !container.railMap.isOccupied(x, y, w, h) &&
           !container.armorMap.isOccupied(x, y, w, h) &&
           !container.unitMap.isOccupied(x, y, w, h) &&
           !container.structureMap.isOccupied(x, y, w, h)
  }

  static isPlacingOnSomeoneElsePlatform(container, x, y, w, h, angle, player) {
    let box = this.getBox(x, y, w, h)

    return container.platformMap.hitTestTile(box).find((hit) => {
      if (!hit.entity) return false

      let placerOwnerId = player && player.getBuildOwnerId()
      return hit.entity.owner && (hit.entity.owner.id !== placerOwnerId)
    })
  }

  static getTextures() {
    if (!this.textures) {
      this.textures = {
        line_zero: PIXI.utils.TextureCache["wall_0.png"],
        line_one: PIXI.utils.TextureCache["wall_1.png"],
        line_two: PIXI.utils.TextureCache["wall_2.png"],
        line_two_straight: PIXI.utils.TextureCache["wall_2_straight.png"],
        line_three: PIXI.utils.TextureCache["wall_3.png"],
        line_four: PIXI.utils.TextureCache["wall_4.png"]
      }
    }

    return this.textures
  }

  hasEdgeSprite() {
    return true
  }

  getUpgradeCost() {
    return 300
  }

  getMaxHealth() {
    let maxHealth = super.getMaxHealth()
    if (this.level === 1) return maxHealth * 2
    return maxHealth
  }

  getGroup() {
    return "armors"
  }

  getBrightness() {
    return 0
  }

  getSideHitTileMaps() {
    return [this.container.armorMap]
  }

  getMap() {
    return this.container.armorMap
  }

  shouldDrawEdge(hit) {
    const isNotWall = hit.entity && !hit.entity.hasCategory("wall")
    const isEmpty = !hit.entity
    return isEmpty || isNotWall
  }

  getSpritePath() {
    let table = this.getConstants()
    if (table.sprite && table.sprite.path) {
      return table.sprite.path + ".png"
    }

    return this.getBaseSpritePath()
  }

  getBaseSpritePath() {
    let table = this.getConstants()
    if (table.sprite && table.sprite.path) {
      return table.sprite.basepath + ".png"
    }
    
    return 'wall_0.png'
  }

  getBuildingSprite() {
    let sprite = super.getBuildingSprite()

    this.baseSprite.name = "WallBaseSprite"
    this.baseSprite.tint = this.getWallColor()

    if (this.data.hasOwnProperty("colorIndex")) {
      let color = this.game.colors[this.data.colorIndex]
      this.baseSprite.tint = color.value
    }

    return sprite
  }

  getDefaultSpriteColor() {
    if (this.data.colorIndex) {
      let color = this.game.colors[this.data.colorIndex]
      return color.value
    }
    
    return this.getWallColor()
  }

  getWallColor() {
    return ClientHelper.hexToInt(this.getConstants().sprite.color)
  }

  redrawSprite() {
    let tiles = this.convertNeighborsToSideHits(this.neighbors)
    for (let direction in tiles) {
      if (!tiles[direction]) {
        delete tiles[direction]
      }
    }

    this.layoutTile(tiles)

    super.redrawSprite()
  }

}

Object.assign(BaseWall.prototype, Tilable.prototype, {
  getTextures() {
    return this.constructor.getTextures()
  },
  getTileSprite() {
    return this.baseSprite
  }
})

module.exports = BaseWall

},{"../../util/client_helper":649,"./../../../../common/constants.json":656,"./../../../../common/interfaces/tilable":680,"./../../../../common/util/protocol":686,"./../../util/socket_util":654,"./base_building":211,"./platforms/base_floor":262}],215:[function(require,module,exports){
const Constants = require("./../../../../common/constants.json")
const Protocol = require("./../../../../common/util/protocol")
const BaseBuilding = require("./base_building")

class Beacon extends BaseBuilding {

  renderEntityMenu(entityMenu) {
    super.renderEntityMenu(entityMenu)

    this.showSpawnPositions(entityMenu)
  }

  showSpawnPositions(entityMenu) {
    if (!this.content) {
      entityMenu.querySelector(".spawn_select").value = "everyone"
    } else {
      entityMenu.querySelector(".spawn_select").value = this.content
    }
  }

  getSpritePath() {
    return "beacon.png"
  }

  getType() {
    return Protocol.definition().BuildingType.Beacon
  }

  getConstantsTable() {
    return "Buildings.Beacon"
  }

}

module.exports = Beacon

},{"./../../../../common/constants.json":656,"./../../../../common/util/protocol":686,"./base_building":211}],216:[function(require,module,exports){
const BaseBuilding = require("./base_building")
const Constants = require("./../../../../common/constants.json")
const Protocol = require("./../../../../common/util/protocol")
const ClientHelper = require("./../../util/client_helper")

class Beaker extends BaseBuilding {

  constructor(game, data, isEquipDisplay) {
    super(game, data, isEquipDisplay)
  }

  onContentChanged() {
    const tint = ClientHelper.getTintForSample(this.content)
    this.getTintableSprite().tint = tint
  }

  getType() {
    return Protocol.definition().BuildingType.Beaker
  }

  getSpritePath() {
    return "beaker.png"
  }

  getConstantsTable() {
    return "Buildings.Beaker"
  }

}

module.exports = Beaker

},{"./../../../../common/constants.json":656,"./../../../../common/util/protocol":686,"./../../util/client_helper":649,"./base_building":211}],217:[function(require,module,exports){
const BaseBuilding = require("./base_building")
const Constants = require("./../../../../common/constants.json")
const Protocol = require("./../../../../common/util/protocol")
const Helper = require("./../../../../common/helper")

class Bed extends BaseBuilding {

  constructor(game, data, isEquipDisplay) {
    super(game, data, isEquipDisplay)
  }

  shouldShowInteractTooltip() {
    let distance = Helper.distance(this.game.player.getX(), this.game.player.getY(), this.getX(), this.getY())
    if (distance > (Constants.tileSize * 2)) {
      return false
    }

    return super.shouldShowInteractTooltip()
  }

  getType() {
    return Protocol.definition().BuildingType.Bed
  }

  getSpritePath() {
    return "bed.png"
  }

  getConstantsTable() {
    return "Buildings.Bed"
  }

}

module.exports = Bed

},{"./../../../../common/constants.json":656,"./../../../../common/helper":664,"./../../../../common/util/protocol":686,"./base_building":211}],218:[function(require,module,exports){
const BaseBuilding = require("./base_building")
const Constants = require("./../../../../common/constants.json")
const Protocol = require("./../../../../common/util/protocol")

class BluePresent extends BaseBuilding {

  constructor(game, data, isEquipDisplay) {
    super(game, data, isEquipDisplay)
  }

  getType() {
    return Protocol.definition().BuildingType.BluePresent
  }

  getSpritePath() {
    return "blue_present.png"
  }

  getConstantsTable() {
    return "Buildings.BluePresent"
  }

}

module.exports = BluePresent

},{"./../../../../common/constants.json":656,"./../../../../common/util/protocol":686,"./base_building":211}],219:[function(require,module,exports){
const Drinks = require("./../drinks/index")
const BaseBuilding = require("./base_building")
const Constants = require("./../../../../common/constants.json")
const Protocol = require("./../../../../common/util/protocol")

class Brewery extends BaseBuilding {

  constructor(game, data, isEquipDisplay) {
    super(game, data, isEquipDisplay)
  }

  openMenu() {
    const templateList = Drinks.getDrinkables()

    let options = {}
    if (!this.isPowered) {
      options["disabled"] = "Insufficient Power"
    }

    this.game.craftMenu.open("Brewery", "Brew", this.id, templateList, options)
  }

  getType() {
    return Protocol.definition().BuildingType.Brewery
  }

  getSpritePath() {
    return "brewery.png"
  }

  getConstantsTable() {
    return "Buildings.Brewery"
  }

}

module.exports = Brewery

},{"./../../../../common/constants.json":656,"./../../../../common/util/protocol":686,"./../drinks/index":340,"./base_building":211}],220:[function(require,module,exports){
const BaseBuilding = require("./base_building")
const Constants = require("./../../../../common/constants.json")
const Protocol = require("./../../../../common/util/protocol")

class Bridge extends BaseBuilding {

  constructor(game, data, isEquipDisplay) {
    super(game, data, isEquipDisplay)

    this.animate()
  }

  animate() {
    this.animationInterval = setInterval(() => {
      this.sprite.scale.set(0 - this.sprite.scale.x)
    }, 500)
  }

  cleanupInterval() {
    if (this.animationInterval) {
      clearInterval(this.animationInterval)
      this.animationInterval = null
    }
  }

  renderEntityMenu(entityMenu) {
    super.renderEntityMenu(entityMenu)
    // this.showAction(entityMenu)
  }

  showAction(entityMenu) {
    const pilot = "<div class='pilot_btn ui_btn' data-action='pilot'>Pilot</div>"

    entityMenu.querySelector(".entity_action").innerHTML = pilot
  }

  remove() {
    super.remove()

    this.cleanupInterval()
  }

  getType() {
    return Protocol.definition().BuildingType.Bridge
  }

  isNotForSale() {
    return true
  }

  getSpritePath() {
    return "bridge_black.png"
  }

  getConstantsTable() {
    return "Buildings.Bridge"
  }

}

module.exports = Bridge

},{"./../../../../common/constants.json":656,"./../../../../common/util/protocol":686,"./base_building":211}],221:[function(require,module,exports){
const BaseBuilding = require("./base_building")
const Constants = require("./../../../../common/constants.json")
const Protocol = require("./../../../../common/util/protocol")
const Table = require("./table")
const ProgressBar = require("./../../components/progress_bar")

class ButcherTable extends Table {

  getType() {
    return Protocol.definition().BuildingType.ButcherTable
  }

  getSpritePath() {
    return "butcher_table.png"
  }

  getConstantsTable() {
    return "Buildings.ButcherTable"
  }

  onUsageChanged() {
    if (this.isButcheringComplete()) {
      this.initButcherProgressBar()
      this.butcherProgressBar.remove()
      this.butcherProgressBar = null
    } else {
      this.initButcherProgressBar()
      this.butcherProgressBar.draw()
    }
  }

  isButcheringComplete() {
    return this.usage >= 100 || this.usage === 0
  }

  initButcherProgressBar() {
    if (this.butcherProgressBar) return

    this.butcherProgressBar = new ProgressBar(this, { 
      attribute: "usage", 
      maxAttribute: "getUsageCapacity", 
      isFixedPosition: true,
      displayOnTop: true
    })
  }

}

module.exports = ButcherTable

},{"./../../../../common/constants.json":656,"./../../../../common/util/protocol":686,"./../../components/progress_bar":183,"./base_building":211,"./table":296}],222:[function(require,module,exports){
const BaseBuilding = require("./base_building")
const Constants = require("./../../../../common/constants.json")
const Protocol = require("./../../../../common/util/protocol")
const Wall = require("./wall")

class Cage extends Wall {

  redrawSprite() {

  }

  getWallColor() {
    return 0xffffff
  }

  getBaseSpritePath() {
    return 'cage_2.png'
  }

  getBuildingSprite() {
    let buildingSprite = super.getBuildingSprite()
    this.baseSprite.width = Constants.tileSize
    this.baseSprite.height = Constants.tileSize
    return buildingSprite
  }

  getType() {
    return Protocol.definition().BuildingType.Cage
  }

  getConstantsTable() {
    return "Buildings.Cage"
  }

}

module.exports = Cage

},{"./../../../../common/constants.json":656,"./../../../../common/util/protocol":686,"./base_building":211,"./wall":321}],223:[function(require,module,exports){
const BaseBuilding = require("./base_building")
const Constants = require("./../../../../common/constants.json")
const Protocol = require("./../../../../common/util/protocol")

class Chair extends BaseBuilding {

  constructor(game, data, isEquipDisplay) {
    super(game, data, isEquipDisplay)
  }

  getType() {
    return Protocol.definition().BuildingType.Chair
  }

  getSpritePath() {
    return "steel_chair.png"
  }

  getConstantsTable() {
    return "Buildings.Chair"
  }

}

module.exports = Chair

},{"./../../../../common/constants.json":656,"./../../../../common/util/protocol":686,"./base_building":211}],224:[function(require,module,exports){
const BaseBuilding = require("./base_building")
const Constants = require("./../../../../common/constants.json")
const Protocol = require("./../../../../common/util/protocol")
const Foods = require("./../foods/index")
const Ores = require("./../ores/index")
const Equipments = require("./../equipments/index")

class ChemistryStation extends BaseBuilding {

  constructor(game, data, isEquipDisplay) {
    super(game, data, isEquipDisplay)
  }

  openMenu() {
    const templateList = Foods.getDrugs().concat([Ores.Explosives])

    let options = {}
    if (!this.isPowered) {
      options["disabled"] = "Insufficient Power"
    }

    this.game.craftMenu.open("Chemistry Station", "Craft", this.id, templateList, options)
  }

  getType() {
    return Protocol.definition().BuildingType.ChemistryStation
  }

  getSpritePath() {
    return "chemistry_station.png"
  }

  getConstantsTable() {
    return "Buildings.ChemistryStation"
  }

}

module.exports = ChemistryStation

},{"./../../../../common/constants.json":656,"./../../../../common/util/protocol":686,"./../equipments/index":407,"./../foods/index":422,"./../ores/index":494,"./base_building":211}],225:[function(require,module,exports){
const BaseBuilding = require("./base_building")
const Constants = require("./../../../../common/constants.json")
const Protocol = require("./../../../../common/util/protocol")

class ChristmasTree extends BaseBuilding {

  constructor(game, data, isEquipDisplay) {
    super(game, data, isEquipDisplay)
  }

  getType() {
    return Protocol.definition().BuildingType.ChristmasTree
  }

  getSpritePath() {
    return "christmas_tree.png"
  }

  getConstantsTable() {
    return "Buildings.ChristmasTree"
  }

}

module.exports = ChristmasTree

},{"./../../../../common/constants.json":656,"./../../../../common/util/protocol":686,"./base_building":211}],226:[function(require,module,exports){
const BaseDistribution = require("./base_distribution")
const Tilable = require("./../../../../common/interfaces/tilable")

class Conduit extends BaseDistribution {

  onBuildingConstructed() {
    super.onBuildingConstructed()
  }

  getMap() {
    return this.container[this.getTileMapName()]
  }

  getTileMapName() {
    return "distributionMap"
  }

  static getTextures() {
    throw "must implement Conduit#getTextures"
  }

  redrawSprite() {
    let tiles = this.convertNeighborsToSideHits(this.neighbors)
    for (let direction in tiles) {
      if (!tiles[direction]) {
        delete tiles[direction]
      }
    }

    this.layoutTile(tiles)
    super.redrawSprite()
  }

  hasConduitInDirection(directionHits) {
    throw "must implement Conduit#hasConduitInDirection"
  }

  getConduits(sideHits) {
    let conduits = {}

    // find out which ones are conduits
    for (let direction in sideHits) {
      let directionHits = sideHits[direction]
      if (this.hasConduitInDirection(directionHits)) {
        conduits[direction] = true
      }
    }

    return conduits
  }

  getSideHitTileMaps() {
    return [this.getMap(), this.container.structureMap]
  }

}

Object.assign(Conduit.prototype, Tilable.prototype, {
  getTextures() {
    return this.constructor.getTextures()
  },
  getTileSprite() {
    return this.buildingSprite
  },
  getSides() {
    const sideHits = this.getSideHits()
    return this.getConduits(sideHits)
  }
})



module.exports = Conduit
},{"./../../../../common/interfaces/tilable":680,"./base_distribution":212}],227:[function(require,module,exports){
const BaseBuilding = require("./base_building")
const Constants = require("./../../../../common/constants.json")
const Protocol = require("./../../../../common/util/protocol")
const Drainable = require("./../../../../common/interfaces/drainable")

class Core extends BaseBuilding {

  constructor(game, data, isEquipDisplay) {
    super(game, data, isEquipDisplay)

  }

  getType() {
    return Protocol.definition().BuildingType.Core
  }

  getSpritePath() {
    return "core_2.png"
  }

  getConstantsTable() {
    return "Buildings.Core"
  }

}

module.exports = Core

},{"./../../../../common/constants.json":656,"./../../../../common/interfaces/drainable":671,"./../../../../common/util/protocol":686,"./base_building":211}],228:[function(require,module,exports){
const BaseBuilding = require("./../base_building")
const SocketUtil = require("./../../../util/socket_util")
const Constants = require("../../../../../common/constants.json")


class BaseSeed extends BaseBuilding {

  static isPositionValid(container, x, y, w, h, angle, player) {
    const hits = container.platformMap.hitTestTile(this.getBox(x, y, w, h))
    const isOnSoil = hits.every((hit) => { return hit.entity && hit.entity.hasCategory("soil") })

    return isOnSoil &&
           this.isWithinInteractDistance(x, y, player) &&
           !container.distributionMap.isOccupied(x, y, w, h) &&
           !container.armorMap.isOccupied(x, y, w, h) &&
           !container.structureMap.isOccupied(x, y, w, h)
  }

  getRotatedWidth() {
    return Constants.tileSize
  }

  getRotatedHeight() {
    return Constants.tileSize
  }


  getTypeName(content) {
    let name = super.getTypeName(content)

    if (this.isHarvestable) {
      name = name.replace("Seed", "Plant")

    }

    return name
  }

  assignStructureOnMap() {
    // dont draw to map
  }

  getEntityMenuStats() {
    let statsEl = super.getEntityMenuStats()

    let growthPercent = Math.floor(100 * (this.health / this.getMaxHealth()))

    let el = "<div class='entity_stats_entry'>" +
                    "<div class='stats_type'>" + i18n.t('PlantGrowth') + ":</div>" +
                    "<div class='stats_value'>" + growthPercent + " %</div>" +
                "</div>"

    return statsEl + el
  }

  interactBuilding() {
    this.game.interact(this)
    this.game.player.setActTarget(this)
  }

  getGroup() {
    return "distributions"
  }


  setIsHarvestable(isHarvestable) {
    this.isHarvestable = isHarvestable

    if (this.isHarvestable) {
      this.redrawCrop()
    }
  }

  onPostClick() {
    if (!this.isHarvestable) {
      this.game.interact(this)
    }
  }

  onIsWateredChanged() {
    let platform = this.getStandingPlatform()
    if (!platform) return

    if (this.isWatered) {
      platform.applyTint(0x999999)
    } else {
      platform.applyTint(0xffffff)
    }

    platform.updateChunkSprite()
  }

  remove() {
    super.remove()

    let platform = this.getStandingPlatform()
    if (!platform) return

    platform.applyTint(0xffffff)
    platform.updateChunkSprite()
  }

  getMatureSpritePath() {
    let table = this.getConstants()
    if (table.sprite && table.sprite.maturepath) {
      return table.sprite.maturepath + ".png"
    }

    throw "must implement getMatureSpritePath"
  }

  redrawCrop() {
    const texture = PIXI.utils.TextureCache[this.getMatureSpritePath()]
    this.buildingSprite.texture = texture

    this.updateChunkSprite()
  }

  onBuildingConstructed() {
    this.container.crops[this.id] = this
    this.container.distributionMap.register(this.getMapRegisterBox(), this)
  }

  unregister() {
    this.getContainer().unregisterEntity("crops", this)
    this.container.distributionMap.unregister(this.getMapRegisterBox(), this)
  }

  getMap() {
    return this.container.distributionMap
  }

  forceShowDamage() {
    return true
  }

}

module.exports = BaseSeed

},{"../../../../../common/constants.json":656,"./../../../util/socket_util":654,"./../base_building":211}],229:[function(require,module,exports){
const BaseSeed = require("./base_seed")
const Constants = require("./../../../../../common/constants.json")
const Protocol = require("./../../../../../common/util/protocol")

class CoffeeSeed extends BaseSeed {

  // constructor(game, data, isEquipDisplay) {
  //   super(game, data, isEquipDisplay)
  // }

  getType() {
    return Protocol.definition().BuildingType.CoffeeSeed
  }

  getMatureSpritePath() {
    return "coffee_plant.png"
  }

  getSpritePath() {
    return "coffee_seed.png"
  }

  getConstantsTable() {
    return "Crops.CoffeeSeed"
  }

}

module.exports = CoffeeSeed

},{"./../../../../../common/constants.json":656,"./../../../../../common/util/protocol":686,"./base_seed":228}],230:[function(require,module,exports){
const BaseSeed = require("./base_seed")
const Constants = require("./../../../../../common/constants.json")
const Protocol = require("./../../../../../common/util/protocol")

class FiberSeed extends BaseSeed {

  // constructor(game, data, isEquipDisplay) {
  //   super(game, data, isEquipDisplay)
  // }

  getType() {
    return Protocol.definition().BuildingType.FiberSeed
  }

  getMatureSpritePath() {
    return "fiber_plant.png"
  }

  getSpritePath() {
    return "fiber_seed.png"
  }

  getConstantsTable() {
    return "Crops.FiberSeed"
  }

}

module.exports = FiberSeed

},{"./../../../../../common/constants.json":656,"./../../../../../common/util/protocol":686,"./base_seed":228}],231:[function(require,module,exports){
const BaseSeed = require("./base_seed")
const Constants = require("./../../../../../common/constants.json")
const Protocol = require("./../../../../../common/util/protocol")

class PotatoSeed extends BaseSeed {

  getType() {
    return Protocol.definition().BuildingType.PotatoSeed
  }

  getMatureSpritePath() {
    return "potato_plant.png"
  }

  getSpritePath() {
    return "potato_seed.png"
  }

  getConstantsTable() {
    return "Crops.PotatoSeed"
  }

}

module.exports = PotatoSeed

},{"./../../../../../common/constants.json":656,"./../../../../../common/util/protocol":686,"./base_seed":228}],232:[function(require,module,exports){
const BaseSeed = require("./base_seed")
const Constants = require("./../../../../../common/constants.json")
const Protocol = require("./../../../../../common/util/protocol")

class PumpkinSeed extends BaseSeed {

  getType() {
    return Protocol.definition().BuildingType.PumpkinSeed
  }

  getMatureSpritePath() {
    return "pumpkin_plant.png"
  }

  getSpritePath() {
    return "pumpkin_seed.png"
  }

  getConstantsTable() {
    return "Crops.PumpkinSeed"
  }

}

module.exports = PumpkinSeed
},{"./../../../../../common/constants.json":656,"./../../../../../common/util/protocol":686,"./base_seed":228}],233:[function(require,module,exports){
const BaseSeed = require("./base_seed")
const Constants = require("./../../../../../common/constants.json")
const Protocol = require("./../../../../../common/util/protocol")

class RiceSeed extends BaseSeed {

  // constructor(game, data, isEquipDisplay) {
  //   super(game, data, isEquipDisplay)
  // }

  getType() {
    return Protocol.definition().BuildingType.RiceSeed
  }

  getMatureSpritePath() {
    return "rice_plant.png"
  }

  getSpritePath() {
    return "rice_seed.png"
  }

  getConstantsTable() {
    return "Crops.RiceSeed"
  }

}

module.exports = RiceSeed

},{"./../../../../../common/constants.json":656,"./../../../../../common/util/protocol":686,"./base_seed":228}],234:[function(require,module,exports){
const BaseSeed = require("./base_seed")
const Constants = require("./../../../../../common/constants.json")
const Protocol = require("./../../../../../common/util/protocol")

class WheatSeed extends BaseSeed {

  // constructor(game, data, isEquipDisplay) {
  //   super(game, data, isEquipDisplay)
  // }

  getType() {
    return Protocol.definition().BuildingType.WheatSeed
  }

  getMatureSpritePath() {
    return "wheat_plant.png"
  }

  getSpritePath() {
    return "wheat_seed.png"
  }

  getConstantsTable() {
    return "Crops.WheatSeed"
  }

}

module.exports = WheatSeed

},{"./../../../../../common/constants.json":656,"./../../../../../common/util/protocol":686,"./base_seed":228}],235:[function(require,module,exports){
const Constants = require("./../../../../common/constants.json")
const Protocol = require("./../../../../common/util/protocol")
const LiquidTank = require("./liquid_tank")

class CryoTube extends LiquidTank {

 onBuildingConstructed() {
    super.onBuildingConstructed()
  }

  setUsage(usage) {
    this.usage = usage
  }

  getBuildingSprite() {
    let sprite = new PIXI.Container()

    this.baseSprite = new PIXI.Sprite(PIXI.utils.TextureCache["cryo_tube_base.png"])
    this.baseSprite.name = "TankBase"
    this.baseSprite.anchor.set(0.5)
    this.baseSprite.position.x = -11

    this.tankCover = new PIXI.Sprite(PIXI.utils.TextureCache["cryo_tube_cover.png"])
    this.tankCover.name = "TankCover"
    this.tankCover.anchor.set(0.5)
    this.tankCover.alpha = 0.7

    sprite.addChild(this.baseSprite)
    sprite.addChild(this.tankCover)

    return sprite
  }

  getSpritePath() {
    return "cryo_tube.png"
  }

  getConstantsTable() {
    return "Buildings.CryoTube"
  }

  getType() {
    return Protocol.definition().BuildingType.CryoTube
  }


}

module.exports = CryoTube

},{"./../../../../common/constants.json":656,"./../../../../common/util/protocol":686,"./liquid_tank":255}],236:[function(require,module,exports){
const BaseBuilding = require("./base_building")
const Constants = require("./../../../../common/constants.json")
const Protocol = require("./../../../../common/util/protocol")
const FuelPipe = require("./fuel_pipe")
const Helper = require("./../../../../common/helper")

class DeepDrill extends BaseBuilding {

  static isPositionValid(container, x, y, w, h, angle, player) {
    let isBuildingValid = !this.isOnHangar(container, x, y, w, h) &&
                          this.isWithinInteractDistance(x, y, player) &&
                          !container.armorMap.isOccupied(x, y, w, h) &&
                          !container.structureMap.isOccupied(x, y, w, h)

    let checkFull = false
    let excludeOutOfBounds = false
    const hits = container.undergroundMap.hitTestTile(this.getBox(x, y, w, h), checkFull, excludeOutOfBounds)
    const isOnOil = hits.find((hit) => { return hit.entity && hit.entity.hasCategory("oil") })
    const isNotOnEmptyTile = !hits.find((hit) => { return hit.entity === null })

    return isBuildingValid && isOnOil && isNotOnEmptyTile
  }


 onBuildingConstructed() {
    super.onBuildingConstructed()
  }

  cleanupTween() {
    if (this.tween) {
      this.tween.stop()
      this.tween = null
    }
  }

  remove() {
    super.remove()

    this.cleanupTween()
  }

  getSpritePath() {
    return 'deep_drill.png'
  }

  getType() {
    return Protocol.definition().BuildingType.DeepDrill
  }

  getConstantsTable() {
    return "Buildings.DeepDrill"
  }

  openMenu() {
    let shouldHideInputSlot = true
    this.game.processorMenu.open("Deep Drill", this, this.getMenuDescription(), shouldHideInputSlot)
  }

  getMenuDescription() {
    let ore = this.getOreOutput()    
    return i18n.t("Generates " + Helper.capitalize(ore) + " Ore")
  }

  getOreOutput() {
    return "sulfur"
  }


}

module.exports = DeepDrill

},{"./../../../../common/constants.json":656,"./../../../../common/helper":664,"./../../../../common/util/protocol":686,"./base_building":211,"./fuel_pipe":245}],237:[function(require,module,exports){
const VendingMachine = require("./vending_machine")
const Constants = require("./../../../../common/constants.json")
const Protocol = require("./../../../../common/util/protocol")

class DrinksVendingMachine extends VendingMachine {

  openMenu() {
    this.game.vendingMachineMenu.open("Drinks Vending Machine", this)
  }

  getType() {
    return Protocol.definition().BuildingType.DrinksVendingMachine
  }

  getSpritePath() {
    return "drinks_vending_machine.png"
  }

  getConstantsTable() {
    return "Buildings.DrinksVendingMachine"
  }

}

module.exports = DrinksVendingMachine

},{"./../../../../common/constants.json":656,"./../../../../common/util/protocol":686,"./vending_machine":319}],238:[function(require,module,exports){
const BaseBuilding = require("./base_building")
const Constants = require("./../../../../common/constants.json")
const Protocol = require("./../../../../common/util/protocol")

class EmergencyButton extends BaseBuilding {

  constructor(game, data, isEquipDisplay) {
    super(game, data, isEquipDisplay)
  }

  getType() {
    return Protocol.definition().BuildingType.EmergencyButton
  }

  getSpritePath() {
    return "emergency_button.png"
  }

  getConstantsTable() {
    return "Buildings.EmergencyButton"
  }

}

module.exports = EmergencyButton

},{"./../../../../common/constants.json":656,"./../../../../common/util/protocol":686,"./base_building":211}],239:[function(require,module,exports){
const BaseBuilding = require("./base_building")
const Constants = require("./../../../../common/constants.json")
const Protocol = require("./../../../../common/util/protocol")

class EscapePod extends BaseBuilding {

  constructor(game, data, isEquipDisplay) {
    super(game, data, isEquipDisplay)

    if (!this.sector.isLobby()) {
      this.onEffectAdded("residue")
    }
  }

  openMenu() {
    if (!this.sector.isLobby()) {
      this.game.storageMenu.open("Escape Pod", this)
    }
  }

  getActionTooltipMessage() {
    if (this.sector.isLobby()) {
      return "Leave Station"
    } else {
      return null
    }
  }

  getType() {
    return Protocol.definition().BuildingType.EscapePod
  }

  getSpritePath() {
    return "escape_pod.png"
  }

  getConstantsTable() {
    return "Buildings.EscapePod"
  }

}

module.exports = EscapePod

},{"./../../../../common/constants.json":656,"./../../../../common/util/protocol":686,"./base_building":211}],240:[function(require,module,exports){
const Constants = require("./../../../../common/constants.json")
const Protocol = require("./../../../../common/util/protocol")
const BaseBuilding = require("./base_building")

class FarmController extends BaseBuilding {

  constructor(game, data, isEquipDisplay) {
    super(game, data, isEquipDisplay)
  }

  remove() {
    super.remove()
  }

  canMenuBeOpened() {
    let team = this.game.player.getTeam()
    if (this.isOwnedBy(this.game.player) && team.hasMember(this.game.player) && !this.game.player.isGuest()) {
      return this.isConstructionFinished()
    }
  }

  openMenu() {
    this.game.soilMenu.open({ entity: this })
  }

  onContentChanged() {
    this.game.soilMenu.render(this)  
  }

  onHighlighted() {
    let text = this.getText()
    if (text.length === 0) return

    this.createChatBubble(text, { isAbsolutePosition: true })
  }

  getText() {
    let type = this.content
    if (!type) { 
      let team = this.game.player.getTeam()
      if (this.isOwnedBy(this.game.player) && team.hasMember(this.game.player) && !this.game.player.isGuest()) {
        return i18n.t("ChooseCrop")
      } else {
        return ""
      }
    }

    let klass = this.game.getItemKlass(type)
    let yieldName = klass.prototype.getConstants().yield

    return i18n.t(yieldName + " Farm")
  }

  getSpritePath() {
    return "farm_controller.png"
  }

  getType() {
    return Protocol.definition().BuildingType.FarmController
  }

  getConstantsTable() {
    return "Buildings.FarmController"
  }

}

module.exports = FarmController

},{"./../../../../common/constants.json":656,"./../../../../common/util/protocol":686,"./base_building":211}],241:[function(require,module,exports){
const BaseBuilding = require("./base_building")
const Constants = require("./../../../../common/constants.json")
const Protocol = require("./../../../../common/util/protocol")

class Fence extends BaseBuilding {

  getSpritePath() {
    return 'fence.png'
  }

  getType() {
    return Protocol.definition().BuildingType.Fence
  }

  getConstantsTable() {
    return "Buildings.Fence"
  }

}

module.exports = Fence

},{"./../../../../common/constants.json":656,"./../../../../common/util/protocol":686,"./base_building":211}],242:[function(require,module,exports){
const VendingMachine = require("./vending_machine")
const Constants = require("./../../../../common/constants.json")
const Protocol = require("./../../../../common/util/protocol")

class FoodVendingMachine extends VendingMachine {

  constructor(game, data, isEquipDisplay) {
    super(game, data, isEquipDisplay)
  }

  openMenu() {
    this.game.vendingMachineMenu.open("Food Vending Machine", this)
  }

  getType() {
    return Protocol.definition().BuildingType.FoodVendingMachine
  }

  getSpritePath() {
    return "food_vending_machine.png"
  }

  getConstantsTable() {
    return "Buildings.FoodVendingMachine"
  }

}

module.exports = FoodVendingMachine

},{"./../../../../common/constants.json":656,"./../../../../common/util/protocol":686,"./vending_machine":319}],243:[function(require,module,exports){
const Equipments = require("./../equipments/index")
const BaseBuilding = require("./base_building")
const Constants = require("./../../../../common/constants.json")
const Protocol = require("./../../../../common/util/protocol")

class Forge extends BaseBuilding {

  constructor(game, data, isEquipDisplay) {
    super(game, data, isEquipDisplay)
  }

  openMenu() {
    const templateList = [Equipments.Katana, Equipments.BlueEnergySword, Equipments.GreenEnergySword, Equipments.RedEnergySword, Equipments.SpaceSuit, Equipments.CombatArmor, Equipments.ImperialSpecialForcesArmor, Equipments.HazmatSuit, Equipments.PrisonerSuit, Equipments.PoliceSuit, Equipments.LabCoat, Equipments.CultistSuit]

    let options = {}
    if (!this.isPowered) {
      options["disabled"] = "Insufficient Power"
    }

    this.game.craftMenu.open("Forge", "Craft", this.id, templateList, options)
  }

  getType() {
    return Protocol.definition().BuildingType.Forge
  }

  getSpritePath() {
    return "forge.png"
  }

  getConstantsTable() {
    return "Buildings.Forge"
  }

}

module.exports = Forge

},{"./../../../../common/constants.json":656,"./../../../../common/util/protocol":686,"./../equipments/index":407,"./base_building":211}],244:[function(require,module,exports){
const BaseBuilding = require("./base_building")
const Constants = require("./../../../../common/constants.json")
const Protocol = require("./../../../../common/util/protocol")

class Fridge extends BaseBuilding {

  constructor(game, data, isEquipDisplay) {
    super(game, data, isEquipDisplay)
  }

  openMenu() {
    this.game.storageMenu.open("Fridge", this)
  }

  getType() {
    return Protocol.definition().BuildingType.Fridge
  }

  getSpritePath() {
    return "fridge.png"
  }

  getConstantsTable() {
    return "Buildings.Fridge"
  }

}

module.exports = Fridge

},{"./../../../../common/constants.json":656,"./../../../../common/util/protocol":686,"./base_building":211}],245:[function(require,module,exports){
const BaseBuilding = require("./base_building")
const Constants = require("./../../../../common/constants.json")
const Protocol = require("./../../../../common/util/protocol")
const Conduit = require("./conduit")

class FuelPipe extends Conduit {
  static isPositionValid(container, x, y, w, h, angle, player) {
    return !this.isOnHangar(container, x, y, w, h) &&
           this.isWithinInteractDistance(x, y, player) &&
           !container.structureMap.isOccupied(x, y, w, h) &&
           !container[this.prototype.getTileMapName()].isOccupied(x, y, w, h)
  }

  static getTextures() {
    if (!this.textures) {
      this.textures = {
        line_zero: PIXI.utils.TextureCache["fuel_pipe_1.png"],
        line_one: PIXI.utils.TextureCache["fuel_pipe_1.png"],
        line_two: PIXI.utils.TextureCache["fuel_pipe_2.png"],
        line_two_straight: PIXI.utils.TextureCache["fuel_pipe_2_straight.png"],
        line_three: PIXI.utils.TextureCache["fuel_pipe_3.png"],
        line_four: PIXI.utils.TextureCache["fuel_pipe_4.png"]
      }
    }

    return this.textures
  }

  getTileMapName() {
    return "fuelDistributionMap"
  }

  getSpriteLayerGroup() {
    return "fuelDistributions"
  }

  hasConduitInDirection(directionHits) {
    return directionHits.every((hit) => {
      return hit.entity && hit.entity.hasFuelRole()
    })
  }

  getType() {
    return Protocol.definition().BuildingType.FuelPipe
  }

  getSpritePath() {
    return "fuel_pipe_1.png"
  }

  getConstantsTable() {
    return "Buildings.FuelPipe"
  }

}

module.exports = FuelPipe


},{"./../../../../common/constants.json":656,"./../../../../common/util/protocol":686,"./base_building":211,"./conduit":226}],246:[function(require,module,exports){
const LiquidTank = require("./liquid_tank")
const Constants = require("./../../../../common/constants.json")
const Protocol = require("./../../../../common/util/protocol")
const Drainable = require("./../../../../common/interfaces/drainable")
const FuelPipe = require("./fuel_pipe")

class FuelTank extends LiquidTank {

 onBuildingConstructed() {
    super.onBuildingConstructed()

    this.initDrainable()
  }

  getType() {
    return Protocol.definition().BuildingType.FuelTank
  }

  getBuildingSprite() {
    let sprite = new PIXI.Container()

    this.baseSprite = new PIXI.Sprite(PIXI.utils.TextureCache["fuel_tank.png"])
    this.baseSprite.name = "TankBase"
    this.baseSprite.anchor.set(0.5)

    sprite.addChild(this.baseSprite)

    return sprite
  }

  onUsageChanged() {
    this.redrawEntityUsage()
  }

  getLiquidMaxWidth() {
    return 55
  }

  getSpritePath() {
    return "fuel_tank.png"
  }

  getConstantsTable() {
    return "Buildings.FuelTank"
  }

}

module.exports = FuelTank

},{"./../../../../common/constants.json":656,"./../../../../common/interfaces/drainable":671,"./../../../../common/util/protocol":686,"./fuel_pipe":245,"./liquid_tank":255}],247:[function(require,module,exports){
const Bars = require("./../bars/index")
const BaseBuilding = require("./base_building")
const Constants = require("./../../../../common/constants.json")
const Protocol = require("./../../../../common/util/protocol")
const Equipments = require("./../equipments/index")

class Furnace extends BaseBuilding {

  constructor(game, data, isEquipDisplay) {
    super(game, data, isEquipDisplay)
  }

  openMenu() {
    const templateList = this.getTemplateList()
    this.game.craftMenu.open("Furnace", "Craft", this.id, templateList)
  }


  getTemplateList() {
    let barKlasses = Object.values(Bars).filter((value) => {
      return typeof value.getType === "function"
    })

    return barKlasses
  }

  getType() {
    return Protocol.definition().BuildingType.Furnace
  }

  getSpritePath() {
    return "furnace.png"
  }

  getConstantsTable() {
    return "Buildings.Furnace"
  }

  getBuildingSprite() {
    const sprite = new PIXI.Container()

    this.furnaceBackground     = new PIXI.Sprite(PIXI.utils.TextureCache["furnace_background.png"])
    this.furnaceBackground.anchor.set(0.5)
    this.furnaceBackground.name = "FurnaceBackground"

    this.furnaceContainer     = new PIXI.Sprite(PIXI.utils.TextureCache["furnace_container.png"])
    this.furnaceContainer.anchor.set(0.5)
    this.furnaceContainer.name = "FurnaceContainer"

    this.fire     = new PIXI.Sprite(PIXI.utils.TextureCache["furnace_fire.png"])
    this.fire.anchor.set(0.5)
    this.fire.name = "Flames"
    this.fire.width = 20
    this.fire.height = 40
    this.fire.anchor.x = 0.5 // up to 0.85

    this.furnaceCage     = new PIXI.Sprite(PIXI.utils.TextureCache["furnace_cage.png"])
    this.furnaceCage.anchor.set(0.5)
    this.furnaceCage.name = "FurnaceCage"
    this.furnaceCage.width = 20
    this.furnaceCage.height = 28

    sprite.addChild(this.furnaceBackground)
    sprite.addChild(this.fire)
    sprite.addChild(this.furnaceContainer)
    sprite.addChild(this.furnaceCage)

    sprite.width = this.getWidth()
    sprite.height = this.getHeight()

    return sprite
  }


}

module.exports = Furnace

},{"./../../../../common/constants.json":656,"./../../../../common/util/protocol":686,"./../bars/index":204,"./../equipments/index":407,"./base_building":211}],248:[function(require,module,exports){
const BaseBuilding = require("./base_building")
const Constants = require("./../../../../common/constants.json")
const Protocol = require("./../../../../common/util/protocol")
const Conduit = require("./conduit")

class GasPipe extends Conduit {
  static isPositionValid(container, x, y, w, h, angle, player) {
    return !this.isOnHangar(container, x, y, w, h) &&
           this.isWithinInteractDistance(x, y, player) &&
           !container.structureMap.isOccupied(x, y, w, h) &&
           !container[this.prototype.getTileMapName()].isOccupied(x, y, w, h)
  }

  static getTextures() {
    if (!this.textures) {
      this.textures = {
        line_zero: PIXI.utils.TextureCache["pipe_1.png"],
        line_one: PIXI.utils.TextureCache["pipe_1.png"],
        line_two: PIXI.utils.TextureCache["pipe_2.png"],
        line_two_straight: PIXI.utils.TextureCache["pipe_2_straight.png"],
        line_three: PIXI.utils.TextureCache["pipe_3.png"],
        line_four: PIXI.utils.TextureCache["pipe_4.png"]
      }
    }

    return this.textures
  }

  getTileMapName() {
    return "gasDistributionMap"
  }

  getSpriteLayerGroup() {
    return "gasDistributions"
  }

  hasConduitInDirection(directionHits) {
    return directionHits.every((hit) => {
      return hit.entity && hit.entity.hasOxygenRole()
    })
  }

  getType() {
    return Protocol.definition().BuildingType.GasPipe
  }

  getSpritePath() {
    return "pipe_1.png"
  }

  getConstantsTable() {
    return "Buildings.GasPipe"
  }

}

module.exports = GasPipe


},{"./../../../../common/constants.json":656,"./../../../../common/util/protocol":686,"./base_building":211,"./conduit":226}],249:[function(require,module,exports){
const BaseBuilding = require("./base_building")
const Constants = require("./../../../../common/constants.json")
const Protocol = require("./../../../../common/util/protocol")

class GreenPresent extends BaseBuilding {

  constructor(game, data, isEquipDisplay) {
    super(game, data, isEquipDisplay)
  }

  getType() {
    return Protocol.definition().BuildingType.GreenPresent
  }

  getSpritePath() {
    return "green_present.png"
  }

  getConstantsTable() {
    return "Buildings.GreenPresent"
  }

}

module.exports = GreenPresent
},{"./../../../../common/constants.json":656,"./../../../../common/util/protocol":686,"./base_building":211}],250:[function(require,module,exports){
const Helper = require("./../../../../common/helper")
const BaseFloor = require('./platforms/base_floor')
const Constants = require("./../../../../common/constants.json")
const BaseWall = require("./base_wall")
const BaseSeed = require("./crops/base_seed")

const Buildings = {}
Buildings.Production = {}
Buildings.Structures = {}
Buildings.Atmospherics = {}
Buildings.Furnitures = {}
Buildings.Floors = {}
Buildings.Power = {}

Buildings.Ships = {}
Buildings.NonBuidables = {}

// production
Buildings.Production.Furnace = require("./furnace")
Buildings.Production.ButcherTable = require("./butcher_table")
Buildings.Production.Stove = require("./stove")
Buildings.Production.Forge = require("./forge")
// Buildings.Production.Workshop = require("./workshop")
Buildings.Production.Brewery = require("./brewery")
Buildings.Production.ChemistryStation = require("./chemistry_station")
Buildings.Production.MiningDrill = require("./mining_drill")
Buildings.Production.DeepDrill = require("./deep_drill")
Buildings.Production.AmmoPrinter = require("./ammo_printer")

// structures

Buildings.Structures.SpikeTrap = require("./spike_trap")
Buildings.Structures.WebTrap = require("./web_trap")
Buildings.Structures.ManualAirlock = require("./manual_airlock")
Buildings.Structures.Airlock = require("./airlock")
Buildings.Structures.SealedDoor = require("./sealed_door")
Buildings.Structures.Fence = require("./fence")
Buildings.Structures.Lamp = require("./lamp")
Buildings.Structures.WallLamp = require("./wall_lamp")
Buildings.Structures.SteelCrate = require("./steel_crate")
Buildings.Structures.FarmController = require("./farm_controller")
Buildings.Structures.FoodVendingMachine = require("./food_vending_machine")
Buildings.Structures.DrinksVendingMachine = require("./drinks_vending_machine")
Buildings.Structures.Atm = require("./atm")
Buildings.Structures.WaterPump = require("./water_pump")
Buildings.Structures.LiquidPipe = require("./liquid_pipe")
Buildings.Structures.LiquidTank = require("./liquid_tank")
Buildings.Structures.CryoTube = require("./cryo_tube")
Buildings.Structures.SuitStation = require("./suit_station")
Buildings.Structures.Beacon = require("./beacon")
Buildings.Structures.UndergroundVent = require("./underground_vent")
Buildings.Structures.SecurityCamera = require("./security_camera")
Buildings.Structures.SecurityMonitor = require("./security_monitor")
Buildings.Structures.MiniTurret = require("./towers/mini_turret")
Buildings.Structures.FlamethrowerTurret = require("./towers/flamethrower_turret")
Buildings.Structures.MissileTurret = require("./towers/missile_turret")
Buildings.Structures.TeslaCoil = require("./towers/tesla_coil")
Buildings.Structures.BomberTurret = require("./towers/bomber_turret")
Buildings.Structures.KeypadDoor = require("./keypad_door")
Buildings.Structures.MiasmaGate = require("./miasma_gate.js")

Buildings.Atmospherics.AirAlarm = require("./air_alarm")
Buildings.Atmospherics.Ventilator = require("./ventilator")
Buildings.Atmospherics.OxygenGenerator = require("./oxygen_generator")
Buildings.Atmospherics.OxygenTank = require("./oxygen_tank")
Buildings.Atmospherics.SmallOxygenTank = require("./small_oxygen_tank")
Buildings.Atmospherics.GasPipe = require("./gas_pipe")

// furniture
// Buildings.Furnitures.Fridge = require("./fridge")
// dynamically create klasses
Buildings.Furnitures.Wall = require("./wall")

for (let name in Constants.Walls) {
  if (!Buildings.Furnitures[name]) {
    let data = Constants.Walls[name]
    if (!data.abstract) {
      Buildings.Furnitures[name] = Helper.createDynamicKlass("Walls", BaseWall, name)
    }
  }
}

Buildings.Furnitures.Bed = require("./bed")
Buildings.Furnitures.Sign = require("./sign")

Buildings.Furnitures.Table = require("./table")
Buildings.Furnitures.LargeTable = require("./large_table")
Buildings.Furnitures.WoodTable = require("./wood_table")
Buildings.Furnitures.TradingTable = require("./trading_table")
Buildings.Furnitures.SlaversTable = require("./slavers_table")
Buildings.Furnitures.Chair = require("./chair")
Buildings.Furnitures.WoodChair = require("./wood_chair")
Buildings.Furnitures.Cage = require("./cage")
Buildings.Furnitures.Television = require("./television")
Buildings.Furnitures.Terminal = require("./terminal")
Buildings.Furnitures.Pot = require("./pot")
Buildings.Furnitures.Tree = require("./tree")
Buildings.Furnitures.ChristmasTree = require("./christmas_tree")
Buildings.Furnitures.RedPresent = require("./red_present")
Buildings.Furnitures.BluePresent = require("./blue_present")
Buildings.Furnitures.GreenPresent = require("./green_present")
Buildings.Furnitures.UnbreakableWall = require("./unbreakable_wall")

// platforms
Buildings.Floors.Lattice = require("./platforms/lattice")
Buildings.Floors.Floor = require("./platforms/floor")

Buildings.Floors.Soil = require("./platforms/soil")
Buildings.Floors.WoodFloor = require("./platforms/wood_floor")
Buildings.Floors.SteelFloor = require("./platforms/steel_floor")

// dynamically create klasses
for (let name in Constants.Floors) {
  if (!Buildings.Floors[name]) {
    let data = Constants.Floors[name]
    if (!data.abstract) {
      Buildings.Floors[name] = Helper.createDynamicKlass("Floors", BaseFloor, name)
    }
  }
}

Buildings.Floors.CarpetFloor = require("./platforms/carpet_floor")
Buildings.Floors.TiledFloor = require("./platforms/tiled_floor")
Buildings.Floors.GreenFloor = require("./platforms/green_floor")
Buildings.Floors.PurpleFloor = require("./platforms/purple_floor")
Buildings.Floors.PlatedFloor = require("./platforms/plated_floor")
Buildings.Floors.StripePlatedFloor = require("./platforms/stripe_plated_floor")
Buildings.Floors.RailTrack = require("./rail_track")
Buildings.Floors.RailStop = require("./rail_stop")

// ship
Buildings.Ships.Reactor = require("./reactor")
Buildings.Ships.ShieldGenerator = require("./shield_generator")
Buildings.Ships.Thruster = require("./thruster")
Buildings.Ships.Bridge = require("./bridge")

// non-buildables
Buildings.NonBuidables.BaseStarter = require("./base_starter")
Buildings.NonBuidables.EscapePod = require("./escape_pod")
Buildings.NonBuidables.Core = require("./core")
Buildings.NonBuidables.Refinery = require("./refinery")
Buildings.NonBuidables.EmergencyButton = require("./emergency_button")
Buildings.NonBuidables.TimerBomb = require("./timer_bomb")
Buildings.NonBuidables.ResearchTable = require("./research_table")
Buildings.NonBuidables.Fridge = require("./fridge")
Buildings.NonBuidables.Beaker = require("./beaker")
Buildings.NonBuidables.Shower = require("./shower")

// power
Buildings.Power.Wire = require("./wire")
Buildings.Power.PowerSwitch = require("./power_switch")
Buildings.Power.OilRefinery = require("./oil_refinery")
Buildings.Power.PowerGenerator = require("./power_generator")
Buildings.Power.FuelPipe = require("./fuel_pipe")
Buildings.Power.FuelTank = require("./fuel_tank")
Buildings.Power.SolarPanel = require("./solar_panel")

// towers
Buildings.Towers = {}
Buildings.Towers.MineralMiner = require("./towers/mineral_miner")
Buildings.Towers.Turret = require("./towers/turret")
Buildings.Towers.Cannon = require("./towers/cannon")
Buildings.Towers.VoidRay = require("./towers/void_ray")
Buildings.Towers.IonCannon = require("./towers/ion_cannon")
Buildings.Towers.MiniTurret = require("./towers/mini_turret")
Buildings.Towers.MissileTurret = require("./towers/missile_turret")
Buildings.Towers.BomberTurret = require("./towers/bomber_turret")
Buildings.Towers.Fighter = require("./units/fighter")

// crops
Buildings.Crops = {}
Buildings.Crops.PotatoSeed = require("./crops/potato_seed")
Buildings.Crops.WheatSeed = require("./crops/wheat_seed")
Buildings.Crops.CoffeeSeed = require("./crops/coffee_seed")
// Buildings.Crops.NitroSeed = require("./crops/nitro_seed")
// Buildings.Crops.CottonSeed = require("./crops/cotton_seed")
Buildings.Crops.FiberSeed = require("./crops/fiber_seed")
Buildings.Crops.PumpkinSeed = require("./crops/pumpkin_seed.js")
Buildings.Crops.RiceSeed = require("./crops/rice_seed")

// dynamically create klasses
for (let name in Constants.Crops) {
  if (!Buildings.Crops[name]) {
    let data = Constants.Crops[name]
    if (!data.abstract) {
      Buildings.Crops[name] = Helper.createDynamicKlass("Crops", BaseSeed, name)
    }
  }
}


Buildings.forType = (type) => {
  let klass
  const klassName = Helper.getTypeNameById(type)

  return Buildings.forTypeByName(klassName)
}

Buildings.forTypeByName = (klassName) => {
  let klass

  // find which namesapce
  for (let group in Buildings) {
    klass = Buildings[group][klassName]
    if (klass) break
  }

  return klass
}

Buildings.getConstructors = () => {
  return [
    Buildings.Structures.Stove,
    Buildings.Structures.Workshop,
    Buildings.Structures.Furnace,
    Buildings.Structures.Refinery,
    Buildings.Structures.AmmoPrinter
  ]
}

Buildings.getList = () => {
  return Object.values(Buildings.Floors).concat(this.getConstructors())
}

Buildings.getExcludeCraftingGroups = () => {
  return ["Ships", "Towers", "Crops", "NonBuidables"]
}

module.exports = Buildings

},{"./../../../../common/constants.json":656,"./../../../../common/helper":664,"./air_alarm":207,"./airlock":208,"./ammo_printer":209,"./atm":210,"./base_starter":213,"./base_wall":214,"./beacon":215,"./beaker":216,"./bed":217,"./blue_present":218,"./brewery":219,"./bridge":220,"./butcher_table":221,"./cage":222,"./chair":223,"./chemistry_station":224,"./christmas_tree":225,"./core":227,"./crops/base_seed":228,"./crops/coffee_seed":229,"./crops/fiber_seed":230,"./crops/potato_seed":231,"./crops/pumpkin_seed.js":232,"./crops/rice_seed":233,"./crops/wheat_seed":234,"./cryo_tube":235,"./deep_drill":236,"./drinks_vending_machine":237,"./emergency_button":238,"./escape_pod":239,"./farm_controller":240,"./fence":241,"./food_vending_machine":242,"./forge":243,"./fridge":244,"./fuel_pipe":245,"./fuel_tank":246,"./furnace":247,"./gas_pipe":248,"./green_present":249,"./keypad_door":251,"./lamp":252,"./large_table":253,"./liquid_pipe":254,"./liquid_tank":255,"./manual_airlock":256,"./miasma_gate.js":257,"./mining_drill":258,"./oil_refinery":259,"./oxygen_generator":260,"./oxygen_tank":261,"./platforms/base_floor":262,"./platforms/carpet_floor":263,"./platforms/floor":264,"./platforms/green_floor":265,"./platforms/lattice":266,"./platforms/plated_floor":267,"./platforms/purple_floor":268,"./platforms/soil":269,"./platforms/steel_floor":270,"./platforms/stripe_plated_floor":271,"./platforms/tiled_floor":272,"./platforms/wood_floor":273,"./pot":274,"./power_generator":275,"./power_switch":276,"./rail_stop":277,"./rail_track":278,"./reactor":279,"./red_present":280,"./refinery":281,"./research_table":282,"./sealed_door":283,"./security_camera":284,"./security_monitor":285,"./shield_generator":286,"./shower":287,"./sign":288,"./slavers_table":289,"./small_oxygen_tank":290,"./solar_panel":291,"./spike_trap":292,"./steel_crate":293,"./stove":294,"./suit_station":295,"./table":296,"./television":297,"./terminal":298,"./thruster":299,"./timer_bomb":300,"./towers/bomber_turret":302,"./towers/cannon":303,"./towers/flamethrower_turret":304,"./towers/ion_cannon":305,"./towers/mineral_miner":307,"./towers/mini_turret":308,"./towers/missile_turret":309,"./towers/tesla_coil":310,"./towers/turret":311,"./towers/void_ray":312,"./trading_table":313,"./tree":314,"./unbreakable_wall":315,"./underground_vent":316,"./units/fighter":318,"./ventilator":320,"./wall":321,"./wall_lamp":322,"./water_pump":323,"./web_trap":324,"./wire":325,"./wood_chair":326,"./wood_table":327}],251:[function(require,module,exports){
const BaseBuilding = require("./base_building")
const Constants = require("./../../../../common/constants.json")
const Protocol = require("./../../../../common/util/protocol")
const Airlock = require("./airlock")


class KeypadDoor extends Airlock {
    constructor(game, data, isEquipDisplay) {
        super(game, data, isEquipDisplay)
    }

    openMenu() {
        this.game.keypadMenu.open(this.id)
    }

    getType() {
        return Protocol.definition().BuildingType.KeypadDoor    
    }

    shouldShowCustomAccessSelect() {
        return false
    }

    getSpritePath() {
        return "keypad_door.png"
    }

    getConstantsTable() {
        return "Buildings.KeypadDoor"
    }

    getBuildingSprite() {
        let sprite = new PIXI.Container()
    
        let texture = PIXI.utils.TextureCache["keypad_door_upper.png"]
        this.upperDoorSprite = new PIXI.Sprite(texture)
        this.upperDoorSprite.anchor.set(0.5)
        this.upperDoorSprite.name = "UpperDoor"
    
        texture = PIXI.utils.TextureCache["keypad_door_lower.png"]
        this.lowerDoorSprite = new PIXI.Sprite(texture)
        this.lowerDoorSprite.anchor.set(0.5)
        this.lowerDoorSprite.name = "LowerDoor"
    
        sprite.addChild(this.lowerDoorSprite)
        sprite.addChild(this.upperDoorSprite)
    
        return sprite
      }
}

module.exports = KeypadDoor


},{"./../../../../common/constants.json":656,"./../../../../common/util/protocol":686,"./airlock":208,"./base_building":211}],252:[function(require,module,exports){
const BaseBuilding = require("./base_building")
const Constants = require("./../../../../common/constants.json")
const Protocol = require("./../../../../common/util/protocol")
const SocketUtil = require("./../../util/socket_util")
const ClientHelper = require("./../../util/client_helper")

class Lamp extends BaseBuilding {

  onClick(event) {
    super.onClick(event)

    if (debugMode) {
      this.handleDoubleClick(() => {
        this.game.lightPathMenu.open(this)
      })
    }
  }

  getEntityMenuStats() {
    let el = super.getEntityMenuStats()

    el += this.getColorStat()
    el += this.getRadiusStat()

    return el
  }

  getColorStat() {
    let value = this.getLightColor()
    let color = this.getColorMap()[value]
    if (!color) {
      color = value
    }

    let el = "<div class='entity_stats_entry lamp_color_entry'>" +
                  "<div class='stats_type'>" + i18n.t('Color') + ":</div>" +
                  "<div class='stats_value'>" + color  + "</div>" +
              "</div>"
    return el
  }

  getRadiusStat() {
    let radius = this.getLightRadius()

    let el = "<div class='entity_stats_entry lamp_radius_entry'>" +
                  "<div class='stats_type'>" + i18n.t('Intensity') + ":</div>" +
                  "<div class='stats_value'>" + radius  + "</div>" +
              "</div>"
    return el
  }

  shouldShowInteractTooltip() {
    if (this.game.player.isGuest()) return false
      
    return super.shouldShowInteractTooltip()
  }

  showAction(entityMenu) {
    const colorPalette = this.buildColorPalette()
    const radiusSlider = this.buildRadiusSlider()

    let actions = ""

    let team = this.game.player.getTeam()
    if (team && team.hasMember(this.game.player) && !this.game.player.isGuest()) {
      actions += colorPalette
      actions += radiusSlider
      
      entityMenu.querySelector(".entity_action").innerHTML = actions
      entityMenu.querySelector(".color_palette_container").addEventListener("click", this.onColorPaletteClick.bind(this), true)
      entityMenu.querySelector(".lamp_color_picker").addEventListener("change", this.onColorPickerChanged.bind(this), true)
      entityMenu.querySelector(".light_radius_container input").addEventListener("change", this.onLightRadiusChanged.bind(this), true)
    }


    if (this.content) {
      let color = this.getLightColor()
      let colorItem = entityMenu.querySelector(`.color_item[data-value='${color}']`)
      if (colorItem) {
        this.selectColorItem(colorItem)
      }
    }
  }

  onColorPaletteClick(e) {
    let colorItem = e.target.closest(".color_item")
    if (colorItem) {
      SocketUtil.emit("EditBuilding", { id: this.id, content: colorItem.dataset.value })
      return
    }
  }

  onColorPickerChanged(e) {
    let color = e.target.value
    let radius = this.getLightRadius()
    let content = this.content ? [color, radius].join(":") : color
    SocketUtil.emit("EditBuilding", { id: this.id, content: content })
    this.unselectColorItem()
  }

  onLightRadiusChanged(e) {
    let color = this.getLightColor()
    let radius = e.target.value
    let content = [color, radius].join(":") 
    SocketUtil.emit("EditBuilding", { id: this.id, content: content })
    this.unselectColorItem()
  }

  selectColorItem(colorItem) {
    this.unselectColorItem()
    colorItem.classList.add("selected")
  }

  unselectColorItem() {
    let selectedItem = document.querySelector(".color_palette_container .color_item.selected")
    if (selectedItem) {
      selectedItem.classList.remove("selected")
    }
  }

  getLightRadius() {
    if (!this.content) {
      return super.getLightRadius()
    } else {
      let radius = this.content.split(":")[1]
      if (radius) {
        return parseInt(radius)
      } else {
        return super.getLightRadius()
      }
    }
  }

  buildRadiusSlider() {
    let radius = this.getLightRadius()
    return "<div class='light_radius_container'>" + 
             "<span>Intensity:</span>" +
             "<input type='range' min='3' max='15' value='" + radius + "' />" + 
           "</div>"
  }

  buildColorPalette() {
    let colorMap = this.getColorMap()
    let el = "<div class='color_palette_container'>"

    for (let value in colorMap) {
      let color = colorMap[value]
      el += this.createPalette(color, value)
    }

    let defaultColor = this.content ? this.getLightColor() : '#000000'

    let customColor = "<div class='lamp_color_picker_container'>" + 
                        "<span>Custom</span>" + 
                        "<input type='color' class='lamp_color_picker' value='" + defaultColor + "'>" +
                      "</div>"
    el += customColor

    el += "</div>"

    return el
  }

  getColorMap() {
    return { 
      "#00ff00": "Green",
      "#07c57c": "DarkGreen",
      "#ffff00": "Yellow",
      "#ff00ff": "Magenta",
      "#00ffff": "Cyan",
      "#3965ac": "Blue",
      "#ffffff": "White",
      "#a90013": "Red",
      "#fb2841": "LightRed",
      "#f6751b": "Orange",
      "#a79161": "Bronze"
    }
  }

  onContentChanged() {
    if (this.game.entityMenu.isOpen(this)) {
      this.game.entityMenu.update(this)
    }

    this.unassignLighting()
    this.renderLighting()
  }

  createPalette(color, value) {
    let el = `<div class='color_item' data-color='${color}' data-value='${value}' style='background-color: ${value};'>` + 
             "</div>"
    return el
  }

  isEquipment() {
    return this.data.user
  }

  onOpenChanged() {
    super.onOpenChanged()
    this.renderLighting()
  }

  onPowerChanged() {
    super.onPowerChanged()

    this.renderLighting()
  }

  renderLighting() {
    if (this.isOpen && this.isPowered) {
      this.assignLighting()
      this.buildingSprite.tint = ClientHelper.hexToInt(this.getLightColor())
    } else {
      this.unassignLighting()
      this.buildingSprite.tint = 0xaaaaaa
    }
  }

  getLightColor() {
    if (this.content) {
      return this.content.split(":")[0]
    } else {
      return this.getConstants().lightColor
    }
  }

  getType() {
    return Protocol.definition().BuildingType.Lamp
  }

  getSpritePath() {
    return "lamp_2.png"
  }

  getConstantsTable() {
    return "Buildings.Lamp"
  }

}

module.exports = Lamp

},{"./../../../../common/constants.json":656,"./../../../../common/util/protocol":686,"./../../util/client_helper":649,"./../../util/socket_util":654,"./base_building":211}],253:[function(require,module,exports){
const BaseBuilding = require("./base_building")
const Constants = require("./../../../../common/constants.json")
const Protocol = require("./../../../../common/util/protocol")

class LargeTable extends BaseBuilding {

  constructor(game, data, isEquipDisplay) {
    super(game, data, isEquipDisplay)
  }

  getType() {
    return Protocol.definition().BuildingType.LargeTable
  }

  getSpritePath() {
    return "large_steel_table.png"
  }

  getConstantsTable() {
    return "Buildings.LargeTable"
  }

}

module.exports = LargeTable

},{"./../../../../common/constants.json":656,"./../../../../common/util/protocol":686,"./base_building":211}],254:[function(require,module,exports){
const BaseBuilding = require("./base_building")
const Constants = require("./../../../../common/constants.json")
const Protocol = require("./../../../../common/util/protocol")
const Conduit = require("./conduit")

class LiquidPipe extends Conduit {
  static isPositionValid(container, x, y, w, h, angle, player) {
    return !this.isOnHangar(container, x, y, w, h) &&
           this.isWithinInteractDistance(x, y, player) &&
           !container.structureMap.isOccupied(x, y, w, h) &&
           !container[this.prototype.getTileMapName()].isOccupied(x, y, w, h)
  }

  static getTextures() {
    if (!this.textures) {
      this.textures = {
        line_zero: PIXI.utils.TextureCache["water_pipe_1.png"],
        line_one: PIXI.utils.TextureCache["water_pipe_1.png"],
        line_two: PIXI.utils.TextureCache["water_pipe_2.png"],
        line_two_straight: PIXI.utils.TextureCache["water_pipe_2_straight.png"],
        line_three: PIXI.utils.TextureCache["water_pipe_3.png"],
        line_four: PIXI.utils.TextureCache["water_pipe_4.png"]
      }
    }

    return this.textures
  }

  getTileMapName() {
    return "liquidDistributionMap"
  }

  getSpriteLayerGroup() {
    return "liquidDistributions"
  }

  hasConduitInDirection(directionHits) {
    return directionHits.every((hit) => {
      return hit.entity && hit.entity.hasLiquidRole()
    })
  }

  getType() {
    return Protocol.definition().BuildingType.LiquidPipe
  }

  getSpritePath() {
    return "water_pipe_1.png"
  }

  getConstantsTable() {
    return "Buildings.LiquidPipe"
  }

}

module.exports = LiquidPipe


},{"./../../../../common/constants.json":656,"./../../../../common/util/protocol":686,"./base_building":211,"./conduit":226}],255:[function(require,module,exports){
const BaseBuilding = require("./base_building")
const Constants = require("./../../../../common/constants.json")
const Protocol = require("./../../../../common/util/protocol")
const Drainable = require("./../../../../common/interfaces/drainable")
const LiquidPipe = require("./liquid_pipe")

class LiquidTank extends BaseBuilding {

 onBuildingConstructed() {
    super.onBuildingConstructed()

    this.initDrainable()
  }

  getType() {
    return Protocol.definition().BuildingType.LiquidTank
  }

  getBuildingSprite() {
    let sprite = new PIXI.Container()

    this.baseSprite = new PIXI.Sprite(PIXI.utils.TextureCache["liquid_tank_base.png"])
    this.baseSprite.name = "TankBase"
    this.baseSprite.anchor.set(0.5)

    this.tankRidge = new PIXI.Sprite(PIXI.utils.TextureCache["liquid_tank_ridge.png"])
    this.tankRidge.name = "TankRidge"
    this.tankRidge.anchor.set(0.5)

    this.tankLiquid = new PIXI.Sprite(PIXI.utils.TextureCache["liquid_tank_water.png"])
    this.tankLiquid.name = "TankLiquid"
    this.tankLiquid.anchor.set(0.5)
    this.tankLiquid.width = 0
    this.tankLiquid.height = 0

    sprite.addChild(this.baseSprite)
    sprite.addChild(this.tankLiquid)
    sprite.addChild(this.tankRidge)

    return sprite
  }

  getLiquidMaxWidth() {
    return 55
  }

  getSpritePath() {
    return "liquid_tank.png"
  }

  onUsageChanged() {
    const usageRate = this.getUsage() / this.getUsageCapacity()

    this.tankLiquid.width = usageRate * this.getLiquidMaxWidth()
    this.tankLiquid.height = usageRate * this.getLiquidMaxWidth()
  }

  getConstantsTable() {
    return "Buildings.LiquidTank"
  }

}

module.exports = LiquidTank

},{"./../../../../common/constants.json":656,"./../../../../common/interfaces/drainable":671,"./../../../../common/util/protocol":686,"./base_building":211,"./liquid_pipe":254}],256:[function(require,module,exports){
const Airlock = require("./airlock")
const Constants = require("./../../../../common/constants.json")
const Protocol = require("./../../../../common/util/protocol")

class ManualAirlock extends Airlock {
  getConstantsTable() {
    return "Buildings.ManualAirlock"
  }

  layoutTiles() {
    // not a power conductor, dont
  }

  redrawNeighborTiles() {
    // not a power conductor, dont
  }

  getType() {
    return Protocol.definition().BuildingType.ManualAirlock
  }

  getBuildingSprite() {
    let sprite = new PIXI.Container()

    let texture = PIXI.utils.TextureCache["upper_door.png"]
    this.upperDoorSprite = new PIXI.Sprite(texture)
    this.upperDoorSprite.anchor.set(0.5)
    this.upperDoorSprite.name = "UpperDoor"

    texture = PIXI.utils.TextureCache["lower_door.png"]
    this.lowerDoorSprite = new PIXI.Sprite(texture)
    this.lowerDoorSprite.anchor.set(0.5)
    this.lowerDoorSprite.name = "LowerDoor"

    sprite.addChild(this.lowerDoorSprite)
    sprite.addChild(this.upperDoorSprite)

    return sprite
  }

  getSpritePath() {
    return "lower_door.png"
  }



}

module.exports = ManualAirlock

},{"./../../../../common/constants.json":656,"./../../../../common/util/protocol":686,"./airlock":208}],257:[function(require,module,exports){
const BaseBuilding = require("./base_building")
const Constants = require("./../../../../common/constants.json")
const Protocol = require("./../../../../common/util/protocol")

class MiasmaGate extends BaseBuilding {

  getSpritePath() {
    return 'miasma_gate.png'
  }

  getType() {
    return Protocol.definition().BuildingType.MiasmaGate
  }

  getConstantsTable() {
    return "Buildings.MiasmaGate"
  }

}

module.exports = MiasmaGate

},{"./../../../../common/constants.json":656,"./../../../../common/util/protocol":686,"./base_building":211}],258:[function(require,module,exports){
const BaseBuilding = require("./base_building")
const Constants = require("./../../../../common/constants.json")
const Protocol = require("./../../../../common/util/protocol")
const Helper = require("./../../../../common/helper")
const Wire = require("./wire")
const BitmapText = require("../../util/bitmap_text")

class MiningDrill extends BaseBuilding {

  onBuildingConstructed() {
    super.onBuildingConstructed()

    if (this.getOreOutput() === "iron") {
      this.baseSprite.tint = 0x66ff66
    }
    
    this.tween = this.getRotatingTween()
  }

  static isOnValidPlatform(container, x, y, w, h, angle, player) {
    if (this.isPlacingOnSomeoneElsePlatform(container, x, y, w, h, angle, player)) return false

    let box = this.getBox(x, y, w, h)
    let checkFull = false
    let excludeOutOfBounds = false

    let groundHits = container.groundMap.hitTestTile(box, checkFull, excludeOutOfBounds)
    let isAllGround = groundHits.every((hit) => {
      return hit.entity
    })

    return isAllGround
  }

  onPositionBecomeInvalid() {
    this.oreOutputText.sprite.alpha = 0
  }

  onPositionBecomeValid() {
    this.oreOutputText.sprite.alpha = 1
  }

  postBuildingEquipDisplayed() {
    super.postBuildingEquipDisplayed()
    this.addOreOutputDisplay()
  }

  addOreOutputDisplay() {
    const oreOutputLabel = Helper.capitalizeWords(this.getOreOutput() + " deposits")

    this.oreOutputText = BitmapText.create({
      label: 'OreOutput',
      text: oreOutputLabel,
      spriteContainer: this.sprite
    })

    this.oreOutputText.sprite.position.y = Constants.tileSize * 2
  }

  onGridPositionChanged() {
    super.onGridPositionChanged()
    
    if (this.oreOutputText) {
      this.oreOutputText.sprite.text = Helper.capitalizeWords(this.getOreOutput() + " deposits")
    }
  }

  onIsProcessingChanged() {
    if (this.isProcessing) {
      if (!this.tween) {
        this.tween = this.getRotatingTween()
      }
      this.tween.start()
    } else {
      this.tween.stop()
      this.tween = null
    }
  }

  getRotatingTween() {
    let rotation = { rotation: 0 }

    const fadeOutTween = new TWEEN.Tween(rotation)
        .to({ rotation: 360 * PIXI.DEG_TO_RAD }, 3000)
        .onUpdate(() => {
          this.guardSpriteContainer.rotation = rotation.rotation
        })
        .repeat(Infinity)

    return fadeOutTween
  }

  cleanupTween() {
    if (this.tween) {
      this.tween.stop()
      this.tween = null
    }
  }

  remove() {
    super.remove()

    if (this.oreOutputText) {
      this.oreOutputText.remove()
    }

    this.cleanupTween()
  }

  openMenu() {
    let shouldHideInputSlot = true
    this.game.processorMenu.open("Mining Drill", this, this.getMenuDescription(), shouldHideInputSlot)
  }

  getMenuDescription() {
    let ore = this.getOreOutput()    
    return i18n.t("Generates " + Helper.capitalize(ore) + " Ore")
  }

  getType() {
    return Protocol.definition().BuildingType.MiningDrill
  }

  getSpritePath() {
    return "mining_drill.png"
  }

  getConstantsTable() {
    return "Buildings.MiningDrill"
  }

  getBuildingSprite() {
    let sprite = new PIXI.Container()

    this.baseSprite = new PIXI.Sprite(PIXI.utils.TextureCache["mining_drill_core.png"])
    this.baseSprite.name = "BaseSprite"
    this.baseSprite.anchor.set(0.5)

    this.guardSpriteContainer = new PIXI.Container()
    this.guardSpriteContainer.name = "GuardContainer"

    let diffs = [
      { angle: 0,   anchor: [0.5,0.5] },
      { angle: 120, anchor: [-1 ,  0] },
      { angle: 240, anchor: [-1 ,  1] }
    ]

    diffs.forEach((diff) => {
      let guardSprite = new PIXI.Sprite(PIXI.utils.TextureCache["mining_drill_guard.png"])
      guardSprite.anchor.set(0.5)
      guardSprite.name = "Guard"
      guardSprite.rotation = diff.angle * Math.PI / 180
      guardSprite.position.x = 30
      guardSprite.anchor.set(diff.anchor[0], diff.anchor[1])
      this.guardSpriteContainer.addChild(guardSprite)
    })

    sprite.addChild(this.baseSprite)
    sprite.addChild(this.guardSpriteContainer)

    return sprite
  }


  getOreOutput() {
    let index = this.getRow() * this.container.getRowCount() + this.getCol()
    if (index % 5 === 0) {
      return "copper"
    } else {
      return "iron"
    }
  }


}

module.exports = MiningDrill

},{"../../util/bitmap_text":648,"./../../../../common/constants.json":656,"./../../../../common/helper":664,"./../../../../common/util/protocol":686,"./base_building":211,"./wire":325}],259:[function(require,module,exports){
const BaseBuilding = require("./base_building")
const Constants = require("./../../../../common/constants.json")
const Protocol = require("./../../../../common/util/protocol")
const FuelPipe = require("./fuel_pipe")

class OilRefinery extends BaseBuilding {

  static isPositionValid(container, x, y, w, h, angle, player) {
    let isBuildingValid = !this.isOnHangar(container, x, y, w, h) &&
                          this.isWithinInteractDistance(x, y, player) &&
                          !container.armorMap.isOccupied(x, y, w, h) &&
                          !container.structureMap.isOccupied(x, y, w, h)

    let checkFull = false
    let excludeOutOfBounds = false
    const hits = container.undergroundMap.hitTestTile(this.getBox(x, y, w, h), checkFull, excludeOutOfBounds)
    const isOnOil = hits.find((hit) => { return hit.entity && hit.entity.hasCategory("oil") })
    const isNotOnEmptyTile = !hits.find((hit) => { return hit.entity === null })

    return isBuildingValid && isOnOil && isNotOnEmptyTile
  }


 onBuildingConstructed() {
    super.onBuildingConstructed()

    this.tween = this.getRotatingTween()
    this.tween.start()
  }

  getRotatingTween() {
    let rotation = { rotation: 0 }

    const fadeOutTween = new TWEEN.Tween(rotation)
        .to({ rotation: 360 * PIXI.DEG_TO_RAD }, 2000)
        .onUpdate(() => {
          this.rotatorSprite.rotation = rotation.rotation
        })
        .repeat(Infinity)

    return fadeOutTween
  }


  cleanupTween() {
    if (this.tween) {
      this.tween.stop()
      this.tween = null
    }
  }

  remove() {
    super.remove()

    this.cleanupTween()
  }

  getSpritePath() {
    return 'oil_refinery.png'
  }

  getType() {
    return Protocol.definition().BuildingType.OilRefinery
  }

  getConstantsTable() {
    return "Buildings.OilRefinery"
  }

  getBuildingSprite() {
    const sprite = new PIXI.Container()

    const baseSprite = new PIXI.Sprite(PIXI.utils.TextureCache["oil_refinery_base.png"])
    baseSprite.anchor.set(0.5)
    this.baseSprite = baseSprite
    this.baseSprite.name = "BaseSprite"

    let rotator = new PIXI.Sprite(PIXI.utils.TextureCache["oil_refinery_wheel.png"])
    rotator.name = "Rotator"

    rotator.anchor.set(0.5)

    this.rotatorSprite = rotator

    sprite.addChild(this.baseSprite)
    sprite.addChild(this.rotatorSprite)

    return sprite
  }

}

module.exports = OilRefinery

},{"./../../../../common/constants.json":656,"./../../../../common/util/protocol":686,"./base_building":211,"./fuel_pipe":245}],260:[function(require,module,exports){
const BaseBuilding = require("./base_building")
const Constants = require("./../../../../common/constants.json")
const Protocol = require("./../../../../common/util/protocol")
const Drainable = require("./../../../../common/interfaces/drainable")

class OxygenGenerator extends BaseBuilding {

  getType() {
    return Protocol.definition().BuildingType.OxygenGenerator
  }

  getSpritePath() {
    return "oxygen_generator.png"
  }

  getBuildingSprite() {
    let sprite = new PIXI.Container()

    this.baseSprite = new PIXI.Sprite(PIXI.utils.TextureCache[this.getSpritePath()])
    this.baseSprite.name = "BaseSprite"
    this.baseSprite.anchor.set(0.5)
    // this.baseSprite.width = this.getWidth()
    // this.baseSprite.height = this.getHeight()

    sprite.addChild(this.baseSprite)

    return sprite
  }

  getOxygenMaxWidth() {
    return 36
  }

  getConstantsTable() {
    return "Buildings.OxygenGenerator"
  }

}

module.exports = OxygenGenerator

},{"./../../../../common/constants.json":656,"./../../../../common/interfaces/drainable":671,"./../../../../common/util/protocol":686,"./base_building":211}],261:[function(require,module,exports){
const BaseBuilding = require("./base_building")
const Constants = require("./../../../../common/constants.json")
const Protocol = require("./../../../../common/util/protocol")
const Drainable = require("./../../../../common/interfaces/drainable")
const GasPipe = require("./gas_pipe")

class OxygenTank extends BaseBuilding {

  getType() {
    return Protocol.definition().BuildingType.OxygenTank
  }

  getSpritePath() {
    return "oxygen_tank.png"
  }

  getBuildingSprite() {
    let sprite = new PIXI.Container()

    this.baseSprite = new PIXI.Sprite(PIXI.utils.TextureCache[this.getSpritePath()])
    this.baseSprite.name = "BaseSprite"
    this.baseSprite.anchor.set(0.5)
    this.baseSprite.width = this.getWidth()
    this.baseSprite.height = this.getHeight()

    sprite.addChild(this.baseSprite)

    return sprite
  }


  getConstantsTable() {
    return "Buildings.OxygenTank"
  }

  getOxygenMaxWidth() {
    return 36
  }

}

module.exports = OxygenTank

},{"./../../../../common/constants.json":656,"./../../../../common/interfaces/drainable":671,"./../../../../common/util/protocol":686,"./base_building":211,"./gas_pipe":248}],262:[function(require,module,exports){
const BaseBuilding = require("./../base_building")
const Constants = require("./../../../../../common/constants.json")
const SocketUtil = require("./../../../util/socket_util")
const SpritePoolInstance = require("../../sprite_pool_instance")

class BaseFloor extends BaseBuilding {

  constructor(game, data) {
    super(game, data)

  }

  static isPlacingOnSomeoneElsePlatform(container, x, y, w, h, angle, player) {
    let box = this.getBox(x, y, w, h)

    return container.platformMap.hitTestTile(box).find((hit) => {
      if (!hit.entity) return false

      let placerOwnerId = player && player.getBuildOwnerId()
      return hit.entity.owner && (hit.entity.owner.id !== placerOwnerId)
    })
  }

  // createSprite(texture) {
  //   this.spritePoolInstance = SpritePoolInstance.create({ texture: texture })
  //   return this.spritePoolInstance.sprite
  // }

  onClick(event) {
    super.onClick(event)

    if (this.game.isAdminMode) {
      this.handleDoubleClick(() => {
        SocketUtil.emit("DebugRoom", { id: this.id })
      })
    }
  }

  getBrightness() {
    return 20
  }

  static isDifferentPlatform(platformEntity, type, currentBuilding) {
    if (platformEntity === 0) return true
    if (!platformEntity) return true
    if (platformEntity.getType() !== type) return true
    // if (!currentBuilding) return true

    if (currentBuilding) {
      if (platformEntity.colorIndex !== currentBuilding.colorIndex) return true
      if (platformEntity.textureIndex !== currentBuilding.textureIndex) return true
    }

    return false
  }

  static isPositionValid(container, x, y, w, h, angle, player, type, currentBuilding) {
    if (!this.isWithinInteractDistance(x, y, player)) return false
    if (this.isPlacingOnSomeoneElsePlatform(container, x, y, w, h, angle, player)) return false

    let isValidOnGlobalMap = container.map ? !container.map.isOccupied(x, y, w, h) : true
    let row = Math.floor(y / Constants.tileSize)
    let col = Math.floor(x / Constants.tileSize)
    let platformEntity = container.platformMap.get(row, col)
    let isDifferentPlatform = this.isDifferentPlatform(platformEntity, type, currentBuilding)
                              
    let isTrap = platformEntity && platformEntity.hasCategory("trap")
    

    let distributionEntity = container.distributionMap.get(row, col)
    let hasCrop = distributionEntity && distributionEntity.hasCategory("crop")

    return isDifferentPlatform &&
           !hasCrop &&
           !isTrap &&
           isValidOnGlobalMap
  }

  postBuildingConstructed() {
    super.postBuildingConstructed()
    let underground = this.sector.undergroundMap.get(this.getRow(), this.getCol())
    if (underground && underground.hasCategory("lava")) {
      underground.onCovered()
    }
  }

  static getGroup() {
    return "platforms"
  }

  getMap() {
    return this.container.platformMap
  }

  isMaxUpgradeReached() {
    return true
  }

  getSideHitTileMaps() {
    return []
  }

  getGroup() {
    return "platforms"
  }

  redrawSprite() {


    super.redrawSprite()
  }

  remove() {
    super.remove()

    // this.spritePoolInstance.remove()

    let underground = this.sector.undergroundMap.get(this.getRow(), this.getCol())
    if (underground && underground.hasCategory("lava")) {
      underground.onUncovered()
    }
  }

  getEdgeSpritePath() {
    return 'platform_edge.png'
  }

  getEdgePadding() {
    return 1
  }

  hasEdgeSprite() {
    return false
  }

  redrawNeighborTiles() {
    // if (this.hasCategory("platform")) return

    super.redrawNeighborTiles()
  }

  getDefaultRotation() {
    return 0
  }

  rotateEquip() {
    // dont allow rotation
  }

  getSpritePath() {
    return this.getBaseSpritePath()
  }

  getBaseSpritePath() {
    let table = this.getConstants()
    if (table.sprite && table.sprite.path) {
      return table.sprite.path + ".png"
    }

    throw "must implement getBaseSpritePath"
  }

  applyTint(tint) {
    this.baseSprite.tint = tint
  }

  getDisplayWidth() {
    return Constants.tileSize
  }

  getDisplayHeight() {
    return Constants.tileSize
  }

  getRotatedWidth() {
    return Constants.tileSize
  }

  getRotatedHeight() {
    return Constants.tileSize
  }

  getBuildingSprite() {
    let baseSpritePath = this.getBaseSpritePath()
    this.baseSprite     = this.createSprite(PIXI.utils.TextureCache[baseSpritePath])
    this.baseSprite.anchor.set(0.5)
    this.baseSprite.name = "FloorBaseSprite"
    if (this.data.hasOwnProperty("colorIndex")) {
      let color = this.game.colors[this.data.colorIndex]
      this.baseSprite.tint = color.value
    }

    return this.baseSprite
  }

}

module.exports = BaseFloor

},{"../../sprite_pool_instance":547,"./../../../../../common/constants.json":656,"./../../../util/socket_util":654,"./../base_building":211}],263:[function(require,module,exports){
const Constants = require("./../../../../../common/constants.json")
const Protocol = require("./../../../../../common/util/protocol")
const Tilable = require("./../../../../../common/interfaces/tilable")
const BaseFloor = require("./base_floor")

class CarpetFloor extends BaseFloor {

  static getTextures() {
    if (!this.textures) {
      this.textures = {
        line_zero: PIXI.utils.TextureCache["carpet_0.png"],
        line_one: PIXI.utils.TextureCache["carpet_1.png"],
        line_two: PIXI.utils.TextureCache["carpet_2.png"],
        line_two_straight: PIXI.utils.TextureCache["carpet_2_straight.png"],
        line_three: PIXI.utils.TextureCache["carpet_3.png"],
        line_four: PIXI.utils.TextureCache["carpet_4.png"]
      }
    }

    return this.textures
  }

  getBaseSpritePath() {
    return 'red_carpet.png'
  }

  getSideHitTileMaps() {
    return [this.container.platformMap]
  }

  getType() {
    return Protocol.definition().BuildingType.CarpetFloor
  }

  getConstantsTable() {
    return "Floors.CarpetFloor"
  }

  redrawSprite() {
    let tiles = this.convertNeighborsToSideHits(this.neighbors)
    for (let direction in tiles) {
      if (!tiles[direction]) {
        delete tiles[direction]
      }
    }

    this.layoutTile(tiles)

    super.redrawSprite()
  }

}

Object.assign(CarpetFloor.prototype, Tilable.prototype, {
  getTextures() {
    return this.constructor.getTextures()
  },
  getTileSprite() {
    return this.baseSprite
  }
})


module.exports = CarpetFloor

},{"./../../../../../common/constants.json":656,"./../../../../../common/interfaces/tilable":680,"./../../../../../common/util/protocol":686,"./base_floor":262}],264:[function(require,module,exports){
const BaseFloor = require("./base_floor")
const Constants = require("./../../../../../common/constants.json")
const Protocol = require("./../../../../../common/util/protocol")


class Floor extends BaseFloor {

  getBaseSpritePath() {
    if (this.data && this.data.textureIndex) {
      let textureName = this.game.floorTextures[this.data.textureIndex]
      return textureName
    }

    return 'solid_texture.png'
  }

  getOverlayTexturePath() {
    return 'bevelled_texture.png'
  }

  getEdgeSpritePath() {
    return 'platform_edge.png'
  }

  hasEdgeSprite() {
    return false
  }

  getType() {
    return Protocol.definition().BuildingType.Floor
  }

  getConstantsTable() {
    return "Floors.Floor"
  }

}

module.exports = Floor

},{"./../../../../../common/constants.json":656,"./../../../../../common/util/protocol":686,"./base_floor":262}],265:[function(require,module,exports){
const Constants = require("./../../../../../common/constants.json")
const Protocol = require("./../../../../../common/util/protocol")
const BaseFloor = require("./base_floor")

class GreenFloor extends BaseFloor {

  getBaseSpritePath() {
    return 'green_floor.png'
  }

  getType() {
    return Protocol.definition().BuildingType.GreenFloor
  }

  getConstantsTable() {
    return "Floors.GreenFloor"
  }

}

module.exports = GreenFloor

},{"./../../../../../common/constants.json":656,"./../../../../../common/util/protocol":686,"./base_floor":262}],266:[function(require,module,exports){
const Constants = require("./../../../../../common/constants.json")
const Protocol = require("./../../../../../common/util/protocol")
const BaseFloor = require("./base_floor")

class Lattice extends BaseFloor {

  static isPositionValid(container, x, y, w, h, angle, player, type) {
    if (container.groundMap.isOccupied(x, y, w, h)) return false

    return super.isPositionValid(container, x, y, w, h, angle, player, type)
  }

  getBaseSpritePath() {
    return 'lattice.png'
  }

  getEdgeSpritePath() {
    return ''
  }

  getType() {
    return Protocol.definition().BuildingType.Lattice
  }

  getConstantsTable() {
    return "Floors.Lattice"
  }

}

module.exports = Lattice

},{"./../../../../../common/constants.json":656,"./../../../../../common/util/protocol":686,"./base_floor":262}],267:[function(require,module,exports){
const Constants = require("./../../../../../common/constants.json")
const Protocol = require("./../../../../../common/util/protocol")
const BaseFloor = require("./base_floor")

class PlatedFloor extends BaseFloor {

  getBaseSpritePath() {
    return 'plated_floor.png'
  }

  getType() {
    return Protocol.definition().BuildingType.PlatedFloor
  }

  getConstantsTable() {
    return "Floors.PlatedFloor"
  }

}

module.exports = PlatedFloor

},{"./../../../../../common/constants.json":656,"./../../../../../common/util/protocol":686,"./base_floor":262}],268:[function(require,module,exports){
const Constants = require("./../../../../../common/constants.json")
const Protocol = require("./../../../../../common/util/protocol")
const BaseFloor = require("./base_floor")

class PurpleFloor extends BaseFloor {

  getBaseSpritePath() {
    return 'purple_floor.png'
  }

  getType() {
    return Protocol.definition().BuildingType.PurpleFloor
  }

  getConstantsTable() {
    return "Floors.PurpleFloor"
  }

}

module.exports = PurpleFloor

},{"./../../../../../common/constants.json":656,"./../../../../../common/util/protocol":686,"./base_floor":262}],269:[function(require,module,exports){
const Constants = require("./../../../../../common/constants.json")
const Protocol = require("./../../../../../common/util/protocol")
const BaseFloor = require("./base_floor")

class Soil extends BaseFloor {

  getBaseSpritePath() {
    return 'soil.png'
  }

  getType() {
    return Protocol.definition().BuildingType.Soil
  }

  getConstantsTable() {
    return "Floors.Soil"
  }

}

module.exports = Soil

},{"./../../../../../common/constants.json":656,"./../../../../../common/util/protocol":686,"./base_floor":262}],270:[function(require,module,exports){
const BaseFloor = require("./base_floor")
const Constants = require("./../../../../../common/constants.json")
const Protocol = require("./../../../../../common/util/protocol")


class SteelFloor extends BaseFloor {

  getBaseSpritePath() {
    return 'platform_chromeless_plated.png'
  }

  getEdgeSpritePath() {
    return 'platform_edge.png'
  }

  getType() {
    return Protocol.definition().BuildingType.SteelFloor
  }

  getConstantsTable() {
    return "Floors.SteelFloor"
  }

}

module.exports = SteelFloor

},{"./../../../../../common/constants.json":656,"./../../../../../common/util/protocol":686,"./base_floor":262}],271:[function(require,module,exports){
const Constants = require("./../../../../../common/constants.json")
const Protocol = require("./../../../../../common/util/protocol")
const BaseFloor = require("./base_floor")

class StripePlatedFloor extends BaseFloor {

  getBaseSpritePath() {
    return 'stripe_plated_floor.png'
  }

  getType() {
    return Protocol.definition().BuildingType.StripePlatedFloor
  }

  getConstantsTable() {
    return "Floors.StripePlatedFloor"
  }

}

module.exports = StripePlatedFloor

},{"./../../../../../common/constants.json":656,"./../../../../../common/util/protocol":686,"./base_floor":262}],272:[function(require,module,exports){
const Constants = require("./../../../../../common/constants.json")
const Protocol = require("./../../../../../common/util/protocol")
const BaseFloor = require("./base_floor")

class TiledFloor extends BaseFloor {

  getBaseSpritePath() {
    return 'tiled_floor.png'
  }

  getType() {
    return Protocol.definition().BuildingType.TiledFloor
  }

  getConstantsTable() {
    return "Floors.TiledFloor"
  }

}

module.exports = TiledFloor

},{"./../../../../../common/constants.json":656,"./../../../../../common/util/protocol":686,"./base_floor":262}],273:[function(require,module,exports){
const Constants = require("./../../../../../common/constants.json")
const Protocol = require("./../../../../../common/util/protocol")
const BaseFloor = require("./base_floor")

class WoodFloor extends BaseFloor {

  getBaseSpritePath() {
    return 'wood_floor.png'
  }

  getType() {
    return Protocol.definition().BuildingType.WoodFloor
  }

  getConstantsTable() {
    return "Floors.WoodFloor"
  }

}

module.exports = WoodFloor

},{"./../../../../../common/constants.json":656,"./../../../../../common/util/protocol":686,"./base_floor":262}],274:[function(require,module,exports){
const BaseBuilding = require("./base_building")
const Constants = require("./../../../../common/constants.json")
const Protocol = require("./../../../../common/util/protocol")
const Ores = require("./../ores/index")

class Pot extends BaseBuilding {

  constructor(game, data, isEquipDisplay) {
    super(game, data, isEquipDisplay)
  }

  onContentChanged() {
    const itemType = this.content

    if (itemType) {
      let data = { x: 0, y: 0, user: this }
      this.plant = Ores.forType(itemType).build(this.game, data)
      this.plant.sprite.position.x = 0
      this.plant.sprite.position.y = 0
      this.plant.sprite.anchor.set(0.5)
      this.plant.sprite.width = 25
      this.plant.sprite.height = 25
    } else if (this.plant) {
      // no more flower in storage, remove it
      this.plant.remove()
    }
  }

  shouldShowInteractTooltip() {
    let team = this.game.player.getTeam()
    if (!this.game.isLeaderAndOwner(this, team, this.game.player)) {
      return false
    }

    return super.shouldShowInteractTooltip()
  }

  getType() {
    return Protocol.definition().BuildingType.Pot
  }

  getSpritePath() {
    return "pot.png"
  }

  getConstantsTable() {
    return "Buildings.Pot"
  }

}

module.exports = Pot

},{"./../../../../common/constants.json":656,"./../../../../common/util/protocol":686,"./../ores/index":494,"./base_building":211}],275:[function(require,module,exports){
const SolarPanel = require("./solar_panel")
const Constants = require("./../../../../common/constants.json")
const Protocol = require("./../../../../common/util/protocol")
const Drainable = require("./../../../../common/interfaces/drainable")
const ClienHelper = require("./../../util/client_helper")

class PowerGenerator extends SolarPanel {

  static isOnValidPlatform(container, x, y, w, h, angle, player) {
    if (this.isPlacingOnSomeoneElsePlatform(container, x, y, w, h, angle, player)) return false

    return container.platformMap.isFullyOccupied(x, y, w, h) ||
          (container.groundMap.isFullyOccupied(x, y, w, h) && !container.map.isOccupied(x, y, w, h))
  }

  getSprite() {
    let sprite = super.getSprite()

    this.fillBarContainer.position.x = -36

    return sprite
  }


  onBuildingConstructed() {
    super.onBuildingConstructed()

    this.tween = this.getTween()
  }

  onUsageChanged() {
    super.onUsageChanged()

    if (this.getUsage() > 0) {
      if (!this.tween.isPlaying()) {
        this.tween.start()
      }
    } else {
      this.tween.stop()
    }
  }

  getTween() {
    let alpha = { alpha: 0 }

    const tween = new TWEEN.Tween(alpha)
        .to({ alpha: 1 }, 1000)
        .onUpdate(() => {
          this.coreSprite.alpha = alpha.alpha
        })
        .yoyo(true)
        .repeat(Infinity)

    return tween
  }

  cleanupTween() {
    if (this.tween) {
      this.tween.stop()
      this.tween = null
    }
  }

  remove() {
    super.remove()

    this.cleanupTween()
  }


  getBuildingSprite() {
    let container = new PIXI.Container()

    this.baseSprite = new PIXI.Sprite(PIXI.utils.TextureCache[this.getSpritePath()])
    this.baseSprite.anchor.set(0.5)

    container.addChild(this.baseSprite)

    this.coreSprite = new PIXI.Sprite(PIXI.utils.TextureCache["chemfuel_power_generator_core.png"])
    this.coreSprite.anchor.set(0.5)
    this.coreSprite.position.y = 2
    this.coreSprite.alpha = 0

    container.addChild(this.coreSprite)

    return container
  }



  getType() {
    return Protocol.definition().BuildingType.PowerGenerator
  }

  getSpritePath() {
    return "chemfuel_power_generator.png"
  }

  getConstantsTable() {
    return "Buildings.PowerGenerator"
  }

}

module.exports = PowerGenerator

},{"./../../../../common/constants.json":656,"./../../../../common/interfaces/drainable":671,"./../../../../common/util/protocol":686,"./../../util/client_helper":649,"./solar_panel":291}],276:[function(require,module,exports){
const BaseBuilding = require("./base_building")
const Constants = require("./../../../../common/constants.json")
const Protocol = require("./../../../../common/util/protocol")
const SocketUtil = require("./../../util/socket_util")
const ClientHelper = require("./../../util/client_helper")

class PowerSwitch extends BaseBuilding {

  shouldShowInteractTooltip() {
    if (this.game.player.isGuest()) return false
      
    return super.shouldShowInteractTooltip()
  }

  onOpenChanged() {
    super.onOpenChanged()

    if (this.isOpen) {
      this.offSprite.alpha = 0
    } else {
      this.offSprite.alpha = 1
    }
  }

  getType() {
    return Protocol.definition().BuildingType.PowerSwitch
  }

  getBuildingSprite() {
    let sprite = super.getBuildingSprite()
    this.offSprite = new PIXI.Sprite(PIXI.utils.TextureCache["power_switch_off.png"])
    this.offSprite.position.x = -20
    this.offSprite.position.y = -12
    this.offSprite.alpha = 0
    sprite.addChild(this.offSprite)
    return sprite
  }

  getSpritePath() {
    return "power_switch.png"
  }

  getConstantsTable() {
    return "Buildings.PowerSwitch"
  }

}

module.exports = PowerSwitch

},{"./../../../../common/constants.json":656,"./../../../../common/util/protocol":686,"./../../util/client_helper":649,"./../../util/socket_util":654,"./base_building":211}],277:[function(require,module,exports){
const Constants = require("./../../../../common/constants.json")
const Protocol = require("./../../../../common/util/protocol")
const Tilable = require("./../../../../common/interfaces/tilable")
const BaseBuilding = require("./base_building")

class RailStop extends BaseBuilding {

  getSpritePath() {
    return 'rail_stop.png'
  }

  getSelectionRect() {
    return this.getControlPanel()
  }

  static isPositionValid(container, x, y, w, h, angle, player, type, instance) {
    let box = this.getBox(x, y, w, h)
    let hasRailStopNeighbor = this.getNeighborTiles(container.structureMap, box)
                                  .find((hit) => {
      return hit.entity && hit.entity.hasCategory("rail_stop")
    })


    return this.isOnValidPlatform(container, x, y, w, h, angle, player) &&
           this.isWithinInteractDistance(x, y, player) &&
           !this.isOnHangar(container, x, y, w, h) &&
           !hasRailStopNeighbor &&
           !this.hasInvalidRailTrackPosition(container, box, instance) &&
           !container.unitMap.isOccupied(x, y, w, h) &&
           !container.armorMap.isOccupied(x, y, w, h) &&
           !container.structureMap.isOccupied(x, y, w, h)
  }

  static hasInvalidRailTrackPosition(container, box, instance) {
    let allowedTrackHits = instance.getAllowedTrackHits()

    let paddedBox = this.getPaddedRelativeBox(box)

    return container.railMap.hitTestTile(paddedBox)
                                  .find((hit) => {
      if (hit.entity && hit.entity.hasCategory("rail_track")) {
        let isNotValidTrackPosition = !allowedTrackHits.find((allowedHit) => {
          return allowedHit.row === hit.row && allowedHit.col === hit.col
        })

        return isNotValidTrackPosition
      }

      return false
    })
  }


  getTramCenter() {
    // -90, x - 16
    // 0,   y - 16
    // 90,  x + 16
    // 180,  y + 16

    let x = this.getX() + Math.round(Math.sin(this.getRadAngle())) * Constants.tileSize / 2
    let y = this.getY() - Math.round(Math.cos(this.getRadAngle())) * Constants.tileSize / 2

    return { x: x, y: y }
  }

  getTramCenterHit() {
    let tramCenter = this.getTramCenter()

    let row = Math.floor(tramCenter.y / Constants.tileSize)
    let col = Math.floor(tramCenter.x / Constants.tileSize)

    return { row: row, col: col }
  }


  getAllowedTrackNeighborHits() {
    let tramCenterHit = this.getTramCenterHit()

    let row = tramCenterHit.row
    let col = tramCenterHit.col

    return [
      { row: row - 1, col: col },
      { row: row    , col: col + 1 },
      { row: row + 1, col: col },
      { row: row    , col: col - 1 }
    ]
  }

  getAllowedTrackHits() {
    let tramCenterHit = this.getTramCenterHit()
    let row = tramCenterHit.row
    let col = tramCenterHit.col

    let innerHits = this.getAllowedTrackNeighborHits()

    let outerHits = [
      { row: row - 2, col: col },
      { row: row    , col: col + 2 },
      { row: row + 2, col: col },
      { row: row    , col: col - 2 }
    ]

    return [tramCenterHit].concat(outerHits).concat(innerHits)
  }

  getControlPanel() {
    let mainX = this.getX()
    let mainY = this.getY()
    let tileDistanceFromCenter = 1.5

    let x
    let y

    let angle = this.angle % 360

    switch(angle) {
      case -90:
        x = Constants.tileSize
        y = -Constants.tileSize * 1.5
        break
      case 0:
        x = -Constants.tileSize * 1.5
        y = Constants.tileSize 
        break
      case 90:
        x = -Constants.tileSize * 2
        y = -Constants.tileSize * 1.5
        break
      case 180:
        x = -Constants.tileSize * 1.5
        y = -Constants.tileSize * 2
        break

    }

    let row = Math.floor(y / Constants.tileSize)
    let col = Math.floor(x / Constants.tileSize)

    let w = Constants.tileSize * 2 * Math.round(Math.abs(Math.cos(this.getRadAngle()))) + Constants.tileSize
    let h = Constants.tileSize * 2 * Math.round(Math.abs(Math.sin(this.getRadAngle()))) + Constants.tileSize

    return {
      row: row,
      col: col,
      x: x,
      y: y,
      w: w,
      h: h
    }
  }


  getType() {
    return Protocol.definition().BuildingType.RailStop
  }

  getConstantsTable() {
    return "Buildings.RailStop"
  }

  getStopName() {
    return this.content || ("Rail Stop " + this.id)
  }

  openMenu() {
    let options = { entity: this }
    if (!this.isPowered) options['disabled'] = 'Insufficient Power'

    this.game.railStopMenu.open(options)
  }

  onContentChanged() {
    this.game.railStopMenu.render(this)  
  }

  remove() {
    super.remove() 
  }

}

module.exports = RailStop
},{"./../../../../common/constants.json":656,"./../../../../common/interfaces/tilable":680,"./../../../../common/util/protocol":686,"./base_building":211}],278:[function(require,module,exports){
const Constants = require("./../../../../common/constants.json")
const Protocol = require("./../../../../common/util/protocol")
const Tilable = require("./../../../../common/interfaces/tilable")
const RailTrackCommon = require("./../../../../common/entities/rail_track_common")
const BaseBuilding = require("./base_building")

class RailTrack extends BaseBuilding {

  onBuildingConstructed() {
    super.onBuildingConstructed()
  }

  getRotatedWidth() {
    return Constants.tileSize
  }

  getRotatedHeight() {
    return Constants.tileSize
  }

  static getTextures() {
    if (!this.textures) {
      this.textures = {
        line_zero: PIXI.utils.TextureCache["rail_track.png"],
        line_one: PIXI.utils.TextureCache["rail_track.png"],
        line_two: PIXI.utils.TextureCache["rail_track_all.png"],
        line_two_straight: PIXI.utils.TextureCache["rail_track.png"],
        line_three: PIXI.utils.TextureCache["rail_track_all.png"],
        line_four: PIXI.utils.TextureCache["rail_track_all.png"]
      }
    }

    return this.textures
  }

  redrawSprite() {
    let tiles = this.convertNeighborsToSideHits(this.neighbors)
    for (let direction in tiles) {
      if (!tiles[direction]) {
        delete tiles[direction]
      }
    }

    this.layoutTile(tiles)
    super.redrawSprite()
  }

  getSideHitTileMaps() {
    return [this.container.railMap]
  }

  getMap() {
    return this.container.railMap
  }

  getAreaInvalidWidth() {
    return this.getWidth() * 3
  }

  getAreaInvalidHeight() {
    return this.getWidth() * 3
  }

  static isPositionValid(container, x, y, w, h, angle, player) {
    let blockingWidth  = w * 3
    let blockingHeight = h * 3

    let foregroundHits = container.map.hitTestTile(this.getBox(x, y, blockingWidth, blockingHeight))
    let hasBlockingAsteroid = foregroundHits.find((hit) => { 
      return hit.entity 
    })

    let row = Math.floor(y / Constants.tileSize)
    let col = Math.floor(x / Constants.tileSize)

    let isOnEdgeOfMap = row === 0 || col === 0 || row === container.getRowCount() - 1 || col === container.getColCount() - 1

    let structureHits = container.structureMap.hitTestTile(this.getBox(x, y, blockingWidth, blockingHeight))
    let hasBlockingStructure = structureHits.find((hit) => { 
      return hit.entity && !hit.entity.hasCategory("rail_stop")
    })

    let structureCenterHit = container.structureMap.get(row, col)
    let isCenterOnInvalidRailStopPosition = structureCenterHit && structureCenterHit.hasCategory("rail_stop")

    return this.isWithinInteractDistance(x, y, player) &&
           !this.isOnHangar(container, x, y, w, h) &&
           !isOnEdgeOfMap &&
           !isCenterOnInvalidRailStopPosition &&
           !RailTrackCommon.hasInvalidRailStopNeighbor(container, row, col) &&
           !RailTrackCommon.hasTriangleRailNeighbors(container, row, col) &&
           !hasBlockingAsteroid &&
           !hasBlockingStructure &&
           !container.railMap.isOccupied(x, y, w, h) &&
           !container.unitMap.isOccupied(x, y, w, h) &&
           !container.armorMap.isOccupied(x, y, blockingWidth, blockingHeight) 
  }


  static hasHorizontalNeighborTrack(container, row, col) {
    let entity = container.railMap.get(row, col - 1) 
    if (entity && entity.getType() === this.getType()) {
      return true
    }

    entity = container.railMap.get(row, col + 1) 
    if (entity && entity.getType() === this.getType()) {
      return true
    }

    return false
  }

  static hasVerticalNeighborTrack(container, row, col) {
    let entity = container.railMap.get(row - 1, col) 
    if (entity && entity.getType() === this.getType()) {
      return true
    }
    
    entity = container.railMap.get(row + 1, col) 
    if (entity && entity.getType() === this.getType()) {
      return true
    }

    return false
  }

  getSpritePath() {
    return 'rail_track.png'
  }

  getType() {
    return Protocol.definition().BuildingType.RailTrack
  }

  getConstantsTable() {
    return "Buildings.RailTrack"
  }

  getConduits(sideHits) {
    let conduits = {}

    // find out which ones are conduits
    for (let direction in sideHits) {
      let directionHits = sideHits[direction]
      if (this.hasConduitInDirection(directionHits)) {
        conduits[direction] = true
      }
    }

    return conduits
  }

  hasConduitInDirection(directionHits) {
    return directionHits.every((hit) => {
      return hit.entity && hit.entity.getType() === this.getType()
    })
  }


}

Object.assign(RailTrack.prototype, Tilable.prototype, {
  getTextures() {
    return this.constructor.getTextures()
  },
  getTileSprite() {
    return this.buildingSprite
  },
  getSides() {
    const sideHits = this.getSideHits()
    return this.getConduits(sideHits)
  }
})


module.exports = RailTrack
},{"./../../../../common/constants.json":656,"./../../../../common/entities/rail_track_common":662,"./../../../../common/interfaces/tilable":680,"./../../../../common/util/protocol":686,"./base_building":211}],279:[function(require,module,exports){
const BaseBuilding = require("./base_building")
const Constants = require("./../../../../common/constants.json")
const Protocol = require("./../../../../common/util/protocol")

class Reactor extends BaseBuilding {

  constructor(game, data, isEquipDisplay) {
    super(game, data, isEquipDisplay)

    this.tween = this.getRotatingTween()
    this.tween.start()
  }

  getRotatingTween() {
    let rotation = { rotation: 0 }

    const fadeOutTween = new TWEEN.Tween(rotation)
        .to({ rotation: 360 * PIXI.DEG_TO_RAD }, 1000)
        .onUpdate(() => {
          this.rotatorSprite.rotation = rotation.rotation
        })
        .repeat(Infinity)

    return fadeOutTween
  }

  cleanupTween() {
    if (this.tween) {
      this.tween.stop()
      this.tween = null
    }
  }

  remove() {
    super.remove()

    this.cleanupTween()
  }


  getSpritePath() {
    return this.getRotatorSpritePath()
  }

  getBaseSpritePath() {
    return "reactor_base.png"
  }

  getRotatorSpritePath() {
    return "reactor_rotator.png"
  }


  getBuildingSprite() {
    const sprite = new PIXI.Container()

    const baseSprite = new PIXI.Sprite(PIXI.utils.TextureCache[this.getBaseSpritePath()])
    baseSprite.anchor.set(0.5)
    baseSprite.width = this.getWidth()
    baseSprite.height = this.getHeight()

    this.rotatorSprite = new PIXI.Sprite(PIXI.utils.TextureCache[this.getRotatorSpritePath()])

    this.rotatorSprite.anchor.set(0.5)
    this.rotatorSprite.width = this.getWidth()
    this.rotatorSprite.height = this.getHeight()



    sprite.addChild(baseSprite)
    sprite.addChild(this.rotatorSprite)

    return sprite
  }


  getType() {
    return Protocol.definition().BuildingType.Reactor
  }

  getConstantsTable() {
    return "Buildings.Reactor"
  }

}

module.exports = Reactor

},{"./../../../../common/constants.json":656,"./../../../../common/util/protocol":686,"./base_building":211}],280:[function(require,module,exports){
const BaseBuilding = require("./base_building")
const Constants = require("./../../../../common/constants.json")
const Protocol = require("./../../../../common/util/protocol")

class RedPresent extends BaseBuilding {

  constructor(game, data, isEquipDisplay) {
    super(game, data, isEquipDisplay)
  }

  getType() {
    return Protocol.definition().BuildingType.RedPresent
  }

  getSpritePath() {
    return "red_present.png"
  }

  getConstantsTable() {
    return "Buildings.RedPresent"
  }

}

module.exports = RedPresent
},{"./../../../../common/constants.json":656,"./../../../../common/util/protocol":686,"./base_building":211}],281:[function(require,module,exports){
const Bars = require("./../bars/index")
const BaseBuilding = require("./base_building")
const Constants = require("./../../../../common/constants.json")
const Protocol = require("./../../../../common/util/protocol")
const Equipments = require("./../equipments/index")

class Refinery extends BaseBuilding {

  constructor(game, data, isEquipDisplay) {
    super(game, data, isEquipDisplay)
  }

  onBuildingConstructed() {
    super.onBuildingConstructed()
    this.tween = this.getRotatingTween()
  }

  onIsProcessingChanged() {
    if (this.isProcessing) {
      if (!this.tween) {
        this.tween = this.getRotatingTween()
      }
      this.tween.start()
    } else {
      this.tween.stop()
      this.tween = null
    }
  }

  openMenu() {
    let options = {}
    if (!this.isPowered) {
      options["disabled"] = "Insufficient Power"
    }

    let shouldHideInput = false
    this.game.processorMenu.open("Refinery", this, this.getMenuDescription(), shouldHideInput, "", options)
  }

  getType() {
    return Protocol.definition().BuildingType.Refinery
  }

  getSpritePath() {
    return "refinery.png"
  }

  getConstantsTable() {
    return "Buildings.Refinery"
  }

  getBuildingSprite() {
    let sprite = new PIXI.Container()

    this.baseSprite = new PIXI.Sprite(PIXI.utils.TextureCache["refinery_base.png"])
    this.baseSprite.name = "BaseSprite"
    this.baseSprite.anchor.set(0.5)

    this.gearSprite = new PIXI.Sprite(PIXI.utils.TextureCache["refinery_gear.png"])
    this.gearSprite.name = "GearSprite"
    this.gearSprite.anchor.set(0.5)
    this.gearSprite.position.x = 10
    this.gearSprite.position.y = -40

    this.smallGearSprite = new PIXI.Sprite(PIXI.utils.TextureCache["refinery_gear_small.png"])
    this.smallGearSprite.name = "SmallGearSprite"
    this.smallGearSprite.anchor.set(0.5)
    this.smallGearSprite.position.x = -25
    this.smallGearSprite.position.y = -20

    sprite.addChild(this.baseSprite)
    sprite.addChild(this.gearSprite)
    sprite.addChild(this.smallGearSprite)

    return sprite
  }

  getRotatingTween() {
    let rotation = { rotation: 0 }

    const fadeOutTween = new TWEEN.Tween(rotation)
        .to({ rotation: 360 * PIXI.DEG_TO_RAD }, 3000)
        .onUpdate(() => {
          this.gearSprite.rotation = rotation.rotation
          this.smallGearSprite.rotation = rotation.rotation
        })
        .repeat(Infinity)

    return fadeOutTween
  }

  cleanupTween() {
    if (this.tween) {
      this.tween.stop()
      this.tween = null
    }
  }

  remove() {
    super.remove()

    this.cleanupTween()
  }

}

module.exports = Refinery

},{"./../../../../common/constants.json":656,"./../../../../common/util/protocol":686,"./../bars/index":204,"./../equipments/index":407,"./base_building":211}],282:[function(require,module,exports){
const BaseBuilding = require("./base_building")
const Constants = require("./../../../../common/constants.json")
const Protocol = require("./../../../../common/util/protocol")

class ResearchTable extends BaseBuilding {

  constructor(game, data, isEquipDisplay) {
    super(game, data, isEquipDisplay)
  }

  getType() {
    return Protocol.definition().BuildingType.ResearchTable
  }

  getSpritePath() {
    return "research_table_2.png"
  }

  getConstantsTable() {
    return "Buildings.ResearchTable"
  }

}

module.exports = ResearchTable

},{"./../../../../common/constants.json":656,"./../../../../common/util/protocol":686,"./base_building":211}],283:[function(require,module,exports){
const BaseBuilding = require("./base_building")
const Constants = require("./../../../../common/constants.json")
const Protocol = require("./../../../../common/util/protocol")
const Airlock = require("./airlock")

class SealedDoor extends Airlock {

  constructor(game, data, isEquipDisplay) {
    super(game, data, isEquipDisplay)
  }

  getType() {
    return Protocol.definition().BuildingType.SealedDoor
  }

  shouldShowCustomAccessSelect() {
    return false
  }

  getSpritePath() {
    return "sealed_door.png"
  }

  getConstantsTable() {
    return "Buildings.SealedDoor"
  }

  getBuildingSprite() {
    let sprite = new PIXI.Container()

    let texture = PIXI.utils.TextureCache["sealed_door_upper.png"]
    this.upperDoorSprite = new PIXI.Sprite(texture)
    this.upperDoorSprite.anchor.set(0.5)
    this.upperDoorSprite.name = "UpperDoor"

    texture = PIXI.utils.TextureCache["sealed_door_lower.png"]
    this.lowerDoorSprite = new PIXI.Sprite(texture)
    this.lowerDoorSprite.anchor.set(0.5)
    this.lowerDoorSprite.name = "LowerDoor"

    sprite.addChild(this.lowerDoorSprite)
    sprite.addChild(this.upperDoorSprite)

    return sprite
  }

}

module.exports = SealedDoor

},{"./../../../../common/constants.json":656,"./../../../../common/util/protocol":686,"./airlock":208,"./base_building":211}],284:[function(require,module,exports){
const BaseBuilding = require("./base_building")
const Constants = require("./../../../../common/constants.json")
const Protocol = require("./../../../../common/util/protocol")
const Helper = require("./../../../../common/helper")

class SecurityCamera extends BaseBuilding {

  constructor(game, data, isEquipDisplay) {
    super(game, data, isEquipDisplay)
  }

  getName() {
    return this.content || "Feed " + this.id
  }

  openMenu() {
    this.game.changeNameMenu.open({ entity: this })
  }

  onContentChanged() {
    this.game.changeNameMenu.close()
  }

  getType() {
    return Protocol.definition().BuildingType.SecurityCamera
  }

  getSpritePath() {
    return "security_camera.png"
  }

  getConstantsTable() {
    return "Buildings.SecurityCamera"
  }

}

module.exports = SecurityCamera

},{"./../../../../common/constants.json":656,"./../../../../common/helper":664,"./../../../../common/util/protocol":686,"./base_building":211}],285:[function(require,module,exports){
const BaseBuilding = require("./base_building")
const Constants = require("./../../../../common/constants.json")
const Protocol = require("./../../../../common/util/protocol")
const Helper = require("./../../../../common/helper")

class SecurityMonitor extends BaseBuilding {

  constructor(game, data, isEquipDisplay) {
    super(game, data, isEquipDisplay)
  }

  openMenu() {
  }

  getType() {
    return Protocol.definition().BuildingType.SecurityMonitor
  }

  getSpritePath() {
    return "security_monitor.png"
  }

  getConstantsTable() {
    return "Buildings.SecurityMonitor"
  }

}

module.exports = SecurityMonitor

},{"./../../../../common/constants.json":656,"./../../../../common/helper":664,"./../../../../common/util/protocol":686,"./base_building":211}],286:[function(require,module,exports){
const BaseBuilding = require("./base_building")
const Constants = require("./../../../../common/constants.json")
const Protocol = require("./../../../../common/util/protocol")

class ShieldGenerator extends BaseBuilding {

  getSpritePath() {
    return 'shield_generator.png'
  }

  getType() {
    return Protocol.definition().BuildingType.ShieldGenerator
  }

  getConstantsTable() {
    return "Buildings.ShieldGenerator"
  }

}

module.exports = ShieldGenerator

},{"./../../../../common/constants.json":656,"./../../../../common/util/protocol":686,"./base_building":211}],287:[function(require,module,exports){
const BaseBuilding = require("./base_building")
const Constants = require("./../../../../common/constants.json")
const Protocol = require("./../../../../common/util/protocol")

class Shower extends BaseBuilding {

  getType() {
    return Protocol.definition().BuildingType.Shower
  }

  getSpritePath() {
    return "shower.png"
  }

  getBuildingSprite() {
    let sprite = super.getBuildingSprite()
    sprite.position.y = -5
    return sprite
  }

  getConstantsTable() {
    return "Buildings.Shower"
  }

}

module.exports = Shower

},{"./../../../../common/constants.json":656,"./../../../../common/util/protocol":686,"./base_building":211}],288:[function(require,module,exports){
const BaseBuilding = require("./base_building")
const Constants = require("./../../../../common/constants.json")
const Protocol = require("./../../../../common/util/protocol")

class Sign extends BaseBuilding {

  static getChatBubbleInstance() {

  }

  constructor(game, data, isEquipDisplay) {
    super(game, data, isEquipDisplay)
  }

  getType() {
    return Protocol.definition().BuildingType.Sign
  }

  getSpritePath() {
    return "sign.png"
  }

  getConstantsTable() {
    return "Buildings.Sign"
  }

  openMenu() {
    this.game.signMenu.open({ entity: this })
  }

  onContentChanged() {
    this.game.signMenu.render(this)  
  }

  canMenuBeOpened() {
    return this.isConstructionFinished()
  }

  onHighlighted() {
    let text = this.getText()
    if (text.length === 0) return

    if (this.constructor.chatBubble && !this.constructor.chatBubble.isRemoved) {
      this.constructor.chatBubble.remove()
    }
    this.constructor.chatBubble = this.createChatBubble(text, { isAbsolutePosition: true })
  }

  setAngle(angle) {
    this.angle = angle
    this.sprite.rotation = this.getRadAngle() + Math.PI/2
  }


  getText() {
    if (window.isForeignLanguage && this.localeContents[window.language]) {
      return this.localeContents[window.language]
    }
    
    return this.content || ""
  }

}

module.exports = Sign

},{"./../../../../common/constants.json":656,"./../../../../common/util/protocol":686,"./base_building":211}],289:[function(require,module,exports){
const BaseBuilding = require("./base_building")
const Constants = require("./../../../../common/constants.json")
const Protocol = require("./../../../../common/util/protocol")
const Table = require("./table")

class SlaversTable extends Table {

  getType() {
    return Protocol.definition().BuildingType.SlaversTable
  }

  getSpritePath() {
    return "slavers_table.png"
  }

  getConstantsTable() {
    return "Buildings.SlaversTable"
  }

}

module.exports = SlaversTable

},{"./../../../../common/constants.json":656,"./../../../../common/util/protocol":686,"./base_building":211,"./table":296}],290:[function(require,module,exports){
const OxygenTank = require("./oxygen_tank")
const Constants = require("./../../../../common/constants.json")
const Protocol = require("./../../../../common/util/protocol")

class SmallOxygenTank extends OxygenTank {

  constructor(game, data, isEquipDisplay) {
    super(game, data, isEquipDisplay)
  }

  getWidth() {
    return 32
  }

  getHeight() {
    return 32
  }

  getSprite() {
    let sprite = super.getSprite()

    this.fillBarContainer.position.x = -22

    return sprite
  }


  getType() {
    return Protocol.definition().BuildingType.SmallOxygenTank
  }

  getSpritePath() {
    return "oxygen_tank.png"
  }

  getConstantsTable() {
    return "Buildings.SmallOxygenTank"
  }

}

module.exports = SmallOxygenTank

},{"./../../../../common/constants.json":656,"./../../../../common/util/protocol":686,"./oxygen_tank":261}],291:[function(require,module,exports){
const BaseBuilding = require("./base_building")
const Constants = require("./../../../../common/constants.json")
const Protocol = require("./../../../../common/util/protocol")
const Drainable = require("./../../../../common/interfaces/drainable")
const Wire = require("./wire")

class SolarPanel extends BaseBuilding {

  static isOnValidPlatform(container, x, y, w, h, angle, player) {
    if (this.isPlacingOnSomeoneElsePlatform(container, x, y, w, h, angle, player)) return false

    let box = this.getBox(x, y, w, h)
    let hasLattice = container.platformMap.hitTestTile(box).every((hit) => {
      return hit.entity && hit.entity.getType() === Protocol.definition().BuildingType.Lattice
    })

    return hasLattice
  }

  getSprite() {
    let sprite = super.getSprite()

    this.fillBarContainer.position.x = -30

    return sprite
  }

  getType() {
    return Protocol.definition().BuildingType.SolarPanel
  }

  getSpritePath() {
    return "solar_panel.png"
  }

  getConstantsTable() {
    return "Buildings.SolarPanel"
  }

}

module.exports = SolarPanel

},{"./../../../../common/constants.json":656,"./../../../../common/interfaces/drainable":671,"./../../../../common/util/protocol":686,"./base_building":211,"./wire":325}],292:[function(require,module,exports){
const BaseFloor = require("./platforms/base_floor")
const Constants = require("./../../../../common/constants.json")
const Protocol = require("./../../../../common/util/protocol")

class SpikeTrap extends BaseFloor {

  constructor(game, data, isEquipDisplay) {
    super(game, data, isEquipDisplay)
  }

  getType() {
    return Protocol.definition().BuildingType.SpikeTrap
  }

  getBaseSpritePath() {
    return "spike_trap.png"
  }

  getSpritePath() {
    return "spike_trap.png"
  }

  getConstantsTable() {
    return "Buildings.SpikeTrap"
  }

}

module.exports = SpikeTrap

},{"./../../../../common/constants.json":656,"./../../../../common/util/protocol":686,"./platforms/base_floor":262}],293:[function(require,module,exports){
const BaseBuilding = require("./base_building")
const Constants = require("./../../../../common/constants.json")
const Protocol = require("./../../../../common/util/protocol")
const SocketUtil = require("../../util/socket_util")

class SteelCrate extends BaseBuilding {

  constructor(game, data, isEquipDisplay) {
    super(game, data, isEquipDisplay)
  }

  openMenu() {
    this.game.storageMenu.open("Steel Crate", this)
  }

  getType() {
    return Protocol.definition().BuildingType.SteelCrate
  }

  getSpritePath() {
    return "steel_crate.png"
  }

  getConstantsTable() {
    return "Buildings.SteelCrate"
  }

}

module.exports = SteelCrate

},{"../../util/socket_util":654,"./../../../../common/constants.json":656,"./../../../../common/util/protocol":686,"./base_building":211}],294:[function(require,module,exports){
const Foods = require("./../foods/index")
const BaseBuilding = require("./base_building")
const Constants = require("./../../../../common/constants.json")
const Protocol = require("./../../../../common/util/protocol")
const ProgressBar = require("./../../components/progress_bar")

class Stove extends BaseBuilding {

  constructor(game, data, isEquipDisplay) {
    super(game, data, isEquipDisplay)
  }

  onContentChanged() {
    this.game.stoveMenu.render(this)  
  }

  openMenu() {
    const templateList = Foods.getCookables()
    
    let options = {
      entity: this
    }

    if (!this.isPowered) {
      options["disabled"] = "Insufficient Power"
    }

    this.game.stoveMenu.open(options)
  }

  onUsageChanged() {
    if (this.isCookingComplete()) {
      this.initStoveProgressBar()
      this.stoveProgressBar.remove()
      this.stoveProgressBar = null
      this.game.stoveMenu.renderSelected()
    } else {
      this.initStoveProgressBar()
      this.stoveProgressBar.draw()
    }

    this.game.stoveMenu.onUsageChanged(this.usage)
  }

  initStoveProgressBar() {
    if (this.stoveProgressBar) return

    this.stoveProgressBar = new ProgressBar(this, { 
      attribute: "usage", 
      maxAttribute: "getUsageCapacity", 
      isFixedPosition: true,
      displayOnTop: true
    })
  }

  isCookingComplete() {
    return this.usage >= 100 || this.usage === 0
  }

  getType() {
    return Protocol.definition().BuildingType.Stove
  }

  shouldSetEmptyContentOnZeroUsage() {
    return false
  }

  getSpritePath() {
    return "stove.png"
  }

  getConstantsTable() {
    return "Buildings.Stove"
  }

}

module.exports = Stove

},{"./../../../../common/constants.json":656,"./../../../../common/util/protocol":686,"./../../components/progress_bar":183,"./../foods/index":422,"./base_building":211}],295:[function(require,module,exports){
const BaseBuilding = require("./base_building")
const Constants = require("./../../../../common/constants.json")
const Protocol = require("./../../../../common/util/protocol")
const Equipments = require("./../equipments/index")

class SuitStation extends BaseBuilding {

  constructor(game, data, isEquipDisplay) {
    super(game, data, isEquipDisplay)
  }

  onContentChanged() {
    const armorType = this.content

    if (armorType) {
      let suitType = armorType.split(":")[0]
      let color = armorType.split(":")[1]

      let data = { x: 0, y: 0, user: this }
      data.instance = {
        content: color
      }

      this.armor = Equipments.forType(suitType).build(this.game, data)
    } else if (this.armor) {
      // no more armor in storage, remove it
      this.armor.remove()
    }
  }

  getType() {
    return Protocol.definition().BuildingType.SuitStation
  }

  getSpritePath() {
    return "suit_station.png"
  }

  getBuildingSprite() {
    let sprite = new PIXI.Container()

    this.baseSprite = new PIXI.Sprite(PIXI.utils.TextureCache["suit_station_base.png"])
    this.baseSprite.name = "BaseSprite"
    this.baseSprite.anchor.set(0.5)

    this.leftCoverSprite = new PIXI.Sprite(PIXI.utils.TextureCache["suit_station_cover.png"])
    this.leftCoverSprite.anchor.set(0.5)
    this.leftCoverSprite.name = "LeftDoor"
    this.leftCoverSprite.rotation = Math.PI
    this.leftCoverSprite.position.y = -Constants.tileSize/2
    this.leftCoverSprite.alpha = 0

    this.rightCoverSprite = new PIXI.Sprite(PIXI.utils.TextureCache["suit_station_cover.png"])
    this.rightCoverSprite.anchor.set(0.5)
    this.rightCoverSprite.name = "RightDoor"
    this.rightCoverSprite.position.y = Constants.tileSize/2
    this.rightCoverSprite.alpha = 0

    this.armorEquipContainer = new PIXI.Container()
    this.armorEquipContainer.name = "ArmorEquipment"
    this.armorEquipContainer.pivot.x = Constants.tileSize/2
    this.armorEquipContainer.pivot.y = Constants.tileSize/2 + 4
    this.armorEquipContainer.rotation = Math.PI

    this.buttonSprite = new PIXI.Sprite(PIXI.utils.TextureCache["suit_station_button.png"])
    this.buttonSprite.anchor.set(0.5)
    this.buttonSprite.name = "Button"
    // this.buttonSprite.position.y = Constants.tileSize/2

    this.topCoverSprite = new PIXI.Sprite(PIXI.utils.TextureCache["suit_station_top.png"])
    this.topCoverSprite.anchor.set(0.5)
    this.topCoverSprite.name = "TopCover"
    this.topCoverSprite.position.x = 18


    sprite.addChild(this.baseSprite)
    sprite.addChild(this.leftCoverSprite)
    sprite.addChild(this.rightCoverSprite)
    sprite.addChild(this.buttonSprite)
    sprite.addChild(this.armorEquipContainer)
    sprite.addChild(this.topCoverSprite)

    return sprite
  }


  getConstantsTable() {
    return "Buildings.SuitStation"
  }

}

module.exports = SuitStation

},{"./../../../../common/constants.json":656,"./../../../../common/util/protocol":686,"./../equipments/index":407,"./base_building":211}],296:[function(require,module,exports){
const BaseBuilding = require("./base_building")
const Constants = require("./../../../../common/constants.json")
const Protocol = require("./../../../../common/util/protocol")

class Table extends BaseBuilding {

  constructor(game, data, isEquipDisplay) {
    super(game, data, isEquipDisplay)
  }

  getType() {
    return Protocol.definition().BuildingType.Table
  }

  getSpritePath() {
    return "steel_table.png"
  }

  getConstantsTable() {
    return "Buildings.Table"
  }

}

module.exports = Table

},{"./../../../../common/constants.json":656,"./../../../../common/util/protocol":686,"./base_building":211}],297:[function(require,module,exports){
const BaseBuilding = require("./base_building")
const Constants = require("./../../../../common/constants.json")
const Protocol = require("./../../../../common/util/protocol")

class Television extends BaseBuilding {

  constructor(game, data, isEquipDisplay) {
    super(game, data, isEquipDisplay)
  }

  getType() {
    return Protocol.definition().BuildingType.Television
  }

  getSpritePath() {
    return "television.png"
  }

  getConstantsTable() {
    return "Buildings.Television"
  }

}

module.exports = Television

},{"./../../../../common/constants.json":656,"./../../../../common/util/protocol":686,"./base_building":211}],298:[function(require,module,exports){
const BaseBuilding = require("./base_building")
const Constants = require("./../../../../common/constants.json")
const Protocol = require("./../../../../common/util/protocol")

class Terminal extends BaseBuilding {

  constructor(game, data, isEquipDisplay) {
    super(game, data, isEquipDisplay)

    // this.animate()
  }

  openMenu() {
    // if (this.game.isMiniGame() && this.isUserImposter()) {
    //   if (!this.game.terminalMenu.isChoiceSubmitted) {
        this.game.terminalMenu.open({ entity: this })
    //   }
    // }
  }

  isUserImposter() {
    let result = false
    
    for (let index in this.game.player.inventory) {
      let item = this.game.player.inventory[index]
      if (item.type === Protocol.definition().BuildingType.AssassinsKnife) {
        result = true
        break
      }
    }

    return result
  }

  animate() {
    // this.animationInterval = setInterval(() => {
    //   this.sprite.scale.set(0 - this.sprite.scale.x)
    // }, 500)
  }

  cleanupInterval() {
    if (this.animationInterval) {
      clearInterval(this.animationInterval)
      this.animationInterval = null
    }
  }

  showPowerOff() {
    super.showPowerOff()
    this.powerOffSprite.rotation = -Math.PI/2
  }

  remove() {
    super.remove()

    this.cleanupInterval()
  }

  getType() {
    return Protocol.definition().BuildingType.Terminal
  }

  isNotForSale() {
    return true
  }

  getSpritePath() {
    return "computer_terminal.png"
  }

  getConstantsTable() {
    return "Buildings.Terminal"
  }

}

module.exports = Terminal

},{"./../../../../common/constants.json":656,"./../../../../common/util/protocol":686,"./base_building":211}],299:[function(require,module,exports){
const BaseBuilding = require("./base_building")
const Constants = require("./../../../../common/constants.json")
const Protocol = require("./../../../../common/util/protocol")
const Trail = require("./../particles/trail")

class Thruster extends BaseBuilding {

  constructor(game, data, isEquipDisplay) {
    super(game, data, isEquipDisplay)

    if (!this.isEquipDisplay && this.container.isMovable()) {
      this.container.addThruster(this)
    }
  }

  remove() {
    if (!this.isEquipDisplay && this.container.isMovable()) {
      this.container.removeThruster(this)
    }
    super.remove()
  }

  addTrail() {
    Trail.create({ 
      x: this.getX(), 
      y: this.getY(), 
      angle: this.getRotatedAngle(), 
      color: 0x86e7ff, 
      radius: 20, 
      offset: 96
    })
  }

  getSpritePath() {
    return this.getBaseSpritePath()
  }

  getBaseSpritePath() {
    return "thruster_small.png"
  }

  getRotatorSpritePath() {
    return ""
  }

  getDisplayWidth() {
    return 48
  }

  getDisplayHeight() {
    return 48
  }

  getBuildingSprite() {
    const sprite = new PIXI.Container()

    const baseSprite = new PIXI.Sprite(PIXI.utils.TextureCache[this.getBaseSpritePath()])
    baseSprite.anchor.x = 0.75
    baseSprite.anchor.y = 0.5
    baseSprite.width  = this.getDisplayWidth()
    baseSprite.height = this.getDisplayHeight()

    this.baseSprite = baseSprite

    sprite.addChild(baseSprite)

    return sprite
  }

  getTintableSprite() {
    return this.baseSprite
  }


  getType() {
    return Protocol.definition().BuildingType.Thruster
  }

  getConstantsTable() {
    return "Buildings.Thruster"
  }

}

module.exports = Thruster

},{"./../../../../common/constants.json":656,"./../../../../common/util/protocol":686,"./../particles/trail":509,"./base_building":211}],300:[function(require,module,exports){
const BaseBuilding = require("./base_building")
const Constants = require("./../../../../common/constants.json")
const Protocol = require("./../../../../common/util/protocol")
const BitmapText = require("../../util/bitmap_text")

class TimerBomb extends BaseBuilding {

  constructor(game, data, isEquipDisplay) {
    super(game, data, isEquipDisplay)
  }

  onContentChanged() {
    let remaining = 10 - parseInt(this.content)
    if (!this.timerText) {
      this.timerText = BitmapText.create({
        label: "Timer",
        text: remaining,
        spriteContainer: this.sprite
      })
      this.timerText.sprite.position.y = -24
    } else {
      this.timerText.sprite.text = remaining
    }
  }

  getType() {
    return Protocol.definition().BuildingType.TimerBomb
  }

  getSpritePath() {
    return "timer_bomb.png"
  }

  getConstantsTable() {
    return "Buildings.TimerBomb"
  }

  remove() {
    super.remove()

    if (this.timerText) {
      this.timerText.remove()
    }
    
  }

}

module.exports = TimerBomb

},{"../../util/bitmap_text":648,"./../../../../common/constants.json":656,"./../../../../common/util/protocol":686,"./base_building":211}],301:[function(require,module,exports){
const BaseBuilding = require("./../base_building")
const Constants = require("./../../../../../common/constants.json")

class BaseTower extends BaseBuilding {

  constructor(game, data, isEquipDisplay) {
    super(game, data, isEquipDisplay)

    this.rangeSprite = this.getRangeSprite()
    this.container.rangeContainerSprite.addChildAt(this.rangeSprite, 0)

    if (isEquipDisplay) {
      this.drawRange()
    } else {
      this.hideRange()
    }
  }

  onPostClick() {
    this.container.setAllRangeAlpha(0)
    this.drawRange()
  }

  static getGroup() {
    return "towers"
  }

  isTower() {
    return true
  }

  getEntityMenuStats() {
    let el = super.getEntityMenuStats()

    el += this.getDamageStat()
    el += this.getRangeStat()

    return el
  }

  getDamageStat() {
    let value = this.getDamage()
    let el = "<div class='entity_stats_entry damage_entry'>" +
                  "<div class='stats_type'>" + i18n.t('Damage') + ":</div>" +
                  "<div class='stats_value'>" + value  + "</div>" +
              "</div>"
    return el
  }

  getRangeStat() {
    let value = this.getRange()
    let el = "<div class='entity_stats_entry range_entry'>" +
                  "<div class='stats_type'>" + i18n.t('Range') + ":</div>" +
                  "<div class='stats_value'>" + value  + "</div>" +
              "</div>"
    return el
  }


  unselect() {
    super.unselect()
    this.hideRange()
  }

  remove() {
    super.remove()

    if (this.rangeSprite.parent) {
      this.rangeSprite.parent.removeChild(this.rangeSprite)
    }
  }

  hasRangeDisplay() {
    return true
  }

  static getRangeTexture() {
    if (!this.rangeTexture) {
      let graphics = new PIXI.Graphics()
      graphics.beginFill(0xc59bff)
      graphics.drawCircle(0, 0, this.prototype.getAttackRange())
      graphics.endFill()

      this.rangeTexture = game.app.renderer.generateTexture(graphics)
    }

    return this.rangeTexture
  }

  getRangeSprite() {
    let sprite = new PIXI.Sprite(this.constructor.getRangeTexture())
    sprite.name = "range"
    sprite.anchor.set(0.5)
    sprite.position.x = this.getRelativeX()
    sprite.position.y = this.getRelativeY()
    return sprite
  }

  getBuildingSprite() {
    if (this.isStaticTower()) {
      return super.getBuildingSprite()
    }

    const sprite = new PIXI.Container()

    const baseSprite = new PIXI.Sprite(PIXI.utils.TextureCache[this.getBaseSpritePath()])
    baseSprite.anchor.set(0.5)
    baseSprite.name = "BaseSprite"
    // baseSprite.position.y = this.getHeight() / 4

    const barrelSprite = new PIXI.Sprite(PIXI.utils.TextureCache[this.getBarrelSpritePath()])

    barrelSprite.anchor.set(0.5)
    barrelSprite.name = "BarrelSprite"

    this.baseSprite = baseSprite
    this.barrelSprite = barrelSprite

    sprite.addChild(baseSprite)
    sprite.addChild(barrelSprite)

    return sprite
  }

  isStaticTower() {
    return false
  }

  setAngle(angle) {
    if (this.isStaticTower()) return
      
    if (this.angle !== angle) {
      this.angle              = angle
      this.barrelSprite.rotation = this.getRadAngle()
    }
  }

  setBaseRotation(angle) {
    super.setBaseRotation(angle)

    if (!this.isStaticTower()) {
      this.baseSprite.rotation = angle * (Math.PI / 180)
    }
  }

  getBaseSpritePath() {
    throw new Error("must implement BaseTower#getBaseSpritePath")
  }

  getBarrelSpritePath() {
    throw new Error("must implement BaseTower#getBarrelSpritePath")
  }

  getSpritePath() {
    return this.getBarrelSpritePath()
  }

  getAttackRange() {
    if (this.sector && this.sector.entityCustomStats[this.id]) {
      return this.sector.entityCustomStats[this.id].range
    }

    if (this.sector && this.sector.buildingCustomStats[this.getType()]) {
      return this.sector.buildingCustomStats[this.getType()].range
    }

    return this.getStats(this.level).range
  }

  getRange() {
    return this.getAttackRange()
  }

  getDamage() {
    if (this.game.sector.entityCustomStats[this.id]) {
      return this.game.sector.entityCustomStats[this.id].damage
    }

    if (this.game.sector.buildingCustomStats[this.getType()]) {
      return this.game.sector.buildingCustomStats[this.getType()].damage
    }

    return this.getStats(this.level).damage
  }

  getUpgradeType() {
    return "units"
  }

  getCollisionGroup() {
    return "collisionGroup.Unit"
  }

  onGridPositionChanged() {
    super.onGridPositionChanged()
    
    this.rangeSprite.position.x = this.getRelativeX()
    this.rangeSprite.position.y = this.getRelativeY()
  }

  drawRange() {
    this.rangeSprite.alpha = 0.1
    this.rangeSprite.width  = this.getRange() * 2
    this.rangeSprite.height = this.getRange() * 2
  }

  hideRange() {
    this.rangeSprite.alpha = 0
  }
}

module.exports = BaseTower

},{"./../../../../../common/constants.json":656,"./../base_building":211}],302:[function(require,module,exports){
const BaseTower = require("./base_tower")
const Constants = require("./../../../../../common/constants.json")
const Protocol = require("./../../../../../common/util/protocol")

class BomberTurret extends BaseTower {

  getBuildingSprite() {
    let sprite = super.getBuildingSprite()

    this.barrelSprite.anchor.x = 0.5
    
    return sprite
  }

  openMenu() {
    this.game.storageMenu.open("Bomber Turret", this)
  }

  getBarrelWidth() {
    return 80
  }

  getBarrelHeight() {
    return 80
  }

  getBaseSpritePath() {
    return 'bomber_turret_by_px.png'
  }

  getBarrelSpritePath() {
    return 'bomber_turret_by_px.png'
  }

  getSpritePath() {
    return 'bomber_turret_by_px.png'
  }

  getConstantsTable() {
    return "Buildings.BomberTurret"
  }

  getType() {
    return Protocol.definition().BuildingType.BomberTurret
  }

}

module.exports = BomberTurret

},{"./../../../../../common/constants.json":656,"./../../../../../common/util/protocol":686,"./base_tower":301}],303:[function(require,module,exports){
const BaseTower = require("./base_tower")
const Constants = require("./../../../../../common/constants.json")
const Protocol = require("./../../../../../common/util/protocol")

class Cannon extends BaseTower {

  getBaseSpritePath() {
    return 'ground.png'
  }

  getBarrelSpritePath() {
    return 'cannon_barrel.png'
  }

  getBarrelWidth() {
    return 96
  }

  getBarrelHeight() {
    return 96
  }

  getConstantsTable() {
    return "Buildings.Cannon"
  }

  getType() {
    return Protocol.definition().BuildingType.Cannon
  }

}

module.exports = Cannon

},{"./../../../../../common/constants.json":656,"./../../../../../common/util/protocol":686,"./base_tower":301}],304:[function(require,module,exports){
const BaseTower = require("./base_tower")
const Constants = require("./../../../../../common/constants.json")
const Protocol = require("./../../../../../common/util/protocol")

class FlamethrowerTurret extends BaseTower {

  getSprite() {
    let sprite = super.getSprite()
    this.fillBarContainer.rotation = -Math.PI/2
    this.fillBarContainer.position.x = 0
    this.fillBarContainer.position.y = 32
    return sprite
  }

  getBaseSpritePath() {
    return 'flamethrower_turret_base.png'
  }

  getBarrelSpritePath() {
    return 'flamethrower_turret_gun.png'
  }

  getSpritePath() {
    return 'flamethrower_turret.png'
  }

  getConstantsTable() {
    return "Buildings.FlamethrowerTurret"
  }

  getType() {
    return Protocol.definition().BuildingType.FlamethrowerTurret
  }

}

module.exports = FlamethrowerTurret

},{"./../../../../../common/constants.json":656,"./../../../../../common/util/protocol":686,"./base_tower":301}],305:[function(require,module,exports){
const BaseTower = require("./base_tower")
const Constants = require("./../../../../../common/constants.json")
const Protocol = require("./../../../../../common/util/protocol")

class IonCannon extends BaseTower {
  constructor(game, data, isEquipDisplay) {
    super(game, data, isEquipDisplay)
  }

  getBarrelSpritePath() {
    return 'ion_cannon.png'
  }

  getBaseSpritePath() {
    return ''
  }

  getConstantsTable() {
    return "Buildings.IonCannon"
  }

  getType() {
    return Protocol.definition().BuildingType.IonCannon
  }

}

module.exports = IonCannon

},{"./../../../../../common/constants.json":656,"./../../../../../common/util/protocol":686,"./base_tower":301}],306:[function(require,module,exports){
const BaseTower = require("./base_tower")
const Constants = require("./../../../../../common/constants.json")
const Protocol = require("./../../../../../common/util/protocol")

class Miner extends BaseTower {

}

module.exports = Miner
},{"./../../../../../common/constants.json":656,"./../../../../../common/util/protocol":686,"./base_tower":301}],307:[function(require,module,exports){
const Miner = require("./miner")
const Constants = require("./../../../../../common/constants.json")
const Protocol = require("./../../../../../common/util/protocol")

class MineralMiner extends Miner {
  getBarrelSpritePath() {
    return 'ore_miner.png'
  }

  getBaseSpritePath() {
    return 'ground.png'
  }

  getConstantsTable() {
    return "Buildings.MineralMiner"
  }

  getType() {
    return Protocol.definition().BuildingType.MineralMiner
  }

}

module.exports = MineralMiner

},{"./../../../../../common/constants.json":656,"./../../../../../common/util/protocol":686,"./miner":306}],308:[function(require,module,exports){
const BaseTower = require("./base_tower")
const Constants = require("./../../../../../common/constants.json")
const Protocol = require("./../../../../../common/util/protocol")

class MiniTurret extends BaseTower {

  openMenu() {
    this.game.storageMenu.open("Mini Turret", this)
  }

  getBaseSpritePath() {
    return 'sentry_turret_base.png'
  }

  getBarrelSpritePath() {
    return 'sentry_turret_gun.png'
  }

  getSpritePath() {
    return 'sentry_turret.png'
  }

  getConstantsTable() {
    return "Buildings.MiniTurret"
  }

  getType() {
    return Protocol.definition().BuildingType.MiniTurret
  }

}

module.exports = MiniTurret

},{"./../../../../../common/constants.json":656,"./../../../../../common/util/protocol":686,"./base_tower":301}],309:[function(require,module,exports){
const BaseTower = require("./base_tower")
const Constants = require("./../../../../../common/constants.json")
const Protocol = require("./../../../../../common/util/protocol")

class MissileTurret extends BaseTower {

  getBuildingSprite() {
    let sprite = super.getBuildingSprite()

    this.barrelSprite.anchor.x = 0.75
    
    return sprite
  }

  openMenu() {
    this.game.storageMenu.open("Missile Turret", this)
  }

  getBarrelWidth() {
    return 80
  }

  getBarrelHeight() {
    return 80
  }

  getBaseSpritePath() {
    return 'missile_turret_base.png'
  }

  getBarrelSpritePath() {
    return 'missile_turret_gun.png'
  }

  getSpritePath() {
    return 'missile_turret.png'
  }

  getConstantsTable() {
    return "Buildings.MissileTurret"
  }

  getType() {
    return Protocol.definition().BuildingType.MissileTurret
  }

}

module.exports = MissileTurret

},{"./../../../../../common/constants.json":656,"./../../../../../common/util/protocol":686,"./base_tower":301}],310:[function(require,module,exports){
const BaseTower = require("./base_tower")
const Constants = require("./../../../../../common/constants.json")
const Protocol = require("./../../../../../common/util/protocol")

class TeslaCoil extends BaseTower {

  onBuildingConstructed() {
    super.onBuildingConstructed()

    this.tween = this.getRotatingTween()
  }

  onPowerChanged() {
    super.onPowerChanged()

    if (this.isPowered) {
      if (!this.tween) {
        this.tween = this.getRotatingTween()
      }
      this.tween.start()
    } else {
      if (this.tween) {
        this.tween.stop()
        this.tween = null
      }
    }
  }

  getRotatingTween() {
    let rotation = { rotation: 0 }

    const fadeOutTween = new TWEEN.Tween(rotation)
        .to({ rotation: 360 * PIXI.DEG_TO_RAD }, 3000)
        .onUpdate(() => {
          this.barrelSprite.rotation = rotation.rotation
        })
        .repeat(Infinity)

    return fadeOutTween
  }

  cleanupTween() {
    if (this.tween) {
      this.tween.stop()
      this.tween = null
    }
  }

  remove() {
    super.remove()

    this.cleanupTween()
  }

  getBaseSpritePath() {
    return 'tesla_coil_base.png'
  }

  getBarrelSpritePath() {
    return 'tesla_coil_ring.png'
  }

  getSpritePath() {
    return 'tesla_coil.png'
  }

  getConstantsTable() {
    return "Buildings.TeslaCoil"
  }

  getType() {
    return Protocol.definition().BuildingType.TeslaCoil
  }

}

module.exports = TeslaCoil

},{"./../../../../../common/constants.json":656,"./../../../../../common/util/protocol":686,"./base_tower":301}],311:[function(require,module,exports){
const BaseTower = require("./base_tower")
const Constants = require("./../../../../../common/constants.json")
const Protocol = require("./../../../../../common/util/protocol")

class Turret extends BaseTower {

  getBaseSpritePath() {
    return 'ground.png'
  }

  getBarrelSpritePath() {
    return 'turret_barrel.png'
  }

  getBarrelWidth() {
    return 80
  }

  getBarrelHeight() {
    return 80
  }

  getConstantsTable() {
    return "Buildings.Turret"
  }

  getType() {
    return Protocol.definition().BuildingType.Turret
  }

}

module.exports = Turret

},{"./../../../../../common/constants.json":656,"./../../../../../common/util/protocol":686,"./base_tower":301}],312:[function(require,module,exports){
const BaseTower = require("./base_tower")
const Constants = require("./../../../../../common/constants.json")
const Protocol = require("./../../../../../common/util/protocol")

class VoidRay extends BaseTower {

  getBaseSpritePath() {
    return 'ground.png'
  }

  getBarrelSpritePath() {
    return 'void_ray_barrel_2.png'
  }

  getConstantsTable() {
    return "Buildings.VoidRay"
  }

  getType() {
    return Protocol.definition().BuildingType.VoidRay
  }

}

module.exports = VoidRay

},{"./../../../../../common/constants.json":656,"./../../../../../common/util/protocol":686,"./base_tower":301}],313:[function(require,module,exports){
const BaseBuilding = require("./base_building")
const Constants = require("./../../../../common/constants.json")
const Protocol = require("./../../../../common/util/protocol")
const Table = require("./table")

class TradingTable extends Table {

  getType() {
    return Protocol.definition().BuildingType.TradingTable
  }

  getSpritePath() {
    return "trading_table.png"
  }

  getConstantsTable() {
    return "Buildings.TradingTable"
  }

}

module.exports = TradingTable

},{"./../../../../common/constants.json":656,"./../../../../common/util/protocol":686,"./base_building":211,"./table":296}],314:[function(require,module,exports){
const BaseBuilding = require("./base_building")
const Constants = require("./../../../../common/constants.json")
const Protocol = require("./../../../../common/util/protocol")

class Tree extends BaseBuilding {

  constructor(game, data, isEquipDisplay) {
    super(game, data, isEquipDisplay)
  }

  getType() {
    return Protocol.definition().BuildingType.Tree
  }

  getSpritePath() {
    return "tree.png"
  }

  getConstantsTable() {
    return "Buildings.Tree"
  }

}

module.exports = Tree

},{"./../../../../common/constants.json":656,"./../../../../common/util/protocol":686,"./base_building":211}],315:[function(require,module,exports){
const BaseBuilding = require("./base_building")
const Protocol = require("./../../../../common/util/protocol")

class UnbreakableWall extends BaseBuilding {

  getType() {
    return Protocol.definition().BuildingType.UnbreakableWall
  }

  getConstantsTable() {
    return "Buildings.UnbreakableWall"
  }

  getSpritePath() {
    return 'unbreakable_wall.png'
  }
}

module.exports = UnbreakableWall

},{"./../../../../common/util/protocol":686,"./base_building":211}],316:[function(require,module,exports){
const Constants = require("./../../../../common/constants.json")
const Protocol = require("./../../../../common/util/protocol")
const BaseBuilding = require("./base_building")

class UndergroundVent extends BaseBuilding {

  getSpritePath() {
    return "underground_vent.png"
  }

  getType() {
    return Protocol.definition().BuildingType.UndergroundVent
  }

  getConstantsTable() {
    return "Buildings.UndergroundVent"
  }

}

module.exports = UndergroundVent

},{"./../../../../common/constants.json":656,"./../../../../common/util/protocol":686,"./base_building":211}],317:[function(require,module,exports){
const BaseBuilding = require("./../base_building")

class BaseUnit extends BaseBuilding {
  static isPositionValid(container, x, y, w, h, angle, player) {
    return container.platformMap.isFullyOccupied(x, y, w, h) &&
           this.isWithinInteractDistance(x, y, player) &&
           !this.isOnHangar(container, x, y, w, h) &&
           !container.armorMap.isOccupied(x, y, w, h) &&
           !container.structureMap.isOccupied(x, y, w, h) &&
           !container.unitMap.isOccupied(x, y, w, h)
  }

  constructor(game, data, isEquipDisplay) {
    super(game, data, isEquipDisplay)
  }

  onBuildingConstructed() {
    if (!this.isLaunched) {
      this.container.units[this.id] = this
      this.container.unitMap.register(this.getRelativeBox(), this)
    }
  }

  getGroup() {
    return "units"
  }


  unregister() {
    if (!this.isLaunched) {
      this.getContainer().unregisterEntity("units", this)
      this.container.unitMap.unregister(this.getRelativeBox())
    }
  }

  onLaunchedChanged() {
    if (this.isLaunched) {
      this.sprite.alpha = 0
    } else {
      this.sprite.alpha = 1
      this.setAngle(this.origAngle)
    }
  }

  getX() {
    return this.isLaunched ? this.sprite.x : super.getX()
  }

  getY() {
    return this.isLaunched ? this.sprite.y : super.getY()
  }
}

module.exports = BaseUnit

},{"./../base_building":211}],318:[function(require,module,exports){
const BaseUnit = require("./base_unit")
const Constants = require("./../../../../../common/constants.json")
const Protocol = require("./../../../../../common/util/protocol")

class Fighter extends BaseUnit {
  getSpritePath() {
    return 'mini_fighter.png'
  }

  getConstantsTable() {
    return "Buildings.Fighter"
  }

  getType() {
    return Protocol.definition().BuildingType.Fighter
  }
}

module.exports = Fighter

},{"./../../../../../common/constants.json":656,"./../../../../../common/util/protocol":686,"./base_unit":317}],319:[function(require,module,exports){
const BaseBuilding = require("./base_building")
const Constants = require("./../../../../common/constants.json")
const Protocol = require("./../../../../common/util/protocol")

class VendingMachine extends BaseBuilding {

  constructor(game, data, isEquipDisplay) {
    super(game, data, isEquipDisplay)
  }

  getEntityMenuStats() {
    let el = super.getEntityMenuStats()

    el += this.getTotalGoldStat()

    return el
  }

  getTotalGoldStat() {
    let totalGold = this.content ? this.content : 0
    let el = "<div class='entity_stats_entry vending_machine_total_gold_entry'>" +
                  "<div class='stats_type'>" + i18n.t('Total Gold') + ":</div>" +
                  "<div class='stats_value'>" + totalGold  + "</div>" +
              "</div>"
    return el
  }

  getActions() {
    const withdraw = "<div class='vending_widthdraw_btn ui_btn' data-action='vending_withdraw'>" + i18n.t("Withdraw") + "</div>"

    let actions = ""

    let team = this.game.player.getTeam()
    if (this.game.isLeaderAndOwner(this, team, this.game.player)) {
      actions += withdraw
    }

    return actions
  }

  onContentChanged() {
    if (this.game.vendingMachineMenu.entity === this) {
      this.game.vendingMachineMenu.updateStorageGoldAmount()
    }

    if (this.game.entityMenu.isOpen(this)) {
      this.game.entityMenu.update(this)
    }
  }


}

module.exports = VendingMachine

},{"./../../../../common/constants.json":656,"./../../../../common/util/protocol":686,"./base_building":211}],320:[function(require,module,exports){
const BaseBuilding = require("./base_building")
const Constants = require("./../../../../common/constants.json")
const Protocol = require("./../../../../common/util/protocol")

class Ventilator extends BaseBuilding {

  constructor(game, data, isEquipDisplay) {
    super(game, data, isEquipDisplay)
  }

  static isPositionValid(container, x, y, w, h, angle, player) {
    let relativeBox = this.getBox(x, y, w, h)
    let armorHits = container.armorMap.hitTestTile(relativeBox)
    const isEnemyArmor = armorHits.find((hit) => { return hit.entity && !hit.entity.isOwnedBy(player) })
    if (isEnemyArmor) return false

    return  this.isOnValidPlatform(container, x, y, w, h, angle, player) &&
            this.isWithinInteractDistance(x, y, player) &&
                         !this.isOnHangar(container, x, y, w, h) &&
                         !container.unitMap.isOccupied(x, y, w, h) &&
                         !container.structureMap.isOccupied(x, y, w, h)
  }

  getType() {
    return Protocol.definition().BuildingType.Ventilator
  }

  getSpritePath() {
    return "ventilator.png"
  }

  getConstantsTable() {
    return "Buildings.Ventilator"
  }

}

module.exports = Ventilator

},{"./../../../../common/constants.json":656,"./../../../../common/util/protocol":686,"./base_building":211}],321:[function(require,module,exports){
const BaseBuilding = require("./base_building")
const Constants = require("./../../../../common/constants.json")
const Protocol = require("./../../../../common/util/protocol")
const BaseWall = require("./base_wall")

class Wall extends BaseWall {

  getType() {
    return Protocol.definition().BuildingType.Wall
  }

  getConstantsTable() {
    return "Walls.Wall"
  }

  getWallColor() {
    return 0x2a2a2a  
  }

}

module.exports = Wall

},{"./../../../../common/constants.json":656,"./../../../../common/util/protocol":686,"./base_building":211,"./base_wall":214}],322:[function(require,module,exports){
const Lamp = require("./lamp")
const Constants = require("./../../../../common/constants.json")
const Protocol = require("./../../../../common/util/protocol")

class WallLamp extends Lamp {

  createSprite() {
    return new PIXI.Sprite(PIXI.utils.TextureCache["wall_lamp_sprite.png"])
  }

  getType() {
    return Protocol.definition().BuildingType.WallLamp
  }

  getSpritePath() {
    return "wall_lamp.png"
  }

  getConstantsTable() {
    return "Buildings.WallLamp"
  }

}

module.exports = WallLamp

},{"./../../../../common/constants.json":656,"./../../../../common/util/protocol":686,"./lamp":252}],323:[function(require,module,exports){
const BaseBuilding = require("./base_building")
const Constants = require("./../../../../common/constants.json")
const Protocol = require("./../../../../common/util/protocol")
const WaterPumpCommon = require("./../../../../common/entities/water_pump_common")
const LiquidPipe = require("./liquid_pipe")

class WaterPump extends BaseBuilding {

  static isOnValidPlatform(container, x, y, w, h, angle, player) {
    if (this.isPlacingOnSomeoneElsePlatform(container, x, y, w, h, angle, player)) return false

    let square = WaterPumpCommon.getSquare(x, y, angle)

    return container.platformMap.isFullyOccupied(square.x, square.y, square.w, square.h) ||
          (container.groundMap.isFullyOccupied(square.x, square.y, square.w, square.h) && !container.map.isOccupied(square.x, square.y, square.w, square.h))
  }


  static isPositionValid(container, x, y, w, h, angle, player) {
    let isBuildingValid = super.isPositionValid(container, x, y, w, h, angle, player)
    let extractor = WaterPumpCommon.getExtractor(x, y, angle)

    let hasLiquid = container.undergroundMap.isFullyOccupied(extractor.x, extractor.y, extractor.w, extractor.h)

    return isBuildingValid && hasLiquid
  }

  getRotatingTween() {
    let position = { position: 0 }

    return new TWEEN.Tween(position)
        .to({ position: 22 }, 200)
        .onUpdate(() => {
          this.rotatorSprites.forEach((rotatorSprite) => {
            rotatorSprite.position.x = position.position
          })
        })
        .repeat(Infinity)
  }

  cleanupTween() {
    if (this.tween) {
      this.tween.stop()
      this.tween = null
    }
  }

  remove() {
    super.remove()

    this.cleanupTween()
  }

  getSpritePath() {
    return 'water_pump.png'
  }

  getType() {
    return Protocol.definition().BuildingType.WaterPump
  }

  getConstantsTable() {
    return "Buildings.WaterPump"
  }

  getBaseSpritePath() {
    return this.getSpritePath()
  }

  getRotatorSpritePath() {
    return ''
  }

  getDisplayHeight() {
    return 92
  }

  getDisplayWidth() {
    return 57
  }

  getBuildingSprite() {
    this.rotatorSprites = this.rotatorSprites || []

    const sprite = new PIXI.Container()

    const baseSprite = new PIXI.Sprite(PIXI.utils.TextureCache[this.getBaseSpritePath()])
    baseSprite.anchor.set(0.5)
    baseSprite.width = this.getDisplayWidth()
    baseSprite.height = this.getDisplayHeight()
    this.baseSprite = baseSprite
    this.baseSprite.name = "BaseSprite"

    let rotator = new PIXI.Sprite(PIXI.utils.TextureCache[this.getRotatorSpritePath()])

    rotator.anchor.set(0.5)
    rotator.position.y = 68

    this.rotatorSprites.push(rotator)

    rotator = new PIXI.Sprite(PIXI.utils.TextureCache[this.getRotatorSpritePath()])

    rotator.anchor.set(0.5)
    rotator.position.y = -68

    this.rotatorSprites.push(rotator)

    sprite.addChild(baseSprite)

    this.rotatorSprites.forEach((rotatorSprite) => {
      sprite.addChild(rotatorSprite)
    })

    return sprite
  }

}

module.exports = WaterPump

},{"./../../../../common/constants.json":656,"./../../../../common/entities/water_pump_common":663,"./../../../../common/util/protocol":686,"./base_building":211,"./liquid_pipe":254}],324:[function(require,module,exports){
const BaseFloor = require("./platforms/base_floor")
const Constants = require("./../../../../common/constants.json")
const Protocol = require("./../../../../common/util/protocol")

class WebTrap extends BaseFloor {

  constructor(game, data, isEquipDisplay) {
    super(game, data, isEquipDisplay)
  }

  getType() {
    return Protocol.definition().BuildingType.WebTrap
  }

  getBaseSpritePath() {
    return "web_trap.png"
  }

  getSpritePath() {
    return "web_trap.png"
  }

  getConstantsTable() {
    return "Buildings.WebTrap"
  }

}

module.exports = WebTrap

},{"./../../../../common/constants.json":656,"./../../../../common/util/protocol":686,"./platforms/base_floor":262}],325:[function(require,module,exports){
const BaseBuilding = require("./base_building")
const Constants = require("./../../../../common/constants.json")
const Protocol = require("./../../../../common/util/protocol")
const Conduit = require("./conduit")

class Wire extends Conduit {

  static getTextures() {
    if (!this.textures) {
      this.textures = {
        line_zero: PIXI.utils.TextureCache["wire_0.png"],
        line_one: PIXI.utils.TextureCache["wire_1.png"],
        line_two: PIXI.utils.TextureCache["wire_2.png"],
        line_two_straight: PIXI.utils.TextureCache["wire_2_straight.png"],
        line_three: PIXI.utils.TextureCache["wire_3.png"],
        line_four: PIXI.utils.TextureCache["wire_4.png"]
      }
    }

    return this.textures
  }

  hasConduitInDirection(directionHits) {
    return directionHits.every((hit) => {
      return hit.entity && hit.entity.hasPowerRole()
    })
  }

  getType() {
    return Protocol.definition().BuildingType.Wire
  }

  getSpritePath() {
    return "wire_0.png"
  }

  getConstantsTable() {
    return "Buildings.Wire"
  }

}

module.exports = Wire

},{"./../../../../common/constants.json":656,"./../../../../common/util/protocol":686,"./base_building":211,"./conduit":226}],326:[function(require,module,exports){
const BaseBuilding = require("./base_building")
const Constants = require("./../../../../common/constants.json")
const Protocol = require("./../../../../common/util/protocol")

class WoodChair extends BaseBuilding {

  constructor(game, data, isEquipDisplay) {
    super(game, data, isEquipDisplay)
  }

  getType() {
    return Protocol.definition().BuildingType.WoodChair
  }

  getSpritePath() {
    return "wood_chair.png"
  }

  getConstantsTable() {
    return "Buildings.WoodChair"
  }

}

module.exports = WoodChair

},{"./../../../../common/constants.json":656,"./../../../../common/util/protocol":686,"./base_building":211}],327:[function(require,module,exports){
const BaseBuilding = require("./base_building")
const Constants = require("./../../../../common/constants.json")
const Protocol = require("./../../../../common/util/protocol")

class WoodTable extends BaseBuilding {

  constructor(game, data, isEquipDisplay) {
    super(game, data, isEquipDisplay)
  }

  getType() {
    return Protocol.definition().BuildingType.WoodTable
  }

  getSpritePath() {
    return "wood_table.png"
  }

  getConstantsTable() {
    return "Buildings.WoodTable"
  }

}

module.exports = WoodTable

},{"./../../../../common/constants.json":656,"./../../../../common/util/protocol":686,"./base_building":211}],328:[function(require,module,exports){
const BaseEntity = require("./base_entity")
const Constants = require("./../../../common/constants.json")

class Button {
  constructor(game, data) {
    this.id = data.id
    this.game = game
    this.sector = game.sector

    this.onButtonCreated()
  }

  onButtonCreated() {
    this.sector.addButton(this)
  }

  remove() {
    this.sector.removeButton(this)
  }

  syncWithServer(data) {
    this.name = data.name
    this.label = data.label
    this.description = data.description
    this.attachments = data.attachments
  }

  isAttachedTo(klassName) {
    return this.attachments[klassName]
  }

  buildHTML(entity) {
    let label = this.label || this.name

    return "<div class='ui_btn' data-name='" + this.name + "' data-description='" + this.description + "'>" + 
             label + 
             "<div class='button_tooltip'></div>" +
           "</div>"
  }

}

module.exports = Button
},{"./../../../common/constants.json":656,"./base_entity":206}],329:[function(require,module,exports){
class Camera {
  constructor() {
    this.position = {
      x: 0,
      y: 0
    }
  }

  getX() {
    return this.position.x
  }

  getY() {
    return this.position.y
  }
  
}

module.exports = Camera
},{}],330:[function(require,module,exports){
const ClientHelper = require("./../util/client_helper")

class ChatBubble {
  constructor(options = {}) {
    this.entity = options.entity

    let text = options.text
    let spriteContainer = options.entity.sprite
    let sector = options.entity.sector

    let container = new PIXI.Container()
    container.name = "SpeechBubble"

    let sprite = new PIXI.Text(text, {fontFamily: "Arial", fontSize: 18, align: "left", fill : 0xcccccc, wordWrapWidth: 250, wordWrap: true })
    sprite.name = "text"

    this.textSprite = sprite

    let backgroundPadding = 10
    const graphics = new PIXI.Graphics()
    graphics.name = "SpeechBackground"
    graphics.beginFill(0x000000)
    // graphics.lineStyle(2, 0x000000, 1)
    graphics.drawRoundedRect(-backgroundPadding, -backgroundPadding/2, sprite.width + backgroundPadding * 2, sprite.height + backgroundPadding, 5)
    graphics.endFill()
    graphics.alpha = 0.8

    container.addChild(graphics)
    container.addChild(sprite)

    let margin = 20
    let x = -sprite.width/2
    let y = -sprite.height/2 - margin - (player.getHeight())

    container.position.x = x
    container.position.y = y

    this.chatBubbleContainer = container

    if (options.isAbsolutePosition) {
      container.position.x += spriteContainer.position.x
      container.position.y += spriteContainer.position.y
      
      sector.effectsContainer.addChild(container)
    } else {
      spriteContainer.addChild(container)
    }
  } 

  remove() {
    this.isRemoved = true
    this.entity.chatBubble = null
    clearTimeout(this.removeChatBubbleTimeout)
    this.textSprite.destroy() 
    ClientHelper.removeSelfAndChildrens(this.chatBubbleContainer)
  }

  delayedRemove(timeout) {
    clearTimeout(this.removeChatBubbleTimeout)

    this.removeChatBubbleTimeout = setTimeout(() => {
      this.remove()
      this.removeChatBubbleTimeout = null
    }, timeout)
  }

}

module.exports = ChatBubble



},{"./../util/client_helper":649}],331:[function(require,module,exports){
const Constants = require("./../../../common/constants.json")
const SocketUtil = require("./../util/socket_util")

/*
  cache chunk to rendertexture
  1. init cachedChunks - sprites (not visible at first)
  2. when caching, call renderTexture.
*/

class Chunk {
  constructor(sector, row, col) {
    this.sector = sector

    this.id = this.constructor.getKey(row, col)
    this.row = row
    this.col = col

    this.tileStartRow = row * Constants.chunkRowCount
    this.tileStartCol = col * Constants.chunkRowCount

    this.spriteLayers = {}
    this.bitmapCacheTimeouts = {}
    this.chunkRegions = {}
    this.cachedChunks = {}

    this.terrains = {}
    this.buildings = {}
    this.corpses = {}
    this.rooms = {}
    this.mobs = {}
    this.pickups = {}
    this.players = {}
    this.projectiles = {}
    this.transports = {}
    this.layersToCache = {}

    this.initContainers()
  }

  removeStale(data) {
    let groupsToSkip = []
    if (this.sector.isFovMode()) {
      groupsToSkip = ["players", "corpses"]
    }

    let currentCollectionMap = this.getCollectionMapFromData(data)
    for (let group in currentCollectionMap) {
      let collection = currentCollectionMap[group]
      for (let existingEntityId in this[group]) {
        let existingEntity = this[group][existingEntityId]
        let isNoLongerInChunk = !collection[existingEntityId]
        let shouldSkipGroup = groupsToSkip.indexOf(group) !== -1
        if (isNoLongerInChunk && !shouldSkipGroup) {
          this.unregister(group, existingEntity)
          existingEntity.remove()
        }
      }
    }

  }

  cacheSpriteLayer(spriteLayer, group) {
    spriteLayer.cacheAsBitmap = true
  }

// cacheSpriteLayer(spriteLayer, group) {
//     var m = new PIXI.Matrix()
// 
//     if (!spriteLayer.visible) {
//       spriteLayer.visible = true
//     }
// 
//     spriteLayer.transform.localTransform.copy(m)
//     m.invert()
// 
//     // getLocalBounds is mutable function. its somehow 
//     // needed for renderer.render to work properly below
//      let bounds = spriteLayer.getLocalBounds()
// 
//     // let xDelta = bounds.x % 512
//     // let yDelta = bounds.y % 512
// 
//     m.tx -= (this.col * 512) //(bounds.x - xDelta)
//     m.ty -= (this.row * 512) //(bounds.y - yDelta)
// 
//     let texture = PIXI.RenderTexture.create(16 * Constants.tileSize, 16 * Constants.tileSize)
//     this.sector.game.app.renderer.render(spriteLayer, texture, true, m, true)
//     spriteLayer.visible = false
//     spriteLayer.isCustomCached = true
// 
//     let cachedSprite = this.cachedChunks[group]
//     cachedSprite.texture = texture
//     cachedSprite.visible = true
//   }

  purgeSpriteLayerCache(spriteLayer, group) {
    if (spriteLayer.cacheAsBitmap) {
      spriteLayer.cacheAsBitmap = false
    }
//     this.cachedChunks[group].texture.destroy()
//     this.cachedChunks[group].visible = false
// 
//     this.spriteLayers[group].visible = true
//     this.spriteLayers[group].isCustomCached = false
  }

  cleanup() {
    this.cleanupBitmapCaches()  
  }

  cleanupBitmapCaches() {
    for (let name in this.spriteLayers) {
      let spriteLayer = this.spriteLayers[name]
      // if (spriteLayer.isCustomCached) {
        this.purgeSpriteLayerCache(spriteLayer, name)
      // }
    }
  }

  getCollectionMapFromData(data) {
    let terrainsJson = data.terrains.reduce((result, entityData) => { 
      let id = this.sector.getTerrainId(entityData)
      result[id] = true 
      return result
    }, {})

    let buildingsJson = data.buildings.reduce((result, entityData) => { 
      result[entityData.id] = true 
      return result
    }, {})

    let corpsesJson = data.corpses.reduce((result, entityData) => { 
      result[entityData.id] = true 
      return result
    }, {})

    let roomsJson = data.rooms.reduce((result, entityData) => { 
      result[entityData.id] = true 
      return result
    }, {})

    let mobsJson = data.mobs.reduce((result, entityData) => { 
      result[entityData.id] = true 
      return result
    }, {})

    let pickupsJson = data.pickups.reduce((result, entityData) => { 
      result[entityData.id] = true 
      return result
    }, {})

    let playersJson = data.players.reduce((result, entityData) => { 
      result[entityData.id] = true 
      return result
    }, {})

    let projectilesJson = data.projectiles.reduce((result, entityData) => { 
      result[entityData.id] = true 
      return result
    }, {})

    let transportsJson = data.transports.reduce((result, entityData) => { 
      result[entityData.id] = true 
      return result
    }, {})

    return {
      terrains: terrainsJson,
      buildings: buildingsJson,
      corpses: corpsesJson,
      rooms: roomsJson,
      mobs: mobsJson,
      pickups: pickupsJson,
      players: playersJson,
      projectiles: projectilesJson,
      transports: transportsJson
    }
  }

  register(group, entity) {
    this[group][entity.id] = entity 
    entity.chunks[this.id] = this
  }

  unregister(group, entity) {
    delete this[group][entity.id] 
    delete entity.chunks[this.id] 
  }

  getTopleftX() {
    return this.tileStartCol * Constants.tileSize
  }

  getTopleftY() {
    return this.tileStartRow * Constants.tileSize
  }

  hasChunkRegions() {
    return Object.keys(this.chunkRegions).length > 0
  }

  registerChunkRegion(chunkRegion) {
    this.chunkRegions[chunkRegion.getId()] = chunkRegion
  }

  unregisterChunkRegion(chunkRegion) {
    delete this.chunkRegions[chunkRegion.getId()] 
  }

  static getKey(row, col) {
    return [row, col].join("-")
  }

  getRandomRow() {
    return this.tileStartRow + Math.floor(Math.random() * Constants.chunkRowCount)
  }

  getRandomCol() {
    return this.tileStartCol + Math.floor(Math.random() * Constants.chunkColCount)
  }

  getSelectionLineStyle() {
    return {
      lineWidth: 4,
      color: 0x66ff66,
      alpha: 0.7
    }
  }

  getBorderSprite() {
    let sprite = new PIXI.Graphics()
    sprite.tint = 0x66ff66
    sprite.name = "ChunkBorder"

    const lineStyle = this.getSelectionLineStyle()

    sprite.lineStyle(lineStyle.lineWidth, lineStyle.color)
    sprite.drawRect(0, 0, Constants.chunkRowCount * Constants.tileSize, Constants.chunkRowCount * Constants.tileSize)
    sprite.endFill()

    return sprite
  }

  initSprite() {
    // this.debugSprite = new PIXI.Container()
    // this.debugSprite.name = "ChunkDebugContainer"

    // // this.debugSpriteBackground = this.getBorderSprite()

    // const style  = { fontFamily : 'PixelForce', fontSize: 36, fill : 0xffffff, align : 'center', strokeThickness: 4, miterLimit: 3 }
    // const textSprite = new PIXI.Text(this.id, style)
    // textSprite.position.set(Constants.chunkRowCount * Constants.tileSize / 2)
    // textSprite.anchor.set(0.5)

    // // this.debugSprite.addChild(this.debugSpriteBackground)
    // this.debugSprite.addChild(textSprite)

    // this.tileStartRow = this.row * Constants.chunkRowCount
    // this.tileStartCol = this.col * Constants.chunkRowCount
    // let x = this.tileStartCol * Constants.tileSize
    // let y = this.tileStartRow * Constants.tileSize

    // this.debugSprite.position.set(x, y)
    // this.sector.chunkDebugSprite.addChild(this.debugSprite)
  }

  showDebug() {
    // this.initSprite()
  }

  hideDebug() {
    // this.debugSprite.parent.removeChild(this.debugSprite)
  }

  getChunkRegion(row, col) {
    for (let chunkRegionId in this.chunkRegions) {
      let chunkRegion = this.chunkRegions[chunkRegionId]  
      let isActiveChunkRegion = chunkRegion.hasTile(row, col)
      if (isActiveChunkRegion) return chunkRegion
    }

    return null
  }

  showChunkRegions() {
    for (let chunkRegionId in this.chunkRegions) {
      let chunkRegion = this.chunkRegions[chunkRegionId]  
      chunkRegion.show()
    }
  }

  hideChunkRegions() {
    for (let chunkRegionId in this.chunkRegions) {
      let chunkRegion = this.chunkRegions[chunkRegionId]  
      chunkRegion.hide()
    }
  }

  getId() {
    return this.id
  }

  getSpriteLayer(group) {
    return this.spriteLayers[group]
  }

  updateSprite(entity) {
    let group = entity.getSpriteLayerGroup()
    let spriteLayer = this.getSpriteLayer(group)

    this.purgeSpriteLayerCache(spriteLayer, group) // whenever sprite has changed, removed the cached bitmap as its dirty

    this.layersToCache[group] = { lastUpdate: Date.now(), spriteLayer: spriteLayer }
    this.sector.addChunksToCache(this)
  }

  cacheLayers() {
    let readyToCacheThreshold = 1000 // 1 sec
    let timeNow = Date.now()
    for (let group in this.layersToCache) {
      let data = this.layersToCache[group]
      if (timeNow - data.lastUpdate >= readyToCacheThreshold) {
        this.cacheSpriteLayer(data.spriteLayer, group)
        delete this.layersToCache[group]
      }
    }
  }

  hasLayersToCache() {
    return Object.keys(this.layersToCache).length > 0
  }

  initContainers() {
    let collections = [
      this.sector.terrainGroups,
      this.sector.buildingGroups, 
      this.sector.structureGroups, 
      this.sector.wallGroups,   
      this.sector.ceilingGroups 
    ]

    collections.forEach((collection) => {
      collection.forEach((group) => {
        this.createChunkContainer(group)
        // this.createCachedChunk(group)
      })
    })
  }

  hide() {
    for (let group in this.spriteLayers) {
      let spriteLayer = this.spriteLayers[group]
      if (spriteLayer.isCustomCached) {
        this.cachedChunks[group].visible = false
      } else {
        spriteLayer.visible = false
      }
    }
  }

  show() {
    for (let group in this.spriteLayers) {
      let spriteLayer = this.spriteLayers[group]
      if (spriteLayer.isCustomCached) {
        this.cachedChunks[group].visible = true
      } else {
        spriteLayer.visible = true
      }
    }
  }

  createChunkContainer(group) {
    let container 

    let shouldUseParticleContainer = group === "platforms" //this.sector.terrainGroups.indexOf(group) !== -1
    if (false) {
      container = new PIXI.ParticleContainer() 
    } else {
      container = new PIXI.Container()
    }
    container.name = ["chunk", this.id, group].join("_")
    container.visible = false // not visible by default

    this.spriteLayers[group] = container 

    this.sector.spriteLayers[group].addChild(container)
  }

  createCachedChunk(group) {
    let sprite = new PIXI.Sprite()
    this.cachedChunks[group] = sprite
    this.cachedChunks[group].name = "CachedChunk-" + [this.row, this.col].join("-")
    this.cachedChunks[group].width  = 16 * Constants.tileSize
    this.cachedChunks[group].height = 16 * Constants.tileSize
    this.cachedChunks[group].visible = false
    // need to be positioned properly as well, as texture created is in relative local coord

    this.cachedChunks[group].position.x = this.col * Constants.tileSize * 16
    this.cachedChunks[group].position.y = this.row * Constants.tileSize * 16

    this.sector.spriteLayers[group].addChild(sprite)
  }
}

module.exports = Chunk
},{"./../../../common/constants.json":656,"./../util/socket_util":654}],332:[function(require,module,exports){
const Constants = require("./../../../common/constants.json")
const BitmapText = require("../util/bitmap_text")

class ChunkRegion {
  constructor(data, sector) {
    this.id = data.id

    this.data = data
    this.sector = sector
    this.tiles = {}
    this.gates = {}

    this.defaultAlpha = 0.3

    this.initSprite()
  }

  getCenter() {
    let rowSum = 0
    let colSum = 0

    Object.values(this.tiles).forEach((tile) => {
      rowSum += tile.row
      colSum += tile.col
    })

    let centerX = (colSum / Object.keys(this.tiles).length) * Constants.tileSize
    let centerY = (rowSum / Object.keys(this.tiles).length) * Constants.tileSize

    return {
      x: centerX,
      y: centerY
    }
  }

  showDistanceLabel(distance) {
    if (this.distanceText) this.distanceText.remove()

    this.distanceText  = BitmapText.create({
      label: "Distance",
      text: distance, 
      spriteContainer: this.sprite
    })

    this.repositionDistanceLabel()
  }

  repositionDistanceLabel() {
    let center = this.getCenter()
    this.distanceText.sprite.position.x = center.x - (this.distanceText.sprite.width/2)
    this.distanceText.sprite.position.y = center.y
  }

  repositionIdText() {
    let center = this.getCenter()
    this.idText.sprite.position.x = center.x - (this.idText.sprite.width/2)
    this.idText.sprite.position.y = center.y - Constants.tileSize 
  }

  initSprite() {
    this.sprite = new PIXI.Container()
    this.sprite.name = "ChunkRegion"
    this.sprite.visible = false

    this.getSpriteContainer().addChild(this.sprite)
  }

  getId() {
    return this.id
  }

  show(alpha) {
    this.sprite.visible = true
    this.sprite.alpha = alpha || this.defaultAlpha
  }

  focus() {
    this.sprite.alpha = 0.8
  }

  unfocus() {
    this.sprite.alpha = this.defaultAlpha
  }

  hide() {
    this.sprite.visible = false
  }

  getSpriteContainer() {
    return this.sector.chunkRegionContainer
  }

  syncWithServer(data) {
    this.chunkId = data.chunkId

    this.setTiles(data.tiles)
    this.setGates(data.gates)
    this.drawTileEdges()
    this.drawIdLabel()

    this.registerToChunk()
  }

  drawIdLabel() {
    this.idText  = BitmapText.create({
      label: "ChunkRegionId",
      text: this.id,
      anchor: 0,
      spriteContainer: this.sprite
    })

    this.idText.sprite.tint = 0xeadd2b
    this.repositionIdText()
  }

  registerToChunk() {
    this.getChunk().registerChunkRegion(this)
  }

  unregisterFromChunk() {
    this.getChunk().unregisterChunkRegion(this)
  }

  remove() {
    this.unregisterFromChunk()

    this.sprite.parent.removeChild(this.sprite)

    if (this.idText) {
      this.idText.remove()
    }

    if (this.distanceText) {
      this.distanceText.remove()
    }
  }


  drawTileEdges() {
    for (let tileKey in this.tiles) {
      let tile = this.tiles[tileKey]
      this.drawEdges(tile)
    }
  }

  getSideHits(tile) {
    const result = { left: false, up: false, right: false, down: false }

    if (this.getChunkRegionTile(tile.row, tile.col - 1)) {
      result.left = true
    }

    if (this.getChunkRegionTile(tile.row - 1, tile.col )) {
      result.up = true
    }

    if (this.getChunkRegionTile(tile.row, tile.col + 1)) {
      result.right = true
    }

    if (this.getChunkRegionTile(tile.row + 1, tile.col )) {
      result.down = true
    }

    return result
  }

  getChunkRegionTile(row, col) {
    return this.tiles[this.getTileKey({ row: row, col: col })]
  }

  hasTile(row, col) {
    let tileKey = this.getTileKey({ row: row, col: col })
    return this.tiles[tileKey]
  }

  drawEdges(tile) {
    const sideHits = this.getSideHits(tile)

    for (let direction in sideHits) {
      let hasTileInDirection = sideHits[direction]

      if (!hasTileInDirection) {
        let edgeSprite = new PIXI.Sprite(PIXI.utils.TextureCache[this.getEdgeSpritePath()])
        edgeSprite.tint = 0x00ff00
        edgeSprite.name = "chunk_region_tile_edge_" + direction
        edgeSprite.height = this.getEdgeWidth()
        // edgeSprite.anchor.set(0.5)
        tile.tileSprite.addChild(edgeSprite)

        let offset = 0
        let padding = this.getEdgePadding()

        switch(direction) {
          case "left":
            edgeSprite.rotation = 90 * PIXI.DEG_TO_RAD
            edgeSprite.position.x = 0
            break
          case "up":
            edgeSprite.rotation = 0
            edgeSprite.position.y = 0
            break
          case "right":
            edgeSprite.rotation = 90 * PIXI.DEG_TO_RAD
            edgeSprite.position.x = Constants.tileSize
            break
          case "down":
            edgeSprite.rotation = 0
            edgeSprite.position.y = Constants.tileSize
            break
        }
      }
    }
  }

  getEdgePadding() {
    return 1
  }

  getEdgeSpritePath() {
    return 'platform_edge_white.png'
  }

  getEdgeWidth() {
    return 3
  }

  setTiles(tiles) {
    for (var i = 0; i < tiles.length; i++) {
      let tile = tiles[i]
      tile.tileSprite = this.createTileSprite(tile.row, tile.col)
      this.registerTile(tile)
      this.sprite.addChild(tile.tileSprite)
    }
  }

  setGates(gates) {
    for (var i = 0; i < gates.length; i++) {
      let gate = gates[i]
      this.gates[gate.id] = gate
    }
  }

  getChunk() {
    let row = this.chunkId.split("-")[0]
    let col = this.chunkId.split("-")[1]
    
    return this.sector.getChunk(row, col)
  }

  registerTile(tile) {
    let tileKey = this.getTileKey(tile)
    this.tiles[tileKey] = tile
  }

  getTileKey(tile) {
    return [tile.row, tile.col].join("-")
  }

  getTileSpritePath() {
    return "room_tile.png"
  }

  createTileSprite(row, col) {
    let container = new PIXI.Container()
    container.name = "chunk_region_tile"

    container.width  = Constants.tileSize
    container.height = Constants.tileSize
    container.position.x = col * Constants.tileSize
    container.position.y = row * Constants.tileSize

    let texture = PIXI.utils.TextureCache[this.getTileSpritePath()]
    let sprite = new PIXI.Sprite(texture)
    sprite.name = "chunk_region_tile_background"
    sprite.tint = 0x0000ff

    container.addChild(sprite)
    return container
  }

}

module.exports = ChunkRegion
},{"../util/bitmap_text":648,"./../../../common/constants.json":656}],333:[function(require,module,exports){
class ChunkRegionPath {
  constructor(data, sector) {
    this.id = data.id
    this.sector = sector
    this.nodes = data.nodes
  }

  syncWithServer(data) {

  }

  remove() {
    
  }

  show() {
    for (var i = 0; i < this.nodes.length; i++) {
      let node = this.nodes[i]
      let chunkRegion = this.sector.getChunkRegionById(node.chunkRegionId)
      if (chunkRegion) {
        chunkRegion.show(0.7)
        chunkRegion.showDistanceLabel(node.distance)
      }
    }
  }

  hide() {
    for (var i = 0; i < this.nodes.length; i++) {
      let node = this.nodes[i]
      let chunkRegion = this.sector.getChunkRegionById(node.chunkRegionId)
      if (chunkRegion) {
        chunkRegion.hide()
      }
    }
  }

}

module.exports = ChunkRegionPath
},{}],334:[function(require,module,exports){
const ExceptionReporter = require("./../util/exception_reporter")
const Helper = require("./../../../common/helper")

const ClientContainer = () => {
}

ClientContainer.prototype = {
  initClientContainer() {
    this.staticSyncQueue = []
    this.dynamicSyncQueue = []
    this.clientContainerInitTime = Date.now()
  },

  syncWithServerForGroups(groups, data, options = {}) {
    let staticGroups = ["buildings", "rooms", "pickups", "chunkRegionPaths"]
    for (var i = 0; i < groups.length; i++) {
      let group = groups[i]
      if (!data[group]) continue
      if (data[group].length === 0) continue

      let entities = data[group]
      let initialMapLoad = (Date.now() - this.clientContainerInitTime) < 3000
      if (initialMapLoad || options.sync) {
        entities.forEach((entityData) => {
          this.processEntitySync(group, entityData)
        })
        return
      }

      let immediateInteractData = entities.find((entityData) => {
         return entityData.id === this.game.lastInteractEntityId
      })
 
      if (immediateInteractData) {
        this.processEntitySync(group, immediateInteractData)
      }
 
      if (staticGroups.indexOf(group) !== -1) {
        this.pushToStaticSyncQueue({ group: group, entities: data[group] })
      } else {
        this.pushToDynamicSyncQueue({ group: group, entities: data[group] })
      }
    }
  },

  sortByDeleteFirst(entities) {
    return entities.sort((a, b) => {
      // https://stackoverflow.com/a/17387454
      return (a.clientMustDelete === b.clientMustDelete)? 0 : a.clientMustDelete ? -1 : 1
    })
  },

  syncTerrains(data, options = {}) {
    if (data.terrains.length === 0) return

    data.terrains = this.sortByDeleteFirst(data.terrains)

    let initialMapLoad = (Date.now() - this.clientContainerInitTime) < 3000
    if (initialMapLoad || options.sync) {
      data.terrains.forEach((entityData) => {
        this.processEntitySync("terrains", entityData)
      })
    } else {
      this.pushToStaticSyncQueue({ group: "terrains", entities: data.terrains })
    }
  },

  getTerrainId(data) {
    let absoluteIndex = data.row * this.getColCount() + data.col
    return [data.type, absoluteIndex].join("-")
  },

  pushToDynamicSyncQueue(options) {
    this.dynamicSyncQueue.push(options)
  },

  pushToStaticSyncQueue(options) {
    this.staticSyncQueue.push(options)
  },

  processDynamicSyncQueue() {
    let allowedMs = 5
    let elapsed = 0

    // dynamic sync
    while (this.dynamicSyncQueue.length > 0 && elapsed < allowedMs) {
      let data = this.dynamicSyncQueue[0]

      while (data.entities.length > 0 && elapsed < allowedMs) {
        let startTime = Date.now()

        let entityData = data.entities.shift()
        this.processEntitySync(data.group, entityData)

        let duration = Date.now() - startTime
        elapsed += duration
      }

      if (data.entities.length === 0) {
        this.dynamicSyncQueue.shift()
      }
    }
  },

  processStaticSyncQueue() {
    let allowedMs 
    if ((Date.now() - this.clientContainerInitTime) < 3000) {
      allowedMs = 1000
    } else if (this.game.resolution < 1) {
      allowedMs = 150
    } else {
      allowedMs = 7
    }

    let elapsed = 0
    // static sync queue
    while (this.staticSyncQueue.length > 0 && elapsed < allowedMs) {
      let data = this.staticSyncQueue[0]

      while (data.entities.length > 0 && elapsed < allowedMs) {
        let startTime = Date.now()

        let entityData = data.entities.shift()
        this.processEntitySync(data.group, entityData)

        let duration = Date.now() - startTime
        elapsed += duration
      }

      if (data.entities.length === 0) {
        this.staticSyncQueue.shift()
      }
    }
  },

  processEntitySyncQueue() {
    this.processDynamicSyncQueue()
    this.processStaticSyncQueue()
  },

  processEntitySync(group, entityData) {
    if (group === 'terrains') {
      this.syncTerrain(entityData)
      return
    } else {
      this.syncGroup(entityData, group)
    }
  },

  syncTerrain(entityData) {
    entityData.id = this.getTerrainId(entityData)

    try {
      if (entityData.clientMustDelete) {
        let entity = this.terrains[entityData.id]
        this.removeEntity(entity, "terrains")
      } else {
        this.renderEntity(entityData, "terrains")
      }
    } catch(e) {
      console.log("failed to sync terrain:")
      console.log(e)
    }
  },

  syncGroup(entityData, group) {
    if (entityData.clientMustDelete) {
      let entity = this[group][entityData.id]
      if (entity) {
        // its possible that clientMustDelete sent more than once 
        // (i.e projectile remove broacasted in all chunks (i.e 3) traversed by projectile)
        this.removeEntity(entity, group, entityData)
      }
    } else {
      this.renderEntity(entityData, group)
    }
  },

  renderEntity(data, group) {
    try {
      const localEntity = this.getLocalEntity(data, group)
      localEntity.syncWithServer(data)
    } catch(e) {
      ExceptionReporter.captureException(e)
    }
  },

  getLocalEntity(data, group) {
    let entity = this[group][data.id]

    if (!entity) {
      entity = this.createEntity(data, group)
    }

    return entity
  },

  createEntity(data, group) {
    data.container = this
    let entity = this.game.createEntity(group, data)
    this[group][entity.id] = entity

    return entity
  },

  // dont need to trigger entity remove callbacks. just need to clear reference..
  removeAllEntities(entityType) {
    for (let clientId in this[entityType]) {
      delete this[entityType][clientId]
    }
  },

  removeAllNonIdEntities(entityType) {
    this[entityType] = []
  },

  removeEntity(entity, entityType, entityData) {
    try {
      if (!entity) return
      entity.remove(entityData)
    } catch(e) {
      ExceptionReporter.captureException(e)
    }
  },

  unregisterEntity(entityType, entity) {
    delete this[entityType][entity.id]
  },

  isRegisterableInMap(entity) {
    return [
      Constants.collisionGroup.Player,
      Constants.collisionGroup.Building,
      Constants.collisionGroup.Unit,
      Constants.collisionGroup.Mob
    ].indexOf(entity.getCollisionGroup()) !== -1
  },

  getGridRulerSprite() {
    let texture = PIXI.utils.TextureCache["grid_ruler.png"]
    const width  = this.getGridWidth()
    const height = this.getGridHeight()
    const sprite = new PIXI.extras.TilingSprite(texture, width, height)
    sprite.alpha = 0
    sprite.anchor.set(0)
    sprite.name = "GridRuler"
    return sprite
  },

  getRegion(x, y) {
    let result = null

    for (let regionId in this.regions) {
      let region = this.regions[regionId]
      let isColliding = this.testBoxPoint(region.getStart().x, region.getStart().y, region.getWidth(), region.getHeight(), x, y)
      if (isColliding) {
        result = region
        break
      }
    }

    return result
  },

  createSpriteLayer(group) {
    const sprite = new PIXI.Container()
    sprite.name = group

    return sprite
  },

  toggleRangeLayer() {
    let alpha = 1 - this.rangeContainerSprite.alpha
    this.setRangeAlpha(alpha)
  },

  setRangeAlpha(alpha) {
    this.rangeContainerSprite.alpha = alpha
    this.setAllRangeAlpha(alpha)
  },

  setAllRangeAlpha(alpha) {
    for (let shipId in this.structures) {
      let ship = this.structures[shipId]
      if (ship.isTower()) {

        if (alpha === 0) {
          ship.hideRange()
        } else {
          ship.drawRange()
        }
      }
    }
  },

  createSpriteLayersFor(parent, groups) {
    this.spriteLayers = this.spriteLayers || {}

    groups.forEach((group) => {
      let layer = this.createSpriteLayer(group)
      this.spriteLayers[group] = layer
      parent.addChild(layer)
    })

  },

  getContainerSprite() {
    const sprite = new PIXI.Container()

    this.gridRulerSprite = this.getGridRulerSprite()

    sprite.addChild(this.gridRulerSprite)

    return sprite
  }

}

module.exports = ClientContainer
},{"./../../../common/helper":664,"./../util/exception_reporter":650}],335:[function(require,module,exports){
const BaseEntity = require('./base_entity')
const Constants     = require('../../../common/constants.json')
const ShipMountable = require('../../../common/interfaces/ship_mountable')
const Mobs = require("./mobs/index")
const SpriteEventHandler = require("./../util/sprite_event_handler")
const ClientHelper = require("./../util/client_helper")
const BitmapText = require("../util/bitmap_text")


class Corpse extends BaseEntity {
  constructor(game, data) {
    super(game, data)

    this.type = data.type
    this.angle = data.angle
    this.chunks = {}

    this.name = data.name
    if (this.name) {
      this.createUsernameSprite(this.sprite)
    }

    this.onCorpseConstructed()
  }

  isCorpse() {
    return true
  }

  getName() {
    return this.name
  }

  createUsernameSprite(container) {
    this.usernameText = BitmapText.create({
      label: "UsernameText",
      text: this.getName(),
      spriteContainer: container
    })

    const margin = this.getHeight()

    this.usernameText.sprite.position.y = margin
  }

  onMouseOver() {
    super.onMouseOver()

    this.game.highlight(this)
    this.game.showEntityMenu(this)
  }

  onMouseOut() {
    super.onMouseOut()

    this.game.unhighlight(this)
    this.game.hideEntityMenu(this)
  }

  getTypeName() {
    return Mobs.forType(this.type).getTypeName() +  " Corpse"
  }

  onCorpseConstructed() {
    this.repositionOnCorpseMap()
    if (this.getChunk()) {
      this.getChunk().register("corpses", this)
    }
  }

  getChunk() {
    return this.sector.getChunk(this.getChunkRow(), this.getChunkCol())
  }

  getType() {
    return this.type
  }

  getConstantsTable() {
    return "Corpse"
  }

  getGroup() {
    return "corpses"
  }

  onPositionChanged() {
    this.registerToChunk()
    this.repositionOnCorpseMap()
  }

  remove() {
    if (this.usernameText) {
      this.usernameText.remove()
    }
    
    this.getContainer().unregisterEntity("corpses", this)

    // chunk might be null (i.e outside of game bounds..)
    if (this.getChunk()) {
      this.getChunk().unregister("corpses", this)
    } else {
      this.sector.forEachChunk((chunk) => {
        chunk.unregister("corpses", this)
      })
    }
    
    this.removeFromCorpseMap()
    super.remove()
  }

  getContainer() {
    return this.ship || this.game.sector
  }

  syncWithServer(data) {
    this.instructToMove(data.x, data.y)
    this.setEffects(data.effects)
  }

  interpolate(lastFrameTime) {
    const prev = { x: this.sprite.position.x, y: this.sprite.position.y }
    super.interpolate(lastFrameTime)
    const curr = { x: this.sprite.position.x, y: this.sprite.position.y }

    if (curr.x !== prev.x || curr.y !== prev.y) {
      this.onPositionChanged()
    }
  }

  getSpriteContainer() {
    return this.game.sector.spriteLayers["corpses"]
  }

  getSprite() {
    const sprite = new PIXI.Container()
    sprite.name = "CorpseContainer"

    const mobKlass = Mobs.forType(this.data.type)

    this.characterSprite = mobKlass.prototype.getCorpseSprite()
    const baseRotationOffset = 90 * (Math.PI / 180)

    let dizzySpriteConfig = mobKlass.prototype.getDizzySpriteConfig()
    if (Object.keys(dizzySpriteConfig).length > 0) {
      this.addDizzyEyes(this.characterSprite)
      this.dizzySprite.width  = dizzySpriteConfig.width
      this.dizzySprite.height = dizzySpriteConfig.height
      this.dizzySprite.position.x = dizzySpriteConfig.position.x
      this.dizzySprite.position.y = dizzySpriteConfig.position.y
      this.dizzySprite.rotation = dizzySpriteConfig.rotation * Math.PI / 180
      if (dizzySpriteConfig.tint) {
        this.dizzySprite.tint = ClientHelper.hexToInt(dizzySpriteConfig.tint)
      }
    }

    let radian = this.data.angle * (Math.PI / 180)
    this.characterSprite.rotation = radian + baseRotationOffset
    sprite.addChild(this.characterSprite)

    return sprite
  }


}

Object.assign(Corpse.prototype, ShipMountable.prototype, {
  getRelativeX() {
    return this.sprite.position.x
  },
  getRelativeY() {
    return this.sprite.position.y
  }
})


module.exports = Corpse

},{"../../../common/constants.json":656,"../../../common/interfaces/ship_mountable":678,"../util/bitmap_text":648,"./../util/client_helper":649,"./../util/sprite_event_handler":655,"./base_entity":206,"./mobs/index":464}],336:[function(require,module,exports){
const BaseDrink = require("./base_drink")
const Constants = require("./../../../../common/constants.json")
const Protocol = require("./../../../../common/util/protocol")

class AlienJuice extends BaseDrink {

  repositionSprite() {
    this.sprite.position.x = 48
    this.sprite.position.y = 30
    this.sprite.rotation = 35 * Math.PI/180
  }

  getSpritePath() {
    return 'alien_juice.png'
  }

  getType() {
    return Protocol.definition().BuildingType.AlienJuice
  }

  getConstantsTable() {
    return "Drinks.AlienJuice"
  }

}

module.exports = AlienJuice

},{"./../../../../common/constants.json":656,"./../../../../common/util/protocol":686,"./base_drink":337}],337:[function(require,module,exports){
const BaseFood = require("./../foods/base_food")

class BaseDrink extends BaseFood {

  static getSellGroup() {
    return "Drinks"
  }

  isAnimatable() {
    return true
  }

  animate() {
    if (this.animationTween) return
    this.animationTween = this.getAnimationTween()
    this.animationTween.start()
  }

  stopAnimation() {
    if (this.animationTween) {
      this.animationTween.stop()
    }

    this.animationTween = null
  }

  getAnimationTween() {
    this.origRotation = this.sprite.rotation
    let rotation = { rotation: this.sprite.rotation }

    const tween = new TWEEN.Tween(rotation)
        .to({ rotation: this.sprite.rotation - Math.PI/3  }, 800)
        .onUpdate(() => {
          this.sprite.rotation = rotation.rotation
        })
        .onStop(() => {
          this.sprite.rotation = this.origRotation
        })
        .yoyo(true)
        .repeat(Infinity)

    return tween
  }

  remove() {
    this.stopAnimation()

    super.remove()
  }
}

module.exports = BaseDrink
},{"./../foods/base_food":411}],338:[function(require,module,exports){
const BaseDrink = require("./base_drink")
const Constants = require("./../../../../common/constants.json")
const Protocol = require("./../../../../common/util/protocol")

class Beer extends BaseDrink {

  repositionSprite() {
    this.sprite.position.x = 48
    this.sprite.position.y = 30
    this.sprite.rotation = 35 * Math.PI/180
  }

  getSpritePath() {
    return 'beer.png'
  }

  getType() {
    return Protocol.definition().BuildingType.Beer
  }

  getConstantsTable() {
    return "Drinks.Beer"
  }

}

module.exports = Beer

},{"./../../../../common/constants.json":656,"./../../../../common/util/protocol":686,"./base_drink":337}],339:[function(require,module,exports){
const BaseDrink = require("./base_drink")
const Constants = require("./../../../../common/constants.json")
const Protocol = require("./../../../../common/util/protocol")

class EnergyDrink extends BaseDrink {

  repositionSprite() {
    this.sprite.position.x = 48
    this.sprite.position.y = 30
    this.sprite.rotation = 35 * Math.PI/180
  }

  getSpritePath() {
    return 'energy_drink.png'
  }

  getType() {
    return Protocol.definition().BuildingType.EnergyDrink
  }

  getConstantsTable() {
    return "Drinks.EnergyDrink"
  }

}

module.exports = EnergyDrink

},{"./../../../../common/constants.json":656,"./../../../../common/util/protocol":686,"./base_drink":337}],340:[function(require,module,exports){
const Helper = require("./../../../../common/helper")
const Constants = require("./../../../../common/constants.json")
const Protocol = require("./../../../../common/util/protocol")

const Drinks = {}
Drinks.Drinkable = {}

const BaseDrink = require("./base_drink")
Drinks.Drinkable.Beer = require("./beer")
Drinks.Drinkable.Vodka = require("./vodka")
Drinks.Drinkable.EnergyDrink = require("./energy_drink")
Drinks.Drinkable.AlienJuice = require("./alien_juice")
Drinks.Drinkable.Nihonshu = require("./nihonshu")

Drinks.forType = (type) => {
  let klass
  const klassName = Helper.getTypeNameById(type) 

  // find which namesapce
  for (let group in Drinks) {
    klass = Drinks[group][klassName]
    if (klass) break
  }

  return klass
}

// dynamically create klasses
for (let name in Constants.Drinks) {
  if (!Drinks.Drinkable[name]) {
    let data = Constants.Drinks[name]
    if (!data.abstract) {
      Drinks.Drinkable[name] = Helper.createDynamicKlass("Drinks", BaseDrink, name)
    }
  }
}

Drinks.getDrinkables = () => {
  return Object.values(Drinks.Drinkable)
}


module.exports = Drinks

},{"./../../../../common/constants.json":656,"./../../../../common/helper":664,"./../../../../common/util/protocol":686,"./alien_juice":336,"./base_drink":337,"./beer":338,"./energy_drink":339,"./nihonshu":341,"./vodka":342}],341:[function(require,module,exports){
const BaseDrink = require("./base_drink")
const Constants = require("./../../../../common/constants.json")
const Protocol = require("./../../../../common/util/protocol")

class Nihonshu extends BaseDrink {

  repositionSprite() {
    this.sprite.position.x = 48
    this.sprite.position.y = 30
    this.sprite.rotation = 35 * Math.PI/180
  }

  getSpritePath() {
    return 'nihonshu.png'
  }

  getType() {
    return Protocol.definition().BuildingType.Nihonshu
  }

  getConstantsTable() {
    return "Drinks.Nihonshu"
  }

}

module.exports = Nihonshu
},{"./../../../../common/constants.json":656,"./../../../../common/util/protocol":686,"./base_drink":337}],342:[function(require,module,exports){
const BaseDrink = require("./base_drink")
const Constants = require("./../../../../common/constants.json")
const Protocol = require("./../../../../common/util/protocol")

class Vodka extends BaseDrink {

  repositionSprite() {
    this.sprite.position.x = 48
    this.sprite.position.y = 30
    this.sprite.rotation = 35 * Math.PI/180
  }

  getType() {
    return Protocol.definition().BuildingType.Vodka
  }

  getConstantsTable() {
    return "Drinks.Vodka"
  }

}

module.exports = Vodka

},{"./../../../../common/constants.json":656,"./../../../../common/util/protocol":686,"./base_drink":337}],343:[function(require,module,exports){
const Definable = require("./../../../../common/interfaces/definable")
const ClientHelper = require("./../../util/client_helper")

class BaseEffect  {
  getSpritePath() {
    return this.getConstants().sprite
  }

  getTypeName() {
    return this.getConstants().name
  }

  hasSprite() {
    return !!this.getSpritePath()
  }

  constructor(affectedEntity) {
    this.affectedEntity = affectedEntity
    this.game = affectedEntity.game

    if (this.hasSprite()) {
      this.sprite = this.getSprite()
      if (this.sprite) {
        this.getEffectSpriteContainer(this.affectedEntity, this.getTypeName()).addChild(this.sprite)
      }
    }

    this.affectedEntity.addEffectInstance(this.getTypeName(), this)

    this.onPostInit()
  }

  onLevelChanged(level) {

  }

  getX() {
    return this.sprite.position.x
  }

  getY() {
    return this.sprite.position.y
  }

  onPostInit() {

  }

  getMaxEffectLevel() {
    return this.affectedEntity.getMaxEffectLevel()
  }

  remove() {
    if (this.tween) {
      this.tween.stop()
    }

    this.affectedEntity.removeEffectInstance(this.getTypeName())

    if (this.sprite) {
      ClientHelper.removeSelfAndChildrens(this.sprite)
    }
  }

  getSprite() {
    let sprite = new PIXI.Sprite(PIXI.utils.TextureCache[this.getSpritePath()])
    sprite.name = this.getTypeName()
    sprite.anchor.set(0.5)

    // if (this.isTargetLivingEntity()) {
    // } else {
    //   sprite.position.set(this.affectedEntity.getX(), this.affectedEntity.getY())
    // }

    return sprite
  }

  isTargetLivingEntity() {
    return this.affectedEntity.isPlayer() || this.affectedEntity.isMob()
  }

  getEffectSpriteContainer(entity, effect) {
    if (entity.isTerrain()) {
      return this.game.sector.groundEffectsContainer
    }
    
    return entity.sprite
    // if (this.isTargetLivingEntity()) {
    //   return entity.sprite
    // }

    // let container = this.game.sector.groundEffectsContainer

    // switch(effect) {
    //   case "water":
    //     container = this.game.sector.highGroundEffectsContainer
    //     break
    //   default:
    //     container = this.game.sector.effectsContainer
    // }

    // return container
  }


}

Object.assign(BaseEffect.prototype, Definable.prototype, {
})

module.exports = BaseEffect

},{"./../../../../common/interfaces/definable":669,"./../../util/client_helper":649}],344:[function(require,module,exports){
const BaseEffect = require("./base_effect")
const Constants = require("./../../../../common/constants.json")

class Blood extends BaseEffect {

  getConstantsTable() {
    return "Effects.Blood"
  }

  onPostInit() {
    if (this.affectedEntity.isTerrain()) {
      this.sprite.position.set(this.affectedEntity.getX(), this.affectedEntity.getY())
    }
  }  

  onLevelChanged(level) {
    if (level <= 0) return

    let textures = ["blood_1.png", "blood_2.png", "blood_3.png"]
    let fullBloodTextures = ["blood_4.png", "blood_4_b.png", "blood_4_c.png"]
    let texture

    if (level === 4)  {
      let index = Math.floor(Math.random() * fullBloodTextures.length)
      texture = fullBloodTextures[index]
    } else {
      texture = textures[level - 1]
    }

    this.sprite.texture = PIXI.utils.TextureCache[texture]
  }


}

module.exports = Blood

},{"./../../../../common/constants.json":656,"./base_effect":343}],345:[function(require,module,exports){
const BaseEffect = require("./base_effect")
const Constants = require("./../../../../common/constants.json")

class Break extends BaseEffect {

  getConstantsTable() {
    return "Effects.Break"
  }

  onPostInit() {
    this.onLevelChanged(1)
  }  

  onLevelChanged(level) {
    this.setSize(level)
  }

  setSize(level) {
    let size = (level / this.getMaxEffectLevel()) * Constants.tileSize
    this.sprite.width  = size
    this.sprite.height = size
  }

  getMaxEffectLevel() {
    return 1
  }


}

module.exports = Break

},{"./../../../../common/constants.json":656,"./base_effect":343}],346:[function(require,module,exports){
const BaseEffect = require("./base_effect")
const Constants = require("./../../../../common/constants.json")

class Dirt extends BaseEffect {

  getConstantsTable() {
    return "Effects.Dirt"
  }

  onLevelChanged(level) {
    if (level <= 0) return

    let textures = ["dirt_1.png", "dirt_2.png", "dirt_3.png", "dirt_4.png"]
    let texture = textures[level - 1]

    this.sprite.texture = PIXI.utils.TextureCache[texture]
  }


}

module.exports = Dirt

},{"./../../../../common/constants.json":656,"./base_effect":343}],347:[function(require,module,exports){
const BaseEffect = require("./base_effect")
const Constants = require("./../../../../common/constants.json")
const ClientHelper = require("./../../util/client_helper")

class Fire extends BaseEffect {

  getConstantsTable() {
    return "Effects.Fire"
  }

  onPostInit() {
    if (this.affectedEntity.isTerrain()) {
      this.sprite.position.set(this.affectedEntity.getX(), this.affectedEntity.getY())
    }

    this.onLevelChanged(1)
  }  

  onLevelChanged(level) {
    this.setSize(level)
    this.reinitTween()
  }

  setSize(level) {
    let size = (level / this.getMaxEffectLevel()) * Constants.tileSize
    this.sprite.width  = size
    this.sprite.height = size
  }

  remove() {
    super.remove()
  }

  reinitTween() {
    if (this.tween) {
      this.tween.stop()
    }

    this.tween = this.getAnimationTween()
    this.tween.start()
  }

  getAnimationTween() {
    const origWidth = this.sprite.width
    const maxExpansion = 10
    const desiredWidth = origWidth + maxExpansion
    let width = { width: origWidth }
    const widthToShiftPosition = origWidth 
    const amountToShift = (Constants.tileSize * 2) / origWidth + 5 // the smaller it is,  the more it shift around
    const origX = this.getX()
    const origY = this.getY()
    const shouldShift = !this.isTargetLivingEntity()
    const tweenSpeed = this.isTargetLivingEntity() ? 300 : 1000

    var tween = new TWEEN.Tween(width)
        .to({ width: desiredWidth }, tweenSpeed)
        .onUpdate(() => {
          if (shouldShift && width.width === widthToShiftPosition) {
            let randomX = amountToShift/2 - Math.floor(Math.random() * amountToShift)
            let randomY = amountToShift/2 - Math.floor(Math.random() * amountToShift)
            this.sprite.position.set(origX + randomX, origY + randomY)
          }
          this.sprite.width = width.width
          this.sprite.height = width.width
        })
        .yoyo(true)
        .repeat(Infinity)

    return tween
  }


}

module.exports = Fire

},{"./../../../../common/constants.json":656,"./../../util/client_helper":649,"./base_effect":343}],348:[function(require,module,exports){
const BaseEffect = require("./base_effect")
const Constants = require("./../../../../common/constants.json")

class Haste extends BaseEffect {

  getConstantsTable() {
    return "Effects.Haste"
  }

}

module.exports = Haste

},{"./../../../../common/constants.json":656,"./base_effect":343}],349:[function(require,module,exports){
const Effects = {}
const Helper = require("./../../../../common/helper")

Effects.Fire = require("./fire")
Effects.Blood = require("./blood")
Effects.Web = require("./web")
Effects.Poison = require("./poison")
Effects.Residue = require("./residue")
Effects.Dirt = require("./dirt")
Effects.Break = require("./break")
Effects.Miasma = require("./miasma")
Effects.Spin = require("./spin")
Effects.Smoke = require("./smoke")
Effects.Invisible = require("./invisible")
Effects.Haste = require("./haste")

Effects.forName = (effectName) => {
  return Effects[Helper.capitalize(effectName)]
}


module.exports = Effects
},{"./../../../../common/helper":664,"./blood":344,"./break":345,"./dirt":346,"./fire":347,"./haste":348,"./invisible":350,"./miasma":351,"./poison":352,"./residue":353,"./smoke":354,"./spin":355,"./web":356}],350:[function(require,module,exports){
const BaseEffect = require("./base_effect")
const Constants = require("./../../../../common/constants.json")

class Invisible extends BaseEffect {

  getConstantsTable() {
    return "Effects.Invisible"
  }

  onPostInit() {
    this.tween = this.getInvisibleTween()
    this.tween.start()
  }

  getInvisibleTween() {
    let opacity = { opacity: 1 }
    let targetOpacity = 0
    if (this.affectedEntity.isPlayer() &&
        this.affectedEntity.isMe()) {
      targetOpacity = 0.2
    }

    const tween = new TWEEN.Tween(opacity)
        .to({ opacity: targetOpacity }, 400)
        .onUpdate(() => {
          this.affectedEntity.sprite.alpha = opacity.opacity
        })

    return tween
  }

  remove() {
    super.remove()

    this.affectedEntity.sprite.alpha = 1
  }


}

module.exports = Invisible

},{"./../../../../common/constants.json":656,"./base_effect":343}],351:[function(require,module,exports){
const BaseEffect = require("./base_effect")
const Constants = require("./../../../../common/constants.json")

class Miasma extends BaseEffect {

  getConstantsTable() {
    return "Effects.Miasma"
  }

  onPostInit() {
    // this.sprite.position.x = this.affectedEntity.getX()
    // this.sprite.position.y = this.affectedEntity.getY()
    this.sprite.tint = 0x9839a6
    this.sprite.alpha = 0.5 

    let affectedSprite = this.affectedEntity.characterSprite || this.affectedEntity.buildingSprite

    let width = affectedSprite.width + Math.floor(Math.random() * Constants.tileSize)
    this.sprite.width  = width
    this.sprite.height = width

    this.tween = this.getAnimationTween() 
    this.tween.start()
  }


  getAnimationTween() {
    let origWidth = this.sprite.width
    const maxExpansion = 10
    const desiredWidth = origWidth + maxExpansion
    let width = { width: origWidth }

    var tween = new TWEEN.Tween(width)
        .to({ width: desiredWidth }, 1000)
        .onUpdate(() => {
          let diff = desiredWidth - width.width
          this.sprite.width = width.width
          this.sprite.height = width.width
          this.sprite.alpha = 0.5 + (diff / maxExpansion) / 3
        })
        .yoyo(true)
        .repeat(Infinity)

     return tween
  }

  // must position and tween (variable circle width)

  onLevelChanged(level) {
    if (level <= 0) return
  }

  // getEffectSpriteContainer() {
  //   return this.game.sector.effectsContainer
  // }


}

module.exports = Miasma


},{"./../../../../common/constants.json":656,"./base_effect":343}],352:[function(require,module,exports){
const BaseEffect = require("./base_effect")
const Constants = require("./../../../../common/constants.json")
const ClientHelper = require("./../../util/client_helper")

class Poison extends BaseEffect {

  getConstantsTable() {
    return "Effects.Poison"
  }

  getSprite() {
    return null
  }

  getTint() {
    return 0x00ff00
  }

  onPostInit() {
    this.affectedEntity.getTintableSprites().forEach((sprite) => {
      sprite.originalTint = sprite.defaultTint ? sprite.defaultTint : sprite.tint
      sprite.tint = this.getTint()
    })
  }  

  remove() {
    super.remove()

    this.affectedEntity.getTintableSprites().forEach((sprite) => {
      if (sprite.originalTint) {
        sprite.tint = sprite.originalTint
      }
    })
  }

}

module.exports = Poison

},{"./../../../../common/constants.json":656,"./../../util/client_helper":649,"./base_effect":343}],353:[function(require,module,exports){
const BaseEffect = require("./base_effect")
const Constants = require("./../../../../common/constants.json")

class Residue extends BaseEffect {

  getConstantsTable() {
    return "Effects.Residue"
  }

}

module.exports = Residue

},{"./../../../../common/constants.json":656,"./base_effect":343}],354:[function(require,module,exports){
const BaseEffect = require("./base_effect")
const Constants = require("./../../../../common/constants.json")
const ClientHelper = require("./../../util/client_helper")

class Smoke extends BaseEffect {

  getConstantsTable() {
    return "Effects.Smoke"
  }

  getSprite() {
    return null
  }

  onPostInit() {
    this.tween = this.getSmokeTween()
    this.tween.start()
  }  

  remove() {
    super.remove()
  }

  getSmokeTween() {
    let position = { position: 0 }
    let counter = 0

    const tween = new TWEEN.Tween(position)
        .to({ position: Constants.tileSize * 3 }, 3000)
        .onUpdate(() => {
          if (counter >= 10) {
            counter = 0
            let x = this.affectedEntity.getX()
            let y = this.affectedEntity.getY()
            let smoke = this.game.createSmoke({ 
              x: x, 
              y: y - Constants.tileSize/2, 
              color: 0xcccccc, 
              minWidth: 15, 
              maxWidth: 35,
              moveTo: { x: Constants.tileSize * 3, y: -(Constants.tileSize * 3) }
            })
          }

          counter += 1
        })
        .repeat(Infinity)

    return tween
  }



}

module.exports = Smoke

},{"./../../../../common/constants.json":656,"./../../util/client_helper":649,"./base_effect":343}],355:[function(require,module,exports){
const BaseEffect = require("./base_effect")
const Constants = require("./../../../../common/constants.json")

class Spin extends BaseEffect {

  getConstantsTable() {
    return "Effects.Spin"
  }

  onPostInit() {
    this.tween = this.getRotatingTween()
    this.tween.start()
  }

  getRotatingTween() {
    let rotation = { rotation: 0 }

    const tween = new TWEEN.Tween(rotation)
        .to({ rotation: 360 * PIXI.DEG_TO_RAD }, 1500)
        .onUpdate(() => {
          if (this.affectedEntity.getEffectableSprite()) {
            this.affectedEntity.getEffectableSprite().rotation = rotation.rotation
          }
        })
        .repeat(Infinity)

    return tween
  }


}

module.exports = Spin

},{"./../../../../common/constants.json":656,"./base_effect":343}],356:[function(require,module,exports){
const BaseEffect = require("./base_effect")
const Constants = require("./../../../../common/constants.json")

class Web extends BaseEffect {

  getConstantsTable() {
    return "Effects.Web"
  }

}

module.exports = Web

},{"./../../../../common/constants.json":656,"./base_effect":343}],357:[function(require,module,exports){
const BaseEquipment = require("./../base_equipment")
const ClientHelper = require("./../../../util/client_helper")
const Trail = require("../../particles/trail")

class ArmorEquipment extends BaseEquipment {
  getSpriteContainer() {
    return this.data.user.armorEquipContainer
  }

  hasOxygen() {
    return false
  }

  repositionSprite() {
    this.sprite.anchor.set(0)

    // this.sprite.position.y = 0
    this.sprite.scale.set(0.65)
  }

  animate(user) {
    // if im on platform, dont animate jetpack
    if (user.getStandingPlatform()) return
    if (user.isDestroyed()) return

    this.animationGap = this.animationGap || 0
    const animationInterval = 8

    if (this.animationGap % animationInterval === 0) {
      const radius = Math.floor(Math.random() * 10) + 5

      Trail.create({
        x: this.user.getX(), 
        y: this.user.getY(), 
        angle: this.user.getRotatedAngle(), 
        color: 0x75d3e6, 
        radius: radius, 
        offset: 48
      })
    }

    this.animationGap += 1
  }

  onOxygenChanged() {
    this.user.onOxygenChanged()
  }

  setOxygen(oxygen) {
    // diff from server. we dont care bout armor oxygen. simply trust server data
    if (this.oxygen !== oxygen) {
      this.oxygen = oxygen
      this.onOxygenChanged()
    }
  }


  getMaxOxygen() {
    return this.getConstants().stats.oxygen
  }


  onPostEquip() {
    // only if not worn by building
    if (this.user && this.user.isPlayer()) {
      this.user.redrawVisionLight()
    }
  }


  remove() {
    super.remove()

    if (this.user && this.user.isPlayer()) {
      this.user.redrawVisionLight()
      this.user.onOxygenChanged()
    }
  }

}

module.exports = ArmorEquipment
},{"../../particles/trail":509,"./../../../util/client_helper":649,"./../base_equipment":367}],358:[function(require,module,exports){
const ArmorEquipment = require("./armor_equipment")
const Constants = require("./../../../../../common/constants.json")
const Protocol = require("./../../../../../common/util/protocol")

class CombatArmor extends ArmorEquipment {

  getSpritePath() {
    return 'combat_armor.png'
  }

  repositionSprite() {
    super.repositionSprite()
    this.sprite.position.x = -10
    this.sprite.position.y = -1
  }

  hasOxygen() {
    return true
  }

  getType() {
    return Protocol.definition().BuildingType.CombatArmor
  }

  getConstantsTable() {
    return "Equipments.CombatArmor"
  }

  onPostEquip() {
    super.onPostEquip()

    if (this.user && this.user.isPlayer()) {
      this.user.hands.tint = 0x666666
      this.user.leftHand.tint = 0x666666
      this.user.rightHand.tint = 0x666666
    }
  }


  remove() {
    super.remove()

    if (this.user && this.user.isPlayer()) {
      this.user.hands.tint = 0xd2b48c
      this.user.leftHand.tint = 0xd2b48c
      this.user.rightHand.tint = 0xd2b48c
    }
  }

}

module.exports = CombatArmor

},{"./../../../../../common/constants.json":656,"./../../../../../common/util/protocol":686,"./armor_equipment":357}],359:[function(require,module,exports){
const ArmorEquipment = require("./armor_equipment")
const Constants = require("./../../../../../common/constants.json")
const Protocol = require("./../../../../../common/util/protocol")

class CultistSuit extends ArmorEquipment {

  getSpritePath() {
    return 'cultist_suit.png'
  }

  repositionSprite() {
    super.repositionSprite()
    this.sprite.scale.set(0.9)
    this.sprite.position.x = -20
    this.sprite.position.y = -10
  }

  getType() {
    return Protocol.definition().BuildingType.CultistSuit
  }

  getConstantsTable() {
    return "Equipments.CultistSuit"
  }


}

module.exports = CultistSuit

},{"./../../../../../common/constants.json":656,"./../../../../../common/util/protocol":686,"./armor_equipment":357}],360:[function(require,module,exports){
const ArmorEquipment = require("./armor_equipment")
const Constants = require("./../../../../../common/constants.json")
const Protocol = require("./../../../../../common/util/protocol")

class HazmatSuit extends ArmorEquipment {

  getSpritePath() {
    return 'hazmat_suit_2.png'
  }

  repositionSprite() {
    super.repositionSprite()
    this.sprite.scale.set(0.75)
    this.sprite.position.x = -22
    this.sprite.position.y = -16
  }

  hasOxygen() {
    return true
  }

  getType() {
    return Protocol.definition().BuildingType.HazmatSuit
  }

  getConstantsTable() {
    return "Equipments.HazmatSuit"
  }


}

module.exports = HazmatSuit

},{"./../../../../../common/constants.json":656,"./../../../../../common/util/protocol":686,"./armor_equipment":357}],361:[function(require,module,exports){
const ArmorEquipment = require("./armor_equipment")
const Constants = require("./../../../../../common/constants.json")
const Protocol = require("./../../../../../common/util/protocol")

class ImperialSpecialForcesArmor extends ArmorEquipment {

  getSpritePath() {
    return 'imperial_special_forces_armor.png'
  }

  repositionSprite() {
    super.repositionSprite()
    this.sprite.position.x = -10
    this.sprite.position.y = -1
  }

  hasOxygen() {
    return true
  }

  getType() {
    return Protocol.definition().BuildingType.ImperialSpecialForcesArmor
  }

  getConstantsTable() {
    return "Equipments.ImperialSpecialForcesArmor"
  }

  onPostEquip() {
    super.onPostEquip()

    if (this.user && this.user.isPlayer()) {
      this.user.hands.tint = 0x666666
      this.user.leftHand.tint = 0x666666
      this.user.rightHand.tint = 0x666666
    }
  }


  remove() {
    super.remove()

    if (this.user && this.user.isPlayer()) {
      this.user.hands.tint = 0xd2b48c
      this.user.leftHand.tint = 0xd2b48c
      this.user.rightHand.tint = 0xd2b48c
    }
  }

}

module.exports = ImperialSpecialForcesArmor
},{"./../../../../../common/constants.json":656,"./../../../../../common/util/protocol":686,"./armor_equipment":357}],362:[function(require,module,exports){
const ArmorEquipment = require("./armor_equipment")
const Constants = require("./../../../../../common/constants.json")
const Protocol = require("./../../../../../common/util/protocol")

class LabCoat extends ArmorEquipment {

  getSpritePath() {
    return 'lab_coat.png'
  }

  repositionSprite() {
    super.repositionSprite()
    this.sprite.scale.set(0.9)
    this.sprite.position.x = -20
    this.sprite.position.y = -10
  }

  getType() {
    return Protocol.definition().BuildingType.LabCoat
  }

  getConstantsTable() {
    return "Equipments.LabCoat"
  }


}

module.exports = LabCoat

},{"./../../../../../common/constants.json":656,"./../../../../../common/util/protocol":686,"./armor_equipment":357}],363:[function(require,module,exports){
const ArmorEquipment = require("./armor_equipment")
const Constants = require("./../../../../../common/constants.json")
const Protocol = require("./../../../../../common/util/protocol")

class PoliceSuit extends ArmorEquipment {

  getSpritePath() {
    return 'police_suit.png'
  }

  repositionSprite() {
    super.repositionSprite()
    this.sprite.scale.set(0.9)
    this.sprite.position.x = -19
    this.sprite.position.y = -8
  }

  getType() {
    return Protocol.definition().BuildingType.PoliceSuit
  }

  getConstantsTable() {
    return "Equipments.PoliceSuit"
  }


}

module.exports = PoliceSuit

},{"./../../../../../common/constants.json":656,"./../../../../../common/util/protocol":686,"./armor_equipment":357}],364:[function(require,module,exports){
const ArmorEquipment = require("./armor_equipment")
const Constants = require("./../../../../../common/constants.json")
const Protocol = require("./../../../../../common/util/protocol")

class PrisonerSuit extends ArmorEquipment {

  getSpritePath() {
    return 'prisoner_suit.png'
  }

  repositionSprite() {
    super.repositionSprite()
    this.sprite.scale.set(0.9)
    this.sprite.position.x = -12
    this.sprite.position.y = -10
  }

  getType() {
    return Protocol.definition().BuildingType.PrisonerSuit
  }

  getConstantsTable() {
    return "Equipments.PrisonerSuit"
  }


}

module.exports = PrisonerSuit

},{"./../../../../../common/constants.json":656,"./../../../../../common/util/protocol":686,"./armor_equipment":357}],365:[function(require,module,exports){
const ArmorEquipment = require("./armor_equipment")
const Constants = require("./../../../../../common/constants.json")
const Protocol = require("./../../../../../common/util/protocol")

class SantaHat extends ArmorEquipment {

  getSpritePath() {
    return 'santa_hat.png'
  }

  repositionSprite() {
    this.sprite.width = 50
    this.sprite.height = 50
    this.sprite.position.x = 0
    this.sprite.position.y = 20
    this.sprite.rotation = -Math.PI/2
  }

  getType() {
    return Protocol.definition().BuildingType.SantaHat
  }

  getConstantsTable() {
    return "Equipments.SantaHat"
  }

}

module.exports = SantaHat
},{"./../../../../../common/constants.json":656,"./../../../../../common/util/protocol":686,"./armor_equipment":357}],366:[function(require,module,exports){
const ArmorEquipment = require("./armor_equipment")
const Constants = require("./../../../../../common/constants.json")
const Protocol = require("./../../../../../common/util/protocol")

class SpaceSuit extends ArmorEquipment {

  getSpritePath() {
    return 'space_helmet_2.png'
  }

  repositionSprite() {
    this.sprite.position.x = 18
    this.sprite.position.y = 12

    if (this.game.isCanvasMode()) {
      this.sprite.rotation = -Math.PI/2
      this.sprite.scale.set(0.7)
      this.sprite.position.x = 12
      this.sprite.position.y = 20
    }
  }

  onPostEquip() {
    super.onPostEquip()

    this.updateHandsColor()
  }

  updateHandsColor() {
    let color = this.data.instance.content || this.content || "gray"

    if (this.user && this.user.isPlayer() && color !== 'gray') {
      this.user.hands.tint = 0x666666
      this.user.leftHand.tint = 0x666666
      this.user.rightHand.tint = 0x666666
    } else {
      this.user.hands.tint = 0xd2b48c
      this.user.leftHand.tint = 0xd2b48c
      this.user.rightHand.tint = 0xd2b48c
    }
  }

  remove() {
    super.remove()

    if (this.user && this.user.isPlayer()) {
      this.user.hands.tint = 0xd2b48c
      this.user.leftHand.tint = 0xd2b48c
      this.user.rightHand.tint = 0xd2b48c
    }
  }

  getBaseSpritePath() {
    return 'space_helmet_base.png'
  }

  getEyeSpritePath() {
    return 'space_helmet_eye.png'
  }

  onContentChanged() {
    if (this.content) {
      let texture = this.game.armorTextures[this.content]
      if (texture) {
        this.sprite.texture = texture
      }

      let colorIndex = Constants.SuitColors[this.content].index
      this.game.suitColorMenu.setColorIndex(colorIndex)

      this.updateHandsColor()
    }
  }

  getSprite() {
    // return this.game.getPlainArmorSprite()
    let color = "gray"
    if (this.data.instance.content) {
      color = this.data.instance.content
    }

    let sprite = new PIXI.Sprite(this.game.armorTextures[color])
    return sprite
  }

  hasOxygen() {
    return true
  }

  getType() {
    return Protocol.definition().BuildingType.SpaceSuit
  }

  getConstantsTable() {
    return "Equipments.SpaceSuit"
  }

}

module.exports = SpaceSuit
},{"./../../../../../common/constants.json":656,"./../../../../../common/util/protocol":686,"./armor_equipment":357}],367:[function(require,module,exports){
const BaseEntity  = require("./../base_entity")
const Constants = require("./../../../../common/constants.json")
const Protocol = require("./../../../../common/util/protocol")
const tinycolor = require("tinycolor2")

class BaseEquipment extends BaseEntity {
  constructor(game, data) {
    data.x = 0
    data.y = 0

    super(game, data)

    this.user   = data.user
    this.content = data.instance ? data.instance.content : null

    if (!this.getConstants().sprite) {
      // if we dont have custom sprite positioning in constants.json
      this.repositionSprite()
    }

  }

  animate() {
    
  }

  onPostEquip() {

  }

  stopAnimation() {
    
  }

  isUnbreakable() {
    return this.getConstants().isUnbreakable
  }

  shouldShowUsage() {
    return this.getConstants().shouldShowUsage
  }

  syncWithServer(data) {
    if (data.instance) {
      if (this.content !== data.instance.content) {
        this.content = data.instance.content
        this.onContentChanged()
      }
    }
  }

  onContentChanged() {
    
  }

  getUsageCapacity() {
    return this.getStats().usageCapacity || 100
  }

  shouldNotInteractBuildings() {
    return false
  }

  getLightColor() {
    return this.getConstants().lightColor
  }

  isWeapon() {
    return false
  }

  static isUsable() {
    return true
  }

  static getSellGroup() {
    return "Equipments"
  }

  getTypeName() {
    return this.getConstantName().replace(/([A-Z])/g, ' $1').trim() // space before capital letters
  }

  getConstantName() {
    const type = this.getType()
    let targetKlassName = ""
    const nameToTypeMap = Protocol.definition().BuildingType

    for (let name in nameToTypeMap) {
      if (nameToTypeMap[name] === type) {
        targetKlassName = name
        break
      }
    }

    return targetKlassName
  }

  static getConstantName() {
    return this.prototype.getConstantName()
  }

  isMiningEquipment() {
    return false
  }

  getSpriteContainer() {
    return this.data.user.characterSprite
  }

  static build(game, data) {
    return new this(game, data)
  }

  getType() {
    throw new Error("must implement BaseEquipment.getType")
  }

}

module.exports = BaseEquipment

},{"./../../../../common/constants.json":656,"./../../../../common/util/protocol":686,"./../base_entity":206,"tinycolor2":172}],368:[function(require,module,exports){
const MeleeEquipment = require("./melee_equipment")
const Constants = require("./../../../../../common/constants.json")
const Protocol = require("./../../../../../common/util/protocol")

class AssassinsKnife extends MeleeEquipment {

  onPostEquip() {
    this.sprite.texture = PIXI.utils.TextureCache['radio.png']
    this.sprite.rotation = Math.PI/2
    this.sprite.position.x = 70
    this.sprite.position.y = 20
  }
 
  onAttackAnimationStart() {
    this.sprite.texture = PIXI.utils.TextureCache['assassins_knife.png']
    this.sprite.rotation = 0
    this.sprite.position.x = 30
    this.sprite.position.y = 0
  }

  onAttackAnimationComplete() {
    this.sprite.texture = PIXI.utils.TextureCache['radio.png']
    this.sprite.rotation = Math.PI/2
    this.sprite.position.x = 70
    this.sprite.position.y = 20
  }
 
  getSpritePath() {
    return 'assassins_knife.png'
  }

  getType() {
    return Protocol.definition().BuildingType.AssassinsKnife
  }

  getConstantsTable() {
    return "Equipments.AssassinsKnife"
  }

}

module.exports = AssassinsKnife

},{"./../../../../../common/constants.json":656,"./../../../../../common/util/protocol":686,"./melee_equipment":387}],369:[function(require,module,exports){
const RangeEquipment = require("./range_equipment")
const Constants = require("./../../../../../common/constants.json")
const Protocol = require("./../../../../../common/util/protocol")

class AssaultRifle extends RangeEquipment {

  repositionSprite() {
    super.repositionSprite()

    this.sprite.position.x = 20
  }

  getSpritePath() {
    return 'assault_rifle.png'
  }

  getType() {
    return Protocol.definition().BuildingType.AssaultRifle
  }

  getConstantsTable() {
    return "Equipments.AssaultRifle"
  }

}

module.exports = AssaultRifle

},{"./../../../../../common/constants.json":656,"./../../../../../common/util/protocol":686,"./range_equipment":397}],370:[function(require,module,exports){
const Bottle = require('./bottle')
const Constants = require("./../../../../../common/constants.json")
const Protocol = require("./../../../../../common/util/protocol")


class BloodBottle extends Bottle {
  getSpritePath() {
    return 'blood_bottle.png'
  }
  
  getTypeName() {
    return this.getConstantName().replace(/([A-Z])/g, ' $1').trim() // space before capital letters
  }

  getType() {
    return Protocol.definition().BuildingType.BloodBottle
  }

  getConstantsTable() {
    return "Equipments.BloodBottle"
  }

}

module.exports = BloodBottle
},{"./../../../../../common/constants.json":656,"./../../../../../common/util/protocol":686,"./bottle":372}],371:[function(require,module,exports){
const EnergySword = require("./energy_sword")
const Constants = require("./../../../../../common/constants.json")
const Protocol = require("./../../../../../common/util/protocol")

class BlueEnergySword extends EnergySword {

  getSpritePath() {
    return 'blue_energy_sword.png'
  }

  getType() {
    return Protocol.definition().BuildingType.BlueEnergySword
  }

  getConstantsTable() {
    return "Equipments.BlueEnergySword"
  }

}

module.exports = BlueEnergySword

},{"./../../../../../common/constants.json":656,"./../../../../../common/util/protocol":686,"./energy_sword":378}],372:[function(require,module,exports){
const MeleeEquipment = require("./melee_equipment")
const Constants = require("./../../../../../common/constants.json")
const Protocol = require("./../../../../../common/util/protocol")
const ClientHelper = require("./../../../util/client_helper")

class Bottle extends MeleeEquipment {

  constructor(game, data) {
    super(game, data)

    if (this.content) {
      this.applyContentTint()
    }
  }

  repositionSprite() {
    this.sprite.position.x = 45
    this.sprite.position.y = 20
    this.sprite.rotation = 35 * Math.PI/180
  }

  getSprite() {
    let sprite = new PIXI.Container()
    sprite.name = "Bottle"

    this.bottleContent = new PIXI.Sprite(PIXI.utils.TextureCache["white.png"])
    this.bottleContent.name = "Content"
    this.bottleContent.alpha = 1
    this.bottleContent.width = 18
    this.bottleContent.height = 20
    this.bottleContent.position.x = 3
    this.bottleContent.position.y = 6
    this.bottleContent.alpha = 0
    sprite.addChild(this.bottleContent)

    let bottleContainer = new PIXI.Sprite(PIXI.utils.TextureCache[this.getSpritePath()])
    bottleContainer.name = "Container"
    sprite.addChild(bottleContainer)

    return sprite
  }

  onContentChanged() {
    if (this.content) {
      this.applyContentTint()
    } else {
      this.removeContentTint()
    }
  }

  applyContentTint() {
    let tint = ClientHelper.getTintForSample(this.content)
    this.bottleContent.tint = tint
    this.bottleContent.alpha = 1
  }

  removeContentTint() {
    this.bottleContent.tint = 0xffffff
    this.bottleContent.alpha = 0
  }

  getTypeName(content) {
    let name = super.getTypeName()

    if (content) {
      return content + " " + name
    } else {
      return name
    }
  }

  static getDescription(content) {
    if (content === "Water") {
      return i18n.t('WaterBottle.Description')
    } else {
      return super.getDescription()
    }
  }

  getSpritePath() {
    return 'bottle.png'
  }

  getType() {
    return Protocol.definition().BuildingType.Bottle
  }

  getConstantsTable() {
    return "Equipments.Bottle"
  }

  getSVG(content) {
    const tint = content ? "#" + ClientHelper.getTintForSample(content).toString(16) : "none"

    return `
      <?xml version="1.0" encoding="UTF-8" standalone="no"?>
      <svg id="svg2" xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#" xmlns="http://www.w3.org/2000/svg" height="76.631mm" width="63.517mm" version="1.1" xmlns:cc="http://creativecommons.org/ns#" xmlns:dc="http://purl.org/dc/elements/1.1/" viewBox="0 0 225.06097 271.52799">
        <metadata id="metadata7">
         <rdf:RDF>
          <cc:Work rdf:about="">
           <dc:format>image/svg+xml</dc:format>
           <dc:type rdf:resource="http://purl.org/dc/dcmitype/StillImage"/>
           <dc:title/>
          </cc:Work>
         </rdf:RDF>
        </metadata>
        <g id="layer1" transform="translate(-251.63 -193.83)">
         <rect id="rect8070" ry="32.325" height="208.09" width="179.81" stroke="#000" y="247.27" x="274.76" stroke-width="20" fill="${tint}"/>
         <rect id="rect8072" ry="21.213" height="42.426" width="205.06" stroke="#000" y="203.83" x="261.63" stroke-width="20" fill="#6e583a"/>
         <rect id="rect8074" ry="12.627" height="98.995" width="25.254" y="284.65" x="400.05" fill="#fff"/>
        </g>
      </svg>
    `.trim()
  }

}

module.exports = Bottle

},{"./../../../../../common/constants.json":656,"./../../../../../common/util/protocol":686,"./../../../util/client_helper":649,"./melee_equipment":387}],373:[function(require,module,exports){
const MeleeEquipment = require("./melee_equipment")
const Constants = require("../../../../../common/constants.json")
const Protocol = require("../../../../../common/util/protocol")

class Bowl extends MeleeEquipment {

  getSpritePath() {
    return 'bowl_by_px.png'
  }

  getType() {
    return Protocol.definition().BuildingType.Bowl
  }

  getConstantsTable() {
    return "Equipments.Bowl"
  }

}

module.exports = Bowl

},{"../../../../../common/constants.json":656,"../../../../../common/util/protocol":686,"./melee_equipment":387}],374:[function(require,module,exports){
const RangeEquipment = require("./range_equipment")
const Constants = require("../../../../../common/constants.json")
const Protocol = require("../../../../../common/util/protocol")

class Deconstructor extends RangeEquipment {

  getSpritePath() {
    return 'deconstructor.png'
  }

  getType() {
    return Protocol.definition().BuildingType.Deconstructor
  }

  getConstantsTable() {
    return "Equipments.Deconstructor"
  }

  

}

module.exports = Deconstructor

},{"../../../../../common/constants.json":656,"../../../../../common/util/protocol":686,"./range_equipment":397}],375:[function(require,module,exports){
const RangeEquipment = require("./range_equipment")
const Constants = require("./../../../../../common/constants.json")
const Protocol = require("./../../../../../common/util/protocol")
const ClientHelper = require("./../../../util/client_helper")


class Disinfectant extends RangeEquipment {

  repositionSprite() {
    super.repositionSprite()

    this.sprite.position.x = 30
  }

  getSpritePath() {
    return 'disinfectant.png'
  }

  getType() {
    return Protocol.definition().BuildingType.Disinfectant
  }

  getConstantsTable() {
    return "Equipments.Disinfectant"
  }

}

module.exports = Disinfectant

},{"./../../../../../common/constants.json":656,"./../../../../../common/util/protocol":686,"./../../../util/client_helper":649,"./range_equipment":397}],376:[function(require,module,exports){
const MeleeEquipment = require("./melee_equipment")
const Constants = require("./../../../../../common/constants.json")
const Protocol = require("./../../../../../common/util/protocol")

class Drill extends MeleeEquipment {

  repositionSprite() {
    this.sprite.position.x = 40
    this.sprite.position.y = 35
  }

  isMiningEquipment() {
    return true
  }

  shouldNotInteractBuildings() {
    return false
  }

  getSpritePath() {
    return 'drill.png'
  }

  getType() {
    return Protocol.definition().BuildingType.Drill
  }

  getConstantsTable() {
    return "Equipments.Drill"
  }

}

module.exports = Drill

},{"./../../../../../common/constants.json":656,"./../../../../../common/util/protocol":686,"./melee_equipment":387}],377:[function(require,module,exports){
const MeleeEquipment = require("./melee_equipment")
const Constants = require("./../../../../../common/constants.json")
const Protocol = require("./../../../../../common/util/protocol")

class Dynamite extends MeleeEquipment {

  getSpritePath() {
    return 'dynamite.png'
  }

  repositionSprite() {
    this.sprite.position.x = 50
    this.sprite.position.y = 30
    this.sprite.rotation = 35 * Math.PI/180
  }

  getAnimationTween() {
    let fireSprite = new PIXI.Sprite(PIXI.utils.TextureCache["flame_2.png"])
    fireSprite.width = Constants.tileSize/2
    fireSprite.height = Constants.tileSize/2
    fireSprite.position.x = 55
    fireSprite.position.y = 0
    fireSprite.rotation = 35 * Math.PI / 180
    fireSprite.alpha = 0

    this.sprite.parent.addChild(fireSprite)

    window.f = fireSprite

    let alpha = { alpha: 0 }

    return new TWEEN.Tween(alpha)
            .to({ alpha: 1  }, 200)
            .onUpdate(() => {
              fireSprite.alpha = alpha.alpha
            })
            .onComplete(() => {
              if (fireSprite.parent) {
                fireSprite.parent.removeChild(fireSprite)
              }
            })
  }

  getType() {
    return Protocol.definition().BuildingType.Dynamite
  }

  getConstantsTable() {
    return "Equipments.Dynamite"
  }

}

module.exports = Dynamite

},{"./../../../../../common/constants.json":656,"./../../../../../common/util/protocol":686,"./melee_equipment":387}],378:[function(require,module,exports){
const MeleeEquipment = require("./melee_equipment")
const Constants = require("./../../../../../common/constants.json")
const Protocol = require("./../../../../../common/util/protocol")

class EnergySword extends MeleeEquipment {

  playSound() {
    let sound = Math.random() < 0.5 ? "saber_one" : "saber_two"

    this.game.playSound(sound)
  }

}

module.exports = EnergySword

},{"./../../../../../common/constants.json":656,"./../../../../../common/util/protocol":686,"./melee_equipment":387}],379:[function(require,module,exports){
const RangeEquipment = require("./range_equipment")
const Constants = require("./../../../../../common/constants.json")
const Protocol = require("./../../../../../common/util/protocol")
const ClientHelper = require("./../../../util/client_helper")


class FireExtinguisher extends RangeEquipment {

  repositionSprite() {
    super.repositionSprite()

    this.sprite.position.x = 30
  }

  getSpritePath() {
    return 'fire_extinguisher.png'
  }

  getType() {
    return Protocol.definition().BuildingType.FireExtinguisher
  }

  getConstantsTable() {
    return "Equipments.FireExtinguisher"
  }

}

module.exports = FireExtinguisher

},{"./../../../../../common/constants.json":656,"./../../../../../common/util/protocol":686,"./../../../util/client_helper":649,"./range_equipment":397}],380:[function(require,module,exports){
const RangeEquipment = require("./range_equipment")
const Constants = require("./../../../../../common/constants.json")
const Protocol = require("./../../../../../common/util/protocol")
const ClientHelper = require("./../../../util/client_helper")


class FlameThrower extends RangeEquipment {

  repositionSprite() {
    super.repositionSprite()

    this.sprite.position.x = 30
  }

  getSpritePath() {
    return 'flame_thrower.png'
  }

  getType() {
    return Protocol.definition().BuildingType.FlameThrower
  }

  getConstantsTable() {
    return "Equipments.FlameThrower"
  }

}

module.exports = FlameThrower

},{"./../../../../../common/constants.json":656,"./../../../../../common/util/protocol":686,"./../../../util/client_helper":649,"./range_equipment":397}],381:[function(require,module,exports){
const EnergySword = require("./energy_sword")
const Constants = require("./../../../../../common/constants.json")
const Protocol = require("./../../../../../common/util/protocol")

class GreenEnergySword extends EnergySword {

  getSpritePath() {
    return 'green_energy_sword.png'
  }

  getType() {
    return Protocol.definition().BuildingType.GreenEnergySword
  }

  getConstantsTable() {
    return "Equipments.GreenEnergySword"
  }

}

module.exports = GreenEnergySword

},{"./../../../../../common/constants.json":656,"./../../../../../common/util/protocol":686,"./energy_sword":378}],382:[function(require,module,exports){
const MeleeEquipment = require("./melee_equipment")
const Constants = require("./../../../../../common/constants.json")
const Protocol = require("./../../../../../common/util/protocol")

class Grenade extends MeleeEquipment {

  getSpritePath() {
    return 'grenade.png'
  }

  repositionSprite() {
    this.sprite.position.x = 50
    this.sprite.position.y = 30
    this.sprite.rotation = 35 * Math.PI/180
  }

  getAnimationTween() {
    let fireSprite = new PIXI.Sprite(PIXI.utils.TextureCache["flame_2.png"])
    fireSprite.width = Constants.tileSize/2
    fireSprite.height = Constants.tileSize/2
    fireSprite.position.x = 55
    fireSprite.position.y = 0
    fireSprite.rotation = 35 * Math.PI / 180
    fireSprite.alpha = 0

    this.sprite.parent.addChild(fireSprite)

    window.f = fireSprite

    let alpha = { alpha: 0 }

    return new TWEEN.Tween(alpha)
            .to({ alpha: 1  }, 200)
            .onUpdate(() => {
              fireSprite.alpha = alpha.alpha
            })
            .onComplete(() => {
              if (fireSprite.parent) {
                fireSprite.parent.removeChild(fireSprite)
              }
            })
  }

  getType() {
    return Protocol.definition().BuildingType.Grenade
  }

  getConstantsTable() {
    return "Equipments.Grenade"
  }

}

module.exports = Grenade

},{"./../../../../../common/constants.json":656,"./../../../../../common/util/protocol":686,"./melee_equipment":387}],383:[function(require,module,exports){
const BaseEquipment = require("./../base_equipment")

class HandEquipment extends BaseEquipment {
  getSpriteContainer() {
    return this.data.user.handEquipContainer
  }

  playSound() {
    if (this.hasCategory("melee_damage")) {
      this.game.playSound("melee_damage")
    }
  }

  isWeapon() {
    return true
  }

  repositionSprite() {
    this.sprite.anchor.set(0)

    this.sprite.position.x = 45
    this.sprite.position.y = 32
  }
}

module.exports = HandEquipment
},{"./../base_equipment":367}],384:[function(require,module,exports){
const MeleeEquipment = require("./melee_equipment")
const Constants = require("./../../../../../common/constants.json")
const Protocol = require("./../../../../../common/util/protocol")

class Katana extends MeleeEquipment {

  getSpritePath() {
    return 'katana_reskin.png'
  }

  getType() {
    return Protocol.definition().BuildingType.Katana
  }

  getConstantsTable() {
    return "Equipments.Katana"
  }

}

module.exports = Katana

},{"./../../../../../common/constants.json":656,"./../../../../../common/util/protocol":686,"./melee_equipment":387}],385:[function(require,module,exports){
const MeleeEquipment = require("./melee_equipment")
const Constants = require("./../../../../../common/constants.json")
const Protocol = require("./../../../../../common/util/protocol")

class LeadPipe extends MeleeEquipment {

  getSpritePath() {
    return 'lead_pipe.png'
  }

  getType() {
    return Protocol.definition().BuildingType.LeadPipe
  }

  getConstantsTable() {
    return "Equipments.LeadPipe"
  }

}

module.exports = LeadPipe

},{"./../../../../../common/constants.json":656,"./../../../../../common/util/protocol":686,"./melee_equipment":387}],386:[function(require,module,exports){
const MeleeEquipment = require("./melee_equipment")
const Constants = require("./../../../../../common/constants.json")
const Protocol = require("./../../../../../common/util/protocol")

class Lighter extends MeleeEquipment {

  getSpritePath() {
    return 'lighter.png'
  }

  repositionSprite() {
    this.sprite.position.x = 50
    this.sprite.position.y = 30
    this.sprite.rotation = 35 * Math.PI/180
  }

  getAnimationTween() {
    let fireSprite = new PIXI.Sprite(PIXI.utils.TextureCache["flame_2.png"])
    fireSprite.width = Constants.tileSize/2
    fireSprite.height = Constants.tileSize/2
    fireSprite.position.x = 55
    fireSprite.position.y = 0
    fireSprite.rotation = 35 * Math.PI / 180
    fireSprite.alpha = 0

    this.sprite.parent.addChild(fireSprite)

    window.f = fireSprite

    let alpha = { alpha: 0 }

    return new TWEEN.Tween(alpha)
            .to({ alpha: 1  }, 200)
            .onUpdate(() => {
              fireSprite.alpha = alpha.alpha
            })
            .onComplete(() => {
              if (fireSprite.parent) {
                fireSprite.parent.removeChild(fireSprite)
              }
            })
  }

  getType() {
    return Protocol.definition().BuildingType.Lighter
  }

  getConstantsTable() {
    return "Equipments.Lighter"
  }

}

module.exports = Lighter

},{"./../../../../../common/constants.json":656,"./../../../../../common/util/protocol":686,"./melee_equipment":387}],387:[function(require,module,exports){
const HandEquipment = require("./hand_equipment")

class MeleeEquipment extends HandEquipment {
  repositionSprite() {
    this.sprite.anchor.set(0)

    this.sprite.rotation = 90 * PIXI.DEG_TO_RAD

    if (!this.getConstants().sprite) {
      this.sprite.position.x = 50
    }


    this.user.openHands()
  }

  getAnimationTween() {
    let halfRotation = 90 * (Math.PI / 180)
    let startRotation = this.user.getRadAngle()
    let midRotation   = this.user.getRadAngle() - (halfRotation)
    let endRotation   = this.user.getRadAngle() - (halfRotation * 2)
    let rotation = { rotation: startRotation }

    const swing = new TWEEN.Tween(rotation)
        .to({ rotation: endRotation  }, 400)
        .onUpdate(() => {
          let progress = Math.abs(rotation.rotation - startRotation)
          if (progress > halfRotation) {
            let backIncrement = progress - halfRotation
            let backRotation = midRotation + backIncrement

            this.user.characterSprite.rotation = backRotation
          } else {
            this.user.characterSprite.rotation = rotation.rotation
          }
        })
        .onRepeatCycleComplete(() => {
          startRotation = this.user.getRadAngle()
          midRotation   = this.user.getRadAngle() - (halfRotation)
          endRotation   = this.user.getRadAngle() - (halfRotation * 2)
          rotation = { rotation: startRotation }

          swing._object = rotation
          swing._valuesEnd = { rotation: endRotation }

        })
        .onComplete(() => {
          this.user.characterSprite.rotation = this.user.getRadAngle()
          this.onAttackAnimationComplete()
        })
        .onStart(() => {
          this.onAttackAnimationStart()
        })



    return swing
  }

  animate() {
    this.getAnimationTween().start()
  }

  onAttackAnimationStart() {
    
  }

  onAttackAnimationComplete() {

  }


}

module.exports = MeleeEquipment

},{"./hand_equipment":383}],388:[function(require,module,exports){
const MeleeEquipment = require("./melee_equipment")
const Constants = require("./../../../../../common/constants.json")
const Protocol = require("./../../../../../common/util/protocol")

class MolotovCocktail extends MeleeEquipment {

  getSpritePath() {
    return 'molotov_cocktail.png'
  }

  repositionSprite() {
    this.sprite.position.x = 50
    this.sprite.position.y = 30
    this.sprite.rotation = 35 * Math.PI/180
  }

  getAnimationTween() {
    let fireSprite = new PIXI.Sprite(PIXI.utils.TextureCache["flame_2.png"])
    fireSprite.width = Constants.tileSize/2
    fireSprite.height = Constants.tileSize/2
    fireSprite.position.x = 55
    fireSprite.position.y = 0
    fireSprite.rotation = 35 * Math.PI / 180
    fireSprite.alpha = 0

    this.sprite.parent.addChild(fireSprite)

    window.f = fireSprite

    let alpha = { alpha: 0 }

    return new TWEEN.Tween(alpha)
            .to({ alpha: 1  }, 200)
            .onUpdate(() => {
              fireSprite.alpha = alpha.alpha
            })
            .onComplete(() => {
              if (fireSprite.parent) {
                fireSprite.parent.removeChild(fireSprite)
              }
            })
  }

  getType() {
    return Protocol.definition().BuildingType.MolotovCocktail
  }

  getConstantsTable() {
    return "Equipments.MolotovCocktail"
  }

}

module.exports = MolotovCocktail

},{"./../../../../../common/constants.json":656,"./../../../../../common/util/protocol":686,"./melee_equipment":387}],389:[function(require,module,exports){
const MeleeEquipment = require("./melee_equipment")
const Constants = require("./../../../../../common/constants.json")
const Protocol = require("./../../../../../common/util/protocol")

class Mop extends MeleeEquipment {

  repositionSprite() {
    super.repositionSprite()
    this.sprite.position.x = 55
  }

  getSpritePath() {
    return 'mop.png'
  }

  getType() {
    return Protocol.definition().BuildingType.Mop
  }

  getConstantsTable() {
    return "Equipments.Mop"
  }

}

module.exports = Mop

},{"./../../../../../common/constants.json":656,"./../../../../../common/util/protocol":686,"./melee_equipment":387}],390:[function(require,module,exports){
const MeleeEquipment = require("./melee_equipment")
const Constants = require("./../../../../../common/constants.json")
const Protocol = require("./../../../../../common/util/protocol")

class NameTag extends MeleeEquipment {

  getSpritePath() {
    return 'name_tag.png'
  }

  getType() {
    return Protocol.definition().BuildingType.NameTag
  }

  getConstantsTable() {
    return "Equipments.NameTag"
  }

}

module.exports = NameTag

},{"./../../../../../common/constants.json":656,"./../../../../../common/util/protocol":686,"./melee_equipment":387}],391:[function(require,module,exports){
const RangeEquipment = require("./range_equipment")
const Constants = require("./../../../../../common/constants.json")
const Protocol = require("./../../../../../common/util/protocol")

class Pistol extends RangeEquipment {

  getSpritePath() {
    return 'pistol.png'
  }

  getType() {
    return Protocol.definition().BuildingType.Pistol
  }

  getConstantsTable() {
    return "Equipments.Pistol"
  }

}

module.exports = Pistol

},{"./../../../../../common/constants.json":656,"./../../../../../common/util/protocol":686,"./range_equipment":397}],392:[function(require,module,exports){
const MeleeEquipment = require("./melee_equipment")
const Constants = require("./../../../../../common/constants.json")
const Protocol = require("./../../../../../common/util/protocol")

class PlasmaBlade extends MeleeEquipment {

  getSpritePath() {
    return 'plasma_blade.png'
  }

  getType() {
    return Protocol.definition().BuildingType.PlasmaBlade
  }

  getConstantsTable() {
    return "Equipments.PlasmaBlade"
  }

}

module.exports = PlasmaBlade

},{"./../../../../../common/constants.json":656,"./../../../../../common/util/protocol":686,"./melee_equipment":387}],393:[function(require,module,exports){
const RangeEquipment = require("./range_equipment")
const Constants = require("./../../../../../common/constants.json")
const Protocol = require("./../../../../../common/util/protocol")

class PlasmaGun extends RangeEquipment {

  repositionSprite() {
    super.repositionSprite()

    this.sprite.position.x = 8

    // this.sprite.position.x 
  }

  getSpritePath() {
    return 'plasma_gun.png'
  }

  getType() {
    return Protocol.definition().BuildingType.PlasmaGun
  }

  getConstantsTable() {
    return "Equipments.PlasmaGun"
  }

}

module.exports = PlasmaGun

},{"./../../../../../common/constants.json":656,"./../../../../../common/util/protocol":686,"./range_equipment":397}],394:[function(require,module,exports){
const RangeEquipment = require("./range_equipment")
const Constants = require("./../../../../../common/constants.json")
const Protocol = require("./../../../../../common/util/protocol")
const ClientHelper = require("./../../../util/client_helper")


class PocketTrader extends RangeEquipment {

  repositionSprite() {
    super.repositionSprite()

    this.sprite.position.x = 30
  }

  getSpritePath() {
    return 'pocket_trader.png'
  }

  getType() {
    return Protocol.definition().BuildingType.PocketTrader
  }

  getConstantsTable() {
    return "Equipments.PocketTrader"
  }

}

module.exports = PocketTrader

},{"./../../../../../common/constants.json":656,"./../../../../../common/util/protocol":686,"./../../../util/client_helper":649,"./range_equipment":397}],395:[function(require,module,exports){
const MeleeEquipment = require("./melee_equipment")
const Constants = require("./../../../../../common/constants.json")
const Protocol = require("./../../../../../common/util/protocol")

class PoisonGrenade extends MeleeEquipment {

  getSpritePath() {
    return 'poison_grenade.png'
  }

  repositionSprite() {
    this.sprite.position.x = 50
    this.sprite.position.y = 30
    this.sprite.rotation = 35 * Math.PI/180
  }

  getType() {
    return Protocol.definition().BuildingType.PoisonGrenade
  }

  getConstantsTable() {
    return "Equipments.PoisonGrenade"
  }

}

module.exports = PoisonGrenade

},{"./../../../../../common/constants.json":656,"./../../../../../common/util/protocol":686,"./melee_equipment":387}],396:[function(require,module,exports){
const RangeEquipment = require("./range_equipment")
const Constants = require("./../../../../../common/constants.json")
const Protocol = require("./../../../../../common/util/protocol")
const ClientHelper = require("./../../../util/client_helper")


class Radio extends RangeEquipment {

  repositionSprite() {
    super.repositionSprite()

    this.sprite.position.x = 30
  }

  getSpritePath() {
    return 'radio.png'
  }

  getType() {
    return Protocol.definition().BuildingType.Radio
  }

  getConstantsTable() {
    return "Equipments.Radio"
  }

}

module.exports = Radio

},{"./../../../../../common/constants.json":656,"./../../../../../common/util/protocol":686,"./../../../util/client_helper":649,"./range_equipment":397}],397:[function(require,module,exports){
const HandEquipment = require("./hand_equipment")

class RangeEquipment extends HandEquipment {
  repositionSprite() {
    this.sprite.anchor.set(0)

    this.sprite.position.x = 35
    this.sprite.position.y = 12

    this.user.closeHands()
  }

  getRange() {
    return this.getConstants().stats.range
  }

}

module.exports = RangeEquipment

},{"./hand_equipment":383}],398:[function(require,module,exports){
const EnergySword = require("./energy_sword")
const Constants = require("./../../../../../common/constants.json")
const Protocol = require("./../../../../../common/util/protocol")

class RedEnergySword extends EnergySword {

  getSpritePath() {
    return 'red_energy_sword.png'
  }

  getType() {
    return Protocol.definition().BuildingType.RedEnergySword
  }

  getConstantsTable() {
    return "Equipments.RedEnergySword"
  }

}

module.exports = RedEnergySword

},{"./../../../../../common/constants.json":656,"./../../../../../common/util/protocol":686,"./energy_sword":378}],399:[function(require,module,exports){
const RangeEquipment = require("./range_equipment")
const Constants = require("./../../../../../common/constants.json")
const Protocol = require("./../../../../../common/util/protocol")

class RocketLauncher extends RangeEquipment {

  repositionSprite() {
    super.repositionSprite()

    // this.sprite.position.x 
  }

  getSpritePath() {
    return 'rocket_launcher.png'
  }

  getType() {
    return Protocol.definition().BuildingType.RocketLauncher
  }

  getConstantsTable() {
    return "Equipments.RocketLauncher"
  }

}

module.exports = RocketLauncher

},{"./../../../../../common/constants.json":656,"./../../../../../common/util/protocol":686,"./range_equipment":397}],400:[function(require,module,exports){

const RangeEquipment = require("./range_equipment")
const Constants = require("./../../../../../common/constants.json")
const Protocol = require("./../../../../../common/util/protocol")

class Scar17 extends RangeEquipment {

  repositionSprite() {
    super.repositionSprite()

    this.sprite.position.x = 20
  }

  getSpritePath() {
    return 'scar_17_by_px.png'
  }

  getType() {
    return Protocol.definition().BuildingType.Scar17
  }

  getConstantsTable() {
    return "Equipments.Scar17"
  }

}

module.exports = Scar17

},{"./../../../../../common/constants.json":656,"./../../../../../common/util/protocol":686,"./range_equipment":397}],401:[function(require,module,exports){
const RangeEquipment = require("./range_equipment")
const Constants = require("./../../../../../common/constants.json")
const Protocol = require("./../../../../../common/util/protocol")

class Shotgun extends RangeEquipment {

  getSpritePath() {
    return 'shotgun.png'
  }

  getType() {
    return Protocol.definition().BuildingType.Shotgun
  }

  getConstantsTable() {
    return "Equipments.Shotgun"
  }

}

module.exports = Shotgun

},{"./../../../../../common/constants.json":656,"./../../../../../common/util/protocol":686,"./range_equipment":397}],402:[function(require,module,exports){
const RangeEquipment = require("./range_equipment")
const Constants = require("./../../../../../common/constants.json")
const Protocol = require("./../../../../../common/util/protocol")

class SquidStaff extends RangeEquipment {

  repositionSprite() {
    super.repositionSprite()

    // this.sprite.position.x 
  }

  getSpritePath() {
    return 'squid_staff.png'
  }

  getType() {
    return Protocol.definition().BuildingType.SquidStaff
  }

  getConstantsTable() {
    return "Equipments.SquidStaff"
  }

}

module.exports = SquidStaff

},{"./../../../../../common/constants.json":656,"./../../../../../common/util/protocol":686,"./range_equipment":397}],403:[function(require,module,exports){
const MeleeEquipment = require("./melee_equipment")
const Constants = require("./../../../../../common/constants.json")
const Protocol = require("./../../../../../common/util/protocol")

class SurvivalTool extends MeleeEquipment {

  repositionSprite() {
    this.sprite.position.x = 40
    this.sprite.position.y = 35
  }

  isMiningEquipment() {
    return true
  }

  shouldNotInteractBuildings() {
    return false
  }


  getSpritePath() {
    return 'mining_gun.png'
  }

  getType() {
    return Protocol.definition().BuildingType.SurvivalTool
  }

  getConstantsTable() {
    return "Equipments.SurvivalTool"
  }

}

module.exports = SurvivalTool

},{"./../../../../../common/constants.json":656,"./../../../../../common/util/protocol":686,"./melee_equipment":387}],404:[function(require,module,exports){
const RangeEquipment = require("./range_equipment")
const Constants = require("./../../../../../common/constants.json")
const Protocol = require("./../../../../../common/util/protocol")
const ClientHelper = require("./../../../util/client_helper")

class Syringe extends RangeEquipment {

  constructor(game, data) {
    super(game, data)

    this.applyContentTint()
  }

  applyContentTint() {
    let tint = ClientHelper.getTintForSample(this.content)
    this.sprite.tint = tint
  }

  getTypeName(content) {
    let name = super.getTypeName()

    if (content) {
      if (content === "PoisonSpider") {
        return "Poison " + name
      } else {
        return content + " blood " + name
      }
    } else {
      return name
    }
  }

  static getDescription(content) {
    let description = this.getConstants().description

    if (content) {
      switch (content) {
        case "Player":
          description = Constants.Player.syringeDescription
          break
        case "PoisonSpider":
          description = Constants.Mobs.PoisonSpider.syringeDescription
          break
        default:
          description = "Unknown sample"
      }
    }

    return description
  }

  static isUsable() {
    return false // not immediately usable. needs a target
  }

  getSpritePath() {
    return 'syringe.png'
  }

  getType() {
    return Protocol.definition().BuildingType.Syringe
  }

  getConstantsTable() {
    return "Equipments.Syringe"
  }

  getSVG(content) {
    let tint = "#e5e5e5"

    if (content) {
      let tintValue = ClientHelper.getTintForSample(content)
      tint = ClientHelper.toHex(tintValue)
    }

    return `
      <svg id="svg2" xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#" xmlns="http://www.w3.org/2000/svg" height="92.148mm" width="54.025mm" version="1.1" xmlns:cc="http://creativecommons.org/ns#" xmlns:dc="http://purl.org/dc/elements/1.1/" viewBox="0 0 191.42858 326.50859">
       <metadata id="metadata7">
        <rdf:RDF>
         <cc:Work rdf:about="">
          <dc:format>image/svg+xml</dc:format>
          <dc:type rdf:resource="http://purl.org/dc/dcmitype/StillImage"/>
          <dc:title/>
         </cc:Work>
        </rdf:RDF>
       </metadata>
       <g id="layer1" transform="translate(-204.29 -50.854)" stroke="#000" stroke-width="20">
        <path id="path8074" d="m298.57 353.08c-0.71428-12.143 0-101.43 0-101.43" fill="none"/>
        <rect id="rect8068" height="127.86" width="77.143" y="161.65" x="262.14" fill="${tint}"/>
        <rect id="rect8070" height="35" width="171.43" y="332.36" x="214.29" fill="${tint}"/>
        <path id="path8072" d="m298.57 152.36c-0.71428-12.143 0-101.43 0-101.43" fill="none"/>
       </g>
      </svg>
    `.trim()
  }

}

module.exports = Syringe

},{"./../../../../../common/constants.json":656,"./../../../../../common/util/protocol":686,"./../../../util/client_helper":649,"./range_equipment":397}],405:[function(require,module,exports){
const Bottle = require('./bottle')
const Constants = require("./../../../../../common/constants.json")
const Protocol = require("./../../../../../common/util/protocol")


class WaterBottle extends Bottle {
  getSpritePath() {
    return 'water_bottle.png'
  }
  
  getTypeName() {
    return this.getConstantName().replace(/([A-Z])/g, ' $1').trim() // space before capital letters
  }

  getType() {
    return Protocol.definition().BuildingType.WaterBottle
  }

  getConstantsTable() {
    return "Equipments.WaterBottle"
  }

}

module.exports = WaterBottle
},{"./../../../../../common/constants.json":656,"./../../../../../common/util/protocol":686,"./bottle":372}],406:[function(require,module,exports){
const MeleeEquipment = require("./melee_equipment")
const Constants = require("./../../../../../common/constants.json")
const Protocol = require("./../../../../../common/util/protocol")
const ClientHelper = require("./../../../util/client_helper")


class Wrench extends MeleeEquipment {

  repositionSprite() {
    super.repositionSprite()
  }

  getSpritePath() {
    return 'wrench.png'
  }

  getType() {
    return Protocol.definition().BuildingType.Wrench
  }

  getConstantsTable() {
    return "Equipments.Wrench"
  }

  getAnimationTween() {
    let halfRotation = 90 * (Math.PI / 180)
    let userRotation = Math.PI/2
    let startRotation = userRotation
    let midRotation   = userRotation - (halfRotation)
    let endRotation   = userRotation - (halfRotation * 2)
    let rotation = { rotation: startRotation }

    const swing = new TWEEN.Tween(rotation)
        .to({ rotation: endRotation  }, 400)
        .onUpdate(() => {
          let progress = Math.abs(rotation.rotation - startRotation)
          if (progress > halfRotation) {
            let backIncrement = progress - halfRotation
            let backRotation = midRotation + backIncrement

            this.sprite.rotation = backRotation
          } else {
            this.sprite.rotation = rotation.rotation
          }
        })
        .onRepeatCycleComplete(() => {
          let userRotation = Math.PI/2

          startRotation = userRotation
          midRotation   = userRotation - (halfRotation)
          endRotation   = userRotation - (halfRotation * 2)
          rotation = { rotation: startRotation }

          swing._object = rotation
          swing._valuesEnd = { rotation: endRotation }

        })
        .onComplete(() => {
          this.sprite.rotation = startRotation
        })



    return swing
  }

}

module.exports = Wrench

},{"./../../../../../common/constants.json":656,"./../../../../../common/util/protocol":686,"./../../../util/client_helper":649,"./melee_equipment":387}],407:[function(require,module,exports){
const Helper = require("./../../../../common/helper")
const BaseEquipment = require("./base_equipment")
const MeleeEquipment = require("./hand/melee_equipment")
const Constants = require("./../../../../common/constants.json")

const Equipments = {}
Equipments.LeadPipe = require("./hand/lead_pipe")
Equipments.PlasmaBlade = require("./hand/plasma_blade")
Equipments.Mop = require("./hand/mop")
Equipments.Pistol = require("./hand/pistol")
Equipments.Shotgun = require("./hand/shotgun")
Equipments.AssaultRifle = require("./hand/assault_rifle")
Equipments.Scar17 = require("./hand/scar_17")
Equipments.FlameThrower = require("./hand/flame_thrower")
Equipments.PlasmaGun = require("./hand/plasma_gun")
Equipments.RocketLauncher = require("./hand/rocket_launcher")
Equipments.SquidStaff = require("./hand/squid_staff")
Equipments.FireExtinguisher = require("./hand/fire_extinguisher")
Equipments.Syringe = require("./hand/syringe")
Equipments.Bottle = require("./hand/bottle")
Equipments.BloodBottle = require("./hand/blood_bottle")
Equipments.WaterBottle = require("./hand/water_bottle")
Equipments.Disinfectant = require("./hand/disinfectant")
Equipments.Lighter = require("./hand/lighter")
Equipments.Wrench = require("./hand/wrench")
Equipments.SurvivalTool = require("./hand/survival_tool")
Equipments.Drill = require("./hand/drill")
Equipments.Katana = require("./hand/katana")
Equipments.BlueEnergySword = require("./hand/blue_energy_sword")
Equipments.GreenEnergySword = require("./hand/green_energy_sword")
Equipments.RedEnergySword = require("./hand/red_energy_sword")
Equipments.MolotovCocktail = require("./hand/molotov_cocktail")
Equipments.Grenade = require("./hand/grenade")
Equipments.PoisonGrenade = require("./hand/poison_grenade")
Equipments.NameTag = require("./hand/name_tag")
Equipments.Radio = require("./hand/radio")
Equipments.AssassinsKnife = require("./hand/assassins_knife")
Equipments.PocketTrader = require("./hand/pocket_trader")
Equipments.Bowl = require("./hand/bowl")
Equipments.Deconstructor = require('./hand/deconstructor')
Equipments.Dynamite = require('./hand/dynamite')

Equipments.SpaceSuit = require("./armor/space_suit")
Equipments.CombatArmor = require("./armor/combat_armor")
Equipments.SantaHat = require("./armor/santa_hat")
Equipments.HazmatSuit = require("./armor/hazmat_suit")
Equipments.PrisonerSuit = require("./armor/prisoner_suit")
Equipments.PoliceSuit = require("./armor/police_suit")
Equipments.LabCoat = require("./armor/lab_coat")
Equipments.CultistSuit = require("./armor/cultist_suit")
Equipments.ImperialSpecialForcesArmor = require("./armor/imperial_special_forces_armor")

Equipments.forType = (type) => {
  const klassName = Helper.getTypeNameById(type)
  return Equipments[klassName]
}

const craftExcludeList = ["Syringe", "StunBaton", "MolotovCocktail", "Grenade", "PoisonGrenade", "BloodBottle", "CombatArmor", "WaterBottle", "NameTag", "SpaceSuit", "BlueEnergySword", "GreenEnergySword", "RedEnergySword", "Katana", "Radio", "AssassinsKnife", "SantaHat", "HazmatSuit", "PoliceSuit", "PrisonerSuit", "LabCoat", "CultistSuit", "ImperialSpecialForcesArmor", "Dynamite"]

Equipments.getList = () => {
  return Object.values(Equipments).filter((klass) => {
    return typeof klass.getType === "function" && craftExcludeList.indexOf(klass.getConstantName()) === -1
  })
}

// dynamically create klasses
for (let name in Constants.Equipments) {
  if (!Equipments[name]) {
    let data = Constants.Equipments[name]
    if (!data.abstract) {
      if (data.parent.match("MeleeEquipment")) {
        Equipments[name] = Helper.createDynamicKlass("Equipments", MeleeEquipment, name) 
      } else {
        Equipments[name] = Helper.createDynamicKlass("Equipments", BaseEquipment, name) 
      }
    }
  }
}



module.exports = Equipments

},{"./../../../../common/constants.json":656,"./../../../../common/helper":664,"./armor/combat_armor":358,"./armor/cultist_suit":359,"./armor/hazmat_suit":360,"./armor/imperial_special_forces_armor":361,"./armor/lab_coat":362,"./armor/police_suit":363,"./armor/prisoner_suit":364,"./armor/santa_hat":365,"./armor/space_suit":366,"./base_equipment":367,"./hand/assassins_knife":368,"./hand/assault_rifle":369,"./hand/blood_bottle":370,"./hand/blue_energy_sword":371,"./hand/bottle":372,"./hand/bowl":373,"./hand/deconstructor":374,"./hand/disinfectant":375,"./hand/drill":376,"./hand/dynamite":377,"./hand/fire_extinguisher":379,"./hand/flame_thrower":380,"./hand/green_energy_sword":381,"./hand/grenade":382,"./hand/katana":384,"./hand/lead_pipe":385,"./hand/lighter":386,"./hand/melee_equipment":387,"./hand/molotov_cocktail":388,"./hand/mop":389,"./hand/name_tag":390,"./hand/pistol":391,"./hand/plasma_blade":392,"./hand/plasma_gun":393,"./hand/pocket_trader":394,"./hand/poison_grenade":395,"./hand/radio":396,"./hand/red_energy_sword":398,"./hand/rocket_launcher":399,"./hand/scar_17":400,"./hand/shotgun":401,"./hand/squid_staff":402,"./hand/survival_tool":403,"./hand/syringe":404,"./hand/water_bottle":405,"./hand/wrench":406}],408:[function(require,module,exports){
const RawFood = require("./raw_food")
const Constants = require("./../../../../common/constants.json")
const Protocol = require("./../../../../common/util/protocol")

class AlienMeat extends RawFood {

  getSpritePath() {
    return 'alien_meat.png'
  }

  getType() {
    return Protocol.definition().BuildingType.AlienMeat
  }

  getConstantsTable() {
    return "Foods.AlienMeat"
  }

}

module.exports = AlienMeat

},{"./../../../../common/constants.json":656,"./../../../../common/util/protocol":686,"./raw_food":431}],409:[function(require,module,exports){
const RawFood = require("./raw_food")
const Constants = require("./../../../../common/constants.json")
const Protocol = require("./../../../../common/util/protocol")

class AnimalMeat extends RawFood {

  getSpritePath() {
    return 'animal_meat.png'
  }

  getType() {
    return Protocol.definition().BuildingType.AnimalMeat
  }

  getConstantsTable() {
    return "Foods.AnimalMeat"
  }

}

module.exports = AnimalMeat

},{"./../../../../common/constants.json":656,"./../../../../common/util/protocol":686,"./raw_food":431}],410:[function(require,module,exports){
const BaseFood = require("./base_food")
const Constants = require("./../../../../common/constants.json")
const Protocol = require("./../../../../common/util/protocol")

class Antidote extends BaseFood {

  getSpritePath() {
    return 'antidote.png'
  }

  getType() {
    return Protocol.definition().BuildingType.Antidote
  }

  getConstantsTable() {
    return "Foods.Antidote"
  }

}

module.exports = Antidote

},{"./../../../../common/constants.json":656,"./../../../../common/util/protocol":686,"./base_food":411}],411:[function(require,module,exports){
const BaseEntity  = require("./../base_entity")
const Constants = require("./../../../../common/constants.json")
const Protocol = require("./../../../../common/util/protocol")

class BaseFood extends BaseEntity {
  constructor(game, data) {
    data.x = 0
    data.y = 0

    super(game, data)

    this.role   = data.role
    this.user = data.user
    this.repositionSprite()
  }

  isEdible() {
    let isEdible = this.getConstants().isEdible
    return typeof isEdible !== 'undefined' ? isEdible : true
  }

  onPostEquip() {

  }

  static isUsable() {
    return true
  }

  isWeapon() {
    return false
  }

  playSound() {
    
  }

  static getCost() {
    let cost = this.prototype.getConstants().cost
    return cost ? cost.gold : 2
  }

  isRaw() {
    return false
  }

  isMiningEquipment() {
    return false
  }

  syncWithServer() {
    
  }

  isAnimatable() {
    return true
  }

  animate() {
    if (this.animationTween) return
    this.animationTween = this.getAnimationTween()
    this.animationTween.start()
  }

  stopAnimation() {
    if (this.animationTween) {
      this.animationTween.stop()
    }

    this.animationTween = null
  }

  getAnimationTween() {
    let delta = { delta: 0 }
    let origX = this.sprite.position.x

    const tween = new TWEEN.Tween(delta)
        .to({ delta: 10  }, 200)
        .onUpdate(() => {
          this.sprite.position.x = origX - delta.delta
        })
        .onStop(() => {
          this.sprite.position.x = origX
        })
        .yoyo(true)
        .repeat(Infinity)

    return tween
  }

  remove() {
    this.stopAnimation()

    super.remove()
  }

  hasRequirements() {
    return this.getConstants().requirements
  }

  repositionSprite() {
    this.sprite.anchor.set(0)
    this.sprite.rotation = Math.PI/2
    this.sprite.position.x = 50
    this.sprite.position.y = 20

    let table = this.getConstants()
    if (table.sprite) {
      if (table.sprite.position) {
        this.sprite.position.x = table.sprite.position.x
        this.sprite.position.y = table.sprite.position.y
      }

      if (typeof table.sprite.rotation !== 'undefined') {
        this.sprite.rotation = table.sprite.rotation * Math.PI / 180
      }

      if (typeof table.sprite.anchor !== 'undefined') {
        this.sprite.anchor.set(table.sprite.anchor) 
      }
    }

  }

  getSprite() {
    const sprite = new PIXI.Sprite(PIXI.utils.TextureCache[this.getSpritePath()])
    return sprite
  }

  static getSellGroup() {
    return "Foods"
  }

  getSpriteContainer() {
    return this.data.user.characterSprite
  }

  getChildIndex() {
    // before body
    return 1
  }

  static build(game, data) {
    return new this(game, data)
  }

  getType() {
    throw new Error("must implement BaseFood.getType")
  }

}

module.exports = BaseFood


},{"./../../../../common/constants.json":656,"./../../../../common/util/protocol":686,"./../base_entity":206}],412:[function(require,module,exports){
const BaseFood = require("./base_food")
const Constants = require("./../../../../common/constants.json")
const Protocol = require("./../../../../common/util/protocol")

class BloodPack extends BaseFood {

  getSpritePath() {
    return 'blood_pack.png'
  }

  getType() {
    return Protocol.definition().BuildingType.BloodPack
  }

  getConstantsTable() {
    return "Foods.BloodPack"
  }

}

module.exports = BloodPack

},{"./../../../../common/constants.json":656,"./../../../../common/util/protocol":686,"./base_food":411}],413:[function(require,module,exports){
const BaseFood = require("./base_food")
const Constants = require("./../../../../common/constants.json")
const Protocol = require("./../../../../common/util/protocol")

class Bread extends BaseFood {

  getSpritePath() {
    return 'bread.png'
  }

  getType() {
    return Protocol.definition().BuildingType.Bread
  }

  getConstantsTable() {
    return "Foods.Bread"
  }

}

module.exports = Bread

},{"./../../../../common/constants.json":656,"./../../../../common/util/protocol":686,"./base_food":411}],414:[function(require,module,exports){
const BaseFood = require("./base_food")
const Constants = require("./../../../../common/constants.json")
const Protocol = require("./../../../../common/util/protocol")

class Egg extends BaseFood {

  getSpritePath() {
    return 'egg.png'
  }

  getType() {
    return Protocol.definition().BuildingType.Egg
  }

  getConstantsTable() {
    return "Foods.Egg"
  }

}

module.exports = Egg

},{"./../../../../common/constants.json":656,"./../../../../common/util/protocol":686,"./base_food":411}],415:[function(require,module,exports){
const BaseFood = require("./base_food")
const Constants = require("./../../../../common/constants.json")
const Protocol = require("./../../../../common/util/protocol")

class FirstAidKit extends BaseFood {

  repositionSprite() {
    this.sprite.position.x = 50
    this.sprite.position.y = 20
  }

  getSpritePath() {
    return 'first_aid_kit.png'
  }

  getType() {
    return Protocol.definition().BuildingType.FirstAidKit
  }

  getConstantsTable() {
    return "Foods.FirstAidKit"
  }

}

module.exports = FirstAidKit

},{"./../../../../common/constants.json":656,"./../../../../common/util/protocol":686,"./base_food":411}],416:[function(require,module,exports){
const BaseFood = require("./base_food")
const Constants = require("./../../../../common/constants.json")
const Protocol = require("./../../../../common/util/protocol")

class Fish extends BaseFood {

  getSpritePath() {
    return 'fish.png'
  }

  getType() {
    return Protocol.definition().BuildingType.Fish
  }

  getConstantsTable() {
    return "Foods.Fish"
  }

}

module.exports = Fish
},{"./../../../../common/constants.json":656,"./../../../../common/util/protocol":686,"./base_food":411}],417:[function(require,module,exports){
const BaseFood = require("./base_food")
const Constants = require("./../../../../common/constants.json")
const Protocol = require("./../../../../common/util/protocol")

class Fries extends BaseFood {

  getSpritePath() {
    return 'fries.png'
  }

  getType() {
    return Protocol.definition().BuildingType.Fries
  }

  getConstantsTable() {
    return "Foods.Fries"
  }

}

module.exports = Fries

},{"./../../../../common/constants.json":656,"./../../../../common/util/protocol":686,"./base_food":411}],418:[function(require,module,exports){
const RawFood = require("./raw_food")
const Constants = require("./../../../../common/constants.json")
const Protocol = require("./../../../../common/util/protocol")

class Gel extends RawFood {

  getSpritePath() {
    return 'gel.png'
  }

  getType() {
    return Protocol.definition().BuildingType.Gel
  }

  getConstantsTable() {
    return "Foods.Gel"
  }

}

module.exports = Gel

},{"./../../../../common/constants.json":656,"./../../../../common/util/protocol":686,"./raw_food":431}],419:[function(require,module,exports){
const BaseFood = require("./base_food")
const Constants = require("./../../../../common/constants.json")
const Protocol = require("./../../../../common/util/protocol")

class Gelatin extends BaseFood {

  repositionSprite() {
    this.sprite.rotation = Math.PI/2
    this.sprite.position.x = 50
    this.sprite.position.y = 20
    this.sprite.width = 25
    this.sprite.height = 20
  }

  getSpritePath() {
    return 'gelatin.png'
  }

  getType() {
    return Protocol.definition().BuildingType.Gelatin
  }

  getConstantsTable() {
    return "Foods.Gelatin"
  }

}

module.exports = Gelatin

},{"./../../../../common/constants.json":656,"./../../../../common/util/protocol":686,"./base_food":411}],420:[function(require,module,exports){
const BaseFood = require("./base_food")
const Constants = require("./../../../../common/constants.json")
const Protocol = require("./../../../../common/util/protocol")

class HotDog extends BaseFood {

  getSpritePath() {
    return 'hotdog.png'
  }

  getType() {
    return Protocol.definition().BuildingType.HotDog
  }

  getConstantsTable() {
    return "Foods.HotDog"
  }

}

module.exports = HotDog

},{"./../../../../common/constants.json":656,"./../../../../common/util/protocol":686,"./base_food":411}],421:[function(require,module,exports){
const RawFood = require("./raw_food")
const Constants = require("./../../../../common/constants.json")
const Protocol = require("./../../../../common/util/protocol")

class HumanMeat extends RawFood {

  getSpritePath() {
    return 'human_meat.png'
  }

  getType() {
    return Protocol.definition().BuildingType.HumanMeat
  }

  getConstantsTable() {
    return "Foods.HumanMeat"
  }

}

module.exports = HumanMeat

},{"./../../../../common/constants.json":656,"./../../../../common/util/protocol":686,"./raw_food":431}],422:[function(require,module,exports){
const Helper = require("./../../../../common/helper")

const Foods = {}

Foods.Raw = {}
Foods.Raw.Gel = require("./gel")
Foods.Raw.Egg = require("./egg")
Foods.Raw.AlienMeat = require("./alien_meat")
Foods.Raw.HumanMeat = require("./human_meat")
Foods.Raw.AnimalMeat = require("./animal_meat")
Foods.Raw.Wheat = require("./wheat")
Foods.Raw.Rice = require("./rice")

Foods.Cooked = {}
Foods.Cooked.Potato = require("./potato")
Foods.Cooked.Gelatin = require("./gelatin")
Foods.Cooked.Steak = require("./steak")
Foods.Cooked.Bread = require("./bread")
Foods.Cooked.HotDog = require("./hot_dog")
Foods.Cooked.VeganPizza = require("./vegan_pizza")
Foods.Cooked.SlimyMeatPizza = require("./slimy_meat_pizza")
Foods.Cooked.LectersDinner = require("./lecters_dinner")
Foods.Cooked.Omelette = require("./omelette")
Foods.Cooked.Fries = require("./fries")
Foods.Cooked.PotatoSoup = require("./potato_soup")
Foods.Cooked.SlimeBroth = require("./slime_broth")
Foods.Cooked.MisoSoup = require("./miso_soup")
Foods.Cooked.Starberries = require("./starberries")
Foods.Cooked.Pumpkin = require("./pumpkin")
Foods.Cooked.Fish = require("./fish")
Foods.Cooked.Nigiri = require("./nigiri")
Foods.Cooked.PumpkinPie = require("./pumpkin_pie")

Foods.Drugs = {}
Foods.Drugs.FirstAidKit = require("./first_aid_kit")
Foods.Drugs.Antidote = require("./antidote")
Foods.Drugs.BloodPack = require("./blood_pack")
Foods.Drugs.Stimpack = require("./stimpack")


Foods.forType = (type) => {
  let klass
  const klassName = Helper.getTypeNameById(type) 

  // find which namesapce
  for (let group in Foods) {
    klass = Foods[group][klassName]
    if (klass) break
  }

  return klass
}


Foods.getCookables = () => {
  return Object.values(Foods.Cooked).filter((klass) => {
    return klass.getConstantsTable() !== "Foods.Potato"
  })
}

Foods.getDrugs = () => {
  return Object.values(Foods.Drugs)
}


module.exports = Foods

},{"./../../../../common/helper":664,"./alien_meat":408,"./animal_meat":409,"./antidote":410,"./blood_pack":412,"./bread":413,"./egg":414,"./first_aid_kit":415,"./fish":416,"./fries":417,"./gel":418,"./gelatin":419,"./hot_dog":420,"./human_meat":421,"./lecters_dinner":423,"./miso_soup":424,"./nigiri":425,"./omelette":426,"./potato":427,"./potato_soup":428,"./pumpkin":429,"./pumpkin_pie":430,"./rice":432,"./slime_broth":433,"./slimy_meat_pizza":434,"./starberries":435,"./steak":436,"./stimpack":437,"./vegan_pizza":438,"./wheat":439}],423:[function(require,module,exports){
const BaseFood = require("./base_food")
const Constants = require("./../../../../common/constants.json")
const Protocol = require("./../../../../common/util/protocol")

class LectersDinner extends BaseFood {

  getSpritePath() {
    return 'lecters_dinner.png'
  }

  getType() {
    return Protocol.definition().BuildingType.LectersDinner
  }

  getConstantsTable() {
    return "Foods.LectersDinner"
  }

}

module.exports = LectersDinner

},{"./../../../../common/constants.json":656,"./../../../../common/util/protocol":686,"./base_food":411}],424:[function(require,module,exports){
const BaseFood = require("./base_food")
const Constants = require("./../../../../common/constants.json")
const Protocol = require("./../../../../common/util/protocol")

class MisoSoup extends BaseFood {

  getSpritePath() {
    return 'miso_soup_by_px.png'
  }

  getType() {
    return Protocol.definition().BuildingType.MisoSoup
  }

  getConstantsTable() {
    return "Foods.MisoSoup"
  }

}

module.exports = MisoSoup

},{"./../../../../common/constants.json":656,"./../../../../common/util/protocol":686,"./base_food":411}],425:[function(require,module,exports){
const BaseFood = require("./base_food")
const Constants = require("../../../../common/constants.json")
const Protocol = require("../../../../common/util/protocol")

class Nigiri extends BaseFood {

  getSpritePath() {
    return 'nigiri.png'
  }

  getType() {
    return Protocol.definition().BuildingType.Nigiri
  }

  getConstantsTable() {
    return "Foods.Nigiri"
  }

}

module.exports = Nigiri

},{"../../../../common/constants.json":656,"../../../../common/util/protocol":686,"./base_food":411}],426:[function(require,module,exports){
const BaseFood = require("./base_food")
const Constants = require("./../../../../common/constants.json")
const Protocol = require("./../../../../common/util/protocol")

class Omelette extends BaseFood {

  getSpritePath() {
    return 'omelette.png'
  }

  getType() {
    return Protocol.definition().BuildingType.Omelette
  }

  getConstantsTable() {
    return "Foods.Omelette"
  }

}

module.exports = Omelette

},{"./../../../../common/constants.json":656,"./../../../../common/util/protocol":686,"./base_food":411}],427:[function(require,module,exports){
const BaseFood = require("./base_food")
const Constants = require("./../../../../common/constants.json")
const Protocol = require("./../../../../common/util/protocol")

class Potato extends BaseFood {

  getSpritePath() {
    return 'potato.png'
  }

  getType() {
    return Protocol.definition().BuildingType.Potato
  }

  getConstantsTable() {
    return "Foods.Potato"
  }

}

module.exports = Potato

},{"./../../../../common/constants.json":656,"./../../../../common/util/protocol":686,"./base_food":411}],428:[function(require,module,exports){
const BaseFood = require("./base_food")
const Constants = require("./../../../../common/constants.json")
const Protocol = require("./../../../../common/util/protocol")

class PotatoSoup extends BaseFood {

  getSpritePath() {
    return 'potato_soup_by_px.png'
  }

  getType() {
    return Protocol.definition().BuildingType.PotatoSoup
  }

  getConstantsTable() {
    return "Foods.PotatoSoup"
  }

}

module.exports = PotatoSoup

},{"./../../../../common/constants.json":656,"./../../../../common/util/protocol":686,"./base_food":411}],429:[function(require,module,exports){
const BaseFood = require("./base_food")
const Constants = require("./../../../../common/constants.json")
const Protocol = require("./../../../../common/util/protocol")

class Pumpkin extends BaseFood {

  getSpritePath() {
    return 'pumpkin.png'
  }

  getType() {
    return Protocol.definition().BuildingType.Pumpkin
  }

  getConstantsTable() {
    return "Foods.Pumpkin"
  }

}

module.exports = Pumpkin

},{"./../../../../common/constants.json":656,"./../../../../common/util/protocol":686,"./base_food":411}],430:[function(require,module,exports){
const BaseFood = require("./base_food")
const Constants = require("./../../../../common/constants.json")
const Protocol = require("./../../../../common/util/protocol")

class PumpkinPie extends BaseFood {

  getSpritePath() {
    return 'pumpkin_pie.png'
  }

  getType() {
    return Protocol.definition().BuildingType.PumpkinPie
  }

  getConstantsTable() {
    return "Foods.PumpkinPie"
  }

}

module.exports = PumpkinPie
},{"./../../../../common/constants.json":656,"./../../../../common/util/protocol":686,"./base_food":411}],431:[function(require,module,exports){
const BaseFood = require("./base_food")

class RawFood extends BaseFood {
  isRaw() {
    return true
  }
}

module.exports = RawFood
},{"./base_food":411}],432:[function(require,module,exports){
const RawFood = require("./raw_food")
const Constants = require("./../../../../common/constants.json")
const Protocol = require("./../../../../common/util/protocol")

class Rice extends RawFood {

  getSpritePath() {
    return 'rice.png'
  }

  getType() {
    return Protocol.definition().BuildingType.Rice
  }

  getConstantsTable() {
    return "Foods.Rice"
  }

}

module.exports = Rice

},{"./../../../../common/constants.json":656,"./../../../../common/util/protocol":686,"./raw_food":431}],433:[function(require,module,exports){
const BaseFood = require("./base_food")
const Constants = require("./../../../../common/constants.json")
const Protocol = require("./../../../../common/util/protocol")

class SlimeBroth extends BaseFood {

  getSpritePath() {
    return 'slime_broth_by_px.png'
  }

  getType() {
    return Protocol.definition().BuildingType.SlimeBroth
  }

  getConstantsTable() {
    return "Foods.SlimeBroth"
  }

}

module.exports = SlimeBroth

},{"./../../../../common/constants.json":656,"./../../../../common/util/protocol":686,"./base_food":411}],434:[function(require,module,exports){
const BaseFood = require("./base_food")
const Constants = require("./../../../../common/constants.json")
const Protocol = require("./../../../../common/util/protocol")

class SlimyMeatPizza extends BaseFood {

  getSpritePath() {
    return 'slimy_meat_pizza.png'
  }

  getType() {
    return Protocol.definition().BuildingType.SlimyMeatPizza
  }

  getConstantsTable() {
    return "Foods.SlimyMeatPizza"
  }

}

module.exports = SlimyMeatPizza

},{"./../../../../common/constants.json":656,"./../../../../common/util/protocol":686,"./base_food":411}],435:[function(require,module,exports){
const BaseFood = require("./base_food")
const Constants = require("./../../../../common/constants.json")
const Protocol = require("./../../../../common/util/protocol")

class Starberries extends BaseFood {

  getSpritePath() {
    return 'starberries.png'
  }

  getType() {
    return Protocol.definition().BuildingType.Starberries
  }

  getConstantsTable() {
    return "Foods.Starberries"
  }

}

module.exports = Starberries

},{"./../../../../common/constants.json":656,"./../../../../common/util/protocol":686,"./base_food":411}],436:[function(require,module,exports){
const BaseFood = require("./base_food")
const Constants = require("./../../../../common/constants.json")
const Protocol = require("./../../../../common/util/protocol")

class Steak extends BaseFood {

  getSpritePath() {
    return 'steak.png'
  }

  getType() {
    return Protocol.definition().BuildingType.Steak
  }

  getConstantsTable() {
    return "Foods.Steak"
  }

}

module.exports = Steak

},{"./../../../../common/constants.json":656,"./../../../../common/util/protocol":686,"./base_food":411}],437:[function(require,module,exports){
const BaseFood = require("./base_food")
const Constants = require("./../../../../common/constants.json")
const Protocol = require("./../../../../common/util/protocol")

class Stimpack extends BaseFood {

  getSpritePath() {
    return 'stimpack.png'
  }

  getType() {
    return Protocol.definition().BuildingType.Stimpack
  }

  getConstantsTable() {
    return "Foods.Stimpack"
  }

}

module.exports = Stimpack

},{"./../../../../common/constants.json":656,"./../../../../common/util/protocol":686,"./base_food":411}],438:[function(require,module,exports){
const BaseFood = require("./base_food")
const Constants = require("./../../../../common/constants.json")
const Protocol = require("./../../../../common/util/protocol")

class VeganPizza extends BaseFood {

  getSpritePath() {
    return 'vegan_pizza.png'
  }

  getType() {
    return Protocol.definition().BuildingType.VeganPizza
  }

  getConstantsTable() {
    return "Foods.VeganPizza"
  }

}

module.exports = VeganPizza

},{"./../../../../common/constants.json":656,"./../../../../common/util/protocol":686,"./base_food":411}],439:[function(require,module,exports){
const RawFood = require("./raw_food")
const Constants = require("./../../../../common/constants.json")
const Protocol = require("./../../../../common/util/protocol")

class Wheat extends RawFood {

  getSpritePath() {
    return 'wheat.png'
  }

  getType() {
    return Protocol.definition().BuildingType.Wheat
  }

  getConstantsTable() {
    return "Foods.Wheat"
  }

}

module.exports = Wheat

},{"./../../../../common/constants.json":656,"./../../../../common/util/protocol":686,"./raw_food":431}],440:[function(require,module,exports){
const Player = require("./player")
const InputController = require("./input_controller")
const SocketUtil = require("./../util/socket_util")
const Helper = require("./../../../common/helper")
const Constants = require("./../../../common/constants.json")
const Protocol = require("./../../../common/util/protocol")
const Grid = require("./../../../common/entities/grid")
const Terrains = require("./terrains/index")
const Buildings = require("./buildings/index")
const Projectiles = require("./projectiles/index")
const Particles = require("./particles/index")
const Transports = require("./transports/index")
const Menus = require("./../menus/index")
const Mobs = require("./mobs/index")
const Backgrounds = require("./backgrounds/index")
const Ship = require("./ship")
const Sector = require("./sector")
const Room = require("./room")
const Pickup = require("./pickup")
const ChunkRegion = require("./chunk_region")
const ChunkRegionPath = require("./chunk_region_path")
const Corpse = require("./corpse")
const Path = require("./path")
const Item = require("./item")
const Region = require("./region")
const Button = require("./button")
const RegionManager = require("./region_manager")
const Team = require("./team")
const Draggable = require("@shopify/draggable").Draggable
const Equipments = require("./equipments/index")
const ClientHelper = require("./../util/client_helper")
const ExceptionReporter = require("./../util/exception_reporter")
const Bowser = require("bowser")
const Cookies = require("js-cookie")
const FirebaseClientHelper = require('../util/firebase_client_helper')
const uuidv4 = require('uuid/v4')
const Trigger = require("../menus/command_blocks/trigger")
const ActionValue = require("../menus/command_blocks/action_value")
const Comparison = require("../menus/command_blocks/comparison")

class Game {
  constructor(main) {
    this.neverInitialized = true // important - only initialize once to avoid ticker being added multiple times

    this.main = main
    this.initVariables()
    this.initPersistentVariables()
    this.initConstants()
    this.initKeyBindings()
    this.initAdditionalLibraries()
    this.initWorld()
  }

  getId() {
    return this.creatorUid // some random number
  }

  setGameConnection(gameConnection) {
    this.gameConnection = gameConnection
    this.reinitConnection()

    this.gameConnection.setGame(this)
  }

  initPersistentVariables() {
    this.armorTextures = {}
    this.loadedSounds = {}
  }

  addMutedPlayer(name) {
    this.mutedPlayers[name] = true
  }

  removeMutedPlayer(name) {
    delete this.mutedPlayers[name]
  }

  initVariables(options = {}) {
    this.destinationStorageId = null
    this.inventoryCooldowns = {}
    this.eventCountdownIntervals = {}
    this.mutedPlayers = {}
    this.commandBlockTimers = {}
    this.isAFK = false
    this.totalTaskBar        = document.querySelector('.total_task_stat')
    this.healthBar        = document.querySelector('.health_stat')
    this.shieldBar        = document.querySelector('.shield_stat')
    this.oxygenBar        = document.querySelector('.oxygen_stat')
    this.hungerBar        = document.querySelector('.hunger_stat')
    this.staminaBar       = document.querySelector('.stamina_stat')
    this.roomOxygenBar    = document.querySelector('.room_oxygen_stat')
    this.energyBar        = document.querySelector('.energy_stat')
    this.errorContent     = document.querySelector('#error_menu_content')
    this.errorTitle       = document.querySelector('#error_title')
    this.shipStatSpeed    = document.querySelector('.ship_stat_speed')
    this.shipStatHealth   = document.querySelector('.ship_stat_health')
    this.shipStatShield   = document.querySelector('.ship_stat_shield')
    this.shipStatEnergy   = document.querySelector('.ship_stat_energy')
    this.shipStatMiningRate = document.querySelector('.ship_stat_mining_rate')
    this.playerPos        = document.querySelector(".player_pos")
    this.waveIncomingTime = document.querySelector("#wave_remaining_time_value")
    this.deathScreen      = document.querySelector("#death_screen_container")
    this.zoomInBtn        = document.querySelector("#zoom_in_btn")
    this.zoomOutBtn       = document.querySelector("#zoom_out_btn")
    this.chatInput        = document.querySelector("#chat_input")
    this.chatInputContainer = document.querySelector("#chat_input_container")
    this.restartBtn       = document.querySelector("#restart_btn")
    this.mobilePrimaryActionBtn = document.querySelector("#mobile_primary_action_btn")
    this.isTracingChunkRegionPath = false
    this.isChunkDisplayEnabled = false

    window.debug_buffer = []
    this.server_update_rate = Constants.physicsTimeStep
    this.upstreamIntervals = []
    this.maxUpstreamIntervals = []
    this.resolution = 1
    this.latencyCalculateIntervalInSeconds = 10
    this.ticksSincePacket = 0
    this.isServerShutdownInProgress = false
    this.firstServerMessage = true
    this.shownChunkRegionPaths = []
    if (!options.excludeTeamInit) {
      this.teams = {}
    }

    window.zoomEnabled = true
    this.isAdminMode = debugMode
    this.isInitialAdminSetup = true
    this.playerId = null
    this.player = null

    this.residents = {}

    this.lastFrameTime = (new Date()).getTime()
    this.myScore = 0
  }

  initFloorTextures() {
    this.floorTextures = {}

    for (let label in Constants.FloorTextures) {
      let texture = Constants.FloorTextures[label]
      this.floorTextures[texture.index] = label + ".png"
    }
  }

  generateId() {
    return uuidv4()
  }

  initFloorColors() {
    this.colors = {}

    for (let label in Constants.FloorColors) {
      let color = Constants.FloorColors[label]
      let colorValue = ClientHelper.hexToInt(color.value)
      this.colors[color.index] = { label: label, value: colorValue }
    }
  }

  initSuitColors() {
    this.suitColors = {}

    for (let label in Constants.SuitColors) {
      let color = Constants.SuitColors[label]
      let colorValue = ClientHelper.hexToInt(color.value)
      this.suitColors[color.index] = { label: label, value: colorValue }
    }
  }

  reinitConnection() {
    SocketUtil.setSocket(this.gameConnection.socket)
  }

  getSocketUtil() {
    return SocketUtil
  }

  initUI() {
    this.initMenus()
    this.initListeners()
    this.initDraggables()
  }

  showNameInput() {
    document.querySelector("#name_input_container").style.display = 'block'
  }

  denyMenuOpen() {
    this.shouldDenyMenuOpen = true
  }

  allowMenuOpen() {
    this.shouldDenyMenuOpen = false
  }

  createSmoke(options) {
    return Particles.Smoke.create(options)
  }

  initMenus() {
    this.openMenus = []

    this.keypadMenu    = new Menus.KeypadMenu(this, document.querySelector("#keypad_menu"))
    this.entityMenu    = new Menus.EntityMenu(this, document.querySelector("#entity_menu"))
    this.blueprintMenu = new Menus.BlueprintMenu(this, document.querySelector("#blueprint_menu"))
    this.craftMenu     = new Menus.CraftMenu(this, document.querySelector("#craft_menu"))
    this.processorMenu = new Menus.ProcessorMenu(this, document.querySelector("#processor_menu"))
    this.storageMenu   = new Menus.StorageMenu(this, document.querySelector("#storage_menu"))
    this.inventoryMenu = new Menus.InventoryMenu(this, document.querySelector("#inventory_menu"))
    this.oxygenTankMenu = new Menus.OxygenTankMenu(this, document.querySelector("#oxygen_tank_menu"))
    this.debugMenu      = new Menus.DebugMenu(this, document.querySelector("#debug_menu"))
    this.chatMenu       = new Menus.ChatMenu(this, document.querySelector("#chat_container"))
    this.tradeMenu      = new Menus.TradeMenu(this, document.querySelector("#trade_menu"))
    this.playerMenu     = new Menus.PlayerMenu(this, document.querySelector("#player_menu"))
    this.lightPathMenu  = new Menus.LightPathMenu(this, document.querySelector("#light_path_menu"))
    this.welcomeMenu    = new Menus.WelcomeMenu(this, document.querySelector("#welcome_menu"))
    this.tutorialMenu   = new Menus.TutorialMenu(this, document.querySelector("#tutorial_menu"))
    this.mapMenu        = new Menus.MapMenu(this, document.querySelector("#map_menu"))
    this.miniMapMenu    = new Menus.MiniMapMenu(this, document.querySelector("#mini_map_menu"))
    this.statusListMenu = new Menus.StatusListMenu(this, document.querySelector("#status_list_menu"))
    this.teamMenu       = new Menus.TeamMenu(this, document.querySelector("#manage_team_menu"))
    this.teamRequestMenu  = new Menus.TeamRequestMenu(this, document.querySelector("#team_request_menu"))
    this.teamStatusMenu  = new Menus.TeamStatusMenu(this, document.querySelector("#team_status_menu"))
    this.friendsMenu  = new Menus.FriendsMenu(this, document.querySelector("#friends_menu"))
    this.npcDialogMenu  = new Menus.NPCDialogMenu(this, document.querySelector("#npc_dialog_menu"))
    this.railStopMenu  = new Menus.RailStopMenu(this, document.querySelector("#rail_stop_menu"))
    this.signMenu  = new Menus.SignMenu(this, document.querySelector("#sign_menu"))
    this.userProfileMenu = new Menus.UserProfileMenu(this, document.querySelector("#user_profile_menu"))
    this.confirmMenu = new Menus.ConfirmMenu(this, document.querySelector("#confirm_menu"))
    this.permissionsMenu = new Menus.PermissionsMenu(this, document.querySelector("#permissions_menu"))
    this.sendMoneyMenu = new Menus.SendMoneyMenu(this, document.querySelector("#send_money_menu"))
    this.vendingMachineMenu = new Menus.VendingMachineMenu(this, document.querySelector("#vending_machine_menu"))
    this.atmMenu = new Menus.AtmMenu(this, document.querySelector("#atm_menu"))
    this.soilMenu = new Menus.SoilMenu(this, document.querySelector("#soil_menu"))
    this.slaveTradeMenu      = new Menus.SlaveTradeMenu(this, document.querySelector("#slave_trade_menu"))
    this.stoveMenu = new Menus.StoveMenu(this, document.querySelector("#stove_menu"))
    this.walkthroughMenu = new Menus.WalkthroughMenu(this, document.querySelector("#walkthrough_menu"))
    this.leaderboardMenu = new Menus.LeaderboardMenu(this, document.querySelector("#leaderboard_menu"))
    this.teamFullMenu = new Menus.TeamFullMenu(this, document.querySelector("#team_full_menu"))
    this.previewCaptureMenu = new Menus.PreviewCaptureMenu(this, document.querySelector("#preview_capture_menu"))
    this.changeNameMenu = new Menus.ChangeNameMenu(this, document.querySelector("#change_name_menu"))
    this.selectDifficultyMenu = new Menus.SelectDifficultyMenu(this, document.querySelector("#select_difficulty_menu"))
    this.colorPickerMenu = new Menus.ColorPickerMenu(this, document.querySelector("#color_picker_menu"))
    this.voteMenu = new Menus.VoteMenu(this, document.querySelector("#vote_menu"))
    this.questMenu = new Menus.QuestMenu(this, document.querySelector("#quest_menu"))
    this.endGameMenu = new Menus.EndGameMenu(this, document.querySelector("#end_game_menu"))
    this.sidebarMenu = new Menus.SidebarMenu(this, document.querySelector("#sidebar_menu"))
    this.securityCameraMenu = new Menus.SecurityCameraMenu(this, document.querySelector("#security_camera_menu"))
    this.suitColorMenu = new Menus.SuitColorMenu(this, document.querySelector("#suit_color_menu"))
    this.terminalMenu = new Menus.TerminalMenu(this, document.querySelector("#terminal_menu"))
    this.commandBlockMenu = new Menus.CommandBlockMenu(this, document.querySelector("#command_block_menu"))
    this.commandBlockPicker = new Menus.CommandBlockPicker(this, document.querySelector("#command_block_picker"))
    this.friendRequestMenu  = new Menus.FriendRequestMenu(this, document.querySelector("#friend_request_menu"))
    this.badgeMenu = new Menus.BadgeMenu(this, document.querySelector("#badge_menu"))


    this.visitColonyMenu = this.main.gameExplorer

    if (this.isMobile()) {
      this.createMobileBuildActionMenu()
      document.querySelector("#base_hud .resources").style.display = 'none'
    }
  }

  equipBadge(name) {
    SocketUtil.emit("EquipBadge", {name: name})
  }

  onFriendRequestReceived(request) {
    this.friendRequestMenu.createRequestEntry(request)
  }

  registerMenu(menu) {
    this.menus = this.menus || []
    this.menus.push(menu)
  }

  getRoleByName(name) {
    let result

    for (let id in this.roles) {
      let role = this.roles[id]
      if (role.name === name) {
        result = role
        break
      }
    }

    return result
  }

  onRoleUpdated(data) {
    if (!this.sector) return

    if (this.player.teamId !== data.teamId) return

    if (this.roles[data.role.id]) {
      if (data.clientShouldDelete) {
        delete this.roles[data.role.id]
        this.teamMenu.removeRole(data.role.id)
      } else {
        this.roles[data.role.id] = data.role
        this.teamMenu.updateRole(data.role)
      }
    } else {
      this.roles[data.role.id] = data.role
      let roleEl = this.teamMenu.addRole(data.role)
      this.teamMenu.selectRole(roleEl)
    }

    this.entityMenu.createPermissions() // add new role to permission checkbox
    this.entityMenu.populateSpawnPointSelectors()
  }

  onTeamUpdated(data) {
    if (!this.sector) return

    let team = this.teams[data.team.id]
    if (!team) {
      if (!data.team.clientMustDelete) {
        team = new Team(this, data.team)
        this.teams[data.team.id] = team
        this.teamMenu.addTeam(team)
      }
    } else if (data.team.clientMustDelete) {
      delete this.teams[data.team.id]
      this.teamMenu.removeTeam(team)
      team.remove()
    } else {
      team.syncWithServer(data.team)
      this.teamMenu.syncTeam(team)
    }

    this.entityMenu.populateSpawnPointSelectors()
  }

  setTeams(teams) {
    for (let id in teams) {
      let data = teams[id]
      this.onTeamUpdated({ team: data })
    }
  }

  getItemKlass(type) {
    return Item.getKlass(type)
  }

  getItemKlassByName(name) {
    return Item.getKlassByName(name)
  }

  getUrl() {
    return this.gameConnection.url
  }

  onTeamRequest(data) {
    if (data.clientMustDelete) {
      this.teamRequestMenu.removeTeamRequestEntry(data)
    } else {
      this.teamRequestMenu.createTeamRequestEntry(data)
    }
  }

  onTeamInvitation(data) {
    if (data.isReject) {
      setTimeout(() => {
        this.teamMenu.resetTeamRequestStatus(data.teamId)
      }, 1000 * 60 * 3)
    }
  }

  openOxygenTank(entity) {
    this.oxygenTankMenu.open(entity)
  }

  initDraggables() {
    const containers = Array.from(document.querySelectorAll(".storage, #game_canvas"))

    const dragDelay = 150

    const draggable = new Draggable(containers, {
      draggable: '.inventory_slot',
      delay: dragDelay,
      placedTimeout: 100
    })

    const canvasContainer = new Draggable(document.querySelector("#game_canvas"), {
      draggable: '.player_inventory_slot',
    })

    draggable.on('drag:start', (event) => {
      this.isDragging = true
    })

    draggable.on('drag:over:container', (event) => {
      let hoveredContainer = event.data.overContainer
      if (hoveredContainer.id === "game_canvas") {
        this.destinationStorageId = Constants.worldStorageId
      }
    })

    draggable.on('drag:over', (event) => {
      let hoveredElement = event.data.over
      this.destinationIndex = hoveredElement.dataset.index
      this.destinationStorageId = hoveredElement.closest(".storage").dataset.storageId
    })
    draggable.on('drag:out', (event) => {
      this.destinationIndex = null
      this.destinationStorageId = null
    })
    draggable.on('drag:stop', (event) => {
      this.isDragging = false

      const sourceIndex = event.data.source.dataset.index
      const sourceStorageId = event.data.source.closest(".storage").dataset.storageId

      let isPositionChanged = this.destinationIndex && this.destinationIndex !== sourceIndex
      if (isPositionChanged) {
        event.data.originalSource.classList.add("hidden")
      } else {
        event.data.originalSource.classList.remove("hidden")
      }


      if (this.destinationStorageId !== null) {
        let data = {
          sourceStorageId: sourceStorageId,
          sourceIndex: sourceIndex,
          destinationStorageId: this.destinationStorageId
        }

        if (this.destinationIndex) {
          data['destinationIndex'] =  this.destinationIndex
        }

        SocketUtil.emit("SwapInventory", data)
      }
    })
  }

  openInventory() {
    this.inventoryMenu.open()
  }

  initConstants() {
    this.CAMERA_WIDTH = Constants.cameraWidth
    this.CAMERA_HEIGHT = Constants.cameraHeight
    this.MAX_ZOOM_LEVEL = debugMode ? 5 : (this.isMobile() ? 4 : 3)
    this.MIN_ZOOM_LEVEL = 0.5
  }

  isEntityMenuOpenFor(entity) {
    return this.entityMenu.isOpen(entity)
  }

  getOpenNonEntityMenus() {
    return this.openMenus.filter((menu) => {
      return !menu.isEntityMenu()
    })
  }

  closeEntityMenu() {
    this.entityMenu.close()
  }

  interact(entity) {
    if (entity.hasMenu() && entity.canMenuBeOpened()) {
      entity.openMenu()
    }

    if (entity.isBuildingType()) {
      this.lastInteractEntityId = entity.id
    }

    if (entity.shouldSendInteractTargetToServer()) {
      SocketUtil.emit("InteractTarget", { id: entity.id })
    }
  }

  interactEmpty() {
    if (this.player && this.player.getMount()) {
      SocketUtil.emit("InteractTarget", { id: this.player.getMount().id })
    }
  }

  isLeaderAndOwner(entity, team, player) {
    if (!team) return false
    if (!entity.owner) return false

    let teamId = team.id
    let ownerId = entity.owner.id

    return ownerId === teamId &&
           team.leader && team.leader.id === player.id
  }

  renderUpgradeDetails(entity) {
    const upgradeProgress = entity.getUpgradeProgress()
    let isMaxUpgradeReached = entity.isMaxUpgradeReached()
    let missingResources = {}

    let stats


    if (isMaxUpgradeReached) {
      this.entityMenu.querySelector(".upgrade_cost").style.display = 'none'
      this.entityMenu.querySelector("#upgrade_btn").querySelector(".action_label").innerText = "Max"
      stats = { health: { before: entity.getMaxHealth() }, damage: { before: entity.getDamage() } , range: { before: entity.getRange() } }

    } else {
      this.entityMenu.querySelector(".upgrade_cost").style.display = 'block'
      stats = upgradeProgress

      if (entity.level > entity.container.level) {
        this.entityMenu.querySelector("#upgrade_btn").querySelector(".action_label").innerText = "Upgrade Ship"
        this.entityMenu.querySelector("#upgrade_btn").className = "disabled"
        this.entityMenu.querySelector(".upgrade_cost_gold").innerText = ""
        isMaxUpgradeReached = true
      } else {
        this.entityMenu.querySelector("#upgrade_btn").querySelector(".action_label").innerText = "Upgrade"
        this.entityMenu.querySelector("#upgrade_btn").className = ""
        // const cost = entity.getUpgradeCost()
        // missingResources = player.getMissingResources(cost)

        // this.entityMenu.querySelector(".upgrade_cost_gold").innerText = cost.gold ? cost.gold + " gold" : ""
      }
    }

    // let statsGrowth = ""
    // for (let statKey in stats) {
    //   if (statKey === "count") continue // dont show count (HACK: refactor this. not easily seen)

    //   let progress = stats[statKey]
    //   let changedKlass = progress.before !== progress.after ? "changed" : ""
    //   let el = "<div class='stats_growth'>" +
    //              "<div class='stats_type'>" + statKey + "</div>" +
    //              "<div class='stats_after " + changedKlass + "'>" + (progress.after ? progress.after : "" ) + "</div>" +
    //              "<div class='stats_before'>" + progress.before + "</div>" +
    //            "</div>"
    //   statsGrowth += el
    // }

    // this.entityMenu.querySelector(".entity_stats_target_growth").innerHTML = statsGrowth


    // // classnames
    // this.entityMenu.querySelector(".upgrade_cost_gold").className = "upgrade_cost_gold"

    // // show which is missing
    // for (let missingResource in missingResources) {
    //   this.entityMenu.querySelector(".upgrade_cost_" + missingResource).className += " missing"
    // }

    // // indicate where button is disabled
    // if (Object.keys(missingResources).length > 0 || isMaxUpgradeReached) {
    //   this.entityMenu.querySelector("#upgrade_btn").className = "disabled"
    // } else {
    //   this.entityMenu.querySelector("#upgrade_btn").className = ""
    // }
  }

  renderSellDetails(entity) {
    if (entity.isNotForSale()) {
      document.querySelector("#sell_btn .action_label").innerText = 'Not for Sale'
      document.querySelector("#sell_btn").className = "disabled"
      this.entityMenu.querySelector("#sell_cost").innerText = ""
    } else {
      document.querySelector("#sell_btn .action_label").innerText = 'Sell'
      document.querySelector("#sell_btn").className = ""

      const sell = entity.getSellCost()
      const sellDetails = Object.keys(sell).map((resourceName) => { return [sell[resourceName], resourceName].join(" ")  } ).join(", ")
      this.entityMenu.el.querySelector("#sell_cost").innerText = sellDetails.length > 0 ? sellDetails : ""
    }
  }

  closeAllMenus() {
    if (!this.openMenus) return
    let maxIteration = 50
    while (this.openMenus.length > 0 && maxIteration > 0) {
      this.openMenus[0].close()
      maxIteration -= 1
    }
  }

  closeAllMenusForced() {
    // even menus that are persistent
    this.openMenus.forEach((menu) => {
      menu.close({ manualUnregister: true })
    })
    this.openMenus = []
  }

  closeLastMenu() {
    let lastMenu = this.openMenus[this.openMenus.length - 1]
    lastMenu.close()
  }

  showEntityMenu(entity, options = {}) {
    options["dontCloseMenus"] = true
    this.entityMenu.open(entity, options)
  }

  shouldShowDebugDetails() {
    if (this.isAdminMode) return true
    let isSandboxOwner = this.isPeaceful() && this.player.isSectorOwner()
    if (isSandboxOwner) return true

    return game.player.getRole() &&
           game.player.getRole().permissions["UseCommands"]
  }

  hideEntityMenu(entity) {
    this.entityMenu.close()
  }

  getHighlightedEntity() {
    if (!this.sector) return null
    return this.sector.selection.selectedEntity ||
           this.sector.persistentSelection.selectedEntity
  }

  highlight(entity) {
    this.sector.highlight(entity)
  }

  unhighlight(entity) {
    this.sector.unhighlight(entity)
  }

  setMobileAction(action) {
    document.querySelector("#mobile_action_btn").innerText = i18n.t(action)
  }

  setDefaultMobileAction() {
    if (this.player.getMount()) {
      document.querySelector("#mobile_action_btn").innerText = "Unmount"
    } else {
      document.querySelector("#mobile_action_btn").innerText = ""
    }

  }

  hideActionTooltip() {
    if (!this.isActionTooltipShown) return

    this.isActionTooltipShown = false
    document.querySelector("#player_action_tooltip").style.display = 'none'
  }

  showActionTooltip(entity) {
    if (this.isActionTooltipShown) return

    this.isActionTooltipShown = true

    let tooltipMessage = entity.getActionTooltipMessage()

    if (tooltipMessage) {
      document.querySelector("#player_action_tooltip").className = ""
      document.querySelector("#action_tooltip_message").innerText = tooltipMessage
    } else {
      document.querySelector("#player_action_tooltip").className = ""
      document.querySelector("#action_tooltip_message").innerText = ""
    }

    document.querySelector("#player_action_tooltip").style.display = 'block'
    let tooltipWidth = document.querySelector("#player_action_tooltip").offsetWidth
    document.querySelector("#player_action_tooltip").style.top = "35%"
    document.querySelector("#player_action_tooltip").style.left = (window.innerWidth/2 - tooltipWidth/2) + "px"
  }

  getNewBuildingStatsHTML(buildingKlass) {
    let statsEl = ""

    const stats = buildingKlass.getUpgradeProgress()

    for (let statKey in stats) {
      if (statKey === "count") continue // dont show count (HACK: refactor this. not easily seen)

      let progress = stats[statKey]
      let el = "<div class='stats_growth'>" +
                 "<div class='stats_type'>" + statKey + "</div>" +
                 "<div class='stats_before'>" + progress.before + "</div>" +
               "</div>"
      statsEl += el
    }

    return statsEl
  }

  hideBuildMenuFor(buildingKlass) {

  }

  getTeam(teamId) {
    return this.teams[teamId]
  }

  getTeamCount() {
    return Object.keys(this.teams).length
  }

  initWorld() {
    window.worldSetupTime = (new Date()).getTime()

    this.initRenderer()
    this.initComponents()
    this.initFloorColors()
    this.initSuitColors()
    this.initFloorTextures()

    Protocol.initClient((error, protocol) => {
      if (error) {
        this.main.onPlayerCantJoin({ message: i18n.t('NetworkOutdatedGameClient') })
        return
      }

      SocketUtil.init({ protocol: protocol })
      this.initSocketHandlers()
      Buildings.Floors.Floor.initAttributeHandlers()

      this.initTextures(() => {
        this.initUI()
        this.generateArmorTextures() // only at this point would TextureCache be populated
        this.createHudAlert()

        this.main.onGameInitialized()
        this.initSoundManager()
      })
    })

  }

  getSoundNames() {
    return this.getBackgroundSoundNames().concat(this.getEffectsSoundNames())
  }

  getBackgroundSoundNames() {
    return ["peaceful", "enemy_invasion", "meeting", "anotherplanet"]
  }

  getEffectsSoundNames() {
    return ["raid_2", "melee_hit", "airlock", "pistol", "machine_gun_2_b",
            "pickup", "place_object", "shotgun", "light_laser", "rock_grind",
            "assault_rifle", "explosion", "missile",
            "harvest_plant", "melee_damage",
            "water_step", "flame", "gas_release", "burning", "eating", "saber_one", "saber_two", "alert", "tesla",
            "cannon", "plasma_gun", "bubble", "deep_laser"]
  }

  initSoundManager() {
    this.sounds = {}
    this.currentSounds = {}

    let soundNames = this.getSoundNames()

    soundNames.forEach((soundName) => {
      this.sounds[soundName] = this.createSound(soundName)
    })

    this.setEffectsVolume(this.getSavedOrDefaultEffectsVolume())
    this.setBackgroundVolume(this.getSavedOrDefaultBackgroundVolume())
  }

  getSavedOrDefaultEffectsVolume() {
    let effectsVolume = Cookies.get("effects_volume")
    if (typeof effectsVolume !== 'undefined') {
      return parseFloat(effectsVolume)
    } else {
      return Constants.defaultVolume
    }
  }

  getSavedOrDefaultBackgroundVolume() {
    if (debugMode) return 0

    let backgroundVolume = Cookies.get("background_volume")
    if (typeof backgroundVolume !== 'undefined') {
      return parseFloat(backgroundVolume)
    } else {
      return Constants.defaultBackgroundVolume
    }
  }

  isSoundRecentlyPlayed(name, interval) {
    let result = false

    let soundData = this.currentSounds[name]
    if (soundData) {
      let elapsed = Date.now() - soundData.lastPlayedTime
      if (elapsed < interval) {
        result = true
      }
    }

    return result
  }

  playSoundLazyDownload(name, options = {}) {
    if (!this.loadedSounds[name]) {
      this.loadSound(name, () => {
        this.playSound(name, options)
      })
    } else {
      this.playSound(name, options)
    }
  }

  playSound(name, options = {}) {
    if (!this.loadedSounds[name]) return

    let sound = this.sounds[name]

    if (options.minInterval) {
      if (this.isSoundRecentlyPlayed(name, options.minInterval)) {
        return
      }
    }

    if (this.isSoundAlreadyPlaying(name)) {
      if (options.skipIfPlaying) {
        return
      } else {
        sound.stop()
      }
    }

    if (options.loop) {
      sound.loop(true)
    }

    let soundId

    try {
      soundId = sound.play()
      this.addCurrentSound(name, options.shouldDelete)
    } catch(e) {
      console.error(e)
    }

    return soundId
  }

  stopSound(name) {
    let sound = this.sounds[name]
    if (sound) {
      try {
        sound.stop()
      } catch(e) {
        console.error(e)
      }
    }
  }

  isSoundAlreadyPlaying(name) {
    return this.sounds[name] && this.sounds[name].playing()
  }

  addCurrentSound(name, shouldDelete = true) {
    this.currentSounds[name] = {
      lastPlayedTime: Date.now(),
      shouldDelete: shouldDelete
    }
  }

  removeCurrentSound(name) {
    if (this.currentSounds[name] && this.currentSounds[name].shouldDelete) {
      delete this.currentSounds[name]
    }
  }

  loadSound(name, cb) {
    let sound = new Howl({
      src: ['/assets/sounds/' + name + '.mp3'],
      volume: 0.5,
      onload: () => {
        this.loadedSounds[name] = true
        cb()
      },
      onend: () => {
        this.removeCurrentSound(name)
      }
    })

    this.sounds[name] = sound
  }

  createSound(name) {
    return new Howl({
      src: ['/assets/sounds/' + name + '.mp3'],
      volume: 0.5,
      onload: this.onSoundLoad.bind(this, name),
      onend: this.onSoundEnd.bind(this, name)
    })
  }

  onSoundLoad(name) {
    this.loadedSounds[name] = true
  }

  onSoundEnd(name) {
    this.removeCurrentSound(name)
  }

  calculatePing() {
    this.pingTime = (new Date()).getTime()
    SocketUtil.emit("Ping", {})
  }

  onPong() {
    let pongTime = (new Date()).getTime()
    let ping = (pongTime - this.pingTime)

    let pingEl = document.querySelector("#performance_stats #ping .value")
    if (pingEl) {
      pingEl.innerText = ping + " ms"
    }

  }

  onSetAdmin(data) {
    this.isAdminMode = data.isAdminMode
    this.initAdditionalLibraries()
  }

  initAdditionalLibraries() {
    if (this.isInitialAdminSetup && this.isAdminMode) {
      this.isInitialAdminSetup = false
      this.main.initAdditionalLibraries()
    }
  }

  onEvent(data) {
    let event = this.parseEvent(data.type, data.eventData)
    if (event) {
      this.handleGameEvent(event)
    }
  }

  parseEvent(type, eventData) {
    switch(type) {
      case Protocol.definition().EventType.TaxCollection:
        return {
          description: i18n.t("Events.TaxCollection"),
          class: null,
          sound: null
        }
        break
      case Protocol.definition().EventType.RaidWarning:
        return {
          description: i18n.t("Events.RaidWarning"),
          class: "danger_event",
          sound: "raid_2",
          countdown: 1 * Constants.secondsPerHour * Constants.physicsTimeStep
        }
        break
      case Protocol.definition().EventType.FixLights:
        return {
          description: i18n.t("Events.FixLights"),
          class: "danger_event",
          id: "fix_lights_event",
          countdown: 90 * Constants.physicsTimeStep,
          handler: "startFixLights"
        }
        break
      case Protocol.definition().EventType.FixLightsEnd:
        return {
          description: i18n.t("Events.FixLightsEnd"),
          handler: "stopFixLights"
        }
        break
      case Protocol.definition().EventType.Alarm:
        return {
          description: i18n.t("Events.Alarm"),
          class: "danger_event",
          handler: "startAlarm",
          id: "alarm_event",
          countdown: 30 * Constants.physicsTimeStep
        }
        break
      case Protocol.definition().EventType.AlarmEnd:
        return {
          description: i18n.t("Events.AlarmEnd"),
          handler: "stopAlarm",
          skipDisplay: true
        }
        break
      case Protocol.definition().EventType.RaidEnd:
        return {
          description: i18n.t("Events.RaidEnd"),
          handler: "stopRaidMusic"
        }
        break
      case Protocol.definition().EventType.TraderArrived:
        return {
          description: i18n.t("Events.TraderArrived"),
          class: null,
          sound: null
        }
        break
      case Protocol.definition().EventType.SlaveTraderArrived:
        return {
          description: i18n.t("Events.SlaveTraderArrived"),
          class: null,
          sound: null
        }
        break
      case Protocol.definition().EventType.SpiderInfestation:
        return {
          description: i18n.t("Events.SpiderInfestation"),
          class: "danger_event",
          sound: "raid_2"
        }
        break
      case Protocol.definition().EventType.MeteorShower:
        return {
          description: i18n.t("Events.MeteorShower"),
          class: "danger_event",
          sound: "raid_2",
          countdown: 1 * Constants.secondsPerHour * Constants.physicsTimeStep,
          onCountdownStart: () => {
            let chunkKey = JSON.parse(eventData).chunkKey
            if (chunkKey) {
              let chunkRow = chunkKey.split("-")[0]
              let chunkCol = chunkKey.split("-")[1]
              this.mapMenu.addAlert(chunkRow, chunkCol)
            }
          },
          onCountdownStop: () => {
            let chunkKey = JSON.parse(eventData).chunkKey
            if (chunkKey) {
              let chunkRow = chunkKey.split("-")[0]
              let chunkCol = chunkKey.split("-")[1]
              this.mapMenu.removeAlert(chunkRow, chunkCol)
            }
          }
        }
        break
      case Protocol.definition().EventType.MeteorShowerImmediate:
        return {
          description: i18n.t("Events.MeteorShower"),
          class: "danger_event",
          sound: "raid_2",
          countdown: 5 * Constants.physicsTimeStep,
          onCountdownStart: () => {
            let chunkKey = JSON.parse(eventData).chunkKey
            if (chunkKey) {
              let chunkRow = chunkKey.split("-")[0]
              let chunkCol = chunkKey.split("-")[1]
              this.mapMenu.addAlert(chunkRow, chunkCol)
            }
          },
          onCountdownStop: () => {
            let chunkKey = JSON.parse(eventData).chunkKey
            if (chunkKey) {
              let chunkRow = chunkKey.split("-")[0]
              let chunkCol = chunkKey.split("-")[1]
              this.mapMenu.removeAlert(chunkRow, chunkCol)
            }
          }
        }
        break
      default:
        return null
    }
  }

  // https://codepen.io/chles/pen/aNxMxQ
  startScreenWarp() {
    if (!this.displacementSprite) {
      this.displacementSprite = new PIXI.Sprite(PIXI.utils.TextureCache["displacement_map.png"])
      this.displacementSprite.scale.set(2)
      this.displacementSprite.texture.baseTexture.wrapMode = PIXI.WRAP_MODES.REPEAT

      this.displacementFilter = new PIXI.filters.DisplacementFilter(this.displacementSprite)
    }

    this.app.stage.addChild(this.displacementSprite)
    this.app.stage.filters = [this.displacementFilter]

    let count = 0

    this.screenWarpInterval = setInterval(() => {
      this.displacementSprite.position.x = count * 10
      this.displacementSprite.position.y = count * 10

      count += 0.20
    }, 30)
  }

  stopScreenWarp() {
    if (!this.displacementSprite) return
    this.app.stage.removeChild(this.displacementSprite)
    this.app.stage.filters = []
    this.displacementSprite.position.x = 0
    this.displacementSprite.position.y = 0
    clearInterval(this.screenWarpInterval)
  }

  screenShake() {
    if (this.screenShakeTween) return

    let targetSprite = this.app.stage
    let origY = targetSprite.position.y
    let position = { y: origY }
    let quakeMagnitude = 5

    this.screenShakeTween = new TWEEN.Tween(position)
        .to({ y: origY + quakeMagnitude  }, 60)
        .onUpdate(() => { // Called after tween.js updates 'coords'.
            targetSprite.position.y = position.y
        })

    let bTween = new TWEEN.Tween(position)
        .to({ y: origY - quakeMagnitude  }, 160)
        .onUpdate(() => { // Called after tween.js updates 'coords'.
            targetSprite.position.y = position.y
        })

    let cTween = new TWEEN.Tween(position)
        .to({ y: origY + quakeMagnitude  }, 60)
        .onUpdate(() => { // Called after tween.js updates 'coords'.
            targetSprite.position.y = position.y
        })

    let dTween = new TWEEN.Tween(position)
        .to({ y: origY - quakeMagnitude  }, 160)
        .onUpdate(() => { // Called after tween.js updates 'coords'.
            targetSprite.position.y = position.y
        })

    let eTween = new TWEEN.Tween(position)
        .to({ y: origY + quakeMagnitude  }, 60)
        .onUpdate(() => { // Called after tween.js updates 'coords'.
            targetSprite.position.y = position.y
        })

    let fTween = new TWEEN.Tween(position)
        .to({ y: origY - quakeMagnitude  }, 160)
        .onUpdate(() => { // Called after tween.js updates 'coords'.
            targetSprite.position.y = position.y
        })
        .onComplete(() => {
            targetSprite.position.y = origY
            this.screenShakeTween = null
        })

    this.screenShakeTween.chain(bTween)
    bTween.chain(cTween)
    cTween.chain(dTween)
    dTween.chain(eTween)
    eTween.chain(fTween)

    this.screenShakeTween.start()
  }

  handleGameEvent(event) {
    let eventsMenu = document.querySelector("#events_menu")

    let eventItem

    if (!event.skipDisplay) {
      eventItem = document.createElement("div")
      eventItem.classList.add("event_item")
      if (event.class) {
        eventItem.classList.add(event.class)
      }

      if (event.id) {
        eventItem.id = event.id
      }

      eventsMenu.appendChild(eventItem)
    }

    if (event.countdown) {
      if (event.onCountdownStart) {
        event.onCountdownStart()
      }
      let occurTimestamp = this.timestamp + event.countdown
      this.eventCountdownIntervals[event.description] = setInterval(() => {
        let timeRemainingInSeconds = Math.floor((occurTimestamp - this.timestamp) / Constants.physicsTimeStep)
        let formattedTimeRemaining = Helper.stringifyTimeShort(timeRemainingInSeconds)
        eventItem.innerText = event.description + " " + formattedTimeRemaining
        if (timeRemainingInSeconds <= 0) {
          if (eventItem.parentElement) {
            eventItem.parentElement.removeChild(eventItem)
          }
          if (event.onCountdownStop) {
            event.onCountdownStop()
          }
          clearInterval(this.eventCountdownIntervals[event.description])
          let errorFadeOutTween = ClientHelper.getFadeTween(eventItem, 1, 0)
          errorFadeOutTween.start()
        }

      }, 1000)
    } else {
      if (!event.skipDisplay) {
        eventItem.innerText = event.description
        setTimeout(() => {
          if (eventItem.parentElement) {
            eventItem.parentElement.removeChild(eventItem)
          }
        }, 6000)

        let errorFadeOutTween = ClientHelper.getFadeTween(eventItem, 1, 0, 5000)
        errorFadeOutTween.start()
      }
    }


    if (event.sound) {
      this.playSound(event.sound)
    }

    if (event.handler) {
      let handler = this[event.handler]
      handler.call(this)
    }
  }

  togglePerformanceDebug() {
    let el = document.querySelector("#performance_stats")

    if (el.style.display === 'block') {
      el.style.display = 'none'
    } else {
      el.style.display = 'block'
    }
  }

  initSector(data) {
    this.sector = new Sector(this, data)
    this.gameLayer.addChild(this.sector.sprite)
  }

  startHudAlertTween() {
    if (this.hudAlertTween) return

    this.app.stage.addChild(this.hudAlertContainer)
    document.querySelector(".hud_alert_container").style.display = 'block'

    let alpha = { alpha: this.hudAlertContainer.alpha }

    this.hudAlertTween = new TWEEN.Tween(alpha)
        .to({ alpha: 0.1 }, 800)
        .easing(TWEEN.Easing.Quadratic.Out)
        .onUpdate(() => {
          this.hudAlertContainer.alpha = alpha.alpha
          document.querySelector(".hud_alert_container").style.opacity = 0.1 + alpha.alpha
        })
        .yoyo(true)
        .repeat(Infinity)

    this.hudAlertTween.start()
  }

  stopHudAlertTween() {
    if (!this.hudAlertTween) return

    this.hudAlertTween.stop()
    this.hudAlertTween = null

    this.hudAlertContainer.parent.removeChild(this.hudAlertContainer)
    document.querySelector(".hud_alert_container").style.display = 'none'
  }

  createHudAlert() {
    this.hudAlertContainer = new PIXI.Sprite(PIXI.utils.TextureCache["white.png"])
    this.hudAlertContainer.name = "HudAlertContainer"
    this.hudAlertContainer.alpha = 0.4
    this.hudAlertContainer.tint = 0xff0000
    this.hudAlertContainer.width = window.innerWidth
    this.hudAlertContainer.height = window.innerHeight
  }

  initComponents() {
    this.regionManager = new RegionManager(this)
  }

  isSelectingRegion() {
    return this.regionManager.isSelectingRegion
  }

  renderRegionBlockAtMousePosition(clientX, clientY) {
    this.regionManager.renderRegionBlockAtMousePosition(clientX, clientY)
  }

  hasRegionStart() {
    return this.regionManager.regionStart
  }

  setRegionStart() {
    this.regionManager.setRegionStart()
  }

  clearRegion() {
    this.regionManager.clearRegion()
  }

  createRegion() {
    this.regionManager.createRegion()
  }

  getShipBuildings() {
    return [
      Buildings.Structures.ShipCore,
      Buildings.Structures.Thruster,
      Buildings.Structures.Reactor,
      Buildings.Structures.Bridge,
      Buildings.Structures.ShieldGenerator
    ]
  }

  distanceBetween(entity, otherEntity) {
    if (entity.getContainer().isMovable()) {
      return this.distance(entity.getRelativeX(), entity.getRelativeY(), otherEntity.getRelativeX(), otherEntity.getRelativeY())
    } else {
      return this.distance(entity.getX(), entity.getY(), otherEntity.getX(), otherEntity.getY())
    }
  }

  distance(x1, y1, x2, y2) {
    return Helper.distance(x1, y1, x2, y2)
  }

  angle(x1, y1, x2, y2) {
    return Math.atan2(y2 - y1, x2 - x1)
  }

  getPlainArmorSprite(){
    if (!this.plainArmorSprite) {
      let container = new PIXI.Container()
      container.name = "SpaceSuitContainer"
      container.pivot.x = 100
      container.pivot.y = 0

      if (!this.isCanvasMode()) {
        container.rotation = -Math.PI/2
        container.scale.set(0.69)
      }

      this.plainArmorSprite = container

      let texture = PIXI.utils.TextureCache["space_helmet_base.png"]
      this.plainArmorSprite.baseSprite = new PIXI.Sprite(texture)
      this.plainArmorSprite.baseSprite.name = "BaseSprite"
      this.plainArmorSprite.baseSprite.tint = 0x999999

      texture = PIXI.utils.TextureCache["space_helmet_eye.png"]
      this.plainArmorSprite.eyeSprite = new PIXI.Sprite(texture)
      this.plainArmorSprite.eyeSprite.name = "EyeSprite"
      this.plainArmorSprite.eyeSprite.position.x = 15
      this.plainArmorSprite.eyeSprite.position.y = 48

      container.addChild(this.plainArmorSprite.baseSprite)
      container.addChild(this.plainArmorSprite.eyeSprite)
    }

    return this.plainArmorSprite

  }

  generateArmorTextures() {
    let sprite = this.getPlainArmorSprite()

    sprite.eyeSprite.tint = 0x78eb76
    let armorTexture = this.app.renderer.generateTexture(sprite)
    this.armorTextures["gray"] = armorTexture

    sprite.baseSprite.tint = 0xc81010
    sprite.eyeSprite.tint = 0xacd8fe
    armorTexture = this.app.renderer.generateTexture(sprite)
    this.armorTextures["red"] = armorTexture

    sprite.baseSprite.tint = 0x186638
    sprite.eyeSprite.tint = 0xacd8fe
    armorTexture = this.app.renderer.generateTexture(sprite)
    this.armorTextures["green"] = armorTexture

    sprite.baseSprite.tint = 0x245e9b
    sprite.eyeSprite.tint = 0x78eb76
    armorTexture = this.app.renderer.generateTexture(sprite)
    this.armorTextures["blue"] = armorTexture

    sprite.baseSprite.tint = 0xf3b61d
    sprite.eyeSprite.tint = 0x78eb76
    armorTexture = this.app.renderer.generateTexture(sprite)
    this.armorTextures["yellow"] = armorTexture

    sprite.baseSprite.tint = 0x6e3797
    sprite.eyeSprite.tint = 0x78eb76
    armorTexture = this.app.renderer.generateTexture(sprite)
    this.armorTextures["purple"] = armorTexture

    sprite.baseSprite.tint = 0xeb4c1a
    sprite.eyeSprite.tint = 0x78eb76
    armorTexture = this.app.renderer.generateTexture(sprite)
    this.armorTextures["orange"] = armorTexture

    sprite.baseSprite.tint = 0x222222
    sprite.eyeSprite.tint = 0x78eb76
    armorTexture = this.app.renderer.generateTexture(sprite)
    this.armorTextures["black"] = armorTexture
  }

  initTextures(cb) {
    window.textureSetupTime = (new Date()).getTime()

    // PIXI.settings.SCALE_MODE = PIXI.SCALE_MODES.NEAREST

    let tempAssets = ['displacement_map.png', 'squid_lord_heart.png', 'squid_staff.png', 'fries.png', 'energy_drink.png', 'alien_juice.png', 'rocket_launcher.png', 'scar_17_by_px.png', 'bowl_by_px.png', 'potato_soup_by_px.png', 'miso_soup_by_px.png', 'slime_broth_by_px.png', 'bomber_turret_by_px.png', 'firebat.png', 'plasma_blade.png', 'raven.png', 'starberries.png', 'car.png', 'bricks_texture.png', 'checker_texture.png', 'noise_texture.png', 'x_texture.png', 'xchecker_texture.png', 'nihonshu.png', 'pumpkin.png', 'pumpkin_plant.png','pumpkin_seed.png', 'rice.png', 'rice_plant.png', 'rice_seed.png', 'fish.png', 'nigiri.png', 'katana_reskin.png', 'pumpkin_pie.png', 'imperial_special_forces_armor.png', 'deconstructor.png', 'blue_laser.png', 'keypad_door.png', 'keypad_door_lower.png', 'keypad_door_upper.png', 'unbreakable_wall.png', 'sapper.png', 'sapper_corpse.png', 'dynamite.png', 'miasma_gate.png']
    tempAssets.forEach((asset) => {
      PIXI.Texture.addToCache(PIXI.Texture.fromImage('/assets/images/' + asset), asset)
    })

    // graphics texture
    let preloadedGraphics = this.getPreloadedGraphics()
    for (let key in preloadedGraphics) {
      let graphic = preloadedGraphics[key]
      let texture = this.app.renderer.generateTexture(graphic)
      PIXI.Texture.addToCache(texture, key)
    }

    PIXI.loader
      .add("/assets/images/background/atlas-2222.json")
      .add("/assets/images/cc.fnt")
      .load((loader, resources) => {
        let selfTime = (new Date()).getTime() - window.textureSetupTime
        let time = (new Date()).getTime() - window.initializeTime
        cb()
    })
  }

  getPreloadedGraphics() {
    return {
      "los_range.png": this.getAttackRangeGraphics()
    }
  }

  getAttackRangeGraphics() {
    const largestRange = 500

    const graphics = new PIXI.Graphics()
    graphics.beginFill(0xc59bff)
    graphics.drawCircle(0, 0, largestRange)
    graphics.endFill()

    return graphics
  }

  openInGameMenu() {
    document.querySelector("#welcome_container").classList.add("in_game")
    document.querySelector("#welcome_container").style.display = 'block'

    this.main.showMainMenu()
    this.hideActionTooltip()
    this.hideGameHuds()
  }

  closeInGameMenu() {
    this.main.onBackMainMenuBtnClick()

    document.querySelector("#welcome_container").classList.remove("in_game")
    document.querySelector("#welcome_container").style.display = 'none'
    this.showGameHuds()
  }

  emitPlayerPositionChanged() {
    this.player.onPositionChanged()
  }

  initSocketHandlers() {
    SocketUtil.on("GameState", this.onSyncWithServer.bind(this))
    SocketUtil.on("JoinGame", this.onJoinGame.bind(this))
    SocketUtil.on("EndGame", this.onEndGame.bind(this))
    SocketUtil.on("CantJoin", this.onPlayerCantJoin.bind(this))
    SocketUtil.on("Respawn", this.onPlayerRespawn.bind(this))
    SocketUtil.on("Leaderboard", this.onLeaderboard.bind(this))
    SocketUtil.on("OtherPlayerJoined", this.onOtherPlayerJoined.bind(this))
    SocketUtil.on("CeilingHit", this.onCeilingHit.bind(this))
    SocketUtil.on("WaveLevel", this.onWaveLevel.bind(this))
    SocketUtil.on("PlayerDestroyed", this.onPlayerDestroyed.bind(this))
    SocketUtil.on("MothershipRepaired", this.onMothershipRepaired.bind(this))
    SocketUtil.on("CollisionDetected", this.onCollisionDetected.bind(this))
    SocketUtil.on("CircleCollision", this.onCircleCollision.bind(this))
    SocketUtil.on("WaveEnd", this.onWaveEnd.bind(this))
    SocketUtil.on("RepairStarted", this.onRepairStarted.bind(this))
    SocketUtil.on("RenderStorage", this.onRenderStorage.bind(this))
    SocketUtil.on("Teleport", this.onTeleport.bind(this))
    SocketUtil.on("ErrorMessage", this.onErrorMessage.bind(this))
    SocketUtil.on("MineralCapacityReached", this.onMineralCapacityReached.bind(this))
    SocketUtil.on("ShowStarMap", this.onShowStarMap.bind(this))
    SocketUtil.on("ServerChat", this.onServerChat.bind(this))
    SocketUtil.on("CraftSuccess", this.onCraftSuccess.bind(this))
    SocketUtil.on("RenderDebug", this.onRenderDebug.bind(this))
    SocketUtil.on("CameraFocusTarget", this.onCameraFocusTarget.bind(this))
    SocketUtil.on("GainResource", this.onGainResource.bind(this))
    SocketUtil.on("Chunk", this.onChunk.bind(this))
    SocketUtil.on("EntityUpdated", this.onEntityUpdated.bind(this))
    SocketUtil.on("RoomTileUpdated", this.onRoomTileUpdated.bind(this))
    SocketUtil.on("SetTutorialIndex", this.onSetTutorialIndex.bind(this))
    SocketUtil.on("Pong", this.onPong.bind(this))
    SocketUtil.on("SetAdmin", this.onSetAdmin.bind(this))
    SocketUtil.on("Event", this.onEvent.bind(this))
    SocketUtil.on("UpdateStats", this.onUpdateStats.bind(this))
    SocketUtil.on("BreakBuilding", this.onBreakBuilding.bind(this))
    SocketUtil.on("DebugRange", this.onDebugRange.bind(this))
    SocketUtil.on("Animate", this.onAnimate.bind(this))
    SocketUtil.on("ProgressCircle", this.onProgressCircle.bind(this))
    SocketUtil.on("TeamUpdated", this.onTeamUpdated.bind(this))
    SocketUtil.on("RoleUpdated", this.onRoleUpdated.bind(this))
    SocketUtil.on("MapPositions", this.onMapPositions.bind(this))
    SocketUtil.on("TeamRequest", this.onTeamRequest.bind(this))
    SocketUtil.on("TeamInvitation", this.onTeamInvitation.bind(this))
    SocketUtil.on("FlowField", this.onFlowField.bind(this))
    SocketUtil.on("ServerRestartCountdown", this.onServerRestartCountdown.bind(this))
    SocketUtil.on("UpdateTeamHealth", this.onUpdateTeamHealth.bind(this))
    SocketUtil.on("EnterSector", this.onEnterSector.bind(this))
    SocketUtil.on("LeaveSector", this.onLeaveSector.bind(this))
    SocketUtil.on("UpdateHomeArea", this.onUpdateHomeArea.bind(this))
    SocketUtil.on("AFK", this.onAFK.bind(this))
    SocketUtil.on("UpdateChunkRegion", this.onUpdateChunkRegion.bind(this))
    SocketUtil.on("UpdateChunkRegionPath", this.onUpdateChunkRegionPath.bind(this))
    SocketUtil.on("SessionResume", this.onSessionResume.bind(this))
    SocketUtil.on("InventoryChanged", this.onInventoryChanged.bind(this))
    SocketUtil.on("EquipIndexChanged", this.onEquipIndexChanged.bind(this))
    SocketUtil.on("SaveProgress", this.onSaveProgress.bind(this))
    SocketUtil.on("ChunkPositionChanged", this.onChunkPositionChanged.bind(this))
    SocketUtil.on("RoomHovered", this.onRoomHovered.bind(this))
    SocketUtil.on("EntityChunkRegionPath", this.onEntityChunkRegionPath.bind(this))
    SocketUtil.on("PlayerKick", this.onPlayerKick.bind(this))
    SocketUtil.on("RemovedFromGame", this.onRemovedFromGame.bind(this))
    SocketUtil.on("NPCServerMessage", this.onNPCServerMessage.bind(this))
    SocketUtil.on("RailDestinations", this.onRailDestinations.bind(this))
    SocketUtil.on("PlaySound", this.onPlaySound.bind(this))
    SocketUtil.on("ScreenshotUpdated", this.onScreenshotUpdated.bind(this))
    SocketUtil.on("AccountBalance", this.onAccountBalance.bind(this))
    SocketUtil.on("FavoriteUpdated", this.onFavoriteUpdated.bind(this))
    SocketUtil.on("SectorUpdated", this.onSectorUpdated.bind(this))
    SocketUtil.on("SellableUpdated", this.onSellableUpdated.bind(this))
    SocketUtil.on("TeamResidentsUpdated", this.onTeamResidentsUpdated.bind(this))
    SocketUtil.on("WalkthroughUpdated", this.onWalkthroughUpdated.bind(this))
    SocketUtil.on("TeamFull", this.onTeamFull.bind(this))
    SocketUtil.on("TeamLogs", this.onTeamLogs.bind(this))
    SocketUtil.on("RegionUpdated", this.onRegionUpdated.bind(this))
    SocketUtil.on("ButtonUpdated", this.onButtonUpdated.bind(this))
    SocketUtil.on("VoteUpdated", this.onVoteUpdated.bind(this))
    SocketUtil.on("StartScene", this.onStartScene.bind(this))
    SocketUtil.on("EndScene", this.onEndScene.bind(this))
    SocketUtil.on("StartVote", this.onStartVote.bind(this))
    SocketUtil.on("EndVote", this.onEndVote.bind(this))
    SocketUtil.on("SidebarUpdated", this.onSidebarUpdated.bind(this))
    SocketUtil.on("Objective", this.onObjective.bind(this))
    SocketUtil.on("DialogueUpdated", this.onDialogueUpdated.bind(this))
    SocketUtil.on("RoundStarted", this.onRoundStarted.bind(this))
    SocketUtil.on("TeamAssignmentChanged", this.onTeamAssignmentChanged.bind(this))
    SocketUtil.on("CameraFeedUpdated", this.onCameraFeedUpdated.bind(this))
    SocketUtil.on("RenderCamera", this.onRenderCamera.bind(this))
    SocketUtil.on("MapAction", this.onMapAction.bind(this))
    SocketUtil.on("TerminalUpdated", this.onTerminalUpdated.bind(this))
    SocketUtil.on("CustomStats", this.onCustomStats.bind(this))
    SocketUtil.on("MenuAction", this.onMenuAction.bind(this))
    SocketUtil.on("CommandBlockUpdated", this.onCommandBlockUpdated.bind(this))
    SocketUtil.on("CommandEventLog", this.onCommandEventLog.bind(this))
    SocketUtil.on("CommandEventLogList", this.onCommandEventLogList.bind(this))
    SocketUtil.on("CommandBlockTimerUpdated", this.onCommandBlockTimerUpdated.bind(this))
    SocketUtil.on("DoorStatus", this.onDoorStatus.bind(this))
    SocketUtil.on("KeypadSuccessful", this.onKeypadSuccessful.bind(this))
    SocketUtil.on("KeypadUnsuccessful", this.onKeypadUnsuccessful.bind(this))
    SocketUtil.on("OpenMenu", this.openMenu.bind(this))
    SocketUtil.on("CloseMenu", this.closeMenu.bind(this))
    SocketUtil.on("TempCommandBlockData", this.onTempCommandBlockData.bind(this))
    SocketUtil.on("BadgesData", this.onBadgesData.bind(this))
    SocketUtil.on("BadgeEquipped", this.onBadgeEquipped.bind(this))
  }

  onBadgeEquipped(data) {
    try {
      let tint = Number("0x"+data.badge.color);
      this.sector.players[data.playerId].sprite.children[1].children[0].tint = tint;
    }
    catch(e) {
      //server sent this before the player was initialized
    }
  }

  onBadgesData(data) {
    document.querySelector('#badge_container').innerHTML = '';
    for(let badge in data.badges) {
      let el = `<div title="${data.badges[badge].description}" onclick="game.equipBadge('${data.badges[badge].name}')" style="display:inline-block;margin-right:10px;"><p style="margin:0px;font-size:10px;">${data.badges[badge].name}</p><div class="badge" id="${data.badges[badge].name}"><img class="${data.badges[badge].isQualified ? "qualified" : "unqualified"}" src="/assets/images/${data.badges[badge].imageUrl}" width="50" height="50"></div></div>`
      document.querySelector('#badge_container').innerHTML += el;
      if(!data.badges[badge].isQualified) {
        let coveringEl = `<img class="cover-badge" src="/assets/images/badges/lock.png" width="50" height="50">`;
        document.querySelector(`#${data.badges[badge].name}`).innerHTML += coveringEl;
      }
    }
  }

  onTempCommandBlockData(data) {
    if(this.commandBlockMenu.getNode(data.tempId)) return
    let parent = this.commandBlockMenu.getNode(data.parentId)
    if(!parent && data.type != "Trigger") return

    if(data.type === "Trigger" && data.parentId === 0) {
      let trigger = new Trigger(this.commandBlockMenu, {id: data.tempId, event: data.value})
      this.commandBlockMenu.addTrigger(trigger)
    }
    else if(data.value == 'ifthenelse') {
      parent.commandBlock.getActionEntryFor(data.value).build(parent, { actionKey: data.value, id: data.tempId }, false) 
      //create ifthenelse, without adding if, then, and else
    }
    else if(data.type === 'if') {
      parent.addIf(data.tempId)
    }
    else if(data.type === 'then') {
      parent.addThen(data.tempId)
    }
    else if(data.type === 'else') {
      parent.addElse(data.tempId)
    }
    else if(data.type == "ActionEntry") { //command action entry, timer
      parent.commandBlock.getActionEntryFor(data.value).build(parent, { actionKey: data.value, id: data.tempId })
    }
    else if(!data.type) {
      if(parent.actionKey != "commands") {//comparison
        new Comparison(parent, {id: data.tempId})
        return
      }
      //command value
      new ActionValue(parent, {value: data.value, id: data.tempId})
    } 
  }

  openMenu(data) {
    this[data.menuName].open()
  }

  closeMenu(data) {
    this[data.menuName].close()
  }

  onKeypadUnsuccessful() {
    document.querySelector("#keypad_err_msg").style.visibility = 'visible'
    document.querySelector("#keypad_code_value").innerHTML = ''

    setTimeout(() => {
      document.querySelector("#keypad_err_msg").style.visibility = 'hidden'
    }, 3000)
  }

  onKeypadSuccessful() {
    game.keypadMenu.close()
  }

  onDoorStatus(status) {
    if(status && status.status) {
      document.querySelector("#keypad_submit_button").innerHTML = status.status
    } else {
      document.querySelector("#keypad_submit_button").innerHTML = status
    }
  }

  onCommandBlockTimerUpdated(data) {
    for (let id in data.commandBlockTimers) {
      let timer = data.commandBlockTimers[id]
      if (timer.clientMustDelete) {
        delete this.commandBlockTimers[timer.id]
      } else {
        this.commandBlockTimers[timer.id] = timer
      }
    }
  }

  addCommandBlockTimer(timer) {
    this.commandBlockTimers[timer.id] = timer
  }

  onMenuAction(data) {
    if (data.action === 'open') {
      let menu = this[data.menu]
      if (menu) {
        menu.open()
      }
    }
  }

  onCommandBlockUpdated(data) {
    if (data.fullJson) {
      this.renderFullCommandBlock(data.fullJson)
      return
    }

    this.commandBlockMenu.update(data)
  }

  onCommandEventLog(data) {
    this.commandBlockMenu.writeLog(data)
  }

  onCommandEventLogList(data) {
    this.commandBlockMenu.writeLogBatched(data.logs)
  }

  renderFullCommandBlock(fullJson) {
    this.commandBlockMenu.renderFullJson(fullJson)
  }

  onCustomStats(data) {
    if (!this.sector) return

    if (data.group === 'mobs') {
      this.sector.setMobCustomStats(data.type, data.stats)
    } else if (data.group === 'buildings') {
      this.sector.setBuildingCustomStats(data.type, data.stats)
    } else if (data.group === 'entities') {
      this.sector.setEntityCustomStats(data.type, data.stats)
    }
  }

  onMapAction(data) {
    if (data.action === "drawDamage") {
      this.mapMenu.drawDamage(data.row, data.col)
    }
  }

  onTerminalUpdated(data) {
    if (data.message) {
      this.sector.addTerminalMessage(data.message)
      if (this.terminalMenu.isOpen()) {
        this.terminalMenu.addTerminalMessage(data.message)
      }
    }
  }

  onStartVote(data) {
    this.voteMenu.open()
    this.voteMenu.setVotingEndTimestamp(data.votingEndTimestamp)
    this.questMenu.close()
  }

  onEndVote(data) {
    this.voteMenu.close()
    this.questMenu.open()
    this.chatMenu.close()

    this.stopMeetingMusic()
  }

  onVoteUpdated(data) {
    this.voteMenu.updateVote(data)
  }

  onRenderCamera(data) {
    this.enterSecurityCameraMode()
  }

  enterSecurityCameraMode() {
    if (this.securityCameraMenu.isOpen()) return

    this.hideActionTooltip()
    this.closeAllMenusForced()
    this.hideGameHuds()
    this.securityCameraMenu.open()
    this.setCustomCanvasSize(512, 512)
    this.resizeCanvas()
    document.querySelector("#home_background").classList.add('security_camera')
  }

  exitSecurityCameraMode() {
    this.setCustomCanvasSize(0, 0)
    this.resizeCanvas()
    document.querySelector("#home_background").classList.remove('security_camera')
    this.showGameHuds()
  }

  onStartScene(data) {
    this.closeAllMenusForced()
    this.isScenePlaying = true
    this.enterMovieMode()
  }

  onSidebarUpdated(data) {
    if (data.hasOwnProperty("isVisible")) {
      this.sidebarMenu.setVisible(data.isVisible)
    }

    if (data.hasOwnProperty("rows")) {
      for (let index in data.rows) {
        let text = data.rows[index]
        this.sidebarMenu.setRowText(index, text)
      }
    }
  }

  onObjective(data) {
    this.questMenu.update(data)
  }

  onDialogueUpdated(data) {
    this.dialogueMap = data.dialogueMap
  }

  onEndScene(data) {
    this.isScenePlaying = false
    this.exitMovieMode()

    if (this.errorFadeOutTween) {
      // clear all caption
      // this.errorFadeOutTween.stop()
      // this.errorContent.innerText = ""
      // this.errorTitle.innerText = ""
    }
  }

  enterMovieMode() {
    this.hideGameHuds()
    this.increaseLetterBox()
  }

  exitMovieMode() {
    this.showGameHuds()
    this.decreaseLetterBox()
  }

  increaseLetterBox() {
    let topBar    = document.querySelector("#top_bar_container")
    let bottomBar = document.querySelector("#bottom_bar_container")

    let height = { height: 45 }
    this.letterBoxTween = new TWEEN.Tween(height)
        .to({ height: 75 }, 1000)
        .easing(TWEEN.Easing.Quadratic.Out)
        .onUpdate(() => {
          topBar.style.height = (height.height) + "px"
          bottomBar.style.height = (height.height + 15) + "px"
        })

    this.letterBoxTween.start()
  }

  decreaseLetterBox() {
    let topBar    = document.querySelector("#top_bar_container")
    let bottomBar = document.querySelector("#bottom_bar_container")

    let height = { height: 75 }
    this.letterBoxTween = new TWEEN.Tween(height)
        .to({ height: 45 }, 1000)
        .easing(TWEEN.Easing.Quadratic.Out)
        .onUpdate(() => {
          topBar.style.height = (height.height) + "px"
          bottomBar.style.height = (height.height + 15) + "px"
        })

    this.letterBoxTween.start()
  }

  onTeamFull(data) {
    this.teamFullMenu.open(data)
  }

  onTeamLogs(data) {
    this.teamMenu.updateActivityLogs(data.activityLogs)
    this.teamMenu.updateCommandLogs(data.commandLogs)
  }

  onRegionUpdated(data) {
    if (!this.sector) return

    if (data.hasOwnProperty("region")) {
      this.sector.syncGroup(data.region, 'regions')
    }

    if (data.hasOwnProperty("displayRegion")) {
      // is for me
      if (data.playerId === this.playerId) {
        this.showRegions(data.displayRegion)
      }
    }
  }

  onButtonUpdated(data) {
    if (data.hasOwnProperty("button")) {
      this.sector.syncGroup(data.button, 'buttons')
    }
  }

  showRegions(shouldDisplayRegion) {
    if (shouldDisplayRegion) {
      this.sector.regionContainer.visible = true
    } else {
      this.sector.regionContainer.visible = false
    }
  }

  onWalkthroughUpdated(data) {
    this.walkthroughMenu.update(data)
  }

  onNPCServerMessage(data) {
    if (this.npcDialogMenu.entityId === data.entityId) {
      this.npcDialogMenu.close()
    }

    let entity = this.sector.getEntity(data.entityId)
    if (entity) {
      entity.onNPCServerMessage(data)
    }
  }

  onRailDestinations(data) {
    this.railStopMenu.renderDestinations(data)
  }

  onPlaySound(data) {
    let soundName = Helper.getSoundNameById(data.id)
    let clientSoundName = Helper.camelToSnakeCase(soundName)

    if (clientSoundName === "meeting") {
      this.playMeetingMusic()
    } else {
      this.playSound(clientSoundName)
    }
  }

  onPlayerKick(data) {
    this.gameConnection.close()
    if (data.isBan) {
      this.main.onPlayerCantJoin({ message: i18n.t("Player.Banned") })
    } else {
      this.main.onPlayerCantJoin({ message: i18n.t("Player.Kicked") })
    }

    window.history.replaceState(null, null, "?")
    this.displayHomePage()
  }

  onRemovedFromGame(data) {
    // this.gameConnection.displayRemoved()
    this.showPlayerLeaveGameMessage(data.playerName)
    if (this.sector) {
      if (this.isRoundStarted) {
        if (this.sector.originalPlayers[data.playerId] &&
            this.sector.originalPlayers[data.playerId].health === 0) {
          this.sector.setOriginalPlayerLeft(data.playerId)
        } else {
          this.sector.removeFromOriginalPlayers(data.playerId)
        }
      } else {
        this.sector.removeFromOriginalPlayers(data.playerId)
      }
    }

    this.voteMenu.rerenderPlayers()
  }

  displayHomePage() {
    this.removeDataFromPreviousGame()
    this.player = null
    this.isActive = false
    this.hideHUD()
    this.hideGameCanvas()
    this.main.showHomeMenu()
    this.main.hideMainMenu()

    this.main.displayHomePageAd()
  }

  onEntityChunkRegionPath(data) {
    this.sector.onEntityChunkRegionPath(data)
  }

  onRoomHovered(data) {
    let room = this.sector.rooms[data.id]
    if (room) {
      this.updateRoomOxygenBar(room.oxygenPercentage, 100)
    } else {
      // i.e roomId is 0, no room selected
      this.updateRoomOxygenBar(0, 100)
    }

    this.displayRoomSelection(room)
  }

  displayRoomSelection(room) {
    if (this.isRoomDisplayEnabled) {
      if (this.currentRoom !== room) {
        if (this.currentRoom) {
          this.currentRoom.hide()
        }

        if (room) {
          room.show()
        }

        this.currentRoom = room
      }
    }
  }

  onSaveProgress(data) {
    if (!data.finished) {
      document.getElementById("save_progress").style.display = 'block'
    } else {
      setTimeout(() => {
        document.getElementById("save_progress").style.display = 'none'
      }, 700)
    }
  }

  sendToMatchmaker(json) {
    this.main.sendToMatchmaker(json)
  }

  onChunkPositionChanged(data) {
    if (!this.player) return
    let visibleChunks = this.player.getVisibleChunks()
    let chunkKey = [data.row, data.col].join("-")

    // if out of bounds, we dont remove entity
    if (!visibleChunks[chunkKey] && !this.isChunkKeyOutOfBounds(data.row, data.col)) {
      // no longer present in any chunk
      let entity = this.sector.getEntity(data.entityId)
      if (entity) {
        entity.remove()
      }
    }
  }

  isChunkKeyOutOfBounds(row, col) {
    if (row < 0 || row >= this.sector.getRowCount()) return true
    if (col < 0 || col >= this.sector.getColCount()) return true
  }

  onSessionResume(data) {
    this.gameConnection.onSessionResume()
    this.playBackgroundMusic()
  }

  onUpdateHomeArea(data) {
    this.sector.homeArea.syncWithServer(data)
  }

  onHoldItemInventoryChanged(data) {
    if (data.clientMustDelete) {
      this.deleteHoldItemInventorySlot()
    } else if (this.holdItemInventorySlot) {
      this.renderInventorySlot(this.holdItemInventorySlot, data)
    } else {
      this.holdItemInventorySlot = this.createHoldItemInventorySlot()
      this.renderInventorySlot(this.holdItemInventorySlot, data)
      this.renderHoldItemAtMousePosition(this.inputController.lastClientX, this.inputController.lastClientY)
    }
  }

  throwHoldItem() {
    SocketUtil.emit("ManageStack", {
      storageId: Constants.worldStorageId,
      mode: Protocol.definition().StackOperationType.Split
    })
  }

  renderHoldItemAtMousePosition(clientX, clientY) {
    let offset = this.getHoldItemOffset()
    this.holdItemInventorySlot.style.left = (clientX - offset) + "px"
    this.holdItemInventorySlot.style.top = (clientY - offset) + "px"
  }

  getHoldItemOffset() {
    return this.holdItemInventorySlot.offsetWidth + 6
  }

  onAccountBalance(data) {
    this.atmMenu.updateBalance(data.balance)
  }

  onSellableUpdated(data) {
    if (!this.sector) return

    this.sector.setSellables(data.sellables)
    this.sector.setIsCustomSell(data.isCustomSell)
    this.sector.setPurchasables(data.purchasables)

    this.tradeMenu.initPurchasables()
  }

  onSectorUpdated(data) {
    if (!this.sector) return

    if (data.hasOwnProperty("upvoteCount")) {
      document.querySelector(".upvote_count").innerText = data.upvoteCount
    }

    this.teamMenu.updateColonySettings(data.settings)
    this.sector.setSettings(data.settings)

    if (data.hasOwnProperty("gameMode")) {
      this.sector.setGameMode(data.gameMode)
      this.initGameModeUI()
    }

    if (data.hasOwnProperty("sectorBans")) {
      this.sector.setSectorBans(data.sectorBans)
      if (this.teamMenu.activeTeam) {
        this.teamMenu.renderMembers(this.teamMenu.activeTeam)
      }
    }

    if (data.hasOwnProperty("isPrivate")) {
      this.sector.setIsPrivate(data.isPrivate)
      this.teamMenu.setSectorIsPrivate(data.isPrivate)
    }

    if (data.hasOwnProperty("buildSpeed")) {
      this.sector.setBuildSpeed(data.buildSpeed)
    }
  }

  onTeamAssignmentChanged(data) {
    this.roles = data.roles
    this.teamMenu.renderRoles()
  }

  onCameraFeedUpdated(data) {
    this.sector.cameraFeeds = data.cameraFeeds
    this.securityCameraMenu.updateCameraFeeds(this.cameraFeeds)
  }

  onRoundStarted(data) {
    this.isRoundStarted = true

    document.querySelector("#minigame_invite_container").style.display = 'none'
  }

  showMiniGameInviteLink() {
    document.querySelector("#minigame_invite_container").style.display = 'block'
  }

  onFavoriteUpdated(data) {
    if (data.hasOwnProperty("upvoteCount")) {
      this.handleUpvoteUpdated(data)
    }

    if (data.hasOwnProperty("favoriteCount")) {
      this.handleFavoriteUpdated(data)
    }
  }

  handleUpvoteUpdated(data) {
    let oldCount = parseInt(document.querySelector(".upvote_count").innerText)
    document.querySelector(".upvote_count").innerText = data.upvoteCount

    if (data.userUid === this.playerUid) {
      this.renderUpvoteFilled(!data.isRemoved)
    }
  }

  handleFavoriteUpdated(data) {
    if (data.userUid === this.playerUid) {
      if (data.isRemoved) {
        this.main.gameExplorer.removeFavoriteColonies([this.getSectorEntryData()])
      } else {
        this.main.gameExplorer.addFavoriteColonies([this.getSectorEntryData()])
      }
    }

    this.onFavoriteCountChanged()
  }

  onTeamResidentsUpdated(data) {
    this.residents = data.residents
    if (this.slaveTradeMenu.isOpen()) {
      this.slaveTradeMenu.onResidentsChanged()
    }
  }

  getSectorEntryData() {
    let name = this.sector.name

    let sectorEntry = main.gameExplorer.sectorEntries[this.sector.uid]
    if (sectorEntry) {
      name = sectorEntry.data.name
    }

    return {
      "name": name,
      "creatorUid": this.creatorUid,
      "daysAlive": this.day,
      "screenshot": null,
      "uid": this.sector.uid
    }
  }

  renderUpvoteFilled(shouldFill) {
    if (shouldFill) {
      document.querySelector(".upvote_btn").classList.add('filled')
    } else {
      document.querySelector(".upvote_btn").classList.remove('filled')
    }
  }

  onFavoriteCountChanged() {
    let favoriteEntries = this.main.gameExplorer.favoriteColonyEntries
    if (favoriteEntries[this.sector.uid]) {
      // already favorited
      document.querySelector(".sector_favorite_btn").classList.add('filled')
    } else {
      document.querySelector(".sector_favorite_btn").classList.remove('filled')
    }
  }

  updateGoldCount(gold, delta) {

    this.inventoryMenu.updateGoldCount(gold)
    this.tradeMenu.updateGoldCount(gold)
    this.sendMoneyMenu.updateGoldCount(gold, delta)
    this.vendingMachineMenu.updateGoldCount(gold, delta)
    this.atmMenu.updateGoldCount(gold, delta)
    this.slaveTradeMenu.updateGoldCount(gold, delta)

    document.querySelector(".gold.resource_count").innerText = gold
  }

  onInventoryChanged(data) {
    if (!this.player) return
    if (!data.inventory) return

    if (data.inventory.index === Constants.holdItemIndex) {
      this.onHoldItemInventoryChanged(data.inventory)
      return
    }

    this.inventoryMenu.render(data)

    this.openMenus.forEach((menu) => {
      menu.onInventoryChanged(data)
    })

    let index = data.inventory.index
    if (index === this.player.equipIndex) {
      this.player.changeEquip(index)
    }

    if (this.player.isBuilding()) {
      // if building depleted, reset
      let itemData = this.player.getActiveItem()
      if (!itemData) {
        this.player.resetBuildMode()
      }
    }
  }

  onEquipIndexChanged(data) {
    this.renderActiveEquip(data.equipIndex)
    this.player.changeEquip(data.equipIndex)
  }

  onUpdateChunkRegionPath(data) {
    this.sector.syncWithServerForGroups(["chunkRegionPaths"], data)
  }

  onlyUnique(value, index, self) {
    return self.indexOf(value) === index
  }

  onUpdateChunkRegion(data) {
    this.sector.syncWithServerForGroups(["chunkRegions"], data)

    // let chunkIds = data.chunkRegions.map((chunkRegionData) => { return chunkRegionData.chunkId })
    //                    .filter(this.onlyUnique)

    // if (this.visibleChunk && chunkIds.indexOf(this.visibleChunk.getId()) !== -1 ) {
    //   let pos = this.inputController.getGlobalMousePos()
    //   const row = Math.floor(pos.y / Constants.tileSize)
    //   const col = Math.floor(pos.x / Constants.tileSize)
    //   this.visibleChunk.showChunkRegions()
    //   let focusedChunkRegion = this.visibleChunk.getChunkRegion(row, col)
    //   if (focusedChunkRegion) {
    //     focusedChunkRegion.focus()
    //   }
    // }
  }

  onAFK(data) {
    this.isAFK = true
  }

  onMapPositions(data) {
    this.mapMenu.syncWithServer(data)
  }

  onFlowField(data) {
    if (data.clientMustDelete) {
      let path = this.sector.paths[data.id]
      if (path) {
        this.sector.removeEntity(path, "paths", data)
      }
    } else {
      this.sector.renderEntity(data, "paths")
    }
  }

  updateShipStats(ship) {
    this.shipStatSpeed.innerText  = ship.speed
    this.shipStatHealth.innerText = ship.health
    this.shipStatShield.innerText = (ship.shield && ship.shield.health) || 0
    this.shipStatEnergy.innerText = ship.energyUsage + "/" + ship.energyCapacity
    // this.shipStatMiningRate.innerText = player.speed
  }

  onSetTutorialIndex(data) {
    if (!this.shouldShowTutorial()) return

    this.tutorialMenu.update(data)
  }

  onServerRestartCountdown(data) {
    document.getElementById("server_announcement_bar").style.display = 'block'

    this.serverRestartTimestamp = data.timestamp
    this.shutdownReason = data.reason

    clearInterval(this.serverRestartInterval)
    this.serverRestartInterval = setInterval(this.renderServerRestartCountdown.bind(this), 1000)
  }

  onUpdateTeamHealth(data) {
    this.teamStatusMenu.updateMemberHealth(data)
  }

  renderServerRestartCountdown() {
    this.isServerShutdownInProgress = true
    let secondsRemaining = parseInt((this.serverRestartTimestamp - this.timestamp) / Constants.physicsTimeStep)
    if (secondsRemaining <= 0) {
      clearInterval(this.serverRestartInterval)
      secondsRemaining = 0
    }

    let formattedTime = Helper.stringifyTimeShort(secondsRemaining)

    let message = ""

    if (this.shutdownReason) {
      message += this.shutdownReason + " "
    } else {
      message += "Server will restart in "
    }

    message += formattedTime
    document.getElementById("server_announcement_message").innerText = message
  }

  initListeners() {
    window.addEventListener('resize', this.resizeCanvas.bind(this), false)

    let isOnIOS = navigator.userAgent.match(/iPad/i)|| navigator.userAgent.match(/iPhone/i)
    let unloadEvent = isOnIOS ? "pagehide" : "beforeunload"
    window.addEventListener(unloadEvent, this.onBeforeUnload.bind(this), false)

    document.getElementById("manage_team_btn").addEventListener("click", this.onManageTeamBtnClick.bind(this), true)
    document.getElementById("friends_btn").addEventListener("click", this.onFriendsBtnClick.bind(this), true)
    document.getElementById("hangar_controller_cancel_btn").addEventListener("click", this.onHangarControllerCancelBtnClick.bind(this), true)
    document.getElementById("range_toggle_btn").addEventListener("click", this.onRangeViewBtnClick.bind(this), true)
    document.getElementById("restart_btn").addEventListener("click", this.onRestartBtnClick.bind(this), true)
    document.getElementById("chat_input").addEventListener("blur", this.onChatInputBlur.bind(this), true)
    document.getElementById("chat_toggle_btn").addEventListener("click", this.onChatToggleBtnClick.bind(this), true)
    document.getElementById("zoom_in_btn").addEventListener("click", this.onZoomInBtnClick.bind(this), true)
    document.getElementById("zoom_out_btn").addEventListener("click", this.onZoomOutBtnClick.bind(this), true)
    document.getElementById("blueprint_open_btn").addEventListener("click", this.onBlueprintOpenBtnClick.bind(this), true)
    document.getElementById("inventory_open_btn").addEventListener("click", this.onInventoryOpenBtnClick.bind(this), true)
    document.getElementById("map_open_btn").addEventListener("click", this.onMapOpenBtnClick.bind(this), true)
    document.getElementById("visit_colony_hud_btn").addEventListener("click", this.onVisitColonyHudBtnClick.bind(this), true)
    document.getElementById("command_block_hud_btn").addEventListener("click", this.onCommandBlockHudBtnClick.bind(this), true)
    document.getElementById("room_display_toggle_btn").addEventListener("click", this.onRoomDisplayToggleBtnClick.bind(this), true)
    document.getElementById("home_area_display_toggle_btn").addEventListener("click", this.onHomeAreaDisplayToggleBtnClick.bind(this), true)
    document.getElementById("chunk_toggle_btn").addEventListener("click", this.onChunkToggleBtnClick.bind(this), true)
    document.getElementById("tutorial_toggle_btn").addEventListener("click", this.onTutorialOpenBtnClick.bind(this), true)
    document.querySelector(".sector_favorite_btn").addEventListener("click", this.onSectorFavoriteBtnClick.bind(this), true)
    document.querySelector(".upvote_btn").addEventListener("click", this.onSectorUpvoteBtnClick.bind(this), true)
    document.querySelector(".play_again_btn").addEventListener("click", this.onPlayAgainBtnClick.bind(this), true)
    document.querySelector(".exit_minigame_btn").addEventListener("click", this.onExitMinigameBtnClick.bind(this), true)
    document.querySelector(".spectate_btn").addEventListener("click", this.onSpectateBtnClick.bind(this), true)
    document.querySelector("#minigame_invite_container .invite_link_input").addEventListener("click", this.onMiniGameInviteInputClick.bind(this), true)
    document.querySelector("#minigame_invite_container .start_minigame_btn").addEventListener("click", this.onStartMiniGameBtnClick.bind(this), true)

    document.querySelector("#player_quick_inventory").addEventListener("click", this.onQuickInventoryClick.bind(this), true)


    document.querySelector("#hangar_controller_menu").addEventListener("click", (event) => {
      let hangarList = event.target.closest("#hangar_list")
      if (!hangarList) return

      let prevActiveItem = hangarList.querySelector("[data-active='true']")
      if (prevActiveItem) {
        prevActiveItem.dataset.active = false
      }

      let hangarListItem = event.target.closest(".hangar_list_item")
      hangarListItem.dataset.active = true
      let hangarId = hangarListItem.dataset.id

      let hangar = this.sector.hangars[hangarId]

      player.setActiveBuildingContainer(hangar)

    })

  }

  onDockClicked(entity) {
    SocketUtil.emit("DockShip", { shipId: player.ship.id, hangarControllerId: entity.id })
  }

  onRepairBtnClick(e) {
    SocketUtil.emit("Repair", {})
  }

  onManageTeamBtnClick(e) {
    if (this.isInGameMenuOpen()) return
    this.toggleTeamMenu()
  }

  onFriendsBtnClick(e) {
    if (this.isInGameMenuOpen()) return
    this.toggleFriendsMenu()
  }

  selectEntity(entity) {
    this.sector.select(entity)
  }

  resetEntitySelection() {
    this.unselectEntity(this.sector.persistentSelection.selectedEntity)

    if (this.entityMenu.selectedEntity) {
      this.entityMenu.removeSelectedEntity()
      this.entityMenu.close()
    }
  }

  unselectEntity(entity) {
    this.sector.unselect(entity)
  }

  onHangarControllerCancelBtnClick(e) {
    document.querySelector("#hangar_controller_menu").style.display = 'none'
  }

  openHangarController() {
    this.closeAllMenus()

    document.querySelector("#hangar_controller_menu").style.display = 'block'
    document.querySelector("#hangar_list").innerHTML = this.buildHangarListHTML()
  }

  buildHangarListHTML() {
    return Object.keys(this.sector.hangars).map((id) => { return "<div class='hangar_list_item' data-id='" + id + "'> Hangar " + id + "</div>" })
  }

  onRestartBtnClick() {
    if (!this.player) return

    if (this.player.health > 0) {
      this.hideDeathMessage()
    } else {
      SocketUtil.emit("RespawnRequest", { })
    }
  }

  onChatInputBlur(e) {
    if (e.target.id === 'chat_input') return

    this.chatMenu.close()
  }

  toggleMainMenus() {
    if (document.querySelector("#hud_action_container").style.display === "none") {
      this.showGameHuds()
    } else {
      this.hideGameHuds()
    }
  }

  isImposterGame() {
    return this.sector.getOriginalUid() === "eWC1CfZymRExY" ||
           this.sector.getOriginalUid() === "Ap9OYBkw3dQvJ"
  }

  showGameHuds() {
    this.hideMainMenus = false

    if (!this.isMiniGame()) {
      document.querySelector("#player_stats").style.display = "block"
    } else {
      if (this.isImposterGame()) {
        document.querySelector(".total_task_stat").style.display = "block"
      } else {
        document.querySelector(".total_task_stat").style.display = "none"
        document.querySelector("#player_stats").style.display = "block"
      }
    }

    if (this.shouldShowMiniMap()) {
      document.querySelector("#mini_map_menu").style.display = "block"
      document.querySelector("#mini_map_player_pos_label").style.display = "block"
    }

    document.querySelector("#entity_menu").setAttribute('style', 'display: block')

    if (!this.sidebarMenu.isEmpty()) {
      document.querySelector("#sidebar_menu").style.display = 'block'
    }

    if (this.shouldShowTutorial()) {
      document.querySelector("#tutorial_menu").style.display = "block"
    }

    document.querySelector("#player_quick_inventory_menu").style.display = "block"
    document.querySelector("#chat_container").style.display = "block"
    document.querySelector("#team_status_menu").style.display = "block"

    document.querySelector(".resources").style.display = 'block'
    document.querySelector("#hud_action_container").style.display = 'block'
    document.querySelector("#time_label").style.display = 'block'
    document.querySelector("#player_quick_inventory_menu").style.display = 'block'
    document.querySelector(".room_oxygen_stat").style.display = 'block'
    document.querySelector("#status_list_menu").style.display = 'block'
    document.querySelector("#quest_menu").style.display = 'block'

    if (this.shouldShowFavoriteButton()) {
      document.querySelector("#sector_action_menu").style.display = "block"
    }

    if (this.shouldShowLeaderboard()) {
      document.querySelector("#leaderboard_menu").style.display = "block"
    }

    // document.querySelector("#tutorial_toggle_btn").style.display = "block"
  }

  shouldShowLeaderboard() {
    return this.isPvP()
  }

  shouldShowMiniMap() {
    return this.sector.shouldShowMiniMap()
  }

  shouldShowTutorial() {
    if (this.isPvP()) return true
    if (!this.sector) return false
    if (this.sector.isPeaceful()) {
      if (this.sector.uid.match('PnGkJd5xZsb0v')) return true
      return false
    }

    if (this.isTutorial() || this.main.isMobile || !this.isGameCreatedByPlayer()) return false

    return true
  }

  shouldShowQuests() {
    return false
  }

  hideGameHuds() {
    this.hideMainMenus = true
    document.querySelector("#player_stats").style.display = "none"
    document.querySelector(".total_task_stat").style.display = "none"
    document.querySelector("#mini_map_menu").style.display = "none"
    document.querySelector("#mini_map_player_pos_label").style.display = "none"
    document.querySelector("#entity_menu").style.display = "none"
    document.querySelector("#tutorial_menu").style.display = 'none'
    // document.querySelector("#player_quick_inventory_menu").style.display = "none"
    document.querySelector("#chat_container").style.display = "none"
    document.querySelector("#performance_stats").style.display = "none"
    document.querySelector("#team_status_menu").style.display = "none"
    document.querySelector("#sector_action_menu").style.display = "none"
    document.querySelector("#leaderboard_menu").style.display = "none"

    document.querySelector(".resources").style.display = 'none'
    document.querySelector("#hud_action_container").style.display = 'none'
    document.querySelector("#time_label").style.display = 'none'
    document.querySelector("#player_quick_inventory_menu").style.display = 'none'
    document.querySelector(".room_oxygen_stat").style.display = 'none'
    document.querySelector("#status_list_menu").style.display = 'none'
    document.querySelector("#quest_menu").style.display = 'none'
    document.querySelector("#sidebar_menu").style.display = 'none'

    // document.querySelector("#tutorial_toggle_btn").style.display = "none"
  }

  shouldShowFavoriteButton() {
    if (this.isTutorial() || this.isAnonymousGame() || this.isMiniGame()) {
      return false
    }

    return true
  }

  toggleChatMenu() {
    if (this.chatMenu.isOpen()) {
      this.chatMenu.close()
    } else {
      if (this.sector.shouldShowChat()) {
        this.chatMenu.open()
      }
    }
  }

  isInGameMenuOpen() {
    let el = document.querySelector("#welcome_container")
    if (!el) return false
    return el.style.display === 'block'
  }

  onBlueprintOpenBtnClick() {
    if (this.isInGameMenuOpen()) return
    this.blueprintMenu.open()
  }

  onChatToggleBtnClick() {
    this.toggleChatMenu()
  }

  onInventoryOpenBtnClick() {
    if (this.isInGameMenuOpen()) return
    this.toggleInventory()
  }

  onMapOpenBtnClick() {
    if (this.isInGameMenuOpen()) return
    this.toggleMapMenu()
  }

  onVisitColonyHudBtnClick() {
    if (this.isInGameMenuOpen()) return
    this.toggleVisitColonyMenu()
  }

  onCommandBlockHudBtnClick() {
    if (this.isInGameMenuOpen()) return
    this.toggleCommandBlockMenu()
  }

  toggleBlueprintMenu() {
    if (this.sector.settings.isCraftingEnabled) {
      this.blueprintMenu.toggle()
    }
  }

  toggleMapMenu() {
    this.mapMenu.toggle()
  }

  toggleVisitColonyMenu() {
    if (this.isPvP()) return
    if (main.impy) return

    document.querySelector(".search_colony_list").style.display = 'none'
    document.querySelector(".main_colony_list").style.display = 'block'

    this.visitColonyMenu.toggle()
  }

  toggleCommandBlockMenu() {
    if (this.isSandbox()) {
      this.commandBlockMenu.toggle()
    }
  }

  toggleFriendsMenu() {
    this.friendsMenu.toggle()
  }

  onRoomDisplayToggleBtnClick() {
    let el = document.getElementById("room_display_toggle_btn")
    el.dataset.toggled = el.dataset.toggled === 'true' ? 'false' : true
    this.isRoomDisplayEnabled = el.dataset.toggled === 'true'
  }

  onSectorFavoriteBtnClick() {
    SocketUtil.emit("SectorAction", { action: "favorite", sectorId: this.sector.uid })
  }

  onSectorUpvoteBtnClick() {
    SocketUtil.emit("SectorAction", { action: "upvote", sectorId: this.sector.uid })
  }

  onPlayAgainBtnClick() {
    if (!this.isMiniGame()) return
    if (this.sector.isPrivate) return

    let uid = this.sector.getOriginalUid()

    // in some cases, we might player to just respawn in same game instance
    // instead of joining a diff one

    this.main.gameExplorer.joinMiniGame(uid, { prevMiniGameId: this.sector.uid })
    this.hideDeathMessage()
  }

  onExitMinigameBtnClick() {
    this.hideDeathMessage()
    this.main.onExitGameMenuBtnClick()
  }

  onSpectateBtnClick() {
    this.hideDeathMessage()
  }

  onStartMiniGameBtnClick(e) {
    SocketUtil.emit("StartRound", { })
  }

  onMiniGameInviteInputClick(e) {
    e.target.select()
    document.execCommand('copy')
  }

  onTutorialOpenBtnClick() {
    if (this.tutorialMenu.isTutorialComplete()) return

    document.querySelector("#tutorial_toggle_btn").style.display = 'none'
    this.tutorialMenu.open()
  }

  onTutorialCloseClick() {
    this.tutorialMenu.onCancelBtnClick()
  }

  toggleTutorial() {
    if (!this.shouldShowTutorial()) return

    if (this.tutorialMenu.isOpen()) {
      this.onTutorialCloseClick()
    } else {
      this.onTutorialOpenBtnClick()
    }
  }

  onChunkToggleBtnClick() {
    let el = document.getElementById("chunk_toggle_btn")
    el.dataset.toggled = el.dataset.toggled === 'true' ? 'false' : true
    this.isChunkDisplayEnabled = el.dataset.toggled === 'true'

    if (!this.isChunkDisplayEnabled && this.visibleChunk) {
      this.visibleChunk.hideDebug()
      this.visibleChunk.hideChunkRegions()
      this.visibleChunk = null
    }

    if (!this.isTracingChunkRegionPath) {
      this.isTracingChunkRegionPath = true
      SocketUtil.emit("Debug", { type: "chunk_region_path" })
    }
  }

  onHomeAreaDisplayToggleBtnClick() {
    let el = document.getElementById("home_area_display_toggle_btn")
    if (el.dataset.toggled === 'true') {
      el.dataset.toggled = 'false'
      this.sector.homeArea.sprite.alpha = 0
    } else {
      el.dataset.toggled = 'true'
      this.sector.homeArea.sprite.alpha = 1
    }
  }

  showChunkRegionPathForEntity(entity) {
    SocketUtil.emit("RequestEntityChunkRegionPath", { entityId: entity.getId() })

    this.shownChunkRegionPaths.forEach((chunkRegionPath) => {
      chunkRegionPath.hide()
    })

    setTimeout(() => {
      // wait until its received from server
      this.shownChunkRegionPaths = this.sector.getChunkRegionPathsFromEntityId(entity.getId())
      this.shownChunkRegionPaths.forEach((chunkRegionPath) => {
        chunkRegionPath.show()
      })
    }, 1000)
  }

  showChunk(clientX, clientY) {
    const cameraPositionX = -this.cameraDisplacement.x
    const cameraPositionY = -this.cameraDisplacement.y
    const x = (cameraPositionX + clientX) / this.resolution
    const y = (cameraPositionY + clientY) / this.resolution

    const row = Math.floor(y / Constants.tileSize)
    const col = Math.floor(x / Constants.tileSize)

    const chunkRow = Math.floor(row / Constants.chunkRowCount)
    const chunkCol = Math.floor(col / Constants.chunkColCount)

    let chunk = this.sector.getChunk(chunkRow, chunkCol)
    let chunkRegion

    if (chunk) {
      chunkRegion = chunk.getChunkRegion(row, col)
    }

    if (this.visibleChunk !== chunk) {
      let prevShownChunk = this.visibleChunk
      this.visibleChunk = chunk
      this.onShownChunkChanged(prevShownChunk, chunk, row, col)
    }

    if (this.visibleChunkRegion !== chunkRegion) {
      let prevShownChunkRegion = this.visibleChunkRegion
      this.visibleChunkRegion = chunkRegion
      this.onShownChunkRegionChanged(prevShownChunkRegion, chunkRegion, row, col)
    }

  }

  onShownChunkRegionChanged(prevShownChunkRegion, chunkRegion, row, col) {
    if (prevShownChunkRegion) {
      prevShownChunkRegion.unfocus()
    }

    if (chunkRegion) {
      chunkRegion.focus()
    }
  }

  onShownChunkChanged(prevShownChunk, chunk, row, col) {
    if (prevShownChunk) {
      prevShownChunk.hideDebug()
      prevShownChunk.hideChunkRegions()
    }

    if (chunk) {
      chunk.showDebug()
      chunk.showChunkRegions(row, col)
    }
  }

  onRangeViewBtnClick(e) {
    if (this.player.ship) {
      this.player.ship.toggleRangeLayer()
    }
  }

  toggleTeamMenu() {
    this.teamMenu.toggle()
  }

  displayError(msg, options = {}) {
    msg = i18n.t(msg)

    if (!this.errorFadeOutTween) {
      this.errorFadeInTween = ClientHelper.getFadeTween(this.errorContent.parentElement, 0, 1, 0)
      this.errorFadeInTween.start()
    } else {

    }

    this.errorContent.parentElement.style.display = 'block'

    let textContent
    if (options.isTitle) {
      textContent = this.errorTitle
    } else {
      textContent = this.errorContent
    }

    textContent.innerText = msg
    textContent.className = ""

    if (options.isTitle) {
      if (options.color) {
        textContent.style.color = options.color
      } else {
        textContent.style.color = "yellow"
      }
    }

    if (options.size) {
      textContent.style.fontSize = options.size + "px"
    } else {
      if (options.isTitle) {
        textContent.style.fontSize = "60px"
      } else {
        textContent.style.fontSize = "30px"
      }
    }

    if (options.warning) {
      textContent.classList.add("warning")
    }

    if (options.success) {
      textContent.classList.add("success")
    }

    if (options.transparent) {
      textContent.classList.add("transparent")
    }

    if (this.errorFadeOutTween) {
      // reset it
      this.errorFadeOutTween.stop()
    }

    this.errorFadeOutTween = ClientHelper.getFadeTween(this.errorContent.parentElement, 1, 0, 5000)
    this.errorFadeOutTween.start()
    this.errorFadeOutTween.onStop(() => {
      this.errorFadeOutTween = null
    })

    this.errorFadeOutTween.onComplete(() => {
      this.errorFadeOutTween = null
      this.errorContent.innerText = ""
      this.errorTitle.innerText = ""
    })
  }

  isPvP() {
    if (!this.sector) return false
    return this.sector.isPvP()
  }

  isSandbox() {
    return this.isPeaceful()
  }

  isPeaceful() {
    if (!this.sector) return false
    return this.sector.isPeaceful()
  }

  isHardcore() {
    if (!this.sector) return false
    return this.sector.isHardcore()
  }

  async submitGameRequest(username, options = {}) {
    let data = {
      username: username,
      screenWidth: this.getScreenWidth(),
      screenHeight: this.getScreenHeight(),
      sessionId: this.main.sessionId,
      locale: window.language,
      fingerprint: this.main.fingerprint
    }

    if (options.sectorId) data["sectorId"] = options.sectorId
    if (options.isNewTeam) data["isNewTeam"] = true

    const url = this.main.getBrowserHref()
    const isTroubleshooter = url.match(new RegExp(".*?stress=(.*)"))
    if (isTroubleshooter) data["isTroubleshooter"] = true

    if (this.main.user) {
      let idToken = await this.main.getFirebaseIdToken()
      if (idToken) {
        data["idToken"] = idToken
        data["username"] = this.main.username
        data["uid"] = this.main.uid
      }

      SocketUtil.emit("RequestGame", data)
    } else {
      SocketUtil.emit("RequestGame", data)
    }
  }

  requestGame(options = {}) {
    this.requestGameTime = (new Date()).getTime()

    document.getElementById("home_error_message").innerText = ""
    const username = document.getElementById("name_input").value

    this.submitGameRequest(username, options)
  }

  resumeGame() {
    if (!this.sector) return
    this.requestGameTime = (new Date()).getTime()

    let data = {
      sessionId: this.main.sessionId,
      screenWidth: this.getScreenWidth(),
      screenHeight: this.getScreenHeight(),
      sectorId: this.sector.uid,
      locale: window.language
    }

    if (this.main.idToken) {
      data.idToken = this.main.idToken
      data.uid = this.main.uid
    }

    SocketUtil.emit("ResumeGame", data)
  }

  toggleInventory() {
    this.inventoryMenu.toggle()
  }


  onQuickInventoryClick(event) {
    const inventorySlot = event.target.closest(".inventory_slot")
    if (!inventorySlot) return

    if (inventorySlot.className.indexOf("ellipsis") > 0) {
      this.toggleInventory()
    } else {
      const index = inventorySlot.dataset.index
      SocketUtil.emit("ChangeEquip", { index: index })
    }
  }

  sellBuilding(building) {
    SocketUtil.emit("Sell", { type: building.getUpgradeType(), id: building.id })
    this.closeEntityMenu()
  }

  autoAdjustResolution() {
    if (!this.sector) return
    if (!this.player) return

    if (this.sector.isZoomAllowed()) return

    const nativeResolution = {
      width: 1280,
      height: 768
    }

    const deviceWidth = this.getCanvasWidth()
    const deviceHeight = this.getCanvasHeight()

    let scaleFactor = deviceWidth / nativeResolution.width
    let minScale = this.isMobile() ? 0.8 : 1
    scaleFactor = Math.max(minScale, scaleFactor)
    scaleFactor = Math.min(1.2, scaleFactor)

    clearTimeout(this.updateCanvasResolutionTimeout)
    this.updateCanvasResolutionTimeout = setTimeout(() => {
      this.resolution = scaleFactor
      this.updateCanvasResolution()
      this.onResolutionChanged()
    }, 500)
  }

  onResolutionChanged() {
    this.centerCameraToCameraFocusTarget()
  }

  centerCameraToCameraFocusTarget() {
    if (!this.player) return

    let cameraFocusTarget = this.player.getCameraFocusTarget()
    if (cameraFocusTarget.isPositionBased) {
      this.centerCameraToXY(cameraFocusTarget.x, cameraFocusTarget.y)
    } else {
      this.centerCameraTo(cameraFocusTarget)
    }
  }


  updateCanvasResolution() {
    this.gameLayer.scale.set(this.resolution)

    let browserResolution = this.getPixelRatio()
    let canvasWidth  = this.getCanvasWidth() * browserResolution
    let canvasHeight = this.getCanvasHeight() * browserResolution

    this.app.renderer.view.style.width  = this.getCanvasWidth()  + 'px'
    this.app.renderer.view.style.height = this.getCanvasHeight() + 'px'

    this.app.renderer.resize(canvasWidth, canvasHeight)
  }

  getPixelRatio() {
    return Math.min(1, window.devicePixelRatio)
  }

  resizeCanvas(options = {}) {
    if (this.hudAlertContainer) {
      this.hudAlertContainer.width = window.innerWidth
      this.hudAlertContainer.height = window.innerHeight
    }

    let browserResolution = this.getPixelRatio()
    let canvasWidth  = this.getCanvasWidth() * browserResolution
    let canvasHeight = this.getCanvasHeight() * browserResolution

    this.app.renderer.resize(canvasWidth, canvasHeight)
    this.app.renderer.view.style.width  = this.getCanvasWidth()  + 'px'
    this.app.renderer.view.style.height = this.getCanvasHeight() + 'px'
    this.autoAdjustResolution()

    // center player only after dimensions/resolution have changed
    if (this.player) {
      this.centerCameraToCameraFocusTarget()
      this.player.cullChunks()

      if (this.player.hangar) {
        this.sector.hangarFadeBlackSprite.width = this.getCanvasWidth()
        this.sector.hangarFadeBlackSprite.height = this.getCanvasHeight()
      }
    }

    this.updateServerUpdateRate(this.getScreenWidth(), this.getScreenHeight())

    SocketUtil.emit('WindowResized', { screenWidth: this.getScreenWidth(), screenHeight: this.getScreenHeight(), isZoom: options.zoom })
  }

  getScreenWidth() {
    return this.getCanvasWidth() / this.resolution
  }

  getScreenHeight() {
    return this.getCanvasHeight() / this.resolution
  }

  updateServerUpdateRate(screenWidth, screenHeight) {
    this.server_update_rate = this.getServerUpdateRate(screenWidth)
    this.latencyCalculateIntervalInSeconds = 2
    this.maxUpstreamIntervals = []
  }

  getServerUpdateRate(screenWidth, screenHeight) {
    const multiplier = this.getServerUpdateRateMultiplier(screenWidth, screenHeight)
    return Constants.physicsTimeStep / multiplier
  }

  getServerUpdateRateMultiplier(screenWidth, screenHeight) {
    if (screenWidth > 4000) {
      return 4
    } else if (screenWidth > 3000) {
      return 3
    } else if (screenWidth > 2000) {
      return 2
    } else {
      return 1
    }
  }

  onSyncWithServer(data) {
    this.timestamp = data.timestamp

    this.markPacketTick()
    this.recordUpstreamRate()
    this.renderTickDuration(data)
    this.renderMemory(data)

    if (this.sector) {
      this.sector.syncWithServer(data)
    }

    if (this.player) {
      this.renderPlayerCamera(data)
    }

    if (this.sector) {
      this.renderHour(data)
      this.renderDay(data)
    }
  }

  onUpdateStats(data) {
    if (!this.player) return

    let stats = ["gold", "oxygen", "stamina", "hunger", "thirst"]

    stats.forEach((stat) => {
      if (data.hasOwnProperty(stat)) {
        let setter = "set" + Helper.capitalize(stat)
        let value  = data[stat]

        if (data.entityId) {
          let entity = this.sector.getEntity(data.entityId)
          if (entity && entity[setter]) {
            entity[setter](value)
          }
        } else {
          this.player[setter](value)
        }
      }
    })

    if (data.hasOwnProperty("taskCompleted")) {
      this.updateTotalTasksBar(data.taskCompleted, data.totalTasks)
    }

    if (data.hasOwnProperty("colorIndex")) {
      this.colorPickerMenu.setColorIndex(data.colorIndex)
    }

    if (data.hasOwnProperty("textureIndex")) {
      this.colorPickerMenu.setTextureIndex(data.textureIndex)
    }
  }

  onBreakBuilding(data) {
    let building = this.sector.buildings[data.id]
    if (building) {
      building.break(data.progress)
    }
  }

  onDebugRange(data) {
    this.sector.drawRange(data.box)
  }

  onProgressCircle(data) {
    if (data.completeTimestamp) {
      this.sector.startProgressCircle(data.completeTimestamp)
    } else if (data.clientMustDelete) {
      this.sector.hideProgressCircle()
    }

  }

  onAnimate(data) {
    if (!this.sector) return
    let entity = this.sector.getEntity(data.entityId)
    if (entity) {
      if (data.animation) {
        if (data.animation === "heart") {
          entity.animateHeart()
        }
      } else if (data.shouldStop) {
        entity.stopEquipmentAnimation()
      } else if (typeof entity.animateEquipment === 'function') {
        entity.animateEquipment()
      }
    }
  }

  markPacketTick() {
    this.ticksSincePacket = 0
  }

  recordUpstreamRate() {
    if (this.firstServerMessage) {
      this.firstServerMessage = false
      return
    }

    let time = Date.now()
    if (this.lastUpstreamTime) {
      let upstreamInterval = time - this.lastUpstreamTime
      this.upstreamIntervals.push(upstreamInterval)
      if (this.upstreamIntervals.length >= (this.server_update_rate)) {
        window.upstream_debug = this.upstreamIntervals.slice()
        this.upstreamIntervals.sort((a, b) => { return a - b })
        let min = this.upstreamIntervals[0]
        let max = this.upstreamIntervals[this.upstreamIntervals.length - 1]
        let avg = Math.floor(this.upstreamIntervals.reduce((sum, val) => { return sum + val }) / this.upstreamIntervals.length)
        let upstreamEl = document.querySelector("#performance_stats #upstream .value")
        if (upstreamEl) {
          upstreamEl.innerText = avg + " ms"
        }

        this.upstreamIntervals = []
        this.maxUpstreamInterval = max

        if (!this.firstTenSecondsMaxUpstreamInterval) {
          // initial value
          let multiplier = this.getServerUpdateRateMultiplier(this.getScreenWidth())
          this.firstTenSecondsMaxUpstreamInterval = 200 // assume bad network in first 10 sec
        }

        this.maxUpstreamIntervals.push(this.maxUpstreamInterval)
        if (this.maxUpstreamIntervals.length >= this.latencyCalculateIntervalInSeconds) {
          this.calculateLatency()
          this.latencyCalculateIntervalInSeconds = 10 // set it back to orig
        }
      }
    }
    this.lastUpstreamTime = time
  }

  calculateLatency() {
    // every 10 sec
    let avg = Math.floor(this.maxUpstreamIntervals.reduce((sum, val) => { return sum + val }) / this.maxUpstreamIntervals.length)
    let multiplier = this.getServerUpdateRateMultiplier(this.getScreenWidth())
    this.firstTenSecondsMaxUpstreamInterval = avg

    // console.log("upsteam : " + this.firstTenSecondsMaxUpstreamInterval)
    this.maxUpstreamIntervals = []
  }


  toggleAdminMode() {
    this.chatMenu.chatInput.value = "/admin"
    this.chatMenu.submit()
  }

  renderTickDuration(data) {
    if (!data.hasOwnProperty("tick")) return
    document.querySelector("#performance_stats #tick .value").innerText = data.tick + " ms"
  }

  renderMemory(data) {
    if (!data.hasOwnProperty("memory")) return
    document.querySelector("#performance_stats #server_memory .value").innerText = data.memory + " MB"
  }

  renderHour(data) {
    if (!data.hasOwnProperty("hour")) return

    if (this.hour !== data.hour) {
      this.hour = data.hour
      this.onHourChanged()
    }
  }

  renderDay(data) {
    if (!data.hasOwnProperty("day")) return

    if (this.day !== data.day) {
      this.day = data.day
      this.onDayChanged()
    }
  }

  onDayChanged() {
    document.querySelector("#day_label").innerText = this.day + ""

    if (this.isLoggedIn() && this.isCreatedByPlayer()) {
      this.updateScreenshot()
    }
  }

  updateScreenshot() {
    // wait for at least few seconds game load before screenshot
    if (Date.now() - this.sector.initialLoadTime < 5000) return

    if (this.sector.getScreenshotCount() === 0) {
      this.screenshot(Constants.autoscreenshotPosition)
      return
    }

    if (this.sector.getScreenshotCount() === 1) {
      let screenshotKey = Object.keys(this.sector.screenshots)[0]
      let screenshotPosition = this.sector.screenshots[screenshotKey]

      if (screenshotPosition === Constants.autoscreenshotPosition &&
          (!this.lastScreenshotDay || this.day - this.lastScreenshotDay >= 5)) {
        SocketUtil.emit("RemoveScreenshot", { id: screenshotKey })
        this.screenshot(Constants.autoscreenshotPosition)
      }
    }
  }

  onHourChanged() {
    document.querySelector("#hour_label").innerText = this.hour

    const isNight = this.hour < 6 || this.hour >= 18

    if (this.isNight !== isNight) {
      this.isNight = isNight
      this.onDayNightChanged()
    }

    this.sector.lightManager.setDarkness(this.hour)
  }

  onDayNightChanged() {
  }

  renderPlayerCamera(data) {
    this.player.setCamera(data.camera)
  }

  isModalMenuOpen() {
    return this.openMenus.filter((menu) => {
      return menu.isModal()
    }).length > 0
  }

  onMenuInteract(cmd) {
    this.openMenus.forEach((menu) => {
      menu.onMenuInteract(cmd)
    })
  }

  renderActiveEquip(index) {
    const quickInventoryIndex = index

    const activeInventorySlot = document.querySelector("#player_quick_inventory .player_inventory_slot.active")
    if (activeInventorySlot) {
      activeInventorySlot.className = "player_inventory_slot inventory_slot"
    }

    let inventorySlot = document.querySelector("#player_quick_inventory .player_inventory_slot[data-index='" + quickInventoryIndex + "']")
    if (inventorySlot) {
      inventorySlot.className = "player_inventory_slot inventory_slot active"

      if (this.isMobile()) {
        let imageSrc = inventorySlot.querySelector("img").getAttribute('src')
        let itemCount = inventorySlot.dataset.content
        this.mobilePrimaryActionBtn.querySelector("img").src = imageSrc
        this.mobilePrimaryActionBtn.dataset.content = itemCount
        this.mobilePrimaryActionBtn.dataset.id = inventorySlot.dataset.id
        this.mobilePrimaryActionBtn.dataset.type = inventorySlot.dataset.type

        let equipmentKlass = Equipments.forType(inventorySlot.dataset.type)
        if (!equipmentKlass) {
          this.removeItemUsageFor(this.mobilePrimaryActionBtn)
          return
        }
        if (equipmentKlass.prototype.isUnbreakable() && !equipmentKlass.prototype.shouldShowUsage()) {
          this.removeItemUsageFor(this.mobilePrimaryActionBtn)
          return
        }

        if (inventorySlot.dataset.usage) {
          let usage = parseInt(inventorySlot.dataset.usage)
          let maxUsage = equipmentKlass.prototype.getUsageCapacity()
          this.renderItemUsageFor(this.mobilePrimaryActionBtn, usage, maxUsage)
        } else {
          this.removeItemUsageFor(this.mobilePrimaryActionBtn)
        }
      }
    }
  }

  isContentFillable(inventoryType) {
    const fillables = [Protocol.definition().BuildingType.Syringe,
                       Protocol.definition().BuildingType.Bottle]

    return fillables.indexOf(inventoryType) !== -1
  }

  getImageSrcForItemType(type) {
    let imgSrc

    imgSrc = "/assets/images/" + Item.getSpritePath(type)

    return imgSrc
  }

  createHoldItemInventorySlot() {
    const div = document.createElement("div")
    div.className = "inventory_slot hold_item_slot"

    const img = document.createElement("img")
    div.appendChild(img)

    document.body.appendChild(div)

    return div
  }

  deleteHoldItemInventorySlot() {
    if (this.holdItemInventorySlot) {
      if (this.holdItemInventorySlot.parentElement) {
        this.holdItemInventorySlot.parentElement.removeChild(this.holdItemInventorySlot)
      }
      this.holdItemInventorySlot = null
    }

    this.isHoldItemDeletedRecently = true
  }

  cleanInventoryCooldowns() {
    for (let index in this.inventoryCooldowns) {
      let inventorySlot = document.querySelector(".player_inventory_slot[data-index='" + index + "']")
      if (inventorySlot) {
        if (inventorySlot.querySelector(".cooldown_overlay")) {
          inventorySlot.querySelector(".cooldown_overlay").innerText = ""
          inventorySlot.querySelector(".cooldown_overlay").style.display = "none"
        }
      }
      clearInterval(this.inventoryCooldowns[index])
      delete this.inventoryCooldowns[index]
    }
  }

  createCooldownRenderInterval(inventorySlot, data, cooldownSeconds) {
    return setInterval(() => {
      if (this.player.mountedId || this.voteMenu.isOpen()) {
        return
      }
      let seconds = Math.floor((this.timestamp - data.lastUsedTimestamp) / Constants.physicsTimeStep)
      let remaining = cooldownSeconds - seconds
      if (remaining > 0) {
        if (inventorySlot.querySelector(".cooldown_overlay")) {
          inventorySlot.querySelector(".cooldown_overlay").innerText = remaining
          inventorySlot.querySelector(".cooldown_overlay").style.display = 'block'
        }
      } else {
        if (inventorySlot.querySelector(".cooldown_overlay")) {
          inventorySlot.querySelector(".cooldown_overlay").style.display = 'none'
        }
        clearInterval(this.inventoryCooldowns[data.index])
        delete this.inventoryCooldowns[data.index]
      }
    }, 1000)
  }

  renderInventoryCooldown(inventorySlot, data) {
    let klass = Item.getKlass(data.type)
    if (!klass.prototype.shouldShowCooldown()) return

    let cooldownSeconds = Math.floor(klass.prototype.getStats().reload / 1000)
    let seconds = Math.floor((this.timestamp - data.lastUsedTimestamp) / Constants.physicsTimeStep)
    if (seconds < cooldownSeconds) {
      if (this.inventoryCooldowns[data.index]) {
        clearInterval(this.inventoryCooldowns[data.index])
      }

      this.inventoryCooldowns[data.index] = this.createCooldownRenderInterval(inventorySlot, data, cooldownSeconds)
    }
  }

  renderInventorySlot(inventorySlot, data) {
    inventorySlot.querySelector("img").src = this.getImageSrcForItemType(data.type)
    if (data.id) {
      inventorySlot.dataset.id    = data.id
    }
    inventorySlot.dataset.type  = data.type

    inventorySlot.dataset.content = data.count === 1 ? "" : data.count
    inventorySlot.dataset.special = data.instance ? data.instance.content : ""

    // show item count in primary action btn
    if (this.isMobile() && inventorySlot.dataset.id === this.mobilePrimaryActionBtn.dataset.id) {
      this.mobilePrimaryActionBtn.dataset.content = data.count === 1 ? "" : data.count
    }

    if (data.lastUsedTimestamp) {
      this.renderInventoryCooldown(inventorySlot, data)
    }

    if (data.instance) {
      inventorySlot.dataset.usage = data.instance.usage
      this.renderInventorySlotUsage(inventorySlot, data.instance.usage)
    } else {
      inventorySlot.dataset.usage = ""
      this.removeInventorySlotUsage(inventorySlot)
    }
  }

  resetInventorySlot(inventorySlot) {
    inventorySlot.querySelector("img").src = ""
    inventorySlot.dataset.id = ""
    inventorySlot.dataset.type = ""
    inventorySlot.dataset.content = ""

    this.removeInventorySlotUsage(inventorySlot)
  }

  resetMobilePrimaryActionBtn(inventorySlot) {
    if (inventorySlot.dataset.id === this.mobilePrimaryActionBtn.dataset.id) {
      this.mobilePrimaryActionBtn.querySelector("img").src = ""
      this.mobilePrimaryActionBtn.dataset.content = ""
      this.mobilePrimaryActionBtn.dataset.id = ""
      this.mobilePrimaryActionBtn.dataset.type = ""

      this.removeItemUsageFor(this.mobilePrimaryActionBtn)
    }
  }


  renderInventorySlotUsage(inventorySlot, usage) {
    let equipmentKlass = Equipments.forType(inventorySlot.dataset.type)
    if (!equipmentKlass) return
    if (equipmentKlass.prototype.isUnbreakable() && !equipmentKlass.prototype.shouldShowUsage()) return

    let maxUsage = equipmentKlass.prototype.getUsageCapacity()

    this.renderItemUsageFor(inventorySlot, usage, maxUsage)

    if (this.isMobile() && inventorySlot.dataset.id === this.mobilePrimaryActionBtn.dataset.id) {
      this.renderItemUsageFor(this.mobilePrimaryActionBtn, usage, maxUsage)
    }
  }

  renderItemUsageFor(el, usage, max) {
    el.dataset.usage = usage
    let usageBar = el.querySelector(".usage_bar")
    if (!usageBar) {
      usageBar = this.createUsageBar()
      el.appendChild(usageBar)
    }

    let curr = usage
    usageBar.querySelector(".bar_fill").style.width = (curr/max * 100) + "%"
  }

  removeInventorySlotUsage(inventorySlot) {
    this.removeItemUsageFor(inventorySlot)

    if (this.isMobile() && inventorySlot.dataset.id === this.mobilePrimaryActionBtn.dataset.id) {
      this.removeItemUsageFor(this.mobilePrimaryActionBtn)
    }
  }

  removeItemUsageFor(el) {
    let usageBar = el.querySelector(".usage_bar")
    if (usageBar && usageBar.parentElement) {
      usageBar.parentElement.removeChild(usageBar)
    }
  }

  createUsageBar() {
    let usageBar = document.createElement("div")
    usageBar.className = "usage_bar"

    let barFill = document.createElement("div")
    barFill.className = "bar_fill"
    usageBar.appendChild(barFill)

    return usageBar
  }

  createEntity(group, data) {
    let entity

    switch(group) {
      case "terrains":
        data.x = data.col * Constants.tileSize + Constants.tileSize/2
        data.y = data.row * Constants.tileSize + Constants.tileSize/2
        entity = Terrains.forType(data.type).build(this, data)
        break
      case "ships":
        entity = new Ship(this, data)
        break
      case "paths":
        entity = new Path(this, data)
        break
      case "chunkRegions":
        entity = new ChunkRegion(data, this.sector)
        break
      case "chunkRegionPaths":
        entity = new ChunkRegionPath(data, this.sector)
        break
      case "rooms":
        entity = new Room(data, this.sector)
        break
      case "players":
        entity = new Player(data, this.sector)
        break
      case "regions":
        entity = new Region(this, data)
        break
      case "buttons":
        entity = new Button(this, data)
        break
      case "pickups":
        entity = new Pickup(this, data)
        break
      case "corpses":
        entity = new Corpse(this, data)
        break
      case "mobs":
        entity = Mobs.forType(data.type).build(this, data)
        break
      case "projectiles":
        entity = Projectiles.forType(data.type).create(this, data)
        break
      case "buildings":
        entity = Buildings.forType(data.type).build(this, data)
        break
      case "transports":
        entity = Transports.forType(data.type).build(this, data)
        break
      default:
        throw new Error("Invalid group for createEntity: " + group)
    }

    return entity
  }

  measureInitialJoinTime() {
    if (this.initialJoinMeasured) return
    this.initialJoinMeasured = true

    const elapsed = (this.joinedGameTime - this.requestGameTime) / 1000
    console.log("initial join time: " + elapsed + " seconds")
  }

  onShowStarMap(data) {
  }

  onTeleport(data) {
    let oldResolution = this.resolution

    this.removeDataFromPreviousGame({
      menuExclude: [this.teamMenu, this.teamStatusMenu, this.chatMenu],
      excludeTeamInit: true
    })

    this.resolution = oldResolution
    this.gameLayer.scale.set(this.resolution)

    this.playerId = data.playerId
    this.initSector(data.sector)
    this.sector.initPlayers(data)
    this.sector.setSettings(data.sector.settings)

    this.renderInventory(data)
    this.onEquipIndexChanged(data)

    this.mapMenu.reinit()
  }

  renderCommon() {
    if (this.isMiniGame()) {
      document.querySelector("#hud_action_container").classList.add("minigame")
      document.querySelector("#time_label").style.display = 'none'

      if (this.isImposterGame()) {
        document.querySelector("#player_stats").style.display = 'none'
        document.querySelector(".total_task_stat").style.display = 'block'
      } else {
        document.querySelector("#player_stats").style.display = 'block'
        document.querySelector(".total_task_stat").style.display = 'none'
      }
    } else {
      document.querySelector("#hud_action_container").classList.remove("minigame")
      document.querySelector("#time_label").style.display = 'block'
      document.querySelector("#player_stats").style.display = 'block'
      document.querySelector(".total_task_stat").style.display = 'none'
    }

    if (this.shouldShowTutorial()) {
      this.tutorialMenu.open()
    } else {
      this.tutorialMenu.close()
    }

    if (this.shouldShowFavoriteButton()) {
      document.querySelector("#sector_action_menu").style.display = 'none'
    } else {
      document.querySelector("#sector_action_menu").style.display = 'block'
    }

    if (this.shouldShowFavoriteButton()) {
      document.querySelector("#sector_action_menu").style.display = "block"
    } else {
      document.querySelector("#sector_action_menu").style.display = "none"
    }

    if (this.shouldShowLeaderboard()) {
      this.leaderboardMenu.open()
    } else {
      this.leaderboardMenu.close()
    }

    if (this.isMiniGameEditor()) {
      document.querySelector(".minigame_controls_container").style.display = 'block'
      let link = main.getBrowserHref() + "minigame=" + "minigame-" + this.sector.uid
      document.querySelector(".launch_minigame_btn").href = link
    } else {
      document.querySelector(".minigame_controls_container").style.display = 'none'
    }
  }

  isMiniGameEditor() {
    let sectors = ["uLHpXWb2koXYe", "l8v7ezWMvnGeC", "eWC1CfZymRExY", "Ap9OYBkw3dQvJ", "YcdqgbswlAqRi"]
    return sectors.indexOf(this.sector.uid) !== -1
  }

  initGameModeUI() {
    if (this.isPvP()) {
      this.renderPvPMode()
    } else {
      this.renderDefault()
    }

    if (this.isSandbox()) {
      document.querySelector("#command_block_hud_btn").style.display = 'block'
    } else {
      document.querySelector("#command_block_hud_btn").style.display = 'none'
    }

    this.renderCommon()

    if (this.main.isMobile) {
      this.renderMobileUI()
    }

  }

  renderTutorial() {
  }

  renderMobileUI() {
  }

  renderDefault() {
    document.querySelector("#base_hud").classList.remove("pvp")
  }

  renderPvPMode() {
    document.querySelector("#alliance_btn").style.display = 'none'
    document.querySelector("#visit_colony_hud_btn").style.display = 'none'
    document.querySelector("#base_hud").classList.add("pvp")
  }

  onEnterSector(data) {
    this.showPlayerJoinGameMessage(data.player.name)
    this.sector.syncWithServerForGroups(["players"], { players: [data.player] })
  }

  onLeaveSector(data) {
    let player = this.sector.players[data.player.id]
    if (player) {
      player.remove()
    }
  }

  onPlayerCantJoin(data) {
    this.main.onPlayerCantJoin(data)
  }

  onPlayerRespawn(data) {
    this.hideDeathMessage()

    this.player.onStaminaChanged()
  }

  getSectorName() {
    return this.sector.name
  }

  playBackgroundMusic() {
    if (this.isPvP()) return
    let musicName =  this.getPeacefulMusicName()
    this.backgroundMusicSoundId = this.playSoundLazyDownload(musicName, { loop: true })
  }

  stopBackgroundMusic() {
    if (this.isPvP()) return
    this.stopSound(this.getPeacefulMusicName())
  }

  getPeacefulMusicName() {
    if (this.sector.getOriginalUid() === "Ap9OYBkw3dQvJ") {
      return "anotherplanet"
    } else if (this.sector.getOriginalUid() === "vbj91eofmFCiu") {
      return "td"
    } else {
      return "peaceful"
    }
  }

  stopAllBackgroundMusic() {
    if (this.isPvP()) return
    this.stopSound("peaceful")
    this.stopSound("enemy_invasion")
    this.stopSound("meeting")
    this.stopSound("anotherplanet")
  }

  playMeetingMusic() {
    try {
      let backgroundSound = this.sounds[this.getPeacefulMusicName()]
      if (backgroundSound.playing()) {
        backgroundSound.once('fade', () => { backgroundSound.stop( this.backgroundMusicSoundId ); }, this.backgroundMusicSoundId)
        backgroundSound.fade(this.getSavedOrDefaultBackgroundVolume(), 0, 3000, this.backgroundMusicSoundId)
      }

      this.meetingMusicSoundId = this.playSound("meeting", { loop: true })
      this.sounds["meeting"].fade(0, this.getSavedOrDefaultBackgroundVolume(), 3000, this.meetingMusicSoundId)
    } catch(e) {
      console.error(e)
    }
  }

  stopMeetingMusic() {
    try {
      let meetingSound = this.sounds["meeting"]
      if (meetingSound.playing()) {
        meetingSound.once('fade', () => { meetingSound.stop( this.meetingMusicSoundId ); }, this.meetingMusicSoundId)
        meetingSound.fade(this.getSavedOrDefaultBackgroundVolume(), 0, 3000, this.meetingMusicSoundId)
      }

      this.backgroundMusicSoundId = this.playSound(this.getPeacefulMusicName(), { loop: true })
      this.sounds[this.getPeacefulMusicName()].fade(0, this.getSavedOrDefaultBackgroundVolume(), 3000, this.backgroundMusicSoundId)
    } catch(e) {
      console.error(e)
    }
  }

  playRaidMusic() {
    if (this.isPvP()) return
    try {
      let backgroundSound = this.sounds[this.getPeacefulMusicName()]
      if (backgroundSound.playing()) {
        backgroundSound.once('fade', () => { backgroundSound.stop( this.backgroundMusicSoundId ); }, this.backgroundMusicSoundId)
        backgroundSound.fade(this.getSavedOrDefaultBackgroundVolume(), 0, 3000, this.backgroundMusicSoundId)
      }

      this.raidMusicSoundId = this.playSound("enemy_invasion", { loop: true })
      this.sounds["enemy_invasion"].fade(0, this.getSavedOrDefaultBackgroundVolume(), 3000, this.raidMusicSoundId)
    } catch(e) {
      console.error(e)
    }
  }

  startAlarm() {
    this.startHudAlertTween()
  }

  stopAlarm() {
    this.stopHudAlertTween()
    let el = document.querySelector(".event_item#alarm_event")
    if (el) {
      if (el.parentElement) {
        el.parentElement.removeChild(el)
      }
    }

    clearInterval(this.eventCountdownIntervals[i18n.t("Events.Alarm")])
  }

  startFixLights() {
  }

  stopFixLights() {
    let el = document.querySelector(".event_item#fix_lights_event")
    if (el) {
      if (el.parentElement) {
        el.parentElement.removeChild(el)
      }
    }

    clearInterval(this.eventCountdownIntervals[i18n.t("Events.FixLights")])
  }

  stopRaidMusic() {
    if (this.isPvP()) return
    try {
      let raidSound = this.sounds["enemy_invasion"]
      if (raidSound.playing()) {
        raidSound.once('fade', () => { raidSound.stop( this.raidMusicSoundId ); }, this.raidMusicSoundId)
        raidSound.fade(this.getSavedOrDefaultBackgroundVolume(), 0, 3000, this.raidMusicSoundId)
      }

      this.backgroundMusicSoundId = this.playSound(this.getPeacefulMusicName(), { loop: true })
      this.sounds[this.getPeacefulMusicName()].fade(0, this.getSavedOrDefaultBackgroundVolume(), 3000, this.backgroundMusicSoundId)
    } catch(e) {
      console.error(e)
    }
  }

  isCreatedByPlayer() {
    return this.playerUid === this.creatorUid
  }

  isAnonymousGame() {
    if (!this.creatorUid) return true

    let uuidv4Regex = new RegExp(/^[0-9A-F]{8}-[0-9A-F]{4}-4[0-9A-F]{3}-[89AB][0-9A-F]{3}-[0-9A-F]{12}$/i)
    return uuidv4Regex.test(this.creatorUid)
  }

  onEndGame(data) {
    if (data.isCountdown) {
      this.hideDeathMessage()
    } else if (this.sector.isPrivate) {
      let uid = this.sector.getOriginalUid()
      this.main.gameExplorer.joinMiniGame(uid, { targetMiniGameId: this.sector.uid, isPrivate: true })
      this.hideDeathMessage()
    } else {
      this.onPlayAgainBtnClick()
    }

  }

  onJoinGame(data) {
    document.body.style.overflow = 'hidden'
    this.joinGameTime = Date.now()

    this.isActive = true
    this.playerUid = data.playerUid
    this.creatorUid = data.creatorUid
    this.host = data.host
    this.pid = data.pid
    this.version = data.version
    this.revision = data.revision
    this._isMiniGame = data.isMiniGame

    console.log("joined sector " + data.sector.uid)

    document.querySelector("#day_label").innerText = data.day
    document.querySelector("#hour_label").innerText = data.hour

    window.history.replaceState(null, null, "?")

    this.main.enableJoin()
    this.main.hideChangeLog()
    this.main.hideHomeMenu()
    this.main.gameExplorer.hideScreenshotsPopup()

    if (this.main.gameExplorer && this.main.gameExplorer.isAttachedToBody) {
      this.main.gameExplorer.attachToMiddleContainer()
    }

    if (this.requestGameTime) {
      this.joinedGameTime = (new Date()).getTime()
      this.measureInitialJoinTime()
      this.requestGameTime = null
    }

    // if I just Joined (need to cleanup prior)
    this.removeDataFromPreviousGame()
    this.initSector(data.sector)

    this.initSidebar(data.sidebar)

    if (data.objectives) {
      this.questMenu.setObjectives(data.objectives)
    }

    if (this.isPvP()) {
      Cookies.set('pvpSectorUid', this.sector.uid)
    }

    this.initGameModeUI()
    this.blueprintMenu.updateAllowedCraftables()

    if (!this.measurePingInterval) {
      this.measurePingInterval = setInterval(this.calculatePing.bind(this), 3000)
    }

    document.querySelector(".disconnected_msg").style.display = 'none'
    this.updateRoomOxygenBar(0,100)

    this.deathScreen.style.display = 'none'
    document.getElementById("save_progress").style.display = 'none'

    this.showHUD()
    this.showGameCanvas()

    if (this.neverInitialized) {
      app.ticker.add((time) => {
        try {
          this.updateGame(time)
        } catch(e) {
          ExceptionReporter.captureException(e)
        }
      })

      this.neverInitialized = false
    }

    this.hasJoinedGame = true

    this.playerId = data.playerId // set playerId of current player
    Cookies.set('uid', data.uid)

    this.setTeams(data.teams)
    this.roles = data.roles

    this.sector.initPlayers(data)
    this.sector.setSettings(data.sector.settings)
    this.teamMenu.renderRoles()
    this.entityMenu.createPermissions()
    this.entityMenu.populateSpawnPointSelectors()

    if (this.isMiniGame()) {
      // render invite link
      this.renderInviteLink(this.sector.uid)
    }

    this.setTeamVisibility()
    this.mapMenu.reinit()

    if (!this.player) {
      alert("error loading game")
      return
    }

    this.player.setOxygen(data.oxygen)
    this.player.setHunger(data.hunger)
    this.player.setStamina(data.stamina)
    this.player.setGold(data.gold)

    this.renderInventory(data)
    this.onEquipIndexChanged(data)

    this.updateInGameMenu()
    this.chatMenu.setGlobalTabRegion()
    this.chatMenu.requestChatHistory()

    if (data.serverRestartTimestamp) {
      this.onServerRestartCountdown({ timestamp: data.serverRestartTimestamp, reason: data.restartReason })
    }

    if (window.debugRoom || debugMode) {
      document.querySelector("#debug_control_panel").style.display = 'block'
    }

    if (this.main.isMobile) {
      this.zoom(1.5) // mobile needs larger zoom
    }

    SocketUtil.emit("PlayerReady", {})


    if (!this.isTutorial()) {
      if (this.isCreatedByPlayer()) {
        this.welcomeMenu.open()
      }
      this.walkthroughMenu.close()
      this.playBackgroundMusic()
      if (this.sector.shouldShowChat()) {
        document.querySelector("#chat_toggle_btn").style.display = 'inline-block'
      }

      if (this.shouldBeAddedToMineColonies(this.sector.uid)) {
        this.addToMineColonies(this.sector.uid)
      }
    } else {
      this.walkthroughMenu.open()
      this.playBackgroundMusic()
      document.querySelector("#chat_toggle_btn").style.display = 'none'
    }

    if (!this.player.isSectorOwner()) {
      document.querySelector(".command_block_tab_container").style.display = 'none'
      this.commandBlockMenu.selectTab('triggers')
    } else {
      document.querySelector(".command_block_tab_container").style.display = 'block'
    }

    document.querySelector(".upvote_count").innerText = data.sector.upvoteCount

    this.teamMenu.updateColonySettings(data.sector.settings)
    this.selectDifficultyMenu.showGameMode(this.sector.gameMode)

    if (data.hasUpvoted) {
      this.renderUpvoteFilled(data.hasUpvoted)
    }

    this.onFavoriteCountChanged()
    this.resizeCanvas()

    this.initDialogue(data)

    this.displayStickyAnnouncement()

    if (this.main.userData && !this.main.userData.isRulesRead) {
      document.querySelector("#rules_menu").style.display = 'block'
    }

    if (data.fullMap) {
      data.fullMap.chunks.forEach((chunk) => {
        this.sector.onChunk(chunk, { sync: true })
      })
    }

    // let joinDuration = Date.now() - this.joinGameTime
    // console.log("map load after join took: " + joinDuration + "ms")
  }

  initDialogue(data) {
    this.dialogueMap = data.dialogueMap
  }

  displayStickyAnnouncement() {
    if (this.isPvP()) {
      document.querySelector("#game_sticky_announcement").innerText = "Map resets in Day 600"
    } else {
      document.querySelector("#game_sticky_announcement").innerText = ""
    }
  }

  renderInviteLink(sectorUid) {
    let params = window.location.search
    params = ClientHelper.replaceQueryParam('e', sectorUid, params)
    let inviteLink = this.main.getBrowserHost() + params

    document.querySelector("#minigame_invite_container .invite_link_input").value = inviteLink
  }

  shouldBeAddedToMineColonies(sectorUid) {
    return this.isLoggedIn() &&
           this.isCreatedByPlayer() &&
           !this.main.gameExplorer.mineColonyEntries[sectorUid]
  }

  initSidebar(data) {
    this.sidebarMenu.setVisible(data.isVisible)
    for (let index in data.rows) {
      this.sidebarMenu.setRowText(index, data.rows[index])
    }
  }

  isLoggedIn() {
    return this.main.isLoggedIn()
  }

  updateInGameMenu() {
    if (this.isLoggedIn() && this.isCreatedByPlayer()) {
      document.querySelector(".exit_game_menu_btn").innerText = i18n.t("Save and Quit")
    } else {
      document.querySelector(".exit_game_menu_btn").innerText = i18n.t("Exit Game")
    }
  }

  async addToMineColonies(sectorUid) {
    let result = await this.main.getUserRecord(this.main.uid)

    if (!result.error) {
      let saveEntries = result.saves
      this.main.gameExplorer.addMyColonies(saveEntries)
    }
  }

  isTutorial() {
    return this.sector.isTutorial()
  }

  isMiniGame() {
    return this._isMiniGame
  }

  visitSector(sectorUid) {

  }

  setEffectsVolume(volume) {
    let soundNames = this.getEffectsSoundNames()

    soundNames.forEach((soundName) => {
      this.setVolume(soundName, volume)
    })
  }

  setBackgroundVolume(volume) {
    let soundNames = this.getBackgroundSoundNames()

    soundNames.forEach((soundName) => {
      this.setVolume(soundName, volume)
    })
  }

  setVolume(soundName, volume) {
    if (!this.sounds) return

    if (this.sounds[soundName]) {
      this.sounds[soundName].volume(volume)
    }
  }

  isMobile() {
    return this.main.isMobile
  }

  setTeamVisibility() {
    if (!this.isGameCreatedByPlayer()) return
    if (this.isAnonymousGame()) return

    let privacy = document.querySelector('.visibility_select').value
    if (privacy === 'private') {
      SocketUtil.emit("EditTeam", { id: this.player.teamId, isPrivate: true })
    } else {
      SocketUtil.emit("EditTeam", { id: this.player.teamId, isPrivate: false })
    }
  }

  renderInventory(data) {
    for (let index in data.inventory.storage) {
      let inventory = data.inventory.storage[index]
      this.onInventoryChanged({ inventory: inventory })
    }
  }

  isGameCreatedByPlayer() {
    return this.creatorUid === this.playerUid
  }

  findOwnerById(ownerId) {
    if (ownerId === 1) return this.sector

    let team = this.teams[ownerId]
    if (team) return team

    let player = this.sector.players[ownerId]
    if (player) return player

    return null
  }


  hideDeathMessage() {
    if (this.deathMessageTween) {
      this.deathMessageTween.stop()
      this.deathMessageTween = null
    }

    this.deathScreen.style.opacity = 0
    this.deathScreen.style.display = 'none'
  }

  showDeathScreenImmediate() {
    document.querySelector("#death_screen_container").classList.add("now")
    this.deathScreen.style.display = 'block'

    if (this.sector.isMiniGame()) {
      this.showDeathMiniGameAction()
    } else {
      this.hideDeathMiniGameAction()
    }
  }

  showDeathMiniGameAction() {
    document.querySelector("#death_minigame_action_container").style.display = 'block'
    if (this.sector.isPrivate) {
      document.querySelector("#death_screen_container .play_again_btn").style.display = 'none'
      document.querySelector("#death_screen_container .exit_minigame_btn").style.display = 'inline-block'
    } else {
      document.querySelector("#death_screen_container .play_again_btn").style.display = 'inline-block'
      document.querySelector("#death_screen_container .exit_minigame_btn").style.display = 'none'
    }
  }

  hideDeathMiniGameAction() {
    document.querySelector("#death_minigame_action_container").style.display = 'none'
  }

  showDeathMessage(canRespawn) {
    document.querySelector("#death_screen_container").classList.remove("now")

    let opacity = { opacity: 0 }
    this.deathScreen.style.display = 'block'
    this.hideDeathMiniGameAction()

    if (this.sector.isMiniGame() && !canRespawn) {
      document.querySelector("#death_screen_action_container").style.display = 'none'
      setTimeout(() => {
        this.showDeathMiniGameAction()
      }, 3000)
    } else {
      document.querySelector("#death_screen_action_container").style.display = 'block'
      this.hideDeathMiniGameAction()
    }

    this.deathMessageTween = new TWEEN.Tween(opacity)
        .to({ opacity: 0.85 }, 2000)
        .easing(TWEEN.Easing.Quadratic.Out) // Use an easing function to make the animation smooth.
        .onUpdate(() => { // Called after tween.js updates 'coords'.
            // Move 'box' to the position described by 'coords' with a CSS translation.
            this.deathScreen.style.opacity = opacity.opacity
        })

    this.deathMessageTween.start()

    this.displayDeathAd()
  }

  displayDeathAd() {
    if (debugMode) return
    let threeMinutes = 1000 * 60 * 3
    let shouldRefreshAd = !this.lastDeathAdDisplay ||
                          (this.lastDeathAdDisplay && ((Date.now() - this.lastDeathAdDisplay) > threeMinutes))
    if (shouldRefreshAd) {
      aiptag.cmd.display.push(function() {
        aipDisplayTag.display('junon-io_728x90');
      })
      this.lastDeathAdDisplay = Date.now()
    }
  }

  showRestartCountdown(startTime, duration) {
    let durationInSeconds = duration / 1000
    document.querySelector("#restart_countdown").style.display = 'block'
    document.querySelector("#restart_countdown_number").innerText = durationInSeconds
    document.querySelector("#restart_btn").style.display = 'none'

    this.restartCountdownInterval = setInterval(() => {
      let elapsed = Date.now() - startTime
      let remaining = Math.max(0, duration - elapsed)
      let remainingInSeconds = Math.round(remaining / 1000)
      if (remainingInSeconds === 0) {
        clearInterval(this.restartCountdownInterval)
        document.querySelector("#restart_countdown").style.display = 'none'
        document.querySelector("#restart_btn").style.display = 'inline-block'
      } else {
        document.querySelector("#restart_countdown_number").innerText = remainingInSeconds
      }
    }, 1000)
  }

  clearChat() {
    Array.from(document.querySelectorAll(".chat_history")).forEach((el) => {
      el.innerHTML = ""
    })
  }

  removeDataFromPreviousGame(options = {}) {
    try {
      this.stopHudAlertTween()
      this.stopScreenWarp()

      this.terminalMenu.isChoiceSubmitted = false
      TWEEN.removeAll()

      if (this.player) {
        this.player.resetBuildMode()
      }

      this.setCustomCanvasSize(null, null)
      this.resizeCanvas()

      this.deleteHoldItemInventorySlot()

      if (this.sector) {
        this.sector.remove()
      }

      for (let description in this.eventCountdownIntervals) {
        clearInterval(this.eventCountdownIntervals[description])
      }
      document.querySelector("#events_menu").innerHTML = ""

      this.visibleChunk = null

      if (this.regionManager) {
        this.regionManager.cleanup()
      }

      this.shouldDenyMenuOpen = false

      this.cleanInventoryCooldowns()
      this.cleanSounds()
      this.clearChat()
      this.hideActionTooltip()
      this.cleanMenus(options)
      this.resetInventory()
      if (this.inputController) {
        this.inputController.reset()
      }


      this.commandBlockMenu.cleanup()
      this.teamMenu.resetJoinableTeams()

      document.querySelector("#error_title").innerText = ""
      document.querySelector("#error_menu_content").innerText = ""

      // reset scale
      this.gameLayer.scale.set(1)

      clearInterval(this.measurePingInterval)
      this.measurePingInterval = null

      document.querySelector("#notice_board").innerHTML = ""

      Array.from(document.querySelectorAll(".modal_menu")).forEach((el) => {
        el.style.display = 'none'
      })

      clearInterval(this.waveCountdownInterval)

      this.initVariables(options)
    } catch(e) {
      ExceptionReporter.captureException(e)
    }
  }

  isConnected() {
    return this.gameConnection.isConnected()
  }

  cleanSounds() {
    for (let soundName in this.currentSounds) {
      this.stopSound(soundName)
    }

    this.currentSounds = {}
  }

  cleanMenus(options = {}) {
    this.closeAllMenus()

    let menusToExclude = options.menuExclude || []
    this.menus.forEach((menu) => {
      if (menusToExclude.indexOf(menu) === -1) {
        menu.cleanup()
      }
    })
  }

  onOtherPlayerJoined(data) {
    this.showPlayerJoinGameMessage(data.player.name)
    if (!this.sector) return

    this.sector.syncWithServerForGroups(["players"], { players: [data.player] })
    this.sector.addToOriginalPlayers(data.player)
  }

  showPlayerLeaveGameMessage(name) {
    let el = document.createElement("div")
    el.className = 'notice_board_row'
    el.innerText = name + " left the game"
    document.querySelector("#notice_board").appendChild(el)

    let fadeOutTween = ClientHelper.getFadeTween(el, 0.3, 0, 3000)
    fadeOutTween.start()
  }

  showPlayerJoinGameMessage(name) {
    let el = document.createElement("div")
    el.className = 'notice_board_row'
    el.innerText = name + " has joined the game"
    document.querySelector("#notice_board").appendChild(el)

    let fadeOutTween = ClientHelper.getFadeTween(el, 0.3, 0, 3000)
    fadeOutTween.start()
  }

  onPlayerDestroyed(data) {
    if (!this.sector) return

    const targetPlayer = this.sector.players[data.id]

    if (targetPlayer) {
      if (targetPlayer.isMe()) {
        this.player.setHealth(0)
        this.showDeathMessage(data.canRespawn)
        this.showRestartCountdown(Date.now(), data.restartCooldown)
      }
    }

    let originalPlayer = this.sector.originalPlayers[data.id]
    if (originalPlayer) {
      originalPlayer.health = 0
    }
  }

  showRepairMessage() {
    this.lastDestroyedTime = (new Date()).getTime()
    this.repairFinishTime = this.lastDestroyedTime + this.player.REPAIR_TIME
    this.isDestroyed = true
    document.querySelector("#repair_menu").style.display = "block"
  }


  onMothershipRepaired(data) {
    const targetPlayer = this.sector.players[data.id]
    targetPlayer.show()

    if (targetPlayer.isMe()) {
      this.isDestroyed = false
      document.querySelector("#repair_menu").style.display = "none"
    }
  }

  onCollisionDetected(data) {
    this.sector.onCollisionDetected(data)
  }

  onCircleCollision(data) {
    this.sector.onCircleCollision(data)
  }

  onRepairStarted(data) {
    this.showRepairMessage()
  }

  onErrorMessage(data) {
    this.displayError(data.message, { warning: data.isWarning, success: data.isSuccess, transparent: data.isTransparent, color: data.color, size: data.size, isTitle: data.isTitle })
  }

  resetInventory() {
    this.inventoryMenu.cleanup()
  }

  onRenderStorage(data) {
    let menu = this.menus.find((menu) => {
      return menu.storageId === data.id
    })

    if (menu) {
      if (menu.isClose()) menu.finishOpen()
      menu.updateStorageInventory(data)

      if (menu.shouldHideQuickInventory()) {
        menu.hideQuickInventory()
      }

      if (menu.hasPlayerInventory()) {
        menu.updateStorageInventory({
          id: Constants.inventoryStorageId,
          inventory: {
            storage: this.player.inventory
          }
        })
      }
    }
  }

  onMineralCapacityReached(data) {
    this.displayError("Can't store more Minerals. Upgrade Mineral Storage")
  }

  onWaveEnd(data) {
    document.querySelector(".wave_container").style.display = 'block'
    document.querySelector("#wave_remaining_time").style.display = 'block'

    const waveInterval = debugMode ? (5 * 1000) : (60 * 1000)
    document.querySelector("#wave_level").innerText = (data.level + 1) + "/3"

    this.nextWaveTime = (new Date()).getTime() + waveInterval

    this.waveCountdownInterval = setInterval(() => {
      let differenceInSeconds = Math.floor((this.nextWaveTime - (new Date()).getTime()) / 1000)
      this.waveIncomingTime.innerText = differenceInSeconds

      if (differenceInSeconds <= 0) {
        clearInterval(this.waveCountdownInterval)
        document.querySelector("#wave_remaining_time").style.display = 'none'
      }
    }, 100)
  }

  onCeilingHit(data) {

  }

  onWaveLevel(data) {
    document.querySelector(".wave_container").style.display = 'block'
    document.querySelector("#wave_level").innerText = (data.level + 1) + "/3"
  }

  showGameCanvas() {
    this.canvas.style.cssText = 'display: block !important'
  }

  hideGameCanvas() {
    this.canvas.style.cssText = 'display: none'
  }

  showHUD() {
    document.getElementById('base_hud').style.display = 'block'
    document.getElementById('welcome_hud').style.display = 'none'
    document.getElementById('welcome_container').style.display = 'none'
  }

  hideHUD() {
    document.getElementById('base_hud').style.display = 'none'
    document.getElementById('welcome_hud').style.display = 'block'
    document.getElementById('welcome_container').style.display = 'block'
  }

  updateShieldBar(curr, max) {
    this.shieldBar.querySelector(".bar_label").innerText = curr
    this.shieldBar.querySelector(".bar_fill").style.width = max ? (curr/max * 100) + "%" : "0%"
  }

  startOxygenLowTween() {
    const barContainer = this.oxygenBar.querySelector(".bar_container")
    let opacity = { opacity: 1 }

    if (!this.oxygenLowTween) {
      this.oxygenLowTween = new TWEEN.Tween(opacity)
          .to({ opacity: 0 }, 1000)
          .easing(TWEEN.Easing.Quadratic.Out)
          .onUpdate(() => {
            let color = "rgb(88,151,209," + opacity.opacity + ")"
            barContainer.style.backgroundColor = color
          })
          .onComplete(() => {
            barContainer.style.background = 'none'
          })
          .onStop(() => {
            barContainer.style.background = 'none'
          })
          .repeat(Infinity)
          .start()
    }
  }

  stopOxygenLowTween() {
    if (this.oxygenLowTween) {
      this.oxygenLowTween.stop()
      this.oxygenLowTween = null
    }
  }

  startHungerLowTween() {
    const barContainer = this.hungerBar.querySelector(".bar_container")
    let opacity = { opacity: 1 }

    if (!this.hungerLowTween) {
      this.hungerLowTween = new TWEEN.Tween(opacity)
          .to({ opacity: 0 }, 1000)
          .easing(TWEEN.Easing.Quadratic.Out)
          .onUpdate(() => {
            let color = "rgb(212,115,35," + opacity.opacity + ")"
            barContainer.style.backgroundColor = color
          })
          .onComplete(() => {
            barContainer.style.background = 'none'
          })
          .onStop(() => {
            barContainer.style.background = 'none'
          })
          .repeat(Infinity)
          .start()
    }
  }

  stopHungerLowTween() {
    if (this.hungerLowTween) {
      this.hungerLowTween.stop()
      this.hungerLowTween = null
    }
  }

  showOxygenBar() {
    this.oxygenBar.style.display = 'block'
  }

  hideOxygenBar() {
    this.oxygenBar.style.display = 'none'
  }

  showStaminaBar() {
    this.staminaBar.style.display = 'block'
  }

  hideStaminaBar() {
    this.staminaBar.style.display = 'none'
  }

  showHungerBar() {
    this.hungerBar.style.display = 'block'
  }

  hideHungerBar() {
    this.hungerBar.style.display = 'none'
  }

  updateStaminaBar(curr, max) {
    this.staminaBar.querySelector(".bar_label").innerText = curr
    this.staminaBar.querySelector(".bar_fill").style.width = max ? (curr/max * 100) + "%" : "0%"
  }

  updateRoomOxygenBar(curr, max) {
    this.roomOxygenBar.querySelector("#oxygen_percentage_value").innerText = curr
    this.roomOxygenBar.querySelector(".bar_fill").style.width = max ? (curr/max * 100) + "%" : "0%"
  }

  updateOxygenBar(curr, max) {
    if (this.player && this.player.isLowStatus("oxygen")) {
      this.startOxygenLowTween()
    } else {
      this.stopOxygenLowTween()
    }

    this.oxygenBar.querySelector(".bar_label").innerText = curr
    this.oxygenBar.querySelector(".bar_fill").style.width = max ? (curr/max * 100) + "%" : "0%"
  }

  updateHungerBar(curr, max) {
    if (this.player && this.player.isLowStatus("hunger")) {
      this.startHungerLowTween()
    } else {
      this.stopHungerLowTween()
    }

    this.hungerBar.querySelector(".bar_label").innerText = curr
    this.hungerBar.querySelector(".bar_fill").style.width = max ? (curr/max * 100) + "%" : "0%"
  }

  updateHealthBar(curr, max) {
    this.healthBar.querySelector(".bar_label").innerText = curr
    this.healthBar.querySelector(".bar_fill").style.width = max ? (curr/max * 100) + "%" : "0%"
  }

  updateTotalTasksBar(curr, max) {
    this.totalTaskBar.querySelector(".bar_label").innerText = curr
    this.totalTaskBar.querySelector(".bar_fill").style.width = max ? (curr/max * 100) + "%" : "0%"
  }

  onLeaderboard(data) {
    if (!this.leaderboardMenu) return
    this.leaderboardMenu.update(data)
  }

  getPIXIOptions() {
  }

  initRenderer() {
    this.canvas = document.getElementById('game_canvas')

    let options = {
      view: this.canvas,
      forceCanvas: false,
      antialias: false,
      roundPixels: true,
      width: window.innerWidth,
      height: window.innerHeight
    }

    window.app = this.app = new PIXI.Application(options)

    let type = "WebGL"
    if(!PIXI.utils.isWebGLSupported()){
      type = "canvas"
    }

    PIXI.utils.sayHello(type)

    this.cameraDisplacement = {
      x: 0,
      y: 0
    }

    this.app.renderer.view.style.position = "absolute"
    this.app.renderer.view.style.display = "block"
    // this.app.renderer.backgroundColor = 0x000a19

    this.createGameLayer()
    this.createUILayer()
  }

  isCanvasMode() {
    if (!this.webGlSupport) {
      this.webGlSupport = PIXI.utils.isWebGLSupported()
    }

    return !this.webGlSupport
  }

  createGameLayer() {
    this.gameLayer = new PIXI.Container()
    this.gameLayer.name = "GameLayer"
    this.gameLayer.scale.y = 1
    this.gameLayer.scale.x = 1

    this.gameLayer.position.x = this.cameraDisplacement.x
    this.gameLayer.interactiveChildren = false

    this.app.stage.name = "Stage"
    this.app.stage.addChild(this.gameLayer)
  }

  createUILayer() {
    this.uiLayer = new PIXI.Container()
    this.uiLayer.name = "UILayer"
    this.app.stage.addChild(this.uiLayer)
  }

  getButtonBackgroundTexture() {
    if (!this.buttonBackgroundTexture) {
      let graphics = new PIXI.Graphics()
      graphics.beginFill(0x222222)
      graphics.lineStyle(2, 0x000000)
      graphics.drawRect(0, 0, 24, 24)
      graphics.endFill()

      this.buttonBackgroundTexture = this.app.renderer.generateTexture(graphics)
    }

    return this.buttonBackgroundTexture
  }

  createActionButton(name, spritePath, size, tint, clickCallback) {
    let container = new PIXI.Container()
    container.name = name
    container.interactive = true

    let buttonBackground = new PIXI.Sprite(this.getButtonBackgroundTexture())
    buttonBackground.anchor.set(0.5)
    buttonBackground.interactive = true

    let icon = new PIXI.Sprite(PIXI.utils.TextureCache[spritePath])
    icon.anchor.set(0.5)
    icon.width  = size
    icon.height = size
    icon.tint   = tint

    container.addChild(buttonBackground)
    container.addChild(icon)

    // container.on("mousedown", clickCallback)
    // container.on("touchstart", clickCallback)

    return container
  }

  createMobileBuildActionMenu() {
    this.buildActionMenu = new PIXI.Container()
    this.buildActionMenu.name = "BuildActionMenu"
    this.buildActionMenu.position.y = 64
    this.buildActionMenu.position.x = 64
    this.buildActionMenu.alpha = 0

    this.confirmBtn = this.createActionButton("ConfirmBtn", "check_icon.png", 16, 0x999999)
    this.confirmBtn.position.x = 30
    this.confirmBtn.onBtnClicked = this.onConfirmBtnClick.bind(this)

    this.rotateBtn = this.createActionButton("RotateBtn", "rotate_icon.png", 16, 0x999999)
    this.rotateBtn.name = "RotateBtn"
    this.rotateBtn.onBtnClicked = this.onRotateBtnClick.bind(this)

    this.cancelBtn = this.createActionButton("CancelBtn", "cancel_icon.png", 12, 0x999999)
    this.cancelBtn.position.x = -30
    this.cancelBtn.onBtnClicked = this.onCancelBtnClick.bind(this)

    this.buildActionMenu.addChild(this.confirmBtn)
    this.buildActionMenu.addChild(this.rotateBtn)
    this.buildActionMenu.addChild(this.cancelBtn)

    this.uiLayer.addChild(this.buildActionMenu)
  }

  onConfirmBtnClick() {
    if (this.player.isBuilding()) {
      this.player.placeBuilding()
    }

    this.buildActionMenu.alpha = 0
  }

  onRotateBtnClick() {
    if (this.player.isBuilding()) {
      this.player.building.rotateEquip()
    }
  }

  onCancelBtnClick() {
    this.player.requestEquipChange(-1) // cancel building

    this.buildActionMenu.alpha = 0
  }

  onZoomOutBtnClick() {
    this.zoomOut()
  }

  onZoomInBtnClick() {
    this.zoomIn()
  }

  zoomOut() {
    if (!window.zoomEnabled) return

    const currentZoomLevel = 1 / this.resolution
    let targetZoomLevel

    if (currentZoomLevel === this.MIN_ZOOM_LEVEL) {
      targetZoomLevel = 0.75
    } else if (currentZoomLevel < 1) {
      targetZoomLevel = 1
    } else {
      targetZoomLevel = currentZoomLevel + 1
    }

    if (targetZoomLevel >= this.MAX_ZOOM_LEVEL) targetZoomLevel = this.MAX_ZOOM_LEVEL

    this.zoom(targetZoomLevel)
  }

  zoomIn() {
    if (!window.zoomEnabled) return

    let targetZoomLevel

    const currentZoomLevel = 1 / this.resolution
    if (currentZoomLevel === 1) {
      targetZoomLevel = 0.75
    } else {
      targetZoomLevel = currentZoomLevel - 1
      if (targetZoomLevel <= this.MIN_ZOOM_LEVEL) targetZoomLevel = this.MIN_ZOOM_LEVEL
    }

    this.zoom(targetZoomLevel)
  }

  zoom(level) {
    let resolution = { resolution: this.resolution }

    if (!this.sector.isZoomAllowed()) return

    window.zoomEnabled = false // dont allow another zoom until this one is finished

    new TWEEN.Tween(resolution)
      .to({ resolution: 1 / level  }, 300)
      .easing(TWEEN.Easing.Quadratic.Out) // Use an easing function to make the animation smooth.
      .onUpdate(() => {
        this.resolution = resolution.resolution
        this.gameLayer.scale.set(resolution.resolution)
        this.centerCameraToCameraFocusTarget()
      })
      .onComplete(() => {
        this.resizeCanvas({ zoom: true }) // since we changed scale, let server know of new calculated screenwidth
        this.player.cullChunks()
        this.onZoomLevelChanged()
        window.zoomEnabled = true
      })
      .start()
  }

  onZoomLevelChanged() {
    if (this.isMobile()) {
      let zoomLevel = 1 / this.resolution
      if (zoomLevel <= 1.5) {
        this.zoomOutBtn.style.display = 'block'
        this.zoomInBtn.style.display  = 'none'
      } else if (zoomLevel >= 3.5) {
        this.zoomOutBtn.style.display = 'none'
        this.zoomInBtn.style.display  = 'block'
      }
    }
  }

  onBeforeUnload() {
    SocketUtil.emit("LeaveGame", {})
  }

  scaleUsernameSprites(resolution) {
    Object.values(this.sector.players).forEach((player) => {
      player.usernameSprite.scale.set(1/resolution)
    })
  }

  initMyPlayer(player) {
    this.player   = player
    window.player = player

    const inputController = this.getInputController()
    inputController.setPlayer(player)

    this.centerCameraTo(this.player.getCameraFocusTarget())
  }

  isMouseHeld() {
    const controlKeys = this.inputController.controlKeys
    return controlKeys & Constants.Control.space
  }

  getInputController() {
    if (!this.inputController) {
      this.inputController = new InputController(this.player, this)
    }

    return this.inputController
  }

  centerCameraTo(entity) {
    if (this.isStarMapShown) return

    this.centerCameraToXY(entity.getX(), entity.getY())
  }

  centerCameraToXY(x, y) {
    let browserResolution = this.getPixelRatio()

    const displacementX = (x * this.resolution) - ((this.getCanvasWidth() * browserResolution) / 2)
    const displacementY = (y * this.resolution) - ((this.getCanvasHeight() * browserResolution) / 2)

    this.cameraDisplacement.x = -displacementX
    this.cameraDisplacement.y = -displacementY

    this.gameLayer.position.x = this.cameraDisplacement.x
    this.gameLayer.position.y = this.cameraDisplacement.y
  }

  setCustomCanvasSize(width, height) {
    this.customCanvasWidth = width
    this.customCanvasHeight = height
  }

  getCanvasWidth() {
    return this.customCanvasWidth || window.innerWidth
  }

  getCanvasHeight() {
    return this.customCanvasHeight || window.innerHeight
  }

  initKeyBindings() {
    this.keyBindings = {
      "move up":     87,          // 'w'
      "move left":   65,          // 'a'
      "move down":   83,          // 's'
      "move right":  68,          // 'd'
      "rotate":      82,          // 'r'
      "craft":       67,          // 'c'
      "inventory":   73,          // 'i'
      "map":         77,          // 'm'
      "colony":      80,          // 'p'
      "alliance":    70,          // 'f'
      "visit":       86,          // 'v'
      "command block": 75,        // k
      "interact":    69,          // 'e'
      "attack":      32,          // 'space'
      "upgrade":     85,          // 'u'
      "chat":        90,          // 'z'
      "zoom in":     187,         // =
      "zoom out":    189,         // -
      "camera mode": 117,         // f6
      "stats view":  116,         // f5
      "view badges": 66,          // b
    }

    if (navigator.userAgent.search("Firefox") !== -1) {
      this.keyBindings["zoom in"] = 61
      this.keyBindings["zoom out"] = 173
    }

  }

  screenshot(position = 0) {
    let renderTexture = PIXI.RenderTexture.create(game_canvas.width, game_canvas.height)
    this.app.renderer.render(this.app.stage, renderTexture)
    let screenshot = this.app.renderer.plugins.extract.image(renderTexture)
    renderTexture.destroy(true)

    this.cropImage(screenshot, 600, 480, (dataUrl) => {
      let base64Image = dataUrl.replace("data:image/png;base64,","")
      SocketUtil.emit("AddScreenshot", { imageData: base64Image, position: position })

      this.lastScreenshotDay = this.day
    })

  }

  createRenderTexture(container) {
    let canvas = document.querySelector(".render_texture_debug")
    if (!canvas) {
      canvas = document.createElement("canvas")
      canvas.width = 512
      canvas.height = 512
      canvas.classList.add("render_texture_debug")
      document.body.appendChild(canvas)
    }
    let renderTexture = PIXI.RenderTexture.create(512, 512)

    var m = new PIXI.Matrix();

    container.transform.localTransform.copy(m);
    m.invert();

    let bounds = container.getLocalBounds()

    let xDelta = bounds.x % 512
    let yDelta = bounds.y % 512

    m.tx -= (bounds.x - xDelta)
    m.ty -= (bounds.y - yDelta)

    this.app.renderer.render(container, renderTexture, true, m, true)
    let screenshot = this.app.renderer.plugins.extract.image(renderTexture)
    let ctx = canvas.getContext("2d")
    screenshot.onload = function() {
      ctx.clearRect(0, 0, 512, 512)
      ctx.drawImage(screenshot, 0, 0, 512, 512)
    }
  }

  upgradeSelectedEntity() {
    if (this.entityMenu.entity &&
        this.entityMenu.entity.isBuildingType() &&
        this.entityMenu.entity.getConstants().isUpgradable &&
        this.entityMenu.entity.isOwnedBy(this.player)) {
      SocketUtil.emit("EditBuilding", { id: this.entityMenu.entity.id, action: 'upgrade' })
    }
  }

  cropImage(image, width, height, cb) {
    let canvas = document.createElement("canvas")
    canvas.width = width
    canvas.height = height
    let ctx = canvas.getContext("2d")
    let frameWidth  = width
    let frameHeight = height
    let sx = (window.innerWidth - frameWidth) / 2
    if (sx < 0) sx = 0

    let sy = (window.innerHeight - frameHeight) / 2
    if (sy < 0) sy = 0

    let sw = frameWidth
    let sh = frameHeight

    let dx = 0
    let dy = 0
    let dw = frameWidth
    let dh = frameHeight

    image.onload = function() {
      ctx.drawImage(image, sx, sy, sw, sh, dx, dy, dw, dh)
      cb(canvas.toDataURL())
    }
  }

  onScreenshotUpdated(data) {
    this.sector.updateScreenshot(data)
    this.teamMenu.renderScreenshots(this.sector)
  }

  updateGame(time) {
    if (!this.player) return

    this.ticksSincePacket += 1

    let cameraFocusTarget = this.player.getCameraFocusTarget()
    if (!cameraFocusTarget.isPositionBased) {
      this.prevPlayerPosX = cameraFocusTarget.getX()
      this.prevPlayerPosY = cameraFocusTarget.getY()
    }

    this.applyMyInputs()
    this.sector.executeTurn()

    if (this.player) {
      this.player.executeTurn()
    }

    this.cameraFollow(cameraFocusTarget)

    if (this.isDestroyed) {
      this.updateRepairTime()
    }

    this.miniMapMenu.updateViewport()

    TWEEN.update()

    this.lastFrameTime = (new Date()).getTime()
  }

  updateRepairTime() {
    const secondsRemaining = (this.repairFinishTime - this.lastFrameTime) / 1000
    const repairTimeFormatted = Helper.stringifyTimeShort(secondsRemaining)
    document.querySelector("#repair_remaining_time").innerText = repairTimeFormatted
  }

  getRoom(row, col) {
    let result

    for (let id in this.sector.rooms) {
      let room = this.sector.rooms[id]
      if (room.hasTile(row, col)) {
        result = room
        break
      }
    }

    return result
  }

  cameraFollow(cameraFocusTarget) {
    if (this.isStarMapShown) return
    if (cameraFocusTarget.isPositionBased) return

    const playerXDiff = cameraFocusTarget.getX() - this.prevPlayerPosX
    const playerYDiff = cameraFocusTarget.getY() - this.prevPlayerPosY

    if (playerXDiff !== 0) {
      this.cameraDisplacement.x   -= playerXDiff * this.resolution
      this.gameLayer.position.x = this.cameraDisplacement.x

      const mousePos = this.app.renderer.plugins.interaction.mouse.global
      if (this.player.building) {
        this.player.building.renderAtMousePosition(mousePos.x, mousePos.y)
      }
    }

    if (playerYDiff !== 0) {
      this.cameraDisplacement.y   -= playerYDiff * this.resolution
      this.gameLayer.position.y = this.cameraDisplacement.y

      const mousePos = this.app.renderer.plugins.interaction.mouse.global
      if (this.player.building) {
        this.player.building.renderAtMousePosition(mousePos.x, mousePos.y)
      }
    }

  }

  panViaControl(controlKeys) {
    const panSpeed = 4
    if (controlKeys & Constants.Control.left) {
      this.cameraDisplacement.x   += panSpeed
      this.gameLayer.position.x = this.cameraDisplacement.x
    }

    if (controlKeys & Constants.Control.right) {
      this.cameraDisplacement.x   -= panSpeed
      this.gameLayer.position.x = this.cameraDisplacement.x
    }

    if (controlKeys & Constants.Control.up) {
      this.cameraDisplacement.y   += panSpeed
      this.gameLayer.position.y = this.cameraDisplacement.y
    }

    if (controlKeys & Constants.Control.down) {
      this.cameraDisplacement.y   -= panSpeed
      this.gameLayer.position.y = this.cameraDisplacement.y
    }
  }

  onRenderDebug(data) {
    if (!this.sector) return

    if (data.type === 'room') {
      console.log(data)
    } else if (data.type === 'mob') {
      let tokens = data.data.split("@__@")
      let id = tokens[0]
      let log = tokens[1]
      let mob = this.sector.getEntity(id)
      if (mob) {
        mob.addBehaviorLog(log)
      }
    }
  }

  onGainResource(data) {
    let typeName = Helper.getTypeNameById(data.type)
    let friendlyTypeName = typeName.replace(/([A-Z])/g, ' $1').trim() // space before capital letters
    ClientHelper.animateMineralIncreased(this.player.getX(), this.player.getY(), data.amount, i18n.t(friendlyTypeName))
  }

  onChunk(data) {
    if (!this.sector) return
    this.sector.onChunk(data)
  }

  onEntityUpdated(data) {
    if (!this.sector) return
    this.sector.onEntityUpdated(data)
  }

  onRoomTileUpdated(data) {
    this.sector.onRoomTileUpdated(data)
  }

  onCameraFocusTarget(data) {
    this.chatMenu.close()
    game_canvas.focus()

    let mob = this.sector.mobs[data.id]
    if (mob) {
      this.centerCameraTo(mob)
      this.player.setCameraFocusTarget(mob)
      return
    }

    if (data.id === this.player.id) {
      this.centerCameraTo(this.player)
      this.player.setCameraFocusTarget(this.player)
      return
    }

    let entity = this.sector.getEntity(data.id)
    if (entity) {
      this.centerCameraTo(entity)
      this.player.setCameraFocusTarget(entity)
      return
    }

    if (data.hasOwnProperty("row")) {
      let x = data.col * Constants.tileSize
      let y = data.row * Constants.tileSize
      this.centerCameraToXY(x, y)
      this.player.setCameraFocusTarget({ x: x, y: y, isPositionBased: true })
      return
    }

    // none found, maybe not initialized on client yet, save for later
    this.setPendingCameraFocusTargetId(data.id)
  }

  getPendingCameraFocusTargetId() {
    return this.cameraFocusTargetId
  }

  setPendingCameraFocusTargetId(id) {
    this.cameraFocusTargetId = id
  }



  onCraftSuccess(data) {
    if (data.isHarvested) {
      data.x = window.innerWidth
      data.y = window.innerHeight
      this.animateCraftSuccess(data)
    } else {
      this.openMenus.forEach((menu) => {
        // quickfix. tbd: figure out which menu doesnt have that func
        if (typeof menu.onCraftSuccess === 'function') {
          menu.onCraftSuccess(data)
        }
      })
    }
  }

  animateCraftSuccess(data) {
    const itemName = data.name
    const friendlyItemName = itemName.replace(/([A-Z])/g, ' $1').trim()
    const label = "+" + data.count + " " + i18n.t(friendlyItemName)

    const style  = { fontFamily : 'PixelForce', fontSize: 28, fill : 0x00ff00, align : 'center', stroke: "#000000", strokeThickness: 5, miterLimit: 3 }
    let text = document.createElement("span")
    text.className = "craft_success_label"
    text.innerText = label
    document.body.appendChild(text)

    text.style.top  = data.y + "px"
    text.style.left = data.x + "px"

    let position = { y: data.y }
    var tween = new TWEEN.Tween(position)
        .to({ y: data.y - 150 }, 1500)
        .onUpdate(() => {
          text.style.top = position.y + "px"
        })
        .onComplete(() => {
          document.body.removeChild(text)
        })
        .start()
  }

  onServerChat(data) {
    this.chatMenu.onServerChat(data)
  }

  hideGhostMenu() {
    document.querySelector("#exit_body_btn").style.display = 'none'
  }

  showGhostMenu() {
    document.querySelector("#exit_body_btn").style.display = 'block'
  }

  showPlayerHud() {
    document.querySelector("#player_quick_inventory_menu").style.display = 'block'
  }

  hidePlayerHud() {
    document.querySelector("#player_quick_inventory_menu").style.display = 'none'
  }

  isInputSameAsPrevious(controlKeys, moveAngle, idle, pressedKey) {
    if (this.main.isMobile) {
      return this.lastMoveAngle === moveAngle && this.lastIdle === idle
    } else {
      if (this.lastPressedKey !== pressedKey) return false
      return this.lastControlKeys === controlKeys
    }
  }

  isPerformingAction(controlKeys) {
    if (this.main.isMobile) {
      return this.inputController.isPerformingMobileAction
    } else {
      return controlKeys & Constants.Control.space
    }
  }

  applyMyInputs() {
    if (!window.player) return
    if (this.isStarMapShown) return

    // check what keys are held
    const controlKeys = this.inputController.controlKeys
    const pressedKey = this.inputController.pressedKey
    const moveAngle = this.inputController.moveAngle
    const idle = this.inputController.idle

    if (player.isMining()) {
      if (player.canAct()) {
        player.mine()
        return
      }
    } else if (this.isPerformingAction(controlKeys)) {
      player.performAction()
    }

    if (this.isInputSameAsPrevious(controlKeys, moveAngle, idle, pressedKey)) return

    if (this.isPanMode) {
      return this.panViaControl()
    }

    if (this.main.isMobile) {
      SocketUtil.emit("PlayerInput", { angle: moveAngle, idle: idle })
    } else {
      SocketUtil.emit("PlayerInput", { controlKeys: controlKeys, pressedKey: pressedKey })
    }

    this.lastPressedKey = pressedKey
    this.lastControlKeys = controlKeys
    this.lastMoveAngle   = moveAngle
    this.lastIdle        = idle
  }

  getCoordFromMouse(clientX, clientY) {
    const cameraPositionX = -this.cameraDisplacement.x
    const cameraPositionY = -this.cameraDisplacement.y
    const x = cameraPositionX + clientX
    const y = cameraPositionY + clientY
    return { x: x, y: y }
  }



}

module.exports = Game

},{"../menus/command_blocks/action_value":597,"../menus/command_blocks/comparison":599,"../menus/command_blocks/trigger":601,"../util/firebase_client_helper":651,"./../../../common/constants.json":656,"./../../../common/entities/grid":659,"./../../../common/helper":664,"./../../../common/util/protocol":686,"./../menus/index":609,"./../util/client_helper":649,"./../util/exception_reporter":650,"./../util/socket_util":654,"./backgrounds/index":196,"./buildings/index":250,"./button":328,"./chunk_region":332,"./chunk_region_path":333,"./corpse":335,"./equipments/index":407,"./input_controller":442,"./item":443,"./mobs/index":464,"./particles/index":506,"./path":510,"./pickup":512,"./player":513,"./projectiles/index":526,"./region":539,"./region_manager":540,"./room":541,"./sector":543,"./ship":546,"./team":562,"./terrains/index":571,"./transports/index":576,"@shopify/draggable":2,"bowser":7,"js-cookie":58,"uuid/v4":176}],441:[function(require,module,exports){
const Constants = require("./../../../common/constants.json")

class HomeArea {
  constructor(container) {
    this.container = container

    this.tiles = {}

    this.initSprite()
  }

  initSprite() {
    this.sprite = new PIXI.Container()
    this.sprite.name = "home_area"
    this.sprite.alpha = 0

    this.getSpriteContainer().addChild(this.sprite)
  }

  syncWithServer(data) {
    this.syncTiles(data.tiles)
  }

  syncTiles(tiles) {
    if (!tiles) return

    tiles.forEach((data) => {
      let tileKey = this.getTileKey(data)
      if (data.clientMustDelete) {
        let tile = this.tiles[tileKey]
        this.removeTile(tile, tileKey)
      } else if (!this.tiles[tileKey]) {
        this.createTile(data, tileKey)
      }
    })
  }

  getTileKey(tile) {
    return [tile.row, tile.col].join("-")
  }

  getSpriteContainer() {
    return this.container.spriteLayers[this.getGroup()]
  }

  getGroup() {
    return "home_areas"
  }

  getTileSpritePath() {
    return "room_tile.png"
  }

  createTile(data, tileKey) {
    let tile = { 
      row: data.row, 
      col: data.col,
      sprite: this.createTileSprite(data.row, data.col)
    }

    this.sprite.addChild(tile.sprite)
    this.tiles[tileKey] = tile

    return tile
  }

  removeTile(tile, tileKey) {
    if (this.sprite && tile) {
      this.sprite.removeChild(tile.sprite)
    }
    
    delete this.tiles[tileKey]
  }

  createTileSprite(row, col) {
    let texture = PIXI.utils.TextureCache[this.getTileSpritePath()]
    let sprite = new PIXI.Sprite(texture)
    sprite.name = "room_tile"
    sprite.width  = Constants.tileSize
    sprite.height = Constants.tileSize
    sprite.position.x = col * Constants.tileSize
    sprite.position.y = row * Constants.tileSize
    sprite.alpha = 0.6
    return sprite
  }

}

module.exports = HomeArea
},{"./../../../common/constants.json":656}],442:[function(require,module,exports){
const SocketUtil = require("../util/socket_util")
const Constants = require('../../../common/constants.json')
const Helper = require('../../../common/helper')
const Buildings = require('./buildings/index')
const Nipplejs = require('nipplejs')
const ClientHelper = require("../util/client_helper")
const isMobile = require('ismobilejs')

class InputController {
  constructor(player, game) {
    this.player = player
    this.player.inputController = this
    this.game = game
    this.main = game.main

    this.initConstants()
    this.initVariables()
    this.initListeners()

    if (this.isMobile()) {
      this.initMobile()
    }
    
  }

  setPlayer(player) {
    this.player = player
    this.player.inputController = this
  }

  initMobile() {
    document.querySelector("#mobile_action_menu").style.display = 'block'
    
    const options = { 
      zone: document.getElementById('gamepad_joystick'), 
      mode: 'static',
      position: {left: '50px', bottom: '50px'} 
    }
    this.joystick = Nipplejs.create(options)
    this.joystick.on("move", this.onJoystickMove.bind(this))
    this.joystick.on("end", this.onJoystickEnd.bind(this))
  }

  onJoystickMove(event, data) {
    this.idle = false
    this.moveAngle = 360 - data.angle.degree

    this.player.setAngle(this.moveAngle)
  }

  onJoystickEnd(event, data) {
    this.idle = true
  }

  initConstants() {
    this.KEY_EVENT_TYPES = {
      down: 0,
      up: 1
    }

  }

  initVariables() {
    this.canvas = document.getElementById("game_canvas")
    this.controlKeys = 0
    this.heldKeys = {}

    this.inputSequenceNumber = 0
    this.moveAngle = 0
    this.idle = true
    this.allowEnter = true
  }

  reset() {
    this.initVariables()
  }

  initListeners() {
    this.keyDownHandler   = this.globalKeyDownHandler.bind(this)
    this.keyUpHandler     = this.globalKeyUpHandler.bind(this)
    this.mouseDownHandler = this.globalMouseDownHandler.bind(this)
    this.mouseUpHandler   = this.globalMouseUpHandler.bind(this)
    this.mouseMoveHandler = this.globalMouseMoveHandler.bind(this)

    document.addEventListener("keydown", this.keyDownHandler, true)
    document.addEventListener("keyup", this.keyUpHandler, true)
    document.addEventListener("mousemove", this.mouseMoveHandler, true)

    if (isMobile.any) {
      document.addEventListener("touchstart", this.mouseDownHandler, true)
      document.addEventListener("touchend", this.mouseUpHandler, true)
    } else {
      document.addEventListener("mousedown", this.mouseDownHandler, true)
      document.addEventListener("mouseup", this.mouseUpHandler, true)
    }

    if (this.isMobile()) {
      this.mobilePrimaryActionTouchStartHandler = this.onMobilePrimaryActionTouchStart.bind(this)
      this.mobilePrimaryActionTouchEndHandler = this.onMobilePrimaryActionTouchEnd.bind(this)

      if (isMobile.any) {
        document.querySelector("#mobile_primary_action_btn").addEventListener("touchstart", this.mobilePrimaryActionTouchStartHandler, true)
        document.querySelector("#mobile_primary_action_btn").addEventListener("touchend",   this.mobilePrimaryActionTouchEndHandler,   true)
      } else {
        document.querySelector("#mobile_primary_action_btn").addEventListener("mousedown", this.mobilePrimaryActionTouchStartHandler, true)
        document.querySelector("#mobile_primary_action_btn").addEventListener("mouseup",   this.mobilePrimaryActionTouchEndHandler,   true)
      }

      this.mobileActionTouchStartHandler = this.onMobileActionTouchStart.bind(this)
      this.mobileActionTouchEndHandler = this.onMobileActionTouchEnd.bind(this)

      if (isMobile.any) {
        document.querySelector("#mobile_action_btn").addEventListener("touchstart", this.mobileActionTouchStartHandler, true)
        document.querySelector("#mobile_action_btn").addEventListener("touchend",   this.mobileActionTouchEndHandler,   true)
      } else {
        document.querySelector("#mobile_action_btn").addEventListener("mousedown", this.mobileActionTouchStartHandler, true)
        document.querySelector("#mobile_action_btn").addEventListener("mouseup",   this.mobileActionTouchEndHandler,   true)
      }
    }
  }

  removeListeners() {
    document.removeEventListener("keydown", this.keyDownHandler, true)
    document.removeEventListener("keyup", this.keyUpHandler, true)
    document.removeEventListener("mousedown", this.mouseDownHandler, true)
    document.removeEventListener("mouseup", this.mouseUpHandler, true)
    document.removeEventListener("touchstart", this.mouseDownHandler, true)
    document.removeEventListener("touchend", this.mouseUpHandler, true)
    document.removeEventListener("mousemove", this.mouseMoveHandler, true)

    if (this.isMobile()) {
      document.querySelector("#mobile_primary_action_btn").removeEventListener("touchstart", this.mobilePrimaryActionTouchStartHandler, true)
      document.querySelector("#mobile_primary_action_btn").removeEventListener("touchend",   this.mobilePrimaryActionTouchEndHandler,   true)
      document.querySelector("#mobile_primary_action_btn").removeEventListener("mousedown", this.mobilePrimaryActionTouchStartHandler, true)
      document.querySelector("#mobile_primary_action_btn").removeEventListener("mouseup",   this.mobilePrimaryActionTouchEndHandler,   true)

      document.querySelector("#mobile_action_btn").removeEventListener("touchstart", this.mobileActionTouchStartHandler, true)
      document.querySelector("#mobile_action_btn").removeEventListener("touchend",   this.mobileActionTouchEndHandler,   true)
      document.querySelector("#mobile_action_btn").removeEventListener("mousedown", this.mobileActionTouchStartHandler, true)
      document.querySelector("#mobile_action_btn").removeEventListener("mouseup",   this.mobileActionTouchEndHandler,   true)
    }
  }

  onMobileActionTouchStart() {
    let entity = this.game.sector.selection.selectedEntity

    if (entity && entity.isBuildingType() && entity.isInteractable()) {
      this.game.interact(entity)
    } else if (this.player.hasMineTarget()) {
      this.player.toggleMiningMode()
    } else if (game.getHighlightedEntity()) {
      game.interact(game.getHighlightedEntity())
    } else if (this.player.getMount()) {
      this.game.interact(this.player.getMount()) // to allow mobile unmount
    } else {
      
    }
  }

  onMobilePrimaryActionTouchStart() {
    this.isPerformingMobileAction = true
  }

  onMobilePrimaryActionTouchEnd() {
    this.isPerformingMobileAction = false
  }

  onMobileActionTouchEnd() {

  }

  handleEnter() {
    if (!this.game.chatMenu.isOpenAndFocused()) {
      if (this.game.sector.shouldShowChat()) {
        this.game.chatMenu.open({ message: this.game.chatMenu.chatInput.value })
      }
    } else {
      this.game.chatMenu.submit()
    }
  }

  handleEsc() {
    if (this.main.gameExplorer && this.main.gameExplorer.isAttachedToBody) {
      this.main.gameExplorer.attachToMiddleContainer()
      return
    }

    if (this.game.chatMenu.isOpen()) {
      this.game.chatMenu.chatInput.blur()
      if (this.game.sector.shouldShowChat()) {
        this.game.chatMenu.close()
      } else if (!this.game.voteMenu.isOpen()) {
        this.game.chatMenu.hide()
      }
      return
    }

    // if (this.game.openMenus.length === 0 && this.player.getActiveItem()) {
    //   this.player.requestEquipChange(-1) // cancel hotbar active item
    //   return
    // }

    this.game.clearRegion()
    this.game.resetEntitySelection()

    if (game.openMenus.length > 0) {
      this.game.closeLastMenu()
      return
    }

    if (this.game.isActive) {
      if (this.isInGameMenuOpen()) {
        this.game.closeInGameMenu() 
      } else {
        this.game.openInGameMenu() 
      }
    }
  }

  isFocusedOnInput(event) {
    // https://stackoverflow.com/a/16508083
    let obj = event.target
    if (obj.type === 'textarea') return true

    return obj instanceof HTMLInputElement && (obj.type == 'text' || obj.type == 'number')
  }

  convertKeyToControl(keyCode) {
    if (keyCode === 38) return Constants.Control.up
    if (keyCode === 37) return Constants.Control.left
    if (keyCode === 40) return Constants.Control.down
    if (keyCode === 39) return Constants.Control.right

    if (this.game.keyBindings["move up"] === keyCode) return Constants.Control.up    
    if (this.game.keyBindings["move left"] === keyCode) return Constants.Control.left    
    if (this.game.keyBindings["move down"] === keyCode) return Constants.Control.down    
    if (this.game.keyBindings["move right"] === keyCode) return Constants.Control.right    
    if (this.game.keyBindings["attack"] === keyCode) return Constants.Control.space
  }

  globalKeyUpHandler(event) {
    if (this.game.isActive && this.isInGameMenuOpen()) {
      if (event.keyCode === 27) {
        this.game.closeInGameMenu()  
      }
      return
    }

    let keyCode = ClientHelper.getKeycode(event)
    delete this.heldKeys[keyCode]

    if (this.isFocusedOnInput(event)) return

    const control = this.convertKeyToControl(keyCode)

    if (control) {
      this.controlKeys ^= control

      if (this.controlKeys === 0) {
        this.moveAngle = 0
      }
    } else {
      if (keyCode === 9) { // tab 
        if (game.isModalMenuOpen()) {
          if (this.heldKeys[16]) { //shift
            game.onMenuInteract("ShiftTab")
          } else {
            game.onMenuInteract("Tab")
          }
        }
      }

      if (event.keyCode === 27) { // escape
        this.handleEsc()
      }

      if (event.keyCode === this.game.keyBindings["rotate"]) { // R
        if (player.building) player.building.rotateEquip()
      }

      if (keyCode === this.game.keyBindings["inventory"]) { // i
        game.toggleInventory()
      } 

      if (keyCode === this.game.keyBindings["colony"]) { // p
        game.toggleTeamMenu()
      } 

      if (keyCode === this.game.keyBindings["stats view"]) { // f5
        game.togglePerformanceDebug()
      } 

      if (keyCode === this.game.keyBindings["camera mode"]) { // f6
        game.toggleMainMenus()
      } 

      if (keyCode === 121) { // f10
        if (debugMode) {
          game.toggleAdminMode()
        }
      }

      if (keyCode === this.game.keyBindings["interact"]) { // e
        let highlightedEntity = game.getHighlightedEntity()
        if (highlightedEntity) {
          game.interact(highlightedEntity)
        } else {
          game.interactEmpty()
        }
      } 

      if (keyCode === this.game.keyBindings["zoom out"]) { // -
        if (game.isModalMenuOpen()) {
          game.onMenuInteract("GoUp")
        } else {
          game.zoomOut()
        }
      } 

      if (keyCode === this.game.keyBindings["zoom in"] ||
          keyCode === 186) { // = or ;
        if (game.isModalMenuOpen()) {
          game.onMenuInteract("GoDown")
        } else {
          game.zoomIn()
        }
      } 

    if (keyCode === this.game.keyBindings["craft"]) { // c
        game.toggleBlueprintMenu()
      } 

      if (keyCode === this.game.keyBindings["view badges"]) { // b 
        if(this.game.badgeMenu.isOpen()) {
          this.game.badgeMenu.close()
          return
        }
        this.game.badgeMenu.open()
      }

      if (keyCode === this.game.keyBindings["map"]) { // m
        game.toggleMapMenu()
      } 

      if (keyCode === this.game.keyBindings["upgrade"]) { // u
        game.upgradeSelectedEntity()
      } 

      if (keyCode === this.game.keyBindings["chat"]) { // z
        game.toggleChatMenu()
      } 

      if (keyCode === this.game.keyBindings["alliance"]) { // f
        game.toggleFriendsMenu()
      } 

      if (keyCode === this.game.keyBindings["visit"]) { // v
        game.toggleVisitColonyMenu()
      } 

      if (keyCode === this.game.keyBindings["command block"]) { // K
        game.toggleCommandBlockMenu()
      } 

      if (keyCode === 81) { // q
        game.toggleTutorial()
      } 

      if (keyCode === 191) { // /
        if (!this.game.chatMenu.isOpenAndFocused()) {
          this.game.chatMenu.open({ message: "/" })
        }
      } 

      if (keyCode === 13 ) { // enter
        if (game.isModalMenuOpen()) {
          this.allowEnter = true
          game.onMenuInteract("EnterUp")
        } else {
          this.handleEnter()
        }
      } 

      if (event.keyCode === 192) {  // backquote
        const mousePos = this.game.app.renderer.plugins.interaction.mouse.global
        const absolutePos  = {
          x: -this.game.cameraDisplacement.x + mousePos.x,
          y: -this.game.cameraDisplacement.y + mousePos.y
        }
        SocketUtil.emit("SpawnMob", absolutePos)
      }

    }

    let numberKeys = [49,50,51,52,53,54,55,56]
    if (numberKeys.indexOf(event.keyCode) !== -1) {
      this.setEquipIndex(event)
    }
  }

  getGlobalMousePos() {
    const mousePos = this.game.app.renderer.plugins.interaction.mouse.global
    const resolution = this.game.resolution

    const absolutePos  = {
      x: Math.floor((-this.game.cameraDisplacement.x + mousePos.x) / resolution),
      y: Math.floor((-this.game.cameraDisplacement.y + mousePos.y) / resolution)
    }
    
    return absolutePos
  }

  getGlobalMouseRow(globalMousePos) {
    return Math.floor(globalMousePos.y / Constants.tileSize)
  }

  getGlobalMouseCol(globalMousePos) {
    return Math.floor(globalMousePos.x / Constants.tileSize)
  }

  setEquipIndex(event) {
    let oneBasedIndex = parseInt(event.key)
    if (isNaN(oneBasedIndex)) return

    let index = oneBasedIndex - 1

    let isDifferentEquipIndex = this.player.equipIndex !== index
    if (isDifferentEquipIndex) {
      this.player.requestEquipChange(index)
    } else {
      this.player.requestEquipChange(-1) // unequip
    }
      
  }


  globalKeyDownHandler(event) {
    if (this.isFocusedOnInput(event)) return
    if (this.isInGameMenuOpen()) return
    if (this.game.chatMenu.isOpenAndFocused()) return

    let keyCode = ClientHelper.getKeycode(event)
    this.heldKeys[keyCode] = true

    this.pressedKey = keyCode

    const controlTarget = this.player

    const control = this.convertKeyToControl(keyCode)
    if (control) {
      this.controlKeys |= control
    }

    if (keyCode === this.game.keyBindings["attack"]) { // space
      if (this.player.hasMineTarget() ) {
        this.player.toggleMiningMode()
      }
    }


    if (keyCode === 116) { // f5
      // dont allow refresh (its used to show debug)
      event.preventDefault()
    }

    if(keyCode == 191) {
      //Firefox opens find box when / pressed
      event.preventDefault()
    }

    if (keyCode === 9) { // tab
      event.preventDefault()
    } else if (keyCode === 13) { // enter
      if (this.allowEnter) {
        if (game.isModalMenuOpen()) {
          game.onMenuInteract("EnterDown")
        }

        this.allowEnter = false
      }
    }
  }

  isDirectionHeld() {
    const leftHeld  = this.controlKeys & Constants.Control.left
    const rightHeld = this.controlKeys & Constants.Control.right
    const upHeld    = this.controlKeys & Constants.Control.up
    const downHeld  = this.controlKeys & Constants.Control.down

    return leftHeld || rightHeld || upHeld || downHeld
  }

  getMoveAngle() {
    const leftHeld  = this.controlKeys & Constants.Control.left
    const rightHeld = this.controlKeys & Constants.Control.right
    const upHeld    = this.controlKeys & Constants.Control.up
    const downHeld  = this.controlKeys & Constants.Control.down

    const direction = {
      x: Math.sign(rightHeld - leftHeld),
      y: Math.sign(upHeld  - downHeld),
    }

    return Math.atan2(direction.y, direction.x)
  }

  globalMouseUpHandler(event) {
    this.controlKeys &= ~Constants.Control.space // remove space key

    this.isPerformingMobileAction = false
  }

  isRightClick(event) {
    let isRightClick = false

    if ("which" in event) {
      // Gecko (Firefox), WebKit (Safari/Chrome) & Opera
      isRightClick = event.which == 3
    } else if ("button" in event) {
      // IE, Opera 
      isRightClick = event.button == 2 

    } 
        
    return isRightClick
  }

  getUIButton(e) {
    let clientX = (e.touches && e.touches[0].clientX) || e.clientX 
    let clientY = (e.touches && e.touches[0].clientY) || e.clientY

    let buildActionMenu = this.game.buildActionMenu
    if (buildActionMenu.alpha === 0) return false

    if (this.isUIButtonHit(this.game.confirmBtn, clientX, clientY)) {
      return this.game.confirmBtn
    }

    if (this.isUIButtonHit(this.game.rotateBtn, clientX, clientY)) {
      return this.game.rotateBtn
    }

    if (this.isUIButtonHit(this.game.cancelBtn, clientX, clientY)) {
      return this.game.cancelBtn
    }

    return null
  }

  isUIButtonHit(displayObject, clientX, clientY) {
    let rectange = displayObject.getBounds()
    return Helper.testBoxPoint(rectange.x, rectange.y, rectange.width, rectange.height, clientX, clientY)
  }

  globalMouseDownHandler(e) {
    if (this.game.securityCameraMenu.isOpen()) return
      
    if (this.isMobile()) {
      let uiBtn = this.getUIButton(e)
      if (uiBtn) {
        uiBtn.onBtnClicked()
        return
      } else {
        this.lastClientX = e.touches[0].clientX
        this.lastClientY = e.touches[0].clientY
      }
    }

    // close tooltip
    if (!e.target.closest("#chat_player_tooltip")) {
      document.querySelector("#chat_player_tooltip").style.display = 'none'
    }

    let isCanvasTarget = e.target.id === "game_canvas"
    let chatContainer = e.target.closest("#chat_container")
    let isChatOverlay = chatContainer && !chatContainer.classList.contains("chat_mode")
    let allowGameMouseDown = isCanvasTarget || isChatOverlay
    if (!allowGameMouseDown) return
    
    let options = {
      isRightClick: this.isRightClick(e)
    }

    if (this.isDesktop() && isCanvasTarget) {
      if (this.game.holdItemInventorySlot) {
        this.game.throwHoldItem()
      }
    }
    
    if (options.isRightClick) {
      this.player.stopBuilding() // unequip
    } else {
      this.controlKeys |= Constants.Control.space
    }

    if (this.player.hasMineTarget() && !this.isMobile()) {
      // in mobile, mining mode is explicitly toggled
      this.player.toggleMiningMode()
    }

    if (this.isMobile()) {
      // if (!e.touches) return
      let clientX = (e.touches && e.touches[0].clientX) || e.clientX 
      let clientY = (e.touches && e.touches[0].clientY) || e.clientY

      if (!this.player.hasMineTarget()) {
        this.player.setMiningMode(false)
      }

      if (this.player.isBuilding()) {
        this.player.building.renderAtMousePosition(clientX, clientY)
        this.game.buildActionMenu.position.x = clientX 
        this.game.buildActionMenu.position.y = clientY + 64

        this.game.buildActionMenu.alpha = 1
      }
      
      let globalMousePos = this.getGlobalMousePosFromXY(clientX, clientY)
      let globalMouseRow = Math.floor(globalMousePos.y / Constants.tileSize)
      let globalMouseCol = Math.floor(globalMousePos.x / Constants.tileSize)

      if (!this.player.dragTargetId) {
        // only if not dragging someone
        this.triggerEntityMouseEvents(globalMouseRow, globalMouseCol, globalMousePos)
      }
      
      this.makePlayerFaceClickedPoint(clientX, clientY)
    }

    // in mobile, we need to make sure triggerMouseEvents get called first
    // before calling this one
    if (this.lastMouseOverEntity) {
      this.lastMouseOverEntity.onClick(options)
      if (this.lastMouseOverEntity.isBuildingType() && player.hasMiningEquipment()) {
        // for salvaging (maybe refactor in future)
        this.isPerformingMobileAction = true
      }
    } else {
      this.game.resetEntitySelection()
    }

    if (this.game.isSelectingRegion()) {
      if (!this.game.hasRegionStart()) {
        this.game.setRegionStart() 
      } else {
        this.game.createRegion() 
      }
    }

  }

  makePlayerFaceClickedPoint(clientX, clientY) {
    const relativeX = clientX - this.canvas.width / 2
    const relativeY = clientY - this.canvas.height / 2

    let angle = Math.atan2(relativeY, relativeX)
    let deg = Math.floor(angle * (180 / Math.PI))

    this.player.setAngle(deg)
  }

  getGlobalMousePosFromXY(clientX, clientY) {
    const cameraPositionX = -this.game.cameraDisplacement.x
    const cameraPositionY = -this.game.cameraDisplacement.y

    const absolutePos  = {
      x: Math.floor((cameraPositionX + clientX) / this.game.resolution),
      y: Math.floor((cameraPositionY + clientY) / this.game.resolution)
    }

    return absolutePos
  }

  isMobile() {
    return this.game.main.isMobile
  }

  isInGameMenuOpen() {
    return document.querySelector("#welcome_container").style.display === 'block'
  }

  globalMouseMoveHandler(e) {
    this.lastClientX = e.clientX * this.game.getPixelRatio()
    this.lastClientY = e.clientY * this.game.getPixelRatio()

    if (!this.game.isConnected()) return
    if (this.isInGameMenuOpen()) return
    if (!this.game.player) return
    if (this.game.player.isDestroyed()) return

    const relativeX = e.clientX * this.game.getPixelRatio() - this.canvas.width / 2
    const relativeY = e.clientY * this.game.getPixelRatio() - this.canvas.height / 2

    if (this.isDesktop() && this.player.canChangeAngle()) {
      let angle = Math.atan2(relativeY, relativeX)
      let deg = Math.floor(angle * (180 / Math.PI))

      this.player.setAngle(deg)

      let globalMousePos = this.getGlobalMousePos()
      let globalMouseRow = this.getGlobalMouseRow(globalMousePos)
      let globalMouseCol = this.getGlobalMouseCol(globalMousePos)
      let data = { angle: deg }

      if (this.lastGlobalMouseRow !== globalMouseRow) {
        data.row = globalMouseRow
        this.lastGlobalMouseRow = globalMouseRow
      }

      if (this.lastGlobalMouseCol !== globalMouseCol) {
        data.col = globalMouseCol
        this.lastGlobalMouseCol = globalMouseCol
      }

      SocketUtil.emit("PlayerTarget", data)
    }

    if (this.isDesktop() && !this.game.player.isControllingGhost()) {
      if (this.game.holdItemInventorySlot) {
        this.game.renderHoldItemAtMousePosition(e.clientX, e.clientY)
      }

      if (this.player.building && !this.game.isDragging) {
        this.player.building.renderAtMousePosition(e.clientX * this.game.getPixelRatio(), e.clientY * this.game.getPixelRatio())
      }

      let globalMousePos = this.getGlobalMousePos()
      let globalMouseRow = Math.floor(globalMousePos.y / Constants.tileSize)
      let globalMouseCol = Math.floor(globalMousePos.x / Constants.tileSize)

      this.triggerEntityMouseEvents(globalMouseRow, globalMouseCol, globalMousePos)
    }

    if (this.game.isSelectingRegion()) {
      this.game.renderRegionBlockAtMousePosition(e.clientX * this.game.getPixelRatio(), e.clientY * this.game.getPixelRatio())
    }

    if (this.game.isChunkDisplayEnabled) {
      this.game.showChunk(e.clientX * this.game.getPixelRatio(), e.clientY * this.game.getPixelRatio())
    }
  }

  isDesktop() {
    return !this.isMobile()
  }

  triggerEntityMouseEvents(globalMouseRow, globalMouseCol, globalMousePos) {
    if (this.game.isModalMenuOpen()) return
    if (!this.game.player) return

    globalMousePos = globalMousePos || this.getGlobalMousePos()
    globalMouseRow = globalMouseRow || this.getGlobalMouseRow(globalMousePos)
    globalMouseCol = globalMouseCol || this.getGlobalMouseCol(globalMousePos)

    let entity = this.game.sector.pick(globalMouseRow, globalMouseCol, globalMousePos)
    if (!entity) {
      if (this.lastMouseOverEntity) {
        this.lastMouseOverEntity.onMouseOut()
        this.lastMouseOverEntity = null
      }
    } else if (entity !== this.lastMouseOverEntity) {
      if (this.lastMouseOverEntity) {
        this.lastMouseOverEntity.onMouseOut()
      }

      entity.onMouseOver()
      
      this.lastMouseOverEntity = entity
    }
  }

}

module.exports = InputController

},{"../../../common/constants.json":656,"../../../common/helper":664,"../util/client_helper":649,"../util/socket_util":654,"./buildings/index":250,"ismobilejs":57,"nipplejs":156}],443:[function(require,module,exports){
const Buildings = require("./buildings/index")
const Equipments = require("./equipments/index")
const Ores = require("./ores/index")
const Bars = require("./bars/index")
const Foods = require("./foods/index")
const Drinks = require("./drinks/index")
const Ammos = require("./ammos/index")
const Terrains = require("./terrains/index")
const Helper = require("./../../../common/helper")
const Protocol = require("./../../../common/util/protocol")

class Item {

  static isUsableEquipment(data) {
    const klass = this.getKlass(data.type)
    return klass.isUsable()
  }

  static getCookableItems() {
    const cookableFoodKlasses = Foods.getCookables()
  }

  static isMiningEquipment(data) {
    if (!data) return false
    const klass = this.getKlass(data.type)
    const klassType = this.getKlassType(data.type)

    return klassType === "equipment" && klass.prototype.isMiningEquipment()
  }

  static isSyringe(data) {
    const klass = this.getKlass(data.type)
    const klassType = this.getKlassType(data.type)

    return klassType === "equipment" && klass.prototype.getType() === Protocol.definition().BuildingType.Syringe
  }

  static isGil(type) {
    return parseInt(type) === Protocol.definition().BuildingType.Gold
  }

  static hasThrowDestination(type) {
    const klass = Equipments.forType(type)
    if (!klass) return false

    return klass.prototype.getConstants().isThrowable
  }

  static isNameTag(type) {
    return type === Protocol.definition().BuildingType.NameTag
  }

  static getKlassType(type) {
    let klass = Buildings.forType(type)
    if (klass) return "building"

    klass = Equipments.forType(type)
    if (klass) return "equipment"

    klass = Ores.forType(type)
    if (klass) return "ore"

    klass = Bars.forType(type)
    if (klass) return "bar"

    klass = Foods.forType(type)
    if (klass) return "food"

    klass = Drinks.forType(type)
    if (klass) return "drink"

    klass = Ammos.forType(type)
    if (klass) return "ammo"

    klass = Terrains.forType(type)
    if (klass) return "terrain"

    throw new Error("no Buildings, Equipment, Ore, Bar, Food klass found for type " + type)
  }

  static getKlassByName(name) {
    const type = Protocol.definition().BuildingType[name]
    return this.getKlass(type)
  }

  static getKlass(type) {
    let klass = Buildings.forType(type)
    if (klass) return klass

    klass = Equipments.forType(type)
    if (klass) return klass

    klass = Ores.forType(type)
    if (klass) return klass

    klass = Bars.forType(type)
    if (klass) return klass

    klass = Foods.forType(type)
    if (klass) return klass

    klass = Drinks.forType(type)
    if (klass) return klass

    klass = Ammos.forType(type)
    if (klass) return klass

    klass = Terrains.forType(type)
    if (klass) return klass

    throw new Error("no Buildings, Equipment, Ore, Food found for type " + type)
  }

  static getRequirements(type) {
    const klass = this.getKlass(type)
    return klass.prototype.getRequirements()
  }

  static getCraftRequirements(type, player) {
    const klass = this.getKlass(type)
    const requirementsByName = klass.prototype.getRequirements()

    let requirements = []

    for (let name in requirementsByName) {
      let count = requirementsByName[name]
      let klass = this.getKlassByName(name)
      let supply = player.getRequirementInventorySupply(klass)
      requirements.push({ name: klass.getTypeName(), klass: klass, count: count, supply: supply })
    }

    return requirements
  }

  getTypeName() {
    return Helper.getTypeNameById(this.type)
  }

  static getMissingResources(type, inventoryInput) {
    const requirements = this.getRequirements(type)
    let missing = {}

    for (var i = 0; i < inventoryInput.length; i++) {
      let itemData = inventoryInput[i]
      if (!itemData) continue

      let typeName = Helper.getTypeNameById(itemData.type)
      let isRequirement = requirements[typeName]
      if (isRequirement) {
        let requiredCount = requirements[typeName]
        let deductible = Math.min(requiredCount, itemData.count)
        requirements[typeName] -= deductible
      }
    }

    for (let name in requirements) {
      if (requirements[name] > 0) missing[name] = true
    }

    return missing
  }

  static getWidth(type) {
    return this.getKlass(type).prototype.getWidth()
  }

  static getHeight(type) {
    return this.getKlass(type).prototype.getHeight()
  }

  static getSpritePath(type) {
    const klass = this.getKlass(type)

    return klass.prototype.getSpritePath()
  }
}

module.exports = Item

},{"./../../../common/helper":664,"./../../../common/util/protocol":686,"./ammos/index":191,"./bars/index":204,"./buildings/index":250,"./drinks/index":340,"./equipments/index":407,"./foods/index":422,"./ores/index":494,"./terrains/index":571}],444:[function(require,module,exports){
module.exports = [
  "", // [0]
  "", // [1]
  "", // [2]
  "CANCEL", // [3]
  "", // [4]
  "", // [5]
  "HELP", // [6]
  "", // [7]
  "BACK_SPACE", // [8]
  "TAB", // [9]
  "", // [10]
  "", // [11]
  "CLEAR", // [12]
  "ENTER", // [13]
  "ENTER_SPECIAL", // [14]
  "", // [15]
  "SHIFT", // [16]
  "CONTROL", // [17]
  "ALT", // [18]
  "PAUSE", // [19]
  "CAPS_LOCK", // [20]
  "KANA", // [21]
  "EISU", // [22]
  "JUNJA", // [23]
  "FINAL", // [24]
  "HANJA", // [25]
  "", // [26]
  "ESC", // [27]
  "CONVERT", // [28]
  "NONCONVERT", // [29]
  "ACCEPT", // [30]
  "MODECHANGE", // [31]
  "SPACE", // [32]
  "PAGE_UP", // [33]
  "PAGE_DOWN", // [34]
  "END", // [35]
  "HOME", // [36]
  "LEFT", // [37]
  "UP", // [38]
  "RIGHT", // [39]
  "DOWN", // [40]
  "SELECT", // [41]
  "PRINT", // [42]
  "EXECUTE", // [43]
  "PRINTSCREEN", // [44]
  "INSERT", // [45]
  "DELETE", // [46]
  "", // [47]
  "0", // [48]
  "1", // [49]
  "2", // [50]
  "3", // [51]
  "4", // [52]
  "5", // [53]
  "6", // [54]
  "7", // [55]
  "8", // [56]
  "9", // [57]
  "COLON", // [58]
  "SEMICOLON", // [59]
  "LESS_THAN", // [60]
  "EQUALS", // [61]
  "GREATER_THAN", // [62]
  "QUESTION_MARK", // [63]
  "AT", // [64]
  "A", // [65]
  "B", // [66]
  "C", // [67]
  "D", // [68]
  "E", // [69]
  "F", // [70]
  "G", // [71]
  "H", // [72]
  "I", // [73]
  "J", // [74]
  "K", // [75]
  "L", // [76]
  "M", // [77]
  "N", // [78]
  "O", // [79]
  "P", // [80]
  "Q", // [81]
  "R", // [82]
  "S", // [83]
  "T", // [84]
  "U", // [85]
  "V", // [86]
  "W", // [87]
  "X", // [88]
  "Y", // [89]
  "Z", // [90]
  "OS_KEY", // [91] Windows Key (Windows) or Command Key (Mac)
  "", // [92]
  "CONTEXT_MENU", // [93]
  "", // [94]
  "SLEEP", // [95]
  "NUMPAD0", // [96]
  "NUMPAD1", // [97]
  "NUMPAD2", // [98]
  "NUMPAD3", // [99]
  "NUMPAD4", // [100]
  "NUMPAD5", // [101]
  "NUMPAD6", // [102]
  "NUMPAD7", // [103]
  "NUMPAD8", // [104]
  "NUMPAD9", // [105]
  "MULTIPLY", // [106]
  "ADD", // [107]
  "SEPARATOR", // [108]
  "SUBTRACT", // [109]
  "DECIMAL", // [110]
  "DIVIDE", // [111]
  "F1", // [112]
  "F2", // [113]
  "F3", // [114]
  "F4", // [115]
  "F5", // [116]
  "F6", // [117]
  "F7", // [118]
  "F8", // [119]
  "F9", // [120]
  "F10", // [121]
  "F11", // [122]
  "F12", // [123]
  "F13", // [124]
  "F14", // [125]
  "F15", // [126]
  "F16", // [127]
  "F17", // [128]
  "F18", // [129]
  "F19", // [130]
  "F20", // [131]
  "F21", // [132]
  "F22", // [133]
  "F23", // [134]
  "F24", // [135]
  "", // [136]
  "", // [137]
  "", // [138]
  "", // [139]
  "", // [140]
  "", // [141]
  "", // [142]
  "", // [143]
  "NUM_LOCK", // [144]
  "SCROLL_LOCK", // [145]
  "WIN_OEM_FJ_JISHO", // [146]
  "WIN_OEM_FJ_MASSHOU", // [147]
  "WIN_OEM_FJ_TOUROKU", // [148]
  "WIN_OEM_FJ_LOYA", // [149]
  "WIN_OEM_FJ_ROYA", // [150]
  "", // [151]
  "", // [152]
  "", // [153]
  "", // [154]
  "", // [155]
  "", // [156]
  "", // [157]
  "", // [158]
  "", // [159]
  "CIRCUMFLEX", // [160]
  "EXCLAMATION", // [161]
  "DOUBLE_QUOTE", // [162]
  "HASH", // [163]
  "DOLLAR", // [164]
  "PERCENT", // [165]
  "AMPERSAND", // [166]
  "UNDERSCORE", // [167]
  "OPEN_PAREN", // [168]
  "CLOSE_PAREN", // [169]
  "ASTERISK", // [170]
  "PLUS", // [171]
  "PIPE", // [172]
  "HYPHEN_MINUS", // [173]
  "OPEN_CURLY_BRACKET", // [174]
  "CLOSE_CURLY_BRACKET", // [175]
  "TILDE", // [176]
  "", // [177]
  "", // [178]
  "", // [179]
  "", // [180]
  "VOLUME_MUTE", // [181]
  "VOLUME_DOWN", // [182]
  "VOLUME_UP", // [183]
  "", // [184]
  "", // [185]
  ";", // [186]
  "=", // [187]
  ",", // [188]
  "-", // [189]
  ".", // [190]
  "/", // [191]
  "`", // [192]
  "", // [193]
  "", // [194]
  "", // [195]
  "", // [196]
  "", // [197]
  "", // [198]
  "", // [199]
  "", // [200]
  "", // [201]
  "", // [202]
  "", // [203]
  "", // [204]
  "", // [205]
  "", // [206]
  "", // [207]
  "", // [208]
  "", // [209]
  "", // [210]
  "", // [211]
  "", // [212]
  "", // [213]
  "", // [214]
  "", // [215]
  "", // [216]
  "", // [217]
  "", // [218]
  "[", // [219]
  "\\", // [220]
  "]", // [221]
  "'", // [222]
  "", // [223]
  "META", // [224]
  "ALTGR", // [225]
  "", // [226]
  "WIN_ICO_HELP", // [227]
  "WIN_ICO_00", // [228]
  "", // [229]
  "WIN_ICO_CLEAR", // [230]
  "", // [231]
  "", // [232]
  "WIN_OEM_RESET", // [233]
  "WIN_OEM_JUMP", // [234]
  "WIN_OEM_PA1", // [235]
  "WIN_OEM_PA2", // [236]
  "WIN_OEM_PA3", // [237]
  "WIN_OEM_WSCTRL", // [238]
  "WIN_OEM_CUSEL", // [239]
  "WIN_OEM_ATTN", // [240]
  "WIN_OEM_FINISH", // [241]
  "WIN_OEM_COPY", // [242]
  "WIN_OEM_AUTO", // [243]
  "WIN_OEM_ENLW", // [244]
  "WIN_OEM_BACKTAB", // [245]
  "ATTN", // [246]
  "CRSEL", // [247]
  "EXSEL", // [248]
  "EREOF", // [249]
  "PLAY", // [250]
  "ZOOM", // [251]
  "", // [252]
  "PA1", // [253]
  "WIN_OEM_CLEAR", // [254]
  "" // [255]
]
},{}],445:[function(require,module,exports){
const tinycolor = require("tinycolor2")
const Grid = require("./../../../common/entities/grid")
const Helper = require("./../../../common/helper")
const Constants = require("./../../../common/constants")
const Lighting = require("./lighting")
const ClientHelper = require("./../util/client_helper")
const ExceptionReporter = require("./../util/exception_reporter")
const Fov = require('../../../common/entities/fov')

class LightManager {

  constructor(container) {
    this.container = container
    this.game = container.game
    this.sector = this.game.sector

    this.shadowMap         = new Grid("shadow", container, container.getRowCount(), container.getColCount(), null)
    this.lightMap          = new Grid("light",  container, container.getRowCount(), container.getColCount())
    this.fovMap            = new Grid("fov",  container, container.getRowCount(), container.getColCount())
    this.MAX_LIGHT_DISTANCE = 3

    this.shadowQueue = []
    this.lightSourceQueue = []
    this.changedLightSources = {}
    this.fovTileHits = {}
    this.skyColor = '#ffffff'
    this.skyBrightness = 100
    this.fovManager = new Fov(this)

    // if (!this.container.isMovable()) {
      this.initSkyMapCanvas()
    // }
    this.initLightMapCanvas()
    this.initFovMapCanvas()
  }

  initSkyMapCanvas() {
    this.skyMapCanvas = document.createElement("canvas")
    this.skyMapCanvas.width  = this.container.getColCount()
    this.skyMapCanvas.height = this.container.getRowCount()
    this.skyMapCanvas.id = "skymap_canvas"
    // document.body.appendChild(this.skyMapCanvas) // uncomment to debug lightmap

    this.drawSky()
  }

  initFovMapCanvas() {
    this.fovMapCanvas = document.createElement("canvas")
    this.fovMapCanvas.width  = this.container.getColCount()
    this.fovMapCanvas.height = this.container.getRowCount()
    this.fovMapCanvas.id = "fov_canvas"
    // let ctx = this.fovMapCanvas.getContext("2d")
    // ctx.fillStyle = '#333333'
    // ctx.fillRect(0, 0, this.fovMapCanvas.width, this.fovMapCanvas.height)
     // document.body.appendChild(this.fovMapCanvas) // uncomment to debug lightmap
  }

  initLightMapCanvas() {
    this.lightMapCanvas = document.createElement("canvas")
    this.lightMapCanvas.width  = this.container.getColCount()
    this.lightMapCanvas.height = this.container.getRowCount()
    this.lightMapCanvas.id = "lightmap_canvas"
    // let ctx = this.lightMapCanvas.getContext("2d")
    // ctx.fillStyle = '#333333'
    // ctx.fillRect(0, 0, this.lightMapCanvas.width, this.lightMapCanvas.height)

    // document.body.appendChild(this.lightMapCanvas) // uncomment to debug lightmap
  }

  redrawChangedLightSources() {
    // we dont want to redraw too many lighting
    // to reduce lag.
    let allowedMs = 8
    let elapsed = 0

    for (let id in this.changedLightSources) {
      if (elapsed > allowedMs) {
        break
      }

      try {
        let lighting = this.changedLightSources[id]
        let lightEntity = lighting.source

        let startTime = Date.now()

        this.unregisterLightSource(lightEntity)
        if (lightEntity.isLightOn()) {
          this.registerLightSource(lightEntity)
        } 

        let duration = Date.now() - startTime
        elapsed += duration

        delete this.changedLightSources[id]
      } catch(e) {
        ExceptionReporter.captureException(e)
      }
    }
  }

  getLightNeighbors(target) {
    let deltas = [{ row: -1, col: 0 }, { row: 0, col: -1 }, { row: +1, col: 0 }, { row: 0, col: +1 }]

    let neighbors = []

    deltas.forEach((delta) => {
      let row = target.row + delta.row
      let col = target.col + delta.col

      if (!this.container.platformMap.isOutOfBounds(row, col)) {
        let tile = this.getLightTile(row, col)
        neighbors.push(tile)
      }
    })

    return neighbors
  }

  getLightTile(row, col) {
    let hit = this.container.structureMap.rowColHitTest(row, col)
    if (hit.entity) return hit

    hit = this.container.armorMap.rowColHitTest(row, col)
    if (hit.entity) return hit

    hit = this.container.platformMap.rowColHitTest(row, col)
    if (hit.entity) return hit

    hit = this.container.map.rowColHitTest(row, col)
    if (hit.entity) return hit

    hit = this.container.groundMap.rowColHitTest(row, col)
    if (hit.entity) return hit

    hit = this.container.undergroundMap.rowColHitTest(row, col)
    if (hit.entity) return hit

    return hit
  }

  getPassableNeighbors(target) {
    let neighbors = this.getLightNeighbors(target)


    return neighbors.filter((neighbor) => {
      if (!neighbor) return null
      if (!neighbor.entity) return true // no obstacle, passable

      let isPassableTileType = !neighbor.entity.isLightBlocker()
      return isPassableTileType
    })
  }

  hasLighting(key) {
    return this.lightings[key]
  }

  registerShadow(hit, color) {
    this.shadowMap.set({ row: hit.row, col: hit.col, value: color })

    this.isShadowMapChanged = true
  }

  unregisterShadow(hit, color) {
    this.shadowMap.set({ row: hit.row, col: hit.col, value: color })

    this.isShadowMapChanged = true
  }

  registerLighting(hit, color) {
    let lighting = Lighting.create({ source: hit.source, distance: hit.distance, color: color, brightnessFactor: hit.brightnessFactor, row: hit.row, col: hit.col })

    this.lightMap.addToCollection(hit.row, hit.col, lighting)

    this.isLightMapChanged = true


    return lighting
  }

  unregisterLighting(lighting) {
    this.lightMap.removeFromCollection(lighting.row, lighting.col, lighting)

    this.isLightMapChanged = true
  }

  computeShadowValue(row, col) {
    let shadowColor = this.getShadowColor(row, col)
    if (!shadowColor) return { r: 255, g: 255, b: 255, a: 1 }

    let color = this.getColorInRange(shadowColor, "#000000", this.skyBrightness)
    return tinycolor(color).toRgb()
  }

  computeLightValue(row, col) {
    let lightSourceColor = this.getLightSourceColor(row, col)
    let totalBrightness = this.getTotalBrightness(row, col)

    if (lightSourceColor) {
      let rgb = lightSourceColor.toRgb()
      rgb.a = totalBrightness / 100

      return rgb
    } else {
      return { r: 0, g: 0, b: 0, a: 0 }
    }

    return 
  }

  getTotalBrightness(row, col) {
    let lightings = this.lightMap.get(row, col)
    let total = 0

    let result = this.applyLightBlocking(lightings)

    let negativeBrightness = 0
    let positiveBrightness = 0

    for (let key in result) {
      let lighting = result[key]
      if (lighting.brightnessFactor < 0) {
        negativeBrightness += lighting.brightnessFactor
      } else if (lighting.brightnessFactor > 0) {
        positiveBrightness += lighting.brightnessFactor
      }
    }

    total += negativeBrightness
    total = Math.max(0, total) // cant be lower than 0

    total += positiveBrightness
    total = Math.min(100, total) // cant be more than 100

    return total
  }

  colorWithBrightness(color, brightness) {
    let hsl = tinycolor(color).toHsl()
    let highestLuminance = hsl.l
    hsl.l = (brightness/100) * highestLuminance
    return tinycolor(hsl)
  }

  getColorInRange(startColor, endColor, brightness) {
    return ClientHelper.getRandomColorInRange(startColor, endColor, brightness / 100) 
  }

  getShadowColor(row, col) {
    return this.shadowMap.get(row, col)
  }

  getLightSourceColor(row, col) {
    let lightings = this.lightMap.get(row, col) || {}

    return this.addLightSourceColors(lightings)
  }

  getNaturalLightColor(row, col) {
    let lightings = this.lightMap.get(row, col) || {}

    const nonLightSourceLightings = Object.values(lightings).filter((lighting) => {
      return !lighting.isLightSource()
    })

    const nonLightSourceLighting = nonLightSourceLightings[0]
    if (nonLightSourceLighting) {
      return this.colorWithBrightness(nonLightSourceLighting.color, nonLightSourceLighting.brightnessFactor)
    } else {
      return this.colorWithBrightness(this.skyColor, this.skyBrightness)
    }
  } 

  addLightSourceColors(lightings) {
    let totalBrightness = 0
    let colorRatios = []

    for (let key in lightings) {
      let lighting = lightings[key]
      if (lighting.isLightSource()) {
        totalBrightness += lighting.brightnessFactor
      }
    }

    for (let key in lightings) {
      let lighting = lightings[key]
      if (lighting.isLightSource()) {
        colorRatios.push({ hex: lighting.color, ratio: lighting.brightnessFactor / totalBrightness })
      }
    }

    let rgb = ClientHelper.mixColors(colorRatios)

    return tinycolor({ r: rgb[0], g: rgb[1], b: rgb[2] })
  }

  applyLightBlocking(lightings) {
    let blocker

    for (let key in lightings) {
      let lighting = lightings[key]
      if (lighting.isLightBlocker()) {
        blocker = lighting
        break
      }
    }

    if (blocker) {
      // remove light source lightings
      let result = []

      for (let key in lightings) {
        let lighting = lightings[key]
        if (!lighting.isLightSource()) {
          result.push(lighting)
        }
      }

      return result
    } else {
      return lightings
    }
  }

  assignShadowFor(entity, color) {
    let row = entity.getRow()
    let col = entity.getCol()
    this.registerShadow({ row: row, col: col }, color)
    this.shadowQueue.push(entity)
  }

  unassignShadowFor(entity, color) {
    let row = entity.getRow()
    let col = entity.getCol()
    this.unregisterShadow({ row: row, col: col }, color)
  }

  assignLightingFor(entity, color, brightnessFactor) {
    let lightDistance = 1
    let hit = { source: entity, row: entity.getRow(), col: entity.getCol(), distance: lightDistance, brightnessFactor: brightnessFactor }
    let lighting = this.registerLighting(hit, color)
    entity.lighting = lighting 

    this.assignLightPixelValue(hit.row, hit.col)
  }

  clearFovCanvas() {
    let ctx = this.fovMapCanvas.getContext("2d")
    ctx.clearRect(0, 0, this.fovMapCanvas.width, this.fovMapCanvas.height)
  }

  applyFov() {
    if (!this.sector.isFovMode()) return
    if (!this.game.player) return
    this.clearFovCanvas()
    this.fovTileHits = this.fovManager.calculateFov(this.game.player, { shouldIncludeLightBlocker: true })
    this.assignFovLightBatched(this.fovTileHits)
    this.isFovMapChanged = true
    this.updateFovMapTexture()
  }

  removeFov() {
    this.clearFovCanvas()
    this.isFovMapChanged = true
    this.updateFovMapTexture()
  }

  assignLightPixelValue(row, col) {
    try {
      const pixel = this.getLightMapCanvasImageData()

      let rgb = this.computeLightValue(row, col)

      pixel.data[0] = rgb.r
      pixel.data[1] = rgb.g
      pixel.data[2] = rgb.b
      pixel.data[3] = Math.floor(rgb.a * 255)

      this.lightMapCanvas.getContext('2d').putImageData(pixel, col, row) // col - x, row - y
    } catch(e) {
      ExceptionReporter.captureException(e)
    }
  }

  isLightingsEmpty(lightings) {
    if (Array.isArray(lightings)) {
      return lightings.length === 0
    } else {
      return Object.keys(lightings).length === 0
    }
  }

  assignFovLightBatched(lightings) {
    if (this.isLightingsEmpty(lightings)) return

    let box
    try {
      box = this.getLightingBox(lightings)
      const imageData = this.getFovMapCanvasImageDataBatched(box)

      this.forEachLightings(lightings, (lighting) => {
        let rgb = { r: 255, g: 255, b: 255, a: 1 }
        let relativeRow = lighting.row - box.top
        let relativeCol = lighting.col - box.left
        let bufferInterval = 4
        let absoluteBaseIndex = bufferInterval * (relativeRow * box.width + relativeCol)

        imageData.data[absoluteBaseIndex    ] = rgb.r
        imageData.data[absoluteBaseIndex + 1] = rgb.g
        imageData.data[absoluteBaseIndex + 2] = rgb.b
        imageData.data[absoluteBaseIndex + 3] = Math.floor(rgb.a * 255)
      })

      this.fovMapCanvas.getContext('2d').putImageData(imageData, box.left, box.top) 
    } catch(e) {
      ExceptionReporter.captureException(e)
    }
  }

  assignLightPixelValueBatched(lightings) {
    if (this.isLightingsEmpty(lightings)) return

    let box
    try {
      box = this.getLightingBox(lightings)
      const imageData = this.getLightMapCanvasImageDataBatched(box)

      this.forEachLightings(lightings, (lighting) => {
        let rgb = this.computeLightValue(lighting.row, lighting.col)
        let relativeRow = lighting.row - box.top
        let relativeCol = lighting.col - box.left
        let bufferInterval = 4
        let absoluteBaseIndex = bufferInterval * (relativeRow * box.width + relativeCol)

        imageData.data[absoluteBaseIndex    ] = rgb.r
        imageData.data[absoluteBaseIndex + 1] = rgb.g
        imageData.data[absoluteBaseIndex + 2] = rgb.b
        imageData.data[absoluteBaseIndex + 3] = Math.floor(rgb.a * 255)
      })

      this.lightMapCanvas.getContext('2d').putImageData(imageData, box.left, box.top) 
    } catch(e) {
      ExceptionReporter.captureException(e)
    }
  }

  assignShadowPixelValue(row, col) {
    try {
      const pixel = this.getSkyMapCanvasImageData()

      let rgb = this.computeShadowValue(row, col)

      pixel.data[0] = rgb.r
      pixel.data[1] = rgb.g
      pixel.data[2] = rgb.b
      pixel.data[3] = Math.floor(rgb.a * 255)

      this.skyMapCanvas.getContext('2d').putImageData(pixel, col, row) // col - x, row - y
    } catch(e) {
      ExceptionReporter.captureException(e)
    }
  }

  getSkyMapCanvasImageData() {
    if (!this.skyMapImageData) {
      let ctx = this.skyMapCanvas.getContext('2d')
      this.skyMapImageData = ctx.getImageData(0, 0, 1, 1)
    }
  
    return this.skyMapImageData
  }

  getLightMapCanvasImageData() {
    if (!this.lightMapImageData) {
      let ctx = this.lightMapCanvas.getContext('2d')
      this.lightMapImageData = ctx.getImageData(0, 0, 1, 1)
    }
  
    return this.lightMapImageData
  }

  getSkyMapCanvasImageDataBatched(box) {
    let ctx = this.skyMapCanvas.getContext('2d')
    return ctx.getImageData(box.left, box.top, box.width, box.height)
  }

  getLightMapCanvasImageDataBatched(box) {
    let ctx = this.lightMapCanvas.getContext('2d')
    return ctx.getImageData(box.left, box.top, box.width, box.height)
  }

  getFovMapCanvasImageDataBatched(box) {
    let ctx = this.fovMapCanvas.getContext('2d')
    return ctx.getImageData(box.left, box.top, box.width, box.height)
  }

  forEachLightings(lightings, cb) {
    if (Array.isArray(lightings)) {
      for (var i = 0; i < lightings.length; i++) {
        cb(lightings[i])
      }
    } else {
      for (let key in lightings) {
        cb(lightings[key])
      }
    }
  }

  isOutOfBounds(row, col) {
    return row < 0 || row >= this.container.getRowCount() ||
           col < 0 || col >= this.container.getColCount()
  }

  getShadowBox(shadows) {
    let top = 100000
    let left = 100000
    let right = 0
    let bottom = 0

    for (var i = 0; i < shadows.length; i++) {
      let shadow = shadows[i]
      if (shadow.row < top) {
        top = shadow.row
      }

      if (shadow.col < left) {
        left = shadow.col
      }

      if (shadow.row > bottom) {
        bottom = shadow.row
      }

      if (shadow.col > right) {
        right = shadow.col
      }

    }

    return {
      top: top,
      left: left,
      width: right - left + 1,
      height: bottom - top + 1
    }
  }

  getLightingBox(lightings) {
    let top = 100000
    let left = 100000
    let right = 0
    let bottom = 0

    this.forEachLightings(lightings, (lighting) => {
      if (lighting.row < top) {
        top = lighting.row
      }

      if (lighting.col < left) {
        left = lighting.col
      }

      if (lighting.row > bottom) {
        bottom = lighting.row
      }

      if (lighting.col > right) {
        right = lighting.col
      }
    })

    return {
      top: top,
      left: left,
      width: right - left + 1,
      height: bottom - top + 1
    }
  }

  cleanup() {
    let ctx = this.lightMapCanvas.getContext("2d")
    ctx.clearRect(0, 0, this.lightMapCanvas.width, this.lightMapCanvas.height)

    ctx = this.fovMapCanvas.getContext("2d")
    ctx.clearRect(0, 0, this.fovMapCanvas.width, this.fovMapCanvas.height)

    ctx = this.skyMapCanvas.getContext("2d")
    ctx.fillStyle = "rgba(255, 255, 255, 1.000)"
    ctx.fillRect(0, 0, this.skyMapCanvas.width, this.skyMapCanvas.height)
    
    if (this.lightMapCanvas.parentElement) {
      this.lightMapCanvas.parentElement.removeChild(this.lightMapCanvas)
    }

    if (this.fovMapCanvas.parentElement) {
      this.fovMapCanvas.parentElement.removeChild(this.fovMapCanvas)
    }

    if (this.skyMapCanvas.parentElement) {
      this.skyMapCanvas.parentElement.removeChild(this.skyMapCanvas)
    }

  }


  addChangedLightSource(lightSource) {
    this.changedLightSources[lightSource.id] = lightSource
  }

  clearChangedLightSources() {
    this.changedLightSources = {}
  }

  invalidateLightSources(row, col) {
    let lightings = this.lightMap.get(row, col)
    let lightSources = Object.values(lightings).filter((lighting) => {
      return lighting.isLightSource()
    })

    lightSources.forEach((lightSource) => {
      this.addChangedLightSource(lightSource)
    })
  }

  isLightSourceRegistered(targetEntity) {
    return targetEntity.lightings.length > 0
  }

  getLightingKey(target) {
    return target.row + "-" + target.col
  }

  assignShadowPixelValueForEntities() {
  }

  assignShadowPixelValueForEntity(entity) {
    if (!entity) return

    try {
      let tiles = entity.getTiles()
      tiles.forEach((tile) => {
        this.assignShadowPixelValue(tile.row, tile.col)
      })
    } catch(e) {
      ExceptionReporter.captureException(e)
    }
  }

  // shadows is array of { row: col: }
  assignShadowPixelValueBatched(shadows) {
    if (shadows.length === 0) return

    let box
    try {
      box = this.getShadowBox(shadows)
      const imageData = this.getSkyMapCanvasImageDataBatched(box)

      for (var i = 0; i < shadows.length; i++) {
        let shadow = shadows[i]

        let rgb = this.computeShadowValue(shadow.row, shadow.col)
        let relativeRow = shadow.row - box.top
        let relativeCol = shadow.col - box.left
        let bufferInterval = 4
        let absoluteBaseIndex = bufferInterval * (relativeRow * box.width + relativeCol)

        imageData.data[absoluteBaseIndex    ] = rgb.r
        imageData.data[absoluteBaseIndex + 1] = rgb.g
        imageData.data[absoluteBaseIndex + 2] = rgb.b
        imageData.data[absoluteBaseIndex + 3] = Math.floor(rgb.a * 255)
      }

      this.skyMapCanvas.getContext('2d').putImageData(imageData, box.left, box.top) 
    } catch(e) {
      ExceptionReporter.captureException(e)
    }
  }

  setSkyColor(color) {
    this.skyColor = color
    this.drawSky()
  }

  setSkyBrightness(brightnessFactor) {
    if (this.sector.settings.isShadowsEnabled) {
      this.skyBrightness = brightnessFactor
    } else {
      this.skyBrightness = 100
    }

    this.drawSky()
  }

  drawSky() {
    let color = this.colorWithBrightness(this.skyColor, this.skyBrightness)

    let ctx = this.skyMapCanvas.getContext("2d")
    ctx.fillStyle = color.toString()
    ctx.fillRect(0, 0, this.skyMapCanvas.width, this.skyMapCanvas.height)


    let entities = Object.values(this.container.platforms).concat(Object.values(this.container.terrains))
    this.shadowQueue = this.shadowQueue.concat(entities)
  }

  nightMode() {
    this.setSkyBrightness(60)
  }

  dayMode() {
    this.setSkyBrightness(100)
  }

  setLightMapContainerAlpha(alpha) {
    if (this.game.isCanvasMode()) return
    if (!this.container.lightMapContainer) return

    if (this.sector.settings.isShadowsEnabled) {
      this.container.lightMapContainer.alpha = alpha  
    } else {
      this.container.lightMapContainer.alpha = 0.3
    }
  }

  setDarkness(hour) {
    if (this.game.isMiniGame()) {
      this.setLightMapContainerAlpha(0.95)
      this.setSkyBrightness(60)
      return
    }

    switch(hour) {
      case 21:
        this.setLightMapContainerAlpha(0.95)
        this.setSkyBrightness(60)
        break
      case 20:
        this.setLightMapContainerAlpha(0.8)
        this.setSkyBrightness(70)
        break
      case 19:
        this.setLightMapContainerAlpha(0.7)
        this.setSkyBrightness(80)
        break
      case 18:
        this.setLightMapContainerAlpha(0.6)
        this.setSkyBrightness(90)
        break
      case 6:
        this.setLightMapContainerAlpha(0.8)
        this.setSkyBrightness(70)
        break
      case 7:
        this.setLightMapContainerAlpha(0.7)
        this.setSkyBrightness(80)
        break
      case 8:
        this.setLightMapContainerAlpha(0.6)
        this.setSkyBrightness(90)
        break
      case 9:
        this.setLightMapContainerAlpha(0.5)
        this.setSkyBrightness(100)
        break
      default:
        if (hour < 6 || hour > 21) {
          this.setLightMapContainerAlpha(0.95)
          this.setSkyBrightness(60)
        } else {
          this.setLightMapContainerAlpha(0.5)
          this.setSkyBrightness(100)
        }
    }

  }

  updateLightMapTexture() {
    if (this.isLightMapChanged) {
      this.isLightMapChanged = false
      this.container.lightMapSprite.texture.update()
    }
  }

  updateFovMapTexture() {
    if (this.isFovMapChanged) {
      this.isFovMapChanged = false
      this.container.fovMapSprite.texture.update()
    }
  }

  updateShadowMapTexture() {
    if (!this.container.skyMapSprite) return

    if (this.isShadowMapChanged) {
      this.isShadowMapChanged = false
      this.container.skyMapSprite.texture.update()
      this.shadowQueue.forEach((entity) => {
        entity.onShadowRendered()
      })

      this.shadowQueue = []
    }
  }

  reduceBrightnessFactor(target, amount) {
    target.brightnessFactor -= amount

    if (target.brightnessFactor < 0) {
      target.brightnessFactor = 0
    }
  }

  processQueue() {
    this.processLightQueue()
    this.processShadowQueue()
  }

  processShadowQueue() {
    let elapsed = 0
    let batchCount = 300 

    let prevShadowQueueLength = this.shadowQueue.length

    while (this.shadowQueue.length > 0 && elapsed < 5) {
      let entities = this.shadowQueue.splice(0, batchCount)
      let start = Date.now()
      this.assignShadowPixelValueBatched(entities)
      elapsed += (Date.now() - start)
    }

    if (this.shadowQueue.length === 0 && prevShadowQueueLength > 0) {
      this.isShadowMapChanged = true
      this.updateShadowMapTexture()
    }
  }

  processLightQueue() {
    let allowedMs = 5
    let elapsed = 0

    while (this.lightSourceQueue.length > 0 && elapsed < allowedMs) {
      let startTime = Date.now()

      let data = this.lightSourceQueue.shift()
      if (data.action === 'register') {
        this.registerLightSource(data.entity)
      } else if (data.action === 'unregister') {
        this.unregisterLightSource(data.entity)
      }

      let duration = Date.now() - startTime
      elapsed += duration
    }
  }

  queueLightSource(data) {
    this.lightSourceQueue.push(data)
  }

  registerLightSource(targetEntity) {
    if (this.isLightSourceRegistered(targetEntity)) return

    let color = targetEntity.getLightColor()
    let radiusTileCount = targetEntity.getLightRadius()

    let lightings = {} // remember them so we can easily remove after

    let target = { 
      id: targetEntity.id, 
      source: targetEntity, 
      row: targetEntity.getRow(), 
      col: targetEntity.getCol(), 
      color: color,
      brightnessFactor: 100 
    }

    let frontier = [target]

    let lightingKey = this.getLightingKey(target)
    target.distance = 0

    let lighting = this.registerLighting(target, color)
    lightings[lightingKey] = lighting

    let brightnessDecay = 100 / radiusTileCount

    // create flows for neighbors recursively
    while (frontier.length > 0) {
      let current = frontier.shift()
      let neighbors = this.getLightNeighbors(current)
      neighbors.forEach((neighbor) => {
        let lightingKey = this.getLightingKey(neighbor)

        // if we've already marked the flow before, dont do it again
        if (!lightings[lightingKey] && current.distance < radiusTileCount) { 
          neighbor.distance = current.distance + 1 
          neighbor.source = targetEntity

          // reduce brightness
          neighbor.brightnessFactor = current.brightnessFactor 
          this.reduceBrightnessFactor(neighbor, brightnessDecay)

          if (neighbor.entity && neighbor.entity.isLightBlocker()) {
            // stop propagating further from that tile. 
            neighbor.brightnessFactor = 0
          } else if (neighbor.entity && neighbor.entity.isLightDiffuser()) {
            this.reduceBrightnessFactor(neighbor, 10)
          }

          if (neighbor.brightnessFactor > 0) {
            frontier.push(neighbor)
          }

          lighting = this.registerLighting(neighbor, color)
          lightings[lightingKey] = lighting
        }
      })
    }

    targetEntity.lightings = Object.values(lightings)  // remember so we can remove later

    this.assignLightPixelValueBatched(lightings)
  }

  unregisterLightSource(targetEntity) {
    for (var i = 0; i < targetEntity.lightings.length; i++) {
      let lighting = targetEntity.lightings[i]
      this.unregisterLighting(lighting)
    }

    this.assignLightPixelValueBatched(targetEntity.lightings)

    for (var i = 0; i < targetEntity.lightings.length; i++) {
      let lighting = targetEntity.lightings[i]
      lighting.remove()
    }

    targetEntity.lightings = []
  }

}

module.exports = LightManager
},{"../../../common/entities/fov":658,"./../../../common/constants":656,"./../../../common/entities/grid":659,"./../../../common/helper":664,"./../util/client_helper":649,"./../util/exception_reporter":650,"./lighting":448,"tinycolor2":172}],446:[function(require,module,exports){
const Path = require("./path")
const LightPathLocation = require("./light_path_location")

class LightPath extends Path {

  show(data) {
    if (this.sprite) {
      this.removeSelfAndChildrens(this.sprite)
    }

    for (let key in data) {
      this.data[key] = data[key]
    }

    this.buildSprites()
  }

  hide() {
    if (this.sprite) {
      this.removeSelfAndChildrens(this.sprite)
    }
  }

  shouldShowDirection() {
    return false
  }

  getPathLocationKlass() {
    return LightPathLocation  
  }

  getBaseSprite() {
    let sprite = super.getBaseSprite()
    sprite.tint = 0xffb6b6
    return sprite
  }

  getGroup() {
    return "light_paths"
  }

}

module.exports = LightPath
},{"./light_path_location":447,"./path":510}],447:[function(require,module,exports){
const PathLocation = require("./path_location")
const Constants = require("./../../../common/constants.json")
const SpriteEventHandler = require("./../util/sprite_event_handler")

class LightPathLocation extends PathLocation {
  
  constructor(game, data) {
    super(game, data)

    this.sprite.interactive = true
    SpriteEventHandler.on(this.sprite, "pointerdown", this.onClick.bind(this))
  }

  onClick() {
    this.game.selectEntity(this)
    this.game.showEntityMenu(this, { dontCloseMenus: true })
  }

  renderEntityMenu(entityMenu) {
    this.showLighting(this.game.sector, entityMenu)
  }

  shouldShowDirection() {
    return false
  }


}

module.exports = LightPathLocation
},{"./../../../common/constants.json":656,"./../util/sprite_event_handler":655,"./path_location":511}],448:[function(require,module,exports){
const Poolable = require("../../../common/interfaces/poolable")
const ObjectPool = require("../../../common/entities/object_pool")

class Lighting {
  static create(options) {
    let lighting = ObjectPool.obtain("Lighting")
    lighting.setAttributes(options)
    return lighting
  }

  constructor(options) {
  }

  setAttributes(options) {
    this.id = [options.source.constructor.getTypeName(), options.source.id].join("-")
    this.row = options.row
    this.col = options.col
    this.distance = options.distance
    this.source = options.source
    this.color = options.color
    this.brightnessFactor = options.brightnessFactor // 0-100 (tinycolor2 spec)
  }

  isLightSource() {
    return this.source.isLightSource()
  }

  isLightBlocker() {
    return this.source.isLightBlocker()
  }

  remove() {
    ObjectPool.free("Lighting", this)
  }

}

Object.assign(Lighting.prototype, Poolable.prototype, {
  reset() {
    // not needed. every instance variable is overwritten anyway
  }
})

module.exports = Lighting

},{"../../../common/entities/object_pool":660,"../../../common/interfaces/poolable":675}],449:[function(require,module,exports){
const BaseEntity = require('./../base_entity')
const Constants = require("./../../../../common/constants.json")
const HealthBar = require("./../../components/health_bar")
const Destroyable = require('./../../../../common/interfaces/destroyable')
const Upgradable = require('./../../../../common/interfaces/upgradable')
const Faithable = require('./../../../../common/interfaces/faithable')
const ShipMountable = require('./../../../../common/interfaces/ship_mountable')
const Helper = require('./../../../../common/helper')
const Ship = require("./../ship")
const ClientHelper = require("./../../util/client_helper")
const SocketUtil = require("./../../util/socket_util")
const SpriteEventHandler = require("./../../util/sprite_event_handler")
const Interpolator = require("./../../util/interpolator")
const Equipments = require("./../equipments/index")
const Item = require("./../item")
const Needs  = require("./../../../../common/interfaces/needs")
const Protocol = require("./../../../../common/util/protocol")
const BitmapText = require("../../util/bitmap_text")

class BaseMob extends BaseEntity {
  constructor(game, data) {
    super(game, data)

    this.level = 0
    this.isKnocked = false

    this.initFaithable(data.faith)
    this.initDestroyable(data.health)
    this.initNeeds()
    this.healthBar = new HealthBar(this)

    this.chunks = {}
    this.behaviorLogs = []

    // this.addRangeSprite()

    this.onPositionChanged()
    this.onPostInit()
  }

  static getRangeTexture() {
    if (!this.rangeTexture) {
      let graphics = new PIXI.Graphics()
      graphics.beginFill(0xc59bff)
      graphics.drawCircle(0, 0, this.prototype.getAttackRange())
      graphics.endFill()

      this.rangeTexture = game.app.renderer.generateTexture(graphics)
    }

    return this.rangeTexture
  }

  getAttackRange() {
    return this.getStats(this.level).range
  }

  getRangeSprite() {
    let sprite = new PIXI.Sprite(this.constructor.getRangeTexture())
    sprite.name = "range"
    sprite.anchor.set(0.5)
    sprite.position.x = 0
    sprite.position.y = 0
    sprite.alpha = 0
    return sprite
  }

  onMouseOver() {
    super.onMouseOver()

    this.game.highlight(this)
    this.game.showEntityMenu(this)
  }

  onMouseOut() {
    super.onMouseOut()

    this.game.unhighlight(this)
    this.game.hideEntityMenu(this)
  }

  addBehaviorLog(log) {
    if (this.behaviorLogs.length >= 200) {
      this.behaviorLogs.shift()
    }

    this.behaviorLogs.push(log)

    if (this.game.entityMenu.isOpen(this)) {
      this.game.entityMenu.update(this)
    }
  }

  onNPCServerMessage(data) {
    this.npcChoice = data.choice
    let message = i18n.t(data.message)
    this.createChatBubble(message)
  }

  onPostInit() {
    let pendingCameraTargetId = this.game.getPendingCameraFocusTargetId()
    if (pendingCameraTargetId && pendingCameraTargetId === this.id) {
      this.game.centerCameraTo(this)
      this.game.player.setCameraFocusTarget(this)

      this.game.setPendingCameraFocusTargetId(null)
    }
  }

  addRangeSprite() {
    this.rangeSprite = this.getLineOfSightRangeSprite()
    this.sprite.addChild(this.rangeSprite)
  }

  unselect() {
    super.unselect()
    // this.hideRange()
  }

  isInteractable() {
    if (this.game.player.isControllingGhost()) {
      return this.isObedient() && !this.isDestroyed() && !this.isGhost()
    } else {
      return this.isDestroyed()
    }
  }

  isGhost() {
    return false
  }

  isObedient() {
    return this.faith >= Constants.Faith.Obedient
  }


  getLineOfSightRangeSprite() {
    const sprite = new PIXI.Sprite(PIXI.utils.TextureCache["los_range.png"])
    sprite.anchor.set(0.5)
    sprite.alpha = 0 // 0.1
    sprite.width  = this.getLineOfSightRange() * 2 // range is radius, so width/diameter should be 2x
    sprite.height = this.getLineOfSightRange() * 2
    return sprite
  }

  drawRange() {
    this.rangeSprite.alpha = 0.1
  }

  hideRange() {
    this.rangeSprite.alpha = 0
  }


  static build(game, data) {
    return new this(game, data)
  }

  getSpriteContainer() {
    return this.game.sector.spriteLayers["mobs"]
  }

  getContainer() {
    return this.ship || this.game.sector
  }

  isMob() {
    return true
  }

  getEffectableSprite() {
    return this.characterSprite
  }

  setScaleX(scale) {
    this.characterSprite.scale.x = scale
  }

  getTintableSprite() {
    return this.characterSprite
  }

  getTintableSprites() {
    return [this.characterSprite]
  }

  getDefaultSpriteColor() {
    return 0xffffff
  }

  getTameFaithPercentage() {
    return Math.min(100, Math.floor((this.faith / Constants.Faith.Obedient) * 100))
  }

  getRotatableSprite() {
    return this.characterSprite
  }

  getSprite() {
    const sprite = new PIXI.Container()

    this.characterSprite = this.getCharacterSprite()
    Interpolator.mixin(this.characterSprite)

    this.sleepStatusContainer = new PIXI.Container()
    this.sleepStatusContainer.name = "SleepStatus"

    sprite.addChild(this.characterSprite)
    sprite.addChild(this.sleepStatusContainer)

    return sprite
  }

  getCharacterSprite() {
    const sprite = new PIXI.Sprite(PIXI.utils.TextureCache[this.getSpritePath()])
    sprite.name = "Mob"
    sprite.anchor.set(0.5)

    if (this.shouldUseOriginalWidth()) {
    } else if (this.getConstants().sprite) {
      sprite.width = this.getConstants().sprite.width
      sprite.height = this.getConstants().sprite.height
    } else {
      // apply server mob width/height
      sprite.width = this.getWidth()
      sprite.height = this.getHeight()
    }

    return sprite
  }

  getCorpseSprite() {
    return this.getCharacterSprite()
  }

  applyConstantsDefinition() {

  }

  syncWithServer(data) {
    this.instructToMove(data.x, data.y)
    this.setKnocked(data.isKnocked)
    this.setLevel(data.level)
    this.setAngle(data.angle)
    this.setStatus(data.status)
    this.setHealth(data.health)
    this.setHunger(data.hunger)
    this.setStamina(data.stamina)
    this.setSleepState(data.isSleeping)
    this.setFaith(data.faith)
    this.setIsAttacking(data.isAttacking)
    this.setIsLivestock(data.isLivestock)
    this.setTasks(data.tasks)
    this.setEffects(data.effects)
    this.setNextFeedTime(data.nextFeedTime)
    this.setMaster(data.master)
    this.setOwner(data.owner)
    this.setRaycast(data)
    this.setGoalTargets(data.goalTargets)
    this.setName(data.name)
    this.setContent(data.content)

    if (data.hasOwnProperty('weaponType')) {
      this.setWeaponType(data.weaponType)
    }

    if (data.hasOwnProperty("behavior")) {
      this.setBehavior(data.behavior)
    }

    if (data.shipId) {
      this.ship = this.game.ships[data.shipId]
    }
  }

  setName(name) {
    if (this.name !== name) {
      this.name = name
      this.onNameChanged()
    }
  }

  setContent(content) {
    if (this.content !== content) {
      this.content = content
      this.onContentChanged()
    }
  }

  setWeaponType(weaponType) {
    if (!this.isEquipper()) return

    if (this.weaponType !== weaponType) {
      if (this.getHandEquipment()) {
        this.getHandEquipment().remove()
      }

      this.weaponType = weaponType
      if (weaponType) {
        this.initWeapon(weaponType)
      }
    }
  }

  isEquipper() {
    return this.equipments
  }

  initWeapon(weaponType) {
    let data = {
      x: 0,
      y: 0,
      user: this
    }

    let item = Item.getKlass(weaponType).build(this.game, data)
    this.setHandEquipment(item)
  }

  getName() {
    return this.name
  }

  onContentChanged() {
    if (this.game.entityMenu.isOpen(this)) {
      this.game.entityMenu.update(this)
    }
  }

  onNameChanged() {
    if (this.name) {
      if (!this.usernameText) {
        this.createUsernameSprite()
      } else {
        this.usernameText.sprite.text = this.name
        if (this.game.changeNameMenu.isOpen()) {
          this.game.changeNameMenu.close()
        }
      }
    } else {
      if (this.usernameText) {
        this.usernameText.remove()
        this.usernameText = null
      }
    }
  }

  createUsernameSprite() {
    this.usernameText = BitmapText.create({
      label: "MobName",
      text: this.getName(),
      spriteContainer: this.sprite
    })

    this.usernameText.sprite.position.y = this.getHeight()
  }

  setIsLivestock(isLivestock) {
    if (this.isLivestock !== isLivestock) {
      this.isLivestock = isLivestock
      this.onIsLivestockChanged()
    }
  }

  setTasks(tasks) {
    let prevTasks = this.tasks
    this.tasks = tasks

    if (this.tasks !== prevTasks) {
      if (this.game.entityMenu.isOpen(this)) {
        this.game.entityMenu.update(this)
      }
    }
  }

  onIsLivestockChanged() {
    if (this.game.entityMenu.isOpen(this)) {
      this.game.entityMenu.update(this)
    }
  }

  setIsAttacking(isAttacking) {
    if (this.isAttacking !== isAttacking) {
      this.isAttacking = isAttacking
      this.onAttackStateChanged()
    }
  }


  onAttackStateChanged() {

  }

  setBehavior(behavior) {
    if (this.behavior !== behavior) {
      this.behavior = behavior
      this.onBehaviorChanged()
    }
  }

  getBehaviorName() {
    return Helper.getBehaviorNameById(this.behavior)
  }

  onBehaviorChanged() {
    if (this.game.entityMenu.isOpen(this)) {
      this.game.entityMenu.update(this)
    }
  }

  getMeleeChargeTween(targetPosition) {
    let origX = this.getX()
    let origY = this.getY()
    let position = { x: origX, y: origY }

    const tween = new TWEEN.Tween(position)
        .to(targetPosition, 250)
        .easing(TWEEN.Easing.Quadratic.Out)
        .onUpdate(() => {
          this.sprite.position.x = position.x
          this.sprite.position.y = position.y
        })
        .repeat(1)
        .yoyo(true)

    return tween
  }


  setGoalTargets(goalTargets) {
    if (this.goalTargets !== goalTargets) {
      this.goalTargets = goalTargets
      this.onGoalTargetsChanged()
    }
  }

  onGoalTargetsChanged() {
    if (game.entityMenu.selectedEntity === this) {
      this.game.showEntityMenu(this)
    }
  }

  setRaycast(data) {
    if (data.raycastX) {
      // check if same position
      let raycastSprite = this.getRaycastSprite()
      if (raycastSprite.position.x !== data.raycastX && raycastSprite.position.y !== data.raycastY) {
        raycastSprite.position.x = data.raycastX
        raycastSprite.position.y = data.raycastY
        this.onRaycastPositionChanged()
      }
    }
  }

  onRaycastPositionChanged() {

  }

  getRange() {
    return this.getStats(this.level).range
  }

  getRaycastSprite() {
    if (!this.raycastSprite) {
      const sprite = new PIXI.Sprite(PIXI.utils.TextureCache["red.png"])
      sprite.anchor.set(0.5)
      sprite.alpha = 0.4
      sprite.position.x = this.getX()
      sprite.position.y = this.getY()
      this.game.sector.effectsContainer.addChild(sprite)
      this.raycastSprite = sprite
    }

    return this.raycastSprite
  }

  isDifferentOwner(owner, otherOwner) {
    if (owner && !otherOwner) return true
    if (otherOwner && !owner) return true
    if (!owner && !otherOwner) return false

    return owner.name !== otherOwner.name
  }

  setOwner(owner) {
    if (this.isDifferentOwner(this.owner, owner)) {
      this.owner = owner
      if (game.entityMenu.selectedEntity === this) {
        this.game.showEntityMenu(this)
      }
    }
  }

  isTamableBy(player) {
    if (!this.isTamable()) return false

    if (this.owner && this.owner.name !== player.name) return false
    return true
  }

  isMountable(player) {
    if (!this.belongToOwner(player)) return false

    return this.hasCategory("mountable")
  }

  isTamable() {
    return this.getConstants().isTamable
  }

  setMaster(master) {
    if (master) {
      if (this.masterId === master.id) return

      this.masterId = master.id

      if (game.entityMenu.selectedEntity === this) {
        this.game.showEntityMenu(this)
      }
    } else {
      if (this.masterId) {
        this.masterId = null

        if (game.entityMenu.selectedEntity === this) {
          this.game.showEntityMenu(this)
        }
      }
    }
  }

  setNextFeedTime(nextFeedTime) {
    this.nextFeedTime = nextFeedTime
  }

  setStatus(status) {
    if (this.status !== status) {
      this.status = status

      if (game.entityMenu.selectedEntity === this) {
        this.game.showEntityMenu(this)
      }

    }
  }

  getStatusName() {
    return Helper.getMobStatusNameById(this.status)
  }

  interpolate(lastFrameTime) {
    const prev = { x: this.sprite.position.x, y: this.sprite.position.y }
    super.interpolate(lastFrameTime)
    const curr = { x: this.sprite.position.x, y: this.sprite.position.y }

    if (curr.x !== prev.x || curr.y !== prev.y) {
      this.onPositionChanged()
    }
  }

  animateWalkOnPlatform() {
    let platform = this.getStandingPlatform()
    if (platform) {
      platform.animateWalk(this)
    }
  }

  onPositionChanged() {
    this.animateWalkOnPlatform()

    this.repositionOnUnitMap()
    this.registerToChunk()

    if (this.isControlledByPlayer()) {
      // this.game.player.checkInteractable(this)
    }
  }

  onHighlighted() {
    let text = this.game.dialogueMap[this.getId()]
    if (text) {
      let message 
      if (text.dialogues[window.language]) {
        message = text.dialogues[window.language]
      } else {
        message = text.dialogues["en"]
      }

      this.createChatBubble(message)
    }
  }

  onPreRemove(cb) {
    cb()
  }

  shouldRemoveImmediately() {
    return !this.getConstants().shouldFadeOut || this.health === 0
  }

  getSelectionWidth() {
    return Constants.tileSize
  }

  remove(entityData) {
    if (this.raycastSprite) {
      this.game.sector.effectsContainer.removeChild(this.raycastSprite)
    }

    this.cleanupAnimationTween()
    this.getContainer().unregisterEntity("mobs", this)
    this.removeFromUnitMap()

    if (entityData && entityData.health === 0) {
      // we want to trigger onHealthZero callback
      this.setHealth(entityData.health)
    }

    if (this.chunk) {
      this.chunk.unregister("mobs", this)
    }

    if (this.game.entityMenu.isOpen(this)) {
      this.game.entityMenu.removeSelectedEntity()
    }

    if (this.shouldRemoveImmediately()) {
      super.remove()
    } else {
      this.onPreRemove(() => {
        super.remove()
      })
    }
  }

  animateHeart() {
    const sprite = new PIXI.Sprite(PIXI.utils.TextureCache["heart.png"])
    sprite.anchor.set(0.5)
    sprite.position.x = this.getX()
    sprite.position.y = this.getY()
    this.game.sector.effectsContainer.addChild(sprite)

    let position = { y: this.getY() }

    var tween = new TWEEN.Tween(position)
        .to({ y: this.getY() - (Constants.tileSize * 1) }, 1000)
        .easing(TWEEN.Easing.Quadratic.Out) // Use an easing function to make the animation smooth.
        .onUpdate(() => {
          sprite.position.y = position.y
        })
        .onComplete(() => {
          this.game.sector.effectsContainer.removeChild(sprite)
        })
        .start()
  }

  onClick() {
    this.game.selectEntity(this)
    this.game.showEntityMenu(this, { dontCloseMenus: true, selectedEntity: this, replaceSelected: true })
    this.game.interact(this)
  }

  getTypeName() {
    let type = this.getType()
    return Helper.getMobNameById(type).replace(/([A-Z])/g, ' $1').trim() // space before capital letters
  }

  getType() {
    return this.prototype.getType()
  }

  getType() {
    throw "must implement BaseMob#getType"
  }

  static getSellGroup() {
    return "Mobs"
  }

  getGroup() {
    return "mobs"
  }

  getGoldDrop() {
    // linear for now
    const startGold = 10
    const multiplier = 1.09
    const base = startGold + Math.floor(startGold * multiplier * this.level)
    return base
  }

  setAngle(angle) {
    if (this.angle !== angle) {
      this.angle = angle
      const baseRotationOffset = this.getBaseRotationOffset()
      this.instructToRotate(this.getRadAngle() + baseRotationOffset)
    }
  }

  getBaseRotationOffset() {
    return 90 * (Math.PI / 180)
  }

  setKnocked(isKnocked) {
    if (this.isKnocked !== isKnocked) {
      this.isKnocked = isKnocked
      this.onKnockedChanged()
    }
  }

  setLevel(level) {
    this.level = level
  }

  onKnockedChanged() {
    if (this.isKnocked) {
      this.dizzySprite = new PIXI.Sprite(PIXI.utils.TextureCache["dizzy_eyes.png"])
      this.dizzySprite.width  = 30
      this.dizzySprite.height = 12
      this.dizzySprite.anchor.set(0.5)
      this.characterSprite.addChild(this.dizzySprite)
    } else {
      if (this.dizzySprite) {
        this.characterSprite.removeChild(this.dizzySprite)
      }
    }
  }

  renderEntityMenu(entityMenu) {
    this.showStats(entityMenu)
    this.showAction(entityMenu)
    this.showTabs(entityMenu)
    this.showLogs(entityMenu)
    this.showTasks(entityMenu)
  }

  showTasks(entityMenu) {
    if (!this.hasTasks()) return

    let taskNames = Object.keys(Protocol.definition().TaskType)
    for (let i = 0; i < taskNames.length; i++) {
      let taskName = taskNames[i]
      let taskId = Protocol.definition().TaskType[taskName]
      let bitValue = (this.tasks >> taskId) % 2
      let isEnabled = bitValue === 1
      let slaveTaskCheckbox = entityMenu.querySelector(`.slave_task[data-task-id='${taskId}'] input`)

      if (isEnabled) {
        slaveTaskCheckbox.checked = true
      } else {
        slaveTaskCheckbox.checked = false
      }
    }
  }

  hasTasks() {
    return this.hasCategory("worker")
  }

  showTabs(entityMenu) {
  }

  showLogs(entityMenu) {
    if (!debugMode) return
      
    let logs = ""
    this.behaviorLogs.forEach((log) => {
      logs += "<div class='entity_log'>" + log + "</div>"
    })

    entityMenu.querySelector(".entity_logs").innerHTML = logs
  }

  showStats(entityMenu) {
    let stats = ""

    const health = "<div class='entity_stats_entry'>" +
                      "<div class='stats_type'>" + i18n.t('Entity.Mob.Health') + "</div>" +
                      "<div class='stats_value'>" + this.health + "/" + this.getMaxHealth() + "</div>" +
                  "</div>"

    stats += health

    if (this.getConstants().shouldShowBehavior) {
      const behavior = "<div class='entity_stats_entry'>" +
                         "<div class='stats_type'>" + i18n.t('State') + "</div>" +
                         "<div class='stats_value'>" + this.getBehaviorName() + "</div>" +
                       "</div>"

      stats += behavior
    }

    if (this.isTamableBy(this.game.player)) {
      let taming = "<div class='entity_stats_entry'>" +
                        "<div class='stats_type'>" + i18n.t("Taming") + "</div>" +
                        "<div class='stats_value'>" + (this.getTameFaithPercentage()) + "%</div>" +
                    "</div>"
      stats += taming
    }


    if (this.owner && this.shouldShowOwner()) {
      let ownership = this.getOwnershipStat()
      stats += ownership
    }

    if (this.masterId) {
      let masterName = this.getMasterName(this.masterId)
      if (masterName) {
        let masterStat = this.getMasterStat(masterName)
        stats += masterStat
      }
    }

    if (this.isLivestock) {
      stats += this.getLivestockStat()
    }
    
    if (this.getConstants().shouldShowNeeds) {
      let barWidthPercent = Math.floor(this.hunger / this.getMaxHunger() * 100)

      const hunger = "<div class='entity_stats_entry'>" +
                         "<div class='stats_type'><img class='entity_stats_hunger_label' src='/assets/images/hunger_status.png'></div>" +
                         "<div class='stats_value'>" + 
                           "<div class='hunger_bar bar_container'>" +
                             "<div class='bar_fill' style='width: " + barWidthPercent + "%'>" +
                             "</div>" +
                           "</div>" +
                         "</div>" +
                       "</div>"

      stats += hunger

      barWidthPercent = Math.floor(this.stamina / this.getMaxStamina() * 100)

      const stamina = "<div class='entity_stats_entry'>" +
                         "<div class='stats_type'><img class='entity_stats_stamina_label'  src='/assets/images/stamina_icon.png'></div>" +
                         "<div class='stats_value'>" + 
                           "<div class='stamina_bar bar_container'>" +
                             "<div class='bar_fill' style='width: " + barWidthPercent + "%'>" +
                             "</div>" +
                           "</div>" +
                         "</div>" +
                       "</div>"

      stats += stamina

//       barWidthPercent = Math.floor(this.happiness / this.getMaxHappiness() * 100)
// 
//       const happiness = "<div class='entity_stats_entry'>" +
//                           "<div class='stats_type'><img class='entity_stats_stamina_label' src='/assets/images/happiness_status.png'></div>" +
//                           "<div class='stats_value'>" + 
//                             "<div class='happiness_bar bar_container'>" +
//                               "<div class='bar_fill' style='width: " + barWidthPercent + "%'>" +
//                               "</div>" +
//                             "</div>" +
//                           "</div>" +
//                         "</div>"
// 
//       stats += happiness
    }


    if (this.goalTargets) {
      let goals = "<div class='entity_stats_entry'>" +
                      "<div class='stats_type'>Goals</div>" +
                      "<div class='stats_value'>" + this.getGoalTargetsHTML() + "</div>" +
                  "</div>"
      stats += goals
    }

    entityMenu.querySelector(".entity_stats").innerHTML = stats
  }

  shouldShowOwner() {
    return true
  }

  getGoalTargetsHTML() {
    return this.goalTargets.split(",").map((goalTarget) => {
      return goalTarget + "<br/>"
    }).join("")
  }

  getMasterName(masterId) {
    let entity = this.game.sector.getEntity(masterId)
    if (entity) {
      return entity.name
    } else {
      return null
    }
  }

  getLivestockStat() {
    let el = "<div class='entity_stats_entry'>" +
                    "<div class='stats_type'>" + i18n.t("livestock") + ":</div>" +
                    "<div class='stats_value livestock_stats_value'>True</div>" +
                "</div>"
    return el
  }

  getMasterStat(masterName) {
    let el = "<div class='entity_stats_entry'>" +
                    "<div class='stats_type'>" + i18n.t("Following") + ":</div>" +
                    "<div class='stats_value'>" + masterName + "</div>" +
                "</div>"
    return el
  }

  isPet() {

  }

  canTakeAlong() {
    if (this.hasCategory("mountable")) return false
      
    return this.getConstants().isTamable ||
           this.hasCategory("bot") ||
           this.hasCategory("worker") ||
           this.hasCategory("trader") 
  }

  canBecomeLivestock() {
    return this.getConstants().isTamable
  }

  shouldShowInteractTooltip() {
    if (this.owner) {
      let item = this.game.player.getActiveItem()
      if (item && Item.isNameTag(item.type)) {
        return true
      }
    }

    return super.shouldShowInteractTooltip()
  }

  hasMenu() {
    if (this.owner) {
      let item = this.game.player.getActiveItem()
      if (item && Item.isNameTag(item.type)) {
        return true
      }
    }

    return super.hasMenu()
  }

  openMenu() {
    if (this.owner) {
      let item = this.game.player.getActiveItem()
      if (item && Item.isNameTag(item.type)) {
        this.game.changeNameMenu.open({ entity: this })
        return
      }
    }
  }

  shouldSendInteractTargetToServer() {
    if (this.owner) {
      let item = this.game.player.getActiveItem()
      if (item && Item.isNameTag(item.type)) {
        return false
      }
    }

    return super.shouldSendInteractTargetToServer()
  }

  getActionTooltipMessage() {
    if (this.owner) {
      let item = this.game.player.getActiveItem()
      if (item && Item.isNameTag(item.type)) {
        return "Change Name"
      }
    }

    return super.getActionTooltipMessage()
  }

  showAction(entityMenu) {
    if (!this.belongToOwner(this.game.player)) {
      // reset
      entityMenu.querySelector(".entity_action").innerHTML = ""
      return
    }

    let player = this.game.player
    let team = player.getTeam()
    let actions = ""

    if (this.canTakeAlong()) {
      const take = "<div class='take_btn ui_btn' data-action='take_along'>" + i18n.t("Take Along") + "</div>"
      const release = "<div class='release_btn ui_btn' data-action='release'>" + i18n.t("Release") + "</div>"


      if (this.masterId === player.id) {
        actions += release
      } else if (!this.masterId) {
        // only show take if no master yet
        actions += take
      }
    }

    const makeLivestock = "<div class='make_livestock_btn ui_btn' data-action='make_livestock'>" + i18n.t("Make Livestock") + "</div>"
    const makePet = "<div class='make_pet_btn ui_btn' data-action='make_pet'>" + i18n.t("Make Pet") + "</div>"

    if (this.game.isLeaderAndOwner(this, team, player) && 
        this.canBecomeLivestock()) {
      if (this.isLivestock) {
        actions += makePet
      } else {
        actions += makeLivestock
      }
    }

    entityMenu.querySelector(".entity_action").innerHTML = actions
  }

  isNPC() {
    return !!this.getConstants().isNPC    
  }

  getDamage() {
    return this.getStats(this.level).damage
  }

  getLineOfSightRange() {
    return this.getStats(this.level).los
  }

  animateDamage() {
    if (this.spriteRestoreTimeout) return

    this.getTintableSprite().alpha = 0.1

    this.spriteRestoreTimeout = setTimeout(() => {
      this.getTintableSprite().alpha = 1
      this.spriteRestoreTimeout = null
    }, 50)

  }

  animateEquipment() {
    // nothing by default
  }

  registerAnimationTween(tween) {
    this.tween = tween
    return tween
  }

  cleanupAnimationTween() {
    if (this.tween) {
      this.tween.stop()
      this.tween = null
    }
  }


  animateExplosion() {
    ClientHelper.animateExplosion(this.getX(), this.getY())
  }

  shouldCreateDeadBody() {
    return false
  }

  getCollisionGroup() {
    return "collisionGroup.Mob"
  }

  renderDeadBody() {
    this.addDizzyEyes(this.characterSprite)
  }

  getDizzySpriteConfig() {
    return this.getConstants().dizzySprite || {}
  }


}

Object.assign(BaseMob.prototype, Upgradable.prototype, {
})

Object.assign(BaseMob.prototype, Faithable.prototype, {
  onFaithChanged() {
    if (game.entityMenu.selectedEntity === this) {
      this.game.showEntityMenu(this)
    }
  },
  onFaithIncreased() {
    this.animateHeart()
  }
})

Object.assign(BaseMob.prototype, Destroyable.prototype, {
  onHealthZero() {
    // this.animateExplosion()
    this.healthBar.hide()
  },
  onHealthReduced(delta) {
    if (this.health === 0) return

    this.healthBar.showDamageTaken(delta)
    this.animateDamage()
  },
  onHealthIncreased(delta) {
    this.healthBar.showHealthIncreased(delta)
    
    const isIncreasedFromZero = this.health === delta
    if (isIncreasedFromZero) {
      this.resurrectBody()
    }
  },
  onPostSetHealth(delta) {
    this.healthBar.draw()

    if (this.game.entityMenu.isOpen(this)) {
      this.game.entityMenu.update(this)
    }
  },
  getMaxHealth() {
    if (this.game.sector.entityCustomStats[this.id]) {
      return this.game.sector.entityCustomStats[this.id].health
    }

    if (this.game.sector.mobCustomStats[this.getType()]) {
      return this.game.sector.mobCustomStats[this.getType()].health
    }

    let health = this.getStats().health
    let level = this.level || 0
    return health + level * 10
  }
})

Object.assign(BaseMob.prototype, ShipMountable.prototype, {
  getRelativeX() {
    return this.sprite.position.x
  },
  getRelativeY() {
    return this.sprite.position.y
  }
})

Object.assign(BaseMob.prototype, Needs.prototype, {
  onHungerChanged(delta) {
    if (this.game.entityMenu.isOpen(this)) {
      this.game.entityMenu.update(this)
    }

    let isHungerDecreased = delta > 0
    if (isHungerDecreased) {
      this.animateHungerDecreased(delta)
    }

  },
  onStaminaChanged() {
    if (this.game.entityMenu.isOpen(this)) {
      this.game.entityMenu.update(this)
    }
  },
  onSleepStateChanged() {
    if (this.isSleeping) {
      this.showSleepAnimation()
    } else {
      this.hideSleepAnimation()
    }
  }
})


module.exports = BaseMob

},{"../../util/bitmap_text":648,"./../../../../common/constants.json":656,"./../../../../common/helper":664,"./../../../../common/interfaces/destroyable":670,"./../../../../common/interfaces/faithable":673,"./../../../../common/interfaces/needs":674,"./../../../../common/interfaces/ship_mountable":678,"./../../../../common/interfaces/upgradable":681,"./../../../../common/util/protocol":686,"./../../components/health_bar":181,"./../../util/client_helper":649,"./../../util/interpolator":652,"./../../util/socket_util":654,"./../../util/sprite_event_handler":655,"./../base_entity":206,"./../equipments/index":407,"./../item":443,"./../ship":546}],450:[function(require,module,exports){
const BaseMob = require('./base_mob')
const Constants = require("./../../../../common/constants.json")
const Protocol = require("./../../../../common/util/protocol")
const ClientHelper = require("./../../util/client_helper")

class BioRaptor extends BaseMob {

  getSpritePath() {
    return "bio_raptor.png"
  }

  animateEquipment() {
    let targetPosition = this.getMeleeTarget()
    this.attackTween = this.getMeleeChargeTween(targetPosition)
    this.attackTween.start()
  }

  shouldShowInteractTooltip() {
    return this.owner
  }

  onPreRemove(cb) {
    let tween = this.getFadeOutTween()
    tween.onComplete(() => {
      cb()
    })
    tween.start()
  }

  getFadeOutTween() {
    let alpha = { alpha: 1 }
    let tween = new TWEEN.Tween(alpha)
        .to({ alpha: 0 }, 2000)
        .easing(TWEEN.Easing.Quadratic.Out) // Use an easing function to make the animation smooth.
        .onUpdate(() => {
          this.sprite.alpha = alpha.alpha
        })

    return tween
  }

  getConstantsTable() {
    return "Mobs.BioRaptor"
  }

  getType() {
    return Protocol.definition().MobType.BioRaptor
  }
  
  animateExplosion() {
    const smokeCount = 4
    for (var i = 0; i < smokeCount; i++) {
      ClientHelper.addSmoke(this.getX(), this.getY())
    }
  }

  // on client, we want bioraptor to circle to be smaller
  // so unitmap would only register one tile per bioraptor if centered on tile
  // then we'll be able to select bioraptor apart from cryotube
  getWidth() {
    return Constants.tileSize
  }

  getHeight() {
    return Constants.tileSize
  }

}

module.exports = BioRaptor

},{"./../../../../common/constants.json":656,"./../../../../common/util/protocol":686,"./../../util/client_helper":649,"./base_mob":449}],451:[function(require,module,exports){
const LandMob = require('./land_mob')
const Constants = require("./../../../../common/constants.json")
const Protocol = require("./../../../../common/util/protocol")

class Brood extends LandMob {

  animateEquipment() {
    let targetPosition = this.getMeleeTarget()
    this.attackTween = this.getMeleeChargeTween(targetPosition)
    this.attackTween.start()
  }

  renderDeadBody() {
    super.renderDeadBody()
    this.dizzySprite.width = 20
    this.dizzySprite.height = 10
  }

  getSpritePath() {
    return "brood.png"
  }

  getConstantsTable() {
    return "Mobs.Brood"
  }

  getType() {
    return Protocol.definition().MobType.Brood
  }


}

module.exports = Brood

},{"./../../../../common/constants.json":656,"./../../../../common/util/protocol":686,"./land_mob":465}],452:[function(require,module,exports){
const BaseMob = require('./base_mob')
const Constants = require("./../../../../common/constants.json")
const Protocol = require("./../../../../common/util/protocol")
const ClientHelper = require("./../../util/client_helper")

class Car extends BaseMob {

  getSpritePath() {
    return "car.png"
  }

  animateEquipment() {
  }

  shouldShowInteractTooltip() {
    return this.owner
  }


  getConstantsTable() {
    return "Mobs.Car"
  }

  getType() {
    return Protocol.definition().MobType.Car
  }
  
  animateExplosion() {
    const smokeCount = 4
    for (var i = 0; i < smokeCount; i++) {
      ClientHelper.addSmoke(this.getX(), this.getY())
    }
  }

  // on client, we want bioraptor to circle to be smaller
  // so unitmap would only register one tile per bioraptor if centered on tile
  // then we'll be able to select bioraptor apart from cryotube
  getWidth() {
    return Constants.tileSize
  }

  getHeight() {
    return Constants.tileSize
  }

}

module.exports = Car

},{"./../../../../common/constants.json":656,"./../../../../common/util/protocol":686,"./../../util/client_helper":649,"./base_mob":449}],453:[function(require,module,exports){
const LandMob = require('./land_mob')
const Constants = require("./../../../../common/constants.json")
const Protocol = require("./../../../../common/util/protocol")
const ClientHelper = require("./../../util/client_helper")

class Cat extends LandMob {
  constructor(game, data) {
    super(game, data)
  }

  animateEquipment() {
    let targetPosition = this.getMeleeTarget()
    this.attackTween = this.getMeleeChargeTween(targetPosition)
    this.attackTween.start()
  }

  getSpritePath() {
    return "cat_yellow.png"
  }

  getConstantsTable() {
    return "Mobs.Cat"
  }

  getType() {
    return Protocol.definition().MobType.Cat
  }


}

module.exports = Cat

},{"./../../../../common/constants.json":656,"./../../../../common/util/protocol":686,"./../../util/client_helper":649,"./land_mob":465}],454:[function(require,module,exports){
const LandMob = require('./land_mob')
const Constants = require("./../../../../common/constants.json")
const Protocol = require("./../../../../common/util/protocol")
const Equipper  = require("./../../../../common/interfaces/equipper")
const ClientHelper = require("./../../util/client_helper")
const Interpolator = require("./../../util/interpolator")
const Equipments = require("./../equipments/index")


class Chemist extends LandMob {
  constructor(game, data) {
    super(game, data)

    // this.characterSprite.tint = 0x444444 // dark + red line eyes maybe

    this.initEquipper()
  }

  getSprite() {
    let sprite = super.getSprite()
    Interpolator.mixin(this.characterSprite)
    return sprite
  }

  getBaseRotationOffset() {
    return 0 * PIXI.DEG_TO_RAD
  }

  renderDeadBody() {
    this.addDizzyEyes(this.body)
    this.dizzySprite.width  = 25
    this.dizzySprite.height = 10
    this.dizzySprite.position.x = 25
    this.dizzySprite.position.y = 25
    this.dizzySprite.rotation = 90 * Math.PI/180

    this.openHands()
    this.removeEquipments()
  }

  getConstantsTable() {
    return "Mobs.Chemist"
  }

  getType() {
    return Protocol.definition().MobType.Chemist
  }


}

Object.assign(Chemist.prototype, Equipper.prototype, {
  getEquipperBodySpritePath() {
    return "chemist.png"
  },
  getDefaultSpriteColor() {
    return 0x444444
  }
})


module.exports = Chemist

},{"./../../../../common/constants.json":656,"./../../../../common/interfaces/equipper":672,"./../../../../common/util/protocol":686,"./../../util/client_helper":649,"./../../util/interpolator":652,"./../equipments/index":407,"./land_mob":465}],455:[function(require,module,exports){
const LandMob = require('./land_mob')
const Constants = require("./../../../../common/constants.json")
const Protocol = require("./../../../../common/util/protocol")
const ClientHelper = require("./../../util/client_helper")

class Chicken extends LandMob {
  constructor(game, data) {
    super(game, data)

  }

  animateEquipment() {
    let targetPosition = this.getMeleeTarget()
    this.attackTween = this.getMeleeChargeTween(targetPosition)
    this.attackTween.start()
  }

  getCharacterSprite() {
    const sprite = new PIXI.Container()
    sprite.name = "Character"
    sprite.pivot.x = this.getWidth() / 2
    sprite.pivot.y = this.getWidth() / 2

    this.body   = new PIXI.Sprite(PIXI.utils.TextureCache["chicken_base.png"])
    this.body.name = "Body"

    this.leftWing   = new PIXI.Sprite(PIXI.utils.TextureCache["chicken_wing_left.png"])
    this.leftWing.name = "LeftWing"
    this.leftWing.position.x = -10
    this.leftWing.position.y = 5

    this.rightWing   = new PIXI.Sprite(PIXI.utils.TextureCache["chicken_wing_right.png"])
    this.rightWing.name = "RightWing"
    this.rightWing.position.x = 15
    this.rightWing.position.y = 5

    sprite.addChild(this.leftWing)
    sprite.addChild(this.rightWing)
    sprite.addChild(this.body)

    return sprite
  }

  getSpritePath() {
    return "chicken.png"
  }

  getConstantsTable() {
    return "Mobs.Chicken"
  }

  getType() {
    return Protocol.definition().MobType.Chicken
  }


}

module.exports = Chicken

},{"./../../../../common/constants.json":656,"./../../../../common/util/protocol":686,"./../../util/client_helper":649,"./land_mob":465}],456:[function(require,module,exports){
const BaseMob = require('./base_mob')
const Constants = require("./../../../../common/constants.json")
const Protocol = require("./../../../../common/util/protocol")

class Drone extends BaseMob {

  onPostInit() {
    super.onPostInit()

    this.rangeSprite = this.getRangeSprite()
    this.sprite.addChildAt(this.rangeSprite, 0)
  }

  drawRange() {
    this.rangeSprite.alpha = 0.1
  }

  hideRange() {
    this.rangeSprite.alpha = 0
  }

  onMouseOver() {
    super.onMouseOver()
    this.drawRange()
  }

  onMouseOut() {
    super.onMouseOut()
    this.hideRange()
  }

  getSpritePath() {
    return "fighter_drone.png"
  }

  getConstantsTable() {
    return "Mobs.Drone"
  }

  getType() {
    return Protocol.definition().MobType.Drone
  }


}

module.exports = Drone

},{"./../../../../common/constants.json":656,"./../../../../common/util/protocol":686,"./base_mob":449}],457:[function(require,module,exports){
const LandMob = require('./land_mob')
const Constants = require("./../../../../common/constants.json")
const Protocol = require("./../../../../common/util/protocol")
const Equipper  = require("./../../../../common/interfaces/equipper")
const ClientHelper = require("./../../util/client_helper")
const Interpolator = require("./../../util/interpolator")
const Equipments = require("./../equipments/index")
const SocketUtil = require("./../../util/socket_util")


class DummyPlayer extends LandMob {
  constructor(game, data) {
    super(game, data)

    // this.characterSprite.tint = 0x444444 // dark + red line eyes maybe

    this.initEquipper()
  }

  getSpritePath() {
    return "human.png"
  }

  getSprite() {
    let sprite = super.getSprite()
    Interpolator.mixin(this.characterSprite)
    return sprite
  }

  getBaseRotationOffset() {
    return 0 * PIXI.DEG_TO_RAD
  }

  renderDeadBody() {
    this.addDizzyEyes(this.body)
    this.dizzySprite.width  = 25
    this.dizzySprite.height = 10
    this.dizzySprite.position.x = 25
    this.dizzySprite.position.y = 25
    this.dizzySprite.rotation = 90 * Math.PI/180

    this.openHands()
    this.removeEquipments()
  }

  getConstantsTable() {
    return "Mobs.DummyPlayer"
  }

  getType() {
    return Protocol.definition().MobType.DummyPlayer
  }

  showAction(entityMenu) {
    let actions = ""
    let permissionSelect = this.createRoleSelect(entityMenu)

    actions += permissionSelect
    entityMenu.querySelector(".entity_action").innerHTML = actions

    this.initPermissionSelect(entityMenu)
  }

  initPermissionSelect(entityMenu) {
    let permissionSelect = entityMenu.querySelector(".player_permissions_select")
    if (!permissionSelect) return
    permissionSelect.addEventListener("change", this.onDummyPlayerPermissionsSelectChanged.bind(this))

    if (this.content) {
      permissionSelect.value = this.content
    } else {
      permissionSelect.value = 0
    }
  }

  onDummyPlayerPermissionsSelectChanged(e) {
    let roleType = e.target.value
    let memberId = e.target.closest(".player_permissions_select").dataset.memberId 
    SocketUtil.emit("EditMob", { id: memberId, content: roleType })
  }

}

Object.assign(DummyPlayer.prototype, Equipper.prototype, {
  getDefaultSpriteColor() {
    return 0xd2b48c
  }
})


module.exports = DummyPlayer

},{"./../../../../common/constants.json":656,"./../../../../common/interfaces/equipper":672,"./../../../../common/util/protocol":686,"./../../util/client_helper":649,"./../../util/interpolator":652,"./../../util/socket_util":654,"./../equipments/index":407,"./land_mob":465}],458:[function(require,module,exports){
const LandMob = require('./land_mob')
const Constants = require("./../../../../common/constants.json")
const Protocol = require("./../../../../common/util/protocol")
const Equipper  = require("./../../../../common/interfaces/equipper")
const ClientHelper = require("./../../util/client_helper")
const Interpolator = require("./../../util/interpolator")
const Equipments = require("./../equipments/index")


class Firebat extends LandMob {
  constructor(game, data) {
    super(game, data)

    // this.characterSprite.tint = 0x444444 // dark + red line eyes maybe
  }

  getSpritePath() {
    return "firebat.png"
  }

  getBaseRotationOffset() {
    return 0 * PIXI.DEG_TO_RAD
  }

  renderDeadBody() {
    this.addDizzyEyes(this.body)
    this.dizzySprite.width  = 25
    this.dizzySprite.height = 10
    this.dizzySprite.position.x = 25
    this.dizzySprite.position.y = 25
    this.dizzySprite.rotation = 90 * Math.PI/180
    this.removeEquipments()
  }

  getConstantsTable() {
    return "Mobs.Firebat"
  }

  getType() {
    return Protocol.definition().MobType.Firebat
  }


}

module.exports = Firebat

},{"./../../../../common/constants.json":656,"./../../../../common/interfaces/equipper":672,"./../../../../common/util/protocol":686,"./../../util/client_helper":649,"./../../util/interpolator":652,"./../equipments/index":407,"./land_mob":465}],459:[function(require,module,exports){
const Constants = require("./../../../../common/constants.json")
const Protocol = require("./../../../../common/util/protocol")

const Slave = require("./slave")

class GaramSlave extends Slave {
  getConstantsTable() {
    return "Mobs.GaramSlave"
  }

  getSpritePath() {
    return "garam_slave.png"
  }

  getType() {
    return Protocol.definition().MobType.GaramSlave
  }

  getEquipperBodySpritePath() {
    return "garam_slave_body.png"
  }

  getBodyWidth() {
    return 55
  }

  getBodyHeight() {
    return 40
  }

  getDefaultSpriteColor() {
    return 0x888888
  }

  getBodyPositionX() {
    return -12
  }

}

module.exports = GaramSlave

},{"./../../../../common/constants.json":656,"./../../../../common/util/protocol":686,"./slave":479}],460:[function(require,module,exports){
const BaseMob = require('./base_mob')
const Constants = require("./../../../../common/constants.json")
const Protocol = require("./../../../../common/util/protocol")

class Ghost extends BaseMob {

  constructor(game, data) {
    super(game, data)

    if (this.game.player.isControllingGhost() && this.sector.isMiniGame()) {
      this.characterSprite.alpha = 0.3
    } else {
      this.characterSprite.alpha = 0
    }
  }

  onMouseOver() {
  }

  onMouseOut() {
  }

  onClick() {
    // dont allow ghost click
  }

  isHiddenFromView() {
    return true
  }

  isGhost() {
    return true
  }

  getSpritePath() {
    return "ghost.png"
  }

  getConstantsTable() {
    return "Mobs.Ghost"
  }

  getType() {
    return Protocol.definition().MobType.Ghost
  }

  onPositionChanged() {
    super.onPositionChanged()

    if (this.isMe()) {
      this.game.player.cullChunks()  
    }

  }

  animateWalkOnPlatform() {
    
  }

  isMe() {
    return this.game.player.cameraFocusTarget === this
  }


}

module.exports = Ghost

},{"./../../../../common/constants.json":656,"./../../../../common/util/protocol":686,"./base_mob":449}],461:[function(require,module,exports){
const LandMob = require('./land_mob')
const Constants = require("./../../../../common/constants.json")
const Protocol = require("./../../../../common/util/protocol")
const ClientHelper = require("./../../util/client_helper")

class Golem extends LandMob {
  constructor(game, data) {
    super(game, data)

  }

  getSpritePath() {
    return "golem.png"
  }

  getConstantsTable() {
    return "Mobs.Golem"
  }

  animateEquipment() {
    let targetPosition = this.getMeleeTarget()
    this.attackTween = this.getMeleeChargeTween(targetPosition)
    this.attackTween.start()
  }

  createUsernameSprite() {
    super.createUsernameSprite()
    this.usernameText.sprite.position.y = 80
  }

  getCorpseSprite() {
    let sprite = super.getCorpseSprite()
    sprite.texture = PIXI.utils.TextureCache["golem_corpse.png"]
    sprite.width = 80
    sprite.height = 80

    return sprite
  }

  getDizzySpriteConfig() {
    return {}
  }

  getType() {
    return Protocol.definition().MobType.Golem
  }

}

module.exports = Golem

},{"./../../../../common/constants.json":656,"./../../../../common/util/protocol":686,"./../../util/client_helper":649,"./land_mob":465}],462:[function(require,module,exports){
const Pirate = require('./pirate')
const Constants = require("./../../../../common/constants.json")
const Protocol = require("./../../../../common/util/protocol")

class Guard extends Pirate {

  getConstantsTable() {
    return "Mobs.Guard"
  }

  getSpritePath() {
    return "guard.png"
  }

  getType() {
    return Protocol.definition().MobType.Guard
  }
}

module.exports = Guard

},{"./../../../../common/constants.json":656,"./../../../../common/util/protocol":686,"./pirate":471}],463:[function(require,module,exports){
const LandMob = require('./land_mob')
const Constants = require("./../../../../common/constants.json")
const Protocol = require("./../../../../common/util/protocol")
const Equipper  = require("./../../../../common/interfaces/equipper")
const ClientHelper = require("./../../util/client_helper")
const Interpolator = require("./../../util/interpolator")
const Equipments = require("./../equipments/index")


class Human extends LandMob {
  constructor(game, data) {
    super(game, data)

    this.initEquipper()
  }

  getSpritePath() {
    return "human.png"
  }

  getSprite() {
    let sprite = super.getSprite()
    Interpolator.mixin(this.characterSprite)
    return sprite
  }

  getBaseRotationOffset() {
    return 0 * PIXI.DEG_TO_RAD
  }

  renderDeadBody() {
    this.addDizzyEyes(this.body)
    this.dizzySprite.anchor.set(0)
    this.dizzySprite.rotation = Math.PI/2
    this.dizzySprite.tint = 0x000000
    this.dizzySprite.width = 24
    this.dizzySprite.height = 8
    this.dizzySprite.position.x = 30
    this.dizzySprite.position.y = 8

    this.openHands()
    this.removeEquipments()
  }

  getConstantsTable() {
    return "Mobs.Human"
  }

  getType() {
    return Protocol.definition().MobType.Human
  }


}

Object.assign(Human.prototype, Equipper.prototype, {
  getDefaultSpriteColor() {
    return 0xd2b48c
  },
  getBodySpriteTint() {
    return 0xd2b48c
  }
})


module.exports = Human

},{"./../../../../common/constants.json":656,"./../../../../common/interfaces/equipper":672,"./../../../../common/util/protocol":686,"./../../util/client_helper":649,"./../../util/interpolator":652,"./../equipments/index":407,"./land_mob":465}],464:[function(require,module,exports){
const Protocol = require("./../../../../common/util/protocol")

const Mobs = {}

Mobs.Ghost = require("./ghost")

Mobs.Slime = require("./slime")
Mobs.Spider = require("./spider")
Mobs.PoisonSpider = require("./poison_spider")
Mobs.Mutant = require("./mutant")
Mobs.Messenger = require("./messenger")
Mobs.Pirate = require("./pirate")
Mobs.Guard = require("./guard")
Mobs.Trooper = require("./trooper")
Mobs.Chemist = require("./chemist")
Mobs.Trader = require("./trader")
Mobs.SlaveTrader = require("./slave_trader")
Mobs.BioRaptor = require("./bio_raptor")
Mobs.Brood = require("./brood")
Mobs.Golem = require("./golem")
Mobs.Mantis = require("./mantis")
Mobs.Prisoner = require("./prisoner")
Mobs.SquidLord = require("./squid_lord")
Mobs.Firebat = require("./firebat")
Mobs.Car = require("./car")
Mobs.Sapper = require("./sapper")

Mobs.Raven = require("./raven")
Mobs.Drone = require("./drone")
Mobs.Cat = require("./cat")
Mobs.Monkey = require("./monkey")
Mobs.Chicken = require("./chicken")

Mobs.CleanBot = require("./robots/clean_bot")
Mobs.DummyPlayer = require("./dummy_player")
Mobs.Human = require("./human")

Mobs.Slave = require("./slave")
Mobs.NuuSlave = require("./nuu_slave")
Mobs.PixiSlave = require("./pixi_slave")
Mobs.GaramSlave = require("./garam_slave")

Mobs.forType = (type) => {
  let className = ""
  const nameToTypeMap = Protocol.definition().MobType

  for (let name in nameToTypeMap) {
    if (nameToTypeMap[name] === type) {
      className = name
    }
  }

  return Mobs[className]
}


module.exports = Mobs
},{"./../../../../common/util/protocol":686,"./bio_raptor":450,"./brood":451,"./car":452,"./cat":453,"./chemist":454,"./chicken":455,"./drone":456,"./dummy_player":457,"./firebat":458,"./garam_slave":459,"./ghost":460,"./golem":461,"./guard":462,"./human":463,"./mantis":466,"./messenger":467,"./monkey":468,"./mutant":469,"./nuu_slave":470,"./pirate":471,"./pixi_slave":472,"./poison_spider":473,"./prisoner":474,"./raven":475,"./robots/clean_bot":477,"./sapper":478,"./slave":479,"./slave_trader":480,"./slime":481,"./spider":482,"./squid_lord":483,"./trader":484,"./trooper":485}],465:[function(require,module,exports){
const BaseMob = require("./base_mob")
const ClientHelper = require("./../../util/client_helper")

class LandMob extends BaseMob {
  shouldCreateDeadBody() {
    return true
  }

  isLandMob() {
    return true
  }

  animateExplosion() {
    const smokeCount = 4
    for (var i = 0; i < smokeCount; i++) {
      ClientHelper.addSmoke(this.getX(), this.getY())
    }
  }
}

module.exports = LandMob
},{"./../../util/client_helper":649,"./base_mob":449}],466:[function(require,module,exports){
const LandMob = require('./land_mob')
const Constants = require("./../../../../common/constants.json")
const Protocol = require("./../../../../common/util/protocol")
const ClientHelper = require("./../../util/client_helper")

class Mantis extends LandMob {
  constructor(game, data) {
    super(game, data)

  }

  getSpritePath() {
    return "mantis.png"
  }

  animateEquipment() {
    let targetPosition = this.getMeleeTarget()
    this.attackTween = this.getMeleeChargeTween(targetPosition)
    this.attackTween.start()
  }

  getConstantsTable() {
    return "Mobs.Mantis"
  }

  getType() {
    return Protocol.definition().MobType.Mantis
  }
}

module.exports = Mantis

},{"./../../../../common/constants.json":656,"./../../../../common/util/protocol":686,"./../../util/client_helper":649,"./land_mob":465}],467:[function(require,module,exports){
const LandMob = require('./land_mob')
const Constants = require("./../../../../common/constants.json")
const Protocol = require("./../../../../common/util/protocol")
const ClientHelper = require("./../../util/client_helper")
const Interpolator = require("./../../util/interpolator")
const Equipper  = require("./../../../../common/interfaces/equipper")

class Messenger extends LandMob {
  constructor(game, data) {
    super(game, data)

    this.initEquipper()
  }

  openMenu() {
    this.game.npcDialogMenu.open(this.getNpcChoicesHTML(), { 
      title: i18n.t("Messenger"),
      team: this.game.player.getTeam(), 
      entityId: this.id 
    })

    if (typeof this.npcChoice !== 'undefined') {
      this.game.npcDialogMenu.hideConfirm()
    }
  }

  onHighlighted() {
    if (typeof this.npcChoice === 'undefined') {
      this.createChatBubble(i18n.t('Messenger.DemandPayment'))
    }
  }

  getNpcChoicesHTML() {
    if (this.npcChoice === 1) {
      return i18n.t('Messenger.RightChoice')
    } else if (this.npcChoice === 2) {
      return i18n.t('Messenger.Blasphemy')
    }

    return "<div data-choice='1' class='npc_choice'>1. " + i18n.t('Messenger.Choices.ProceedPay', { gold: "<span class='payment_amount'></span>"}) + "</div>" + 
           "<div data-choice='2' class='npc_choice'>2. " + i18n.t('Messenger.Choices.RefusePay') + "</div>"
  }

  getBaseRotationOffset() {
    return 0 * PIXI.DEG_TO_RAD
  }

  getWidth() {
    return 40
  }

  getHeight() {
    return 40
  }

  isInteractable() {
    return true
  }

  getConstantsTable() {
    return "Mobs.Messenger"
  }

  getType() {
    return Protocol.definition().MobType.Messenger
  }

  shouldShowOwner() {
    return false
  }

}

Object.assign(Messenger.prototype, Equipper.prototype, {
  getDefaultSpriteColor() {
    return 0x777777
  },
  getBodySpriteTint() {
    return 0x777777
  }
})


module.exports = Messenger


},{"./../../../../common/constants.json":656,"./../../../../common/interfaces/equipper":672,"./../../../../common/util/protocol":686,"./../../util/client_helper":649,"./../../util/interpolator":652,"./land_mob":465}],468:[function(require,module,exports){
const LandMob = require('./land_mob')
const Constants = require("./../../../../common/constants.json")
const Protocol = require("./../../../../common/util/protocol")
const ClientHelper = require("./../../util/client_helper")

class Monkey extends LandMob {
  constructor(game, data) {
    super(game, data)

  }

  animateEquipment() {
    let targetPosition = this.getMeleeTarget()
    this.attackTween = this.getMeleeChargeTween(targetPosition)
    this.attackTween.start()
  }

  getSpritePath() {
    return "monkey.png"
  }

  getConstantsTable() {
    return "Mobs.Monkey"
  }

  getType() {
    return Protocol.definition().MobType.Monkey
  }


}

module.exports = Monkey

},{"./../../../../common/constants.json":656,"./../../../../common/util/protocol":686,"./../../util/client_helper":649,"./land_mob":465}],469:[function(require,module,exports){
const LandMob = require('./land_mob')
const Constants = require("./../../../../common/constants.json")
const Protocol = require("./../../../../common/util/protocol")
const ClientHelper = require("./../../util/client_helper")

class Mutant extends LandMob {
  constructor(game, data) {
    super(game, data)

  }

  getWidth() {
    return 56
  }

  getHeight() {
    return 40
  }

  animateEquipment() {
    let targetPosition = this.getMeleeTarget()
    this.attackTween = this.getMeleeChargeTween(targetPosition)
    this.attackTween.start()
  }

  getSpritePath() {
    return "mutant.png"
  }

  getConstantsTable() {
    return "Mobs.Mutant"
  }

  getType() {
    return Protocol.definition().MobType.Mutant
  }


}

module.exports = Mutant

},{"./../../../../common/constants.json":656,"./../../../../common/util/protocol":686,"./../../util/client_helper":649,"./land_mob":465}],470:[function(require,module,exports){
const Constants = require("./../../../../common/constants.json")
const Protocol = require("./../../../../common/util/protocol")

const Slave = require("./slave")

class NuuSlave extends Slave {
  getConstantsTable() {
    return "Mobs.NuuSlave"
  }

  getSpritePath() {
    return "nuu_slave.png"
  }

  getType() {
    return Protocol.definition().MobType.NuuSlave
  }

  getEquipperBodySpritePath() {
    return "nuu_slave.png"
  }

}

module.exports = NuuSlave

},{"./../../../../common/constants.json":656,"./../../../../common/util/protocol":686,"./slave":479}],471:[function(require,module,exports){
const LandMob = require('./land_mob')
const Constants = require("./../../../../common/constants.json")
const Protocol = require("./../../../../common/util/protocol")
const Equipper  = require("./../../../../common/interfaces/equipper")
const ClientHelper = require("./../../util/client_helper")
const Interpolator = require("./../../util/interpolator")
const Equipments = require("./../equipments/index")


class Pirate extends LandMob {
  constructor(game, data) {
    super(game, data)

    this.characterSprite.tint = 0x444444 // dark + red line eyes maybe

    this.initEquipper()
  }

  getSprite() {
    let sprite = super.getSprite()
    Interpolator.mixin(this.characterSprite)
    return sprite
  }

  getBaseRotationOffset() {
    return 0 * PIXI.DEG_TO_RAD
  }

  renderDeadBody() {
    this.addDizzyEyes(this.body)
    this.dizzySprite.width  = 25
    this.dizzySprite.height = 10
    this.dizzySprite.position.x = 25
    this.dizzySprite.position.y = 25
    this.dizzySprite.rotation = 90 * Math.PI/180

    this.openHands()
    this.removeEquipments()
  }

  getConstantsTable() {
    return "Mobs.Pirate"
  }

  getType() {
    return Protocol.definition().MobType.Pirate
  }


}

Object.assign(Pirate.prototype, Equipper.prototype, {
  getDefaultSpriteColor() {
    return 0x444444
  },
  getBodySpriteTint() {
    return 0x444444
  }
})


module.exports = Pirate

},{"./../../../../common/constants.json":656,"./../../../../common/interfaces/equipper":672,"./../../../../common/util/protocol":686,"./../../util/client_helper":649,"./../../util/interpolator":652,"./../equipments/index":407,"./land_mob":465}],472:[function(require,module,exports){
const Constants = require("./../../../../common/constants.json")
const Protocol = require("./../../../../common/util/protocol")

const Slave = require("./slave")

class PixiSlave extends Slave {
  getConstantsTable() {
    return "Mobs.PixiSlave"
  }

  getSpritePath() {
    return "pixi_slave.png"
  }

  getType() {
    return Protocol.definition().MobType.PixiSlave
  }

  getEquipperBodySpritePath() {
    return "pixi_slave_body.png"
  }

  getBodyWidth() {
    return 47
  }

  getBodyHeight() {
    return 53
  }

  getDefaultSpriteColor() {
    return 0xbbbbbb
  }

  getBodyPositionX() {
    return -5
  }

  getBodyPositionY() {
    return -6
  }

}

module.exports = PixiSlave

},{"./../../../../common/constants.json":656,"./../../../../common/util/protocol":686,"./slave":479}],473:[function(require,module,exports){
const Spider = require('./spider')
const Constants = require("./../../../../common/constants.json")
const Protocol = require("./../../../../common/util/protocol")

class PoisonSpider extends Spider {
  getSpritePath() {
    return "poison_spider.png"
  }

  addDizzyEyes(targetSprite) {
    super.addDizzyEyes(targetSprite)

    this.dizzySprite.width = 16
    this.dizzySprite.height = 6
    this.dizzySprite.position.y = -8
  }


  getConstantsTable() {
    return "Mobs.PoisonSpider"
  }

  getType() {
    return Protocol.definition().MobType.PoisonSpider
  }

  getWidth() {
    return 72
  }

  getHeight() {
    return 48
  }

}

module.exports = PoisonSpider

},{"./../../../../common/constants.json":656,"./../../../../common/util/protocol":686,"./spider":482}],474:[function(require,module,exports){
const LandMob = require('./land_mob')
const Constants = require("./../../../../common/constants.json")
const Protocol = require("./../../../../common/util/protocol")

class Prisoner extends LandMob {
  constructor(game, data) {
    super(game, data)
  }

  getSpritePath() {
    return "prisoner.png"
  }

  animateEquipment() {
    let targetPosition = this.getMeleeTarget()
    this.attackTween = this.getMeleeChargeTween(targetPosition)
    this.attackTween.start()
  }


  getConstantsTable() {
    return "Mobs.Prisoner"
  }

  getType() {
    return Protocol.definition().MobType.Prisoner
  }


}

module.exports = Prisoner


},{"./../../../../common/constants.json":656,"./../../../../common/util/protocol":686,"./land_mob":465}],475:[function(require,module,exports){
const BaseMob = require('./base_mob')
const Constants = require("./../../../../common/constants.json")
const Protocol = require("./../../../../common/util/protocol")

class Raven extends BaseMob {

  onPostInit() {
    super.onPostInit()

    this.rangeSprite = this.getRangeSprite()
    this.sprite.addChildAt(this.rangeSprite, 0)
  }

  drawRange() {
    this.rangeSprite.alpha = 0.1
  }

  hideRange() {
    this.rangeSprite.alpha = 0
  }

  onMouseOver() {
    super.onMouseOver()
    this.drawRange()
  }

  onMouseOut() {
    super.onMouseOut()
    this.hideRange()
  }

  getSpritePath() {
    return "raven.png"
  }

  getConstantsTable() {
    return "Mobs.Raven"
  }

  getType() {
    return Protocol.definition().MobType.Raven
  }


}

module.exports = Raven

},{"./../../../../common/constants.json":656,"./../../../../common/util/protocol":686,"./base_mob":449}],476:[function(require,module,exports){
const BaseMob = require('./../base_mob')

class BaseRobot extends BaseMob {

}

module.exports = BaseRobot

},{"./../base_mob":449}],477:[function(require,module,exports){
const BaseRobot = require('./base_robot')
const Constants = require("./../../../../../common/constants.json")
const Protocol = require("./../../../../../common/util/protocol")

class CleanBot extends BaseRobot {
  constructor(game, data) {
    super(game, data)
  }

  getLightTween() {
    let alpha = { alpha: 0 }

    const tween = new TWEEN.Tween(alpha)
        .to({ alpha: 1 }, 500)
        .easing(TWEEN.Easing.Quadratic.Out)
        .onUpdate(() => {
          this.lightRing.alpha = alpha.alpha
        })
        .repeat(Infinity)
        .yoyo(true)

    return tween
  }

  onBehaviorChanged() {
    if (this.behavior === Protocol.definition().BehaviorType.Clean) {
      if (!this.tween) {
        this.tween = this.getLightTween()
      }

      this.tween.start()
    } else {
      this.lightRing.alpha = 0
      
      if (this.tween) {
        this.tween.stop()
      }

      this.tween = null
    }
  }

  isInteractable() {
    return true
  }

  getSpritePath() {
    return "clean_bot_2.png"
  }

  getType() {
    return Protocol.definition().MobType.CleanBot
  }

  getConstantsTable() {
    return "Mobs.CleanBot"
  }

  getCharacterSprite() {
    const sprite = new PIXI.Container()
    sprite.name = "Character"
    sprite.pivot.x = this.getWidth() / 2
    sprite.pivot.y = this.getWidth() / 2

    this.body   = new PIXI.Sprite(PIXI.utils.TextureCache["clean_bot_base.png"])
    this.body.name = "Body"
    this.body.anchor.set(0.1)

    this.lightRing   = new PIXI.Sprite(PIXI.utils.TextureCache["clean_bot_light.png"])
    this.lightRing.name = "LightRing"
    this.lightRing.anchor.set(0.1)

    this.core   = new PIXI.Sprite(PIXI.utils.TextureCache["clean_bot_core.png"])
    this.core.name = "Core"
    this.core.anchor.set(-0.1)

    sprite.addChild(this.body)
    sprite.addChild(this.lightRing)
    sprite.addChild(this.core)

    return sprite
  }



}

module.exports = CleanBot

},{"./../../../../../common/constants.json":656,"./../../../../../common/util/protocol":686,"./base_robot":476}],478:[function(require,module,exports){
const Guard = require('./guard')
const LandMob = require('./land_mob')
const Constants = require("./../../../../common/constants.json")
const Protocol = require("./../../../../common/util/protocol")

class Sapper extends LandMob {

  getConstantsTable() {
    return "Mobs.Sapper"
  }

  getType() {
    return Protocol.definition().MobType.Sapper
  }

  getSpritePath() {
    return "sapper.png"
  }


  getCorpseSprite() {
    let sprite = super.getCorpseSprite()
    sprite.texture = PIXI.utils.TextureCache["sapper_corpse.png"]
    sprite.height = 181

    return sprite
  }

  getDizzySpriteConfig() {
    return {}
  }
}

module.exports = Sapper

},{"./../../../../common/constants.json":656,"./../../../../common/util/protocol":686,"./guard":462,"./land_mob":465}],479:[function(require,module,exports){
const LandMob = require('./land_mob')
const Constants = require("./../../../../common/constants.json")
const Protocol = require("./../../../../common/util/protocol")
const ClientHelper = require("./../../util/client_helper")
const Interpolator = require("./../../util/interpolator")
const Equipper  = require("./../../../../common/interfaces/equipper")

class Slave extends LandMob {
  constructor(game, data) {
    super(game, data)

    this.initEquipper()
  }

  onHighlighted() {
  }

  getEntityMenuName() {
    return `${this.name} (${this.getTypeName()})` 
  }

  getBaseRotationOffset() {
    return 0 * PIXI.DEG_TO_RAD
  }

  getWidth() {
    return 40
  }

  getHeight() {
    return 40
  }

  isInteractable() {
    return true
  }

  getConstantsTable() {
    return "Mobs.Slave"
  }

  getSpritePath() {
    return "blue_slave.png"
  }

  getType() {
    return Protocol.definition().MobType.Slave
  }

}

Object.assign(Slave.prototype, Equipper.prototype, {
  getDefaultSpriteColor() {
    return 0x252e4e
  },
  getBodySpriteTint() {
    return 0xffffff
  },
  getEquipperBodySpritePath() {
    return "blue_slave.png"
  },
  getBodyWidth() {
    return 50
  },
  getBodyHeight() {
    return 40
  },
  getBodyPositionX() {
    return -10
  }
})


module.exports = Slave


},{"./../../../../common/constants.json":656,"./../../../../common/interfaces/equipper":672,"./../../../../common/util/protocol":686,"./../../util/client_helper":649,"./../../util/interpolator":652,"./land_mob":465}],480:[function(require,module,exports){
const LandMob = require('./land_mob')
const Constants = require("./../../../../common/constants.json")
const Protocol = require("./../../../../common/util/protocol")
const ClientHelper = require("./../../util/client_helper")
const Interpolator = require("./../../util/interpolator")
const Equipper  = require("./../../../../common/interfaces/equipper")

class SlaveTrader extends LandMob {
  constructor(game, data) {
    super(game, data)
  }

  openMenu() {
    this.game.slaveTradeMenu.open(this)
  }

  isInteractable() {
    return true
  }

  getSpritePath() {
    return "slave_trader.png"
  }

  getConstantsTable() {
    return "Mobs.SlaveTrader"
  }

  getType() {
    return Protocol.definition().MobType.SlaveTrader
  }


}

module.exports = SlaveTrader

},{"./../../../../common/constants.json":656,"./../../../../common/interfaces/equipper":672,"./../../../../common/util/protocol":686,"./../../util/client_helper":649,"./../../util/interpolator":652,"./land_mob":465}],481:[function(require,module,exports){
const LandMob = require('./land_mob')
const Constants = require("./../../../../common/constants.json")
const Protocol = require("./../../../../common/util/protocol")
const ClientHelper = require("./../../util/client_helper")


class Slime extends LandMob {
  constructor(game, data) {
    super(game, data)

    // this.characterSprite.tint = 0x319ef7 // 0x2e482e // green
    
    this.characterSprite.rotation = Math.PI

    this.registerAnimationTween(this.getAnimationTween()).start()
  }

  animateEquipment() {
    let targetPosition = this.getMeleeTarget()
    this.attackTween = this.getMeleeChargeTween(targetPosition)
    this.attackTween.start()
  }

  animateWalkOnPlatform() {
    
  }

  setAngle(angle) {
    this.angle = angle
    // on client, we want Slime to have same orientation even if direction angle changed
    // so dont change sprite rotation. only the data
  }

  getAnimationTween() {
    let delta = { delta: 0 }
    let origSize = this.characterSprite.width

    const tween = new TWEEN.Tween(delta)
        .to({ delta: 6 }, 500)
        .easing(TWEEN.Easing.Quadratic.Out)
        .onUpdate(() => {
          this.characterSprite.width = origSize + delta.delta
          this.characterSprite.height = origSize - delta.delta
          this.characterSprite.position.y = delta.delta/2
        })
        .repeat(Infinity)
        .yoyo(true)

    return tween
  }

  getWidth() {
    return 32
  }

  getHeight() {
    return 32
  }

  getSpritePath() {
    return "blue_slime.png"
  }

  getType() {
    return Protocol.definition().MobType.Slime
  }

  getConstantsTable() {
    return "Mobs.Slime"
  }

  shouldCreateDeadBody() {
    return false
  }

}

module.exports = Slime

},{"./../../../../common/constants.json":656,"./../../../../common/util/protocol":686,"./../../util/client_helper":649,"./land_mob":465}],482:[function(require,module,exports){
const LandMob = require('./land_mob')
const Constants = require("./../../../../common/constants.json")
const Protocol = require("./../../../../common/util/protocol")

class Spider extends LandMob {
  constructor(game, data) {
    super(game, data)
  }

  getSpritePath() {
    return "spider.png"
  }

  animateEquipment() {
    let targetPosition = this.getMeleeTarget()
    this.attackTween = this.getMeleeChargeTween(targetPosition)
    this.attackTween.start()
  }


  getConstantsTable() {
    return "Mobs.Spider"
  }

  getType() {
    return Protocol.definition().MobType.Spider
  }


}

module.exports = Spider


},{"./../../../../common/constants.json":656,"./../../../../common/util/protocol":686,"./land_mob":465}],483:[function(require,module,exports){
const BaseMob = require('./base_mob')
const Constants = require("./../../../../common/constants.json")
const Protocol = require("./../../../../common/util/protocol")

class SquidLord extends BaseMob {

  onPostInit() {
    super.onPostInit()
// 
//     this.rangeSprite = this.getRangeSprite()
//     this.sprite.addChildAt(this.rangeSprite, 0)
  }

//   drawRange() {
//     this.rangeSprite.alpha = 0.1
//   }
// 
//   hideRange() {
//     this.rangeSprite.alpha = 0
//   }
// 
//   onMouseOver() {
//     super.onMouseOver()
//     this.drawRange()
//   }
// 
//   onMouseOut() {
//     super.onMouseOut()
//     this.hideRange()
//   }

  getSpritePath() {
    return "squid_lord.png"
  }

  getConstantsTable() {
    return "Mobs.SquidLord"
  }

  getType() {
    return Protocol.definition().MobType.SquidLord
  }


}

module.exports = SquidLord

},{"./../../../../common/constants.json":656,"./../../../../common/util/protocol":686,"./base_mob":449}],484:[function(require,module,exports){
const LandMob = require('./land_mob')
const Constants = require("./../../../../common/constants.json")
const Protocol = require("./../../../../common/util/protocol")
const ClientHelper = require("./../../util/client_helper")
const Interpolator = require("./../../util/interpolator")
const Equipper  = require("./../../../../common/interfaces/equipper")

class Trader extends LandMob {
  constructor(game, data) {
    super(game, data)

    this.initEquipper()
  }

  getSpritePath() {
    return "trader.png"
  }

  openMenu() {
    this.game.tradeMenu.open(this)
  }

  getBaseRotationOffset() {
    return 0 * PIXI.DEG_TO_RAD
  }

  isInteractable() {
    return true
  }

  getSprite() {
    let sprite = super.getSprite()

    this.hat  = new PIXI.Sprite(PIXI.utils.TextureCache["cowboy_hat.png"])
    this.hat.anchor.set(0.5)
    this.hat.position.x = 10
    this.hat.position.y = 20

    this.characterSprite.addChild(this.hat)

    return sprite
  }

  renderDeadBody() {
    this.addDizzyEyes(this.body)
    this.dizzySprite.width  = 25
    this.dizzySprite.height = 10
    this.dizzySprite.position.x = 25
    this.dizzySprite.position.y = 25
    this.dizzySprite.rotation = 90 * Math.PI/180
  }

  getConstantsTable() {
    return "Mobs.Trader"
  }

  getType() {
    return Protocol.definition().MobType.Trader
  }


}

Object.assign(Trader.prototype, Equipper.prototype, {
  getDefaultSpriteColor() {
    return 0xd2b48c
  }
})


module.exports = Trader

},{"./../../../../common/constants.json":656,"./../../../../common/interfaces/equipper":672,"./../../../../common/util/protocol":686,"./../../util/client_helper":649,"./../../util/interpolator":652,"./land_mob":465}],485:[function(require,module,exports){
const Guard = require('./guard')
const LandMob = require('./land_mob')
const Constants = require("./../../../../common/constants.json")
const Protocol = require("./../../../../common/util/protocol")

class Trooper extends LandMob {

  getConstantsTable() {
    return "Mobs.Trooper"
  }

  getType() {
    return Protocol.definition().MobType.Trooper
  }

  getSpritePath() {
    return "trooper_active.png"
  }

  getCorpseSprite() {
    let sprite = super.getCorpseSprite()
    sprite.texture = PIXI.utils.TextureCache["trooper_corpse.png"]
    sprite.height = 40

    return sprite
  }

  getDizzySpriteConfig() {
    return {}
  }
}

module.exports = Trooper

},{"./../../../../common/constants.json":656,"./../../../../common/util/protocol":686,"./guard":462,"./land_mob":465}],486:[function(require,module,exports){
const BaseEntity = require("./base_entity")
const Constants = require("./../../../common/constants.json")
const Helper = require("./../../../common/helper")
const BitmapText = require("../util/bitmap_text")

class NetworkSprite extends BaseEntity {
  getSprite() {
    let sprite = new PIXI.Container()
    this.sprite = sprite
    sprite.name = "network"
    sprite.alpha = 0.5

    // let texture = PIXI.utils.TextureCache["room_tile.png"]
    // this.baseSprite = new PIXI.Sprite(texture)
    // this.baseSprite.name = "tile"
    // this.baseSprite.width  = Constants.tileSize
    // this.baseSprite.height = Constants.tileSize
    // this.baseSprite.anchor.set(0.5)

    const style  = { fontFamily : 'PixelForce', fontSize: 14, fill : 0xffffff, align : 'center', strokeThickness: 4, miterLimit: 3 }
    this.idSprite = BitmapText.create({
      label: "id",
      text: this.data.id,
      size: 14,
      spriteContainer: sprite
    })

    return sprite
  }

  getSpriteContainer() {
    return this.data.container.spriteLayers[this.getGroup()] 
  }

  remove() {
    if (this.idSprite) {
      this.idSprite.remove()
    }
    
    super.remove()
  }

  getGroup() {
    return this.data.type
  }

  getWidth() {
    return 32
  }

  getHeight() {
    return 32
  }

}

module.exports = NetworkSprite
},{"../util/bitmap_text":648,"./../../../common/constants.json":656,"./../../../common/helper":664,"./base_entity":206}],487:[function(require,module,exports){
const BaseEntity  = require("./../base_entity")
const Constants = require("./../../../../common/constants.json")
const Protocol = require("./../../../../common/util/protocol")

class BaseOre extends BaseEntity {
  constructor(game, data) {
    data.x = 0
    data.y = 0

    super(game, data)

    this.repositionSprite()
  }

  static getSellGroup() {
    return "Ores"
  }

  onPostEquip() {

  }

  syncWithServer() {
    
  }


  getSprite() {
    const sprite = new PIXI.Sprite(PIXI.utils.TextureCache[this.getSpritePath()])
    sprite.width = this.getWidth()
    sprite.height = this.getHeight()
    return sprite
  }

  getSpriteContainer() {
    if (this.data.user.isBuildingType()) {
      return this.data.user.buildingSprite
    } else {
      return this.data.user.characterSprite
    }
  }

  repositionSprite() {
    this.sprite.anchor.set(0)
    this.sprite.position.x = 40
    this.sprite.position.y = 10
  }

  static build(game, data) {
    return new this(game, data)
  }

  getType() {
    throw new Error("must implement BaseOre.getType")
  }

}

module.exports = BaseOre

},{"./../../../../common/constants.json":656,"./../../../../common/util/protocol":686,"./../base_entity":206}],488:[function(require,module,exports){
const BaseOre = require("./base_ore")
const Constants = require("./../../../../common/constants.json")
const Protocol = require("./../../../../common/util/protocol")

class Cloth extends BaseOre {

  getSpritePath() {
    return 'cloth.png'
  }

  getType() {
    return Protocol.definition().BuildingType.Cloth
  }

  getConstantsTable() {
    return "Ores.Cloth"
  }

}

module.exports = Cloth

},{"./../../../../common/constants.json":656,"./../../../../common/util/protocol":686,"./base_ore":487}],489:[function(require,module,exports){
const BaseOre = require("./base_ore")
const Constants = require("./../../../../common/constants.json")
const Protocol = require("./../../../../common/util/protocol")

class CoffeeBean extends BaseOre {

  getSpritePath() {
    return 'coffee_bean.png'
  }

  getType() {
    return Protocol.definition().BuildingType.CoffeeBean
  }

  getConstantsTable() {
    return "Ores.CoffeeBean"
  }

}

module.exports = CoffeeBean

},{"./../../../../common/constants.json":656,"./../../../../common/util/protocol":686,"./base_ore":487}],490:[function(require,module,exports){
const BaseOre = require("./base_ore")
const Constants = require("./../../../../common/constants.json")
const Protocol = require("./../../../../common/util/protocol")

class CopperOre extends BaseOre {

  getSpritePath() {
    return 'copper_ore.png'
  }

  getType() {
    return Protocol.definition().BuildingType.CopperOre
  }

  getConstantsTable() {
    return "Ores.CopperOre"
  }

}

module.exports = CopperOre

},{"./../../../../common/constants.json":656,"./../../../../common/util/protocol":686,"./base_ore":487}],491:[function(require,module,exports){
const BaseOre = require("./base_ore")
const Constants = require("./../../../../common/constants.json")
const Protocol = require("./../../../../common/util/protocol")

class Explosives extends BaseOre {

  getSpritePath() {
    return 'explosives.png'
  }

  getType() {
    return Protocol.definition().BuildingType.Explosives
  }

  getConstantsTable() {
    return "Ores.Explosives"
  }

}

module.exports = Explosives

},{"./../../../../common/constants.json":656,"./../../../../common/util/protocol":686,"./base_ore":487}],492:[function(require,module,exports){
const BaseOre = require("./base_ore")
const Constants = require("./../../../../common/constants.json")
const Protocol = require("./../../../../common/util/protocol")

class Gold extends BaseOre {

  getSpritePath() {
    return 'gil.png'
  }

  getType() {
    return Protocol.definition().BuildingType.Gold
  }

  getConstantsTable() {
    return "Ores.Gold"
  }

}

module.exports = Gold

},{"./../../../../common/constants.json":656,"./../../../../common/util/protocol":686,"./base_ore":487}],493:[function(require,module,exports){
const BaseOre = require("./base_ore")
const Constants = require("./../../../../common/constants.json")
const Protocol = require("./../../../../common/util/protocol")

class IceOre extends BaseOre {

  getSpritePath() {
    return 'ice_ore.png'
  }

  getType() {
    return Protocol.definition().BuildingType.IceOre
  }

  getConstantsTable() {
    return "Ores.IceOre"
  }

}

module.exports = IceOre

},{"./../../../../common/constants.json":656,"./../../../../common/util/protocol":686,"./base_ore":487}],494:[function(require,module,exports){
const Helper = require("./../../../../common/helper")
const Constants = require("./../../../../common/constants.json")
const BaseOre = require("./base_ore")

const Ores = {}
Ores.IceOre = require("./ice_ore")
Ores.CopperOre = require("./copper_ore")
Ores.SteelOre = require("./steel_ore")
Ores.IronOre = require("./iron_ore")
Ores.NitroPowder = require("./nitro_powder")
Ores.Sand = require("./sand")
Ores.Gold = require("./gold")
Ores.Wood = require("./wood")
Ores.Cloth = require("./cloth")
Ores.PlantFiber = require("./plant_fiber")
Ores.Poison = require("./poison")
Ores.Web = require("./web")
Ores.CoffeeBean = require("./coffee_bean")
Ores.SulfurOre = require("./sulfur_ore")
Ores.Explosives = require("./explosives")
Ores.Meteorite = require("./meteorite")
Ores.SquidLordHeart = require("./squid_lord_heart")

Ores.forType = (type) => {
  const klassName = Helper.getTypeNameById(type)
  return Ores[klassName]
}

for (let name in Constants.Ores) {
  if (!Ores[name]) {
    let data = Constants.Ores[name]
    if (!data.abstract) {
      Ores[name] = Helper.createDynamicKlass("Ores", BaseOre, name)
    }
  }
}

module.exports = Ores

},{"./../../../../common/constants.json":656,"./../../../../common/helper":664,"./base_ore":487,"./cloth":488,"./coffee_bean":489,"./copper_ore":490,"./explosives":491,"./gold":492,"./ice_ore":493,"./iron_ore":495,"./meteorite":496,"./nitro_powder":497,"./plant_fiber":498,"./poison":499,"./sand":500,"./squid_lord_heart":501,"./steel_ore":502,"./sulfur_ore":503,"./web":504,"./wood":505}],495:[function(require,module,exports){
const BaseOre = require("./base_ore")
const Constants = require("./../../../../common/constants.json")
const Protocol = require("./../../../../common/util/protocol")

class IronOre extends BaseOre {

  getSpritePath() {
    return 'iron_ore.png'
  }

  getType() {
    return Protocol.definition().BuildingType.IronOre
  }

  getConstantsTable() {
    return "Ores.IronOre"
  }

}

module.exports = IronOre

},{"./../../../../common/constants.json":656,"./../../../../common/util/protocol":686,"./base_ore":487}],496:[function(require,module,exports){
const BaseOre = require("./base_ore")
const Constants = require("./../../../../common/constants.json")
const Protocol = require("./../../../../common/util/protocol")

class Meteorite extends BaseOre {

  getSpritePath() {
    return 'meteorite.png'
  }

  getType() {
    return Protocol.definition().BuildingType.Meteorite
  }

  getConstantsTable() {
    return "Ores.Meteorite"
  }

}

module.exports = Meteorite

},{"./../../../../common/constants.json":656,"./../../../../common/util/protocol":686,"./base_ore":487}],497:[function(require,module,exports){
const BaseOre = require("./base_ore")
const Constants = require("./../../../../common/constants.json")
const Protocol = require("./../../../../common/util/protocol")

class NitroPowder extends BaseOre {

  getSpritePath() {
    return 'nitro_powder.png'
  }

  getType() {
    return Protocol.definition().BuildingType.NitroPowder
  }

  getConstantsTable() {
    return "Ores.NitroPowder"
  }

}

module.exports = NitroPowder

},{"./../../../../common/constants.json":656,"./../../../../common/util/protocol":686,"./base_ore":487}],498:[function(require,module,exports){
const BaseOre = require("./base_ore")
const Constants = require("./../../../../common/constants.json")
const Protocol = require("./../../../../common/util/protocol")

class PlantFiber extends BaseOre {

  getSpritePath() {
    return 'plant_fiber.png'
  }

  getType() {
    return Protocol.definition().BuildingType.PlantFiber
  }

  getConstantsTable() {
    return "Ores.PlantFiber"
  }

}

module.exports = PlantFiber

},{"./../../../../common/constants.json":656,"./../../../../common/util/protocol":686,"./base_ore":487}],499:[function(require,module,exports){
const BaseOre = require("./base_ore")
const Constants = require("./../../../../common/constants.json")
const Protocol = require("./../../../../common/util/protocol")

class Poison extends BaseOre {

  getSpritePath() {
    return 'poison.png'
  }

  getType() {
    return Protocol.definition().BuildingType.Poison
  }

  getConstantsTable() {
    return "Ores.Poison"
  }

}

module.exports = Poison

},{"./../../../../common/constants.json":656,"./../../../../common/util/protocol":686,"./base_ore":487}],500:[function(require,module,exports){
const BaseOre = require("./base_ore")
const Constants = require("./../../../../common/constants.json")
const Protocol = require("./../../../../common/util/protocol")

class Sand extends BaseOre {

  getSpritePath() {
    return 'sand.png'
  }

  getType() {
    return Protocol.definition().BuildingType.Sand
  }

  getConstantsTable() {
    return "Ores.Sand"
  }

}

module.exports = Sand

},{"./../../../../common/constants.json":656,"./../../../../common/util/protocol":686,"./base_ore":487}],501:[function(require,module,exports){
const BaseOre = require("./base_ore")
const Constants = require("./../../../../common/constants.json")
const Protocol = require("./../../../../common/util/protocol")

class SquidLordHeart extends BaseOre {

  getSpritePath() {
    return 'squid_lord_heart.png'
  }

  getType() {
    return Protocol.definition().BuildingType.SquidLordHeart
  }

  getConstantsTable() {
    return "Ores.SquidLordHeart"
  }

}

module.exports = SquidLordHeart

},{"./../../../../common/constants.json":656,"./../../../../common/util/protocol":686,"./base_ore":487}],502:[function(require,module,exports){
const BaseOre = require("./base_ore")
const Constants = require("./../../../../common/constants.json")
const Protocol = require("./../../../../common/util/protocol")

class SteelOre extends BaseOre {

  getSpritePath() {
    return 'steel_ore.png'
  }

  getType() {
    return Protocol.definition().BuildingType.SteelOre
  }

  getConstantsTable() {
    return "Ores.SteelOre"
  }

}

module.exports = SteelOre

},{"./../../../../common/constants.json":656,"./../../../../common/util/protocol":686,"./base_ore":487}],503:[function(require,module,exports){
const BaseOre = require("./base_ore")
const Constants = require("./../../../../common/constants.json")
const Protocol = require("./../../../../common/util/protocol")

class SulfurOre extends BaseOre {

  getSpritePath() {
    return 'sulfur_ore.png'
  }

  getType() {
    return Protocol.definition().BuildingType.SulfurOre
  }

  getConstantsTable() {
    return "Ores.SulfurOre"
  }

}

module.exports = SulfurOre

},{"./../../../../common/constants.json":656,"./../../../../common/util/protocol":686,"./base_ore":487}],504:[function(require,module,exports){
const BaseOre = require("./base_ore")
const Constants = require("./../../../../common/constants.json")
const Protocol = require("./../../../../common/util/protocol")

class Web extends BaseOre {

  getSpritePath() {
    return 'web.png'
  }

  getType() {
    return Protocol.definition().BuildingType.Web
  }

  getConstantsTable() {
    return "Ores.Web"
  }

}

module.exports = Web

},{"./../../../../common/constants.json":656,"./../../../../common/util/protocol":686,"./base_ore":487}],505:[function(require,module,exports){
const BaseOre = require("./base_ore")
const Constants = require("./../../../../common/constants.json")
const Protocol = require("./../../../../common/util/protocol")

class Wood extends BaseOre {

  getSpritePath() {
    return 'wood.png'
  }

  getType() {
    return Protocol.definition().BuildingType.Wood
  }

  getConstantsTable() {
    return "Ores.Wood"
  }

}

module.exports = Wood

},{"./../../../../common/constants.json":656,"./../../../../common/util/protocol":686,"./base_ore":487}],506:[function(require,module,exports){
const Particles = {}

Particles.Trail = require("./trail")
Particles.Meteor = require("./meteor")
Particles.Smoke = require("./smoke")

module.exports = Particles

},{"./meteor":507,"./smoke":508,"./trail":509}],507:[function(require,module,exports){
const Poolable = require("../../../../common/interfaces/poolable")
const ObjectPool = require("../../../../common/entities/object_pool")
const Constants = require("./../../../../common/constants.json")
const Projectiles = require("../projectiles/index")
const Protocol = require("./../../../../common/util/protocol")

class Meteor {
  static create(options) {
    let object = ObjectPool.obtain("Meteor")
    object.setAttributes(options)
    object.animate()
    return object
  }

  setAttributes(options) {
    let spriteContainer = game.sector.effectsContainer

    const minDiameter = Constants.tileSize
    const randomWidth = minDiameter + Math.floor(Math.random() * (Constants.tileSize))
    this.sprite.width = randomWidth
    this.sprite.height = randomWidth

    this.sprite.position.x = options.x 
    this.sprite.position.y = options.y 

    this.sprite.texture = PIXI.utils.TextureCache["meteor_rock.png"]
    spriteContainer.addChild(this.sprite)
  }

  constructor() {
    this.sprite = new PIXI.Sprite()
    this.sprite.anchor.set(0.5)
  }

  animate() {
    let offset = Constants.tileSize * 12
    let angle = Math.PI/4 // 45 degrees

    let sourceX = this.sprite.position.x + offset * Math.cos(angle)
    let sourceY = this.sprite.position.y - offset * Math.cos(angle)
    let destinationX = this.sprite.position.x
    let destinationY = this.sprite.position.y

    let position = { x: sourceX, y: sourceY }

    var tween = new TWEEN.Tween(position)
        .to({ x: destinationX, y: destinationY }, 1000)
        .onUpdate(() => {
          this.sprite.position.x = position.x
          this.sprite.position.y = position.y
        })
        .onComplete(() => {
          this.remove()

          Projectiles.Explosion.create(game, {
            x: this.sprite.position.x,
            y: this.sprite.position.y,
            type: Protocol.definition().ProjectileType.Explosion,
            angle: 0
          })

        })
        .start()

  }

  remove() {
    if (this.sprite.parent) {
      this.sprite.parent.removeChild(this.sprite)
    }
    ObjectPool.free("Meteor", this)
  }

}

Object.assign(Meteor.prototype, Poolable.prototype, {
  reset() {
    // not needed. every instance variable is overwritten anyway
  }
})

module.exports = Meteor
},{"../../../../common/entities/object_pool":660,"../../../../common/interfaces/poolable":675,"../projectiles/index":526,"./../../../../common/constants.json":656,"./../../../../common/util/protocol":686}],508:[function(require,module,exports){
const Poolable = require("../../../../common/interfaces/poolable")
const ObjectPool = require("../../../../common/entities/object_pool")
const ClientHelper = require("../../util/client_helper")

class Smoke {
  static create(options) {
    let smoke = ObjectPool.obtain("Smoke")
    smoke.setAttributes(options)
    smoke.animate()
    return smoke
  }

  setAttributes(options) {
    let shouldRandomizeDistance = (typeof options.shouldRandomizeDistance === 'undefined') ? true : options.shouldRandomizeDistance
    let x = options.x
    let y = options.y
    let color = options.color

    const randomDistanceX = shouldRandomizeDistance ? Math.floor(Math.random() * 64) - 32 : 0
    const randomDistanceY = shouldRandomizeDistance ? Math.floor(Math.random() * 64) - 32 : 0

    const randomWidth = Math.floor(Math.random() * (options.maxWidth - options.minWidth)) + options.minWidth
    this.sprite.width = randomWidth
    this.sprite.height = randomWidth
    this.sprite.tint = color
    this.sprite.position.x = x - randomDistanceX
    this.sprite.position.y = y - randomDistanceY

    if (options.moveTo) {
      this.moveTo = { 
        x: this.sprite.position.x + options.moveTo.x,
        y: this.sprite.position.y + options.moveTo.y
      }
    }

    game.sector.effectsContainer.addChild(this.sprite)
  }

  constructor() {
    this.sprite = new PIXI.Sprite(PIXI.utils.TextureCache["white_smoke.png"])
    this.sprite.anchor.set(0.5)
  }

  animate() {
    let current = { alpha: 0.8 }
    let destination = { alpha: 0 }

    if (this.moveTo) {
      current.x = this.sprite.position.x
      current.y = this.sprite.position.y

      destination.x = this.moveTo.x
      destination.y = this.moveTo.y
    }

    var tween = new TWEEN.Tween(current)
        .to(destination, 4000)
        .easing(TWEEN.Easing.Quadratic.Out) // Use an easing function to make the animation smooth.
        .onUpdate(() => {
          this.sprite.alpha = current.alpha
          if (this.moveTo) {
            this.sprite.position.x = current.x
            this.sprite.position.y = current.y
          }
        })
        .onComplete(() => {
          this.remove()
        })
    tween.start()
  }

  remove() {
    if (this.sprite.parent) {
      this.sprite.parent.removeChild(this.sprite)
    }
    this.moveTo = null
    ObjectPool.free("Smoke", this)
  }

}

Object.assign(Smoke.prototype, Poolable.prototype, {
  reset() {
    // not needed. every instance variable is overwritten anyway
  }
})

module.exports = Smoke
},{"../../../../common/entities/object_pool":660,"../../../../common/interfaces/poolable":675,"../../util/client_helper":649}],509:[function(require,module,exports){
const Poolable = require("../../../../common/interfaces/poolable")
const ObjectPool = require("../../../../common/entities/object_pool")
const ClientHelper = require("../../util/client_helper")

class Trail {
  static create(options) {
    let trail = ObjectPool.obtain("Trail")
    trail.setAttributes(options)
    trail.animate()
    return trail
  }

  setAttributes(options) {
    this.isExpanding = options.isExpanding
    this.isShrinking = options.isShrinking

    let angle = options.angle
    let offset = options.offset
    let color = options.color
    let spritePath = options.spritePath || "white_smoke.png"
    let spriteContainer = options.spriteContainer || game.sector.effectsContainer

    this.sourceColor      = "#" + Number(options.color).toString(16)
    if (options.destinationColor) {
      this.destinationColor = "#" + Number(options.destinationColor).toString(16) 
    } else {
      this.destinationColor = null
    }

    const randomWidth = Math.floor(Math.random() * options.radius) + 10
    this.sprite.width = randomWidth
    this.sprite.height = randomWidth
    this.sprite.tint = color

    this.sprite.position.x = options.x - offset * Math.cos(angle)
    this.sprite.position.y = options.y - offset * Math.sin(angle) // opposite y direction

    this.sprite.texture = PIXI.utils.TextureCache[spritePath]
    spriteContainer.addChild(this.sprite)
  }

  constructor() {
    this.sprite = new PIXI.Sprite()
    this.sprite.anchor.set(0.5)
  }

  animate() {
    let alpha = { alpha: 1 }
    let maxExpansion = 32
    let origWidth = this.sprite.width

    var tween = new TWEEN.Tween(alpha)
        .to({ alpha: 0 }, 1500)
        .easing(TWEEN.Easing.Quadratic.Out) // Use an easing function to make the animation smooth.
        .onUpdate(() => {
          this.sprite.alpha = alpha.alpha
          if (this.isExpanding) {
            let delta = maxExpansion - alpha.alpha * maxExpansion
            this.sprite.width  = origWidth + delta
            this.sprite.height = origWidth + delta
          } else if (this.isShrinking) {
            let delta = (1 - alpha.alpha) * maxExpansion
            let newWidth = origWidth - delta
            this.sprite.width  = newWidth < 0 ? 0 : newWidth
            this.sprite.height = newWidth < 0 ? 0 : newWidth
          }

          if (this.destinationColor) {
            let ratio = 1 - alpha.alpha
            let tint = ClientHelper.getRandomColorInRange(
                         this.sourceColor, 
                         this.destinationColor, 
                         ratio, 
                         { shouldReturnInteger: true })

            this.sprite.tint = tint
          }
        })
        .onComplete(() => {
          this.remove()
        })
        .start()

  }

  remove() {
    if (this.sprite.parent) {
      this.sprite.parent.removeChild(this.sprite)
    }
    ObjectPool.free("Trail", this)
  }

}

Object.assign(Trail.prototype, Poolable.prototype, {
  reset() {
    // not needed. every instance variable is overwritten anyway
  }
})

module.exports = Trail
},{"../../../../common/entities/object_pool":660,"../../../../common/interfaces/poolable":675,"../../util/client_helper":649}],510:[function(require,module,exports){
const BaseEntity = require("./base_entity")
const Constants = require("./../../../common/constants.json")
const Helper = require("./../../../common/helper")
const PathLocation = require("./path_location")

class Path extends BaseEntity {
  constructor(game, data) {
    super(game, data)

    this.locations = data.locations
    this.pathLocations = []
  }

  getWidth() {
    return 0
  }

  getHeight() {
    return 0
  }

  syncWithServer(data) {
    if (this.sprite) {
      this.removeSelfAndChildrens(this.sprite)
    }

    for (let key in data) {
      this.data[key] = data[key]
    }

    this.buildSprites()
    console.log("rebuild paths..")
  }

  initSprite() {
    // nothing
  }

  getPathLocationKlass() {
    return PathLocation
  }

  remove() {
    super.remove()
    this.getContainer().unregisterEntity("paths", this)
  }

  buildTileSprite(tile) {
    let klass = this.getPathLocationKlass()
    tile.container = this.data.container
    let pathLocation = new klass(this, tile)
    this.sprite.addChild(pathLocation.sprite)
    
    this.pathLocations.push(pathLocation)
  }

  buildSprites() {
    this.sprite = new PIXI.Container()
    this.sprite.name = "path"
    this.getSpriteContainer().addChild(this.sprite)

    let batches = Helper.batch(this.data.locations, 50)
    batches.forEach((batch) => {
      // setTimeout(() => {
        batch.forEach((tile) => {
          this.buildTileSprite(tile)
        })
      // }, 0)
    })

    let goal = this.data.goal
    let goalSprite = this.createTargetSprite(goal.row, goal.col)
    this.sprite.addChild(goalSprite)
  }

  createTargetSprite(row, col) {
    let texture = PIXI.utils.TextureCache[this.getTileSpritePath()]
    let sprite = new PIXI.Sprite(texture)
    sprite.name = "goal_target"
    sprite.tint = 0x00ff00
    sprite.position.x = col * Constants.tileSize + Constants.tileSize / 2
    sprite.position.y = row * Constants.tileSize + Constants.tileSize / 2
    sprite.width  = Constants.tileSize
    sprite.height = Constants.tileSize
    sprite.anchor.set(0.5)

    this.getSpriteContainer().addChild(sprite)

    return sprite
  }

  getSpriteContainer() {
    return this.data.container.spriteLayers[this.getGroup()] 
  }

  getTileSpritePath() {
    return "room_tile.png"
  }

  getGroup() {
    return "paths"
  }


}

module.exports = Path
},{"./../../../common/constants.json":656,"./../../../common/helper":664,"./base_entity":206,"./path_location":511}],511:[function(require,module,exports){
const BaseEntity = require("./base_entity")
const Constants = require("./../../../common/constants.json")

class PathLocation extends BaseEntity {
  constructor(path, data) {
    super(path.game, data)

    this.path = path
    this.data = data
    this.row = data.row
    this.col = data.col
    this.direction = data.direction
    this.distance = data.distance

    this.buildSprite()
  }

  static getTextures() {
    if (!this.textures) {
      this.textures = {}

      let count = 150
      for (var i = 0; i <= count; i++) {
        let text = new PIXI.Text(i, {fontSize: 20, fontFamily: "Arial", align: "center", fill : 0xeeeeee })
        text.updateText()
        this.textures[i] = text.texture
      }

    }

    return this.textures
  }

  getTypeName() {
    return "Path"
  }

  getSelectionSprite() {
    const padding = 2
    const w = this.getWidth()
    const h = this.getHeight()
    const graphics = new PIXI.Graphics()
    graphics.name = "Selection"
    const lineStyle = this.getSelectionLineStyle()
    graphics.lineStyle(lineStyle.lineWidth, lineStyle.color)
    graphics.drawRect(-w/2 + padding, -h/2 + padding, w - (padding * 2), h - (padding * 2))
    graphics.endFill()

    return graphics
  }


  getWidth() {
    return Constants.tileSize
  }

  getHeight() {
    return Constants.tileSize
  }

  getRow() {
    return this.row
  }

  getCol() {
    return this.col
  }

  getX() {
    return this.getCol() * Constants.tileSize + Constants.tileSize/2
  }

  getY() {
    return this.getRow() * Constants.tileSize + Constants.tileSize/2
  }

  initSprite() {
    // use our own
  }

  buildSprite() {
    let sprite = new PIXI.Container()
    this.sprite = sprite
    sprite.name = "path_tile"
    sprite.position.x = this.col * Constants.tileSize + Constants.tileSize / 2
    sprite.position.y = this.row * Constants.tileSize + Constants.tileSize / 2
    sprite.alpha = 0.5

    sprite.addChild(this.getBaseSprite())

    if (this.shouldShowDirection()) {
      let angle = Math.atan2(this.direction.y, this.direction.x)
      let isZeroDirection = this.direction.x === 0 && this.direction.y === 0
      if (!isZeroDirection) {
        sprite.addChild(this.getArrowSprite(angle))
      }
    }

    sprite.addChild(this.getDistanceSprite(this.distance))

    return sprite
  }

  shouldShowDirection() {
    return true
  }

  getBaseSprite() {
    let texture = PIXI.utils.TextureCache[this.getTileSpritePath()]
    let sprite = new PIXI.Sprite(texture)
    sprite.name = "tile"
    sprite.tint = 0x0000ff
    sprite.width  = Constants.tileSize
    sprite.height = Constants.tileSize
    sprite.anchor.set(0.5)
    return sprite
  }

  getTileSpritePath() {
    return "room_tile.png"
  }

  getArrowSprite(angle) {
    let texture = PIXI.utils.TextureCache["arrow.png"]
    let sprite = new PIXI.Sprite(texture)
    sprite.name = "arrow"
    sprite.tint = 0x00ff00
    sprite.rotation = angle
    sprite.anchor.set(0.5)
    return sprite
  }

  getDistanceSprite(distance) {
    let sprite = new PIXI.Sprite(this.constructor.getTextures()[distance])
    sprite.name = "distance"
    sprite.anchor.set(0.5)
    return sprite
  }

}


module.exports = PathLocation

},{"./../../../common/constants.json":656,"./base_entity":206}],512:[function(require,module,exports){
const BaseEntity  = require("./base_entity")
const Buildings  = require("./buildings/index")
const Constants = require("./../../../common/constants.json")
const Item = require("./item")
const BitmapText = require("../util/bitmap_text")

class Pickup extends BaseEntity {
  constructor(game, data) {
    super(game, data)

    this.type = data.item.type
    this.count = data.item.count

    this.tween = this.getFloatingTween()
    this.tween.start()

    this.chunks = {}

    this.registerToChunk()
  }

  cleanupTween() {
    if (this.tween) {
      this.tween.stop()
      this.tween = null
    }
  }

  getGroup() {
    return "pickups"
  }

  remove() {
    super.remove()

    if (this.pickupCountText) {
      this.pickupCountText.remove()
    }

    this.getContainer().unregisterEntity("pickups", this)

    if (this.chunk) {
      this.chunk.unregister("pickups", this)
    }

    this.cleanupTween()
  }

  getFloatingTween() {
    let origPosition = this.sprite.position.y

    let position = { position: origPosition }

    return new TWEEN.Tween(position)
        .to({ position: origPosition + 20 }, 1000)
        .easing(TWEEN.Easing.Linear.None)
        .onUpdate(() => {
          this.sprite.position.y = position.position
        })
        .yoyo(true)
        .repeat(Infinity)
  }

  getSprite() {
    let sprite = new PIXI.Container()
    sprite.name = "Pickup"

    let texture = PIXI.utils.TextureCache[this.getSpritePath()]
    let itemSprite = new PIXI.Sprite(texture)
    itemSprite.width  = Math.min(itemSprite.width, Constants.tileSize)
    itemSprite.height = Math.min(itemSprite.height, Constants.tileSize)
    itemSprite.rotation = -90 * PIXI.DEG_TO_RAD

    const countText = this.data.item.count

    this.pickupCountText = BitmapText.create({
      label: "PickupCount",
      text: countText, 
      align: 'center',
      anchor: 0,
      size: 20,
      spriteContainer: sprite
    })

    this.pickupCountText.sprite.position.x = 21
    this.pickupCountText.sprite.position.y = -13

    sprite.addChildAt(itemSprite, 0)

    return sprite
  }

  getSpriteContainer() {
    return this.data.container.spriteLayers["pickups"]
  }

  getSpritePath() {
    return Item.getSpritePath(this.data.item.type)
  }

  syncWithServer(data) {
  }

  getYScale() {
    let scale = (Constants.tileSize * 2)  / Item.getHeight(this.data.item.type)  
    return Math.min(scale, 1)
  }

  getXScale() {
    let scale = (Constants.tileSize * 2)  / Item.getWidth(this.data.item.type)  
    return Math.min(scale, 1)
  }

  getConstantsTable() {
    return "Pickup"
  }
}

module.exports = Pickup

},{"../util/bitmap_text":648,"./../../../common/constants.json":656,"./base_entity":206,"./buildings/index":250,"./item":443}],513:[function(require,module,exports){
const BaseEntity = require("./base_entity")
const Buildings = require("./buildings/index")
const Mobs = require("./mobs/index")
const Equipments = require("./equipments/index")
const Interpolator = require("./../util/interpolator")
const SpriteEventHandler = require("./../util/sprite_event_handler")
const PlayerCommon = require("./../../../common/entities/player_common")
const ShipMountable = require("./../../../common/interfaces/ship_mountable")
const Needs = require("./../../../common/interfaces/needs")
const SocketUtil = require("./../util/socket_util")
const Destroyable  = require("./../../../common/interfaces/destroyable")
const Upgradable  = require("./../../../common/interfaces/upgradable")
const Equipper  = require("./../../../common/interfaces/equipper")
const Helper = require("./../../../common/helper")
const Constants = require("./../../../common/constants.json")
const Protocol = require("./../../../common/util/protocol")
const HealthBar = require("./../components/health_bar")
const Ship = require("./ship")
const Item = require("./item")
const Camera = require("./camera")
const StatusManager = require("./status_manager")
const tinycolor = require("tinycolor2")
const BitmapText = require("../util/bitmap_text")

class Player extends BaseEntity {
  constructor(data, sector) {
    super(sector.game, data)

    this.sector = sector
    this.relativeX = data.relativeX
    this.relativeY = data.relativeY

    this.setAngle(data.angle)
    this.setShip(data.ship)

    this.initPlayerCommon()
    this.initDestroyable()
    this.initVariables(data)
    this.setTeam(data.team)
    this.initVisionLight()

    this.setEquipments(data)

    this.initNeeds()

    this.initUsernameHeight()
    this.setCameraFocusTarget(this)
    this.setActiveBuildingContainer(this.sector)

    this.healthBar = new HealthBar(this)
    this.statusManager = new StatusManager(this)

    this.uid = data.uid

    this.chunks = {}

    this.onPositionChanged()

    if (this.isDestroyed()) {
      this.renderDeadBody()
      if (this.isMe()) {
        this.game.showDeathScreenImmediate()
        this.game.showRestartCountdown(Date.now(), Constants.restartCountdown)
      }
    }

    this.interpolator.setOnNoPositionAvailableListener(this.onNoPositionAvailable.bind(this))

    if (this.isMe()) {
      this.game.updateHealthBar(this.health, this.getMaxHealth())
      this.game.updateOxygenBar(this.oxygen, this.getMaxOxygen())
      this.game.updateStaminaBar(this.stamina, this.getMaxStamina())
      this.game.updateHungerBar(this.hunger, this.getMaxHunger())
      this.game.initMyPlayer(this)

      this.game.teamStatusMenu.showTeamMembers(this.getTeam())
      if (!this.isSpectating()) {
        this.sector.lightManager.applyFov()
      }
    }
  }

  openMenu() {
    this.game.playerMenu.open(this)
  }

  getPlayerVisionRadius() {
    return Constants.tileSize * 11
  }

  hasCommandsPermission() {
    return this.isSectorOwner() || this.getRolePermissions()["UseCommands"]
  }

  isNotVisible() {
    return !this.sprite.visible
  }

  setVisible(visible) {
    this.sprite.visible = visible
  }

  isSectorOwner() {
    return this.game.creatorUid === this.uid
  }

  canEditCommandBlock() {
    if (this.sector.isTutorial()) return true
    if(this.isSectorOwner()) return true
    if(this.getRolePermissions()["EditCommandBlocks"]) return true
    return false
  }

  initVisionLight() {
    this.visionLightCanvas = document.createElement("canvas")
    this.visionLightCanvas.className = "vision_light_canvas"
    let radius = this.getPlayerVisionRadius()
    let padding = 2
    this.visionLightCanvas.width  = radius * 2 + padding * 2
    this.visionLightCanvas.height = radius * 2 + padding * 2

    // document.body.appendChild(this.visionLightCanvas)

    this.visionLightSprite = new PIXI.Sprite()
    this.visionLightSprite.texture = PIXI.Texture.fromCanvas(this.visionLightCanvas)
    this.visionLightSprite.position.x = this.getX()
    this.visionLightSprite.position.y = this.getY()
    this.visionLightSprite.anchor.set(0.5)
    this.visionLightSprite.width  = radius * 2
    this.visionLightSprite.height = radius * 2

    this.redrawVisionLight()

    this.getContainer().dynamicLightSprite.addChild(this.visionLightSprite)

    // this.visionLight.beginFill(0xffffff)
    // this.visionLight.drawCircle(0,0, 32 * 3)
    // this.visionLight.endFill()
    // this.visionLight.position.x = this.getX()
    // this.visionLight.position.y = this.getY()

    // this.getContainer().lightMapContainer.addChild(this.visionLight)
  }

  getPlayerVisionColor() {
    let armorEquipment = this.getArmorEquipment()
    if (!armorEquipment) {
      if (this.isMe()) {
        return { r: 255,  g: 255, b: 255, a: 0.250 }
      } else {
        return { r: 255,  g: 255, b: 255, a: 0.000 } // i cant see other player's normal vision
      }

    }

    let armorColorRgb = tinycolor(armorEquipment.getLightColor()).toRgb()
    armorColorRgb.a = armorEquipment.getBrightness()

    return armorColorRgb
  }

  redrawVisionLight() {
    let radius = this.getPlayerVisionRadius()
    let padding = 2

    let playerVisionColor = this.getPlayerVisionColor()
    let visonRgbString = [playerVisionColor.r, playerVisionColor.g, playerVisionColor.b, playerVisionColor.a].join(",")

    // reset canvas first
    let ctx = this.visionLightCanvas.getContext("2d")
    ctx.clearRect(0, 0, this.visionLightCanvas.width, this.visionLightCanvas.height)

    // apply radial gradient
    let gradient = ctx.createRadialGradient(radius + padding, radius + padding , radius/4, radius + padding, radius + padding, radius)
    gradient.addColorStop(0, "rgba(" + visonRgbString + ")")
    gradient.addColorStop(1, "rgba(255, 255, 255, 0.000)")
    ctx.fillStyle = gradient
    ctx.fillRect(0, 0, this.visionLightCanvas.width, this.visionLightCanvas.height)

    this.visionLightSprite.texture.update()
  }

  onClick() {
    this.game.interact(this)
    if (this.isHidden) return

    if (this.isMe()) {
      this.setActTarget(this)
    } else {
      this.game.showEntityMenu(this, { dontCloseMenus: true, selectedEntity: this, replaceSelected: true })
      this.game.selectEntity(this)
    }
  }

  onMouseOver() {
    super.onMouseOver()
    if (this.isMe()) return
    if (this.isHidden) return

    this.game.highlight(this)
    this.game.showEntityMenu(this)
  }

  isHiddenFromView() {
    return this.isHidden
  }

  onMouseOut() {
    super.onMouseOut()
    if (this.isMe()) return
    if (this.isHidden) return

    this.game.unhighlight(this)
    this.game.hideEntityMenu(this)
  }

  renderEntityMenu(entityMenu) {
    this.showStats(entityMenu)
    this.showAction(entityMenu)
  }

  showStats(entityMenu) {
    let stats = ""

    const health = "<div class='entity_stats_entry'>" +
                      "<div class='stats_type'>Health</div>" +
                      "<div class='stats_value'>" + this.health + "/" + this.getMaxHealth() + "</div>" +
                  "</div>"

    const daysAlive = "<div class='entity_stats_entry'>" +
                      "<div class='stats_type'>Days Alive</div>" +
                      "<div class='stats_value'>" + this.daysAlive + "</div>" +
                  "</div>"


    stats += health
    stats += daysAlive

    let team = this.getTeam()
    if (team) {
      const teamEntry = "<div class='entity_stats_entry'>" +
                            "<div class='stats_type'>Team</div>" +
                            "<div class='stats_value'>" + team.getName() + "</div>" +
                        "</div>"
      stats += teamEntry
    }

    entityMenu.querySelector(".entity_stats").innerHTML = stats
  }

  initPermissionSelect(entityMenu) {
    let permissionSelect = entityMenu.querySelector(".player_permissions_select")
    if (!permissionSelect) return
    permissionSelect.addEventListener("change", this.onPlayerPermissionsSelectChanged.bind(this))

    if (typeof this.roleType !== 'undefined') {
      permissionSelect.value = this.roleType
    }

  }

  onPlayerPermissionsSelectChanged(e) {
    e.preventDefault()
    let roleType = e.target.value
    let memberId = e.target.closest(".player_permissions_select").dataset.memberId 
    SocketUtil.emit("TeamMemberAction", { memberId: memberId, action: 'role', roleType: roleType })
  }

  isAdmin() {
    let team = this.getTeam()
    if (!team) return false

    return team.isAdmin(this)
  }

  isLeader() {
    let team = this.getTeam()
    if (!team) return false

    return team.isLeader(this)
  }

  showAction(entityMenu) {
    let actions = ""
    let permissionSelect = this.createRoleSelect(entityMenu)

    let team = this.game.player.getTeam()
    if (!team) return

    let sameTeam = this.getTeam() === team
    if (team.isAdmin(this.game.player) && sameTeam) {
      actions += permissionSelect
    }

    const playerKickBtn = "<div class='player_kick_btn ui_btn' data-action='kick'>" + i18n.t('Kick') + "</div>"
    const playerBanBtn = "<div class='player_ban_btn ui_btn' data-action='ban'>" + i18n.t('Ban') + "</div>"
    const playerAddFriendBtn = "<div class='player_add_friend_btn ui_btn' data-action='add_friend'><img src='/assets/images/add_friend_icon.png' /></div>"
    const playerFriendRequestPending = "<div class='pending_friend_request_label'>" + i18n.t('Friend request sent') + "</div>"

    if (this.game.teamMenu.canKickMembers(this.getTeam(), this)) {
      actions += playerKickBtn
      actions += playerBanBtn
    }

    if (this.game.isLoggedIn() && this.isLoggedIn()) {
      if (this.isMyFriend() || this.isFriendRequestPending()) {
          // actions += playerFriendRequestPending
      } else {
        actions += playerAddFriendBtn
      }
    }

    entityMenu.querySelector(".entity_action").innerHTML = actions

    this.initPermissionSelect(entityMenu)
  }

  isLoggedIn() {
    return !this.uid.match("-")
  }

  isMyFriend() {
    return this.game.main.friends[this.uid]
  }

  isFriendRequestPending() {
    return this.game.main.sentFriendRequests[this.uid] ||
           this.game.main.receivedFriendRequests[this.uid]
  }

  initUsernameHeight() {
    this.setUsernameHeight(Constants.Player.height  - 10)
  }

  isInventoryFull() {
    return this.getInventoryCount() >= this.getMaxInventoryCount()
  }

  getInventoryCount() {
    return Object.keys(this.inventory).length
  }

  getMaxInventoryCount() {
    return this.getConstants().inventoryCount
  }

  onEffectAdded(effect) {
    super.onEffectAdded(effect)
    this.addStatus(effect)
  }

  addStatus(effect) {
    this.statusManager.addStatus(effect)

    if (this.shouldShowStatusList(effect)) {
      this.game.statusListMenu.addStatus(effect)
    }

    this.onStatusAdded(effect)
  }

  shouldShowStatusList(effect) {
    if (!this.isMe()) return false

    let effects = ["rage", "fear", "poison", "stamina", "paralyze", "drunk", "miasma"]
    return effects.indexOf(effect) !== -1
  }

  removeStatus(effect) {
    this.statusManager.removeStatus(effect)

    if (this.shouldShowStatusList(effect)) {
      this.game.statusListMenu.removeStatus(effect)
    }
  }

  onEffectRemoved(effect) {
    super.onEffectRemoved(effect)
    this.removeStatus(effect)

    this.onStatusRemoved(effect)
  }

  onStatusAdded(effect) {
    if (effect === 'drunk') {
      if (this.isMe()) {
        this.game.startScreenWarp()
      }
    }
  }

  onStatusRemoved(effect) {
    if (effect === 'drunk') {
      if (this.isMe()) {
        this.game.stopScreenWarp()
      }
    }
  }

  isUsingDismantler() {
    let item = this.getActiveItem()
    return item && item.type === Protocol.definition().BuildingType.Dismantler
  }

  initVariables(data) {
    this.isHoldingAttack = true
    this.isAttacking = false
    this.isSleeping = false
    this.inventory = {}
    this.equipments = {}
    this.visibleChunks = {}

    this.level = data.level
    this.health = data.health
    this.name = data.name

    this.clientJoinTime = Date.now()
  }

  isImmuneToKick() {
    return false
  }

  getSpriteContainer() {
    return this.game.sector.spriteLayers["players"]
  }

  setUsernameHeight(height) {
    // this.sprite.position.y = height
  }

  setTeam(team) {
    if (!team) return
      
    if (this.teamId !== team.id) {
      this.teamId = team.id
      this.onTeamChanged()
    }
  }

  isSameTeam(targetPlayer) {
    return this.teamId  === targetPlayer.teamId
  }

  getTeam() {
    return this.game.teams[this.teamId]
  }

  getName() {
    return this.name
  }

  onTeamChanged() {
    let team = this.getTeam()
    if (team) {
      let differentTeamName = team.name !== this.name
      let hasMultipleMembers = team.getMemberCount() > 1
      if (differentTeamName || hasMultipleMembers) {
        if (team.prefix === 'allow') {
          this.usernameText.sprite.text = "[" + team.name + "] " + this.name
        }
      } else {
        this.usernameText.sprite.text = this.name
      }
    } else {
      this.usernameText.sprite.text = this.name
    }

    if (this.game.teamMenu.isOpen()) {
      this.game.teamMenu.renderJoinableTeams()
    }
  }

  canChangeAngle() {
    return !this.isPilot && !this.isDestroyed() && !this.isWorking && !this.game.isScenePlaying
  }

  syncWithServer(data) {
    this.instructToMove(data.x , data.y)

    this.setPilotStatus(data.isPilot)
    this.setState(data)

    this.setUid(data.uid)
    this.setHealth(data.health)
    this.setLevel(data.level)
    this.setRelativePosition(data)
    this.setEquipments(data)
    this.setEffects(data.effects)
    this.setAttackState(data.isAttacking)
    this.setSleepState(data.isSleeping)
    this.setTeam(data.team)
    this.setDaysAlive(data.daysAlive)
    this.setIsAngleLocked(data.isAngleLocked)
    this.setDragTarget(data.dragTarget)
    this.setRoleType(data.roleType)
    this.setIsWorking(data.isWorking)
    this.setContainer(data.container)
    this.setMounted(data.mounted)
    this.setIsHidden(data.isHidden)
    this.setViewDistance(data.viewDistance)

    // set angle after equipments setup
    if (!this.isMe()) {
      // other players must see me rotate
      this.setAngleInterpolated(data.angle)
    } else {
      // rely on inputController to do client-side rotation for immediate feedback
    }

    if (this.isPilot || this.isWorking) {
      this.setAngleInterpolated(data.angle)
    }
    this.setShip(data.ship)
  }

  setDaysAlive(daysAlive) {
    let prevDaysAlive = this.daysAlive
    if (this.daysAlive !== daysAlive) {
      this.daysAlive = daysAlive
      this.onDaysAliveChanged(daysAlive)
    }
  }

  setIsAngleLocked(isAngleLocked) {
    this.isAngleLocked = isAngleLocked
  }

  setRoleType(roleType) {
    if (!this.sector.shouldShowPlayerList()) return

    if (this.roleType !== roleType) {
      this.roleType = roleType
      this.onRoleTypeChanged(roleType)
    }
  }

  setIsWorking(isWorking) {
    if (this.isWorking !== isWorking) {
      this.isWorking = isWorking
      this.onIsWorkingChanged(isWorking)
    }
  }

  onIsWorkingChanged(isWorking) {
    if (isWorking) {

    } else {

    }
  }

  setDragTarget(dragTarget) {
    let prevDragTargetId = this.dragTargetId

    if (dragTarget) {
      this.dragTargetId = dragTarget.id
    } else {
      this.dragTargetId = null
    }

    if (prevDragTargetId !== this.dragTargetId) {
      this.onDragTargetChanged()
    }
  }

  onDragTargetChanged() {
    if (this.isMe()) {
      this.sector.onSelectionChanged(this.sector.selection.selectedEntity)
    }
  }

  onRoleTypeChanged(roleType) {
    if (this.getTeam() && this.getTeam().prefix !== 'allow') {
      if (roleType === 0 ) {
        this.usernameText.sprite.text = "[guest] " + this.name
      } else {
        this.usernameText.sprite.text = this.name
      }
    }

    if (this.game.entityMenu.isOpen(this)) {
      this.game.entityMenu.update(this)
    }
  }

  onDaysAliveChanged(currDaysAlive) {
    // every 2 days
    if (currDaysAlive < 30 && currDaysAlive % 2 === 0) {
      if (debugMode) {
        console.log("production analytics will send day_passed event")
      } else {
        gtag('event', 'day_passed', { event_category: 'gameplay' })
      }
    }
  }

  isGuest() {
    return this.roleType === Protocol.definition().RoleType.Everyone
  }

  setAttackState(isAttacking) {
    if (this.isAttacking !== isAttacking) {
      this.isAttacking = isAttacking
      this.onAttackStateChanged()
    }
  }

  getTintableSprites() {
    let sprites = [this.body, this.hands]

    let armorEquipment = this.getArmorEquipment()
    if (armorEquipment) {
      sprites.push(armorEquipment.sprite)
    }

    return sprites
  }

  getFadeTween(sprite, start, end) {
    let opacity = { opacity: start }

    return new TWEEN.Tween(opacity)
        .to({ opacity: end }, 300)
        .onUpdate(() => {
          sprite.alpha = opacity.opacity
        })
        .onComplete(() => {
          opacity.opacity = start
        })
  }

  setPilotStatus(isPilot) {
    this.isPilot = isPilot
  }

  setUid(uid) {
    this.uid = uid
  }

  setRelativePosition(data) {
    if (data.relativeX !== this.relativeX || data.relativeY !== this.relativeY) {
      this.onRelativePositionChanged()
    }
    this.relativeX = data.relativeX
    this.relativeY = data.relativeY
  }

  onShipAssigned() {
    if (this.isMe()) {
      this.game.centerCameraTo(this.getCameraFocusTarget())
      this.setHangar(null)
    }
  }

  setContainer(container) {
    this.containerId = container.id
  }

  setMounted(mounted) {
    let prevMountedId = this.mountedId
    this.mountedId = mounted && mounted.id

    if (prevMountedId !== this.mountedId) {
      this.onMountedChanged(prevMountedId)
    }
  }

  setIsHidden(isHidden) {
    if (this.isHidden !== isHidden) {
      this.isHidden = isHidden

      if (this.isHidden) {
        this.sprite.alpha = 0
      } else {
        this.sprite.alpha = 1
      }
    }
  }

  setViewDistance(viewDistance) {
    if (this.viewDistance !== viewDistance) {
      this.viewDistance = viewDistance
      this.onViewDistanceChanged()
    }
  }

  onViewDistanceChanged() {
    if (this.isSpectating()) return
    if (!this.isMe()) return
    this.sector.lightManager.applyFov()
  }

  getMount() {
    if (!this.mountedId) return null

    return this.sector.getEntity(this.mountedId)
  }

  onMountedChanged(prevMountedId) {
    if (this.mountedId) {
      let origSprite = this.sprite
      this.sprite.parent.removeChild(this.sprite)
      this.sector.spriteLayers['units'].addChild(origSprite)
      // player entity might loaded first in client before mob
      setTimeout(() => {
        if (this.getMount() && this.getMount().usernameText) {
          this.getMount().usernameText.sprite.alpha = 0
        }
      }, 1000)
    } else {
      let origSprite = this.sprite
      this.sprite.parent.removeChild(this.sprite)
      this.sector.spriteLayers['players'].addChild(origSprite)
      setTimeout(() => {
        let prevMount = this.sector.getEntity(prevMountedId)
        if (prevMount && prevMount.usernameText) {
          prevMount.usernameText.sprite.alpha = 1
        }
      }, 1000)
    }

    this.game.setDefaultMobileAction()
  }

  setShip(ship) {
    if (ship) {
      if (this.shipId === ship.id) return
      if (this.sector.ships[ship.id]) {
        this.shipId = ship.id

        this.ship = this.sector.ships[ship.id]
        this.ship.pilot = this
        this.onShipAssigned()
      }
    } else {
      this.shipId = null
      this.ship = null
    }
  }

  setEquipments(data) {
    for (let slotIndex in this.equipments) {
      slotIndex = parseInt(slotIndex)
      let isEquipmentStillPresentOnServer = false

      for (let index in data.equipments.storage) {
        let equipment = data.equipments.storage[index]
        let sameSlotIndex = slotIndex === equipment.index
        let sameEquipmentId = this.equipments[slotIndex].id === equipment.id
        if (sameSlotIndex && sameEquipmentId) {
          isEquipmentStillPresentOnServer = true
        }
      }

      if (!isEquipmentStillPresentOnServer) {
        this.removeEquipment({ index: slotIndex })
      }
    }

    for (let index in data.equipments.storage) {
      let equipment = data.equipments.storage[index]
      this.renderEquipment(equipment)
    }
  }


  removeEquipment(data) {
    const index = data.index

    // remove UI slot
    if (this.isMe()) {
      const equipmentSlot = document.querySelector(".equipment_slot[data-index='" + index  + "']")
      if (equipmentSlot) {
        this.game.resetInventorySlot(equipmentSlot)
      }
    }

    // remove equipment
    const equipment = this.equipments[index]
    if (equipment) {
      delete this.equipments[index]
      equipment.remove()
      this.openHands() // reset hand position
    }

  }

  renderEquipment(data) {
    const index = data.index

    let existingEquipment = this.equipments[index]

    // equipment slot changed
    if (existingEquipment) {
      let isSameEquipment = data.id === existingEquipment.id
      if (isSameEquipment) {
        existingEquipment.syncWithServer(data)
      } else {
        existingEquipment.remove()
        existingEquipment = null
      }
    }

    // dont convert to else if (existingEquipment can become null above)
    if (!existingEquipment) {
      // init equipment
      data.user = this
      this.equipments[index] = Item.getKlass(data.type).build(this.game, data)
      this.equipments[index].onPostEquip()

      // render UI slot
      if (this.isMe()) {
        const equipmentSlot = document.querySelector(".equipment_slot[data-index='" + index  + "']")
        if (equipmentSlot) {
          this.game.renderInventorySlot(equipmentSlot, data)
        }
      }
    }
  }

  setAngle(angle) {
    if (this.isAngleLocked) return
    this.angle = angle
    this.characterSprite.rotation = this.getRadAngle()
  }

  getEffectableSprite() {
    return this.characterSprite
  }

  setAngleInterpolated(angle) {
    this.angle = angle
    this.instructToRotate(this.getRadAngle())
  }

  onLevelIncreased() {
  }

  setDirection(data) {
    if (data.direction === 0) return // we only care if its facing left/right

    const prevDirection = this.direction
    this.direction = data.direction

    const isDirectionChanged = prevDirection !== this.direction

    if (isDirectionChanged && this.direction !== 0) {
      this.setCharacterOrientation(this.direction)
      this.stopMine()
    }
  }

  setCharacterOrientation(direction) {
    const characterSpriteIndex = 0
    this.sprite.children[characterSpriteIndex].scale.x = direction
  }

  getTypeName() {
    return "Player"
  }

  getWidth() {
    return 40
  }

  getHeight() {
    return 40
  }

  setState(data) {
    const prevInvulnerable = this.isInvulnerable
    this.isInvulnerable = data.isInvulnerable

    const becameInvulnerable = prevInvulnerable !== this.isInvulnerable && this.isInvulnerable
    const becameVulnerable   = prevInvulnerable !== this.isInvulnerable && !this.isInvulnerable

    if (becameInvulnerable) {
      // this.setAlpha(0.5)
    } else if (becameVulnerable) {
    }
  }

  getDamagedTween() {
    let opacity = { opacity: 0.5 }

    const fadeOutTween = new TWEEN.Tween(opacity)
        .to({ opacity: 0.2 }, 100)
        .easing(TWEEN.Easing.Quadratic.Out)
        .onUpdate(() => {
          this.characterSprite.alpha = opacity.opacity
        })
        .onComplete(() => {
          this.characterSprite.alpha = 1
        })
        .repeat(10)
        .yoyo(true)

    return fadeOutTween
  }

  isMe() {
    return this.id === this.game.playerId
  }

  isDead() {
    return typeof this.sector.players[this.id] === "undefined"
  }

  hide() {
    this.sprite.alpha = 0
  }

  show() {
    this.sprite.alpha = 1
  }

  getSprite() {
    this.usernameSprite  = this.getUsernameSprite()

    this.characterSprite  = this.getCharacterSprite()
    this.characterSprite.alpha = 1
    Interpolator.mixin(this.characterSprite)

    this.sleepStatusContainer = new PIXI.Container()
    this.sleepStatusContainer.name = "SleepStatus"

    const sprite = new PIXI.Container()
    sprite.name = "Player"

    sprite.addChild(this.characterSprite)
    sprite.addChild(this.usernameSprite)
    sprite.addChild(this.sleepStatusContainer)

    return sprite
  }

  onNoPositionAvailable() {
  }

  getUsername() {
    return this.data.name
  }

  equipItem(item) {
    this.characterSprite.removeChild(this.weaponSprite)
    this.weaponSprite    = this.getWeaponSprite()
    this.characterSprite.addChild(this.weaponSprite)
  }

  getWeapon() {
    return this.equipments[Protocol.definition().EquipmentRole.Hand]
  }

  getWeaponSprite(x, y) {
    const sprite = new PIXI.Sprite(PIXI.utils.TextureCache[this.getWeaponSpritePath()])

    sprite.anchor.set(-1)
    sprite.position.y = 15
    sprite.position.x = 0
    sprite.pivot.x = 0 //-Constants.Player.width / 2
    sprite.pivot.y = 0 //Constants.Player.height / 2

    return sprite
  }

  getRotatedAngle() {
    return this.getRadAngle()
  }

  getBuildOwnerId() {
    if (this.getTeam()) return this.getTeam().getId()
      
    return this.getId()
  }

  getUsernameSprite() {
    const margin = this.getHeight()

    const container = new PIXI.Container()
    container.position.y = margin
    container.name = "UsernameContainer"

    this.usernameText = BitmapText.create({ 
      label: "UsernameText",
      text: this.getUsername(), 
      align: 'center',
      spriteContainer: container
    })

    return container
  }

  getCollisionGroup() {
    return Constants.collisionGroup.Player
  }

  getWeaponSpritePath() {
    return "blaster.png"
  }

  canAct() {
    return (new Date()).getTime() - this.lastActionTime > 200
  }

  getActiveItem() {
    return this.inventory[this.equipIndex]
  }

  hasMiningEquipment() {
    const itemData = this.getActiveItem()
    return Item.isMiningEquipment(itemData)
  }

  startMining(resource) {
    this.lastActionTime = (new Date()).getTime()

    SocketUtil.emit("StartMining", { id: resource.id })
  }

  hasMineTarget() {
    return this.hasMiningEquipment() && this.mineTarget
  }

  isMining() {
    return this.isMiningMode
  }

  toggleMiningMode() {
    this.setMiningMode(!this.isMining())
  }

  setMiningMode(isMiningMode) {
    if (this.isMiningMode !== isMiningMode) {
      this.isMiningMode = isMiningMode
      this.onMiningModeChanged(isMiningMode)
    }
  }

  onMiningModeChanged(isMiningMode) {
    if (isMiningMode) {
      // this.game.playSound("rock_grind", { loop: true })
    } else {
      // this.game.stopSound("rock_grind")
    }
  }

  setMineTarget(resource) {
    this.mineTarget = resource
  }

  getTintableSprite() {
    return this.body
  }

  interpolate(lastFrameTime) {
    this.interpolatePlayerCustom(lastFrameTime)
    this.update()
  }

  update() {
    this.statusManager.update()
  }

  getRotatableSprite() {
    return this.characterSprite
  }

  interpolatePlayerCustom(lastFrameTime) {
    const prev = { x: this.sprite.position.x, y: this.sprite.position.y }

    const prevGrid = { row: this.getRow(), col: this.getCol() }

    super.interpolate(lastFrameTime)
    const curr = { x: this.sprite.position.x, y: this.sprite.position.y }

    const currGrid = { row: this.getRow(), col: this.getCol() }

    if (curr.x !== prev.x || curr.y !== prev.y) {
      let isGridPositionChanged = currGrid.row !== prevGrid.row || currGrid.col !== prevGrid.col

      this.onPositionChanged({ isGridPositionChanged: isGridPositionChanged })
    }


    if (this.isCameraMode) {
      this.getCamera().interpolate(lastFrameTime)
    }
  }

  onRelativePositionChanged() {
    this.onPositionChanged()
  }

  executeTurn() {
    const isThreeSecondInterval = this.game.timestamp % (Constants.physicsTimeStep * 3) === 0
    if (!isThreeSecondInterval) return

    this.checkFirePrescence()
  }

  onPositionChanged(options = {}) {
    const armor = this.getArmorEquipment()
    if (armor) {
      armor.animate(this)
    }

    let platform = this.getStandingPlatform()
    if (platform) {
      platform.animateWalk(this)
    }

    if (this.hangar) {
      this.sector.repositionFadeBlackSprite()
    }
    
    this.registerToChunk()

    this.repositionOnUnitMap()

    if (this.isMe()) {
      if (this.sector.isFovMode()) {
        this.game.mapMenu.setMapPosition(this, Protocol.definition().EntityType.Player)  
        this.game.mapMenu.redrawEntityMap()
      }

      this.highlightNearbyEntities()
      this.redrawVisionLightSprite()
      this.updateSelectedEntity()

      if (options.isGridPositionChanged) {
        this.game.mapMenu.repositionTo(this)
        this.game.miniMapMenu.displayPosition(this)

        if (this.isSpectating()) {

        } else {
          this.sector.lightManager.applyFov()
        }
      }

      this.cullChunks()

      if (!this.game.isMobile()) {
        // for mobile we dont want to trigger any mouseover events
        // and we cant rely on app.renderer.plugins.interaction.mouse.global anyway on mobile
        this.triggerEntityMouseEvents()
      }
    }
  }

  recalculateFovIfHitPresent(hits) {
    if (!this.sector.isFovMode()) return
    if (this.isSpectating() && this.isMe()) return

      
    for (var i = 0; i < hits.length; i++) {
      let hit = hits[i]
      if (this.isTileVisible(hit.row, hit.col)) {
        this.sector.lightManager.applyFov()
        break
      }
    }
  }

  isTileVisible(row, col) {
    let tileKey = [row, col].join("-")
    return this.sector.lightManager.fovTileHits[tileKey]
  }

  updateSelectedEntity() {
    if (!this.game.entityMenu.selectedEntity) return

    let distanceFromSelectedEntity = this.game.distanceBetween(this.game.entityMenu.selectedEntity, this)
    if (distanceFromSelectedEntity > Constants.tileSize * 10) {
      this.game.resetEntitySelection()  
    }
  }

  triggerEntityMouseEvents() {
    if (this.containerId > 1) return // im riding on tram

    if (this.game.inputController) {
      this.game.inputController.triggerEntityMouseEvents()
    }
  }

  getChunk() {
    return this.sector.getChunk(this.getChunkRow(), this.getChunkCol())
  }

  cullChunks() {
    let visibleChunks = this.getVisibleChunks()
    // get chunks no longer visible
    for (let chunkId in this.visibleChunks) {
      let prevChunk = this.visibleChunks[chunkId]
      let isPrevChunkStillVisible = visibleChunks[chunkId]
      if (!isPrevChunkStillVisible) {
        prevChunk.hide()
      }
    }

    // get new visible chunks
    for (let chunkId in visibleChunks) {
      let chunk = visibleChunks[chunkId]
      let isChunkNewlyVisible = !this.visibleChunks[chunkId]
      if (isChunkNewlyVisible) {
        chunk.show()
      }
    }

    this.visibleChunks = visibleChunks
  }

  getGridViewport() {
    let viewport = {}

    let box = this.getCameraBoundingBox()
    viewport.minCol = Math.floor(box.minX / Constants.tileSize)
    viewport.maxCol = Math.floor(box.maxX / Constants.tileSize)
    viewport.minRow = Math.floor(box.minY / Constants.tileSize)
    viewport.maxRow = Math.floor(box.minY / Constants.tileSize)

    return viewport
  }

  redrawVisionLightSprite() {
    if (this.visionLightSprite) {
      // adjust position
      this.visionLightSprite.position.x = this.getX()
      this.visionLightSprite.position.y = this.getY()

      // apply occlusion (walls block light)
    }
  }

  highlightNearbyEntities() {
    if (!this.game.player) return // player not initialized yet

    if (!this.hasMouseTarget()) {
      this.checkInteractable(this)
    }
  }

  setMouseTarget(entity) {
    this.mouseTarget = entity
  }

  hasMouseTarget() {
    return !!this.mouseTarget
  }

  checkFirePrescence() {
    let padding = Constants.tileSize * 16
    let box = this.getPaddedRelativeBox(padding)

    let boundingBox = {
      minX: box.pos.x,
      maxX: box.pos.x + box.w,
      minY: box.pos.y        ,
      maxY: box.pos.y + box.h
    }

    let structures = this.getContainer().structureMap.search(boundingBox)
    let units = this.getContainer().unitMap.searchCollection(boundingBox)
    let hasStructureOnFire = structures.find((structure) => {
      return structure.isOnFire()
    })

    let hasUnitOnFire = units.find((unit) => {
      return unit.isOnFire()
    })

    if (hasStructureOnFire || hasUnitOnFire) {
      this.setHasDetectedFire(true)
    } else {
      this.setHasDetectedFire(false)
    }
  }

  setHasDetectedFire(hasDetectedFire) {
    if (this.hasDetectedFire !== hasDetectedFire) {
      this.hasDetectedFire = hasDetectedFire
      this.onHasDetectedFireChanged()
    }

  }

  onHasDetectedFireChanged() {
    if (this.hasDetectedFire) {
      if (!this.game.isSoundAlreadyPlaying("burning")) {
        this.game.playSound("burning", { loop: true })
      }
    } else {
      if (this.game.isSoundAlreadyPlaying("burning")) {
        this.game.stopSound("burning")
      }

    }
  }

  checkInteractable(entity) {
    let padding = 12
    let relativeBox = entity.getPaddedRelativeBox(padding)

    // account for direction player is facing
    const xp = Constants.tileSize * Math.cos(this.getRadAngle())
    const yp = Constants.tileSize * Math.sin(this.getRadAngle())

    const interactableCenter = { x: this.getX() + xp, y: this.getY() + yp }

    let checkFullBox = true
    const structureHits = this.getContainer().structureMap.hitTestTile(relativeBox, checkFullBox)
    const distributionHits = this.getContainer().distributionMap.hitTestTile(relativeBox, checkFullBox)
    const unitHits      = this.getContainer().unitMap.hitTestTileCollection(relativeBox, checkFullBox)
    const corpseHits      = this.getContainer().corpseMap.hitTestTileCollection(relativeBox, checkFullBox)
    const hits = structureHits.concat(unitHits).concat(corpseHits).concat(distributionHits)

    let closestHit = hits.filter((hit) => {
      let isNotSelf = hit.entity !== entity
      let isNotDragTarget = hit.entity.id !== this.dragTargetId
      return hit.entity && isNotSelf && hit.entity.isInteractable() && isNotDragTarget
    }).sort((a, b) => {
      let distanceA =  this.game.distance(interactableCenter.x, interactableCenter.y, a.entity.getX(), a.entity.getY())
      let distanceB =  this.game.distance(interactableCenter.x, interactableCenter.y, b.entity.getX(), b.entity.getY())
      return distanceA - distanceB
    })[0]

    if (closestHit && this.dragTargetId) {
      let isDragTargetStorage = closestHit.entity.hasCategory("drag_target_storage")
      if (isDragTargetStorage) {
        this.onInteractableFound(closestHit.entity)  
      }
    } else if (closestHit) {
      this.onInteractableFound(closestHit.entity)  
    } else if (this.dragTargetId) {
      let dragTarget = this.game.sector.getEntity(this.dragTargetId)
      if (dragTarget) {
        this.onInteractableFound(dragTarget)  
      }
    } else {
      if (this.dragTargetId) return
      let highlightedEntity = this.game.getHighlightedEntity()
      if (highlightedEntity && !Helper.isTargetWithinWalkRange(this, highlightedEntity)) {
        this.onInteractableOutOfRange(highlightedEntity)
      }
    }
  }

  isInteractable() {
    if (this.isControllingGhost()) {
      let isSelf = this.id === this.game.player.id
      return isSelf && !this.isDestroyed() // can only possses my own living body if its alive
    } else {
      return this.isDestroyed()
    }
  }

  onInteractableFound(entity) {
    // dont proceed if already selecting something else
    if (this.game.sector.persistentSelection.isShown()) return

    this.game.highlight(entity)
    this.game.showEntityMenu(entity)
  }

  onInteractableOutOfRange(entity) {
    if (entity && !entity.hasMouseOver()) {
      this.game.unhighlight(entity)
      this.game.hideEntityMenu(entity)
    }
  }

  setHangar(hangar) {
    const prevHangar = hangar
    if (this.hangar !== hangar) {
      this.hangar = hangar
      this.onHangarChanged(prevHangar)
    }
  }

  onHangarChanged(prevHangar) {
    if (this.hangar) {
      let shipId = this.hangar.content
      let ship = this.sector.ships[shipId]
      if (ship) {
        this.setActiveBuildingContainer(ship)
        this.sector.showHangarBackgroundSprite(this.hangar)
        this.sector.showHangarFadeBlackSprite()
      }
    } else {
      this.setActiveBuildingContainer(this.sector)
      this.sector.hideHangarBackgroundSprite()
      this.sector.hideHangarFadeBlackSprite()
    }
  }

  isPlayer() {
    return true
  }

  setPositionFromParent() {

  }

  getGroup() {
    return "players"
  }

  remove() {
    super.remove()
    this.removeFromUnitMap()

    if (this.usernameText) {
      this.usernameText.remove()
    }

    this.getContainer().unregisterEntity("players", this)

    if (this.chunk) {
      this.chunk.unregister("players", this)
    }

    if (this.game.entityMenu.isOpen(this)) {
      this.game.entityMenu.removeSelectedEntity()
    }

    this.statusManager.cleanup()

    if (this.handAnimationTween) {
      this.handAnimationTween.stop()
    }

    if (this.sleepTween) {
      this.sleepTween.stop()
    }

    if (this.damagedTween) {
      this.damagedTween.stop()
    }

  }

  stopBuilding() {
    if (this.isBuilding()) {
      this.requestEquipChange(-1)
    }
  }

  requestEquipChange(index) {
    SocketUtil.emit("ChangeEquip", { index: index })
  }

  isControllingPlayer() {
    return this.cameraFocusTarget instanceof Player
  }

  getRequirementInventorySupply(klass) {
    let type = klass.getType()
    let supply = 0

    for (let index in this.inventory) {
      let itemData = this.inventory[index]
      if (itemData && itemData.type === type) {
        supply += itemData.count
      }
    }

    return supply
  }


  changeEquip(index) {
    this.equipIndex = index

    const absoluteIndex = index

    const itemData = this.inventory[absoluteIndex]
    if (!itemData) {
      this.resetBuildMode()
      return
    }

    const klass = Item.getKlass(itemData.type)
    const klassType = Item.getKlassType(itemData.type)

    if (klassType === "building" || klassType === "terrain") {
      const pos = game.app.renderer.plugins.interaction.mouse.global
      this.enterBuildMode(klass, pos)
    } else {
      this.resetBuildMode()
    }
  }

  reEquipIndex(index) {
    const itemData = this.inventory[index]
    if (itemData) {
      const klass = Item.getKlass(itemData.type)
      const klassType = Item.getKlassType(itemData.type)

      if (klassType === "building") {
        const pos = game.app.renderer.plugins.interaction.mouse.global
        this.enterBuildMode(klass, pos)
      }
    }
  }

  enterBuildMode(buildingKlass, position) {
    let isSameBuilding = this.building && this.building.getType() === buildingKlass.getType()
    if (isSameBuilding) return

    this.resetBuildMode()
    this.game.closeEntityMenu()

    const container = this.getActiveBuildingContainer()

    const data = {
      x: container.getSnappedPosX(position.x, buildingKlass.getConstants().width),
      y: container.getSnappedPosY(position.y, buildingKlass.getConstants().height),
      container: container,
      isEquipDisplay: true
    }

    const building = new buildingKlass(this.game, data)
    this.building  = building
    this.building.onBuildStart()

    this.game.colorPickerMenu.applyBuildingTint(building)

    building.renderAtMousePosition(position.x, position.y)
  }

  getActiveBuildingContainer() {
    return this.buildingContainer
  }

  setActiveBuildingContainer(container) {
    this.buildingContainer = container
  }

  getStandingRegion() {
    return this.getContainer().getRegion(this.getX(), this.getY())
  }

  getContainer() {
    return this.ship || this.sector
  }

  resetBuildMode() {
    const container = this.getActiveBuildingContainer()

    if (this.building) {
      this.sector.invalidAreaSprite.alpha = 0
      this.sector.removeEntity(this.building, this.building.getGroup())
      this.building.onBuildStop()
      this.building = null
    }
  }

  getVisibleChunksList() {
    return Object.values(this.getVisibleChunks())
  }

  getScreenWidth() {
    return this.game.getScreenWidth()
  }

  getScreenHeight() {
    return this.game.getScreenHeight()
  }

  isBuildingPositionValid(buildContainer, building, gridCoord) {
    return building.constructor.isPositionValid(buildContainer,
                                                   gridCoord.x,
                                                   gridCoord.y,
                                                   building.getRotatedWidth(),
                                                   building.getRotatedHeight(),
                                                   building.getAngle(),
                                                   this,
                                                   building.getType(),
                                                   building)
  }

  getRole() {
    return this.game.roles[this.roleType]
  }

  getRolePermissions() {
    if (!this.getRole()) return {}
    return this.getRole().permissions
  }

  isSameBuildingRequest(data) {
    if (!this.buildingRequestData) return false

    return data.type == this.buildingRequestData.type &&
           data.x == this.buildingRequestData.x &&
           data.y == this.buildingRequestData.y &&
           data.containerId == this.buildingRequestData.containerId
  }

  performAction() {
    if (!this.isControllingPlayer()) return

    if (this.isBuilding()) {
      this.placeBuilding()
    } else if (this.hasUsableEquip() && this.canAct()) {
      this.act()
    }
  }

  placeBuilding() {
    const buildContainer = this.getActiveBuildingContainer()
    const gridCoord = buildContainer.getGridCoord(this.building.getX(), this.building.getY())

    let buildingRequestData = {
      type: this.building.getType(),
      angle: this.building.getAngle(),
      x: gridCoord.x,
      y: gridCoord.y,
      containerId: buildContainer.id
    }

    if (this.isSameBuildingRequest(buildingRequestData)) return
    if (!this.isBuildingPositionValid(buildContainer, this.building, gridCoord)) return

    this.game.playSound("place_object")
    this.buildingRequestData = buildingRequestData

    clearTimeout(this.clearBuildRequestData)
    this.clearBuildRequestData = setTimeout(() => {
      this.buildingRequestData = null
    }, 2000)

    SocketUtil.emit("Build", buildingRequestData)
  }

  hasUsableEquip() {
    const itemData = this.getActiveItem()
    if (!itemData) return true // bare hands

    return Item.isUsableEquipment(itemData)
  }

  mine() {
    if (!this.hasMineTarget()) {
      this.setMiningMode(false)
      return
    }

    this.lastActionTime = (new Date()).getTime()
    SocketUtil.emit("MineResource", { row: this.mineTarget.row, col: this.mineTarget.col })
  }

  act() {
    if (this.hasEffect("spin")) return
    this.lastActionTime = (new Date()).getTime()

    let data = this.actTarget ? { targetEntityId: this.actTarget.id }  : {}
    if (this.hasThrowDestination()) {
      let mousePos = this.game.inputController.getGlobalMousePos()
      data['targetX'] = mousePos.x
      data['targetY'] = mousePos.y
    }
    SocketUtil.emit("Act", data)
  }

  hasThrowDestination() {
    let item = this.getActiveItem()
    return item && Item.hasThrowDestination(item.type)
  }

  setActTarget(entity) {
    this.actTarget = entity
  }

  getActTarget() {
    return this.actTarget
  }

  getCamera() {
    if (!this.camera) {
      this.camera = new Camera()
      Interpolator.mixin(this.camera)
    }

    return this.camera
  }

  setCamera(camera) {
    let isCameraMode = !!camera

    if (this.isCameraMode !== isCameraMode) {
      this.isCameraMode = isCameraMode
      this.onCameraModeChanged(camera)
    }

    if (isCameraMode) {
      this.getCamera().instructToMove(camera.x, camera.y)
    }
  }

  onCameraModeChanged(camera) {
    if (this.isCameraMode) {
      this.setCameraFocusTarget(this.getCamera())
      console.log("onCameraModeChanged..tocamera")
      this.getCamera().position.x = camera.x
      this.getCamera().position.y = camera.y
      this.game.centerCameraTo(this.getCamera())
    } else {
      this.setCameraFocusTarget(this)
      this.game.centerCameraTo(this)
    }
  }

  isControllingGhost() {
    return this.getCameraFocusTarget() instanceof Mobs.Ghost
  }

  isControllingMob() {
    return !this.isControllingPlayer() && !this.isControllingGhost()
  }

  getCameraFocusTarget() {
    return this.cameraFocusTarget
  }

  setCameraFocusTarget(target) {
    this.cameraFocusTarget = target
    this.onCameraFocusTargetChanged()
  }

  onCameraFocusTargetChanged() {
    if (this.isControllingPlayer()) {
      this.game.showPlayerHud()
    } else {
      this.game.hidePlayerHud()
    }

    this.cullChunks()

    if (this.isMe() && this.sector.isFovMode()) {
      if (this.shouldSkipFov()) {
        this.sector.lightManager.removeFov()
        this.sector.removeFovMaskFromLight()
      } else {
        this.sector.lightManager.applyFov()
        this.sector.applyFovMaskToLight()
      }
    }
  }

  shouldSkipFov() {
    if (this.isSpectating()) return true
    if (this.game.securityCameraMenu.isOpen()) return true
    return false
  }

  isSpectating() {
    return this.sector.isMiniGame() && this.health === 0
  }

  renderDeadBody() {
    this.addDizzyEyes(this.characterSprite)
    this.dizzySprite.anchor.set(0)
    this.dizzySprite.rotation = Math.PI/2
    this.dizzySprite.tint = 0x000000
    this.dizzySprite.width = 24
    this.dizzySprite.height = 8
    this.dizzySprite.position.x = 30
    this.dizzySprite.position.y = 8

    this.hideEquipments()
  }

  canBuildInRegion(buildFlag) {
    if (buildFlag === 'everyone') return true

    let isTeamRestricted = this.game.teams[buildFlag]
    let isRoleRestricted = this.game.getRoleByName(buildFlag)

    if (isTeamRestricted) {
      if (!this.getTeam()) return false
      return this.getTeam().name === buildFlag
    }

    if (isRoleRestricted) {
      if (!this.getRole()) return false
      return this.getRole().name === buildFlag
    }

    // username restricted
    return this.name === buildFlag 
  }

  hideEquipments() {
    for (let index in this.equipments) {
      let equipment = this.equipments[index]
      equipment.sprite.alpha = 0
    }    
  }

  showEquipments() {
    for (let index in this.equipments) {
      let equipment = this.equipments[index]
      equipment.sprite.alpha = 1
    }    
  }

  isBuilding() {
    return this.building
  }

  getMissingResources(cost) {
    let missing = {}

    const requirements = cost
    for (let resourceName in requirements) {
      let value = requirements[resourceName]
      if (this[resourceName] < value) {
        missing[resourceName] = true
      }
    }

    return missing
  }

  notifyLowStatus(stat) {
    if (this.isLowStatus(stat)) {
      this.addStatus(stat)
    } else {
      this.removeStatus(stat)
    }
  }

  getMaxViewDistance() {
    return this.viewDistance || Constants.fovViewDistance
  }

  displayLowStatusWarning(stat) {
    switch(stat) {
      case "oxygen":
        this.game.displayError("You are running out of oxygen")
        break
      case "hunger":
        this.game.displayError("You are feeling hungry")
        break
      case "thirst":
        this.game.displayError("You are feeling thirsty")
        break
      case "stamina":
        this.game.displayError("You are tired and restless")
        break
      default:
    }
  }

  getOxygen() {
    const armor = this.getArmorEquipment()
    if (armor && typeof armor.hasOxygen === 'function' && armor.hasOxygen()) {
      return armor.oxygen
    } else {
      return this.oxygen
    }
  }

}

Object.assign(Player.prototype, Upgradable.prototype)
Object.assign(Player.prototype, PlayerCommon.prototype, {
  onGoldChanged(delta) {
    if (!this.isMe()) return

    this.game.updateGoldCount(this.gold, delta)
  }
})

Object.assign(Player.prototype, Destroyable.prototype, {
  onHealthReduced(delta) {
    if (this.health === 0) return

    this.healthBar.showDamageTaken(delta)
    this.animateDamage()

    if (this.damagedTween) this.damagedTween.stop()
    this.damagedTween = this.getDamagedTween()
    this.damagedTween.start()
  },
  onHealthIncreased(delta) {
    this.healthBar.showHealthIncreased(delta)

    const isIncreasedFromZero = this.health === delta
    if (isIncreasedFromZero) {
      this.resurrectBody()
      this.showEquipments()
    }
  },
  onHealthZero() {
    if (this.game.securityCameraMenu.isOpen() && this.isMe()) {
      this.game.securityCameraMenu.close()
    }

    this.renderDeadBody()
    if (this.sector.originalPlayers[this.getId()]) {
      this.sector.originalPlayers[this.getId()].health = 0
    }
  },
  onPostSetHealth() {
    if (this.isMe()) {
      this.game.updateHealthBar(this.health, this.getMaxHealth())
    }

    if (this.sector.originalPlayers[this.getId()]) {
      this.sector.originalPlayers[this.getId()].health = this.health
    }

    if (this.health > 0 && !this.sprite.visible) {
      // respawned
      this.sprite.visible = true
      this.game.hideDeathMessage()
    }

    if (this.game.entityMenu.isOpen(this)) {
      this.game.entityMenu.update(this)
    }
  },
  getMaxHealth() {
    if (this.game.sector.entityCustomStats[this.id]) {
      return this.game.sector.entityCustomStats[this.id].health
    }
    
    return 100
  }

})

Object.assign(Player.prototype, Equipper.prototype, {
  getDefaultSpriteColor() {
    if (this.effects && this.hasEffect("poison") && this.getEffectInstance("poison")) {
      return this.getEffectInstance("poison").getTint()
    }

    return 0xd2b48c
  },
  getBodySpriteTint() {
    return 0xd2b48c
  }
})

Object.assign(Player.prototype, ShipMountable.prototype, {
  getRelativeX() {
    return this.sprite.position.x
  },
  getRelativeY() {
    return this.sprite.position.y
  }
})


Object.assign(Player.prototype, Needs.prototype, {
  onOxygenChanged() {
    if (!this.isMe()) return

    this.game.updateOxygenBar(this.getOxygen(), this.getMaxOxygen())
    this.notifyLowStatus("oxygen")
  },
  getMaxStamina() {
    if (this.game.isPvP()) return 300
    return Constants.Player.stamina
  },
  getMaxOxygen() {
    const armor = this.getArmorEquipment()
    if (armor && typeof armor.hasOxygen === 'function' && armor.hasOxygen()) {
      return armor.getMaxOxygen()
    } else {
      return this.getConstants().oxygen
    }
  },
  onStaminaChanged() {
    if (!this.isMe()) return

    if (!this.sector.settings['isStaminaEnabled']) return

    this.game.updateStaminaBar(this.stamina, this.getMaxStamina())
    this.notifyLowStatus("stamina")
  },
  onHungerChanged(delta) {
    if (!this.isMe()) return

    if (!this.sector.settings['isHungerEnabled']) return

    let isHungerDecreased = delta > 0
    if (isHungerDecreased) {
      this.animateHungerDecreased(delta)
    }

    this.game.updateHungerBar(this.hunger, this.getMaxHunger())
    this.notifyLowStatus("hunger")
  },
  onSleepStateChanged() {
    if (this.isSleeping) {
      this.showSleepAnimation()
    } else {
      this.hideSleepAnimation()
    }
  }

})

module.exports = Player

},{"../util/bitmap_text":648,"./../../../common/constants.json":656,"./../../../common/entities/player_common":661,"./../../../common/helper":664,"./../../../common/interfaces/destroyable":670,"./../../../common/interfaces/equipper":672,"./../../../common/interfaces/needs":674,"./../../../common/interfaces/ship_mountable":678,"./../../../common/interfaces/upgradable":681,"./../../../common/util/protocol":686,"./../components/health_bar":181,"./../util/interpolator":652,"./../util/socket_util":654,"./../util/sprite_event_handler":655,"./base_entity":206,"./buildings/index":250,"./camera":329,"./equipments/index":407,"./item":443,"./mobs/index":464,"./ship":546,"./status_manager":549,"tinycolor2":172}],514:[function(require,module,exports){
const BaseProjectile = require("./base_projectile")
const Constants = require("./../../../../common/constants.json")
const Protocol = require("./../../../../common/util/protocol")

class AcidSpit extends BaseProjectile {

  getSpritePath() {
    return 'acid_spit.png'
  }

  getType() {
    return Protocol.definition().ProjectileType.AcidSpit
  }

  getConstantsTable() {
    return "Projectiles.AcidSpit"
  }

}

module.exports = AcidSpit

},{"./../../../../common/constants.json":656,"./../../../../common/util/protocol":686,"./base_projectile":515}],515:[function(require,module,exports){
const BaseEntity  = require("./../base_entity")
const Constants = require("./../../../../common/constants.json")
const Protocol = require("./../../../../common/util/protocol")
const Helper = require("./../../../../common/helper")
const Poolable = require("../../../../common/interfaces/poolable")
const ObjectPool = require("../../../../common/entities/object_pool")

class BaseProjectile extends BaseEntity {
  static create(game, data) {
    let projectileName = Helper.getProjectileNameById(data.type)
    let projectile = ObjectPool.obtain(projectileName, game, data)

    projectile.setEntityAttributes(game, data)
    projectile.setAttributes(data)
    projectile.interpolator.reset()
    projectile.onProjectileConstructed()

    return projectile
  }

  constructor(game, data) {
    super(game, data)

    this.reset()
  }

  setAttributes(data) {
    this.angle = data.angle
    this.sprite.rotation = this.getRadAngle()
    this.sprite.visible = true
  }

  onProjectileConstructed() {
  }

  shouldRemoveImmediately() {
    return false
  }

  markForRemoval() {
    this.shouldRemove = true
  }

  onNoPositionAvailable() {
  }

  getSpriteContainer() {
    return this.game.sector.spriteLayers["projectiles"]
  }

  onPostRemoved() {
    // were sure thats its removed..

  }

  interpolate(lastFrameTime) {
    if (this.shouldRemove) {
      if (this.interpolator.hasCoveredDistance()) {
        this.performRemove()
        this.onPostRemoved()
        return
      }
    }

    if (this.hasCategory("distance_dependent_width")) {
      let distance = Helper.distance(0, 0, this.interpolator.distanceCoveredThisFrame.x, this.interpolator.distanceCoveredThisFrame.y)
      let width = (distance / 10) * this.getDisplayWidth()
      this.sprite.width = Math.max(width, 16)
    }

    super.interpolate(lastFrameTime)
  }

  syncWithServer(data) {
    // console.log("move projectile: " + data.id + " " + [data.x, data.y].join(","))
    this.instructToMove(data.x, data.y)
    this.onPositionChanged()

    this.angle = data.angle
    this.instructToRotate(this.getRadAngle())
  }

  getGroup() {
    return "projectiles"
  }

  onPositionChanged() {
    this.registerToChunk()
  }

  isFastProjectile() {
    return this.getSpeed() >= 25
  }

  getSpeed() {
    return this.getConstants().speed
  }

  // for debugging projectile id
  // getSprite() {
  //   let container = new PIXI.Container()
  //   let sprite = super.getSprite()
  //   container.addChild(sprite)

  //   const style  = { fontFamily : 'PixelForce', fontSize: 14, fill : 0xffffff, align : 'center', strokeThickness: 4, miterLimit: 3 }
  //   this.idSprite = new PIXI.Text(this.data.id, style)
  //   this.idSprite.name = "id"
  //   this.idSprite.anchor.set(0.5)

  //   container.addChild(this.idSprite)

  //   return container
  // }

  remove(entityData) {
    if (this.isFastProjectile()) {
      if (entityData) {
        let x = entityData.x
        let y = entityData.y
        this.instructToMove(x, y)
        
        this.angle = entityData.angle
        this.instructToRotate(this.getRadAngle())
      }

      this.markForRemoval()
    } else {
      this.performRemove()
    }
  }

  performRemove() {
    this.getContainer().unregisterEntity("projectiles", this)
    if (this.getChunk()) {
      this.getChunk().unregister("projectiles", this)
    }

    let projectileName = Helper.getProjectileNameById(this.getType())
    ObjectPool.free(projectileName, this)

    // unregister from global entity list
    this.unregisterEntity()

    this.sprite.visible = false

    for (let effect in this.effectInstances) {
      let effectInstance = this.effectInstances[effect]
      effectInstance.remove()
    }
  }

}

Object.assign(BaseProjectile.prototype, Poolable.prototype, {
  reset() {
    this.chunks = {}
    this.shouldRemove = false
  }
})

module.exports = BaseProjectile

},{"../../../../common/entities/object_pool":660,"../../../../common/interfaces/poolable":675,"./../../../../common/constants.json":656,"./../../../../common/helper":664,"./../../../../common/util/protocol":686,"./../base_entity":206}],516:[function(require,module,exports){
const BaseProjectile = require("./base_projectile")
const Constants = require("./../../../../common/constants.json")
const Protocol = require("./../../../../common/util/protocol")

class BasicLaser extends BaseProjectile {

  onProjectileConstructed() {
    this.game.playSound("machine_gun_2_b")
  }

  getSpritePath() {
    return 'basic_laser_projectile.png'
  }

  getType() {
    return Protocol.definition().ProjectileType.BasicLaser
  }

  getConstantsTable() {
    return "Projectiles.BasicLaser"
  }

}

module.exports = BasicLaser

},{"./../../../../common/constants.json":656,"./../../../../common/util/protocol":686,"./base_projectile":515}],517:[function(require,module,exports){
const BaseProjectile = require("./base_projectile")
const Constants = require("./../../../../common/constants.json")
const Protocol = require("./../../../../common/util/protocol")

class BlueLaser extends BaseProjectile {
    onProjectileConstructed() {
        this.game.playSound("deep_laser")
    }

    getSpritePath() {
        return 'blue_laser.png'
    }

    getType() {
        return Protocol.definition().ProjectileType.BlueLaser
    }

    getConstantsTable() {
        return "Projectiles.BlueLaser"
    }
}

module.exports = BlueLaser
},{"./../../../../common/constants.json":656,"./../../../../common/util/protocol":686,"./base_projectile":515}],518:[function(require,module,exports){
const BaseProjectile = require("./base_projectile")
const Constants = require("./../../../../common/constants.json")
const Protocol = require("./../../../../common/util/protocol")

class Bubble extends BaseProjectile {

  onProjectileConstructed() {
    this.game.playSound("bubble")
  }

  getSpritePath() {
    return 'violet_bubble.png'
  }

  getType() {
    return Protocol.definition().ProjectileType.Bubble
  }

  getConstantsTable() {
    return "Projectiles.Bubble"
  }

}

module.exports = Bubble

},{"./../../../../common/constants.json":656,"./../../../../common/util/protocol":686,"./base_projectile":515}],519:[function(require,module,exports){
const BaseProjectile = require("./base_projectile")
const Constants = require("./../../../../common/constants.json")
const Protocol = require("./../../../../common/util/protocol")
const ClientHelper = require("./../../util/client_helper")
const Helper = require("./../../../../common/helper")

class Bullet extends BaseProjectile {

  onProjectileConstructed() {
    this.game.playSound("pistol")
    this.sprite.anchor.set(1) // so the head is where the actual position of bullet is
  }


  getSpritePath() {
    return 'bullet_projectile.png'
  }

  getType() {
    return Protocol.definition().ProjectileType.Bullet
  }

  getConstantsTable() {
    return "Projectiles.Bullet"
  }

}

module.exports = Bullet

},{"./../../../../common/constants.json":656,"./../../../../common/helper":664,"./../../../../common/util/protocol":686,"./../../util/client_helper":649,"./base_projectile":515}],520:[function(require,module,exports){
const BaseProjectile = require("./base_projectile")
const Constants = require("./../../../../common/constants.json")
const Protocol = require("./../../../../common/util/protocol")
const ClientHelper = require("./../../util/client_helper")

class CarbonGas extends BaseProjectile {

  constructor(game, data) {
    super(game, data)
    this.MAX_WIDTH_EXPANSION = this.getConstants().maxRadialExpansion * 2
  }

  onProjectileConstructed() {
    // this.game.playSound("gas_release", { skipIfPlaying: true })
  }
  
  reset() {
    super.reset()
    this.sprite.width = 0
  }

  setAttributes(data) {
    super.setAttributes(data)

    data.w = data.width
    data.h = data.width

    this.origWidth = data.width

    this.minAlpha = 0.3
    this.sprite.alpha = this.minAlpha
    this.sprite.tint = ClientHelper.getRandomColorInRange("#aaaaaa", "#cccccc", Math.random(), { shouldReturnInteger: true })
  }

  syncWithServer(data) {
    super.syncWithServer(data)

    this.instructToExpand(data.width)
  }

  interpolate(lastFrameTime) {
    this.interpolateExpansion(lastFrameTime)
    const expansionProgress = this.sprite.width - this.origWidth
    const alpha = (expansionProgress / this.MAX_WIDTH_EXPANSION)
    this.sprite.alpha = Math.min(1, this.minAlpha + alpha)
  }

  interpolateExpansion(lastFrameTime) {
    this.sprite.interpolateExpansion(lastFrameTime)
  }

  getSpritePath() {
    return 'white_gas.png'
  }

  getType() {
    return Protocol.definition().ProjectileType.CarbonGas
  }

  getConstantsTable() {
    return "Projectiles.CarbonGas"
  }

}

module.exports = CarbonGas


},{"./../../../../common/constants.json":656,"./../../../../common/util/protocol":686,"./../../util/client_helper":649,"./base_projectile":515}],521:[function(require,module,exports){
const BaseProjectile = require("./base_projectile")
const Constants = require("./../../../../common/constants.json")
const Protocol = require("./../../../../common/util/protocol")
const ClientHelper = require("./../../util/client_helper")

class DisinfectingGas extends BaseProjectile {

  constructor(game, data) {
    super(game, data)
    this.MAX_WIDTH_EXPANSION = this.getConstants().maxRadialExpansion 
  }

  onProjectileConstructed() {
    this.game.playSound("gas_release", { skipIfPlaying: true })
  }
  
  reset() {
    super.reset()
    this.sprite.width = 0
  }

  setAttributes(data) {
    super.setAttributes(data)

    data.w = data.width
    data.h = data.width

    this.origWidth = data.width

    this.minAlpha = 0.3
    this.sprite.alpha = this.minAlpha
    this.sprite.tint = ClientHelper.getRandomColorInRange("#cccccc", "#ffffff", Math.random(), { shouldReturnInteger: true })
  }

  syncWithServer(data) {
    super.syncWithServer(data)

    this.instructToExpand(data.width)
  }

  interpolate(lastFrameTime) {
    this.interpolateExpansion(lastFrameTime)
  }

  interpolateExpansion(lastFrameTime) {
    this.sprite.interpolateExpansion(lastFrameTime)
  }

  getSpritePath() {
    return 'white_gas.png'
  }

  getType() {
    return Protocol.definition().ProjectileType.DisinfectingGas
  }

  getConstantsTable() {
    return "Projectiles.DisinfectingGas"
  }

}

module.exports = DisinfectingGas


},{"./../../../../common/constants.json":656,"./../../../../common/util/protocol":686,"./../../util/client_helper":649,"./base_projectile":515}],522:[function(require,module,exports){
const BaseProjectile = require("./base_projectile")
const Constants = require("./../../../../common/constants.json")
const Protocol = require("./../../../../common/util/protocol")
const ClientHelper = require("./../../util/client_helper")
const Helper = require("./../../../../common/helper")

class Dynamite extends BaseProjectile {

  onProjectileConstructed() {
    // this.game.playSound("shotgun")
  }

  getSpritePath() {
    return 'dynamite.png'
  }

  getType() {
    return Protocol.definition().ProjectileType.Dynamite
  }

  getConstantsTable() {
    return "Projectiles.Dynamite"
  }

}

module.exports = Dynamite

},{"./../../../../common/constants.json":656,"./../../../../common/helper":664,"./../../../../common/util/protocol":686,"./../../util/client_helper":649,"./base_projectile":515}],523:[function(require,module,exports){
const BaseProjectile = require("./base_projectile")
const Constants = require("./../../../../common/constants.json")
const Protocol = require("./../../../../common/util/protocol")
const ClientHelper = require("./../../util/client_helper")
const Helper = require("./../../../../common/helper")

class Explosion extends BaseProjectile {

  onProjectileConstructed() {
    if (this.data.width > (Constants.tileSize * 2)) {
      this.game.playSound("explosion")
    }
    
    this.animateExplosion()
  }

  animateExplosion() {
    ClientHelper.animateExplosion(this.getX(), this.getY(), { 
      minWidth: 32, 
      maxWidth: this.data.width,
      tint: 0xd1c04a
    })

    const smokeCount = 6
    for (var i = 0; i < smokeCount; i++) {
      ClientHelper.addSmoke(this.getX(), this.getY())
    }

  }

  getSpritePath() {
    return 'explosion.png'
  }

  getType() {
    return Protocol.definition().ProjectileType.Explosion
  }

  getConstantsTable() {
    return "Projectiles.Explosion"
  }

}

module.exports = Explosion

},{"./../../../../common/constants.json":656,"./../../../../common/helper":664,"./../../../../common/util/protocol":686,"./../../util/client_helper":649,"./base_projectile":515}],524:[function(require,module,exports){
const BaseProjectile = require("./base_projectile")
const Constants = require("./../../../../common/constants.json")
const Protocol = require("./../../../../common/util/protocol")
const ClientHelper = require("./../../util/client_helper")

class Flame extends BaseProjectile {

  constructor(game, data) {
    super(game, data)

    this.MAX_WIDTH_EXPANSION = this.getConstants().maxRadialExpansion * 2
  }

  onProjectileConstructed() {
    this.game.playSound("flame", { skipIfPlaying: true })
  }

  reset() {
    super.reset()
    this.sprite.width = 0
  }

  setAttributes(data) {
    super.setAttributes(data)

    data.w = data.width
    data.h = data.width

    this.origWidth = data.width

    this.minAlpha = 0.5
    this.sprite.alpha = this.minAlpha
    this.sprite.tint = ClientHelper.getRandomColorInRange("#ce5304", "#f8ce79", Math.random(), { shouldReturnInteger: true })
  }

  syncWithServer(data) {
    super.syncWithServer(data)

    this.instructToExpand(data.width)
  }

  interpolate(lastFrameTime) {
    this.interpolateExpansion(lastFrameTime)
  }

  interpolateExpansion(lastFrameTime) {
    this.sprite.interpolateExpansion(lastFrameTime)
  }

  getSpritePath() {
    return 'white_gas.png'
  }

//   remove() {
//     // let animation finish before removing..
// 
//     let alpha = { alpha: this.sprite.alpha }
//     let vanish = new TWEEN.Tween(alpha)
//         .to({ alpha: 0 }, 3000)
//         .easing(TWEEN.Easing.Quadratic.Out) // Use an easing function to make the animation smooth.
//         .onUpdate(() => {
//           this.sprite.alpha = alpha.alpha
//         })
//         .onComplete(() => {
//           this.removeSelfAndChildrens(this.sprite)
//         })
//         .start()
// 
//   }
// 
  getType() {
    return Protocol.definition().ProjectileType.Flame
  }

  getConstantsTable() {
    return "Projectiles.Flame"
  }

}

module.exports = Flame


},{"./../../../../common/constants.json":656,"./../../../../common/util/protocol":686,"./../../util/client_helper":649,"./base_projectile":515}],525:[function(require,module,exports){
const BaseProjectile = require("./base_projectile")
const Constants = require("./../../../../common/constants.json")
const Protocol = require("./../../../../common/util/protocol")
const ClientHelper = require("./../../util/client_helper")
const Helper = require("./../../../../common/helper")

class Grenade extends BaseProjectile {

  onProjectileConstructed() {
    // this.game.playSound("shotgun")
  }

  getSpritePath() {
    return 'grenade.png'
  }

  getType() {
    return Protocol.definition().ProjectileType.Grenade
  }

  getConstantsTable() {
    return "Projectiles.Grenade"
  }

}

module.exports = Grenade

},{"./../../../../common/constants.json":656,"./../../../../common/helper":664,"./../../../../common/util/protocol":686,"./../../util/client_helper":649,"./base_projectile":515}],526:[function(require,module,exports){
const Helper = require("./../../../../common/helper")

const Projectiles = {}

Projectiles.BasicLaser = require("./basic_laser")
Projectiles.LightLaser = require("./light_laser")
Projectiles.Missile = require("./missile")
Projectiles.Bullet = require("./bullet")
Projectiles.ShotgunBullet = require("./shotgun_bullet")
Projectiles.RifleBullet = require("./rifle_bullet")
Projectiles.CarbonGas = require("./carbon_gas")
Projectiles.DisinfectingGas = require("./disinfecting_gas")
Projectiles.Flame = require("./flame")
Projectiles.AcidSpit = require("./acid_spit")
Projectiles.Spike = require("./spike")
Projectiles.Grenade = require("./grenade")
Projectiles.Explosion = require("./explosion")
Projectiles.MiningExplosion = require("./mining_explosion")
Projectiles.PoisonGrenade = require("./poison_grenade")
Projectiles.PoisonGas = require("./poison_gas")
Projectiles.Meteor = require("./meteor")
Projectiles.TeslaLaser = require("./tesla_laser")
Projectiles.MolotovCocktail = require("./molotov_cocktail")
Projectiles.PlasmaBullet = require("./plasma_bullet")
Projectiles.Bubble = require("./bubble")
Projectiles.BlueLaser = require("./blue_laser")
Projectiles.Dynamite = require("./dynamite")

Projectiles.forType = (type) => {
  const klassName = Helper.getProjectileNameById(type) 
  return Projectiles[klassName]
}

Projectiles.getList = () => {
  return Object.values(Projectiles).filter((klass) => {
    return typeof klass.getType === "function"
  })
}

module.exports = Projectiles
},{"./../../../../common/helper":664,"./acid_spit":514,"./basic_laser":516,"./blue_laser":517,"./bubble":518,"./bullet":519,"./carbon_gas":520,"./disinfecting_gas":521,"./dynamite":522,"./explosion":523,"./flame":524,"./grenade":525,"./light_laser":527,"./meteor":528,"./mining_explosion":529,"./missile":530,"./molotov_cocktail":531,"./plasma_bullet":532,"./poison_gas":533,"./poison_grenade":534,"./rifle_bullet":535,"./shotgun_bullet":536,"./spike":537,"./tesla_laser":538}],527:[function(require,module,exports){
const BasicLaser = require("./basic_laser")
const Constants = require("./../../../../common/constants.json")
const Protocol = require("./../../../../common/util/protocol")

class LightLaser extends BasicLaser {

  onProjectileConstructed() {
    this.game.playSound("light_laser")
  }

  getSpritePath() {
    return 'light_laser.png'
  }

  getType() {
    return Protocol.definition().ProjectileType.LightLaser
  }

  getConstantsTable() {
    return "Projectiles.LightLaser"
  }

}

module.exports = LightLaser

},{"./../../../../common/constants.json":656,"./../../../../common/util/protocol":686,"./basic_laser":516}],528:[function(require,module,exports){
const BaseProjectile = require("./base_projectile")
const Constants = require("./../../../../common/constants.json")
const Protocol = require("./../../../../common/util/protocol")
const ClientHelper = require("./../../util/client_helper")
const Helper = require("./../../../../common/helper")
const Trail = require("../particles/trail")

class Meteor extends BaseProjectile {

  onProjectileConstructed() {
    // this.game.playSound("shotgun")
  }

  interpolate(lastFrameTime) {
    // create 3 trails of varying color - yellow to red. positioned in top/middle/bottom
    let offset = 4
    let attrs = [
      { y: this.getY() - offset, color: 0xfabd77, radius: 10 + Math.floor(Math.random() * 10) },
      { y: this.getY()         , color: 0xfad677, radius: 10 + Math.floor(Math.random() * 10) },
      { y: this.getY() + offset, color: 0xfac977, radius: 10 + Math.floor(Math.random() * 10) }
    ]

    // e97e2e, change from yellow to ed7236, and get smaller as well

    attrs.forEach((attr) => {
      Trail.create({
        x: this.getX(), 
        y: attr.y, 
        angle: 0, 
        color: 0xc75637, 
        destinationColor: 0xed7236,
        radius: attr.radius, 
        offset: 0,
        isShrinking: true
      })
    })

    super.interpolate(lastFrameTime)
  }

  performRemove() {
    super.performRemove()
    this.game.screenShake()
  }

  getSpritePath() {
    return 'meteor_rock.png'
  }

  getType() {
    return Protocol.definition().ProjectileType.Meteor
  }

  getConstantsTable() {
    return "Projectiles.Meteor"
  }

}

module.exports = Meteor

},{"../particles/trail":509,"./../../../../common/constants.json":656,"./../../../../common/helper":664,"./../../../../common/util/protocol":686,"./../../util/client_helper":649,"./base_projectile":515}],529:[function(require,module,exports){
const BaseProjectile = require("./base_projectile")
const Constants = require("./../../../../common/constants.json")
const Protocol = require("./../../../../common/util/protocol")
const ClientHelper = require("./../../util/client_helper")
const Helper = require("./../../../../common/helper")

class MiningExplosion extends BaseProjectile {

  onProjectileConstructed() {
    if (this.data.width > (Constants.tileSize * 2)) {
      this.game.playSound("explosion")
    }
    
    this.animateExplosion()
  }

  animateExplosion() {
    ClientHelper.animateExplosion(this.getX(), this.getY(), { 
      minWidth: 32, 
      maxWidth: this.data.width,
      tint: 0xd1c04a
    })

    const smokeCount = 6
    for (var i = 0; i < smokeCount; i++) {
      ClientHelper.addSmoke(this.getX(), this.getY())
    }

  }

  getSpritePath() {
    return 'explosion.png'
  }

  getType() {
    return Protocol.definition().ProjectileType.MiningExplosion
  }

  getConstantsTable() {
    return "Projectiles.MiningExplosion"
  }

}

module.exports = MiningExplosion

},{"./../../../../common/constants.json":656,"./../../../../common/helper":664,"./../../../../common/util/protocol":686,"./../../util/client_helper":649,"./base_projectile":515}],530:[function(require,module,exports){
const BaseProjectile = require("./base_projectile")
const Constants = require("./../../../../common/constants.json")
const Protocol = require("./../../../../common/util/protocol")
const Trail = require("../particles/trail")

class Missile extends BaseProjectile {

  constructor(game, data) {
    super(game, data)
  }

  reset() {
    super.reset()
    this.interpolationCounter = 0
  }

  onProjectileConstructed() {
    this.game.playSound("missile")
  }

  getSpritePath() {
    return 'missile.png'
  }

  getType() {
    return Protocol.definition().ProjectileType.Missile
  }


  getConstantsTable() {
    return "Projectiles.Missile"
  }

  onPostRemoved() {
    // this.animateExplosion()
  }

  animateExplosion() {
    const sprite = new PIXI.Sprite(PIXI.utils.TextureCache["circle.png"])
    sprite.anchor.set(0.5)
    sprite.position.x = this.getX()
    sprite.position.y = this.getY()
    this.game.sector.effectsContainer.addChild(sprite)

    let width = { width: 10 }
    let randomWidth = Math.floor(Math.random() * 100) + 50

    var tween = new TWEEN.Tween(width)
        .to({ width: randomWidth }, 200)
        .easing(TWEEN.Easing.Quadratic.Out) // Use an easing function to make the animation smooth.
        .onUpdate(() => {
          sprite.width = width.width
          sprite.height = width.width
        })
        .onComplete(() => {
          this.game.sector.effectsContainer.removeChild(sprite)
        })
        .start()
  }


  addTrail() {
    const sprite = new PIXI.Sprite(PIXI.utils.TextureCache["white_smoke.png"])
    sprite.anchor.set(0.5)
    sprite.width = randomWidth
    sprite.height = randomWidth
    sprite.tint = 0x777777
    sprite.position.x = this.getX()
    sprite.position.y = this.getY()

    this.game.sector.effectsContainer.addChild(sprite)

    let alpha = { alpha: 1 }

    var tween = new TWEEN.Tween(alpha)
        .to({ alpha: 0 }, 2500)
        .easing(TWEEN.Easing.Quadratic.Out) // Use an easing function to make the animation smooth.
        .onUpdate(() => {
          sprite.alpha = alpha.alpha
        })
        .onComplete(() => {
          this.game.sector.effectsContainer.removeChild(sprite)
        })
        .start()
  }

  interpolate(lastFrameTime) {
    // create trail
    if (this.interpolationCounter % 2 === 0) {
      Trail.create({
        x: this.getX(), 
        y: this.getY(), 
        angle: 0, 
        color: 0x777777, 
        radius: 3, 
        offset: 0
      })
    }

    super.interpolate(lastFrameTime)

    this.interpolationCounter += 1
  }

}

module.exports = Missile

},{"../particles/trail":509,"./../../../../common/constants.json":656,"./../../../../common/util/protocol":686,"./base_projectile":515}],531:[function(require,module,exports){
const BaseProjectile = require("./base_projectile")
const Constants = require("./../../../../common/constants.json")
const Protocol = require("./../../../../common/util/protocol")
const ClientHelper = require("./../../util/client_helper")
const Helper = require("./../../../../common/helper")

class MolotovCocktail extends BaseProjectile {

  onProjectileConstructed() {
    // this.game.playSound("shotgun")
  }

  getSpritePath() {
    return 'molotov_cocktail.png'
  }

  getType() {
    return Protocol.definition().ProjectileType.MolotovCocktail
  }

  getConstantsTable() {
    return "Projectiles.MolotovCocktail"
  }

}

module.exports = MolotovCocktail

},{"./../../../../common/constants.json":656,"./../../../../common/helper":664,"./../../../../common/util/protocol":686,"./../../util/client_helper":649,"./base_projectile":515}],532:[function(require,module,exports){
const BaseProjectile = require("./base_projectile")
const Constants = require("./../../../../common/constants.json")
const Protocol = require("./../../../../common/util/protocol")
const ClientHelper = require("./../../util/client_helper")
const Helper = require("./../../../../common/helper")

class PlasmaBullet extends BaseProjectile {

  onProjectileConstructed() {
    this.game.playSound("plasma_gun")
    this.sprite.anchor.set(1) // so the head is where the actual position of bullet is
  }


  getSpritePath() {
    return 'bullet_projectile.png'
  }

  getType() {
    return Protocol.definition().ProjectileType.PlasmaBullet
  }

  getConstantsTable() {
    return "Projectiles.PlasmaBullet"
  }

}

module.exports = PlasmaBullet

},{"./../../../../common/constants.json":656,"./../../../../common/helper":664,"./../../../../common/util/protocol":686,"./../../util/client_helper":649,"./base_projectile":515}],533:[function(require,module,exports){
const CarbonGas = require("./carbon_gas")
const Constants = require("./../../../../common/constants.json")
const Protocol = require("./../../../../common/util/protocol")
const ClientHelper = require("./../../util/client_helper")

class PoisonGas extends CarbonGas {
  constructor(game, data) {
    super(game, data)
  }

  setAttributes(data) {
    super.setAttributes(data)
    this.sprite.tint = ClientHelper.getRandomColorInRange("#a7e6a7", "#6aa56a", Math.random(), { shouldReturnInteger: true })
  }

  getType() {
    return Protocol.definition().ProjectileType.PoisonGas
  }

  getConstantsTable() {
    return "Projectiles.PoisonGas"
  }
}
module.exports = PoisonGas

},{"./../../../../common/constants.json":656,"./../../../../common/util/protocol":686,"./../../util/client_helper":649,"./carbon_gas":520}],534:[function(require,module,exports){
const BaseProjectile = require("./base_projectile")
const Constants = require("./../../../../common/constants.json")
const Protocol = require("./../../../../common/util/protocol")
const ClientHelper = require("./../../util/client_helper")
const Helper = require("./../../../../common/helper")

class PoisonGrenade extends BaseProjectile {

  onProjectileConstructed() {
    // this.game.playSound("shotgun")
  }

  getSpritePath() {
    return 'poison_grenade.png'
  }

  getType() {
    return Protocol.definition().ProjectileType.PoisonGrenade
  }

  getConstantsTable() {
    return "Projectiles.PoisonGrenade"
  }

}

module.exports = PoisonGrenade

},{"./../../../../common/constants.json":656,"./../../../../common/helper":664,"./../../../../common/util/protocol":686,"./../../util/client_helper":649,"./base_projectile":515}],535:[function(require,module,exports){
const BaseProjectile = require("./base_projectile")
const Constants = require("./../../../../common/constants.json")
const Protocol = require("./../../../../common/util/protocol")
const ClientHelper = require("./../../util/client_helper")
const Helper = require("./../../../../common/helper")

class RifleBullet extends BaseProjectile {

  onProjectileConstructed() {
    this.game.playSound("assault_rifle")
    this.sprite.anchor.set(1) // so the head is where the actual position of bullet is
  }


  getSpritePath() {
    return 'bullet_projectile.png'
  }

  getType() {
    return Protocol.definition().ProjectileType.RifleBullet
  }

  getConstantsTable() {
    return "Projectiles.RifleBullet"
  }

}

module.exports = RifleBullet

},{"./../../../../common/constants.json":656,"./../../../../common/helper":664,"./../../../../common/util/protocol":686,"./../../util/client_helper":649,"./base_projectile":515}],536:[function(require,module,exports){
const BaseProjectile = require("./base_projectile")
const Constants = require("./../../../../common/constants.json")
const Protocol = require("./../../../../common/util/protocol")
const ClientHelper = require("./../../util/client_helper")
const Helper = require("./../../../../common/helper")

class ShotgunBullet extends BaseProjectile {

  onProjectileConstructed() {
    this.game.playSound("shotgun")
    this.sprite.anchor.set(1) // so the head is where the actual position of bullet is
  }

  getSpritePath() {
    return 'bullet_projectile.png'
  }

  getType() {
    return Protocol.definition().ProjectileType.ShotgunBullet
  }

  getConstantsTable() {
    return "Projectiles.ShotgunBullet"
  }

}

module.exports = ShotgunBullet

},{"./../../../../common/constants.json":656,"./../../../../common/helper":664,"./../../../../common/util/protocol":686,"./../../util/client_helper":649,"./base_projectile":515}],537:[function(require,module,exports){
const BaseProjectile = require("./base_projectile")
const Constants = require("./../../../../common/constants.json")
const Protocol = require("./../../../../common/util/protocol")
const ClientHelper = require("./../../util/client_helper")
const Helper = require("./../../../../common/helper")

class Spike extends BaseProjectile {

  onProjectileConstructed() {
  }


  getSpritePath() {
    return 'spike.png'
  }

  getType() {
    return Protocol.definition().ProjectileType.Spike
  }

  getConstantsTable() {
    return "Projectiles.Spike"
  }

}

module.exports = Spike

},{"./../../../../common/constants.json":656,"./../../../../common/helper":664,"./../../../../common/util/protocol":686,"./../../util/client_helper":649,"./base_projectile":515}],538:[function(require,module,exports){
const BaseProjectile = require("./base_projectile")
const Constants = require("./../../../../common/constants.json")
const Protocol = require("./../../../../common/util/protocol")
const ClientHelper = require("./../../util/client_helper")
const Helper = require("./../../../../common/helper")

class TeslaLaser extends BaseProjectile {

  onProjectileConstructed() {
    this.laserSprite = this.sprite
    let distance = this.game.distance(this.data.x, this.data.y, this.data.endX, this.data.endY)
    this.laserSprite.width = distance
    this.laserSprite.height = 10
    let angle = this.game.angle(this.data.x, this.data.y, this.data.endX, this.data.endY)
    this.laserSprite.rotation = angle
    this.laserSprite.anchor.set(0)

    this.game.playSound("tesla")
  }

//   getSprite() {
//     let container = new PIXI.Container()
//     container.name = 'TeslaLaser'
//     let sprite = super.getSprite()
//     this.laserSprite = sprite
//     container.addChild(sprite)
//     container.pivot.set()
// 
//     let distance = this.game.distance(this.data.x, this.data.y, this.data.endX, this.data.endY)
//     this.laserSprite.width = distance
//     this.laserSprite.height = 10
//     let angle = this.game.angle(this.data.x, this.data.y, this.data.endX, this.data.endY)
//     this.laserSprite.rotation = angle
//     this.laserSprite.anchor.set(0)
// 
//     let laser_head = new PIXI.Sprite(PIXI.utils.TextureCache["tesla_laser_head.png"])
//     let laser_tail = new PIXI.Sprite(PIXI.utils.TextureCache["tesla_laser_head.png"])
//     laser_head.position.x = 0
//     laser_tail.position.x = distance
// 
//     // container.addChild(laser_head)
//     // container.addChild(laser_tail)
//     return container
//   }

  getSpritePath() {
    return 'tesla_laser.png'
  }

  getType() {
    return Protocol.definition().ProjectileType.TeslaLaser
  }

  getConstantsTable() {
    return "Projectiles.TeslaLaser"
  }

}

module.exports = TeslaLaser

},{"./../../../../common/constants.json":656,"./../../../../common/helper":664,"./../../../../common/util/protocol":686,"./../../util/client_helper":649,"./base_projectile":515}],539:[function(require,module,exports){
const BaseEntity = require("./base_entity")
const Constants = require("./../../../common/constants.json")
const BitmapText = require("../util/bitmap_text")

class Region extends BaseEntity {
  constructor(game, data) {
    super(game, data)

    this.id = data.id
    this.sector = game.sector

    this.onRegionCreated()
  }

  redrawSprite() {
    this.drawFill()
    this.drawIdLabel()
  }

  getFlag(flag) {
    return this.flags[flag]
  }

  drawFill() {
    this.sprite.scale.set(1)
    this.fillSprite.scale.set(1)
    this.fillSprite.width  = this.w
    this.fillSprite.height = this.h
  }

  drawIdLabel() {
    if (!this.idText) {
      this.idText  = BitmapText.create({
        label: "RegionId",
        text: this.name,
        anchor: 0,
        spriteContainer: this.sprite
      })

      this.idText.sprite.tint = 0xeadd2b
    } else {
      this.idText.sprite.text = this.name
    }

    this.repositionIdText()
  }

  getCenter() {
    return { x: this.x, y: this.y } 
  }

  repositionIdText() {
    let xDisplacement = this.name.length * 5
    this.idText.sprite.position.x = -xDisplacement
    this.idText.sprite.position.y = -10
  }

  onRegionCreated() {
    this.sector.addRegion(this)
  }

  getSpritePath() {
    return "white.png"
  }

  createSprite(texture) {
    return new PIXI.Sprite(texture)
  }

  getSpriteContainer() {
    return this.sector.regionContainer
  }

  getSprite() {
    let sprite = new PIXI.Container()
    sprite.name = this.constructor.name
    sprite.scale.set(1)

    let texture = PIXI.utils.TextureCache[this.getSpritePath()]
    this.fillSprite = new PIXI.Sprite(texture)
    this.fillSprite.name = 'RegionFill'
    this.fillSprite.anchor.set(0.5)
    this.fillSprite.alpha = 0.3
    this.fillSprite.tint = 0x0000ff
    this.fillSprite.scale.set(1)
    sprite.addChild(this.fillSprite)

    return sprite
  }

  show() {
    this.sprite.alpha = 0.3
  }

  hide() {
    this.sprite.alpha = 0
  }

  getStart() {
    return {
      x: this.getX() - this.getWidth()  / 2,
      y: this.getY() - this.getHeight() / 2
    }
  }

  remove() {
    super.remove()

    if (this.idText) {
      this.idText.remove()
    }

    this.sector.removeRegion(this)
  }

  syncWithServer(data) {
    this.sprite.position.x = data.x
    this.sprite.position.y = data.y

    this.name = data.name
    this.x = data.x
    this.y = data.y
    this.w = this.sprite.width = data.w
    this.h = this.sprite.height = data.h

    this.redrawSprite()
    this.updateRbushCoords()

    this.onBoundsChanged()

    this.flags = data.flags
    this.onFlagsChanged()
  }

  updateRbushCoords() {
    this.minX = this.x - this.w/2
    this.maxX = this.x + this.w/2
    this.minY = this.y - this.h/2
    this.maxY = this.y + this.h/2
  }

  onBoundsChanged() {
    if (!this.isInvalidBoundingBox(this)) {
      this.sector.regionTree.remove(this)
      this.sector.regionTree.insert(this)
    }
  }

  isInvalidBoundingBox(entity) {
    return isNaN(entity.minX) || isNaN(entity.maxX) || isNaN(entity.minY) || isNaN(entity.maxY)
  }

  onFlagsChanged() {
    if (this.flags.map_label === 'allow') {
      // draw on map
      this.game.mapMenu.addLabel(this.id, this.name, this.x, this.y)
    } else if (this.flags.map_label === 'deny') {
      this.game.mapMenu.removeLabel(this.id)
    }
  }

  getWidth() {
    return this.w
  }

  getHeight() {
    return this.h
  }

}

module.exports = Region
},{"../util/bitmap_text":648,"./../../../common/constants.json":656,"./base_entity":206}],540:[function(require,module,exports){
const SocketUtil = require("./../util/socket_util")
const Constants = require("./../../../common/constants.json")


class RegionManager {
  constructor(game) {
    this.game = game
    this.sector = game.sector
  }

  startRegionSelect() {
    this.isSelectingRegion = true
    this.sector.regionAreaSprite.alpha = 0.6
    this.sector.regionAreaSprite.width = Constants.tileSize
    this.sector.regionAreaSprite.height = Constants.tileSize
  }

  setRegionStart() {
    this.regionStart = {
      x: this.sector.regionAreaSprite.x,
      y: this.sector.regionAreaSprite.y
    }
  }

  clearRegion() {
    this.isSelectingRegion = false
    this.regionStart = null
    this.regionEnd = null

    if (this.sector) {
      this.sector.regionAreaSprite.alpha  = 0
      this.sector.regionAreaSprite.width  = Constants.tileSize
      this.sector.regionAreaSprite.height = Constants.tileSize
    }
  }

  setRegionEnd(x, y) {
    this.regionEnd = {
      x: x,
      y: y
    }
  }
  
  renderRegionBlockAtMousePosition(clientX, clientY) {
    const cameraPositionX = -this.game.cameraDisplacement.x
    const cameraPositionY = -this.game.cameraDisplacement.y
    const x = cameraPositionX + clientX
    const y = cameraPositionY + clientY
    const snappedX = this.sector.getSnappedPosX(x, Constants.tileSize)
    const snappedY = this.sector.getSnappedPosY(y, Constants.tileSize)

    if (!this.regionStart) {
      this.sector.regionAreaSprite.x = snappedX
      this.sector.regionAreaSprite.y = snappedY
    } else {
      let endX = snappedX
      let endY = snappedY

      this.setRegionEnd(endX, endY)

      this.renderRegion(this.regionStart.x, this.regionStart.y, this.regionEnd.x, this.regionEnd.y)
    }

  }

  renderRegion(x1, y1, x2, y2) {
    let midpoint = {
      x: Math.max(x1, (x2 + x1) / 2),
      y: Math.max(y1, (y2 + y1) / 2)
    }

    let width  = Math.max(0, x2 - x1 + Constants.tileSize)
    let height = Math.max(0, y2 - y1 + Constants.tileSize)

    this.sector.regionAreaSprite.x = midpoint.x
    this.sector.regionAreaSprite.y = midpoint.y
    this.sector.regionAreaSprite.width = width
    this.sector.regionAreaSprite.height = height
  }

  createRegion() {
    const width = this.regionEnd.x - this.regionStart.x
    const height = this.regionEnd.y - this.regionStart.y
    const area = width * height
    const isRegionValid = area > 0 && width > 0 && height > 0

    if (isRegionValid) {
      this.onRegionCreated(this.regionStart, this.regionEnd)
    }

    this.clearRegion()
  }

  showHangarRegion(x1, x2, y1, y2) {
    this.sector.regionAreaSprite.alpha = 0.6
    this.renderRegion(x1, x2, y1, y2)
  }

  onRegionCreated(regionStart, regionEnd) {
    let midpoint = {
      x: (regionEnd.x + regionStart.x) / 2,
      y: (regionEnd.y + regionStart.y) / 2
    }

    const w = regionEnd.x - regionStart.x + Constants.tileSize
    const h = regionEnd.y - regionStart.y + Constants.tileSize

    let hangarControllerId = this.game.selectedEntity.id

    SocketUtil.emit("SetHangar", {
      id: hangarControllerId,
      x: midpoint.x,
      y: midpoint.y,
      w: w,
      h: h
    })
  }

  cleanup() {
    this.clearRegion()
  }



}

module.exports = RegionManager
},{"./../../../common/constants.json":656,"./../util/socket_util":654}],541:[function(require,module,exports){
const Constants = require("./../../../common/constants.json")
const BoundingBox = require("./../../../common/interfaces/bounding_box")
const Helper = require("./../../../common/helper")
const ClientHelper = require("./../util/client_helper")
const BitmapText = require("../util/bitmap_text")

/*
  NOTE:
    Room is meant for visualzing rooms (i.e determinining if oxygenated)
    The tiles in this room function as a debugging mechanism for determining which are designated rooms
    They only contain row, col information as opposed to what the tiles actually are

*/
class Room {
  constructor(data, sector) {
    this.id = data.id
    this.sector = sector
    this.container = data.container
    this.game = sector.game
    this.data = data
    this.tiles = {}
    this.chunks = {}

    this.initSprite()
  }

  // to remove overlap in rendering door platform tiles overlay
  getUnoccupiedTiles(tiles) {
    return tiles.filter((tile) => {
      return !this.isTileOccupied(tile)
    })
  }

  getCenter() {
    let rowSum = 0
    let colSum = 0

    Object.values(this.tiles).forEach((tile) => {
      rowSum += tile.row
      colSum += tile.col
    })

    let centerX = (colSum / Object.keys(this.tiles).length) * Constants.tileSize
    let centerY = (rowSum / Object.keys(this.tiles).length) * Constants.tileSize

    return {
      x: centerX,
      y: centerY
    }
  }

  getChunks() {
    let boundingBox = this.getBoundingBox()
    let chunksById = Helper.getChunksFromBoundingBox(this.sector, boundingBox)
    return Object.values(chunksById)
  }

  hasTile(row, col) {
    let tileKey = [row, col].join("-")
    return this.tiles[tileKey]
  }

  initSprite() {
    if (!this.shouldCreateSprites()) return

    this.sprite = new PIXI.Container()
    this.sprite.name = "room"
    this.sprite.alpha = 0

    // if (this.sprite.anchor) this.sprite.anchor.set(0.5)
    this.getSpriteContainer().addChild(this.sprite)

    this.labelText  = BitmapText.create({
      label: "RoomId",
      text: "Room " + this.id,
      size: 18,
      anchor: 0,
      spriteContainer: this.container.effectsContainer
    })

    this.labelText.sprite.tint = 0x34ccfd
  }

  repositionRoomLabel() {
    if (!this.shouldCreateSprites()) return

    this.labelText.sprite.position.x = this.x - (this.labelText.sprite.width/2)
    this.labelText.sprite.position.y = this.y
  }

  getContainer() {
    return this.sector
  }

  isTileOccupied(tile) {
    return this.container.roomTileMap.get(tile.row, tile.col)
  }

  registerTile(tile) {
    this.container.roomTileMap.set({ row: tile.row, col: tile.col, value: tile  })
  }

  unregisterTile(tile) {
    this.container.roomTileMap.set({ row: tile.row, col: tile.col, value: 0  })
  }

  remove() {
    Object.values(this.tiles).forEach((tile) => {
      this.unregisterTile(tile)
    })

    this.getContainer().unregisterEntity("rooms", this)
    this.unregisterFromChunks()

    if (this.labelText) {
      this.labelText.remove()
    }

    ClientHelper.removeSelfAndChildrens(this.sprite)
    this.cleanupTween()
  }

  cleanupTween() {
    if (this.alarmTween) {
      this.alarmTween.stop()
    }
  }

  syncWithServer(data) {
    if (data.hasOwnProperty("oxygenPercentage")) {
      this.setOxygenPercentage(data.oxygenPercentage)
    }

    if (data.tiles) {
      this.syncTiles(Object.values(data.tiles))
    }

    if (data.edgeTiles) {
      this.syncTiles(Object.values(data.edgeTiles))
    }

    if (data.hasOwnProperty('x')) {
      this.x = data.x
      this.y = data.y

      this.repositionRoomLabel()
    }
    
    this.updateRbushCoords()
    this.registerToChunks()
  }

  getWidth() {
    let minX = 1000000
    let maxX = 0

    Object.values(this.tiles).map((hit) => {
      let leftEdge  = (hit.col * Constants.tileSize) - Constants.tileSize / 2
      let rightEdge = (hit.col * Constants.tileSize) + Constants.tileSize / 2

      minX = Math.min(minX, leftEdge)
      maxX = Math.max(maxX, rightEdge)
    })

    return maxX - minX
  }

  getHeight() {
    let minY = 1000000
    let maxY = 0

    Object.values(this.tiles).map((hit) => {
      let topEdge    = (hit.row * Constants.tileSize) - Constants.tileSize / 2
      let bottomEdge = (hit.row * Constants.tileSize) + Constants.tileSize / 2

      minY = Math.min(minY, topEdge)
      maxY = Math.max(maxY, bottomEdge)
    })

    return maxY - minY
  }

  registerToChunks() {
    this.getChunks().forEach((chunk) => {
      chunk.register("rooms", this)
    })
  }

  unregisterFromChunks() {
    this.getChunks().forEach((chunk) => {
      chunk.unregister("rooms", this)
    })
  }

  getTileKey(tile) {
    return [tile.row, tile.col].join("-")
  }

  syncTiles(tiles) {
    if (!tiles) return

    tiles.forEach((tile) => {
      let tileKey = this.getTileKey(tile)
      if (tile.clientMustDelete) {
        this.removeTile(tileKey)
      } else if (!this.tiles[tileKey]) {
        this.tiles[tileKey] = this.createTile(tile)
      }
    })

    this.repositionRoomLabel()
  }

  removeTile(tileKey) {
    let tile = this.tiles[tileKey]

    if (tile) {
      if (tile.sprite) {
        this.sprite.removeChild(tile.sprite)
      }

      this.unregisterTile(tile)
    }

    delete this.tiles[tileKey]
  }

  createTile(data) {
    let tile = { row: data.row, col: data.col }

    tile.room = this
    this.registerTile(tile)

    if (this.shouldCreateSprites()) {
      tile.sprite = this.createTileSprite(tile.row, tile.col)
      this.sprite.addChild(tile.sprite)
    }

    return tile
  }

  shouldCreateSprites() {
    return window.debugRoom || debugMode
  }

  setOxygenPercentage(oxygenPercentage) {
    this.oxygenPercentage = oxygenPercentage
  }

  hide() {
    if (!this.shouldCreateSprites()) return
    this.sprite.alpha = 0
  }

  show() {
    if (!this.shouldCreateSprites()) return
    this.sprite.alpha = 1
  }

  createTileSprite(row, col) {
    let texture = PIXI.utils.TextureCache[this.getTileSpritePath()]
    let sprite = new PIXI.Sprite(texture)
    sprite.name = "room_tile"
    sprite.tint = 0xff0000
    sprite.width  = Constants.tileSize
    sprite.height = Constants.tileSize
    sprite.position.x = col * Constants.tileSize
    sprite.position.y = row * Constants.tileSize
    sprite.alpha = 0.6
    return sprite
  }

  getTileSpritePath() {
    return "room_tile.png"
  }

  getSpriteContainer() {
    return this.data.container.spriteLayers[this.getGroup()]
  }

  getGroup() {
    return "rooms"
  }
}

Object.assign(Room.prototype, BoundingBox.prototype, {
  getX() {
    return this.x
  },
  getY() {
    return this.y
  }
})

module.exports = Room

},{"../util/bitmap_text":648,"./../../../common/constants.json":656,"./../../../common/helper":664,"./../../../common/interfaces/bounding_box":665,"./../util/client_helper":649}],542:[function(require,module,exports){
class RoomAlertManager {
  constructor(container) {
    this.container = container
    this.rooms = {}
  }

  addRoom(room) {
    this.rooms[room.id] = room
    room.sprite.alpha = 1
    this.onRoomChanged()
  }

  removeRoom(room) {
    delete this.rooms[room.id] 
    room.sprite.alpha = 0
    this.onRoomChanged()
  }

  hasAlarm() {
    return Object.keys(this.rooms).length > 0  
  }

  onRoomChanged() {
    if (this.hasAlarm()) {
      this.alarmTween = this.getAlarmAnimationTween()
      this.alarmTween.start()
    } else {
      this.clear()
    }
  }

  clear() {
    if (this.alarmTween) {
      this.alarmTween.stop()
      this.alarmTween = null
    }
  }

  getSprite() {
    return this.container.spriteLayers["rooms"] 
  }

  getAlarmAnimationTween() {
    let opacity = { opacity: 1 }

    var tween = new TWEEN.Tween(opacity)
        .to({ opacity: 0.5 }, 1000)
        .onUpdate(() => {
          this.getSprite().alpha = opacity.opacity
        })
        .onStop(() => {
          this.getSprite().alpha = 0
        })
        .yoyo(true)
        .repeat(Infinity)

    return tween
  }

}

module.exports = RoomAlertManager
},{}],543:[function(require,module,exports){
const Grid = require("./../../../common/entities/grid")
const Constants = require("./../../../common/constants.json")
const Container = require("./../../../common/interfaces/container")
const ClientContainer = require("./client_container")
const Protocol = require("./../../../common/util/protocol")
const Helper = require("./../../../common/helper")
const Player = require("./player")
const Backgrounds = require("./backgrounds/index")
const ClientHelper = require("./../util/client_helper")
const StarmapLocation = require("./starmap_location")
const RoomAlertManager = require("./room_alert_manager")
const LightManager = require("./light_manager")
const Selection = require("./selection")
const Chunk = require("./chunk")
const HomeArea = require("./home_area")
const ExceptionReporter = require("./../util/exception_reporter")
const Buildings = require('./buildings/index')
const ObjectPool = require("../../../common/entities/object_pool")
const rbush = require("rbush")

const Wire = require("./buildings/wire")
const GasPipe = require("./buildings/gas_pipe")
const LiquidPipe = require("./buildings/liquid_pipe")
const FuelPipe = require("./buildings/fuel_pipe")

// mostly used as a sprite container
class Sector {
  constructor(game, data) {
    this.id  = data.id
    this.uid = data.uid
    this.name = data.name
    this.game = game
    this.createdAt = data.createdAt
    this.game.sector = this
    this.angle = 0
    this.tick = 0

    this.settings = {}
    this.buttons = {}

    this.sectorBans = data.sectorBans
    this.gameMode = data.gameMode
    this.rowCount = data.rowCount
    this.colCount = data.colCount
    this.buildSpeed = data.buildSpeed
    this.screenshots = data.screenshots
    this.sellables = data.sellables
    this.mobCustomStats = data.mobCustomStats || {}
    this.buildingCustomStats = data.buildingCustomStats || {}
    this.entityCustomStats = data.entityCustomStats || {}
    
    for (let name in data.buttons) {
      let buttonData = data.buttons[name]
      this.game.onButtonUpdated({ button: buttonData })
    }

    for (let id in data.commandBlockTimers) {
      let timer = data.commandBlockTimers[id]
      this.game.addCommandBlockTimer(timer)
    }

    this.purchasables = data.purchasables
    this.isCustomSell = data.isCustomSell
    this.isPrivate = data.isPrivate
    this.cameraFeeds = data.cameraFeeds

    this.undergroundMap = new Grid("underground", this, this.getRowCount(), this.getColCount())
    this.groundMap = new Grid("ground", this, this.getRowCount(), this.getColCount())
    this.map = new Grid("foreground", this, this.getRowCount(), this.getColCount())
    this.corpseMap = new Grid("corpse", this, this.getRowCount(), this.getColCount())

    this.initGrids()
    this.initRoomAlertManager()
    this.initClientContainer()
    this.initProgressCircle()

    // will need to cleanup objects eventually
    this.starmapLocations = {}
    this.players = {}
    this.terminalMessages = []
    this.ships = {}
    this.originalColors = {}
    this.mobs = {}
    this.units = {}
    this.pickups = {}
    this.projectiles = {}
    this.backgrounds = []
    this.terrains = {}
    this.buildings = {}
    this.transports = {}
    this.plants = {}
    this.chunkRegions = {}
    this.chunkRegionPaths = {}
    this.entityToChunkRegionPaths = {}
    this.chunksToCache = {}
    this.originalPlayers = {}
    this.bars = {}
    this.regionTree = rbush()
    this.regionTree.name = 'regionTree'

    this.entities = {}
    this.hangars = {}

    this.movableGroupSet = new Set()
    this.movableGroups = ["transports", "ships", "corpses", "players", "mobs", "units", "projectiles", "pickups"]
    this.movableGroups.forEach((group) => {
      this.movableGroupSet.add(group)
    })

    this.backgroundGroups = ["backgrounds"]
    this.roomGroups    = ["rooms"]
    this.homeAreaGroups = ["home_areas"]
    this.tileGroups    = ["buildings"]
    this.clientDebugGroups = ["paths", "regions", "light_paths"]
    this.networkGroups = ["power", "oxygen", "liquid", "fuel", "rail", "soil"]

    // chunkable
    this.terrainGroups = ["undergrounds", "grounds", "foregrounds"]
    this.buildingGroups = ["platforms", "liquidDistributions", "gasDistributions", "fuelDistributions", "distributions"]
    this.wallGroups    = ["armors"]
    this.structureGroups = ["structures"]
    this.ceilingGroups = ["ceilings"]

    this.initLightManager()

    this.initSprite()
    this.initSelection()
    this.initChunks() // need to be loaded after initSprite
    this.renderBackgrounds()

    this.initHomeArea()
    this.game.teamMenu.renderScreenshots(this)
    this.game.mapMenu.resizeCanvas(this)

    if (this.isMiniGame() && this.isPrivate) {
      this.game.showMiniGameInviteLink()
    }

    if (this.isMiniGame()) {
      document.body.classList.add("minigame")
    } else {
      document.body.classList.remove("minigame")
    }

    this.initialLoadTime = Date.now()

  }

  setMobCustomStats(type, stats) {
    this.mobCustomStats[type] = stats
  }

  setBuildingCustomStats(type, stats) {
    this.buildingCustomStats[type] = stats
  }

  setEntityCustomStats(id, stats) {
    this.entityCustomStats[id] = stats

    if (id === this.game.playerId) {
      this.game.updateHealthBar(this.game.player.health, this.game.player.getMaxHealth())
    }
  }

  setSettings(settings) {
    for (let key in settings) {
      let prevValue = this.settings[key]
      let value = settings[key]

      if (prevValue !== value) {
        this.settings[key] = value
        this.onSettingsChanged(key, value)
      }
    }
  }

  getRegionBuildPermission(x, y, w, h) {
    let padding = 1
    let boundingBox = {
      minX: x - w/2 + padding,
      minY: y - h/2 + padding,
      maxX: x + w/2 - padding,
      maxY: y + w/2 - padding
    }

    let regions = this.regionTree.search(boundingBox)
    if (regions.length === 0) return null

    let region

    if (regions.length > 1) {
      // highest priority
      region = regions.sort((a, b) => {
        let priorityA = parseInt(a.getFlag("priority") || 0)
        let priorityB = parseInt(b.getFlag("priority") || 0)
        return priorityB - priorityA
      })[0]
    } else {
      region = regions[0]
    }

    return region.getFlag("build")
  }


  addRegion(region) {
    this.regions[region.id] = region
  }

  removeRegion(region) {
    delete this.regions[region.id]
  }

  addButton(button) {
    this.buttons[button.id] = button
  }

  removeButton(button) {
    delete this.buttons[button.id]
  }

  getButtonsFor(klassName) {
    let result = []

    for (let id in this.buttons) {
      let button = this.buttons[id]
      if (button.isAttachedTo(klassName)) {
        result.push(button)
      }
    }

    return result
  }

  setIsPrivate(isPrivate) {
    this.isPrivate = isPrivate
  }

  getOriginalUid() {
    if (this.isMiniGame()) {
      return this.uid.split(/mini-(.*)-/)[1]
    }

    return this.uid
  }

  getTimerBombKlass() {
    return Buildings.NonBuidables.TimerBomb
  }

  onSettingsChanged(key, value) {
    if (key === "isZoomAllowed") {
      this.game.autoAdjustResolution()
    }
    
    if (key === "isFovMode") {
      if (this.isFovMode()) {
        this.applyFovMaskToLight()
        this.lightManager.applyFov()
      } else {
        this.lightManager.removeFov()
        this.removeFovMaskFromLight()
      }
      
      this.game.mapMenu.clearMapPositions()
      this.game.mapMenu.redrawEntityMap()
    }

    if (key === "showMiniMap") {
      if (this.shouldShowMiniMap()) {
        document.querySelector("#mini_map_menu").style.display = 'block'
        document.querySelector("#mini_map_player_pos_label").style.display = 'block'
        document.querySelector("#entity_menu").classList.remove("no_minimap")
      } else {
        document.querySelector("#mini_map_menu").style.display = 'none'
        document.querySelector("#mini_map_player_pos_label").style.display = 'none'
        document.querySelector("#entity_menu").classList.add("no_minimap")
      }
    }

    if (key === "showPlayerList") {
      if (this.shouldShowPlayerList()) {
        document.querySelector("#team_status_menu").style.display = 'block'
      } else {
        document.querySelector("#team_status_menu").style.display = 'none'
      }
    }

    if (key === "showTeamJoin") {
      if (this.settings.showTeamJoin) {
        this.game.teamMenu.showTeamJoinTab()
      } else {
        this.game.teamMenu.hideTeamJoinTab()
      }
    }

    if (key === "isStaminaEnabled") {
      if (this.settings.isStaminaEnabled) {
        this.game.showStaminaBar()
      } else {
        this.game.hideStaminaBar()
      }
    }

    if (key === "isHungerEnabled") {
      if (this.settings.isHungerEnabled) {
        this.game.showHungerBar()
      } else {
        this.game.hideHungerBar()
      }
    }

    if (key === "isOxygenEnabled") {
      if (this.settings.isOxygenEnabled) {
        this.game.showOxygenBar()
      } else {
        this.game.hideOxygenBar()
      }
    }

    if (key === "isChatEnabled") {
      if (this.settings.isChatEnabled) {
        document.querySelector("#chat_toggle_btn").style.display = 'block'
        this.game.chatMenu.close()
      } else {
        document.querySelector("#chat_toggle_btn").style.display = 'none'
        this.game.chatMenu.hide()
      }
    }

    if (key === "isShadowsEnabled") {
      this.game.sector.lightManager.setDarkness(this.game.hour)
    }

    if (key === "isCraftingEnabled") {
      if (this.settings.isCraftingEnabled) {
        document.querySelector("#blueprint_open_btn").style.display = 'block'
      } else {
        document.querySelector("#blueprint_open_btn").style.display = 'none'
      }
    }

  }

  setBuildSpeed(buildSpeed) {
    this.buildSpeed = buildSpeed
  }

  shouldShowChat() {
    return this.settings.isChatEnabled
  }

  shouldShowMiniMap() {
    return this.settings.showMiniMap
  }

  shouldShowPlayerList() {
    return this.settings.showPlayerList
  }

  setSellables(sellables) {
    this.sellables = sellables
    this.game.tradeMenu.initSellables()
  }

  setIsCustomSell(isCustomSell) {
    this.isCustomSell = isCustomSell
    this.game.tradeMenu.initPurchasables()
  }

  setPurchasables(purchasables) {
    this.purchasables = purchasables
  }

  getName() {
    return this.name
  }

  setSectorBans(sectorBans) {
    this.sectorBans = sectorBans
  }

  updateScreenshot(data) {
    if (data.clientMustDelete) {
      delete this.screenshots[data.id]
    } else {
      this.screenshots[data.id] = data.position
    }
  }

  getScreenshotCount() {
    return Object.keys(this.screenshots).length
  }

  showTutorialQuests(data) {
    if (data.name !== "Lobby") {
      this.game.tutorialMenu.open()
    }
  }

  isTutorial() {
    return this.name === "Tutorial Lobby"
  }

  isMiniGame() {
    return this.uid.match(/mini-.*-/)
  }

  onEntityChunkRegionPath(data) {
    this.entityToChunkRegionPaths[data.entityId] = this.entityToChunkRegionPaths[data.entityId] || {}
    this.entityToChunkRegionPaths[data.entityId][data.chunkRegionPath.id] = true

    this.syncWithServerForGroups(["chunkRegionPaths"], {
      chunkRegionPaths: [data.chunkRegionPath]
    })
  }

  getChunkRegionPathsFromEntityId(entityId) {
    let chunkRegionPathSet = this.entityToChunkRegionPaths[entityId]
    if (!chunkRegionPathSet) return []

    let chunkRegionPaths = []
    for (let chunkRegionPathId in chunkRegionPathSet) {
      let chunkRegionPath = this.chunkRegionPaths[chunkRegionPathId]
      if (chunkRegionPath) {
        chunkRegionPaths.push(chunkRegionPath)
      }
    }

    return chunkRegionPaths
  }

  isZoomAllowed() {
    if (this.isPvP()) return false
    return this.settings.isZoomAllowed
  }

  isPvP() {
    return this.gameMode === 'pvp'
  }

  isPeaceful() {
    return this.gameMode === 'peaceful'
  }

  isHardcore() {
    return this.gameMode === 'hardcore'
  }

  setGameMode(gameMode) {
    if (this.gameMode !== gameMode) {
      this.gameMode = gameMode
      this.onGameModeChanged()
    }
  }

  onGameModeChanged() {
    this.game.selectDifficultyMenu.close()
  }

  initSelection() {
    this.selection           = new Selection(this)
    this.persistentSelection = new Selection(this)
  }

  getRadAngle() {
    return this.angle * (Math.PI / 180)    
  }

  isLobby() {
    return this.name === "Lobby"
  }

  pick(row, col, globalMousePos, shouldIgnoreDynamic = false) {
    // dynamic units
    let dynamicEntity 
    let corpseEntity

    if (!shouldIgnoreDynamic) {
      dynamicEntity = this.pickUnit(row, col, globalMousePos)
      corpseEntity = this.pickCorpse(row, col, globalMousePos)
    }

    // foreground (i.e asteroid)
    let foregroundEntity = this.map.get(row, col)
    if (foregroundEntity) {
      return foregroundEntity
    }

    if (this.game.player.dragTargetId) {
      // prefer structure over corpse
      let structureEntity = this.structureMap.get(row, col)
      if (structureEntity) {
        return structureEntity
      }

      if (corpseEntity) {
        return corpseEntity
      }
    } else {
      // prefer corpse over structure
      if (corpseEntity) {
        return corpseEntity
      }

      let structureEntity = this.structureMap.get(row, col)
      if (structureEntity) {
        return structureEntity
      }
    }

    if (dynamicEntity) {
      return dynamicEntity
    }

    // static
    let grids = [
      this.armorMap,
      this.liquidDistributionMap,
      this.fuelDistributionMap,
      this.gasDistributionMap,
      this.distributionMap,
      this.railMap,
      this.platformMap,
      this.groundMap,
      this.undergroundMap
    ]

    let entity = null

    // static tiles first (asteroid/structure picked over player)
    for (var i = 0; i < grids.length; i++) {
      let grid = grids[i]
      entity = grid.get(row, col)
      if (entity) {
        break
      }
    }

    return entity
  }

  pickUnit(row, col, globalMousePos) {
    let entity
    let units = this.unitMap.get(row, col)

    if (units && Object.keys(units).length > 0) {
      let sortedEntities = Object.values(units).sort((a, b) => {
        let distanceA = Helper.distance(a.getX(), a.getY(), globalMousePos.x, globalMousePos.y)
        let distanceB = Helper.distance(b.getX(), b.getY(), globalMousePos.x, globalMousePos.y)

        return distanceA - distanceB
      }).filter((unit) => {
        return !unit.isHiddenFromView()
      })

      entity = sortedEntities[0]
    }

    return entity
  }

  pickCorpse(row, col, globalMousePos) {
    let entity
    let units = this.corpseMap.get(row, col)

    if (units && Object.keys(units).length > 0) {
      let sortedEntities = Object.values(units).sort((a, b) => {
        let distanceA = Helper.distance(a.getX(), a.getY(), globalMousePos.x, globalMousePos.y)
        let distanceB = Helper.distance(b.getX(), b.getY(), globalMousePos.x, globalMousePos.y)

        return distanceA - distanceB
      })

      entity = sortedEntities[0]
    }

    return entity
  }

  // here to avoid circuler dependency
  getConduitTexturesForRole(role) {
    let textures = null

    switch (role) {
      case "power":
        textures = Wire.getTextures()
        break
      case "liquid":
        textures = LiquidPipe.getTextures()
        break
      case "oxygen":
        textures = GasPipe.getTextures()
        break
      case "fuel":
        textures = FuelPipe.getTextures()
        break
    }

    return textures
  }

  getSpriteLayerForChunk(group, chunkRow, chunkCol) {
    let chunk = this.getChunk(chunkRow,chunkCol)
    if (!chunk) return null
      
    return chunk.getSpriteLayer(group)
  }

  initChunks() {
    const numOfTilesInRow  = this.getColCount()

    this.chunks = {}
    this.NUM_CHUNKS_IN_ROW = numOfTilesInRow / Constants.chunkRowCount
    this.NUM_CHUNKS_IN_COL = numOfTilesInRow / Constants.chunkRowCount
  }

  getChunkRegionById(id) {
    return this.chunkRegions[id]
  }

  getChunk(row, col) {
    if (row < 0 || row > this.NUM_CHUNKS_IN_ROW - 1) return null
    if (col < 0 || col > this.NUM_CHUNKS_IN_COL - 1) return null

    let chunkKey = Chunk.getKey(row, col)
    if (!this.chunks[chunkKey]) {
      this.chunks[chunkKey] = new Chunk(this, row, col)
    }

    return this.chunks[chunkKey]
  }

  forEachChunk(cb) {
    for (let chunkKey in this.chunks) {
      cb(this.chunks[chunkKey])
    }
  }

  getEntity(id) {
    return this.entities[id]
  }

  registerGlobalEntity(entity) {
    this.entities[entity.id] = entity
  }

  unregisterGlobalEntity(entity) {
    delete this.entities[entity.id]
  }

  initLightManager() {
    this.lightManager = new LightManager(this)
  }

  initHomeArea() {
    this.homeArea = new HomeArea(this)
  }

  nightMode() {
    this.lightManager.nightMode()
  }

  dayMode() {
    this.lightManager.dayMode()
  }

  initSprite() {
    this.sprite = this.getSprite()
    this.postInitSprite()
  }

  initRoomAlertManager() {
    this.roomAlertManager = new RoomAlertManager(this)
  }

  initPlayers(data) {
    this.setOriginalPlayerList(data.players)

    for(let i in data.players) {
      let playerData = data.players[i]
      let player = new Player(playerData, this)
      this.players[player.id] = player
    }
  }

  setOriginalPlayerList(players) {
    this.originalPlayers = players

    for (let id in players) {
      let player = players[id]
      if (player.equipments.storage[0]) {
        let color = player.equipments.storage[0].instance.content
        this.originalColors[player.id] = color
      }
    }
  }

  addToOriginalPlayers(player) {
    this.originalPlayers[player.id] = player

    if (player.equipments.storage[0]) {
      let color = player.equipments.storage[0].instance.content
      this.originalColors[player.id] = color
    }
  }

  removeFromOriginalPlayers(playerId) {
    delete this.originalPlayers[playerId]
  }

  setOriginalPlayerLeft(playerId) {
    if (this.originalPlayers[playerId]) {
      this.originalPlayers[playerId].hasLeftGame = true
    }
  }

  destroyTextures() {
    if (this.backgroundSprite) {
      this.backgroundSprite.texture.destroy()
    }

    for (let id in this.chunks) {
      let chunk = this.chunks[id]
      chunk.cleanup()
    }

    if (this.progressCircle && this.progressCircle.graphicsData) {
      this.progressCircle.destroy()
    }
  }

  registerBar(bar) {
    this.bars = this.bars || {}
    this.bars[bar.entity.getId()] = bar
  }

  unregisterBar(bar) {
    delete this.bars[bar.entity.getId()]
  }

  getBar(entity) {
    return this.bars[entity.getId()]
  }

  cleanup() {
    this.bars = {}
    this.originalColors = {}
    this.buttons = {}
    this.settings = {}

    this.regionTree.clear()

    ObjectPool.reset()
    this.destroyTextures()
    this.lightManager.cleanup()

    let collections = [
      this.movableGroups,
      this.terrainGroups,
      this.clientDebugGroups,
      this.roomGroups,
      this.buildingGroups,
      this.structureGroups,
      this.wallGroups,
      this.ceilingGroups,
      this.tileGroups
    ]

    collections.forEach((groups) => {
      groups.forEach((group) => {
        this.removeAllEntities(group)
      })
    })

    this.initGrids()

    this.removeAllEntities("terrains")

    this.backgroundGroups.forEach((group) => {
      this.removeAllNonIdEntities(group)
    })

    if (this.groundEffectsContainer) {
      this.groundEffectsContainer.children.forEach((sprite) => {
        ClientHelper.removeSelfAndChildrens(sprite)
      })
    }

    this.effectsContainer.children.forEach((sprite) => {
      ClientHelper.removeSelfAndChildrens(sprite)
    })

    this.roomAlertManager.clear()

    this.invalidAreaSprite.alpha = 0

    this.entities = {}

  }

  remove() {
    this.cleanup()
    ClientHelper.removeSelfAndChildrens(this.sprite)
  }

  renderBackgrounds() {
    let starCount = 50
    let backgrounds = []

    for (var i = 0; i < starCount; i++) {
      backgrounds.push(this.randomStar())
    }

    this.renderBackgroundGroup(backgrounds)
  }

  randomStar() {
    let tileCount = 32
    const randomRow = Math.floor(Math.random() * tileCount)
    const randomCol = Math.floor(Math.random() * tileCount)
    const randomWidth = Math.floor(Math.random() * 3) + 2

    return {
      x: randomCol * Constants.tileSize,
      y: randomRow * Constants.tileSize,
      w: randomWidth,
      h: randomWidth,
      type: Protocol.definition().BackgroundType.Star
    }
  }

  renderBackgroundGroup(backgrounds) {
    let sprites = []
    for (var i = 0; i < backgrounds.length; i++) {
      let data = backgrounds[i]
      let sprite = Backgrounds.forType(data.type).build(this.game, data)
      sprites.push(sprite)
    }
    
    this.backgroundSpriteContainer.alpha = 1
    let tileCount = 32
    let texture = PIXI.RenderTexture.create(tileCount * Constants.tileSize, tileCount * Constants.tileSize)
    this.game.app.renderer.render(this.backgroundSpriteContainer, texture)
    if (this.backgroundSpriteContainer.parent) {
      this.backgroundSpriteContainer.parent.removeChild(this.backgroundSpriteContainer)
    }

    for (var i = 0; i < sprites.length; i++) {
      sprites[i].remove()
    }

    this.backgroundSprite.texture = texture
  }

  onRemovePlayer(data) {
    const targetPlayer = this.players[data.playerId]

    if (targetPlayer) {
      this.removeEntity(targetPlayer, "players")
    }

  }

  onCollisionDetected(data) {
    if (this.prevBoxes) {
      this.prevBoxes.forEach((box) => {
        this.effectsContainer.removeChild(box.graphics)
        this.effectsContainer.removeChild(box.text)
      })

      this.prevBoxes = []
    }

    this.drawBox(data.sourceBox, 0xff0000)
    this.drawBox(data.otherBox, 0x00ff00)
  }

  onCircleCollision(data) {
    if (this.prevCircles) {
      this.prevCircles.forEach((circle) => {
        circle.parent.removeChild(circle)
      })

      this.prevCircles = []
    }

    data.circles.forEach((data) => {
      this.drawCircle(data, 0x0000ff)
    })

  }

  drawCircle(circle, color) {
    let graphics = new PIXI.Graphics()
    graphics.position.x = circle.x
    graphics.position.y = circle.y
    graphics.beginFill(color)
    graphics.drawCircle(0, 0, circle.radius)
    graphics.endFill()
    graphics.alpha = 0.3
    this.effectsContainer.addChild(graphics)

    this.prevCircles = this.prevCircles || []
    this.prevCircles.push(graphics)
  }

  initProgressCircle() {
    this.progressCircleContainer = new PIXI.Container()
    this.progressCircleContainer.name = 'ProgressCircleContainer' 
    this.progressCircleContainer.position.y = -96

    let blackCircle = new PIXI.Sprite(PIXI.utils.TextureCache['white_gas.png'])
    blackCircle.anchor.set(0.5)
    blackCircle.tint = 0x000000
    blackCircle.width = 96
    blackCircle.height = 96
    blackCircle.alpha = 0.5
    this.progressCircleContainer.addChild(blackCircle)

    this.progressCircle = new PIXI.Graphics()
    this.progressCircleAngle = 0

    this.progressCircleContainer.addChild(this.progressCircle)
  }

  startProgressCircle(completeTimestamp) {
    this.game.player.sprite.addChild(this.progressCircleContainer)
    this.progressCircleContainer.visible = true

    this.progressCircle.clear()
    this.progressCircleAngle = 0

    this.progressCircleStartTimestamp = this.game.timestamp
    this.progressCircleCompleteTimestamp = completeTimestamp
  }

  hideProgressCircle() {
    this.progressCircleContainer.parent.removeChild(this.progressCircleContainer)
    this.progressCircleContainer.visible = false

    this.progressCircleCompleteTimestamp = null
  }

  renderProgressCircle() {
    let padding = 3
    let duration = this.progressCircleCompleteTimestamp - this.progressCircleStartTimestamp - padding
    let elapsed = this.game.timestamp - this.progressCircleStartTimestamp
    let percentComplete = elapsed / duration

    let cx = 0
    let cy = 0
    let radius = 30
    let startAngle = 0
    let endAngle = Math.PI * 2 * percentComplete

    if (this.progressCircleTween) {
      this.progressCircleTween.stop()
    }

    let angle = { angle: this.progressCircleAngle }
    this.progressCircleTween = new TWEEN.Tween(angle)
        .to({ angle: endAngle }, 300)
        .onUpdate(() => {
          this.progressCircle.clear()
          this.progressCircle.lineStyle(6, 0xCCCCCC, 0.9)
          this.progressCircle.arc(cx, cy, radius, startAngle, angle.angle)
          this.progressCircleAngle = angle.angle
        })

    this.progressCircleTween.start()
  }

  drawBox(box, color) {
    let graphics = new PIXI.Graphics()
    graphics.position.x = box.pos.x
    graphics.position.y = box.pos.y
    graphics.lineStyle(2, color)
    graphics.drawRect(0, 0, box.w, box.h)
    this.effectsContainer.addChild(graphics)

    const style  = { fontFamily : 'Arial', fontSize: 20, fill : 0xffd700, align : 'center', strokeThickness: 5, miterLimit: 3 }
    const text = new PIXI.Text([box.pos.x, box.pos.y, box.w, box.h].join(","), style)
    text.position.x = box.pos.x
    text.position.y = box.pos.y
    this.effectsContainer.addChild(text)

    this.prevBoxes = this.prevBoxes || []
    this.prevBoxes.push({ graphics: graphics, text: text })
  }

  box(x, y, container) {
    let graphics = new PIXI.Graphics()
    graphics.position.x = x
    graphics.position.y = y
    graphics.lineStyle(2, 0xff0000)
    graphics.drawRect(0, 0, 100, 100)
    container.addChild(graphics)
  }

  onPlayerLeave(data) {
    const targetPlayer = this.players[data.id]

    if (targetPlayer) {
      this.removeEntity(targetPlayer, "players")
    }
  }

  getInvalidAreaSprite() {
    const sprite = new PIXI.Sprite(PIXI.utils.TextureCache["red.png"])
    sprite.name = "InvalidArea"
    sprite.anchor.set(0.5)
    sprite.alpha = 0
    return sprite
  }

  getRegionAreaSprite() {
    const sprite = new PIXI.Sprite(PIXI.utils.TextureCache["green.png"])
    sprite.name = "Region"
    sprite.anchor.set(0.5)
    sprite.alpha = 0
    return sprite
  }

  getSprite() {
    const sprite = new PIXI.Container()
    sprite.name = "Sector"
    this.gameBoundsSprite           = this.getGameBoundsSprite()
    this.backgroundSpriteContainer  = new PIXI.Container()
    this.backgroundSpriteContainer.alpha = 0

    // z-order based on add order
    sprite.addChild(this.gameBoundsSprite)
    sprite.addChild(this.backgroundSpriteContainer)

    return sprite
  }

  drawRange(box) {
    if (this.rangeBox) {
      this.rangeBox.parent.removeChild(this.rangeBox)
    }

    this.rangeBox = new PIXI.Graphics()
    this.rangeBox.beginFill(0x00ff00)
    this.rangeBox.drawRect(box.pos.x, box.pos.y, box.w, box.h)
    this.rangeBox.endFill()
    this.rangeBox.alpha = 0.3
    this.effectsContainer.addChild(this.rangeBox)
  }

  getVisibleArea() {
    const screenWidth = window.innerWidth / this.game.resolution
    const screenHeight = window.innerHeight / this.game.resolution

    let visibleTopLeftY = Math.max(0, -this.game.cameraDisplacement.y - screenHeight/2)
    let visibleTopLeftX = Math.max(0, -this.game.cameraDisplacement.x - screenWidth/2)

    let visibleBottomRightY = visibleTopLeftY + screenHeight
    let visibleBottomRightX = visibleTopLeftX + screenWidth

    const visibleTopLeftRow = Math.floor(visibleTopLeftY / Constants.tileSize)
    const visibleTopLeftCol = Math.floor(visibleTopLeftX / Constants.tileSize)
    const visibleBottomRightRow = Math.floor(visibleBottomRightY / Constants.tileSize)
    const visibleBottomRightCol = Math.floor(visibleBottomRightX / Constants.tileSize)

    const visibleRowCount = visibleBottomRightRow - visibleTopLeftRow + 1
    const visibleColCount = visibleBottomRightCol - visibleTopLeftCol + 1

    return {
      topLeft: {
        x: visibleTopLeftX,
        y: visibleTopLeftY,
        row: visibleTopLeftRow,
        col: visibleTopLeftCol
      },
      bottomRight: {
        x: visibleBottomRightX,
        y: visibleBottomRightY,
        row: visibleBottomRightRow,
        col: visibleBottomRightCol
      },
      rowCount: visibleRowCount,
      colCount: visibleColCount
    }
  }

  getHangarFadeBlackSprite() {
    let sprite = new PIXI.Sprite(PIXI.utils.TextureCache["black.png"])
    sprite.name = "hangar_fade_black"
    sprite.alpha = 0
    sprite.width = window.innerWidth
    sprite.height = window.innerHeight
    sprite.anchor.set(0.5)
    return sprite
  }

  getHangarBackgroundSprite() {
    let sprite = new PIXI.extras.TilingSprite(PIXI.utils.TextureCache["hangar_background.png"])
    sprite.name = "hangar_background"
    sprite.alpha = 0
    sprite.anchor.set(0.5)
    return sprite
  }

  showHangarBackgroundSprite(region) {
    this.hangarBackgroundSprite.alpha = 0.7
    this.hangarBackgroundSprite.position.x = region.getX()
    this.hangarBackgroundSprite.position.y = region.getY()
    this.hangarBackgroundSprite.width = region.getWidth()
    this.hangarBackgroundSprite.height = region.getHeight()
  }

  hideHangarBackgroundSprite() {
    this.hangarBackgroundSprite.alpha = 0
  }

  showHangarFadeBlackSprite() {
    this.repositionFadeBlackSprite()
    this.getHangarFadeBlackTween(0, 0.9).start()
  }

  repositionFadeBlackSprite() {
    if (this.game.player) {
      this.hangarFadeBlackSprite.position.x = this.game.player.getX()
      this.hangarFadeBlackSprite.position.y = this.game.player.getY()
    }
  }

  hideHangarFadeBlackSprite() {
    this.getHangarFadeBlackTween(0.9, 0).start()
  }

  getHangarFadeBlackTween(start, end) {
    let opacity = { opacity: start }
    let sprite = this.hangarFadeBlackSprite

    return new TWEEN.Tween(opacity)
        .to({ opacity: end }, 500)
        .easing(TWEEN.Easing.Quadratic.Out)
        .onUpdate(() => {
          sprite.alpha = opacity.opacity
        })
  }

  postInitSprite() {
    this.backgroundSprite  = new PIXI.extras.TilingSprite(PIXI.utils.TextureCache["hangar_background.png"], this.getSectorWidth(), this.getSectorHeight())
    this.backgroundSprite.name = "Backgrounds" 
    this.sprite.addChild(this.backgroundSprite)

    this.createSpriteLayersFor(this.sprite, this.terrainGroups)
    this.createSpriteLayersFor(this.sprite, this.buildingGroups)
    this.createSpriteLayersFor(this.sprite, this.wallGroups)

    this.hangarFadeBlackSprite = this.getHangarFadeBlackSprite()
    this.sprite.addChild(this.hangarFadeBlackSprite)

    this.hangarBackgroundSprite = this.getHangarBackgroundSprite()
    this.sprite.addChild(this.hangarBackgroundSprite)

    this.hangarContainer = new PIXI.Container()
    this.hangarContainer.name = "HangarContainer"
    this.sprite.addChild(this.hangarContainer)

    this.groundEffectsContainer = new PIXI.Container()
    this.groundEffectsContainer.name = "GroundEffects"
    this.sprite.addChild(this.groundEffectsContainer)

    this.highGroundEffectsContainer = new PIXI.Container()
    this.highGroundEffectsContainer.name = "HighGroundEffects"
    this.sprite.addChild(this.highGroundEffectsContainer)

    this.createSpriteLayersFor(this.sprite, this.structureGroups)
    this.createSpriteLayersFor(this.sprite, this.clientDebugGroups)

    this.createSpriteLayersFor(this.sprite, this.movableGroups)
    this.createSpriteLayersFor(this.sprite, this.roomGroups)
    this.createSpriteLayersFor(this.sprite, this.homeAreaGroups)

    this.createSpriteLayersFor(this.sprite, this.ceilingGroups)
    this.createSpriteLayersFor(this.sprite, this.networkGroups)

    this.invalidAreaSprite = this.getInvalidAreaSprite()
    this.regionAreaSprite = this.getRegionAreaSprite()

    this.rangeContainerSprite = this.createSpriteLayer("Range")

    this.effectsContainer  = new PIXI.Container()
    this.effectsContainer.name = "Effects"

    this.createLightMapContainer()

    this.chunkDebugSprite = new PIXI.Container()
    this.chunkDebugSprite.name = "ChunkDebugContainer"

    this.chunkRegionContainer = new PIXI.Container()
    this.chunkRegionContainer.name = "ChunkRegionContainer"

    this.regionContainer = new PIXI.Container()
    this.regionContainer.name = "RegionContainer"
    this.regionContainer.visible = false

    this.sprite.addChild(this.lightMapContainer)
    this.sprite.addChild(this.rangeContainerSprite)
    this.sprite.addChild(this.invalidAreaSprite)
    this.sprite.addChild(this.regionAreaSprite)
    this.sprite.addChild(this.chunkDebugSprite)
    this.sprite.addChild(this.chunkRegionContainer)
    this.sprite.addChild(this.regionContainer)
    this.sprite.addChild(this.effectsContainer)
  }

  createLightMapContainer() {
    this.lightMapContainer = new PIXI.Container()
    this.lightMapContainer.alpha = 0.95
    if (this.game.isCanvasMode()) {
      this.lightMapContainer.alpha = 0
    }
    
    let multiplyBlend = new PIXI.filters.AlphaFilter()
    multiplyBlend.blendMode = PIXI.BLEND_MODES.MULTIPLY
    this.lightMapContainer.filters = [multiplyBlend]

    this.skyMapSprite = new PIXI.Sprite()
    this.skyMapSprite.width  = this.getSectorWidth()
    this.skyMapSprite.height = this.getSectorHeight()
    this.skyMapSprite.texture = PIXI.Texture.fromCanvas(this.lightManager.skyMapCanvas)
    this.skyMapSprite.name = 'SkyMapSprite'


    this.dynamicLightSprite = new PIXI.Container()
    this.dynamicLightSprite.name = "DynamicLightSprite"
    // this.dynamicLightSprite.filters = [alphaFilter]

    this.fovMapSprite = new PIXI.Sprite()
    this.fovMapSprite.width  = this.getSectorWidth()
    this.fovMapSprite.height = this.getSectorHeight()
    this.fovMapSprite.name = "FovMap"
    this.fovMapSprite.texture = PIXI.Texture.fromCanvas(this.lightManager.fovMapCanvas)
    

    this.lightMapSprite = new PIXI.Sprite()
    this.lightMapSprite.width  = this.getSectorWidth()
    this.lightMapSprite.height = this.getSectorHeight()
    this.lightMapSprite.name = "LightMap"
    this.lightMapSprite.texture = PIXI.Texture.fromCanvas(this.lightManager.lightMapCanvas)

    // this.illuminationContainer.addChild(this.dynamicLightSprite)
    // this.illuminationContainer.addChild(this.lightMapSprite)

    this.detailedLightMapContainer = new PIXI.Container()
    this.detailedLightMapContainer.width  = this.getSectorWidth()
    this.detailedLightMapContainer.height = this.getSectorHeight()
    this.detailedLightMapContainer.name = "DetailedLightMapContainer"

    this.sprite.addChild(this.fovMapSprite)

    this.lightMapContainer.addChild(this.skyMapSprite)
    this.lightMapContainer.addChild(this.dynamicLightSprite)
    this.lightMapContainer.addChild(this.lightMapSprite)
  }

  isFovMode() {
    return this.settings.isFovMode
  }

  applyFovMaskToLight() {
    this.lightMapSprite.mask = this.fovMapSprite
    this.dynamicLightSprite.mask = this.fovMapSprite
  }

  removeFovMaskFromLight() {
    this.lightMapSprite.mask = null
    this.dynamicLightSprite.mask = null
  }

  addTerminalMessage(message) {
    if (this.terminalMessages.length >= 200) {
      this.terminalMessages.shift()
    }

    this.terminalMessages.push(message)
  }

  onSelectionChanged(entity) {
    if (!entity) return

    if (this.game.main.isMobile) {
      if (entity.isMob() ) {
        if (entity.isMountable(this.game.player)) {
          this.game.setMobileAction("mount")
        }
      } else if (entity.isBuildingType() && entity.isInteractable()) {
        if (entity.isItemStorage()) {
          this.game.setMobileAction("open")
        } else if (entity.hasCategory("switch")) {
          if (entity.isOpen) {
            this.game.setMobileAction("off")
          } else {
            this.game.setMobileAction("on")
          }
        } else if (entity.hasCategory("door")) {
          if (entity.isOpen) {
            this.game.setMobileAction("close")
          } else {
            this.game.setMobileAction("open")
          }
        } else if (entity.hasCategory("ammo_turret")) {
          this.game.setMobileAction("open")
        } else if (entity.isProducer()) {
          this.game.setMobileAction("use")
        } else if (entity.isHarvestable) {
          this.game.setMobileAction("pick")
        } else if (entity.getConstants().interactButtonMessage) {
          this.game.setMobileAction(entity.getConstants().interactButtonMessage)
        } else if (entity.isUsable()) {
          this.game.setMobileAction("use")
        } else {
          this.game.setDefaultMobileAction()
        }
      } else if (entity.isForegroundTile() && this.game.player.hasMineTarget()) { 
        this.game.setMobileAction("mine")
      } else if (entity.isCorpse()) { 
        if (this.game.player.dragTargetId === entity.id) {
          this.game.setMobileAction("release")
        } else {
          this.game.setMobileAction("drag")
        }
      } else {
        this.game.setDefaultMobileAction()
      }
    } else {
      if (entity.shouldShowInteractTooltip()) {
        this.game.showActionTooltip(entity)
      }
    }
  }

  onSelectionRemoved(entity) {
    if (this.game.main.isMobile) {
      this.game.setDefaultMobileAction()
    } else {
      this.game.hideActionTooltip(entity)
    }
  }


  showStarMap() {
    this.starMap.visible = true
  }

  hideStarMap() {
    this.starMap.visible = false
  }

  highlight(entity) {
    this.selection.highlight(entity)
  }

  unhighlight(entity) {
    this.selection.unhighlight(entity)
  }

  select(entity) {
    if (this.game.isMobile()) return

    this.persistentSelection.highlight(entity)
  }

  unselect(entity) {
    if (this.game.isMobile()) return

    this.persistentSelection.unhighlight(entity)
  }

  setLocations(data) {
    let x = 200
    let y = window.innerHeight/2
    for (var i = 0; i < data.locations.length; i++) {
      let location = data.locations[i]
      location.x = x + i * 200
      location.y = y
      this.starmapLocations[location.id] = new StarmapLocation(this.game, location)
    }
  }

  getGameBoundsSprite() {
    const sprite = new PIXI.Sprite(PIXI.utils.TextureCache["square_white.png"])
    sprite.name = "GameBounds"
    // sprite.tint = 0x4f495f // light purple
    sprite.tint = 0x00ff00 // bright green for debuggability
    sprite.tint = 0x112944
    sprite.width  = this.getSectorWidth()
    sprite.height = this.getSectorHeight()
    return sprite
  }

  syncWithServer(data) {
    this.lightManager.updateLightMapTexture()
    this.lightManager.redrawChangedLightSources()

    if (this.progressCircleCompleteTimestamp) {
      this.renderProgressCircle()
    }
  }

  onChunk(data, options = {}) {
    this.arrayifyChunkEntityData(data)

    let chunk = this.getChunk(data.row, data.col)
    if (chunk) {
      chunk.removeStale(data)
    }

    this.syncTerrains(data, options)
    this.syncWithServerForGroups(["buildings"], data, options)
    this.syncWithServerForGroups(["players"], data, options)
    this.syncWithServerForGroups(["corpses"], data, options)
    this.syncWithServerForGroups(["projectiles"], data, options)
    this.syncWithServerForGroups(["rooms"], data, options)
    this.syncWithServerForGroups(["mobs"], data, options)
    this.syncWithServerForGroups(["pickups"], data, options)

    this.onFullChunkReceived()
  }

  onFullChunkReceived() {
    if (this.isFovMode()) {
      this.reapplyFov()
    }
  }

  reapplyFov() {
    if (this.game.player && this.game.player.isSpectating()) return
      
    clearTimeout(this.reapplyFovTimeout)

    this.reapplyFovTimeout = setTimeout(() => {
      this.lightManager.applyFov()
    }, 500)
  }

  addChunksToCache(chunk) {
    this.chunksToCache[chunk.id] = chunk
  }

  cacheChunks() {
    if (!this.isOneSecondInterval()) return

    for (let id in this.chunksToCache) {
      let chunk = this.chunksToCache[id]
      chunk.cacheLayers()  
      if (!chunk.hasLayersToCache()) {
        delete this.chunksToCache[id]
      }
    }

  }

  arrayifyChunkEntityData(data) {
    data.terrains = Object.values(data.terrains)
    data.buildings = Object.values(data.buildings)
    data.players = Object.values(data.players)
    data.corpses = Object.values(data.corpses)
    data.projectiles = Object.values(data.projectiles)
    data.rooms = Object.values(data.rooms)
    data.mobs = Object.values(data.mobs)
    data.pickups = Object.values(data.pickups)

    if (data.hasOwnProperty("transports")) {
      data.transports = Object.values(data.transports)
    }
  }

  onEntityUpdated(data) {
    this.arrayifyChunkEntityData(data)

    if (data.hasOwnProperty("terrains") || data.hasOwnerProperty("buildings")) {
      this.syncTerrains(data)
      this.syncWithServerForGroups(["buildings"], data)
    }

    this.syncWithServerForGroups(["players"], data)
    this.syncWithServerForGroups(["corpses"], data)
    this.syncWithServerForGroups(["projectiles"], data)
    this.syncWithServerForGroups(["rooms"], data)
    this.syncWithServerForGroups(["mobs"], data)
    this.syncWithServerForGroups(["pickups"], data)
    this.syncWithServerForGroups(["transports"], data)

    this.syncRoomTiles(data)
  }

  syncRoomTiles(data) {
    for (let roomId in data.roomTiles) {
      let roomTileMap = data.roomTiles[roomId]
      let roomTileList = Object.values(roomTileMap.tiles)
      let room = this.rooms[roomId]
      if (room) {
        let roomTileBatches = Helper.batch(roomTileList, 20)
        this.processRoomTileUpdate(room, roomTileBatches)
      }
    }
  }

  processRoomTileUpdate(room, roomTileBatches) {
    let roomTileBatch = roomTileBatches.shift()

    if (roomTileBatch) {
      room.syncWithServer({ tiles: roomTileBatch })

      setTimeout(this.processRoomTileUpdate.bind(this, room, roomTileBatches), 10)
    } else {
      // finished
    }
  }

  incrementTick() {
    this.tick += 1

    if (this.tick > 60) {
      this.tick = 0
    }
  }

  isOneSecondInterval() {
    return this.tick === 60
  }

  executeTurn() {
    this.incrementTick()

    try {
      let start = Date.now()
      this.processEntitySyncQueue()

      this.interpolateEntities()  
      this.cacheChunks()

      let elapsed = Date.now() - start

      if (elapsed <= 5) {
        this.lightManager.processQueue()
        this.processMapRenderQueue()
      }
    } catch(e) {
      ExceptionReporter.captureException(e)
    }
  }

  processMapRenderQueue() {
    this.game.mapMenu.processRenderQueue()
  }

  interpolateEntities() {
    this.movableGroups.forEach((group) => {
      for (let key in this[group]) {
        let entity = this[group][key]
        entity.interpolate(this.game.lastFrameTime)
      }
    })
  }

  getSpriteContainer() {
    return this.game.sectorSpriteContainer
  }

  isMovable() {
    return false
  }

  getX() {
    return this.getSectorWidth() / 2
  }

  getY() {
    return this.getSectorHeight() / 2
  }

  getSectorWidth() {
    return this.getColCount() * Constants.tileSize
  }

  getSectorHeight() {
    return this.getRowCount() * Constants.tileSize
  }

}

Object.assign(Sector.prototype, Container.prototype, {
  getRowCount() {
    return this.rowCount
  },
  getColCount() {
    return this.colCount
  },
  getGridRulerTopLeft() {
    return {
      x: 0,
      y: 0
    }
  }
})

Object.assign(Sector.prototype, ClientContainer.prototype, {
})

module.exports = Sector

},{"../../../common/entities/object_pool":660,"./../../../common/constants.json":656,"./../../../common/entities/grid":659,"./../../../common/helper":664,"./../../../common/interfaces/container":668,"./../../../common/util/protocol":686,"./../util/client_helper":649,"./../util/exception_reporter":650,"./backgrounds/index":196,"./buildings/fuel_pipe":245,"./buildings/gas_pipe":248,"./buildings/index":250,"./buildings/liquid_pipe":254,"./buildings/wire":325,"./chunk":331,"./client_container":334,"./home_area":441,"./light_manager":445,"./player":513,"./room_alert_manager":542,"./selection":544,"./starmap_location":548,"rbush":167}],544:[function(require,module,exports){
const Constants = require("./../../../common/constants.json")

class Selection {
  
  constructor(container) {
    this.container = container

    this.graphics = this.sprite = this.getSprite()
    this.getSpriteContainer().addChild(this.sprite)

    this.padding = 2

    // can change depending on selected entity
    this.width  = Constants.tileSize 
    this.height = Constants.tileSize 
  }

  getSprite() {
    const graphics = new PIXI.Graphics()
    graphics.name = "Selection"

    return graphics
  }

  isShown() {
    return this.graphics.width > 0
  }

  getSpriteContainer() {
    return this.container.effectsContainer
  }

  draw() {
    const lineStyle = this.getSelectionLineStyle()
    let shape = this.getSelectionShape(this.selectedEntity)

    this.graphics.lineStyle(lineStyle.lineWidth, lineStyle.color)

    let selectionRect = this.selectedEntity.getSelectionRect()

    if (selectionRect) {
      this.graphics.drawRect(selectionRect.x, selectionRect.y, selectionRect.w, selectionRect.h)
    } else if (shape === "rectangle") {
      this.graphics.drawRect(-this.width/2 + this.padding, -this.height/2 + this.padding, this.width - (this.padding * 2), this.height - (this.padding * 2))
    } else {
      this.graphics.drawCircle(0, 0, this.width / 2)
    }

    this.graphics.endFill()
  }

  getSelectionLineStyle() {
    return {
      lineWidth: 4,
      color: 0xeeeeee,
      alpha: 0.7
    }
  }

  clear() {
    this.graphics.clear()
  }

  shouldAttachToSprite(entity) {
    return entity.isMovingEntity() || entity.isCorpse()
  }

  onSelectionRemoved(entity) {
    this.container.onSelectionRemoved(entity)
  }

  onSelectionChanged(entity) {
    this.container.onSelectionChanged(entity)
  }

  highlight(entity) {
    let isAlreadySelected = this.selectedEntity === entity
    if (isAlreadySelected) return

    this.clear()

    if (this.selectedEntity) {
      this.onSelectionRemoved(this.selectedEntity)
    }

    this.selectedEntity = entity

    this.onSelectionChanged(this.selectedEntity)

    if (this.shouldAttachToSprite(entity)) {
      // attach sprite to entity
      this.attachToSprite(entity)
      this.reposition(0,0)
    } else {
      this.attachToSector()
      this.reposition(entity.getRelativeX(), entity.getRelativeY())
    }

    this.resize(entity.getSelectionWidth(), entity.getSelectionHeight())
    this.draw()

    this.selectedEntity.onHighlighted()
  }

  attachToSprite(entity) {
    if (this.graphics.parent) {
      this.graphics.parent.removeChild(this.graphics)
    }
    
    entity.sprite.addChild(this.graphics)
  }

  attachToSector() {
    // possible that parent is null. entity removed due to death
    if (this.graphics.parent) {
      this.graphics.parent.removeChild(this.graphics)
    }
    this.getSpriteContainer().addChild(this.graphics)
  }

  unhighlight(entity) {
    if (this.selectedEntity === entity) {
      this.clear()
      this.onSelectionRemoved(this.selectedEntity)
      this.selectedEntity = null
    }
  }

  getSelectionShape(entity) {
    if (this.shouldAttachToSprite(entity)) {
      return "circle"
    } else {
      return "rectangle"
    }
  }

  resize(w, h) {
    this.width = w
    this.height = h
  }

  reposition(x, y) {
    this.graphics.position.set(x, y)
  }
}

module.exports = Selection
},{"./../../../common/constants.json":656}],545:[function(require,module,exports){
const BaseEntity  = require("./base_entity")
const Destroyable  = require("./../../../common/interfaces/destroyable")
const Upgradable  = require("./../../../common/interfaces/upgradable")
// const Tileable  = require("./../../../../common/interfaces/tileable")
const Constants = require("./../../../common/constants.json")
const HealthBar = require("./../components/health_bar")
const Protocol = require("./../../../common/util/protocol")

const getShieldRadius = () => {
  const numTiles = 10
  const shieldShipPadding = Constants.tileSize
  const diameter = Math.ceil(numTiles * Math.sqrt(2)) * Constants.tileSize + shieldShipPadding
  return diameter / 2
}


class Shield extends BaseEntity {
  constructor(game, data) {
    super(game, data)

    this.ship = data.ship
    this.health = data.health
    this.level = data.level

    this.initDestroyable()
    this.healthBar = new HealthBar(this)
  }

  getSprite() {
    const mainSprite = this.getMainSprite()

    const sprite = new PIXI.Container()

    this.shieldSprite = mainSprite
    sprite.addChild(mainSprite)

    return sprite
  }

  getSpriteContainer() {
    return this.game.backgroundSpriteContainer
  }

  animateShieldDamage() {
    if (this.shieldRestoreTimeout) return

    // this.shieldSprite.alpha = 0.2
    this.shieldSprite.tint = 0x34a378

    this.shieldRestoreTimeout = setTimeout(() => {
      this.shieldSprite.tint = 0xffffff
      this.shieldRestoreTimeout = null
      // this.shieldSprite.alpha = 1
    }, 100)
  }

  getMainSprite() {
    const shieldDiameter = getShieldRadius() * 2

    const sprite = new PIXI.Sprite(PIXI.utils.TextureCache["shield.png"])
    sprite.anchor.set(0.5)
    sprite.width = shieldDiameter
    sprite.height = shieldDiameter
    sprite.alpha = 1
    window.shield = sprite
    return sprite
  }

  syncWithServer(data) {
    const prevLevel = this.level

    this.setLevel(data.level)
    this.setHealth(data.health)

    if (this.level !== prevLevel && this.level !== 0) {
      this.onLevelIncreased()
    }
  }

  setLevel(level) {
    this.level = level
  }

  onLevelIncreased() {
    if (this.isEntityMenuOpenFor(this)) {
      this.game.showEntityMenu(this)
    }
  }

  getCollisionGroup() {
    return "collisionGroup.Building"
  }
}

/* Implement Destroyable */

Object.assign(Shield.prototype, Upgradable.prototype, {
  getConstantsTable() {
    return "Shield"
  }
})

Object.assign(Shield.prototype, Destroyable.prototype, {
  getMaxHealth() {
    return this.getStats(this.level).health
  },
  onPostSetHealth() {
    this.healthBar.draw()
  },
  onHealthReduced(delta) {
    this.animateShieldDamage()
  },
  onHealthZero() {
    this.remove()
  }
})


module.exports = Shield

},{"./../../../common/constants.json":656,"./../../../common/interfaces/destroyable":670,"./../../../common/interfaces/upgradable":681,"./../../../common/util/protocol":686,"./../components/health_bar":181,"./base_entity":206}],546:[function(require,module,exports){
const BaseEntity = require("./base_entity")
const Constants = require("./../../../common/constants.json")
const Grid = require("./../../../common/entities/grid")
const Shield = require("./shield")
const Buildings = require("./buildings/index")
const Destroyable  = require("./../../../common/interfaces/destroyable")
const Container = require("./../../../common/interfaces/container")
const ClientContainer = require("./client_container")
const RoomAlertManager = require("./room_alert_manager")
const LightManager = require("./light_manager")

class Ship extends BaseEntity {

  constructor(game, data, pilot) {
    super(game, data)

    this.thrusters = {}
    this.buildings = {}
    this.terrains = {}

    this.rowCount = data.rowCount
    this.colCount = data.colCount

    this.setOwner(data.ownerId)
    this.setPilot(pilot)
    this.initDestroyable()
    this.initGrids()
    this.initRoomAlertManager()


    this.buildingGroups = ["platforms", "distributions", "armors", "structures", "units"]
    this.groups = ["pickups"]
    this.tileGroups = ["buildings"]

    this.createSpriteLayersFor(this.sprite, this.buildingGroups)
    this.createSpriteLayersFor(this.sprite, this.groups)
    this.createColliderSprite()

    this.initLightManager()

    this.postInitSprite()
  }

  postInitSprite() {
    this.repositionSprite()  

    this.lightMapContainer = new PIXI.Container()
    let multiplyBlend = new PIXI.filters.AlphaFilter()
    multiplyBlend.blendMode = PIXI.BLEND_MODES.MULTIPLY
    this.lightMapContainer.filters = [multiplyBlend]

    this.createShadowMapSprite()
    this.createLightMapSprite()

    this.sprite.addChild(this.lightMapContainer)

    this.effectsContainer  = new PIXI.Container()
    this.effectsContainer.name = "Effects"

    this.sprite.addChild(this.effectsContainer)
  }

  onSelectionChanged(entity) {
  }

  onSelectionRemoved(entity) {
  }

  createShadowMapSprite() {
    this.skyMapSprite = new PIXI.Sprite()
    this.skyMapSprite.width  = this.getGridWidth()
    this.skyMapSprite.height = this.getGridHeight()
    this.skyMapSprite.texture = PIXI.Texture.fromCanvas(this.lightManager.skyMapCanvas)

    this.lightMapContainer.addChild(this.skyMapSprite)
  }

  createLightMapSprite() {
    this.lightMapSprite = new PIXI.Sprite()
    this.lightMapSprite.width  = this.getGridWidth()
    this.lightMapSprite.height = this.getGridHeight()
    this.lightMapSprite.name = "LightMap"
    this.lightMapSprite.blendMode = PIXI.BLEND_MODES.MULTIPLY
    this.lightMapSprite.texture = PIXI.Texture.fromCanvas(this.lightManager.lightMapCanvas)

    this.lightMapContainer.addChild(this.lightMapSprite)
  }

  getSpriteLayerForChunk(group, chunkRow, chunkCol) {
    return this.spriteLayers[group]
  }

  createColliderSprite() {
    this.colliderSprite = new PIXI.Graphics()
    this.getSpriteContainer().addChild(this.colliderSprite)
  }

  initRoomAlertManager() {
    this.roomAlertManager = new RoomAlertManager(this)
  }

  repositionSprite() {
    // hack: the ship is actually currently positioned at center of a 50x50 row,col tilesize. 
    // we reposition it to 0,0 coord 
    this.sprite.pivot.x = this.getGridWidth()  / 2
    this.sprite.pivot.y = this.getGridHeight() / 2
  }

  assignLightingFor() {

  }

  unassignLightingFor() {
    
  }

  setOwner(ownerId) {
    this.ownerId = ownerId
  }

  setPilot(pilot) {
    this.pilot = pilot
  }

  getSpriteContainer() {
    return this.game.sector.spriteLayers["ships"]
  }

  getSprite() {
    let sprite = this.getContainerSprite()
    sprite.name = "Ship"

    return sprite
  }

  addThruster(thruster) {
    this.thrusters[thruster.id] = thruster
  }

  isMovable() {
    return true
  }

  removeThruster(thruster) {
    delete this.thrusters[thruster.id]
  }

  initShield(data) {
    data.shield.ship = this
    this.shield = new Shield(this.game, data.shield)
    this.sprite.addChild(this.shield.sprite)
    if (this.isMe()) this.game.updateShieldBar(this.shield.health, this.shield.getMaxHealth())
  }


  setShield(data) {
    const isNewShield = !this.shield && data.shield
    const isShieldGone = this.shield && !data.shield

    if (isNewShield) {
      this.initShield(data)
    } else if (isShieldGone) {
      this.shield.remove()
      this.shield = null
      if (this.isMe()) this.game.updateShieldBar(0,0)

    } else if (data.shield) {
      this.shield.syncWithServer(data.shield)
      if (this.isMe()) this.game.updateShieldBar(this.shield.health, this.shield.getMaxHealth())
    }
  }

  remove() {
    super.remove()

    this.getContainer().unregisterEntity("players", this)

    if (this.collider) {
      this.getSpriteContainer().removeChild(this.colliderSprite)
    }

    this.lightManager.cleanup()
    this.roomAlertManager.clear()
  }

  isMe() {
    return this.pilot && this.pilot.id === player.id
  }

  setAngle(angle) {
    this.angle = angle
    this.instructToRotate(this.getRadAngle())
  }

  setSpeed(speed) {
    this.speed = speed
  }

  initLightManager() {
    this.lightManager = new LightManager(this)
  }


  syncWithServer(data) {
    this.instructToMove(data.x , data.y)

    this.setHealth(data.health)
    this.setAngle(data.angle)

    this.setLevel(data.level)
    this.setSpeed(data.speed)

    this.syncWithServerForGroups([this.groups, this.tileGroups].flat(), data)

    this.setCollider(data.collider)
    this.setShield(data)

    if (this.isMe()) {
      this.game.updateShipStats(this)
      this.game.updateHealthBar(this.health, this.getMaxHealth())
    }

    this.lightManager.updateLightMapTexture()
    this.lightManager.redrawChangedLightSources()
  }

  drawColliderDebug() {
    if (!this.collider) return

    let points = this.collider.map((point) => { return [point.x, point.y] })
    points = [].concat.apply([], points) // flatten
    points.push(points[0])
    points.push(points[1]) // reconnect last line to first point

    this.colliderSprite.clear()
    this.colliderSprite.lineStyle(5, 0xff0000, 0.7)
    this.colliderSprite.drawPolygon(points)
    this.colliderSprite.endFill()
  }

  setCollider(collider) {
    this.collider = collider
    this.drawColliderDebug()
  }


  getRelativeBox(box) {
    const gridTopLeft = this.getGridRulerTopLeft()
    box.pos.x -= gridTopLeft.x
    box.pos.y -= gridTopLeft.y
    return box
  }


  interpolate(lastFrameTime) {
    const prev = { x: this.sprite.position.x, y: this.sprite.position.y }
    super.interpolate(lastFrameTime)
    const curr = { x: this.sprite.position.x, y: this.sprite.position.y }

    if (curr.x !== prev.x || curr.y !== prev.y) {
      this.animateThursters()
    }
  }

  animateThursters() {
    for (let thrusterId in this.thrusters) {
      let thruster = this.thrusters[thrusterId]
      thruster.addTrail()
    }
  }

  getWidth() {
    return 32
  }

  getHeight() {
    return 32
  }

}

Object.assign(Ship.prototype, Container.prototype, {
  getRowCount() {
    return this.rowCount
  },
  getColCount() {
    return this.colCount
  }
})

Object.assign(Ship.prototype, ClientContainer.prototype, {
})


Object.assign(Ship.prototype, Destroyable.prototype, {
  onHealthReduced(delta) {
  },
  onHealthIncreased(delta) {
  },
  onPostSetHealth() {
    if (this.isMe()) {
      this.game.updateHealthBar(this.health, this.getMaxHealth())
    }
  },
  getMaxHealth() {
    return this.shipCore ? this.shipCore.getMaxHealth() : 0
  }

})


module.exports = Ship

},{"./../../../common/constants.json":656,"./../../../common/entities/grid":659,"./../../../common/interfaces/container":668,"./../../../common/interfaces/destroyable":670,"./base_entity":206,"./buildings/index":250,"./client_container":334,"./light_manager":445,"./room_alert_manager":542,"./shield":545}],547:[function(require,module,exports){
const Poolable = require("../../../common/interfaces/poolable")
const ObjectPool = require("../../../common/entities/object_pool")

class SpritePoolInstance {
  static create(options) {
    let sprite = ObjectPool.obtain("Sprite")
    sprite.setAttributes(options)
    return sprite
  }

  constructor() {
    this.sprite = new PIXI.Sprite()
  }

  setAttributes(options) {
    this.sprite.texture = options.texture
  }

  remove() {
    if (this.sprite.parent) {
      this.sprite.parent.removeChild(this.sprite)
    }
    ObjectPool.free("Sprite", this)
  }

}

Object.assign(SpritePoolInstance.prototype, Poolable.prototype, {
  reset() {
    this.sprite.name = ""
  }
})

module.exports = SpritePoolInstance

},{"../../../common/entities/object_pool":660,"../../../common/interfaces/poolable":675}],548:[function(require,module,exports){
const BaseEntity = require("./base_entity")
const Constants = require("./../../../common/constants.json")
const SocketUtil = require("./../util/socket_util")
const SpriteEventHandler = require("./../util/sprite_event_handler")

class StarmapLocation extends BaseEntity {
  constructor(game, data) {
    super(game, data)

    this.id = data.id // sector id
    this.name = data.name

    this.initInteractivity()
  }

  initInteractivity() {
    this.sprite.interactive = true
    SpriteEventHandler.on(this.sprite, "pointerdown", this.onClick.bind(this))
    SpriteEventHandler.on(this.sprite, "pointerover", this.onMouseOver.bind(this))
    SpriteEventHandler.on(this.sprite, "pointerout", this.onMouseOut.bind(this))
  }

  onClick() {
    SocketUtil.emit("TeleportRequest", { sectorId: this.id })
  }

  onMouseOver() {
    this.game.highlight(this)  
  }

  onMouseOut() {
    this.game.unhighlight(this)  
  }

  getSelectionSpriteParent() {
    return this.baseSprite
  }

  getSpriteContainer() {
    return this.game.sector.starMapLocationContainer
  }

  getSprite() {
    let container = new PIXI.Container()  
    container.name = "location"

    this.baseSprite = new PIXI.Sprite(PIXI.utils.TextureCache["map_point.png"])
    this.baseSprite.name = "map_point"
    this.baseSprite.anchor.set(0.5)

    const style  = { fontFamily : 'PixelForce', fontSize: 14, fill : 0xffffff, align : 'center', strokeThickness: 4, miterLimit: 3 }
    this.nameSprite = new PIXI.Text(this.data.name, style)
    this.nameSprite.name = "name"
    this.nameSprite.anchor.set(0.5)
    this.nameSprite.position.y = -32

    container.addChild(this.baseSprite)
    container.addChild(this.nameSprite)

    return container
  }

  getSpritePath() {
    return "map_point.png"
  }

  syncWithServer(data) {

  }

  getWidth() {
    return Constants.tileSize
  }

  getHeight() {
    return Constants.tileSize
  }

}

module.exports = StarmapLocation
},{"./../../../common/constants.json":656,"./../util/socket_util":654,"./../util/sprite_event_handler":655,"./base_entity":206}],549:[function(require,module,exports){
const Statuses = require("./statuses/index")
const Helper = require("./../../../common/helper")

class StatusManager {
  constructor(entity) {
    this.entity = entity
    this.game = this.entity.game

    this.statusSprites = {}
    this.statuses = {}
    this.STATUS_EFFECT_LIST = ["poison", "oxygen", "hunger", "thirst", "stamina", "fear", "rage", "paralyze", "drunk", "miasma"]

    this.createStatusContainer()
  }

  cleanup() {
    if (this.statusEffectTween) {
      this.statusEffectTween.stop()
    }

    if (this.multipleStatusTween) {
      this.multipleStatusTween.stop()
    }

  }

  update() {
    let seconds = parseInt(this.game.lastFrameTime / 1000)  
    let isThreeSecondInterval = seconds % 3 === 0
    if (!isThreeSecondInterval) return

    if (this.isStatusDisplaying) return

    for (let statusName in this.statuses) {
      let status = this.statuses[statusName]
      let canShowStatus = this.game.lastFrameTime - status.getLastShownTime() > (25 * 1000)
      if (canShowStatus) {
        this.showStatusEffect(statusName)
      }
    }
  }

  createStatusContainer() {
    this.statusContainer = this.getStatusContainerSprite()

    this.entity.sprite.addChild(this.statusContainer)
  }

  addStatus(statusName) {
    if (this.STATUS_EFFECT_LIST.indexOf(statusName) === -1) return

    if (!this.statuses[statusName]) {
      this.statuses[statusName] = true

      let klass = Statuses[Helper.capitalize(statusName)]
      let statusInstance = new klass(this)

      this.statuses[statusName] = statusInstance

      this.showStatusEffect(statusName)

      if (this.entity.isPlayer() && this.entity.isMe()) {
        this.entity.displayLowStatusWarning(statusName)
      }
    }
  }

  removeStatus(statusName) {
    if (!this.statuses[statusName]) return

    this.statuses[statusName].remove() 
    delete this.statuses[statusName]
  }

  addStatusSprite(statusName, sprite) {
    this.statusSprites[statusName] = sprite
  }

  removeStatusSprite(statusName, sprite) {
    delete this.statusSprites[statusName] 
  }

  getStatusContainerSprite() {
    let sprite = new PIXI.Container()
    sprite.name = "StatusEffects"
    sprite.position.y = -60
    sprite.position.x = this.entity.getWidth()/2
    sprite.alpha = 0
    sprite.pivot.x = 20
    sprite.pivot.y = 20

    this.statusBackground = new PIXI.Sprite(PIXI.utils.TextureCache["status_container.png"])
    this.statusBackground.name = "StatusBackground"
    sprite.addChild(this.statusBackground)

    return sprite
  }

  showStatusEffect(statusName) {
    if (this.isStatusDisplaying) return

    this.statusEffectTween = this.getStatusEffectTween(statusName)
    this.statusEffectTween.start()
  }

  hideStatusEffect() {
    this.statusContainer.alpha = 0

    if (this.statusEffectTween) {
      this.statusEffectTween.stop()
      this.statusEffectTween = null
    }

    if (this.multipleStatusTween) {
      this.multipleStatusTween.stop()
      this.multipleStatusTween = null
    }
  }

  getMultipleStatusEffectTween() {
    let statusSpriteList =  Object.values(this.statusSprites)
    this.multipleStatusIndex = this.multipleStatusIndex || 0

    // start with every sprite set to alpha 0 except first one
    statusSpriteList.forEach((sprite) => {
      sprite.alpha = 0
    })

    statusSpriteList[0].alpha = 1

    // cycle visibility of sprites
    let toggle = { toggle: 0 }

    return new TWEEN.Tween(toggle)
        .to({ toggle: 1 }, 2000)
        .onUpdate(() => {
          try {
            statusSpriteList = Object.values(this.statusSprites) // make sure to fetch updated sprites

            if (toggle.toggle === 1) {
              if (this.multipleStatusIndex > statusSpriteList.length - 1) {
                this.multipleStatusIndex = 0
              }

              let statusSprite = statusSpriteList[this.multipleStatusIndex]
              statusSprite.alpha = 0

              this.multipleStatusIndex += 1

              if (this.multipleStatusIndex > statusSpriteList.length - 1) {
                this.multipleStatusIndex = 0
              }

              statusSpriteList[this.multipleStatusIndex].alpha = 1
            }
          } catch(e) {
            console.log(e)
          }
        })
        .repeat(Infinity)
  }

  getStatusEffectTween(statusName) {
    const status = this.statuses[statusName]
    status.touch()
    this.statusContainer.addChild(status.sprite)

    this.isStatusDisplaying = true
    this.statusContainer.alpha = 1

    const origY = this.statusContainer.position.y
    let scale = { scale: 0 }
    let alpha = { alpha: 1 }

    const appearTween = new TWEEN.Tween(scale)
        .to({ scale: 0.8  }, 200)
        .onUpdate(() => {
          this.statusContainer.scale.set(scale.scale)
        })

    var delayTween = new TWEEN.Tween({ x: 0 })
        .to({ x: 1 }, 4000)

    const fadeTween = new TWEEN.Tween(alpha)
        .to({ alpha: 0 }, 1000)
        .onUpdate(() => {
          this.statusContainer.alpha = alpha.alpha
        })
        .onComplete(() => {
          this.isStatusDisplaying = false
          this.statusContainer.removeChild(status.sprite)
        })

    appearTween.chain(delayTween)
    delayTween.chain(fadeTween)

    return appearTween
  }


}

module.exports = StatusManager
},{"./../../../common/helper":664,"./statuses/index":554}],550:[function(require,module,exports){
class BaseStatus {
  constructor() {
    this.sprite = this.getSprite()
  }

  touch() {
    this.lastShownTime = Date.now()    
  }

  getLastShownTime() {
    return this.lastShownTime
  }

  getStatusName() {
    return "oxygen"
  }

  getStatusTint() {
    return null
  }

  getSprite() {
    const sprite = new PIXI.Sprite(PIXI.utils.TextureCache[this.getStatusName() + "_status.png"])
    sprite.name = this.getStatusName()

    let tint = this.getStatusTint()
    if (tint) {
      sprite.tint = tint
    }
    
    sprite.anchor.set(0)
    sprite.position.x = 12
    sprite.position.y = 8
    sprite.width = 25
    sprite.height = 25

    return sprite
  }

  getSpriteContainer() {
    return this.affectedEntity.statusContainer
  }

  remove() {
    if (this.sprite.parent) {
      this.sprite.parent.removeChild(this.sprite)
    }
  }
}

module.exports = BaseStatus
},{}],551:[function(require,module,exports){
const BaseStatus = require("./base_status")

class DrankStatus extends BaseStatus {
  getStatusName() {
    return "drunk"
  }
}

module.exports = DrankStatus
},{"./base_status":550}],552:[function(require,module,exports){
const BaseStatus = require("./base_status")

class FearStatus extends BaseStatus {
  getStatusName() {
    return "fear"
  }
}

module.exports = FearStatus
},{"./base_status":550}],553:[function(require,module,exports){
const BaseStatus = require("./base_status")

class HungerStatus extends BaseStatus {
  getStatusName() {
    return "hunger"
  }

}

module.exports = HungerStatus
},{"./base_status":550}],554:[function(require,module,exports){
const Statuses = {}

Statuses.Oxygen  = require("./oxygen_status")
Statuses.Poison  = require("./poison_status")
Statuses.Hunger  = require("./hunger_status")
Statuses.Thirst  = require("./thirst_status")
Statuses.Stamina = require("./stamina_status")
Statuses.Fear    = require("./fear_status")
Statuses.Rage    = require("./rage_status")
Statuses.W = require("./paralyze_status")
Statuses.Drunk = require("./drunk_status")
Statuses.Miasma = require("./miasma_status")

module.exports = Statuses
},{"./drunk_status":551,"./fear_status":552,"./hunger_status":553,"./miasma_status":555,"./oxygen_status":556,"./paralyze_status":557,"./poison_status":558,"./rage_status":559,"./stamina_status":560,"./thirst_status":561}],555:[function(require,module,exports){
const BaseStatus = require("./base_status")

class MiasmaStatus extends BaseStatus {
  getStatusName() {
    return "miasma"
  }
}

module.exports = MiasmaStatus
},{"./base_status":550}],556:[function(require,module,exports){
const BaseStatus = require("./base_status")

class OxygenStatus extends BaseStatus {
  getStatusName() {
    return "oxygen"
  }
}

module.exports = OxygenStatus
},{"./base_status":550}],557:[function(require,module,exports){
const BaseStatus = require("./base_status")

class ParalyzeStatus extends BaseStatus {
  getStatusName() {
    return "paralyze"
  }
}

module.exports = ParalyzeStatus
},{"./base_status":550}],558:[function(require,module,exports){
const BaseStatus = require("./base_status")

class PoisonStatus extends BaseStatus {
  getStatusName() {
    return "poison"
  }
}

module.exports = PoisonStatus
},{"./base_status":550}],559:[function(require,module,exports){
const BaseStatus = require("./base_status")

class RageStatus extends BaseStatus {
  getStatusName() {
    return "rage"
  }
}

module.exports = RageStatus
},{"./base_status":550}],560:[function(require,module,exports){
const BaseStatus = require("./base_status")

class StaminaStatus extends BaseStatus {
  getStatusName() {
    return "stamina"
  }

  getStatusTint() {
    return 0xd47323
  }

}

module.exports = StaminaStatus
},{"./base_status":550}],561:[function(require,module,exports){
const BaseStatus = require("./base_status")

class ThirstStatus extends BaseStatus {
  getStatusName() {
    return "thirst"
  }
}

module.exports = ThirstStatus
},{"./base_status":550}],562:[function(require,module,exports){
const Constants = require("./../../../common/constants.json")
const Protocol = require("./../../../common/util/protocol")

class Team {
  constructor(game, data) {
    this.game = game
    this.members = {}

    this.syncWithServer(data)    

    this.onTeamCreated()
  }

  getTeamKey() {
    return [this.id, this.game.sector.uid].join(":")
  }

  getInviteToken() {
    return this.game.sector.uid
  }

  isSectorOwner() {
    return this.creatorUid === this.game.creatorUid
  }

  syncWithServer(data) {
    this.data = data
    this.id = data.id
    this.ip = data.ip
    this.setName(data.name)
    this.isPrivate = data.isPrivate
    this.leader = data.leader
    this.creatorUid = data.creatorUid
    this.creatorName = data.creatorName
    this.deeds = data.deeds
    this.dayCount = data.dayCount
    this.prefix = data.prefix

    this.permissions = data.permissions

    let prevMembers = this.members
    if (this.isMyTeam()) {
      if (this.isBeingRemovedFromTeam(data)) {
        this.game.mapMenu.removePrevTeamMembers(prevMembers)
      }
    }

    this.members = data.members
    this.offlineMembers = data.offlineMembers

    this.updateRelationship()
    this.onTeamUpdated(prevMembers)
  }

  isBeingRemovedFromTeam(data) {
    if (!this.game.player) return false
    return !data.members[this.game.player.id]
  }

  isMyTeam() {
    if (!this.game.player) return false
    return this.members[this.game.player.id]
  }

  setName(name) {
    this.name = name
  }

  isCreator(member) {
    return member.name === this.creatorName
  }

  updateRelationship() {
    this.relationshipScore = this.calculateRelationshipScore()

    const prevRelationshipStatus = this.relationshipStatus
    this.relationshipStatus = this.getRelationshipStatus()

    if (this.relationshipStatus !== prevRelationshipStatus) {
      if (prevRelationshipStatus) {
        this.onRelationshipStatusChanged()
      }
    }
  }

  onRelationshipStatusChanged() {
    if (this.relationshipStatus === "Hostile") {
      this.game.displayError('Relationship.EmpireHostile', { warning: true })
    } else if (this.relationshipStatus === "Neutral") {
      this.game.displayError("Relationship.EmpireNeutral")
    } else if (this.relationshipStatus === "Friendly") {
      this.game.displayError("Relationship.EmpireFriendly", { success: true })
    }
  }

  getRelationshipStatus() {
    if (this.relationshipScore <= 40) {
      return "Hostile"
    } else if (this.relationshipScore < 60) {
      return "Neutral"
    } else {
      return "Friendly"
    }
  }

  calculateRelationshipScore() {
    let total = 0
    let baseScore = 60
    total += baseScore

    for (let deed in this.deeds) {
      total += Constants.Deeds[deed].effect
    }

    return total
  }

  hasMember(targetMember, members) {
    if (!targetMember) return false

    members = members || this.members

    return members[targetMember.id]
  }

  getMemberCount() {
    return Object.keys(this.members).length
  }

  getId() {
    return this.id
  }

  getName() {
    return this.name 
  }

  isLeader(member) {
    return this.leader && this.leader.id === member.id
  }

  isAdmin(member) {
    return member.roleType === Protocol.definition().RoleType.Admin &&
           this.hasMember(member)
  }

  isCreator(member) {
    return this.creatorName === member.name
  }

  getIpHex() {
    return this.ip.replace("ip_", "").replace(".junon.io","")
  }

  onTeamUpdated(prevMembers) {
    let isPlayerTeamMemberPreviously = this.hasMember(this.game.player, prevMembers)
    let isPlayerTeamMemberCurrently  = this.hasMember(this.game.player)

    if (isPlayerTeamMemberPreviously && !isPlayerTeamMemberCurrently) {
      this.onPlayerLeftTeam()
    } else if (this.hasMember(this.game.player)) {
      this.game.teamMenu.render(this)
      this.game.teamStatusMenu.showTeamMembers(this)
      // this.game.allianceMenu.render(this)
    }

    for (let id in this.members) {
      let player = this.game.sector.players[id]
      if (player) {
        player.onTeamChanged()
      }
    }
  }

  onPlayerLeftTeam() {
    this.game.teamStatusMenu.cleanup()
  }

  onTeamCreated() {
    // this.game.teamMenu.addTeam(this)

    if (this.hasMember(this.game.player)) {
      this.game.teamMenu.render(this)
      this.game.teamStatusMenu.showTeamMembers(this)
    }
  }

  remove() {
    // this.game.teamMenu.removeTeam(this)
  }


}

module.exports = Team
},{"./../../../common/constants.json":656,"./../../../common/util/protocol":686}],563:[function(require,module,exports){
const BaseEntity  = require("./../base_entity")
const Constants = require("./../../../../common/constants.json")
const Protocol = require("./../../../../common/util/protocol")
const Helper = require("./../../../../common/helper")
const Tilable  = require("./../../../../common/interfaces/tilable")
const BaseBuildingCommon  = require("./../../../../common/entities/base_building_common")
const SocketUtil = require("./../../util/socket_util")
const SpriteEventHandler = require("./../../util/sprite_event_handler")

class BaseTerrain extends BaseEntity {
  static build(game, data) {
    return new this(game, data)
  }

  constructor(game, data) {
    super(game, data)

    this.row = Math.floor(data.y / Constants.tileSize)
    this.col = Math.floor(data.x / Constants.tileSize)

    this.lightings = []
    this.lighting = null
    this.chunks = {}

    if (data.isEquipDisplay) {

    } else {
      this.onBuildingConstructed()
      this.updateChunkSprite()
      this.assignShadow()
      this.redrawNeighborShadows()
    }
  }

  syncWithServer(data) {
    this.setEffects(data.effects)
  }

  static getTextures() {
    if (!this.textures) {
      this.textures = {}
    }

    if (!this.textures[this.getType()]) {
      this.textures[this.getType()] = this.getTextureMapping()
    }

    return this.textures[this.getType()]
  }

  static isPositionValid(container, x, y, w, h, angle, player) {
    return true
  }

  static getTextureMapping() {
    let spritePath = this.getSpritePath()

    return {
      line_zero: PIXI.utils.TextureCache[spritePath],
      line_one: PIXI.utils.TextureCache[spritePath],
      line_two: PIXI.utils.TextureCache[spritePath],
      line_two_straight: PIXI.utils.TextureCache[spritePath],
      line_three: PIXI.utils.TextureCache[spritePath],
      line_four: PIXI.utils.TextureCache[spritePath]
    }
  }

  static getSpritePath() {
    return this.prototype.getSpritePath()
  }

  updateChunkSprite() {
    if (!this.isChunkable()) return

    this.getChunk().updateSprite(this)
  }

  isChunkable() {
    if (this.getContainer().isMovable()) return false

    return true
  }

  onEffectAdded(effect) {
    super.onEffectAdded(effect)
    this.updateChunkSprite()
  }

  onBuildStart() {
  }

  onBuildStop() {
  }

  onEffectRemoved(effect) {
    super.onEffectRemoved(effect)
    this.updateChunkSprite()
  }

  onEffectLevelChanged(effect, level) {
    super.onEffectLevelChanged(effect, level)
    this.updateChunkSprite()
  }

  renderEntityMenu(entityMenu) {
    this.showLogs(entityMenu)
  }

  showLogs(entityMenu) {
    entityMenu.querySelector(".entity_logs").innerHTML = ""
  }

  applyTint(tint) {
    this.getTileSprite().tint = tint
  }

  getRedrawNeighborTileMaps() {
    return [this.game.sector.map, this.game.sector.groundMap]
  }

  redrawNeighborTiles() {
    const row = this.getRow()
    const col = this.getCol()
    // const tilemap = this.getTileMap()
    let tilemaps = this.getRedrawNeighborTileMaps()
    tilemaps.forEach((tilemap) => {
      let neighbors = tilemap.getNeighbors(row, col)
      neighbors.forEach((hit) => {
        hit.entity.redrawSprite()
      })
    })


  }

  animateWalk(entity) {

  }

  onClick(options) {
    this.game.resetEntitySelection()

    if (options.isRightClick) {
      // right click
      this.game.selectEntity(this)
      this.game.showEntityMenu(this)
    }

    this.handleDoubleClick()

  }

  static isTerrain() {
    return true
  }

  onMouseOver() {
    super.onMouseOver()

    if (this.isGroundTile()) return

    if (!Helper.isTargetWithinRange(this.game.player, this)) {
      return
    }

    if (this.isForegroundTile()) {
      this.game.player.setMineTarget(this)
    }

    this.game.highlight(this)
    this.game.showEntityMenu(this)
  }

  onMouseOut() {
    super.onMouseOut()

    if (this.isGroundTile()) return

    if (this.isForegroundTile()) {
      this.game.player.setMineTarget(null)
    }

    this.game.unhighlight(this)
    this.game.hideEntityMenu(this)
  }

  handleDoubleClick() {
    let currClickTime = (new Date()).getTime()
    let doubleClickThreshold = 500 // ms
    let isDblClick = this.lastClickTime && ((currClickTime - this.lastClickTime) < doubleClickThreshold)

    if (isDblClick) {
      if (debugMode) {
        SocketUtil.emit("ClientChat", { message: "/tp " + this.getRow() + " " + this.getCol() })
      }
    }

    this.lastClickTime = (new Date()).getTime()
  }


  redrawSprite() {
    this.layoutTile()
    this.updateChunkSprite()
  }

  getSelectionSprite() {
    const padding = 2
    const w = Constants.tileSize
    const h = Constants.tileSize
    const graphics = new PIXI.Graphics()
    const lineStyle = this.getSelectionLineStyle()
    graphics.lineStyle(lineStyle.lineWidth, lineStyle.color)
    graphics.drawRect(-w/2 + padding, -h/2 + padding, w - (padding * 2), h - (padding * 2))
    graphics.endFill()
    graphics.position.x = this.getX()
    graphics.position.y = this.getY()

    return graphics
  }

  getTypeName() {
    let label = this.getConstants().label
    if (label) return label

    const type = this.getType()
    return Helper.getTerrainNameById(type).replace(/([A-Z])/g, ' $1').trim() // space before capital letters
  }

  getSpriteLayerGroup() {
    return this.getGroup()
  }

  getSpriteContainer() {
    let group = this.getSpriteLayerGroup()

    if (this.data.isEquipDisplay) {
      return this.container.effectsContainer
    } else {
      return this.container.getSpriteLayerForChunk(group, this.getChunkRow(), this.getChunkCol())
    }
  }

  getGroundSpriteContainer() {
    return this.container.getSpriteLayerForChunk("grounds", this.getChunkRow(), this.getChunkCol())
  }

  getContainer() {
    return this.sector
  }

  onPositionChanged() {

  }

  rotateEquip() {

  }

  onGridPositionChanged() {
    this.renderInvalidArea()
  }

  getSprite() {
    let texture = PIXI.utils.TextureCache[this.getSpritePath()]
    let sprite = new PIXI.Sprite(texture)
    sprite.name = this.getTypeName()
    sprite.anchor.set(0.5)
    sprite.width  = this.w
    sprite.height = this.h

    return sprite
  }

  getSelectionSpriteParent() {
    return this.game.sector.effectsContainer // selectionSpriteContainer
  }

  onBuildingConstructed() {
    this.getTileMap().register(this.getBox(), this)
    this.getChunk().register("terrains", this)

    this.layoutTile()
    this.redrawNeighborTiles()
    this.drawMinimap()
  }

  drawMinimap() {
    let color = this.getConstants().minimapColor
    if (color) {
      this.game.mapMenu.assignTile(this.getRow(), this.getCol(), color)
    }
  }

  undrawMinimap() {
    let color = this.getConstants().minimapColor
    if (color) {
      this.game.mapMenu.unassignTile(this.getRow(), this.getCol())
    }
  }

  assignShadow() {
    this.game.sector.lightManager.assignShadowFor(this, this.getShadowColor())
  }

  onShadowRendered() {
    this.sprite.alpha = 1
  }

  getPositionStat() {
    let el = "<div class='entity_stats_entry'>" +
                    "<div class='stats_type'>Coord:</div>" +
                    "<div class='stats_value'>" + [this.getRow(), this.getCol()].join(",") + "</div>" +
                "</div>"
    return el
  }

  getShadowColor() {
    let neighbors = this.game.sector.lightManager.getLightNeighbors({ row: this.getRow(), col: this.getCol() })
    let hasEmptySpace = neighbors.find((neighbor) => { return !neighbor.entity })
    if (hasEmptySpace) {
      return "#ffffff" // no shadows
    } else {
      return "#111111" // slightly hidden by default
    }
  }

  unassignShadow() {
    this.game.sector.lightManager.unassignShadowFor(this)
  }

  getBrightness() {
    return 0
  }

  getDefaultLightingColor() {
    return "#ffffff"
  }

  static getSellGroup() {
    return "Terrains"
  }

  redrawNeighborShadows() {
    let neighbors = this.game.sector.lightManager.getLightNeighbors(this)
    neighbors.forEach((neighbor) => {
      if (neighbor.entity) {
        neighbor.entity.assignShadow()
      }
    })
  }

  unregister() {
    this.getContainer().unregisterEntity("terrains", this)
    this.getChunk().unregister("terrains", this)

    this.undrawMinimap()

    this.getTileMap().unregister(this.getBox())
    if (this.isLightSource()) {
    } else {
    }
  }

  isLightSource() {
    return this.lightings.length > 0
  }

  remove() {
    super.remove()

    if (!this.data.isEquipDisplay) {
      this.unregister()
      this.updateChunkSprite()
      this.unassignShadow()

      this.redrawNeighborTiles()
      this.redrawNeighborShadows()
    }
  }

  // subclass overrides
  isUndergroundTile() {
    return false
  }

  // subclass overrides
  isGroundTile() {
    return false
  }

  isPlant() {
    return false
  }


  getTileMap() {
    if (this.isUndergroundTile()) {
      return this.game.sector.undergroundMap
    } else if (this.isGroundTile()) {
      return this.game.sector.groundMap
    } else {
      return this.game.sector.map
    }
  }

  getSideHitTileMaps() {
    return [this.getTileMap()]
  }

  getSideHits() {
    let tileMaps = this.getSideHitTileMaps()
    if (tileMaps.length === 1) {
      return this.getSideHitsFor(tileMaps[0])
    } else {
      return this.getSideHitsMulti(tileMaps)
    }
  }

  getSideHitsMulti(tileMaps) {
    let firstSideHits    = this.getSideHitsFor(tileMaps[0])
    let secondSideHits   = this.getSideHitsFor(tileMaps[1])
    let hits = {}

    for (let direction in firstSideHits) {
      let directionHits = firstSideHits[direction]
      let hit = directionHits[0] // it'll only have one entry only
      if (!hit) continue

      let firstHitDetected = hit.entity
      if (firstHitDetected) {
        hits[direction] = firstSideHits[direction]
      } else {
        hits[direction] = secondSideHits[direction]
      }
    }

    return hits
  }


  getSideHitsFor(tilemap) {
    const result = { left: [], up: [], right: [], down: [] }

    let neighbors = tilemap.getNeighborsAllowEmpty(this.getRow(), this.getCol())

    result["left"].push(neighbors[0])
    result["up"].push(neighbors[1])
    result["right"].push(neighbors[2])
    result["down"].push(neighbors[3])

    return result
  }

  getTileNeighbor(sideHits) {
    let tiles = {}

    // find out which ones are neighbor tiles
    for (let direction in sideHits) {
      let directionHits = sideHits[direction]
      if (this.hasTerrainInDirection(directionHits)) {
        tiles[direction] = true
      }
    }

    return tiles
  }

  hasTerrainInDirection(directionHits) {
    return directionHits.find((hit) => {
      return hit.entity
    })
  }

  getRelativeX() {
    return this.getX()
  }

  getRelativeY() {
    return this.getY()
  }

  getRow() {
    return Math.floor(this.getY() / Constants.tileSize)
  }

  getCol() {
    return Math.floor(this.getX() / Constants.tileSize)
  }

  static build(game, data) {
    return new this(game, data)
  }

  getType() {
    throw new Error("must implement BaseTerrain.getType")
  }

}

Object.assign(BaseTerrain.prototype, Tilable.prototype, {
  getTextures() {
    return this.constructor.getTextures()
  },
  getTileSprite() {
    return this.sprite
  },
  getSides() {
    const sides = this.getSideHits()
    return this.getTileNeighbor(sides)
  }

})

Object.assign(BaseTerrain.prototype, BaseBuildingCommon.prototype, {
})


module.exports = BaseTerrain

},{"./../../../../common/constants.json":656,"./../../../../common/entities/base_building_common":657,"./../../../../common/helper":664,"./../../../../common/interfaces/tilable":680,"./../../../../common/util/protocol":686,"./../../util/socket_util":654,"./../../util/sprite_event_handler":655,"./../base_entity":206}],564:[function(require,module,exports){
const BaseForeground = require("./base_foreground")
const Tilable  = require("./../../../../../common/interfaces/tilable")
const Constants = require("./../../../../../common/constants.json")
const Protocol = require("./../../../../../common/util/protocol")
const Helper = require("./../../../../../common/helper")
const ClientHelper = require("./../../../util/client_helper")
const Rock = require("./../grounds/rock")

class Asteroid extends BaseForeground {

  static build(game, data) {
    return new this(game, data)
  }

  // parent must implement
  getOreSpritePath() {
    return null
  }

  onBuildingConstructed() {
    super.onBuildingConstructed()
    this.drawGround()
  }

  drawGround() {
    let groundNeighbors = this.sector.groundMap.getNeighbors(this.getRow(), this.getCol())
    if (Object.keys(groundNeighbors).length > 0) {
      if (this.groundSprite) return // avoid double grounds
      let texture = Rock.getTextures()["line_four"]
      let sprite = new PIXI.Sprite(texture)
      sprite.name = "AsteroidGround"
      sprite.anchor.set(0.5)
      sprite.position.y = this.getRow() * Constants.tileSize + Constants.tileSize/2
      sprite.position.x = this.getCol() * Constants.tileSize + Constants.tileSize/2
      sprite.width  = Constants.tileSize
      sprite.height = Constants.tileSize
      this.getGroundSpriteContainer().addChild(sprite)
      this.groundSprite = sprite
    } else if (this.groundSprite) {
      this.removeGroundSprite()
    }
  }

  removeGroundSprite() {
    this.groundSprite.parent.removeChild(this.groundSprite)
    this.groundSprite = null
  }

  redrawSprite() {
    this.drawGround()
    super.redrawSprite()
  }

  getType() {
    return Protocol.definition().TerrainType.Asteroid
  }

  getConstantsTable() {
    return "Terrains.Asteroid"
  }

  remove() {
    super.remove()
    if (this.groundSprite) {
      this.removeGroundSprite()
    }
  }

  static getTextureMapping() {
    return {
      line_zero: PIXI.utils.TextureCache["asteroid_0_ridge.png"],
      line_one: PIXI.utils.TextureCache["asteroid_1_ridge.png"],
      line_two: PIXI.utils.TextureCache["asteroid_2_ridge.png"],
      line_two_straight: PIXI.utils.TextureCache["asteroid_2_straight_ridge.png"],
      line_three: PIXI.utils.TextureCache["asteroid_3_ridge.png"],
      line_four: PIXI.utils.TextureCache["asteroid_4_ridge.png"]
    }
  }

  getSpritePath() {
    return "asteroid_2_ridge.png"
  }

  onHealthReduced(delta) {
    if (this.health === 0) return

    ClientHelper.addSmoke(this.getX(), this.getY())
  }

}


module.exports = Asteroid

},{"./../../../../../common/constants.json":656,"./../../../../../common/helper":664,"./../../../../../common/interfaces/tilable":680,"./../../../../../common/util/protocol":686,"./../../../util/client_helper":649,"./../grounds/rock":569,"./base_foreground":565}],565:[function(require,module,exports){
const BaseTerrain = require("./../base_terrain")
const Destroyable  = require("./../../../../../common/interfaces/destroyable")
const Helper = require("./../../../../../common/helper")

class BaseForeground extends BaseTerrain {
  getGroup() {
    return "foregrounds"
  }

  isForegroundTile() {
    return true
  }

  onBuildingConstructed() {
    super.onBuildingConstructed()

    this.initDestroyable()
  }

  syncWithServer(data) {
    super.syncWithServer(data)
    this.setHealth(data.health)
  }

  remove() {
    if (this.game.entityMenu.isOpen(this)) {
      this.game.entityMenu.close()
    }

    super.remove()
  }

  renderEntityMenu(entityMenu) {
    super.renderEntityMenu(entityMenu)
    this.showStats(entityMenu)
  }

  showStats(entityMenu) {
    let maxHealth = this.getMaxHealth()
    let health = this.health

    let el = ""
    const usage = "<div class='entity_stats_entry'>" +
                      "<div class='stats_type'>" + i18n.t('Remaining') + ":</div>" +
                      "<div class='stats_value'>" + health + "/" + maxHealth + "</div>" +
                  "</div>"
    el += usage

    entityMenu.querySelector(".entity_stats").innerHTML = el
  }

}

Object.assign(BaseForeground.prototype, Destroyable.prototype, {
  onHealthZero() {
  },
  onHealthIncreased(delta) {
  },
  onPostSetHealth() {
    if (this.game.entityMenu.isOpen(this)) {
      this.game.entityMenu.update(this)
    }
  },
  getMaxHealth() {
    return this.getConstants().health
  }

})


module.exports = BaseForeground

},{"./../../../../../common/helper":664,"./../../../../../common/interfaces/destroyable":670,"./../base_terrain":563}],566:[function(require,module,exports){
const Asteroid = require("./asteroid")
const Constants = require("./../../../../../common/constants.json")
const Protocol = require("./../../../../../common/util/protocol")

class CopperAsteroid extends Asteroid {
  static getTextureMapping() {
    return {
      line_zero: PIXI.utils.TextureCache["copper_asteroid_0_ridge.png"],
      line_one: PIXI.utils.TextureCache["copper_asteroid_1_ridge.png"],
      line_two: PIXI.utils.TextureCache["copper_asteroid_2_ridge.png"],
      line_two_straight: PIXI.utils.TextureCache["copper_asteroid_2_straight_ridge.png"],
      line_three: PIXI.utils.TextureCache["copper_asteroid_3_ridge.png"],
      line_four: PIXI.utils.TextureCache["copper_asteroid_4_ridge.png"]
    }
  }

  getSpritePath() {
    return "copper_asteroid_2_ridge.png"
  }

  getOreSpritePath() {
    return "copper_ore.png"
  }

  getType() {
    return Protocol.definition().TerrainType.CopperAsteroid
  }

  getConstantsTable() {
    return "Terrains.CopperAsteroid"
  }

}

module.exports = CopperAsteroid

},{"./../../../../../common/constants.json":656,"./../../../../../common/util/protocol":686,"./asteroid":564}],567:[function(require,module,exports){
const Asteroid = require("./asteroid")
const Constants = require("./../../../../../common/constants.json")
const Protocol = require("./../../../../../common/util/protocol")

class MeteoriteAsteroid extends Asteroid {
  static getTextureMapping() {
    return {
      line_zero: PIXI.utils.TextureCache["meteorite_asteroid_0_ridge.png"],
      line_one: PIXI.utils.TextureCache["meteorite_asteroid_1_ridge.png"],
      line_two: PIXI.utils.TextureCache["meteorite_asteroid_2_ridge.png"],
      line_two_straight: PIXI.utils.TextureCache["meteorite_asteroid_2_straight_ridge.png"],
      line_three: PIXI.utils.TextureCache["meteorite_asteroid_3_ridge.png"],
      line_four: PIXI.utils.TextureCache["meteorite_asteroid_4_ridge.png"]
    }
  }

  getSpritePath() {
    return "meteorite_asteroid_2_ridge.png"
  }

  getOreSpritePath() {
    return "meteorite.png"
  }

  getType() {
    return Protocol.definition().TerrainType.MeteoriteAsteroid
  }

  getConstantsTable() {
    return "Terrains.MeteoriteAsteroid"
  }

  getShadowColor() {
    return "#ffffff" // no shadows
  }

  drawMinimap() {
  }

  undrawMinimap() {
  }
}

module.exports = MeteoriteAsteroid

},{"./../../../../../common/constants.json":656,"./../../../../../common/util/protocol":686,"./asteroid":564}],568:[function(require,module,exports){
const BaseTerrain = require("./../base_terrain")

class BaseGround extends BaseTerrain {
  getGroup() {
    return "grounds"
  }

  isGroundTile() {
    return true
  }

}

module.exports = BaseGround

},{"./../base_terrain":563}],569:[function(require,module,exports){
const BaseGround = require("./base_ground")
const Constants = require("./../../../../../common/constants.json")
const Protocol = require("./../../../../../common/util/protocol")

class Rock extends BaseGround {

  static getTextureMapping() {
    return {
      line_zero: PIXI.utils.TextureCache["rock_0.png"],
      line_one: PIXI.utils.TextureCache["rock_1.png"],
      line_two: PIXI.utils.TextureCache["rock_2.png"],
      line_two_straight: PIXI.utils.TextureCache["rock_2_straight.png"],
      line_three: PIXI.utils.TextureCache["rock_3.png"],
      line_four: PIXI.utils.TextureCache["rock_4.png"]
    }
  }

  getSideHitTileMaps() {
    return [this.game.sector.map, this.game.sector.groundMap]
  }

  getSpritePath() {
    return 'rock_2.png'
  }

  getType() {
    return Protocol.definition().TerrainType.Rock
  }

  getConstantsTable() {
    return "Terrains.Rock"
  }

  // getShadowColor() {
  //   let neighbors = this.game.sector.lightManager.getLightNeighbors({ row: this.getRow(), col: this.getCol() })
  //   let isBesideSkyOrWater = neighbors.find((neighbor) => { 
  //     return !neighbor.entity || (neighbor.entity && neighbor.entity.isUndergroundTile())
  //   })

  //   if (isBesideSkyOrWater) {
  //     return "#ffffff" // no shadows
  //   } else {
  //     return "#111111" // completely hidden by default
  //   }
  // }


}

module.exports = Rock

},{"./../../../../../common/constants.json":656,"./../../../../../common/util/protocol":686,"./base_ground":568}],570:[function(require,module,exports){
const BaseGround = require("./base_ground")
const Constants = require("../../../../../common/constants")
const Protocol = require("../../../../../common/util/protocol")

class Sky extends BaseGround {

  getSprite() {
    let sprite = super.getSprite()
    sprite.tint = 0x0e1f32
    return sprite
  }

  onBuildingPlaced(row, col) {
  }

  unregister() {
  }

  getType() {
    return Protocol.definition().TerrainType.Sky
  }

  getConstantsTable() {
    return "Terrains.Sky"
  }

  getSpritePath() {
    return 'sky.png'
  }

}

module.exports = Sky

},{"../../../../../common/constants":656,"../../../../../common/util/protocol":686,"./base_ground":568}],571:[function(require,module,exports){
const Helper = require("./../../../../common/helper")

const Terrains = {}

Terrains.Sky = require("./grounds/sky")
Terrains.Water = require("./undergrounds/water")
Terrains.Lava = require("./undergrounds/lava")
Terrains.Oil = require("./undergrounds/oil")

Terrains.Rock = require("./grounds/rock")
// Terrains.Ice = require("./grounds/ice")
// Terrains.LavaRock = require("./grounds/lava_rock")

// Terrains.Vine = require("./foregrounds/vine")
Terrains.Asteroid = require("./foregrounds/asteroid")
Terrains.CopperAsteroid = require("./foregrounds/copper_asteroid")
// Terrains.SteelAsteroid = require("./foregrounds/steel_asteroid")
// Terrains.IceAsteroid = require("./foregrounds/ice_asteroid")
// Terrains.IronAsteroid = require("./foregrounds/iron_asteroid")
Terrains.MeteoriteAsteroid = require("./foregrounds/meteorite_asteroid")

Terrains.forType = (type) => {
  const klassName = Helper.getTerrainNameById(type) 
  return Terrains[klassName]
}

Terrains.getList = () => {
  return Object.values(Terrains).filter((klass) => {
    return typeof klass.getType === "function"
  })
}

module.exports = Terrains
},{"./../../../../common/helper":664,"./foregrounds/asteroid":564,"./foregrounds/copper_asteroid":566,"./foregrounds/meteorite_asteroid":567,"./grounds/rock":569,"./grounds/sky":570,"./undergrounds/lava":573,"./undergrounds/oil":574,"./undergrounds/water":575}],572:[function(require,module,exports){
const BaseTerrain = require("./../base_terrain")
const Constants = require("./../../../../../common/constants.json")
const ClientHelper = require("./../../../util/client_helper")
const Trail = require("../../particles/trail")

class BaseUnderground extends BaseTerrain {
  getGroup() {
    return "undergrounds"
  }

  isUndergroundTile() {
    return true
  }

  onBuildingConstructed() {
    super.onBuildingConstructed()

    // this.shadowSprites = []
    // this.drawShadow()
  }

  getShadowColor() {
    return "#ffffff" // no shadows
  }

  redrawSprite() {
    // this.drawShadow()
  }

  getHitDirection(hit) {
    if (hit.row === this.getRow() - 1) {
      return "up"
    } else if (hit.row === this.getRow() + 1) {
      return "down"
    } else if (hit.col === this.getCol() - 1) {
      return "left"
    } else if (hit.col === this.getCol() + 1) {
      return "right"
    }
  }

  getShadowRotation(direction) {
    let angle  

    switch(direction) {
      case "up": 
        angle = Math.PI/2
        break
      case "right": 
        angle = Math.PI
        break
      case "down": 
        angle = -Math.PI/2
        break
      case "left": 
        angle = 0
        break
    }

    return angle
  }

  createShadowSprite(angle) {
    let texture = PIXI.utils.TextureCache["shadow.png"]
    let sprite = new PIXI.Sprite(texture)
    sprite.name = "Shadow"
    sprite.anchor.set(0.5)
    sprite.position.y = this.getRow() * Constants.tileSize + Constants.tileSize/2
    sprite.position.x = this.getCol() * Constants.tileSize + Constants.tileSize/2
    sprite.width  = 40
    sprite.height = 40
    sprite.rotation = angle
    return sprite
  }

  drawShadow() {
    this.removeShadowSprites()

    let groundNeighbors = this.sector.groundMap.getNeighbors(this.getRow(), this.getCol())
    if (Object.keys(groundNeighbors).length > 0) {
      groundNeighbors.forEach((hit) => {
        let direction = this.getHitDirection(hit)
        let angle  = this.getShadowRotation(direction)
        let sprite = this.createShadowSprite(angle)
        this.getSpriteContainer().addChild(sprite)
        this.shadowSprites.push(sprite)
      })
    }
  }

  removeShadowSprites() {
    this.shadowSprites.forEach((sprite) => {
      sprite.parent.removeChild(sprite)
    })

    this.shadowSprites = []
  }

  remove() {
    super.remove()
    // this.removeShadowSprites()
  }


  animateWalk(entity) {
    if (!this.getConstants().showLiquidTrail) return

    this.animationGap = this.animationGap || 0
    const animationInterval = 32

    if (this.animationGap % animationInterval === 0) {
      const radius = Math.floor(Math.random() * 10) + 32

      Trail.create({
        x: entity.getX(), 
        y: entity.getY(), 
        angle: 0, 
        color: this.getTrailColor(), 
        radius: radius, 
        offset: 0, 
        isExpanding: true, 
        spritePath: "circle_white.png", 
        spriteContainer: this.game.sector.highGroundEffectsContainer
      })
    
      // this.game.playSound("water_step")
    }

    this.animationGap += 1
  }

  getTrailColor() {
    let color = this.getConstants().liquidTrailColor
    if (color) {
      let numericalColor = parseInt(color.replace("#", ""), 16)
      return numericalColor
    } else {
      return 0x888888
    }
  }

  getSprite() {
    let sprite = super.getSprite()

    // we want it to be a little larger so that
    // edges above ground would be more visible
    let gameRowCount = this.sector.rowCount
    let gameColCount = this.sector.colCount

    let isEdgeOfMap =  this.data.row === 0 || this.data.row === gameRowCount - 1 ||
                       this.data.col === 0 || this.data.col === gameColCount - 1

    if (!isEdgeOfMap) {
      sprite.width = 48
      sprite.height = 48
    }

    return sprite
  }

}

module.exports = BaseUnderground

},{"../../particles/trail":509,"./../../../../../common/constants.json":656,"./../../../util/client_helper":649,"./../base_terrain":563}],573:[function(require,module,exports){
const BaseUnderground = require("./base_underground")
const Constants = require("./../../../../../common/constants.json")
const Protocol = require("./../../../../../common/util/protocol")

class Lava extends BaseUnderground {

  onBuildingConstructed() {
    super.onBuildingConstructed()

    if (Math.random() < 0.15) {
      this.animate()
    }
  }

  animate() {
    this.animateLava()
  }

  animateLava() {
    if (this.tween) return
    if (this.bubbleSprite) return

    this.bubbleSprite = this.getBubbleSprite()
    this.sector.groundEffectsContainer.addChild(this.bubbleSprite)

    let width = { width: this.bubbleSprite.width }

    this.tween = new TWEEN.Tween(width)
        .to({ width: this.bubbleSprite.width + 20 }, 1000)
        .onUpdate(() => {
          this.bubbleSprite.width  = width.width
          this.bubbleSprite.height = width.width
        })
        .onComplete(() => {
          this.sector.groundEffectsContainer.removeChild(this.bubbleSprite)
          this.tween = null
        })
        .repeat(Infinity)
        .yoyo(true)

    this.tween.start()
  }

  getBubbleSprite() {
    const sprite = new PIXI.Sprite(PIXI.utils.TextureCache["lava_bubble.png"])
    sprite.anchor.set(0.5)

    let randomWidth = Math.floor(Math.random() * 7) + 2
    sprite.width = randomWidth
    sprite.height = randomWidth
    sprite.position.x = this.getX()
    sprite.position.y = this.getY()

    return sprite
  }

  cleanupTween() {
    if (this.tween) {
      this.tween.stop()
      this.tween = null
    }
  }

  remove() {
    super.remove()

    this.cleanupTween()

    if (this.bubbleSprite) {
      this.bubbleSprite.parent.removeChild(this.bubbleSprite)
      this.bubbleSprite = null
    }
  }

  onCovered() {
    if (this.bubbleSprite) {
      this.cleanupTween()
      this.bubbleSprite.parent.removeChild(this.bubbleSprite)
      this.bubbleSprite = null
    }
  }

  onUncovered() {
    if (Math.random() < 0.15) {
      this.animate()
    }
  }

  getSpritePath() {
    return 'lava.png'
  }

  getType() {
    return Protocol.definition().TerrainType.Lava
  }

  getConstantsTable() {
    return "Terrains.Lava"
  }

}

module.exports = Lava

},{"./../../../../../common/constants.json":656,"./../../../../../common/util/protocol":686,"./base_underground":572}],574:[function(require,module,exports){
const BaseUnderground = require("./base_underground")
const Constants = require("./../../../../../common/constants.json")
const Protocol = require("./../../../../../common/util/protocol")

class Oil extends BaseUnderground {

  getSpritePath() {
    return 'black.png'
  }

  getType() {
    return Protocol.definition().TerrainType.Oil
  }

  getConstantsTable() {
    return "Terrains.Oil"
  }

}

module.exports = Oil

},{"./../../../../../common/constants.json":656,"./../../../../../common/util/protocol":686,"./base_underground":572}],575:[function(require,module,exports){
const BaseUnderground = require("./base_underground")
const Constants = require("./../../../../../common/constants.json")
const Protocol = require("./../../../../../common/util/protocol")

class Water extends BaseUnderground {

  getSpritePath() {
    return 'water.png'
  }

  getType() {
    return Protocol.definition().TerrainType.Water
  }

  getConstantsTable() {
    return "Terrains.Water"
  }


}

module.exports = Water

},{"./../../../../../common/constants.json":656,"./../../../../../common/util/protocol":686,"./base_underground":572}],576:[function(require,module,exports){
const Helper = require("./../../../../common/helper")

const Transports = {}

Transports.RailTram = require("./rail_tram")

Transports.forType = (type) => {
  const klassName = Helper.getTransportNameById(type) 
  return Transports[klassName]
}


module.exports = Transports

},{"./../../../../common/helper":664,"./rail_tram":577}],577:[function(require,module,exports){
const Constants = require("./../../../../common/constants.json")
const Protocol = require("./../../../../common/util/protocol")
const Tilable = require("./../../../../common/interfaces/tilable")
const BaseEntity = require("./../base_entity")

class RailTram extends BaseEntity {

  constructor(game, data) {
    super(game, data)
    
    this.chunks = {}
  }

  static build(game, data) {
    return new this(game, data)
  }

  getSpriteContainer() {
    return this.game.sector.spriteLayers["transports"]
  }

  getSpritePath() {
    return 'rail_tram.png'
  }

  syncWithServer(data) {
    this.instructToMove(data.x, data.y)
  }

//   instructToMove(x, y) {
//     // this.direction = [x - this.sprite.x, y - this.sprite.y]
//     // console.log("direction: " + this.direction)
//     this.sprite.instructToMove(x, y)
// 
//     console.log('move: ' + [x,y].join("-"))
//     console.log('distanceToCover: ' + JSON.stringify(this.sprite.interpolator.distanceToCover))
//   }

  interpolate(lastFrameTime) {
    this.interpolateCustom(lastFrameTime)
  }

  interpolateCustom(lastFrameTime) {
    const prev = { x: this.sprite.position.x, y: this.sprite.position.y }

    const oldX = this.sprite.x
    const oldY = this.sprite.y
    const oldRow = Math.floor(oldY / Constants.tileSize)
    const oldCol = Math.floor(oldX / Constants.tileSize)

    super.interpolate(lastFrameTime)
    const curr = { x: this.sprite.position.x, y: this.sprite.position.y }

    const row = Math.floor(this.sprite.y / Constants.tileSize)
    const col = Math.floor(this.sprite.x / Constants.tileSize)

    if (curr.x !== prev.x || curr.y !== prev.y) {
      this.onPositionChanged()

      if (oldRow !== row || oldCol !== col) {
        this.onGridPositionChanged()
      }
    }
  }

  onPositionChanged() {

  }

  onGridPositionChanged() {
    this.registerToChunk()
  }

  getGroup() {
    return "transports"
  }

  getType() {
    return Protocol.definition().TransportType.RailTram
  }

  getConstantsTable() {
    return "Transports.RailTram"
  }

  remove() {
    this.getContainer().unregisterEntity("transports", this)

    if (this.getChunk()) {
      this.getChunk().unregister("transports", this)
    }
    
    super.remove()
  }

}

module.exports = RailTram
},{"./../../../../common/constants.json":656,"./../../../../common/interfaces/tilable":680,"./../../../../common/util/protocol":686,"./../base_entity":206}],578:[function(require,module,exports){
const SocketUtil = require("./../util/socket_util")
const BaseMenu = require("./base_menu")
const Constants = require("./../../../common/constants.json")


/*
    while element references only inventory, it actually changes hotbar/quick_inventory as well
*/
class AllianceMenu extends BaseMenu {
  onMenuConstructed() {
  }

  render(team) {
    this.team = team

    this.el.querySelector(".alliance_relationship_percentage").innerText = this.team.relationshipScore + " / 100"

    this.renderRelationshipStatus()
    this.renderDeeds()
  }

  renderRelationshipStatus() {
    this.el.querySelector(".alliance_relationship_status").innerText = i18n.t(this.team.relationshipStatus)
    if (this.team.relationshipStatus === "Hostile") {
      this.el.querySelector(".alliance_relationship_status").classList.remove("friendly")
      this.el.querySelector(".alliance_relationship_status").classList.add("hostile")
    } else if (this.team.relationshipStatus === "Friendly") {
      this.el.querySelector(".alliance_relationship_status").classList.remove("hostile")
      this.el.querySelector(".alliance_relationship_status").classList.add("friendly")
    }
  }

  renderDeeds() {
    let deedList = ""

    for (let deed in this.team.deeds) {
      let deedData = Constants.Deeds[deed]
      let className = deedData.effect < 0 ? 'deed_entry negative' : 'deed_entry positive'
      let deedDescriptionTranslationKey = deed + ".Description"
      let deedDescription = i18n.has(deedDescriptionTranslationKey) ? i18n.t(deedDescriptionTranslationKey) : deedData.description
      deedList += "<div class='" + className + "'>" + deedData.effect + " " + deedDescription + "</div>"
    }

    this.el.querySelector(".alliance_relationship_details").innerHTML = deedList
  }
}

module.exports = AllianceMenu

},{"./../../../common/constants.json":656,"./../util/socket_util":654,"./base_menu":581}],579:[function(require,module,exports){
const SocketUtil = require("./../util/socket_util")
const BaseMenu = require("./base_menu")
const Constants = require("./../../../common/constants.json")

class AtmMenu extends BaseMenu {
  onMenuConstructed() {
    let tab = document.querySelector(".atm_tab.selected").dataset.tab
    this.activeTabContent = document.querySelector(".atm_content[data-tab='" + tab + "']")
    this.activeTabContent.style.display = 'block'
  }

  initListeners() {
    super.initListeners()

    this.el.querySelector(".atm_withdraw_btn").addEventListener("click", this.onAtmWithdrawBtnClick.bind(this))
    this.el.querySelector(".atm_deposit_btn").addEventListener("click", this.onAtmDepositBtnClick.bind(this))

    this.el.querySelector(".atm_tab_container").addEventListener("click", this.onAtmTabClick.bind(this), true)

    this.el.querySelector(".send_money_btn").addEventListener("click", this.onSendMoneyBtnClick.bind(this))
    this.el.querySelector(".send_money_input").addEventListener("keyup", this.onSendMoneyInputKeyup.bind(this))
  }

  onSendMoneyInputKeyup(e) {
    if (e.key === "Enter") {
      this.sendMoney()
    }
  }

  onSendMoneyBtnClick(e) {
    this.sendMoney()
  }

  sendMoney() {
    let gold = parseInt(this.el.querySelector(".send_money_input").value)
    if (gold < 0) {
      this.game.displayError("Invalid Amount", { warning: true })
      return
    }

    let playerId = this.el.querySelector(".recepient_name_select").value
    if (!playerId) return

    SocketUtil.emit("SendMoney", { playerId: playerId, gold: gold })
  }


  onAtmTabClick(e) {
    this.selectTab(e.target)
  }

  selectTab(tabEl) {
    let tab = tabEl.dataset.tab
    if (!tab) return

    let selectedTab = this.el.querySelector(".atm_tab.selected")
    if (selectedTab) {
      selectedTab.classList.remove("selected")
    }

    tabEl.classList.add("selected")

    if (this.activeTabContent) {
      this.activeTabContent.style.display = 'none'
    }

    let tabContent = this.el.querySelector(".atm_content[data-tab='" + tab + "'")
    this.activeTabContent = tabContent
    this.activeTabContent.style.display = 'block'
  }

  onAtmWithdrawBtnClick(e) {
    let gold = parseInt(this.el.querySelector(".atm_money_input").value)
    if (isNaN(gold)) return
    // if (gold === 0) return
    // if (gold < 0) {
    //   this.game.displayError("Invalid Amount", { warning: true })
    //   return
    // }

    SocketUtil.emit("AtmAction", { action: 'withdraw', gold: gold })
  }

  onAtmDepositBtnClick(e) {
    let gold = parseInt(this.el.querySelector(".atm_money_input").value)
    if (isNaN(gold)) return
    // if (gold === 0) return
    // if (gold < 0) {
    //   this.game.displayError("Invalid Amount", { warning: true })
    //   return
    // }

    SocketUtil.emit("AtmAction", { action: 'deposit', gold: gold })
  }

  updateGoldCount(gold, delta) {
    this.el.querySelector(".local_gold_value").innerText = gold || 0
    this.el.querySelector(".player_gold_count_value").innerText = gold

    if (this.isOpen()) {
      this.animateGoldChanged(delta)
    }
  }

  open(options = {}) {
    super.open(options)

    this.entity = options.entity
    this.render()

  }

  updateBalance(balance) {
    this.el.querySelector(".atm_balance_value").innerText = balance
  }

  isNotAllowed() {
    return this.game.isHardcore()
  }

  render() {
    let accountTab = this.el.querySelector(".atm_tab[data-tab='account']")
    let transferTab = this.el.querySelector(".atm_tab[data-tab='transfer']")

    if (this.game.isPeaceful() || !this.game.isLoggedIn()) {
      accountTab.style.display = 'none'
      this.selectTab(transferTab)
    } else {
      accountTab.style.display = 'block'
      this.selectTab(accountTab)
    }

    if (this.isNotAllowed()) {
      this.el.querySelector(".atm_invalid_access").style.display = 'block'
      this.el.querySelector(".atm_invalid_access").innerText = i18n.t("ATM is disabled")

      this.el.querySelector(".atm_content_container").style.display = 'none'
    } else {
      this.el.querySelector(".atm_invalid_access").style.display = 'none'
      this.el.querySelector(".atm_content_container").style.display = 'block'
    }

    let gold = this.game.player.gold
    this.el.querySelector(".local_gold_value").innerText = gold
    this.el.querySelector(".player_gold_count_value").innerText = gold

    this.el.querySelector(".atm_balance_value").innerText = "Loading.."
    SocketUtil.emit("AtmAction", { action: 'balance' })

    this.renderSendMoneyRecipients()
  }

  renderSendMoneyRecipients() {
    let team = this.game.player.getTeam()
    if (!team) return

    this.el.querySelector(".recepient_name_select").innerHTML = ""

    for (let id in team.members) {
      let member = team.members[id]
      if (member.id !== this.game.player.id) {
        let option = "<option value='" + member.id + "'>" + member.name + "</option>"
        this.el.querySelector(".recepient_name_select").innerHTML += option
      }
    }
  }

  animateGoldChanged(delta) {
    let data = {}

    let activeTab = this.activeTabContent.dataset.tab
    let goldElKlass = activeTab === 'account' ? 'local_gold_value' : 'player_gold_count_value'
    let rect = this.el.querySelector("." + goldElKlass).getBoundingClientRect()
    data.y = rect.top - 20
    data.x = rect.left - 50

    let label = delta < 0 ? delta : "+" + delta
    let text = document.createElement("span")
    text.className = "gold_changed_label"
    text.innerText = label
    document.body.appendChild(text)

    text.style.top  = data.y + "px"
    text.style.left = data.x + "px"

    let position = { y: data.y }
    var tween = new TWEEN.Tween(position)
        .to({ y: data.y - 50 }, 1500)
        .onUpdate(() => {
          text.style.top = position.y + "px"
        })
        .onComplete(() => {
          if (text.parentElement) {
            text.parentElement.removeChild(text)
          }
        })
        .start()
  }


}



module.exports = AtmMenu

},{"./../../../common/constants.json":656,"./../util/socket_util":654,"./base_menu":581}],580:[function(require,module,exports){
const BaseMenu = require('./base_menu')

class BadgeMenu extends BaseMenu {
    onMenuConstructed() {
        
    }
    open() {
        super.open()
        this.game.getSocketUtil().emit("GetBadges", {})
    }
}

module.exports = BadgeMenu
},{"./base_menu":581}],581:[function(require,module,exports){
const Item = require("./../entities/item")
const SocketUtil = require("./../util/socket_util")
const Constants = require("./../../../common/constants.json")
const Protocol = require("./../../../common/util/protocol")

class BaseMenu {
  constructor(game, el) {
    this.el   = el
    this.game = game

    this.buildingTooltip  = document.querySelector("#building_menu_tooltip")

    this.onMenuConstructed() // before listeners are setup so listeners can attach to dynamic dom elements
    this.initListeners()

    this.game.registerMenu(this)
  }

  getPlayer() {
    return this.game.player
  }

  isModal() {
    return true
  }

  finishOpen() {
    // nothing by default
  }

  onMenuConstructed() {
    // callback
  }

  initListeners() {
    const cancelBtn = this.el.querySelector(".cancel_btn")
    if (cancelBtn) {
      cancelBtn.addEventListener("click", this.onCancelBtnClick.bind(this), true)
    }
  }

  onCancelBtnClick() {
    this.close()
  }

  initInventorySlotListener(el) {
    if (this.game.main.isMobile) {
      el.addEventListener("touchstart", this.onInventoryTouchStart.bind(this), true)
      el.addEventListener("touchmove", this.onInventoryTouchMove.bind(this), true)
      el.addEventListener("touchend", this.onInventoryTouchEnd.bind(this), true)
    } else {
      el.addEventListener("mouseover", this.onInventoryMouseover.bind(this), true)
      el.addEventListener("mouseout", this.onInventoryMouseout.bind(this), true)
      el.addEventListener("mousedown", this.onInventoryMouseDown.bind(this), true)
      el.addEventListener("mouseup", this.onInventoryMouseUp.bind(this), true)
    }
  }

  onInventoryMouseUp(e) {
  }

  onInventoryMouseDown(e) {
    const storageId = e.target.closest(".storage").dataset.storageId
    const index = e.target.closest(".inventory_slot").dataset.index

    if (this.game.inputController.isRightClick(e)) {
      if (this.game.holdItemInventorySlot) {
        SocketUtil.emit("ManageStack", { 
          storageId: storageId,
          index: index, 
          mode: Protocol.definition().StackOperationType.Merge,
          count: 1
        })
      } else {
        SocketUtil.emit("ManageStack", { 
          storageId: storageId,
          index: index, 
          mode: Protocol.definition().StackOperationType.Split
        })
      }
    } else {
      if (this.game.holdItemInventorySlot) {
        let count = this.game.holdItemInventorySlot.dataset.content
        count = parseInt(count)
        if (isNaN(count)) {
          count = 1
        }

        SocketUtil.emit("ManageStack", { 
          storageId: storageId,
          index: index, 
          mode: Protocol.definition().StackOperationType.Merge,
          count: count
        })
      }
    }
  }

  onInventoryMouseover(e) {
    const inventorySlot = e.target.closest(".inventory_slot")
    if (inventorySlot) {
      let boundingRect = inventorySlot.getBoundingClientRect()
      this.showInventoryTooltip(inventorySlot, boundingRect)
    }
  }

  showInventoryTooltip(inventorySlot, boundingRect) {
    const type = parseInt(inventorySlot.dataset.type)
    if (isNaN(type)) return
      
    const itemId = inventorySlot.dataset.id
    const itemContent = inventorySlot.dataset.special
    const itemKlass = Item.getKlass(type)
    if (itemKlass) {
      this.showBuildMenuForAt(itemId, itemKlass, inventorySlot, itemContent, boundingRect)
    }
  }

  onInventoryTouchStart(e) {
    const inventorySlot = e.target.closest(".inventory_slot")
    let boundingRect = inventorySlot.getBoundingClientRect()

    this.displayBuildMenuTimeout = setTimeout(() => {
      this.showInventoryTooltip(inventorySlot, boundingRect)
    }, 500)
  }

  renderPlayerInventory(data) {
    let inventory = data.inventory
    
    if (inventory.clientMustDelete) {
      const inventorySlot = this.el.querySelector(".storage_player_inventory .inventory_slot[data-index='" + inventory.index  + "']")
      this.game.resetInventorySlot(inventorySlot)
    } else {
      const prevInventorySlot = this.el.querySelector(".storage_player_inventory .inventory_slot[data-id='" + inventory.id  + "']") 
      if (prevInventorySlot) {
        this.game.resetInventorySlot(prevInventorySlot)
      }

      const inventorySlot = this.el.querySelector(".storage_player_inventory .inventory_slot[data-index='" + inventory.index  + "']")
      this.game.renderInventorySlot(inventorySlot, inventory)
    }
  }

  initPlayerInventorySlotListeners() {
    let elements = this.el.querySelectorAll(".storage_player_inventory .inventory_slot")
    for (let i = 0; i < elements.length; i++) {
      let el = elements[i]
      this.initInventorySlotListener(el)
    }
  }

  initPlayerInventoryStorage() {
    const inventorySlotCount = Constants.Player.inventoryCount 

    this.el.querySelector(".storage_player_inventory").innerHTML = this.createInventorySlots(inventorySlotCount)
  }

  createTradeItem(klass, options = {}) {
    let imagePath = "/assets/images/" + klass.prototype.getSpritePath()

    let cost = (options.isSelling ? Math.ceil(klass.getCost() / 2) : klass.getCost())
    if (options.cost) cost = options.cost
    let currency = "G"
    let currencyklass = ""
    if (options.itemName) {
      currency = options.itemName
      currencyklass = "custom"
    }

    const el = "<div class='trade_item_row' data-group='" + klass.getSellGroup() + "' data-type='" + klass.getType() + "' data-count='" + options.count + "' data-index='" + options.index + "' >" +
                    "<img class='trade_item_image' src='" + imagePath + "'>" +
                    "<div class='trade_item_name'>" + i18n.t(klass.getTypeName()) + "</div>" +
                    "<div class='trade_item_count'>" + (options.count ? 'x' + options.count : '') + "</div>" +
                    "<div class='trade_item_cost " + currencyklass + "'>" + cost  + " " + currency + "</div>" +
                "</div>"

    return el
  }
  
  hideQuickInventory() {
    document.querySelector("#player_quick_inventory_menu").style.display = 'none'
  }

  showQuickInventory() {
    document.querySelector("#player_quick_inventory_menu").style.display = 'block'
  }

  shouldHideQuickInventory() {
    return false
  }

  onInventoryTouchEnd(e) {
    clearTimeout(this.displayBuildMenuTimeout)
    this.onInventoryMouseout(e)
  }

  onInventoryTouchMove(e) {
    clearTimeout(this.displayBuildMenuTimeout)
  }

  onInventoryMouseout(e) {
    this.buildingTooltip.style.display = 'none'
  }

  showBuildMenuForAt(itemId, buildingKlass, inventorySlot, itemContent, boundingRect) {
    this.buildingTooltip.style.display = 'block'
    if (this.game.shouldShowDebugDetails()) {
      if (!this.buildingTooltip.classList.contains("admin")) {
        this.buildingTooltip.classList.add("admin")
      }
    } else {
      this.buildingTooltip.classList.remove("admin")
    }
    this.buildingTooltip.querySelector(".entity_name_label").innerText = i18n.t(buildingKlass.getCraftTypeName(itemContent))
    this.buildingTooltip.querySelector(".entity_id").innerText = "ID: " + itemId
    this.buildingTooltip.querySelector(".entity_description").innerText = buildingKlass.getDescription(itemContent)

    // if (!this.isTouchDevice()) {
    this.repositionTooltip(inventorySlot, boundingRect)
    // }
  }

  isTouchDevice() {
    return ('ontouchstart' in document.documentElement)
  }

  repositionTooltip(inventorySlot, boundingRect) {
    const bottomMargin = 25
    let left = boundingRect.x - this.buildingTooltip.offsetWidth  / 2 + inventorySlot.offsetWidth / 2
    let top  = boundingRect.y - this.buildingTooltip.offsetHeight  - bottomMargin
    const margin = 25

    left = Math.max(margin, left) // cant be lower than margin
    left = Math.min(window.innerWidth - this.buildingTooltip.offsetWidth - margin, left) // cant be more than than margin

    if (top < margin) {
      // show at bottom instead
      top = boundingRect.y + (bottomMargin * 2)
    }
    top = Math.max(margin, top) // cant be lower than margin
    top = Math.min(window.innerHeight - this.buildingTooltip.offsetHeight - margin, top) // cant be more than than margin

    this.buildingTooltip.style.left = left + "px"
    this.buildingTooltip.style.top  = top  + "px"
  }

  closeAllMenus() {
    this.game.closeAllMenus()
  }

  isEntityMenu() {
    return false
  }

  open(options = {}) {
    if (this.isControllingPlayerRequired()) {
      if (!this.game.player) return
      if (!this.game.player.isControllingPlayer()) return
    }

    if (this.game.shouldDenyMenuOpen) return

    if (!options.dontCloseMenus) {
      this.closeAllMenus()
    }

    if (!this.isAlwaysOpen()) {
      let isNotOpen = this.game.openMenus.indexOf(this) === -1
      if (isNotOpen) {
        this.game.openMenus.push(this)
      }
    }

    this.setOpenDisplay()
  }

  setOpenDisplay() {
    this.el.style.display = 'block'
  }

  isControllingPlayerRequired() {
    return true
  }

  isAlwaysOpen() {
    return false
  }

  close(options = {}) {
    if (!options.manualUnregister) {
      let index = this.game.openMenus.indexOf(this)
      if (index >= 0) {
        this.game.openMenus.splice(index, 1)
      }
    }

    if (this.storageId) {
      SocketUtil.emit("CloseStorage", { id: this.storageId })
    }

    this.el.style.display = 'none'
  }

  isOpen() {
    return this.el.style.display === 'block'
  }

  isClose() {
    return this.el.style.display === 'none'
  }

  toggle() {
    if (this.isClose()) {
      this.open()
    } else {
      this.close()
    }
  }

  onCraftSuccess(data) {
    // nothing by default
  }

  onInventoryChanged() {
    // nothing by default
  }

  onCraftBtnRelease() {
    this.isCraftBtnHeld = false
  }

  onCraftBtnHold() {
    if (this.isDisabled) return
    if (!this.craftType) return

    if (this.el.querySelector(".craft_btn").dataset.disabled === "true") return

    this.isCraftBtnHeld = true

    let craftCount = parseInt(this.el.querySelector(".craft_count").value)
    if (isNaN(craftCount)) craftCount = 1
    this.craftItem(craftCount)

    // // reset interval
    // clearInterval(this.craftMultipleInterval)

    // this.craftMultipleInterval = setInterval(() => {
    //   if (this.isCraftBtnHeld) {
    //     this.craftItem(5)
    //   } else {
    //     clearInterval(this.craftMultipleInterval)
    //   }
    // }, 600)
  }

  craftItem(count) {
    let options = { storageId: this.getStorageId(), type: this.craftType, count: count }
    
    if (this.sourceStorageId) {
      options['sourceStorageId'] = this.sourceStorageId
    }
    
    SocketUtil.emit("Craft", options)
  }

  cleanup() {

  }

  clearRequirements() {
    this.el.querySelector(".crafting_requirements").innerHTML = ""
  }

  showProductInfo(type) {
    const itemKlass = Item.getKlass(type)
    let imagePath = "/assets/images/" + itemKlass.prototype.getSpritePath()

    this.el.querySelector(".blueprint_image").src = imagePath
    this.el.querySelector(".blueprint_name").innerText = i18n.t(itemKlass.getCraftTypeName())
    this.el.querySelector(".blueprint_description").innerText = itemKlass.getDescription()

    let productUnavailableEl = this.el.querySelector(".product_unavailable_notice")
    if (!this.isBuildingAllowedInGame(type)) {
      if (productUnavailableEl) {
        productUnavailableEl = i18n.t('Disabled in PvP')
      }
      this.el.querySelector(".craft_count").style.display = 'none'
      this.el.querySelector(".craft_btn").style.display = 'none'
    } else {
      if (productUnavailableEl) {
        productUnavailableEl.style.display = 'none'
      }
      this.el.querySelector(".craft_count").style.display = 'inline-block'
      this.el.querySelector(".craft_btn").style.display = 'inline-block'
    }

    this.showRequirements(type)
  }

  isBuildingAllowedInGame(type) {
    if (this.game.isPvP()) {
      let notAllowedList = ["Atm", "RailStop", "RailTrack", "Beacon"]
      notAllowedList = notAllowedList.map((name) => {
        return Protocol.definition().BuildingType[name]
      })

      if (notAllowedList.indexOf(type) !== -1) {
        return false
      }
    } else if (this.game.isHardcore() || this.game.isPeaceful()) {
      let notAllowedList = ["Atm"]
      notAllowedList = notAllowedList.map((name) => {
        return Protocol.definition().BuildingType[name]
      })

      if (notAllowedList.indexOf(type) !== -1) {
        return false
      }
    }

    return true
  }

  isSandboxMode() {
    if (this.game.isSandbox()) return true
    return (debugMode && this.game.isAdminMode)
  }

  showRequirements(type) {
    this.clearRequirements()

    const requirements = Item.getCraftRequirements(type, this.game.player)
    requirements.forEach((requirement) => {
      let row = this.createRequirementRow(requirement)
      this.el.querySelector(".crafting_requirements").innerHTML += row
    })

    let isSandboxModeAndOwner = this.isSandboxMode() && this.game.player.isSectorOwner()
    if (this.isDisabled || (this.hasMissingRequirements(requirements) && !isSandboxModeAndOwner)) {
      this.el.querySelector(".craft_btn").dataset.disabled = true
    } else {
      this.el.querySelector(".craft_btn").dataset.disabled = ""
    }
  }

  hasMissingRequirements(requirements) {
    return requirements.find((requirement) => {
      let count = requirement.count
      let buildSpeed =  this.game.sector.buildSpeed
      count = Math.ceil(count / buildSpeed)
      return requirement.supply < count
    })
  }

  createRequirementRow(requirement) {
    let type = requirement.klass.getType()
    let imgSrc = this.game.getImageSrcForItemType(type)

    let count = requirement.count
    let buildSpeed =  this.game.sector.buildSpeed
    count = Math.ceil(count / buildSpeed)


    let hasInsufficientSupply = requirement.supply < count
    let supplyClassName = hasInsufficientSupply ? "unmet" : ""

    let requirementName = isForeignLanguage ? i18n.t(requirement.name) : requirement.name

    let el = "<div class='requirement_row'>" +
               "<img src='" + imgSrc + "'>" +
               "<div class='requirement_name'>" + requirementName + "</div>" +
               "<div class='requirement_supply " + supplyClassName + "'>" +
                 "<span class='supply_count'>" + requirement.supply + "</span>" +
                   "/" +
                 "<span class='requirement_count'>" + count + "</span>" +
               "</div>" +
             "</div>"

    return el
  }

  buildRequirementsLabel(type, missingRequirements) {
    const requirements = Item.getRequirements(type)

    let buildSpeed =  this.game.sector.buildSpeed

    let result = []

    for (let name in requirements) {
      let count = requirements[name]
      count = Math.ceil(count / buildSpeed)
      let label = count + " x " + name

      if (missingRequirements[name]) {
        result.push("<span class='missing_requirement'>" + label + "</span>")
      } else {
        result.push(label)
      }
    }

    return result.join(", ")
  }

  createInventorySlots(count, baseIndex) {
    let el = ""

    for (var i = 0; i < count; i++) {
      el += this.createInventorySlot(i, baseIndex)
    }

    return el
  }

  createInventorySlot(index, baseIndex = 0) {
    let absoluteIndex = baseIndex + index
    return  "<div class='inventory_slot' data-index='" + absoluteIndex + "'><img src=''></div>"
  }

  unhighlightInventorySlot(inventorySlot) {
    const activeInventorySlot = inventorySlot || this.el.querySelector(".inventory_slot.active")
    if (activeInventorySlot) {
      activeInventorySlot.className = "inventory_slot"
    }
  }

  highlightInventorySlot(inventorySlot) {
    inventorySlot.className = "inventory_slot active"
  }

  hasPlayerInventory() {
    return false
  }

  updateStorageInventory(data) {
    let storageEl = this.el.querySelector(".storage[data-storage-id='" + data.id + "']")
    if (!storageEl) return

    Array.from(storageEl.querySelectorAll(".inventory_slot")).forEach((inventorySlot) => {
      let isNotDraggableMirror = inventorySlot.className.indexOf("draggable-mirror") === -1
      if (isNotDraggableMirror) {
        this.game.resetInventorySlot(inventorySlot)
      }
    })

    for (let index in data.inventory.storage) {
      let inventory = data.inventory.storage[index]
      if (inventory) {
        let inventorySlot = storageEl.querySelector(".inventory_slot[data-index='" + inventory.index + "']")
        if (inventorySlot) {
          this.game.renderInventorySlot(inventorySlot, inventory)
        }
      }
    }

    if (this.entity && this.entity.getId() === data.id) {
      this.storage = data.inventory.storage
    }
    

    this.onStorageInventoryUpdated()
  }

  onStorageInventoryUpdated() {

  }

  storeInventorySlot(e) {
    if (this.game.isDragging) return
    if (this.game.main.isMobile) return
    if (!this.game.storageMenu.isOpen()) return

    if (this.game.isHoldItemDeletedRecently) {
      this.game.isHoldItemDeletedRecently = false
      return
    }

    let sourceIndex = e.target.closest(".inventory_slot").dataset.index

    let data = {
      sourceStorageId: Constants.inventoryStorageId,
      sourceIndex: sourceIndex,
      destinationStorageId: this.game.storageMenu.storageId
    }

    SocketUtil.emit("SwapInventory", data)
  }


  isStorageMenu() {
    return false
  }

  retrieveInventorySlot(event) {
    if (this.game.isDragging) return
      
    if (!this.game.main.isMobile) {
      let sourceStorageId = event.target.closest(".storage").dataset.storageId
      let sourceIndex = event.target.closest(".inventory_slot").dataset.index
      let destinationStorageId = Constants.inventoryStorageId

      let data = {
        sourceStorageId: sourceStorageId,
        sourceIndex: sourceIndex,
        destinationStorageId: destinationStorageId
      }

      SocketUtil.emit("SwapInventory", data)
    }

  }


  unhighlightTemplateRow(templateRow) {
    if (templateRow) {
      templateRow.className = "template_row"
      return
    }

    const activeRow = this.el.querySelector(".template_row.active")
    if (activeRow) {
      activeRow.className = "template_row"
    }
  }

  highlightTemplateRow(templateRow) {
    templateRow.className = "template_row active"
  }

  onMenuInteract(cmd) {

  }

  createTemplateRow(klass, group) {
    let type = klass.getType()
    let imgSrc = "/assets/images/" + Item.getSpritePath(type)

    let categoryData = group ? "data-construction-type='" + group + "'" : ""
    let el = "<div class='template_row' data-type='" + type + "' " + categoryData + ">" +
      "<img src='" + imgSrc + "'>" +
      "<div class='template_info'>" +
        "<div class='template_name'>" + i18n.t(klass.getCraftTypeName()) + "</div>" +
      "</div>" +
    "</div>"

    return el
  }

}

module.exports = BaseMenu

},{"./../../../common/constants.json":656,"./../../../common/util/protocol":686,"./../entities/item":443,"./../util/socket_util":654}],582:[function(require,module,exports){
const SocketUtil = require("./../util/socket_util")
const CraftMenu = require("./craft_menu")
const Constants = require("./../../../common/constants.json")
const Protocol = require("./../../../common/util/protocol")
const Buildings = require("./../entities/buildings/index")
const Terrains = require("./../entities/terrains/index")
const Equipments = require("./../entities/equipments/index")
const Item = require("./../entities/item")
const GeminiScrollbar = require('gemini-scrollbar')

class BlueprintMenu extends CraftMenu {

  onMenuConstructed() {
    this.lastActiveRows = {}
    this.initCrafting()

    this.terrainNames = Terrains.getList().map((klass) => {
      return klass.getCraftTypeName()
    })
  }

  initCraftTemplateListeners() {
    let elements = Array.from(this.el.querySelectorAll(".construction_category"))
    for (let i = 0; i < elements.length; i++) {
      let el = elements[i]
      el.addEventListener("click", this.onBlueprintTemplateClick.bind(this), true)
    }

    elements = Array.from(this.el.querySelectorAll(".construction_tab"))
    for (let i = 0; i < elements.length; i++) {
      let el = elements[i]
      el.addEventListener("click", this.onConstructionTabClick.bind(this), true)
    }

    this.el.querySelector(".blueprint_search_input").addEventListener("keyup", this.onBlueprintSearchKeyup.bind(this), true)
  }

  canCraftItemName(itemName) {
    if (this.terrainNames.indexOf(itemName) !== -1) {
      if (this.game.sector.isPeaceful() && this.game.player.isSectorOwner()) {
        return true
      } else {
        return false
      }
    }

    return true
  }

  onBlueprintSearchKeyup(e) {
    let text = e.target.value
    if (text.length > 0) {
      // search mode
      this.el.querySelector(".construction_category").dataset.searching = 'true'
    } else {
      this.el.querySelector(".construction_category").removeAttribute("data-searching")
    }

    let prevSearchedRows = this.el.querySelectorAll(".template_row[data-searched='true']")
    for (var i = 0; i < prevSearchedRows.length; i++) {
      let el = prevSearchedRows[i]
      el.removeAttribute("data-searched")
    }

    let templateNameElements = this.el.querySelectorAll(".template_row .template_name")
    let matchCount = 0
    for (var i = 0; i < templateNameElements.length; i++) {
      let el = templateNameElements[i]
      let isSearchMatched = false
      if (this.canCraftItemName(el.innerText)) {
        try {
          isSearchMatched = el.innerText.toLowerCase().match(text.toLowerCase())
        } catch(e) {
        }
      }
      
      if (isSearchMatched) {
        matchCount += 1
        el.closest(".template_row").dataset.searched = 'true'
      }
    }

    if (matchCount === 0) {
      this.el.querySelector(".search_empty_state").dataset.visible = true
    } else {
      this.el.querySelector(".search_empty_state").removeAttribute("data-visible")
    }

    // esc
    if (e.keyCode === 27) {
      this.close()
    }

  }

  open() {
    if (!this.game.player) return
      
    super.open()
    
    let defaultTab 

    if (this.game.sector.isPeaceful() && this.game.player.isSectorOwner()) {
      this.el.querySelector(".construction_tab[data-tab='Terrains']").style.display = 'inline-block'
      defaultTab = document.querySelector(".construction_tab[data-tab='Terrains']")
    } else {
      this.el.querySelector(".construction_tab[data-tab='Terrains']").style.display = 'none'
      defaultTab = document.querySelector(".construction_tab[data-tab='equipments']")
    }

    let lastTab = this.lastActiveTab || defaultTab
    this.selectConstructionTabAndHighlightRow(lastTab)
  }

  initCraftMenu() {
    // dont do anything, already initialized..
  }

  cleanup() {
    this.unhighlightTemplateRow()
    this.craftType = null
    this.lastActiveTab = null
  }

  initCrafting() {
    this.el.querySelector("#blueprint_main_container").innerHTML = this.getCraftingListContainer()

    this.buildSearchInput()
  }

  buildSearchInput() {
    let search = "<div class='blueprint_search_container'>" + 
                    "<img src='/assets/images/search_icon.png'>" +
                    "<input type='text' class='blueprint_search_input'></text>" +
                 "</div>"
    this.el.querySelector("#blueprint_main_container").innerHTML += search
  }

  buildEquipmentMenu() {
    let group = "equipments"
    let equipmentKlasses = Equipments.getList()
    let el = this.buildBlueprintInventorySlots(equipmentKlasses, group)


    return {
      group: group,
      el: el
    }
  }

  buildBlueprintInventorySlots(klasses, group) {
    let inventories = ""

    klasses.forEach((klass) => {
      inventories += this.createTemplateRow(klass, group)
    })

    return inventories
  }

  buildTerrainSlots(klasses, group) {
    let rows = ""

    klasses.forEach((klass) => {
      rows += this.createTemplateRow(klass, group)
    })

    return rows
  }

  buildTab(groups) {
    // make tab buttons
    let tabs = ""
    for (var i = 0; i < groups.length; i++) {
      let group = groups[i]
      let tabEl =  "<div class='construction_tab tab_btn' data-tab='" + group + "'><img src='" + this.getIconImagePathForGroup(group) + "'>" + 
                     "<div class='game_tooltip'>" + i18n.t(group) + "</div>" +
                   "</div>"
      tabs += tabEl
    }

    tabs = "<div class='construction_tabs'>" + tabs + "</div>"

    return tabs
  }

  getIconImagePathForGroup(group) {
    return "/assets/images/" + group.toLowerCase() + "_icon.png"
  }

  updateAllowedCraftables() {
  }

  getFloorKlasses(klasses) {
    let outdatedKlasses = ["WoodFloor", "SteelFloor", "BlueFloor", "GreenFloor", "PurpleFloor", "YellowFloor", "BronzeFloor", "GrayFloor", "PinkFloor", "PlatedFloor", "StripePlatedFloor"]
    return klasses.filter((klass) => {
      let klassName = Protocol.definition().BuildingType[klass.getType()]
      let isOutdated = outdatedKlasses.indexOf(klassName) !== -1 
      return !isOutdated
    })
  }

  getCraftingListContainer() {
    let groups = []
    let containers = ""

    let group = "Terrains"
    groups.push(group)
    let el  = this.buildTerrainSlots(Terrains.getList(), group)
    containers += el

    let menu = this.buildEquipmentMenu()
    groups.push(menu.group)

    for (let group in Buildings) {
      if (typeof Buildings[group] === "function") continue // ignore helpers
      if (Buildings.getExcludeCraftingGroups().indexOf(group) !== -1) continue

      groups.push(group)

      let buildingKlasses = Object.values(Buildings[group])
      if (group === 'Floors') {
        buildingKlasses = this.getFloorKlasses(buildingKlasses)  
      }
      let el = this.buildBlueprintInventorySlots(buildingKlasses, group)

      containers += el
    }


    containers += menu.el

    let tabs = this.buildTab(groups)

    let emptyState = "<div class='search_empty_state'>" + i18n.t('No results') + "</div>"

    containers = "<div class='construction_category'>" + emptyState + containers + "</div>"

    return tabs + containers
  }

  onBlueprintTemplateClick(event) {
    let templateRow = this.handleTemplateClick(event)
    if (!templateRow) return

    let constructionType = templateRow.dataset.constructionType
    this.lastActiveRows[constructionType] = templateRow

    let constructionTab = this.el.querySelector(".construction_tab[data-tab='" + constructionType + "']")
    if (constructionTab) {
      this.selectConstructionTab(constructionTab)
    }
  }

  onConstructionTabClick(e) {
    this.selectConstructionTabAndHighlightRow(e.target)
  }

  selectConstructionTabAndHighlightRow(targetElement) {
    targetElement = targetElement.closest(".construction_tab")

    this.selectConstructionTab(targetElement)

    this.unhighlightTemplateRow()
    this.renderLastSelectedTemplateRow(targetElement.dataset.tab)
  }

  selectConstructionTab(targetElement) {
    targetElement = targetElement.closest(".construction_tab")

    this.highlightTab(targetElement)
    this.highlightTabContainer(targetElement.dataset.tab)

    this.lastActiveTab = targetElement
  }

  onTemplateRowSelected(templateRow) {
    if (templateRow.dataset.constructionType === "equipments") {
      this.el.querySelector(".craft_count").value = "1"
      this.el.querySelector(".craft_count").disabled = true
    } else {
      this.el.querySelector(".craft_count").disabled = false
    }

  }

  getLastActiveTabContainer() {
    let constructionType = this.lastActiveTab.dataset.tab
    return this.el.querySelector(".construction_category[data-construction-type='" + constructionType + "']")
  }

  getLastActiveRow(constructionType) {
    return this.lastActiveRows[constructionType]
  }

  highlightTab(targetElement) {
    let activeTab = document.querySelector(".construction_tab.active")
    if (activeTab) {
      activeTab.classList.remove("active")
    }

    targetElement.classList.add("active")
  }

  highlightTabContainer(group) {
    let elements = Array.from(document.querySelectorAll(".template_row[data-categorized='true']"))
    for (let i = 0; i < elements.length; i++) {
      let el = elements[i]
      el.removeAttribute("data-categorized")
    }

    let rows = document.querySelectorAll(".template_row[data-construction-type='" + group + "']")
    for (let i = 0; i < rows.length; i++) {
      let el = rows[i]
      el.dataset.categorized = 'true'
    }
  }

}

module.exports = BlueprintMenu


},{"./../../../common/constants.json":656,"./../../../common/util/protocol":686,"./../entities/buildings/index":250,"./../entities/equipments/index":407,"./../entities/item":443,"./../entities/terrains/index":571,"./../util/socket_util":654,"./craft_menu":603,"gemini-scrollbar":46}],583:[function(require,module,exports){
const SocketUtil = require("./../util/socket_util")
const BaseMenu = require("./base_menu")
const Constants = require("./../../../common/constants.json")

class ChangeNameMenu extends BaseMenu {
  onMenuConstructed() {
  }

  initListeners() {
    super.initListeners()

    this.el.querySelector(".change_name_input").addEventListener("keyup", this.onChangeNameInputKeyup.bind(this))
    this.el.querySelector(".set_name_btn").addEventListener("click", this.onSetNameBtnClick.bind(this))
  }

  open(options = {}) {
    super.open(options)

    this.entity = options.entity
    this.render()
  }

  render() {
    this.el.querySelector(".change_name_input").value = this.entity.getName()
  }

  onChangeNameInputKeyup(e) {
    if (e.which === 13) {  // enter
      this.onSetNameBtnClick()
    } else if (e.which === 27) {
      this.close()
    }

  }

  onSetNameBtnClick() {
    let name = this.el.querySelector(".change_name_input").value
    if (this.entity.isBuildingType()) {
      SocketUtil.emit("EditBuilding", { id: this.entity.id, content: name })
    } else if (this.entity.isMob()) {
      SocketUtil.emit("EditMob", { id: this.entity.id, name: name })
    }
  }
}



module.exports = ChangeNameMenu 
},{"./../../../common/constants.json":656,"./../util/socket_util":654,"./base_menu":581}],584:[function(require,module,exports){
const SocketUtil = require("./../util/socket_util")
const BaseMenu = require("./base_menu")

class ChatMenu extends BaseMenu {

  onMenuConstructed() {
    this.chatInput = this.el.querySelector("#chat_input")
    this.chatInputContainer = this.el.querySelector("#chat_input_container")
    this.chatHistory = {}
    this.chatHistory["local"]  = this.el.querySelector(".local_chat_history")
    this.chatHistory["global"] = this.el.querySelector(".global_chat_history")
    this.chatHistory["team"] = this.el.querySelector(".team_chat_history")
    this.chatGroup = 'local'

    this.commandHistory = []
    this.MAX_COMMAND_HISTORY = 100
    this.MAX_HISTORY_CHAT_MESSAGES = 200

    this.scrollIndex = 0
    this.el.style.display = 'inline-block'

  }

  setGlobalTabRegion() {
    document.querySelector(".global_chat_tab .chat_tab_label").innerText = i18n.t("Global") + " " + this.game.main.getRegionName()
  }

  requestChatHistory() {
    let region = this.game.main.region
    this.game.sendToMatchmaker({ event: "RequestChatHistory", data: { region: region } })
  }

  onChatHistory(chatHistory) {
    this.chatHistory["global"].innerText = ""

    for (var i = 0; i < chatHistory.length; i++) {
      let chat = chatHistory[i]
      this.createChatEntry("global", chat)
    }
  }

  getTotalMessageCount() {
    return this.chatHistory["global"].children.length +
           this.chatHistory["local"].children.length
  }

  isControllingPlayerRequired() {
    return false
  }

  initListeners() {
    this.chatInput.addEventListener("keyup", this.onInputKeyup.bind(this), true)
    this.chatInput.addEventListener("focusout", this.onInputFocusOut.bind(this), true)
    document.querySelector("#chat_group_tab_container").addEventListener("click", this.onChatTabClick.bind(this), true)
    document.querySelector("#chat_group_tab_content").addEventListener("click", this.onChatContentClick.bind(this), true)
    document.querySelector("#chat_group_tab_content").addEventListener("contextmenu", this.onChatContentRightClick.bind(this), true)
    document.querySelector("#chat_player_tooltip").addEventListener("click", this.onChatTooltipClick.bind(this), true)
  }

  onChatTooltipClick(e) {
    if (e.target.closest(".mute_player_btn")) {
      document.querySelector("#chat_player_tooltip").style.display = 'none'
      if (!this.focusedUsername) return
      if (this.game.player.name === this.focusedUsername) return

      this.game.addMutedPlayer(this.focusedUsername)
      let list = Array.from(this.el.querySelectorAll(`.chat_message[data-username='${this.focusedUsername}']`))
      list.forEach((el) => {
        el.parentElement.removeChild(el)
      })
    }
  }

  onChatTabClick(e) {
    let tab = e.target.closest(".chat_tab")
    if (tab) {
      let selected = document.querySelector(".chat_tab.selected")
      if (selected) {
        selected.classList.remove("selected")
      }

      tab.classList.add("selected")
      this.chatGroup = tab.dataset.chat
      this.showChatHistory(this.chatGroup)
      this.clearUnreadCount(this.chatGroup)

      this.chatInput.focus()
    }
  }

  onChatContentRightClick(e) {
    let chatUser = e.target.closest(".chat_user")
    if (chatUser) {
      document.querySelector("#chat_player_tooltip").style.display = 'block'
      this.repositionTooltip(e.target, e.target.getBoundingClientRect())

      this.focusedUsername = chatUser.dataset.username
    }
  }

  onChatContentClick(e) {
    let chatUser = e.target.closest(".chat_user")
    if (chatUser) {
      let uid = chatUser.dataset.uid
      let username = chatUser.dataset.username
      this.game.userProfileMenu.open({ username: username, uid: uid })
    }
  }

  showChatHistory(chatGroup) {
    let selected = document.querySelector(".chat_history.selected")
    if (selected) {
      selected.classList.remove("selected")
    }
    document.querySelector("." + chatGroup + "_chat_history").classList.add("selected")
  }

  isModal() {
    return false
  }

  onInputKeyup(event) {
    if (event.keyCode === 27) { // escape
      this.game.inputController.handleEsc()
    } else if (event.key === "Enter") {
      this.submit()
    } else if (event.key === "ArrowUp") {
      this.game.chatMenu.scrollHistory(1)
    } else if (event.key === "ArrowDown") {
      this.game.chatMenu.scrollHistory(-1)
    }
  }

  onInputFocusOut(e) {
    if (this.game.isMobile()) {
      // virtual keyboard "Done" key is tapped
      if (e.target.id === 'chat_input') return

      this.submit()
      this.close()
    } else {
      // this.close()
    }
  }

  isGlobalChat() {
    return this.chatGroup === 'global'
  }

  isTeamChat() {
    return this.chatGroup === 'team'
  }

  onGlobalServerChat(data) {
    this.createChatEntry("global", data)

    let chatMessages = Array.from(this.el.querySelectorAll(".global_chat_history .chat_message"))
    if (chatMessages.length > this.MAX_HISTORY_CHAT_MESSAGES) {
      let oldMessage = chatMessages[0]
      if (oldMessage.parentElement) {
        oldMessage.parentElement.removeChild(oldMessage)
      }

    }

  }

  submit() {
    let text = this.chatInput.value

    SocketUtil.emit("ClientChat", { message: text, isGlobal: this.isGlobalChat(), isTeam: this.isTeamChat() })

    if (text.length > 0) {
      this.commandHistory.unshift(text)
    }

    if (this.commandHistory.length > this.MAX_COMMAND_HISTORY) {
      this.commandHistory.pop()
    }

    this.chatInput.value = ""
    this.scrollIndex = -1 // start at -1
  }

  clearUnreadCount(chatGroup) {
    let chatTab = document.querySelector("." + chatGroup +  "_chat_tab")
    chatTab.querySelector(".chat_unread_count").innerText = ""
  }

  increaseUnreadCount(chatGroup) {
    let chatTab = document.querySelector("." + chatGroup +  "_chat_tab")
    let unreadCount = parseInt(chatTab.querySelector(".chat_unread_count").innerText)
    if (isNaN(unreadCount)) unreadCount = 0

    unreadCount += 1

    chatTab.querySelector(".chat_unread_count").innerText = unreadCount
  }

  repositionTooltip(el, boundingRect) {
    let tooltip = document.querySelector("#chat_player_tooltip")

    const bottomMargin = 5
    let left = boundingRect.x + el.offsetWidth / 2 
    let top  = boundingRect.y + bottomMargin
    const margin = 5

    left = Math.max(margin, left) // cant be lower than margin
    left = Math.min(window.innerWidth - tooltip.offsetWidth - margin, left) // cant be more than than margin

    if (top < margin) {
      // show at bottom instead
      top = boundingRect.y + (bottomMargin * 2)
    }
    top = Math.max(margin, top) // cant be lower than margin
    top = Math.min(window.innerHeight - tooltip.offsetHeight - margin, top) // cant be more than than margin

    tooltip.style.left = left + "px"
    tooltip.style.top  = top  + "px"
  }


  createChatEntry(chatGroup, messageObj) {
    let chatMessage = document.createElement("div")
    chatMessage.className = "chat_message"
    chatMessage.dataset.username = messageObj.username

    // username
    let chatUsername = document.createElement("span")
    chatUsername.className = "chat_user"
    if (messageObj.username) {
      chatUsername.innerText = "[" + messageObj.username + "]"
      if (messageObj.uid) {
        chatUsername.dataset.uid = messageObj.uid
      }
      chatUsername.dataset.username = messageObj.username
    }

    // message
    let chatContent = document.createElement("span")
    chatContent.className = "chat_content"
    chatContent.innerText = messageObj.message
    if (messageObj.status === "error") {
      chatContent.dataset.error = true
    }  else if (messageObj.status === "success") {
      chatContent.dataset.success = true
    } else if(messageObj.status === "hexcolor") {
      chatContent.style.color ="#"+ messageObj.color
    } else if(messageObj.status === "color") {
      chatContent.style.color = messageObj.color
    }

    chatMessage.appendChild(chatUsername)
    chatMessage.appendChild(chatContent)

    this.chatHistory[chatGroup].appendChild(chatMessage)
    this.chatHistory[chatGroup].scrollTop = this.chatHistory[chatGroup].scrollHeight

    if (this.chatGroup !== chatGroup) {
      this.increaseUnreadCount(chatGroup)
    }
  }

  setOpenDisplay() {
    this.el.style.display = 'inline-block'
  }

  isMuted(name) {
    return this.game.mutedPlayers[name]
  }

  onServerChat(data) {
    if (!this.game.hasJoinedGame) return

    const playerId = data.playerId
    const username = data.username
    const message  = data.message

    const chatUser = this.game.sector.players[playerId]

    let messageObj = this.parseServerChat(message)
    messageObj.username = username
    messageObj.uid = data.uid

    let chatGroup = data.isTeam ? "team" : "local"

    if (!this.isMuted(username)) {
      this.createChatEntry(chatGroup, messageObj)
    }

    if (chatUser && !this.isMuted(chatUser.name)) {
      chatUser.createChatBubble(messageObj.message)
    }

    let chatMessages = Array.from(this.el.querySelectorAll(`.${chatGroup}_chat_history .chat_message`))
    if (chatMessages.length > this.MAX_HISTORY_CHAT_MESSAGES) {
      let oldMessage = chatMessages[0]
      if (oldMessage.parentElement) {
        oldMessage.parentElement.removeChild(oldMessage)
      }
    }
  }

  parseServerChat(message) {
    let errorRegex = new RegExp(/^%error%/)
    let successRegex = new RegExp(/^%success%/)

    if (message.match(errorRegex)) {
      return { status: "error", message: message.replace(errorRegex, "") }

    } else if (message.match(successRegex)) {
      return { status: "success", message: message.replace(successRegex, "") }

    } else if (message.startsWith("%#")) { //regular expressions are consusing lol
        let colorEndIndex = message.indexOf("%", 2);

        if (colorEndIndex === -1) {
          return { status: "normal", message: message };
        }
            
        let colorCode = message.slice(2, colorEndIndex);
        let restOfMessage = message.slice(colorEndIndex + 1);
        return { status: "hexcolor", message: restOfMessage, color: colorCode };
    } else if (message.startsWith("%")) {
      const colorEndIndex = message.indexOf("%", 2)
      if(colorEndIndex === -1) {
        return { status: "normal", message: message };
      }

      const allowedColors = ["blue", "red", "green", "yellow", "brown", "purple", "pink", "gray", "orange", "black", "white",]

      const color = message.slice(1, colorEndIndex)

      if(allowedColors.indexOf(color) === -1) {
        return { status: "normal", message: message }
      }

      let restOfMessage = message.slice(colorEndIndex + 1);

      return { status: "color", message: restOfMessage, color:color}
    }

    return { status: "normal", message: message };
  }


  close() {
    if (this.isVoteMode) return

    let index = this.game.openMenus.indexOf(this)
    if (index >= 0) {
      this.game.openMenus.splice(index, 1)
    }

    if (this.getTotalMessageCount() > 0) {
      this.el.classList.add("non_empty")
    }

    this.el.classList.add("read_mode")
    this.el.classList.remove("chat_mode")
  }

  setVoteMode(voteMode) {
    if (voteMode) {
      this.isVoteMode = voteMode
      this.el.classList.add("vote_mode")
    } else {
      this.isVoteMode = voteMode
      this.el.classList.remove("vote_mode")
    }
  }

  hide() {
    this.el.style.display = 'none'
  }

  open(options = {}) {
    if (this.isVoteMode) return

    super.open(options)

    this.game.inputController.controlKeys = 0

    if (this.chatHideTween) {
      this.chatHideTween.stop()
    }

    if (this.game.isTutorial() || !this.game.isLoggedIn() || this.game.isPvP()) {
      document.querySelector(".global_chat_tab").style.display = 'none'
    } else {
      document.querySelector(".global_chat_tab").style.display = 'none'
    }

    if (this.game.isPvP()) {
      document.querySelector(".team_chat_tab").style.display = 'inline-block'
    } else {
      document.querySelector(".team_chat_tab").style.display = 'none'
    }

    if (options.message) {
      this.chatInput.value = options.message
    } else {
      this.chatInput.value = ""
    }

    this.el.classList.remove("read_mode")
    this.el.classList.add("chat_mode")

    if (document.activeElement !== this.chatInput) {
      this.chatInput.focus()
    }
  }

  isOpen() {
    return this.el.classList.contains("chat_mode")
  }

  isOpenAndFocused() {
    return this.isOpen() && document.activeElement === this.chatInput
  }

  isClose() {
    return !this.isOpen()
  }

  scrollHistory(direction) {
    if (this.commandHistory.length === 0) return

    this.scrollIndex += direction

    if (this.scrollIndex < 0) {
      this.scrollIndex = 0
    } else if (this.scrollIndex >= this.commandHistory.length) {
      this.scrollIndex = this.commandHistory.length - 1
    }

    this.chatInput.value = this.commandHistory[this.scrollIndex]
  }

  getChatHideTween() {
    let opacity = { opacity: 1 }
    this.chatHideTween = new TWEEN.Tween(opacity)
        .to({ opacity: 0 }, 2000)
        .easing(TWEEN.Easing.Quadratic.Out)
        .onUpdate(() => {
          this.chatMenu.style.opacity = opacity.opacity
        })
        .delay(3000)

    return this.chatHideTween
  }

}

module.exports = ChatMenu

},{"./../util/socket_util":654,"./base_menu":581}],585:[function(require,module,exports){
const SocketUtil = require("./../util/socket_util")
const BaseMenu = require("./base_menu")
const Constants = require("./../../../common/constants.json")
const Protocol = require("./../../../common/util/protocol")
const ClientHelper = require("../util/client_helper")

class ColorPickerMenu extends BaseMenu {
  onMenuConstructed() {
    this.el.querySelector(".picker_color_value").innerText = "white_1"
    this.colors = {}

    if (this.el.querySelector(".picker_texture_value")) {
      this.el.querySelector(".picker_texture_value").innerText = "solid_texture"
    }
  }

  setColorIndex(colorIndex) {
    if (!this.colors[colorIndex]) return
    this.colorIndex = colorIndex

    let cell = this.el.querySelector(".color_cell[data-index='" + this.colorIndex + "']")
    if (cell) {
      let selectedCell = this.el.querySelector(".color_cell.selected")
      if (selectedCell) {
        selectedCell.classList.remove("selected")
      }

      cell.classList.add("selected")
    }

    if (this.game.player.building) {
      this.applyBuildingTint(this.game.player.building)
    }

    let label = this.colors[this.colorIndex].label
    this.el.querySelector(".picker_color_value").innerText = label
  }

  setTextureIndex(textureIndex) {
    this.textureIndex = textureIndex

    let cell = this.el.querySelector(".texture_cell[data-index='" + this.textureIndex + "']")
    if (cell) {
      let selectedCell = this.el.querySelector(".texture_cell.selected")
      if (selectedCell) {
        selectedCell.classList.remove("selected")
      }

      cell.classList.add("selected")
    }

    if (this.game.player.building) {
      this.applyBuildingTexture(this.game.player.building)
    }

    let label = this.game.floorTextures[this.textureIndex]
    this.el.querySelector(".picker_texture_value").innerText = label
  }

  applyBuildingTint(building) {
    let floorWallTypes = [Protocol.definition().BuildingType.Floor, Protocol.definition().BuildingType.Wall]
    let isFloorOrWall = floorWallTypes.indexOf(building.getType()) !== -1
    if (isFloorOrWall) {
      if (this.colorIndex) {
        building.setColorIndex(this.colorIndex)
        let value = this.game.colors[this.colorIndex].value
        building.baseSprite.tint = value
      }
    }
  }

  applyBuildingTexture(building) {
    let floorWallTypes = [Protocol.definition().BuildingType.Floor, Protocol.definition().BuildingType.Wall]
    let isFloorOrWall = floorWallTypes.indexOf(building.getType()) !== -1
    if (isFloorOrWall) {
      if (this.textureIndex) {
        building.setTextureIndex(this.textureIndex)
        let value = this.game.floorTextures[this.textureIndex]
        building.baseSprite.texture = PIXI.utils.TextureCache[value]
      }
    }
  }

  initListeners() {
    super.initListeners()

    this.el.querySelector(".color_picker_grid").addEventListener("click", this.onColorPickerGridClick.bind(this), true)
    if (this.el.querySelector(".texture_picker_grid")) {
      this.el.querySelector(".texture_picker_grid").addEventListener("click", this.onTexturePickerGridClick.bind(this), true)
    }
    
    this.el.querySelector(".color_picker_tab_container").addEventListener("click", this.onTabClick.bind(this))
  }

  open(options = {}) {
    super.open(options)

    this.colors = options.colors
    this.entityId = options.entityId

    this.render()
  }

  onTabClick(e) {
    let tab = e.target.closest(".picker_tab")
    if (!tab) return

    let customize = tab.dataset.customize
    let selectedTab = this.el.querySelector(".picker_tab.selected")
    let selectedTabContent = this.el.querySelector(".tab-pane.selected")
    if (selectedTab) {
      selectedTab.classList.remove("selected")
      if (selectedTabContent) {
        selectedTabContent.classList.remove("selected")
      }
    }

    tab.classList.add("selected")
    let tabContent = this.el.querySelector(".tab-pane[data-customize='" + customize + "']")
    if (tabContent) {
      tabContent.classList.add("selected")
    }
  }

  onColorPickerGridClick(e) {
    let cell = e.target.closest(".color_cell")
    if (cell) {
      let colorIndex = cell.dataset.index
      SocketUtil.emit("EditTexture", { colorIndex: colorIndex, entityId: this.entityId  })
    }
  }

  onTexturePickerGridClick(e) {
    let cell = e.target.closest(".texture_cell")
    if (cell) {
      let textureIndex = cell.dataset.index
      SocketUtil.emit("EditTexture", { textureIndex: textureIndex, entityId: this.entityId })
    }
  }

  createColorPickerGrid() {
    let el = ""

    for (let index in this.colors) {
      let color = this.colors[index]
      el += this.createColorCellEl(index, color)
    }

    return el
  }

  createColorCellEl(index, color) {
    let hex = ClientHelper.toHex(color.value)
    return `<div class='color_cell' data-index='${index}' style='background-color: ${hex}'></div>`
  }

  createTexturePickerGrid() {
    let el = ""

    for (let index in this.game.floorTextures) {
      let texture = this.game.floorTextures[index]
      el += this.createTextureCellEl(index, texture)
    }

    return el
  }

  createTextureCellEl(index, texture) {
    if (texture === 'cornered_texture.png') {
      texture = 'cornered_texture_display.png'
    }
    return `<div class='texture_cell' data-index='${index}'><img src='/assets/images/${texture}'></div>`
  }

  render() {
    this.el.querySelector(".color_picker_grid").innerHTML = this.createColorPickerGrid()

    if (this.el.querySelector(".texture_picker_grid")) {
      this.el.querySelector(".texture_picker_grid").innerHTML = this.createTexturePickerGrid()
    }
    
  }


}



module.exports = ColorPickerMenu 
},{"../util/client_helper":649,"./../../../common/constants.json":656,"./../../../common/util/protocol":686,"./../util/socket_util":654,"./base_menu":581}],586:[function(require,module,exports){
const SocketUtil = require("./../util/socket_util")
const BaseMenu = require("./base_menu")
const Constants = require("./../../../common/constants.json")
const Trigger = require("./command_blocks/trigger")
const ActionEntries = require("./command_blocks/action_entries/index")

class CommandBlockMenu extends BaseMenu {
  onMenuConstructed() {
    this.nodes = {}
    this.triggers = []
  }

  cleanup() {
    document.querySelector(".triggers_container").innerHTML = ""
    this.triggers = []
    this.nodes = {}
  }

  getActionEntryFor(actionKey) {
    return ActionEntries.forType(actionKey)
  }

  initListeners() {
    super.initListeners()
    this.el.querySelector(".command_block_tab_container").addEventListener("click", this.onTabClick.bind(this), true)
    this.el.querySelector(".add_trigger_btn").addEventListener("click", this.onNewTriggerBtnClick.bind(this), true)
    this.el.querySelector(".enable_trigger_toggle").addEventListener("click", this.onEnableTriggersClick.bind(this), true)
  }

  onEnableTriggersClick(e) {
    let toggle = e.target.closest(".enable_trigger_toggle")
    if (!toggle) return
    if (e.target.tagName !== 'INPUT') return // dont process label click event

    e.stopPropagation()
    e.preventDefault()

    let enabled = toggle.querySelector("input").checked

    let data = {
      operation: "enable",
      value: enabled ? "true" : "false"
    }

    SocketUtil.emit("EditCommandBlock", data)

    return false
  }


  onTabClick(e) {
    let tab = e.target.closest(".command_block_tab")
    if (!tab) return

    this.selectTab(tab.dataset.view)
  }

  open() {
    if (!this.game.player) return

    super.open()
    if (!this.game.player.canEditCommandBlock()) {
      if (!this.el.classList.contains("readonly")) {
        this.el.classList.add("readonly")
      }
    } else {
      this.el.classList.remove("readonly")
    }

    if (!this.game.player.isSectorOwner()) {
      document.querySelector(".command_block_tab_container").style.display = 'none'
      this.selectTab('triggers')
    } else {
      document.querySelector(".command_block_tab_container").style.display = 'block'
    }
  }

  onNewTriggerBtnClick(e) {
    this.game.commandBlockPicker.open({ mode: "triggers" })
  }

  hasTrigger(name) {
    return this.triggers.find((trigger) => {
      return trigger.event === name
    })
  }

  addTrigger(trigger) {
    this.triggers.push(trigger)
  }

  removeTrigger(trigger) {
    let index = this.triggers.indexOf(trigger)
    if (index !== -1) {
      this.triggers.splice(index, 1)
    }
  }

  selectTab(view) {
    let selected = this.el.querySelector(".command_block_tab.selected")
    if (selected) {
      selected.classList.remove('selected')
    }

    let activeTab = this.el.querySelector(".tab-pane.active")
    if (activeTab) {
      activeTab.classList.remove('active')
    }

    let tab = this.el.querySelector(`.command_block_tab[data-view='${view}']`)
    if (tab) {
      tab.classList.add("selected")
    }

    let tabContent = this.el.querySelector(`.tab-pane[data-view='${view}']`)
    if (tabContent) {
      tabContent.classList.add("active")
    }
  }

  registerNode(node) {
    this.nodes[node.id] = node
  }

  unregisterNode(node) {
    delete this.nodes[node.id] 
  }

  getNode(id) {
    return this.nodes[id]
  }

  renderFullJson(fullJson) {
    document.querySelector(".triggers_container").innerHTML = ""

    // removes invalid characters
    // https://stackoverflow.com/a/20856346
    const sanitatedJson = fullJson.replace(/[^\x00-\x7F§]/g, "")

    let data = JSON.parse(sanitatedJson)
    this.parseTriggers(data.triggers)
    this.setIsEnabled(data.isEnabled)
  }

  parseTriggers(triggers) {
    for (var i = 0; i < triggers.length; i++) {
      let trigger = triggers[i]
      triggers[i] = new Trigger(this, trigger)
    }
  }

  createTrigger(event) {
    let trigger = new Trigger(this, { event: event })
    trigger.submitSave()
  }

  appendTriggerChildEl(el) {
    document.querySelector(".triggers_container").appendChild(el)
  }

  update(data) {
    if (data.error) {
      this.game.displayError(data.error, { warning: true })
      return
    }

    if (data.operation === "enable") {
      this.setIsEnabled(data.value === 'true')

    } else if (data.operation === "edit") {
      let node = this.getNode(data.id)
      if (node) {
        node.edit(data.value)
      }
    } else if (data.operation === "delete") {
      let node = this.getNode(data.id)
      if (node) {
        node.remove()
      }
    } else if (data.operation === "add") {
      let node = this.getNode(data.tempId)
      if (node) {
        node.finishAdd(data)
      }
    }
  }

  setIsEnabled(isEnabled) {
    this.isEnabled = isEnabled

    document.querySelector(".enable_trigger_toggle input").checked = isEnabled
  }

  writeLog(data) {
    let log = document.createElement("div")
    log.classList.add("log_entry")

    let logType = document.createElement("div")
    logType.classList.add("log_type")
    logType.classList.add(data.type)
    logType.innerText = data.type


    let logMessage = document.createElement("div")
    logMessage.classList.add("log_message")
    logMessage.classList.add(data.type)
    logMessage.innerText = data.message

    log.appendChild(logType)
    log.appendChild(logMessage)

    this.el.querySelector(".commands_event_log").appendChild(log)

    this.removeOldLog()
  }

  writeLogBatched(logs) {
    let documentFragment = document.createDocumentFragment()

    for (var i = 0; i < logs.length; i++) {
      let data = logs[i]

      let log = document.createElement("div")
      log.classList.add("log_entry")

      let logType = document.createElement("div")
      logType.classList.add("log_type")
      logType.classList.add(data.type)
      logType.innerText = data.type


      let logMessage = document.createElement("div")
      logMessage.classList.add("log_message")
      logMessage.classList.add(data.type)
      logMessage.innerText = data.message

      log.appendChild(logType)
      log.appendChild(logMessage)

      documentFragment.appendChild(log)
    }

    this.el.querySelector(".commands_event_log").appendChild(documentFragment)

    this.removeOldLog()
  }

  removeOldLog() {
    let logs = Array.from(this.el.querySelectorAll(".log_entry"))
    if (logs.length > 5000) {
      let amountToRemove = logs.length - 5000
      for (var i = 0; i < amountToRemove; i++) {
        let log = logs[i]
        if (log.parentElement) {
          log.parentElement.removeChild(log)
        }
      }
    }
  }

}



module.exports = CommandBlockMenu 
},{"./../../../common/constants.json":656,"./../util/socket_util":654,"./base_menu":581,"./command_blocks/action_entries/index":594,"./command_blocks/trigger":601}],587:[function(require,module,exports){
const BaseMenu = require("./base_menu")
const Constants = require("./../../../common/constants.json")
const Trigger = require("./command_blocks/trigger")

class CommandBlockPicker extends BaseMenu {
  initListeners() {
    super.initListeners()

    this.el.querySelector(".create_block_item_btn").addEventListener("click", this.onSubmitClick.bind(this), true)
    this.el.querySelector(".left_content").addEventListener("click", this.onLeftContentClick.bind(this), true)
    this.el.querySelector(".left_content").addEventListener("dblclick", this.onLeftContentDblClick.bind(this), true)
  }

  onLeftContentDblClick(e) {
    this.onSubmitClick()
  }

  onLeftContentClick(e) {
    let selected = this.el.querySelector(".left_content_entry.selected")
    if (selected) {
      selected.classList.remove("selected")
    }

    let el = e.target.closest(".left_content_entry") 
    if (!el) return

    el.classList.add("selected")
    let value = el.innerText

    if (!this.el.classList.contains("active")) {
      this.el.classList.add("active")
    }

    if (this.mode === "triggers") {
      this.handleTriggerSelected(value)
    } else if (this.mode === "actions") {
      this.handleActionSelected(value)
    }
  }

  handleTriggerSelected(triggerName) {
    let data = Constants.Triggers[triggerName]
    if (!data) {
      let tokens = triggerName.split(":")
      let timerEvent = tokens[2]
      if (!timerEvent) return

      data = Constants.Triggers[timerEvent]
      if (!data) return
    }

    let container = this.el.querySelector(".trigger_details")
    Trigger.prototype.renderEventDetails(container, triggerName, data)
  }

  handleActionSelected(actionName) {
    let data = Constants.Actions[actionName]
    if (!data) return

    let description = this.el.querySelector(".action_description")
    description.innerHTML = data.description

    this.el.querySelector(".action_details .examples").innerHTML = ""

    data.examples.forEach((example) => {
      let el = "<div class='action_example'>" + example + "</div>"
      this.el.querySelector(".action_details .examples").innerHTML += el
    })

  }

  onSubmitClick(e) {
    let selected = this.el.querySelector(".left_content_entry.selected")
    if (!selected) return

    let value = selected.innerText

    if (this.mode === 'triggers') {
      if (this.game.commandBlockMenu.hasTrigger(value)) {
        this.game.displayError("Trigger already added", { warning: true })
        return
      } else {
        this.game.commandBlockMenu.createTrigger(value)
      }
    } else if (this.mode === 'actions') {
      if (this.parent) {
        if (value === 'commands' && this.parent.hasActionEntry(value)) {
          this.game.displayError("Action already added", { warning: true })
          return
        } else {
          this.parent.createActionEntry(value)
        }
      }
      
    }

    this.close()
  }

  close() {
    this.cleanup() 
    super.close()
  }

  open(options = {}) {
    options.dontCloseMenus = true
    
    super.open(options)

    this.mode = options.mode
    this.el.dataset.mode = this.mode

    if (options.parent) {
      this.parent = options.parent
    }

    this.el.querySelector(".left_content").innerHTML = ""

    if (options.mode === 'triggers') {
      this.displayTriggersPicker()
    } else if (options.mode === 'actions') {
      this.displayActionsPicker()
    }
  }

  getTriggerNames() {
    let names = Object.keys(Constants.Triggers)

    let skip = ["start", "tick", "end"]
    skip.forEach((name) => {
      const index = names.indexOf(name)
      if (index > -1) {
        names.splice(index, 1)
      }
    })

    return names
  }


  displayTriggersPicker() {
    this.el.querySelector(".menu_main_header").innerText = "Triggers"

    let triggers =  this.getTriggerNames()
    triggers.forEach((name) => {
      let el = this.createTriggerEntry(name)
      this.el.querySelector(".left_content").appendChild(el)
    })

    for (let id in this.game.commandBlockTimers) {
      let timer = this.game.commandBlockTimers[id]
      let events = ["start", "tick", "end"]
      events.forEach((event) => {
        let name = "Timer:" + timer.timer.name + ":" + event
        let existingTrigger = this.el.querySelector(`.trigger_name[data-name='${name}']`)
        if (!existingTrigger) {
          let el = this.createTriggerEntry(name)
          this.el.querySelector(".left_content").appendChild(el)
        }
      })
    }
  }

  displayActionsPicker() {
    this.el.querySelector(".menu_main_header").innerText = "Actions"

    let actions = ["commands", "ifthenelse", "timer"]
    actions.forEach((name) => {
      let el = this.createActionEntry(name)
      this.el.querySelector(".left_content").appendChild(el)
    })
  }

  createTriggerEntry(name) {
    let div = document.createElement("div")
    div.classList.add("left_content_entry")
    div.classList.add("trigger_name")
    div.dataset.name = name
    div.innerText = name

    return div
  }

  createActionEntry(name) {
    let div = document.createElement("div")
    div.classList.add("left_content_entry")
    div.classList.add("action_name")
    div.innerText = name

    return div
  }

  cleanup() {
    this.el.classList.remove("active")
    this.el.dataset.mode = ""
    this.parent = null
  }
}

module.exports = CommandBlockPicker
},{"./../../../common/constants.json":656,"./base_menu":581,"./command_blocks/trigger":601}],588:[function(require,module,exports){
const ActionContainer = () => {
}

ActionContainer.prototype = {
  initActionContainer(data) {
    this.actions = []
    this.parseActions(data.actions) 
  },

  addAction(action) {
    this.actions.push(action)
  },

  removeAction(action) {
    let index = this.actions.indexOf(action)
    if (index !== -1) {
      this.actions.splice(index, 1)
    }
  },

  parseActions(actions) {
    if (!actions) return

    for (var i = 0; i < actions.length; i++) {
      let action = actions[i]
      this.commandBlock.getActionEntryFor(action.actionKey).build(this, action)
    }
  },

  createActionEntry(actionKey) {
    let actionEntry = this.commandBlock.getActionEntryFor(actionKey).build(this, { actionKey: actionKey })
    actionEntry.submitSave()
  },

  hasActionEntry(name) {
    return this.actions.find((action) => {
      return action.actionKey === name
    })
  }
}
  


module.exports = ActionContainer
},{}],589:[function(require,module,exports){
const Helper = require("../../../../../common/helper")
const Command = require("../command")
const Node = require("../node")
const SocketUtil = require("../../../util/socket_util")

class ActionEntry extends Node {
  static build(parent, data, handleActionValues) {
    let klass = this
    return new klass(parent, data, handleActionValues)
  }

  constructor(parent, data, handleActionValues=true) {
    super(parent.game, data)

    this.parent = parent
    this.commandBlock = parent.commandBlock

    this.actionKey = data.actionKey || ""

    this.el = this.createEl()
    this.el.addEventListener("click", this.onContainerClick.bind(this), true)

    if(handleActionValues) this.handleActionValues(data) 

    this.parent.addAction(this)
  }

  handleActionValues(data) {
    throw new Error("must implement handleActionValues")
  }

  finishAdd(data) {
    this.actionKey = data.value
    this.replaceId(data.id)
    this.redraw()
  }

  createEl() {
    throw new Error("must implement createEl")
  }

  onContainerClick() {

  }

  redraw() {
    this.el.querySelector(".action_key").innerText = Helper.capitalize(this.actionKey)
  }

  appendChildEl(el) {
    this.el.querySelector(".action_value_list").appendChild(el)
  }

  submitSave() {
    let data = {
      operation: "add",
      tempId: this.id,
      parentId: this.parent.id,
      value: this.actionKey,
      type: "ActionEntry"
    }

    SocketUtil.emit("EditCommandBlock", data)
  }

  remove() {
    super.remove()
    this.parent.removeAction(this)
  }

}

module.exports = ActionEntry
},{"../../../../../common/helper":664,"../../../util/socket_util":654,"../command":598,"../node":600}],590:[function(require,module,exports){
const ActionEntry = require("./action_entry")
const Helper = require("../../../../../common/helper")
const Command = require("../command")

class CommandActionEntry extends ActionEntry {
  handleActionValues(data) {
    this.actionValues = []
    this.parseActionValues(data.actionValues)
  }

  parseActionValues(list) {
    if (!list) return

    for (var i = 0; i < list.length; i++) {
      let item = list[i]
      new Command(this, item)
    }
  }

  addActionValue(actionValue) {
    this.actionValues.push(actionValue)
  }

  removeActionValue(actionValue) {
    let index = this.actionValues.indexOf(actionValue)
    if (index !== -1) {
      this.actionValues.splice(index, 1)
    }
  }

  onContainerClick(e) {
    if (e.target.classList.contains("add_action_value_btn")) {
      if (!this.hasPendingActionValue()) {
        this.createActionValue()
      }
    } else if (e.target.classList.contains("delete_action_btn")) {
      let id = parseInt(e.target.closest(".action_entry").dataset.id)
      if (id !== this.id) return

      if (this.isTempId()) {
        this.remove()
      } else {
        this.submitDelete()
      }
    }
  }

  hasPendingActionValue() {
    return this.actionValues.find((actionValue) => {
      return actionValue.isTempId()
    })
  }

  createActionValue() {
    let container = this.el.querySelector(".action_value_list")
    let actionValue = new Command(this, {})
    actionValue.enterEditMode()
  }

  createEl() {
    let row = document.createElement("div")
    row.dataset.id = this.id
    row.classList.add("action_entry")
    row.classList.add("tab_1")

    let actionKey = document.createElement("div")
    actionKey.classList.add("action_key")
    actionKey.innerText = Helper.capitalize(this.actionKey)

    let addActionValueBtn = document.createElement("img")
    addActionValueBtn.classList.add("add_action_value_btn")
    addActionValueBtn.src = "/assets/images/add_icon.png"
    
    let actionValueEl = document.createElement("div")
    actionValueEl.classList.add("action_value")
    actionValueEl.classList.add("tab_1")

    let actionValueList = document.createElement("div")
    actionValueList.classList.add("action_value_list")
    actionValueEl.appendChild(actionValueList)

    let deleteBtn = document.createElement("img")
    deleteBtn.classList.add("delete_action_btn")
    deleteBtn.src = "/assets/images/trash_icon.png"

    row.appendChild(deleteBtn)
    row.appendChild(actionKey)
    row.appendChild(addActionValueBtn)
    row.appendChild(actionValueEl)

    this.parent.appendChildEl(row)

    return row
  }


}

module.exports = CommandActionEntry
},{"../../../../../common/helper":664,"../command":598,"./action_entry":589}],591:[function(require,module,exports){
const Node = require("../node")
const ActionContainer = require("../action_container")

class Else extends Node {

  constructor(parent, data) {
    super(parent.game, data)

    this.parent = parent
    this.el = this.createEl()
    this.el.querySelector(".add_action_btn").addEventListener("click", this.onAddActionBtnClick.bind(this), true)

    this.initActionContainer(data)
  }

  onAddActionBtnClick() {
    this.game.commandBlockPicker.open({ mode: "actions", parent: this })
  }

  createEl() {
    let row = document.createElement("div")
    row.classList.add('else')
    row.classList.add('tab_1')
    row.dataset.id = this.id
    row.innerText = "Else:"

    let addActionBtn = document.createElement("img")
    addActionBtn.classList.add("add_action_btn")
    addActionBtn.src = "/assets/images/add_icon.png"
    row.appendChild(addActionBtn)

    this.parent.appendChildEl(row)
    return row
  }

  getNodeValue() {
    return "else"
  }

  getNodeType() {
    return "else"
  }

}

Object.assign(Else.prototype, ActionContainer.prototype, {
})


module.exports = Else

},{"../action_container":588,"../node":600}],592:[function(require,module,exports){
const Node = require("../node")
const Comparison = require("../comparison")

class If extends Node {
  constructor(parent, data, isCreator) {
    super(parent.game, data)
    this.isCreator = isCreator

    this.parent = parent

    this.el = this.createEl()

    this.parseData(data)
  }

  parseData(data) {
    this.conditions = []

    if (!data.conditions) return

    data.conditions.forEach((condition) => {
      if (condition.comparison) {
        new Comparison(this, condition.comparison)
      }
    })
  }

  addCondition(condition) {
    this.conditions.push(condition)
  }

  removeCondition(condition) {
    let index = this.conditions.indexOf(condition)
    if (index !== -1) {
      this.conditions.splice(index, 1)
    }
  }

  finishAdd(data) {
    super.finishAdd(data)

    if(this.isCreator) {
      let comparison = new Comparison(this, {})
      comparison.submitSave()
    }
  }

  createEl() {
    let row = document.createElement("div")
    row.classList.add('if')
    row.classList.add('tab_1')
    row.dataset.id = this.id
    row.innerText = "If:"

    this.parent.appendChildEl(row)
    return row
  }

  getNodeType() {
    return "if"
  }

  getNodeValue() {
    return "if"
  }

  appendChildEl(el) {
    this.el.appendChild(el)
  }

 
}

module.exports = If

},{"../comparison":599,"../node":600}],593:[function(require,module,exports){
const Helper = require("../../../../../common/helper")
const ActionEntry = require("./action_entry")
const SocketUtil = require("../../../util/socket_util")
const If = require("./if")
const Else = require("./else")
const Then = require("./then")


class IfThenElse extends ActionEntry {
  handleActionValues(data) {
    this.isCreator = true

    data.ifthenelse = data.ifthenelse || { if: [], else: [], then: [] }

    this.ifthenelse = {
      if: new If(this, data.ifthenelse.if, true),
      then: new Then(this, data.ifthenelse.then),
      else: new Else(this, data.ifthenelse.else)
    }
  }
  addIf(id) {
    if(!this.ifthenelse) this.ifthenelse = {}
    this.ifthenelse.if = new If(this, {id: id})
  }

  addThen(id) {
    if(!this.ifthenelse) this.ifthenelse = {}
    this.ifthenelse.if = new Then(this, {id: id})
  }

  addElse(id) {
    if(!this.ifthenelse) this.ifthenelse = {}
    this.ifthenelse.if = new Else(this, {id: id})
  }

  finishAdd(data) {
    this.actionKey = data.value
    this.replaceId(data.id)
    this.redraw()

    if(!this.ifthenelse) return //this is a client who didn't edit command blocks
    this.ifthenelse.if.submitSave()
    this.ifthenelse.else.submitSave()
    this.ifthenelse.then.submitSave()
  }

  redraw() {
    this.el.querySelector(".action_key").innerText = Helper.capitalize(this.actionKey)
  }

  onContainerClick(e) {
    if (e.target.classList.contains("delete_action_btn")) {
      let id = parseInt(e.target.closest(".action_entry").dataset.id)
      if (id !== this.id) return

      if (this.isTempId()) {
        this.remove()
      } else {
        this.submitDelete()
      }
    }
  }

  createEl() {
    let row = document.createElement("div")
    row.dataset.id = this.id
    row.classList.add("action_entry")
    row.classList.add("ifthenelse")
    row.classList.add("tab_1")

    let actionKey = document.createElement("div")
    actionKey.classList.add("action_key")
    actionKey.innerText = "IfThenElse"

    row.appendChild(actionKey)

    let deleteBtn = document.createElement("img")
    deleteBtn.classList.add("delete_action_btn")
    deleteBtn.src = "/assets/images/trash_icon.png"

    row.appendChild(deleteBtn)

    this.parent.appendChildEl(row)

    return row
  }

  appendChildEl(el) {
    this.el.appendChild(el)
  }

}

module.exports = IfThenElse
},{"../../../../../common/helper":664,"../../../util/socket_util":654,"./action_entry":589,"./else":591,"./if":592,"./then":595}],594:[function(require,module,exports){
const ActionEntries = {}

ActionEntries.CommandActionEntry = require("./command_action_entry")
ActionEntries.IfThenElse = require("./ifthenelse")
ActionEntries.Timer = require("./timer")

ActionEntries.forType = (actionKey) => {
  if (actionKey === "commands") {
    return ActionEntries.CommandActionEntry
  } else if (actionKey === "ifthenelse") {
    return ActionEntries.IfThenElse
  } else if (actionKey === "timer") {
    return ActionEntries.Timer
  }
}


module.exports = ActionEntries




},{"./command_action_entry":590,"./ifthenelse":593,"./timer":596}],595:[function(require,module,exports){
const Node = require("../node")
const ActionContainer = require("../action_container")

class Then extends Node {
  constructor(parent, data) {
    super(parent.game, data)

    this.parent = parent
    this.el = this.createEl()

    this.el.querySelector(".add_action_btn").addEventListener("click", this.onAddActionBtnClick.bind(this), true)

    this.initActionContainer(data)
  }

  createEl() {
    let row = document.createElement("div")
    row.classList.add('then')
    row.classList.add('tab_1')
    row.dataset.id = this.id
    row.innerText = "Then:"

    let addActionBtn = document.createElement("img")
    addActionBtn.classList.add("add_action_btn")
    addActionBtn.src = "/assets/images/add_icon.png"
    row.appendChild(addActionBtn)

    this.parent.appendChildEl(row)
    return row
  }

  onAddActionBtnClick() {
    this.game.commandBlockPicker.open({ mode: "actions", parent: this })
  }

  getNodeValue() {
    return "then"
  }

  getNodeType() {
    return "then"
  }


}

Object.assign(Then.prototype, ActionContainer.prototype, {
})


module.exports = Then

},{"../action_container":588,"../node":600}],596:[function(require,module,exports){
const Helper = require("../../../../../common/helper")
const ActionEntry = require("./action_entry")
const SocketUtil = require("../../../util/socket_util")

class Timer extends ActionEntry {
  handleActionValues(data) {
    data.timer = data.timer || { name: "Timer", duration: 10, every: 1 }

    this.parseData(data) 

    this.redraw()
  }

  parseData(data) {
    this.timer = {
      name: data.timer.name,
      duration: data.timer.duration,
      every: data.timer.every 
    }
  }

  finishAdd(data) {
    this.replaceId(data.id)
  }

  edit(text) {
    let key     = text.split(":")[0]
    let value = text.split(":")[1]

    if (key === 'name') {
      this.timer.name = value
    } else if (key === 'duration') {
      this.timer.duration = parseInt(value)
    } else if (key === 'every') {
      this.timer.every = parseInt(value)
    }

    this.redraw()
  }

  redraw() {
    this.el.querySelector(".timer_name .row_content").innerText = this.timer.name
    this.el.querySelector(".timer_name input").value = this.timer.name
    this.el.querySelector(".timer_duration input").value = this.timer.duration
    this.el.querySelector(".timer_every input").value = this.timer.every

    this.exitEditMode(this.el.querySelector(".timer_name"))
  }

  onContainerClick(e) {
    if (e.target.classList.contains("edit_action_value_btn")) {
      let row = e.target.closest(".action_value_list_row")
      this.enterEditMode(row)
    } else if (e.target.classList.contains("delete_action_btn")) {
      let id = parseInt(e.target.closest(".action_entry").dataset.id)
      if (id !== this.id) return

      if (this.isTempId()) {
        this.remove()
      } else {
        this.submitDelete()
      }
    }
  }

  createEl() {
    let row = document.createElement("div")
    row.dataset.id = this.id
    row.classList.add("timer")
    row.classList.add("action_entry")
    row.classList.add("tab_1")

    let actionKey = document.createElement("div")
    actionKey.classList.add("action_key")
    actionKey.innerText = Helper.capitalize(this.actionKey)

    let timerNameContainer = this.createTimerNameContainer()
    let timerDurationContainer = this.createTimerDurationContainer()
    let timerEveryContainer = this.createTimerEveryContainer()

    let deleteBtn = document.createElement("img")
    deleteBtn.classList.add("delete_action_btn")
    deleteBtn.src = "/assets/images/trash_icon.png"

    row.appendChild(deleteBtn)
    row.appendChild(actionKey)
    row.appendChild(timerNameContainer)
    row.appendChild(timerDurationContainer)
    row.appendChild(timerEveryContainer)

    this.parent.appendChildEl(row)

    return row
  }

  createTimerNameContainer() {
    let timerNameContainer = document.createElement("div")
    timerNameContainer.classList.add("timer_name")
    timerNameContainer.classList.add("action_value_list_row")
    timerNameContainer.classList.add("tab_1")

    let nameLabel = document.createElement("div")
    nameLabel.classList.add("label")
    nameLabel.innerText = "Name:"

    let content = document.createElement("div")
    content.classList.add("row_content")

    let nameInput = this.createActionValueInput("")
    let editBtn = document.createElement("img")
    editBtn.classList.add("edit_action_value_btn")
    editBtn.src = "/assets/images/edit_icon.png"

    let deleteBtn = document.createElement("img") 
    deleteBtn.classList.add("delete_action_value_btn")
    deleteBtn.src = "/assets/images/trash_icon.png"


    timerNameContainer.appendChild(nameLabel)
    timerNameContainer.appendChild(content)
    timerNameContainer.appendChild(nameInput)
    timerNameContainer.appendChild(editBtn)
    timerNameContainer.appendChild(deleteBtn)

    return timerNameContainer
  }

  createTimerDurationContainer() {
    let container = document.createElement("div")
    container.classList.add("timer_duration")
    container.classList.add("tab_1")

    let label = document.createElement("div")
    label.classList.add("label")
    label.innerText = "Duration:"

    let timerInput = document.createElement("input") 
    timerInput.setAttribute("type", "number")
    timerInput.setAttribute("min", "0")
    timerInput.classList.add("black_input")
    timerInput.addEventListener("change", this.onDurationChanged.bind(this), true)

    container.appendChild(label)
    container.appendChild(timerInput)

    return container
  }

  createTimerEveryContainer() {
    let container = document.createElement("div")
    container.classList.add("timer_every")
    container.classList.add("tab_1")

    let label = document.createElement("div")
    label.classList.add("label")
    label.innerText = "Tick:"

    let timerInput = document.createElement("input") 
    timerInput.setAttribute("type", "number")
    timerInput.setAttribute("min", "1")
    timerInput.classList.add("black_input")
    timerInput.addEventListener("change", this.onEveryChanged.bind(this), true)

    container.appendChild(label)
    container.appendChild(timerInput)

    return container
  }

  createActionValueInput(value) {
    value = value || ""
    let width = value.length < 15 ? 15 : value.length
    let input = document.createElement("input")
    input.classList.add("black_input")
    input.addEventListener("keyup", this.onActionValueInputKeyup.bind(this), true)
    input.addEventListener("input", this.onActionValueInputChange.bind(this), true)
    input.addEventListener("blur", this.onActionValueInputBlur.bind(this), true)
    input.value = value
    input.style.width = width + "ch"

    return input
  }

  onActionValueInputKeyup(e) {
    if (e.which === 13) {
      // enter
      let key = "name"
      let inputValue = e.target.value
      this.submitActionValueChange([key, inputValue].join(":"))
    } else if (e.which === 27) {
      let row = e.target.closest(".action_value_list_row")
      this.exitEditMode(row)
    }
  }

  exitEditMode(row) {
    row.classList.remove("edit_mode")
  }

  enterEditMode(row) {
    row.classList.add("edit_mode")
    this.focusInput(row)
  }

  focusInput(row) {
    row.querySelector("input").focus()
  }

  onActionValueInputChange(e) {
    let value = e.target.value
    let input = e.target

    value = value || ""
    let width = value.length < 15 ? 15 : value.length

    input.style.width = width + "ch"
  }

  onActionValueInputBlur(e) {
    let key = "name"
    let inputValue = e.target.value
    this.submitActionValueChange([key, inputValue].join(":"))
  }

  onDurationChanged(e) {
    let key = "duration"
    let inputValue = e.target.value
    this.submitActionValueChange([key, inputValue].join(":"))
  }

  onEveryChanged(e) {
    let key = "every"
    let inputValue = e.target.value
    this.submitActionValueChange([key, inputValue].join(":"))
  }

  appendChildEl(el) {
    this.el.appendChild(el)
  }

  submitActionValueChange(value) {
    let data = {
      id: this.id,
      value: value,
      operation: "edit"
    }

    SocketUtil.emit("EditCommandBlock", data)
  }

}

module.exports = Timer
},{"../../../../../common/helper":664,"../../../util/socket_util":654,"./action_entry":589}],597:[function(require,module,exports){
const SocketUtil = require("../../util/socket_util")
const Node = require("./node")

class ActionValue extends Node {
  constructor(actionEntry, data) {
    super(actionEntry.game, data)

    this.actionEntry = actionEntry

    this.value = data.value

    this.el = this.createEl()
    this.el.addEventListener("click", this.onContainerClick.bind(this), true)

    this.actionEntry.addActionValue(this)
  }

  finishAdd(data) {
    this.value = data.value
    this.replaceId(data.id)

    this.redraw()
  }

  onContainerClick(e) {
    if (e.target.classList.contains("edit_action_value_btn")) {
      let row = e.target.closest(".action_value_list_row")
      this.enterEditMode()
    } else if (e.target.classList.contains("delete_action_value_btn")) {
      if (this.isTempId()) {
        this.remove()
      } else {
        this.submitDelete()
      }
    }
  }

  focusInput() {
    this.el.querySelector("input").focus()
  }

  createEl(options = {}) {
    let row = document.createElement("div")
    row.dataset.id = this.id
    row.classList.add("action_value_list_row")

    let content = document.createElement("div")
    content.classList.add("row_content")
    content.innerText = this.value || ""

    let input = this.createActionValueInput(this.value)

    let editBtn = document.createElement("img")
    editBtn.classList.add("edit_action_value_btn")
    editBtn.src = "/assets/images/edit_icon.png"

    let deleteBtn = document.createElement("img") 
    deleteBtn.classList.add("delete_action_value_btn")
    deleteBtn.src = "/assets/images/trash_icon.png"

    row.appendChild(content)
    row.appendChild(input)

    row.appendChild(editBtn)
    row.appendChild(deleteBtn)

    this.actionEntry.appendChildEl(row)

    return row
  }

  createActionValueInput(value) {
    value = value || ""
    let width = value.length < 15 ? 15 : value.length
    let input = document.createElement("input")
    input.classList.add("black_input")
    input.addEventListener("keyup", this.onActionValueInputKeyup.bind(this), true)
    input.addEventListener("input", this.onActionValueInputChange.bind(this), true)
    input.addEventListener("blur", this.onActionValueInputBlur.bind(this), true)
    input.value = value
    input.style.width = width + "ch"

    return input
  }

  onActionValueInputChange(e) {
    let value = e.target.value
    let input = e.target

    value = value || ""
    let width = value.length < 15 ? 15 : value.length

    input.style.width = width + "ch"
  }

  redraw() {
    this.el.querySelector(".row_content").innerText = this.value
    this.el.querySelector("input").value = this.value
    this.exitEditMode()
  }

  onActionValueInputBlur(e) {
    let inputValue = e.target.value
    this.submitActionValueChange(inputValue)
  }

  onActionValueInputKeyup(e) {
    if (e.which === 13) {
      // enter
      let inputValue = e.target.value
      this.submitActionValueChange(inputValue)
    } else if (e.which === 27) {
      //esc
      this.exitEditMode()
    }
  }

  showActionValueEditError() {

  }

  exitEditMode() {
    this.el.classList.remove("edit_mode")
  }

  enterEditMode() {
    this.el.classList.add("edit_mode")
    this.focusInput()
  }

  getAction() {
    return this.actionEntry.actionKey
  }

  submitActionValueChange(value) {
    let data = {
      value: value
    }

    if (this.isTempId()) {
      data.operation = "add"
      data.tempId = this.id
      data.parentId = this.actionEntry.id
    } else {
      data.operation = "edit"
      data.id = this.id
    }


    SocketUtil.emit("EditCommandBlock", data)
  }

  edit(value) {
    this.value = value
    this.redraw()
  }

  remove() {
    super.remove()
    this.actionEntry.removeActionValue(this)
  }

}

module.exports = ActionValue
},{"../../util/socket_util":654,"./node":600}],598:[function(require,module,exports){
const ActionValue = require("./action_value")

class Command extends ActionValue {
  constructor(game, data) {
    super(game, data)
  }

}

module.exports = ActionValue
},{"./action_value":597}],599:[function(require,module,exports){
const SocketUtil = require("../../util/socket_util")
const Node = require("./node")
const Constants = require("../../../../common/constants.json")

class Comparison extends Node {
  constructor(parent, data) {
    super(parent.game, data)

    this.parent = parent
    this.parent.addCondition(this)

    this.value1 = data.value1 || ""
    this.operator = data.operator || "=="
    this.value2 = data.value2 || ""

    this.el = this.createEl()
    this.el.addEventListener("click", this.onContainerClick.bind(this), true)
  }

  onContainerClick(e) {
    if (e.target.classList.contains("edit_action_value_btn")) {
      let row = e.target.closest(".action_value_list_row")
      this.enterEditMode(row)
    }
  }

  exitEditMode(row) {
    row.classList.remove("edit_mode")
  }

  enterEditMode(row) {
    row.classList.add("edit_mode")
    this.focusInput(row)
  }

  focusInput(row) {
    row.querySelector("input").focus()
  }

  createEl() {
    let div = document.createElement("div")
    div.dataset.id = this.id
    div.classList.add("comparison")
    div.classList.add("tab_1")

    let valueContainer = this.createValueContainer(this.value1)
    valueContainer.querySelector(".label").innerText = "Value1:"
    valueContainer.dataset.key = 'value1'
    valueContainer.classList.add("value1")

    let otherValueContainer = this.createValueContainer(this.value2)
    otherValueContainer.querySelector(".label").innerText = "Value2:"
    otherValueContainer.dataset.key = 'value2'
    otherValueContainer.classList.add("value2")

    let operatorContainer = document.createElement("div")
    operatorContainer.dataset.key = 'operator'
    operatorContainer.classList.add("operator")

    let operatorLabel = document.createElement("div")
    operatorLabel.classList.add("label")
    operatorLabel.innerText = "Operator:"

    let operatorSelect = this.createOperatorSelect()

    operatorContainer.appendChild(operatorLabel)
    operatorContainer.appendChild(operatorSelect)

    div.appendChild(valueContainer)
    div.appendChild(operatorContainer)
    div.appendChild(otherValueContainer)

    this.parent.appendChildEl(div)

    return div
  }

  onOperatorChange(e) {
    let key = "operator"
    let inputValue = e.target.value
    this.submitActionValueChange([key, inputValue].join(":"))
  }

  createOperatorSelect() {
    let select = document.createElement("select")
    select.addEventListener("change", this.onOperatorChange.bind(this), true)

    let operators = ["==", "!=", ">", "<", ">=", "<=", "=~"]
    operators.forEach((operator) => {
      let option = document.createElement("option")

      if (operator === "=~") {
        option.innerText = operator + " (contains word)"
      } else {
        option.innerText = operator
      }

      option.value = operator

      if (this.operator === operator) {
        option.selected = true
      }

      select.appendChild(option)
    })

    return select
  }

  createValueContainer(value) {
    let valueContainer = document.createElement("div")
    valueContainer.classList.add('action_value_list_row')

    let label = document.createElement("div")
    label.classList.add("label")

    let content = document.createElement("div")
    content.classList.add("row_content")
    content.innerText = value

    let input = this.createActionValueInput("value")
    input.value = value

    let editBtn = document.createElement("img")
    editBtn.classList.add("edit_action_value_btn")
    editBtn.src = "/assets/images/edit_icon.png"

    valueContainer.appendChild(label)
    valueContainer.appendChild(content)
    valueContainer.appendChild(input)
    valueContainer.appendChild(editBtn)

    return valueContainer
  }

  createActionValueInput(value) {
    value = value || ""
    let width = value.length < 15 ? 15 : value.length
    let input = document.createElement("input")
    input.classList.add("black_input")
    input.addEventListener("keyup", this.onActionValueInputKeyup.bind(this), true)
    input.addEventListener("input", this.onActionValueInputChange.bind(this), true)
    input.addEventListener("blur", this.onActionValueInputBlur.bind(this), true)
    input.value = value
    input.style.width = width + "ch"

    return input
  }

  onActionValueInputKeyup(e) {
    if (e.which === 13) {
      // enter
      let key = e.target.closest(".action_value_list_row").dataset.key
      let inputValue = e.target.value
      this.submitActionValueChange([key, inputValue].join(":"))
    } else if (e.which === 27) {
      let row = e.target.closest(".action_value_list_row")
      this.exitEditMode(row)
    }
  }

  onActionValueInputBlur(e) {
    let key = e.target.closest(".action_value_list_row").dataset.key
    let inputValue = e.target.value
    this.submitActionValueChange([key, inputValue].join(":"))
  }

  onActionValueInputChange(e) {
    let value = e.target.value
    let input = e.target

    value = value || ""
    let width = value.length < 15 ? 15 : value.length

    input.style.width = width + "ch"
  }

  edit(text) {
    let key   = text.split(":")[0]
    let value = text.split(":")[1]

    let actionValueListRow = this.el.querySelector(".action_value_list_row[data-key='" + key + "'")
    if (actionValueListRow) {
      this.redraw(actionValueListRow, value)
    }
  }

  redraw(actionValueListRow, value) {
    actionValueListRow.querySelector(".row_content").innerText = value
    this.exitEditMode(actionValueListRow)
  }

  submitActionValueChange(value) {
    let data = {
      id: this.id,
      value: value,
      operation: "edit"
    }

    SocketUtil.emit("EditCommandBlock", data)
  }

  remove() {
    this.parent.removeCondition(this)
    super.remove() 
  }

}

module.exports = Comparison

},{"../../../../common/constants.json":656,"../../util/socket_util":654,"./node":600}],600:[function(require,module,exports){
const SocketUtil = require("../../util/socket_util")

class Node {

  constructor(game, data) {
    this.game = game
    this.commandBlock = game.commandBlockMenu

    this.id = data.id || "temp-" + this.game.generateId()
    this.registerNode()
  }

  finishAdd(data) {
    this.replaceId(data.id)
  }

  appendChildEl(el) {
    this.el.appendChild(el)
  }

  repositionTooltip(el, boundingRect) {
    let tooltip = document.querySelector("#command_block_tooltip")

    const bottomMargin = 25
    let left = boundingRect.x + el.offsetWidth / 2 
    let top  = boundingRect.y - tooltip.offsetHeight  - bottomMargin
    const margin = 25

    left = Math.max(margin, left) // cant be lower than margin
    left = Math.min(window.innerWidth - tooltip.offsetWidth - margin, left) // cant be more than than margin

    if (top < margin) {
      // show at bottom instead
      top = boundingRect.y + (bottomMargin * 2)
    }
    top = Math.max(margin, top) // cant be lower than margin
    top = Math.min(window.innerHeight - tooltip.offsetHeight - margin, top) // cant be more than than margin

    tooltip.style.left = left + "px"
    tooltip.style.top  = top  + "px"
  }


  registerNode() {
    this.commandBlock.registerNode(this)
  }

  unregisterNode() {
    this.commandBlock.unregisterNode(this)
  }

  remove() {
    this.unregisterNode()
    this.el.parentElement.removeChild(this.el)
  }

  replaceId(id) {
    this.unregisterNode()
    this.id = id
    this.el.dataset.id = this.id
    this.registerNode()
  }

  submitDelete() {
    if (this.isTempId()) return

    SocketUtil.emit("EditCommandBlock", {
      operation: "delete", 
      id: this.id
    })
  }

  getNodeType() {

  }

  getNodeValue() {

  }

  getParentId() {
    return this.parent.id
  }

  submitSave() {
    let data = {
      operation: "add",
      tempId: this.id,
      parentId: this.getParentId(),
      value: this.getNodeValue(),
      type: this.getNodeType()
    }

    SocketUtil.emit("EditCommandBlock", data)
  }

  isTempId() {
    return isNaN(this.id)
  }

}

module.exports = Node
},{"../../util/socket_util":654}],601:[function(require,module,exports){
const SocketUtil = require("../../util/socket_util")
const ActionContainer = require("./action_container")
const Node = require("./node")
const Constants = require("../../../../common/constants.json")

class Trigger extends Node {
  constructor(commandBlock, trigger) {
    super(commandBlock.game, trigger)

    this.event = trigger.event || ""
    this.el = this.createEl()
    this.el.addEventListener("click", this.onContainerClick.bind(this), true)
    this.el.querySelector(".event_help_btn").addEventListener("mouseover", this.onHelpMouseOver.bind(this), true)
    this.el.querySelector(".event_help_btn").addEventListener("mouseout", this.onHelpMouseOut.bind(this), true)
    this.el.querySelector(".add_action_btn").addEventListener("click", this.onAddActionBtnClick.bind(this), true)

    this.initActionContainer(trigger)

    this.commandBlock.addTrigger(this)
  }  

  onAddActionBtnClick(e) {
    this.game.commandBlockPicker.open({ mode: "actions", parent: this })
  }

  onHelpMouseOver(e) {
    let data = Constants.Triggers[this.event]
    if (!data) {
      if (this.event.match(":")) {
        let tokens = this.event.split(":")
        let key = tokens[tokens.length - 1]
        data = Constants.Triggers[key]
      } else {
        return
      }
    }

    let container = document.querySelector("#command_block_tooltip")
    this.renderEventDetails(container, this.event, data)

    document.querySelector("#command_block_tooltip").style.display = 'block'
    this.repositionTooltip(e.target, e.target.getBoundingClientRect())
  }

  onHelpMouseOut(e) {
    document.querySelector("#command_block_tooltip").style.display = 'none'
  }

  renderEventDetails(container, eventName, data) {
    if (container.querySelector(".event_name")) {
      container.querySelector(".event_name").innerText = eventName
    }
    
    container.querySelector(".event_description").innerText = data.description
    container.querySelector(".variables").innerHTML = ""

    for (let key in data.variables) {
      let description = data.variables[key]
      let el = this.createVariableEl(key, description)
      container.querySelector(".variables").appendChild(el)
    }
  }

  createVariableEl(key, description) {
    let div = document.createElement("div")
    div.classList.add("variable")

    let variable = document.createElement("div")
    variable.classList.add("key")
    variable.innerText = "$" + key

    let value = document.createElement("div")
    value.classList.add("description")
    value.innerText = description

    div.appendChild(variable)
    div.appendChild(value)

    return div
  }

  onContainerClick(e) {
    if (e.target.classList.contains("delete_trigger_btn")) {
      if (this.isTempId()) {
        this.remove()
      } else {
        this.submitDelete()
      }
    }
  }

  getParentId() {
    return 0
  }

  getNodeValue() {
    return this.event
  }

  getNodeType() {
    return "Trigger"
  }

  finishAdd(data) {
    this.event = data.value
    this.replaceId(data.id)
  }

  createEl() {
    let triggerEntry = document.createElement("div")
    triggerEntry.dataset.id = this.id
    triggerEntry.classList.add("trigger_entry")

    let eventEntry = document.createElement("div")
    eventEntry.classList.add("event_entry")

    let eventEntryLabel = document.createElement("label")
    eventEntryLabel.innerText = "Event:"

    let eventValue = document.createElement("div")
    eventValue.classList.add("event_value")
    eventValue.innerText = this.event

    let eventHelpBtn = document.createElement("img")
    eventHelpBtn.classList.add("event_help_btn")
    eventHelpBtn.src = "/assets/images/help_icon.png"

    eventEntry.appendChild(eventEntryLabel)
    eventEntry.appendChild(eventValue)
    eventEntry.appendChild(eventHelpBtn)

    let triggerActions = document.createElement("div")
    triggerActions.classList.add("trigger_actions")

    let actionsLabel = document.createElement("label")
    actionsLabel.innerText = "Actions:"

    let addActionBtn = document.createElement("img")
    addActionBtn.classList.add("add_action_btn")
    addActionBtn.src = "/assets/images/add_icon.png"

    let deleteTriggerBtn = document.createElement("img")
    deleteTriggerBtn.classList.add("delete_trigger_btn")
    deleteTriggerBtn.src = "/assets/images/trash_icon.png"

    triggerActions.appendChild(actionsLabel)

    triggerActions.appendChild(addActionBtn)
    triggerEntry.appendChild(deleteTriggerBtn)

    triggerEntry.appendChild(eventEntry)    
    triggerEntry.appendChild(triggerActions)    

    this.commandBlock.appendTriggerChildEl(triggerEntry)

    return triggerEntry
  }

  appendChildEl(el) {
    this.el.appendChild(el)
  }

  remove() {
    super.remove()
    this.commandBlock.removeTrigger(this)
  }

}

Object.assign(Trigger.prototype, ActionContainer.prototype, {
})


module.exports = Trigger
},{"../../../../common/constants.json":656,"../../util/socket_util":654,"./action_container":588,"./node":600}],602:[function(require,module,exports){
const SocketUtil = require("./../util/socket_util")
const BaseMenu = require("./base_menu")
const Constants = require("./../../../common/constants.json")


class ConfirmMenu extends BaseMenu {
  onMenuConstructed() {
    document.querySelector(".confirm_cancel_btn").addEventListener("click", this.onCancelClick.bind(this), true)
    document.querySelector(".confirm_ok_btn").addEventListener("click", this.onOkClick.bind(this), true)
  }

  isControllingPlayerRequired() {
    return false
  }

  onCancelClick() {
    this.close()

    if (this.cancelCallback) {
      this.cancelCallback()
    }
  }

  onOkClick() {
    this.close()

    if (this.proceedCallback) {
      this.proceedCallback.call()
    }
  }

  open(options = {}) {
    super.open(options)
  
    document.querySelector(".confirm_message").innerText = options.message

    this.proceedCallback = options.proceedCallback
    this.cancelCallback  = options.cancelCallback
  }

}

module.exports = ConfirmMenu

},{"./../../../common/constants.json":656,"./../util/socket_util":654,"./base_menu":581}],603:[function(require,module,exports){
const SocketUtil = require("./../util/socket_util")
const BaseMenu = require("./base_menu")
const Item = require("./../entities/item")
const GeminiScrollbar = require('gemini-scrollbar')
// const SimpleBar = require("simplebar")
// const PerfectScrollbar = require("perfect-scrollbar")
const Constants = require("./../../../common/constants.json")


class CraftMenu extends BaseMenu {
  onMenuConstructed() {
    this.lastActiveRows = {}
  }

  onInventoryChanged() {
    if (!this.craftType) return

    this.showProductInfo(this.craftType)    
  }

  getStorage() {
    return document.querySelector("#player_inventory")
  }

  open(header, label, storageId, templateList, options = {}) {
    super.open()
    this.cleanup()

    this.initCraftMenu(header, label, storageId, templateList, options)
  }

  initCraftMenu(header, label, storageId, templateList, options = {}) {
    this.header = header
    this.el.querySelector("#crafting_container_header").innerText = i18n.t(header)
    this.el.querySelector(".craft_btn").innerText = i18n.t(label)
    this.el.querySelector(".craft_btn").dataset.disabled = true

    this.sourceStorageId = storageId

    if (options.disabled) {
      this.isDisabled = true
      this.el.querySelector("#crafting_status_message").innerText = i18n.t(options.disabled)
    } else {
      this.isDisabled = false
      this.el.querySelector("#crafting_status_message").innerText = ""
    }

    if (header === "Forge") {
      this.el.querySelector(".craft_count").value = "1"
      this.el.querySelector(".craft_count").disabled = true
    } else {
      this.el.querySelector(".craft_count").disabled = false
    }

    let tabContainer = this.el.querySelector("#crafting_template_container")
    tabContainer.dataset.constructionType = header
    this.lastActiveTabContainer = tabContainer

    for (let i = 0; i < templateList.length; i++) {
      let klass = templateList[i]
      let row = this.createTemplateRow(klass)
      tabContainer.innerHTML += row
    }

    // this.scrollBar.update()
    this.scrollBar = new GeminiScrollbar({
        element: tabContainer,
        autoshow: true,
        forceGemini: true
    }).create()

    this.renderLastSelectedTemplateRow()
  }

  cleanup() {
    this.unhighlightInventorySlot()

    this.el.querySelector("#crafting_template_container").innerHTML = ""
    this.craftType = null
  }

  getStorageId() {
    return Constants.inventoryStorageId
  }

  initListeners() {
    super.initListeners()

    this.initCraftBtnListeners()
    this.initCraftTemplateListeners()
  }

  initCraftBtnListeners() {
    this.el.querySelector(".craft_count").addEventListener("change", this.onCraftCountChange.bind(this), true)
    this.el.querySelector(".craft_count").addEventListener("input", this.onCraftCountInput.bind(this), true)
    this.el.querySelector(".craft_count").addEventListener("keydown", this.onCraftCountKeydown.bind(this), true)
    this.el.querySelector(".craft_count").addEventListener("keyup", this.onCraftCountKeyup.bind(this), true)
    this.el.querySelector(".craft_btn").addEventListener("mousedown", this.onCraftBtnHold.bind(this), true)
    this.el.querySelector(".craft_btn").addEventListener("mouseup", this.onCraftBtnRelease.bind(this), true)
    this.el.querySelector(".craft_btn").addEventListener("mouseout", this.onCraftBtnRelease.bind(this), true)
  }

  onCraftCountKeydown(e) {
    this.oldCraftCount = parseInt(e.target.value)
  }

  onCraftCountInput(e) {
    let maxLength = 2
    if (e.target.value.length > maxLength) {
      e.target.value = e.target.value.slice(0, maxLength)
    }
  }

  onCraftCountChange(e) {
    if (e.target.value.length === 0) {
      e.target.value = 1
    }
  }

  onCraftCountKeyup(e) {
    if (e.target.value.length === 0) return

    let number = parseInt(e.target.value)
    if (isNaN(number) || number < 1 || number > 99) {
      e.target.value = this.oldCraftCount
    } 

    if (e.key === "Enter") {
      this.onCraftBtnHold()
    }

    if (e.keyCode === 27) {
      this.game.inputController.handleEsc()
    }
  }

  initCraftTemplateListeners() {
    this.el.querySelector("#crafting_template_container").addEventListener("click", this.onCraftingTemplateClick.bind(this), true)
  }

  selectTemplateRow(constructionType, templateRow) {
    this.craftType = templateRow.dataset.type
    // this.highlightTemplateRow(templateRow)
    // this.showProductInfo(this.craftType)

    templateRow.tabIndex = -1
    templateRow.click()
    templateRow.focus()

    this.lastActiveRows[constructionType] = templateRow
  }

  renderLastSelectedTemplateRow(constructionType) {
    let lastActiveRowForTab = constructionType && this.getLastActiveRow(constructionType)
    if (lastActiveRowForTab) {
       let templateRow = lastActiveRowForTab
       this.selectTemplateRow(constructionType, templateRow)
    } else {
      // select first slot
      let categoryFilter = constructionType ? "[data-construction-type='" + constructionType + "']" : ""
      let templateRow = this.el.querySelector(".template_row" + categoryFilter)
      this.selectTemplateRow(constructionType, templateRow)
    }
  }



  onCraftSuccess(data) {
    let rect = this.el.querySelector(".craft_btn").getBoundingClientRect()
    data.y = rect.top - 20
    data.x = rect.left - 50

    this.game.animateCraftSuccess(data)
  }

  onCraftingTemplateClick(event) {
    this.lastActiveRows[this.header] = this.handleTemplateClick(event)
  }

  handleTemplateClick(event) {
    const templateRow = event.target.closest(".template_row")
    if (!templateRow) return

    const type = parseInt(templateRow.dataset.type)
    if (isNaN(type)) return

    this.craftType = type

    this.unhighlightTemplateRow()
    this.highlightTemplateRow(templateRow)
    this.showProductInfo(this.craftType)
    this.onTemplateRowSelected(templateRow)

    return templateRow
  }

  onTemplateRowSelected(templateRow) {

  }

  /*

  Keyboard shortcuts

  */

  onMenuInteract(cmd) {
    switch(cmd) {
      case "ShiftTab":
        this.onShiftTab()
        break
      case "Tab":
        this.onTab()
        break
      case "GoUp":
        this.onGoUp()
        break
      case "GoDown":
        this.onGoDown()
        break
      case "EnterDown":
        this.onEnterDown()
        break
      case "EnterUp":
        this.onEnterUp()
        break
    } 
  }

  onEnterDown() {
    this.onCraftBtnHold()
  }

  onEnterUp() {
    this.onCraftBtnRelease()
  }

  onShiftTab() {
    this.onTabDirection(-1)
  }

  onTab() {
    this.onTabDirection(1)
  }

  onTabDirection(direction) {
    let tabs = Array.from(this.el.querySelectorAll(".construction_tab"))
    if (tabs.length <= 1) return

    let tabIndex = Array.prototype.indexOf.call(tabs, this.lastActiveTab)
    
    if (direction > 0) {
      // next
      let isLastTab = tabIndex === tabs.length - 1
      if (isLastTab) {
        this.selectConstructionTab(tabs[0])
      } else {
        this.selectConstructionTab(tabs[tabIndex + 1])
      }
    } else {
      // prev
      let isFirstTab = tabIndex === 0
      if (isFirstTab) {
        this.selectConstructionTab(tabs[tabs.length - 1])
      } else {
        this.selectConstructionTab(tabs[tabIndex - 1])
      }
    }
  }

  onGoUp() {
    this.onGoDirection(-1)
  }

  onGoDown() {
    this.onGoDirection(1)
  }

  getLastActiveTabContainer() {
    return this.lastActiveTabContainer
  }

  getLastActiveRow(constructionType) {
    let lastActiveRowForTab = this.lastActiveRows[constructionType]
    if (!lastActiveRowForTab) return null

    let type = lastActiveRowForTab.dataset.type

    // we create new instance of elemes for craft menu. so we need select newly built one
    return this.el.querySelector(".template_row[data-type='" + type + "']")
  }

  onGoDirection(direction) {
    let activeTab = document.querySelector(".construction_tab.active")
    let constructionType = activeTab.dataset.tab
    let rows = Array.from(this.el.querySelectorAll(".template_row[data-construction-type='" + constructionType + "']"))
    let lastActiveRowForTab = this.getLastActiveRow(constructionType)
    let rowIndex = Array.prototype.indexOf.call(rows, lastActiveRowForTab)
    this.unhighlightTemplateRow(lastActiveRowForTab)

    if (direction > 0) {
      // going down
      let isLastRow = rowIndex === rows.length - 1
      if (isLastRow) {
        this.selectTemplateRow(constructionType, rows[0])
      } else {
        this.selectTemplateRow(constructionType, rows[rowIndex + 1])
      }
    } else {
      let isFirstRow = rowIndex === 0
      if (isFirstRow) {
        this.selectTemplateRow(constructionType, rows[rows.length - 1])
      } else {
        this.selectTemplateRow(constructionType, rows[rowIndex - 1])
      }
    }
  }


}



module.exports = CraftMenu
},{"./../../../common/constants.json":656,"./../entities/item":443,"./../util/socket_util":654,"./base_menu":581,"gemini-scrollbar":46}],604:[function(require,module,exports){
const SocketUtil = require("./../util/socket_util")
const BaseMenu = require("./base_menu")

class DebugMenu extends BaseMenu {

  open(data) {
    super.open()

    let json = JSON.parse(data.data)
    if (data.type === "room") {
      this.drawRoomGraph(json)
    }
  }

  isModal() {
    return false
  }


  drawRoomGraph(json) {
    let nodes = json.nodes
    let edges = json.edges

    var cy = window.cy = cytoscape({
      container: document.getElementById('debug_network_graph'),

      boxSelectionEnabled: false,
      autounselectify: true,

      style: [
        {
          selector: 'node',
          css: {
            'content': 'data(id)',
            'text-valign': 'center',
            'text-halign': 'center'
          }
        },
        {
          selector: '$node > node',
          css: {
            'padding-top': '5px',
            'padding-left': '5px',
            'padding-bottom': '5px',
            'padding-right': '5px',
            'text-valign': 'top',
            'text-halign': 'center',
            'background-color': '#bbb'
          }
        },
        {
          selector: 'edge',
          css: {
            'target-arrow-shape': 'triangle'
          }
        },
        {
          selector: ':selected',
          css: {
            'background-color': 'black',
            'line-color': 'black',
            'target-arrow-color': 'black',
            'source-arrow-color': 'black'
          }
        }
      ],

      elements: {
        nodes: nodes,
        edges: edges
      },

      layout: {
        name: 'breadthfirst'
      }
    })

  }



  cleanup() {

  }

}



module.exports = DebugMenu 
},{"./../util/socket_util":654,"./base_menu":581}],605:[function(require,module,exports){
const SocketUtil = require("./../util/socket_util")
const BaseMenu = require("./base_menu")
const Constants = require("./../../../common/constants.json")

class EndGameMenu extends BaseMenu {
  onMenuConstructed() {
  }

  initListeners() {
    super.initListeners()

    this.el.querySelector(".play_again_btn").addEventListener("keyup", this.onPlayAgainBtnClick.bind(this))
    this.el.querySelector(".spectate_btn").addEventListener("click", this.onSpectateBtnClick.bind(this))
  }

  onPlayAgainBtnClick(e) {

  }

  onSpectateBtnClick(e) {

  }

  open(options = {}) {
    super.open(options)
  }

}



module.exports = EndGameMenu 
},{"./../../../common/constants.json":656,"./../util/socket_util":654,"./base_menu":581}],606:[function(require,module,exports){
const SocketUtil = require("./../util/socket_util")
const BaseMenu = require("./base_menu")
const Helper = require("../../../common/helper")
const Protocol = require("../../../common/util/protocol")

class EntityMenu extends BaseMenu {

  onMenuConstructed() {
    this.createSlaveTasks()
    this.createAttackTargets()
  }

  initListeners() {
    super.initListeners()
    this.initActionListeners()
    this.initTabListeners()
    this.initTasksListeners()
    this.initAttackTargetListeners()
    this.initPermissionListeners()
    this.initSpawnPointListeners()

    this.selectedEntity = null
  }

  isModal() {
    return false
  }

  cleanup() {
    this.selectedEntity = null
    this.close()
  }

  createSlaveTasks() {
    // let tasks = ["farm", "butcher_corpse", "refill_turret", "cook", "repair"]

    let el = ""

    let taskNames = Object.keys(Protocol.definition().TaskType)
    for (let i = 0; i < taskNames.length; i++) {
      let taskName = taskNames[i]
      let taskId = Protocol.definition().TaskType[taskName]
      el += this.createTaskEl(taskName, taskId)
    }

    this.el.querySelector(".slave_task_container").innerHTML = el
  }

  createAttackTargets() {
    let targetTypes = ["Mob", "Player"]

    let el = ""

    for (let i = 0; i < targetTypes.length; i++) {
      let targetTypeName = targetTypes[i]
      let typeId = Protocol.definition().AttackTargetType[targetTypeName]
      el += this.createAttackTargetEl(targetTypeName, typeId)
    }

    this.el.querySelector(".attack_type_container").innerHTML = el
  }

  createPermissions() {
    let el = ""

    let slaveRoleId = 3

    el += this.createPermissionEl({ id: slaveRoleId, name: "Slave" })

    for (let id in this.game.roles) {
      let role = this.game.roles[id]
      el += this.createPermissionEl(role)
    }

    this.el.querySelector(".entity_permission_roles").innerHTML = el

    this.slaveRoleEl = this.el.querySelector(".entity_permission_roles .permission_role[data-role-id='" + slaveRoleId + "']")
  }

  populateSpawnPointSelectors() {
    let el = ""

    el += this.createSpawnPointEl("everyone", "Everyone")

    for (let id in this.game.roles) {
      let role = this.game.roles[id]
      let key = "role-" + role.id
      let value = "Role: " + role.name
      el += this.createSpawnPointEl(key, value)
    }

    for (let id in this.game.teams) {
      let team = this.game.teams[id]
      let key = "team-" + team.id
      let value = "Team: " + team.name
      el += this.createSpawnPointEl(key, value)
    }

    this.el.querySelector(".spawn_select").innerHTML = el
  }

  createTaskEl(taskName, taskId) {
    let task = Helper.camelToSnakeCase(taskName)
    let taskFriendlyName = i18n.t(taskName.replace(/([A-Z])/g, ' $1').replace(/^\s+/g,''))
    return "<div class='slave_task' data-task-id='" + taskId + "'>" + 
      "<input type='checkbox'  id='" + task + "_task' >" +
      "<label                 for='" + task + "_task' >" +
        taskFriendlyName + 
      "</label>" +
    "</div>"
  }

  createAttackTargetEl(targetName, typeId) {
    let target = Helper.camelToSnakeCase(targetName)
    let targetFriendlyName = targetName + "Target"
    return "<div class='attack_target' data-target-id='" + typeId + "'>" + 
      "<input type='checkbox'  id='" + target + "_target' >" +
      "<label                 for='" + target + "_target' >" +
        i18n.t(targetFriendlyName) + 
      "</label>" +
    "</div>"
  }

  createPermissionEl(role) {
    return "<div class='permission_role' data-role-id='" + role.id + "'>" + 
      "<input type='checkbox'  id='" + role.name + "_role' >" +
      "<label                 for='" + role.name + "_role' >" +
        i18n.t(role.name) +
      "</label>" +
    "</div>"
  }

  createSpawnPointEl(key, value) {
    return "<option class='spawn_point_filter' value='" + key + "'>" + 
      value + 
    "</option>"
  }

  initTasksListeners() {
    this.el.querySelector(".slave_task_container").addEventListener("click", (e) => {
      let slaveTask = e.target.closest(".slave_task")
      if (!slaveTask) return
      if (e.target.tagName !== 'INPUT') return // dont process label click event

      e.stopPropagation()
      e.preventDefault()

      let taskId = slaveTask.dataset.taskId

      SocketUtil.emit("EditTask", { 
        entityId: this.entity.getId(),
        taskType: taskId,
        isEnabled: slaveTask.querySelector("input").checked
      })

    }, true)
      
  }

  initAttackTargetListeners() {
    this.el.querySelector(".attack_type_container").addEventListener("click", (e) => {
      let attackTarget = e.target.closest(".attack_target")
      if (!attackTarget) return
      if (e.target.tagName !== 'INPUT') return // dont process label click event

      e.stopPropagation()
      e.preventDefault()

      let targetId = attackTarget.dataset.targetId

      SocketUtil.emit("EditBuilding", { 
        id: this.entity.getId(),
        targetType: targetId,
        isTargetEnabled: attackTarget.querySelector("input").checked
      })

    }, true)
      
  }

  onCustomAccessSelectChanged(e) {
    e.preventDefault()
    let access = e.target.value

    SocketUtil.emit("EditBuilding", {
      id: this.entity.id,
      isCustomAccess: access === 'custom'
    })
  }

  onSpawnSelectChanged(e) {
    e.preventDefault()
    let value = e.target.value

    SocketUtil.emit("EditBuilding", {
      id: this.entity.id,
      content: value
    })
  }

  initSpawnPointListeners() {
    this.el.querySelector(".spawn_select").addEventListener("change", this.onSpawnSelectChanged.bind(this))
  }

  initPermissionListeners() {
    this.el.querySelector(".custom_access_select").addEventListener("change", this.onCustomAccessSelectChanged.bind(this))

    this.el.querySelector(".entity_permission_roles").addEventListener("click", (e) => {
      let role = e.target.closest(".permission_role")
      if (!role) return
      if (e.target.tagName !== 'INPUT') return // dont process label click event

      e.stopPropagation()
      e.preventDefault()

      if (!this.game.player.isAdmin()) {
        this.game.displayError("Permission Denied", { warning: true })
        return
      }

      let roleId = role.dataset.roleId

      SocketUtil.emit("EditBuilding", { 
        id: this.entity.getId(),
        roleType: roleId,
        isRoleEnabled: role.querySelector("input").checked
      })

    }, true)
      
  }

  initTabListeners() {
    document.querySelector(".entity_tabs").addEventListener("click", (event) => {
      let entityTab = event.target.closest(".entity_tab")
      if (!entityTab) return

      this.resetTabs()

      this.selectedTab = entityTab

      let tab = entityTab.dataset.tab
      this.showTab(tab)
    })
  }

  resetTabs() {
    let content = document.querySelector(".entity_tab_content.selected")
    if (content) {
      content.classList.remove("selected")
    }

    let tab = document.querySelector(".entity_tab.selected")
    if (tab) {
      tab.classList.remove("selected")
    }
  }

  hideTab(tab) {

  }

  showTab(tabName) {
    let tabContent = document.querySelector(`.entity_tab_content.${tabName}`)
    tabContent.classList.add('selected')

    let tab = document.querySelector(`.entity_tab[data-tab='${tabName}']`)
    tab.classList.add("selected")
  }

  interpolateDescription(description, entity) {
    let result = description

    result = result.replace(/`.*?`/g, (x) => { 
      try {
        x = x.substring(1, x.length-1) //remove the ` characters
        let evaluated = eval(x) 
        return evaluated
      } catch(e) {
        return ''
      }
    })

    return result
  }

  initActionListeners() {
    document.querySelector(".entity_action").addEventListener("mouseover", (event) => {
      let button = event.target.closest(".ui_btn")
      if (!button) return

      if (button.querySelector(".button_tooltip")) {
        button.querySelector(".button_tooltip").style.display = 'block'
        let description = button.dataset.description
        if (description) {
          let newDescription = this.interpolateDescription(description, this.selectedEntity)
          button.querySelector(".button_tooltip").innerText = newDescription
        }
      } 
    })

    document.querySelector(".entity_action").addEventListener("mouseout", (event) => {
      let button = event.target.closest(".ui_btn")
      if (!button) return

      if (button.querySelector(".button_tooltip")) {
        button.querySelector(".button_tooltip").style.display = 'none'
      } 
    })

    document.querySelector(".entity_action").addEventListener("click", (event) => {
      let button = event.target.closest(".ui_btn")
      if (!button) return

      if (button.querySelector(".button_tooltip")) {
        button.querySelector(".button_tooltip").style.display = 'none'
      } 

      SocketUtil.emit("ButtonClick", { 
        name: button.dataset.name,
        entityId: this.selectedEntity && this.selectedEntity.id
      })

      switch(button.dataset.action) {
        case "take_along":
          this.onTakeAlongClicked(this.selectedEntity)
          break
        case "release":
          this.onReleaseClicked(this.selectedEntity)
          break
        case "make_livestock":
          this.onMakeLivestockClicked(this.selectedEntity)
          break
        case "make_pet":
          this.onMakePetClicked(this.selectedEntity)
          break
        case "set_hangar":
          this.startRegionSelect()
          break
        case "edit_ship":
          this.editShip(this.selectedEntity)
          break
        case "edit_permissions":
          this.onEditPermissions(this.selectedEntity)
          break
        case "send_money":
          this.onSendMoney(this.selectedEntity)
          break
        case "vending_withdraw": 
          this.onVendingWithdraw(this.selectedEntity)
          break
        case "kick": 
          this.onPlayerKick(this.selectedEntity)
          break
        case "ban": 
          this.onPlayerBan(this.selectedEntity)
          break
        case "add_friend": 
          this.onPlayerAddFriend(this.selectedEntity)
          break
        default: 

      }
    })
  }

  isEntityMenu() {
    return true
  }

  update(entity) {
    if (this.entity === entity) {
      this.showEntitySummary(entity)
    }
  }

  showEntitySummary(entity) {
    // reset action/stats
    if (!entity) return
    if (!this.game.player) return
      
    this.el.querySelector(".entity_stats").innerHTML  = ""
    
    if (entity.isPlayer()) {
      this.el.querySelector(".entity_info_tab .entity_name_label").innerText = entity.getName()
      this.el.querySelector(".entity_task_tab .entity_name_label").innerText = entity.getName()
      this.el.querySelector(".entity_targets_tab .entity_name_label").innerText = entity.getName()
    } else {
      this.el.querySelector(".entity_info_tab .entity_name_label").innerText = entity.getEntityMenuName()
      this.el.querySelector(".entity_task_tab .entity_name_label").innerText = entity.getEntityMenuName()
      this.el.querySelector(".entity_targets_tab .entity_name_label").innerText = entity.getEntityMenuName()
    }
    
    this.el.querySelector(".entity_action").innerHTML = "" // reset

    
    if (this.game.shouldShowDebugDetails()) {
      this.el.querySelector(".debug_container").style.display = 'block'

      this.el.querySelector(".entity_id").innerText    = "id: " + entity.id
      // this.el.querySelector(".entity_pos_x").innerText = "xy:  (" + [Math.round(entity.getX()), Math.round(entity.getY())].join(",") + ")"

      if (typeof entity.getRow === "function") {
        this.el.querySelector(".entity_row").innerText = "rowcol:  (" + [Math.round(entity.getRow()), Math.round(entity.getCol())].join(",") + ")"
      }

      // reset values
      this.el.querySelector(".entity_light_ambient_color").innerText = ""
      this.el.querySelector(".entity_light_brightness").innerText = ""
      this.el.querySelector(".entity_light_color").innerText = ""
    } else {
      this.el.querySelector(".debug_container").style.display = 'none'
    }

    if (entity.hasCategory("editable_permissions") &&
        entity.belongToOwner(this.game.player) &&
        this.game.player.isAdmin()) {
      this.el.querySelector(".entity_permissions_container").style.display = 'block'
    } else {
      this.el.querySelector(".entity_permissions_container").style.display = 'none'
    }

    if (entity.hasCategory("spawnpoint") &&
        entity.belongToOwner(this.game.player) &&
        this.game.player.isAdmin()) {
      this.el.querySelector(".spawn_select_container").style.display = 'block'
    } else {
      this.el.querySelector(".spawn_select_container").style.display = 'none'
    }

    let slaveRoleId = 3
    if (entity.hasCategory("door")) {
      if (this.slaveRoleEl.style.display !== 'none') {
        this.slaveRoleEl.style.display = 'none'
      }
    } else {
      if (this.slaveRoleEl.style.display !== 'block') {
        this.slaveRoleEl.style.display = 'block'
      }
    }

    entity.renderEntityMenu(this.el)

    if (entity.hasCategory("dummy_player")) {
      this.el.querySelector(".entity_info_tab").classList.add("dummy_player")      
    } else {
      this.el.querySelector(".entity_info_tab").classList.remove("dummy_player")      
    }
  }

  editShip(hangarController) {
    const region = hangarController.getRegion()
    if (this.getPlayer().hangar) {
      this.getPlayer().setHangar(null)
    } else {
      this.getPlayer().setHangar(region)
      let shipId = region.content
      SocketUtil.emit("EditShip", { id: shipId })
    }

    this.game.showEntityMenu(this.selectedEntity)
  }


  onEditPermissions(entity) {
    if (!entity) return

    this.game.permissionsMenu.open({ entity: entity })
  }

  onSendMoney(entity) {
    if (!entity) return

    this.game.sendMoneyMenu.open({ receiver: entity })
  }

  onPlayerKick(entity) {
    if (!entity) return

    this.game.teamMenu.kickMember(entity.id)
  }

  onPlayerBan(entity) {
    if (!entity) return

    this.game.teamMenu.banMember(entity.id)
  }

  onPlayerAddFriend(entity) {
    if (!entity) return
    if (!entity.isPlayer()) return   

    if (this.game.main.isMyFriend(entity.uid)) return

    this.game.main.addFriend(entity.uid)
    this.game.entityMenu.redraw()
  }

  onVendingWithdraw(entity) {
    if (!entity) return

    SocketUtil.emit("EditBuilding", { id: entity.id, action: 'withdraw' })
  }

  onTakeAlongClicked(entity) {
    if (!entity) return
    SocketUtil.emit("TakeAlong", { id: entity.id })
  }

  onReleaseClicked(entity) {
    if (!entity) return 
    SocketUtil.emit("Release", { id: entity.id })
  }

  onMakeLivestockClicked(entity) {
    if (!entity) return 
    SocketUtil.emit("SetLivestock", { id: entity.id, isLivestock: true })
  }

  onMakePetClicked(entity) {
    if (!entity) return 
    SocketUtil.emit("SetLivestock", { id: entity.id, isLivestock: false })
  }

  open(entity, options = {}) {
    if (!this.game.player) return
      
    if (this.game.hideMainMenus) return
    if (this.selectedEntity && 
        this.selectedEntity !== entity &&
        !options.replaceSelected) {
      return
    }

    clearTimeout(this.closeTimeout)
    clearTimeout(this.openTimeout)

    this.openTimeout = setTimeout(() => {
      super.open(options)

      this.entity = entity
      if (options.selectedEntity) {
        this.selectedEntity = options.selectedEntity
      }

      this.showEntitySummary(entity)
      this.renderTabs()
    }, 30)
  }

  redraw() {
    if (this.selectedEntity) {
      this.showEntitySummary(this.selectedEntity)
      this.renderTabs()
    }
  }

  shouldShowTabs() {
    if (!this.entity.belongToOwner(this.game.player)) return false
    if (this.game.player.isGuest()) return false

    let entityHasTab = this.entity.hasCategory("worker") || this.entity.hasCategory("editable_targets")
    return entityHasTab 
  }

  renderTabs() {
    let shouldShowTabs = this.shouldShowTabs()
    if (shouldShowTabs) {
      this.el.classList.add("tabbed")
      this.el.querySelector(".entity_tabs").style.display = 'table-cell'
      if (this.entity.hasCategory("worker")) {
        this.el.querySelector("[data-tab='entity_task_tab']").style.display = 'table-cell'
        this.el.querySelector("[data-tab='entity_targets_tab']").style.display = 'none'
      } else if (this.entity.hasCategory("editable_targets")) {
        this.el.querySelector("[data-tab='entity_task_tab']").style.display = 'none'
        this.el.querySelector("[data-tab='entity_targets_tab']").style.display = 'table-cell'
      }
    } else {
      this.el.classList.remove("tabbed")
      this.el.querySelector(".entity_tabs").style.display = 'none'
    }

    this.resetTabs()

    if (shouldShowTabs &&
        this.selectedTab && 
        this.selectedTab.dataset.tab === 'entity_task_tab' &&
        this.entity.hasCategory("worker")) {
      this.showTab("entity_task_tab")
    } else {
      this.showTab("entity_info_tab")
    }
  }

  removeSelectedEntity() {
    this.selectedEntity = null
  }

  isOpen(entity) {
    let isOpen = super.isOpen()
    let isBelongToEntity = entity === this.selectedEntity || entity === this.entity
    return isOpen && isBelongToEntity
  }

  close() {
    clearTimeout(this.closeTimeout)
    if (this.selectedEntity) return

    this.closeTimeout = setTimeout(() => {
      if (this.selectedEntity) {
        // this.showEntitySummary(this.selectedEntity)
      } else {
        super.close()
      }
    }, 30)
  }
}

module.exports = EntityMenu

},{"../../../common/helper":664,"../../../common/util/protocol":686,"./../util/socket_util":654,"./base_menu":581}],607:[function(require,module,exports){
const SocketUtil = require("./../util/socket_util")
const BaseMenu = require("./base_menu")
const Constants = require("./../../../common/constants.json")

class FriendRequestMenu extends BaseMenu {
  onMenuConstructed() {
  }

  initListeners() {
    super.initListeners()

    this.el.addEventListener("click", this.onRequestMenuClick.bind(this), true)
  }

  createRequestEntry(data) {
    let playerName = data.sender.username

    let el = "<div class='friend_request_entry' data-request-id='" + data.id + "' data-player-uid='" + data.userUid + "' data-username='" + playerName + "'>" +
               "<div class='friend_request_message'><span class='friend_requester'>" + playerName + "</span> " + i18n.t('wants to be your friend') + "</div>" +
               "<div class='accept_friend_request_btn ui_btn' >" + i18n.t('Accept') + "</div>" +
               "<div class='ignore_friend_request_btn ui_btn' >" + i18n.t('Ignore') +"</div>" +
             "</div>"

    this.el.innerHTML += el
  }

  onRequestMenuClick(event) {
    let entry = event.target.closest(".friend_request_entry")
    let playerId = entry.dataset.playerId

    let acceptRequestBtn = event.target.closest(".accept_friend_request_btn")
    let ignoreRequestBtn = event.target.closest(".ignore_friend_request_btn")
    let profileBtn = event.target.closest(".friend_requester")

    if (acceptRequestBtn) {
      let requestId = entry.dataset.requestId
      this.game.main.acceptFriendRequest(requestId)
    } else if (ignoreRequestBtn) {
      let requestId = entry.dataset.requestId
      this.game.main.ignoreFriendRequest(requestId)
    } else if (profileBtn) {
      let uid = entry.dataset.playerUid
      let username = entry.dataset.username
      this.game.userProfileMenu.open({ uid: uid, username: username })
    }
  }

  onFriendRequestAccepted(requestId) {
    this.close()
  }

  onFriendRequestIgnored(requestId) {
    this.close()
  }



}


module.exports = FriendRequestMenu
},{"./../../../common/constants.json":656,"./../util/socket_util":654,"./base_menu":581}],608:[function(require,module,exports){
const SocketUtil = require("./../util/socket_util")
const BaseMenu = require("./base_menu")
const Constants = require("./../../../common/constants.json")
const Config = require("junon-common/config")
const ClientHelper = require("../util/client_helper")


class FriendsMenu extends BaseMenu {
  onMenuConstructed() {
    this.el.querySelector(".friends_tab_container").addEventListener("click", this.onTabClick.bind(this))
    this.el.querySelector(".pending_requests_content").addEventListener("click", this.onPendingRequestContainerClick.bind(this))
    this.el.querySelector(".my_friends_content").addEventListener("click", this.onFriendsContainerClick.bind(this))
    this.el.querySelector(".player_search_btn").addEventListener("click", this.onPlayerSearchClick.bind(this))
    this.el.querySelector(".player_search_results").addEventListener("click", this.onPlayerSearchResultsClick.bind(this))
    this.el.querySelector(".player_search_input").addEventListener("keyup", this.onPlayerSearchInputKeyup.bind(this))
  }

  resetSearch() {
    this.el.querySelector(".player_search_results").innerHTML = ""
  }

  onPlayerSearchClick() {
    let search = this.el.querySelector(".player_search_input").value
    if (search.length === 0) {
      this.resetSearch()
      return
    }

    if (this.searchLock) return
    this.searchLock = true

    let matchmakerUrl = Config[env].matchmakerUrl
    ClientHelper.httpRequest(matchmakerUrl + "search_player?q=" + search, {
      success: (result) => {
        try {
          this.resetSearch()

          let users = JSON.parse(result)
          for (var i = 0; i < users.length; i++) {
            let userData = users[i]
            this.createSearchPlayerResult(userData)
          }

          this.searchLock = false
        } catch(e) {

          this.searchLock = false
        }
      },
      error: () => {
        this.searchLock = false
      }
    })
  }

  createSearchPlayerResult(data) {
    let isMyFriend = this.game.main.isMyFriend(data.uid)
    let isPending = this.game.main.isFriendRequestPending(data.uid)
    let isMe = this.game.playerUid === data.uid

    let addBtn = "<img class='add_search_friend_btn' src='/assets/images/add_friend_icon.png'>"
    if (isMe || isMyFriend || isPending) addBtn = ""

    let el = "<div class='player_search_row' data-uid='" + data.uid + "' data-username='" + data.username + "'>" +
               "<span class='search_username'>" + data.username + "</span>" +
               addBtn +
               "<div class='profile_btn'><img src='/assets/images/profile_icon.png'></div>" + 
             "</div>"

    document.querySelector(".player_search_results").innerHTML += el
  }

  open(options = {}) {
    this.redraw()
    super.open(options)
  }

  redraw() {
    this.renderPendingRequests()
    this.renderFriends()
  }

  onRemoveFriendSuccessful() {
    this.redraw()
  }

  onFriendRequestAccepted(requestId) {
    this.redraw()
  }

  onFriendRequestIgnored(requestId) {
    this.redraw()
  }

  onFriendRequestSent() {
    this.redraw()
  }

  onTabClick(e) {
    let tab = e.target.closest(".friend_tab")
    if (!tab) return

    this.selectTab(tab.dataset.tab)
  }

  selectTab(view) {
    let selected = this.el.querySelector(".friend_tab.selected")
    if (selected) {
      selected.classList.remove('selected')
    }

    let activeTab = this.el.querySelector(".tab-pane.active")
    if (activeTab) {
      activeTab.classList.remove('active')
    }

    let tab = this.el.querySelector(`.friend_tab[data-tab='${view}']`)
    if (tab) {
      tab.classList.add("selected")
    }

    let tabContent = this.el.querySelector(`.tab-pane[data-tab='${view}']`)
    if (tabContent) {
      tabContent.classList.add("active")
    }
  }

  onPlayerSearchInputKeyup(e) {
    if (e.which === 13) {
      this.onPlayerSearchClick()
    }
  }

  onPlayerSearchResultsClick(e) {
    let row = e.target.closest(".player_search_row")
    let uid = row.dataset.uid
    let username = row.dataset.username

    let profileBtn = e.target.closest(".profile_btn")
    let addFriendBtn = e.target.closest(".add_search_friend_btn")

    if (profileBtn) {
      this.game.userProfileMenu.open({ uid: uid, username: username })
    } else if (addFriendBtn) {
      this.game.main.addFriend(uid)
      let btn = row.querySelector(".add_search_friend_btn")
      btn.parentElement.removeChild(btn)
    }
  }

  onFriendsContainerClick(e) {
    let removeFriendBtn = e.target.closest(".remove_friend_btn")
    let profileBtn = e.target.closest(".profile_btn")
    let friendRow = e.target.closest(".friend_row")

    if (profileBtn) {
      let uid = friendRow.dataset.uid
      let username = friendRow.dataset.username
      this.game.userProfileMenu.open({ uid: uid, username: username })
    } else if (removeFriendBtn) {
      //
      this.game.main.removeFriend(friendRow.dataset.uid)
    }
  }


  onPendingRequestContainerClick(e) {
    let acceptRequestBtn = e.target.closest(".accept_request_btn")
    let ignoreRequestBtn = e.target.closest(".ignore_request_btn")
    let friendRequestRow = e.target.closest(".friend_request_row")

    if (acceptRequestBtn) {
      let requestId = friendRequestRow.dataset.requestId
      this.game.main.acceptFriendRequest(requestId)
    } else if (ignoreRequestBtn) {
      let requestId = friendRequestRow.dataset.requestId
      this.game.main.ignoreFriendRequest(requestId)
    }
  }

  renderFriends() {
    document.querySelector(".my_friends_content").innerHTML = ""

    // online first
    for (let uid in this.game.main.friends) {
      let data = this.game.main.friends[uid]
      let onlineStatus = this.getOnlineStatus(data)
      if (onlineStatus === "Online") {
        let el = this.createFriendEl(data)
        document.querySelector(".my_friends_content").innerHTML += el
      }
    }

    // offline next
    for (let uid in this.game.main.friends) {
      let data = this.game.main.friends[uid]
      let onlineStatus = this.getOnlineStatus(data)
      if (onlineStatus !== "Online") {
        let el = this.createFriendEl(data)
        document.querySelector(".my_friends_content").innerHTML += el
      }
    }
  }

  renderPendingRequests() {
    document.querySelector(".pending_requests_content").innerHTML = ""

    let count = this.game.main.getPendingReceivedFriendRequestsCount()
    if (count === 0) {
      document.querySelector(".pending_request_tab").innerText = "Requests"
    } else {
      document.querySelector(".pending_request_tab").innerHTML = "<div>Requests <span class='pendign_request_count'>" + count + "</span></div>"
    }
    

    for (let uid in this.game.main.receivedFriendRequests) {
      let data = this.game.main.receivedFriendRequests[uid]
      if (data.status !== 'ignored') {
        let el = this.createFriendRequestEl(data)
        document.querySelector(".pending_requests_content").innerHTML += el
      }
    }
  }

  getOnlineStatus(data) {
    let friendUid

    let isRequestSentByMe = data.userUid === this.game.main.uid
    if (isRequestSentByMe) {
      friendUid = data.friendUid
    } else {
      friendUid = data.userUid
    }

    return this.game.main.onlinePlayers[friendUid] ? "Online" : "Offline"
  }

  createFriendEl(data) {
    let friendUid
    let friendName

    let isRequestSentByMe = data.userUid === this.game.main.uid
    if (isRequestSentByMe) {
      friendUid = data.friendUid
      friendName = data.receiver.username
    } else {
      friendUid = data.userUid
      friendName = data.sender.username
    }

    let status = this.game.main.onlinePlayers[friendUid] ? "Online" : "Offline"
    let statusKlass = this.game.main.onlinePlayers[friendUid] ? "online" : ""

    let removeFriendBtn = "<div class='remove_friend_btn'><img src='/assets/images/remove_friend_icon.png'></div>"  

    let el = "<div class='friend_row' data-uid='" + friendUid + "' data-username='" + friendName + "'>" + 
                "<div class='name'>" + friendName + "</div>" +
                removeFriendBtn +
                "<div class='profile_btn'><img src='/assets/images/profile_icon.png'></div>" + 
                "<div class='online_status " + statusKlass + "'>" + status + "</div>" + 
             "</div>"
    return el
  }

  createFriendRequestEl(data) {
    let el = "<div class='friend_request_row' data-request-id=" + data.id + ">" + 
                "<div class='name friend_requester_name'>" + data.sender.username + "</div>" +
                "<div class='ignore_request_btn'>Ignore</div>" + 
                "<div class='accept_request_btn'>Accept</div>" + 
             "</div>"
    return el
  }

}

module.exports = FriendsMenu

},{"../util/client_helper":649,"./../../../common/constants.json":656,"./../util/socket_util":654,"./base_menu":581,"junon-common/config":59}],609:[function(require,module,exports){
const Menus = {}

Menus.EntityMenu = require("./entity_menu")
Menus.BlueprintMenu = require("./blueprint_menu")
Menus.CraftMenu = require("./craft_menu")
Menus.ProcessorMenu = require("./processor_menu")
Menus.StorageMenu = require("./storage_menu")
Menus.InventoryMenu = require("./inventory_menu")
Menus.OxygenTankMenu = require("./oxygen_tank_menu")
Menus.DebugMenu = require("./debug_menu")
Menus.ChatMenu = require("./chat_menu")
Menus.TradeMenu = require("./trade_menu")
Menus.SlaveTradeMenu = require("./slave_trade_menu")
Menus.LightPathMenu = require("./light_path_menu")
Menus.WelcomeMenu = require("./welcome_menu")
Menus.TutorialMenu = require("./tutorial_menu")
Menus.MapMenu = require("./map_menu")
Menus.MiniMapMenu = require("./mini_map_menu")
Menus.StatusListMenu = require("./status_list_menu")
Menus.PlayerMenu = require("./player_menu")
Menus.AllianceMenu = require("./alliance_menu")
Menus.NPCDialogMenu = require("./npc_dialog_menu")
Menus.RailStopMenu = require("./rail_stop_menu")
Menus.SignMenu = require("./sign_menu")
Menus.UserProfileMenu = require("./user_profile_menu")
Menus.ConfirmMenu = require("./confirm_menu")
Menus.PermissionsMenu = require("./permissions_menu")
Menus.SendMoneyMenu = require("./send_money_menu")
Menus.VendingMachineMenu = require("./vending_machine_menu")
Menus.AtmMenu = require("./atm_menu")
Menus.SoilMenu = require("./soil_menu")
Menus.StoveMenu = require("./stove_menu")
Menus.WalkthroughMenu = require("./walkthrough_menu")
Menus.LeaderboardMenu = require("./leaderboard_menu")
Menus.TeamFullMenu = require("./team_full_menu")
Menus.PreviewCaptureMenu = require("./preview_capture_menu")
Menus.ChangeNameMenu = require("./change_name_menu")
Menus.SelectDifficultyMenu = require("./select_difficulty_menu")
Menus.ColorPickerMenu = require("./color_picker_menu")
Menus.CommandBlockMenu = require("./command_block_menu")
Menus.CommandBlockPicker = require("./command_block_picker")
Menus.VoteMenu = require("./vote_menu")
Menus.QuestMenu = require("./quest_menu")
Menus.EndGameMenu = require("./end_game_menu")
Menus.SidebarMenu = require("./sidebar_menu")
Menus.SecurityCameraMenu = require("./security_camera_menu")
Menus.SuitColorMenu = require("./suit_color_menu")
Menus.TerminalMenu = require("./terminal_menu")
Menus.FriendsMenu = require("./friends_menu")
Menus.FriendRequestMenu = require("./friend_request_menu")
Menus.KeypadMenu = require("./keypad_menu")
Menus.BadgeMenu = require('./badge_menu')

Menus.TeamMenu = require("./team_menu")
Menus.TeamRequestMenu = require("./team_request_menu")
Menus.TeamStatusMenu = require("./team_status_menu")

module.exports = Menus
},{"./alliance_menu":578,"./atm_menu":579,"./badge_menu":580,"./blueprint_menu":582,"./change_name_menu":583,"./chat_menu":584,"./color_picker_menu":585,"./command_block_menu":586,"./command_block_picker":587,"./confirm_menu":602,"./craft_menu":603,"./debug_menu":604,"./end_game_menu":605,"./entity_menu":606,"./friend_request_menu":607,"./friends_menu":608,"./inventory_menu":610,"./keypad_menu":611,"./leaderboard_menu":612,"./light_path_menu":613,"./map_menu":614,"./mini_map_menu":615,"./npc_dialog_menu":616,"./oxygen_tank_menu":617,"./permissions_menu":618,"./player_menu":619,"./preview_capture_menu":620,"./processor_menu":621,"./quest_menu":622,"./rail_stop_menu":623,"./security_camera_menu":624,"./select_difficulty_menu":625,"./send_money_menu":626,"./sidebar_menu":627,"./sign_menu":628,"./slave_trade_menu":629,"./soil_menu":630,"./status_list_menu":631,"./storage_menu":632,"./stove_menu":633,"./suit_color_menu":634,"./team_full_menu":635,"./team_menu":636,"./team_request_menu":637,"./team_status_menu":638,"./terminal_menu":639,"./trade_menu":640,"./tutorial_menu":641,"./user_profile_menu":642,"./vending_machine_menu":643,"./vote_menu":644,"./walkthrough_menu":645,"./welcome_menu":646}],610:[function(require,module,exports){
const SocketUtil = require("./../util/socket_util")
const BaseMenu = require("./base_menu")
const Constants = require("./../../../common/constants.json")
const Protocol = require("./../../../common/util/protocol")


/*
    while element references only inventory, it actually changes hotbar/quick_inventory as well
*/
class InventoryMenu extends BaseMenu {
  onMenuConstructed() {
    this.initSlots()
    this.initQuickInventory()

    this.hungerBar       = document.querySelector('.hunger_stat')
    this.thirstBar       = document.querySelector('.thirst_stat')
  }

  initSlots() {
    let regularInventoryBaseIndex = Constants.regularInventoryBaseIndex
    let inventorySlots = Constants.Player.inventoryCount - regularInventoryBaseIndex
    let inventoryEl = ""
    for (var i = 0; i < inventorySlots; i++) {
      let el = "<div class='player_inventory_slot inventory_slot' data-index='" + (regularInventoryBaseIndex + i) + "'><img src=''></div>"
      inventoryEl += el
    }

    this.el.querySelector("#player_inventory").innerHTML = inventoryEl
  }

  initQuickInventory() {
    let quickInventorySlots = 8
    let inventoryEl = ""
    for (var i = 0; i < quickInventorySlots; i++) {
      let index = i
      let el = "<div class='player_inventory_slot inventory_slot' data-index='" + index + "'><div class='cooldown_overlay'></div><img src=''></div>"
      inventoryEl += el
    }

    document.querySelector("#player_quick_inventory").innerHTML = inventoryEl
    document.querySelector("#player_quick_inventory").addEventListener("dblclick", this.onQuickInventoryDblClick.bind(this), true)
  }

  onQuickInventoryDblClick(e) {
    let slot = e.target.closest(".player_inventory_slot")
    if (slot) {
      let type = parseInt(slot.dataset.type)
      let isFloor = type === Protocol.definition().BuildingType.Floor 
      let isWall = type === Protocol.definition().BuildingType.Wall 
      if (isFloor || isWall) {
        this.game.colorPickerMenu.open({ colors: this.game.colors, entityId: null })
      }
    }
  }

  onPlayerEquipmentDblClick(e) {
    if (this.game.isMiniGame()) return
    let slot = e.target.closest(".equipment_slot")
    if (slot) {
      let type = parseInt(slot.dataset.type)
      let id = parseInt(slot.dataset.id)
      let isSpaceSuit = type === Protocol.definition().BuildingType.SpaceSuit 
      if (isSpaceSuit) {
        this.game.suitColorMenu.open({colors: this.game.suitColors, entityId: id })
      }
    }
  }

  open(label, storageId) {
    super.open()

    if (this.game.player) {
      this.updateGoldCount(this.game.player.gold)
    }
  }

  updateGoldCount(gold) {
    this.el.querySelector(".player_gold_count_value").innerText = gold || 0
  }

  cleanup() {
    let selectors = "#inventory_menu .inventory_slot, #player_quick_inventory_menu .inventory_slot"
    Array.from(document.querySelectorAll(selectors)).filter((inventorySlot) => {
      let isNotInventoryButton = inventorySlot.dataset.index !== "-1"
      return isNotInventoryButton
    }).forEach((inventorySlot) => {
      this.game.resetInventorySlot(inventorySlot)
    })
  }

  initListeners() {
    super.initListeners()

    this.el.querySelector("#player_equipment").addEventListener("dblclick", this.onPlayerEquipmentDblClick.bind(this), true)

    Array.from(this.el.querySelectorAll(".inventory_slot")).forEach((el) => {
      this.initInventorySlotListener(el)
    })

    Array.from(document.querySelectorAll("#player_quick_inventory_menu .inventory_slot")).forEach((el) => {
      this.initInventorySlotListener(el)
    })
  }

  render(data) {
    let inventory = data.inventory
    
    if (inventory.clientMustDelete) {
      this.removeInventory(inventory)
    } else {
      this.renderInventory(inventory)
    }
  }

  renderInventory(data) {
    // we use document since we are updating both inventory + quickInventory

    const prevInventorySlot = document.querySelector(".player_inventory_slot[data-id='" + data.id  + "']")
    if (prevInventorySlot) {
      this.getPlayer().inventory[prevInventorySlot.dataset.index] = null
      this.game.resetInventorySlot(prevInventorySlot)
    }

    const index = data.index
    const inventorySlot = document.querySelector(".player_inventory_slot[data-index='" + index  + "']")
    this.game.renderInventorySlot(inventorySlot, data)

    if (this.getPlayer()) {
      this.getPlayer().inventory[data.index] = data
    }
  }

  removeInventory(data) {
    const index = data.index
    const inventorySlot = document.querySelector(".player_inventory_slot[data-index='" + index  + "']")

    this.game.resetMobilePrimaryActionBtn(inventorySlot)
    this.game.resetInventorySlot(inventorySlot)

    if (this.getPlayer()) {
      delete this.getPlayer().inventory[data.index]
    }
  }

}



module.exports = InventoryMenu

},{"./../../../common/constants.json":656,"./../../../common/util/protocol":686,"./../util/socket_util":654,"./base_menu":581}],611:[function(require,module,exports){
const BaseMenu = require("./base_menu");

class KeypadMenu extends BaseMenu {
    onMenuConstructed() {
        document.querySelector("#keypad_clear_button").addEventListener('click', () => {
            document.querySelector("#keypad_code_value").value = ''
        })

        document.querySelector("#keypad_submit_button").addEventListener("click", () => {
            if(!this.doorId) return
            let el = document.querySelector("#keypad_submit_button")
            let valueEl = document.querySelector("#keypad_code_value")
            switch (el.innerText) {
                case 'set code':
                    if(valueEl.value != '') {
                        this.game.getSocketUtil().emit("KeypadAction", {id: this.doorId, action: "setCode", keyCode: valueEl.value})
                    }
                    break
                    
                case 'check code':
                    if(valueEl.value != '') {
                        this.game.getSocketUtil().emit("KeypadAction", {id: this.doorId, action: "checkCode", keyCode: valueEl.value})
                    }
                    break;
                default:
                    break;
            }
        })

        document.querySelector("#keypad_code_value").addEventListener("keydown", (e) => {
            if (e.key === "Enter") {
                document.querySelector("#keypad_submit_button").click()
            }
        })

        for(let element of document.getElementsByClassName('keypad_button')) {
            if(element.id == 'keypad_clear_button' || element.id == 'keypad_submit_button') return
            element.addEventListener('click', () => {
                let valueEl = document.querySelector('#keypad_code_value')

                if(valueEl.value.length < 10) {
                    valueEl.value += element.innerText
                }
            })
        }
    }
    
    open(doorId=0) {
        this.el.style.display = 'block'
        document.querySelector("#keypad_code_value").focus()
        document.querySelector("#keypad_code_value").value = ''
        document.querySelector("#keypad_err_msg").style.visibility = 'hidden'

        this.doorId = doorId

        if(doorId == 0) return
        this.game.getSocketUtil().emit("GetDoorStatus", {id: doorId})
    }
    
}

module.exports = KeypadMenu
},{"./base_menu":581}],612:[function(require,module,exports){
const SocketUtil = require("./../util/socket_util")
const BaseMenu = require("./base_menu")
const Constants = require("./../../../common/constants.json")
const ClientHelper = require("./../util/client_helper")

class LeaderboardMenu extends BaseMenu {

  onMenuConstructed() {
    this.el.querySelector(".leaderboard_tab_container").addEventListener("click", this.onTabClick.bind(this), true)
    this.activeTabContent = this.el.querySelector(".leaderboard_tab_content[data-tab='team']")
  }

  onTabClick(e) {
    let tab = e.target.closest(".leaderboard_tab")
    if (!tab) return

    let selectedTab = this.el.querySelector(".leaderboard_tab.selected")
    if (selectedTab) {
      selectedTab.classList.remove("selected")
    }

    tab.classList.add("selected")

    let tabName = tab.dataset.tab

    let tabContent = this.el.querySelector(".leaderboard_tab_content[data-tab='" + tabName + "']")
    if (!tabContent) return

    this.activeTabContent.style.display = 'none'

    this.activeTabContent = tabContent
    this.activeTabContent.style.display = 'block'
  }

  isModal() {
    return false
  }

  onCancelBtnClick() {
  }

  update(data) {
    this.updateTeamRankings(data)
    this.updatePlayerRankings(data)
  }

  updateTeamRankings(data) {
    let el = ""
    let sortedRankings = data.rankings.sort((a, b) => {
      return b.score - a.score
    })
    
    for (let i = 0; i < sortedRankings.length; i++) {
      let ranking = sortedRankings[i]
      el += "<div class='leaderboard_entry' data-id='" + ranking.id +  "'>" +
              "<div class='team_name'>" + ranking.name + "</div>" +
              "<div class='team_score'>" + ranking.score + "</div>" +
            "</div>"
    }

    this.el.querySelector(".team_ranking").innerHTML = el
  }

  updatePlayerRankings(data) {
    let el = ""
    let sortedRankings = data.playerRankings.sort((a, b) => {
      return b.score - a.score
    })
    
    for (let i = 0; i < sortedRankings.length; i++) {
      let ranking = sortedRankings[i]
      el += "<div class='leaderboard_entry' data-id='" + ranking.id +  "'>" +
              "<div class='team_name'>" + ranking.name + "</div>" +
              "<div class='team_score'>" + ranking.score + "</div>" +
            "</div>"
    }

    this.el.querySelector(".player_ranking").innerHTML = el
  }

  open() {
    this.el.style.display = 'block'
  }

}

module.exports = LeaderboardMenu
},{"./../../../common/constants.json":656,"./../util/client_helper":649,"./../util/socket_util":654,"./base_menu":581}],613:[function(require,module,exports){
const BaseMenu = require("./base_menu")
const LightPath = require("./../entities/light_path")

class LightPathMenu extends BaseMenu {

  isModal() {
    return false
  }


  open(entity) {
    super.open()
    
    if (this.lightPath) {
      this.lightPath.remove()
    }

    let data = {
      goal: {
        row: entity.getRow(), 
        col: entity.getCol()
      },
      container: this.game.sector,
      locations: []
    }

    entity.lightings.forEach((lighting) => {
      let location = {
        row: lighting.row,
        col: lighting.col,
        distance: lighting.distance
      }

      data.locations.push(location)
    })

    this.lightPath = new LightPath(this.game, data)
    this.lightPath.show()
  }

  close() {
    super.close()
    if (this.lightPath) {
      this.lightPath.remove()
    }
  }

}

module.exports = LightPathMenu

},{"./../entities/light_path":446,"./base_menu":581}],614:[function(require,module,exports){
const SocketUtil = require("./../util/socket_util")
const Constants = require("./../../../common/constants.json")
const Protocol = require("./../../../common/util/protocol")
const BaseMenu = require("./base_menu")

class MapMenu extends BaseMenu {

  resizeCanvas(sector) {
    let cssCanvasWidth = 512
    this.zoomMultiplier = Math.floor(cssCanvasWidth / sector.getRowCount())
    this.mapSize = this.zoomMultiplier * sector.getRowCount()

    this.terrainCanvas.width = this.mapSize
    this.terrainCanvas.height = this.mapSize

    this.entityCanvas.width = this.mapSize
    this.entityCanvas.height = this.mapSize
  }

  onMenuConstructed() {
    this.terrainCanvas = document.querySelector("#map_terrain_canvas")
    this.entityCanvas = document.querySelector("#map_entity_canvas")
    this.miniMapTerrainCanvas = document.querySelector("#mini_map_terrain_canvas")
    this.miniMapEntityCanvas  = document.querySelector("#mini_map_entity_canvas")
    this.miniMapMenu = document.querySelector("#mini_map_menu")

    this.STRUCTURE_COLOR = "#888888"

    this.labels = {}
    this.mapPositions = {}
    this.alerts = {}
    this.renderQueue = []

    if (this.game.isMobile()) {
      this.repositionMapCanvas() 
    }
  }

  isControllingPlayerRequired() {
    return false
  }

  repositionMapCanvas() {
    let targetWidth 
    if (window.innerWidth < window.innerHeight) {
      targetWidth = window.innerWidth - 75
    } else {
      targetWidth = window.innerHeight - 75
    }

    this.terrainCanvas.style.width = targetWidth + "px"
    this.entityCanvas.style.width = targetWidth + "px"
    document.querySelector("#map_menu_frame").style.width = targetWidth + "px"
    document.querySelector("#map_menu_frame").style.margin = 'auto'
  }

  reinit() {
    // the grid size is 200x200. map is 600px by 600px wide
    let sectorColCount = this.game.sector.getColCount()

    this.zoomMultiplier = Math.floor(this.mapSize / sectorColCount)
  }

  syncWithServer(data) {
    let isEntityMapChanged = false

    data.positions.forEach((position) => {
      isEntityMapChanged = true

      if (this.mapPositions[position.id]) {
        if (position.clientMustDelete) {
          // delete position
          delete this.mapPositions[position.id] 
        } else {
          // update position
          this.mapPositions[position.id] = position
        }
      } else if (!position.clientMustDelete) {
        // create position
        this.mapPositions[position.id] = position
      }
    })

    if (isEntityMapChanged) {
      this.redrawEntityMap()
    }
  }

  addAlert(chunkRow, chunkCol) {
    let key = [chunkRow, chunkCol].join("-")
    this.alerts[key] = true
    this.redrawEntityMap()
  }

  removeAlert(chunkRow, chunkCol) {
    let key = [chunkRow, chunkCol].join("-")
    delete this.alerts[key] 
    this.redrawEntityMap()
  }

  addLabel(id, text, x, y) {
    if (this.game.isMiniGame()) {
      text = i18n.t(text)  
    }
    this.labels[id] = { x: x, y: y, text: text }

    this.redrawEntityMap()
  }

  removeLabel(id) {
    delete this.labels[id] 

    this.redrawEntityMap()
  }

  removePrevTeamMembers(prevMembers) {
    for (let id in prevMembers) {
      delete this.mapPositions[id]
    }
    this.redrawEntityMap()
  }

  redrawEntityMap() {
    this.getEntityContextList().forEach((ctx) => {
      ctx.clearRect(0, 0, this.entityCanvas.width, this.entityCanvas.height)
    })

    for (let id in this.labels) {
      let label = this.labels[id]
      this.drawLabel(label)
    }

    for (let positionId in this.mapPositions) {
      let position = this.mapPositions[positionId]
      this.drawEntityPosition(position)
    }

    for (let alertKey in this.alerts) {
      this.drawAlert(alertKey)
    }
  }

  shouldExcludePosition(ctx, position) {
    return ctx.canvas.id === "mini_map_entity_canvas" && position.id === this.game.playerId
  }

  setPositionChanged() {
    this.isPositionChanged = true
  }

  repositionMiniMap(player) {
    let miniMapWidth  = this.miniMapMenu.offsetWidth
    let actualMapWidth = this.mapSize
    let topLeftX = (player.getX() / this.game.sector.getSectorWidth()) * actualMapWidth - miniMapWidth / 2
    let topLeftY = (player.getY() / this.game.sector.getSectorWidth()) * actualMapWidth - miniMapWidth /2

    this.miniMapTerrainCanvas.style.marginLeft = (0 - topLeftX) + "px"
    this.miniMapTerrainCanvas.style.marginTop =  (0 - topLeftY) + "px"

    this.miniMapEntityCanvas.style.marginLeft = (0 - topLeftX) + "px"
    this.miniMapEntityCanvas.style.marginTop =  (0 - topLeftY) + "px"
  }

  getTerrainCanvasContext() {
    if (!this.terrainCanvasCtx) {
      this.terrainCanvasCtx = this.terrainCanvas.getContext("2d")
      this.terrainCanvasCtx.strokeStyle = 'rgba(0,0,0,0)'
    }

    return this.terrainCanvasCtx
  }

  getEntityCanvasContext() {
    if (!this.entityCanvasCtx) {
      this.entityCanvasCtx = this.entityCanvas.getContext("2d")
    }

    return this.entityCanvasCtx
  }

  getMiniMapTerrainCanvasContext() {
    if (!this.miniMapTerrainCanvasCtx) {
      this.miniMapTerrainCanvasCtx = this.miniMapTerrainCanvas.getContext("2d")
    }

    return this.miniMapTerrainCanvasCtx
  }

  getMiniMapEntityCanvasContext() {
    if (!this.miniMapEntityCanvasCtx) {
      this.miniMapEntityCanvasCtx = this.miniMapEntityCanvas.getContext("2d")
    }

    return this.miniMapEntityCanvasCtx
  }

  getTerrainContextList() {
    return [this.getTerrainCanvasContext(), this.getMiniMapTerrainCanvasContext()]
  }

  getEntityContextList() {
    return [this.getEntityCanvasContext(), this.getMiniMapEntityCanvasContext()]
  }

  clearMapPositions() {
    this.mapPositions = {}
  }

  setMapPosition(entity, type) {
    this.mapPositions[entity.getId()] = { x: entity.getX(), y: entity.getY(), type: type, id: entity.getId() }
  }

  cleanup() {
    this.mapPositions = {}
    this.labels = {}
    this.renderQueue = []

    this.getTerrainContextList().forEach((ctx) => {
      ctx.clearRect(0, 0, this.terrainCanvas.width, this.terrainCanvas.height)
    })

    this.getEntityContextList().forEach((ctx) => {
      ctx.clearRect(0, 0, this.entityCanvas.width, this.entityCanvas.height)
    })
  }

  repositionTo(player) {
    if (this.lastPosition !== player.getCoord()) {
      this.lastPosition = player.getCoord()
      this.repositionMiniMap(player)
    }
  }

  getEntityRadius(position) {
    if (position.type === Protocol.definition().EntityType.Player) {
      return 8
    }

    return 4
  }

  getLineWidth(position) {
    if (position.type === Protocol.definition().EntityType.Player) {
      return 2
    }

    return 1
  }

  getEntityMapPositionColor(position) {
    if (position.type === Protocol.definition().EntityType.Player) {
      return "#bf5036"
    } else if (position.type === Protocol.definition().EntityType.Slave) {
      return "#ffff22"
    } else if (position.type === Protocol.definition().EntityType.Mob) {
      return "#ff2222"
    } else {
      throw new Error("Invalid position type: " + JSON.stringify(position))
    }
  }

  drawAlert(alertKey) {
    let chunkRow = alertKey.split("-")[0]
    let chunkCol = alertKey.split("-")[1]
    let radius = 80

    let row = chunkRow * Constants.chunkColCount + (Constants.chunkColCount)
    let col = chunkCol * Constants.chunkColCount + (Constants.chunkColCount)
    let color = "#ff5b5b"

    this.getEntityContextList().forEach((ctx) => {
      ctx.beginPath()
      ctx.globalAlpha = 0.35
      ctx.arc(col * this.zoomMultiplier, row * this.zoomMultiplier, radius, 0, 2 * Math.PI, false)
      ctx.fillStyle = color
      ctx.lineWidth = 1
      ctx.fill()
      ctx.stroke()
      ctx.globalAlpha = 1
    })

  }

  drawLabel(options) {
    let ctx = this.getEntityCanvasContext()
    ctx.font = "14px Arial"
    ctx.textAlign = 'center'
    ctx.textBaseline = 'middle'

    ctx.fillStyle = "#eadd2b"
    ctx.strokeStyle = "black"
    ctx.lineWidth = 4;

    let row = options.y / Constants.tileSize
    let col = options.x / Constants.tileSize

    ctx.strokeText(options.text, col * this.zoomMultiplier, row * this.zoomMultiplier)

    ctx.fillText(options.text, col * this.zoomMultiplier, row * this.zoomMultiplier)
  }

  drawEntityPosition(position) {
    let radius = this.getEntityRadius(position)
    let row = Math.floor(position.y / Constants.tileSize)
    let col = Math.floor(position.x / Constants.tileSize)
    let color = this.getEntityMapPositionColor(position)

    this.getEntityContextList().forEach((ctx) => {
      if (!this.shouldExcludePosition(ctx, position)) {
        ctx.beginPath()
        ctx.arc(col * this.zoomMultiplier, row * this.zoomMultiplier, radius, 0, 2 * Math.PI, false)
        ctx.fillStyle = color
        ctx.lineWidth = this.getLineWidth(position)
        ctx.fill()
        ctx.stroke()
      }
    })
  }

  assignTile(row, col, color) {
    this.renderQueue.push({ row: row, col: col, color: color, type: 'tile' })
  }

  unassignTile(row, col, color) {
    this.renderQueue.push({ row: row, col: col, type: 'tile', shouldRemove: true })
  }

  drawTile(row, col, color) {
    this.getTerrainContextList().forEach((ctx) => {
      ctx.fillStyle = color
      ctx.fillRect(col * this.zoomMultiplier, row * this.zoomMultiplier, this.zoomMultiplier, this.zoomMultiplier)
    })
  }

  undrawTile(row, col) {
    this.getTerrainContextList().forEach((ctx) => {
      ctx.clearRect(col * this.zoomMultiplier, row * this.zoomMultiplier, this.zoomMultiplier, this.zoomMultiplier)
    })
  }

  drawSquareWithColor(ctx, row, col, color) {
    let widthInTiles = 2
    let heightInTiles = 2

    ctx.fillStyle = color

    ctx.fillRect(col * this.zoomMultiplier, 
                 row * this.zoomMultiplier, 
                 widthInTiles * this.zoomMultiplier, 
                 heightInTiles * this.zoomMultiplier)
  }

  drawStructureWithColor(ctx, entity, color) {
    let widthInTiles = entity.getRotatedWidth() / Constants.tileSize
    let heightInTiles = entity.getRotatedHeight() / Constants.tileSize

    ctx.fillStyle = color

    ctx.fillRect(entity.getUpperLeftCol() * this.zoomMultiplier, 
                 entity.getUpperLeftRow() * this.zoomMultiplier, 
                 widthInTiles * this.zoomMultiplier, 
                 heightInTiles * this.zoomMultiplier)
  }

  assignStructure(entity) {
    this.renderQueue.push({ entity: entity, type: 'structure' })
  }

  unassignStructure(entity) {
    this.renderQueue.push({ entity: entity, type: 'structure', shouldRemove: true })
  }

  processRenderQueue() {
    let elapsed = 0

    while (this.renderQueue.length > 0 && elapsed < 5) {
      let queueItem = this.renderQueue.shift()
      if (queueItem.type === 'structure') {
        if (queueItem.shouldRemove) {
          this.removeStructure(queueItem.entity)
        } else {
          this.drawStructure(queueItem.entity)
        }
      } else if (queueItem.type === 'tile') {
        if (queueItem.shouldRemove) {
          this.undrawTile(queueItem.row, queueItem.col)
        } else {
          this.drawTile(queueItem.row, queueItem.col, queueItem.color)
        }
      }
    }
  }

  drawStructure(entity) {
    if (!entity.hasCategory("wall") && entity.hasWallOnTop()) return
    if (!entity.hasCategory("rail") && entity.hasRailOnTop()) return
    if (entity.hasCategory("platform") && entity.hasStructureOnTop()) return

    let structureColor = entity.getMinimapColor() || this.STRUCTURE_COLOR
    this.getTerrainContextList().forEach((ctx) => {
      this.drawStructureWithColor(ctx, entity, structureColor)
    })
  }

  getDamageTween(row, col) {
    let state = { state: 0 }

    let tween = new TWEEN.Tween(state)
        .to({ state: 1 }, 250)
        .delay(250)
        .onStart(() => {
          this.getTerrainContextList().forEach((ctx) => {
            this.drawSquareWithColor(ctx, row, col, '#ff2222') // red
          })
        })
        .onComplete(() => {
          this.getTerrainContextList().forEach((ctx) => {
            this.drawSquareWithColor(ctx, row, col, this.STRUCTURE_COLOR) 
          })
        })
        .onStop(() => {
          this.getTerrainContextList().forEach((ctx) => {
            this.drawSquareWithColor(ctx, row, col, this.STRUCTURE_COLOR) 
          })
        })

    return tween
  }

  drawDamage(row, col) {
    let damageTweenA = this.getDamageTween(row, col)
    let damageTweenB = this.getDamageTween(row, col)
    damageTweenA.chain(damageTweenB)
    damageTweenA.start()
  }

  removeStructure(entity) {
    this.getTerrainContextList().forEach((ctx) => {
      let widthInTiles = entity.getRotatedWidth() / Constants.tileSize
      let heightInTiles = entity.getRotatedHeight() / Constants.tileSize

      ctx.clearRect(entity.getUpperLeftCol() * this.zoomMultiplier, 
                    entity.getUpperLeftRow() * this.zoomMultiplier, 
                    widthInTiles * this.zoomMultiplier, 
                    heightInTiles * this.zoomMultiplier)
    })
  }

}



module.exports = MapMenu 
},{"./../../../common/constants.json":656,"./../../../common/util/protocol":686,"./../util/socket_util":654,"./base_menu":581}],615:[function(require,module,exports){
const SocketUtil = require("./../util/socket_util")
const Constants = require("./../../../common/constants.json")
const BaseMenu = require("./base_menu")

class MiniMapMenu extends BaseMenu {

  onMenuConstructed() {
    this.canvas = this.el.querySelector("#mini_map_canvas")
    this.rowColPosition = document.querySelector("#mini_map_player_pos_label")
  }

  open() {
    this.el.style.display = 'block'
  }

  cleanup() {
    // let ctx = this.canvas.getContext("2d")
    // ctx.clearRect(0, 0, this.canvas.width, this.canvas.height)
  }

  displayPosition(player) {
    if (this.lastPosition !== player.getCoord()) {
      this.lastPosition = player.getCoord()
      this.rowColPosition.innerText = player.getCoord()
    }
    
  }

  updateViewport() {
    // if (this.isCanvasChanged) {
    //   this.isCanvasChanged = false
      
    //   let player = this.game.player

    //   let viewportWidth  = 200 // 1/3 of 600px buffermap
    //   let viewportHeight = 200
    //   let topLeftX = player.getCol() * 2 - viewportWidth/2
    //   let topLeftY = player.getRow() * 2 - viewportWidth/2

    //   let ctx = this.canvas.getContext("2d")
    //   ctx.fillStyle = "#0d151d"
    //   ctx.fillRect(0,0,150,150)
    //   ctx.drawImage(this.game.mapMenu.terrainCanvas, topLeftX, topLeftY, viewportWidth, viewportHeight, 
    //                                                  0, 0, 150, 150)
    //   ctx.drawImage(this.game.mapMenu.entityCanvas, topLeftX, topLeftY, viewportWidth, viewportHeight, 
    //                                                  0, 0, 150, 150)
    // }
  }

  invalidate() {
    this.isCanvasChanged = true
  }


}



module.exports = MiniMapMenu 
},{"./../../../common/constants.json":656,"./../util/socket_util":654,"./base_menu":581}],616:[function(require,module,exports){
const SocketUtil = require("./../util/socket_util")
const BaseMenu = require("./base_menu")
const Mobs = require("./../entities/mobs/index")
const Ores = require("./../entities/ores/index")
const Item = require("./../entities/item")
const Buildings = require("./../entities/buildings/index")
const Equipments = require("./../entities/equipments/index")
const Helper = require("./../../../common/helper")

/*
    while element references only inventory, it actually changes hotbar/quick_inventory as well
*/
class NPCDialogMenu extends BaseMenu {
  onMenuConstructed() {
    this.el.querySelector(".confirm_npc_choice_btn").addEventListener("click", this.onChoiceConfirmClick.bind(this), true)
    this.el.querySelector(".npc_choices_container").addEventListener("click", this.onChoiceItemClick.bind(this) , true)
  }

  onChoiceItemClick(e) {
    let npcChoice = e.target.closest(".npc_choice")
    if (npcChoice) {
      if (this.selectedChoice) {
        this.selectedChoice.classList.remove("selected")
      }

      this.selectedChoice = npcChoice
      this.selectedChoice.classList.add("selected")
    }
  }

  onChoiceConfirmClick() {
    if (!this.selectedChoice) return

    let choice = this.selectedChoice.dataset.choice
    SocketUtil.emit("NPCClientMessage", { entityId: this.entityId, choice: choice })
  }

  open(choicesHTML, options = {}) {
    super.open()

    this.el.querySelector(".menu_main_header").innerText = options.title
    this.el.querySelector(".npc_choices_container").innerHTML = choicesHTML
    this.el.querySelector(".confirm_npc_choice_btn").style.display = 'block'    

    this.entityId = options.entityId
    this.team = options.team
    this.renderPaymentAmount()
  }

  getPaymentAmount() {
    let paymentAmount = 100 * Math.ceil(this.team.dayCount / 3) 
    paymentAmount = Math.max(0, paymentAmount)
    paymentAmount = Math.min(5000, paymentAmount)
    return paymentAmount
  }

  hideConfirm() {
    this.el.querySelector(".confirm_npc_choice_btn").style.display = 'none'    
  }

  renderPaymentAmount() {
    if (!this.el.querySelector(".payment_amount")) return

    let paymentAmount = this.getPaymentAmount()

    this.el.querySelector(".payment_amount").innerText = paymentAmount
  }

}

module.exports = NPCDialogMenu
},{"./../../../common/helper":664,"./../entities/buildings/index":250,"./../entities/equipments/index":407,"./../entities/item":443,"./../entities/mobs/index":464,"./../entities/ores/index":494,"./../util/socket_util":654,"./base_menu":581}],617:[function(require,module,exports){
const SocketUtil = require("./../util/socket_util")
const StorageMenu = require("./storage_menu")

class OxygenTankMenu extends StorageMenu {
  initStorage() {
    this.el.querySelector(".storage").innerHTML = this.createInventorySlots(2)
  }

  open(entity) {
    super.open(null, entity.id)

    this.entity = entity
  }

  initListeners() {
    super.initListeners()

    let elements = Array.from(this.el.querySelectorAll(".inventory_slot"))
    for (let i = 0; i < elements.length; i++) {
      let el = elements[i]
      this.initInventorySlotListener(el)
    }

  }

}



module.exports = OxygenTankMenu

},{"./../util/socket_util":654,"./storage_menu":632}],618:[function(require,module,exports){
const SocketUtil = require("./../util/socket_util")
const BaseMenu = require("./base_menu")
const Constants = require("./../../../common/constants.json")

class PermissionsMenu extends BaseMenu {
  onMenuConstructed() {
  }

  initListeners() {
    super.initListeners()

    this.el.querySelector(".allow_access_select").addEventListener("change", this.onAllowAccessSelectChanged.bind(this))
  }

  open(options = {}) {
    super.open(options)

    this.entity = options.entity
    this.render()
  }

  render() {
    this.createOptions()

    if (this.entity.accessType !== 'undefined') {
      this.el.querySelector(".allow_access_select").value = this.entity.accessType
    }
  }

  onAllowAccessSelectChanged(e) {
    let value = e.target.value
    SocketUtil.emit("EditBuilding", { id: this.entity.id, accessType: value })
  }

  createOptions() {
    this.el.querySelector(".allow_access_select").innerHTML = ""

    let options = "<option value='2'>" + i18n.t('Admin') + "</option>" + 
                  "<option value='1'>" + i18n.t('Members') + "</option>" +
                  "<option value='0'>" + i18n.t('Everyone') + "</option>"

    this.el.querySelector(".allow_access_select").innerHTML += options
  }


}



module.exports = PermissionsMenu 
},{"./../../../common/constants.json":656,"./../util/socket_util":654,"./base_menu":581}],619:[function(require,module,exports){
const SocketUtil = require("./../util/socket_util")
const BaseMenu = require("./base_menu")
const Item = require("./../entities/item")

class PlayerMenu extends BaseMenu {
  onMenuConstructed() {

  }

  initProcessing() {
  }

  initListeners() {
    super.initListeners()

    this.el.querySelector(".add_player_btn").addEventListener("click", this.onAddToTeamBtnClick.bind(this))
    this.el.querySelector(".kick_player_btn").addEventListener("click", this.onKickFromTeamBtnClick.bind(this))
  }

  onAddToTeamBtnClick() {

  }

  onKickFromTeamBtnClick() {

  }

  open(player) {
    super.open()

    if (player.isSameTeam(this.game.player)) {
      this.el.querySelector(".add_player_team_container").style.display = 'none'
      this.el.querySelector(".kick_player_team_container").style.display = 'block'
    } else {
      this.el.querySelector(".add_player_team_container").style.display = 'block'
      this.el.querySelector(".kick_player_team_container").style.display = 'none'
    }
  }

  cleanup() {

  }

}



module.exports = PlayerMenu
},{"./../entities/item":443,"./../util/socket_util":654,"./base_menu":581}],620:[function(require,module,exports){
const SocketUtil = require("./../util/socket_util")
const BaseMenu = require("./base_menu")
const Constants = require("./../../../common/constants.json")
const ClientHelper = require("./../util/client_helper")

class PreviewCaptureMenu extends BaseMenu {

  onMenuConstructed() {
  }

  isModal() {
    return true
  }

  onCancelBtnClick() {
    this.close()
  }

}

module.exports = PreviewCaptureMenu
},{"./../../../common/constants.json":656,"./../util/client_helper":649,"./../util/socket_util":654,"./base_menu":581}],621:[function(require,module,exports){
const SocketUtil = require("./../util/socket_util")
const BaseMenu = require("./base_menu")
const Item = require("./../entities/item")

class ProcessorMenu extends BaseMenu {
  onMenuConstructed() {
    this.progressBar = this.el.querySelector(".processor_progress_bar_fill")
  }

  initProcessing() {
  }

  initListeners() {
    super.initListeners()

    Array.from(this.el.querySelectorAll(".inventory_slot")).forEach((el) => {
      this.initInventorySlotListener(el)
      el.addEventListener("click", this.onInventoryClick.bind(this), true)
    })
  }

  close() {
    this.label = null
    
    if (!this.game.hideMainMenus) {
      this.showQuickInventory()
    }
    
    super.close()
  }


  onInventoryClick(event) {
    this.retrieveInventorySlot(event)
  }

  onInventoryChanged(data) {
    this.renderPlayerInventory(data)
  }

  hasPlayerInventory() {
    return true
  }

  updateStorageInventory(data) {
    super.updateStorageInventory(data)

    let progressWidth = data.progress / 100 * this.getProgressMaxWidth()
    this.progressBar.style.width = progressWidth + "px"
  }

  getProgressMaxWidth() {
    return 50
  }

  finishOpen() {
    super.open()
  }

  open(header, entity, description, shouldHideInput = false, footer = "", options = {}) {
    this.cleanup()

    this.storageId = entity.id

    if (shouldHideInput) {
      this.el.classList.add("processor_output_only")
    } else {
      this.el.classList.remove("processor_output_only")
    }

    this.el.querySelector(".input_inventory").style.display = shouldHideInput ? "none" : "inline-block"
    this.el.querySelector(".processor_storage").dataset.storageId = this.storageId
    this.el.querySelector(".menu_main_header").innerText = i18n.t(header)
    this.el.querySelector(".menu_description").innerText = i18n.t(description)

    if (options.disabled) {
      this.isDisabled = true
      this.el.querySelector(".processor_status_message").innerText = i18n.t(options.disabled)
    } else {
      this.isDisabled = false
      this.el.querySelector(".processor_status_message").innerText = ""
    }

    SocketUtil.emit("ViewStorage", { id: this.storageId })

    this.initPlayerInventoryStorage()
    this.initPlayerInventorySlotListeners()
  }

  shouldHideQuickInventory() {
    return true
  }

  cleanup() {
    this.el.querySelector(".processor_storage").dataset.storageId = ""
    this.storageId = null

    Array.from(this.el.querySelectorAll(".inventory_slot")).forEach((inventorySlot) => {
      this.game.resetInventorySlot(inventorySlot)
    })

    this.progressBar.style.width = "0px"
  }

}



module.exports = ProcessorMenu

},{"./../entities/item":443,"./../util/socket_util":654,"./base_menu":581}],622:[function(require,module,exports){
const SocketUtil = require("./../util/socket_util")
const BaseMenu = require("./base_menu")
const Constants = require("./../../../common/constants.json")
const ClientHelper = require("./../util/client_helper")

class QuestMenu extends BaseMenu {

  onMenuConstructed() {
    this.objectives = {}
  }

  isModal() {
    return false
  }

  setObjectives(objectives) {
    for (let name in objectives) {
      let objective = objectives[name]
      this.objectives[name] = objective
    }

    this.renderObjectives()
  }

  update(data) {
    if (data.isCompleted) {
      if (this.objectives[data.name]) {
        this.objectives[data.name].isCompleted = true
      }
    } else {
      this.objectives[data.name] = data
    }

    this.renderObjectives()
  }

  open() {
    this.el.style.display = 'block'
  }

  renderObjectives() {
    let el = ""

    for (let id in this.objectives) {
      let quest = this.objectives[id]  
      let description = quest.description
      if (quest.translations[window.language]) {
        description = quest.translations[window.language]
      }

      el += this.createQuestEl(id, description, quest.isCompleted)
    }

    this.el.querySelector(".quest_list").innerHTML = el

    if (Object.keys(this.objectives).length > 0) {
      this.open()
    }
  }

  createQuestEl(id, text, isCompleted) {
    let statusKlass = ""

    if (isCompleted) {
      statusKlass = "completed"
    }

    return "<div class='quest_row custom_checkbox_container " + statusKlass + "' data-id='" + id + "'>" + 
      "<input type='checkbox'>" +
      "<span class='checkmark'></span>" +
      "<div class='quest_label'>" + text + "</div>" +
    "</div>"
  }

  hide() {
    this.cleanup()
  }

  cleanup() {
    this.el.querySelector(".quest_list").innerHTML = ""
    document.querySelector("#quest_menu").style.display = 'none'
    this.objectives = {}
  }

}

module.exports = QuestMenu
},{"./../../../common/constants.json":656,"./../util/client_helper":649,"./../util/socket_util":654,"./base_menu":581}],623:[function(require,module,exports){
const SocketUtil = require("./../util/socket_util")
const BaseMenu = require("./base_menu")
const Constants = require("./../../../common/constants.json")

class RailStopMenu extends BaseMenu {
  onMenuConstructed() {
  }

  initListeners() {
    super.initListeners()

    this.el.querySelector(".destination_list").addEventListener("click", this.onDestinationListClick.bind(this))

    this.el.querySelector(".rename_btn").addEventListener("click", this.onRenameBtnClick.bind(this))
    this.el.querySelector(".stop_name_input").addEventListener("blur", this.onStopNameInputBlur.bind(this))
    this.el.querySelector(".stop_name_input").addEventListener("keyup", this.onStopNameInputKeyup.bind(this))

    this.el.querySelector(".go_destination_btn").addEventListener("click", this.onGoBtnClick.bind(this))
  }

  onMenuInteract(cmd) {
    switch(cmd) {
      case "EnterUp":
        this.onEnterUp()
        break
    }
  }

  onEnterUp() {
    this.onGoBtnClick()    
  }

  onDestinationListClick(e) {
    let choice = e.target.closest(".rail_destination_item")
    if (choice) {
      if (this.selectedChoice) {
        this.selectedChoice.classList.remove("selected")
      }

      this.selectedChoice = choice
      this.selectedChoice.classList.add("selected")

      this.el.querySelector(".go_destination_btn").dataset.disabled = ''
    }
  }

  open(options = {}) {
    super.open(options)

    // clear destinations. always fetch from server
    this.el.querySelector(".destination_list").innerHTML = ''

    this.entity = options.entity
    this.render(this.entity)

    this.hideStopNameInput()
    this.el.querySelector(".go_destination_btn").dataset.disabled = 'true'

    if (options.disabled) {
      this.isDisabled = true
      this.el.querySelector("#rail_status_message").innerText = i18n.t(options.disabled)
    } else {
      this.isDisabled = false
      this.el.querySelector("#rail_status_message").innerText = ""
    }

    if (this.entity.isPowered) {
      SocketUtil.emit("InteractTarget", { id: this.entity.id, action: "view" })
    }
  }

  render(stop) {
    this.stopName = stop.getStopName()
    this.el.querySelector(".stop_info_name").innerText = i18n.t(this.stopName)

    this.renderRenameBtn(stop, this.game.player.getTeam()) 
  }

  renderDestinations(data) {
    if (Object.keys(data.destinationMap).length === 0) {
      let el = "<div class='empty_destination_message'>No Destinations Found</div>"
      this.el.querySelector(".destination_list").innerHTML = el
      return
    }

    for (let stopId in data.destinationMap) {
      let stopName = data.destinationMap[stopId]
      const div = document.createElement("div")
      div.className = "rail_destination_item"
      div.dataset.id = stopId

      if (stopName.replace(/\s+/,'').length === 0) {
        div.innerText = "(" + i18n.t('Unnamed') + ")"
      } else {
        div.innerText = i18n.t(stopName)
      }
      
      this.el.querySelector(".destination_list").appendChild(div)
    }
  }


  onRenameBtnClick(e) {
    let renameBtn = e.target.closest(".rename_btn")
    if (renameBtn) {
      this.showStopNameInput()
    } 
  }

  onGoBtnClick() {
    if (!this.selectedChoice) return
    if (this.disabled) return

    let action = "travel:" + this.selectedChoice.dataset.id
    SocketUtil.emit("InteractTarget", { id: this.entity.id, action: action })

    this.close()
  }

  showStopNameInput() {
    this.el.querySelector(".stop_info_name").style.display = 'none'
    this.el.querySelector(".stop_name_input").style.display = 'inline-block'
    this.el.querySelector(".stop_name_input").value = this.stopName
    this.el.querySelector(".stop_name_input").focus()
  }

  hideStopNameInput() {
    this.el.querySelector(".stop_info_name").style.display = 'inline-block'
    this.el.querySelector(".stop_name_input").style.display = 'none'
  }

  onStopNameInputBlur(e) {
    this.setStopName(e.target.value)
    this.hideStopNameInput()
  }

  onStopNameInputKeyup(e) {
    if (e.which === 13 || e.which === 27) { // enter or esc
      this.setStopName(e.target.value)
      e.target.blur()
      this.hideStopNameInput()
    }
  }

  setStopName(name) {
    SocketUtil.emit("EditBuilding", { id: this.entity.id, content: name })
  }

  cleanup() {
    this.el.querySelector(".destination_list").innerHTML = ""
  }

  renderRenameBtn(stop, team) {
    if (this.game.isLeaderAndOwner(stop, team, this.game.player)) {
      this.el.querySelector(".rename_btn").style.display = 'inline-block'
    } else {
      this.el.querySelector(".rename_btn").style.display = 'none'
    }
  }


}



module.exports = RailStopMenu 
},{"./../../../common/constants.json":656,"./../util/socket_util":654,"./base_menu":581}],624:[function(require,module,exports){
const SocketUtil = require("./../util/socket_util")
const BaseMenu = require("./base_menu")
const Constants = require("./../../../common/constants.json")

class SecurityCameraMenu extends BaseMenu {
  onMenuConstructed() {
  }

  initListeners() {
    super.initListeners()

    this.el.querySelector(".camera_feed_navigator").addEventListener("click", this.onCameraFeedClick.bind(this), true)
  }

  open(options = {}) {
    super.open(options)

    this.render()
    this.clickFirstItem()
  }

  clickFirstItem() {
    let cameraFeedItem = this.el.querySelector(".camera_feed_item")
    if (cameraFeedItem && !cameraFeedItem.classList.contains("exit_camera_feed_btn")) {
      this.selectFeed(cameraFeedItem)
    }
  }

  selectFeed(el) {
    let selected = document.querySelector(".camera_feed_item.selected")
    if (selected) {
      selected.classList.remove("selected")
    }

    el.classList.add("selected")
    let id = el.dataset.id

    SocketUtil.emit("ViewCamera", { id: id })
    this.lastActiveFeed = el
  }

  onCameraFeedClick(e) {
    let target = e.target.closest(".camera_feed_item")
    if (!target) return

    if (target.classList.contains("exit_camera_feed_btn")) {
      this.close()
      return
    }

    this.selectFeed(target)
  }

  close(options = {}) {
    super.close(options)

    SocketUtil.emit("ViewCamera", { id: 0 })
    this.game.exitSecurityCameraMode()
  }

  onMenuInteract(cmd) {
    switch(cmd) {
      case "ShiftTab":
        this.onShiftTab()
        break
      case "Tab":
        this.onTab()
        break
      default:
    }
  }

  onShiftTab() {
    this.onTabDirection(-1)
  }

  onTab() {
    this.onTabDirection(1)
  }

  onTabDirection(direction) {
    let tabs = Array.from(this.el.querySelectorAll(".camera_feed_item"))
    if (tabs.length <= 1) return

    let tabIndex = Array.prototype.indexOf.call(tabs, this.lastActiveFeed)
    
    if (direction > 0) {
      // next
      let isLastTab = tabIndex === tabs.length - 2
      if (isLastTab) {
        this.selectFeed(tabs[0])
      } else {
        this.selectFeed(tabs[tabIndex + 1])
      }
    } else {
      let isFirstTab = tabIndex === 0
      if (isFirstTab) {
        this.selectFeed(tabs[tabs.length - 2])
      } else {
        this.selectFeed(tabs[tabIndex - 1])
      }
    }
  }

  render() {
    this.updateCameraFeeds(this.game.sector.cameraFeeds)
  }

  updateCameraFeeds(cameraFeeds) {
    let el = ""

    for (let id in cameraFeeds) {
      let name = cameraFeeds[id].content
      let translated = i18n.t(name)
      el += `<div class='camera_feed_item' data-id='${id}'>${translated}</div>`
    }

    el += `<div class='camera_feed_item exit_camera_feed_btn' data-id='-1'>${i18n.t('ExitCamera')}</div>`

    this.el.querySelector(".camera_feed_navigator").innerHTML = el
  }


}



module.exports = SecurityCameraMenu 
},{"./../../../common/constants.json":656,"./../util/socket_util":654,"./base_menu":581}],625:[function(require,module,exports){
const SocketUtil = require("./../util/socket_util")
const BaseMenu = require("./base_menu")
const Mobs = require("./../entities/mobs/index")
const Ores = require("./../entities/ores/index")
const Item = require("./../entities/item")
const Buildings = require("./../entities/buildings/index")
const Equipments = require("./../entities/equipments/index")
const Helper = require("./../../../common/helper")

class SelectDifficultyMenu extends BaseMenu {
  onMenuConstructed() {
    this.el.querySelector(".accept_game_mode_btn").addEventListener("click", this.onAcceptGameModeBtnClick.bind(this), true)
    this.el.querySelector(".game_modes_list").addEventListener("click", this.onGameModesListClick.bind(this), true)
    this.el.querySelector(".game_modes_list").addEventListener("dblclick", this.onGameModesListDblClick.bind(this), true)
    this.el.querySelector(".game_modes_list").addEventListener("keyup", this.onGameModesListKeyup.bind(this), true)
  }

  onGameModesListDblClick() {
    this.onAcceptGameModeBtnClick()
  }

  onGameModesListKeyup(e) {
    if (e.which === 13) {
      this.onAcceptGameModeBtnClick()
    }
  }

  onGameModesListClick(e) {
    let gameMode = e.target.closest(".game_mode")
    if (gameMode) {
      let selectedGameMode = this.el.querySelector(".game_mode.selected")
      if (selectedGameMode) {
        selectedGameMode.classList.remove("selected")
      }
      gameMode.classList.add("selected")
    }
  }

  showGameMode(gameMode) {
    if (gameMode) return // gameMode already exist

    if (!this.game.player) return
    if (!this.game.player.isSectorOwner()) return

    let peacefulHardcoreModeDate = (new Date(2020, 7, 19)).getTime() / 1000
    if (this.game.sector.createdAt < peacefulHardcoreModeDate) return

    let selectedGameMode = this.el.querySelector(".game_mode.selected")
    if (selectedGameMode) {
      selectedGameMode.classList.remove("selected")
    }

    selectedGameMode = this.el.querySelector(".game_mode[data-mode='survival']")
    selectedGameMode.classList.add("selected")

    this.open()
  }

  onAcceptGameModeBtnClick(e) {
    let selectedGameMode = this.el.querySelector(".game_mode.selected")
    if (!selectedGameMode) return

    let action = selectedGameMode.dataset.mode + "Mode"

    SocketUtil.emit("SectorAction", { action: action })

  }

}

module.exports = SelectDifficultyMenu
},{"./../../../common/helper":664,"./../entities/buildings/index":250,"./../entities/equipments/index":407,"./../entities/item":443,"./../entities/mobs/index":464,"./../entities/ores/index":494,"./../util/socket_util":654,"./base_menu":581}],626:[function(require,module,exports){
const SocketUtil = require("./../util/socket_util")
const BaseMenu = require("./base_menu")
const Constants = require("./../../../common/constants.json")

class SendMoneyMenu extends BaseMenu {
  onMenuConstructed() {
  }

  initListeners() {
    super.initListeners()

    this.el.querySelector(".send_money_btn").addEventListener("click", this.onSendMoneyBtnClick.bind(this))
    this.el.querySelector(".send_money_input").addEventListener("keyup", this.onSendMoneyInputKeyup.bind(this))
  }

  onSendMoneyInputKeyup(e) {
    if (e.key === "Enter") {
      this.sendMoney() 
    }
  }

  onSendMoneyBtnClick(e) {
    this.sendMoney() 
  }

  sendMoney() {
    let gold = parseInt(this.el.querySelector(".send_money_input").value)
    if (gold < 0) {
      this.game.displayError("Invalid Amount", { warning: true })
      return
    }

    SocketUtil.emit("SendMoney", { playerId: this.targetPlayer.id, gold: gold })
  }

  updateGoldCount(gold, delta) {
    this.el.querySelector(".player_gold_count_value").innerText = gold || 0

    if (this.isOpen()) {
      this.animateGoldChanged(delta)
    }
  }

  animateGoldChanged(delta) {
    let data = {}
    let rect = this.el.querySelector(".send_money_btn").getBoundingClientRect()
    data.y = rect.top - 20
    data.x = rect.left + 50

    let label = delta < 0 ? delta : "+" + delta
    let text = document.createElement("span")
    text.className = "gold_changed_label"
    text.innerText = label
    document.body.appendChild(text)

    text.style.top  = data.y + "px"
    text.style.left = data.x + "px"

    let position = { y: data.y }
    var tween = new TWEEN.Tween(position)
        .to({ y: data.y - 50 }, 1500)
        .onUpdate(() => {
          text.style.top = position.y + "px"
        })
        .onComplete(() => {
          document.body.removeChild(text)
        })
        .start()
  }

  open(options = {}) {
    super.open(options)

    this.targetPlayer = options.receiver
    this.render()
  }

  render() {
    let gold = this.game.player.gold
    this.el.querySelector(".recepient_name").innerText = this.targetPlayer.name
    this.el.querySelector(".player_gold_count_value").innerText = gold
  }


}



module.exports = SendMoneyMenu 
},{"./../../../common/constants.json":656,"./../util/socket_util":654,"./base_menu":581}],627:[function(require,module,exports){
const SocketUtil = require("./../util/socket_util")
const BaseMenu = require("./base_menu")
const Constants = require("./../../../common/constants.json")
const ClientHelper = require("./../util/client_helper")

class SidebarMenu extends BaseMenu {
  onMenuConstructed() {
    this.rows = []
  }

  initListeners() {
    super.initListeners()

  }

  open(options = {}) {
    this.el.style.display = 'block'
  }

  close() {
    this.el.style.display = 'none'
  }

  setVisible(isVisible) {
  }

  setRowText(row, text) {
    this.rows[row] = text

    this.onTextUpdated()
    if (this.isEmpty()) {
      this.close()
    } else {
      this.open()
    }
  }

  isEmpty() {
    let result = true

    for (let row in this.rows) {
      let text = this.rows[row]
      if (text && text.length > 0) {
        result = false
        break
      }
    }

    return result
  }

  onTextUpdated() {
    this.el.querySelector(".sidebar_text").innerHTML = this.buildSidebarText()
  }

  buildSidebarText() {
    let maxRows = 15

    let result = "<ul>"
    for (var i = 0; i < maxRows; i++) {
      let text = this.rows[i]
      if (!text) {
        result += "<li></li>"
      } else {
        result = result + "<li>" + this.buildTextEl(text) + "</li>"
      }
    }

    result += "</ul>"

    return result
  }

  buildTextEl(text) {
    const htmlSafeText = ClientHelper.escapeHTML(text)
    let characters = htmlSafeText.split('')
    let result = ""
    let buffer = ""
    let isTagOpen = false

    for (var i = 0; i < characters.length; i++) {
      let char = characters[i]
      if (char === '§') {
        if (isTagOpen) {
          buffer += "</span>"
        }

        result += buffer // flush buffer
        let colorCode = characters[i + 1]
        i++
        buffer = `<span class='color_text' data-code='${colorCode}'>`
        isTagOpen = true
      } else {
        buffer += char
      }
    }

    if (buffer.length > 0) {
      result += buffer
    }
    
    return result
  }

  isModal() {
    return false
  }

  cleanup() {
    this.rows = []
    this.el.querySelector(".sidebar_text").innerHTML = ""
  }
}



module.exports = SidebarMenu 
},{"./../../../common/constants.json":656,"./../util/client_helper":649,"./../util/socket_util":654,"./base_menu":581}],628:[function(require,module,exports){
const SocketUtil = require("./../util/socket_util")
const BaseMenu = require("./base_menu")
const Constants = require("./../../../common/constants.json")

class SignMenu extends BaseMenu {
  onMenuConstructed() {
  }

  initListeners() {
    super.initListeners()

    this.el.querySelector(".edit_sign_message_btn").addEventListener("click", this.onEditSignMessageBtnClick.bind(this))
    this.el.querySelector(".sign_message_input").addEventListener("blur", this.onSignMessageInputBlur.bind(this))
    this.el.querySelector(".sign_message_input").addEventListener("keyup", this.onSignMessageInputKeyup.bind(this))

    this.el.querySelector(".cancel_sign_edit_btn").addEventListener("click", this.onCancelSignEditBtnClick.bind(this))
    this.el.querySelector(".done_sign_edit_btn").addEventListener("click", this.onDoneSignEditBtnClick.bind(this))
  }

  open(options = {}) {
    super.open(options)

    this.hideSignMessageInput()

    this.entity = options.entity
    this.render(this.entity)
  }

  onSignMessageInputBlur(e) {
  }

  onSignMessageInputKeyup(e) {

  }

  onCancelSignEditBtnClick() {
    this.hideSignMessageInput()
  }

  onDoneSignEditBtnClick() {
    let text = this.el.querySelector(".sign_message_input").value
    this.setSignMessage(text)
    this.hideSignMessageInput()
  }

  hideSignMessageInput() {
    this.el.querySelector(".sign_message_input").style.display = 'none'
    this.el.querySelector(".sign_message").style.display = 'block'

    this.el.querySelector(".edit_sign_message_btn").style.display = 'inline-block'
    this.el.querySelector(".cancel_sign_edit_btn").style.display = 'none'
    this.el.querySelector(".done_sign_edit_btn").style.display = 'none'
  }

  showSignMessageInput() {
    this.el.querySelector(".sign_message_input").style.display = 'block'
    this.el.querySelector(".sign_message_input").value = this.signText
    this.el.querySelector(".sign_message").style.display = 'none'

    this.el.querySelector(".edit_sign_message_btn").style.display = 'none'
    this.el.querySelector(".cancel_sign_edit_btn").style.display = 'inline-block'
    this.el.querySelector(".done_sign_edit_btn").style.display = 'inline-block'
  }

  render(sign) {
    this.signText = sign.getText()

    if (this.signText.length === 0) {
      this.el.querySelector(".sign_message").innerText = "(Empty)"
    } else {
      this.el.querySelector(".sign_message").innerText = this.signText
    }
    
  }

  onEditSignMessageBtnClick() {
    this.showSignMessageInput()
  }

  setSignMessage(text) {
    SocketUtil.emit("EditBuilding", { id: this.entity.id, content: text })
  }


}



module.exports = SignMenu 
},{"./../../../common/constants.json":656,"./../util/socket_util":654,"./base_menu":581}],629:[function(require,module,exports){
const SocketUtil = require("./../util/socket_util")
const BaseMenu = require("./base_menu")
const Mobs = require("./../entities/mobs/index")
const Ores = require("./../entities/ores/index")
const Item = require("./../entities/item")
const Buildings = require("./../entities/buildings/index")
const Equipments = require("./../entities/equipments/index")
const Helper = require("./../../../common/helper")

/*
    while element references only inventory, it actually changes hotbar/quick_inventory as well
*/
class SlaveTradeMenu extends BaseMenu {
  onMenuConstructed() {
    this.initSellables()
    let rows = Array.from(this.el.querySelectorAll(".trade_item_row"))
    this.selectRow(rows[0]) // select first item

    this.errorMessage = this.el.querySelector(".error_message")

    this.activeTabContent = this.el.querySelector(".buy_trade_content")
  }

  initListeners() {
    super.initListeners()

    this.el.querySelector(".trade_btn").addEventListener("click", this.onTradeBtnClick.bind(this), true)
    this.el.querySelector(".trade_inventory").addEventListener("click", this.onTradeInventoryClick.bind(this), true)
    this.el.querySelector(".trade_type_tab_container").addEventListener("click", this.onTradeTypeTabClick.bind(this), true)
  }

  onTradeTypeTabClick(e) {
    let tradeType = e.target.dataset.tradeType
    if (!tradeType) return

    let selectedTab = this.el.querySelector(".trade_type_tab.selected")
    if (selectedTab) {
      selectedTab.classList.remove("selected")
    }

    e.target.classList.add("selected")

    if (this.activeTabContent) {
      this.activeTabContent.style.display = 'none'
    }

    let tradeContent = this.el.querySelector(".trade_inventory .tab-pane[data-trade-type='" + tradeType + "'")
    this.activeTabContent = tradeContent
    this.activeTabContent.style.display = 'block'

    this.el.querySelector(".trade_btn").dataset.tradeType = tradeType
    this.el.querySelector(".trade_btn").innerText = i18n.t(Helper.capitalize(tradeType))

    this.isSelling = tradeType === 'sell'
  }

  initSellables() {
    let items = [Mobs.NuuSlave, Mobs.PixiSlave, Mobs.GaramSlave]

    let rows = items.map((klass) => {
      return this.createTradeItem(klass)
    }).join("")

    this.el.querySelector(".buy_trade_content").innerHTML = rows
  }

  onTradeInventoryClick(event) {
    if (this.selectedRow) {
      this.unselectRow(this.selectedRow)
    }

    let row = event.target.closest(".trade_item_row")

    if (row) {
      this.selectRow(row)
    }
  }

  unselectRow(row) {
    this.selectedRow = null

    if (row) {
      row.dataset.selected = false
    }
  }

  selectRow(row) {
    this.selectedRow = row
    this.selectedRow.dataset.selected = true
  }

  displayError(message) {
    this.errorMessage.innerText = message

    setTimeout(() => {
      this.errorMessage.innerText = ""
    }, 3000)
  }

  onTradeBtnClick(e) {
    if (e.target.dataset.tradeType === 'buy') {
      this.onBuyBtnClick()
    } else {
      this.onSellBtnClick()
    }
  }

  onSellBtnClick() {
    if (!this.selectedRow) return
    if (this.el.querySelector(".trade_btn").dataset.disabled === "true") return

    let buyCount = 1

    let group = this.selectedRow.dataset.group
    let type = this.selectedRow.dataset.type
    let index = this.selectedRow.dataset.index
    let id = this.selectedRow.dataset.id

    SocketUtil.emit("Trade", { group: group, type: type, count: buyCount, sell: true, index: index, id: id })
  }

  onBuyBtnClick() {
    if (!this.selectedRow) return
    if (this.el.querySelector(".trade_btn").dataset.disabled === "true") return

    let buyCount = 1

    let cost = parseInt(this.selectedRow.querySelector(".trade_item_cost").innerText)
    let totalCost = cost * buyCount

    if (player.gold < totalCost) {
      this.displayError("Not enough gold")
      return
    }

    let group = this.selectedRow.dataset.group
    let type = this.selectedRow.dataset.type
    let index = this.selectedRow.dataset.index

    SocketUtil.emit("Trade", { group: group, type: type, count: buyCount, index: index, recipientId: this.seller.id })
  }

  onMenuInteract(cmd) {
    switch(cmd) {
      case "GoUp":
        this.onGoUp()
        break
      case "GoDown":
        this.onGoDown()
        break
      case "EnterUp":
        this.onEnterUp()
        break
    } 
  }

  onEnterUp() {
    if (this.isSelling) {
      this.onSellBtnClick()
    } else {
      this.onBuyBtnClick()
    }
  }

  updateGoldCount(gold) {
    this.el.querySelector(".player_gold_count_value").innerText = gold || 0
  }

  onCraftSuccess(data) {
    let rect = this.el.querySelector(".trade_btn").getBoundingClientRect()
    data.y = rect.top - 20
    data.x = rect.left - 50

    this.game.animateCraftSuccess(data)
  }

  onCraftCountKeyup(e) {
    if (e.target.value.length === 0) return

    let number = parseInt(e.target.value)
    if (isNaN(number) || number < 1 || number > 99) {
      e.target.value = this.oldBuyCount
    } 

    if (e.key === "Enter") {
      this.onCraftBtnHold()
    }

    if (e.keyCode === 27) {
      this.game.inputController.handleEsc()
    }
  }


  onGoUp() {
    this.onGoDirection(-1)
  }

  onGoDown() {
    this.onGoDirection(1)
  }

  onGoDirection(direction) {
    let rows = Array.from(this.el.querySelectorAll(".trade_item_row"))
    let rowIndex = Array.prototype.indexOf.call(rows, this.selectedRow)
    this.unselectRow(this.selectedRow)

    if (direction > 0) {
      // going down
      let isLastRow = rowIndex === rows.length - 1
      if (isLastRow) {
        this.selectRow(rows[0])
      } else {
        this.selectRow(rows[rowIndex + 1])
      }
    } else {
      let isFirstRow = rowIndex === 0
      if (isFirstRow) {
        this.selectRow(rows[rows.length - 1])
      } else {
        this.selectRow(rows[rowIndex - 1])
      }
    }
  }

  open(seller) {
    super.open()

    this.seller = seller
    this.renderPlayerSellables()
  }

  onResidentsChanged() {
    this.renderPlayerSellables()
  }

  createMobTradeItem(mobData, isSelling) {
    let klass = Mobs.forType(mobData.type)
    let imagePath = "/assets/images/" + klass.prototype.getSpritePath()

    const el = "<div class='trade_item_row' data-id='" + mobData.id + "' data-group='" + klass.getSellGroup() + "' data-type='" + klass.getType() + "' data-count='1' >" +
                    "<img class='trade_item_image' src='" + imagePath + "'>" +
                    "<div class='trade_item_name'>" + mobData.name + "</div>" +
                    "<div class='trade_item_count'></div>" +
                    "<div class='trade_item_cost'>" + Math.ceil(klass.getCost() / 2)  + " G</div>" +
                "</div>"

    return el
  }

  renderPlayerSellables() {
    if (!this.game.player) return


    let isSelling = true
    let rows = ""
    for (let id in this.game.residents) {
      let mobData = this.game.residents[id]
      rows += this.createMobTradeItem(mobData, isSelling)
    }

    this.el.querySelector(".sell_trade_content").innerHTML = rows

    if (this.selectedRow) {
      let prevIndex = this.selectedRow.dataset.index
      if (isNaN(prevIndex)) return
        
      const newSelectedRow = this.el.querySelector(".trade_item_row[data-index='" + prevIndex + "']")
      if (newSelectedRow) {
        this.selectRow(newSelectedRow)
      } else {
        this.selectedRow = null
      }
    }
  }

  shouldExcludeFromSelling(itemKlass) {
    return itemKlass.getTypeName() === "Gold"
  }

  cleanup() {
    Array.from(this.el.querySelectorAll(".inventory_slot")).forEach((inventorySlot) => {
      this.game.resetInventorySlot(inventorySlot)
    })
  }

}



module.exports = SlaveTradeMenu

},{"./../../../common/helper":664,"./../entities/buildings/index":250,"./../entities/equipments/index":407,"./../entities/item":443,"./../entities/mobs/index":464,"./../entities/ores/index":494,"./../util/socket_util":654,"./base_menu":581}],630:[function(require,module,exports){
const SocketUtil = require("./../util/socket_util")
const BaseMenu = require("./base_menu")
const Mobs = require("./../entities/mobs/index")
const Ores = require("./../entities/ores/index")
const Item = require("./../entities/item")
const Buildings = require("./../entities/buildings/index")
const Equipments = require("./../entities/equipments/index")
const Helper = require("./../../../common/helper")

/*
    while element references only inventory, it actually changes hotbar/quick_inventory as well
*/
class SoilMenu extends BaseMenu {
  onMenuConstructed() {
    this.el.querySelector(".crop_selection_container").addEventListener("click", this.onCropSelectionClick.bind(this) , true)
  }

  onCropSelectionClick(e) {
    let el = e.target.closest(".crop_selection")
    if (!el) return

    this.changeCropSelection(el.dataset.type)
  }

  selectCrop(el) {
    let selectedItem = this.el.querySelector(".crop_selection.selected")
    if (selectedItem) {
      selectedItem.classList.remove("selected")
    }

    el.classList.add("selected")
  }

  changeCropSelection(type) {
    SocketUtil.emit("EditBuilding", { id: this.entity.id, content: type })
  }

  open(options = {}) {
    super.open()

    this.entity = options.entity
    this.render()
  }

  render() {
    if (!this.entity) return
    this.renderSeedSelection()
    this.renderSelected()
  }

  renderSeedSelection() {
    let el = ""
    for (let name in Buildings.Crops) {
      let cropKlass = Buildings.Crops[name]
      el += this.createCropSelection(cropKlass)
    }

    this.el.querySelector(".crop_selection_container").innerHTML = el
  }

  renderSelected() {
    let type = this.entity.content
    if (!type) return

    let cropSelection = this.el.querySelector(".crop_selection[data-type='" + type + "']") 
    if (cropSelection) {
      this.el.querySelector(".crop_selection_name").innerText = cropSelection.dataset.name
      this.selectCrop(cropSelection)
    }
  }

  createCropSelection(klass) {
    let yieldName = klass.prototype.getConstants().yield
    let yieldKlass = Item.getKlassByName(yieldName)
    let imagePath = "/assets/images/" + yieldKlass.prototype.getSpritePath()

    const el = "<div class='crop_selection' data-type='" + klass.getType() + "' data-name='" + i18n.t(yieldKlass.getTypeName()) + "' >" +
                    "<img class='crop_image' src='" + imagePath + "'>" +
                "</div>"

    return el
  }

}

module.exports = SoilMenu
},{"./../../../common/helper":664,"./../entities/buildings/index":250,"./../entities/equipments/index":407,"./../entities/item":443,"./../entities/mobs/index":464,"./../entities/ores/index":494,"./../util/socket_util":654,"./base_menu":581}],631:[function(require,module,exports){
const Constants = require("./../../../common/constants.json")
const BaseMenu = require("./base_menu")

class StatusListMenu extends BaseMenu {

  onMenuConstructed() {
    this.statuses = {}
  }

  isAlwaysOpen() {
    return true
  }

  isModal() {
    return false
  }


  addStatus(effect) {
    if (this.statuses[effect]) return

    this.statuses[effect] = true

    let effectId = effect + "_effect"
    let imgPath = effectId + ".png"

    let entry = "<div class='status_list_entry' id='" + effectId + "'>" +
      "<img src='/assets/images/" + imgPath + "' />" +
    "</div>"

    this.el.innerHTML += entry
  }

  removeStatus(effect) {
    delete this.statuses[effect]

    let effectId = effect + "_effect"
    let entry = this.el.querySelector("#" + effectId)
    if (entry && entry.parentElement) {
      entry.parentElement.removeChild(entry)
    }
  }

  cleanup() {
    this.el.innerHTML = ""
  }

}

module.exports = StatusListMenu

},{"./../../../common/constants.json":656,"./base_menu":581}],632:[function(require,module,exports){
const SocketUtil = require("./../util/socket_util")
const BaseMenu = require("./base_menu")
const Constants = require("./../../../common/constants.json")

class StorageMenu extends BaseMenu {
  onMenuConstructed() {
  }

  initListeners() {
    super.initListeners()
  }

  initInventorySlotListeners() {
    let elements = this.el.querySelectorAll("#storage_inventory .inventory_slot")
    for (let i = 0; i < elements.length; i++) {
      let el = elements[i]
      this.initInventorySlotListener(el)
    }
  }

  onInventoryChanged(data) {
    this.renderPlayerInventory(data)
  }

  hasPlayerInventory() {
    return true
  }

  onInventoryMouseUp(e) {
    if (this.game.holdItemInventorySlot) return
    
    let isPlayerInventorySlot = parseInt(e.target.closest(".storage").dataset.storageId) === Constants.inventoryStorageId
    if (isPlayerInventorySlot) {
      this.storeInventorySlot(e)
    } else {
      this.retrieveInventorySlot(e)
    }
  }

  isStorageMenu() {
    return true
  }

  // response open
  finishOpen() {
    super.open()
    this.cleanup()

    this.el.querySelector(".storage").dataset.storageId = this.entity.id

    if (this.label) {
      this.el.querySelector(".menu_main_header").innerText = this.label
    }

    let menuDescription = this.entity.getMenuDescription()
    if (menuDescription) {
      this.el.querySelector(".menu_description").innerText = i18n.t(menuDescription)
    } else {
      this.el.querySelector(".menu_description").innerText = ""
    }

    this.initStorage()
    this.initInventorySlotListeners()

    this.initPlayerInventoryStorage()
    this.initPlayerInventorySlotListeners()
  }

  shouldHideQuickInventory() {
    return true
  }

  // request open
  open(label, entity) {
    this.entity = entity
    this.storageId = entity.id
    this.label = i18n.t(label)

    SocketUtil.emit("ViewStorage", { id: this.entity.id })
  }

  close() {
    this.label = null
    
    if (!this.game.hideMainMenus) {
      this.showQuickInventory()
    }
    
    super.close()
  }

  cleanup() {
    this.el.querySelector(".storage").dataset.storageId = ""

    // we want to create slots as it should be limited to amount of slots for target entity
    this.el.querySelector(".storage").innerHTML = ""
  }

  initStorage() {
    this.el.querySelector("#storage_inventory").innerHTML = this.createInventorySlots(this.entity.getStorageCount())
  }

}



module.exports = StorageMenu

},{"./../../../common/constants.json":656,"./../util/socket_util":654,"./base_menu":581}],633:[function(require,module,exports){
const SocketUtil = require("./../util/socket_util")
const BaseMenu = require("./base_menu")
const Item = require("./../entities/item")
const Foods = require("./../entities/foods/index")
const Equipments = require("./../entities/equipments/index")
const Helper = require("./../../../common/helper")

/*
    while element references only inventory, it actually changes hotbar/quick_inventory as well
*/
class StoveMenu extends BaseMenu {
  onMenuConstructed() {
    this.el.querySelector(".food_selection_container").addEventListener("click", this.onFoodSelectionClick.bind(this) , true)

    this.progressBar = this.el.querySelector(".stove_progress_bar_fill")

    this.el.querySelector(".cook_btn").addEventListener("click", this.onCookBtnClick.bind(this) , true)
  }

  onCookBtnClick(e) {
    if (this.disabled) return
    SocketUtil.emit("InteractTarget", { id: this.entity.id })
  }

  onUsageChanged(usage) {
    let progressWidth = (usage / 100) * this.getProgressMaxWidth()
    this.progressBar.style.width = progressWidth + "px"
  }

  getProgressMaxWidth() {
    return 150
  }

  onFoodSelectionClick(e) {
    let el = e.target.closest(".food_selection")
    if (!el) return

    this.changeFoodSelection(el.dataset.type)
  }

  selectFood(el) {
    let selectedItem = this.el.querySelector(".food_selection.selected")
    if (selectedItem) {
      selectedItem.classList.remove("selected")
    }

    el.classList.add("selected")
  }

  changeFoodSelection(type) {
    SocketUtil.emit("EditBuilding", { id: this.entity.id, content: type })
  }

  open(options = {}) {
    super.open()

    this.disabled = options.disabled
    this.entity = options.entity
    this.render()
  }

  render() {
    if (!this.entity) return

    if (this.disabled) {
      this.el.querySelector(".stove_status_message").innerText = this.disabled
      this.el.querySelector(".stove_progress_bar").style.display = 'none'
    } else {
      this.el.querySelector(".stove_status_message").innerText = ""
      this.el.querySelector(".stove_progress_bar").style.display = 'inline-block'
    }

    this.renderFoodSelection()
    this.renderSelected()
  }

  renderFoodSelection() {
    let el = ""
    for (let name in Foods.Cooked) {
      let foodKlass = Foods.Cooked[name]
      if (foodKlass.prototype.hasRequirements()) {
        el += this.createFoodSelection(foodKlass)
      }
    }

    this.el.querySelector(".food_selection_container").innerHTML = el
  }

  renderSelected() {
    if (!this.entity) return
      
    let type = this.entity.content
    if (!type) return

    let foodSelection = this.el.querySelector(".food_selection[data-type='" + type + "']") 
    if (foodSelection) {
      this.el.querySelector(".food_selection_name").innerText = foodSelection.dataset.name
      this.selectFood(foodSelection)

      this.clearRequirements()

      const requirements = Item.getCraftRequirements(type, this.game.player)
      requirements.forEach((requirement) => {
        let row = this.createRequirementRow(requirement)
        this.el.querySelector(".crafting_requirements").innerHTML += row
      })

      if (this.disabled || (this.hasMissingRequirements(requirements))) {
        this.el.querySelector(".cook_btn").dataset.disabled = true
      } else {
        this.el.querySelector(".cook_btn").dataset.disabled = ""
      }

    }
  }

  createFoodSelection(klass) {
    let imagePath = "/assets/images/" + klass.prototype.getSpritePath()

    const el = "<div class='food_selection' data-type='" + klass.getType() + "' data-name='" + i18n.t(klass.getTypeName()) + "' >" +
                    "<img class='food_image' src='" + imagePath + "'>" +
                "</div>"

    return el
  }

}

module.exports = StoveMenu
},{"./../../../common/helper":664,"./../entities/equipments/index":407,"./../entities/foods/index":422,"./../entities/item":443,"./../util/socket_util":654,"./base_menu":581}],634:[function(require,module,exports){
const ColorPickerMenu = require("./color_picker_menu")

class SuitColorMenu extends ColorPickerMenu {
  getEntityTypeName() {
    return "Suit"
  }
}

module.exports = SuitColorMenu 

},{"./color_picker_menu":585}],635:[function(require,module,exports){
const SocketUtil = require("./../util/socket_util")
const BaseMenu = require("./base_menu")
const Constants = require("./../../../common/constants.json")

class TeamFullMenu extends BaseMenu {
  onMenuConstructed() {
  }

  initListeners() {
    super.initListeners()

    this.el.querySelector(".create_new_team_btn").addEventListener("click", this.onCreateNewTeamBtnClick.bind(this))
  }

  open(options = {}) {
    super.open(options)

    let teamData = options.team
    let memberNames = Object.values(teamData.members).map((member) => { return member.name })
    memberNames = ["sneaky", "xbeep"]

    this.el.querySelector(".team_full_description").innerText = "Team " + teamData.name + " is currently FULL with 5 members online" 
    this.el.querySelector(".team_full_member_names").innerText = memberNames.join(", ")
  }

  isControllingPlayerRequired() {
    return false
  }

  onCreateNewTeamBtnClick() {
    this.game.main.pvpExplorer.lastSectorEntry.join({ isNewTeam: true })
  }

}



module.exports = TeamFullMenu 
},{"./../../../common/constants.json":656,"./../util/socket_util":654,"./base_menu":581}],636:[function(require,module,exports){
const SocketUtil = require("./../util/socket_util")
const BaseMenu = require("./base_menu")
const Constants = require("./../../../common/constants.json")
const Protocol = require("./../../../common/util/protocol")
const Helper = require("./../../../common/helper")
const ClientHelper = require("./../util/client_helper")


/*
    while element references only inventory, it actually changes hotbar/quick_inventory as well
*/
class TeamMenu extends BaseMenu {
  onMenuConstructed() {
  }

  initListeners() {
    super.initListeners()

    this.el.querySelector("#leave_team_btn").addEventListener("click", this.onLeaveTeamBtnClick.bind(this), true)
    this.el.querySelector(".invite_link_input").addEventListener("click", this.onTeamInviteInputClick.bind(this), true)
    this.el.querySelector(".team_private_status").addEventListener("click", this.onTeamPrivacyStatusClick.bind(this), true)
    this.el.querySelector(".member_management_container").addEventListener("click", this.onMemberListClick.bind(this))

    this.el.querySelector(".rename_btn").addEventListener("click", this.onRenameBtnClick.bind(this))
    this.el.querySelector(".colony_name_input").addEventListener("blur", this.onColonyNameInputBlur.bind(this))
    this.el.querySelector(".colony_name_input").addEventListener("keyup", this.onColonyNameInputKeyup.bind(this))

    this.el.querySelector(".team_list_container").addEventListener("click", this.onTeamContainerClick.bind(this))
    this.el.querySelector(".role_list").addEventListener("click", this.onRoleListClick.bind(this))
    this.el.querySelector(".role_permissions").addEventListener("click", this.onRolePermissionsClick.bind(this), true)

    this.el.querySelector(".add_screenshot_btn").addEventListener("click", this.onAddScreenshotClick.bind(this))
    this.el.querySelector(".new_role_btn").addEventListener("click", this.onNewRoleBtnClick.bind(this))
    this.el.querySelector(".delete_role_btn").addEventListener("click", this.onDeleteRoleBtnClick.bind(this))
    this.el.querySelector(".role_name_input").addEventListener("change", this.onRoleNameInputChanged.bind(this))
    this.el.querySelector(".role_name_input").addEventListener("keydown", this.onRoleNameInputKeydown.bind(this))
    this.el.querySelector(".role_name_input").addEventListener("keyup", this.onRoleNameInputKeyup.bind(this))

    this.el.querySelector(".colony_info_tab_container").addEventListener("click", this.onColonyTabClick.bind(this))
    this.el.querySelector(".colony_screenshots_gallery").addEventListener("click", this.onScreenshotGalleryClick.bind(this))

    this.el.querySelector("#enable_pvp").addEventListener("click", this.onEnablePvPClick.bind(this), true)
    this.el.querySelector("#disable_pvp").addEventListener("click", this.onDisablePvPClick.bind(this), true)

    this.el.querySelector("#enable_zoom").addEventListener("click", this.onEnableZoomClick.bind(this), true)
    this.el.querySelector("#disable_zoom").addEventListener("click", this.onDisableZoomClick.bind(this), true)

    this.el.querySelector("#enable_fov").addEventListener("click", this.onEnableFovClick.bind(this), true)
    this.el.querySelector("#disable_fov").addEventListener("click", this.onDisableFovClick.bind(this), true)

    this.el.querySelector("#enable_minimap").addEventListener("click", this.onEnableMinimapClick.bind(this), true)
    this.el.querySelector("#disable_minimap").addEventListener("click", this.onDisableMinimapClick.bind(this), true)

    this.el.querySelector("#enable_team_join").addEventListener("click", this.onEnableTeamJoinClick.bind(this), true)
    this.el.querySelector("#disable_team_join").addEventListener("click", this.onDisableTeamJoinClick.bind(this), true)

    this.el.querySelector("#enable_playerlist").addEventListener("click", this.onEnablePlayerlistClick.bind(this), true)
    this.el.querySelector("#disable_playerlist").addEventListener("click", this.onDisablePlayerlistClick.bind(this), true)

    this.el.querySelector("#enable_mob_autospawn").addEventListener("click", this.onEnableMobAutospawnClick.bind(this), true)
    this.el.querySelector("#disable_mob_autospawn").addEventListener("click", this.onDisableMobAutospawnClick.bind(this), true)

    this.el.querySelector("#enable_floor_autodirt").addEventListener("click", this.onEnableFloorAutodirtClick.bind(this), true)
    this.el.querySelector("#disable_floor_autodirt").addEventListener("click", this.onDisableFloorAutodirtClick.bind(this), true)

    this.el.querySelector("#enable_stamina").addEventListener("click", this.onEnableStaminaClick.bind(this), true)
    this.el.querySelector("#disable_stamina").addEventListener("click", this.onDisableStaminaClick.bind(this), true)

    this.el.querySelector("#enable_hunger").addEventListener("click", this.onEnableHungerClick.bind(this), true)
    this.el.querySelector("#disable_hunger").addEventListener("click", this.onDisableHungerClick.bind(this), true)

    this.el.querySelector("#enable_oxygen").addEventListener("click", this.onEnableOxygenClick.bind(this), true)
    this.el.querySelector("#disable_oxygen").addEventListener("click", this.onDisableOxygenClick.bind(this), true)

    this.el.querySelector("#enable_chat").addEventListener("click", this.onEnableChatClick.bind(this), true)
    this.el.querySelector("#disable_chat").addEventListener("click", this.onDisableChatClick.bind(this), true)

    this.el.querySelector("#enable_infinite_ammo").addEventListener("click", this.onEnableInfiniteAmmoClick.bind(this), true)
    this.el.querySelector("#disable_infinite_ammo").addEventListener("click", this.onDisableInfiniteAmmoClick.bind(this), true)

    this.el.querySelector("#enable_infinite_power").addEventListener("click", this.onEnableInfinitePowerClick.bind(this), true)
    this.el.querySelector("#disable_infinite_power").addEventListener("click", this.onDisableInfinitePowerClick.bind(this), true)

    this.el.querySelector("#enable_shadows").addEventListener("click", this.onEnableShadowsClick.bind(this), true)
    this.el.querySelector("#disable_shadows").addEventListener("click", this.onDisableShadowsClick.bind(this), true)

    this.el.querySelector("#enable_player_saving").addEventListener("click", this.onEnablePlayerSavingClick.bind(this), true)
    this.el.querySelector("#disable_player_saving").addEventListener("click", this.onDisablePlayerSavingClick.bind(this), true)

    this.el.querySelector("#enable_crafting").addEventListener("click", this.onEnableCraftingClick.bind(this), true)
    this.el.querySelector("#disable_crafting").addEventListener("click", this.onDisableCraftingClick.bind(this), true)

    this.el.querySelector("#enable_blood").addEventListener("click", this.onEnableBloodClick.bind(this), true)
    this.el.querySelector("#disable_blood").addEventListener("click", this.onDisableBloodClick.bind(this), true)

    this.el.querySelector("#enable_suit_change").addEventListener("click", this.onEnableSuitChangeClick.bind(this), true)
    this.el.querySelector("#disable_suit_change").addEventListener("click", this.onDisableSuitChangeClick.bind(this), true)

    this.el.querySelector("#enable_drop_inventory_on_death").addEventListener("click", this.onEnableDropInventoryOnDeathClick.bind(this), true)
    this.el.querySelector("#disable_drop_inventory_on_death").addEventListener("click", this.onDisableDropInventoryOnDeathClick.bind(this), true)

    this.el.querySelector("#enable_corpse").addEventListener("click", this.onEnableCorpse.bind(this), true)
    this.el.querySelector("#disable_corpse").addEventListener("click", this.onDisableCorpse.bind(this), true)

    this.el.querySelector("#enable_mutant").addEventListener("click", this.onEnableMutant.bind(this), true)
    this.el.querySelector("#disable_mutant").addEventListener("click", this.onDisableMutant.bind(this), true)

    this.el.querySelector("#enable_gravity").addEventListener("click", this.onEnableGravity.bind(this), true)
    this.el.querySelector("#disable_gravity").addEventListener("click", this.onDisableGravity.bind(this), true)

    this.el.querySelector(".colony_logs_refresh_btn").addEventListener("click", this.onLogsRefreshClick.bind(this), true)
    this.el.querySelector(".command_logs_refresh_btn").addEventListener("click", this.onCommandLogsRefreshClick.bind(this), true)
  }

  updateColonySettings(settings) {
    for (let name in settings) {
      if (name === 'isPvPAllowed') {
        let value = settings[name]
        if (value) {
          this.el.querySelector("#enable_pvp").checked = true
        } else {
          this.el.querySelector("#disable_pvp").checked = true
        }
      }

      if (name === 'isZoomAllowed') {
        let value = settings[name]
        if (value) {
          this.el.querySelector("#enable_zoom").checked = true
        } else {
          this.el.querySelector("#disable_zoom").checked = true
        }
      }

      if (name === 'isFovMode') {
        let value = settings[name]
        if (value) {
          this.el.querySelector("#enable_fov").checked = true
        } else {
          this.el.querySelector("#disable_fov").checked = true
        }
      }

      if (name === 'showMiniMap') {
        let value = settings[name]
        if (value) {
          this.el.querySelector("#enable_minimap").checked = true
        } else {
          this.el.querySelector("#disable_minimap").checked = true
        }
      }

      if (name === 'showTeamJoin') {
        let value = settings[name]
        if (value) {
          this.el.querySelector("#enable_team_join").checked = true
        } else {
          this.el.querySelector("#disable_team_join").checked = true
        }
      }

      if (name === 'showPlayerList') {
        let value = settings[name]
        if (value) {
          this.el.querySelector("#enable_playerlist").checked = true
        } else {
          this.el.querySelector("#disable_playerlist").checked = true
        }
      }

      if (name === 'isMobAutospawn') {
        let value = settings[name]
        if (value) {
          this.el.querySelector("#enable_mob_autospawn").checked = true
        } else {
          this.el.querySelector("#disable_mob_autospawn").checked = true
        }
      }

      if (name === 'isFloorAutodirt') {
        let value = settings[name]
        if (value) {
          this.el.querySelector("#enable_floor_autodirt").checked = true
        } else {
          this.el.querySelector("#disable_floor_autodirt").checked = true
        }
      }

      if (name === 'isStaminaEnabled') {
        let value = settings[name]
        if (value) {
          this.el.querySelector("#enable_stamina").checked = true
        } else {
          this.el.querySelector("#disable_stamina").checked = true
        }
      }

      if (name === 'isHungerEnabled') {
        let value = settings[name]
        if (value) {
          this.el.querySelector("#enable_hunger").checked = true
        } else {
          this.el.querySelector("#disable_hunger").checked = true
        }
      }

      if (name === 'isOxygenEnabled') {
        let value = settings[name]
        if (value) {
          this.el.querySelector("#enable_oxygen").checked = true
        } else {
          this.el.querySelector("#disable_oxygen").checked = true
        }
      }

      if (name === 'isChatEnabled') {
        let value = settings[name]
        if (value) {
          this.el.querySelector("#enable_chat").checked = true
        } else {
          this.el.querySelector("#disable_chat").checked = true
        }
      }

      if (name === 'isInfiniteAmmo') {
        let value = settings[name]
        if (value) {
          this.el.querySelector("#enable_infinite_ammo").checked = true
        } else {
          this.el.querySelector("#disable_infinite_ammo").checked = true
        }
      }

      if (name === 'isInfinitePower') {
        let value = settings[name]
        if (value) {
          this.el.querySelector("#enable_infinite_power").checked = true
        } else {
          this.el.querySelector("#disable_infinite_power").checked = true
        }
      }

      if (name === 'isShadowsEnabled') {
        let value = settings[name]
        if (value) {
          this.el.querySelector("#enable_shadows").checked = true
        } else {
          this.el.querySelector("#disable_shadows").checked = true
        }
      }

      if (name === 'isPlayerSavingEnabled') {
        let value = settings[name]
        if (value) {
          this.el.querySelector("#enable_player_saving").checked = true
        } else {
          this.el.querySelector("#disable_player_saving").checked = true
        }
      }

      if (name === 'isCraftingEnabled') {
        let value = settings[name]
        if (value) {
          this.el.querySelector("#enable_crafting").checked = true
        } else {
          this.el.querySelector("#disable_crafting").checked = true
        }
      }

      if (name === 'isBloodEnabled') {
        let value = settings[name]
        if (value) {
          this.el.querySelector("#enable_blood").checked = true
        } else {
          this.el.querySelector("#disable_blood").checked = true
        }
      }

      if (name === 'isSuitChangeEnabled') {
        let value = settings[name]
        if (value) {
          this.el.querySelector("#enable_suit_change").checked = true
        } else {
          this.el.querySelector("#disable_suit_change").checked = true
        }
      }

      if (name === 'isDropInventoryOnDeath') {
        let value = settings[name]
        if (value) {
          this.el.querySelector("#enable_drop_inventory_on_death").checked = true
        } else {
          this.el.querySelector("#disable_drop_inventory_on_death").checked = true
        }
      }

      if (name === 'isCorpseEnabled') {
        let value = settings[name]
        if (value) {
          this.el.querySelector("#enable_corpse").checked = true
        } else {
          this.el.querySelector("#disable_corpse").checked = true
        }
      }

      if (name === 'isMutantEnabled') {
        let value = settings[name]
        if (value) {
          this.el.querySelector("#enable_mutant").checked = true
        } else {
          this.el.querySelector("#disable_mutant").checked = true
        }
      }

      if (name === 'isGravityEnabled') {
        let value = settings[name]
        if (value) {
          this.el.querySelector("#enable_gravity").checked = true
        } else {
          this.el.querySelector("#disable_gravity").checked = true
        }
      }

    }
  }

  onEnablePvPClick(e) {
    e.preventDefault()

    let value = e.target.value
    if (value === 'yes') {
      SocketUtil.emit("SectorAction", {
        action: 'editSetting',
        sectorId: this.game.sector.uid,
        key: 'isPvPAllowed',
        value: 'true'
      })
    }
  }

  onDisablePvPClick(e) {
    e.preventDefault()

    let value = e.target.value
    if (value === 'no') {
      SocketUtil.emit("SectorAction", {
        action: 'editSetting',
        sectorId: this.game.sector.uid,
        key: 'isPvPAllowed',
        value: 'false'
      })
    }
  }

  onEnableZoomClick(e) {
    e.preventDefault()

    let value = e.target.value
    if (value === 'yes') {
      SocketUtil.emit("SectorAction", {
        action: 'editSetting',
        sectorId: this.game.sector.uid,
        key: 'isZoomAllowed',
        value: 'true'
      })
    }
  }

  onDisableZoomClick(e) {
    e.preventDefault()

    let value = e.target.value
    if (value === 'no') {
      SocketUtil.emit("SectorAction", {
        action: 'editSetting',
        sectorId: this.game.sector.uid,
        key: 'isZoomAllowed',
        value: 'false'
      })
    }
  }

  onEnableFovClick(e) {
    e.preventDefault()

    let value = e.target.value
    if (value === 'yes') {
      SocketUtil.emit("SectorAction", {
        action: 'editSetting',
        sectorId: this.game.sector.uid,
        key: 'isFovMode',
        value: 'true'
      })
    }
  }

  onDisableFovClick(e) {
    e.preventDefault()

    let value = e.target.value
    if (value === 'no') {
      SocketUtil.emit("SectorAction", {
        action: 'editSetting',
        sectorId: this.game.sector.uid,
        key: 'isFovMode',
        value: 'false'
      })
    }
  }

  onEnableFloorAutodirtClick(e) {
    e.preventDefault()

    let value = e.target.value
    if (value === 'yes') {
      SocketUtil.emit("SectorAction", {
        action: 'editSetting',
        sectorId: this.game.sector.uid,
        key: 'isFloorAutodirt',
        value: 'true'
      })
    }
  }

  onDisableFloorAutodirtClick(e) {
    e.preventDefault()

    let value = e.target.value
    if (value === 'no') {
      SocketUtil.emit("SectorAction", {
        action: 'editSetting',
        sectorId: this.game.sector.uid,
        key: 'isFloorAutodirt',
        value: 'false'
      })
    }
  }

  onEnableStaminaClick(e) {
    e.preventDefault()

    let value = e.target.value
    if (value === 'yes') {
      SocketUtil.emit("SectorAction", {
        action: 'editSetting',
        sectorId: this.game.sector.uid,
        key: 'isStaminaEnabled',
        value: 'true'
      })
    }
  }

  onDisableStaminaClick(e) {
    e.preventDefault()

    let value = e.target.value
    if (value === 'no') {
      SocketUtil.emit("SectorAction", {
        action: 'editSetting',
        sectorId: this.game.sector.uid,
        key: 'isStaminaEnabled',
        value: 'false'
      })
    }
  }

  onEnableHungerClick(e) {
    e.preventDefault()

    let value = e.target.value
    if (value === 'yes') {
      SocketUtil.emit("SectorAction", {
        action: 'editSetting',
        sectorId: this.game.sector.uid,
        key: 'isHungerEnabled',
        value: 'true'
      })
    }
  }

  onDisableHungerClick(e) {
    e.preventDefault()

    let value = e.target.value
    if (value === 'no') {
      SocketUtil.emit("SectorAction", {
        action: 'editSetting',
        sectorId: this.game.sector.uid,
        key: 'isHungerEnabled',
        value: 'false'
      })
    }
  }

  onEnableOxygenClick(e) {
    e.preventDefault()

    let value = e.target.value
    if (value === 'yes') {
      SocketUtil.emit("SectorAction", {
        action: 'editSetting',
        sectorId: this.game.sector.uid,
        key: 'isOxygenEnabled',
        value: 'true'
      })
    }
  }

  onDisableOxygenClick(e) {
    e.preventDefault()

    let value = e.target.value
    if (value === 'no') {
      SocketUtil.emit("SectorAction", {
        action: 'editSetting',
        sectorId: this.game.sector.uid,
        key: 'isOxygenEnabled',
        value: 'false'
      })
    }
  }

  onEnableChatClick(e) {
    e.preventDefault()

    let value = e.target.value
    if (value === 'yes') {
      SocketUtil.emit("SectorAction", {
        action: 'editSetting',
        sectorId: this.game.sector.uid,
        key: 'isChatEnabled',
        value: 'true'
      })
    }
  }

  onDisableChatClick(e) {
    e.preventDefault()

    let value = e.target.value
    if (value === 'no') {
      SocketUtil.emit("SectorAction", {
        action: 'editSetting',
        sectorId: this.game.sector.uid,
        key: 'isChatEnabled',
        value: 'false'
      })
    }
  }

  onEnableInfiniteAmmoClick(e) {
    e.preventDefault()

    let value = e.target.value
    if (value === 'yes') {
      SocketUtil.emit("SectorAction", {
        action: 'editSetting',
        sectorId: this.game.sector.uid,
        key: 'isInfiniteAmmo',
        value: 'true'
      })
    }
  }

  onDisableInfiniteAmmoClick(e) {
    e.preventDefault()

    let value = e.target.value
    if (value === 'no') {
      SocketUtil.emit("SectorAction", {
        action: 'editSetting',
        sectorId: this.game.sector.uid,
        key: 'isInfiniteAmmo',
        value: 'false'
      })
    }
  }

  onEnableInfinitePowerClick(e) {
    e.preventDefault()

    let value = e.target.value
    if (value === 'yes') {
      SocketUtil.emit("SectorAction", {
        action: 'editSetting',
        sectorId: this.game.sector.uid,
        key: 'isInfinitePower',
        value: 'true'
      })
    }
  }

  onDisableInfinitePowerClick(e) {
    e.preventDefault()

    let value = e.target.value
    if (value === 'no') {
      SocketUtil.emit("SectorAction", {
        action: 'editSetting',
        sectorId: this.game.sector.uid,
        key: 'isInfinitePower',
        value: 'false'
      })
    }
  }

  onEnableShadowsClick(e) {
    e.preventDefault()

    let value = e.target.value
    if (value === 'yes') {
      SocketUtil.emit("SectorAction", {
        action: 'editSetting',
        sectorId: this.game.sector.uid,
        key: 'isShadowsEnabled',
        value: 'true'
      })
    }
  }

  onDisableShadowsClick(e) {
    e.preventDefault()

    let value = e.target.value
    if (value === 'no') {
      SocketUtil.emit("SectorAction", {
        action: 'editSetting',
        sectorId: this.game.sector.uid,
        key: 'isShadowsEnabled',
        value: 'false'
      })
    }
  }

  onEnablePlayerSavingClick(e) {
    e.preventDefault()

    let value = e.target.value
    if (value === 'yes') {
      SocketUtil.emit("SectorAction", {
        action: 'editSetting',
        sectorId: this.game.sector.uid,
        key: 'isPlayerSavingEnabled',
        value: 'true'
      })
    }
  }

  onDisablePlayerSavingClick(e) {
    e.preventDefault()

    let value = e.target.value
    if (value === 'no') {
      SocketUtil.emit("SectorAction", {
        action: 'editSetting',
        sectorId: this.game.sector.uid,
        key: 'isPlayerSavingEnabled',
        value: 'false'
      })
    }
  }

  onEnableCraftingClick(e) {
    e.preventDefault()

    let value = e.target.value
    if (value === 'yes') {
      SocketUtil.emit("SectorAction", {
        action: 'editSetting',
        sectorId: this.game.sector.uid,
        key: 'isCraftingEnabled',
        value: 'true'
      })
    }
  }

  onDisableCraftingClick(e) {
    e.preventDefault()

    let value = e.target.value
    if (value === 'no') {
      SocketUtil.emit("SectorAction", {
        action: 'editSetting',
        sectorId: this.game.sector.uid,
        key: 'isCraftingEnabled',
        value: 'false'
      })
    }
  }

  onEnableBloodClick(e) {
    e.preventDefault()

    let value = e.target.value
    if (value === 'yes') {
      SocketUtil.emit("SectorAction", {
        action: 'editSetting',
        sectorId: this.game.sector.uid,
        key: 'isBloodEnabled',
        value: 'true'
      })
    }
  }

  onDisableBloodClick(e) {
    e.preventDefault()

    let value = e.target.value
    if (value === 'no') {
      SocketUtil.emit("SectorAction", {
        action: 'editSetting',
        sectorId: this.game.sector.uid,
        key: 'isBloodEnabled',
        value: 'false'
      })
    }
  }

  onEnableSuitChangeClick(e) {
    e.preventDefault()

    let value = e.target.value
    if (value === 'yes') {
      SocketUtil.emit("SectorAction", {
        action: 'editSetting',
        sectorId: this.game.sector.uid,
        key: 'isSuitChangeEnabled',
        value: 'true'
      })
    }
  }

  onDisableSuitChangeClick(e) {
    e.preventDefault()

    let value = e.target.value
    if (value === 'no') {
      SocketUtil.emit("SectorAction", {
        action: 'editSetting',
        sectorId: this.game.sector.uid,
        key: 'isSuitChangeEnabled',
        value: 'false'
      })
    }
  }

  onEnableDropInventoryOnDeathClick(e) {
    e.preventDefault()

    let value = e.target.value
    if (value === 'yes') {
      SocketUtil.emit("SectorAction", {
        action: 'editSetting',
        sectorId: this.game.sector.uid,
        key: 'isDropInventoryOnDeath',
        value: 'true'
      })
    }
  }

  onDisableDropInventoryOnDeathClick(e) {
    e.preventDefault()

    let value = e.target.value
    if (value === 'no') {
      SocketUtil.emit("SectorAction", {
        action: 'editSetting',
        sectorId: this.game.sector.uid,
        key: 'isDropInventoryOnDeath',
        value: 'false'
      })
    }
  }

  onEnableCorpse(e) {
    e.preventDefault()

    let value = e.target.value
    if (value === 'yes') {
      SocketUtil.emit("SectorAction", {
        action: 'editSetting',
        sectorId: this.game.sector.uid,
        key: 'isCorpseEnabled',
        value: 'true'
      })
    }
  }

  onDisableCorpse(e) {
    e.preventDefault()

    let value = e.target.value
    if (value === 'no') {
      SocketUtil.emit("SectorAction", {
        action: 'editSetting',
        sectorId: this.game.sector.uid,
        key: 'isCorpseEnabled',
        value: 'false'
      })
    }
  }

  onEnableMutant(e) {
    e.preventDefault()

    let value = e.target.value
    if (value === 'yes') {
      SocketUtil.emit("SectorAction", {
        action: 'editSetting',
        sectorId: this.game.sector.uid,
        key: 'isMutantEnabled',
        value: 'true'
      })
    }
  }

  onDisableMutant(e) {
    e.preventDefault()

    let value = e.target.value
    if (value === 'no') {
      SocketUtil.emit("SectorAction", {
        action: 'editSetting',
        sectorId: this.game.sector.uid,
        key: 'isMutantEnabled',
        value: 'false'
      })
    }
  }

  onEnableGravity(e) {
    e.preventDefault()

    let value = e.target.value
    if (value === 'yes') {
      SocketUtil.emit("SectorAction", {
        action: 'editSetting',
        sectorId: this.game.sector.uid,
        key: 'isGravityEnabled',
        value: 'true'
      })
    }
  }

  onDisableGravity(e) {
    e.preventDefault()

    let value = e.target.value
    if (value === 'no') {
      SocketUtil.emit("SectorAction", {
        action: 'editSetting',
        sectorId: this.game.sector.uid,
        key: 'isGravityEnabled',
        value: 'false'
      })
    }
  }

  onEnableMinimapClick(e) {
    e.preventDefault()

    let value = e.target.value
    if (value === 'yes') {
      SocketUtil.emit("SectorAction", {
        action: 'editSetting',
        sectorId: this.game.sector.uid,
        key: 'showMiniMap',
        value: 'true'
      })
    }
  }

  onDisableMinimapClick(e) {
    e.preventDefault()

    let value = e.target.value
    if (value === 'no') {
      SocketUtil.emit("SectorAction", {
        action: 'editSetting',
        sectorId: this.game.sector.uid,
        key: 'showMiniMap',
        value: 'false'
      })
    }
  }

  onEnableTeamJoinClick(e) {
    e.preventDefault()

    let value = e.target.value
    if (value === 'yes') {
      SocketUtil.emit("SectorAction", {
        action: 'editSetting',
        sectorId: this.game.sector.uid,
        key: 'showTeamJoin',
        value: 'true'
      })
    }
  }

  onDisableTeamJoinClick(e) {
    e.preventDefault()

    let value = e.target.value
    if (value === 'no') {
      SocketUtil.emit("SectorAction", {
        action: 'editSetting',
        sectorId: this.game.sector.uid,
        key: 'showTeamJoin',
        value: 'false'
      })
    }
  }

  showTeamJoinTab() {
    document.querySelector(".colony_teams_tab").style.display = 'inline-block'
  }

  hideTeamJoinTab() {
    document.querySelector(".colony_teams_tab").style.display = 'none'
  }

  onEnablePlayerlistClick(e) {
    e.preventDefault()

    let value = e.target.value
    if (value === 'yes') {
      SocketUtil.emit("SectorAction", {
        action: 'editSetting',
        sectorId: this.game.sector.uid,
        key: 'showPlayerList',
        value: 'true'
      })
    }
  }

  onDisablePlayerlistClick(e) {
    e.preventDefault()

    let value = e.target.value
    if (value === 'no') {
      SocketUtil.emit("SectorAction", {
        action: 'editSetting',
        sectorId: this.game.sector.uid,
        key: 'showPlayerList',
        value: 'false'
      })
    }
  }

  onEnableMobAutospawnClick(e) {
    e.preventDefault()

    let value = e.target.value
    if (value === 'yes') {
      SocketUtil.emit("SectorAction", {
        action: 'editSetting',
        sectorId: this.game.sector.uid,
        key: 'isMobAutospawn',
        value: 'true'
      })
    }
  }

  onDisableMobAutospawnClick(e) {
    e.preventDefault()

    let value = e.target.value
    if (value === 'no') {
      SocketUtil.emit("SectorAction", {
        action: 'editSetting',
        sectorId: this.game.sector.uid,
        key: 'isMobAutospawn',
        value: 'false'
      })
    }
  }

  onScreenshotGalleryClick(e) {
    let removeScreenshotBtn = e.target.closest(".remove_screenshot_btn")
    if (removeScreenshotBtn) {
      let screenshotKey = e.target.closest(".screenshot_entry").dataset.key
      SocketUtil.emit("RemoveScreenshot", { id: screenshotKey })
    }
  }

  onAddScreenshotClick() {
    this.game.screenshot()
  }

  onNewRoleBtnClick() {
    SocketUtil.emit("EditRole", {
      teamId: this.game.player.teamId
    })
  }

  onDeleteRoleBtnClick() {
    SocketUtil.emit("EditRole", {
      teamId: this.game.player.teamId,
      roleId: this.activeRoleId,
      shouldDelete: true
    })
  }

  onRoleNameInputKeydown(e) {
    clearTimeout(this.roleNameKeyupTimeout)
  }

  onRoleNameInputKeyup(e) {
    let newName = this.el.querySelector(".role_name_input").value

    clearTimeout(this.roleNameKeyupTimeout)

    this.roleNameKeyupTimeout = setTimeout(() => {
      SocketUtil.emit("EditRole", {
        teamId: this.game.player.teamId,
        roleId: this.activeRoleId,
        name: newName
      })
    }, 2000)
  }

  onRoleNameInputChanged(e) {
    let newName = this.el.querySelector(".role_name_input").value

    SocketUtil.emit("EditRole", {
      teamId: this.game.player.teamId,
      roleId: this.activeRoleId,
      name: newName
    })
  }

  updateRole(role) {
    let roleEl = this.el.querySelector(".role[data-id='" + role.id + "']")
    if (roleEl) {
      roleEl.innerText = role.name
    }

    if (this.activeRoleId === role.id) {
      this.renderRolePermissions(role.id)
    }
  }

  renderScreenshots(sector) {
    this.el.querySelector(".colony_screenshots_gallery").innerHTML = ""

    for (let key in sector.screenshots) {
      let el = "<div class='screenshot_entry' data-key='" + key + "'>" +
                  "<img src='" + this.game.main.getScreenshotThumbnailPath(key) + "' />" +
                  "<div class='remove_screenshot_btn'></div>" +
               "</div>"

      this.el.querySelector(".colony_screenshots_gallery").innerHTML += el
    }
  }

  onColonyTabClick(e) {
    let selectedTab = this.el.querySelector(".colony_tab.selected")
    if (selectedTab) {
      selectedTab.classList.remove('selected')
    }

    if (e.target.classList.contains("colony_tab")) {
      let newTab = e.target
      newTab.classList.add('selected')
    }

    let filter = e.target.dataset.tab
    let content = this.el.querySelector(".colony_tab_content[data-tab='" + filter + "']")
    if (content) {
      let activeContent = this.el.querySelector(".colony_tab_content.active")
      if (activeContent) {
        activeContent.classList.remove("active")
      }

      content.classList.add("active")
      this.onColonyTabContentShown(filter)
    }
  }

  onColonyTabContentShown(filter) {
    if (filter === 'logs' || filter === 'commands') {
      SocketUtil.emit("SectorAction", { action: 'viewLogs' })
    }
  }

  onLogsRefreshClick() {
    SocketUtil.emit("SectorAction", { action: 'viewLogs' })
  }

  onCommandLogsRefreshClick() {
    SocketUtil.emit("SectorAction", { action: 'viewLogs' })
  }

  updateActivityLogs(activityLogs) {
    let el = "<table class=''>"

    for (var i = activityLogs.length - 1; i >= 0; i--) {
      el += this.createActivityLogEl(activityLogs[i])
    }

    el += "</table>"

    this.el.querySelector(".colony_logs_list").innerHTML = el
  }

  createActivityLogEl(activityLog) {
    let activityName = Protocol.definition().ActivityType[activityLog.activityType]
    let buildingName = Protocol.definition().BuildingType[activityLog.entityType]
    let friendlyBuildingName = buildingName.replace(/([A-Z])/g, ' $1').trim() // space before capital letters

    let date = new Date(activityLog.timestamp)
    let formattedTime = date.toLocaleDateString() + " " + date.toLocaleTimeString()

    let el = "<tr class='activity_log_row'>" +
               "<td class='activity_log_stat'>" + formattedTime + "</td>" +
               "<td class='activity_log_stat'>" + activityLog.username + "</td>" +
               "<td class='activity_log_stat'>" + i18n.t(activityName) + "</td>" +
               "<td class='activity_log_stat'>" + i18n.t(friendlyBuildingName) + "</td>" +
               "<td class='activity_log_stat'>@ " + [activityLog.row,activityLog.col].join(",") + " </td>" +
             "</tr>"

    return el
  }

  updateCommandLogs(commandLogs) {
    let el = "<table class=''>"

    for (var i = commandLogs.length - 1; i >= 0; i--) {
      el += this.createCommandLogEl(commandLogs[i])
    }

    el += "</table>"

    this.el.querySelector(".command_logs_list").innerHTML = el
  }

  createCommandLogEl(commandLog) {
    let date = new Date(commandLog.timestamp)
    let formattedTime = date.toLocaleDateString() + " " + date.toLocaleTimeString()
    let escapedCommand = ClientHelper.escapeHTML(commandLog.command)

    let el = "<tr class='activity_log_row'>" +
               "<td class='activity_log_stat'>" + formattedTime + "</td>" +
               "<td class='activity_log_stat'>" + commandLog.username + "</td>" +
               "<td class='activity_log_stat command_entry_stat'>" + escapedCommand  + "</td>" +
             "</tr>"

    return el
  }

  onStorageAccessPermissionChange(e) {
    e.preventDefault()

    if (!this.activeTeam) return

    let value = e.target.value
    let permissions = Object.assign({}, this.activeTeam.permissions)
    permissions.storageAccess = value

    SocketUtil.emit("EditTeam", { id: this.activeTeam.id, permissions: permissions })
  }

  redrawMembers() {
    this.render(this.game.teams[this.game.player.teamId])
  }

  onMemberListClick(e) {
    let muteBtn = e.target.closest(".mute_btn")
    if (muteBtn) {
      let username = e.target.closest(".member_list_entry").dataset.username
      if (muteBtn.classList.contains("muted")) {
        this.game.removeMutedPlayer(username)
        this.redrawMembers()
      } else {
        this.game.addMutedPlayer(username)
        this.redrawMembers()
      }
    }

    let kickBtn = e.target.closest(".kick_btn")
    if (kickBtn) {
      let memberId = e.target.closest(".member_list_entry").dataset.memberId
      this.kickMember(memberId)
    }

    let banBtn = e.target.closest(".ban_btn")
    if (banBtn) {
      let memberId = e.target.closest(".member_list_entry").dataset.memberId
      this.banMember(memberId)
    }

    let unbanBtn = e.target.closest(".unban_btn")
    if (unbanBtn) {
      let banId = e.target.closest(".banned_member").dataset.banId
      this.unbanMember(banId)
    }

    let memberName = e.target.closest(".member_list_entry_name")
    if (memberName) {
      let memberEntry = e.target.closest(".member_list_entry")
      let uid = memberEntry.dataset.uid
      let username = memberEntry.dataset.username

      if (!this.game.isPvP()) {
        this.game.userProfileMenu.open({ username: username, uid: uid })
      }
    }
  }

  open(options = {}) {
    super.open(options)

    if (this.game.player) {
      this.render(this.game.teams[this.game.player.teamId])
      this.renderJoinableTeams()
    }

    if (this.game.getTeamCount() > 1 && this.game.sector.settings.showTeamJoin) {
      this.el.querySelector(".colony_teams_tab").style.display = 'inline-block'
    } else {
      this.el.querySelector(".colony_teams_tab").style.display = 'none'
    }

    if (this.game.isPvP()) {
      this.el.querySelector(".colony_pvp_mode").style.display = 'none'
      this.el.querySelector(".colony_zoom").style.display = 'none'
      this.el.querySelector(".colony_fov").style.display = 'none'
      this.el.querySelector(".colony_minimap").style.display = 'none'
    } else {
      this.el.querySelector(".colony_pvp_mode").style.display = 'block'
      this.el.querySelector(".colony_zoom").style.display = 'block'
      this.el.querySelector(".colony_fov").style.display = 'block'
      this.el.querySelector(".colony_minimap").style.display = 'block'
    }

    if (this.game.isPeaceful() || this.game.isMiniGame()) {
      this.el.querySelector(".alliance_entry").style.display = 'none'
      this.el.querySelector(".colony_playerlist").style.display = 'block'
      this.el.querySelector(".colony_hunger_bar").style.display = 'block'
      this.el.querySelector(".colony_stamina_bar").style.display = 'block'
      this.el.querySelector(".colony_oxygen_bar").style.display = 'block'
      this.el.querySelector(".colony_chat_allowed").style.display = 'block'
      this.el.querySelector(".is_infinite_ammo").style.display = 'block'
      this.el.querySelector(".is_infinite_power").style.display = 'block'
    } else {
      this.el.querySelector(".alliance_entry").style.display = 'block'
      this.el.querySelector(".colony_playerlist").style.display = 'none'
      this.el.querySelector(".colony_hunger_bar").style.display = 'none'
      this.el.querySelector(".colony_stamina_bar").style.display = 'none'
      this.el.querySelector(".colony_oxygen_bar").style.display = 'none'
      this.el.querySelector(".colony_chat_allowed").style.display = 'none'
      this.el.querySelector(".is_infinite_ammo").style.display = 'none'
      this.el.querySelector(".is_infinite_power").style.display = 'none'
    }

    this.renderVisitorActionsState()
  }

  resetJoinableTeams() {
    this.el.querySelector(".team_list_container").innerHTML = ""
  }

  renderJoinableTeams() {
    let teamRows = Array.from(this.el.querySelectorAll(".team_list_container .team_list_entry"))
    let visibleCount = 0

    teamRows.forEach((teamRow) => {
      let isOwnTeam = this.activeTeam ? this.activeTeam.id === parseInt(teamRow.dataset.teamId) : false
      let isPrivate = teamRow.dataset.isPrivate

      let multipleMembers = parseInt(teamRow.dataset.memberCount) > 1
      let isFull = parseInt(teamRow.dataset.memberCount) >= 5

      if (isOwnTeam) {
        teamRow.classList.add("own")
      } else {
        teamRow.classList.remove("own")
      }

      if (multipleMembers) {
        teamRow.classList.add("multiple")
      } else {
        teamRow.classList.remove("multiple")
      }

      if (isFull) {
        teamRow.classList.add("full")
      } else {
        teamRow.classList.remove("full")
      }

      if (isOwnTeam) {
        visibleCount += 1
      } else if (!isOwnTeam && !isPrivate && !isFull) {
        visibleCount += 1
      }
    })

    if (visibleCount === 0) {
      this.el.querySelector(".empty_teams_container").style.display = 'block'
    } else {
      this.el.querySelector(".empty_teams_container").style.display = 'none'
    }
  }

  renderVisitorActionsState() {
    if (!this.activeTeam) return
    for (let playerId in this.activeTeam.members) {
      let targetPlayer = this.game.sector.players[playerId]
      let visitorListEntry = this.el.querySelector(".member_list_entry[data-member-id='" + playerId + "']")
      if (targetPlayer && visitorListEntry) {
        if (targetPlayer.isImmuneToKick()) {
          visitorListEntry.classList.add("not_kickable")
        } else {
          visitorListEntry.classList.remove("not_kickable")
        }
      }
    }
  }

  muteMember(memberId) {
    let targetPlayer = this.game.sector.players[memberId]

    SocketUtil.emit("TeamMemberAction", { memberId: memberId, action: "mute" })
  }

  kickMember(memberId) {
    let targetPlayer = this.game.sector.players[memberId]
    if (targetPlayer && targetPlayer.isImmuneToKick()) {
      return
    }

    SocketUtil.emit("TeamMemberAction", { memberId: memberId, action: "kick" })
  }

  banMember(memberId) {
    let targetPlayer = this.game.sector.players[memberId]
    if (targetPlayer && targetPlayer.isImmuneToKick()) {
      return
    }

    SocketUtil.emit("TeamMemberAction", { memberId: memberId, action: "ban" })
  }

  unbanMember(banId) {
    SocketUtil.emit("TeamMemberAction", { banId: banId, action: "unban" })
  }

  onRenameBtnClick(e) {
    let renameBtn = e.target.closest(".rename_btn")
    if (renameBtn) {
      this.showColonyNameInput()
    }
  }

  showColonyNameInput() {
    if (!this.activeTeam) return

    this.el.querySelector(".colony_info_name").style.display = 'none'
    this.el.querySelector(".colony_name_input").style.display = 'inline-block'
    this.el.querySelector(".colony_name_input").value = this.activeTeam.name
    this.el.querySelector(".colony_name_input").focus()
  }

  hideColonyNameInput() {
    this.el.querySelector(".colony_info_name").style.display = 'inline-block'
    this.el.querySelector(".colony_name_input").style.display = 'none'
  }

  onColonyNameInputBlur(e) {
    if (this.omitBlurEvents) return
    this.setColonyName(e.target.value)
    this.hideColonyNameInput()
  }

  onColonyNameInputKeyup(e) {
    if (e.which === 13 || e.which === 27) { // enter or esc
      this.setColonyName(e.target.value)
      this.omitBlurEvents = true
      e.target.blur()
      this.omitBlurEvents = false
      this.hideColonyNameInput()
    }
  }

  setColonyName(name) {
    if (!this.activeTeam) return

    SocketUtil.emit("EditTeam", { id: this.activeTeam.id, name: name })
  }

  onTeamInviteInputClick(event) {
    event.target.select()
    document.execCommand('copy')
  }

  onTeamPrivacyStatusClick() {
    if (!this.activeTeam) return

    SocketUtil.emit("EditTeam", { id: this.activeTeam.id, isPrivate: !this.activeTeam.isPrivate })
  }

  onTeamContainerClick(event) {
    let el = event.target
    let teamEntry = el.closest(".team_list_entry")

    if (el.classList.contains("team_join_btn")) {
      // Join Team
      teamEntry.querySelector(".team_join_btn").style.display = 'none'
      teamEntry.querySelector(".team_status").style.display = 'block'

      let teamId = teamEntry.dataset.teamId
      SocketUtil.emit("JoinTeam", { id: teamId })
    } else if (el.classList.contains("team_leave_btn")) {
      let teamId = teamEntry.dataset.teamId
      SocketUtil.emit("LeaveTeam", { })
    }

  }

  cleanup() {
    // this.el.querySelector(".team_list").innerHTML = ""
    this.el.querySelector(".member_list").innerHTML = ""
  }

  onLeaveTeamBtnClick() {
    let teamId = this.activeTeam.id
    SocketUtil.emit("LeaveTeam", { id: teamId })
  }

  onRestartCharacterClick() {
    SocketUtil.emit("RestartCharacter", {  })
  }

  onRoleListClick(e) {
    let roleEl = e.target.closest(".role")
    if (roleEl) {
      this.selectRole(roleEl)
    }
  }

  selectRole(roleEl) {
    let selectedRole = this.el.querySelector(".role.selected")
    if (selectedRole) {
      selectedRole.classList.remove("selected")
    }

    roleEl.classList.add("selected")

    let roleId = parseInt(roleEl.dataset.id)
    this.renderRolePermissions(roleId)
  }

  onRolePermissionsClick(e) {
    let rolePermission = e.target.closest(".role_permission")
    if (!rolePermission) return
    if (e.target.tagName !== 'INPUT') return // dont process label click event

    e.stopPropagation()
    e.preventDefault()

    if (!this.activeTeam.isLeader(this.game.player)) {
      this.game.displayError("Permission Denied", { warning: true })
      return
    }

    let permission = rolePermission.dataset.permission

    let isEnabled = rolePermission.querySelector("input").checked
    if (permission === "UseCommands" && isEnabled) {
        this.game.confirmMenu.open({
          dontCloseMenus: true,
          message: "Warning! Commands allow people to delete your world. Proceed?",
          proceedCallback: this.editRole.bind(this, permission, isEnabled)
        })
    }else if (permission === "EditCommandBlocks" && isEnabled) {
      this.game.confirmMenu.open({
        dontCloseMenus: true,
        message: "Warning! This permission can potentially allow anyone with this role to do anything to your world. Proceed?",
        proceedCallback: this.editRole.bind(this, permission, isEnabled)
      })
  } else {
      this.editRole(permission, isEnabled)
    }

    return false
  }

  editRole(permission, isEnabled) {
    SocketUtil.emit("EditRole", {
      teamId: this.game.player.teamId,
      roleId: this.activeRoleId,
      permission: permission,
      isEnabled: isEnabled
    })
  }

  removeRole(roleId) {
    let roleEl = this.el.querySelector(".role_list .role[data-id='" + roleId + "']")
    if (roleEl.parentElement) {
      roleEl.parentElement.removeChild(roleEl)
    }

    let roleCount = Object.keys(this.game.roles).length
    let lastRole = Object.values(this.game.roles)[roleCount - 1]
    if (lastRole) {
      let lastRoleEl = this.el.querySelector(".colony_roles_container .role_list .role[data-id='" + lastRole.id + "']")
      if (lastRoleEl) {
        this.selectRole(lastRoleEl)
      }
    }
  }

  renderRolePermissions(roleId) {
    if (Object.keys(this.game.roles).length === 0) return

    this.activeRoleId = roleId
    let result = ""

    if (parseInt(roleId) <= 3 || !this.game.player.isLeader()) {
      this.el.querySelector(".role_name_label").style.display = 'block'
      this.el.querySelector(".role_name_edit").style.display = 'none'
      this.el.querySelector(".delete_role_btn").style.display = 'none'
    } else {
      this.el.querySelector(".role_name_label").style.display = 'none'
      this.el.querySelector(".role_name_edit").style.display = 'block'
      this.el.querySelector(".delete_role_btn").style.display = 'block'
    }

    let role = this.game.roles[roleId]

    this.el.querySelector(".role_name_label_value").innerText = role.name
    this.el.querySelector(".role_name_input").value = role.name

    for (let name in role.permissions) {
      let value = role.permissions[name]
      let el = this.createRolePermissionEl(name, value)
      result += el
    }

    this.el.querySelector(".role_permissions").innerHTML = result
  }

  createRolePermissionEl(permission, value) {
    let permissionFriendlyName = i18n.t(permission.replace(/([A-Z])/g, ' $1').replace(/^\s+/g,''))
    let checked = value ? "checked" : ""

    return "<div class='role_permission' data-permission='" + permission + "'>" +
      "<input type='checkbox'  id='" + permission + "_permission' " + checked + ">" +
      "<label                 for='" + permission + "_permission' >" +
        permissionFriendlyName +
      "</label>" +
    "</div>"
  }

  resetTeamRequestStatus(teamId) {
    let teamEntry = this.el.querySelector(".team_list_entry[data-team-id='" + teamId + "']")
    if (!teamEntry) return

    teamEntry.querySelector(".team_join_btn").style.display = 'block'
    teamEntry.querySelector(".team_status").style.display = 'none'
  }

  renderRelationshipStatus() {
    let team = this.activeTeam

    this.el.querySelector(".colony_info_alliance").innerText = i18n.t(team.relationshipStatus)
    if (team.relationshipStatus === "Hostile") {
      this.el.querySelector(".colony_info_alliance").classList.remove("friendly")
      this.el.querySelector(".colony_info_alliance").classList.add("hostile")
    } else if (team.relationshipStatus === "Friendly") {
      this.el.querySelector(".colony_info_alliance").classList.remove("hostile")
      this.el.querySelector(".colony_info_alliance").classList.add("friendly")
    }
  }

  // if i joined/created a team, show members
  render(team) {
    if (!team) return
    this.resetTeamRequestStatus(team.id)

    this.activeTeam = team

    this.el.querySelector(".colony_info_name").innerText = team.name
    this.el.querySelector(".colony_game_mode").innerText = i18n.t(Helper.capitalize(this.game.sector.gameMode))
    this.el.querySelector(".colony_info_creator_name").innerText = team.creatorName

    this.renderRelationshipStatus()

    this.el.querySelector(".member_list_container").style.display = 'block'

    this.renderRenameBtn(team)
    this.renderInviteLink(team)
    this.renderPrivacy(team)
    this.renderMembers(team)

    if (team.isLeader(this.game.player)) {
      this.el.querySelector(".new_role_btn").style.display = 'inline-block'
    } else {
      this.el.querySelector(".new_role_btn").style.display = 'none'
    }

    if (this.game.isAnonymousGame() || !this.game.player.isSectorOwner()) {
      this.el.querySelector(".colony_screenshot_tab").style.display = 'none'
      if (this.el.querySelector(".colony_screenshots_container").classList.contains("active")) {
        this.el.querySelector(".colony_screenshots_container").classList.remove("active")
        this.el.querySelector(".colony_info_container").classList.add("active")
      }
    } else {
      document.querySelector(".colony_screenshot_tab").style.display = 'inline-block'
    }

    document.querySelector(".colony_settings_tab").style.display = 'inline-block'

    if (!team.isAdmin(this.game.player) || this.game.isMiniGame()) {
      this.el.querySelector(".colony_logs_tab").style.display = 'none'
      this.el.querySelector(".command_logs_tab").style.display = 'none'
      if (this.el.querySelector(".colony_logs_container").classList.contains("active")) {
        this.el.querySelector(".colony_logs_container").classList.remove("active")
        this.el.querySelector(".colony_info_container").classList.add("active")
      }
      if (this.el.querySelector(".command_logs_container").classList.contains("active")) {
        this.el.querySelector(".command_logs_container").classList.remove("active")
        this.el.querySelector(".colony_info_container").classList.add("active")
      }
    } else {
      document.querySelector(".colony_logs_tab").style.display = 'inline-block'
      document.querySelector(".command_logs_tab").style.display = 'inline-block'
    }

    if (this.game.isPvP()) {
      this.renderPvPMode()
    }
  }

  renderPvPMode() {
    this.el.querySelector(".colony_mode_entry").style.display = 'none'
    this.el.querySelector(".colony_creator_name_entry").style.display = 'none'
    this.el.querySelector(".colony_screenshot_tab").style.display = 'none'
    this.el.querySelector(".colony_settings_tab").style.display = 'none'
  }

  createRolesEl(roles) {
    roles = Object.assign({}, roles)
    let result = "<ul>"

    for (let id in roles) {
      let role = roles[id]
      let roleEl = "<li class='role' data-id='" + role.id + "'>" + role.name + "</li>"
      result += roleEl
    }

    return result
  }

  addRole(role) {
    let roleEl = "<li class='role' data-id='" + role.id + "'>" + role.name + "</li>"

    this.el.querySelector(".colony_roles_container .role_list ul").innerHTML += roleEl

    return this.el.querySelector(".role_list .role[data-id='" + role.id + "']")
  }

  renderRoles() {
    let roles = this.game.roles

    let rolesEl = this.createRolesEl(roles)

    this.el.querySelector(".colony_roles_container .role_list").innerHTML = rolesEl

    let firstRole = Object.values(roles)[0]
    if (firstRole) {
      let firstRoleEl = this.el.querySelector(".colony_roles_container .role_list .role")
      if (firstRoleEl) {
        this.selectRole(firstRoleEl)
      }
    }
  }

  isLeader(team, player) {
    return team.leader && team.leader.id === player.id
  }

  renderRenameBtn(team) {
    if (!this.isLeader(team, this.game.player)) {
      this.el.querySelector(".rename_btn").style.display = 'none'
    } else {
      this.el.querySelector(".rename_btn").style.display = 'inline-block'
    }
  }

  renderInviteLink(team) {
    let params = window.location.search
    params = ClientHelper.replaceQueryParam('e', team.getInviteToken(), params)
    let inviteLink = this.game.main.getBrowserHost() + params

    this.el.querySelector(".invite_link_input").value = inviteLink

    if (this.game.isMiniGame()) {
      document.querySelector("#minigame_invite_container .invite_link_input").value = inviteLink
    }
  }

  renderPrivacy(team) {
    let isPrivate = team.isPrivate

    if (this.game.isMiniGame()) {
      isPrivate = this.game.sector.isPrivate
      if (!this.game.isRoundStarted) {
        if (isPrivate) {
          document.querySelector("#minigame_invite_container").style.display = 'block'
        } else {
          document.querySelector("#minigame_invite_container").style.display = 'none'
        }
      }
    } else {
      document.querySelector("#minigame_invite_container").style.display = 'none'
    }

    if (!this.isLeader(team, this.game.player)) {
      this.el.querySelector(".team_private_status").dataset.disabled = true
      this.el.querySelector(".team_private_status").classList.add("read_only")
    } else {
      this.el.querySelector(".team_private_status").classList.remove("read_only")
    }

    if (isPrivate) {
      this.el.querySelector(".team_private_status").classList.add("private")
      this.el.querySelector(".team_private_status").innerText = i18n.t("Private")
    } else {
      this.el.querySelector(".team_private_status").classList.remove("private")
      this.el.querySelector(".team_private_status").innerText = i18n.t("Public")
    }
  }

  setSectorIsPrivate(isPrivate) {
    this.sectorIsPrivate = isPrivate

    this.el.querySelector(".team_private_status").dataset.disabled = true
    this.el.querySelector(".team_private_status").classList.add("read_only")

    if (isPrivate) {
      this.el.querySelector(".team_private_status").classList.add("private")
      this.el.querySelector(".team_private_status").innerText = i18n.t("Private")
    } else {
      this.el.querySelector(".team_private_status").classList.remove("private")
      this.el.querySelector(".team_private_status").innerText = i18n.t("Public")
    }
  }


  renderMembers(team) {
    let playerList = Object.values(team.members)
    this.el.querySelector(".member_list").innerHTML = this.createMemberListHTML(playerList)
    if (!this.activeTeam) return

    if (this.activeTeam.isAdmin(this.game.player)) {
      let offlinePlayerList = Object.values(team.offlineMembers)
      if (offlinePlayerList.length > 0) {
        this.el.querySelector(".offline_member_list").innerHTML = this.createMemberListHTML(offlinePlayerList, { offline: true })
        this.el.querySelector(".offline_member_list_container").style.display = 'block'
      } else {
        this.el.querySelector(".offline_member_list").innerHTML = ""
        this.el.querySelector(".offline_member_list_container").style.display = 'none'
      }

      let sectorBanList = Object.values(this.game.sector.sectorBans)
      if (sectorBanList.length > 0) {
        this.el.querySelector(".ban_member_list").innerHTML = this.createBanListHTML(sectorBanList)
        this.el.querySelector(".ban_member_list_container").style.display = 'block'
      } else {
        this.el.querySelector(".ban_member_list").innerHTML = ""
        this.el.querySelector(".ban_member_list_container").style.display = 'none'
      }

    } else {
      this.el.querySelector(".offline_member_list").innerHTML = ""
      this.el.querySelector(".offline_member_list_container").style.display = 'none'

      this.el.querySelector(".ban_member_list").innerHTML = ""
      this.el.querySelector(".ban_member_list_container").style.display = 'none'
    }

    this.initSelectRoleListeners()

    this.renderVisitorActionsState()
  }

  createTeamEntryHTML(team) {
    return "<div class='team_list_entry' data-team-id='" + team.id +  "' data-is-private='" + (team.isPrivate ? true : '') + "' data-member-count='" + team.getMemberCount()  + "'>" +
             "<div class='team_name'>" + team.name + "</div>" +
             "<div class='team_member_count'>" + team.getMemberCount() + " / 5</div>" +
             "<div class='team_status'>" + i18n.t('Request Sent') + "</div>" +
             "<div class='team_join_btn team_action_btn'>" + i18n.t('Join') + "</div>" +
           "</div>"
  }

  renderTeamEntry(el, team) {
    el.querySelector(".team_name").innerText = team.name
    el.querySelector(".team_member_count").innerText = team.getMemberCount() + " / 5"
    el.dataset.memberCount = team.getMemberCount()
    if (team.isPrivate) {
      el.dataset.isPrivate = team.isPrivate
    } else {
      el.removeAttribute("data-is-private")
    }
  }

  buildOption(member, roleType, roleLabel) {
    let isSelected = member.roleType === roleType
    return `<option value='${roleType}' ${isSelected ? 'selected' : ''}>${i18n.t(roleLabel)}</option>`
  }

  initSelectRoleListeners() {
    Array.from(document.querySelectorAll(".member_role_select")).forEach((select) => {
      select.addEventListener("change", this.onMemberRoleChanged.bind(this), true)
    })

  }

  onMemberRoleChanged(e) {
    // e.preventDefault()

    let roleType = e.target.value
    let memberId = e.target.closest(".member_list_entry").dataset.memberId

    SocketUtil.emit("TeamMemberAction", { memberId: memberId, action: 'role', roleType: roleType })
  }

  getMemberRoleName(roleType) {
    if (roleType === Protocol.definition().RoleType.Everyone) return "Guest"
    if (roleType === Protocol.definition().RoleType.Member) return "Member"
    if (roleType === Protocol.definition().RoleType.Admin) return "Admin"

    return ""
  }

  isMe(member) {
    return this.game.playerId === member.id
  }

  canManageRoles(member) {
    let isTeamCreator = this.activeTeam.isCreator(this.game.player)
    if (isTeamCreator) return true

    return this.activeTeam.isAdmin(this.game.player) &&
           !this.activeTeam.isLeader(member) &&
           !this.activeTeam.isCreator(member) &&
           !this.isMe(member)
  }

  getRolePermissions(member) {
    let role = this.game.roles[member.roleType]
    if (!role) return {}

    return role.permissions
  }

  canKickMembers(team, member, isOffline) {
    if (isOffline) return false
    if (this.isMe(member)) return false

    if (this.game.player.isSectorOwner()) {
      return true
    }

    if (this.getRolePermissions(this.game.player)["Kick"]) {
      if (this.isMe(member)) return false
      return true
    }

    if (!team) return false

    return false
  }

  canBanMembers(team, member, isOffline) {
    if (isOffline) return false
    if (this.isMe(member)) return false

    if (this.game.player.isSectorOwner()) {
      return true
    }

    if (this.getRolePermissions(this.game.player)["Ban"]) {
      if (this.isMe(member)) return false
      return true
    }

    if (!team) return false

    return false
  }

  buildRoleSelect(member) {
    let roleSelection = "<select class='member_role_select ui_select'>"

    for (let roleId in this.game.roles) {
      let role = this.game.roles[roleId]
      let option = this.buildOption(member, role.id, role.name)
      roleSelection += option
    }

    roleSelection += "</select>"

    return roleSelection
  }

  isMuted(memberName) {
    return this.game.mutedPlayers[memberName] 
  }

  createMemberListHTML(playerList, options = {}) {
    let ul = "<ul>"

    playerList.forEach((member) => {
      let kickBtn = ""
      let banBtn = ""
      let promoteBtn = ""
      let demoteBtn  = ""

      let actionBtns = ""

      let roleName = this.game.roles[member.roleType] && this.game.roles[member.roleType].name
      let roleLabel = `<span class='member_role'>${roleName}</span>`

      let roleSelection = this.buildRoleSelect(member)

      if (this.canManageRoles(member)) {
        actionBtns = roleSelection
      } else {
        actionBtns = roleLabel
      }

      if (!this.isMe(member)) {
        if (this.isMuted(member.name)) {
          actionBtns += "<div class='mute_btn muted'>Unblock</div>"
        } else {
          actionBtns += "<div class='mute_btn' title='Stop Seeing messages from this player'>Block</div>"
        }
      }
 
      kickBtn = "<div class='kick_btn'>Kick</div>"
      banBtn = "<div class='ban_btn'>Ban</div>"
      let userActionBtns = []

      if (this.canKickMembers(this.activeTeam, member, options.offline)) {
        userActionBtns.push(kickBtn)
      }

      if (this.canBanMembers(this.activeTeam, member, options.offline)) {
        userActionBtns.push(banBtn)
      }

      if (userActionBtns.length > 0) {
        actionBtns += userActionBtns.join("<span>|</span>")
      }

      let daysAliveEl = ""
      if (member.daysAlive) {
        daysAliveEl = "<span class='member_days_alive'>" + member.daysAlive + ' ' + i18n.t('Days Alive') + "</span>"
      }

      let li = "<li class='member_list_entry' data-member-id='" + member.id +  "' data-uid='" + member.uid + "' data-username='" + member.name + "' >" +
                 "<span class='member_list_entry_name'>" + member.name  + "</span>" +
                 actionBtns +
                 daysAliveEl +
               "</li>"
      ul += li
    })

    return ul
  }

  createBanListHTML(banList) {
    let ul = "<ul>"

    banList.forEach((sectorBan) => {
      if (sectorBan.username) {
        let li = "<li class='banned_member' data-ban-id='" + sectorBan.id + "'>" +
                   "<span class='banned_username'>" + sectorBan.username + "</span>" +
                   "<span class='unban_btn'>" + i18n.t('unban') + "</span>" +
                 "</li>"
        ul += li
      }
    })

    return ul
  }

  addTeam(team) {
    if (team.isSectorOwner()) return
    let el = this.createTeamEntryHTML(team)
    this.el.querySelector(".team_list_container").innerHTML += el
  }

  removeTeam(team) {
    let el = this.el.querySelector(".team_list_container div[data-team-id='" + team.id + "']")
    if (!el) return
    if (el.parentElement) {
      el.parentElement.removeChild(el)
    }

  }

  syncTeam(team) {
    let el = this.el.querySelector(".team_list_container div[data-team-id='" + team.id + "']")
    if (!el) return
    this.renderTeamEntry(el, team)
  }


}



module.exports = TeamMenu

},{"./../../../common/constants.json":656,"./../../../common/helper":664,"./../../../common/util/protocol":686,"./../util/client_helper":649,"./../util/socket_util":654,"./base_menu":581}],637:[function(require,module,exports){
const SocketUtil = require("./../util/socket_util")
const BaseMenu = require("./base_menu")
const Constants = require("./../../../common/constants.json")

class TeamRequestMenu extends BaseMenu {
  onMenuConstructed() {
  }

  initListeners() {
    super.initListeners()

    this.el.addEventListener("click", this.onTeamRequestMenuClick.bind(this), true)
  }

  createTeamRequestEntry(data) {
    let playerName = data.playerName

    let el = "<div class='team_request_entry' data-player-id=" + data.playerId + ">" +
               "<div class='team_request_message'><span class='team_requester'>" + playerName + "</span> " + i18n.t('requests to join your team') + "</div>" +
               "<div class='accept_team_request_btn ui_btn' >" + i18n.t('Accept') + "</div>" +
               "<div class='reject_team_request_btn ui_btn' >" + i18n.t('Reject') +"</div>" +
             "</div>"

    this.el.innerHTML += el
  }

  removeTeamRequestEntry(data) {
    let teamRequestEntry = this.el.querySelector(".team_request_entry[data-player-id='" + data.playerId + "']")
    if (teamRequestEntry && teamRequestEntry.parentElement) {
      teamRequestEntry.parentElement.removeChild(teamRequestEntry)
    }
  }

  onTeamRequestMenuClick(event) {
    let entry = event.target.closest(".team_request_entry")
    let playerId = entry.dataset.playerId

    if (event.target.classList.contains("accept_team_request_btn")) {
      entry.parentElement.removeChild(entry)
      SocketUtil.emit("AcceptTeamRequest", { playerId: playerId })
    } else if (event.target.classList.contains("reject_team_request_btn")) {
      entry.parentElement.removeChild(entry)
      SocketUtil.emit("AcceptTeamRequest", { playerId: playerId, isReject: true })
    }
  }


}



module.exports = TeamRequestMenu

},{"./../../../common/constants.json":656,"./../util/socket_util":654,"./base_menu":581}],638:[function(require,module,exports){
const SocketUtil = require("./../util/socket_util")
const BaseMenu = require("./base_menu")
const Constants = require("./../../../common/constants.json")


/*
    while element references only inventory, it actually changes hotbar/quick_inventory as well
*/
class TeamStatusMenu extends BaseMenu {
  onMenuConstructed() {
  }

  initListeners() {

  }

  cleanup() {
    this.el.innerHTML = ""
  }

  // if i joined/created a team, show members
  showTeamMembers(team) {
    if (!team) return
    this.renderMembers(team.members)
  }

  renderMembers(members) {
    this.el.innerHTML = this.createMemberListHTML(members)
  }

  createMemberListHTML(members) {
    let list = ""

    Object.values(members).forEach((member) => {
      let isSelf = member.id === this.game.player.id
      if (!isSelf) {
        let entry = "<div class='member_status_entry' data-member-id='" + member.id +  "' >" + 
                      "<div class='member_status_name'>" + member.name + "</div>" + 
                      "<div class='member_health_container bar_container'>" +
                        "<div class='bar_fill'></div>" +
                      "</div>" +
                    "</div>"
        list += entry
      }
    })

    return list
  }

  updateMemberHealth(data) {
    if (!this.game.sector) return
    let entityId = data.entityId
    let entity = this.game.sector.getEntity(entityId)

    let memberEntry = this.el.querySelector(".member_status_entry[data-member-id='" + entityId + "']")
    if (memberEntry && entity) {
      let curr = data.health
      let max  = entity.getMaxHealth()

      memberEntry.querySelector(".bar_fill").style.width = (curr/max * 100) + "%"
    }
  }


}



module.exports = TeamStatusMenu 
},{"./../../../common/constants.json":656,"./../util/socket_util":654,"./base_menu":581}],639:[function(require,module,exports){
const SocketUtil = require("./../util/socket_util")
const BaseMenu = require("./base_menu")
const Constants = require("./../../../common/constants.json")
const Protocol = require("./../../../common/util/protocol")

class TerminalMenu extends BaseMenu {
  onMenuConstructed() {
    this.chatInput = this.el.querySelector(".terminal_chat_input")
    this.chatContent = this.el.querySelector(".terminal_chat_content")
  }

  initListeners() {
    super.initListeners()

    this.el.querySelector(".confirm_choice_btn").addEventListener("click", this.onChoiceConfirmClick.bind(this), true)
    this.el.querySelector(".terminal_choices_container").addEventListener("click", this.onTerminalChoiceClick.bind(this) , true)
    this.el.querySelector(".terminal_chat_input").addEventListener("keyup", this.onTerminalChatInputKeyup.bind(this) , true)
    this.el.querySelector(".terminal_chat_send_btn").addEventListener("click", this.onTerminalChatSendClick.bind(this) , true)
    this.el.querySelector(".terminal_tab_container").addEventListener("click", this.onTerminalTabClick.bind(this) , true)
  }

  open(options = {}) {
    super.open(options)

    this.entity = options.entity
    this.render()
  }

  onTerminalChatInputKeyup(e) {
    if (e.which === 13) {
      let chat = this.chatInput.value
      this.chatInput.value = ""
      SocketUtil.emit("InteractTarget", { id: this.entity.id, action: "chat", content: chat })
    }
  }

  onTerminalTabClick(e) {
    let tab = e.target.dataset.tab
    if (tab) {
      this.selectTab(tab)
    }
  }

  selectTab(tab) {
    // remove previous selected
    let prevSelectedTab = this.el.querySelector(".terminal_tab.selected")
    if (prevSelectedTab) {
      prevSelectedTab.classList.remove("selected")
      
      let prevTabContent = this.el.querySelector(".terminal_tab_content div[data-tab='" + prevSelectedTab.dataset.tab + "']")
      prevTabContent.classList.remove("selected")
    }

    let targetTab = this.el.querySelector(".terminal_tab[data-tab='" + tab + "']")
    targetTab.classList.add("selected")
    let tabContent = this.el.querySelector(".terminal_tab_content div[data-tab='" + tab + "']")
    tabContent.classList.add("selected")
  }

  onTerminalChatSendClick(e) {
    let chat = this.chatInput.value
    this.chatInput.value = ""
    SocketUtil.emit("InteractTarget", { id: this.entity.id, action: "chat", content: chat })
  }

  render() {
    this.el.querySelector(".terminal_chat_content").innerHTML = this.getChatContent()

    if (this.game.isMiniGame() && this.isUserImposter()) {
      if (!this.game.terminalMenu.isChoiceSubmitted) {
        this.el.querySelector(".terminal_tab[data-tab='hack']").style.display = 'inline-block'
      } else {
        this.el.querySelector(".terminal_tab[data-tab='hack']").style.display = 'none'
        this.selectTab("chat")
      }
    } else {
      this.el.querySelector(".terminal_tab[data-tab='hack']").style.display = 'none'
      this.selectTab("chat")
    }
  }

  isUserImposter() {
    let result = false
    
    for (let index in this.game.player.inventory) {
      let item = this.game.player.inventory[index]
      if (item.type === Protocol.definition().BuildingType.AssassinsKnife) {
        result = true
        break
      }
    }

    return result
  }


  getChatContent() {
    let result = ""
    for (var i = 0; i < this.game.sector.terminalMessages.length; i++) {
      let msg = this.game.sector.terminalMessages[i]
      let el = this.createChatEntry(msg)
      result += el
    }

    return result
  }

  createChatEntry(msg) {
    return "<div class='terminal_chat_entry'>" + msg + "</div>"
  }

  addTerminalMessage(message) {
    let el = this.createChatEntry(message)
    this.chatContent.innerHTML += el
    this.chatContent.scrollTop = this.chatContent.scrollHeight
  }

  onTerminalChoiceClick(e) {
    let choice = e.target.closest(".terminal_choice")
    if (choice) {
      if (this.selectedChoice) {
        this.selectedChoice.classList.remove("selected")
      }

      this.selectedChoice = choice
      this.selectedChoice.classList.add("selected")
    }
  }

  onChoiceConfirmClick() {
    if (!this.selectedChoice) return

    let choice = this.selectedChoice.dataset.choice
    SocketUtil.emit("InteractTarget", { id: this.entity.id, action: choice })
    this.isChoiceSubmitted = true
  }

}



module.exports = TerminalMenu 
},{"./../../../common/constants.json":656,"./../../../common/util/protocol":686,"./../util/socket_util":654,"./base_menu":581}],640:[function(require,module,exports){
const SocketUtil = require("./../util/socket_util")
const BaseMenu = require("./base_menu")
const Mobs = require("./../entities/mobs/index")
const Ores = require("./../entities/ores/index")
const Item = require("./../entities/item")
const Buildings = require("./../entities/buildings/index")
const Equipments = require("./../entities/equipments/index")
const Helper = require("./../../../common/helper")
const Protocol = require("./../../../common/util/protocol")

/*
    while element references only inventory, it actually changes hotbar/quick_inventory as well
*/
class TradeMenu extends BaseMenu {
  onMenuConstructed() {
    this.errorMessage = this.el.querySelector(".error_message")

    this.activeTabContent = this.el.querySelector(".buy_trade_content")
  }

  initListeners() {
    super.initListeners()

    this.el.querySelector(".buy_count").addEventListener("change", this.onBuyCountChange.bind(this), true)
    this.el.querySelector(".buy_count").addEventListener("input", this.onBuyCountInput.bind(this), true)
    this.el.querySelector(".buy_count").addEventListener("keydown", this.onBuyCountKeydown.bind(this), true)
    this.el.querySelector(".buy_count").addEventListener("keyup", this.onBuyCountKeyup.bind(this), true)

    this.el.querySelector(".trade_btn").addEventListener("click", this.onTradeBtnClick.bind(this), true)
    this.el.querySelector(".trade_inventory").addEventListener("click", this.onTradeInventoryClick.bind(this), true)
    this.el.querySelector(".trade_type_tab_container").addEventListener("click", this.onTradeTypeTabClick.bind(this), true)
  }

  onTradeTypeTabClick(e) {
    let tradeType = e.target.dataset.tradeType
    if (!tradeType) return

    let selectedTab = this.el.querySelector(".trade_type_tab.selected")
    if (selectedTab) {
      selectedTab.classList.remove("selected")
    }

    e.target.classList.add("selected")

    if (this.activeTabContent) {
      this.activeTabContent.style.display = 'none'
    }

    let tradeContent = this.el.querySelector(".trade_inventory .tab-pane[data-trade-type='" + tradeType + "'")
    this.activeTabContent = tradeContent
    this.activeTabContent.style.display = 'block'

    this.el.querySelector(".trade_btn").dataset.tradeType = tradeType
    this.el.querySelector(".trade_btn").innerText = i18n.t(Helper.capitalize(tradeType))

    this.isSelling = tradeType === 'sell'
  }

  initPurchasables() {
    if (!this.game.sector.isCustomSell) return

    let purchasables = this.game.sector.purchasables

    let rows = ""
    for (let typeName in purchasables) {
      let purchasable = purchasables[typeName]
      let klass
      let cost = purchasable.cost

      if (purchasable.group === "mob") {
        klass = Mobs.forType(purchasable.type)
      } else {
        klass = Item.getKlass(purchasable.type) 
      }
      
      let itemCount = this.getPlayerItemCount(purchasable.type)
      rows += this.createTradeItem(klass, { count: itemCount, cost: cost })
    }

    this.el.querySelector(".sell_trade_content").innerHTML = rows
  }

  getPlayerItemCount(type) {
    let count = 0

    for (let index in this.game.player.inventory) {
      let item = this.game.player.inventory[index]
      if (item && item.type === type) {
        count += item.count
      }
    }

    return count
  }

  initSellables() {
    let sellables = this.game.sector.sellables

    let rows = ""
    for (let typeName in sellables) {
      let sellable = sellables[typeName]
      let klass
      let cost = sellable.cost
      let itemName = sellable.itemName

      if (sellable.group === "mob") {
        klass = Mobs.forType(sellable.type)
      } else {
        klass = Item.getKlass(sellable.type) 
      }
      
      rows += this.createTradeItem(klass, { cost: cost, itemName: itemName })
    }

    this.el.querySelector(".buy_trade_content").innerHTML = rows
  }

  onBuyCountKeydown(e) {
    this.oldBuyCount = parseInt(e.target.value)
  }

  onBuyCountInput(e) {
    let maxLength = 4
    if (e.target.value.length > maxLength) {
      e.target.value = e.target.value.slice(0, maxLength)
    }
  }

  onBuyCountChange(e) {
    if (e.target.value.length === 0) {
      e.target.value = 1
    }
  }

  onBuyCountKeyup(e) {
    if (e.target.value.length === 0) return

    let number = parseInt(e.target.value)
    if (isNaN(number) || number < 1 || number > 9999) {
      e.target.value = this.oldBuyCount
    } 

    if (this.isSelling && this.selectedRow) {
      let itemCount = parseInt(this.selectedRow.dataset.count)
      if (number > itemCount) {
        e.target.value = itemCount
      }
    }

    if (e.key === "Enter") {
      this.onEnterUp()
    }

    if (e.keyCode === 27) {
      this.game.inputController.handleEsc()
    }
  }

  onTradeInventoryClick(event) {
    if (this.selectedRow) {
      this.unselectRow(this.selectedRow)
    }

    let row = event.target.closest(".trade_item_row")

    if (row) {
      this.selectRow(row)
      this.resetBuyCount()
    }
  }

  resetBuyCount() {
    this.el.querySelector(".buy_count").value = 1
  }

  unselectRow(row) {
    this.selectedRow = null

    if (row) {
      row.dataset.selected = false
    }
  }

  selectRow(row) {
    if (!row) return

    this.selectedRow = row
    this.selectedRow.dataset.selected = true
  }

  displayError(message) {
    this.errorMessage.innerText = message

    setTimeout(() => {
      this.errorMessage.innerText = ""
    }, 3000)
  }

  onTradeBtnClick(e) {
    if (e.target.dataset.tradeType === 'buy') {
      this.onBuyBtnClick()
    } else {
      this.onSellBtnClick()
    }
  }

  onSellBtnClick() {
    if (!this.selectedRow) return
    if (this.el.querySelector(".trade_btn").dataset.disabled === "true") return

    let buyCount = parseInt(this.el.querySelector(".buy_count").value)
    if (isNaN(buyCount)) buyCount = 1

    let group = this.selectedRow.dataset.group
    let type = this.selectedRow.dataset.type
    let index = this.selectedRow.dataset.index

    SocketUtil.emit("Trade", { group: group, type: type, count: buyCount, sell: true, index: index })
  }

  onBuyBtnClick() {
    if (!this.game.player) return
    if (!this.selectedRow) return
    if (this.el.querySelector(".trade_btn").dataset.disabled === "true") return

    let buyCount = parseInt(this.el.querySelector(".buy_count").value)
    if (isNaN(buyCount)) buyCount = 1

    let cost = parseInt(this.selectedRow.querySelector(".trade_item_cost").innerText)
    let totalCost = cost * buyCount

    if (player.isInventoryFull()) {
      this.displayError("Inventory Full")
      return
    }

    let group = this.selectedRow.dataset.group
    let type = this.selectedRow.dataset.type
    let index = this.selectedRow.dataset.index

    SocketUtil.emit("Trade", { group: group, type: type, count: buyCount, index: index, recipientId: this.seller.id })
  }

  onMenuInteract(cmd) {
    switch(cmd) {
      case "GoUp":
        this.onGoUp()
        break
      case "GoDown":
        this.onGoDown()
        break
      case "EnterUp":
        this.onEnterUp()
        break
    } 
  }

  onEnterUp() {
    if (this.isSelling) {
      this.onSellBtnClick()
    } else {
      this.onBuyBtnClick()
    }
  }

  updateGoldCount(gold) {
    this.el.querySelector(".player_gold_count_value").innerText = gold || 0
  }

  onCraftSuccess(data) {
    let rect = this.el.querySelector(".trade_btn").getBoundingClientRect()
    data.y = rect.top - 20
    data.x = rect.left - 50

    this.game.animateCraftSuccess(data)
  }

  onCraftCountKeyup(e) {
    if (e.target.value.length === 0) return

    let number = parseInt(e.target.value)
    if (isNaN(number) || number < 1 || number > 99) {
      e.target.value = this.oldBuyCount
    } 

    if (e.key === "Enter") {
      this.onCraftBtnHold()
    }

    if (e.keyCode === 27) {
      this.game.inputController.handleEsc()
    }
  }


  onGoUp() {
    this.onGoDirection(-1)
  }

  onGoDown() {
    this.onGoDirection(1)
  }

  onGoDirection(direction) {
    let rows = Array.from(this.el.querySelectorAll(".trade_item_row"))
    let rowIndex = Array.prototype.indexOf.call(rows, this.selectedRow)
    this.unselectRow(this.selectedRow)

    if (direction > 0) {
      // going down
      let isLastRow = rowIndex === rows.length - 1
      if (isLastRow) {
        this.selectRow(rows[0])
      } else {
        this.selectRow(rows[rowIndex + 1])
      }
    } else {
      let isFirstRow = rowIndex === 0
      if (isFirstRow) {
        this.selectRow(rows[rows.length - 1])
      } else {
        this.selectRow(rows[rowIndex - 1])
      }
    }
  }



  open(seller) {
    super.open()

    this.initSellables()
    let rows = Array.from(this.el.querySelectorAll(".trade_item_row"))
    this.selectRow(rows[0]) // select first item

    this.seller = seller
    this.initPurchasables()
    this.renderPlayerSellables()
    this.renderAdditionalTraderSellables()
  }

  renderAdditionalTraderSellables() {
    let grenadeType = Protocol.definition().BuildingType.Grenade
    let poisonGrenadeType = Protocol.definition().BuildingType.PoisonGrenade

    let grenadeTradeItemRow = this.el.querySelector(".buy_trade_content .trade_item_row[data-type='" + grenadeType + "']")  
    let poisonGrenadeTradeItemRow = this.el.querySelector(".buy_trade_content .trade_item_row[data-type='" + poisonGrenadeType + "']")  

    if (this.game.isPvP()) {
      if (!grenadeTradeItemRow) {
        this.el.querySelector(".buy_trade_content").innerHTML += this.createTradeItem(Equipments.PoisonGrenade)
        this.el.querySelector(".buy_trade_content").innerHTML += this.createTradeItem(Equipments.Grenade)
      }
    } else {
    }
  }

  onInventoryChanged() {
    this.renderPlayerSellables()
    this.initPurchasables()
  }

  renderPlayerSellables() {
    if (!this.game.player) return
    if (this.game.sector.isCustomSell) return

    let isSelling = true
    let rows = ""
    for (let index in this.game.player.inventory) {
      let item = this.game.player.inventory[index]
      if (item) {
        let itemKlass = Item.getKlass(item.type)
        if (!this.shouldExcludeFromSelling(itemKlass)) {
          rows += this.createTradeItem(itemKlass, { count: item.count, index: index, isSelling: isSelling })
        }
      }
    }

    this.el.querySelector(".sell_trade_content").innerHTML = rows

    if (this.selectedRow) {
      let prevIndex = this.selectedRow.dataset.index
      if (isNaN(prevIndex)) return
        
      const newSelectedRow = this.el.querySelector(".trade_item_row[data-index='" + prevIndex + "']")
      if (newSelectedRow) {
        this.selectRow(newSelectedRow)
      } else {
        this.selectedRow = null
      }
    }
  }

  shouldExcludeFromSelling(itemKlass) {
    return itemKlass.getTypeName() === "Gold" || itemKlass.isTerrain()
  }

  cleanup() {
    Array.from(this.el.querySelectorAll(".inventory_slot")).forEach((inventorySlot) => {
      this.game.resetInventorySlot(inventorySlot)
    })
  }

}



module.exports = TradeMenu

},{"./../../../common/helper":664,"./../../../common/util/protocol":686,"./../entities/buildings/index":250,"./../entities/equipments/index":407,"./../entities/item":443,"./../entities/mobs/index":464,"./../entities/ores/index":494,"./../util/socket_util":654,"./base_menu":581}],641:[function(require,module,exports){
const SocketUtil = require("./../util/socket_util")
const BaseMenu = require("./base_menu")
const Constants = require("./../../../common/constants.json")
const ClientHelper = require("./../util/client_helper")

class TutorialMenu extends BaseMenu {

  onMenuConstructed() {
    this.tutorialIndex = {}
    this.tutorialIndex["main"] = 0
    this.tutorialIndex["corpse"] = 0
  }

  getMaxTutorialSteps(name) {
    return Object.keys(Constants.Tutorial[name]).length
  }

  isModal() {
    return false
  }

  createTutorialCategory(name) {
    this.tutorialIndex[name] = 0
  }

  fadeIn(name) {
    let element = document.querySelector(".tutorial_text." + name)
    let fadeInTween = ClientHelper.getFadeTween(element, 0, 1, 0, 3000)
    fadeInTween.start()
  }

  onCancelBtnClick() {
    document.querySelector("#tutorial_toggle_btn").style.display = 'block'
    this.close()
  }

  update(data) {
    if (typeof this.tutorialIndex[data.name] === "undefined") {
      this.fadeIn(data.name)
    }

    this.tutorialIndex[data.name] = data.tutorialIndex
    this.updateTutorialText(data.name)

    this.hideIfComplete()
  }

  hideIfComplete() {
    if (this.isTutorialComplete()) {
      this.hide()       
    }
  }

  isTutorialComplete() {
    let content = ""
    Array.from(document.querySelectorAll(".tutorial_text")).forEach((tutorialText) => {
      content += tutorialText.innerText
    })

    return content.length === 0
  }

  open() {
    this.updateTutorialText("main")

    this.el.style.display = 'block'
  }

  hide() {
    this.cleanup()
  }

  cleanup() {
    document.getElementById("tutorial_menu").style.display = 'none'
  }

  updateTutorialText(name) {
    let index = this.tutorialIndex[name]

    if (index === -1 || index === this.getMaxTutorialSteps(name)) {
      this.el.querySelector(".tutorial_text." + name).innerText = ""
    } else {
      let text = Constants.Tutorial[name][index]
      this.el.querySelector(".tutorial_text." + name).innerText = text
    }
  }

}

module.exports = TutorialMenu
},{"./../../../common/constants.json":656,"./../util/client_helper":649,"./../util/socket_util":654,"./base_menu":581}],642:[function(require,module,exports){
const SocketUtil = require("./../util/socket_util")
const BaseMenu = require("./base_menu")
const Constants = require("./../../../common/constants.json")
const FirebaseClientHelper = require('./../util/firebase_client_helper')

class UserProfileMenu extends BaseMenu {
  onMenuConstructed() {
  }

  initListeners() {
    super.initListeners()

    document.querySelector(".visit_colony_btn").addEventListener("click", this.onVisitColonyBtnClick.bind(this), true)
    document.querySelector(".user_colonies").addEventListener("click", this.onUserColoniesClick.bind(this), true)
  }

  onVisitColonyBtnClick() {
    if (this.userData) {
      let sector = this.userData.sector

      let data = {
        name: sector.name,
        daysAlive: sector.dayCount,
        sectorId: sector.uid
      }

      this.getGameExplorer().visitSector(data)
    }
  }

  onUserColoniesClick(e) {
    let colonyEntry = e.target.closest('.user_colony_entry')
    if (colonyEntry) {
      let sectorUid = colonyEntry.dataset.uid
      let daysAlive = colonyEntry.dataset.days
      let data = {
        name: colonyEntry.querySelector(".user_colony_name").innerText,
        daysAlive: daysAlive,
        sectorId: sectorUid
      }
      this.getGameExplorer().visitSector(data)
    }
  }

  getGameExplorer() {
    return this.game.main.gameExplorer
  }

  async open(options = {}) {
    options.dontCloseMenus = true

    super.open(options)

    this.uid = options.uid
    this.username = options.username

    if (this.uid) {
      document.querySelector("#user_profile_menu .guest_account_label").style.display = 'none'

      let result = await this.game.main.getUserRecord(this.uid)
      if (!result.error) {
        this.userData = result
        this.renderAccount()
      } else {
        this.userData = null
        this.renderAnonymous()
      }
    } else {
      this.userData = null
      this.renderAnonymous()
    }
  }

  renderAccount() {
    let sector = this.userData.sector
    let colonies = this.userData.saves

    document.querySelector("#user_profile_menu .username_header").innerText = this.username
    document.querySelector("#user_profile_menu .user_profile_details").style.display = 'block'

    if (sector && !sector.isPrivate) {
      document.querySelector("#user_profile_menu .visit_colony_btn").style.display = 'inline-block'
      document.querySelector("#user_profile_menu .colony_name").innerText = sector.name
      document.querySelector("#user_profile_menu .colony_day_count").innerText = sector.dayCount
    } else {
      document.querySelector("#user_profile_menu .visit_colony_btn").style.display = 'none'
    }

    document.querySelector(".user_colonies").innerHTML = ""

    let isMe = this.game.main.user && this.game.main.user.uid === this.userData.uid 

    for (let sectorUid in colonies) {
      let colony = colonies[sectorUid]

      if (colony.isPrivate) {
      } else {
        this.createColonyEntry(colony)
      }
    }
  }

  createColonyEntry(colony) {
    let entry = "<div class='user_colony_entry' data-uid='" + colony.uid + "' data-days='" + colony.daysAlive + "'>" + 
                  "<div class='user_colony_name'>" + colony.name + "</div>" +    
                  "<div class='user_colony_visit_btn ui_btn'>" + i18n.t('Visit') + "</div>" +    
                  "<div class='user_colony_day_count'>" + colony.daysAlive + " " + i18n.t('Days') + "</div>" +    
                "</div>"

    document.querySelector(".user_colonies").innerHTML += entry
  }

  renderAnonymous() {
    document.querySelector("#user_profile_menu .username_header").innerText = this.username
    document.querySelector("#user_profile_menu .user_profile_details").style.display = 'none'
    document.querySelector("#user_profile_menu .visit_colony_btn").style.display = 'none'

    document.querySelector("#user_profile_menu .guest_account_label").style.display = 'block'
  }

}



module.exports = UserProfileMenu 
},{"./../../../common/constants.json":656,"./../util/firebase_client_helper":651,"./../util/socket_util":654,"./base_menu":581}],643:[function(require,module,exports){
const SocketUtil = require("./../util/socket_util")
const StorageMenu = require("./storage_menu")
const Constants = require("./../../../common/constants.json")
const Item = require("./../entities/item")

class VendingMachineMenu extends StorageMenu {

  onMenuConstructed() {
    super.onMenuConstructed()

    this.errorMessage = this.el.querySelector(".error_message")
  }

  initListeners() {
    super.initListeners()

    this.el.querySelector(".vending_machine_tab_container").addEventListener("click", this.onVendingMachineTabClick.bind(this), true)
    this.el.querySelector(".purchasable_items_list").addEventListener("click", this.onPurchasableItemsClick.bind(this), true)
    this.el.querySelector(".buy_btn").addEventListener("click", this.onBuyBtnClick.bind(this), true)
    this.el.querySelector(".collect_money_btn").addEventListener("click", this.onWithdrawBtnClick.bind(this), true)
  }

  onStorageInventoryUpdated() {
    this.renderPurchasables()
  }

  updateStorageGoldAmount() {
    this.el.querySelector(".collected_money_value").innerText = this.entity.getGold() 
  }

  open(label, entity) {
    super.open(label, entity)

    this.updateStorageGoldAmount()
    this.renderManageTab()
    this.renderWithdrawBtn()

    // reset row selection
    if (this.selectedRow) {
      this.unselectRow(this.selectedRow)
    }

    this.selectTab(this.el.querySelector(".vending_machine_tab[data-tab='purchase']"))
  }

  renderManageTab() {
    if (this.game.player.isGuest()) {
      this.el.querySelector(".vending_machine_tab[data-tab='manage']").style.display = 'none'
    } else {
      this.el.querySelector(".vending_machine_tab[data-tab='manage']").style.display = 'inline-block'
    }
  }

  renderWithdrawBtn() {
    let team = this.game.player.getTeam()
    if (this.game.isLeaderAndOwner(this.entity, team, this.game.player)) {
      this.el.querySelector(".collect_money_btn").style.display = 'block'
    } else {
      this.el.querySelector(".collect_money_btn").style.display = 'none'
    }
  }

  onWithdrawBtnClick(e) {
    SocketUtil.emit("EditBuilding", { id: this.entity.getId(), action: 'withdraw' })
  }

  displayError(message) {
    this.errorMessage.innerText = message

    setTimeout(() => {
      this.errorMessage.innerText = ""
    }, 3000)
  }

  onBuyBtnClick() {
    if (!this.selectedRow) return
    if (this.el.querySelector(".buy_btn").dataset.disabled === "true") return

    let group = this.selectedRow.dataset.group
    let type = this.selectedRow.dataset.type
    let index = parseInt(this.selectedRow.dataset.index)

    SocketUtil.emit("Trade", { group: group, type: type, count: 1, recipientId: this.entity.getId(), index: index })
  }

  onPurchasableItemsClick(event) {
    if (this.selectedRow) {
      this.unselectRow(this.selectedRow)
    }

    let row = event.target.closest(".trade_item_row")

    if (row) {
      this.selectRow(row)
    }
  }

  unselectRow(row) {
    this.selectedRow = null

    if (row) {
      row.dataset.selected = false
    }
  }

  selectRow(row) {
    this.selectedRow = row
    this.selectedRow.dataset.selected = true
  }


  onCraftSuccess(data) {
    let rect = this.el.querySelector(".buy_btn").getBoundingClientRect()
    data.y = rect.top - 20
    data.x = rect.left - 50

    this.game.animateCraftSuccess(data)
  }

  renderPurchasables() {
    let rows = ""
    for (let index in this.storage) {
      let item = this.storage[index]
      let itemKlass = Item.getKlass(item.type)
      rows += this.createTradeItem(itemKlass, { count: item.count, index: index })
    }

    this.el.querySelector(".purchasable_items_list").innerHTML = rows

    if (rows.length === 0) {
      this.el.querySelector(".purchase_empty_state").style.display = 'block'
    } else {
      this.el.querySelector(".purchase_empty_state").style.display = 'none'
    }


    if (this.selectedRow) {
      let type = this.selectedRow.dataset.type
      let index = this.selectedRow.dataset.index
      let tradeItemRow = this.el.querySelector(`.trade_item_row[data-type='${type}'][data-index='${index}'`)
      if (tradeItemRow) {
        this.selectRow(tradeItemRow)
      }
    }

  }

  updateGoldCount(gold) {
    this.el.querySelector(".player_gold_count_value").innerText = gold || 0
  }

  onVendingMachineTabClick(e) {
    let tab = e.target.closest('.vending_machine_tab')
    if (!tab) return

    this.selectTab(tab)
  }

  selectTab(tab) {
    let selectedTab = this.el.querySelector('.vending_machine_tab.selected')
    if (selectedTab) {
      selectedTab.classList.remove("selected")
    }

    tab.classList.add("selected")

    let filter = tab.dataset.tab

    let content = this.el.querySelector(".vending_machine_tab_content[data-tab='" + filter + "']")
    if (content) {
      let activeContent = this.el.querySelector(".vending_machine_tab_content.active")
      if (activeContent) {
        activeContent.classList.remove("active")
      }

      content.classList.add("active")
    }

  }

}

module.exports = VendingMachineMenu

},{"./../../../common/constants.json":656,"./../entities/item":443,"./../util/socket_util":654,"./storage_menu":632}],644:[function(require,module,exports){
const SocketUtil = require("./../util/socket_util")
const BaseMenu = require("./base_menu")
const Constants = require("./../../../common/constants.json")
const Helper = require("./../../../common/helper")

class VoteMenu extends BaseMenu {
  onMenuConstructed() {
    this.votes = {}
  }

  initListeners() {
    super.initListeners()

    this.el.querySelector(".vote_player_list").addEventListener("click", this.onVotePlayerListClick.bind(this), true)
    this.el.querySelector(".vote_action_container").addEventListener("click", this.onVoteActionContainerClick.bind(this), true)
  }

  onVotePlayerListClick(e) {
    let playerCell = e.target.closest(".vote_player_cell")
    if (playerCell && !playerCell.classList.contains("dead")) {
      this.selectPlayer(playerCell)
    }
  }

  onVoteActionContainerClick(e) {
    let voteBtn = e.target.closest(".vote_btn")
    if (voteBtn) {
      SocketUtil.emit("SendVote", { targetPlayerId: this.selectedPlayerId })      
    }

    let skipVoteBtn = e.target.closest(".skip_vote_btn")
    if (skipVoteBtn) {
      this.selectedPlayerId = null
      SocketUtil.emit("SendVote", { targetPlayerId: 0 })      
    }
  }

  setVotingEndTimestamp(votingEndTimestamp) {
    this.votingEndTimestamp = votingEndTimestamp

    this.timerInterval = setInterval(() => {
      let secondsRemaining = Math.floor((this.votingEndTimestamp - this.game.timestamp) / Constants.physicsTimeStep)

      let formattedTime = Helper.stringifyTimeShort(secondsRemaining)
      this.el.querySelector(".vote_timer").innerText = formattedTime

      if (secondsRemaining <= 0) {
        clearInterval(this.timerInterval)
      }
    }, 1000)
  }

  selectPlayer(playerCell) {
    if (this.hasVoted()) return

    let selected = this.el.querySelector(".vote_player_cell.selected")
    if (selected) {
      selected.classList.remove("selected")
    }

    playerCell.classList.add('selected')
    let playerId = playerCell.dataset.playerId
    this.selectedPlayerId = playerId
  }

  open(options = {}) {
    super.open(options)

    this.isFinal = false
    this.votes = {}

    this.game.chatMenu.open({ dontCloseMenus: true })
    this.game.chatMenu.setVoteMode(true)

    this.renderPlayers(this.game.sector.originalPlayers)
    this.renderActionButtons()

    this.game.denyMenuOpen()
  }

  rerenderPlayers() {
    if (!this.game.sector) return
    this.renderPlayers(this.game.sector.originalPlayers)
  }

  isControllingPlayerRequired() {
    return false
  }

  close() {
    this.game.chatMenu.setVoteMode(false)
    if (this.game.sector && !this.game.sector.shouldShowChat()) {
      this.game.chatMenu.hide()
    }
    super.close()
    this.game.allowMenuOpen()
  }

  getMostVotedPlayerId() {
    let highestVoteCount = 0
    let result = null

    for (let targetPlayerId in this.votes) {
      let voteCount = this.votes[targetPlayerId]
      if (voteCount > highestVoteCount) {
        result = parseInt(targetPlayerId)
        highestVoteCount = voteCount
      }
    }

    return result
  }

  updateVote(data) {
    if (data.isFinal) {
      this.isFinal = true
      this.votes = {}
      for (let targetPlayerId in data.voteResults) {
        let count = data.voteResults[targetPlayerId]
        this.votes[targetPlayerId] = count
      }
    } else {
      for (let sourcePlayerId in data.voteResults) {
        this.votes[sourcePlayerId] = true
      }
    }

    this.renderPlayers(this.game.sector.originalPlayers)
    this.renderActionButtons()
  }

  renderActionButtons() {
    if (!this.game.player) return

    if (this.votes[this.game.player.getId()]) {
      this.el.querySelector(".vote_action_container").style.display = 'none'
    } else {
      this.el.querySelector(".vote_action_container").style.display = 'block'
    }
  }

  renderPlayers(players) {
    let el = ""
    for (let id in players) {
      let player = players[id]
      el += this.createVotePlayerEl(player)
    }
    
    this.el.querySelector(".vote_player_list").innerHTML = el
  }

  hasVoted() {
    return this.votes[this.game.player.id]
  }

  createVotePlayerEl(player) {
    let voteResult = this.votes[player.id] || 0
    let votedEl = (voteResult && !this.isFinal) ? i18n.t("Voted") : ""

    let suitColor = "gray"
    if (this.game.sector.originalColors[player.id]) {
      suitColor = this.game.sector.originalColors[player.id]
    }
    
    let avatarPath = suitColor + "_suit.png"
    let isSelected = !this.isFinal && player.id === parseInt(this.selectedPlayerId)
    let voteCount = this.isFinal ? voteResult + " " + i18n.t("votes") : ""
    let mostVotedPlayerId = this.getMostVotedPlayerId()
    let deadClass = (player.health === 0 || player.hasLeftGame) ? "dead" : ""

    let selectedClass 
    if (isSelected) {
      selectedClass = "selected" 
    } else if (this.isFinal && mostVotedPlayerId === player.id) {
      selectedClass = "voted"
    } else {
      selectedClass = ""
    }

    return "<div class='vote_player_cell " + selectedClass + " " + deadClass + "' data-player-id='" + player.id +"'>" + 
      "<img class='vote_player_avatar' src='/assets/images/background/" + avatarPath + "'>" + 
      "<div class='vote_player_name'>" + player.name + "</div>" + 
      "<div class='player_voted'>" + votedEl + "</div>" + 
      "<div class='player_voted_by'>" + voteCount + "</div>" + 
      "<div class='dead_icon'>❌</div>" + 
    "</div>"
  }
  
}



module.exports = VoteMenu 
},{"./../../../common/constants.json":656,"./../../../common/helper":664,"./../util/socket_util":654,"./base_menu":581}],645:[function(require,module,exports){
const SocketUtil = require("./../util/socket_util")
const BaseMenu = require("./base_menu")
const Constants = require("./../../../common/constants.json")
const ClientHelper = require("./../util/client_helper")

class WalkthroughMenu extends BaseMenu {

  onMenuConstructed() {
    this.walkthroughIndex = 1
    this.step = "movement"
  }

  isModal() {
    return false
  }

  onCancelBtnClick() {
    document.querySelector("#tutorial_toggle_btn").style.display = 'block'
    this.close()
  }

  update(data) {
    this.walkthroughIndex = data.index
    this.step = data.step
    this.updateText()

    let isLastWalkthrough = data.step === "end"
    if (isLastWalkthrough) {
      setTimeout(() => {
        this.game.confirmMenu.open({
          message: i18n.t('TutorialCreateNewColonyMessage'),
          proceedCallback: this.game.main.createNewColony.bind(this.game.main)
        })
      }, 4000)
    }
  }

  open() {
    this.updateText()

    this.el.style.display = 'block'
  }

  updateText() {
    let content = i18n.t("Walkthrough." + this.step)
    if (!content) {
      content = i18n.t("Walkthrough" + this.walkthroughIndex)
    }
    
    this.el.querySelector(".walthrough_content").innerHTML = content
  }

}

module.exports = WalkthroughMenu
},{"./../../../common/constants.json":656,"./../util/client_helper":649,"./../util/socket_util":654,"./base_menu":581}],646:[function(require,module,exports){
const SocketUtil = require("./../util/socket_util")
const BaseMenu = require("./base_menu")

class WelcomeMenu extends BaseMenu {
  open(options = {}) {
    super.open(options)

    if (this.game.sector.isTutorial()) {
      document.querySelector(".welcome_menu_header").innerText = i18n.t("Tutorial")
      document.querySelector(".welcome_menu_description").innerText = i18n.t("TutorialWelcomeMessage")
    }


    if (this.game.isAnonymousGame() && this.game.isCreatedByPlayer()) {
      document.querySelector(".welcome_menu_warning_description").innerText = i18n.t('AnonymousGameWarning')
    } else {
      document.querySelector(".welcome_menu_warning_description").innerText = ""
    }
  }

}



module.exports = WelcomeMenu 
},{"./../util/socket_util":654,"./base_menu":581}],647:[function(require,module,exports){
class BetterDedupe {

  constructor() {
    this.name = "BetterDedupe"
    this.pastMessages = {}
    this.pastFingerprintHashes = {}
    this.pastStacktraceHashes  = {}
  }

  setupOnce(addGlobalEventProcessor, getCurrentHub) {
    addGlobalEventProcessor((event) => {
      const self = getCurrentHub().getIntegration(BetterDedupe);
      if (self) {
        if (self._shouldDropEvent(event)) {
          return null
        }
        this.registerEvent(event)
      }

      return event
    });
  }

  registerEvent(event) {
    try {
      if (event.message) {
        this.pastMessages[event.message] = event
      }
      
      this.pastFingerprintHashes[this.getFingerprintHash(event)] = event
      this.pastStacktraceHashes[this.getStacktraceHash(event)] = event
    } catch(e) {

    }
  }

  _shouldDropEvent(event) {
    try {
      let isMessageEvent = event.message
      if (isMessageEvent && !this._hasPastMessage(event)) {
        return false
      }

      if (!this._hasPastFingerprint(event)) {
        return false
      }

      if (!this._hasPastStacktrace(event)) {
        return false
      }

      return true
    } catch(e) {
      return false
    }
  }

  getFingerprintHash(event) {
    if (!event.fingerprint) return ""

    return event.fingerprint.join('')
  }

  getStacktraceHash(event) {
    if (!event.exception) return "" 
    if (!event.exception.values) return "" 

    let frames = this._getFramesFromEvent(event)
    if (!frames) return ""

    let stringifiedFrames = frames.map((frame) => {
      return [frame.filename, frame.lineno, frame.colno, frame.function.toString()].join("-")
    }).join("\n")

    return this.hashCode(stringifiedFrames)
  }

  // https://stackoverflow.com/a/7616484
  hashCode(string) {
    let hash = 0, i, chr
    if (string.length === 0) return hash
    for (i = 0; i < string.length; i++) {
      chr   = string.charCodeAt(i)
      hash  = ((hash << 5) - hash) + chr
      hash |= 0 // Convert to 32bit integer
    }
    return hash
  }

  _hasPastMessage(event) {
    return !!this.pastMessages[event.message]
  }

  _hasPastFingerprint(event) {
    return !!this.pastFingerprintHashes[this.getFingerprintHash(event)]
  }

  _hasPastStacktrace(event) {
    return !!this.pastStacktraceHashes[this.getStacktraceHash(event)]
  }
  
  _getFramesFromEvent(event) {
    const exception = event.exception

    if (exception) {
      try {
        return exception.values[0].stacktrace.frames
      } catch (e) {
        return undefined
      }
    } else if (event.stacktrace) {
      return event.stacktrace.frames
    }
    return undefined;
  }


}

BetterDedupe.id = "BetterDedupe"

module.exports = BetterDedupe
},{}],648:[function(require,module,exports){
const Poolable = require("../../../common/interfaces/poolable")
const ObjectPool = require("../../../common/entities/object_pool")

class BitmapText {
  static create(options) {
    let object = ObjectPool.obtain("BitmapText")
    object.setAttributes(options)
    return object
  }

  constructor() {
    const style  = { font : '23px CC Red Alert [INET]', align : 'center' }
    this.sprite = new PIXI.extras.BitmapText("", style)
    this.sprite.anchor.set(0.5)
  }

  wordWrap(text) {
    if (language === 'ja') {
      return this.wordWrapNonspaced(text)
    } else {
      return this.wordWrapSpaced(text)
    }

  }

  wordWrapSpaced(text) {
    let result = ""
    let buffer = ""

    let words = text.split(/\s+/)
    
    for (var i = 0; i < words.length; i++) {
      let word = words[i]
      buffer += word
      buffer += ' '

      if (buffer.length >= 30) {
        result += buffer
        result += "\n"
        buffer = ""
      }
    }

    result += buffer
    return result
  }

  wordWrapNonspaced(text) {
    let result = ""
    let buffer = ""

    for (var i = 0; i < text.length; i++) {
      let char = text[i]
      buffer += char
      if (buffer.length >= 15) {
        result += buffer
        result += "\n"
        buffer = ""
      }
    }

    result += buffer
    return result
  }

  setAttributes(options) {
    let spriteContainer = options.spriteContainer 
    spriteContainer.addChild(this.sprite)

    this.sprite.text = options.text
    this.sprite.name = options.label

    if (options.size) {
      this.sprite.font.size = options.size
    }

    if (options.align) {
      this.sprite.font.align = options.align
    }

    if (typeof options.anchor !== 'undefined') {
      this.sprite.anchor.set(options.anchor)
    }
    
    
    this.sprite.updateText()
  }

  remove() {
    if (this.sprite.parent) {
      this.sprite.parent.removeChild(this.sprite)
    }

    ObjectPool.free("BitmapText", this)
  }

}

Object.assign(BitmapText.prototype, Poolable.prototype, {
  reset() {
    this.sprite.anchor.set(0.5)
    this.sprite.position.x = 0
    this.sprite.position.y = 0
    this.sprite.alpha = 1
    this.sprite.font.size = 23
    this.sprite.tint = 0xffffff
    // not needed. every instance variable is overwritten anyway
  }
})

module.exports = BitmapText
},{"../../../common/entities/object_pool":660,"../../../common/interfaces/poolable":675}],649:[function(require,module,exports){
const BitmapText = require("./bitmap_text")

let cachedPIXIText = {}

module.exports = {
  httpRequest(url, cb) {
    var xhttp = new XMLHttpRequest()
    xhttp.onreadystatechange = function() {
      if (this.readyState == 4 && this.status == 200) {
         cb.success(xhttp.responseText)
      }
    }
    xhttp.onerror = cb.error
    xhttp.open("GET", url, true)
    xhttp.send()

    return xhttp
  },
  escapeHTML(str) {
    return str.replace(/&/g, '&amp;')
             .replace(/</g, '&lt;')
             .replace(/>/g, '&gt;')
             .replace(/"/g, '&quot;')
             .replace(/'/g, '&#039;');
  },
  httpPost(url, body, cb) {
    var xhttp = new XMLHttpRequest()
    xhttp.onreadystatechange = function() {
      if (this.readyState == 4 && this.status == 200) {
         cb.success(xhttp.responseText)
      }
    }

    xhttp.onerror = cb.error

    xhttp.open("POST", url)
    xhttp.setRequestHeader("Content-Type", "application/json;charset=UTF-8")
    xhttp.send(JSON.stringify(body))

    return xhttp
  },
  getKeycode(event) {
    // similar to jquery
    if (event.which == null) {
      return event.charCode != null ? event.charCode : event.keyCode
    }
    
    return event.which
  },
  removeSelfAndChildrens(sprite) {
    if (!sprite) return

    while(sprite.children[0]) {
      this.removeSelfAndChildrens(sprite.children[0])
    }

    if (sprite.parent) {
      sprite.parent.removeChild(sprite)
    }
  },

  toHex(number) {
    let hex = number.toString(16)

    if (hex.length % 2) {
      hex = '0' + hex
    }

    return "#" + hex
  },

  hexToInt(hex) {
    return parseInt(hex.replace("#", ""), 16)
  },

  getTintForSample(sample) {
    let tint = 0xffffff

    switch (sample) {
      case "Player":
        tint = 0xff0000
        break
      case "Alien":
        tint = 0x0000ff
        break
      case "Spider":
        tint = 0x444444
        break
      case "PoisonSpider":
        tint = 0x044304
        break
      case "Water":
        tint = 0x2F5399
        break
      case "Blood":
        tint = 0x840309
        break
      default:
        // nothing
    }

    return tint
  },

  animateExplosion(x, y, options = {}) {
    let spritePath = options.spritePath || "circle.png"
    let minWidth = options.minWidth || 10
    let maxWidth = options.maxWidth || 100
    const sprite = new PIXI.Sprite(PIXI.utils.TextureCache[spritePath])
    sprite.anchor.set(0.5)
    sprite.position.x = x
    sprite.position.y = y

    if (options.tint) {
      sprite.tint = options.tint
    }
    
    game.sector.effectsContainer.addChild(sprite)

    let width = { width: minWidth }

    var tween = new TWEEN.Tween(width)
        .to({ width: maxWidth }, 200)
        .easing(TWEEN.Easing.Quadratic.Out) // Use an easing function to make the animation smooth.
        .onUpdate(() => {
          sprite.width = width.width
          sprite.height = width.width
        })
        .onComplete(() => {
          game.sector.effectsContainer.removeChild(sprite)
        })
        .start()
  },


  animateMineralIncreased(x, y, amount, name) {
    const duration = 1000
    const yLength  = 100

    let text = "+" + amount + " " + name

    if (!cachedPIXIText[text]) {
      let style = { fontFamily : 'Arial', fontSize: 16, fill : 0xffffff, align : 'center', strokeThickness: 5, miterLimit: 3 }
      let pixiText = new PIXI.Text(text, style)
      cachedPIXIText[text] = pixiText 
    }

    let sprite = cachedPIXIText[text]

    game.sector.effectsContainer.addChild(sprite)

    let position = {
      x: x,
      y: y
    }

    sprite.visible = true
    sprite.position.set(position.x, position.y)

    new TWEEN.Tween(position)
        .to({ x: position.x, y: position.y - yLength }, duration)
        .easing(TWEEN.Easing.Quadratic.Out)
        .onUpdate(() => {
          sprite.position.y = position.y
        })
        .onComplete(() => {
          sprite.visible = false
        })
        .start()
  },

  addTrail(x, y, angle, color, radius, offset, isExpanding, spritePath, spriteContainer) {
    spriteContainer = spriteContainer || game.sector.effectsContainer
    spritePath = spritePath || "white_smoke.png"
    const sprite = new PIXI.Sprite(PIXI.utils.TextureCache[spritePath])
    sprite.anchor.set(0.5)

    const distanceFromThurster = 96

    const randomWidth = Math.floor(Math.random() * radius) + 10
    sprite.width = randomWidth
    sprite.height = randomWidth
    sprite.tint = color
    sprite.position.x = x - offset * Math.cos(angle)
    sprite.position.y = y - offset * Math.sin(angle) // opposite y direction

    spriteContainer.addChild(sprite)

    let alpha = { alpha: 1 }
    let maxExpansion = 32
    let origWidth = sprite.width

    var tween = new TWEEN.Tween(alpha)
        .to({ alpha: 0 }, 1500)
        .easing(TWEEN.Easing.Quadratic.Out) // Use an easing function to make the animation smooth.
        .onUpdate(() => {
          sprite.alpha = alpha.alpha
          if (isExpanding) {
            let delta = maxExpansion - alpha.alpha * maxExpansion
            sprite.width  = origWidth + delta
            sprite.height = origWidth + delta
          }
        })
        .onComplete(() => {
          spriteContainer.removeChild(sprite)
        })
        .start()
  },

  addSmoke(x, y, color = 0x999999, minWidth = 20, maxWidth = 50, shouldRandomizeDistance) {
    let data = this.getSmokeTween(x, y, color, minWidth, maxWidth, shouldRandomizeDistance)

    data.tween.start()

    return data
  },

  addBulletTrail(x, y, angle, color, width) {
    this.getBulletTrailTween(x, y, angle, color, width).start()
  },

  // https://stackoverflow.com/a/16360660
  getRandomColorInRange(startColor, endColor, ratio, options = {}) {
    startColor = startColor.replace("#", "")
    endColor   = endColor.replace("#", "")

    let r = Math.ceil(parseInt(startColor.substring(0,2), 16) * ratio + parseInt(endColor.substring(0,2), 16) * (1-ratio))
    let g = Math.ceil(parseInt(startColor.substring(2,4), 16) * ratio + parseInt(endColor.substring(2,4), 16) * (1-ratio))
    let b = Math.ceil(parseInt(startColor.substring(4,6), 16) * ratio + parseInt(endColor.substring(4,6), 16) * (1-ratio))

    const randomColor = this.hex(r) + this.hex(g) + this.hex(b)
    return options.shouldReturnInteger ? parseInt(randomColor, 16) : randomColor
  },

  // colors - [{ hex: '#00ff00', ratio: 0.2 }]
  mixColors(colors) {
    let r = 0
    let g = 0
    let b = 0

    colors.forEach((color) => {
      let hexValue = color.hex.replace("#", "")
      r += Math.ceil(parseInt(hexValue.substring(0,2), 16) * color.ratio)
      g += Math.ceil(parseInt(hexValue.substring(2,4), 16) * color.ratio)
      b += Math.ceil(parseInt(hexValue.substring(4,6), 16) * color.ratio)
    })

    r = Math.min(255, r)
    g = Math.min(255, g)
    b = Math.min(255, b)

    return [r, g, b]
  },

  hex(x) {
    x = x.toString(16);
    return (x.length == 1) ? '0' + x : x
  },

  getGasTween(sprite, x, y, color = 0x999999, minWidth = 20, maxWidth = 50, onComplete) {
    sprite.anchor.set(0.5)

    const randomWidth = Math.floor(Math.random() * (maxWidth - minWidth)) + minWidth
    sprite.alpha = 0.1
    sprite.width = randomWidth
    sprite.height = randomWidth
    sprite.tint = color
    sprite.position.x = x
    sprite.position.y = y

    let prop = { alpha: 0.1, width: randomWidth }

    let expand = new TWEEN.Tween(prop)
        .to({ alpha: 0.9, width: prop.width + 64 }, 3000)
        .easing(TWEEN.Easing.Quadratic.Out) // Use an easing function to make the animation smooth.
        .onUpdate(() => {
          sprite.alpha = prop.alpha
          sprite.width = prop.width
          sprite.height = prop.width
        })
        .onComplete(() => {
        })

    alpha = { alpha: 0.9 }

    let vanish = new TWEEN.Tween(alpha)
        .to({ alpha: 0 }, 3000)
        .easing(TWEEN.Easing.Quadratic.Out) // Use an easing function to make the animation smooth.
        .onUpdate(() => {
          sprite.alpha = alpha.alpha
        })
        .onComplete(() => {
          onComplete()
        })

    return expand.chain(vanish)
  },

  getSmokeTween(x, y, color = 0x999999, minWidth = 20, maxWidth = 50, shouldRandomizeDistance = true) {
    const sprite = new PIXI.Sprite(PIXI.utils.TextureCache["white_smoke.png"])
    sprite.anchor.set(0.5)

    const randomDistanceX = shouldRandomizeDistance ? Math.floor(Math.random() * 64) - 32 : 0
    const randomDistanceY = shouldRandomizeDistance ? Math.floor(Math.random() * 64) - 32 : 0

    const randomWidth = Math.floor(Math.random() * (maxWidth - minWidth)) + minWidth
    sprite.width = randomWidth
    sprite.height = randomWidth
    sprite.tint = color
    sprite.position.x = x - randomDistanceX
    sprite.position.y = y - randomDistanceY

    game.sector.effectsContainer.addChild(sprite)

    let alpha = { alpha: 0.8 }

    var tween = new TWEEN.Tween(alpha)
        .to({ alpha: 0 }, 3000)
        .easing(TWEEN.Easing.Quadratic.Out) // Use an easing function to make the animation smooth.
        .onUpdate(() => {
          sprite.alpha = alpha.alpha
        })
        .onComplete(() => {
          game.sector.effectsContainer.removeChild(sprite)
        })

    return {
      sprite: sprite,
      tween: tween
    }
  },

  getFadeTween(element, before, after, delay, duration = 1000) {
    if (element.style.display === 'none' && before === 0) {
      element.style.display = 'block'
      element.style.opacity = '0'
    }

    let opacity = { opacity: before }
    let tween = new TWEEN.Tween(opacity)
        .to({ opacity: after }, duration)
        .easing(TWEEN.Easing.Quadratic.Out) // Use an easing function to make the animation smooth.
        .onUpdate(() => {
          element.style.opacity = opacity.opacity
        })
        .onComplete(() => {
          if (after === 0) {
            element.style.display = 'none'
          }
        })
        .delay(delay)

    return tween
  },

  getBulletTrailTween(x, y, angle, color = 0x999999, width = 8) {
    const sprite = new PIXI.Sprite(PIXI.utils.TextureCache["bullet_trail.png"])
    sprite.anchor.set(0.5)
    sprite.rotation = angle

    sprite.width = 32
    sprite.height = width
    sprite.tint = color
    sprite.position.x = x
    sprite.position.y = y

    game.sector.effectsContainer.addChild(sprite)

    let alpha = { alpha: 0.8 }

    var tween = new TWEEN.Tween(alpha)
        .to({ alpha: 0 }, 400)
        .easing(TWEEN.Easing.Quadratic.Out) // Use an easing function to make the animation smooth.
        .onUpdate(() => {
          sprite.alpha = alpha.alpha
        })
        .onComplete(() => {
          game.sector.effectsContainer.removeChild(sprite)
        })

    return tween
  },

  replaceQueryParam(param, newval, search) {
      var regex = new RegExp("([?;&])" + param + "[^&;]*[;&]?");
      var query = search.replace(regex, "$1").replace(/&$/, '');

      return (query.length > 2 ? query + "&" : "?") + (newval ? param + "=" + newval : '');
  }



}

},{"./bitmap_text":648}],650:[function(require,module,exports){
const BetterDedupe = require("./better_dedupe")

const dedupeIntegration = new BetterDedupe()


const ExceptionReporter = {
  init: () => {
    // https://github.com/quasarframework/quasar/issues/2233
    
    Sentry.init({ 
      dsn: 'https://51a838887e50448d8a5370ff84c2932c@sentry.io/1467965', 
      release: ["junon-io@", window.revision].join(""),
      maxBreadcrumbs: 100,
      integrations: [dedupeIntegration],
      ignoreErrors: ['ResizeObserver loop limit exceeded', 'interrupted connection or unreachable host', 'Network Error', 'Extension context invalidated']
    })

    this.initialized = true
  },
  getDedupeInstance() {
    return dedupeIntegration
  },
  getSentryInstance() {
    return Sentry
  },
  captureException: (e) => {
    console.error(e)

    if (typeof debugMode !== "undefined" && debugMode) {
      return
    }

    if (!this.initialized) ExceptionReporter.init()
    Sentry.captureException(e)
  }
}

module.exports = ExceptionReporter

},{"./better_dedupe":647}],651:[function(require,module,exports){
const Config = require("junon-common/config")
const ExceptionReporter = require("./../util/exception_reporter")
const Cookies = require("js-cookie")

class FirebaseClientHelper {

  static async getServerAnnouncement() {
    if (firebase.apps.length === 0) return 
    let snapshot = await firebase.database().ref(`/announcement`).once('value')
    return snapshot.val()
  }

  static createFirebaseUser(uid, username, cb) {
    firebase.database().ref('users/' + uid).set({
      username: username
    }, (error) => {
      if (error) return cb(error)
      cb()
    })
  }

  static isElectron() {
    var userAgent = navigator.userAgent.toLowerCase();
    return userAgent === 'chrome' 
    // electron app modified userAgent to be chrome
    // to work 
    // https://stackoverflow.com/a/59722822
  }

  static signIn(providerName) {
    let provider  
    if (providerName === 'google') {
      provider = this.googleProvider
    } else if (providerName === 'facebook') {
      provider = this.facebookProvider
    } else {
      provider = this.googleProvider
    }

    if (main.isMobile || this.isElectron()) {
      firebase.auth().signInWithRedirect(provider)
      return
    }

    firebase.auth().signInWithPopup(provider).then((result) => {
      let token = result.credential.accessToken
      let user = result.user

      this.onSignInSuccessful(user)
    }).catch((error) => {
      this.onSignInError(error)
    })
  }

  static onSignInError(error) {
    document.querySelector("#login_btn").style.display = 'none'
    document.querySelector("#social_login_container").style.display = 'none'

    document.querySelector(".login_error").style.display = 'block'
    document.querySelector(".login_error_message").innerText = error.message
  }

  static onSignInSuccessful(user) {
    Cookies.set("uid", user.uid)  
    Cookies.set("email", user.email)  
  }

  static signOut(cb) {
    firebase.auth().signOut().then(() => {
      Cookies.remove("uid")  
      Cookies.remove("email")  
      cb()
    }).catch((error) => {
      alert("Logout failed")
    })
  }

  static initFirebase(callback) {
    firebase.initializeApp(Config[env].firebase)
    this.googleProvider = new firebase.auth.GoogleAuthProvider()
    this.facebookProvider = new firebase.auth.FacebookAuthProvider()

    firebase.auth().onAuthStateChanged((user) => {
      callback(user)
    })

    firebase.auth().getRedirectResult().then((result) => {
      let user = result.user
      if (user) {
        this.onSignInSuccessful(user)
      }
    }).catch((error) => {
      this.onSignInError(error)
    })
  }

  static getUIConfig() {
    let signInType = main.isMobile ? 'redirect' : 'popup'

    return {
      callbacks: {
        signInSuccessWithAuthResult: (authResult, redirectUrl) => {
          if (authResult.user) {
          }

          return false // Do not redirect.
        },
        uiShown: () => {
          let img = document.querySelector(".firebaseui-idp-google .firebaseui-idp-icon")
          let googleIconBasePath = "/assets/images/google_white_icon.png"

          if (!img) return

          if (this.isItchPage()) {
            img.src = window.location.href.replace("/index.html", googleIconBasePath)
          } else {
            img.src = googleIconBasePath
          }
        }
      },
      signInFlow: signInType,
      signInOptions: [
        firebase.auth.GoogleAuthProvider.PROVIDER_ID,
        firebase.auth.FacebookAuthProvider.PROVIDER_ID
      ]
    }
  }

  static initFirebaseUI() {
    // this.ui.start('#firebaseui-auth-container', this.getUIConfig())
  }

  static rerenderFirebaseLoginUI() {
    // this.ui.start('#firebaseui-auth-container', this.getUIConfig())
  }

  static isItchPage() {
    return window.location.hostname.match("hwcdn.net")  
  }

  static listenToFirebaseAuth(cb) {
    firebase.auth().onAuthStateChanged(cb)
  }

  static fetchFirebaseIdToken(cb) {
    let forceRefresh = true
    firebase.auth().currentUser.getIdToken(forceRefresh).then((idToken) => {
      cb(idToken)
    }).catch((e) => {
      ExceptionReporter.captureException(e)
      cb(null)
    })
  }

  static isLoggedIn() {
    return firebase.auth().currentUser
  }

  static getFirebaseInstance() {
    return firebase
  }

}

module.exports = FirebaseClientHelper
},{"./../util/exception_reporter":650,"js-cookie":58,"junon-common/config":59}],652:[function(require,module,exports){
const Constants = require('../../../common/constants.json')
const Helper = require("./../../../common/helper")

class Interpolator {
  constructor(target) {
    this.setTarget(target)
    this.reset()
    this.initTimestepFraction()
  }

  setTarget(target) {
    this.target = target
  }

  reset() {
    this.position = this.target.position

    this.targetPosition  = { }
    this.distanceToCover = { x: 0, y: 0 }
    this.distanceCovered = { x: 0, y: 0 }
    this.distanceCoveredThisFrame = { x: 0, y: 0 }

    this.rotationToCover = 0
    this.rotationCovered = 0
    
    this.position_buffer = []
    this.rotation_buffer = []
    this.expansion_buffer = []
    this.lastDistanceStep = [0,0]

  }

  initTimestepFraction() {
    // 1 timestep === duration of lag
    let millisecondsPerFrame = 16
    let averageLag = 400 // will wait this much before rendering
    let millisecondsPerTimestep = averageLag
    this.timestepFraction = millisecondsPerFrame / millisecondsPerTimestep
  }

  static mixin(target) {
    target.interpolator = new Interpolator(target)

    this.defineMethods(target)

    return target.interpolator
  }

  static defineMethods(target) {
    target.setImmediatePosition = (x, y)          => { target.interpolator.setImmediatePosition(x, y) }
    target.instructToMove       = (x, y)          => { target.interpolator.instructToMove(x, y) }
    target.instructToRotate     = (rotation)      => { target.interpolator.instructToRotate(rotation) }
    target.instructToExpand     = (width)         => { target.interpolator.instructToExpand(width) }
    target.interpolate          = (lastFrameTime) => { target.interpolator.interpolate(lastFrameTime) }
    target.interpolateRotation  = (lastFrameTime) => { target.interpolator.interpolateRotation(lastFrameTime) }
    target.interpolateExpansion = (lastFrameTime) => { target.interpolator.interpolateExpansion(lastFrameTime) }
  }

  hasCoveredDistance() {
    let margin = 1 // account for floating point inaccuracies (i.e x being 1.999 instead of 2)

    let result = this.distanceCovered.x >= (Math.abs(this.distanceToCover.x) - margin) &&
                 this.distanceCovered.y >= (Math.abs(this.distanceToCover.y) - margin)

    return result
  }

  interpolate(lastFrameTime) {
    let hasNoTargetPosition = typeof this.targetPosition.x === "undefined"
    if (hasNoTargetPosition) return

    let isSamePosition = this.targetPosition.x === this.position.x && this.targetPosition.y === this.position.y
    if (isSamePosition) return

    if(this.hasCoveredDistance()) {
      this.onNoPositionAvailable()
      // stop interpolating
      this.position.x = this.targetPosition.x
      this.position.y = this.targetPosition.y
      return
    }

    let isPositionTooFar = Helper.distance(this.targetPosition.x, this.targetPosition.y, this.position.x, this.position.y) > (Constants.tileSize * 30)
    if (isPositionTooFar) {
      this.setImmediatePosition(this.targetPosition.x, this.targetPosition.y)
      return
    }

    let elapsedTime = Date.now() - lastFrameTime

    let distanceCoveredThisFrameX = elapsedTime * this.allowedDistancePerMillisecond(this.distanceToCover.x)
    let distanceCoveredThisFrameY = elapsedTime * this.allowedDistancePerMillisecond(this.distanceToCover.y)

    this.distanceCoveredThisFrame.x = Math.abs(distanceCoveredThisFrameX)
    this.distanceCoveredThisFrame.y = Math.abs(distanceCoveredThisFrameY)

    this.distanceCovered.x += this.distanceCoveredThisFrame.x
    this.distanceCovered.y += this.distanceCoveredThisFrame.y

    // console.log("speed: " + (distanceCoveredThisFrameY / (Date.now() - lastFrameTime)).toFixed(2) + " , ticksSincePacket: " + game.ticksSincePacket )

    this.position.x += distanceCoveredThisFrameX
    this.position.y += distanceCoveredThisFrameY

    this.lastDistanceStep = [distanceCoveredThisFrameX, distanceCoveredThisFrameY]
  }

  allowedDistancePerMillisecond(distance) {
    let millisecondsToRenderPacket 

    if (game.firstTenSecondsMaxUpstreamInterval && game.firstTenSecondsMaxUpstreamInterval > 250) {
      // cant be slower than 400
      millisecondsToRenderPacket = Math.min(350, game.firstTenSecondsMaxUpstreamInterval)
    } else if (game.firstTenSecondsMaxUpstreamInterval && game.firstTenSecondsMaxUpstreamInterval > 150) {
      millisecondsToRenderPacket = Math.min(250, game.firstTenSecondsMaxUpstreamInterval)
    } else {
      millisecondsToRenderPacket = 150 // assume quick at first, then if turns out its slow, use duration above
    }

    return distance / (millisecondsToRenderPacket / game.resolution)
  }

  instructToMove(x,y) {
    let isSamePosition = this.targetPosition.x === x && this.targetPosition.y === y
    if (isSamePosition) return

    this.targetPosition = { x: x, y: y }

    this.distanceToCover = { 
      x: x - this.position.x,
      y: y - this.position.y
    }

    this.distanceCovered = { x: 0, y: 0 }
  }

  instructToRotate(rotation) {
    let isSameRotation = this.targetRotation === rotation
    if (isSameRotation) return

    this.targetRotation = rotation

    this.rotationToCover = Helper.angleDeltaSigned(rotation, this.target.rotation)
    this.rotationCovered = 0
  }

  instructToExpand(width) {
    let timestamp = (new Date()).getTime()

    this.expansion_buffer.push({
      timestamp: timestamp,
      width: width
    })

  }

  interpolateRotation(lastFrameTime) {
    let hasCoveredRotation = this.rotationCovered >= Math.abs(this.rotationToCover) 

    if(hasCoveredRotation && (typeof this.targetRotation !== "undefined")) {
      // stop interpolating
      // this.target.rotation = this.targetRotation
      this.targetRotation = null
      return
    }

    let rotationCoveredThisFrame = this.timestepFraction * this.rotationToCover

    this.rotationCovered += Math.abs(rotationCoveredThisFrame)
    this.target.rotation += rotationCoveredThisFrame
  }


  interpolateExpansion(lastFrameTime) {
    let server_update_rate = Constants.physicsTimeStep
    let render_timestamp = lastFrameTime - (1000.0 / server_update_rate)

    // Find the two authoritative positions surrounding the rendering timestamp.
    let buffer = this.expansion_buffer

    // Drop older positions.
    while (buffer.length >= 2 && buffer[1].timestamp <= render_timestamp) {
      buffer.shift()
    }

    // Interpolate between the two surrounding authoritative positions.
    if (buffer.length >= 2 && buffer[0].timestamp <= render_timestamp && render_timestamp <= buffer[1].timestamp) {
      let width0 = buffer[0].width
      let width1 = buffer[1].width
      let t0 = buffer[0].timestamp
      let t1 = buffer[1].timestamp

      this.target.width = width0 + (width1 - width0) * (render_timestamp - t0) / (t1 - t0)
      this.target.height = width0 + (width1 - width0) * (render_timestamp - t0) / (t1 - t0)
    }

  }


  setImmediatePosition(x, y) {
    this.position.x = x
    this.position.y = y

    this.distanceCovered = this.distanceToCover = { x: 0, y: 0 }
    this.targetPosition = {}
  }

  setOnNoPositionAvailableListener(listener) {
    this.onNoPositionAvailableListener = listener
  }

  onNoPositionAvailable() {
    if (this.onNoPositionAvailableListener) {
      this.onNoPositionAvailableListener()
    }
  }

}

module.exports = Interpolator

},{"../../../common/constants.json":656,"./../../../common/helper":664}],653:[function(require,module,exports){
const elementClosest = require('element-closest')
elementClosest(window)

if (typeof Object.values !== "function") {
  Object.values = (items) => {
    return Object.keys(items).map((key) => {
        return items[key]
    })
  } 
}

if (!Array.from) {
    Array.from = function (object) {
        return [].slice.call(object)
    }
}

Object.defineProperty(Array.prototype, 'flat', {
    value: function(depth = 1) {
      return this.reduce(function (flat, toFlatten) {
        return flat.concat((Array.isArray(toFlatten) && (depth-1)) ? toFlatten.flat(depth-1) : toFlatten);
      }, []);
    }
})

// https://tc39.github.io/ecma262/#sec-array.prototype.includes
if (!Array.prototype.includes) {
  Object.defineProperty(Array.prototype, 'includes', {
    value: function(valueToFind, fromIndex) {

      if (this == null) {
        throw new TypeError('"this" is null or not defined');
      }

      // 1. Let O be ? ToObject(this value).
      var o = Object(this);

      // 2. Let len be ? ToLength(? Get(O, "length")).
      var len = o.length >>> 0;

      // 3. If len is 0, return false.
      if (len === 0) {
        return false;
      }

      // 4. Let n be ? ToInteger(fromIndex).
      //    (If fromIndex is undefined, this step produces the value 0.)
      var n = fromIndex | 0;

      // 5. If n ≥ 0, then
      //  a. Let k be n.
      // 6. Else n < 0,
      //  a. Let k be len + n.
      //  b. If k < 0, let k be 0.
      var k = Math.max(n >= 0 ? n : len - Math.abs(n), 0);

      function sameValueZero(x, y) {
        return x === y || (typeof x === 'number' && typeof y === 'number' && isNaN(x) && isNaN(y));
      }

      // 7. Repeat, while k < len
      while (k < len) {
        // a. Let elementK be the result of ? Get(O, ! ToString(k)).
        // b. If SameValueZero(valueToFind, elementK) is true, return true.
        if (sameValueZero(o[k], valueToFind)) {
          return true;
        }
        // c. Increase k by 1. 
        k++;
      }

      // 8. Return false
      return false;
    }
  });
}

// https://stackoverflow.com/a/31340895/803865
if (!String.prototype.includes) {
    String.prototype.includes = function() {
        'use strict';
        return String.prototype.indexOf.apply(this, arguments) !== -1;
    };
}

},{"element-closest":13}],654:[function(require,module,exports){
class SocketUtil {

  static getInstance() {
    if (!this.instance) {
      this.instance = new SocketUtil()
    }  

    return this.instance
  }

  static init(options) {
    this.getInstance().init(options)  
  }

  static setSocket(socket) {
    this.getInstance().setSocket(socket)  
  }

  static emit(eventName, payload) {
    this.getInstance().emit(eventName, payload)  
  }

  static on(eventName, handler) {
    this.getInstance().on(eventName, handler)  
  }

  static onMessage(e) {
    this.getInstance().onMessage(e)
  }

  static listenToMessages() {
    this.getInstance().listenToMessages(e)
  }

  init(options = {}){
    this.protocol = options.protocol
    this.options = options

    this.handlers = {}

    this.isOnMessageRegistered = false
  }

  setSocket(socket) {
    this.socket = socket
    this.isOnMessageRegistered = false
    this.listenToMessages()
  }

  emit(eventName, payload) {
    if (!this.socket) return
    if (this.socket.readyState !== WebSocket.OPEN) {
      return
    }

    const messageProtocol = this.protocol[eventName]
    if (!messageProtocol) {
      throw "The message '" + eventName + "' is not defined in Protocol Buffer file app.proto"
    }
    const message = this.protocol[eventName].create(payload)

    const wrappedMessage = {}
    wrappedMessage[eventName] = message

    const messageWrapper = this.protocol.MessageWrapper.create(wrappedMessage)
    const uint8Array  = this.protocol.MessageWrapper.encode(messageWrapper).finish()

    if (env === "development") {
      const isEncodingFailed = uint8Array.length === 0
      if (isEncodingFailed) {
        throw "Failed to binary encode " + eventName + " : " + JSON.stringify(payload) + " . Make sure event is included in MessageWrapper#oneof list"
      }
    }

    const copy = new Uint8Array(uint8Array.length)
    uint8Array.forEach((value, index) => { copy[index] = value; })

    this.socket.send(copy.buffer)
  }

  on(eventName, handler) {
    this.handlers[eventName] = handler
  }

  onMessage(e) {
    const arrayBuffer = e.data
    const uint8Array = new Uint8Array(arrayBuffer)

    const messageWrapper = this.protocol.MessageWrapper.decode(uint8Array)
    const data = messageWrapper[messageWrapper.kind]

    const isMessageHandlerDefined = typeof this.handlers[messageWrapper.kind] === "function"
    if (!isMessageHandlerDefined) {
      if (this.options.allowMissingHandlers) {
        return
      } else {
        throw new Error("Must implement Socket handler for " + messageWrapper.kind)
      }
    }

    this.handlers[messageWrapper.kind](data)
  }

  listenToMessages() {
    if (this.isOnMessageRegistered) return; // already initialized

    this.socket.onmessage = this.onMessage.bind(this)
    this.isOnMessageRegistered = true
  }

}

module.exports = SocketUtil

},{}],655:[function(require,module,exports){
const ExceptionReporter = require("./../util/exception_reporter")

class SpriteEventHandler {
  static on(sprite, eventName, handler) {
    sprite.on(eventName, (event) => {
      try {
        handler(event)
      } catch(e) {
        ExceptionReporter.captureException(e)
      }
    })
  }
}

module.exports = SpriteEventHandler
},{"./../util/exception_reporter":650}],656:[function(require,module,exports){
module.exports={
  "Control": {
    "up": 1,
    "down": 2,
    "left": 4,
    "right": 8,
    "space": 16
  },
  "globalSpeedMultiplier": 2,
  "maxStackCount": 99,
  "holdItemIndex": 9999,
  "chunkRowCount": 16,
  "chunkColCount": 16,
  "fovViewDistance": 384,
  "maxStorageCount": 48,
  "maxColonyScreenshots": 2,
  "interactDistance": 128,
  "quickInventoryBaseIndex": 0,
  "regularInventoryBaseIndex": 8,
  "inventoryStorageId": 1,
  "autoscreenshotPosition": 99,
  "equipmentStorageId": 2,
  "worldStorageId": 0,
  "defaultVolume": 0.2,
  "defaultBackgroundVolume": 0.1,
  "gameWidth": 9600,
  "gameHeight": 9600,
  "cameraWidth": 544,
  "cameraHeight": 512,
  "floorHeight": 128,
  "secondsPerHour": 25,
  "physicsTimeStep": 10,
  "decayThresholdInSeconds": 600,
  "restartCountdown": 10000,
  "maxAsteroidRadius": 32,
  "minAsteroidRadius": 32,
  "maxPlanetRadius": 150,
  "minPlanetRadius": 50,
  "maxStarRadius": 3,
  "minStarRadius": 1,
  "maxRingRadius": 2200,
  "minRingRadius": 1500,
  "mobSpawnRadiusTileCount": 20,
  "mobSafeSpawnRadiusTileCountDay": 15,
  "mobSafeSpawnRadiusTileCountNight": 10,
  "mobDespawnRadiusTileCount": 25,
  "maxMobActivity": 60,
  "mobSpawnLimitDay": 3,
  "mobSpawnLimitNight": 5,
  "oxygenProductionConsumptionRate": 3,
  "Triggers": {
    "PlayerJoined": {
      "description": "Event triggered when a player joins a game. ",
      "variables": {
        "player": "username of player who joined",
        "playerRole": "role of player who joined"
      }
    },
    "PlayerLeft": {
      "description": "Event triggered when a player leaves a game. ",
      "variables": {
        "player": "username of player who left",
        "playerRole": "role of player who left"
      }
    },
    "PlayerMessage": {
      "description": "Event triggered when a player sends a chat message",
      "variables": {
        "player": "username of player",
        "message": "message sent by player"
      }
    },
    "PlayerAttacked": {
      "description": "Event triggered when a player gets damaged",
      "variables": {
        "player": "username of player got attacked",
        "playerRole": "role of player got attacked",
        "attackingPlayer": "username of player who attacked the unit",
        "attackingPlayerRole": "role of player who attacked the unit",
        "attackingMob": "id of mob who attacked the unit",
        "damage": "amount of damage"
      }
    },
    "PlayerDestroyed": {
      "description": "Event triggered when a player dies. ",
      "variables": {
        "player": "username of player who died",
        "playerRole": "role of player who died",
        "killingPlayer": "username of player who killed the unit",
        "killingPlayerRole": "role of player who killed the unit",
        "killingMob": "id of mob who killed the unit"
      }
    },
    "PlayerMove": {
      "description": "Event triggered when player changes position",
      "variables": {
        "player": "username of player",
        "row": "row position of player",
        "col": "row position of player"
      }
    },
    "PlayerRespawn": {
      "description": "Event triggered when player respawns",
      "variables": {
         "playerId": "id of player",
         "player": "username of player"
      }
    },
    "PlayerKeyboard": {
      "description": "Event triggered when player presses a key",
      "variables": {
        "playerId": "id of player",
        "player": "username of player",
        "key": "key pressed"
      }
    },
    "MobAttacked": {
      "description": "Event triggered when a mob gets damaged",
      "variables": {
        "entityId": "id of mob who got attacked",
        "entityType": "type of mob got attacked",
        "attackingPlayer": "username of player who attacked the unit",
        "attackingPlayerRole": "role of player who attacked the unit",
        "attackingMob": "id of mob who attacked the unit",
        "damage": "amount of damage"
      }
    },
    "MobDestroyed": {
      "description": "Event triggered when a mob dies. ",
      "variables": {
        "entityId": "id of mob who died",
        "entityType": "type of mob who died",
        "killingPlayer": "username of player who killed the unit",
        "killingPlayerRole": "role of player who killed the unit",
        "killingMob": "id of mob who killed the unit"
      }
    },
    "MobFeed": {
      "description": "Event triggered when a mob is fed. ",
      "variables": {
        "entityId": "id of mob",
        "entityType": "type of mob",
        "playerId": "id of player who fed the mob",
        "player": "name of player who fed the mob",
        "itemType": "name of item used to feed"
      }
    },
    "MobTamed": {
      "description": "Event triggered when a mob is tamed. ",
      "variables": {
        "entityId": "id of mob",
        "entityType": "type of mob",
        "playerId": "id of player who tamed the mob",
        "player": "name of player who tamed the mob"
      }
    },
    "MobFollow": {
      "description": "Event triggered when a mob starts following player. ",
      "variables": {
        "entityId": "id of mob",
        "entityType": "type of mob",
        "playerId": "id of player that mob follows",
        "player": "name of player that mob follows"
      }
    },
    "MobRelease": {
      "description": "Event triggered when a mob stops following player. ",
      "variables": {
        "entityId": "id of mob",
        "entityType": "type of mob",
        "playerId": "id of player that mob follows",
        "player": "name of player that mob follows"
      }
    },
    "MobMount": {
      "description": "Event triggered when a player mounts mob. ",
      "variables": {
        "entityId": "id of mob",
        "entityType": "type of mob",
        "playerId": "id of player",
        "player": "name of players"
      }
    },
    "MobUnmount": {
      "description": "Event triggered when a player unmounts mob. ",
      "variables": {
        "entityId": "id of mob",
        "entityType": "type of mob",
        "playerId": "id of player",
        "player": "name of players"
      }
    },
    "BuildingAttacked": {
      "description": "Event triggered when a building gets damaged",
      "variables": {
        "entityId": "id of building that got attacked",
        "entityType": "type of building that got attacked",
        "attackingPlayer": "username of player who attacked the building",
        "attackingPlayerRole": "role of player who attacked the building",
        "attackingMob": "id of mob who attacked the building",
        "damage": "amount of damage"
      }
    },
    "BuildingPlaced": {
      "description": "Event triggered when a building gets placed",
      "variables": {
        "entityId": "id of building ",
        "entityType": "type of building ",
        "player": "username of player",
        "playerId": "id of player"
      }
    },
    "BuildingDeconstructed": {
      "description": "Event triggered when a building gets deconstructed",
      "variables": {
        "entityId": "id of building ",
        "entityType": "type of building ",
        "player": "username of player",
        "playerId": "id of player"
      }
    },
    "AsteroidMined": {
      "description": "Event triggered when asteroid mined",
      "variables": {
        "type": "name of resource gained",
        "player": "name of player who mined resource",
        "remaining": "amount of resource remaining"
      }
    },
    "ItemCrafted": {
      "description": "Event triggered when item crafted",
      "variables": {
        "type": "name of item crafted",
        "player": "name of player who crafted item"
      }
    },
    "TeamMemberAdded": {
      "description": "Event triggered when membed added to team",
      "variables": {
        "player": "username of player who joined team",
        "team": "name of team",
        "count": "number of members in team"
      }
    },
    "TeamMemberRemoved": {
      "description": "Event triggered when membed removed from team",
      "variables": {
        "player": "username of player who was removed",
        "team": "name of team",
        "count": "number of members in team"
      }
    },
    "RegionEnter": {
      "description": "Event triggered when entity enters a region ",
      "variables": {
        "region": "name of region",
        "player": "username of player who entered",
        "playerRole": "role of player who entered",
        "entityId": "id of entity who entered",
        "entityType": "type of mob who entered"
      }
    },
    "RegionLeave": {
      "description": "Event triggered when entity leaves a region ",
      "variables": {
        "region": "name of region",
        "player": "username of player who left",
        "playerRole": "role of player who left",
        "entityId": "id of entity who left",
        "entityType": "type of mob who entered"
      }
    },
    "ColonyLike": {
      "description": "Event triggered when player likes colony ",
      "variables": {
        "player": "username of player"
      }
    },
    "ColonyUnlike": {
      "description": "Event triggered when player unlikes colony ",
      "variables": {
        "player": "username of player"
      }
    },
    "WorldLoaded": {
      "description": "Event triggered when world is first loaded. Useful for setting up commands such as sidebar etc.",
      "variables": {
      }
    },
    "InteractBuilding": {
      "description": "Event triggered when player interacts with building",
      "variables": {
         "entityId": "id of building", 
         "entityType": "type of building", 
         "playerId": "id of player",
         "player": "username of player who interacted"
      }
    },
    "HealthChanged": {
      "description": "Event triggered when entity health changed",
      "variables": {
         "entityId": "id of entity", 
         "entityType": "type of entity", 
         "playerId": "id of player",
         "player": "username of player",
         "previous": "previous value",
         "current": "current value",
         "delta": "amount changed"
      }
    },
    "OxygenChanged": {
      "description": "Event triggered when player oxygen changed",
      "variables": {
         "playerId": "id of player",
         "player": "username of player",
         "previous": "previous value",
         "current": "current value",
         "delta": "amount changed"
      }
    },
    "HungerChanged": {
      "description": "Event triggered when player hunger changed",
      "variables": {
         "playerId": "id of player",
         "player": "username of player",
         "previous": "previous value",
         "current": "current value",
         "delta": "amount changed"
      }
    },
    "StaminaChanged": {
      "description": "Event triggered when player stamina changed",
      "variables": {
         "playerId": "id of player",
         "player": "username of player",
         "previous": "previous value",
         "current": "current value",
         "delta": "amount changed"
      }
    },
    "ScoreChanged": {
      "description": "Event triggered when player score changed",
      "variables": {
         "playerId": "id of player",
         "player": "username of player",
         "previous": "previous value",
         "current": "current value",
         "delta": "amount changed"
      }
    },
    "ItemBuy": {
      "description": "Event triggered when player buys items",
      "variables": {
         "playerId": "id of player",
         "player": "username of player",
         "itemType": "name of item purchased",
         "count": "amount of items"
      }
    },
    "ItemSell": {
      "description": "Event triggered when player sells items",
      "variables": {
         "playerId": "id of player",
         "player": "username of player",
         "itemType": "name of item sold",
         "count": "amount of items"
      }
    },
    "ItemUsed": {
      "description": "Event triggered when player uses item",
      "variables": {
         "playerId": "id of player",
         "player": "username of player",
         "itemType": "name of item"
      }
    },
    "ItemConsumed": {
      "description": "Event triggered when player consumes item",
      "variables": {
         "playerId": "id of player",
         "player": "username of player",
         "itemType": "name of item"
      }
    },
    "ItemDropped": {
      "description": "Event triggered when player drops item",
      "variables": {
         "playerId": "id of player",
         "player": "username of player",
         "itemType": "name of item",
         "count": "count of item"
      }
    },
    "ItemPickup": {
      "description": "Event triggered when player picks up item",
      "variables": {
         "playerId": "id of player",
         "player": "username of player",
         "itemType": "name of item",
         "count": "count of item"
      }
    },
    "CropHarvested": {
      "description": "Event triggered when a crop gets harvested",
      "variables": {
        "entityId": "id of crop",
        "entityType": "type of crop",
        "yieldType": "type of yield dropped",
        "player": "username of player who harvested crop"
      }
    },
    "CropPlanted": {
      "description": "Event triggered when a crop gets planted",
      "variables": {
        "entityId": "id of crop",
        "entityType": "type of crop",
        "player": "username of player who planted crop"
      }
    },
    "CorpseButchered": {
      "description": "Event triggered when corpse butchered",
      "variables": {
         "entityId": "id of user who cooked food",
         "player": "username of player",
         "corpseType": "type of corpse"
      }
    },
    "CorpseDragged": {
      "description": "Event triggered when corpse dragged",
      "variables": {
         "entityId": "id of user who dragged",
         "player": "username of player",
         "corpseType": "type of corpse",
         "corpseId": "id of corpse"
      }
    },
    "CorpseReleased": {
      "description": "Event triggered when corpse released",
      "variables": {
         "entityId": "id of user who dragged",
         "player": "username of player",
         "corpseType": "type of corpse",
         "corpseId": "id of corpse"
      }
    },
    "FoodCooked": {
      "description": "Event triggered when food cooked",
      "variables": {
         "entityId": "id of user who cooked food",
         "player": "username of player",
         "foodType": "type of food"
      }
    },
    "RoleChanged": {
      "description": "Event triggered when role changed",
      "variables": {
         "playerId": "id of player",
         "player": "username of player",
         "previous": "previous role",
         "current": "current role"
      }
    },
    "GoldChanged": {
      "description": "Event triggered when gold changed",
      "variables": {
         "playerId": "id of player",
         "player": "username of player",
         "previous": "previous gold",
         "current": "current gold",
         "delta": "amount changed"
      }
    },
    "ArmorEquipChanged": {
      "description": "Event triggered when armor equip changed",
      "variables": {
         "playerId": "id of player",
         "player": "username of player",
         "previous": "previous armor",
         "current": "current armor"
      }
    },
    "PlatformCleaned": {
      "description": "Event triggered when platform cleaned",
      "variables": {
         "playerId": "id of player",
         "player": "username of player",
         "entityId": "id of platform",
         "row": "row of platform",
         "col": "col of platform"
      }
    },
    "StoragePut": {
      "description": "Event triggered when player puts item into storage",
      "variables": {
         "playerId": "id of player",
         "player": "username of player",
         "itemType": "name of item",
         "count": "count of item",
         "storageId": "id of storage",
         "storageType": "type of storage"
      }
    },
    "StorageGet": {
      "description": "Event triggered when player gets item from storage",
      "variables": {
         "playerId": "id of player",
         "player": "username of player",
         "itemType": "name of item",
         "count": "count of item",
         "storageId": "id of storage",
         "storageType": "type of storage"
      }
    },
    "ButtonClicked": {
      "description": "Event triggered when a player clicks custom button",
      "variables": {
        "player": "username of player that clicked",
        "playerId":"id of player",
        "entityId": "id of entity button attached",
        "name": "name of button clicked"
      }
    },
    "Timer:start": {
      "description": "Event triggered when timer starts",
      "variables": {
        "name": "name of timer"
      }
    },
    "Timer:tick": {
      "description": "Event triggered when timer is ticking",
      "variables": {
        "name": "name of timer",
        "seconds": "number of seconds elapsed",
        "remaining": "number of seconds remaining before timer ends"
      }
    },
    "Timer:end": {
      "description": "Event triggered when timer ends",
      "variables": {
        "name": "name of timer"
      }
    },
    "start": {
      "description": "Event triggered when timer starts",
      "variables": {
      }
    },
    "tick": {
      "description": "Event triggered when timer is ticking",
      "variables": {
        "seconds": "number of seconds elapsed",
        "remaining": "number of seconds remaining before timer ends"
      }
    },
    "end": {
      "description": "Event triggered when timer ends",
      "variables": {
      }
    }
  },
  "Actions": {
    "commands": {
      "description": "Execute command. Can use variable names provided by the event. Variable names must start with dollar sign $ . Certain commands also accept <a href='/selectors.html' target='_blank'>target_selectors</a> which starts with @ symbol. See example below",
      "examples": [
        "/give $player potato 5",
        "/tp @a 20 20",
        "/caption @a[role=crew] title Role: Crew"
      ]
    },
    "ifthenelse": {
      "description": "Add a condition for another action to execute. Can use variable names provided by the event. Variable names must start with dollar sign $",
      "examples": [
        "if $player != insert_owner_name, then /give $player potato 5"
      ]
    },
    "timer": {
      "description": "Timer that emits start/tick/end events which can be used as triggers",
      "examples": [
        "name: RounStartTimer, duration: 10 (in seconds)"
      ]
    }
  },
  "Effects": {
    "Fire": {
      "name": "fire",
      "sprite": "flame_2.png"
    },
    "Blood": {
      "name": "blood",
      "sprite": "blood_1.png"
    },
    "Web": {
      "name": "web",
      "sprite": "web.png"
    },
    "Residue": {
      "name": "residue",
      "sprite": "residue.png"
    },
    "Dirt": {
      "name": "dirt",
      "sprite": "residue.png"
    },
    "Miasma": {
      "name": "miasma",
      "sprite": "white_gas.png"
    },
    "Break": {
      "name": "break",
      "sprite": "break.png"
    },
    "Poison": {
      "name": "poison",
      "sprite": "acid_spit.png"
    },
    "Smoke": {
      "name": "smoke",
      "sprite": ""
    },
    "Spin": {
      "name": "spin",
      "sprite": ""
    },
    "Invisible": {
      "name": "invisible",
      "sprite": ""
    },
    "Haste": {
      "name": "haste",
      "sprite": ""
    }
  },
  "Tutorial": {
    "main": {
      "0": "Grab Items from EscapePod (Right-Click)" ,
      "1": "Mine 10 Iron Ores from Asteroid" ,
      "2": "Craft Furnace (Press C to open craft menu)" ,
      "3": "Smelt 15 Iron Bars",
      "4": "Craft OxygenGenerator" ,
      "5": "Collect Water with Bottle",
      "6": "Refill Oxygen Generator with Water Bottle",
      "7": "Interact OxygenGenerator to refill suit oxygen",
      "8": "Gather 5 plant fibers",
      "9": "Craft 2 cloth using furnace",
      "10": "Craft Bed and sleep to restore stamina",
      "11": "Craft TradingTable",
      "12": "Craft ChemistryStation",
      "13": "Collect Blood using bottle until full",
      "14": "Craft BloodPack",
      "15": "Craft SlaversTable"
    },
    "corpse": {
      "0": "Craft ButcherTable",
      "1": "Drag a Corpse (Press E)",
      "2": "Harvest Corpse Meat using ButcherTable"
    } 
  },
  "CategoryClassifiers": {
    "power_producer": "powerProduction",
    "power_storage": "powerCapacity",
    "power_consumer": "powerConsumption",
    "oxygen_producer": "oxygenProduction",
    "oxygen_storage": "oxygenCapacity",
    "liquid_producer": "liquidProduction",
    "liquid_storage": "liquidCapacity",
    "liquid_consumer": "liquidConsumption",
    "fuel_producer": "fuelProduction",
    "fuel_storage": "fuelCapacity",
    "fuel_consumer": "fuelConsumption"
  },
  "Events": {
    "Raid": "raid",
    "TaxCollection": "tax_collection",
    "SpiderInfestation": "spider_infestation",
    "TraderArrived": "trader_arrived",
    "SlaveTraderArrived": "slave_trade_arrived",
    "MeteorShower": "meteor_shower"
  },
  "FloorTextures": {
    "solid_texture":       { "index": 1 },
    "cornered_texture":    { "index": 2 },
    "plated_texture":      { "index": 3 },
    "striped_texture":     { "index": 4 },
    "layered_bar_texture": { "index": 5 },
    "grilled_texture":     { "index": 6 },
    "bricks_texture":      { "index": 7 },
    "checker_texture":     { "index": 8 },
    "xchecker_texture":    { "index": 9 },
    "x_texture":           { "index": 10 },
    "noise_texture":       { "index": 11 }
  },
  "SuitColors": {
    "gray":   { "index": 1 , "value": "#999999" },
    "red":   { "index": 2 , "value": "#c81010" },
    "blue":   { "index": 3 , "value": "#245e9b" },
    "green":   { "index": 4 , "value": "#186638" },
    "yellow":   { "index": 5 , "value": "#f3b61d" },
    "orange":   { "index": 6 , "value": "#eb4c1a" },
    "purple":   { "index": 7 , "value": "#6e3797" },
    "black":   { "index": 8 , "value": "#222222" }
  },
  "FloorColors": {
    "grey_1":   { "index": 1 , "value": "#6c6c6c" },
    "grey_2":   { "index": 2 , "value": "#2e3940" },
    "grey_3":   { "index": 3 , "value": "#76756a" },
    "grey_4":   { "index": 4 , "value": "#a7adbb" },
    "blue_1":   { "index": 5 , "value": "#495377" },
    "blue_2":   { "index": 6 , "value": "#3a5b75" },
    "blue_3":   { "index": 7 , "value": "#306be4" },
    "blue_4":   { "index": 8 , "value": "#78ccee" },
    "blue_5":   { "index": 9 , "value": "#dbefee" },
    "orange_1": { "index": 10, "value": "#ec7333" },
    "red_1":    { "index": 11, "value": "#754e4e" },
    "red_2":    { "index": 12, "value": "#632828" },
    "red_3":    { "index": 13, "value": "#c80016" },
    "green_1":  { "index": 14, "value": "#bbf5e1" },
    "green_2":  { "index": 15, "value": "#818371" },
    "green_3":  { "index": 16, "value": "#416747" },
    "green_4":  { "index": 17, "value": "#627435" },
    "green_5":  { "index": 18, "value": "#6a8867" },
    "yellow_1": { "index": 19, "value": "#e0c78f" },
    "yellow_2": { "index": 20, "value": "#edd46f" },
    "yellow_3": { "index": 21, "value": "#856420" },
    "yellow_4": { "index": 22, "value": "#e7c727" },
    "yellow_5": { "index": 23, "value": "#c57f17" },
    "brown_1":  { "index": 24, "value": "#5b3119" },
    "brown_2":  { "index": 25, "value": "#493c21" },
    "white_1":  { "index": 26, "value": "#c5c5c5" },
    "purple_1": { "index": 27, "value": "#564a54" },
    "white_2":  { "index": 28, "value": "#ffffff" },
    "gray_5":   { "index": 29, "value": "#2a2a2a" },
    "cyan_1":   { "index": 30, "value": "#10b3a1" },
    "cyan_2":   { "index": 31, "value": "#00ffff" },
    "cyan_3":   { "index": 32, "value": "#55cbbe" },
    "cyan_4":   { "index": 33, "value": "#007971" },
    "pink_1":   { "index": 34, "value": "#d784de" },
    "pink_2":   { "index": 35, "value": "#ff51b1" },
    "pink_3":   { "index": 36, "value": "#ef6990" },
    "pink_4":   { "index": 37, "value": "#ff54c9" }
  },
  "Deeds": {
    "taxes_not_paid": {
      "effect": -20,
      "description": "Taxes not paid"
    },
    "cannibalism": {
      "effect": -10,
      "description": "Ate empire soldiers"
    },
    "extreme_cannibalism": {
      "effect": -10,
      "description": "Cannibalized large amount of empire soldiers"
    },
    "no_beacon": {
      "effect": -5,
      "description": "No Beacon constructed"
    }
  },
  "Mothership": {
    "maxWidth": 640,
    "maxHeight": 640,
    "cost": {
      "gold": 5000
    },
    "stats": {
      "tileCount": 50
    },
    "upgrade": {}
  },
  "Faith": {
    "Hostile": 0,
    "Obedient": 50,
    "Guardian": 80
  },
  "Shield": {
    "width": 32,
    "height": 32,
    "cost": 5000,
    "stats": {
      "health": 250
    },
    "upgrade": {
      "health": "+250"
    }
  },
  "Pickup": {
    "width": 32,
    "height": 32
  },
  "Corpse": {
    "width": 32,
    "height": 32,
    "categories": {"corpse": true},
    "isFlamable": true,
    "isInteractable": true
  },
  "Player": {
    "width": 24,
    "height": 24,
    "oxygen": 15,
    "speed": 8,
    "isFlamable": true,
    "syringeDescription": "Increase health by 5",
    "inventoryCount": 32,
    "happiness": 100,
    "stamina": 100,
    "hunger": 100,
    "thirst": 100,
    "stats": {
      "damage": 1,
      "reload": 500,
      "range": 64,
      "oxygenConsumption": 1
    }
  },
  "Mobs": {
    "BaseMob": {
      "width": 32,
      "height": 32,
      "obstacleCollisionWidth": 20,
      "obstacleCollisionHeight": 20,
      "isFlamable": true,
      "stats": {
        "oxygen": 100,
        "speed": 3,
        "reload": 3000
      }
    },
    "SkyMob": {
      "parent": "Mobs.BaseMob",
      "categories": {"sky_creature": true}
    },
    "Ghost": {
      "parent": "Mobs.BaseMob",
      "attackGroups": [],
      "categories": {"ghost": true},
      "immunity": ["miasma"],
      "stats": {
        "speed": 20,
        "reload": 3000,
        "health": 5,
        "damage": 5,
        "range": 50,
        "los": 160
      },
      "upgrade": {
        "health": "+5",
        "damage": "+5"
      }
    },
    "Slime": {
      "parent": "Mobs.BaseMob",
      "drop": "Gel",
      "isNonHostile": true,
      "isTamable": true,
      "attackGroups": ["mobs"],
      "cost": {
        "gold": 600
      },
      "dizzySprite": {
        "position": {
          "x": 0,
          "y": 0
        },
        "width": 20,
        "height": 8,
        "rotation": 0
      },
      "stats": {
        "speed": 2,
        "reload": 2000,
        "health": 10,
        "damage": 5,
        "range": 32,
        "los": 160
      }
    },
    "Brood": {
      "parent": "Mobs.BaseMob",
      "drop": "AlienMeat",
      "useOriginalSize": true,
      "hasBlood": true,
      "isTamable": true,
      "cost": {
        "gold": 800
      },
      "attackGroups": ["players", "mobs"],
      "dizzySprite": {
        "position": {
          "x": 0,
          "y": 0
        },
        "width": 20,
        "height": 8,
        "rotation": 0
      },
      "stats": {
        "speed": 2,
        "reload": 1000,
        "health": 10,
        "damage": 2,
        "range": 32,
        "los": 160
      },
      "upgrade": {
        "health": "+5",
        "damage": "+5"
      }
    },
    "BioRaptor": {
      "parent": "Mobs.SkyMob",
      "width": 96,
      "height": 96,
      "useOriginalSize": true,
      "shouldFadeOut": true,
      "immunity": ["miasma"],
      "categories": {"mountable":true,"flying":true},
      "drop": "AlienMeat",
      "isTamable": true,
      "hasBlood": true,
      "cost": {
        "gold": 1500
      },
      "attackGroups": ["players"],
      "dizzySprite": {
        "position": {
          "x": 0,
          "y": -20
        },
        "width": 28,
        "height": 12,
        "rotation": 0,
        "tint": "#444444"
      },
      "stats": {
        "reload": 3000,
        "health": 50,
        "damage": 15,
        "range": 96,
        "los": 640
      },
      "upgrade": {
        "health": "+5",
        "damage": "+5"
      }
    },
    "Car": {
      "parent": "Mobs.BaseMob",
      "width": 96,
      "height": 96,
      "useOriginalSize": true,
      "shouldFadeOut": true,
      "immunity": ["miasma","poison","fear"],
      "categories": {"mountable":true},
      "drop": "IronOre",
      "isTamable": true,
      "hasBlood": false,
      "cost": {
        "gold": 20000
      },
      "attackGroups": ["players"],
      "dizzySprite": {
        "position": {
          "x": 0,
          "y": -20
        },
        "width": 28,
        "height": 12,
        "rotation": 0,
        "tint": "#444444"
      },
      "stats": {
        "reload": 3000,
        "health": 3000,
        "damage": 1,
        "range": 96,
        "los": 640
      }
    },
    "Spider": {
      "parent": "Mobs.BaseMob",
      "hasBlood": true,
      "isTamable": true,
      "cost": {
        "gold": 2000
      },
      "isBuildingDestroyer": true,
      "attackGroups": ["players", "buildings", "mobs"],
      "drop": ["Web"],
      "resistance": ["fire"],
      "sprite": {
        "width": 96,
        "height": 64
      },
      "dizzySprite": {
        "position": {
          "x": 0,
          "y": -8
        },
        "width": 13,
        "height": 6,
        "rotation": 0
      },
      "stats": {
        "reload": 1500,
        "health": 120,
        "damage": 10,
        "range": 50,
        "los": 160
      },
      "upgrade": {
        "health": "+5",
        "damage": "+5"
      }
    },
    "PoisonSpider": {
      "parent": "Mobs.BaseMob",
      "drop": "Poison",
      "syringeDescription": "Poisons target for 30 seconds",
      "isTamable": true,
      "cost": {
        "gold": 2500
      },
      "sprite": {
        "width": 96,
        "height": 64
      },
      "stats": {
        "health": 150,
        "damage": 5,
        "range": 320,
        "los": 480
      },
      "upgrade": {
        "health": "+5",
        "damage": "+5"
      }
    },
    "Pirate": {
      "parent": "Mobs.BaseMob",
      "drop": "HumanMeat",
      "isHuman": true,
      "canFly": true,
      "cost": {
        "gold": 500
      },
      "attackGroups": ["players", "buildings", "mobs"],
      "sprite": {
        "width": 40,
        "height": 40
      },
      "dizzySprite": {
        "position": {
          "x": 22,
          "y": 20
        },
        "width": 20,
        "height": 8,
        "rotation": 90
      },
      "stats": {
        "health": 30,
        "damage": 10,
        "range": 32,
        "los": 256
      },
      "upgrade": {
        "health": "+10",
        "damage": "+2"
      }
    },
    "Human": {
      "parent": "Mobs.BaseMob",
      "drop": "HumanMeat",
      "isHuman": true,
      "cost": {
        "gold": 500
      },
      "attackGroups": [],
      "sprite": {
        "width": 40,
        "height": 40
      },
      "dizzySprite": {
        "tint": "#000000",
        "position": {
          "x": 22,
          "y": 20
        },
        "width": 20,
        "height": 8,
        "rotation": 90
      },
      "stats": {
        "health": 100,
        "damage": 10,
        "range": 32,
        "los": 256
      },
      "upgrade": {
        "health": "+10",
        "damage": "+2"
      }
    },
    "Guard": {
      "parent": "Mobs.Pirate",
      "hasBlood": true
    },
    "Trooper": {
      "parent": "Mobs.Guard",
      "sprite": {
        "width": 50,
        "height": 72
      },
      "stats": {
        "health": 150,
        "damage": 12,
        "range": 256,
        "los": 256
      }
    },
    "Sapper": {
      "parent": "Mobs.Guard",
      "sprite": {
        "width": 60,
        "height": 181
      },
      "stats": {
        "health": 350,
        "damage": 80,
        "range": 400,
        "los": 256
      }
    },
    "Chemist": {
      "parent": "Mobs.BaseMob",
      "hasBlood": true,
      "drop": ["Grenade", "PoisonGrenade"],
      "resistance": ["fire"],
      "immunity": ["poison"],
      "canTargetTraps": true,
      "canFly": true,
      "cost": {
        "gold": 2500
      },
      "attackGroups": ["players", "buildings", "mobs"],
      "sprite": {
        "width": 50,
        "height": 45
      },
      "dizzySprite": {
        "position": {
          "x": 30,
          "y": 25
        },
        "width": 25,
        "height": 10,
        "rotation": 90
      },
      "stats": {
        "health": 90,
        "damage": 1,
        "range": 256,
        "los": 256,
        "reload": 8000
      }
    },
    "Firebat": {
      "parent": "Mobs.BaseMob",
      "hasBlood": true,
      "drop": ["Flamethrower"],
      "resistance": ["fire"],
      "immunity": ["poison"],
      "canTargetTraps": true,
      "canFly": true,
      "cost": {
        "gold": 2500
      },
      "attackGroups": ["crops", "buildings", "players", "mobs"],
      "sprite": {
        "width": 90,
        "height": 60
      },
      "canTargetCrops": true,
      "dizzySprite": {
        "position": {
          "x": 0,
          "y": 0
        },
        "width": 40,
        "height": 15,
        "rotation": 90
      },
      "stats": {
        "health": 150,
        "damage": 1,
        "range": 256,
        "los": 256,
        "reload": 8000
      }
    },
    "DummyPlayer": {
      "parent": "Mobs.BaseMob",
      "cost": {
        "gold": 1000
      },
      "categories": {"dummy_player": true},
      "attackGroups": [],
      "sprite": {
        "width": 40,
        "height": 40
      },
      "stats": {
        "health": 100,
        "damage": 1,
        "range": 32,
        "los": 256
      },
      "upgrade": {
        "damage": "+2"
      }
    },
    "Chicken": {
      "parent": "Mobs.BaseMob",
      "hasBlood": true,
      "isTamable": true,
      "drop": "Egg",
      "cost": {
        "gold": 1000
      },
      "dizzySprite": {
        "position": {
          "x": 15,
          "y": 14
        },
        "width": 20,
        "height": 8,
        "rotation": 0,
        "tint": "#000000"
      },
      "stats": {
        "health": 35,
        "damage": 1,
        "range": 32,
        "los": 256
      },
      "upgrade": {
        "health": "+10",
        "damage": "+2"
      }
    },
    "Monkey": {
      "parent": "Mobs.BaseMob",
      "hasBlood": true,
      "isTamable": true,
      "drop": "AnimalMeat",
      "cost": {
        "gold": 1000
      },
      "dizzySprite": {
        "position": {
          "x": 0,
          "y": -20
        },
        "width": 30,
        "height": 15,
        "rotation": 0
      },
      "sprite": {
        "width": 40,
        "height": 40
      },
      "stats": {
        "health": 75,
        "damage": 10,
        "range": 32,
        "los": 256
      },
      "upgrade": {
        "health": "+10",
        "damage": "+2"
      }
    },
    "Trader": {
      "parent": "Mobs.BaseMob",
      "hasBlood": true,
      "hasMenu": true,
      "categories": {"trader": true},
      "isNPC": true,
      "sprite": {
        "width": 40,
        "height": 40
      },
      "stats": {
        "reload": 4000,
        "health": 100,
        "damage": 10,
        "range": 32,
        "los": 256
      },
      "upgrade": {
        "health": "+10",
        "damage": "+2"
      }
    },
    "SlaveTrader": {
      "parent": "Mobs.BaseMob",
      "hasBlood": true,
      "categories": {"trader": true},
      "hasMenu": true,
      "isNPC": true,
      "stats": {
        "reload": 4000,
        "health": 40,
        "damage": 10,
        "range": 32,
        "los": 256
      },
      "sprite": {
        "width": 42,
        "height": 50
      },
      "upgrade": {
        "health": "+10",
        "damage": "+2"
      }
    },
    "Slave": {
      "parent": "Mobs.BaseMob",
      "hasBlood": true,
      "hasMenu": true,
      "categories": {"worker": true},
      "isNPC": true,
      "isNonHostile": true,
      "shouldShowBehavior": true,
      "shouldShowNeeds": true,
      "cost": {
        "gold": 10000
      },
      "dizzySprite": {
        "position": {
          "x": 27,
          "y": 20
        },
        "width": 28,
        "height": 12,
        "rotation": 90,
        "tint": "#222222"
      },
      "stats": {
        "reload": 4000,
        "health": 100,
        "damage": 1,
        "range": 32,
        "los": 256
      },
      "upgrade": {
        "health": "+10",
        "damage": "+2"
      }
    },
    "NuuSlave": {
      "parent": "Mobs.Slave",
      "cost": {
        "gold": 10000
      },
      "dizzySprite": {
        "position": {
          "x": 27,
          "y": 20
        },
        "width": 28,
        "height": 12,
        "rotation": 90,
        "tint": "#222222"
      }
    },
    "PixiSlave": {
      "parent": "Mobs.Slave",
      "cost": {
        "gold": 10000
      },
      "dizzySprite": {
        "position": {
          "x": 27,
          "y": 20
        },
        "width": 28,
        "height": 12,
        "rotation": 90,
        "tint": "#222222"
      }
    },
    "GaramSlave": {
      "parent": "Mobs.Slave",
      "cost": {
        "gold": 10000
      },
      "dizzySprite": {
        "position": {
          "x": 27,
          "y": 20
        },
        "width": 28,
        "height": 12,
        "rotation": 90,
        "tint": "#222222"
      }
    },
    "Messenger": {
      "parent": "Mobs.BaseMob",
      "hasBlood": true,
      "hasMenu": true,
      "isNPC": true,
      "cost": {
        "gold": 1000
      },
      "stats": {
        "reload": 4000,
        "health": 50,
        "damage": 1,
        "range": 32,
        "los": 256
      },
      "upgrade": {
        "health": "+10",
        "damage": "+2"
      }
    },
    "FirstBot": {
      "parent": "Mobs.BaseMob",
      "stats": {
        "reload": 4000,
        "health": 20,
        "damage": 10,
        "range": 32,
        "los": 256
      },
      "categories": {"bot": true},
      "upgrade": {
        "health": "+10",
        "damage": "+2"
      }
    },
    "CleanBot": {
      "parent": "Mobs.BaseMob",
      "cost": {
        "gold": 5000
      },
      "categories": {"bot": true},
      "stats": {
        "speed": 2,
        "reload": 1000,
        "health": 100,
        "damage": 10,
        "range": 32,
        "los": 256
      },
      "upgrade": {
        "health": "+10",
        "damage": "+2"
      }
    },
    "GuardBot": {
      "parent": "Mobs.BaseMob",
      "cost": {
        "gold": 3000
      },
      "stats": {
        "reload": 4000,
        "health": 20,
        "damage": 10,
        "range": 32,
        "los": 256
      },
      "categories": {"bot": true},
      "upgrade": {
        "health": "+10",
        "damage": "+2"
      }
    },
    "Mutant": {
      "parent": "Mobs.BaseMob",
      "stats": {
        "speed": 5,
        "reload": 2000,
        "health": 150,
        "damage": 15,
        "range": 64,
        "los": 256
      },
      "resistance": ["fire", "poison"],
      "attackGroups": ["players", "buildings", "mobs"],
      "sprite": {
        "width": 100,
        "height": 80
      },
      "cost": {
        "gold": 2000
      },
      "dizzySprite": {
        "position": {
          "x": 3,
          "y": -2
        },
        "width": 30,
        "height": 12,
        "rotation": 40
      },
      "upgrade": {
        "health": "+10",
        "damage": "+2"
      }
    },
    "Cat": {
      "parent": "Mobs.BaseMob",
      "hasBlood": true,
      "isNonHostile": true,
      "isTamable": true,
      "drop": "AnimalMeat",
      "cost": {
        "gold": 3000
      },
      "dizzySprite": {
        "position": {
          "x": 0,
          "y": -14
        },
        "width": 25,
        "height": 12,
        "rotation": 0,
        "tint": "#000000"
      },
      "stats": {
        "reload": 3000,
        "health": 50,
        "damage": 5,
        "range": 48,
        "los": 160
      },
      "sprite": {
        "width": 40,
        "height": 50
      },
      "upgrade": {
        "health": "+5",
        "damage": "+5"
      }
    },
    "Golem": {
      "parent": "Mobs.BaseMob",
      "isTamable": true,
      "width": 192,
      "height": 192,
      "drop": "SulfurOre",
      "isNonHostile": true,
      "cost": {
        "gold": 3000
      },
      "immunity": ["poison", "fear", "miasma"],
      "attackGroups": ["players", "buildings", "mobs"],
      "dizzySprite": {
        "position": {
          "x": 0,
          "y": -14
        },
        "width": 25,
        "height": 12,
        "rotation": 0,
        "tint": "#000000"
      },
      "stats": {
        "reload": 4000,
        "health": 300,
        "damage": 30,
        "range": 96,
        "los": 160
      },
      "sprite": {
        "width": 200,
        "height": 145
      }
    },
    "Prisoner": {
      "parent": "Mobs.BaseMob",
      "isTamable": true,
      "width": 64,
      "height": 64,
      "drop": "HumanMeat",
      "isNonHostile": true,
      "cost": {
        "gold": 3000
      },
      "attackGroups": ["players", "buildings", "mobs"],
      "dizzySprite": {
        "position": {
          "x": 0,
          "y": 7
        },
        "width": 25,
        "height": 12,
        "rotation": 0,
        "tint": "#000000"
      },
      "stats": {
        "health": 100,
        "damage": 5,
        "range": 64,
        "los": 128
      },
      "sprite": {
        "width": 58,
        "height": 58
      }
    },
    "Mantis": {
      "parent": "Mobs.BaseMob",
      "isNonHostile": true,
      "isTamable": true,
      "drop": "Stimpack",
      "cost": {
        "gold": 3000
      },
      "attackGroups": ["players", "buildings", "mobs"],
      "dizzySprite": {
        "position": {
          "x": 0,
          "y": -8
        },
        "width": 20,
        "height": 10,
        "rotation": 0,
        "tint": "#ffffff"
      },
      "stats": {
        "reload": 2000,
        "health": 150,
        "damage": 15,
        "range": 48,
        "los": 160
      },
      "sprite": {
        "width": 80,
        "height": 80
      }
    },
    "SquidLord": {
      "parent": "Mobs.BaseMob",
      "width": 256,
      "height": 256,
      "drop": "SquidLordHeart",
      "stats": {
        "speed": 4,
        "reload": 3000,
        "health": 2000,
        "damage": 10,
        "range": 256,
        "los": 384
      },
      "isFlamable": false,
      "categories": {"flying": true},
      "shouldAttackIgnoreObstacle": true,
      "isBuildingDestroyer": true,
      "attackGroups": ["players", "buildings", "mobs"],
      "sprite": {
        "width": 256,
        "height": 236
      },
      "cost": {
        "gold": 30000
      },
      "upgrade": {
        "health": "+3",
        "damage": "+2"
      }
    },
    "Drone": {
      "parent": "Mobs.BaseMob",
      "stats": {
        "speed": 4,
        "reload": 3000,
        "health": 200,
        "damage": 10,
        "range": 256,
        "los": 384
      },
      "isFlamable": false,
      "immunity": ["poison"],
      "categories": {"flying": true},
      "shouldAttackIgnoreObstacle": true,
      "isBuildingDestroyer": true,
      "attackGroups": ["players", "buildings", "mobs"],
      "sprite": {
        "width": 52,
        "height": 40
      },
      "cost": {
        "gold": 3000
      },
      "upgrade": {
        "health": "+3",
        "damage": "+2"
      }
    },
    "Raven": {
      "parent": "Mobs.BaseMob",
      "stats": {
        "speed": 4,
        "reload": 3000,
        "health": 800,
        "damage": 5,
        "range": 384,
        "los": 512
      },
      "isFlamable": false,
      "immunity": ["poison"],
      "categories": {"flying": true},
      "shouldAttackIgnoreObstacle": true,
      "isBuildingDestroyer": true,
      "attackGroups": ["players", "buildings", "mobs"],
      "sprite": {
        "width": 148,
        "height": 96
      },
      "cost": {
        "gold": 3000
      }
    },
    "Reaver": {
      "parent": "Mobs.BaseMob",
      "stats": {
        "speed": 4,
        "reload": 4000,
        "health": 15,
        "damage": 1,
        "range": 100,
        "los": 256
      },
      "upgrade": {
        "health": "+10",
        "damage": "+2"
      },
      "cost": {
        "gold": 4000
      }
    },
    "Transporter": {
      "parent": "Mobs.BaseMob",
      "stats": {
        "reload": 4000,
        "health": 15,
        "damage": 1,
        "range": 100,
        "los": 256
      },
      "upgrade": {
        "health": "+10",
        "damage": "+2"
      }
    },
    "Catapult": {
      "parent": "Mobs.BaseMob",
      "width": 128,
      "height": 128,
      "cost": {
        "gold": 5000
      },
      "stats": {
        "speed": 5,
        "reload": 5000,
        "health": 30,
        "damage": 7,
        "range": 150,
        "los": 256
      },
      "upgrade": {
        "health": "+10",
        "damage": "+3"
      }
    }
  },
  "Crops": {
    "BaseSeed": {
      "width": 32,
      "height": 32,
      "abstract": true,
      "isInteractable": true,
      "dontShowHealth": true,
      "categories": {"distribution":true,"not_structure_conduit":true,"crop":true,"seed":true},
      "sprite": {
        "width": 24,
        "height": 24
      },
      "stats": {
        "liquidCapacity": 10,
        "health": 100
      }
    },
    "FiberSeed": {
      "parent": "Crops.BaseSeed",
      "cost": {
        "gold": 25
      },
      "yield": "PlantFiber",
      "description": "Plant on soil to grow fiber"
    },
    "PotatoSeed": {
      "parent": "Crops.BaseSeed",
      "cost": {
        "gold": 25
      },
      "yield": "Potato",
      "description": "Plant on soil to grow potato"
    },
    "CoffeeSeed": {
      "parent": "Crops.BaseSeed",
      "cost": {
        "gold": 100
      },
      "stats": {
        "health": 100
      },
      "yield": "CoffeeBean",
      "description": "Plant on soil to grow coffee"
    },
    "SunflowerSeed": {
      "parent": "Crops.BaseSeed",
      "sprite": {
        "path": "sunflower_seed",
        "maturepath": "sunflower"
      },
      "yield": "Sunflower",
      "cost": {
        "gold": 200
      },
      "stats": {
        "health": 100
      },
      "description": "Plant on soil to grow Sunflower"
    },
    "BlueSeed": {
      "parent": "Crops.BaseSeed",
      "sprite": {
        "path": "blue_seed",
        "maturepath": "blue_lotus"
      },
      "yield": "BlueLotus",
      "cost": {
        "gold": 200
      },
      "stats": {
        "health": 100
      },
      "description": "Plant on soil to grow Blue Lotus"
    },
    "PoppySeed": {
      "parent": "Crops.BaseSeed",
      "sprite": {
        "path": "poppy_seed",
        "maturepath": "poppy"
      },
      "yield": "Poppy",
      "cost": {
        "gold": 200
      },
      "stats": {
        "health": 100
      },
      "description": "Plant on soil to grow Poppy"
    },
    "PumpkinSeed": {
      "parent": "Crops.BaseSeed",
      "cost": {
        "gold": 500
      },
      "sprite": {
        "width": 33,
        "height": 33
      },
      "stats": {
        "health": 90
      },
      "yield": "Pumpkin",
      "description": "Plant on soil to grow pumpkin"
    },
    "WheatSeed": {
      "parent": "Crops.BaseSeed",
      "cost": {
        "gold": 100
      },
      "yield": "Wheat",
      "stats": {
        "health": 150
      },
      "description": "Plant on soil to grow wheat"
    },
    "RiceSeed": {
      "parent": "Crops.BaseSeed",
      "cost": {
        "gold": 150
      },
      "yield": "Rice",
      "stats": {
        "health": 150
      },
      "sprite": {
        "width": 28,
        "height": 28
      },
      "description": "Plant on soil to grow rice"
    }
  },
  "Projectiles": {
    "BasicLaser": {
      "width": 5,
      "height": 5,
      "speed": 60,
      "damage": 12,
      "sprite": {
        "width": 32,
        "height": 4,
        "tint": "#ffff07"
      },
      "categories": {"distance_dependent_width": true}
    },
    "BlueLaser": {
      "width": 5,
      "height": 5,
      "speed": 15,
      "damage": 75,
      "sprite": {
        "width": 32,
        "height": 4
      }

    },
    "MiningBeam": {
      "width": 32,
      "height": 32,
      "speed": 0
    },
    "VoidRayLight": {
      "width": 32,
      "height": 32,
      "speed": 0
    },
    "LightLaser": {
      "width": 5,
      "height": 5,
      "speed": 70,
      "sprite": {
        "width": 32,
        "height": 3,
        "tint": "#f33136"
      },
      "categories": {"distance_dependent_width": true}
    },
    "CannonBall": {
      "width": 32,
      "height": 32,
      "speed": 10
    },
    "Bubble": {
      "width": 32,
      "height": 32,
      "speed": 12
    },
    "BlasterLaser": {
      "width": 24,
      "height": 8,
      "speed": 15
    },
    "CarbonGas": {
      "width": 64,
      "height": 64,
      "minWidth": 32,
      "maxWidth": 40,
      "maxRadialExpansion": 30,
      "speed": 0
    },
    "DisinfectingGas": {
      "width": 64,
      "height": 64,
      "minWidth": 32,
      "maxWidth": 64,
      "maxRadialExpansion": 32,
      "speed": 0
    },
    "PoisonGas": {
      "width": 64,
      "height": 64,
      "minWidth": 42,
      "maxWidth": 50,
      "maxRadialExpansion": 90,
      "speed": 0
    },
    "AcidSpit": {
      "width": 24,
      "height": 24,
      "speed": 8
    },
    "Grenade": {
      "canDamageWalls": true,
      "width": 16,
      "height": 16,
      "speed": 8
    },
    "Dynamite": {
      "canDamageWalls": true,
      "width": 16,
      "height": 16,
      "speed": 8
    },
    "MolotovCocktail": {
      "canDamageWalls": false,
      "width": 24,
      "height": 28,
      "speed": 12
    },
    "Meteor": {
      "width": 64,
      "height": 64,
      "speed": 30
    },
    "PoisonGrenade": {
      "width": 16,
      "height": 16,
      "speed": 8
    },
    "TeslaLaser": {
      "width": 10,
      "height": 10,
      "damage": 40
    },
    "Explosion": {
      "canDamageWalls": true,
      "width": 192,
      "height": 192,
      "damage": 25,
      "speed": 1
    },
    "MiningExplosion": {
      "canDamageWalls": true,
      "width": 192,
      "height": 192,
      "damage": 10,
      "speed": 1
    },
    "Flame": {
      "width": 32,
      "height": 32,
      "minWidth": 32,
      "maxWidth": 64,
      "maxRadialExpansion": 16,
      "damage": 10,
      "speed": 0,
      "categories": {"elemental":true,"fire":true}
    },
    "IonBeam": {
      "width": 512,
      "height": 32,
      "speed": 5
    },
    "Spike": {
      "width": 32,
      "height": 32
    },
    "Bullet": {
      "width": 8,
      "height": 8,
      "sprite": {
        "width": 32,
        "height": 5,
        "tint": "#ffff07"
      },
      "damage": 10,
      "speed": 70,
      "categories": {"distance_dependent_width": true}
    },
    "ShotgunBullet": {
      "width": 8,
      "height": 8,
      "sprite": {
        "width": 32,
        "height": 5,
        "tint": "#777777"
      },
      "damage": 12,
      "speed": 50,
      "categories": {"distance_dependent_width": true}
    },
    "RifleBullet": {
      "width": 8,
      "height": 8,
      "sprite": {
        "width": 32,
        "height": 5,
        "tint": "#666666"
      },
      "speed": 70,
      "damage": 7,
      "categories": {"distance_dependent_width": true}
    },
    "PlasmaBullet": {
      "width": 32,
      "height": 32,
      "sprite": {
        "width": 64,
        "height": 16,
        "tint": "#cc4ad7"
      },
      "isPiercing": true,
      "speed": 120,
      "damage": 40,
      "categories": {"distance_dependent_width": true}
    },
    "Missile": {
      "width": 32,
      "height": 32,
      "speed": 25,
      "damage": 20
    }
  },
  "Bars": {
    "CircuitBoard": {
      "width": 32,
      "height": 32,
      "cost": {
        "gold": 30
      },
      "stats": {
        "health": 100,
        "speed": 5
      },
      "requirements": {
        "CopperBar": 2
      },
      "upgrade": {},
      "description": "CircuitBoard"
    },
    "CopperBar": {
      "width": 25,
      "height": 16,
      "cost": {
        "gold": 15
      },
      "stats": {
        "health": 100,
        "speed": 5
      },
      "requirements": {
        "CopperOre": 1
      },
      "upgrade": {},
      "description": "Copper bar"
    },
    "SteelBar": {
      "width": 25,
      "height": 16,
      "cost": {
        "gold": 15
      },
      "stats": {
        "health": 100,
        "speed": 5
      },
      "requirements": {
        "IronOre": 1
      },
      "upgrade": {},
      "description": "Steel bar"
    },
    "IronBar": {
      "width": 25,
      "height": 16,
      "cost": {
        "gold": 15
      },
      "stats": {
        "health": 100,
        "speed": 5
      },
      "requirements": {
        "IronOre": 1
      },
      "upgrade": {},
      "description": "Iron bar"
    },
    "Glass": {
      "width": 25,
      "height": 16,
      "cost": {
        "gold": 10
      },
      "stats": {
        "health": 100,
        "speed": 5
      },
      "requirements": {
        "Sand": 1
      },
      "upgrade": {},
      "description": "Glass"
    }
  },
  "Ores": {
    "PlantFiber": {
      "width": 26,
      "height": 22,
      "categories": {"crop": true},
      "isIngredient": true,
      "cost": {
        "gold": 5
      },
      "stats": {
        "health": 100,
        "speed": 5
      },
      "upgrade": {},
      "description": "Ingredient for crafting medicine"
    },
    "Explosives": {
      "width": 32,
      "height": 32,
      "categories": {},
      "requirements": {
        "SulfurOre": 1
      },
      "sprite": {
        "path": "sunflower"
      },
      "isFlower": true,
      "cost": {
        "gold": 250
      },
      "stats": {
      },
      "upgrade": {},
      "description": "Ingredient for making grenades and missiles"
    },
    "Sunflower": {
      "width": 32,
      "height": 32,
      "categories": {"crop": true},
      "sprite": {
        "path": "sunflower"
      },
      "isFlower": true,
      "cost": {
        "gold": 250
      },
      "stats": {
        "health": 100,
        "speed": 5
      },
      "upgrade": {},
      "description": "Flower that is placable on pot"
    },
    "BlueLotus": {
      "width": 32,
      "height": 32,
      "categories": {"crop": true},
      "cost": {
        "gold": 250
      },
      "isFlower": true,
      "sprite": {
        "path": "blue_lotus"
      },
      "stats": {
        "health": 100,
        "speed": 5
      },
      "upgrade": {},
      "description": "Flower that is placable on pot"
    },
    "Poppy": {
      "width": 32,
      "height": 32,
      "categories": {"crop": true},
      "cost": {
        "gold": 250
      },
      "isFlower": true,
      "sprite": {
        "path": "poppy"
      },
      "stats": {
        "health": 100,
        "speed": 5
      },
      "upgrade": {},
      "description": "Flower that is placable on pot"
    },
    "CoffeeBean": {
      "width": 20,
      "height": 20,
      "categories": {"crop": true},
      "cost": {
        "gold": 200
      },
      "stats": {
        "health": 100,
        "speed": 5
      },
      "upgrade": {},
      "description": "Ingredient for making coffee"
    },
    "Cloth": {
      "width": 26,
      "height": 22,
      "cost": {
        "gold": 10
      },
      "stats": {
        "health": 100,
        "speed": 5
      },
      "requirements": {
        "PlantFiber": 2
      },
      "upgrade": {},
      "description": "Ingredient for crafting furnitures and armors"
    },
    "Web": {
      "width": 26,
      "height": 22,
      "cost": {
        "gold": 50
      },
      "stats": {
        "health": 100,
        "speed": 5
      },
      "upgrade": {},
      "description": "Sticky. Useful for catching prey"
    },
    "Wood": {
      "width": 26,
      "height": 22,
      "cost": {
        "gold": 25
      },
      "stats": {
        "health": 100
      },
      "upgrade": {},
      "description": "Ingredient for crafting furnitures"
    },
    "Poison": {
      "width": 26,
      "height": 22,
      "cost": {
        "gold": 50
      },
      "stats": {
        "health": 100
      },
      "upgrade": {},
      "description": "Ingredient for crafting poisonous items or cure"
    },
    "SquidLordHeart": {
      "width": 26,
      "height": 22,
      "cost": {
        "gold": 1000
      },
      "stats": {
        "health": 100
      },
      "upgrade": {},
      "description": "Ingredient for crafting rare items"
    },
    "Sand": {
      "width": 26,
      "height": 22,
      "cost": {
        "gold": 15
      },
      "stats": {
        "health": 100
      },
      "upgrade": {},
      "description": "Ingredient for crafting certain equipments"
    },
    "NitroPowder": {
      "width": 26,
      "height": 22,
      "cost": {
        "gold": 20
      },
      "requirements": {
      },
      "stats": {
        "health": 100,
        "speed": 5
      },
      "upgrade": {},
      "description": "Ingredient for crafting explosives"
    },
    "Gold": {
      "width": 20,
      "height": 25,
      "cost": {
        "gold": 1
      },
      "stats": {
        "health": 100,
        "speed": 5
      },
      "upgrade": {},
      "description": "Currency for buying/selling goods and services"
    },
    "IceOre": {
      "width": 20,
      "height": 25,
      "cost": {
        "gold": 10
      },
      "stats": {
        "health": 100,
        "speed": 5
      },
      "upgrade": {},
      "description": "Ice ore"
    },
    "IronOre": {
      "width": 20,
      "height": 25,
      "cost": {
        "gold": 10
      },
      "stats": {
        "health": 100,
        "speed": 5
      },
      "upgrade": {},
      "description": "Iron ore"
    },
    "SteelOre": {
      "width": 20,
      "height": 25,
      "cost": {
        "gold": 15
      },
      "stats": {
        "health": 100,
        "speed": 5
      },
      "upgrade": {},
      "description": "Steel ore"
    },
    "SulfurOre": {
      "width": 20,
      "height": 25,
      "cost": {
        "gold": 15
      },
      "stats": {
        "health": 100,
        "speed": 5
      },
      "upgrade": {},
      "description": "Sulfur ore"
    },
    "Meteorite": {
      "width": 20,
      "height": 25,
      "cost": {
        "gold": 100
      },
      "stats": {
        "health": 100,
        "speed": 5
      },
      "upgrade": {},
      "description": "Meteorite"
    },
    "CopperOre": {
      "width": 20,
      "height": 25,
      "cost": {
        "gold": 10
      },
      "stats": {
        "health": 100,
        "speed": 5
      },
      "upgrade": {},
      "description": "Copper ore"
    }
  },
  "Ammos": {
    "BulletAmmo": {
      "width": 32,
      "height": 32,
      "cost": {
        "gold": 10
      },
      "stats": {
        "health": 100,
        "speed": 5,
        "range": 250
      },
      "requirements": {
        "IronOre": 3
      },
      "upgrade": {},
      "description": "Ammunition for Pistol/Turrets"
    },
    "PlasmaCell": {
      "width": 32,
      "height": 32,
      "cost": {
        "gold": 8
      },
      "stats": {
        "health": 100,
        "speed": 5,
        "range": 250
      },
      "requirements": {
        "SulfurOre": 1
      },
      "upgrade": {},
      "description": "Ammunition for Plasma Gun"
    },
    "RifleAmmo": {
      "width": 32,
      "height": 32,
      "cost": {
        "gold": 8
      },
      "stats": {
        "health": 100,
        "speed": 5,
        "range": 250
      },
      "requirements": {
        "IronOre": 2
      },
      "upgrade": {},
      "description": "Ammunition for AssaultRifle"
    },
    "ShotgunShell": {
      "width": 32,
      "height": 32,
      "cost": {
        "gold": 10
      },
      "stats": {
        "health": 100,
        "speed": 5,
        "range": 250
      },
      "requirements": {
        "IronOre": 10
      },
      "upgrade": {},
      "description": "Ammunition for Shotgun"
    },
    "Missile": {
      "width": 32,
      "height": 32,
      "cost": {
        "gold": 10
      },
      "stats": {
      },
      "requirements": {
        "CopperOre": 10,
        "Explosives": 1
      },
      "upgrade": {},
      "description": "Ammunition for Missile Turret"
    }
  },
  "Drinks": {
    "Beer": {
      "width": 24,
      "height": 24,
      "sprite": {
        "path": "beer"
      },
      "cost": {
        "gold": 300
      },
      "stats": {
        "stamina": 30
      },
      "requirements": {
        "Wheat": 1,
        "Bottle": 1
      },
      "description": "Restores 30 stamina. Dont Drink too much"
    },
    "Vodka": {
      "width": 24,
      "height": 24,
      "sprite": {
        "path": "vodka"
      },
      "cost": {
        "gold": 600
      },
      "stats": {
        "stamina": 40
      },
      "requirements": {
        "Potato": 2,
        "Bottle": 1
      },
      "description": "Restores 40 stamina. Make Russia great again!"
    },
    "Nihonshu": {
      "width": 24,
      "height": 24,
      "sprite": {
        "width": 30,
        "height": 36,
        "path": "nihonshu"
      },
      "cost": {
        "gold": 250
      },
      "stats": {
        "stamina": 40
      },
      "requirements": {
        "Rice": 1,
        "Bottle": 1
      },
      "description": "Japanese rice wine."
    },
    "EnergyDrink": {
      "width": 24,
      "height": 24,
      "sprite": {
        "path": "energy_drink"
      },
      "cost": {
        "gold": 300
      },
      "stats": {
        "stamina": 20
      },
      "requirements": {
        "CoffeeBean": 5,
        "Bottle": 1
      },
      "description": "Adds Haste effect."
    },
    "AlienJuice": {
      "width": 24,
      "height": 24,
      "sprite": {
        "path": "alien_juice"
      },
      "cost": {
        "gold": 300
      },
      "stats": {
        "stamina": 20
      },
      "requirements": {
        "SquidLordHeart": 1,
        "Bottle": 1
      },
      "description": "Adds Invisibility effect."
    },
    "Cola": {
      "width": 24,
      "height": 24,
      "cost": {
        "gold": 80
      },
      "sprite": {
        "path": "cola",
        "position": {
          "x": 48,
          "y": 20
        },
        "rotation": 35
      },
      "stats": {
        "stamina": 10,
        "thirst": 20
      },
      "requirements": {
        "PlantFiber": 3,
        "Bottle": 1
      },
      "description": "Restores 10 stamina"
    },
    "Coffee": {
      "width": 24,
      "height": 24,
      "cost": {
        "gold": 300
      },
      "sprite": {
        "path": "coffee",
        "position": {
          "x": 48,
          "y": 20
        },
        "rotation": 35
      },
      "stats": {
        "stamina": 50,
        "thirst": 20
      },
      "requirements": {
        "CoffeeBean": 1,
        "Bottle": 1
      },
      "description": "Restores 50 stamina"
    }
  },
      "Foods": {
    "Gelatin": {
      "width": 24,
      "height": 24,
      "cost": {
        "gold": 15
      },
      "stats": {
        "food": 25
      },
      "requirements": {
        "Gel": 1
      },
      "upgrade": {},
      "description": "Good source of protein. Yummy"
    },
    "Gel": {
      "width": 24,
      "height": 24,
      "cost": {
        "gold": 10
      },
      "stats": {
        "food": 5
      },
      "isIngredient": true,
      "upgrade": {},
      "description": "Can be cooked to make gelatin."
    },
    "AlienMeat": {
      "width": 24,
      "height": 24,
      "cost": {
        "gold": 5
      },
      "sprite": {
        "position": {
          "x": 32,
          "y": 0
        },
        "rotation": 0
      },
      "stats": {
        "food": 15
      },
      "upgrade": {},
      "description": "Raw Alien Meat. Cook to eat."
    },
    "HumanMeat": {
      "width": 24,
      "height": 24,
      "cost": {
        "gold": 20
      },
      "isIngredient": true,
      "sprite": {
        "position": {
          "x": 32,
          "y": 0
        },
        "rotation": 0
      },
      "stats": {
        "food": 25
      },
      "upgrade": {},
      "description": "Raw Human Meat. Do not eat."
    },
    "AnimalMeat": {
      "width": 24,
      "height": 24,
      "isIngredient": true,
      "cost": {
        "gold": 15
      },
      "sprite": {
        "position": {
          "x": 32,
          "y": 0
        },
        "rotation": 0
      },
      "stats": {
        "food": 25
      },
      "upgrade": {},
      "description": "Raw Animal Meat. Tasty if cooked."
    },
    "HotDog": {
      "width": 24,
      "height": 24,
      "sprite": {
        "position": {
          "x": 60,
          "y": 15
        }
      },
      "cost": {
        "gold": 300
      },
      "stats": {
        "food": 25
      },
      "requirements": {
        "AnimalMeat": 1,
        "Wheat": 1
      },
      "upgrade": {},
      "description": "Cooked Animal Meat. Classic American Food."
    },
    "Bread": {
      "width": 24,
      "height": 24,
      "sprite": {
        "position": {
          "x": 32,
          "y": 0
        },
        "rotation": 0
      },
      "cost": {
        "gold": 250
      },
      "stats": {
        "food": 25
      },
      "requirements": {
        "Wheat": 1
      },
      "upgrade": {},
      "description": "Yummy breakfast food"
    },
    "VeganPizza": {
      "width": 40,
      "height": 40,
      "sprite": {
        "position": {
          "x": 95,
          "y": -5
        }
      },
      "cost": {
        "gold": 500
      },
      "stats": {
        "food": 50
      },
      "requirements": {
        "PlantFiber": 5,
        "Wheat": 2
      },
      "upgrade": {},
      "description": "Pizza for vegans."
    },
    "SlimyMeatPizza": {
      "width": 40,
      "height": 40,
      "cost": {
        "gold": 500
      },
      "sprite": {
        "position": {
          "x": 95,
          "y": -5
        }
      },
      "stats": {
        "food": 100
      },
      "requirements": {
        "Gel": 2,
        "Wheat": 2
      },
      "upgrade": {},
      "description": "Exotic Pizza made from slime and animal meat."
    },
    "LectersDinner": {
      "width": 40,
      "height": 40,
      "cost": {
        "gold": 300
      },
      "stats": {
        "food": 50
      },
      "sprite": {
        "position": {
          "x": 70,
          "y": 0
        }
      },
      "requirements": {
        "HumanMeat": 1
      },
      "upgrade": {},
      "description": "Cooked Human meat"
    },
    "Potato": {
      "width": 24,
      "height": 24,
      "cost": {
        "gold": 150
      },
      "sprite": {
        "position": {
          "x": 32,
          "y": 0
        },
        "rotation": 0
      },
      "stats": {
        "food": 40
      },
      "upgrade": {},
      "description": "Staple food for Survival."
    },
    "Wheat": {
      "width": 24,
      "height": 24,
      "categories": {"crop": true},
      "isIngredient": true,
      "cost": {
        "gold": 200
      },
      "sprite": {
        "position": {
          "x": 70,
          "y": 0
        }
      },
      "isEdible": false,
      "stats": {
        "food": 10
      },
      "upgrade": {},
      "description": "Raw wheat. For making bread"
    },
    "Rice": {
      "width": 24,
      "height": 24,
      "categories": {"crop": true},
      "isIngredient": true,
      "cost": {
        "gold": 200
      },
      "sprite": {
        "position": {
          "x": 70,
          "y": 0
        }
      },
      "isEdible": false,
      "stats": {
        "food": 10
      },
      "upgrade": {},
      "description": "A bag of rice."
    },
    "Egg": {
      "width": 24,
      "height": 24,
      "cost": {
        "gold": 50
      },
      "isIngredient": true,
      "stats": {
        "food": 10
      },
      "sprite": {
        "position": {
          "x": 32,
          "y": 0
        },
        "rotation": 0
      },
      "upgrade": {},
      "description": "Good protein source"
    },
    "Fries": {
      "width": 24,
      "height": 24,
      "cost": {
        "gold": 100
      },
      "isIngredient": true,
      "stats": {
        "food": 70
      },
      "sprite": {
        "position": {
          "x": 65,
          "y": 5
        },
        "rotation": 90
      },
      "requirements": {
        "Potato": 3
      },
      "upgrade": {},
      "description": "Yummy potato fries"
    },
    "Steak": {
      "width": 24,
      "height": 24,
      "cost": {
        "gold": 200
      },
      "stats": {
        "food": 50
      },
      "sprite": {
        "position": {
          "x": 32,
          "y": 0
        },
        "rotation": 0
      },
      "requirements": {
        "AlienMeat": 1
      },
      "upgrade": {},
      "description": "Cooked meat. Dont care where it came from. "
    },
    "Pumpkin": {
      "width": 24,
      "height": 24,
      "cost": {
        "gold": 80
      },
      "sprite": {
        "position": {
          "x": 32,
          "y": 0
        },
        "rotation": 0
      },
      "stats": {
        "food": 30
      },
      "upgrade": {},
      "description": "Orange pumpkin."
    },
    "PotatoSoup": {
      "width": 32,
      "height": 32,
      "cost": {
        "gold": 200
      },
      "sprite": {
        "anchor": 0.5
      },
      "stats": {
        "food": 75
      },
      "requirements": {
        "Bowl": 1,
        "Potato": 2,
        "Bread": 1
      },
      "upgrade": {},
      "description": "Healthy and luxury breakfast dish"
    },
    "SlimeBroth": {
      "width": 32,
      "height": 32,
      "cost": {
        "gold": 200
      },
      "sprite": {
        "anchor": 0.5
      },
      "stats": {
        "food": 40
      },
      "requirements": {
        "Bowl": 1,
        "Gel": 3
      },
      "upgrade": {},
      "description": "An unembellished, but edible soup. Who knew your pet could satisfy your hunger?"
    },
    "MisoSoup": {
      "width": 32,
      "height": 32,
      "cost": {
        "gold": 200
      },
      "sprite": {
        "anchor": 0.5
      },
      "stats": {
        "food": 50
      },
      "requirements": {
        "Bowl": 1,
        "Bread": 2
      },
      "upgrade": {},
      "description": "A simple, but tasty soup dish. Don't burn your tongue!"
    },
    "Omelette": {
      "width": 24,
      "height": 24,
      "cost": {
        "gold": 200
      },
      "stats": {
        "food": 25
      },
      "sprite": {
        "position": {
          "x": 64,
          "y": 0
        },
        "rotation": 90
      },
      "requirements": {
        "Egg": 1
      },
      "upgrade": {},
      "description": "Breakfast favorite."
    },
    "Nigiri": {
      "width": 24,
      "height": 24,
      "cost": {
        "gold": 400
      },
      "stats": {
        "food": 50,
        "health": 25
      },
      "sprite": {
        "position": {
          "x": 55 ,
          "y": 0
        },
        "rotation": 70
      },
      "requirements": {
        "Fish": 1,
        "Rice": 1
      },
      "upgrade": {},
      "description": "Type of japanese sushi dish made with japanese rice and slice of fish on top. Perfect small and healthy meal."
    },
    "PumpkinPie": {
      "width": 32,
      "height": 32,
      "cost": {
        "gold": 250
      },
      "sprite": {
        "anchor": 0.5
      },
      "stats": {
        "food": 80,
        "health": 20
      },
      "requirements": {
        "Pumpkin": 2,
        "Egg": 2,
        "Wheat": 2
      },
      "upgrade": {},
      "description": "Tasty dessert pie with a spiced, pumpkin-based custard filling."
    },
    "Starberries": {
      "width": 21,
      "height": 14,
      "cost": {
        "gold": 500
      },
      "stats": {
        "food": 40,
        "health": 30
      },
      "sprite": {
        "position": {
          "x": 64,
          "y": 0
        },
        "rotation": 90
      },
      "upgrade": {},
      "description": "Strange berries from alien bushes."
    },
    "Fish": {
      "width": 32,
      "height": 32,
      "cost": {
        "gold": 200
      },
      "sprite": {
        "anchor": 0.5
      },
      "stats": {
        "food": 40,
        "health": 30
      },
      "upgrade": {},
      "description": "A yummy fish, used in lots of dishes. I wonder where that trader got it from?"
    },
    "Antidote": {
      "width": 24,
      "height": 24,
      "cost": {
        "gold": 15
      },
      "isEdible": false,
      "categories": {"drug": true},
      "sprite": {
        "position": {
          "x": 50,
          "y": 20
        },
        "rotation": 35
      },
      "stats": {
        "food": 0,
        "health": 100,
        "reload": 3000
      },
      "requirements": {
        "Poison": 1,
        "Bottle": 1
      },
      "upgrade": {},
      "description": "Cures poison"
    },
    "BloodPack": {
      "width": 24,
      "height": 24,
      "isEdible": false,
      "categories": {"drug": true},
      "cost": {
        "gold": 80
      },
      "sprite": {
        "position": {
          "x": 40,
          "y": 0
        },
        "rotation": 0
      },
      "stats": {
        "food": 0,
        "health": 50
      },
      "requirements": {
        "BloodBottle": 1
      },
      "upgrade": {},
      "description": "Heals 50 health points"
    },
    "Stimpack": {
      "width": 24,
      "height": 24,
      "categories": {"drug": true},
      "isEdible": false,
      "cost": {
        "gold": 600
      },
      "sprite": {
        "position": {
          "x": 50,
          "y": 55
        },
        "rotation": 210
      },
      "stats": {
        "food": 0
      },
      "requirements": {
        "IronBar": 20,
        "BloodPack": 1,
        "PlantFiber": 5
      },
      "upgrade": {},
      "description": "Doubles Attack Speed for 15 seconds. Reduces health by 25"
    },
    "FirstAidKit": {
      "width": 24,
      "height": 24,
      "cost": {
        "gold": 50
      },
      "isEdible": false,
      "categories": {"drug": true},
      "stats": {
        "food": 0,
        "health": 50
      },
      "requirements": {
        "PlantFiber": 5
      },
      "upgrade": {},
      "description": "Heals 50 health points instantly"
    }
  },
  "Equipments": {
    "BaseEquipment": {
      "abstract": true,
      "width": 24,
      "height": 24,
      "useOriginalSize": true,
      "stats": {
        "health": 100,
        "speed": 5
      }
    },
    "MeleeEquipment": {
      "parent": "Equipments.BaseEquipment",
      "categories": {"melee_weapon": true},
      "useOriginalSize": true,
      "abstract": true,
      "stats": {
        "range": 32
      }
    },
    "Syringe": {
      "parent": "Equipments.BaseEquipment",
      "isWeapon": true,
      "cost": {
        "gold": 30
      },
      "stats": {
        "range": 250,
        "liquidCapacity": 100
      },
      "description": "[Deprecated]"
    },
    "Lighter": {
      "parent": "Equipments.MeleeEquipment",
      "isAnimatable": true,
      "isWeapon": true,
      "cost": {
        "gold": 100
      },
      "shouldNotRemoveOnBreak": true,
      "stats": {
        "health": 50,
        "range": 64,
        "usageCapacity": 10,
        "fuelConsumption": 40,
        "meleeRange": 48
      },
      "requirements": {
        "Glass": 2,
        "CopperBar": 5
      },
      "description": "Light things on fire. Refill with FuelTank"
    },
    "NameTag": {
      "parent": "Equipments.MeleeEquipment",
      "isStackable": true,
      "cost": {
        "gold": 15000
      },
      "sprite": {
        "position": {
          "x": 48,
          "y": 16
        },
        "rotation": 0
      },
      "isUnbreakable": true,
      "stats": {
        "range": 64
      },
      "requirements": {
      },
      "description": "Change name of pet or slave"
    },
    "Bottle": {
      "parent": "Equipments.MeleeEquipment",
      "cost": {
        "gold": 15
      },
      "shouldShowUsage": true,
      "isUnbreakable": true,
      "shouldNotRemoveOnBreak": true,
      "isAnimatable": true,
      "stats": {
        "range": 64,
        "liquidCapacity": 100,
        "oxygenProduction": 50
      },
      "requirements": {
        "Glass": 2
      },
      "description": "Stores liquid"
    },
    "BloodBottle": {
      "parent": "Equipments.Bottle",
      "description": "Contains Blood"
    },
    "Bowl": {
      "parent": "Equipments.MeleeEquipment",
      "width": 32,
      "height": 32,
      "isStackable": true,
      "shouldShowUsage": false,
      "isUnbreakable": true,
      "cost": {
        "gold": 100
      },
      "sprite": {
        "path": "bowl_by_px",
        "position": {
          "x": 50,
          "y": 20
        },
        "anchor": 0.5
      },
      "stats": {
      },
      "requirements": {
        "Wood": 10
      },
      "description": "Can be used to craft Soups"
    },
    "WaterBottle": {
      "parent": "Equipments.Bottle",
      "description": "Used to fill up OxygenGenerator or watering plants"
    },
    "SurvivalTool": {
      "parent": "Equipments.MeleeEquipment",
      "isAnimatable": true,
      "isUnbreakable": true,
      "isWeapon": true,
      "categories": {"melee_damage": true},
      "cost": {
        "gold": 300
      },
      "stats": {
        "damage": 2,
        "range": 250,
        "meleeRange": 48
      },
      "requirements": {
        "IronBar": 25,
        "CircuitBoard": 5
      },
      "description": "Used for mining, and salvaging objects. Damage 2"
    },
    "Drill": {
      "parent": "Equipments.MeleeEquipment",
      "isAnimatable": true,
      "isWeapon": true,
      "cost": {
        "gold": 600
      },
      "stats": {
        "damage": 5,
        "range": 250,
        "meleeRange": 48
      },
      "requirements": {
        "IronBar": 20,
        "CopperBar": 20,
        "Wire": 5
      },
      "description": "Mines Asteroids faster. Damage 5"
    },
    "Deconstructor": {
      "parent": "Equipments.BaseEquipment",
      "canDamageWalls": true,
      "isWeapon": true,
      "isFireArm": true,
      "cost": {
        "gold": 2050
      },
      "stats": {
        "range": 1500,
        "damage": 100,
        "health": 20,
        "reload": 2000
      },
      "requirements": {
        "IronBar": 95,
        "CopperBar": 215,
        "Wire": 10,
        "CircuitBoard": 20
      },
      "sprite": {
        "position": {
          "x": 67,
          "y": 20
        }
      },
      "description": "An energy powered gun which easily destroys buildings"
    },
    "Pistol": {
      "parent": "Equipments.BaseEquipment",
      "isWeapon": true,
      "isFireArm": true,
      "cost": {
        "gold": 250
      },
      "stats": {
        "range": 960,
        "damage": 10,
        "health": 300,
        "reload": 500
      },
      "requirements": {
        "IronBar": 10,
        "CopperBar": 10
      },
      "description": "Range weapon. Damage 10"
    },
    "Shotgun": {
      "parent": "Equipments.BaseEquipment",
      "isWeapon": true,
      "isFireArm": true,
      "cost": {
        "gold": 550
      },
      "stats": {
        "range": 256,
        "damage": 12,
        "health": 300,
        "reload": 1500
      },
      "requirements": {
        "IronBar": 20,
        "CopperBar": 20
      },
      "description": "Spread shot weapon. Each Deals Damage 12"
    },
    "PlasmaGun": {
      "parent": "Equipments.BaseEquipment",
      "isWeapon": true,
      "isFireArm": true,
      "cost": {
        "gold": 2000
      },
      "stats": {
        "range": 1280,
        "damage": 52,
        "health": 300,
        "reload": 1200
      },
      "requirements": {
        "CopperBar": 20,
        "Meteorite": 20
      },
      "description": "Concentrated Energy Shot weapon"
    },
    "AssaultRifle": {
      "parent": "Equipments.BaseEquipment",
      "isWeapon": true,
      "isFireArm": true,
      "cost": {
        "gold": 900
      },
      "stats": {
        "range": 960,
        "damage": 7,
        "health": 300,
        "reload": 1000
      },
      "requirements": {
        "IronBar": 30,
        "CopperBar": 30
      },
      "description": "Burst Weapon that shoots fast projectiles"
    },
    "Scar17": {
      "parent": "Equipments.BaseEquipment",
      "isWeapon": true,
      "isFireArm": true,
      "cost": {
        "gold": 700
      },
      "stats": {
        "range": 960,
        "damage": 9,
        "health": 300,
        "reload": 1200
      },
      "requirements": {
        "IronBar": 70,
        "CopperBar": 70
      },
      "description": "Burst Weapon that shoots fast projectiles"
    },
    "RocketLauncher": {
      "parent": "Equipments.BaseEquipment",
      "isWeapon": true,
      "isFireArm": true,
      "cost": {
        "gold": 900
      },
      "stats": {
        "range": 960,
        "damage": 25,
        "health": 300,
        "reload": 1000
      },
      "requirements": {
        "SulfurOre": 2,
        "CircuitBoard": 20
      },
      "description": "Shoots missiles towards target enemy"
    },
    "FlameThrower": {
      "parent": "Equipments.MeleeEquipment",
      "isWeapon": true,
      "cost": {
        "gold": 450
      },
      "isFireArm": true,
      "shouldNotRemoveOnBreak": true,
      "stats": {
        "damage": 2,
        "usageCapacity": 20,
        "fuelConsumption": 80,
        "range": 200
      },
      "requirements": {
        "CopperBar": 30
      },
      "description": "Shoots flames"
    },
    "SquidStaff": {
      "parent": "Equipments.BaseEquipment",
      "isWeapon": true,
      "isFireArm": true,
      "cost": {
        "gold": 5000
      },
      "sprite": {
        "position": {
          "x": 70,
          "y": -60
        },
        "anchor": 0,
        "rotation": 90
      },
      "stats": {
        "range": 800,
        "damage": 10,
        "health": 300,
        "reload": 800
      },
      "requirements": {
        "SquidLordHeart": 1,
        "Meteorite": 20
      },
      "description": "Shoots 5 beams of charged energy"
    },
    "MolotovCocktail": {
      "parent": "Equipments.MeleeEquipment",
      "isWeapon": true,
      "isThrowable": true,
      "isUnbreakable": true,
      "cost": {
        "gold": 80
      },
      "stats": {
        "damage": 5,
        "range": 256
      },
      "requirements": {
        "Beer": 1,
        "Cloth": 1
      },
      "description": "Throw it to an area to create flames"
    },
    "Grenade": {
      "parent": "Equipments.MeleeEquipment",
      "isWeapon": true,
      "isThrowable": true,
      "isStackable": true,
      "isUnbreakable": true,
      "isCostIndependent": true,
      "cost": {
        "gold": 1000
      },
      "stats": {
        "damage": 25,
        "range": 256,
        "reload": 1000
      },
      "requirements": {
        "Explosives": 1,
        "IronBar": 5
      },
      "description": "Throwable item that creates explosive damage"
    },
    "PoisonGrenade": {
      "parent": "Equipments.MeleeEquipment",
      "isWeapon": true,
      "isThrowable": true,
      "isStackable": true,
      "isUnbreakable": true,
      "isCostIndependent": true,
      "cost": {
        "gold": 750
      },
      "stats": {
        "damage": 25,
        "range": 256,
        "reload": 1000
      },
      "requirements": {
        "Explosives": 1,
        "Poison": 1
      },
      "description": "Throwable item that emits poison to an area"
    },
    "Dynamite": {
      "parent": "Equipments.MeleeEquipment",
      "isWeapon": true,
      "isThrowable": true,
      "isUnbreakable": true,
      "isStackable": true,
      "isCostIndependent": true,
      "cost": {
        "gold": 1500
      },
      "stats": {
        "damage": 10,
        "range": 256,
        "reload": 900
      },
      "requirements": {
        "Explosives": 30,
        "IronOre": 5
      },
      "description": "Creates an explosion that easily destroys asteroids that can't be salvaged."
    },
    "FireExtinguisher": {
      "parent": "Equipments.BaseEquipment",
      "cost": {
        "gold": 200
      },
      "stats": {
        "range": 64,
        "damage": 2
      },
      "requirements": {
        "IronBar": 25
      },
      "description": "Puts out fire."
    },
    "Disinfectant": {
      "parent": "Equipments.BaseEquipment",
      "cost": {
        "gold": 200
      },
      "stats": {
        "range": 32,
        "damage": 2
      },
      "sprite": {
        "position": {
          "x": 70,
          "y": 20
        },
        "anchor": 0,
        "rotation": 90
      },
      "requirements": {
        "PlantFiber": 10,
        "Bottle": 1
      },
      "description": "Cleans area. Removes miasma."
    },
    "Radio": {
      "parent": "Equipments.BaseEquipment",
      "isUnbreakable": true,
      "cost": {
        "gold": 300
      },
      "stats": {
        "range": 32,
        "damage": 2
      },
      "sprite": {
        "position": {
          "x": 70,
          "y": 20
        },
        "anchor": 0,
        "rotation": 90
      },
      "requirements": {
        "CircuitBoard": 20,
        "IronBar": 10
      },
      "description": "Comm Device. Report suspicious activities."
    },
    "PocketTrader": {
      "parent": "Equipments.BaseEquipment",
      "isUnbreakable": true,
      "cost": {
        "gold": 300
      },
      "stats": {
        "range": 32,
        "damage": 2
      },
      "sprite": {
        "position": {
          "x": 30,
          "y": 0
        },
        "anchor": 0,
        "rotation": 0
      },
      "requirements": {
        "CircuitBoard": 20,
        "Meteorite": 10
      },
      "description": "Buy/Sell items"
    },
    "Wrench": {
      "parent": "Equipments.BaseEquipment",
      "cost": {
        "gold": 300
      },
      "stats": {
        "range": 32,
        "damage": 2,
        "meleeRange": 48
      },
      "sprite": {
        "position": {
          "x": 50,
          "y": 15
        },
        "anchor": 0,
        "rotation": 90
      },
      "isAnimatable": true,
      "requirements": {
        "IronBar": 25
      },
      "description": "Repairs Structures"
    },
    "Mop": {
      "parent": "Equipments.MeleeEquipment",
      "cost": {
        "gold": 50
      },
      "isAnimatable": true,
      "stats": {
        "damage": 1,
        "health": 30,
        "range": 40,
        "meleeRange": 48
      },
      "requirements": {
        "IronOre": 10
      },
      "upgrade": {},
      "description": "Floor cleaning equipment"
    },
    "LeadPipe": {
      "parent": "Equipments.MeleeEquipment",
      "isWeapon": true,
      "cost": {
        "gold": 100
      },
      "categories": {"melee_damage": true},
      "isAnimatable": true,
      "stats": {
        "damage": 7,
        "range": 55,
        "meleeRange": 55
      },
      "requirements": {
        "IronOre": 10
      },
      "description": "Basic Melee weapon. Damage 7"
    },
    "PlasmaBlade": {
      "parent": "Equipments.MeleeEquipment",
      "isWeapon": true,
      "sprite": {
        "width": 120,
        "height": 40,
        "position": {
          "x": 62,
          "y": 0
        },
        "anchor": 0,
        "rotation": 90
      },
      "cost": {
        "gold": 1000
      },
      "categories": {"melee_damage": true},
      "isAnimatable": true,
      "stats": {
        "damage": 35,
        "range": 75,
        "meleeRange": 75
      },
      "requirements": {
        "CopperBar": 20,
        "Meteorite": 25
      },
      "description": "Strong blade made of plasma"
    },
    "AssassinsKnife": {
      "parent": "Equipments.MeleeEquipment",
      "isWeapon": true,
      "cost": {
        "gold": 1000
      },
      "shouldShowCooldown": true,
      "sprite": {
        "position": {
          "x": 30,
          "y": 0
        },
        "anchor": 0,
        "rotation": 0
      },
      "categories": {"melee_damage": true},
      "isAnimatable": true,
      "canDamageEveryone": true,
      "stats": {
        "damage": 1,
        "attackRadius": 128,
        "reload": 20000
      },
      "requirements": {
      },
      "description": "Looks like a radio but is actually an Assassins Knife"
    },
    "Katana": {
      "parent": "Equipments.MeleeEquipment",
      "isWeapon": true,
      "cost": {
        "gold": 500
      },
      "categories": {"melee_damage": true},
      "sprite": {
        "position": {
          "x": 53,
          "y": -8
        },
        "anchor": 0,
        "rotation": 90
      },
      "concurrentTargetCount": 3,
      "isAnimatable": true,
      "stats": {
        "damage": 15,
        "range": 64,
        "attackRadius": 64,
        "meleeRange": 64
      },
      "requirements": {
        "IronOre": 50,
        "Wood": 20
      },
      "description": "Can slice through 3 enemies at a time. Damage 15."
    },
    "BlueEnergySword": {
      "parent": "Equipments.MeleeEquipment",
      "isWeapon": true,
      "cost": {
        "gold": 2000
      },
      "categories": {"melee_damage": true},
      "sprite": {
        "position": {
          "x": 45,
          "y": 5
        },
        "anchor": 0,
        "rotation": 90
      },
      "concurrentTargetCount": 3,
      "isAnimatable": true,
      "stats": {
        "damage": 25,
        "range": 48,
        "attackRadius": 48,
        "meleeRange": 48
      },
      "requirements": {
        "Meteorite": 10,
        "CopperBar": 10
      },
      "description": "A energy based sword forged from meteorite. Damage 25"
    },
    "GreenEnergySword": {
      "parent": "Equipments.BlueEnergySword"
    },
    "RedEnergySword": {
      "parent": "Equipments.BlueEnergySword"
    },
    "StunBaton": {
      "parent": "Equipments.MeleeEquipment",
      "isAnimatable": true,
      "isWeapon": true,
      "cost": {
        "gold": 150
      },
      "sprite": {
        "path": "stun_baton",
        "position": {
          "x": 42,
          "y": 0
        },
        "anchor": 0,
        "rotation": 90
      },
      "categories": {"wall_breaker":true,"melee_damage":true},
      "stats": {
        "damage": 6,
        "health": 200,
        "range": 48,
        "meleeRange": 48
      },
      "requirements": {
        "IronBar": 10,
        "CircuitBoard": 2
      },
      "description": "Melee Weapon that can stun enemy. Damage 6"
    },
    "SantaHat": {
      "parent": "Equipments.BaseEquipment",
      "width": 50,
      "height": 50,
      "cost": {
        "gold": 10000
      },
      "isCostIndependent": true,
      "stats": {
        "range": 64
      },
      "requirements": {
        "Cloth": 20
      },
      "description": "Hat that santa wears"
    },
    "SpaceSuit": {
      "parent": "Equipments.BaseEquipment",
      "width": 64,
      "height": 64,
      "lightColor": "#ffffff",
      "isLightPersistent": true,
      "brightness": 0.8,
      "cost": {
        "gold": 200
      },
      "stats": {
        "range": 64,
        "oxygen": 300
      },
      "requirements": {
        "Glass": 5,
        "Cloth": 20,
        "IronBar": 20
      },
      "description": "Wear this in space to avoid suffocating"
    },
    "CombatArmor": {
      "parent": "Equipments.BaseEquipment",
      "width": 64,
      "height": 64,
      "lightColor": "#ffffff",
      "isLightPersistent": true,
      "isCostIndependent": true,
      "brightness": 0.8,
      "cost": {
        "gold": 8000
      },
      "stats": {
        "range": 64,
        "oxygen": 150,
        "defense": 4
      },
      "requirements": {
        "Meteorite": 40,
        "SpaceSuit": 1
      },
      "description": "Good for melee combat. Reduces damage by 4."
    },
    "ImperialSpecialForcesArmor": {
      "parent": "Equipments.BaseEquipment",
      "width": 64,
      "height": 64,
      "lightColor": "#ffffff",
      "isLightPersistent": true,
      "isCostIndependent": true,
      "brightness": 0.8,
      "cost": {
        "gold": 50000
      },
      "stats": {
        "range": 64,
        "oxygen": 100,
        "defense": 10
      },
      "requirements": {
        "Meteorite": 180,
        "SulfurOre": 20,
        "CombatArmor": 1,
        "CircuitBoard": 40
      },
      "description": "Advanced armor used by Imperial Special Forces. That reduces damage by 10 and is immune to negative effects."
    },
    "PrisonerSuit": {
      "parent": "Equipments.BaseEquipment",
      "width": 64,
      "height": 64,
      "lightColor": "#ffffff",
      "isLightPersistent": true,
      "brightness": 0.8,
      "stats": {
        "range": 64
      },
      "requirements": {
        "PlantFiber": 30
      },
      "description": "Prisoner clothing"
    },
    "PoliceSuit": {
      "parent": "Equipments.BaseEquipment",
      "width": 64,
      "height": 64,
      "lightColor": "#ffffff",
      "isLightPersistent": true,
      "brightness": 0.8,
      "stats": {
        "range": 64
      },
      "requirements": {
        "PlantFiber": 50
      },
      "description": "Police clothing"
    },
    "LabCoat": {
      "parent": "Equipments.BaseEquipment",
      "width": 64,
      "height": 64,
      "lightColor": "#ffffff",
      "isLightPersistent": true,
      "brightness": 0.8,
      "stats": {
        "range": 64
      },
      "requirements": {
        "PlantFiber": 50
      },
      "description": "Scientist clothing"
    },
    "CultistSuit": {
      "parent": "Equipments.BaseEquipment",
      "width": 80,
      "height": 75,
      "lightColor": "#ffffff",
      "isLightPersistent": true,
      "brightness": 0.8,
      "stats": {
        "range": 64
      },
      "requirements": {
        "PlantFiber": 50
      },
      "description": "Cult Leader clothing"
    },
    "HazmatSuit": {
      "parent": "Equipments.BaseEquipment",
      "width": 64,
      "height": 64,
      "lightColor": "#ffffff",
      "isLightPersistent": true,
      "isCostIndependent": true,
      "brightness": 0.8,
      "cost": {
        "gold": 25000
      },
      "stats": {
        "range": 64,
        "oxygen": 150
      },
      "requirements": {
        "Meteorite": 50,
        "PlantFiber": 20,
        "SpaceSuit": 1
      },
      "description": "Protect against environmental hazards (miasma, poison)"
    }
  },
  "Transports": {
    "RailTram": {
      "width": 96,
      "height": 96,
      "cost": {
        "gold": 1000
      },
      "categories": {"rail":true,"rail_tram":true},
      "isPassable": true,
      "requirements": {
        "IronBar": 50,
        "Wire": 10,
        "CircuitBoard": 5
      },
      "stats": {
        "health": 500,
        "count": 125
      },
      "upgrade": {
        "health": "+25",
        "count": "+25"
      },
      "description": "Fast rail transportation. Must be placed at end of Rail Track"
    }
  },
  "Floors": {
    "BaseFloor": {
      "categories": {"platform": true},
      "abstract": true,
      "width": 32,
      "height": 32
    },
    "Lattice": {
      "parent": "Floors.BaseFloor",
      "cost": {
        "gold": 15
      },
      "requirements": {
        "IronBar": 1
      },
      "stats": {
        "health": 50,
        "count": 125
      },
      "upgrade": {
        "health": "+25",
        "count": "+25"
      },
      "description": "Lightweight support. Can only be placed outside asteroid area"
    },
    "Floor": {
      "parent": "Floors.BaseFloor",
      "cost": {
        "gold": 20
      },
      "categories": {"custom_colors": true},
      "requirements": {
        "IronBar": 1
      },
      "stats": {
        "health": 125
      },
      "description": "Customizable floor. Double-click to change color and texture"
    },
    "SteelFloor": {
      "parent": "Floors.BaseFloor",
      "cost": {
        "gold": 20
      },
      "requirements": {
        "IronBar": 1
      },
      "stats": {
        "health": 50,
        "count": 125
      },
      "upgrade": {
        "health": "+25",
        "count": "+25"
      },
      "description": "Allow players to move around and place additional buildings"
    },
    "WoodFloor": {
      "parent": "Floors.BaseFloor",
      "cost": {
        "gold": 30
      },
      "requirements": {
        "Wood": 1
      },
      "stats": {
        "health": 250,
        "count": 1
      },
      "upgrade": {
        "health": "+25",
        "count": "+1"
      },
      "description": "wooden floor"
    },
    "BlueFloor": {
      "parent": "Floors.BaseFloor",
      "cost": {
        "gold": 30
      },
      "sprite": {
        "path": "blue_floor"
      },
      "requirements": {
        "IronBar": 1
      },
      "stats": {
        "health": 250,
        "count": 1
      },
      "upgrade": {
        "health": "+25",
        "count": "+1"
      },
      "description": "blue floor"
    },
    "GreenFloor": {
      "parent": "Floors.BaseFloor",
      "cost": {
        "gold": 30
      },
      "requirements": {
        "IronBar": 1
      },
      "stats": {
        "health": 250,
        "count": 1
      },
      "upgrade": {
        "health": "+25",
        "count": "+1"
      },
      "description": "green floor"
    },
    "PurpleFloor": {
      "parent": "Floors.BaseFloor",
      "cost": {
        "gold": 30
      },
      "requirements": {
        "IronBar": 1
      },
      "stats": {
        "health": 250,
        "count": 1
      },
      "upgrade": {
        "health": "+25",
        "count": "+1"
      },
      "description": "purple floor"
    },
    "YellowFloor": {
      "parent": "Floors.BaseFloor",
      "cost": {
        "gold": 30
      },
      "sprite": {
        "path": "yellow_floor"
      },
      "requirements": {
        "IronBar": 1
      },
      "stats": {
        "health": 250,
        "count": 1
      },
      "upgrade": {
        "health": "+25",
        "count": "+1"
      },
      "description": "yellow floor"
    },
    "BronzeFloor": {
      "parent": "Floors.BaseFloor",
      "cost": {
        "gold": 30
      },
      "sprite": {
        "path": "bronze_floor"
      },
      "requirements": {
        "CopperBar": 1
      },
      "stats": {
        "health": 250,
        "count": 1
      },
      "upgrade": {
        "health": "+25",
        "count": "+1"
      },
      "description": "Bronze floor"
    },
    "GrayFloor": {
      "parent": "Floors.BaseFloor",
      "cost": {
        "gold": 30
      },
      "sprite": {
        "path": "gray_floor"
      },
      "requirements": {
        "IronBar": 1
      },
      "stats": {
        "health": 250,
        "count": 1
      },
      "upgrade": {
        "health": "+25",
        "count": "+1"
      },
      "description": "gray floor"
    },
    "GrassFloor": {
      "parent": "Floors.BaseFloor",
      "cost": {
        "gold": 40
      },
      "sprite": {
        "path": "grass_floor"
      },
      "requirements": {
        "IronBar": 1,
        "PlantFiber": 1
      },
      "stats": {
        "health": 250,
        "count": 1
      },
      "upgrade": {
        "health": "+25",
        "count": "+1"
      },
      "description": "grass floor"
    },
    "PinkFloor": {
      "parent": "Floors.BaseFloor",
      "cost": {
        "gold": 30
      },
      "sprite": {
        "path": "pink_floor"
      },
      "requirements": {
        "IronBar": 1
      },
      "stats": {
        "health": 250,
        "count": 1
      },
      "upgrade": {
        "health": "+25",
        "count": "+1"
      },
      "description": "pink floor"
    },
    "CarpetFloor": {
      "parent": "Floors.BaseFloor",
      "cost": {
        "gold": 30
      },
      "requirements": {
        "Cloth": 2
      },
      "stats": {
        "health": 250,
        "count": 1
      },
      "upgrade": {
        "health": "+25",
        "count": "+1"
      },
      "description": "red carpet"
    },
    "PlatedFloor": {
      "parent": "Floors.BaseFloor",
      "cost": {
        "gold": 30
      },
      "requirements": {
        "IronBar": 1
      },
      "stats": {
        "health": 250,
        "count": 1
      },
      "upgrade": {
        "health": "+25",
        "count": "+1"
      },
      "description": "plated floor"
    },
    "StripePlatedFloor": {
      "parent": "Floors.BaseFloor",
      "cost": {
        "gold": 30
      },
      "requirements": {
        "IronBar": 1
      },
      "stats": {
        "health": 250,
        "count": 1
      },
      "upgrade": {
        "health": "+25",
        "count": "+1"
      },
      "description": "stripe plated floor"
    },
    "Soil": {
      "width": 32,
      "height": 32,
      "categories": {"soil":true,"platform":true},
      "cost": {
        "gold": 30
      },
      "requirements": {
        "Sand": 2
      },
      "stats": {
        "health": 250,
        "count": 1
      },
      "upgrade": {
        "health": "+25",
        "count": "+1"
      },
      "description": "Used for growing crops"
    },
    "TiledFloor": {
      "parent": "Floors.BaseFloor",
      "cost": {
        "gold": 30
      },
      "requirements": {
        "IronBar": 2
      },
      "stats": {
        "health": 250,
        "count": 1
      },
      "upgrade": {
        "health": "+25",
        "count": "+1"
      },
      "description": "tiled floor"
    }
  },
  "Walls": {
    "BaseWall": {
      "width": 32,
      "height": 32,
      "abstract": true,
      "isLightBlocker": true,
      "isAirtight": true,
      "isUpgradable": true,
      "minimapColor": "#444444",
      "categories": {"wall":true, "melee_resistant":true, "custom_colors": true},
      "cost": {
        "gold": 15
      },
      "requirements": {
        "IronBar": 1
      },
      "stats": {
        "health": 300,
        "pvpHealth": 600,
        "count": 100
      },
      "upgrade": {
        "health": "+100",
        "count": "+25"
      }
    },
    "Wall": {
      "parent": "Walls.BaseWall",
      "sprite": {
        "path": "wall",
        "basepath": "wall_0",
        "color": "#2a2a2a"
      },
      "description": "Airtight structure for sealing a room"
    },
    "BlueWall": {
      "parent": "Walls.BaseWall",
      "description": "blue wall",
      "sprite": {
        "path": "blue_wall",
        "basepath": "wall_0",
        "color": "#3a3e55"
      }
    },
    "GreenWall": {
      "parent": "Walls.BaseWall",
      "description": "green wall",
      "sprite": {
        "path": "green_wall",
        "basepath": "wall_0",
        "color": "#25352d"
      }
    },
    "IvoryWall": {
      "parent": "Walls.BaseWall",
      "description": "white wall",
      "sprite": {
        "path": "white_wall",
        "basepath": "wall_0",
        "color": "#8c8a7d"
      }
    }
  },
  "Buildings": {
    "UnbreakableWall": {
      "isAbstract": true,
      "isAirtight": true,
      "width": 32,
      "height": 32,
      "cost": {
        "gold": 70
      },
      "stats": {
        "health": 750,
        "speed": 1,
        "count": 1
      },
      "description": "A sturdy, airtight wall, that only the owner of a world/sector can place or break."
      
    },
    "HangarCornerBlock": {
      "width": 32,
      "height": 32,
      "cost": {
        "gold": 300
      },
      "stats": {
        "health": 100,
        "speed": 5,
        "count": 2
      },
      "upgrade": {
        "health": "+150",
        "count": "+1"
      },
      "maxCount": 1
    },
    "HangarController": {
      "width": 32,
      "height": 64,
      "cost": {
        "gold": 300
      },
      "isInteractable": true,
      "energy": 50,
      "stats": {
        "health": 100,
        "speed": 5,
        "count": 2
      },
      "upgrade": {
        "health": "+150",
        "count": "+1"
      },
      "maxCount": 1
    },
    "ShipyardConstructor": {
      "width": 32,
      "height": 32,
      "hasMenu": true,
      "cost": {
        "gold": 300
      },
      "stats": {
        "health": 100,
        "speed": 5,
        "count": 2
      },
      "upgrade": {
        "health": "+150",
        "count": "+1"
      },
      "maxCount": 1
    },
    "Thruster": {
      "width": 32,
      "height": 32,
      "isAirtight": true,
      "cost": {
        "gold": 300
      },
      "stats": {
        "health": 100,
        "speed": 5,
        "count": 2
      },
      "upgrade": {
        "health": "+150",
        "count": "+1"
      },
      "maxCount": 1,
      "description": "Provided ship mobility"
    },
    "Reactor": {
      "width": 64,
      "height": 64,
      "cost": {
        "gold": 500
      },
      "stats": {
        "health": 500,
        "powerProduction": 100,
        "count": 3
      },
      "upgrade": {
        "health": "+100",
        "energy": "+50",
        "count": "+1"
      },
      "maxCount": 1,
      "description": "Generates Energy for Weapons"
    },
    "MineralStorage": {
      "width": 64,
      "height": 64,
      "cost": {
        "gold": 250
      },
      "stats": {
        "health": 250,
        "minerals": 5000,
        "count": 2
      },
      "upgrade": {
        "health": "+100",
        "minerals": "+5000"
      },
      "maxCount": 1
    },
    "MineralMiner": {
      "width": 64,
      "height": 64,
      "cost": {
        "gold": 500
      },
      "stats": {
        "damage": 20,
        "health": 200,
        "production": 500,
        "reload": 2500,
        "range": 700,
        "count": 1
      },
      "upgrade": {
        "damage": "+2",
        "health": "+100",
        "count": "+1"
      },
      "maxCount": 1,
      "description": "Increases Minerals overtime"
    },
    "ShieldGenerator": {
      "width": 64,
      "height": 64,
      "energy": 100,
      "cost": {
        "gold": 500
      },
      "stats": {
        "health": 250,
        "count": 1
      },
      "upgrade": {
        "health": "+250",
        "count": "+1"
      },
      "maxCount": 1,
      "description": "Generates a force field around the entire ship. [Requires Energy]"
    },
    "WallLamp": {
      "width": 32,
      "height": 32,
      "isInteractable": true,
      "categories": {"not_structure_conduit":true,"switch":true,"lamp":true},
      "hasEditableContent": true,
      "showInteractTooltip": true,
      "isPassable": true,
      "isLightSource": true,
      "lightColor": "#ffffff",
      "lightRadius": 15,
      "useOriginalSize": true,
      "cost": {
        "gold": 50
      },
      "requirements": {
        "Glass": 1,
        "CopperBar": 2
      },
      "stats": {
        "health": 50,
        "count": 1,
        "powerConsumption": 50
      },
      "upgrade": {
        "health": "+250",
        "count": "+1"
      },
      "maxCount": 1,
      "description": "Lights up surrounding."
    },
    "Lamp": {
      "width": 32,
      "height": 32,
      "isInteractable": true,
      "categories": {"not_structure_conduit":true,"switch":true,"lamp":true},
      "hasEditableContent": true,
      "showInteractTooltip": true,
      "isPassable": true,
      "isLightSource": true,
      "lightColor": "#ffffff",
      "lightRadius": 15,
      "useOriginalSize": true,
      "cost": {
        "gold": 50
      },
      "requirements": {
        "Glass": 1,
        "CopperBar": 2
      },
      "stats": {
        "health": 50,
        "count": 1,
        "powerConsumption": 50
      },
      "upgrade": {
        "health": "+250",
        "count": "+1"
      },
      "maxCount": 1,
      "description": "Lights up surrounding."
    },
    "PowerSwitch": {
      "width": 64,
      "height": 64,
      "isInteractable": true,
      "categories": {"switch":true,"power_conduit":true},
      "showInteractTooltip": true,
      "isLightSource": true,
      "cost": {
        "gold": 50
      },
      "sprite": {
        "rotation": 90
      },
      "requirements": {
        "CircuitBoard": 10,
        "CopperBar": 20
      },
      "stats": {
        "health": 200,
        "count": 1
      },
      "upgrade": {
        "health": "+250"
      },
      "description": "Controls multiple power sources. Can turn them off/on"
    },
    "WaterPump": {
      "width": 64,
      "height": 96,
      "isInteractable": true,
      "cost": {
        "gold": 500
      },
      "requirements": {
        "IronBar": 30,
        "LiquidPipe": 5
      },
      "stats": {
        "health": 250,
        "count": 1,
        "liquidProduction": 10
      },
      "upgrade": {
        "health": "+250",
        "count": "+1"
      },
      "maxCount": 1,
      "description": "Generates water. Must be placed beside water source and connected via pipes"
    },
    "BaseStarter": {
      "width": 64,
      "height": 64,
      "cost": {
        "gold": 2500
      },
      "stats": {
        "health": 200,
        "range": 2000,
        "reload": 1
      },
      "upgrade": {
        "health": "+250",
        "range": "+5"
      },
      "maxCount": 1,
      "description": "Allows player to create a new base."
    },
    "Core": {
      "width": 64,
      "height": 64,
      "cost": {
        "gold": 250
      },
      "hasFillBar": true,
      "isInteractable": true,
      "stats": {
        "health": 1000,
        "range": 2000,
        "reload": 1,
        "powerProduction": 10,
        "powerCapacity": 500,
        "clientResource": "power"
      },
      "upgrade": {
        "health": "+250",
        "range": "+5"
      },
      "maxCount": 1,
      "description": "Power Source. 500 W"
    },
    "Beaker": {
      "width": 32,
      "height": 32,
      "requirements": {
        "Glass": 5
      },
      "cost": {
        "gold": 75
      },
      "stats": {
        "health": 100,
        "count": 100,
        "liquidCapacity": 100
      },
      "upgrade": {
        "health": "+100",
        "count": "+25"
      },
      "description": "stores injectable samples"
    },
    "Cage": {
      "width": 32,
      "height": 32,
      "cost": {
        "gold": 50
      },
      "requirements": {
        "IronBar": 4
      },
      "stats": {
        "health": 100,
        "count": 100
      },
      "upgrade": {
        "health": "+100",
        "count": "+25"
      },
      "description": "Used to secure tamed animals/aliens"
    },
    "Fence": {
      "width": 128,
      "height": 32,
      "requirements": {
        "CopperBar": 15,
        "CircuitBoard": 5
      },
      "stats": {
        "health": 100
      },
      "description": "Door that restricts pets/bots/slaves but allows players"
    },
    "MiasmaGate": {
      "width": 128,
      "height": 32,
      "isPassable": true,
      "requirements": {
        "Disinfectant": 3,
        "Bottle": 4,
        "CopperBar": 50,
        "CircuitBoard": 25
      },
      "stats": {
        "health": 50
      },
      "description": "A gate that strips any entity of miasma"
    },
    "SecurityCamera": {
      "width": 32,
      "height": 32,
      "cost": {
        "gold": 100
      },
      "isPassable": true,
      "hasMenu": true,
      "hasEditableContent": true,
      "isInteractable": true,
      "showInteractTooltip": true,
      "maxContentLength": 50,
      "requirements": {
        "IronBar": 10,
        "CircuitBoard": 10
      },
      "stats": {
        "health": 100,
        "count": 100
      },
      "upgrade": {
        "health": "+100",
        "count": "+25"
      },
      "description": "monitors an area."
    },
    "SecurityMonitor": {
      "width": 64,
      "height": 128,
      "cost": {
        "gold": 100
      },
      "hasMenu": true,
      "isInteractable": true,
      "showInteractTooltip": true,
      "requirements": {
        "CopperBar": 20,
        "CircuitBoard": 20
      },
      "stats": {
        "health": 300,
        "count": 100
      },
      "upgrade": {
        "health": "+100",
        "count": "+25"
      },
      "description": "view security camera screens"
    },
    "Chair": {
      "width": 32,
      "height": 32,
      "cost": {
        "gold": 100
      },
      "useOriginalSize": true,
      "isPassable": true,
      "requirements": {
        "IronBar": 10
      },
      "stats": {
        "health": 75,
        "count": 100
      },
      "upgrade": {
        "health": "+100",
        "count": "+25"
      },
      "description": "decorative chair"
    },
    "RedPresent": {
      "width": 32,
      "height": 32,
      "cost": {
        "gold": 100
      },
      "isPassable": true,
      "requirements": {
        "Cloth": 10
      },
      "stats": {
        "health": 75,
        "count": 100
      },
      "description": "Red present"
    },
    "BluePresent": {
      "width": 32,
      "height": 32,
      "cost": {
        "gold": 100
      },
      "isPassable": true,
      "requirements": {
        "Cloth": 10
      },
      "stats": {
        "health": 75,
        "count": 100
      },
      "description": "Blue present"
    },
    "GreenPresent": {
      "width": 32,
      "height": 32,
      "cost": {
        "gold": 100
      },
      "isPassable": true,
      "requirements": {
        "Cloth": 10
      },
      "stats": {
        "health": 75,
        "count": 100
      },
      "description": "Green present"
    },
    "WoodChair": {
      "width": 32,
      "height": 32,
      "cost": {
        "gold": 100
      },
      "useOriginalSize": true,
      "isPassable": true,
      "requirements": {
        "Wood": 5
      },
      "stats": {
        "health": 75,
        "count": 100
      },
      "upgrade": {
        "health": "+100",
        "count": "+25"
      },
      "description": "wood chair"
    },
    "Shower": {
      "width": 32,
      "height": 32,
      "cost": {
        "gold": 75
      },
      "isPassable": true,
      "isInteractable": true,
      "isOnCeiling": true,
      "useOriginalSize": true,
      "requirements": {
        "IronBar": 5
      },
      "stats": {
        "health": 75,
        "count": 100
      },
      "upgrade": {
        "health": "+100",
        "count": "+25"
      },
      "description": "For cleaning your body"
    },
    "SuitStation": {
      "width": 64,
      "height": 64,
      "isInteractable": true,
      "showInteractTooltip": true,
      "storageCount": 1,
      "cost": {
        "gold": 550
      },
      "requirements": {
        "IronBar": 30,
        "CopperBar": 5,
        "CircuitBoard": 5
      },
      "stats": {
        "health": 100,
        "count": 100,
        "oxygenConsumption": 1
      },
      "upgrade": {
        "health": "+100",
        "count": "+25"
      },
      "description": "stores armor/suits"
    },
    "Sign": {
      "width": 32,
      "height": 32,
      "cost": {
        "gold": 200
      },
      "isPassable": true,
      "categories": {"sign": true},
      "hasMenu": true,
      "hasEditableContent": true,
      "isInteractable": true,
      "maxContentLength": 300,
      "requirements": {
        "Wood": 4
      },
      "stats": {
        "health": 50
      },
      "upgrade": {
        "health": "+100",
        "count": "+25"
      },
      "description": "Display Editable Text to Players"
    },
    "EmergencyButton": {
      "width": 64,
      "height": 64,
      "cost": {
        "gold": 300
      },
      "categories": {},
      "isInteractable": true,
      "showInteractTooltip": true,
      "requirements": {
        "IronBar": 30,
        "CircuitBoard": 10
      },
      "stats": {
        "health": 100,
        "count": 100
      },
      "upgrade": {
        "health": "+100",
        "count": "+25"
      },
      "description": "Calls an Emergency"
    },
    "TimerBomb": {
      "width": 32,
      "height": 32,
      "cost": {
        "gold": 300
      },
      "categories": {},
      "requirements": {
        "IronBar": 30,
        "CircuitBoard": 5,
        "Explosives": 2
      },
      "stats": {
        "health": 50,
        "damage": 50
      },
      "upgrade": {
      },
      "description": "Will detonate after 10 seconds of planting"
    },
    "Tree": {
      "width": 64,
      "height": 64,
      "cost": {
        "gold": 200
      },
      "requirements": {
        "Wood": 10
      },
      "stats": {
        "health": 100
      },
      "description": "tree"
    },
    "ChristmasTree": {
      "width": 64,
      "height": 64,
      "cost": {
        "gold": 300
      },
      "requirements": {
        "Wood": 20,
        "PlantFiber": 20
      },
      "stats": {
        "health": 100
      },
      "description": "Christmas tree"
    },
    "Table": {
      "width": 32,
      "height": 64,
      "cost": {
        "gold": 300
      },
      "categories": {"dining_table": true},
      "requirements": {
        "IronBar": 30
      },
      "stats": {
        "health": 100,
        "count": 100
      },
      "upgrade": {
        "health": "+100",
        "count": "+25"
      },
      "description": "decorative table"
    },
    "WoodTable": {
      "width": 32,
      "height": 128,
      "cost": {
        "gold": 300
      },
      "categories": {"dining_table":true,"large_dining_table":true},
      "requirements": {
        "Wood": 20
      },
      "stats": {
        "health": 100,
        "count": 100
      },
      "upgrade": {
        "health": "+100",
        "count": "+25"
      },
      "description": "wood table"
    },
    "LargeTable": {
      "width": 64,
      "height": 128,
      "cost": {
        "gold": 600
      },
      "categories": {"dining_table":true,"large_dining_table":true},
      "requirements": {
        "IronBar": 70
      },
      "stats": {
        "health": 100,
        "count": 100
      },
      "upgrade": {
        "health": "+100",
        "count": "+25"
      },
      "description": "large decorative table"
    },
    "TradingTable": {
      "parent": "Buildings.Table",
      "requirements": {
        "IronBar": 30,
        "CopperBar": 20,
        "PlantFiber": 10
      },
      "description": "Build to attract Traders to arrive."
    },
    "SlaversTable": {
      "parent": "Buildings.Table",
      "requirements": {
        "IronBar": 30,
        "BloodPack": 1
      },
      "description": "Build to attract Slave Traders to arrive."
    },
    "ButcherTable": {
      "categories": {"producer":true,"drag_target_storage":true,"butcher_table":true},
      "width": 32,
      "height": 96,
      "isInteractable": true,
      "showInteractTooltip": true,
      "cost": {
        "gold": 300
      },
      "stats": {
        "health": 100
      },
      "requirements": {
        "IronBar": 35
      },
      "description": "Allows you to butcher dead bodies for meat and other resources"
    },
    "SealedDoor": {
      "width": 128,
      "height": 32,
      "requirements": {
        "IronBar": 20,
        "CircuitBoard": 8
      },
      "cost": {
        "gold": 400
      },
      "stats": {
        "health": 300,
        "count": 125
      },
      "isUpgradable": true,
      "isInteractable": true,
      "minimapColor": "#3bceaa",
      "showInteractTooltip": true,
      "isAirtight": true,
      "categories": {"door":true,"melee_resistant":true,"editable_permissions":true},
      "upgrade": {
        "health": "+25",
        "count": "+25"
      },
      "description": "Door that restricts access to certain personnels only"
    },
    "KeypadDoor": {
      "hasMenu": true,
      "width": 128,
      "height": 32,
      "requirements": {
        "IronBar": 35,
        "CircuitBoard": 30,
        "Wire": 15
      },
      "cost": {
        "gold": 800
      },
      "stats": {
        "health": 300,
        "count": 125
      },
      "isInteractable": true,
      "minimapColor": "#3bceaa",
      "showInteractTooltip": true,
      "isAirtight": true,
      "categories": {"door":true,"melee_resistant":true},
      "upgrade": {
        "health": "+25",
        "count": "+25"
      },
      "description": "Only opens if you have the code"
    },
    "SolarPanel": {
      "width": 64,
      "height": 32,
      "cost": {
        "gold": 200
      },
      "isInteractable": true,
      "hasFillBar": true,
      "requirements": {
        "IronBar": 10,
        "Glass": 10,
        "Wire": 5
      },
      "stats": {
        "health": 150,
        "count": 125,
        "powerProduction": 10,
        "powerCapacity": 1000,
        "clientResource": "power"
      },
      "upgrade": {
        "health": "+25",
        "count": "+25"
      },
      "description": "Generates Power using sun energy. Can only be placed on Lattice"
    },
    "OxygenTank": {
      "width": 64,
      "height": 64,
      "cost": {
        "gold": 350
      },
      "isInteractable": true,
      "hasFillBar": true,
      "requirements": {
        "IronBar": 20,
        "GasPipe": 5
      },
      "stats": {
        "health": 200,
        "count": 125,
        "oxygenCapacity": 200,
        "clientResource": "oxygen"
      },
      "upgrade": {
        "health": "+25",
        "count": "+25"
      },
      "description": "Stores oxygen. Must be connected via gas pipes"
    },
    "OxygenGenerator": {
      "width": 64,
      "height": 128,
      "isInteractable": true,
      "showInteractTooltip": true,
      "interactButtonMessage": "use",
      "hasFillBar": true,
      "cost": {
        "gold": 250
      },
      "requirements": {
        "IronBar": 15
      },
      "primaryResource": "oxygen",
      "stats": {
        "health": 150,
        "count": 125,
        "oxygenProduction": 5,
        "oxygenCapacity": 100,
        "liquidConsumption": 1,
        "liquidCapacity": 25,
        "clientResource": "oxygen"
      },
      "upgrade": {
        "health": "+25",
        "count": "+25"
      },
      "description": "Converts Water to Oxygen"
    },
    "CryoTube": {
      "width": 96,
      "height": 96,
      "cost": {
        "gold": 350
      },
      "categories": {"entity_storage":true,"editable_permissions":true},
      "isInteractable": true,
      "skipRemoveOwner": true,
      "storageCount": 1,
      "isLightSource": true,
      "isLightPersistent": true,
      "lightColor": "#578357",
      "lightRadius": 3,
      "requirements": {
        "IronBar": 20,
        "LiquidPipe": 5
      },
      "stats": {
        "health": 150,
        "count": 125,
        "liquidCapacity": 200
      },
      "upgrade": {
        "health": "+25",
        "count": "+25"
      },
      "description": "Stores living organisms for healing."
    },
    "LiquidTank": {
      "width": 64,
      "height": 64,
      "cost": {
        "gold": 250
      },
      "categories": {"liquid_tank": true},
      "isInteractable": true,
      "isBottleFillable": true,
      "requirements": {
        "IronBar": 20,
        "LiquidPipe": 5
      },
      "stats": {
        "health": 150,
        "count": 125,
        "liquidCapacity": 200,
        "clientResource": "liquid"
      },
      "upgrade": {
        "health": "+25",
        "count": "+25"
      },
      "description": "Stores liquid."
    },
    "SmallOxygenTank": {
      "width": 32,
      "height": 32,
      "hasFillBar": true,
      "isInteractable": true,
      "cost": {
        "gold": 150
      },
      "requirements": {
        "IronBar": 10,
        "GasPipe": 2
      },
      "stats": {
        "health": 150,
        "count": 125,
        "oxygenCapacity": 100,
        "clientResource": "oxygen"
      },
      "upgrade": {
        "health": "+25",
        "count": "+25"
      },
      "description": "Stores small amount of oxygen. Connect via gas pipes"
    },
    "AirAlarm": {
      "width": 32,
      "height": 32,
      "isLightSource": true,
      "lightColor": "#ff0000",
      "lightRadius": 30,
      "categories": {"air_detector": true},
      "cost": {
        "gold": 100
      },
      "requirements": {
        "CopperBar": 5,
        "Wire": 2
      },
      "stats": {
        "health": 100,
        "count": 125
      },
      "upgrade": {
        "health": "+25",
        "count": "+25"
      },
      "description": "Sets alarm when room has no oxygen"
    },
    "Ventilator": {
      "width": 32,
      "height": 32,
      "isLightBlocker": true,
      "isAirtight": true,
      "categories": {"vent":true,"structure_conduit":true,"oxygen_conduit":true},
      "cost": {
        "gold": 150
      },
      "requirements": {
        "IronBar": 15
      },
      "stats": {
        "health": 150,
        "count": 125
      },
      "upgrade": {
        "health": "+25",
        "count": "+25"
      },
      "description": "Airtight oxygen distributor. Must be connected via gas pipes"
    },
    "Atm": {
      "width": 64,
      "height": 64,
      "isLightSource": true,
      "lightColor": "#18bffa",
      "lightRadius": 3,
      "hasMenu": true,
      "isInteractable": true,
      "showInteractTooltip": true,
      "categories": {"atm": true},
      "sprite": {
        "rotation": 90
      },
      "cost": {
        "gold": 300
      },
      "requirements": {
        "CopperBar": 20,
        "CircuitBoard": 5,
        "Wire": 5
      },
      "stats": {
        "health": 300
      },
      "upgrade": {
        "health": "+25",
        "count": "+25"
      },
      "description": "Withdraw and Deposit Gold to your account"
    },
    "Fridge": {
      "width": 32,
      "height": 32,
      "energy": 50,
      "description": "",
      "cost": {
        "gold": 150
      },
      "hasMenu": true,
      "isInteractable": true,
      "storageCount": 10,
      "requirements": {
        "IronBar": 10,
        "Wire": 2
      },
      "stats": {
        "health": 150,
        "count": 125
      },
      "upgrade": {
        "health": "+25",
        "count": "+25"
      }
    },
    "BaseProcessor": {
      "storageCount": 2
    },
    "MiningDrill": {
      "parent": "Buildings.BaseProcessor",
      "width": 96,
      "height": 96,
      "hasMenu": true,
      "menuDescription": "Generates ores over time",
      "energy": 100,
      "cost": {
        "gold": 500
      },
      "categories": {"producer":true,"mining_drill":true,"editable_permissions":true},
      "isInteractable": true,
      "showInteractTooltip": true,
      "requirements": {
        "IronBar": 50,
        "CircuitBoard": 10
      },
      "stats": {
        "health": 250,
        "count": 125,
        "processingRate": 5,
        "powerConsumption": 300
      },
      "upgrade": {
        "health": "+25",
        "count": "+25"
      },
      "description": "Mines Ores underground automatically"
    },
    "EscapePod": {
      "width": 32,
      "height": 64,
      "showInteractTooltip": true,
      "storageCount": 5,
      "categories": {"escape_pod":true,"food_storage":true,"storage":true},
      "cost": {
        "gold": 150
      },
      "hasMenu": true,
      "isAirtight": true,
      "isInteractable": true,
      "requirements": {
        "IronBar": 10
      },
      "stats": {
        "health": 150,
        "count": 125
      },
      "upgrade": {
        "health": "+25",
        "count": "+25"
      },
      "description": "Broken escape pod"
    },
    "SteelCrate": {
      "width": 32,
      "height": 64,
      "cost": {
        "gold": 50
      },
      "hasMenu": true,
      "menuDescription": "",
      "categories": {"food_storage":true,"storage":true,"editable_permissions":true},
      "isInteractable": true,
      "showInteractTooltip": true,
      "storageCount": 16,
      "requirements": {
        "IronBar": 10
      },
      "stats": {
        "health": 150,
        "count": 125
      },
      "upgrade": {
        "health": "+25",
        "count": "+25"
      },
      "description": "stores items"
    },
    "FoodVendingMachine": {
      "width": 64,
      "height": 64,
      "cost": {
        "gold": 500
      },
      "sprite": {
        "rotation": 90
      },
      "categories": {"seller":true,"vending_machine":true},
      "hasMenu": true,
      "menuDescription": "",
      "isInteractable": true,
      "showInteractTooltip": true,
      "storageCount": 8,
      "requirements": {
        "IronBar": 30,
        "Wire": 5,
        "CircuitBoard": 10
      },
      "stats": {
        "health": 250
      },
      "upgrade": {
        "health": "+25",
        "count": "+25"
      },
      "description": "Store and sell food"
    },
    "DrinksVendingMachine": {
      "width": 64,
      "height": 64,
      "cost": {
        "gold": 500
      },
      "sprite": {
        "rotation": 90
      },
      "categories": {"seller":true,"vending_machine":true},
      "hasMenu": true,
      "menuDescription": "",
      "isInteractable": true,
      "showInteractTooltip": true,
      "storageCount": 8,
      "requirements": {
        "IronBar": 30,
        "Wire": 5,
        "CircuitBoard": 10
      },
      "stats": {
        "health": 250
      },
      "upgrade": {
        "health": "+25",
        "count": "+25"
      },
      "description": "Store and sell drinks"
    },
    "Conveyor": {
      "width": 32,
      "height": 32,
      "cost": {
        "gold": 50
      },
      "stats": {
        "health": 50,
        "count": 125
      },
      "upgrade": {
        "health": "+25",
        "count": "+25"
      }
    },
    "FuelPipe": {
      "width": 32,
      "height": 32,
      "cost": {
        "gold": 30
      },
      "categories": {"fuel_conduit":true,"distribution":true,"pipe":true},
      "requirements": {
        "IronBar": 2
      },
      "stats": {
        "health": 50,
        "count": 125
      },
      "upgrade": {
        "health": "+25",
        "count": "+25"
      },
      "description": "transports fuel between components"
    },
    "LiquidPipe": {
      "width": 32,
      "height": 32,
      "cost": {
        "gold": 30
      },
      "categories": {"liquid_conduit":true,"distribution":true,"pipe":true},
      "requirements": {
        "IronBar": 2
      },
      "stats": {
        "health": 50,
        "count": 125
      },
      "upgrade": {
        "health": "+25",
        "count": "+25"
      },
      "description": "transports liquid between components"
    },
    "GasPipe": {
      "width": 32,
      "height": 32,
      "categories": {"oxygen_conduit":true,"distribution":true,"pipe":true},
      "cost": {
        "gold": 30
      },
      "requirements": {
        "IronBar": 2
      },
      "stats": {
        "health": 50,
        "count": 125
      },
      "upgrade": {
        "health": "+25",
        "count": "+25"
      },
      "description": "transports oxygen between components"
    },
    "Wire": {
      "width": 32,
      "height": 32,
      "cost": {
        "gold": 10
      },
      "categories": {"power_conduit":true,"distribution":true,"wire":true},
      "requirements": {
        "CopperOre": 1
      },
      "stats": {
        "health": 50,
        "count": 125
      },
      "upgrade": {
        "health": "+25",
        "count": "+25"
      },
      "description": "transports power to objects"
    },
    "Hangar": {
      "width": 480,
      "height": 640,
      "cost": {
        "gold": 50
      },
      "stats": {
        "health": 50,
        "count": 125
      },
      "upgrade": {
        "health": "+25",
        "count": "+25"
      }
    },
    "Airlock": {
      "width": 128,
      "height": 32,
      "cost": {
        "gold": 200
      },
      "isInteractable": true,
      "minimapColor": "#3bceaa",
      "showInteractTooltip": true,
      "isAirtight": true,
      "isUpgradable": true,
      "categories": {"door":true,"partially_passable":true,"melee_resistant":true},
      "requirements": {
        "IronBar": 10,
        "CircuitBoard": 4
      },
      "stats": {
        "health": 300,
        "count": 125
      },
      "upgrade": {
        "health": "+25",
        "count": "+25"
      },
      "description": "Airtight door that seals oxygen inside the area"
    },
    "ManualAirlock": {
      "width": 64,
      "height": 32,
      "isInteractable": true,
      "showInteractTooltip": true,
      "isUpgradable": true,
      "isAirtight": true,
      "categories": {"door":true,"melee_resistant":true},
      "minimapColor": "#3bceaa",
      "requirements": {
        "IronBar": 5
      },
      "cost": {
        "gold": 50
      },
      "stats": {
        "health": 200,
        "count": 125
      },
      "upgrade": {
        "health": "+25",
        "count": "+25"
      },
      "description": "Airtight door. No power required to operate"
    },
    "SmallAirlock": {
      "width": 64,
      "height": 32,
      "cost": {
        "gold": 50
      },
      "stats": {
        "health": 100,
        "count": 125
      },
      "upgrade": {
        "health": "+25",
        "count": "+25"
      }
    },
    "ResearchTable": {
      "width": 32,
      "height": 96,
      "cost": {
        "gold": 50
      },
      "stats": {
        "health": 150,
        "count": 125
      },
      "requirements": {
        "IronBar": 20,
        "CircuitBoard": 4
      },
      "upgrade": {
        "health": "+25",
        "count": "+25"
      }
    },
    "Forge": {
      "width": 64,
      "height": 128,
      "cost": {
        "gold": 500
      },
      "hasMenu": true,
      "categories": {"producer": true},
      "isInteractable": true,
      "showInteractTooltip": true,
      "storageCount": 1,
      "isCraftingStorage": true,
      "stats": {
        "health": 250,
        "powerConsumption": 200
      },
      "requirements": {
        "Wire": 5,
        "IronBar": 20,
        "CircuitBoard": 10
      },
      "description": "Craft Weapons and Armors"
    },
    "AmmoPrinter": {
      "width": 64,
      "height": 128,
      "cost": {
        "gold": 500
      },
      "hasMenu": true,
      "categories": {"producer": true},
      "isInteractable": true,
      "showInteractTooltip": true,
      "storageCount": 1,
      "isCraftingStorage": true,
      "stats": {
        "health": 250,
        "count": 125,
        "powerConsumption": 200
      },
      "requirements": {
        "Wire": 5,
        "IronBar": 20,
        "CircuitBoard": 10
      },
      "upgrade": {
        "health": "+25",
        "count": "+25"
      },
      "description": "Producers ammunition for weapons"
    },
    "Brewery": {
      "width": 64,
      "height": 96,
      "cost": {
        "gold": 300
      },
      "categories": {"producer": true},
      "hasMenu": true,
      "isInteractable": true,
      "showInteractTooltip": true,
      "storageCount": 1,
      "isCraftingStorage": true,
      "requirements": {
        "IronBar": 10,
        "CopperBar": 10
      },
      "stats": {
        "health": 150,
        "count": 125,
        "powerConsumption": 100
      },
      "upgrade": {
        "health": "+25",
        "count": "+25"
      },
      "description": "Make drinks and quench thirst"
    },
    "Stove": {
      "width": 32,
      "height": 64,
      "energy": 50,
      "cost": {
        "gold": 250
      },
      "categories": {"producer":true,"stove":true},
      "hasMenu": true,
      "hasEditableContent": true,
      "isInteractable": true,
      "shouldLimitInteractToMenuOnly": true,
      "showInteractTooltip": true,
      "storageCount": 1,
      "isCraftingStorage": true,
      "requirements": {
        "IronBar": 10,
        "CopperBar": 10
      },
      "stats": {
        "health": 100,
        "count": 125,
        "powerConsumption": 200
      },
      "upgrade": {
        "health": "+25",
        "count": "+25"
      },
      "description": "cook your food here"
    },
    "ChemistryStation": {
      "width": 64,
      "height": 96,
      "hasMenu": true,
      "isInteractable": true,
      "showInteractTooltip": true,
      "storageCount": 1,
      "categories": {"producer": true},
      "isCraftingStorage": true,
      "cost": {
        "gold": 350
      },
      "requirements": {
        "Bottle": 2,
        "IronBar": 20
      },
      "stats": {
        "health": 150,
        "count": 125,
        "powerConsumption": 200
      },
      "upgrade": {
        "health": "+25",
        "count": "+25"
      },
      "description": "Craft drugs and explosives"
    },
    "Workshop": {
      "width": 64,
      "height": 64,
      "hasMenu": true,
      "isInteractable": true,
      "storageCount": 1,
      "isCraftingStorage": true,
      "cost": {
        "gold": 450
      },
      "requirements": {
        "CopperBar": 10,
        "IronBar": 20,
        "Wire": 5
      },
      "stats": {
        "health": 150,
        "count": 125,
        "powerConsumption": 200
      },
      "upgrade": {
        "health": "+25",
        "count": "+25"
      },
      "description": "craft equipments"
    },
    "Refinery": {
      "parent": "Buildings.BaseProcessor",
      "width": 64,
      "height": 128,
      "hasMenu": true,
      "categories": {"producer": true},
      "isInteractable": true,
      "menuDescription": "[Deprecated] No longer functional",
      "requirements": {
        "IronBar": 30,
        "CircuitBoard": 10,
        "Wire": 5
      },
      "cost": {
        "gold": 500
      },
      "stats": {
        "health": 150,
        "count": 125,
        "processingRate": 10
      },
      "upgrade": {
        "health": "+25",
        "count": "+25"
      },
      "description": "[Deprecated] No longer functional"
    },
    "OilRefinery": {
      "width": 96,
      "height": 96,
      "isInteractable": true,
      "interactButtonMessage": "use",
      "requirements": {
        "IronBar": 30,
        "FuelPipe": 5
      },
      "cost": {
        "gold": 500
      },
      "stats": {
        "health": 100,
        "count": 125,
        "fuelProduction": 5
      },
      "description": "Extracts oil underground and generates chemfuel"
    },
    "FuelTank": {
      "width": 64,
      "height": 96,
      "cost": {
        "gold": 300
      },
      "isInteractable": true,
      "interactButtonMessage": "use",
      "hasFillBar": true,
      "requirements": {
        "IronBar": 20,
        "FuelPipe": 2
      },
      "stats": {
        "health": 100,
        "count": 125,
        "fuelCapacity": 200,
        "clientResource": "fuel"
      },
      "description": "Stores Fuel"
    },
    "DeepDrill": {
      "parent": "Buildings.BaseProcessor",
      "width": 96,
      "height": 96,
      "isInteractable": true,
      "showInteractTooltip": true,
      "hasFillBar": true,
      "hasMenu": true,
      "categories": ["editable_permissions", "mining_drill"],
      "menuDescription": "Generates ores over time",
      "requirements": {
        "IronBar": 200,
        "CopperBar": 200,
        "FuelPipe": 25
      },
      "cost": {
        "gold": 2000
      },
      "stats": {
        "health": 300,
        "fuelConsumption": 25,
        "fuelCapacity": 100,
        "powerConsumption": 200,
        "clientResource": "fuel",
        "processingRate": 5
      },
      "description": "Extracts rare resources from oil underground. Needs fuel and power."
    },
    "PowerGenerator": {
      "width": 64,
      "height": 96,
      "cost": {
        "gold": 250
      },
      "primaryResource": "power",
      "isInteractable": true,
      "hasFillBar": true,
      "requirements": {
        "IronBar": 20,
        "FuelPipe": 2
      },
      "stats": {
        "health": 150,
        "count": 125,
        "fuelConsumption": 3,
        "fuelCapacity": 3,
        "powerProduction": 10,
        "powerCapacity": 500,
        "clientResource": "power"
      },
      "description": "Generates Power using chemfuel"
    },
    "Furnace": {
      "width": 32,
      "height": 64,
      "hasMenu": true,
      "showInteractTooltip": true,
      "categories": {"producer": true},
      "isInteractable": true,
      "storageCount": 1,
      "isCraftingStorage": true,
      "description": "Smelts ores into other items",
      "menuDescription": "Place ore in left slot to smelt",
      "requirements": {
        "IronOre": 10
      },
      "cost": {
        "gold": 150
      },
      "stats": {
        "health": 100,
        "count": 125
      },
      "upgrade": {
        "health": "+25",
        "count": "+25"
      }
    },
    "RailTrack": {
      "width": 32,
      "height": 32,
      "categories": {"rail":true,"rail_track":true,"instant_build":true},
      "isPassable": true,
      "isFlamable": false,
      "minimapColor": "#483d8b",
      "cost": {
        "gold": 50
      },
      "requirements": {
        "IronBar": 5
      },
      "stats": {
        "health": 250,
        "count": 125
      },
      "upgrade": {
        "health": "+25",
        "count": "+25"
      },
      "description": "Platform for Rail Tram to travel on"
    },
    "RailStop": {
      "width": 96,
      "height": 128,
      "cost": {
        "gold": 1000
      },
      "minimapColor": "#483d8b",
      "isInteractable": true,
      "hasEditableContent": true,
      "hasMenu": true,
      "categories": {"rail":true,"rail_stop":true,"partially_passable":true},
      "requirements": {
        "IronBar": 20,
        "CircuitBoard": 20, 
        "Glass": 5
      },
      "stats": {
        "health": 500,
        "count": 125,
        "powerConsumption": 100
      },
      "upgrade": {
        "health": "+25",
        "count": "+25"
      },
      "description": "Acts as Start/Stop point for Rail Trams. Must be placed at end of Rail Track"
    },
    "Terminal": {
      "width": 64,
      "height": 64,
      "cost": {
        "gold": 250
      },
      "sprite": {
        "rotation": 90
      },
      "hasMenu": true,
      "isInteractable": true,
      "showInteractTooltip": true,
      "requirements": {
        "IronBar": 25,
        "CircuitBoard": 10,
        "Wire": 10
      },
      "stats": {
        "health": 100,
        "count": 1,
        "powerConsumption": 100
      },
      "upgrade": {
        "health": "+100",
        "count": "+1"
      },
      "description": "Decorative Computer Terminal"
    },
    "Television": {
      "width": 32,
      "height": 32,
      "cost": {
        "gold": 500
      },
      "requirements": {
        "IronBar": 30,
        "CircuitBoard": 10
      },
      "stats": {
        "health": 100,
        "count": 1
      },
      "upgrade": {
        "health": "+100",
        "count": "+1"
      },
      "description": "Decorative Television"
    },
    "Pot": {
      "width": 32,
      "height": 32,
      "cost": {
        "gold": 50
      },
      "isInteractable": true,
      "showInteractTooltip": true,
      "storageCount": 1,
      "requirements": {
        "Wood": 2
      },
      "stats": {
        "health": 100,
        "count": 1
      },
      "upgrade": {
        "health": "+100",
        "count": "+1"
      },
      "description": "Decorative container for plants/flowers"
    },
    "Bridge": {
      "width": 32,
      "height": 64,
      "isInteractable": true,
      "cost": {
        "gold": 1000
      },
      "stats": {
        "health": 100,
        "count": 1
      },
      "upgrade": {
        "health": "+100",
        "count": "+1"
      },
      "description": "Allows player to pilot ship"
    },
    "Beacon": {
      "width": 64,
      "height": 64,
      "categories": {"walkable":true,"spawnpoint":true},
      "hasEditableContent": true,
      "isPassable": true,
      "isFlamable": false,
      "cost": {
        "gold": 200
      },
      "requirements": {
        "IronBar": 20,
        "CircuitBoard": 10,
        "Glass": 5
      },
      "stats": {
        "health": 200,
        "count": 1
      },
      "upgrade": {
        "health": "+25",
        "count": "+1"
      },
      "description": "Acts as spawn point for visitors"
    },
    "UndergroundVent": {
      "width": 64,
      "height": 64,
      "categories": {"walkable":true,"editable_permissions":true},
      "isPassable": true,
      "isInteractable": true,
      "showInteractTooltip": true,
      "isFlamable": false,
      "cost": {
        "gold": 200
      },
      "requirements": {
        "IronBar": 20
      },
      "stats": {
        "health": 150,
        "count": 1
      },
      "description": "Underground Vent"
    },
    "FarmController": {
      "width": 32,
      "height": 32,
      "categories": {"farm_controller": true},
      "cost": {
        "gold": 200
      },
      "hasMenu": true,
      "isInteractable": true,
      "hasEditableContent": true,
      "isLightSource": true,
      "lightColor": "#00ffff",
      "isLightPersistent": true,
      "lightRadius": 2,
      "requirements": {
        "Wood": 20,
        "CircuitBoard": 10
      },
      "stats": {
        "health": 200,
        "count": 1
      },
      "upgrade": {
        "health": "+25",
        "count": "+1"
      },
      "description": "Place beside soil. Informs workers which crops to grow"
    },
    "SpikeTrap": {
      "width": 32,
      "height": 32,
      "categories": {"trap":true,"spike_trap":true},
      "isPassable": true,
      "isFlamable": false,
      "cost": {
        "gold": 400
      },
      "requirements": {
        "IronBar": 20,
        "CircuitBoard": 2
      },
      "stats": {
        "health": 200,
        "pvpHealth": 50,
        "damage": 10,
        "count": 1,
        "reload": 5000
      },
      "upgrade": {
        "health": "+25",
        "count": "+1"
      },
      "description": "spike trap"
    },
    "WebTrap": {
      "width": 32,
      "height": 32,
      "categories": {"trap": true},
      "isPassable": true,
      "isFlamable": false,
      "cost": {
        "gold": 400
      },
      "requirements": {
        "IronBar": 10,
        "Web": 2, 
        "CircuitBoard": 2
      },
      "stats": {
        "health": 50,
        "damage": 10,
        "count": 1,
        "reload": 20000
      },
      "upgrade": {
        "health": "+25",
        "count": "+1"
      },
      "description": "Trap that immobilizes enemies for 5 seconds"
    },
    "Bed": {
      "width": 64,
      "height": 32,
      "cost": {
        "gold": 150
      },
      "isPassable": true,
      "isInteractable": true,
      "showInteractTooltip": true,
      "requirements": {
        "IronBar": 10,
        "Cloth": 2
      },
      "stats": {
        "health": 250,
        "count": 1
      },
      "upgrade": {
        "health": "+25",
        "count": "+1"
      },
      "description": "Restores player stamina. Also a respawn point"
    },
    "FlamethrowerTurret": {
      "width": 64,
      "height": 64,
      "cost": {
        "gold": 500
      },
      "shouldAttackIgnoreObstacle": true,
      "hasFillBar": true,
      "categories": {"turret":true,"editable_targets":true},
      "stats": {
        "reload": 2000,
        "damage": 10,
        "range": 288,
        "health": 200,
        "fuelConsumption": 25,
        "fuelCapacity": 100,
        "powerConsumption": 100,
        "clientResource": "fuel"
      },
      "requirements": {
        "IronBar": 20,
        "CopperBar": 40
      },
      "upgrade": {
        "damage": "+3",
        "health": "+50",
        "count": "+1"
      },
      "description": "Shoots flames at targets. Requires fuel and power."
    },
    "MiniTurret": {
      "width": 64,
      "height": 64,
      "energy": 25,
      "storageCount": 1,
      "cost": {
        "gold": 500
      },
      "shouldAttackIgnoreObstacle": true,
      "categories": {"turret":true,"editable_targets":true,"ammo_turret":true},
      "hasMenu": true,
      "menuDescription": "Place Ammunition",
      "isInteractable": true,
      "showInteractTooltip": true,
      "stats": {
        "reload": 3000,
        "damage": 12,
        "range": 320,
        "health": 300,
        "count": 2,
        "powerConsumption": 100
      },
      "requirements": {
        "IronBar": 50,
        "CopperBar": 20
      },
      "upgrade": {
        "damage": "+3",
        "health": "+50",
        "count": "+1"
      },
      "description": "Sentry Turret. Needs Power and Ammunition. Damage 15"
    },
    "Turret": {
      "width": 64,
      "height": 64,
      "energy": 25,
      "cost": {
        "gold": 500
      },
      "stats": {
        "reload": 2000,
        "damage": 50,
        "range": 800,
        "health": 150,
        "count": 2
      },
      "upgrade": {
        "damage": "+3",
        "health": "+50",
        "count": "+1"
      },
      "description": "Short Ranged Lasers. [Requires Energy]"
    },
    "VoidRay": {
      "width": 64,
      "height": 64,
      "energy": 75,
      "cost": {
        "gold": 1000
      },
      "stats": {
        "reload": 1000,
        "damage": 10,
        "range": 400,
        "health": 150,
        "count": 2
      },
      "upgrade": {
        "damage": "+5",
        "health": "+50",
        "count": "+1"
      },
      "description": "Shoots a continuous beam of focused energy. [Requires Energy]"
    },
    "TeslaCoil": {
      "width": 64,
      "height": 64,
      "cost": {
        "gold": 3000
      },
      "shouldAttackIgnoreObstacle": true,
      "categories": {"turret":true,"editable_targets":true},
      "stats": {
        "reload": 3000,
        "damage": 50,
        "health": 350,
        "range": 320,
        "powerConsumption": 750
      },
      "requirements": {
        "IronBar": 50,
        "Meteorite": 20,
        "CircuitBoard": 20
      },
      "upgrade": {
        "damage": "+5",
        "health": "+50",
        "count": "+1"
      },
      "description": "Strikes Lightning Bolt to up to 4 targets"
    },
    "BomberTurret": {
      "width": 64,
      "height": 64,
      "cost": {
        "gold": 3000
      },
      "storageCount": 1,
      "shouldAttackIgnoreObstacle": true,
      "categories": {"turret":true,"editable_targets":true,"ammo_turret":true},
      "hasMenu": true,
      "menuDescription": "Place Ammunition",
      "isInteractable": true,
      "showInteractTooltip": true,
      "stats": {
        "reload": 2000,
        "damage": 75,
        "health": 300,
        "range": 320,
        "powerConsumption": 200
      },
      "requirements": {
        "IronBar": 50,
        "SulfurOre": 30,
        "CircuitBoard": 15
      },
      "upgrade": {
        "damage": "+5",
        "health": "+50",
        "count": "+1"
      },
      "description": "Blast your enemies with this powerful and capable turret."
    },
    "MissileTurret": {
      "width": 64,
      "height": 64,
      "cost": {
        "gold": 500
      },
      "storageCount": 1,
      "shouldAttackIgnoreObstacle": true,
      "categories": {"turret":true,"editable_targets":true,"ammo_turret":true},
      "hasMenu": true,
      "menuDescription": "Place Ammunition",
      "isInteractable": true,
      "showInteractTooltip": true,
      "stats": {
        "reload": 2000,
        "damage": 20,
        "health": 400,
        "range": 480,
        "powerConsumption": 250
      },
      "requirements": {
        "IronBar": 50,
        "SulfurOre": 10,
        "CircuitBoard": 20
      },
      "upgrade": {
        "damage": "+5",
        "health": "+50",
        "count": "+1"
      },
      "description": "Launches homing missile towards locked target."
    },
    "Cannon": {
      "width": 64,
      "height": 64,
      "energy": 50,
      "cost": {
        "gold": 750
      },
      "stats": {
        "reload": 2000,
        "damage": 75,
        "range": 800,
        "health": 250,
        "count": 2
      },
      "upgrade": {
        "damage": "+5",
        "health": "+100",
        "count": "+1"
      },
      "description": "Long Range Cannon. Moderate Damage. [Requires Energy]"
    },
    "IonCannon": {
      "width": 64,
      "height": 64,
      "energy": 50,
      "cost": {
        "gold": 500
      },
      "stats": {
        "reload": 500,
        "damage": 50,
        "range": 400,
        "health": 200,
        "count": 1
      },
      "upgrade": {
        "damage": "+10",
        "health": "+100",
        "count": "+1"
      },
      "description": "Static but powerful ranged cannon that damages anything on its path"
    },
    "Fighter": {
      "width": 64,
      "height": 64,
      "cost": {
        "gold": 1000
      },
      "stats": {
        "reload": 2000,
        "speed": 10,
        "damage": 10,
        "range": 300,
        "health": 50,
        "count": 2
      },
      "upgrade": {
        "damage": "+5",
        "health": "+50",
        "count": "+1"
      },
      "description": "Basic Fighter Drone"
    }
  },
  "Terrains": {
    "BaseTerrain": {
      "width": 32,
      "height": 32,
      "categories": {"terrain": true}
    },
    "Rock": {
      "parent": "Terrains.BaseTerrain",
      "minimapColor": "#201003",
      "description": "Rock"
    },
    "LavaRock": {
      "parent": "Terrains.BaseTerrain"
    },
    "Water": {
      "parent": "Terrains.BaseTerrain",
      "description": "Water",
      "isBottleFillable": true,
      "isInteractable": true,
      "bottleDescription": "Use to refill oxygen tanks",
      "speedMultiplier": 0.7,
      "showLiquidTrail": true,
      "liquidTrailColor": "#75d3e6",
      "minimapColor": "#1269b9"
    },
    "Oil": {
      "parent": "Terrains.BaseTerrain",
      "description": "Oil",
      "categories": {"oil": true},
      "speedMultiplier": 0.5,
      "isInteractable": true,
      "showLiquidTrail": true,
      "liquidTrailColor": "#333333",
      "minimapColor": "#000000"
    },
    "Ice": {
      "parent": "Terrains.BaseTerrain"
    },
    "Sky": {
      "parent": "Terrains.BaseTerrain",
      "description": "Sky"
    },
    "Lava": {
      "parent": "Terrains.BaseTerrain",
      "minimapColor": "#ff0000",
      "description": "Lava",
      "categories": {"lava": true}
    },
    "Vine": {
      "parent": "Terrains.BaseTerrain",
      "health": 10
    },
    "Asteroid": {
      "parent": "Terrains.BaseTerrain",
      "description": "Asteroid",
      "isLightBlocker": true,
      "categories": {"wall":true,"astreoid":true},
      "health": 25,
      "isAirtight": true,
      "minimapColor": "#2b1e14"
    },
    "IceAsteroid": {
      "parent": "Terrains.Asteroid",
      "health": 100
    },
    "IronAsteroid": {
      "parent": "Terrains.Asteroid",
      "label": "Iron Ore",
      "health": 100,
      "minimapColor": "#2b1e14"
    },
    "MeteoriteAsteroid": {
      "parent": "Terrains.Asteroid",
      "description": "Meteorite Asteroid",
      "label": "Meteorite",
      "health": 20,
      "minimapColor": "#2b1e14"
    },
    "SteelAsteroid": {
      "parent": "Terrains.Asteroid",
      "label": "Steel Ore",
      "health": 100
    },
    "CopperAsteroid": {
      "parent": "Terrains.Asteroid",
      "description": "Copper Asteroid",
      "label": "Copper Ore",
      "health": 100,
      "minimapColor": "#2b1e14"
    }
  },
  "Resource": {
    "width": 32,
    "height": 32
  },
  "Tiles": {
    "Ground": 1,
    "Tree": 2
  },
  "tileSize": 32,
  "collisionGroup": {
    "Player": 1,
    "Ground": 2,
    "Projectile": 4,
    "Building": 8,
    "Resource": 16,
    "Mob": 32,
    "Unit": 64,
    "Pickup": 128,
    "Ship": 256
  }
}

},{}],657:[function(require,module,exports){
const Protocol = require('./../util/protocol')

const BaseBuildingCommon = () => {
}

BaseBuildingCommon.prototype = {

  getChunk() {
    return this.sector.getChunk(this.getChunkRow(), this.getChunkCol())
  },

  isStructure() {
    return !this.hasCategory("terrain") && !this.hasCategory("platform") && 
           !this.hasCategory("wall") && !this.hasCategory("distribution")
  },

  // account for structures only
  isOccupied() {
    let x
    let y

    if (this.getContainer().isMovable()) {
      x = this.getRelativeX()
      y = this.getRelativeY()
    } else {
      x = this.getX()
      y = this.getY()
    }

    const w = this.getWidth()
    const h = this.getHeight()

    return this.getContainer().armorMap.isOccupied(x, y, w, h) ||
           this.getContainer().structureMap.isOccupied(x, y, w, h)
  },

  isTrap() {
    return this.hasCategory("trap")
  },

  isDistribution() {
    return this.hasCategory("distribution")
  },

  isStructureConduit() {
    if (this.hasCategory("not_structure_conduit")) return false
      
    // a structure that's also a conduit (i.e electrical door, tanks)
    return this.hasCategory("power_consumer") || this.hasCategory("power_producer")  ||
           this.hasCategory("power_storage")  || this.hasCategory("oxygen_producer") ||
           this.hasCategory("oxygen_storage") || this.hasCategory("liquid_producer") ||
           this.hasCategory("liquid_storage") || this.hasCategory("fuel_producer")   ||
           this.hasCategory("fuel_storage")   || this.hasCategory("structure_conduit")
  },


  isGroundTile() {
    return false
  },

  isForegroundTile() {
    return false
  },

  isUndergroundTile() {
    return false
  },

  setRemoved() {
    this.isRemoved = true
  },

  drainSample() {
    if (this.hasEffect('blood')) {
      this.setEffectLevel('blood', this.getEffectLevel('blood') - 1)
      return "Blood"
    }
  },

  isPathFindable() {
    return true
  },

  isPathFindBlocker() {
    if (this.hasCategory("trap")) return false
    if (this.hasCategory("walkable")) return false
    return this.isStructure() || this.hasCategory("wall")
  },

  isRoomPartitioner() {
    return this.hasCategory("door") || 
           this.hasCategory("vent") ||
           this.hasCategory("wall") ||
           this.hasCategory("escape_pod") 
  },

  hasRoomRole() {
    return this.isRoomPartitioner() || 
           this.hasCategory("platform") || 
           this.hasCategory("air_detector") || 
           this.hasCategory("oxygen_storage") ||
           this.isStructure()
  },


  hasOxygenRole() {
    return this.hasCategory("oxygen_conduit") ||
           this.hasCategory("oxygen_producer") ||
           this.hasCategory("oxygen_storage") ||
           this.hasCategory("vent")
  },

  hasPowerRole() {
    return this.hasCategory("power_conduit")  ||
           this.hasCategory("power_producer") ||
           this.hasCategory("power_storage")  ||
           this.hasCategory("power_consumer")
  },

  hasLiquidRole() {
    return this.hasCategory("liquid_conduit")  ||
           this.hasCategory("liquid_producer") ||
           this.hasCategory("liquid_storage")  ||
           this.hasCategory("liquid_consumer")
  },

  hasRailRole() {
    return this.hasCategory("rail")
  },

  hasSoilRole() {
    return this.hasCategory("soil") || this.hasCategory("farm_controller")
  },

  hasFuelRole() {
    return this.hasCategory("fuel_conduit")  ||
           this.hasCategory("fuel_producer") ||
           this.hasCategory("fuel_storage")  ||
           this.hasCategory("fuel_consumer")
  },

  hasDistributionRole() {
    return this.hasPowerRole() || this.hasOxygenRole() || this.hasLiquidRole() || this.hasFuelRole()
  },

  getLand() {
    return this.sector.getLand(this.getRow(), this.getCol())
  },

  getRoom() {
    return this.room
  },

  getRooms() {
    return this.rooms
  },

  getOccupiedRoom() {
    let platform = this.getStandingPlatform()
    if (!platform) return null

    return platform.getRoom()
  },

  getResourceConsumption(name) {
    let field = name + "Consumption"
    return this.getStats(this.level)[field]
  },

  getResourceCapacity(name) {
    let field = name + "Capacity"
    return this.getStats(this.level)[field]
  },

  getResourceProduction(name) {
    let field = name + "Production"
    return this.getStats(this.level)[field]
  },

  isAirtight() {
    return !!this.getConstants().isAirtight
  },

  hasObstacleOnTop() {
    let row = this.getRow()
    let col = this.getCol()
    let entity = this.getContainer().structureMap.get(row, col)
    if (entity && 
        entity.isConstructionFinished() &&
        !entity.isPassableByPathFinder()) {
      return true
    }

    entity = this.getContainer().armorMap.get(row, col)
    if (entity && entity.isConstructionFinished()) return true

    return false
  }

}

module.exports = BaseBuildingCommon


},{"./../util/protocol":686}],658:[function(require,module,exports){
const Constants = require("../constants")
const Helper = require("../helper")

class Fov {
  constructor(tileManager) {
    this.tileManager = tileManager
  }

  calculateFov(entity, options = {}) {
    let lightings = {}

    let visited = {}
    let LIGHT_TILE = 1
    let LIGHT_BLOCKER = 2

    let start = Date.now()

    // go through each angle surrounding player
    for(let i = 0; i < 360; i += 2) {
      let dx = Math.cos(i * Math.PI/180) * Constants.tileSize;
      let dy = Math.sin(i * Math.PI/180) * Constants.tileSize;

      let maxViewDistance = entity.getMaxViewDistance()
      let distanceStep = Helper.distance(0, 0, dx, dy)

      let x = entity.getX()
      let y = entity.getY()

      // traverse an angle until radius hit maximum distance
      for(let distance = 0 ; distance < maxViewDistance; distance++) {
        let row = Math.floor(y / Constants.tileSize)
        let col = Math.floor(x / Constants.tileSize)
        if (this.tileManager.isOutOfBounds(row, col)) {
          break
        }

        let tileKey = [row, col].join("-")
        if (!visited[tileKey]) {
          let tile = this.tileManager.getLightTile(row, col)
          if (tile && tile.entity && tile.entity.isLightBlocker()) {
            if (options.shouldIncludeLightBlocker) {
              lightings[tileKey] = { row: row, col: col }
            }
            
            visited[tileKey] = LIGHT_BLOCKER
            break
          } else {
            visited[tileKey] = LIGHT_TILE
            lightings[tileKey] = { row: row, col: col }
          }
        } else if (visited[tileKey] === LIGHT_BLOCKER) {
          break
        }
        
        x += dx
        y += dy
        distance += distanceStep
      }
    }

    let duration = Date.now() - start
    // console.log("fov duration: " + (duration/1000))

    return lightings
  }

}

module.exports = Fov
},{"../constants":656,"../helper":664}],659:[function(require,module,exports){
const Constants = require('./../constants.json')
const Helper = require('./../helper')

class Grid {
  constructor(name, container, rowCount, colCount, emptyValue = 0) {
    this.name = name
    this.container = container
    this.mapData = []
    this.tileSize = Constants.tileSize

    this.ROW_COUNT    = rowCount
    this.COLUMN_COUNT = colCount
    this.EMPTY_VALUE = emptyValue

    this.init()
  }

  reset() {
    this.mapData = []
    this.init()
  }

  init() {
    for(var row = 0; row < this.ROW_COUNT; row++) {
      this.mapData.push([])
      for(var col = 0; col < this.COLUMN_COUNT; col++) {
        this.mapData[row][col] = this.EMPTY_VALUE
      }
    }
  }

  getNumberGrid() {
    return this.mapData.map((row) => {
      return row.map((col) => {
        return col ? col.getType() : 0
      })
    })
  }

  applyMap(map) {
    for (var row = 0; row < map.length; row++) {
      let rowSection = map[row]
      for(var col = 0; col < rowSection.length; col++) {
        entity = map[row][col]
        if (typeof entity === "function") {
          this.mapData[row][col] = entity()
        } else {
          this.mapData[row][col] = entity
        }
      }
    }
  }

  set(data) {
    if (typeof data.value === "function") {
      this.mapData[data.row][data.col] = data.value()
    } else {
      this.mapData[data.row][data.col] = data.value
    }
  }

  get(row, col) {
    let isRowColNaN = (isNaN(parseInt(row)) || isNaN(parseInt(col)))

    if (this.isOutOfBounds(row, col) || isRowColNaN) {
      return null
    } else {
      return this.mapData[row][col]
    }
  }

  forEachMultiple(startRow, startCol, endRow, endCol, cb) {
    for (var row = startRow; row <= endRow; row++) {
      for (var col = startCol; col <= endCol; col++) {
        let value = this.rowColHitTest(row, col).entity
        cb(row, col, value)
      }
    }
  }

  isRowOutOfBounds(row) {
    return row < 0 || row >= this.ROW_COUNT
  }

  isColumnOutOfBounds(col) {
    return col < 0 || col >= this.COLUMN_COUNT
  }

  isOutOfBounds(row, col) {
    return this.isRowOutOfBounds(row) || this.isColumnOutOfBounds(col)
  }

  isTileEmptyRowCol(row, col) {
    if (this.isOutOfBounds(row, col)) return true

    return this.mapData[row][col] === this.EMPTY_VALUE
  }

  isFullyOccupied(x, y, width, height) {
    let checkFull = true
    return this.isOccupied(x, y, width, height, checkFull)
  }

  isOccupied(x, y, width, height, checkFull = false) {
    let isOneBlock = (width === this.tileSize && height === this.tileSize)

    if (isOneBlock) {
      const position = this.getTilePosition(x, y)
      if (this.isOutOfBounds(position.row, position.col)) return true

      const isTileFilled = this.mapData[position.row][position.col] !== this.EMPTY_VALUE
      return isTileFilled
    } else {
      const box = {
        pos: {
          x: x - width / 2,
          y: y - height / 2
        },
        w: width,
        h: height
      }

      return checkFull ? this.isBoxFullyOccupied(box) : this.isBoxOccupied(box)
    }
  }


  getTilePosition(x, y) {
    const row = Math.floor(y / this.tileSize)
    const col = Math.floor(x / this.tileSize)

    return {
      row: row,
      col: col
    }
  }

  addToCollection(row, col, entity) {
    let collection = this.mapData[row][col]
    if (!collection) {
      collection = {}
    }

    collection[entity.id] = entity

    this.mapData[row][col] = collection
  }

  removeFromCollection(row, col, entity) {
    let collection = this.mapData[row][col]
    if (collection) {
      delete collection[entity.id]

      if (Object.keys(collection).length > 0) {
        this.mapData[row][col] = collection
      } else {
        this.mapData[row][col] = this.EMPTY_VALUE
      }
    }
  }

  registerToCollection(box, tileable) {
    const tilesOccupied = this.hitTestTile(box)

    tilesOccupied.forEach((tilesOccupied) => {
      let collection = this.mapData[tilesOccupied.row][tilesOccupied.col]
      if (!collection) {
        collection = {}
      }

      collection[tileable.id] = tileable

      this.mapData[tilesOccupied.row][tilesOccupied.col] = collection
    })
  }

  unregisterFromCollection(box, tileable) {
    const tilesOccupied = this.hitTestTile(box)

    tilesOccupied.forEach((tilesOccupied) => {
      let collection = this.mapData[tilesOccupied.row][tilesOccupied.col]
      if (collection) {
        delete collection[tileable.id]

        if (Object.keys(collection).length > 0) {
          this.mapData[tilesOccupied.row][tilesOccupied.col] = collection
        } else {
          this.mapData[tilesOccupied.row][tilesOccupied.col] = this.EMPTY_VALUE
        }
      }
    })
  }

  hitTestTileCollection(box, checkFull = false) {
    let hits = this.hitTestTile(box, checkFull)

    return hits.map((hit) => {
      if (!hit.entity) return [hit]

      let entities = Object.values(hit.entity)
      return entities.map((entity) => {
        return { row: hit.row, col: hit.col , entity: entity }
      })
    }).flat()
  }

  register(box, tileable) {
    const tilesOccupied = this.hitTestTile(box)

    tilesOccupied.forEach((tilesOccupied) => {
      this.mapData[tilesOccupied.row][tilesOccupied.col] = tileable
    })
  }

  unregister(box, tileable) {
    const tilesOccupied = this.hitTestTile(box)

    tilesOccupied.forEach((tilesOccupied) => {
      if (tileable) {
        if (this.mapData[tilesOccupied.row][tilesOccupied.col] === tileable) {
          this.mapData[tilesOccupied.row][tilesOccupied.col] = this.EMPTY_VALUE
        }
      } else {
        this.mapData[tilesOccupied.row][tilesOccupied.col] = this.EMPTY_VALUE
      }
      
    })
  }

  hitTestTile(box, checkFull = false, excludeOutOfBounds = true) {
    let width  = box.w
    let height = box.h

    let topLeftPoint
    let bottomRightPoint

    if (checkFull) {
      topLeftPoint     = { x: box.pos.x         , y: box.pos.y   }
      bottomRightPoint = { x: box.pos.x + width, y: box.pos.y + height }
    } else {
      // i.e if we have 32x32 box that fits exactly on a specific tile,
      // we dont want to consider its 4 corners for hit tests
      // otherwise, it'll match against 9 tiles, instead of just one
      let padding = 2
      topLeftPoint     = { x: box.pos.x         + padding, y: box.pos.y          + padding }
      bottomRightPoint = { x: box.pos.x + width - padding, y: box.pos.y + height - padding }
    }

    let results = this.hitTestRect(topLeftPoint, bottomRightPoint)

    if (excludeOutOfBounds) {
      results = results.filter((hit) => {
        return hit.entity !== null
      })
    }

    return results
  }

  randomTile(boundingBox, excludeBoundingBox) {
    let startCol = Math.floor(boundingBox.minX/this.tileSize)
    let endCol = Math.floor(boundingBox.maxX/this.tileSize)

    let startRow = Math.floor(boundingBox.minY/this.tileSize)
    let endRow = Math.floor(boundingBox.maxY/this.tileSize)

    if (excludeBoundingBox) {
      let excludeStartCol = Math.floor(excludeBoundingBox.minX/this.tileSize)
      let excludeEndCol = Math.floor(excludeBoundingBox.maxX/this.tileSize)

      let excludeStartRow = Math.floor(excludeBoundingBox.minY/this.tileSize)
      let excludeEndRow = Math.floor(excludeBoundingBox.maxY/this.tileSize)

      let row = this.randomBetweenExcluding(startRow, endRow, excludeStartRow, excludeEndRow)
      let col = this.randomBetweenExcluding(startCol, endCol, excludeStartCol, excludeEndCol)

      return this.rowColHitTest(row, col)
    } else {
      let row = this.randomBetweenExcluding(startRow, endRow)
      let col = this.randomBetweenExcluding(startCol, endCol)

      return this.rowColHitTest(row, col)
    }
  }

  randomBetweenExcluding(start, end, excludeStart, excludeEnd) {
    if (excludeStart === start && excludeEnd === end) {
      throw new Error("invalid condition: exclude start/end same as start/end")
    }

    let count = end - start + 1
    let number = start + Math.floor(Math.random() * count)
    if (excludeStart && excludeEnd && number >= excludeStart && number <= excludeEnd) {
      return this.randomBetweenExcluding(start, end, excludeStart, excludeEnd)
    } else {
      return number
    }
  }

  getXY(row, col) {
    const x = (col * this.tileSize) + (this.tileSize / 2)
    const y = (row * this.tileSize) + (this.tileSize / 2)

    return {
      x: x,
      y: y
    }
  }


  hitTest(x, y) {
    var row = Math.floor(y / this.tileSize)
    var col = Math.floor(x / this.tileSize)

    return this.rowColHitTest(row, col)
  }

  rowColHitTest(row, col) {
    let isRowColNaN = (isNaN(parseInt(row)) || isNaN(parseInt(col)))

    if (this.isOutOfBounds(row, col) || isRowColNaN) {
      return { row: row, col: col, entity: null }
    } else {
      return { row: row, col: col, entity: this.mapData[row][col] }
    }
  }

  getDiagonalEdges(box) {
    return {
      upperLeft:  this.hitTest(box.pos.x         + this.tileSize/2, box.pos.y + this.tileSize/2),
      upperRight: this.hitTest(box.pos.x + box.w - this.tileSize/2, box.pos.y + this.tileSize/2),
      lowerLeft:  this.hitTest(box.pos.x         + this.tileSize/2, box.pos.y + box.h - this.tileSize/2),
      lowerRight: this.hitTest(box.pos.x + box.w - this.tileSize/2, box.pos.y + box.h - this.tileSize/2)
    }
  }

  forEach(cb) {
    for(let row = 0; row < this.ROW_COUNT; row++) {
      for(let col = 0; col < this.COLUMN_COUNT; col++) {
        let value = this.mapData[row][col]
        cb(row, col, value)
      }
    }
  }

  count() {
    let result = 0

    this.forEach((row, col, value) => {
      if (value) {
        result += 1
      }
    })

    return result
  }

  hitTestRect(topLeft, bottomRight) {
    var startRow = Math.floor(topLeft.y / this.tileSize)
    var startCol = Math.floor(topLeft.x / this.tileSize)
    var endRow   = Math.floor(bottomRight.y / this.tileSize)
    var endCol   = Math.floor(bottomRight.x / this.tileSize)

    return this.hitTestStartEnd(startRow, startCol, endRow, endCol)
  }

  hitTestStartEnd(startRow, startCol, endRow, endCol, includeOutOfBounds = true, includeMeta = true, includeEmpty = true) {
    var rowLength = endRow - startRow + 1
    var colLength = endCol - startCol + 1

    var hits = []
    var hit

    for (var y = 0; y < rowLength; y++) {
      for (var x = 0; x < colLength; x++) {
        let row = startRow + y
        let col = startCol + x

        if (this.isRowOutOfBounds(row) || this.isColumnOutOfBounds(col)) {
          if (includeOutOfBounds) {
            hit = includeMeta ? { row: row, col: col, entity: null } : null
            hits.push(hit)
          }
        } else {
          hit = includeMeta ? { row: row, col: col, entity: this.mapData[row][col] } : this.mapData[row][col]
          if (!hit) {
            if (includeEmpty) {
              hits.push(hit)
            }
          } else {
            hits.push(hit)
          }

        }
      }
    }

    return hits
  }

  isLeft(hit, otherHits) {
    return otherHits.every((otherHit) => { return hit.col < otherHit.col })
  }

  isUp(hit, otherHits) {
    return otherHits.every((otherHit) => { return hit.row < otherHit.row })
  }

  isRight(hit, otherHits) {
    return otherHits.every((otherHit) => { return hit.col > otherHit.col })
  }

  isDown(hit, otherHits) {
    return otherHits.every((otherHit) => { return hit.row > otherHit.row })
  }

  normalizeCoord(coord, orientation) {
    if (orientation === "row") {
      var maxCoord = this.ROW_COUNT - 1

      if (coord > maxCoord) coord = maxCoord
    } else {
      // column
      var maxCoord = this.COLUMN_COUNT - 1

      if (coord > maxCoord) coord = maxCoord
    }

    if (coord < 0) coord = 0

    return coord
  }

  isBoxOccupied(box) {
    return this.getOccupancy(box).occupied.length > 0
  }

  getOccupancy(box) {
    const hits = this.hitTestTile(box)
    const occupied = hits.filter((hit) => {
      const noEntityPresent = hit.entity === this.EMPTY_VALUE
      const outOfBoundsIndicator = hit.entity === null

      if (noEntityPresent) {
        return false
      } else if (outOfBoundsIndicator) {
        return true
      } else {
        return true
      }

    })

    return {
      occupied: occupied,
      hits: hits
    }
  }

  isBoxFullyOccupied(box) {
    const occupancy = this.getOccupancy(box)
    const boxTileCount = box.w/Constants.tileSize * box.h/Constants.tileSize

    return occupancy.occupied.length > 0 && occupancy.occupied.length === boxTileCount
  }

  getVerticallyBumpedTile(velocity, position, w, h) {
    const padding = 10 // dont go to close
    const horizontalLeaway  = 3  // if already close to side, give me some slack, and allow to move vertical still
    const isGoingUp = velocity[1] < 0

    const x = position[0]
    const y = position[1]

    let colliders = []

    if (isGoingUp) {
      let topLeft  = [x - w/2 + horizontalLeaway, y - h / 2 - padding]
      let top      = [x                         , y - h / 2 - padding]
      let topRight = [x + w/2 - horizontalLeaway, y - h / 2 - padding]

      colliders.push(topLeft)
      colliders.push(top)
      colliders.push(topRight)
    } else {
      let bottomLeft  = [x - w/2 + horizontalLeaway, y + h / 2 + padding]
      let bottom      = [x                         , y + h / 2 + padding]
      let bottomRight = [x + w/2 - horizontalLeaway, y + h / 2 + padding]

      colliders.push(bottomLeft)
      colliders.push(bottom)
      colliders.push(bottomRight)
    }

    let hit = null
    let hits = []

    for (var i = 0; i < colliders.length; i++) {
      let collider = colliders[i]
      let hitResult  = this.hitTest(collider[0], collider[1])

      if (!hit && this.isBoundary(hitResult)) {
        hit = hitResult
      }

      hits.push(hitResult)
    }

    return { hit: hit, hits: hits }
  }

  setBoundaryDetector(detector) {
    this.boundaryDetector = detector
  }

  search(boundingBox) {
    let startCol = Math.floor(boundingBox.minX/this.tileSize)
    let endCol = Math.floor(boundingBox.maxX/this.tileSize)

    let startRow = Math.floor(boundingBox.minY/this.tileSize)
    let endRow = Math.floor(boundingBox.maxY/this.tileSize)

    let includeOutOfBounds = false
    let includeMeta = false
    let includeEmpty = false

    let visited = {}
    let unique = []

    let entities = this.hitTestStartEnd(startRow, startCol, endRow, endCol, includeOutOfBounds, includeMeta, includeEmpty)
    entities.forEach((entity) => {
      if (entity) {
        if (!visited[entity.getId()]) {
          visited[entity.getId()] = true
          unique.push(entity)
        }
      }
    })

    return unique
  }

  searchDict(boundingBox) {
    let startCol = Math.floor(boundingBox.minX/this.tileSize)
    let endCol = Math.floor(boundingBox.maxX/this.tileSize)

    let startRow = Math.floor(boundingBox.minY/this.tileSize)
    let endRow = Math.floor(boundingBox.maxY/this.tileSize)

    let includeOutOfBounds = false
    let includeMeta = false
    let includeEmpty = false

    let result = {}

    let entities = this.hitTestStartEnd(startRow, startCol, endRow, endCol, includeOutOfBounds, includeMeta, includeEmpty)
    entities.forEach((entity) => {
      if (entity) {
        result[entity.getId()] = entity
      }
    })

    return result
  }

  searchCollection(boundingBox) {
    let startCol = Math.floor(boundingBox.minX/this.tileSize)
    let endCol = Math.floor(boundingBox.maxX/this.tileSize)

    let startRow = Math.floor(boundingBox.minY/this.tileSize)
    let endRow = Math.floor(boundingBox.maxY/this.tileSize)

    let includeOutOfBounds = false
    let includeMeta = false
    let includeEmpty = false

    let visited = {}
    let unique = []

    let entities = this.hitTestStartEnd(startRow, startCol, endRow, endCol, includeOutOfBounds, includeMeta, includeEmpty)
    entities.forEach((entityMap) => {
      if (entityMap) {
        for (let id in entityMap) {
          let entity = entityMap[id]
          if (!visited[entity.getId()]) {
            visited[entity.getId()] = true
            unique.push(entity)
          }
        }
      }
    })

    return unique
  }

  isBoundary(hit) {
    // use custom detector if present
    if (this.boundaryDetector) return this.boundaryDetector(hit)

    if (hit.entity === null) return true // out of bounds

    let entity = hit.entity

    return entity !== this.EMPTY_VALUE && (entity.getCollisionGroup() === Constants.collisionGroup.Ground ||
                            entity.getCollisionGroup() === Constants.collisionGroup.Building ||
                            entity.getCollisionGroup() === Constants.collisionGroup.Resource)
  }

  getHorizontallyBumpedTile(velocity, position, w, h) {
    const padding = 10 // dont go to close
    const verticalLeaway  = 3  // if already close vertically, give me some slack, and allow to move sideways still
    const isGoingLeft = velocity[0] < 0

    const x = position[0]
    const y = position[1]

    let colliders = []

    if (isGoingLeft) {
      let topLeft    = [x - w/2 - padding, y - h / 2 + verticalLeaway]
      let left       = [x - w/2 - padding, y                         ]
      let bottomLeft = [x - w/2 - padding, y + h / 2 - verticalLeaway]

      colliders.push(topLeft)
      colliders.push(left)
      colliders.push(bottomLeft)
    } else {
      let topRight    = [x + w / 2 + padding, y - h / 2 + verticalLeaway]
      let right       = [x + w/2   + padding, y                         ]
      let bottomRight = [x + w / 2 + padding, y + h / 2 - verticalLeaway]

      colliders.push(topRight)
      colliders.push(right)
      colliders.push(bottomRight)
    }


    let hit = null
    let hits = []

    for (var i = 0; i < colliders.length; i++) {
      let collider = colliders[i]
      let hitResult  = this.hitTest(collider[0], collider[1])

      if (!hit && this.isBoundary(hitResult)) {
        hit = hitResult
      }

      hits.push(hitResult)
    }

    return { hit: hit, hits: hits }
  }

  // order is different from left/top/right/down. WARNING
  getNeighbors(row, col) {
    return [
      this.rowColHitTest(row - 1, col    ), // top
      this.rowColHitTest(row    , col - 1), // left
      this.rowColHitTest(row + 1, col    ), // down
      this.rowColHitTest(row    , col + 1)  // right
    ].filter((hit) => {
      return hit.entity // must be present
    })
  }

  getNeighborsAllowEmpty(row, col) {
    return [
      this.rowColHitTest(row    , col - 1), // left
      this.rowColHitTest(row - 1, col    ), // top
      this.rowColHitTest(row    , col + 1), // right
      this.rowColHitTest(row + 1, col    )  // down
    ]
  }

  raycast(x1, y1, x2, y2, maxLength, entityToIgnore) {
    let result = []

    result = result.concat(this.raycastHorizontal(x1, y1, x2, y2, maxLength, entityToIgnore))
    result = result.concat(this.raycastVertical(x1, y1, x2, y2, maxLength, entityToIgnore))

    return result
  }

  /*
    https://www.permadi.com/tutorial/raycast/rayc7.html
    x1,y1 - source
    x2,y2 - target
  */
  raycastVertical(x1, y1, x2, y2, maxLength, entityToIgnore) {
    let obstacles = []

    maxLength = maxLength || this.tileSize * this.ROW_COUNT // default is map width

    if (x2 - x1 === 0) return obstacles

    let slope = (y2 - y1) / (x2 - x1)
    let radian = Math.atan2(y2 - y1, x2 - x1)
    let absAngle = Math.abs(radian)
    let dx, dy, stepX, stepY
    let isOutOfBounds = false
    let obstacle = null

    // step 1: find dx + dy
    let directionX = Math.sign(Math.cos(radian))
    let directionY = Math.sign(Math.sin(radian))
    let margin = 1 // we dont want the point on edge of grid, but a little bit extended into the inside of it

    if (directionX === -1) {
      dx = -(x1 - (Math.floor(x1 / this.tileSize) * this.tileSize) + margin)
    } else {
      dx = (Math.ceil(x1 / this.tileSize) * this.tileSize) - x1 + margin
    }

    dy = (dx * slope) + (margin * directionY)

    // step 2: find 1st intersection
    let intersection = [x1 + dx, y1 + dy]

    // step 3: find stepX, stepY
    stepX = this.tileSize * directionX
    stepY = stepX * slope
    let stepDistance = Math.abs(stepX / Math.cos(radian))
    let currCol = Math.floor(y1 / this.tileSize)
    let maxXSteps = directionX === -1 ? currCol : this.COLUMN_COUNT - currCol
    let iteration = 0
    let extension = 0
    let distance = 0

    // step 4: check for grid intersections
    // check current source x,y as well
    let sourceRow = Math.floor(y1 / this.tileSize)
    let sourceCol = Math.floor(x1 / this.tileSize)
    if (!this.isOutOfBounds(sourceRow, sourceCol)) {
      obstacle = this.mapData[sourceRow][sourceCol]
      if (obstacle && obstacle.isCollidable() && obstacle !== entityToIgnore) {
        obstacles.push({ x: x1, y: y1, entity: obstacle, distance: 0 })
      }
    }

    while (iteration < maxXSteps && (extension + stepDistance < maxLength)) {
      iteration += 1
      distance += Helper.distance(0, 0, stepX, stepY)

      let row = Math.floor(intersection[1] / this.tileSize)
      let col = Math.floor(intersection[0] / this.tileSize)
      isOutOfBounds   = this.isOutOfBounds(row, col)

      if (isOutOfBounds) {
        break
      }

      obstacle = this.mapData[row][col]

      if (obstacle && obstacle.isCollidable() && obstacle !== entityToIgnore) {
        obstacles.push({ x: intersection[0], y: intersection[1], entity: obstacle, distance: distance })
        break
      }

      // next iteration
      intersection[0] += stepX
      intersection[1] += stepY

      extension += stepDistance
    }

    return obstacles
  }

  /*
    https://www.permadi.com/tutorial/raycast/rayc7.html
    x1,y1 - source
    x2,y2 - target
  */
  raycastHorizontal(x1, y1, x2, y2, maxLength, entityToIgnore) {
    let obstacles = []

    maxLength = maxLength || this.tileSize * this.ROW_COUNT // default is map width

    if (x2 - x1 === 0) return obstacles

    let slope = (y2 - y1) / (x2 - x1)
    let radian = Math.atan2(y2 - y1, x2 - x1)
    let absAngle = Math.abs(radian)
    let dx, dy, stepX, stepY
    let isOutOfBounds = false
    let obstacle = null

    // step 1: find dx + dy
    let directionY = Math.sign(Math.sin(radian))
    let margin = 1 // we dont want the point on edge of grid, but a little bit extended into the inside of it

    if (directionY === -1) {
      dy = -(y1 - (Math.floor(y1 / this.tileSize) * this.tileSize) + margin)
    } else {
      dy = (Math.ceil(y1 / this.tileSize) * this.tileSize) - y1 + margin
    }

    dx = dy / slope + Math.sign(Math.cos(absAngle)) * margin

    // step 2: find 1st intersection
    let intersection = [x1 + dx, y1 + dy]

    // step 3: find stepX, stepY
    stepY = this.tileSize * directionY
    stepX = stepY / slope
    let stepDistance = Math.abs(stepX / Math.cos(radian))
    let currRow = Math.floor(y1 / this.tileSize)
    let maxYSteps = directionY === -1 ? currRow : this.ROW_COUNT - currRow
    let iteration = 0
    let extension = 0
    let distance = 0

    // step 4: check for grid intersections
    // check current source x,y as well
    let sourceRow = Math.floor(y1 / this.tileSize)
    let sourceCol = Math.floor(x1 / this.tileSize)
    if (!this.isOutOfBounds(sourceRow, sourceCol)) {
      obstacle = this.mapData[sourceRow][sourceCol]
      if (obstacle && obstacle.isCollidable() && obstacle !== entityToIgnore) {
        obstacles.push({ x: x1, y: y1, entity: obstacle, distance: 0 })
      }
    }

    while (iteration < maxYSteps && (extension + stepDistance < maxLength)) {
      iteration += 1
      distance += Helper.distance(0, 0, stepX, stepY)

      let row = Math.floor(intersection[1] / this.tileSize)
      let col = Math.floor(intersection[0] / this.tileSize)
      isOutOfBounds   = this.isOutOfBounds(row, col)

      if (isOutOfBounds) {
        break
      }

      obstacle = this.mapData[row][col]

      if (obstacle && obstacle.isCollidable() && obstacle !== entityToIgnore) {
        obstacles.push({ x: intersection[0], y: intersection[1], entity: obstacle, distance: distance })
        break
      }

      // next iteration
      intersection[0] += stepX
      intersection[1] += stepY

      extension += stepDistance
    }

    return obstacles
  }

  getRowCount() {
    return this.ROW_COUNT
  }

  getColCount() {
    return this.COLUMN_COUNT
  }

}

module.exports = Grid

},{"./../constants.json":656,"./../helper":664}],660:[function(require,module,exports){
class ObjectPool {

  static create(name, klass) {
    this.pools = this.pools || {}

    let pool = new ObjectPool(klass)

    // after minification, javascript klass.name is changed and could result in conflicts
    // rely on static string name instead
    this.pools[name] = pool
  }

  static obtain(name, ...args) {
    let pool = this.pools[name]
    if (!pool) throw new Error("object pool " + name + " not found")
    
    return pool.obtain(...args)
  }

  static reset() {
    for (let name in this.pools) {
      let pool = this.pools[name]
      pool.reset()
    }
  }

  static free(name, instance) {
    let pool = this.pools[name]
    if (!pool) throw new Error("object pool " + name + " not found")
    
    pool.free(instance)    
  }

  constructor(klass) {
    this.klass = klass
    this.freeList = []
    this.count = 0
  }

  reset() {
    this.freeList = []
    this.count = 0
  }

  obtain(...args) {
    let object

    if (this.count === 0) {
      // nothing in freelist
      object = new this.klass(...args)
    } else {
      this.count--
      object = this.freeList[this.count]
    }
    
    return object
  }

  free(object) {
    object.reset()
    this.freeList[this.count] = object
    this.count++
  }
}

module.exports = ObjectPool
},{}],661:[function(require,module,exports){
const Constants = require("./../constants.json")
const Protocol = require('./../util/protocol')
const Helper = require('./../helper')
const vec2 = require('./../util/vec2')

const PlayerCommon = () => {
}

PlayerCommon.prototype = {
  initPlayerCommon() {
    this.ACTION_INTERVAL = this.getStats().reload
    this.moveYaw = 0
    this.lastActionTime = (new Date()).getTime()
    this.wave = null
    this.RESPAWN_TIME = 5 * 1000
    this.thirst = this.getMaxThirst()
  },
  getActionInterval() {
    return this.isLowStatus("stamina") ? this.ACTION_INTERVAL * 2 : this.ACTION_INTERVAL
  },
  getCameraBoundingBox() {
    var padding = Constants.tileSize*3;
    var cameraTarget = this.getCameraFocusTarget();

    let x
    let y

    if (cameraTarget) {
      x = cameraTarget.isPositionBased ? cameraTarget.x : cameraTarget.getX()
      y = cameraTarget.isPositionBased ? cameraTarget.y : cameraTarget.getY()
    } else {
      x = this.getX()
      y = this.getY()
    }

    var minX = x - this.getScreenWidth() / 2 - padding;
    var maxX = x + this.getScreenWidth() / 2 + padding;
    var minY = y - this.getScreenHeight() / 2 - padding;
    var maxY = y + this.getScreenHeight() / 2 + padding;

    return {
      minX: minX,
      minY: minY,
      maxX: maxX,
      maxY: maxY
    }
  },
  getLimitedCameraBoundingBox() {
    let range = this.getMaxViewDistance()
    let cameraTarget = this.getCameraFocusTarget()

    let x = cameraTarget.isPositionBased ? cameraTarget.x : cameraTarget.getX()
    let y = cameraTarget.isPositionBased ? cameraTarget.y : cameraTarget.getY()

    let minX = x - range 
    let maxX = x + range 
    let minY = y - range 
    let maxY = y + range

    return {
      minX: minX,
      minY: minY,
      maxX: maxX,
      maxY: maxY
    }
  },
  setThirst(thirst) {
    let prevThirst = this.thirst

    if (thirst > this.getMaxThirst()) {
      this.thirst = this.getMaxThirst()
    } else if (thirst < 0) {
      this.thirst = 0
    } else {
      this.thirst = thirst
    }

    if (prevThirst !== this.thirst) {
      this.onThirstChanged()
    }
  },
  setGold(amount) {
    if (isNaN(amount)) return
    let maxInt = ((2 ** 32) / 2) - 1
    if (amount < 0) amount = 0
    if (amount > maxInt) amount = maxInt
    let delta = this.gold ? amount - this.gold : amount
    let prevAmount = this.gold
    this.gold = amount
    this.onGoldChanged(prevAmount, amount)
  },
  getGold() {
    return this.gold
  },
  getVisibleChunks() {
    let boundingBox = this.getCameraBoundingBox()
    return Helper.getChunksFromBoundingBox(this.sector, boundingBox)
  },
  isBareHanded() {
    const itemData = this.getActiveItem()
    return !itemData
  },
  getMaxThirst() {
    return Constants.Player.thirst
  },
  getVelocityFromControls(controlKeys, speed) {
    // player movement is wasd
    let targetVelocity = vec2.create()

    if (controlKeys & Constants.Control.left) {
      targetVelocity[0] = -speed
    }

    if (controlKeys & Constants.Control.right) {
      targetVelocity[0] = speed
    }

    if (controlKeys & Constants.Control.down) {
      targetVelocity[1] =  speed
    }

    if (controlKeys & Constants.Control.up) {
      targetVelocity[1] = -speed
    }

    return targetVelocity
  },
  getBuildableCounts() {
    let countMap = {}
    const buildingTypes = Protocol.definition().BuildingType
    for (let typeId in buildingTypes) {
      let type = buildingTypes[typeId]
      countMap[type] = 0
    }

    for (let buildingId in this.ship.platforms) {
      let building = this.ship.platforms[buildingId]
      let type = building.getType()
      countMap[type] += 1
    }

    for (let buildingId in this.ship.armors) {
      let building = this.ship.armors[buildingId]
      let type = building.getType()
      countMap[type] += 1
    }

    for (let buildingId in this.ship.structures) {
      let building = this.ship.structures[buildingId]
      let type = building.getType()
      countMap[type] += 1
    }

    for (let buildingId in this.ship.units) {
      let building = this.ship.units[buildingId]
      let type = building.getType()
      countMap[type] += 1
    }

    return countMap
  },
  hasReachedMaxCount(buildingKlass) {
    return false
    const buildableCounts = this.getBuildableCounts()
    return buildableCounts[buildingKlass.getType()] >= buildingKlass.getMaxCountFor(this.ship)
  },
  hasEnoughResourcesFor(cost) {
    let result = true

    const requirements = cost
    for (let resourceName in requirements) {
      let value = requirements[resourceName]
      if (this[resourceName] < value) {
        result = false
        break
      }
    }

    return result
  },
  getGridSize() {
    return this.getStats(this.level).tileCount * Constants.tileSize
  },
  isWithinGrid(coord) {
    const gridSize = this.getStats(this.level).tileCount * Constants.tileSize

    return (coord.x >= 0 && coord.x <= gridSize) &&
           (coord.y >= 0 && coord.y <= gridSize)
  },
  getVelocity(controlKeys) {
    const moveData = this.getMoveData(controlKeys)

    // console.log("moveData: " + JSON.stringify(moveData))

    var velocityX = this.speed * moveData.dx
    var velocityY = this.speed * moveData.dy

    // diagonal movement
    if (velocityX !== 0 && velocityY !== 0) {
      velocityX = velocityX / Math.sqrt(2)
      velocityY = velocityY / Math.sqrt(2)
    }

    return {
      x: velocityX,
      y: velocityY,
    }
  },
  getMoveData(controlKeys) {
    var dx = 0
    var dy = 0

    // Based on user held keys, calculate the diff in movement

    if (controlKeys & Constants.Control.left) {
      dx -= Math.cos(this.moveYaw)
      dy += Math.sin(this.moveYaw)
    }

    if (controlKeys & Constants.Control.right) {
      dx += Math.cos(this.moveYaw)
      dy -= Math.sin(this.moveYaw)
    }

    if (controlKeys & Constants.Control.up) {
      dx += Math.sin(this.moveYaw)
      dy += Math.cos(this.moveYaw)
    }

    if (controlKeys & Constants.Control.down) {
      dx -= Math.sin(this.moveYaw)
      dy -= Math.cos(this.moveYaw)
    }

    return {
      dx: dx,
      dy: dy
    }

  },

  getConstantsTable() {
    return "Player"
  },

  getCollisionGroup() {
    return Constants.collisionGroup.Player
  },

  isLowStatus(stat) {
    let result = false

    switch(stat) {
      case "stamina":
        result = (this.stamina / this.getMaxStamina()) < 0.25
        break
      case "oxygen":
        let maxOxygen = this.getMaxOxygen()
        if (maxOxygen < 25) {
          result = (this.getOxygen() / this.getMaxOxygen()) < 0.75
        } else {
          result = (this.getOxygen() / this.getMaxOxygen()) < 0.25
        }
        break
      case "gold":
        break
      case "hunger":
        result = (this.hunger / this.getMaxHunger()) < 0.25
        break
      case "thirst":
        result = (this.thirst / this.getMaxThirst()) < 0.25
        break
    }

    return result
  },

  onGoldChanged() {

  },
  
  onThirstChanged() {

  }


}

module.exports = PlayerCommon

},{"./../constants.json":656,"./../helper":664,"./../util/protocol":686,"./../util/vec2":687}],662:[function(require,module,exports){
const RailTrackCommon = {
  hasTriangleRailNeighbors(container, row, col) {
    let left      = container.railMap.get(row    , col - 1) 
    let upLeft    = container.railMap.get(row - 1, col - 1) 
    let up        = container.railMap.get(row - 1, col    ) 
    let upRight   = container.railMap.get(row - 1, col + 1) 
    let right     = container.railMap.get(row    , col + 1) 
    let downRight = container.railMap.get(row + 1, col + 1) 
    let down      = container.railMap.get(row + 1, col    ) 
    let downLeft  = container.railMap.get(row + 1, col - 1) 

    return (left && upLeft && up)   ||
           (up && upRight && right) ||
           (right && downRight && down) ||
           (down && downLeft && left) 
  },

  hasInvalidRailStopNeighbor(container, row, col) {
    let left = container.structureMap.rowColHitTest(row, col - 1) 
    let right = container.structureMap.rowColHitTest(row, col + 1) 
    let up = container.structureMap.rowColHitTest(row - 1, col) 
    let down = container.structureMap.rowColHitTest(row + 1, col) 

    return this.isInvalidRailStopNeighborForTrack(left)  ||
           this.isInvalidRailStopNeighborForTrack(right) ||
           this.isInvalidRailStopNeighborForTrack(up)    ||
           this.isInvalidRailStopNeighborForTrack(down) 
  },

  isInvalidRailStopNeighborForTrack(hit) {
    if (hit.entity && hit.entity.hasCategory("rail_stop")) {
      let allowedRailStopNeighbors = hit.entity.getAllowedTrackNeighborHits()
      let isInAllowedPosition = allowedRailStopNeighbors.find((rowCol) => {
        return rowCol.row === hit.row && rowCol.col === hit.col 
      })
      return !isInAllowedPosition
    }
  }

}

module.exports = RailTrackCommon
},{}],663:[function(require,module,exports){
const Constants = require("./../constants.json")

const WaterPumpCommon = {
  getExtractor(centerX, centerY, angle) {
    let radian = angle * (Math.PI / 180)
    let tileDistanceFromHinge = 1
    let x = centerX + Math.floor(Math.sin(radian) * Constants.tileSize * tileDistanceFromHinge)
    let y = centerY - Math.floor(Math.cos(radian) * Constants.tileSize * tileDistanceFromHinge)
    let row = Math.floor(y / Constants.tileSize)
    let col = Math.floor(x / Constants.tileSize)

    return {
      row: row,
      col: col,
      x: x,
      y: y,
      w: this.getRotatedExtractorWidth(angle),
      h: this.getRotatedExtractorHeight(angle)
    }
  },

  getSquare(centerX, centerY, angle) {
    let radian = angle * (Math.PI / 180)
    let tileDistanceFromHinge = 0.5
    let x = centerX - Math.round(Math.sin(radian) * Constants.tileSize * tileDistanceFromHinge)
    let y = centerY + Math.round(Math.cos(radian) * Constants.tileSize * tileDistanceFromHinge)
    let row = Math.floor(y / Constants.tileSize)
    let col = Math.floor(x / Constants.tileSize)

    return {
      row: row,
      col: col,
      x: x,
      y: y,
      w: Constants.tileSize*2,
      h: Constants.tileSize*2
    }
  },

  getRotatedExtractorWidth(angle) {
    let radian = angle * (Math.PI / 180)
    let w = Constants.tileSize
    let h = Constants.tileSize*2
    return Math.round(Math.abs(Math.cos(radian)) * h + Math.abs(Math.sin(radian)) * w)
  },

  getRotatedExtractorHeight(angle) {
    let radian = angle * (Math.PI / 180)
    let w = Constants.tileSize
    let h = Constants.tileSize*2
    return Math.round(Math.abs(Math.cos(radian)) * w + Math.abs(Math.sin(radian)) * h)
  }

}

module.exports = WaterPumpCommon

},{"./../constants.json":656}],664:[function(require,module,exports){
const Protocol = require('./util/protocol')
const Constants = require('./constants')

module.exports = {
  MAX_PLAYERS_PER_SERVER: 50,
  MAX_PLAYERS_PER_GAME: 50,
  ENTITY_WALK_INTERACT_RANGE: 64,
  ENTITY_INTERACT_RANGE: 224,
  createES6Class(subKlass, name, methods) {
    methods = methods || {}

    let klass = class extends subKlass {
    }

    Object.defineProperty(klass, 'name', {value: name })

    if (typeof methods["static"] === "object") {
      Object.assign(klass, methods["static"])
    } 
    
    if (typeof methods["instance"] === "object") {
      Object.assign(klass.prototype, methods["instance"])
    }

    // so that it'll output nice in chrome console instead of showing "class extends"
    klass.toString = () => {
      return "class " + name + " {}"
    }

    return klass
  },
  getSocketRemoteAddress(socket) {
    let uint8Array = new Uint8Array(socket.getRemoteAddress())
    return [uint8Array[12], uint8Array[13], uint8Array[14], uint8Array[15]].join(".")
  },
  getRowColFromCoord(coord) {
    let rowCol = coord.split("-")
    rowCol[0] = parseInt(rowCol[0])
    rowCol[1] = parseInt(rowCol[1])
    return rowCol 
  },
  generateShuffledArrayIndex(array) {
    let list = Array.from(Array(array.length).keys())
    this.shuffleArray(list)
    return list
  },
  shuffleArray(array) {
    // https://stackoverflow.com/a/12646864
    for (var i = array.length - 1; i > 0; i--) {
      var j = Math.floor(Math.random() * (i + 1))
      var temp = array[i]
      array[i] = array[j]
      array[j] = temp
    }
  },
  createDynamicKlass(constantsNamespace, parentKlass, klassName) {
    return this.createES6Class(parentKlass, klassName, {
      static: {

      },
      instance: {
        getType() {
          return Protocol.definition().BuildingType[klassName]
        },
        getConstantsTable() {
          return constantsNamespace + "." + klassName
        }
      }
    })
  },
  isProtobufAttributeSet(data, attribute) {
    if (data.hasOwnProperty(attribute)) {
      if (data[attribute] instanceof Array) {
        return data[attribute].length > 0
      } else if (typeof data[attribute] === "object") {
        return Object.keys(data[attribute]).length > 0
      } else {
        return true
      }
    } else {
      return false
    }
  },
  batch(arr, len) {
    let batches = [],
        i = 0,
        n = arr.length;

    while (i < n) {
      batches.push(arr.slice(i, i += len))
    }

    return batches
  },
  capitalize(str) {
    return str.replace(/^\w/g, function(c) { return c.toUpperCase() })
  },
  capitalizeWords(str) {
    return str.split(' ')
              .map(function(w) { return w.charAt(0).toUpperCase() + w.substring(1) })
              .join(' ')
  },
  camelCase(str) {
    return str.replace(/(\_\w)/g, function(c) {
      return c[1].toUpperCase()
    })
  },
  camelToSnakeCase(str) {
    return str.replace(/[\w]([A-Z])/g, function(m) {
      return m[0] + "_" + m[1]
    }).toLowerCase()
  },
  getAttribute(o, s) {
    // https://stackoverflow.com/a/6491621
      var a = s.split('.')
      for (var i = 0, n = a.length; i < n; ++i) {
          var k = a[i]
          if (k in o) {
              o = o[k]
          } else {
              return
          }
      }
      return o
  },
  combineArrays(objValue, srcValue) {
    if (Array.isArray(objValue)) {
      return objValue.concat(srcValue)
    }
  },
  getChunkRowFromRow(row) {
    return Math.floor(row / Constants.chunkRowCount)
  },
  getChunkColFromCol(col) {
    return Math.floor(col / Constants.chunkColCount)
  },
  normalizeChunkRowCol(sector, rowOrCol) {
    const numOfChunksInRow = sector.getRowCount() / Constants.chunkRowCount
    let maxRowOrCol = numOfChunksInRow - 1

    if (rowOrCol < 0) return 0
    if (rowOrCol > maxRowOrCol) return maxRowOrCol

    return rowOrCol
  },
  getChunksFromBoundingBox(sector, boundingBox) {
    const chunkSize = Constants.chunkRowCount * Constants.tileSize

    let chunkStart = {
      row: this.normalizeChunkRowCol(sector, Math.floor(boundingBox.minY / chunkSize)),
      col: this.normalizeChunkRowCol(sector, Math.floor(boundingBox.minX / chunkSize))
    }

    let chunkEnd = {
      row: this.normalizeChunkRowCol(sector, Math.floor(boundingBox.maxY / chunkSize)),
      col: this.normalizeChunkRowCol(sector, Math.floor(boundingBox.maxX / chunkSize))
    }

    // chunkStart = { row: Math.floor(this.getY() / chunkSize), col: Math.floor(this.getX() / chunkSize) }
    // chunkEnd   = { row: Math.floor(this.getY() / chunkSize), col: Math.floor(this.getX() / chunkSize) }

    let chunks = {}

    for (var row = chunkStart.row; row <= chunkEnd.row; row++) {
      for (var col = chunkStart.col; col <= chunkEnd.col; col++) {
        let chunk = sector.getChunk(row, col)

        chunks[chunk.id] = chunk
      }
    }

    return chunks
  },
  isTargetWithinRange(entity, otherEntity) {
    const distance = this.distance(entity.getX(), entity.getY(), otherEntity.getX(), otherEntity.getY())
    return distance < this.ENTITY_INTERACT_RANGE
  },
  isTargetWithinWalkRange(entity, otherEntity) {
    const distance = this.distance(entity.getX(), entity.getY(), otherEntity.getX(), otherEntity.getY())
    return distance < this.ENTITY_WALK_INTERACT_RANGE
  },
  distance(x1, y1, x2, y2) {
    return Math.sqrt((x2 - x1) ** 2 + (y2 - y1) ** 2)
  },
  assetPath: (assetName) => {
    return "assets/" + assetName
  },
  pointFromDistance(x, y, distance, angle) {
    const xp = distance * Math.cos(angle)
    const yp = distance * Math.sin(angle)

    return [x + xp, y + yp]
  },
  angleDeltaSigned: (targetAngleInRad, sourceAngleInRad) => {
    // https://stackoverflow.com/questions/2708476/rotation-interpolation
    let endDeg   = targetAngleInRad * 180 / Math.PI
    let startDeg = sourceAngleInRad * 180 / Math.PI
    let shortestAngle = ((((endDeg - startDeg) % 360) + 540) % 360) - 180
    return shortestAngle * Math.PI / 180

    // const diff = (targetAngleInRad - sourceAngleInRad) * 180 / Math.PI
    // const angleInDeg = (diff + 180) % 360 - 180
    // return angleInDeg * Math.PI / 180
  },
  customMod: (a, n) => {
    // https://stackoverflow.com/a/7869457
    return a - Math.floor(a/n) * n
  },
  degToRad: (deg) => {
    return deg * Math.PI / 180
  },
  radToDeg: (rad) => {
    return rad * 180 / Math.PI 
  },
  swap: (json) => {
    var ret = {}
    for(var key in json){
      ret[json[key]] = key
    }
    return ret
  },
  ipToInt: (dot) => {
    var d = dot.split('.')
    return ((((((+d[0])*256)+(+d[1]))*256)+(+d[2]))*256)+(+d[3])
  },
  intToIp: (num) => {
    var d = num%256
    for (var i = 3; i > 0; i--)
    {
        num = Math.floor(num/256)
        d = num%256 + '.' + d
    }
    return d
  },
  stringifyTimeShort: (time) => {
    time = Math.round(time * 1000) / 1000

    var hours = parseInt( time / 3600 ) % 24
    var minutes = parseInt( time / 60 ) % 60
    var seconds = Math.floor(time % 60)
    var milliseconds = Math.floor(time * 1000) % 1000

    var result = ""
    var zeroPrependCheck = false

    if (hours !== 0) {
      result = result + hours
      zeroPrependCheck = true
      result += ":"
    }

    if (zeroPrependCheck) {
      result = result + (minutes < 10 ? "0" + minutes : minutes)
    } else {
      result = result + minutes
    }
    result += ":"

    zeroPrependCheck = true

    // if (seconds !== 0) {
    if (zeroPrependCheck) {
      result = result + (seconds < 10 ? "0" + seconds : seconds)
    } else {
      result = result + seconds
    }
    // }

    return result
  },
  getBuildingTypeByName(typeName) {
    return Protocol.definition().BuildingType[typeName]
  },
  getTypeNameById(id) {
    this.typeNamesById = this.typeNamesById || this.swapObject(Protocol.definition().BuildingType)
    return this.typeNamesById[id]
  },
  getNetworkNameById(id) {
    this.networkNamesById = this.networkNamesById || this.swapObject(Protocol.definition().NetworkType)
    return this.networkNamesById[id]
  },
  getResourceNameById(id) {
    this.resourceNamesById = this.resourceNamesById || this.swapObject(Protocol.definition().ResourceType)
    return this.resourceNamesById[id]
  },
  getProjectileNameById(id) {
    this.projectileNamesById = this.projectileNamesById || this.swapObject(Protocol.definition().ProjectileType)
    return this.projectileNamesById[id]
  },
  getTransportNameById(id) {
    this.transportNamesById = this.transportNamesById || this.swapObject(Protocol.definition().TransportType)
    return this.transportNamesById[id]
  },
  getMobNameById(id) {
    this.mobNameById = this.mobNameById || this.swapObject(Protocol.definition().MobType)
    return this.mobNameById[id]
  },
  getSoundNameById(id) {
    this.soundNameById = this.soundNameById || this.swapObject(Protocol.definition().SoundType)
    return this.soundNameById[id]
  },
  getTerrainNameById(id) {
    this.terrainNameById = this.terrainNameById || this.swapObject(Protocol.definition().TerrainType)
    return this.terrainNameById[id]
  },
  getEffectNameById(id) {
    this.effectNameById = this.effectNameById || this.swapObject(Protocol.definition().EffectType)
    return this.effectNameById[id]
  },
  getMobStatusNameById(id) {
    this.mobStatusNameById = this.mobStatusNameById || this.swapObject(Protocol.definition().MobStatus)
    return this.mobStatusNameById[id]
  },
  getBehaviorNameById(id) {
    this.behaviorNameById = this.behaviorNameById || this.swapObject(Protocol.definition().BehaviorType)
    return this.behaviorNameById[id]
  },
  roughSizeOfObject(object) {
    var objectSet = new WeakSet();
    var stack = [ object ];
    var bytes = 0;

    while ( stack.length ) {
        var value = stack.pop();

        if ( typeof value === 'boolean' ) {
            bytes += 4;
        }
        else if ( typeof value === 'string' ) {
            bytes += value.length * 2;
        }
        else if ( typeof value === 'number' ) {
            bytes += 8;
        }
        else if
        (
            typeof value === 'object'
            && value !== null 
            && !objectSet.has(value)
        )
        {
            objectSet.add(value);

            for( var i in value ) {
                let attribute = value[i];
                let attributeType = typeof attribute;
                if (['boolean', 'string', 'number', 'object'].indexOf(attributeType) !== -1) {
                    stack.push(attribute);
                }
            }
        }
    }
    return bytes;
  },
  swapObject(json) {
    var ret = {};
    for(var key in json){
      ret[json[key]] = key
    }
    return ret
  },

  // https://github.com/davidfig/intersects/blob/master/box-point.js
  /**
   * box-point collision
   * @param {number} x1 top-left corner of box
   * @param {number} y1 top-left corner of box
   * @param {number} w1 width of box
   * @param {number} h1 height of box
   * @param {number} x2 of point
   * @param {number} y2 of point
   * @return {boolean}
   */
  testBoxPoint(x1, y1, w1, h1, x2, y2) {
    return x2 >= x1 && x2 <= x1 + w1 && y2 >= y1 && y2 <= y1 + h1
  },

  testOverlap(circle, entity) {
    if (entity.isBuilding()) {
      let box = entity.getRelativeBox()
      return this.testBoxCircle(box.pos.x, box.pos.y, box.w, box.h, circle.x, circle.y, circle.radius)
    } else {
      return this.testCircleCircle(circle, entity.getCircle())
    } 
  },

  testCircleCircle(circle, otherCircle) {
    let a = circle.radius + otherCircle.radius
    let x = circle.x - otherCircle.x
    let y = circle.y - otherCircle.y

    return a > Math.sqrt((x * x) + (y * y))
  },

  // https://github.com/davidfig/intersects/blob/master/box-circle.js
  /**
   * box-circle collision
   * @param {number} xb top-left corner of box
   * @param {number} yb top-left corner of box
   * @param {number} wb width of box
   * @param {number} hb height of box
   * @param {number} xc center of circle
   * @param {number} yc center of circle
   * @param {number} rc radius of circle
   */
  testBoxCircle(xb, yb, wb, hb, xc, yc, rc) {
    var hw = wb / 2
    var hh = hb / 2
    var distX = Math.abs(xc - (xb + wb / 2))
    var distY = Math.abs(yc - (yb + hb / 2))

    if (distX > hw + rc || distY > hh + rc)
    {
        return false
    }

    if (distX <= hw || distY <= hh)
    {
        return true
    }

    var x = distX - hw
    var y = distY - hh
    return x * x + y * y <= rc * rc
  },

  randomIndexList(array) {
    let indexArray = Array.apply(0, new Array(array.length)).map((_,i) => { 
      return i
    })

    this.shuffleArray(indexArray)

    return indexArray
  },

  // https://gist.github.com/ryanmcgrath/982242
  isJapaneseText(text) {
    const regex = /[\u3000-\u303F]|[\u3040-\u309F]|[\u30A0-\u30FF]|[\uFF00-\uFFEF]|[\u4E00-\u9FAF]|[\u2605-\u2606]|[\u2190-\u2195]|\u203B/g 
    return regex.test(text)
  },

  /**
   * https://stackoverflow.com/a/12646864
   *
   * Randomize array element order in-place.
   * Using Durstenfeld shuffle algorithm.
   */
  shuffleArray(array) {
      for (var i = array.length - 1; i > 0; i--) {
          var j = Math.floor(Math.random() * (i + 1))
          var temp = array[i]
          array[i] = array[j]
          array[j] = temp
      }
  },

  isHashEmpty(obj) {
    for (let prop in obj) {
      if(obj.hasOwnProperty(prop)) {
        return false
      }
    }

    return true
  }

}

},{"./constants":656,"./util/protocol":686}],665:[function(require,module,exports){
const BoundingBox = () => {
}

BoundingBox.prototype = {
  getX() {
    throw new Error("must implement BoundingBox#getX")
  },

  getY() {
    throw new Error("must implement BoundingBox#getY")
  },

  getBoxWithRadius(radius) {
    return this.getBox(this.getX(), this.getY(), radius * 2, radius * 2)
  },

  getBox(x = this.getX(), y = this.getY(), w = this.getWidth(), h = this.getHeight()) {
    return {
      pos: {
        x: x - w/2,
        y: y - h/2,
      },
      w: w,
      h: h
    }
  },

  getNeighborBoundingBox(padding = 100) {
    return {
      minX: this.minX - padding,
      minY: this.minY - padding,
      maxX: this.maxX + padding,
      maxY: this.maxY + padding
    }

  },

  getBoundingBox() {
    return {
      minX: this.minX,
      minY: this.minY,
      maxX: this.maxX,
      maxY: this.maxY
    }
  },

  updateRbushCoords() {
    var box = this.getBox(this.getX(), this.getY())

    this.minX = box.pos.x,
    this.minY = box.pos.y,
    this.maxX = box.pos.x + box.w,
    this.maxY = box.pos.y + box.h
  }

}

module.exports = BoundingBox

},{}],666:[function(require,module,exports){
const Constants = require("./../constants.json")

const Categorizable = () => {
}

Categorizable.prototype = {

  isBottleFillable() {
    return !!this.getConstants().isBottleFillable
  },

  hasCategory(category) {
    let result = false

    let constants = this.getConstants()

    let constantsTag = Constants.CategoryClassifiers[category]
    if (constantsTag) {
      return !!constants.stats && constants.stats[constantsTag]
    } else {
      return constants.categories &&
             constants.categories[category] 
    }
  }

}

module.exports = Categorizable

},{"./../constants.json":656}],667:[function(require,module,exports){
// tightly coupled to BaseBuilding

const Tilable = require("./tilable")

const Conductor = () => {
}

Conductor.prototype = {
  canConduct(hit) {
    throw new Error("must implement Conductor#canConduct")
  },

  layoutConduits() {
    let hits = this.getCoreHits()
    hits.forEach((hit) => {
      let sides = this.getSidesWithConduit(hit.row, hit.col)
      let sprite = this.getConduitSprite(hit.row, hit.col)

      if (Object.keys(sides).length > 0) {
        sprite.visible = true
        this.layoutTile(sides, sprite)
      } else {
        sprite.visible = false
      }
    })
  },

  getConduitMap() {
    throw new Error("must implement Conductor#getConduitMap")
  },

  getSidesWithConduit(row, col) {
    let result = {}
    let sideHits = this.getRowColSideHitsFor(this.getConduitMap(), row, col)

    for (let direction in sideHits) {
      let hit = sideHits[direction]
      if (this.canConduct(hit)) {
        result[direction] = true
      }
    }

    return result
  }

}

Object.assign(Conductor.prototype, Tilable.prototype, {

})



module.exports = Conductor
},{"./tilable":680}],668:[function(require,module,exports){
const Constants = require("../constants.json")
const vec2 = require("./../util/vec2")
const Grid = require("./../entities/grid")

const Container = () => {
}

Container.prototype = {
  initGrids() {
    this.regions = {}
    this.platforms = {}
    this.platformMap = new Grid("platform", this, this.getRowCount(), this.getColCount())

    this.distributions = {}
    this.distributionMap = new Grid("distribution", this, this.getRowCount(), this.getColCount())
    this.liquidDistributionMap = new Grid("liquidDistribution", this, this.getRowCount(), this.getColCount())
    this.gasDistributionMap    = new Grid("gasDistribution", this, this.getRowCount(), this.getColCount())
    this.fuelDistributionMap   = new Grid("fuelDistribution", this, this.getRowCount(), this.getColCount())

    this.armors = {}
    this.armorMap = new Grid("wall", this, this.getRowCount(), this.getColCount())

    this.structures = {}
    this.structureMap = new Grid("structure", this, this.getRowCount(), this.getColCount())

    this.railMap = new Grid("rail", this, this.getRowCount(), this.getColCount())

    this.rooms = {}
    this.roomTileMap = new Grid("room", this, this.getRowCount(), this.getColCount())

    this.units = {}
    this.unitMap = new Grid("unit", this, this.getRowCount(), this.getColCount())

    this.towers = {}
    this.flames = {}
    this.crops = {}
    this.processors = {}
    this.pickups = {}
    this.paths = {}
    this.breakings = {}
    this.corpses = {}
  },

  removeBuildings(box) {
    [this.platformMap, this.armorMap, this.structureMap, this.distributionMap, this.liquidDistributionMap, this.fuelDistributionMap, this.gasDistributionMap].forEach((map) => {
      let hits = map.hitTestTile(box)
      hits.forEach((hit) => {
        if (hit.entity) {
          hit.entity.remove()
        }
      })
    })
  },

  addBreaking(entity) {
    this.breakings[entity.id] = entity
  },

  removeBreaking(entity) {
    delete this.breakings[entity.id] 
  },

  getCollidableGrids() {
    throw new Error("must implement Container#getCollidableGrids")
  },

  getRaycastObstacles(sourceX, sourceY, targetX, targetY, maxLength, entityToIgnore) {
    let obstacles = []

    this.getCollidableGrids().forEach((grid) => {
      let raycasts = grid.raycast(sourceX, sourceY, targetX, targetY, maxLength, entityToIgnore)
      let blockingRaycasts = raycasts.filter((raycast) => {
        if (raycast.entity.isBuilding()) {
          return raycast.entity.isPathFindBlocker()
        } else {
          return true
        }
      })
      obstacles = obstacles.concat(blockingRaycasts)
    })

    return obstacles
  },

  raycast(sourceX, sourceY, targetX, targetY, maxLength, entityToIgnore) {
    let obstacles = this.getRaycastObstacles(sourceX, sourceY, targetX, targetY, maxLength, entityToIgnore)

    let nearestObstacle = null
    let nearestDistance = 100000 // very high num
    obstacles.forEach((obstacle) => {
      if (obstacle.distance < nearestDistance) {
        nearestDistance = obstacle.distance
        nearestObstacle = obstacle
      }
    })

    return nearestObstacle
  },

  removeExisting(map, box) {
    let hits = map.hitTestTile(box)
    hits.forEach((hit) => {
      if (hit.entity) hit.entity.remove()
    })
  },

  testBoxPoint(x1, y1, w1, h1, x2, y2) {
    return x2 >= x1 && x2 <= x1 + w1 && y2 >= y1 && y2 <= y1 + h1
  },

  addCrop(entity) {
    this.crops[entity.id] = entity
  },

  addProcessor(entity) {
    this.processors[entity.id] = entity
  },

  removeProcessor(entity) {
    delete this.processors[entity.id]
  },

  registerComponent(collectionName, mapName, entity) {
    const box = entity.getRelativeBox()
    this.removeExisting(this[mapName], box)

    this[mapName].register(box, entity)
    this[collectionName][entity.id] = entity

    this.onComponentAdded(entity)
  },

  unregisterComponent(collectionName, mapName, entity) {
    this[mapName].unregister(entity.getRelativeBox())
    delete this[collectionName][entity.id]

    if (entity.hasOwner()) {
      entity.getOwner().unregisterOwnership(collectionName, entity)
    }

    this.onComponentRemoved(entity)
  },

  onComponentAdded(entity) {
    // callback
  },

  onComponentRemoved(entity) {
    // callback
  },

  addPickup(pickup) {
    this.pickups[pickup.id] = pickup
  },

  removePickup(pickup) {
    delete this.pickups[pickup.id]
  },

  getPathFindableGrids() {
    return [this.structureMap, this.armorMap, this.platformMap]
  },

  getPathFindingGrid() {
    let grids = this.getPathFindableGrids().map((grid) => {
      return grid.getNumberGrid()
    })

    let rowCount = this.getRowCount()
    let colCount = this.getColCount()

    let grid = []

    for (let row = 0; row < rowCount; row++) {
      let rowGrid = []

      for (let col = 0; col < colCount; col++) {
        let tileType = grids[grids.length - 1][row][col] // default to last grid unless layer above exist

        for (var i = 0; i < grids.length; i++) {
          let grid = grids[i]
          tileType = grid[row][col]
          if (tileType) {
            break
          }
        }

        rowGrid.push(tileType)
      }

      grid.push(rowGrid)
    }

    return grid
  },

  getGridCoord(x, y) {
    const gridTopLeft = this.getGridRulerTopLeft()
    const relativeX = x - gridTopLeft.x
    const relativeY = y - gridTopLeft.y

    return {
      x: relativeX,
      y: relativeY
    }
  },


  getGridWidth() {
    return this.getColCount() * Constants.tileSize
  },

  getGridHeight() {
    return this.getRowCount() * Constants.tileSize
  },

  getGridRulerTopLeft() {
    const gridTopLeft  = {
      x: this.getX() - this.getGridWidth() / 2,
      y: this.getY() - this.getGridHeight() / 2
    }

    return gridTopLeft
  },

  getSnappedPosX(x, width) {
    const gridTopLeft = this.getGridRulerTopLeft()
    const objectSize = width
    const offset = ((objectSize / Constants.tileSize) - 1) * (Constants.tileSize / 2)

    const relativeMouseX = x - gridTopLeft.x
    const col = Math.floor((relativeMouseX + offset) / Constants.tileSize)
    const relativeX = col * Constants.tileSize + (Constants.tileSize / 2) - offset

    return relativeX
  },

  getSnappedPosY(y, height) {
    const gridTopLeft = this.getGridRulerTopLeft()
    const objectSize = height
    const offset = ((objectSize / Constants.tileSize) - 1) * (Constants.tileSize / 2)

    const relativeMouseY = y - gridTopLeft.y
    const row = Math.floor((relativeMouseY + offset) / Constants.tileSize)
    const relativeY = row * Constants.tileSize + (Constants.tileSize / 2) - offset

    return relativeY
  },

  isOutOfBounds(row, col) {
    return row < 0 || row >= this.getRowCount() ||
           col < 0 || col >= this.getColCount()
  }


}

module.exports = Container



},{"../constants.json":656,"./../entities/grid":659,"./../util/vec2":687}],669:[function(require,module,exports){
const mergeWith = require("lodash/mergeWith")
const Constants = require("./../constants")
const Helper = require("./../helper")

let FlatConstants = JSON.parse(JSON.stringify(Constants))

let groups = ["Terrains", "Buildings", "Crops", "Equipments", "Mobs", 
              "Projectiles", "Bars", "Ores", "Ammos", "Drinks", "Foods", "Walls", "Floors", "Effects", "Transports"]

groups.forEach((group) => {
  for (let key in FlatConstants[group]) {
    if (FlatConstants[group][key].parent) {
      FlatConstants[group][key] = buildConstants(FlatConstants[group][key])
    }

    FlatConstants[group + "." + key] = FlatConstants[group][key]
  }
})

function buildConstants(table) {
  if (table.parent) {
    let parentTable = buildConstants(Helper.getAttribute(Constants, table.parent))
    let combinedTable = mergeWith({}, parentTable, table, Helper.combineArrays)
    if (!table["abstract"]) {
      // dont inherit abstract field
      delete combinedTable["abstract"]
    }
    return combinedTable
  } else {
    return table
  }
}

const Definable = () => {
}

Definable.prototype = {
  getConstants() {
    let constantsTable = this.getConstantsTable()
    if (constantsTable) {
      return FlatConstants[constantsTable]
    } else {
      return {}
    }
  },

  getConstantsTable() {
    return null // none by default
  }
}

module.exports = Definable


},{"./../constants":656,"./../helper":664,"lodash/mergeWith":153}],670:[function(require,module,exports){
const EventBus = require('eventbusjs')

const Destroyable = () => {
}

Destroyable.prototype = {
  initDestroyable(initialHealth) {
    this.health = initialHealth || this.getMaxHealth()
  },

  getMaxHealth() {
    return 10    
  },

  getHealth() {
    return this.health
  },

  isHealthFull() {
    return this.health === this.getMaxHealth()
  },

  isDestroyed() {
    return this.health === 0
  },

  isDestroyable() {
    return true
  },

  damage(amount, attacker, attackEntity) {
    if (isNaN(amount)) {
      throw new Error("damage amount " + amount + " is invalid")
    }

    if (!attackEntity) {
      attackEntity = attacker
    }

    amount = Math.max(1, amount - this.getDamageResistance(amount, attackEntity))
    amount = parseInt(amount)

    const prevHealth = this.health 
    
    this.onDamaged(attacker, amount)
    this.setHealth(this.health - amount)
  },

  reduceHealth(amount = 1) {
    this.setHealth(this.health - amount)
  },

  getDamageResistance(amount, attackEntity) {
    return 0
  },

  setHealth(newHealth) {
    const prevHealth = this.health

    if (newHealth < 0) { 
      newHealth = 0;
    } else if (newHealth > this.getMaxHealth()) { 
      newHealth = this.getMaxHealth()
    }

    const delta = newHealth - prevHealth
    this.health = newHealth

    if (isNaN(delta)) {
      throw new Error("delta is not a number. prevHealth: " + prevHealth + " newHealth: " + newHealth)
    }

    if (delta < 0) {
      this.onHealthReduced(delta)

      if (this.health === 0 && prevHealth !== 0) {
        EventBus.dispatch(this.game.getId() + ":entity:destroyed", this)
        this.onHealthZero()
      }
      
      this.onPostSetHealth(delta)
    } else if (delta > 0) {
      this.onHealthIncreased(delta)

      this.onPostSetHealth(delta)
    } else if (this.health === 0 && prevHealth !== 0) {
      EventBus.dispatch(this.game.getId() + ":entity:destroyed", this)
      this.onHealthZero()
    }
  },

  onDamaged(attacker) {}, // callback for actual physic damage as opposed to generic one
  onPostSetHealth() {},
  onHealthReduced(delta) {},
  onHealthIncreased(delta) {},
  onHealthZero() {}

}

module.exports = Destroyable


},{"eventbusjs":43}],671:[function(require,module,exports){
function Drainable(usage, capacity, entity, resource) {
  this.entity = entity
  this.initDrainable(usage)
  this.initCapacity(capacity)
  this.resource = resource
}

Drainable.prototype = {
  initDrainable(initialUsage) {
    this.setContent(null)
    this.usage = initialUsage || 0
    this.prevUsage = null
  },

  initCapacity(capacity) {
    this.capacity = capacity
  },

  getUsage() {
    return this.usage
  },

  isFull() {
    return this.getUsage() >= this.getUsageCapacity()
  },

  isEmpty() {
    return this.getUsage() <= 0
  },

  isDepleted() {
    return this.getUsage() <= 0
  },

  checkUsage() {
    if (isNaN(this.usage)) {
      this.usage = 0
    }

    if (this.usage < 0) this.usage = 0
    if (this.usage > this.getUsageCapacity()) this.usage = this.getUsageCapacity()

    if (this.usage === 0) {
      if (this.shouldSetEmptyContentOnZeroUsage()) {
        this.setContent(null)
      }
    }

    if (this.usage !== this.prevUsage) {
      this.onUsageChanged(this.resource, this.usage)
    }

    this.prevUsage = null
  },

  shouldSetEmptyContentOnZeroUsage() {
    return true
  },

  setUsage(usage) {
    if (isNaN(usage)) return
      
    const prevUsage = this.usage 

    if (usage < 0) usage = 0
    if (usage > this.getUsageCapacity()) usage = this.getUsageCapacity()

    this.usage = usage

    if (this.usage === 0) {
      if (this.shouldSetEmptyContentOnZeroUsage()) {
        this.setContent(null)
      }
    }

    if (this.usage !== prevUsage || this.usage === 0) {
      this.onUsageChanged(this.resource, this.usage)
    }
  },

  setContent(content) {
    if (this.content !== content) {
      this.content = content
      this.onContentChanged()
    }
  },

  isDrainable() {
    return true
  },

  getContent() {
    return this.content
  },

  drainDelayed(amount) {
    let amountDrained = this.usage < amount ? this.usage : amount

    if (this.prevUsage === null) {
      this.prevUsage = this.usage
    }
    
    this.usage = this.usage - amount

    this.onDrainableDelayed()

    return amountDrained
  },

  drain(amount) {
    let amountDrained = this.usage < amount ? this.usage : amount
    
    this.setUsage(this.usage - amount)

    return amountDrained
  },

  fillDelayed(content, amount) {
    this.setContent(content)

    if (this.prevUsage === null) {
      this.prevUsage = this.usage
    }

    let excess = (this.usage + amount - this.getUsageCapacity())
    if (excess < 0) excess = 0
      
    this.usage = this.usage + amount

    this.onDrainableDelayed()

    return excess
  },

  fill(content, amount) {
    this.setContent(content)

    let excess = (this.usage + amount - this.getUsageCapacity())
    if (excess < 0) excess = 0
      
    this.setUsage(this.usage + amount)

    return excess
  },

  setUsageChangedListener(listener) {
    this.usageChangeListener = listener
  },

  setDrainableDelayedListener(listener) {
    this.drainableDelayedListener = listener
  },

  onUsageChanged(resource, usage) {
    if (this.usageChangeListener) {
      this.usageChangeListener.onUsageChanged(resource, usage)
    }
  },

  onDrainableDelayed() {
    if (this.drainableDelayedListener) {
      this.drainableDelayedListener.onDrainableDelayed()
    }
  },

  onContentChanged() {

  },

  getUsageCapacity() {
    if (this.capacity) return this.capacity
      
    throw new Error("must implement Drainable#getUsageCapacity")
  }

}

module.exports = Drainable
},{}],672:[function(require,module,exports){
const Constants = require("./../constants")
const Protocol = require("./../util/protocol")

const Equipper = () => {
}

Equipper.prototype = {
  initEquipper() {
    this.equipments = {}
  },
  getDefaultSpriteColor() {
    throw new Error("must implement Equipper#getDefaultSpriteColor")
  },
  getBodySpriteTint() {
    return 0xd2b48c
  },
  getSingleHandPosition() {
    return 20
  },
  getEquipperBodySpritePath() {
    return "player_body.png"
  },
  setDefaultTint(sprite, tint) {
    sprite.defaultTint = tint
    sprite.tint = tint
  },
  getTintableSprites() {
    let sprites = [this.body, this.hands]

    let armorEquipment = this.getArmorEquipment()
    if (armorEquipment) {
      sprites.push(armorEquipment.sprite)
    }

    return sprites
  },
  getCharacterSprite() {
    const sprite = new PIXI.Container()
    sprite.name = "Character"
    sprite.pivot.x = this.getDisplayWidth() / 2
    sprite.pivot.y = this.getDisplayWidth() / 2

    this.handContainer = new PIXI.Container()
    /*       
      pivot is at top-left by default. rotating around there.
      we have left  hand at upper y, we have right hand at lower y
      must rotate around middle of y, and maintain left edge x
    */
    this.handContainer.pivot.y = 20
    // pivot change above will also shift the sprite up, so compensate by moving sprite position down
    this.handContainer.position.y = 20
    // move the hands forward so it can be more visible
    this.handContainer.position.x = 15
    this.handContainer.name = "HandContainer"

    // body
    this.body   = new PIXI.Sprite(PIXI.utils.TextureCache[this.getEquipperBodySpritePath()])
    this.body.name = "Body"
    this.body.width = this.getBodyWidth()
    this.body.height = this.getBodyHeight()
    this.body.position.x = this.getBodyPositionX()
    this.body.position.y = this.getBodyPositionY()

    // both hands
    this.hands  = new PIXI.Sprite(PIXI.utils.TextureCache["player_hands.png"])
    this.hands.name = "Hands"
    this.hands.width = this.hands.height = this.getDisplayWidth()

    // left hand
    this.leftHand  = new PIXI.Sprite(PIXI.utils.TextureCache["player_hands_single.png"])
    this.leftHand.name = "LeftHand"
    this.leftHand.alpha = 0
    this.leftHand.width = this.leftHand.height = Constants.tileSize/2
    this.leftHand.position.x = this.getSingleHandPosition()

    // right hand
    this.rightHand  = new PIXI.Sprite(PIXI.utils.TextureCache["player_hands_single.png"])
    this.rightHand.name = "RightHand"
    this.rightHand.alpha = 0
    this.rightHand.width = this.rightHand.height = Constants.tileSize/2
    this.rightHand.position.x = this.getSingleHandPosition()
    this.rightHand.position.y = 24

    // tint
    this.setDefaultTint(this.hands, this.getDefaultSpriteColor())
    this.setDefaultTint(this.leftHand, this.getDefaultSpriteColor())
    this.setDefaultTint(this.rightHand, this.getDefaultSpriteColor())
    this.setDefaultTint(this.body, this.getBodySpriteTint())

    // equipments
    this.handEquipContainer = new PIXI.Container()
    this.handEquipContainer.name = "HandEquipment"
    this.handEquipContainer.position.x = -15

    this.armorEquipContainer = new PIXI.Container()
    this.armorEquipContainer.name = "ArmorEquipment"

    this.handContainer.addChild(this.handEquipContainer)
    this.handContainer.addChild(this.hands)
    this.handContainer.addChild(this.leftHand)
    this.handContainer.addChild(this.rightHand)

    sprite.addChild(this.handContainer)
    sprite.addChild(this.body)
    sprite.addChild(this.armorEquipContainer)

    return sprite
  },

  onAttackStateChanged() {
    if (this.isAttacking) {
      // start attacking
      const handEquipment = this.equipments[Protocol.definition().EquipmentRole.Hand]
      if (handEquipment ) {
        if (handEquipment.isAnimatable()) {
          this.animateHands(handEquipment)
        }
      } else {
        this.animateHands() // bare hands
      }
    } else {
    }
  },

  animateEquipment() {
    const handEquipment = this.getHandEquipment()
    if (handEquipment && handEquipment.isAnimatable()) {
      handEquipment.animate()
      handEquipment.playSound()
    } else {
      this.animateHands()
    }
  },

  stopEquipmentAnimation() {
    const handEquipment = this.getHandEquipment()
    if (handEquipment && handEquipment.isAnimatable()) {
      handEquipment.stopAnimation()
    } else {
      if (this.handAnimationTween) {
        this.handAnimationTween.stop()
        this.handAnimationTween = null
      }
    }
  },

  animateHands(handEquipment) {
    this.handAnimationTween = this.getPunchAnimationTween()
    this.handAnimationTween.start()
  },

  hideLeftRightHands() {
    this.leftHand.alpha = 0
    this.rightHand.alpha = 0

    this.hands.alpha = 1
  },

  resetHands() {
    this.leftHand.position.x = this.getSingleHandPosition()
    this.leftHand.position.y = 0
    this.rightHand.position.x = this.getSingleHandPosition()
    this.rightHand.position.y = 24
  },

  getPunchAnimationTween() {
    this.hands.alpha = 0
    this.leftHand.alpha = 1
    this.rightHand.alpha = 1

    let hand = Math.random() < 0.5 ? this.leftHand : this.rightHand

    let orig = { x: hand.position.x, y: hand.position.y }
    let position = { x: orig.x, y: orig.y }
    let target = { x: orig.x + Constants.tileSize, y: 12 }

    const tween = new TWEEN.Tween(position)
        .to(target, 200)
        .onUpdate(() => {
          hand.position.x = position.x
          hand.position.y = position.y
        })
        .onComplete(() => {
          this.resetHands()

          if (this.hideLeftRightTimeout) {
            clearTimeout(this.hideLeftRightTimeout)  
          }
          this.hideLeftRightTimeout = setTimeout(this.hideLeftRightHands.bind(this), 1000)
        })

    return tween
  },

  getArmorEquip() {
    return this.getArmorEquipment()
  },

  getArmorEquipment() {
    return this.equipments[Protocol.definition().EquipmentRole.Armor]
  },

  setArmorEquipment(equipment) {
    this.equipments[Protocol.definition().EquipmentRole.Armor] = equipment
  },

  getHandEquipment() {
    return this.equipments[Protocol.definition().EquipmentRole.Hand]
  },

  setHandEquipment(equipment) {
    this.equipments[Protocol.definition().EquipmentRole.Hand] = equipment
  },

  removeEquipments() {
    for (let index in this.equipments) {
      let equipment = this.equipments[index]
      equipment.remove()
      delete this.equipments[index]
    }
  },

  getBodyWidth() {
    return this.getDisplayWidth()
  },

  getBodyHeight() {
    return this.getDisplayWidth()
  },

  getBodyPositionX() {
    return 0
  },

  getBodyPositionY() {
    return 0
  }

}

module.exports = Equipper


},{"./../constants":656,"./../util/protocol":686}],673:[function(require,module,exports){
const Faithable = () => {
}

Faithable.prototype = {
  initFaithable(faith) {
    this.faith = faith || 0
  },

  setFaith(faith) {
    const prevFaith = this.faith

    if (faith > this.getMaxFaith()) {
      this.faith = this.getMaxFaith()
    } else if (faith < 0) {
      this.faith = 0
    } else {
      this.faith = faith
    }

    const delta = faith - prevFaith

    if (this.faith !== prevFaith) {
      if (delta < 0) {
        this.onFaithReduced() 
      } else if (delta > 0) {
        this.onFaithIncreased()
      }
      this.onFaithChanged()
    }
  },

  getMaxFaith() {
    return 100
  },

  onFaithChanged() {},
  onFaithIncreased() {},
  onFaithReduced() {}
}

module.exports = Faithable


},{}],674:[function(require,module,exports){
const Constants = require("./../constants.json")
const Protocol = require('./../util/protocol')

const Needs = () => {
}

Needs.prototype = {
  initNeeds() {
    this.hunger = this.getMaxHunger()
    this.oxygen = this.getMaxOxygen()
    this.stamina = this.getMaxStamina()
    this.happiness = this.getMaxHappiness()
  },
  setStamina(stamina) {
    let prevStamina = this.stamina

    if (stamina > this.getMaxStamina()) {
      this.stamina = this.getMaxStamina()
    } else if (stamina < 0) {
      this.stamina = 0
    } else {
      this.stamina = stamina
    }

    if (prevStamina !== this.stamina) {
      this.onStaminaChanged(this.stamina - prevStamina)
    }
  },
  setHunger(hunger) {
    let prevHunger = this.hunger

    if (hunger > this.getMaxHunger()) {
      this.hunger = this.getMaxHunger()
    } else if (hunger < 0) {
      this.hunger = 0
    } else {
      this.hunger = hunger
    }

    if (prevHunger !== this.hunger) {
      this.onHungerChanged(this.hunger - prevHunger)
    }

    if (this.hunger === 0) {
      this.onHungerZero()
    }
  },
  setHappiness(happiness) {
    let prevHappiness = this.happiness

    if (happiness > this.getMaxHappiness()) {
      this.happiness = this.getMaxHappiness()
    } else if (happiness < 0) {
      this.happiness = 0
    } else {
      this.happiness = happiness
    }

    if (prevHappiness !== this.happiness) {
      this.onHappinessChanged()
    }
  },
  setOxygen(oxygen) {
    let prevOxygen = this.oxygen

    if (oxygen > this.getMaxOxygen()) {
      this.oxygen = this.getMaxOxygen()
    } else if (oxygen < 0) {
      this.oxygen = 0
    } else {
      this.oxygen = oxygen
    }

    if (prevOxygen !== this.oxygen) {
      this.onOxygenChanged(this.oxygen - prevOxygen)
    }
  },
  onHungerChanged(delta) {

  },

  onOxygenChanged(delta) {

  },

  onStaminaChanged(delta) {

  },

  onHappinessChanged() {

  },

  getMaxStamina() {
    return Constants.Player.stamina
  },
  getMaxHappiness() {
    return Constants.Player.happiness
  },
  getMaxOxygen() {
    return Constants.Player.oxygen
  },
  getMaxHunger() {
    return Constants.Player.hunger
  },
  wakeup() {
    this.setSleepState(false) 
  },
  sleep() {
    this.setSleepState(true) 
  },
  setSleepState(isSleeping) {
    if (this.isSleeping !== isSleeping) {
      this.isSleeping = isSleeping
      this.onSleepStateChanged()
    }
  },
  onSleepStateChanged(){

  },
  onHungerZero() {
    
  }
}

module.exports = Needs

},{"./../constants.json":656,"./../util/protocol":686}],675:[function(require,module,exports){
const Poolable = () => {
}

Poolable.prototype = {
  reset() {
    throw new Error("must implement reset")
  }
}

module.exports = Poolable

},{}],676:[function(require,module,exports){
const Powerable = () => {
}

Powerable.prototype = {
  setPowerStatus(isPowered) {
    if (this.isPowered !== isPowered) {
      this.isPowered = isPowered
      this.onPowerChanged()
    }
  },

  onPowerChanged() {

  }

}

module.exports = Powerable

},{}],677:[function(require,module,exports){
const Resource = () => {
}

Resource.prototype = {
  getResourceConsumption(name) {
    let field = name + "Consumption"
    return this.getStats(this.level)[field]
  },

  getResourceCapacity(name) {
    let field = name + "Capacity"
    return this.getStats(this.level)[field]
  },

  getResourceProduction(name) {
    let field = name + "Production"
    return this.getStats(this.level)[field]
  }
}

module.exports = Resource

},{}],678:[function(require,module,exports){
const Constants = require("../constants.json")
const vec2 = require("./../util/vec2")

const ShipMountable = () => {
}

ShipMountable.prototype = {
  becomePilot(ship) {
    this.isPilot = true
    this.ship = ship
  },
  unmountPilot() {
    this.isPilot = false
    this.ship = null
  },

  // https://math.stackexchange.com/questions/270194/how-to-find-the-vertices-angle-after-rotation
  getAbsoluteXOnContainer() {
    const x     = this.getContainer().getGridRulerTopLeft().x + this.getRelativeX()
    const y     = this.getContainer().getGridRulerTopLeft().y + this.getRelativeY()
    const p     = this.getContainer().getX()
    const q     = this.getContainer().getY()
    const radian = this.getContainer().getRadAngle()
    const rotatedX = (x-p) * Math.cos(radian) - (y-q) * Math.sin(radian) + p

    return rotatedX
  },

  getAbsoluteYOnContainer() {
    const x     = this.getContainer().getGridRulerTopLeft().x + this.getRelativeX()
    const y     = this.getContainer().getGridRulerTopLeft().y + this.getRelativeY()
    const p     = this.getContainer().getX()
    const q     = this.getContainer().getY()
    const radian = this.getContainer().getRadAngle()
    const rotatedY = (x-p) * Math.sin(radian) + (y-q) * Math.cos(radian) + q

    return rotatedY
  },

  getRelativeX() {
    throw new Error("Must implement ShipMountable#getRelativeX")
  },

  getRelativeY() {
    throw new Error("Must implement ShipMountable#getRelativeY")
  }
}

module.exports = ShipMountable



},{"../constants.json":656,"./../util/vec2":687}],679:[function(require,module,exports){
const Protocol = require('../util/protocol')
const Helper   = require('../helper')

// tiedly coupled to pressureNetwork..
const Taintable = () => {
}

Taintable.prototype = {
  initTaintable(options) {
  },

  getMaxEffectLevel() {
    return 4
  },

  getEffectsJson() {
    return this.effects
  },

  clean() {
    for (let effect in this.effects) {
      let value = this.effects[effect]
      if (value > 0) {
        this.setEffectLevel(effect, value - 1)
        break
      }
    }
  },

  getTotalEffectValue() {
    if (typeof this.effects === "undefined") return 0

    return Object.values(this.effects).reduce((sum, value) => { return sum + value }, 0)
  },

  setEffectLevel(effect, level) {
    const prevEffectLevel = this.getEffectLevel(effect)

    if (typeof this.effects === "undefined") {
      this.effects = {}
    }

    if (level < 0) {
      this.effects[effect] = 0
    } else if (level > this.getMaxEffectLevel()) {
      this.effects[effect] = this.getMaxEffectLevel()
    } else {
      this.effects[effect] = level
    }

    if (this.effects[effect] !== prevEffectLevel) {
      if (this.effects[effect] === 0) {
        this.unsetEffectCreatedAt(effect)
        this.onEffectRemoved(effect)
      } else if (!prevEffectLevel) {
        this.setEffectCreatedAt(effect, this.sector.game.timestamp)
        this.onEffectAdded(effect)
      }

      this.onEffectLevelChanged(effect, level)
    }

  },

  setEffectCreatedAt(effect, timestamp) {
    this.initEffectCreatedAt()
    this.effectCreatedAt[effect] = timestamp
  },

  unsetEffectCreatedAt(effect) {
    this.initEffectCreatedAt()
    delete this.effectCreatedAt[effect]
  },

  initEffectCreatedAt() {
    if (typeof this.effectCreatedAt === "undefined") {
      this.effectCreatedAt = {}
    }
  },

  getEffectCreatedAt(effect) {
    this.initEffectCreatedAt()

    return this.effectCreatedAt[effect] 
  },

  isMaxEffectLevelReached(effect) {
    return this.getEffectLevel(effect) >= this.getMaxEffectLevel()
  },

  getEffectLevel(effect) {
    if (typeof this.effects === "undefined") return 0

    return this.effects[effect] || 0
  },

  addWeb() {
    this.setEffectLevel("web", 1)
  },

  removeWeb() {
    this.setEffectLevel("web", 0)
  },

  addParalyze() {
    this.setEffectLevel("paralyze", 1)
  },

  removeParalyze() {
    this.setEffectLevel("paralyze", 0)
  },

  addPoison() {
    this.setEffectLevel("poison", 1)
  },

  removePoision() {
    this.setEffectLevel("poison", 0)
  },

  addRage() {
    this.setEffectLevel("rage", 1)
  },

  removeRage() {
    this.setEffectLevel("rage", 0)
  },

  addFear() {
    this.setEffectLevel("fear", 1)
  },

  removeFear() {
    this.setEffectLevel("fear", 0)
  },

  addInvisible() {
    this.setEffectLevel("invisible", 1)
  },

  removeInvisible() {
    this.setEffectLevel("invisible", 0)
  },

  addHaste() {
    this.setEffectLevel("haste", 1)
  },

  removeHaste() {
    this.setEffectLevel("haste", 0)
  },

  addDrunk() {
    this.setEffectLevel("drunk", 1)
  },

  removeDrunk() {
    this.setEffectLevel("drunk", 0)
  },

  addMiasma() {
    this.setEffectLevel("miasma", 1)
  },

  removeMiasma() {
    this.setEffectLevel("miasma", 0)
  },

  addSpin() {
    this.setEffectLevel("spin", 1)
  },

  removeSpin() {
    this.setEffectLevel("spin", 0)
  },

  addSmoke() {
    this.setEffectLevel("smoke", 1)
  },

  removeSmoke() {
    this.setEffectLevel("smoke", 0)
  },

  addDirt() {
    this.setEffectLevel("dirt", this.getEffectLevel("dirt") + 1)
  },

  reduceDirt() {
    this.setEffectLevel("dirt", this.getEffectLevel("dirt") - 1)
  },

  getDirtLevel() {
    return this.getEffectLevel("dirt")
  },

  hasBlood() {
    return this.hasEffect("blood")
  },

  removeDirt() {
    this.setEffectLevel("dirt", 0)
  },

  hasDirt() {
    return this.hasEffect("dirt")
  },

  hasEffect(effectName) {
    return this.getEffectLevel(effectName)
  },

  canAddEffect(effectName) {
    return true
  },

  addEffect(effectName) {
    if (effectName === 'poison') return this.addPoison()
    if (effectName === 'fire') return this.addFire()
    if (effectName === 'drunk') return this.addDrunk()
    if (effectName === 'fear') return this.addFear()
    if (effectName === 'paralyze') return this.addParalyze()
    if (effectName === 'miasma') return this.addMiasma()
    if (effectName === 'spin') return this.addSpin()
    if (effectName === 'smoke') return this.addSmoke()
    if (effectName === 'rage') return this.addRage()
    if (effectName === 'invisible') return this.addInvisible()
    if (effectName === 'haste') return this.addHaste()
  },

  addFire(level, options = {}) {
    if (!options.forceFlamable) {
      if (!this.isFlamable()) return
    }

    let fireLevel = level || this.getEffectLevel("fire") + 1
    this.setEffectLevel("fire", fireLevel)
  },

  reduceFire() {
    this.setEffectLevel("fire", this.getEffectLevel("fire") - 1)
  },

  removeFire() {
    this.setEffectLevel("fire", 0)
  },

  removeEffect(effectName) {
    if (!this.effects) return
      
    delete this.effects[effectName]
    this.onEffectRemoved(effectName)
  },

  removeAllEffects() {
    if (typeof this.effects === "undefined") return

    for (let effectName in this.effects) {
      this.removeEffect(effectName)
    }
  },

  isFlamable() {
    return this.getConstants().isFlamable || false
  },

  isInvisible() {
    return this.hasEffect("invisible")
  },

  isOnFire() {
    return this.getEffectLevel("fire") > 0
  },

  onEffectRemoved(effect) {},
  onEffectAdded(effect) {},
  onEffectLevelChanged(effect, level) {}
}

module.exports = Taintable


},{"../helper":664,"../util/protocol":686}],680:[function(require,module,exports){
// tiedly coupled to pressureNetwork..
const Tilable = () => {
}

Tilable.prototype = {
  getTileSprite() {
    throw new Error("must implement Tilable#getTileSprite")
  },

  getSides() {
    throw new Error("must implement Tilable#getSides")
  },

  // ideally cached 
  getTextures() {
    throw new Error("must implement Tilable#getTextures")
  },

  layoutTile(tiles = this.getSides(), targetSprite = this.getTileSprite()) {

    const numOfTiles = Object.keys(tiles).length

    switch(numOfTiles) {
      case 4:
        targetSprite.texture = this.getTextures()["line_four"]
        break
      case 3:
        targetSprite.texture = this.getTextures()["line_three"]
        targetSprite.rotation = this.getConduitRotation(tiles)
        break
      case 2:
        let textureName = this.isStraightLine(tiles) ? "line_two_straight" : "line_two"
        targetSprite.texture = this.getTextures()[textureName]
        targetSprite.rotation = this.getConduitRotation(tiles)
        break
      case 1:
        targetSprite.texture = this.getTextures()["line_one"]
        targetSprite.rotation = this.getConduitRotation(tiles)
        break
      case 0:
        targetSprite.texture = this.getTextures()["line_zero"]
        break
    }

  },

  isStraightLine(tiles) {
    return (tiles["left"] && tiles["right"]) || (tiles["up"] && tiles["down"])
  },

  getConduitRotation(sideTiles) {
    let rotation = 0
    let c = sideTiles

    switch(true) {
      case (c["down"] && c["right"] && c["up"]):
        rotation = 0 * PIXI.DEG_TO_RAD
        break
      case (c["right"] && c["up"] && c["left"]):
        rotation = -90 * PIXI.DEG_TO_RAD
        break
      case (c["up"] && c["left"] && c["down"]):
        rotation = 180 * PIXI.DEG_TO_RAD
        break
      case (c["left"] && c["down"] && c["right"]):
        rotation = 90 * PIXI.DEG_TO_RAD
        break
      case (c["right"] && c["up"]):
        rotation = 0 * PIXI.DEG_TO_RAD
        break
      case (c["up"] && c["left"]):
        rotation = -90 * PIXI.DEG_TO_RAD
        break
      case (c["left"] && c["down"]):
        rotation = 180 * PIXI.DEG_TO_RAD
        break
      case (c["down"] && c["right"]):
        rotation = 90 * PIXI.DEG_TO_RAD
        break
      case (c["left"] && c["right"]):
        rotation = 0 * PIXI.DEG_TO_RAD
        break
      case (c["down"] && c["up"]):
        rotation = -90 * PIXI.DEG_TO_RAD
        break
      case (c["right"]):
        rotation = 0 * PIXI.DEG_TO_RAD
        break
      case (c["up"]):
        rotation = -90 * PIXI.DEG_TO_RAD
        break
      case (c["left"]):
        rotation = 180 * PIXI.DEG_TO_RAD
        break
      case (c["down"]):
        rotation = 90 * PIXI.DEG_TO_RAD
        break
    }

    return rotation
  }

}

module.exports = Tilable
},{}],681:[function(require,module,exports){
const Upgradable = () => {
}

Upgradable.prototype = {
  getConstantsTable() {
    throw new Error("must implement getConstantsTable")
  },

  hasArithmeticProgressionUpgrades() {
    return true
  },

  arithmeticSum(count, first, last) {
    return  count * (first + last) / 2
  },

  getUpgradeProgress(level = this.level) {
    const progress = {}
    let curr, next

    if (typeof level === "undefined") {
      curr = this.getStats(0)
      for (let key in curr) {
        progress[key] = { before: curr[key] }
      }
    } else {
      curr = this.getStats(level)
      next = this.getStats(level + 1)

      for (let key in next) {
        progress[key] = { before: curr[key], after: next[key]  }
      }
    }

    return progress
  }



}

module.exports = Upgradable

},{}],682:[function(require,module,exports){
module.exports={
  "TutorialWelcomeMessage": "Right now, its just a sample base that shows how to power things up, how to oxygenate a room, etc. Open the Crafting Menu [C] to see what each structure does",
  "SurvivalWelcomeMessage": "Establish a colony and build your space fortress. Enemies spawn at night",
  "Messenger.DemandPayment": "The Empire demands payment as a token of loyalty",
  "Messenger.Blasphemy": "This is Blasphemy!",
  "Messenger.RightChoice": "You made the right choice",
  "Messenger.Choices.ProceedPay": "Pay %{gold} to the Empire",
  "Messenger.Choices.RefusePay": "Refuse to pay",
  "VisitOtherColony": "Visit Colony",
  "DayCount": "Day %{day}",
  "HourCount": "Hour %{hour}",
  "RailStationName": "Name",
  "PlantGrowth": "Growth",
  "AllianceName": "Name",
  "ColonyName": "Name",
  "ColonyDay": "Day",
  "ColonyOnline": "Online",
  "DisconnectedReconnecting": "Disconnected. Reconnecting in",
  "OutdatedGameClient": "Your game client is outdated. Please Refresh browser.",
  "NetworkOutdatedGameClient": "Unable to load network protocol definition. Game Client might be outdated.",
  "PlayersOnline": "online",
  "Entity.Health": "Health",
  "Entity.Mob.Health": "Health",
  "Events.TaxCollection": "Empire's Tax Collector arrived",
  "Events.RaidWarning": "Raid Incoming",
  "Events.Raid": "Raid",
  "Events.RaidEnd": "Raid Finished",
  "Events.TraderArrived": "Trader has arrived",
  "Events.SlaveTraderArrived": "Slave Trader has arrived",
  "Events.SpiderInfestation": "Spider Infestation",
  "Events.MeteorShower": "Meteor Shower",
  "MatchmakerUnavailable": "Matchmaker not available. Reload and try again",
  "Relationship.EmpireFriendly": "Empire Is Now Friendly to You",
  "Relationship.EmpireNeutral": "Empire Is Now Neutral to You",
  "Relationship.EmpireHostile": "Empire Is Now Hostile to You",
  "Player.Kicked": "You've been kicked from the game",
  "ButcherTable.HarvestFailure": "Failed to Harvest Any Meat or Organs",
  "GuestRole": "You have been assigned a guest role",
  "MemberRole": "You have been assigned a member role",
  "RestartIn": "Restart in %{number}",
  "ColonyLeaveConfirmMessage": "As a non-registered user, your colony would be deleted once you leave. Do you want to proceed?",
  "DemoteMembersPermission": "Demote members to guest when owner exits game",
  "MemberList": "Members",
  "AllowMembers": "Members",
  "AllowEveryone": "Everyone",
  "MineColony": "Mine",
  "AnonymousGameWarning": "[Warning] This colony wont be saved. Login to save your progress.",
  "ColonyFull": "Colony is Full",
  "Player.Banned": "You've been banned",
  "VendingEmpty": "(Empty)",
  "VendingStorage": "Storage",
  "BoughtTooMuch": "You bought too much today. Try again tomorrow.",
  "AdminRole": "You have been assigned an admin role",
  "ChooseCrop": "[E] choose crop",
  "FarmControllerTip": "Requires seed storage nearby before slaves can start planting",
  "Walkthrough.movement": "Move around using <b>w</b>,<b>a</b>,<b>s</b>,<b>d</b> keys",
  "Walkthrough.mining": "Go to room 2 and <b>Mine 10 Iron ores</b> by clicking on an asteroid",
  "Walkthrough.lead_pipe": "Open crafting menu by pressing <b>C</b> and make a <b>Lead Pipe</b>",
  "Walkthrough.release_guard": "Go to room 3 and <b>Release the guard</b> from the Cryotube. To do that, highlight the Cryotube and press <b>E</b>",
  "Walkthrough.kill_guard": "Kill the guard",
  "Walkthrough.grab_potatoes": "Go to room 4 and <b>Grab potatoes</b> from the blue steel crate. Right click to open storage.",
  "Walkthrough.eat_potatoes": "<b>Eat potato</b> to restore your hunger",
  "Walkthrough.player_permissions": "Change the Dummy Player's permission by clicking it and changing the value in the <b>Permissions drop down</b>",
  "Walkthrough.dismantle": "Equip your survival tool and <b>Remove the steelcrate</b> by highlighting it and holding the mouse down until it breaks",
  "Walkthrough.tame_slime": "<b>Tame a slime</b> by feeding it potatoes. While you have potatoes equipped, simply go to the slime to feed it",
  "Walkthrough.kill_slime": "Kill the other slime",
  "Walkthrough.butcher_slime": "Grab the slime corpse by highlighting it and pressing <b>E</b> and go over to <b>Butcher Table</b> to chop it",
  "Walkthrough.cook_slime": "<b>Cook the gel</b> into gelatin using the stove",
  "Walkthrough.sleep": "Go into the next room and <b>Sleep on your bed</b> to restore your stamina",
  "Walkthrough.zoom": "Zoom in/out by pressing <b>-</b> or <b>=</b>",
  "Walkthrough.suit_station": "Grab the <b>Space suit</b> on the suit rack",
  "Walkthrough.collect_water": "Go to next room. The oxygen generator doesnt have any water source currently. You can refill it using a water bottle. <b>Grab a bottle</b> from escape pod and collect water from liquid tank",
  "Walkthrough.fill_oxygen_generator": "<b>Fill the Oxygen Generator</b> with water. The room should now have some oxygen",
  "Walkthrough.refill_space_suit": "You can refill your spacesuit oxygen as well by interacting <b>E</b> with the oxygen generator",
  "Walkthrough.craft_iron_bar": "We can automate the oxygen generation process. Just connect a liquid pipe from liquid tank to the oxygen generator. <b>Craft some Iron Bars</b> using the <b>Furnace</b>. You need some iron ores which can be found on the escape pod",
  "Walkthrough.craft_liquid_pipe": "Craft a <b>Liquid Pipe</b>. When you open the craft menu, you can use <b>search bar</b> to look for the Liquid Pipe.",
  "Walkthrough.connect_liquid_pipe": "<b>Connect the Liquid Pipe</b> between oxygen generator and liquid tank",
  "Walkthrough.rail_tram": "Congratulations. The room is now oxygenated. Exit the room and use the <b>Rail Tram</b> to go to the farm station",
  "Walkthrough.plant_seed": "<b>Grab a wheat seed</b> from the escape pod and plant it on the soil",
  "Walkthrough.water_crop": "Use your bottle to collect water from the lake and <b>water the soil</b> with seed. This speeds up the crop growth",
  "Walkthrough.farm_controller": "Slaves can automate farming for you. You just need to <b>place a Farm Controller</b> beside a soil. Grab one from the escape pod.",
  "Walkthrough.select_wheat": "Highlight the farm controller and open its menu to change the target crop to <b>Wheat</b>",
  "Walkthrough.end": "Slave would now start planting wheat seeds as long as they are available in storage. They will also water plants that havent been watered if they can find a bottle from nearby storage.",
  "AskTutorialMessage": "Do you want to do the tutorial first? Its highly recommended for new players.",
  "TutorialCreateNewColonyMessage": "Congratulations! You have finished the tutorial. Do you wish to make your own space colony now?",
  "StoveSlaveNotice": "Slaves would cook this food only",
  "MobTarget": "Mob",
  "PlayerTarget": "Player",
  "AssignedRole": "Your role is now %{roleName}",
  "RoleName": "Name",
  "PeacefulModeDescription": "Full Admin Commands. No Raids. No taxes. Good for roleplay and minigames.",
  "SurvivalModeDescription": "Raids if taxes are not paid. Good for a little challenge.",
  "HardcoreModeDescription": "Raids everyday. Enemies get stronger each time. Survive as long as you can.",
  "GameModeWarning": "You cannot change game mode later in the game.",
  "AcceptDecide": "Accept",
  "MissileTurret.PlaceAmmunition": "Place Ammunition",
  "ReportPlayer.Description": "If you suspect a player is breaking any of the rules in %{rules} . Send a report and please include screenshot if applicable. Sending report for no reason is against the rules and can result in a ban.",
  "ExitCamera": "Exit",
  "NeededToStart": "%{count} players needed to start game",
  "FindTheImposter.Title": "Find the Imposter",
  "FindTheImposter.Description": "Crewmates win by completing tasks and voting out imposter. Imposter wins by killing everyone.",
  "Domination.Title": "Domination",
  "Domination.Description": "Team up and destroy enemy bases",
  "CanUseAgain": "Can use again in %{cooldown} seconds",
  "Events.Alarm": "Fire Detected.",
  "Events.AlarmEnd": "Fire resolved successfully.",
  "Events.FixLights": "Fix Lights",
  "Events.FixLightsEnd": "Lights Fixed",
  "Function.Usage1": "A function call looks like this",
  "Function.Usage2": "Basically, given an input (player), it returns an output (gold of the player). Functions can be used in commands or in ifelse conditions. "
}

},{}],683:[function(require,module,exports){
module.exports={
    "New Game": "新しい基地を作成",
    "Visit Colony": "基地を訪問",
    "Tutorial": "チュートリアル",
    "Starting": "読み込み中",
    "Load Game": "自分の基地をロード",
    "Login": "ログイン",
    "Logout": "ログアウト",
    "Back": "戻る",
    "Online": "オンライン",
    "Offline": "オフライン",
    "Initializing": "読み込み中",
    "Last Played At": "最後にプレイした時刻",
    "Public": "公開",
    "Private": "非公開",
    "Start Game": "ゲーム開始",
    "Welcome": "ようこそ",
    "Awoken The Spiders You Have": "蜘蛛が目覚めてしまいました。",
    "Unable to Find Spawn Position for Trader. Skipping Event": "貿易商のスポーン地点が見つからないので訪問イベントがスキップされました。",
    "Raid Incoming": "敵の襲撃まで",
    "Spider Infestation": "蜘蛛が侵入しています",
    "Respawn": "リスポーン",
    "Iron Ore": "鉄鉱石",
    "Iron Bar": "鉄の延べ棒",
    "Copper Ore": "銅鉱石",
    "Copper Bar": "銅の延べ棒",
    "Circuit Board": "電子回路",
    "Cloth": "布",
    "Sand": "砂",
    "Glass": "ガラス",
    "Wood": "木材",
    "Bottle": "瓶",
    "Water Bottle": "水が入った瓶",
    "Blood Bottle": "血が入った瓶",
    "Wire": "電線",
    "Potato": "ジャガイモ",
    "Potato Seed": "ジャガイモの種",
    "Plant Fiber": "センイ草",
    "Fiber Seed": "センイ草の種",
    "Wheat": "小麦",
    "Wheat Seed": "小麦の種",
    "Gel": "ジェル",
    "Alien Meat": "エイリアンの肉",
    "Animal Meat": "動物の肉",
    "Human Meat": "人肉",
    "Gelatin": "ゼラチン",
    "Steak": "ステーキ",
    "Hot Dog": "ホットドッグ",
    "Vegan Pizza": "ベジタリアンピザ",
    "Slimy Meat Pizza": "とろとろお肉のピザ",
    "Beer": "ビール",
    "Cola": "コーラ",
    "First Aid Kit": "救急箱",
    "Antidote": "解毒薬",
    "Stimpack": "怪しい注射",
    "Mop": "モップ",
    "Pistol": "ピストル",
    "Shotgun": "ショットガン",
    "Bullet Ammo": "弾丸",
    "Bullet Damage": "撃ち抜いた敵にダメージを与えます。",
    "Fire Extinguisher": "消火器",
    "Flame Thrower": "火炎放射器",
    "Lighter": "ライター",
    "Survival Tool": "サバイバルツール",
    "Drill": "ドリル",
    "Katana": "刀",
    "Space Suit": "宇宙服",
    "Furnace": "かまど",
    "Butcher Table": "解体台",
    "Stove": "コンロ",
    "Brewery": "醸造機",
    "Chemistry Station": "薬品製造機",
    "Mining Drill": "設置型ドリル",
    "Ammo Printer": "弾丸製造機",
    "Refinery": "鋳造機",
    "Wall": "壁",
    "Spike Trap": "スパイクトラップ",
    "Manual Airlock": "手動エアロック",
    "Airlock": "自動エアロック",
    "Lamp": "ランプ",
    "Steel Crate": "鉄箱",
    "Water Pump": "水用ポンプ",
    "Liquid Pipe": "液体用パイプ",
    "Liquid Tank": "液体タンク",
    "Suit Station": "宇宙服置き場",
    "Beacon": "ビーコン",
    "Mini Turret": "小型タレット",
    "Air Alarm": "空気漏れ警報機",
    "Ventilator": "通風装置",
    "Oxygen Generator": "酸素発生機",
    "Small Oxygen Tank": "小型酸素タンク",
    "Gas Pipe": "気体用パイプ",
    "Bed": "ベッド",
    "Table": "テーブル",
    "Trading Table": "貿易用テーブル",
    "Chair": "椅子",
    "Cage": "檻",
    "Television": "テレビ",
    "Pot": "植木鉢",
    "Lattice": "格子床",
    "Steel Floor": "鉄製の床",
    "Soil": "土",
    "Wood Floor": "木製の床",
    "Carpet Floor": "絨毯付きの床",
    "Tiled Floor": "タイル張りの床",
    "Purple Floor": "紫の床",
    "Plated Floor": "メッキされた床",
    "Stripe Plated Floor": "ストライプメッキされた床",
    "Green Floor": "緑の床",
    "Rail Track": "線路",
    "Rail Stop": "駅",
    "Oil Refinery": "石油掘削・精製機",
    "Power Generator": "燃料発電機",
    "Fuel Pipe": "燃料用パイプ",
    "Fuel Tank": "燃料タンク",
    "Solar Panel": "ソーラーパネル",
    "Asteroid": "アステロイド",
    "Remaining": "残量",
    "Owner": "所有者",
    "Stored": "貯蔵量",
    "Production": "総量",
    "Power Needed": "電力需要",
    "Slime": "スライム",
    "Slime Corpse": "スライムの死体",
    "Brood": "寄生虫",
    "Brood Corpse": "寄生虫の死体",
    "Spider": "蜘蛛",
    "Spider Corpse": "蜘蛛の死体",
    "Monkey": "猿",
    "Monkey Corpse": "猿の死体",
    "Chicken": "ニワトリ",
    "Chicken Corpse": "ニワトリの死体",
    "Clean Bot": "クリーンボット",
    "Clean Bot Corpse": "壊れたクリーンボット",
    "Trader": "貿易商",
    "Empire": "帝国",
    "Guard": "衛兵",
    "Chemist": "化学者",
    "Chemist Corpse": "化学者の死体",
    "Messenger": "税務官",
    "Messenger Corpse": "税務官の死体",
    "O2": "酸素濃度",
    "Crafting": "製作",
    "Ingredients": "材料",
    "Suit": "宇宙服",
    "Inventory": "インベントリ",
    "Map": "地図",
    "Colony": "基地情報",
    "Name": "基地名",
    "Location": "所在地",
    "Members": "メンバー",
    "Days Alive": "日間生存",
    "Alliance": "対外関係情報",
    "Status": "状態",
    "Friendly": "友好的",
    "Neutral": "中立",
    "Hostile": "敵対的",
    "Relationship": "友好度",
    "Insufficient Power": "電力が不足しています。",
    "Generates Iron Ore": "鉄鉱石を採掘中",
    "Resume": "ゲームを再開",
    "Settings": "設定",
    "Exit Game": "ゲームをやめる",
    "Sound": "音声",
    "Volume": "音量",
    "Controls": "操作",
    "Move Up": "上に移動",
    "Move Left": "左に移動",
    "Move Down": "下に移動",
    "Move Right": "右に移動",
    "Rotate": "回転する",
    "Craft": "製作",
    "Interact": "操作",
    "Attack": "攻撃する",
    "Chat": "チャット",
    "Camera Mode": "カメラモード",
    "Stats View": "通信状態確認",
    "Press Any Key": "設定したいキーを押してください",
    "Trade": "貿易",
    "Sell": "売る",
    "Trader has arrived": "貿易商がやってきました",
    "Tax Officer Has Arrived": "税務官がやってきました",
    "Confirm": "決定",
    "Needs Fuel": "燃料の補充が必要です。",
    "Bullet Ammo Required": "弾丸が必要です。",
    "Destination": "目的地",
    "Go": "出発",
    "No Passengers on Tram": "トロッコに何も乗っていません。",
    "Web": "蜘蛛の巣",
    "Web Trap": "ベタベタトラップ",
    "Sign": "立て札",
    "Happiness": "幸福度",
    "Make Pet": "ペットにする",
    "Place ore in left slot to refine gold": "鉱石を左のスロットに入れるとGoldの鋳造が始まります",
    "You Died": "死んでしまった！",
    "Blood Pack": "血液パック",
    "Lead Pipe": "鉄パイプ",
    "Cryo Tube": "凍結保存器",
    "Oxygen Tank": "酸素タンク",
    "Generates Copper Ore": "銅鉱石を採掘中",
    "Buy": "買う",
    "ColonyName": "基地名　",
    "ColonyDay": "経過日数",
    "ColonyOnline": "人数",
    "PlayersOnline": "人がオンライン",
    "TutorialWelcomeMessage": "ここはどのようにして電力を供給し、部屋に酸素を充満させるのかを確認するためのサンプルの基地です。[C] キーを押して製作メニューを開き、それぞれの装置が何をしているのかを確認しましょう。",
    "Potato.Description": "サバイバルのための主食です。",
    "PotatoSeed.Description": "土に植えるとジャガイモに育ちます。",
    "PlantFiber.Description": "薬品などを作成するための材料です。",
    "FiberSeed.Description": "土に植えるとセンイ草に育ちます。",
    "Wheat.Description": "未加工の小麦です。パンなどになります。",
    "WheatSeed.Description": "土に植えると小麦に育ちます。",
    "Gel.Description": "ゼラチンに加工できます。",
    "AlienMeat.Description": "生のエイリアンの肉です。料理して食べましょう。",
    "AnimalMeat.Description": "生の動物の肉です。料理すると美味しくなります。",
    "HumanMeat.Description": "生の人肉です。食べるなよ、絶対だぞ！？",
    "Gelatin.Description": "タンパク質を豊富に含んでいます。美味。",
    "Steak.Description": "料理したお肉です。何の肉かは気にしたら負けです。",
    "HotDog.Description": "料理した動物のお肉です。昔からアメリカと言えばやっぱりこれですよね。",
    "VeganPizza.Description": "ベジタリアンの方にも美味しく食べられるピザです。",
    "SlimyMeatPizza.Description": "スライムと動物のお肉から作ったエキゾチックなピザです。",
    "LectersDinner.Description": "料理した人肉です。泣く子も羊も黙るインパクトのある味です。",
    "Beer.Description": "スタミナを30回復します。飲み過ぎ注意。",
    "Cola.Description": "スタミナを10回復します。",
    "FirstAidKit.Description": "体力を50回復します。",
    "Antidote.Description": "毒状態を治療します。",
    "BloodPack.Description": "体力を50回復します。",
    "Stimpack.Description": "体力を25奪われるのと引き換えに攻撃速度が15秒間2倍になります。",
    "Entity.Health": "耐久度",
    "PlantGrowth": "成長度",
    "DayCount": "%{day}日目",
    "HourCount": "%{hour}時",
    "LeadPipe.Description": "基本的な近接武器です。攻撃力:7",
    "Mop.Description": "床掃除に用いる道具です。",
    "Pistol.Description": "遠距離から攻撃できる武器です。攻撃力:10",
    "Shotgun.Description": "複数の弾を同時に拡散して撃ち出す武器です。撃ち出された弾がそれぞれ12のダメージを与えます。",
    "FireExtinguisher.Description": "火を消すことができます。",
    "FlameThrower.Description": "炎を放って攻撃できます。",
    "Bottle.Description": "液体を汲むことができます。",
    "Lighter.Description": "火をつけることができます。燃料タンクから補充しましょう。",
    "SurvivalTool.Description": "採掘や物を回収するのに用います。攻撃力:2",
    "Drill.Description": "サバイバルツールより速く採掘できます。攻撃力:5",
    "Katana.Description": "３体の敵に同時に切りつけることができます。攻撃力:10",
    "SpaceSuit.Description": "宇宙空間で窒息を防ぐためにはこれを着用しなければなりません。",
    "Furnace.Description": "鉱石を他のアイテムに精製できます。",
    "ButcherTable.Description": "死体を解体して肉やその他の資源を入手できます。",
    "Stove.Description": "ここで料理を行いましょう。",
    "Brewery.Description": "飲み物を作って喉の渇きを潤しましょう。",
    "ChemistryStation.Description": "様々な薬品を作れます。",
    "MiningDrill.Description": "地中から鉱石を自動的に採掘します。",
    "AmmoPrinter.Description": "武器用の弾丸を作れます。",
    "Refinery.Description": "鉱石を鋳造してGoldに変えます。",
    "Wall.Description": "部屋を囲うのに用います。空気を通しません。",
    "SpikeTrap.Description": "上を通る敵にダメージを与えます。",
    "ManualAirlock.Description": "手動で開閉するタイプのエアロックです。電力なしで開閉できます。",
    "Airlock.Description": "空気を通さないドアです。これを用いることで内側のエリアを酸素で満たすことができます。",
    "Lamp.Description": "周囲を照らします。",
    "WaterPump.Description": "水を生成します。水資源の付近に設置した上でパイプによって接続されている必要があります。",
    "LiquidPipe.Description": "これで接続した装置間に液体を通すことができます。",
    "LiquidTank.Description": "液体を貯蔵します。",
    "CryoTube.Description": "中に入れられた生き物を回復させます。",
    "SuitStation.Description": "宇宙服を収納できます。",
    "Beacon.Description": "あなたの基地を訪れるプレイヤーのスポーン地点となります。",
    "MiniTurret.Description": "防衛用のタレットです。電力と弾丸が必要です。攻撃力:15",
    "AirAlarm.Description": "室内に酸素がない時警報として赤く点灯します。",
    "Ventilator.Description": "密閉された室内に酸素を満たすことができます。気体用パイプで接続されている必要があります。",
    "OxygenGenerator.Description": "水から酸素を発生させます。",
    "SmallOxygenTank.Description": "少量の酸素を貯蔵します。気体用パイプで接続されている必要があります。",
    "GasPipe.Description": "これで接続した装置間に酸素を通すことができます。",
    "Bed.Description": "この上で寝ることでスタミナが回復します。リスポーン地点ともなります。",
    "Table.Description": "装飾用のテーブル。",
    "TradingTable.Description": "設置することで貿易商を呼び込むことができます。",
    "Chair.Description": "装飾用の椅子。",
    "Cage.Description": "手懐けた動物やエイリアンを収容するために用います。",
    "Television.Description": "装飾用のテレビ。",
    "Pot.Description": "草花の装飾用の入れ物です。",
    "Lattice.Description": "外部に装置を設置するための軽量な床です。Can only be placed outside asteroid area",
    "SteelFloor.Description": "設置した上を移動できます。また、水上、石油上、宇宙空間上に装置を置くために使います。",
    "Soil.Description": "農作物を栽培するために使います。",
    "WoodFloor.Description": "木製の床です。",
    "CarpetFloor.Description": "赤絨毯が敷かれた床です。",
    "TiledFloor.Description": "タイル状の床です。",
    "PurpleFloor.Description": "紫色の床です。",
    "PlatedFloor.Description": "メッキ加工された床です。",
    "StripePlatedFloor.Description": "縞状にメッキ加工された床です。",
    "GreenFloor.Description": "緑色の床です。",
    "RailTrack.Description": "トロッコが運行するための線路です。",
    "RailStop.Description": "トロッコが発車・停車するための駅です。線路の端に設置される必要があります。",
    "Wire.Description": "装置間に電力を供給します。",
    "OilRefinery.Description": "地下の石油を採取し化学燃料を精製します。",
    "PowerGenerator.Description": "化学燃料を用いて発電します。",
    "FuelPipe.Description": "これで接続した装置間に燃料を通すことができます。",
    "FuelTank.Description": "燃料を貯蔵します。",
    "AllianceName": "勢力名",
    "taxes_not_paid.Description": "税金未納",
    "cannibalism.Description": "帝国軍兵士の肉を喰らった",
    "extreme_cannibalism.Description": "多数の帝国軍兵士達の肉を貪った",
    "RailStationName": "駅名",
    "WebTrap.Description": "敵を５秒間拘束し動けなくするトラップです。",
    "Sign.Description": "他のプレイヤーたちに見せたい文章を書き込むことができます。",
    "RifleAmmo.Description": "アサルトライフル用の弾薬です。",
    "Grenade.Description": "爆発して敵にダメージを与える投擲武器です。",
    "PoisonGrenade.Description": "一定のエリアに毒ガスを発生させる投擲武器です。",
    "Web.Description": "ベタベタしていて、獲物を捕らえるのに有効です。",
    "Gold.Description": "品物を売買したり、サービスを受けたりするために用いる通貨です。",
    "to save your progress": "すると進行状況をセーブできます",
    "SurvivalWelcomeMessage": "基地を創設し、あなたの宇宙要塞を建造しましょう。敵は夜になると出現します。",
    "IronBar.Description": "鉄の延べ棒。",
    "CopperBar.Description": "銅の延べ棒。",
    "CircuitBoard.Description": "電子回路。",
    "Cloth.Description": "家具や装備を作成するための材料です。",
    "Sand.Description": "特定の物品を作成するための材料です。",
    "Glass.Description": "ガラスです。",
    "Water": "水",
    "Wood.Description": "家具を作成するための材料です。",
    "Assault Rifle": "アサルトライフル",
    "Bio Raptor": "バイオラプター",
    "Bio Raptor Corpse": "バイオラプターの死体",
    "Car":"車",
    "Car Corpse": "車の死体",
    "SteelCrate.Description": "アイテムを収納できます。",
    "SolarPanel.Description": "太陽エネルギーを用いて発電します。Can only be placed on Lattice",
    "Messenger.DemandPayment": "我らが神聖なる帝国の名において 忠誠の証としての税金の納入を命ずる!",
    "Messenger.RightChoice": "賢明な選択だ!",
    "Messenger.Blasphemy": "我らが神聖なる帝国を冒涜する非国民めが！",
    "Messenger.Choices.ProceedPay": "%{gold} Gold払う。",
    "Messenger.Choices.RefusePay": "支払いを拒否する。",
    "Shotgun Shell": "ショットガンの弾",
    "Rifle Ammo": "ライフルの弾",
    "Livestock": "家畜",
    "WaterBottle.Description": "酸素発生機に水を入れたり、植物に水を与えたりできます。",
    "BloodBottle.Description": "血が入っています。",
    "BulletAmmo.Description": "ピストルやタレット用の弾丸です。",
    "OutdatedGameClient": "ゲームクライアントが時間切れになっています。ページを再読み込みしてください。",
    "NetworkOutdatedGameClient": "ゲームクライアントが時間切れになっています。ページを再読み込みしてください。",
    "Escape Pod": "亡命ポッド",
    "Core": "コア",
    "Core.Description": "電力源です。 500W。",
    "Connecting": "接続中です",
    "DisconnectedReconnecting": "接続が切断されました。秒後に再接続します。",
    "Taming": "親密度",
    "Following": "同伴者",
    "Take Along": "ついて来させる",
    "Release": "離れる",
    "Message": "メッセージ",
    "Done": "完了",
    "Edit": "編集",
    "Cancel": "キャンセル",
    "Cook": "作成",
    "Brew": "作成",
    "Place Ammunition": "弾丸を装填してください",
    "MatchmakerUnavailable": "サーバと同期できません。ページを再読み込みしてやり直してください。",
    "Relationship.EmpireFriendly": "帝国は現在あなたに対して友好的です。",
    "Relationship.EmpireNeutral": "帝国は現在あなたに対し中立です。",
    "Relationship.EmpireHostile": "帝国は現在あなたに対し敵対的です。",
    "Oil": "石油",
    "Potato Plant": "ジャガイモ",
    "Fiber Plant": "センイ草",
    "Wheat Plant": "小麦",
    "Lecters Dinner": "レクター流ディナー",
    "Game Settings": "ゲムの設定",
    "Zoom In": "ズームイン",
    "Zoom Out": "ズームアウト",
    "ShotgunShell.Description": "ショットガン用の弾薬です。",
    "Make Livestock": "家畜にする",
    "Events.TaxCollection": "帝国の税務官がやって来ました",
    "Events.RaidWarning": "敵の襲撃まで",
    "Events.Raid": "襲撃",
    "Events.RaidEnd": "襲撃が終わりました",
    "Events.TraderArrived": "貿易商がやってきました。",
    "Events.SlaveTraderArrived": "貿易商がやってきました。",
    "Events.SpiderInfestation": "蜘蛛が侵入しています",
    "Events.MeteorShower": "Meteor Shower",
    "Shotgun Shells Required": "ショットガンの弾が必要です。",
    "Rifle Ammo Required": "ライフルの弾が必要です。",
    "Corpse Required": "死体が必要です。",
    "Background Volume": "BGMの音量",
    "Effects Volume": "効果音の音量",
    "No Saves Found": "セーブデータが見つかりません",
    "Privacy": "プライバシー",
    "Credits": "クレジット",
    "Inventory Full": "インベントリがいっぱいです。",
    "Mining not allowed when owner is offline": "基地のオーナーが不在の間は採掘することができません。",
    "You are not allowed to use flamethrower": "あなたには火炎放射器を使用する権限がありません。",
    "You dont have building permissions": "あなたには建築を行う権限がありません。",
    "That doesnt belong to you": "あなたには所有権がありません。",
    "You dont have storage viewing permissions": "あなたには倉庫の中身を見る権限がありません。",
    "Invalid Item": "このアイテムをここで使うことはできません。",
    "You just ate": "さっき食べたばかりです。",
    "Not enough Gold": "Goldが足りません。",
    "Not enough inventory to store gold": "Goldを持ち歩くための十分なインベントリがありません。",
    "Not enough items available": "アイテムが足りません。",
    "Bot Limit Reached": "ボットの数が上限に達しています。",
    "Pet Limit Reached": "ペットの数が上限に達しています。",
    "Insufficient Blood": "血が足りません。",
    "Taming Limit Reached": "手懐けられる個体数の上限に達しています。",
    "The Spiders have been left in peace": "蜘蛛たちは再び休眠状態に入りました。",
    "Rail Network is currently in use": "この駅は現在利用されている為解体できません。",
    "Player.Kicked": "基地からキック（追放）されてしまいました。",
    "ButcherTable.HarvestFailure": "肉や器官などの剥ぎ取りに失敗しました。",
    "AssaultRifle.Description": "高速の弾丸を連射できる突撃銃です。",
    "Entity.Mob.Health": "体力",
    "OxygenTank.Description": "酸素を貯蔵します。気体用パイプで接続されている必要があります。",
    "Grenade": "グレネード",
    "AssignedRole": "%{roleName}の役職を与えられました",
    "GuestRole": "ゲストの役職を与えられました",
    "MemberRole": "メンバーの役職を与えられました",
    "Visibility": "公開設定",
    "You are running out of oxygen": "酸素が足りなくなってきました。",
    "You are tired and restless": "あなたは疲れてヘトヘトになってきました。",
    "You are feeling hungry": "あなたはお腹が空いてきました。",
    "IronOre.Description": "鉄鉱石です。",
    "CopperOre.Description": "銅鉱石です。",
    "VisitOtherColony": "他の基地に行く",
    "Visit": "基地を訪問",
    "RestartIn": "%{number} 秒後にリスタート",
    "Guard Corpse": "衛兵の死体",
    "MemberList": "メンバー一覧",
    "Days": "日目",
    "Poison Grenade": "毒ガス爆弾",
    "Yes": "はい",
    "No": "いいえ",
    "Access Denied": "立ち入り禁止です。",
    "Sealed Door": "関係者専用ドア",
    "SealedDoor.Description": "特定の人物以外の立ち入りを制限するドアです。",
    "Unreachable": "手が届きません。",
    "Permissions": "権限設定",
    "Storage Access": "倉庫へのアクセス",
    "Asteroid Mining": "アステロイドの採掘",
    "DemoteMembersPermission": "基地の所有者がゲームから抜けた時に メンバーをゲストに降格するか",
    "Everyone": "全員",
    "ColonyLeaveConfirmMessage": "Your colony would be deleted since you're not logged in. Do you want to proceed?",
    "Permission": "権限",
    "AllowMembers": "メンバー",
    "AllowEveryone": "全員",
    "Send Money": "お金を渡す",
    "To": "渡す相手",
    "Send": "渡す",
    "Top": "トップ",
    "MineColony": "自分の基地",
    "AnonymousGameWarning": "[警告] この基地はセーブされません。進行状況をセーブするにはログインしてください。",
    "ColonyFull": "この基地は満員です。",
    "Save and Quit": "セーブしてやめる",
    "Info": "情報",
    "Player.Banned": "基地からキック（追放）されてしまいました。",
    "No results": "結果なし",
    "Items": "アイテム",
    "Manage": "管理",
    "VendingStorage": "陳列",
    "Purchase": "購入",
    "VendingEmpty": "この自動販売機は現在空です",
    "Balance": "残高",
    "Deposit": "預け入れ",
    "Withdraw": "引き出し",
    "Large Table": "大型テーブル",
    "LargeTable.Description": "大型の装飾用のテーブルです。",
    "Food Vending Machine": "食べ物用自販機",
    "Drinks Vending Machine": "飲み物用自販機",
    "Combat Armor": "コンバットアーマー",
    "CombatArmor.Description": "近接格闘を行いやすくなります。ダメージを4軽減します。",
    "BoughtTooMuch": "今日あなたは既にたくさん買いました。また明日お試し下さい。",
    "AdminRole": "You have been assigned an admin role",
    "Yellow Floor": "黄色の床",
    "Bronze Floor": "青銅の床",
    "Blue Floor": "青の床",
    "Gray Floor": "グレーの床",
    "Grass Floor": "芝生の床",
    "Pink Floor": "ピンクの床",
    "YellowFloor.Description": "黄色の床です。",
    "BronzeFloor.Description": "青銅製の床です。",
    "BlueFloor.Description": "青色の床です。",
    "GrayFloor.Description": "グレーの床です。",
    "GrassFloor.Description": "芝生が植えられた床です。",
    "PinkFloor.Description": "ピンク色の床です。",
    "FoodVendingMachine.Description": "食べ物を陳列することで販売できます。",
    "DrinksVendingMachine.Description": "飲み物を陳列することで販売できます。",
    "Atm.Description": "あなたの口座からGoldを引き出したり口座にGoldを預け入れたりできます。",
    "AdminRole": "管理者権限を与えられました。",
    "Coffee Seed": "コーヒーの種",
    "Sunflower Seed": "ヒマワリの種",
    "Poppy Seed": "ポピーの種",
    "Blue Seed": "ブルーの種",
    "Coffee": "コーヒー",
    "Coffee.Description": "スタミナを50回復します。",
    "Coffee Bean": "コーヒー豆",
    "CoffeeBean.Description": "コーヒーを淹れるための材料です。",
    "Coffee Plant": "コーヒーノキ",
    "CoffeePlant.Description": "土に植えるとコーヒーノキが育ちます。",
    "Sunflower": "ヒマワリ",
    "Sunflower.Description": "植木鉢に飾ることができる花です。",
    "Poppy": "ポピー",
    "Poppy.Description": "植木鉢に飾ることができる花です。",
    "Blue Lotus": "ブルーロータス",
    "BlueLotus.Description": "植木鉢に飾ることができる花です。",
    "SunflowerSeed.Description": "土に植えるとヒマワリが育ちます。",
    "BlueSeed.Description": "土に植えるとブルーロータスが育ちます。",
    "PoppySeed.Description": "土に植えるとポピーが育ちます。",
    "Flower Required": "花が必要です。",
    "Ivory Wall": "象牙色の壁",
    "IvoryWall.Description": "白い壁です。",
    "Green Wall": "緑の壁",
    "GreenWall.Description": "緑色の壁です。",
    "Blue Wall": "青の壁",
    "BlueWall.Description": "青色の壁です。",
    "Favorite": "お気に入り",
    "Favorites": "お気に入り",
    "New": "新",
    "You dont have permission to sell": "あなたには物を販売する権限がありません。",
    "Poppy Farm": "ポピー畑",
    "BlueLotus Farm": "ブルーロータス畑",
    "Sunflower Farm": "ヒマワリ畑",
    "PlantFiber Farm": "センイ草用農地",
    "CoffeeBean Farm": "コーヒー豆用農地",
    "Wheat Farm": "小麦畑用農地",
    "Potato Farm": "ジャガイモ用農地",
    "Choose Crop to Grow": "栽培する作物を選択",
    "ChooseCrop": "[E] 作物を選択",
    "Slave Trader": "奴隷商人",
    "Trade Slaves": "奴隷貿易",
    "Nuu Slave": "ヌー星人奴隷",
    "Pixi Slave": "ピクシィ星人奴隷",
    "Garam Slave": "ガラム星人奴隷",
    "Slavers Table": "奴隷貿易用テーブル",
    "SlaversTable.Description": "設置することで奴隷商人を呼び込むことができます。",
    "Farm Controller": "農業コントローラー",
    "FarmController.Description": "土の側に設置してください。労働者にどの作物を育てるべきが指示することができます。",
    "State": "状態",
    "Tasks": "仕事",
    "Plant Seed": "種播き",
    "Water Crop": "水やり",
    "Harvest Crop": "収穫",
    "Butcher Corpse": "解体",
    "Edit Sign": "立て札を編集",
    "Access Storage": "倉庫へのアクセス",
    "Access Mining Drill": "設置型ドリルへのアクセス",
    "Cook": "料理",
    "Refill Turret": "タレットの装填",
    "FarmControllerTip": "奴隷が種蒔きを始める前に近くに種用の箱が必要です。",
    "Play": "プレイ",
    "Walkthrough.movement": "<b>w</b>,<b>a</b>,<b>s</b>,<b>d</b>キーを押して移動しましょう。",
    "Walkthrough.mining": "Room2に行き、アステロイドをクリックして<b>鉄鉱石</b>を<b>10</b>個採掘しましょう。",
    "Walkthrough.lead_pipe": "<b>C</b>キーを押して製作メニューを開き、<b>鉄パイプ</b>を作成しましょう。",
    "Walkthrough.release_guard": "Room3に行き、<b>衛兵</b>を<b>凍結保存器</b>から解放しましょう。凍結保存器にカーソルを合わせた状態で<b>E</b>キーを押すことで解放できます。衛兵はあなたを攻撃してくるためご注意ください。",
    "Walkthrough.kill_guard": "衛兵を倒しましょう。",
    "Walkthrough.grab_potatoes": "Room4に行き、鉄箱から<b>ジャガイモ</b>を取り出しましょう。Right-click to open storage",
    "Walkthrough.eat_potatoes": "<b>ジャガイモ</b>を食べてお腹を充しましょう。",
    "Walkthrough.player_permissions": "ダミーくんにカーソルを合わせた状態でクリックすると、右上に権限設定のメニューが表示されます。<b>[Guest]と表示されているところをクリックし</b>、権限を変更しましょう。",
    "Walkthrough.dismantle": "<b>サバイバルツール</b>を装備し、鉄箱にカーソルを合わせた状態でクリックしたままにし、鉄箱を<b>取り壊しましょう</b>。",
    "Walkthrough.tame_slime": "ジャガイモを与えてスライムを1匹<b>懐かせましょう</b>。ポテトを装備した（手に持った）状態で、スライムに近づくことでジャガイモを食べさせられます。",
    "Walkthrough.kill_slime": "もう1匹のスライムを倒しましょう。",
    "Walkthrough.butcher_slime": "スライムの死体にカーソルを合わせた状態で<b>E</b>キーを押すことで掴むことができます。スライムの死体を掴んだ状態で<b>解体台</b>まで行き、死体を解体しましょう。",
    "Walkthrough.cook_slime": "<b>コンロ</b>で<b>ジェル</b>を料理して<b>ゼラチン</b>にしましょう。",
    "Walkthrough.sleep": "次の部屋に行き、<b>ベッド</b>で<b>睡眠</b>をとりスタミナを回復させましょう。",
    "Walkthrough.zoom": "Zoom in/out by pressing <b>-</b> or <b>=</b>",
    "Walkthrough.suit_station": "宇宙服置き場から<b>宇宙服</b>を回収しましょう。",
    "Walkthrough.collect_water": "次の部屋に行きましょう。現在、酸素発生機は水が供給されていません。水が入った瓶を使うことで酸素発生機に水を入れられます。亡命ポッドから<b>瓶</b>を取り出し、液体タンクから水をすくいましょう。",
    "Walkthrough.fill_oxygen_generator": "<b>酸素発生機</b>がいっぱいになるまで水を入れましょう。水がいっぱいに入っている状態ならば部屋が酸素で満たされるはずです。",
    "Walkthrough.refill_space_suit": "酸素発生機にカーソルを合わせた状態で<b>E</b>キーを押すことで宇宙服に酸素を供給することもできます。",
    "Walkthrough.craft_iron_bar": "酸素を発生させるための操作を自動化することもできます。液体タンクと酸素発生機を液体用パイプでつなぐだけです。<b>かまど</b>を使って<b>鉄の延べ棒</b>をいくつか製作しましょう。必要な鉄鉱石は亡命ポッドの中に入っています。",
    "Walkthrough.craft_liquid_pipe": "<b>C</b>キーを押して製作メニューを開き、<b>液体用パイプ</b>を製作しましょう。下の虫眼鏡のマークが描かれた検索バーから液体用パイプを検索することも可能です。",
    "Walkthrough.connect_liquid_pipe": "酸素発生機と液体タンクの間に<b>液体用パイプ</b>を設置し、発生機とタンクを接続しましょう。",
    "Walkthrough.rail_tram": "おめでとうございます。部屋に酸素が満たされました。部屋を出て、<b>駅</b>からfarm駅まで<b>トロッコ</b>に乗って移動しましょう。",
    "Walkthrough.plant_seed": "<b>小麦の種</b>を亡命ポッドから取り出し、土に植えましょう。",
    "Walkthrough.water_crop": "瓶を使って湖から水をくみ、 <b>土に植えた種に水をやりましょう </b>。水をやることで作物の生長が速まります。",
    "Walkthrough.farm_controller": "奴隷たちに指示することで農業を自動化できます。土の側に<b>農業コントローラー</b>を設置するだけです。亡命ポッドから農業コントローラーを取り出し、設置してみましょう。",
    "Walkthrough.select_wheat": "農業コントローラーにカーソルを合わせ、メニューを開いて栽培する作物として<b>小麦</b>を選びましょう。",
    "Walkthrough.end": "奴隷は箱から種を回収できる限り小麦を栽培し続けます。また、もし近くの箱から瓶を見つけることができれば、奴隷はまだ水をやっていない作物に瓶を使って水やりを行うでしょう。",
    "AskTutorialMessage": "まずチュートリアルに行きたいですか？このゲームを始められたばかりなら、一度チュートリアルでこのゲームについて簡単に学ぶことを強くお勧めいたします。",
    "TutorialCreateNewColonyMessage": "おめでとうございます！これでチュートリアルは終了です。今からあなた自身の宇宙基地を作成したいですか？",
    "Unset": "未設定",
    "Not enough Ingredients": "材料が不足しています。",
    "Slave": "奴隷",
    "Dummy Player": "ダミーくん",
    "Partners": "宣伝・協力",
    "Permission Denied": "あなたには権限がありません。",
    "Local": "内部",
    "Global": "グローバル",
    "Guests are not allowed to do that": "ゲストにはこの行動をする許可が与えられていません。",
    "Admin": "管理者",
    "Account": "口座",
    "Transfer": "送金",
    "Amount": "金額",
    "StoveSlaveNotice": "Slaves would cook this food only",
    "Bread": "パン",
    "Bread.Description": "朝の元気の源です。",
    "Targets": "標的設定",
    "MobTarget": "敵NPC",
    "PlayerTarget": "敵プレイヤー",
    "You dont have permission to mine asteroids": "あなたにはアステロイドを採掘する権限がありません",
    "Team": "チーム",
    "Teams": "チーム",
    "Player": "個人",
    "requests to join your team": "があなたのチームへの参加を申請しました。",
    "Upgrade": "アップグレード",
    "Request Sent": "申請が送信されました",
    "Join Team": "チームに参加する",
    "Accept": "許可",
    "Reject": "拒否",
    "Join": "参加",
    "Leave": "チームから脱退",
    "Restart Character": "キャラクターを初期化してやり直す（*進行状況が消えます）",
    "You just did that recently": "この操作は先ほど行われたばかりです。",
    "Preview": "プレビュー画像",
    "FlamethrowerTurret": "火炎放射型タレット",
    "Delete Role": "役職を削除",
    "New Role": "新しい役職を追加",
    "RoleName": "役職名",
    "Build": "建築",
    "Mine Asteroids": "アステロイドの採掘",
    "Plant Seeds": "種蒔き",
    "Harvest Crops": "農作物の収穫",
    "Sell To Trader": "貿易商への売却",
    "PeacefulModeDescription": "税金を納める必要も、襲撃される危険もありません。美しい拠点を築いたり、ロールプレイを楽しんだりするのに最適なモードです。",
    "SurvivalModeDescription": "税金を納めないと帝国軍に襲撃されます。適度なリスクとスリルを楽しみたい方にお勧めです。",
    "HardcoreModeDescription": "毎日帝国軍が襲来します。襲撃ごとに敵が強くなっていきます。自分がどれだけ長く生き延びられるか腕試ししたい方にお勧めです。",
    "GameModeWarning": "注意:ゲームの途中で難易度を変更することはできません。",
    "Choose a Game Mode": "ゲームの難易度を選択",
    "Peaceful": "ピースフル",
    "Survival": "サバイバル",
    "Hardcore": "ハードコア",
    "AcceptDecide": "決定",
    "You must login to use this": "これを利用するにはログインする必要があります。",
    "Fence": "フェンス",
    "Fence.Description": "ペット・ボット・奴隷の動きを制限するドアですが、プレイヤーは自由に通過できます。",
    "Mode": "難易度",
    "Logs": "ログ",
    "Deconstruct": "解体",
    "Collect Miner": "ドリルから鉱石を回収",
    "Deep Drill": "深層ドリル",
    "DeepDrill.Description": "油田の地下から貴重な資源を採取します。燃料と電力が必要です。",
    "Flamethrower Turret": "火炎放射タレット",
    "FlamethrowerTurret.Description": "標的に対し火炎を放射します。起動には燃料と電力が必要です。",
    "Missile Turret": "ミサイルタレット",
    "MissileTurret.Description": "ロックオンした標的に追尾ミサイルを発射します。",
    "Sulfur Ore": "硫黄鉱石",
    "SulfurOre.Description": "硫黄鉱石です",
    "Explosives": "爆薬",
    "Explosives.Description": "グレネードやミサイルの材料となります。",
    "Missile": "ミサイル",
    "Ammunition for missile turret": "ミサイルタレット用の砲弾です。",
    "open": "開く",
    "close": "閉める",
    "use": "使う",
    "Generates Sulfur Ore": "硫黄鉱石を採掘中",
    "MissileTurret.PlaceAmmunition": "ミサイルを装填してください。",
    "Blue Energy Sword": "ブルーエナジーソード",
    "Red Energy Sword": "レッドエナジーソード",
    "Green Energy Sword": "グリーンエナジーソード",
    "BlueEnergySword.Description": "隕石鉱を鍛えて作られた、特殊な力を生み出す剣です。25のダメージを与えます。",
    "RedEnergySword.Description": "隕石鉱を鍛えて作られた、特殊な力を生み出す剣です。25のダメージを与えます。",
    "GreenEnergySword.Description": "隕石鉱を鍛えて作られた、特殊な力を生み出す剣です。25のダメージを与えます。",
    "Vodka": "ウォッカ",
    "Vodka.Description": "スタミナを40回復します。これがあればロシアは無敵です！",
    "Meteorite": "隕石鉱",
    "Meteor Shower": "隕石の飛来まで",
    "Miasma": "瘴気",
    "Forge": "鍛冶炉",
    "Forge.Description": "武器や宇宙服を作製できます。",
    "Disinfectant": "消毒剤",
    "Disinfectant.Description": "散布することで瘴気を除去できます。",
    "Wrench": "レンチ",
    "Wrench.Description": "建築物を修復できます。",
    "Floor": "床",
    "Floor.Description": "カスタマイズ可能な床です。ダブルクリックで色やテクスチャを変更できます。",
    "Sky": "空",
    "Sky.Description": "空",
    "Water": "水",
    "Water.Description": "水",
    "Oil": "石油",
    "Oil.Description": "石油",
    "Rock": "地面",
    "Rock.Description": "地面",
    "Asteroid": "アステロイド",
    "Asteroid.Description": "アステロイド",
    "Copper Asteroid": "銅鉱石",
    "CopperAsteroid.Description": "銅鉱石",
    "Meteorite Asteroid": "隕石鉱",
    "MeteoriteAsteroid.Description": "隕石鉱",
    "Report Player": "問題のあるプレイヤーを報告",
    "ReportPlayer.Description": "もし %{rules} に記載されているルールに違反していると疑われるプレイヤーを確認した場合はこちらからご報告下さい。報告する際にもし可能であればスクリーンショットを添付してください。理由なく報告を行うことはルール違反であり、あなたのbanに繋がる可能性があります。",
    "Offending user": "違反ユーザーの名前",
    "Description": "説明",
    "Attach screenshot": "スクリーンショットの添付",
    "Assassins Knife": "アサシンナイフ",
    "AssassinsKnife.Description": "通信機に偽装した暗殺用のナイフです。",
    "Radio": "通信機",
    "Radio.Description": "通信機です。死体を発見したらこれを使って通報しましょう。",
    "Bar": "バー",
    "Engine Room": "エンジンルーム",
    "Chemistry Lab": "化学研究室",
    "ExitCamera": "戻る",
    "Camera": "カメラ",
    "Invite": "招待",
    "NeededToStart": "ゲームを始めるには%{count}人のプレイヤーが必要です。",
    "armory": "武器庫",
    "incinerator": "処刑室",
    "Medbay": "医務室",
    "medbay": "医務室",
    "security": "セキュリティ",
    "oxygen_supply": "酸素供給室",
    "prison": "牢獄",
    "corpses": "死体置き場",
    "chemistry": "化学研究室",
    "meeting": "会議室",
    "biology": "生物学研究室",
    "engine": "エンジンルーム",
    "bar": "バー",
    "kitchen": "キッチン",
    "garden": "農業エリア",
    "No player targets available": "付近に襲撃できる相手がいません。",
    "Voted": "投票済",
    "Vote": "投票",
    "votes": "投票",
    "Skip Vote": "投票をスキップ",
    "Vote the Imposter": "スパイと思われる人物に投票せよ",
    "Play Again": "もう一度遊ぶ",
    "Spectate": "観戦する",
    "Total Tasks Completed": "タスクの達成率",
    "Host Private Game": "プライベートゲームを開く",
    "FindTheImposter.Title": "スパイを見つけろ",
    "FindTheImposter.Description": "タスクを完了するか、スパイを追放することでクルーの勝利となります。クルー全員を殺害することでスパイの勝利となります。",
    "CanUseAgain": "%{cooldown} 秒後に使用できます。",
    "No corpses nearby": "付近に死体がありません。",
    "Meeting Room": "会議室",
    "Spawn Area": "スポーンルーム",
    "Oxygen Supply Room": "酸素供給室",
    "Power Switch": "配電盤",
    "PowerSwitch.Description": "複数の電力源をコントロールできます。ON・OFFの切り替えができます。",
    "Terminal": "コンピューター",
    "Terminal.Description": "装飾用のコンピューターです。",
    "Underground Vent": "ダクト",
    "UndergroundVent.Description": "ダクトです。別のダクトに瞬間移動できます。",
    "Lava": "溶岩",
    "Security Camera": "監視カメラ",
    "SecurityCamera.Description": "特定のエリアを監視できます。",
    "Security Monitor": "監視モニター",
    "SecurityMonitor.Description": "監視カメラの映像を確認できます。",
    "Wall Lamp": "ウォールランプ",
    "WallLamp.Description": "周囲を照らします。",
    "Custom": "カスタムカラー",
    "Intensity": "光の強さ",
    "Wood Table": "木のテーブル",
    "WoodTable.Description": "木製のテーブルです。",
    "Wood Chair": "木の椅子",
    "WoodChair.Description": "木製の椅子です。",
    "Domination.Title": "シマ争い",
    "Domination.Description": "他のプレイヤーとチームを組み、敵の基地を破壊しましょう。",
    "Command Blocks": "コマンドブロック",
    "Triggers": "トリガー",
    "Logs": "ログ",
    "Functions": "関数",
    "Function": "関数",
    "Enable Triggers": "トリガーを有効化",
    "New Trigger": "新規のトリガーを追加",
    "Create": "作成",
    "Usage": "使用方法",
    "Function.Usage1": "関数呼び出しは以下の様にお使い下さい。",
    "Function.Usage2": "基本的に、入力した値(上の例ではプレイヤー名)に応じて値(上の例ではそのプレイヤーの所持するGoldの額)を出力します。関数はコマンドやifelse条件で使用できます。",
    "Arguments": "引数",
    "Returns": "戻り値",
    "Tesla Coil":"テスラコイル",
    "TeslaCoil.Description":"最大4体の標的に稲妻を打ちます。起動には電力が必要です。",
    "Bomber Turret":"ボムタレット",
    "BomberTurret.Description":"標的に爆弾を発射します。起動には電力と爆弾が必要です。",
    "Scar17.Description":"高速の弾丸を発射するバーストウェポンです。",
    "Plasma Gun":"プラズマガン",
    "PlasmaGun.Description":"プラズマ弾を発射する武器です。",
    "Plasma Cell":"プラズマ弾",
    "PlasmaCell.Description":"プラズマガン用の弾薬です。",
    "Rocket Launcher":"ロケットランチャー",
    "RocketLauncher.Description":"標的に向かってミサイルを発射する武器です。",
    "Squid Staff":"魔法の杖",
    "SquidStaff.Discription":"一回に5発のエネルギー弾を撃つ武器です。",
    "Tree":"木",
    "Tree.Description":"装飾用の木です。",
    "Christmas Tree":"クリスマスツリー",
    "ChristmasTree.Description":"クリスマスツリーです。",
    "Red Present":"赤色のプレゼント",
    "RedPresent.Description":"赤色のプレゼントボックスです。",
    "Blue Present":"青色のプレゼント",
    "BluePresent.Description":"青色のプレゼントボックスです。",
    "Green Present":"緑色のプレゼント",
    "GreenPresent.Description":"緑色のプレゼントです。",
    "Pocket Trader":"ポケットトレーダー",
    "PocketTrader.Description":"使用する事で貿易商人が付近にいない時でも売買ができます。",
    "Bowl":"ボウル",
    "Bowl.Description":"スープを作るのに使えます。",
    "Omelette":"オムレツ",
    "Fries":"フライドポテト",
    "Potato Soup":"ジャガイモのスープ",
    "Slime Broth":"スライムスープ",
    "Miso Soup":"味噌汁",
    "Energy Drink":"エナジードリンク",
    "EnergyDrink.Description":"飲むと一時的に移動速度が上がります。",
    "Alien Juice":"エイリアンジュース",
    "AlienJuice.Description":"飲むと一時的に透明になります。",
    "Timer Bomb":"時限爆弾",
    "TimerBomb.Description":"設置すると10秒後に爆発します。",
    "Hazmat Suit":"化学防護服",
    "HazmatSuit.Description":"瘴気や毒から身を守ることができます",
    "Prisoner Suit":"囚人服",
    "PrisonerSuit.Description":"囚人用の服です。",
    "Police Suit":"警官服",
    "PoliceSuit.Description":"警官服です。",
    "Lab Coat":"白衣",
    "LabCoat.Description":"研究者用の服です。",
    "Cultist Suit":"カルト信者の服",
    "CultistSuit.Description":"カルト集団のリーダーの服です。",
    "Santa Hat":"サンタの帽子",
    "Name Tag":"名札",
    "Missile.Description":"ミサイルタレット、ロケットランチャー用の弾です。",
    "Events.Alarm":"電球を修理する"
}

},{}],684:[function(require,module,exports){
module.exports={
    "New Colony": "Новая колония",
    "Visit Colony": "Посетить колонию",
    "Tutorial": "Обучение",
    "Starting": "Запускаем игру",
    "Load Game": "Загрузить игру",
    "Login": "Войти",
    "Logout": "Выйти",
    "Back": "Назад",
    "Online": "В сети",
    "Offline": "Не в сети",
    "Initializing": "Инициализация",
    "Last Played At": "Последний раз был в сети в",
    "Public": "Публичная",
    "Private": "Приватная",
    "New Game": "Начать игру",
    "Start Game": "Начать игру",
    "Welcome": "Добро пожаловать",
    "Unable to Find Spawn Position for Trader. Skipping Event": "Невозможно найти точку для спавна торговца. Пропуск события.",
    "Raid Incoming": "Рейд приближается",
    "Spider Infestation": "Вторжение пауков",
    "Respawn": "Возродиться",
    "Iron Ore": "Железная руда",
    "Iron Bar": "Железный слиток",
    "Copper Ore": "Медная руда",
    "Copper Bar": "Медный слиток",
    "Circuit Board": "Микросхемы",
    "Cloth": "Ткань",
    "Sand": "Песок",
    "Glass": "Стекло",
    "Wood": "Дерево",
    "Bottle": "Бутылка",
    "Water Bottle": "Бутылка с водой",
    "Blood Bottle": "Бутылка с кровью",
    "Wire": "Кабель",
    "Potato": "Картофель",
    "Potato Seed": "Картофельное семя",
    "Plant Fiber": "Волокнистое растение",
    "Fiber Seed": "Семя волокнистого растения",
    "Wheat": "Пшеница",
    "Wheat Seed": "Пшеничное семя",
    "Gel": "Гель",
    "Alien Meat": "Мясо пришельца",
    "Animal Meat": "Мясо животного",
    "Human Meat": "Человеческое мясо",
    "Gelatin": "Желе",
    "Steak": "Стейк",
    "Hot Dog": "Хотдог",
    "Vegan Pizza": "Веганская пицца",
    "Slimy Meat Pizza": "Пицца-желе",
    "Beer": "Пиво",
    "Cola": "Кола",
    "First Aid Kit": "Полевая аптечка",
    "Antidote": "Антидот",
    "Stimpack": "Стимулятор",
    "Mop": "Швабра",
    "Pistol": "Пистолет",
    "Shotgun": "Дробовик",
    "Bullet Ammo": "стандартные боеприпасы",
    "Fire Extinguisher": "Огнетушитель",
    "Flame Thrower": "Огнемёт",
    "Lighter": "Зажигалка",
    "Survival Tool": "Мультиинструмент",
    "Drill": "Бур",
    "Katana": "Катана",
    "Space Suit": "Скафандр",
    "Furnace": "Плавильня",
    "Butcher Table": "Разделочный стол",
    "Stove": "Печь",
    "Brewery": "Варочный аппарат",
    "Chemistry Station": "Химическая станция",
    "Mining Drill": "Буровая установка",
    "Ammo Printer": "Машина по производству боеприпасов",
    "Refinery": "Очистительная станция",
    "Wall": "Стена",
    "Spike Trap": "ШИпастая ловушка",
    "Manual Airlock": "Ручной воздушный шлюз",
    "Airlock": "Воздушный шлюз",
    "Lamp": "Лампочка",
    "Steel Crate": "Металлический ящик",
    "Water Pump": "Водный насос",
    "Liquid Pipe": "Жидкостная труба",
    "Liquid Tank": "Жидкостный бак",
    "Suit Station": "Подпиточная станция",
    "Beacon": "Маяк",
    "Mini Turret": "Мини-турель",
    "Air Alarm": "Воздушная сигнализация",
    "Ventilator": "Вентиляция",
    "Oxygen Generator": "Генератор кислорода",
    "Small Oxygen Tank": "Маленькое хранилище кислорода",
    "Gas Pipe": "Газовая труба",
    "Bed": "Кровать",
    "Table": "Стол",
    "Trading Table": "Стол торговца",
    "Chair": "Стул",
    "Cage": "Сетка",
    "Television": "телевизор",
    "Pot": "Горшок",
    "Lattice": "Решётка",
    "Steel Floor": "Стальной пол",
    "Soil": "Грядка",
    "Wood Floor": "Паркет",
    "Carpet Floor": "Ковёр",
    "Tiled Floor": "Плитка",
    "Purple Floor": "Пурпурный пол",
    "Plated Floor": "Решётчатый пол",
    "Stripe Plated Floor": "Линейчатый пол",
    "Green Floor": "Зелёный пол",
    "Rail Track": "Рельсы",
    "Rail Stop": "Железнодорожная станция",
    "Oil Refinery": "Нефтеперерабатывающая станция",
    "Power Generator": "Генератор",
    "Fuel Pipe": "Топливная труба",
    "Fuel Tank": "Хранилище топлива",
    "Solar Panel": "Солнечная панель",
    "Lava": "Лава",
    "Lava.Description": "Лава",
    "Sky": "Пустота",
    "Sky.Description": "Пустота",
    "Asteroid": "Астероид",
    "Asteroid.Description": "Астероид",
    "Rock": "Камень",
    "Rock.Description": "Камень",
    "Copper Asteroid": "Медный астероид",
    "Meteorite Asteroid": "Метеоритный астероид",
    "Remaining": "Осталось",
    "Owner": "Хозяин",
    "Stored": "Хранится",
    "Production": "Производство",
    "Power Needed": "Требуется энергии",
    "Slime": "Слизень",
    "Slime Corpse": "Тело слизня",
    "Brood": "Рой",
    "Brood Corpse": "Тело роя",
    "Spider": "Паук",
    "Spider Corpse": "Тело паука",
    "Monkey": "Обезьяна",
    "Monkey Corpse": "Тело обезьяны",
    "Chicken": "Курица",
    "Chicken Corpse": "Тело курицы",
    "Clean Bot": "Робот-пылесос",
    "Clean Bot Corpse": "Тело Робот-пылесос",
    "Trader": "Торговец",
    "Empire": "Империя",
    "Guard": "Стражник",
    "Chemist": "Химик",
    "Chemist Corpse": "Тело химика",
    "Messenger": "Посол",
    "Messenger Corpse": "Тело посла",
    "O2": "О2",
    "Crafting": "Создание",
    "Ingredients": "Материалы",
    "Suit": "Костюм",
    "Inventory": "Инвентарь",
    "Map": "Карта",
    "Colony": "Колония",
    "Name": "Название",
    "Location": "Местонахождение",
    "Members": "Участники",
    "Days Alive": "Дней прожито",
    "Alliance": "Союз",
    "Status": "Статус",
    "Friendly": "Дружба",
    "Neutral": "Нейтралитет",
    "Hostile": "Вражда",
    "Relationship": "Отношение",
    "Insufficient Power": "Недостаточно энергии",
    "Generates Iron Ore": "Добывает железную руду",
    "Resume": "Продолжить",
    "Settings": "Настройки",
    "Exit Game": "Выйти из игры",
    "Sound": "Звук",
    "Volume": "Громкость",
    "Controls": "Управление",
    "Move Up": "Двигаться вверх",
    "Move Left": "Двигаться влево",
    "Move Down": "Двигаться вниз",
    "Move Right": "Двигаться вправо",
    "Rotate": "Вращать",
    "Craft": "Создать",
    "Interact": "Взаимодействие",
    "Attack": "Атака",
    "Chat": "Чат",
    "Camera Mode": "Режим камеры",
    "Stats View": "Статистика",
    "Press Any Key": "Нажмите любую клавишу",
    "Trade": "Торговать",
    "Sell": "Продать",
    "Confirm": "Подтвердить",
    "Needs Fuel": "Требуется топливо",
    "Bullet Ammo Required": "Необходимы патроны",
    "Destination": "Пункт назначения",
    "Go": "В путь",
    "No Passengers on Tram": "На платформе никого нет",
    "Web": "Паутина",
    "Web Trap": "Липкая ловушка",
    "Sign": "Табличка",
    "Happiness": "Счастье",
    "Make Pet": "Сделать питомцем",
    "Place ore in left slot to refine gold": "鉱石を左のスロットに入れるとGoldの鋳造が始まります",
    "You Died": "Вы умерли",
    "Blood Pack": "Пакет с кровью",
    "Lead Pipe": "Свинцовая труба",
    "Cryo Tube": "Криогенная капсула",
    "Oxygen Tank": "Хранилище кислорода",
    "Generates Copper Ore": "Добывает медную руду",
    "Buy": "Купить",
    "New": "Новые",
    "ColonyName": "Название",
    "ColonyDay": "День",
    "ColonyOnline": "В сети",
    "PlayersOnline": "В сети",
    "TutorialWelcomeMessage": "Right now, its just a sample base that shows how to power things up, how to oxygenate a room, etc. Open the Crafting Menu [C] to see what each structure does",
    "Potato.Description": "Основная еда для выживания",
    "PotatoSeed.Description": "Посадите это на грядку, чтобы вырастить картофель",
    "PlantFiber.Description": "Широко спользуется в медицине",
    "FiberSeed.Description": "Посадите это на грядку, чтобы вырастить волокнистое растение",
    "Wheat.Description": "Сырая пшеница. Из неё делают хлеб",
    "WheatSeed.Description": "Посадите это на грядку, чтобы вырастить пшеницу.",
    "Gel.Description": "Может быть приготовлен, чтобы сделать желе",
    "AlienMeat.Description": "Сырое мясо пришельца, Пожарьте, перед тем как есть",
    "AnimalMeat.Description": "Сырое мясо животного. Очень вкусное, если приготовить",
    "HumanMeat.Description": "Сырое человеческое мясо. Не ешь это",
    "Gelatin.Description": "Хороший источник протеина. Объеденье",
    "Steak.Description": "Приготовленное мясо. Не беспокойся о том, откуда оно",
    "HotDog.Description": "Приготовленное мясо животного. Типичная для американца еда",
    "VeganPizza.Description": "Пицца для веганов",
    "SlimyMeatPizza.Description": "Экзотическая пицца, сделана из слизня и животного мяса",
    "LectersDinner.Description": "Приготовленное человеческое мясо.Любимое блюдо Ганнибала Лектера",
    "Beer.Description": "Восстанавливает 30 очков бодрости. МинЗдрав предупреждает! Чрезмерное употребление алкогольных напитков вредит Вашему здоровью.",
    "Cola.Description": "Восстанавливает 10 очков бодрости.",
    "FirstAidKit.Description": "Восстанавливает 50 очков здоровья",
    "Antidote.Description": "Выводит яд",
    "BloodPack.Description": "Восстанавливает 50 очков здоровья",
    "Stimpack.Description": "Doubles Attack Speed for 15 seconds. Reduces health by 25",
    "Entity.Health": "Здоровье",
    "PlantGrowth": "Выросло",
    "DayCount": "День %{day}",
    "HourCount": "Час %{hour}",
    "LeadPipe.Description": "Базовое оружие ближнего боя. Урон 7",
    "Mop.Description": "Инструменты для мытья пола",
    "Pistol.Description": "Оружие дальнего боя. Урон 10",
    "Shotgun.Description": "Оружие с широким радиусом поражения, наносящее урон в 12 очков",
    "FireExtinguisher.Description": "Тушит огонь",
    "FlameThrower.Description": "Стреляет огнём",
    "Bottle.Description": "Позволяет собирать жидкости",
    "Lighter.Description": "Поджигает предметы. Можно заполнить при помощи топливного бака",
    "SurvivalTool.Description": "Используется для добычи ресурсов и разборке построек. Урон 2",
    "Drill.Description": "Позволяет копать быстрее и пронзать небеса. Урон 5",
    "Katana.Description": "Может проткнуть одновременно 3 врагов. Урон 10",
    "SpaceSuit.Description": "Наденьте это в космосе, во избежание удушения",
    "Furnace.Description": "Переплавляет руду в разные вещи",
    "ButcherTable.Description": "Позволяет разделывать мёртвые тела для получения мяса и других ресурсов",
    "Stove.Description": "Приготовьте свою еду с её помощью",
    "Brewery.Description": "Приготовьте коктейль и утолите жажду",
    "ChemistryStation.Description": "Позволяет делать наркотики и лекарста",
    "MiningDrill.Description": "Автоматически добывает руду из-под земли",
    "AmmoPrinter.Description": "Производит боеприпасы для оружия",
    "Refinery.Description": "Превращает руды в золото",
    "Wall.Description": "Воздухонепроницаемая структура для изоляции комнаты",
    "SpikeTrap.Description": "Джонни, Они на деревьях!",
    "ManualAirlock.Description": "Воздухонепроницаемая дверь.Не требует энергии для работы",
    "Airlock.Description": "Воздухонепроницаемая дверь, которая удерживает кислород внутри помещения",
    "Lamp.Description": "Освещает территорию вокруг себя",
    "WaterPump.Description": "Добывает воду. Должен быть помещён в непосредственной близости к источнику воды и соединён трубами",
    "LiquidPipe.Description": "Транспортирует жидкость между двумя составляющими",
    "LiquidTank.Description": "Хранилище для жидкости",
    "CryoTube.Description": "Сохраняет живие организмы для лечения",
    "SuitStation.Description": "Оставьте здесь свою броню/костюм",
    "Beacon.Description": "Играет роль точки появления для посетителей",
    "MiniTurret.Description": "Охраняющая турель. Требует энергию и боеприпасы. Урон:15",
    "AirAlarm.Description": "Бьёт тревогу, если в комнате нет кислорода",
    "Ventilator.Description": "Впускает, но не выпускает воздух. Должна быть подключена газовыми трубами",
    "OxygenGenerator.Description": "Превращает воду в кислород",
    "SmallOxygenTank.Description": "Хранит небольшое количество кислорода. Должно быть подключено газовыми трубами",
    "GasPipe.Description": "Транспортирует кислород между двумя составляющими",
    "Bed.Description": "Восстанавливает бодрость Игрока. Также является точкой возрождения",
    "Table.Description": "Декоративный стол",
    "TradingTable.Description": "Построй, чтобы привлечь торговцев",
    "Chair.Description": "Декоративный стул",
    "Cage.Description": "Используется для обеспечения безопасности прирученных животных/пришельцев",
    "Television.Description": "Декоративный телевизор",
    "Pot.Description": "Декоративное вместилище растений/цветов",
    "Lattice.Description": "Лёгкая поддержка для наружних построек. Can only be placed outside asteroid area",
    "SteelFloor.Description": "Стальной пол",
    "Soil.Description": "Используется для выращивания овощей и других культур",
    "WoodFloor.Description": "Паркет",
    "CarpetFloor.Description": "Ковёр",
    "TiledFloor.Description": "Плитка",
    "PurpleFloor.Description": "Пурпурный пол",
    "PlatedFloor.Description": "Решётчатый пол",
    "StripePlatedFloor.Description": "Линейчатый пол",
    "GreenFloor.Description": "Зелёный пол",
    "RailTrack.Description": "Платформа для вагонетки",
    "RailStop.Description": "Играет роль начальной/конечной точки для вагонеток. Должна находиться на конце железнодорожного пути",
    "Wire.Description": "Транспортирует энергию к постройкам",
    "OilRefinery.Description": "Добывает нефть из земли и генерирует химическое топливо",
    "PowerGenerator.Description": "Производит энергию, используя химическое топливо",
    "FuelPipe.Description": "Транспортирует топливо между двумя составляющими",
    "FuelTank.Description": "Хранит топливо",
    "AllianceName": "Название",
    "taxes_not_paid.Description": "Неуплата налогов",
    "cannibalism.Description": "Съедение имперских солдат",
    "extreme_cannibalism.Description": "Было съедено огромное количество солдат Империи",
    "RailStationName": "Название станции",
    "WebTrap.Description": "Ловушка, которая обездвиживает врагов на 5 секунд.",
    "Sign.Description": "Показывать редактируемый текст игрокам.",
    "RifleAmmo.Description": "Боеприпасы для штурмовой винтовки",
    "Grenade.Description": "Метательное оружие, наносящее урон взрывом.",
    "PoisonGrenade.Description": "Метательное оружие, распространяющее яд вокруг места взрыва.",
    "Web.Description": "Липкая. Полезно для поимки жертвы.",
    "Gold.Description": "[Deprecated] Currency",
    "to save your progress": "Чтобы сохранить свой прогресс",
    "SurvivalWelcomeMessage": "Создайте свою колонию и постройте космический замок. Враги появляются ночью.",
    "IronBar.Description": "Железный слиток",
    "CopperBar.Description": "Медный слиток",
    "CircuitBoard.Description": "Микросхемы",
    "Cloth.Description": "Используется для создания мебели и брони",
    "Sand.Description": "Используется для создание некоторых предметов",
    "Glass.Description": "Стекло",
    "Water": "Вода",
    "Wood.Description": "Используется для создания мебели",
    "Assault Rifle": "Штурмовая винтовка",
    "Bio Raptor": "Биораптор",
    "Bio Raptor Corpse": "Тело биораптора",
    "Car": "машина",
    "Car Corpse":"труп автомобиля",
    "SteelCrate.Description": "Хранилище для предметов",
    "SolarPanel.Description": "Производит энергию, используя Солнечную энергию. Can only be placed on Lattice",
    "Messenger.DemandPayment": "Империя требует денежную плату, в качестве знака лояльности!",
    "Messenger.RightChoice": "Вы сделали правильный выбор",
    "Messenger.Blasphemy": "Это Богохульство!",
    "Messenger.Choices.ProceedPay": "Заплатить %{gold} Империи",
    "Messenger.Choices.RefusePay": "Не платить налоги",
    "Shotgun Shell": "Дробь",
    "Rifle Ammo": "Винтовочный патрон",
    "Livestock": "скот",
    "WaterBottle.Description": "Бутылка с водой",
    "BloodBottle.Description": "Бытулка с кровью",
    "BulletAmmo.Description": "Боеприпасы для пистолета/турели",
    "OutdatedGameClient": "Версия Вашей игры устарела. Пожалуйста, обновите страницу в браузере.",
    "NetworkOutdatedGameClient": "Невозможно загрузить определение сетевого протокола. Игровой клиент, должно быть, устарел",
    "Escape Pod": "Спасательая капсула",
    "Core": "Ядро",
    "Core.Description": "Источник энергии. 500 w",
    "Connecting": "Подключение",
    "DisconnectedReconnecting": "Отключено.Переподключение через ",
    "Taming": "Приручение",
    "Following": "Следование",
    "Take Along": "Взять с собой",
    "Release": "Отпустить",
    "Message": "Сообщение",
    "Done": "Готово",
    "Edit": "Редактировать",
    "Cancel": "Отмена",
    "Cook": "Готовить",
    "Brew": "Варить",
    "Place Ammunition": "Поместите боеприпасы",
    "MatchmakerUnavailable": "Матчмейкер недоступен. Перезагрузите страницу и попробуйте снова.",
    "Relationship.EmpireFriendly": "Империя дружелюбна по отношению к Вам",
    "Relationship.EmpireNeutral": "Империя нейтральна по отношению к Вам",
    "Relationship.EmpireHostile": "Империя объявила Вас своим врагом",
    "Oil": "Нефть",
    "Potato Plant": "Картофель",
    "Fiber Plant": "Хлопок",
    "Wheat Plant": "Пшеница",
    "Lecters Dinner": "Обед каннибала",
    "Game Settings": "Игровые настройки",
    "Zoom In": "Приблизить",
    "Zoom Out": "Отдалить",
    "ShotgunShell.Description": "Боеприпасы для дробовика",
    "Make Livestock": "Сделать скотом",
    "Events.TaxCollection": "Имперский сборщик налогов появился",
    "Events.RaidWarning": "Рейд приближается",
    "Events.Raid": "Рейд",
    "Events.RaidEnd": "Рейд окончен",
    "Events.TraderArrived": "Прибыл торговец",
    "Events.SlaveTraderArrived": "Прибыл торговец",
    "Events.SpiderInfestation": "Вы разбудили пауков",
    "Events.MeteorShower": "Meteor Shower",
    "Shotgun Shells Required": "Необходима дробь",
    "Rifle Ammo Required": "Необходимы винтовочные патроны",
    "Corpse Required": "необходимо тело",
    "Background Volume": "Громкость заднего фона",
    "Effects Volume": "Громкость эффектов",
    "No Saves Found": "Сохранения не найдены",
    "Partners": "Партнёры",
    "Privacy": "Соглашение",
    "Credits": "Авторы",
    "Rules": "Правила",
    "Inventory Full": "Инвентарь переполнен",
    "Mining not allowed when owner is offline": "Копать запрещено, хозяин не в сети",
    "You are not allowed to use flamethrower": "Вам не разрешено использовать огнемёт",
    "You dont have building permissions": "У Вас нет прав на строительство",
    "That doesnt belong to you": "Это не твоё",
    "You dont have storage viewing permissions": "Вам запрещено смотреть наполнение хранилищ",
    "Invalid Item": "Неподходящий предметы",
    "You just ate": "Жуй медленнее",
    "Not enough Gold": "Нужно больше золота",
    "Not enough inventory to store gold": "Недостаточно места, чтобы складывать золото",
    "Not enough items available": "Недостаточно материалов",
    "Bot Limit Reached": "Достигнут лимит роботов",
    "Pet Limit Reached": "Достигнут лимит питомцев",
    "Insufficient Blood": "Недостаточно крови",
    "Taming Limit Reached": "Достигнут лимит приручений",
    "The Spiders have been left in peace": "Сообщение показано когда пауки снова засыпают из-за потери буровых машин.",
    "Rail Network is currently in use": "Железнодорожная линия уже кем-то используется",
    "Player.Kicked": "Вы были кикнуты из игры",
    "ButcherTable.HarvestFailure": "Не удалось извлечь какое-либо мясо или органы",
    "AssaultRifle.Description": "Автоматическое огнестрельное оружие, стреляет короткими очередями",
    "Entity.Mob.Health": "здоровье",
    "OxygenTank.Description": "Хранит кислород. Должно быть подключено газовыми трубами",
    "Grenade": "Граната",
    "AssignedRole": "Вас перевели в %{roleName}",
    "GuestRole": "Вас перевели в гости",
    "MemberRole": "Вас перевели в участники",
    "Visibility": "Видимость",
    "You are running out of oxygen": "У Вас критический уровень кислорода",
    "You are tired and restless": "Вы устали и должны поспать",
    "You are feeling hungry": "Вы голодны",
    "IronOre.Description": "Железная руда",
    "CopperOre.Description": "Медная руда",
    "VisitOtherColony": "Посетить другие колонии",
    "Visit": "Посетить",
    "RestartIn": "Возрождение через %{number}",
    "Guard Corpse": "Тело стражника",
    "MemberList": "Участники",
    "Days": "Дней",
    "Poison Grenade": "Ядовитая граната",
    "Yes": "Да",
    "No": "Нет",
    "Access Denied": "Отказано в доступе",
    "Sealed Door": "Запертая дверь",
    "SealedDoor.Description": "Дверь",
    "Unreachable": "Отсюда не достать",
    "Permissions": "Разрешения",
    "Storage Access": "Доступ к хранилищам",
    "Asteroid Mining": "Добыча астероидов",
    "DemoteMembersPermission": "Сделать всех участников гостями, когда хозяин покидает игру",
    "Everyone": "Все",
    "ColonyLeaveConfirmMessage": "Ваша колония будет удалена, так как Вы не зарегистрированы",
    "Permission": "Разрешение",
    "AllowMembers": "участникам",
    "AllowEveryone": "всем",
    "Send Money": "Отправить деньги",
    "To": "Кому",
    "Send": "Отправить",
    "Top": "Топ",
    "MineColony": "Мои",
    "AnonymousGameWarning": "[Внимание] Эта колония не будет сохранена. Войдите в аккаунт или зарегистрируйтесь, чтобы сохранить свой прогресс.",
    "ColonyFull": "Колония переполнена",
    "Save and Quit": "Сохранить и выйти",
    "Info": "Информация",
    "Player.Banned": "Вы были забанены в игре",
    "Combat Armor": "Боевая броня",
    "CombatArmor.Description": "Отлично подходит для ближнего боя. Уменьшает получаемый урон на 4.",
    "No results": "Ничего не найдено",
    "You dont have permission to sell": "У Вас нет разрешения на продажу",
    "Items": "Предметы",
    "Manage": "Управление",
    "VendingStorage":"Хранилище",
    "Purchase":"Применить",
    "VendingEmpty": "Пусто",
    "Balance": "Баланс",
    "Deposit": "Внести",
    "Withdraw": "Изъять",
    "Large Table": "Большой стол",
    "LargeTable.Description": "Большой декоративный стол",
    "Food Vending Machine": "Торговый автомат с едой",
    "Drinks Vending Machine": "Торговый автомат с напитками",
    "Yellow Floor": "Жёлтый пол",
    "Bronze Floor": "Бронзовый пол",
    "Blue Floor": "Синий пол",
    "Gray Floor": "Серый пол",
    "Grass Floor": "Трава",
    "Pink Floor": "Розовый пол",
    "YellowFloor.Description": "Слава Солнцу!",
    "BronzeFloor.Description": "Бронзовый пол",
    "BlueFloor.Description": "Синий пол",
    "GrayFloor.Description": "Серый пол. Ничем не выделяется",
    "GrassFloor.Description": "Теперь Вы можете устраивать пикники на лужайке, возле своей космической дачи!",
    "PinkFloor.Description": "Розовый пол. Выглядит мило.",
    "FoodVendingMachine.Description":"Хранит и продаёт пищу",
    "DrinksVendingMachine.Description":"Хранит и продаёт напитки",
    "Atm.Description":"Снимайте и кладите деньги на счёт своего аккаунта.",
    "BoughtTooMuch": "Вы сделали слишком много покупок сегодня. Попробуйте завтра.",
    "AdminRole": "Теперь Вы админ.",
    "Coffee Seed": "Кофейное семя",
    "CoffeeSeed.Description": "Посадите на грядку, чтобы вырастить кофе.",
    "Sunflower Seed": "Подсолнечное семя",
    "SunflowerSeed.Description": "Посадите на грядку, чтобы вырастить подсолнух.",
    "Blue Seed": "Голубой семя",
    "Poppy Seed": "Маковое семя",
    "PoppySeed.Description": "Посадите на грядку, чтобы вырастить мак.",
    "Coffee": "Кофе",
    "Coffee.Description": "Восстанавливает 50 очков усталости.",
    "Coffee Bean": "Кофейное зерно",
    "CoffeeBean.Description": "Ингридиент для приготовления кофе.",
    "Coffee Plant": "Кофейный росток",
    "CoffeePlant.Description": "С него можно получить кофейные зёрна.",
    "Sunflower": "Подсолнух",
    "Sunflower.Description": "Цветок, который можно посадить в горшок.",
    "Poppy": "Мак",
    "Poppy.Description": "Цветок, который можно посадить в горшок.",
    "Blue Lotus": "Голубой лотос",
    "BlueLotus.Description": "Цветок, который можно посадить в горшок.",
    "SunflowerSeed.Description": "Посадите на грядку, чтобы вырастить подсолнух",
    "BlueSeed.Description": "Посадите на грядку, чтобы вырастить голубой лотос",
    "PoppySeed.Description": "Посадите на грядку, чтобы вырастить мак",
    "Flower Required": "Нужен цветок",
    "Ivory Wall": "Слоновая кость",
    "IvoryWall.Description": "Белая стена. Не переживайте, ни один слон не пострадал.",
    "Green Wall": "Зелёная стена",
    "GreenWall.Description": "Зелёный цвет помогает глазам расслабиться.",
    "Blue Wall": "Синяя стена",
    "BlueWall.Description": "Синяя стена",
    "Favorite": "Любимые",
    "Favorites": "Любимые",
    "Farm Controller": "Фермерский контроллер",
    "FarmController.Description":"Поставьте возле почвы. Информирует работников о том, какие культуры им выращивать.",
    "Slavers Table": "Стол работорговца",
    "SlaversTable.Description":"Постройте, чтобы привлечь работорговца.",
    "Slave Trader": "Работорговец",
    "Trade Slaves": "Торговать рабами",
    "Nuu Slave": "Ниииит",
    "Pixi Slave": "Пикси",
    "Garam Slave": "Гарам",
    "Slave Limit Reached": "Достигнут лимит рабов",
    "ChooseCrop":"[E] выбрать культуру",
    "Choose Crop to Grow": "Выберите культуру для посадки",
    "Plant Seed": "Посадить семя",
    "Water Crop": "Полив растений",
    "Harvest Crop": "Сборка урожая",
    "Butcher Corpse": "Разделка тел",
    "Cook": "Готовка",
    "Refill Turret": "Зарядка турели",
    "Tasks": "Задачи",
    "FarmControllerTip": "Чтобы рабы могли сажать растения неподалёку должно быть хранилище",
    "Play": "Играть",
    "Walkthrough.movement": "Передвигайтесь, используя клавиши <b>w</b>,<b>a</b>,<b>s</b>,<b>d</b>",
    "Walkthrough.mining": "Пройдите в комнату 2 и <b>добудьте 10 железной руды</b>, нажав на астероид",
    "Walkthrough.lead_pipe": "Откройте меню создания предметов, нажав <b>C</b>. Создайте <b>свинцовую трубу</b>",
    "Walkthrough.release_guard": "Пройдите в комнату 3 и <b>выпустите стражника</b> из криогенной капсулы. Чтобы сделать это, выделите криокаспулу и нажмите <b>E</b>",
    "Walkthrough.kill_guard": "Убейте стражника",
    "Walkthrough.grab_potatoes": "Пройдите в комнату 4 и <b>возьмите картофель</b> из синего металлического ящика",
    "Walkthrough.eat_potatoes": "<b>Съешьте картошку</b> для восстановления сытости",
    "Walkthrough.player_permissions": "Измените роль Dummy Player'а, нажав на него и выбрав нужное значение в <b>выпадающем списке</b>",
    "Walkthrough.dismantle": "Возьмите свой мультиинструмент и <b>демонтируйте металлический ящик</b>, выделив его и зажав левую кнопку мыши до того момента, как он не сломается",
    "Walkthrough.tame_slime": "<b>Приручите слизня</b>, скормив ему картофель. Чтобы сделать это, подойдите к слизню, взяв в руки картофель",
    "Walkthrough.kill_slime": "Убейте другого слизня",
    "Walkthrough.butcher_slime": "Возьмите труп слизня, выделив его и нажав <b>E</b>. Пройдите и используйте <b>разделочный стол</b>, чтобы разделить труп",
    "Walkthrough.cook_slime": "<b>Приготовьте из геля желе</b>, используя печь",
    "Walkthrough.sleep": "Пройдите в следущую комнату и <b>отдохните на своей кровати</b>, чтобы восстановить выносливость",
    "Walkthrough.zoom": "Изменяйте масштаб, нажимая <b>-</b> или <b>=</b>",
    "Walkthrough.suit_station": "Заберите <b>скафандр</b> из стойки для скафандров",
    "Walkthrough.collect_water": "Пройдите в следующую комнату. У генератора кислорода пока что отсутствует источник воды. Вы можете заполнить запасы воды в генераторе, используя бутылку с водой. <b>Возьмите бутылку</b> из спасательной капсулы и возьмите воду из жидкостного бака",
    "Walkthrough.fill_oxygen_generator": "<b>Заполните генератор кислорода</b> водой. В комнате теперь должен быть кислород",
    "Walkthrough.refill_space_suit": "Вы так же можете заполнить запасы кислорода в вашем скафандре, выделив генератор кислорода и нажав <b>E</b>",
    "Walkthrough.craft_iron_bar": "Мы можем автоматизировать процесс генерации кислорода. Просто подсоедините жидкостную трубу, ведущую из бака, к генератору кислорода. <b>Создайте несколько железных слитков</b>, используя <b>плавильню</b>. Вам понадобится железная руда, которую вы можете взять из спасательной капсулы",
    "Walkthrough.craft_liquid_pipe": "Создайте <b>жидкостную трубу</b>",
    "Walkthrough.connect_liquid_pipe": "<b>Подведите жидкостную трубу</b> к генератору кислорода от жидкостного бака",
    "Walkthrough.rail_tram": "Поздравляем. Комната теперь наполнена кислородом. Покиньте комнату и используйте <b>железнодорожную станцию</b>, чтобы попасть на ферму.",
    "Walkthrough.plant_seed": "<b>Возьмите пшеничное семя</b> из спасательной капсулы и посадите его на грядку.",
    "Walkthrough.water_crop": "Используйте свою бутылку, чтобы собрать воду из озера и <b>полить грядки</b> с семенами. Это ускоряет рост растений",
    "Walkthrough.farm_controller": "Рабы могут автоматизировать ферму. Вам нужно <b>построить фермерский контроллер</b> рядом с грядкой. Возьмите его из спасательной капсулы.",
    "Walkthrough.select_wheat": "Выделите фермерский контроллер и откройте его меню. Измените целевую культуру для посадки на <b>пшеницу</b>",
    "Walkthrough.end": "Рабы теперь должны садить пшеничные семена, если они доступны в хранилище. Они так же будут поливать неполитые растения, если они смогут найти бутылку в хранилище неподалёку.",
    "AskTutorialMessage": "Возможно, вы хотите сначала пройти обучение? Оно рекомендовано новым игрокам.",
    "TutorialCreateNewColonyMessage": "Поздравляем! Вы завершили обучение. Желаете ли вы сейчас создать свою колонию?",
    "StoveSlaveNotice": "Рабы будут готовить только эту еду",
    "Targets": "Цели",
    "MobTarget": "Мобы",
    "PlayerTarget": "Игроки",
    "RoleName": "Имя",
    "Choose a Game Mode": "Выберите режим игры",
    "Sandbox": "Песочница",
    "Peaceful": "Мирный",
    "Survival": "Выживание",
    "Hardcore": "Хардкор",
    "PeacefulModeDescription": "Нет рейдов. Нет налогов. Прекрасно для постройки баз или ролевых игр.",
    "SurvivalModeDescription": "Рейды в случае неуплаты налогов. Прекрасно для небольшого испытания.",
    "HardcoreModeDescription": "Рейды ежедневно. Враги становятся сильнее с каждым разом. Выживите столько, сколько сможете.",
    "GameModeWarning": "Вы не сможете изменить режим игры позже.",
    "AcceptDecide": "Принять",
    "Accept": "Принять",
    "MissileTurret.PlaceAmmunition": "Поместите боеприпасы",
    "ExitCamera": "Выйти",
    "Scar17.Description": "Автоматическое огнестрельное оружие, стреляет короткими очередями",
    "Plasma Gun": "Плазмапушка",
    "PlasmaGun.Description": "Оружие, стреляющее концентрированной энергией",
    "Rocket Launcher": "Ракетница",
    "RocketLauncher.Description": "Стреляет в врага ракетами",
    "Squid Staff": "Посох кальмара",
    "SquidStaff.Description": "Стреляет 5 энергетическими снарядами",
    "Disinfectant": "Дезинфектор",
    "Disinfectant.Description": "Очищает площадь. Удаляет миазмы.",
    "Wrench": "Гаечный ключ",
    "Wrench.Description": "Чинит постройки",
    "Pocket Trader": "Карманный торговец",
    "PocketTrader.Description": "Покупка/продажа вещей",
    "Bowl": "Миска",
    "Bowl.Description": "Используется для приготовления супов",
    "Forge": "Кузница",
    "Forge.Description": "Нужна для изготовления продвинутого оружия и брони",
    "Deep Drill": "Глубокий бур",
    "DeepDrill.Description": "Добывает редкие ресурсы из нефти под землёй. Требует топливо и энергию.",
    "Fence": "Забор",
    "Fence.Description": "Дверь, не пропускающая питомцев/роботов/рабов, но пропускающая игроков",
    "Wall Lamp": "Настенная лампа",
    "WallLamp.Description": "Освещает территорию вокруг себя",
    "Underground Vent": "Подземная вентиляция",
    "UndergroundVent.Description": "Подземная вентиляция",
    "Security Camera": "Камера безопасности",
    "SecurityCamera.Description": "Видит определённую площадь.",
    "Security Monitor": "Монитор камер",
    "SecurityMonitor.Description": "Позволяет смотреть в камеры.",
    "Flamethrower Turret": "Турель-огнемёт",
    "FlamethrowerTurret.Description": "Стреляет огнём во врагов. Требует топливо и энергию.",
    "Missile Turret": "Ракетная турель",
    "MissileTurret.Description": "Стреляет во врагов самонаводящимися ракетами.",
    "Tesla Coil": "Катушка Теслы",
    "TeslaCoil.Description": "Атакует молниями до 4 врагов.",
    "Bomber Turret": "Турель-бомбардировщик",
    "BomberTurret.Description": "Взорвите своих врагов с помощью этой мощной турели.",
    "Wood Table": "Деревянный стол",
    "WoodTable.Description": "Деревянный стол",
    "Wood Chair": "Деревянный стул",
    "Wood Chair.Description": "Деревянный стул",
    "Terminal": "Терминал",
    "Terminal.Description": "Декоративный компьютерный терминал",
    "Tree": "Ёлка",
    "Tree.Description": "Ёлка",
    "Christmas Tree": "Рождественская ёлка",
    "ChristmasTree.Description": "Рождественская ёлка",
    "Red Present": "Красный подарок",
    "RedPresent.Description": "Красный подарок",
    "Blue Present": "Синий подарок",
    "BluePresent.Description": "Синий подарок",
    "Green Present": "Зелёный подарок",
    "GreenPresent.Description": "Зелёный подарок",
    "Floor": "Пол",
    "Floor.Description": "Настраиваемый пол. Сделайте двойной клик для открытия меню изменения цвета и текстуры",
    "Power Switch": "Переключатель питания",
    "PowerSwitch.Description": "Контролирует несколько источников энергии. Может включать и выключать их.",
    "Assassins Knife": "Нож киллера",
    "AssassinsKnife.Description": "Выглядит как радио, но на самом деле является ножом.",
    "Radio": "Радио",
    "Radio.Description": "Средство коммуникации. Сообщайте о подозрительной активности.",
    "Emergency Button": "Кнопка экстренной тревоги",
    "EmergencyButton.Description": "Вызывает экстренную тревогу.",
    "Bread": "Хлеб",
    "Bread.Description": "Вкусный завтрак",
    "Omelette": "Омлет",
    "Omelette.Description": "Лучший завтрак",
    "Fries": "Картофель фри",
    "Fries.Description": "Вкусный картофель фри",
    "Potato Soup": "Картофельный суп",
    "PotatoSoup.Description": "Здоровое и роскошное блюдо на завтрак",
    "Slime Broth": "Бульон из слизняка",
    "SlimeBroth.Description": "Неприукрашенный, но съедобный суп. Кто бы знал, что твой питомец может утолить твой голод?",
    "Miso Soup": "Суп мисо",
    "MisoSoup.Description": "Простой, но вкусный суп. Не обожгите язык!",
    "Egg": "Яйцо",
    "Egg.Description": "Хороший источник протеина",
    "Blue Energy Sword": "Синий энергетический меч",
    "BlueEnergySword.Description": "Энергетический меч, выплавленный из метеорита. Урон 25",
    "Green Energy Sword": "Зелёный энергетический меч",
    "GreenEnergySword.Description": "Энергетический меч, выплавленный из метеорита. Урон 25",
    "Red Energy Sword": "Красный энергетический меч",
    "RedEnergySword.Description": "Энергетический меч, выплавленный из метеорита. Урон 25",
    "Hazmat Suit": "Костюм химзащиты",
    "HazmatSuit.Description": "Защищает от внешних угроз (миазмы, яд)",
    "Prisoner Suit": "Костюм заключенного",
    "PrisonerSuit.Description": "Одежда заключенного",
    "Police Suit": "Костюм полицейского",
    "PoliceSuit.Description": "Одежда полицейского",
    "Lab Coat": "Халат лаборанта",
    "LabCoat.Description": "Одежда учёного",
    "Cultist Suit": "Костюм культиста",
    "CultistSuit.Description": "Одежда лидера культа",
    "Energy Drink": "Энергетический напиток",
    "EnergyDrink.Description": "Даёт эффект спешки.",
    "Alien Juice": "Инопланетный сок",
    "AlienJuice.Description": "Даёт эффект невидимости.",
    "Vodka": "Водка",
    "Vodka.Description": "Восстанавливает 40 выносливости. Сделайте Россию снова великой!",
    "Explosives": "Взрывчатка",
    "Explosives.Description": "Необходима для производства гранат и ракет",
    "Missile": "Ракета",
    "Missile.Description": "Боеприпасы для ракетной турели",
    "Plasma Cell": "Ячейка плазмы",
    "PlasmaCell.Description": "Боеприпасы для плазмапушки",
    "Timer Bomb": "Бомба с таймером",
    "TimerBomb.Description": "Взрывается через 10 секунд после установки",
    "Ice Ore": "Ледяная руда",
    "IceOre.Description": "Ледяная руда",
    "Steel Ore": "Стальная руда",
    "SteelOre.Description": "Стальная руда",
    "Meteorite": "Метеорит",
    "Meteorite.Description": "Метеорит",
    "Santa Hat": "Шляпа Санты",
    "SantaHat.Description": "Шляпа, которую носит Санта",
    "Name Tag": "Именная бирка",
    "NameTag.Description": "Нужна для изменения имени питомца или раба",
    "Cat": "Кот",
    "Drone": "Дрон",
    "Trooper": "Пехотинец",
    "Mantis": "Богомол",
    "Golem": "Голем",
    "Squid Lord": "Лорд кальмаров",
    "Logs": "Журнал событий",
    "Commands": "Журнал команд",
    "Teams": "Команды",
    "No Teams Found": "Команды не найдены",
    "Request Sent": "Запрос послан",
    "Mode": "Режим",
    "Friends": "Друзья",
    "Search Users": "Поиск",
    "Enter username": "Введите ник игрока",
    "Requests": "Запросы",
    "Games": "Миниигры",
    "Worlds": "Колонии",
    "Enter world name": "Введите название колонии",
    "Enter Colony Name": "Введите название колонии",
    "Start": "Начать",
    "Search": "Поиск",
    "New Role": "Новая роль",
    "Kick": "Выгонять игроков",
    "Ban": "Блокировать игроков",
    "Build": "Стройка",
    "Deconstruct": "Демонтаж",
    "Mine Asteroids": "Добыча астероидов",
    "Plant Seeds": "Посадка семян",
    "Harvest Crops": "Сборка урожая",
    "Sell To Trader": "Продажа предметов",
    "Edit Sign": "Редактирование табличек",
    "Access Storage": "Доступ к хранилищам",
    "Access Mining Drill": "Доступ к буровым установкам",
    "Damage Pvp Players": "Разрешить атаковать PvP игроков",
    "Use Vents": "Использование подземных вентиляций",
    "Use Commands": "Использование команд",
    "Command Block": "Командный блок",
    "Command Blocks": "Командные блоки",
    "Triggers": "Триггеры",
    "Enable Triggers": "Включить триггеры",
    "New Trigger": "Новый триггер",
    "Create": "Создать",
    "Functions": "Функции",
    "Damage": "Урон",
    "Range": "Дальность",
    "Join": "Присоединиться",
    "Host Private Game": "Создать приватную игру",
    "Colonies": "Колонии",
    "NeededToStart": "Необходимо %{count} игроков для начала игры",
    "FindTheImposter.Description": "Члены экипажа выигрывают, выполнив задания или проголосовав за выброс предателя. Предатель выигрывает, убив всех.",
    "Domination.Description": "Объединяйтесь и уничтожайте базы врагов.",
    "CanUseAgain": "Вы можете использовать снова через %{cooldown} секунд",
    "Events.Alarm": "Обнаружен пожар.",
    "Events.AlarmEnd": "Пожар потушен.",
    "Events.FixLights": "Почините свет",
    "Events.FixLightsEnd": "Свет починен",
    "Function.Usage1": "Вызов функции выглядит так:",
    "Function.Usage2": "Проще говоря, получив ввод имени (player), он возвращает вывод в виде количества золота у игрока. Функции могут быть использованы в командах или условном операторе \"If\"."
}

},{}],685:[function(require,module,exports){
/* global P2_ARRAY_TYPE */

module.exports = Utils;

/**
 * Misc utility functions
 * @class Utils
 * @constructor
 */
function Utils(){}

/**
 * Append the values in array b to the array a. See <a href="http://stackoverflow.com/questions/1374126/how-to-append-an-array-to-an-existing-javascript-array/1374131#1374131">this</a> for an explanation.
 * @method appendArray
 * @static
 * @param  {Array} a
 * @param  {Array} b
 */
Utils.appendArray = function(a,b){
    if (b.length < 150000) {
        a.push.apply(a, b);
    } else {
        for (var i = 0, len = b.length; i !== len; ++i) {
            a.push(b[i]);
        }
    }
};

/**
 * Garbage free Array.splice(). Does not allocate a new array.
 * @method splice
 * @static
 * @param  {Array} array
 * @param  {Number} index
 * @param  {Number} howmany
 */
Utils.splice = function(array,index,howmany){
    howmany = howmany || 1;
    for (var i=index, len=array.length-howmany; i < len; i++){
        array[i] = array[i + howmany];
    }
    array.length = len;
};

/**
 * Remove an element from an array, if the array contains the element.
 * @method arrayRemove
 * @static
 * @param  {Array} array
 * @param  {Number} element
 */
Utils.arrayRemove = function(array, element){
    var idx = array.indexOf(element);
    if(idx!==-1){
        Utils.splice(array, idx, 1);
    }
};

/**
 * The array type to use for internal numeric computations throughout the library. Float32Array is used if it is available, but falls back on Array. If you want to set array type manually, inject it via the global variable P2_ARRAY_TYPE. See example below.
 * @static
 * @property {function} ARRAY_TYPE
 * @example
 *     <script>
 *         <!-- Inject your preferred array type before loading p2.js -->
 *         P2_ARRAY_TYPE = Array;
 *     </script>
 *     <script src="p2.js"></script>
 */
if(typeof P2_ARRAY_TYPE !== 'undefined') {
    Utils.ARRAY_TYPE = P2_ARRAY_TYPE;
} else if (typeof Float32Array !== 'undefined'){
    Utils.ARRAY_TYPE = Float32Array;
} else {
    Utils.ARRAY_TYPE = Array;
}

/**
 * Extend an object with the properties of another
 * @static
 * @method extend
 * @param  {object} a
 * @param  {object} b
 */
Utils.extend = function(a,b){
    for(var key in b){
        a[key] = b[key];
    }
};

/**
 * Shallow clone an object. Returns a new object instance with the same properties as the input instance.
 * @static
 * @method shallowClone
 * @param  {object} obj
 */
Utils.shallowClone = function(obj){
    var newObj = {};
    Utils.extend(newObj, obj);
    return newObj;
};

/**
 * Extend an options object with default values.
 * @deprecated Not used internally, will be removed.
 * @static
 * @method defaults
 * @param  {object} options The options object. May be falsy: in this case, a new object is created and returned.
 * @param  {object} defaults An object containing default values.
 * @return {object} The modified options object.
 */
Utils.defaults = function(options, defaults){
    console.warn('Utils.defaults is deprecated.');
    options = options || {};
    for(var key in defaults){
        if(!(key in options)){
            options[key] = defaults[key];
        }
    }
    return options;
};

},{}],686:[function(require,module,exports){
const Protocol = {
  initClient(cb) {
    let protoFile = debugMode ? "app_debug-" + window.protocolHash + ".proto" : "app-" + window.protocolHash + ".proto"
    this.init(protoFile, cb)
  },
  initServer(cb) {
    let nodeModulesPath = require('child_process').execSync("npm root").toString().replace("\n","")
    const directory = nodeModulesPath + "/junon-common/protocol"
    let protoFile = debugMode ? `${directory}/app_debug.proto` : `${directory}/app.proto`
    this.init(protoFile, cb)
  },
  init(filePath, cb){
    let protobuf 
    let isClient = typeof window !== 'undefined'
    if (typeof window !== 'undefined' && window.Protobuf) {
      protobuf = window.Protobuf
    } else {
      protobuf = require("protobufjs")
    }

    let root = new protobuf.Root()

    root.resolvePath = function(origin, target) {
      let protoMatch = origin.match(/(.*)\/.*\.proto/)
      let directory = protoMatch ? protoMatch[1] : ""
      let path 
      if (isClient) {
        path = directory.length > 0 ? directory + "/" + target : "/" + target
      } else {
        path = directory.length > 0 ? directory + "/" + target : target
      }
      
      return path
    }
    root.load(filePath, (err, root) => {
      if (err) {
        cb(err)
        return
      }
      if (!root.nested) {
        cb("error_fetching_proto_file")
        return
      }
      this.protocol = root.nested.app
      cb(null, this.protocol)
    })
  },
  definition() {
    return this.protocol
  }
}
module.exports = Protocol

},{"child_process":9,"protobufjs":"protobufjs"}],687:[function(require,module,exports){
/* Copyright (c) 2013, Brandon Jones, Colin MacKenzie IV. All rights reserved.

Redistribution and use in source and binary forms, with or without modification,
are permitted provided that the following conditions are met:

  * Redistributions of source code must retain the above copyright notice, this
    list of conditions and the following disclaimer.
  * Redistributions in binary form must reproduce the above copyright notice,
    this list of conditions and the following disclaimer in the documentation
    and/or other materials provided with the distribution.

THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND
ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR
ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
(INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON
ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
(INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE. */

/**
 * The vec2 object from glMatrix, with some extensions and some removed methods. See http://glmatrix.net.
 * @class vec2
 */

var vec2 = module.exports = {};

var Utils = require('./p2_utils');

/**
 * Make a cross product and only return the z component
 * @method crossLength
 * @static
 * @param  {Array} a
 * @param  {Array} b
 * @return {Number}
 */
vec2.crossLength = function(a,b){
    return a[0] * b[1] - a[1] * b[0];
};

/**
 * Cross product between a vector and the Z component of a vector
 * @method crossVZ
 * @static
 * @param  {Array} out
 * @param  {Array} vec
 * @param  {Number} zcomp
 * @return {Array}
 */
vec2.crossVZ = function(out, vec, zcomp){
    vec2.rotate(out,vec,-Math.PI/2);// Rotate according to the right hand rule
    vec2.scale(out,out,zcomp);      // Scale with z
    return out;
};

/**
 * Cross product between a vector and the Z component of a vector
 * @method crossZV
 * @static
 * @param  {Array} out
 * @param  {Number} zcomp
 * @param  {Array} vec
 * @return {Array}
 */
vec2.crossZV = function(out, zcomp, vec){
    vec2.rotate(out,vec,Math.PI/2); // Rotate according to the right hand rule
    vec2.scale(out,out,zcomp);      // Scale with z
    return out;
};

/**
 * Rotate a vector by an angle
 * @method rotate
 * @static
 * @param  {Array} out
 * @param  {Array} a
 * @param  {Number} angle
 * @return {Array}
 */
vec2.rotate = function(out,a,angle){
    if(angle !== 0){
        var c = Math.cos(angle),
            s = Math.sin(angle),
            x = a[0],
            y = a[1];
        out[0] = c*x -s*y;
        out[1] = s*x +c*y;
    } else {
        out[0] = a[0];
        out[1] = a[1];
    }
    return out;
};

/**
 * Rotate a vector 90 degrees clockwise
 * @method rotate90cw
 * @static
 * @param  {Array} out
 * @param  {Array} a
 * @param  {Number} angle
 * @return {Array}
 */
vec2.rotate90cw = function(out, a) {
    var x = a[0];
    var y = a[1];
    out[0] = y;
    out[1] = -x;
    return out;
};

/**
 * Transform a point position to local frame.
 * @method toLocalFrame
 * @param  {Array} out
 * @param  {Array} worldPoint
 * @param  {Array} framePosition
 * @param  {Number} frameAngle
 * @return {Array}
 */
vec2.toLocalFrame = function(out, worldPoint, framePosition, frameAngle){
    var c = Math.cos(-frameAngle),
        s = Math.sin(-frameAngle),
        x = worldPoint[0] - framePosition[0],
        y = worldPoint[1] - framePosition[1];
    out[0] = c * x - s * y;
    out[1] = s * x + c * y;
    return out;
};

/**
 * Transform a point position to global frame.
 * @method toGlobalFrame
 * @param  {Array} out
 * @param  {Array} localPoint
 * @param  {Array} framePosition
 * @param  {Number} frameAngle
 */
vec2.toGlobalFrame = function(out, localPoint, framePosition, frameAngle){
    var c = Math.cos(frameAngle),
        s = Math.sin(frameAngle),
        x = localPoint[0],
        y = localPoint[1],
        addX = framePosition[0],
        addY = framePosition[1];
    out[0] = c * x - s * y + addX;
    out[1] = s * x + c * y + addY;
};

/**
 * Transform a vector to local frame.
 * @method vectorToLocalFrame
 * @param  {Array} out
 * @param  {Array} worldVector
 * @param  {Number} frameAngle
 * @return {Array}
 */
vec2.vectorToLocalFrame = function(out, worldVector, frameAngle){
    var c = Math.cos(-frameAngle),
        s = Math.sin(-frameAngle),
        x = worldVector[0],
        y = worldVector[1];
    out[0] = c*x -s*y;
    out[1] = s*x +c*y;
    return out;
};

/**
 * Transform a vector to global frame.
 * @method vectorToGlobalFrame
 * @param  {Array} out
 * @param  {Array} localVector
 * @param  {Number} frameAngle
 */
vec2.vectorToGlobalFrame = vec2.rotate;

/**
 * Compute centroid of a triangle spanned by vectors a,b,c. See http://easycalculation.com/analytical/learn-centroid.php
 * @method centroid
 * @static
 * @param  {Array} out
 * @param  {Array} a
 * @param  {Array} b
 * @param  {Array} c
 * @return  {Array} The "out" vector.
 */
vec2.centroid = function(out, a, b, c){
    vec2.add(out, a, b);
    vec2.add(out, out, c);
    vec2.scale(out, out, 1/3);
    return out;
};

/**
 * Creates a new, empty vec2
 * @static
 * @method create
 * @return {Array} a new 2D vector
 */
vec2.create = function() {
    var out = new Utils.ARRAY_TYPE(2);
    out[0] = 0;
    out[1] = 0;
    return out;
};

/**
 * Creates a new vec2 initialized with values from an existing vector
 * @static
 * @method clone
 * @param {Array} a vector to clone
 * @return {Array} a new 2D vector
 */
vec2.clone = function(a) {
    var out = new Utils.ARRAY_TYPE(2);
    out[0] = a[0];
    out[1] = a[1];
    return out;
};

/**
 * Creates a new vec2 initialized with the given values
 * @static
 * @method fromValues
 * @param {Number} x X component
 * @param {Number} y Y component
 * @return {Array} a new 2D vector
 */
vec2.fromValues = function(x, y) {
    var out = new Utils.ARRAY_TYPE(2);
    out[0] = x;
    out[1] = y;
    return out;
};

/**
 * Copy the values from one vec2 to another
 * @static
 * @method copy
 * @param {Array} out the receiving vector
 * @param {Array} a the source vector
 * @return {Array} out
 */
vec2.copy = function(out, a) {
    out[0] = a[0];
    out[1] = a[1];
    return out;
};

/**
 * Set the components of a vec2 to the given values
 * @static
 * @method set
 * @param {Array} out the receiving vector
 * @param {Number} x X component
 * @param {Number} y Y component
 * @return {Array} out
 */
vec2.set = function(out, x, y) {
    out[0] = x;
    out[1] = y;
    return out;
};

/**
 * Adds two vec2's
 * @static
 * @method add
 * @param {Array} out the receiving vector
 * @param {Array} a the first operand
 * @param {Array} b the second operand
 * @return {Array} out
 */
vec2.add = function(out, a, b) {
    out[0] = a[0] + b[0];
    out[1] = a[1] + b[1];
    return out;
};

/**
 * Subtracts two vec2's
 * @static
 * @method subtract
 * @param {Array} out the receiving vector
 * @param {Array} a the first operand
 * @param {Array} b the second operand
 * @return {Array} out
 */
vec2.subtract = function(out, a, b) {
    out[0] = a[0] - b[0];
    out[1] = a[1] - b[1];
    return out;
};

/**
 * Multiplies two vec2's
 * @static
 * @method multiply
 * @param {Array} out the receiving vector
 * @param {Array} a the first operand
 * @param {Array} b the second operand
 * @return {Array} out
 */
vec2.multiply = function(out, a, b) {
    out[0] = a[0] * b[0];
    out[1] = a[1] * b[1];
    return out;
};

/**
 * Divides two vec2's
 * @static
 * @method divide
 * @param {Array} out the receiving vector
 * @param {Array} a the first operand
 * @param {Array} b the second operand
 * @return {Array} out
 */
vec2.divide = function(out, a, b) {
    out[0] = a[0] / b[0];
    out[1] = a[1] / b[1];
    return out;
};

/**
 * Scales a vec2 by a scalar number
 * @static
 * @method scale
 * @param {Array} out the receiving vector
 * @param {Array} a the vector to scale
 * @param {Number} b amount to scale the vector by
 * @return {Array} out
 */
vec2.scale = function(out, a, b) {
    out[0] = a[0] * b;
    out[1] = a[1] * b;
    return out;
};

/**
 * Calculates the euclidian distance between two vec2's
 * @static
 * @method distance
 * @param {Array} a the first operand
 * @param {Array} b the second operand
 * @return {Number} distance between a and b
 */
vec2.distance = function(a, b) {
    var x = b[0] - a[0],
        y = b[1] - a[1];
    return Math.sqrt(x*x + y*y);
};

/**
 * Calculates the squared euclidian distance between two vec2's
 * @static
 * @method squaredDistance
 * @param {Array} a the first operand
 * @param {Array} b the second operand
 * @return {Number} squared distance between a and b
 */
vec2.squaredDistance = function(a, b) {
    var x = b[0] - a[0],
        y = b[1] - a[1];
    return x*x + y*y;
};

/**
 * Calculates the length of a vec2
 * @static
 * @method length
 * @param {Array} a vector to calculate length of
 * @return {Number} length of a
 */
vec2.length = function (a) {
    var x = a[0],
        y = a[1];
    return Math.sqrt(x*x + y*y);
};

/**
 * Calculates the squared length of a vec2
 * @static
 * @method squaredLength
 * @param {Array} a vector to calculate squared length of
 * @return {Number} squared length of a
 */
vec2.squaredLength = function (a) {
    var x = a[0],
        y = a[1];
    return x*x + y*y;
};

/**
 * Negates the components of a vec2
 * @static
 * @method negate
 * @param {Array} out the receiving vector
 * @param {Array} a vector to negate
 * @return {Array} out
 */
vec2.negate = function(out, a) {
    out[0] = -a[0];
    out[1] = -a[1];
    return out;
};

/**
 * Normalize a vec2
 * @static
 * @method normalize
 * @param {Array} out the receiving vector
 * @param {Array} a vector to normalize
 * @return {Array} out
 */
vec2.normalize = function(out, a) {
    var x = a[0],
        y = a[1];
    var len = x*x + y*y;
    if (len > 0) {
        //TODO: evaluate use of glm_invsqrt here?
        len = 1 / Math.sqrt(len);
        out[0] = a[0] * len;
        out[1] = a[1] * len;
    }
    return out;
};

/**
 * Calculates the dot product of two vec2's
 * @static
 * @method dot
 * @param {Array} a the first operand
 * @param {Array} b the second operand
 * @return {Number} dot product of a and b
 */
vec2.dot = function (a, b) {
    return a[0] * b[0] + a[1] * b[1];
};

/**
 * Returns a string representation of a vector
 * @static
 * @method str
 * @param {Array} vec vector to represent as a string
 * @return {String} string representation of the vector
 */
vec2.str = function (a) {
    return 'vec2(' + a[0] + ', ' + a[1] + ')';
};

/**
 * Linearly interpolate/mix two vectors.
 * @static
 * @method lerp
 * @param {Array} out
 * @param {Array} a First vector
 * @param {Array} b Second vector
 * @param {number} t Lerp factor
 */
vec2.lerp = function (out, a, b, t) {
    var ax = a[0],
        ay = a[1];
    out[0] = ax + t * (b[0] - ax);
    out[1] = ay + t * (b[1] - ay);
    return out;
};

/**
 * Reflect a vector along a normal.
 * @static
 * @method reflect
 * @param {Array} out
 * @param {Array} vector
 * @param {Array} normal
 */
vec2.reflect = function(out, vector, normal){
    var dot = vector[0] * normal[0] + vector[1] * normal[1];
    out[0] = vector[0] - 2 * normal[0] * dot;
    out[1] = vector[1] - 2 * normal[1] * dot;
};

/**
 * Get the intersection point between two line segments.
 * @static
 * @method getLineSegmentsIntersection
 * @param  {Array} out
 * @param  {Array} p0
 * @param  {Array} p1
 * @param  {Array} p2
 * @param  {Array} p3
 * @return {boolean} True if there was an intersection, otherwise false.
 */
vec2.getLineSegmentsIntersection = function(out, p0, p1, p2, p3) {
    var t = vec2.getLineSegmentsIntersectionFraction(p0, p1, p2, p3);
    if(t < 0){
        return false;
    } else {
        out[0] = p0[0] + (t * (p1[0] - p0[0]));
        out[1] = p0[1] + (t * (p1[1] - p0[1]));
        return true;
    }
};

/**
 * Get the intersection fraction between two line segments. If successful, the intersection is at p0 + t * (p1 - p0)
 * @static
 * @method getLineSegmentsIntersectionFraction
 * @param  {Array} p0
 * @param  {Array} p1
 * @param  {Array} p2
 * @param  {Array} p3
 * @return {number} A number between 0 and 1 if there was an intersection, otherwise -1.
 */
vec2.getLineSegmentsIntersectionFraction = function(p0, p1, p2, p3) {
    var s1_x = p1[0] - p0[0];
    var s1_y = p1[1] - p0[1];
    var s2_x = p3[0] - p2[0];
    var s2_y = p3[1] - p2[1];

    var s, t;
    s = (-s1_y * (p0[0] - p2[0]) + s1_x * (p0[1] - p2[1])) / (-s2_x * s1_y + s1_x * s2_y);
    t = ( s2_x * (p0[1] - p2[1]) - s2_y * (p0[0] - p2[0])) / (-s2_x * s1_y + s1_x * s2_y);
    if (s >= 0 && s <= 1 && t >= 0 && t <= 1) { // Collision detected
        return t;
    }
    return -1; // No collision
};

},{"./p2_utils":685}]},{},[1]);
